webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(36);
	var hide = __webpack_require__(21);
	var redefine = __webpack_require__(22);
	var ctx = __webpack_require__(30);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.20.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(1725)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true;
	    var m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
	        }
	    }
	    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.20.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	// currently HTML5 input type only supports 24-hour formats
	hooks.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD',                             // <input type="date" />
	    TIME: 'HH:mm',                                  // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	    MONTH: 'YYYY-MM'                                // <input type="month" />
	};
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(1)(module)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(503)
	var ieee754 = __webpack_require__(1709)
	var isArray = __webpack_require__(242)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(111)('wks');
	var uid = __webpack_require__(68);
	var Symbol = __webpack_require__(5).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(6)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var IE8_DOM_DEFINE = __webpack_require__(215);
	var toPrimitive = __webpack_require__(40);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(11) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(39);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(37);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(185)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * vuex v2.5.0
	 * (c) 2017 Evan You
	 * @license MIT
	 */
	'use strict';
	
	var applyMixin = function (Vue) {
	  var version = Number(Vue.version.split('.')[0]);
	
	  if (version >= 2) {
	    Vue.mixin({ beforeCreate: vuexInit });
	  } else {
	    // override init and inject vuex init procedure
	    // for 1.x backwards compatibility.
	    var _init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      if ( options === void 0 ) options = {};
	
	      options.init = options.init
	        ? [vuexInit].concat(options.init)
	        : vuexInit;
	      _init.call(this, options);
	    };
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit () {
	    var options = this.$options;
	    // store injection
	    if (options.store) {
	      this.$store = typeof options.store === 'function'
	        ? options.store()
	        : options.store;
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store;
	    }
	  }
	};
	
	var devtoolHook =
	  typeof window !== 'undefined' &&
	  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }
	
	  store._devtoolHook = devtoolHook;
	
	  devtoolHook.emit('vuex:init', store);
	
	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState);
	  });
	
	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state);
	  });
	}
	
	/**
	 * Get the first item that pass the test
	 * by second argument function
	 *
	 * @param {Array} list
	 * @param {Function} f
	 * @return {*}
	 */
	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	
	
	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
	}
	
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	function isPromise (val) {
	  return val && typeof val.then === 'function'
	}
	
	function assert (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}
	
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime;
	  this._children = Object.create(null);
	  this._rawModule = rawModule;
	  var rawState = rawModule.state;
	  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
	};
	
	var prototypeAccessors$1 = { namespaced: { configurable: true } };
	
	prototypeAccessors$1.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};
	
	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module;
	};
	
	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key];
	};
	
	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};
	
	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced;
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions;
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations;
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters;
	  }
	};
	
	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn);
	};
	
	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn);
	  }
	};
	
	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn);
	  }
	};
	
	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn);
	  }
	};
	
	Object.defineProperties( Module.prototype, prototypeAccessors$1 );
	
	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  // register root module (Vuex.Store options)
	  this.register([], rawRootModule, false);
	};
	
	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};
	
	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root;
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key);
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};
	
	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update([], this.root, rawRootModule);
	};
	
	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;
	
	  if (false) {
	    assertRawModule(path, rawModule);
	  }
	
	  var newModule = new Module(rawModule, runtime);
	  if (path.length === 0) {
	    this.root = newModule;
	  } else {
	    var parent = this.get(path.slice(0, -1));
	    parent.addChild(path[path.length - 1], newModule);
	  }
	
	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime);
	    });
	  }
	};
	
	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1));
	  var key = path[path.length - 1];
	  if (!parent.getChild(key).runtime) { return }
	
	  parent.removeChild(key);
	};
	
	function update (path, targetModule, newModule) {
	  if (false) {
	    assertRawModule(path, newModule);
	  }
	
	  // update target module
	  targetModule.update(newModule);
	
	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        if (false) {
	          console.warn(
	            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	            'manual reload is needed'
	          );
	        }
	        return
	      }
	      update(
	        path.concat(key),
	        targetModule.getChild(key),
	        newModule.modules[key]
	      );
	    }
	  }
	}
	
	var functionAssert = {
	  assert: function (value) { return typeof value === 'function'; },
	  expected: 'function'
	};
	
	var objectAssert = {
	  assert: function (value) { return typeof value === 'function' ||
	    (typeof value === 'object' && typeof value.handler === 'function'); },
	  expected: 'function or object with "handler" function'
	};
	
	var assertTypes = {
	  getters: functionAssert,
	  mutations: functionAssert,
	  actions: objectAssert
	};
	
	function assertRawModule (path, rawModule) {
	  Object.keys(assertTypes).forEach(function (key) {
	    if (!rawModule[key]) { return }
	
	    var assertOptions = assertTypes[key];
	
	    forEachValue(rawModule[key], function (value, type) {
	      assert(
	        assertOptions.assert(value),
	        makeAssertionMessage(path, key, type, value, assertOptions.expected)
	      );
	    });
	  });
	}
	
	function makeAssertionMessage (path, key, type, value, expected) {
	  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
	  if (path.length > 0) {
	    buf += " in module \"" + (path.join('.')) + "\"";
	  }
	  buf += " is " + (JSON.stringify(value)) + ".";
	  return buf
	}
	
	var Vue; // bind on install
	
	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};
	
	  // Auto install if it is not done yet and `window` has `Vue`.
	  // To allow users to avoid auto-installation in some cases,
	  // this code should be placed here. See #731
	  if (!Vue && typeof window !== 'undefined' && window.Vue) {
	    install(window.Vue);
	  }
	
	  if (false) {
	    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
	    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
	    assert(this instanceof Store, "Store must be called with the new operator.");
	  }
	
	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;
	
	  var state = options.state; if ( state === void 0 ) state = {};
	  if (typeof state === 'function') {
	    state = state() || {};
	  }
	
	  // store internal state
	  this._committing = false;
	  this._actions = Object.create(null);
	  this._actionSubscribers = [];
	  this._mutations = Object.create(null);
	  this._wrappedGetters = Object.create(null);
	  this._modules = new ModuleCollection(options);
	  this._modulesNamespaceMap = Object.create(null);
	  this._subscribers = [];
	  this._watcherVM = new Vue();
	
	  // bind commit and dispatch to self
	  var store = this;
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	  this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  };
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	  };
	
	  // strict mode
	  this.strict = strict;
	
	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root);
	
	  // initialize the store vm, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreVM(this, state);
	
	  // apply plugins
	  plugins.forEach(function (plugin) { return plugin(this$1); });
	
	  if (Vue.config.devtools) {
	    devtoolPlugin(this);
	  }
	};
	
	var prototypeAccessors = { state: { configurable: true } };
	
	prototypeAccessors.state.get = function () {
	  return this._vm._data.$$state
	};
	
	prototypeAccessors.state.set = function (v) {
	  if (false) {
	    assert(false, "Use store.replaceState() to explicit replace store state.");
	  }
	};
	
	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;
	
	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;
	
	  var mutation = { type: type, payload: payload };
	  var entry = this._mutations[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown mutation type: " + type));
	    }
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload);
	    });
	  });
	  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });
	
	  if (
	    false
	  ) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    );
	  }
	};
	
	Store.prototype.dispatch = function dispatch (_type, _payload) {
	    var this$1 = this;
	
	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;
	
	  var action = { type: type, payload: payload };
	  var entry = this._actions[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown action type: " + type));
	    }
	    return
	  }
	
	  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });
	
	  return entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload)
	};
	
	Store.prototype.subscribe = function subscribe (fn) {
	  return genericSubscribe(fn, this._subscribers)
	};
	
	Store.prototype.subscribeAction = function subscribeAction (fn) {
	  return genericSubscribe(fn, this._actionSubscribers)
	};
	
	Store.prototype.watch = function watch (getter, cb, options) {
	    var this$1 = this;
	
	  if (false) {
	    assert(typeof getter === 'function', "store.watch only accepts a function.");
	  }
	  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
	};
	
	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;
	
	  this._withCommit(function () {
	    this$1._vm._data.$$state = state;
	  });
	};
	
	Store.prototype.registerModule = function registerModule (path, rawModule, options) {
	    if ( options === void 0 ) options = {};
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	    assert(path.length > 0, 'cannot register the root module by using registerModule.');
	  }
	
	  this._modules.register(path, rawModule);
	  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
	  // reset store to update getters...
	  resetStoreVM(this, this.state);
	};
	
	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	  }
	
	  this._modules.unregister(path);
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1));
	    Vue.delete(parentState, path[path.length - 1]);
	  });
	  resetStore(this);
	};
	
	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions);
	  resetStore(this, true);
	};
	
	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing;
	  this._committing = true;
	  fn();
	  this._committing = committing;
	};
	
	Object.defineProperties( Store.prototype, prototypeAccessors );
	
	function genericSubscribe (fn, subs) {
	  if (subs.indexOf(fn) < 0) {
	    subs.push(fn);
	  }
	  return function () {
	    var i = subs.indexOf(fn);
	    if (i > -1) {
	      subs.splice(i, 1);
	    }
	  }
	}
	
	function resetStore (store, hot) {
	  store._actions = Object.create(null);
	  store._mutations = Object.create(null);
	  store._wrappedGetters = Object.create(null);
	  store._modulesNamespaceMap = Object.create(null);
	  var state = store.state;
	  // init all modules
	  installModule(store, state, [], store._modules.root, true);
	  // reset vm
	  resetStoreVM(store, state, hot);
	}
	
	function resetStoreVM (store, state, hot) {
	  var oldVm = store._vm;
	
	  // bind store public getters
	  store.getters = {};
	  var wrappedGetters = store._wrappedGetters;
	  var computed = {};
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    computed[key] = function () { return fn(store); };
	    Object.defineProperty(store.getters, key, {
	      get: function () { return store._vm[key]; },
	      enumerable: true // for local getters
	    });
	  });
	
	  // use a Vue instance to store the state tree
	  // suppress warnings just in case the user has added
	  // some funky global mixins
	  var silent = Vue.config.silent;
	  Vue.config.silent = true;
	  store._vm = new Vue({
	    data: {
	      $$state: state
	    },
	    computed: computed
	  });
	  Vue.config.silent = silent;
	
	  // enable strict mode for new vm
	  if (store.strict) {
	    enableStrictMode(store);
	  }
	
	  if (oldVm) {
	    if (hot) {
	      // dispatch changes in all subscribed watchers
	      // to force getter re-evaluation for hot reloading.
	      store._withCommit(function () {
	        oldVm._data.$$state = null;
	      });
	    }
	    Vue.nextTick(function () { return oldVm.$destroy(); });
	  }
	}
	
	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length;
	  var namespace = store._modules.getNamespace(path);
	
	  // register in namespace map
	  if (module.namespaced) {
	    store._modulesNamespaceMap[namespace] = module;
	  }
	
	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1));
	    var moduleName = path[path.length - 1];
	    store._withCommit(function () {
	      Vue.set(parentState, moduleName, module.state);
	    });
	  }
	
	  var local = module.context = makeLocalContext(store, namespace, path);
	
	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key;
	    registerMutation(store, namespacedType, mutation, local);
	  });
	
	  module.forEachAction(function (action, key) {
	    var type = action.root ? key : namespace + key;
	    var handler = action.handler || action;
	    registerAction(store, type, handler, local);
	  });
	
	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key;
	    registerGetter(store, namespacedType, getter, local);
	  });
	
	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot);
	  });
	}
	
	/**
	 * make localized dispatch, commit, getters and state
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace, path) {
	  var noNamespace = namespace === '';
	
	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      return store.dispatch(type, payload)
	    },
	
	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      store.commit(type, payload, options);
	    }
	  };
	
	  // getters and state object must be gotten lazily
	  // because they will be changed by vm update
	  Object.defineProperties(local, {
	    getters: {
	      get: noNamespace
	        ? function () { return store.getters; }
	        : function () { return makeLocalGetters(store, namespace); }
	    },
	    state: {
	      get: function () { return getNestedState(store.state, path); }
	    }
	  });
	
	  return local
	}
	
	function makeLocalGetters (store, namespace) {
	  var gettersProxy = {};
	
	  var splitPos = namespace.length;
	  Object.keys(store.getters).forEach(function (type) {
	    // skip if the target getter is not match this namespace
	    if (type.slice(0, splitPos) !== namespace) { return }
	
	    // extract local getter type
	    var localType = type.slice(splitPos);
	
	    // Add a port to the getters proxy.
	    // Define as getter property because
	    // we do not want to evaluate the getters in this time.
	    Object.defineProperty(gettersProxy, localType, {
	      get: function () { return store.getters[type]; },
	      enumerable: true
	    });
	  });
	
	  return gettersProxy
	}
	
	function registerMutation (store, type, handler, local) {
	  var entry = store._mutations[type] || (store._mutations[type] = []);
	  entry.push(function wrappedMutationHandler (payload) {
	    handler.call(store, local.state, payload);
	  });
	}
	
	function registerAction (store, type, handler, local) {
	  var entry = store._actions[type] || (store._actions[type] = []);
	  entry.push(function wrappedActionHandler (payload, cb) {
	    var res = handler.call(store, {
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: local.state,
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload, cb);
	    if (!isPromise(res)) {
	      res = Promise.resolve(res);
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err);
	        throw err
	      })
	    } else {
	      return res
	    }
	  });
	}
	
	function registerGetter (store, type, rawGetter, local) {
	  if (store._wrappedGetters[type]) {
	    if (false) {
	      console.error(("[vuex] duplicate getter key: " + type));
	    }
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      local.state, // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  };
	}
	
	function enableStrictMode (store) {
	  store._vm.$watch(function () { return this._data.$$state }, function () {
	    if (false) {
	      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
	    }
	  }, { deep: true, sync: true });
	}
	
	function getNestedState (state, path) {
	  return path.length
	    ? path.reduce(function (state, key) { return state[key]; }, state)
	    : state
	}
	
	function unifyObjectStyle (type, payload, options) {
	  if (isObject(type) && type.type) {
	    options = payload;
	    payload = type;
	    type = type.type;
	  }
	
	  if (false) {
	    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
	  }
	
	  return { type: type, payload: payload, options: options }
	}
	
	function install (_Vue) {
	  if (Vue && _Vue === Vue) {
	    if (false) {
	      console.error(
	        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
	      );
	    }
	    return
	  }
	  Vue = _Vue;
	  applyMixin(Vue);
	}
	
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {};
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedState () {
	      var state = this.$store.state;
	      var getters = this.$store.getters;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
	        if (!module) {
	          return
	        }
	        state = module.context.state;
	        getters = module.context.getters;
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {};
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var commit = this.$store.commit;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
	        if (!module) {
	          return
	        }
	        commit = module.context.commit;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [commit].concat(args))
	        : commit.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {};
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val;
	    res[key] = function mappedGetter () {
	      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
	        return
	      }
	      if (false) {
	        console.error(("[vuex] unknown getter: " + val));
	        return
	      }
	      return this.$store.getters[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {};
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var dispatch = this.$store.dispatch;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
	        if (!module) {
	          return
	        }
	        dispatch = module.context.dispatch;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [dispatch].concat(args))
	        : dispatch.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var createNamespacedHelpers = function (namespace) { return ({
	  mapState: mapState.bind(null, namespace),
	  mapGetters: mapGetters.bind(null, namespace),
	  mapMutations: mapMutations.bind(null, namespace),
	  mapActions: mapActions.bind(null, namespace)
	}); };
	
	function normalizeMap (map) {
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}
	
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace;
	      namespace = '';
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/';
	    }
	    return fn(namespace, map)
	  }
	}
	
	function getModuleByNamespace (store, helper, namespace) {
	  var module = store._modulesNamespaceMap[namespace];
	  if (false) {
	    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
	  }
	  return module
	}
	
	var index = {
	  Store: Store,
	  install: install,
	  version: '2.5.0',
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions,
	  createNamespacedHelpers: createNamespacedHelpers
	};
	
	module.exports = index;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(12);
	var createDesc = __webpack_require__(64);
	module.exports = __webpack_require__(11) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var hide = __webpack_require__(21);
	var has = __webpack_require__(20);
	var SRC = __webpack_require__(68)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(36).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var defined = __webpack_require__(37);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(177);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(196)('wks')
	  , uid    = __webpack_require__(130)
	  , Symbol = __webpack_require__(34).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(89);
	var createDesc = __webpack_require__(64);
	var toIObject = __webpack_require__(28);
	var toPrimitive = __webpack_require__(40);
	var has = __webpack_require__(20);
	var IE8_DOM_DEFINE = __webpack_require__(215);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(11) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(20);
	var toObject = __webpack_require__(14);
	var IE_PROTO = __webpack_require__(152)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(88);
	var defined = __webpack_require__(37);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(18);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* vim: set softtabstop=2 shiftwidth=2 expandtab : */
	
	var _ = __webpack_require__(8);
	var assert = __webpack_require__(119);
	
	function capitalizeFirstLetter(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	exports.default = function (vueElement, googleMapsElement, props, options) {
	  options = options || {};
	  var _options = options,
	      afterModelChanged = _options.afterModelChanged;
	
	  _.forEach(props, function (_ref, attribute) {
	    var twoWay = _ref.twoWay,
	        type = _ref.type,
	        trackProperties = _ref.trackProperties;
	
	    var setMethodName = 'set' + capitalizeFirstLetter(attribute);
	    var getMethodName = 'get' + capitalizeFirstLetter(attribute);
	    var eventName = attribute.toLowerCase() + '_changed';
	    var initialValue = vueElement[attribute];
	
	    assert(googleMapsElement[setMethodName], setMethodName + ' is not a method of (the Maps object corresponding to) ' + vueElement.$options._componentTag);
	
	    // We need to avoid an endless
	    // propChanged -> event emitted -> propChanged -> event emitted loop
	    // although this may really be the user's responsibility
	    var timesSet = 0;
	    if (type !== Object || !trackProperties) {
	      // Track the object deeply
	      vueElement.$watch(attribute, function () {
	        var attributeValue = vueElement[attribute];
	
	        timesSet++;
	        googleMapsElement[setMethodName](attributeValue);
	        if (afterModelChanged) {
	          afterModelChanged(attribute, attributeValue);
	        }
	      }, {
	        immediate: typeof initialValue !== 'undefined',
	        deep: type === Object
	      });
	    } else if (type === Object && trackProperties) {
	      // I can watch multiple properties, but the danger is that each of
	      // them triggers the event handler multiple times
	      // This ensures that the event handler will only be fired once
	      var tick = 0,
	          expectedTick = 0;
	
	      var raiseExpectation = function raiseExpectation() {
	        expectedTick += 1;
	      };
	
	      var updateTick = function updateTick() {
	        tick = Math.max(expectedTick, tick + 1);
	      };
	
	      var respondToChange = function respondToChange() {
	        if (tick < expectedTick) {
	          googleMapsElement[setMethodName](vueElement[attribute]);
	
	          if (afterModelChanged) {
	            afterModelChanged(attribute, attributeValue);
	          }
	
	          updateTick();
	        }
	      };
	
	      trackProperties.forEach(function (propName) {
	        // When any props change -- assume they change on the same tick
	        vueElement.$watch(attribute + '.' + propName, function () {
	          raiseExpectation();
	          vueElement.$nextTick(respondToChange);
	        }, {
	          immediate: typeof initialValue !== 'undefined'
	        });
	      });
	    }
	
	    if (twoWay) {
	      googleMapsElement.addListener(eventName, function (ev) {
	        // eslint-disable-line no-unused-vars
	        /* Check for type === Object because we're quite happy
	          when primitive types change -- the change detection is cheap
	        */
	        if (type === Object && timesSet > 0) {
	          timesSet--;
	          return;
	        } else {
	          vueElement.$emit(eventName, googleMapsElement[getMethodName]());
	        }
	      });
	    }
	  });
	};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(30);
	var IObject = __webpack_require__(88);
	var toObject = __webpack_require__(14);
	var toLength = __webpack_require__(13);
	var asc = __webpack_require__(137);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(2);
	var core = __webpack_require__(36);
	var fails = __webpack_require__(6);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(7);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    getPropsValues: function getPropsValues() {
	      var _this = this;
	
	      return _lodash2.default.mapValues(this.$options.props, function (v, k) {
	        return _this[k];
	      });
	    }
	  }
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(34)
	  , core      = __webpack_require__(16)
	  , ctx       = __webpack_require__(57)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(236);
	var $export = __webpack_require__(2);
	var shared = __webpack_require__(111)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(239))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(11)) {
	  var LIBRARY = __webpack_require__(60);
	  var global = __webpack_require__(5);
	  var fails = __webpack_require__(6);
	  var $export = __webpack_require__(2);
	  var $typed = __webpack_require__(113);
	  var $buffer = __webpack_require__(158);
	  var ctx = __webpack_require__(30);
	  var anInstance = __webpack_require__(58);
	  var propertyDesc = __webpack_require__(64);
	  var hide = __webpack_require__(21);
	  var redefineAll = __webpack_require__(65);
	  var toInteger = __webpack_require__(39);
	  var toLength = __webpack_require__(13);
	  var toIndex = __webpack_require__(234);
	  var toAbsoluteIndex = __webpack_require__(67);
	  var toPrimitive = __webpack_require__(40);
	  var has = __webpack_require__(20);
	  var classof = __webpack_require__(87);
	  var isObject = __webpack_require__(7);
	  var toObject = __webpack_require__(14);
	  var isArrayIter = __webpack_require__(144);
	  var create = __webpack_require__(61);
	  var getPrototypeOf = __webpack_require__(27);
	  var gOPN = __webpack_require__(62).f;
	  var getIterFn = __webpack_require__(161);
	  var uid = __webpack_require__(68);
	  var wks = __webpack_require__(10);
	  var createArrayMethod = __webpack_require__(35);
	  var createArrayIncludes = __webpack_require__(100);
	  var speciesConstructor = __webpack_require__(112);
	  var ArrayIterators = __webpack_require__(162);
	  var Iterators = __webpack_require__(75);
	  var $iterDetect = __webpack_require__(106);
	  var setSpecies = __webpack_require__(66);
	  var arrayFill = __webpack_require__(136);
	  var arrayCopyWithin = __webpack_require__(207);
	  var $DP = __webpack_require__(12);
	  var $GOPD = __webpack_require__(26);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(9)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (vueElement, googleMapObject, events) {
	  _lodash2.default.forEach(events, function (eventName) {
	    var exposedName = eventName;
	    googleMapObject.addListener(eventName, function (ev) {
	      vueElement.$emit(exposedName, ev);
	    });
	  });
	}; /* vim: set softtabstop=2 shiftwidth=2 expandtab : */

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(469), __esModule: true };

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(48);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(502);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	module.exports = { "default": module.exports, __esModule: true };
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(10)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(21)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(68)('meta');
	var isObject = __webpack_require__(7);
	var has = __webpack_require__(20);
	var setDesc = __webpack_require__(12).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(6)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1771);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1770);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(32)))

/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deferredReady = __webpack_require__(118);
	
	/**
	 * @class MapElementMixin @mixins DeferredReadyMixin
	 *
	 * Extends components to include the following fields:
	 *
	 * @property $map        The Google map (valid only after the promise returns)
	 *
	 *
	 * */
	exports.default = {
	
	  mixins: [_deferredReady.DeferredReadyMixin],
	
	  created: function created() {
	    var _this = this;
	
	    /* Search for the Map component in the parent */
	    var search = this.$findAncestor(function (ans) {
	      return ans.$mapCreated;
	    });
	
	    if (!search) {
	      throw new Error(this.constructor.name + ' component must be used within a <Map>');
	    }
	
	    this.$mapPromise = search.$mapCreated.then(function (map) {
	      _this.$map = map;
	    });
	    // FIXME: This is a hack to ensure correct loading
	    // when the map has already be instantiated.
	    if (search.$mapObject) {
	      this.$map = search.$mapObject;
	    }
	    this.$MapElementMixin = search;
	    this.$map = null;
	  },
	  beforeDeferredReady: function beforeDeferredReady() {
	    return this.$mapPromise;
	  },
	
	
	  methods: {
	    $findAncestor: function $findAncestor(condition) {
	      var search = this.$parent;
	
	      while (search) {
	        if (condition(search)) {
	          return search;
	        }
	        search = search.$parent;
	      }
	      return null;
	    }
	  }
	
	}; /* vim: set softtabstop=2 shiftwidth=2 expandtab : */

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(73);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(122);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(30);
	var call = __webpack_require__(218);
	var isArrayIter = __webpack_require__(144);
	var anObject = __webpack_require__(4);
	var toLength = __webpack_require__(13);
	var getIterFn = __webpack_require__(161);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(4);
	var dPs = __webpack_require__(224);
	var enumBugKeys = __webpack_require__(140);
	var IE_PROTO = __webpack_require__(152)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(139)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(142).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(226);
	var hiddenKeys = __webpack_require__(140).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(226);
	var enumBugKeys = __webpack_require__(140);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(22);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var dP = __webpack_require__(12);
	var DESCRIPTORS = __webpack_require__(11);
	var SPECIES = __webpack_require__(10)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
	
	function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var InvalidError = /*#__PURE__*/function (_Error) {
	  _inherits(InvalidError, _Error);
	
	  var _super = _createSuper(InvalidError);
	
	  function InvalidError(reason) {
	    var _this;
	
	    _classCallCheck(this, InvalidError);
	
	    _this = _super.call(this, 'invalid');
	    _this.reason = reason;
	    return _this;
	  }
	
	  return _createClass(InvalidError);
	}( /*#__PURE__*/_wrapNativeSuper(Error));
	
	exports["default"] = InvalidError;
	//# sourceMappingURL=InvalidError.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBaseStyles = getBaseStyles;
	exports.getCellInlineStringValue = getCellInlineStringValue;
	exports.getCellStyles = getCellStyles;
	exports.getCellValue = getCellValue;
	exports.getCells = getCells;
	exports.getDimensions = getDimensions;
	exports.getMergedCells = getMergedCells;
	exports.getNumberFormats = getNumberFormats;
	exports.getRelationships = getRelationships;
	exports.getSharedStrings = getSharedStrings;
	exports.getSheets = getSheets;
	exports.getWorkbookProperties = getWorkbookProperties;
	
	var _dom = __webpack_require__(371);
	
	// Returns an array of cells,
	// each element being an XML DOM element representing a cell.
	function getCells(document) {
	  var worksheet = document.documentElement;
	  var sheetData = (0, _dom.findChild)(worksheet, 'sheetData');
	  var cells = [];
	  (0, _dom.forEach)(sheetData, 'row', function (row) {
	    (0, _dom.forEach)(row, 'c', function (cell) {
	      cells.push(cell);
	    });
	  });
	  return cells;
	}
	
	function getMergedCells(document) {
	  var worksheet = document.documentElement;
	  var mergedCells = (0, _dom.findChild)(worksheet, 'mergeCells');
	  var mergedCellsInfo = [];
	
	  if (mergedCells) {
	    (0, _dom.forEach)(mergedCells, 'mergeCell', function (mergedCell) {
	      mergedCellsInfo.push(mergedCell.getAttribute('ref'));
	    });
	  }
	
	  return mergedCellsInfo;
	}
	
	function getCellValue(document, node) {
	  return (0, _dom.findChild)(node, 'v');
	}
	
	function getCellInlineStringValue(document, node) {
	  if (node.firstChild && (0, _dom.getTagName)(node.firstChild) === 'is' && node.firstChild.firstChild && (0, _dom.getTagName)(node.firstChild.firstChild) === 't') {
	    return node.firstChild.firstChild.textContent;
	  }
	}
	
	function getDimensions(document) {
	  var worksheet = document.documentElement;
	  var dimensions = (0, _dom.findChild)(worksheet, 'dimension');
	
	  if (dimensions) {
	    return dimensions.getAttribute('ref');
	  }
	}
	
	function getBaseStyles(document) {
	  var styleSheet = document.documentElement;
	  var cellStyleXfs = (0, _dom.findChild)(styleSheet, 'cellStyleXfs');
	
	  if (cellStyleXfs) {
	    return (0, _dom.findChildren)(cellStyleXfs, 'xf');
	  }
	
	  return [];
	}
	
	function getCellStyles(document) {
	  var styleSheet = document.documentElement;
	  var cellXfs = (0, _dom.findChild)(styleSheet, 'cellXfs');
	
	  if (!cellXfs) {
	    return [];
	  }
	
	  return (0, _dom.findChildren)(cellXfs, 'xf');
	}
	
	function getNumberFormats(document) {
	  var styleSheet = document.documentElement;
	  var numberFormats = [];
	  var numFmts = (0, _dom.findChild)(styleSheet, 'numFmts');
	
	  if (numFmts) {
	    return (0, _dom.findChildren)(numFmts, 'numFmt');
	  }
	
	  return [];
	}
	
	function getSharedStrings(document) {
	  // An `<si/>` element can contain a `<t/>` (simplest case) or a set of `<r/>` ("rich formatting") elements having `<t/>`.
	  // https://docs.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.sharedstringitem?redirectedfrom=MSDN&view=openxml-2.8.1
	  // http://www.datypic.com/sc/ooxml/e-ssml_si-1.html
	  var sst = document.documentElement;
	  return (0, _dom.map)(sst, 'si', function (string) {
	    var t = (0, _dom.findChild)(string, 't');
	
	    if (t) {
	      return t.textContent;
	    }
	
	    var value = '';
	    (0, _dom.forEach)(string, 'r', function (r) {
	      value += (0, _dom.findChild)(r, 't').textContent;
	    });
	    return value;
	  });
	}
	
	function getWorkbookProperties(document) {
	  var workbook = document.documentElement;
	  return (0, _dom.findChild)(workbook, 'workbookPr');
	}
	
	function getRelationships(document) {
	  var relationships = document.documentElement;
	  return (0, _dom.findChildren)(relationships, 'Relationship');
	}
	
	function getSheets(document) {
	  var workbook = document.documentElement;
	  var sheets = (0, _dom.findChild)(workbook, 'sheets');
	  return (0, _dom.findChildren)(sheets, 'sheet');
	}
	//# sourceMappingURL=xlsx.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(116);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(90);
	util.inherits = __webpack_require__(41);
	/*</replacement>*/
	
	var Readable = __webpack_require__(372);
	var Writable = __webpack_require__(168);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  processNextTick(cb, err);
	};
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(83)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(12).f;
	var has = __webpack_require__(20);
	var TAG = __webpack_require__(10)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var defined = __webpack_require__(37);
	var fails = __webpack_require__(6);
	var spaces = __webpack_require__(156);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(17)
	  , createDesc = __webpack_require__(125);
	module.exports = __webpack_require__(72) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(17).setDesc
	  , has = __webpack_require__(96)
	  , TAG = __webpack_require__(25)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(489)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(123)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(29);
	var TAG = __webpack_require__(10)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(29);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.load = exports.loaded = undefined;
	
	var _keys = __webpack_require__(457);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(460);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(48);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* vim: set softtabstop=2 shiftwidth=2 expandtab : */
	
	var setUp = false;
	
	var loaded = exports.loaded = new _promise2.default(function (resolve, reject) {
	  // eslint-disable-line no-unused-vars
	  if (typeof window === 'undefined') {
	    // Do nothing if run from server-side
	    return;
	  }
	  window['vueGoogleMapsInit'] = resolve;
	});
	
	/**
	 * @param apiKey    API Key, or object with the URL parameters. For example
	 *                  to use Google Maps Premium API, pass
	 *                    `{ client: <YOUR-CLIENT-ID> }`.
	 *                  You may pass the libraries and/or version (as `v`) parameter into
	 *                  this parameter and skip the next two parameters
	 * @param version   Google for Maps version
	 * @param libraries Libraries to load (@see
	 *                  https://developers.google.com/maps/documentation/javascript/libraries)
	 * @param loadCn    Boolean. If set to true, the map will be loaded form goole maps China
	 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
	 *
	 * Example:
	 * ```
	 *      import {load} from 'vue-google-maps'
	 *
	 *      load(<YOUR-API-KEY>)
	 *
	 *      load({
	 *              key: <YOUR-API-KEY>,
	 *      })
	 *
	 *      load({
	 *              client: <YOUR-CLIENT-ID>,
	 *              channel: <YOUR CHANNEL>
	 *      })
	 * ```
	 */
	var load = exports.load = function load(apiKey, version, libraries, loadCn) {
	  if (typeof document === 'undefined') {
	    // Do nothing if run from server-side
	    return;
	  }
	  if (!setUp) {
	    var googleMapScript = document.createElement('SCRIPT');
	
	    // Allow apiKey to be an object.
	    // This is to support more esoteric means of loading Google Maps,
	    // such as Google for business
	    // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
	    var options = {};
	    if (typeof apiKey == 'string') {
	      options.key = apiKey;
	    } else if ((typeof apiKey === 'undefined' ? 'undefined' : (0, _typeof3.default)(apiKey)) == 'object') {
	      for (var k in apiKey) {
	        // transfer values in apiKey to options
	        options[k] = apiKey[k];
	      }
	    } else {
	      throw new Error('apiKey should either be a string or an object');
	    }
	
	    // libraries
	    var librariesPath = '';
	    if (libraries && libraries.length > 0) {
	      librariesPath = libraries.join(',');
	      options['libraries'] = librariesPath;
	    } else if (Array.prototype.isPrototypeOf(options.libraries)) {
	      options.libraries = options.libraries.join(',');
	    }
	    options['callback'] = 'vueGoogleMapsInit';
	
	    var baseUrl = 'https://maps.googleapis.com/';
	
	    if (typeof loadCn == 'boolean' && loadCn === true) {
	      baseUrl = 'http://maps.google.cn/';
	    }
	
	    var url = baseUrl + 'maps/api/js?' + (0, _keys2.default)(options).map(function (key) {
	      return encodeURIComponent(key) + '=' + encodeURIComponent(options[key]);
	    }).join('&');
	
	    if (version) {
	      url = url + '&v=' + version;
	    }
	
	    googleMapScript.setAttribute('src', url);
	    googleMapScript.setAttribute('async', '');
	    googleMapScript.setAttribute('defer', '');
	    document.body.appendChild(googleMapScript);
	  } else {
	    throw new Error('You already started the loading of google maps');
	  }
	};

/***/ }),
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(82)
	  , TAG = __webpack_require__(25)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(57)
	  , call        = __webpack_require__(191)
	  , isArrayIter = __webpack_require__(190)
	  , anObject    = __webpack_require__(56)
	  , toLength    = __webpack_require__(198)
	  , getIterFn   = __webpack_require__(131);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(189)
	  , defined = __webpack_require__(94);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(494);
	var Iterators = __webpack_require__(74);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(28);
	var toLength = __webpack_require__(13);
	var toAbsoluteIndex = __webpack_require__(67);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(22);
	var redefineAll = __webpack_require__(65);
	var meta = __webpack_require__(52);
	var forOf = __webpack_require__(59);
	var anInstance = __webpack_require__(58);
	var isObject = __webpack_require__(7);
	var fails = __webpack_require__(6);
	var $iterDetect = __webpack_require__(106);
	var setToStringTag = __webpack_require__(76);
	var inheritIfRequired = __webpack_require__(143);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(21);
	var redefine = __webpack_require__(22);
	var fails = __webpack_require__(6);
	var defined = __webpack_require__(37);
	var wks = __webpack_require__(10);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(4);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(29);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(7);
	var cof = __webpack_require__(29);
	var MATCH = __webpack_require__(10)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(10)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(60) || !__webpack_require__(6)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(5)[K];
	});


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(18);
	var ctx = __webpack_require__(30);
	var forOf = __webpack_require__(59);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(4);
	var aFunction = __webpack_require__(18);
	var SPECIES = __webpack_require__(10)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var hide = __webpack_require__(21);
	var uid = __webpack_require__(68);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	var JsonWebTokenError = function (message, error) {
	  Error.call(this, message);
	  if(Error.captureStackTrace) {
	    Error.captureStackTrace(this, this.constructor);
	  }
	  this.name = 'JsonWebTokenError';
	  this.message = message;
	  if (error) this.inner = error;
	};
	
	JsonWebTokenError.prototype = Object.create(Error.prototype);
	JsonWebTokenError.prototype.constructor = JsonWebTokenError;
	
	module.exports = JsonWebTokenError;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Papa Parse
		v4.3.6
		https://github.com/mholt/PapaParse
		License: MIT
	*/
	(function(root, factory)
	{
		if (true)
		{
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if (typeof module === 'object' && typeof exports !== 'undefined')
		{
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		}
		else
		{
			// Browser globals (root is window)
			root.Papa = factory();
		}
	}(this, function()
	{
		'use strict';
	
		var global = (function () {
			// alternative method, similar to `Function('return this')()`
			// but without using `eval` (which is disabled when
			// using Content Security Policy).
	
			if (typeof self !== 'undefined') { return self; }
			if (typeof window !== 'undefined') { return window; }
			if (typeof global !== 'undefined') { return global; }
	
			// When running tests none of the above have been defined
			return {};
		})();
	
	
		var IS_WORKER = !global.document && !!global.postMessage,
			IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
			LOADED_SYNC = false, AUTO_SCRIPT_PATH;
		var workers = {}, workerIdCounter = 0;
	
		var Papa = {};
	
		Papa.parse = CsvToJson;
		Papa.unparse = JsonToCsv;
	
		Papa.RECORD_SEP = String.fromCharCode(30);
		Papa.UNIT_SEP = String.fromCharCode(31);
		Papa.BYTE_ORDER_MARK = '\ufeff';
		Papa.BAD_DELIMITERS = ['\r', '\n', '"', Papa.BYTE_ORDER_MARK];
		Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
		Papa.SCRIPT_PATH = null;	// Must be set by your code if you use workers and this lib is loaded asynchronously
	
		// Configurable chunk sizes for local and remote files, respectively
		Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
		Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
		Papa.DefaultDelimiter = ',';			// Used if not specified and detection fails
	
		// Exposed for testing and development only
		Papa.Parser = Parser;
		Papa.ParserHandle = ParserHandle;
		Papa.NetworkStreamer = NetworkStreamer;
		Papa.FileStreamer = FileStreamer;
		Papa.StringStreamer = StringStreamer;
		Papa.ReadableStreamStreamer = ReadableStreamStreamer;
	
		if (global.jQuery)
		{
			var $ = global.jQuery;
			$.fn.parse = function(options)
			{
				var config = options.config || {};
				var queue = [];
	
				this.each(function(idx)
				{
					var supported = $(this).prop('tagName').toUpperCase() === 'INPUT'
									&& $(this).attr('type').toLowerCase() === 'file'
									&& global.FileReader;
	
					if (!supported || !this.files || this.files.length === 0)
						return true;	// continue to next input element
	
					for (var i = 0; i < this.files.length; i++)
					{
						queue.push({
							file: this.files[i],
							inputElem: this,
							instanceConfig: $.extend({}, config)
						});
					}
				});
	
				parseNextFile();	// begin parsing
				return this;		// maintains chainability
	
	
				function parseNextFile()
				{
					if (queue.length === 0)
					{
						if (isFunction(options.complete))
							options.complete();
						return;
					}
	
					var f = queue[0];
	
					if (isFunction(options.before))
					{
						var returned = options.before(f.file, f.inputElem);
	
						if (typeof returned === 'object')
						{
							if (returned.action === 'abort')
							{
								error('AbortError', f.file, f.inputElem, returned.reason);
								return;	// Aborts all queued files immediately
							}
							else if (returned.action === 'skip')
							{
								fileComplete();	// parse the next file in the queue, if any
								return;
							}
							else if (typeof returned.config === 'object')
								f.instanceConfig = $.extend(f.instanceConfig, returned.config);
						}
						else if (returned === 'skip')
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
					}
	
					// Wrap up the user's complete callback, if any, so that ours also gets executed
					var userCompleteFunc = f.instanceConfig.complete;
					f.instanceConfig.complete = function(results)
					{
						if (isFunction(userCompleteFunc))
							userCompleteFunc(results, f.file, f.inputElem);
						fileComplete();
					};
	
					Papa.parse(f.file, f.instanceConfig);
				}
	
				function error(name, file, elem, reason)
				{
					if (isFunction(options.error))
						options.error({name: name}, file, elem, reason);
				}
	
				function fileComplete()
				{
					queue.splice(0, 1);
					parseNextFile();
				}
			}
		}
	
	
		if (IS_PAPA_WORKER)
		{
			global.onmessage = workerThreadReceivedMessage;
		}
		else if (Papa.WORKERS_SUPPORTED)
		{
			AUTO_SCRIPT_PATH = getScriptPath();
	
			// Check if the script was loaded synchronously
			if (!document.body)
			{
				// Body doesn't exist yet, must be synchronous
				LOADED_SYNC = true;
			}
			else
			{
				document.addEventListener('DOMContentLoaded', function () {
					LOADED_SYNC = true;
				}, true);
			}
		}
	
	
	
	
		function CsvToJson(_input, _config)
		{
			_config = _config || {};
			var dynamicTyping = _config.dynamicTyping || false;
			if (isFunction(dynamicTyping)) {
				_config.dynamicTypingFunction = dynamicTyping;
				// Will be filled on first row call
				dynamicTyping = {};
			}
			_config.dynamicTyping = dynamicTyping;
	
			if (_config.worker && Papa.WORKERS_SUPPORTED)
			{
				var w = newWorker();
	
				w.userStep = _config.step;
				w.userChunk = _config.chunk;
				w.userComplete = _config.complete;
				w.userError = _config.error;
	
				_config.step = isFunction(_config.step);
				_config.chunk = isFunction(_config.chunk);
				_config.complete = isFunction(_config.complete);
				_config.error = isFunction(_config.error);
				delete _config.worker;	// prevent infinite loop
	
				w.postMessage({
					input: _input,
					config: _config,
					workerId: w.id
				});
	
				return;
			}
	
			var streamer = null;
			if (typeof _input === 'string')
			{
				if (_config.download)
					streamer = new NetworkStreamer(_config);
				else
					streamer = new StringStreamer(_config);
			}
			else if (_input.readable === true && isFunction(_input.read) && isFunction(_input.on))
			{
				streamer = new ReadableStreamStreamer(_config);
			}
			else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
				streamer = new FileStreamer(_config);
	
			return streamer.stream(_input);
		}
	
	
	
	
	
	
		function JsonToCsv(_input, _config)
		{
			var _output = '';
			var _fields = [];
	
			// Default configuration
	
			/** whether to surround every datum with quotes */
			var _quotes = false;
	
			/** whether to write headers */
			var _writeHeader = true;
	
			/** delimiting character */
			var _delimiter = ',';
	
			/** newline character(s) */
			var _newline = '\r\n';
	
			/** quote character */
			var _quoteChar = '"';
	
			unpackConfig();
	
			var quoteCharRegex = new RegExp(_quoteChar, 'g');
	
			if (typeof _input === 'string')
				_input = JSON.parse(_input);
	
			if (_input instanceof Array)
			{
				if (!_input.length || _input[0] instanceof Array)
					return serialize(null, _input);
				else if (typeof _input[0] === 'object')
					return serialize(objectKeys(_input[0]), _input);
			}
			else if (typeof _input === 'object')
			{
				if (typeof _input.data === 'string')
					_input.data = JSON.parse(_input.data);
	
				if (_input.data instanceof Array)
				{
					if (!_input.fields)
						_input.fields =  _input.meta && _input.meta.fields;
	
					if (!_input.fields)
						_input.fields =  _input.data[0] instanceof Array
										? _input.fields
										: objectKeys(_input.data[0]);
	
					if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
						_input.data = [_input.data];	// handles input like [1,2,3] or ['asdf']
				}
	
				return serialize(_input.fields || [], _input.data || []);
			}
	
			// Default (any valid paths should return before this)
			throw 'exception: Unable to serialize unrecognized input';
	
	
			function unpackConfig()
			{
				if (typeof _config !== 'object')
					return;
	
				if (typeof _config.delimiter === 'string'
					&& _config.delimiter.length === 1
					&& Papa.BAD_DELIMITERS.indexOf(_config.delimiter) === -1)
				{
					_delimiter = _config.delimiter;
				}
	
				if (typeof _config.quotes === 'boolean'
					|| _config.quotes instanceof Array)
					_quotes = _config.quotes;
	
				if (typeof _config.newline === 'string')
					_newline = _config.newline;
	
				if (typeof _config.quoteChar === 'string')
					_quoteChar = _config.quoteChar;
	
				if (typeof _config.header === 'boolean')
					_writeHeader = _config.header;
			}
	
	
			/** Turns an object's keys into an array */
			function objectKeys(obj)
			{
				if (typeof obj !== 'object')
					return [];
				var keys = [];
				for (var key in obj)
					keys.push(key);
				return keys;
			}
	
			/** The double for loop that iterates the data and writes out a CSV string including header row */
			function serialize(fields, data)
			{
				var csv = '';
	
				if (typeof fields === 'string')
					fields = JSON.parse(fields);
				if (typeof data === 'string')
					data = JSON.parse(data);
	
				var hasHeader = fields instanceof Array && fields.length > 0;
				var dataKeyedByField = !(data[0] instanceof Array);
	
				// If there a header row, write it first
				if (hasHeader && _writeHeader)
				{
					for (var i = 0; i < fields.length; i++)
					{
						if (i > 0)
							csv += _delimiter;
						csv += safe(fields[i], i);
					}
					if (data.length > 0)
						csv += _newline;
				}
	
				// Then write out the data
				for (var row = 0; row < data.length; row++)
				{
					var maxCol = hasHeader ? fields.length : data[row].length;
	
					for (var col = 0; col < maxCol; col++)
					{
						if (col > 0)
							csv += _delimiter;
						var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
						csv += safe(data[row][colIdx], col);
					}
	
					if (row < data.length - 1)
						csv += _newline;
				}
	
				return csv;
			}
	
			/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
			function safe(str, col)
			{
				if (typeof str === 'undefined' || str === null)
					return '';
	
				str = str.toString().replace(quoteCharRegex, _quoteChar+_quoteChar);
	
				var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
								|| (_quotes instanceof Array && _quotes[col])
								|| hasAny(str, Papa.BAD_DELIMITERS)
								|| str.indexOf(_delimiter) > -1
								|| str.charAt(0) === ' '
								|| str.charAt(str.length - 1) === ' ';
	
				return needsQuotes ? _quoteChar + str + _quoteChar : str;
			}
	
			function hasAny(str, substrings)
			{
				for (var i = 0; i < substrings.length; i++)
					if (str.indexOf(substrings[i]) > -1)
						return true;
				return false;
			}
		}
	
		/** ChunkStreamer is the base prototype for various streamer implementations. */
		function ChunkStreamer(config)
		{
			this._handle = null;
			this._paused = false;
			this._finished = false;
			this._input = null;
			this._baseIndex = 0;
			this._partialLine = '';
			this._rowCount = 0;
			this._start = 0;
			this._nextChunk = null;
			this.isFirstChunk = true;
			this._completeResults = {
				data: [],
				errors: [],
				meta: {}
			};
			replaceConfig.call(this, config);
	
			this.parseChunk = function(chunk)
			{
				// First chunk pre-processing
				if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
				{
					var modifiedChunk = this._config.beforeFirstChunk(chunk);
					if (modifiedChunk !== undefined)
						chunk = modifiedChunk;
				}
				this.isFirstChunk = false;
	
				// Rejoin the line we likely just split in two by chunking the file
				var aggregate = this._partialLine + chunk;
				this._partialLine = '';
	
				var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);
	
				if (this._handle.paused() || this._handle.aborted())
					return;
	
				var lastIndex = results.meta.cursor;
	
				if (!this._finished)
				{
					this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
					this._baseIndex = lastIndex;
				}
	
				if (results && results.data)
					this._rowCount += results.data.length;
	
				var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);
	
				if (IS_PAPA_WORKER)
				{
					global.postMessage({
						results: results,
						workerId: Papa.WORKER_ID,
						finished: finishedIncludingPreview
					});
				}
				else if (isFunction(this._config.chunk))
				{
					this._config.chunk(results, this._handle);
					if (this._paused)
						return;
					results = undefined;
					this._completeResults = undefined;
				}
	
				if (!this._config.step && !this._config.chunk) {
					this._completeResults.data = this._completeResults.data.concat(results.data);
					this._completeResults.errors = this._completeResults.errors.concat(results.errors);
					this._completeResults.meta = results.meta;
				}
	
				if (finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted))
					this._config.complete(this._completeResults, this._input);
	
				if (!finishedIncludingPreview && (!results || !results.meta.paused))
					this._nextChunk();
	
				return results;
			};
	
			this._sendError = function(error)
			{
				if (isFunction(this._config.error))
					this._config.error(error);
				else if (IS_PAPA_WORKER && this._config.error)
				{
					global.postMessage({
						workerId: Papa.WORKER_ID,
						error: error,
						finished: false
					});
				}
			};
	
			function replaceConfig(config)
			{
				// Deep-copy the config so we can edit it
				var configCopy = copy(config);
				configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
				if (!config.step && !config.chunk)
					configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
				this._handle = new ParserHandle(configCopy);
				this._handle.streamer = this;
				this._config = configCopy;	// persist the copy to the caller
			}
		}
	
	
		function NetworkStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.RemoteChunkSize;
			ChunkStreamer.call(this, config);
	
			var xhr;
	
			if (IS_WORKER)
			{
				this._nextChunk = function()
				{
					this._readChunk();
					this._chunkLoaded();
				};
			}
			else
			{
				this._nextChunk = function()
				{
					this._readChunk();
				};
			}
	
			this.stream = function(url)
			{
				this._input = url;
				this._nextChunk();	// Starts streaming
			};
	
			this._readChunk = function()
			{
				if (this._finished)
				{
					this._chunkLoaded();
					return;
				}
	
				xhr = new XMLHttpRequest();
	
				if (this._config.withCredentials)
				{
					xhr.withCredentials = this._config.withCredentials;
				}
	
				if (!IS_WORKER)
				{
					xhr.onload = bindFunction(this._chunkLoaded, this);
					xhr.onerror = bindFunction(this._chunkError, this);
				}
	
				xhr.open('GET', this._input, !IS_WORKER);
				// Headers can only be set when once the request state is OPENED
				if (this._config.downloadRequestHeaders)
				{
					var headers = this._config.downloadRequestHeaders;
	
					for (var headerName in headers)
					{
						xhr.setRequestHeader(headerName, headers[headerName]);
					}
				}
	
				if (this._config.chunkSize)
				{
					var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
					xhr.setRequestHeader('Range', 'bytes='+this._start+'-'+end);
					xhr.setRequestHeader('If-None-Match', 'webkit-no-cache'); // https://bugs.webkit.org/show_bug.cgi?id=82672
				}
	
				try {
					xhr.send();
				}
				catch (err) {
					this._chunkError(err.message);
				}
	
				if (IS_WORKER && xhr.status === 0)
					this._chunkError();
				else
					this._start += this._config.chunkSize;
			}
	
			this._chunkLoaded = function()
			{
				if (xhr.readyState != 4)
					return;
	
				if (xhr.status < 200 || xhr.status >= 400)
				{
					this._chunkError();
					return;
				}
	
				this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
				this.parseChunk(xhr.responseText);
			}
	
			this._chunkError = function(errorMessage)
			{
				var errorText = xhr.statusText || errorMessage;
				this._sendError(errorText);
			}
	
			function getFileSize(xhr)
			{
				var contentRange = xhr.getResponseHeader('Content-Range');
				if (contentRange === null) { // no content range, then finish!
						return -1;
						}
				return parseInt(contentRange.substr(contentRange.lastIndexOf('/') + 1));
			}
		}
		NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
		NetworkStreamer.prototype.constructor = NetworkStreamer;
	
	
		function FileStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.LocalChunkSize;
			ChunkStreamer.call(this, config);
	
			var reader, slice;
	
			// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
			// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
			var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105
	
			this.stream = function(file)
			{
				this._input = file;
				slice = file.slice || file.webkitSlice || file.mozSlice;
	
				if (usingAsyncReader)
				{
					reader = new FileReader();		// Preferred method of reading files, even in workers
					reader.onload = bindFunction(this._chunkLoaded, this);
					reader.onerror = bindFunction(this._chunkError, this);
				}
				else
					reader = new FileReaderSync();	// Hack for running in a web worker in Firefox
	
				this._nextChunk();	// Starts streaming
			};
	
			this._nextChunk = function()
			{
				if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
					this._readChunk();
			}
	
			this._readChunk = function()
			{
				var input = this._input;
				if (this._config.chunkSize)
				{
					var end = Math.min(this._start + this._config.chunkSize, this._input.size);
					input = slice.call(input, this._start, end);
				}
				var txt = reader.readAsText(input, this._config.encoding);
				if (!usingAsyncReader)
					this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
			}
	
			this._chunkLoaded = function(event)
			{
				// Very important to increment start each time before handling results
				this._start += this._config.chunkSize;
				this._finished = !this._config.chunkSize || this._start >= this._input.size;
				this.parseChunk(event.target.result);
			}
	
			this._chunkError = function()
			{
				this._sendError(reader.error);
			}
	
		}
		FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
		FileStreamer.prototype.constructor = FileStreamer;
	
	
		function StringStreamer(config)
		{
			config = config || {};
			ChunkStreamer.call(this, config);
	
			var string;
			var remaining;
			this.stream = function(s)
			{
				string = s;
				remaining = s;
				return this._nextChunk();
			}
			this._nextChunk = function()
			{
				if (this._finished) return;
				var size = this._config.chunkSize;
				var chunk = size ? remaining.substr(0, size) : remaining;
				remaining = size ? remaining.substr(size) : '';
				this._finished = !remaining;
				return this.parseChunk(chunk);
			}
		}
		StringStreamer.prototype = Object.create(StringStreamer.prototype);
		StringStreamer.prototype.constructor = StringStreamer;
	
	
		function ReadableStreamStreamer(config)
		{
			config = config || {};
	
			ChunkStreamer.call(this, config);
	
			var queue = [];
			var parseOnData = true;
	
			this.stream = function(stream)
			{
				this._input = stream;
	
				this._input.on('data', this._streamData);
				this._input.on('end', this._streamEnd);
				this._input.on('error', this._streamError);
			}
	
			this._nextChunk = function()
			{
				if (queue.length)
				{
					this.parseChunk(queue.shift());
				}
				else
				{
					parseOnData = true;
				}
			}
	
			this._streamData = bindFunction(function(chunk)
			{
				try
				{
					queue.push(typeof chunk === 'string' ? chunk : chunk.toString(this._config.encoding));
	
					if (parseOnData)
					{
						parseOnData = false;
						this.parseChunk(queue.shift());
					}
				}
				catch (error)
				{
					this._streamError(error);
				}
			}, this);
	
			this._streamError = bindFunction(function(error)
			{
				this._streamCleanUp();
				this._sendError(error.message);
			}, this);
	
			this._streamEnd = bindFunction(function()
			{
				this._streamCleanUp();
				this._finished = true;
				this._streamData('');
			}, this);
	
			this._streamCleanUp = bindFunction(function()
			{
				this._input.removeListener('data', this._streamData);
				this._input.removeListener('end', this._streamEnd);
				this._input.removeListener('error', this._streamError);
			}, this);
		}
		ReadableStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
		ReadableStreamStreamer.prototype.constructor = ReadableStreamStreamer;
	
	
		// Use one ParserHandle per entire CSV file or string
		function ParserHandle(_config)
		{
			// One goal is to minimize the use of regular expressions...
			var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;
	
			var self = this;
			var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
			var _input;				// The input being parsed
			var _parser;			// The core parser being used
			var _paused = false;	// Whether we are paused or not
			var _aborted = false;	// Whether the parser has aborted or not
			var _delimiterError;	// Temporary state between delimiter detection and processing results
			var _fields = [];		// Fields are from the header row of the input, if there is one
			var _results = {		// The last results returned from the parser
				data: [],
				errors: [],
				meta: {}
			};
	
			if (isFunction(_config.step))
			{
				var userStep = _config.step;
				_config.step = function(results)
				{
					_results = results;
	
					if (needsHeaderRow())
						processResults();
					else	// only call user's step function after header row
					{
						processResults();
	
						// It's possbile that this line was empty and there's no row here after all
						if (_results.data.length === 0)
							return;
	
						_stepCounter += results.data.length;
						if (_config.preview && _stepCounter > _config.preview)
							_parser.abort();
						else
							userStep(_results, self);
					}
				};
			}
	
			/**
			 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
			 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
			 * when an input comes in multiple chunks, like from a file.
			 */
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				if (!_config.newline)
					_config.newline = guessLineEndings(input);
	
				_delimiterError = false;
				if (!_config.delimiter)
				{
					var delimGuess = guessDelimiter(input, _config.newline, _config.skipEmptyLines);
					if (delimGuess.successful)
						_config.delimiter = delimGuess.bestDelimiter;
					else
					{
						_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
						_config.delimiter = Papa.DefaultDelimiter;
					}
					_results.meta.delimiter = _config.delimiter;
				}
				else if(isFunction(_config.delimiter))
				{
					_config.delimiter = _config.delimiter(input);
					_results.meta.delimiter = _config.delimiter;
				}
	
				var parserConfig = copy(_config);
				if (_config.preview && _config.header)
					parserConfig.preview++;	// to compensate for header row
	
				_input = input;
				_parser = new Parser(parserConfig);
				_results = _parser.parse(_input, baseIndex, ignoreLastRow);
				processResults();
				return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
			};
	
			this.paused = function()
			{
				return _paused;
			};
	
			this.pause = function()
			{
				_paused = true;
				_parser.abort();
				_input = _input.substr(_parser.getCharIndex());
			};
	
			this.resume = function()
			{
				_paused = false;
				self.streamer.parseChunk(_input);
			};
	
			this.aborted = function ()
			{
				return _aborted;
			};
	
			this.abort = function()
			{
				_aborted = true;
				_parser.abort();
				_results.meta.aborted = true;
				if (isFunction(_config.complete))
					_config.complete(_results);
				_input = '';
			};
	
			function processResults()
			{
				if (_results && _delimiterError)
				{
					addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \''+Papa.DefaultDelimiter+'\'');
					_delimiterError = false;
				}
	
				if (_config.skipEmptyLines)
				{
					for (var i = 0; i < _results.data.length; i++)
						if (_results.data[i].length === 1 && _results.data[i][0] === '')
							_results.data.splice(i--, 1);
				}
	
				if (needsHeaderRow())
					fillHeaderFields();
	
				return applyHeaderAndDynamicTyping();
			}
	
			function needsHeaderRow()
			{
				return _config.header && _fields.length === 0;
			}
	
			function fillHeaderFields()
			{
				if (!_results)
					return;
				for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
					for (var j = 0; j < _results.data[i].length; j++)
						_fields.push(_results.data[i][j]);
				_results.data.splice(0, 1);
			}
	
			function shouldApplyDynamicTyping(field) {
				// Cache function values to avoid calling it for each row
				if (_config.dynamicTypingFunction && _config.dynamicTyping[field] === undefined) {
					_config.dynamicTyping[field] = _config.dynamicTypingFunction(field);
				}
				return (_config.dynamicTyping[field] || _config.dynamicTyping) === true
			}
	
			function parseDynamic(field, value)
			{
				if (shouldApplyDynamicTyping(field))
				{
					if (value === 'true' || value === 'TRUE')
						return true;
					else if (value === 'false' || value === 'FALSE')
						return false;
					else
						return tryParseFloat(value);
				}
				return value;
			}
	
			function applyHeaderAndDynamicTyping()
			{
				if (!_results || (!_config.header && !_config.dynamicTyping))
					return _results;
	
				for (var i = 0; i < _results.data.length; i++)
				{
					var row = _config.header ? {} : [];
	
					for (var j = 0; j < _results.data[i].length; j++)
					{
						var field = j;
						var value = _results.data[i][j];
	
						if (_config.header)
							field = j >= _fields.length ? '__parsed_extra' : _fields[j];
	
						value = parseDynamic(field, value);
	
						if (field === '__parsed_extra')
						{
							row[field] = row[field] || [];
							row[field].push(value);
						}
						else
							row[field] = value;
					}
	
					_results.data[i] = row;
	
					if (_config.header)
					{
						if (j > _fields.length)
							addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
						else if (j < _fields.length)
							addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
					}
				}
	
				if (_config.header && _results.meta)
					_results.meta.fields = _fields;
				return _results;
			}
	
			function guessDelimiter(input, newline, skipEmptyLines)
			{
				var delimChoices = [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP];
				var bestDelim, bestDelta, fieldCountPrevRow;
	
				for (var i = 0; i < delimChoices.length; i++)
				{
					var delim = delimChoices[i];
					var delta = 0, avgFieldCount = 0, emptyLinesCount = 0;
					fieldCountPrevRow = undefined;
	
					var preview = new Parser({
						delimiter: delim,
						newline: newline,
						preview: 10
					}).parse(input);
	
					for (var j = 0; j < preview.data.length; j++)
					{
						if (skipEmptyLines && preview.data[j].length === 1 && preview.data[j][0].length === 0) {
							emptyLinesCount++
							continue
						}
						var fieldCount = preview.data[j].length;
						avgFieldCount += fieldCount;
	
						if (typeof fieldCountPrevRow === 'undefined')
						{
							fieldCountPrevRow = fieldCount;
							continue;
						}
						else if (fieldCount > 1)
						{
							delta += Math.abs(fieldCount - fieldCountPrevRow);
							fieldCountPrevRow = fieldCount;
						}
					}
	
					if (preview.data.length > 0)
						avgFieldCount /= (preview.data.length - emptyLinesCount);
	
					if ((typeof bestDelta === 'undefined' || delta < bestDelta)
						&& avgFieldCount > 1.99)
					{
						bestDelta = delta;
						bestDelim = delim;
					}
				}
	
				_config.delimiter = bestDelim;
	
				return {
					successful: !!bestDelim,
					bestDelimiter: bestDelim
				}
			}
	
			function guessLineEndings(input)
			{
				input = input.substr(0, 1024*1024);	// max length 1 MB
	
				var r = input.split('\r');
	
				var n = input.split('\n');
	
				var nAppearsFirst = (n.length > 1 && n[0].length < r[0].length);
	
				if (r.length === 1 || nAppearsFirst)
					return '\n';
	
				var numWithN = 0;
				for (var i = 0; i < r.length; i++)
				{
					if (r[i][0] === '\n')
						numWithN++;
				}
	
				return numWithN >= r.length / 2 ? '\r\n' : '\r';
			}
	
			function tryParseFloat(val)
			{
				var isNumber = FLOAT.test(val);
				return isNumber ? parseFloat(val) : val;
			}
	
			function addError(type, code, msg, row)
			{
				_results.errors.push({
					type: type,
					code: code,
					message: msg,
					row: row
				});
			}
		}
	
	
	
	
	
		/** The core parser implements speedy and correct CSV parsing */
		function Parser(config)
		{
			// Unpack the config object
			config = config || {};
			var delim = config.delimiter;
			var newline = config.newline;
			var comments = config.comments;
			var step = config.step;
			var preview = config.preview;
			var fastMode = config.fastMode;
			var quoteChar = config.quoteChar || '"';
	
			// Delimiter must be valid
			if (typeof delim !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
				delim = ',';
	
			// Comment character must be valid
			if (comments === delim)
				throw 'Comment character same as delimiter';
			else if (comments === true)
				comments = '#';
			else if (typeof comments !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
				comments = false;
	
			// Newline must be valid: \r, \n, or \r\n
			if (newline != '\n' && newline != '\r' && newline != '\r\n')
				newline = '\n';
	
			// We're gonna need these at the Parser scope
			var cursor = 0;
			var aborted = false;
	
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				// For some reason, in Chrome, this speeds things up (!?)
				if (typeof input !== 'string')
					throw 'Input must be a string';
	
				// We don't need to compute some of these every time parse() is called,
				// but having them in a more local scope seems to perform better
				var inputLen = input.length,
					delimLen = delim.length,
					newlineLen = newline.length,
					commentsLen = comments.length;
				var stepIsFunction = isFunction(step);
	
				// Establish starting state
				cursor = 0;
				var data = [], errors = [], row = [], lastCursor = 0;
	
				if (!input)
					return returnable();
	
				if (fastMode || (fastMode !== false && input.indexOf(quoteChar) === -1))
				{
					var rows = input.split(newline);
					for (var i = 0; i < rows.length; i++)
					{
						var row = rows[i];
						cursor += row.length;
						if (i !== rows.length - 1)
							cursor += newline.length;
						else if (ignoreLastRow)
							return returnable();
						if (comments && row.substr(0, commentsLen) === comments)
							continue;
						if (stepIsFunction)
						{
							data = [];
							pushRow(row.split(delim));
							doStep();
							if (aborted)
								return returnable();
						}
						else
							pushRow(row.split(delim));
						if (preview && i >= preview)
						{
							data = data.slice(0, preview);
							return returnable(true);
						}
					}
					return returnable();
				}
	
				var nextDelim = input.indexOf(delim, cursor);
				var nextNewline = input.indexOf(newline, cursor);
				var quoteCharRegex = new RegExp(quoteChar+quoteChar, 'g');
	
				// Parser loop
				for (;;)
				{
					// Field has opening quote
					if (input[cursor] === quoteChar)
					{
						// Start our search for the closing quote where the cursor is
						var quoteSearch = cursor;
	
						// Skip the opening quote
						cursor++;
	
						for (;;)
						{
							// Find closing quote
							var quoteSearch = input.indexOf(quoteChar, quoteSearch+1);
	
							//No other quotes are found - no other delimiters
							if (quoteSearch === -1)
							{
								if (!ignoreLastRow) {
									// No closing quote... what a pity
									errors.push({
										type: 'Quotes',
										code: 'MissingQuotes',
										message: 'Quoted field unterminated',
										row: data.length,	// row has yet to be inserted
										index: cursor
									});
								}
								return finish();
							}
	
							// Closing quote at EOF
							if (quoteSearch === inputLen-1)
							{
								var value = input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar);
								return finish(value);
							}
	
							// If this quote is escaped, it's part of the data; skip it
							if (input[quoteSearch+1] === quoteChar)
							{
								quoteSearch++;
								continue;
							}
	
							// Closing quote followed by delimiter
							if (input[quoteSearch+1] === delim)
							{
								row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
								cursor = quoteSearch + 1 + delimLen;
								nextDelim = input.indexOf(delim, cursor);
								nextNewline = input.indexOf(newline, cursor);
								break;
							}
	
							// Closing quote followed by newline
							if (input.substr(quoteSearch+1, newlineLen) === newline)
							{
								row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
								saveRow(quoteSearch + 1 + newlineLen);
								nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field
	
								if (stepIsFunction)
								{
									doStep();
									if (aborted)
										return returnable();
								}
	
								if (preview && data.length >= preview)
									return returnable(true);
	
								break;
							}
	
	
							// Checks for valid closing quotes are complete (escaped quotes or quote followed by EOF/delimiter/newline) -- assume these quotes are part of an invalid text string
							errors.push({
								type: 'Quotes',
								code: 'InvalidQuotes',
								message: 'Trailing quote on quoted field is malformed',
								row: data.length,	// row has yet to be inserted
								index: cursor
							});
	
							quoteSearch++;
							continue;
	
						}
	
						continue;
					}
	
					// Comment found at start of new line
					if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
					{
						if (nextNewline === -1)	// Comment ends at EOF
							return returnable();
						cursor = nextNewline + newlineLen;
						nextNewline = input.indexOf(newline, cursor);
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// Next delimiter comes before next newline, so we've reached end of field
					if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
					{
						row.push(input.substring(cursor, nextDelim));
						cursor = nextDelim + delimLen;
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// End of row
					if (nextNewline !== -1)
					{
						row.push(input.substring(cursor, nextNewline));
						saveRow(nextNewline + newlineLen);
	
						if (stepIsFunction)
						{
							doStep();
							if (aborted)
								return returnable();
						}
	
						if (preview && data.length >= preview)
							return returnable(true);
	
						continue;
					}
	
					break;
				}
	
	
				return finish();
	
	
				function pushRow(row)
				{
					data.push(row);
					lastCursor = cursor;
				}
	
				/**
				 * Appends the remaining input from cursor to the end into
				 * row, saves the row, calls step, and returns the results.
				 */
				function finish(value)
				{
					if (ignoreLastRow)
						return returnable();
					if (typeof value === 'undefined')
						value = input.substr(cursor);
					row.push(value);
					cursor = inputLen;	// important in case parsing is paused
					pushRow(row);
					if (stepIsFunction)
						doStep();
					return returnable();
				}
	
				/**
				 * Appends the current row to the results. It sets the cursor
				 * to newCursor and finds the nextNewline. The caller should
				 * take care to execute user's step function and check for
				 * preview and end parsing if necessary.
				 */
				function saveRow(newCursor)
				{
					cursor = newCursor;
					pushRow(row);
					row = [];
					nextNewline = input.indexOf(newline, cursor);
				}
	
				/** Returns an object with the results, errors, and meta. */
				function returnable(stopped)
				{
					return {
						data: data,
						errors: errors,
						meta: {
							delimiter: delim,
							linebreak: newline,
							aborted: aborted,
							truncated: !!stopped,
							cursor: lastCursor + (baseIndex || 0)
						}
					};
				}
	
				/** Executes the user's step function and resets data & errors. */
				function doStep()
				{
					step(returnable());
					data = [], errors = [];
				}
			};
	
			/** Sets the abort flag */
			this.abort = function()
			{
				aborted = true;
			};
	
			/** Gets the cursor position */
			this.getCharIndex = function()
			{
				return cursor;
			};
		}
	
	
		// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
		// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
		function getScriptPath()
		{
			var scripts = document.getElementsByTagName('script');
			return scripts.length ? scripts[scripts.length - 1].src : '';
		}
	
		function newWorker()
		{
			if (!Papa.WORKERS_SUPPORTED)
				return false;
			if (!LOADED_SYNC && Papa.SCRIPT_PATH === null)
				throw new Error(
					'Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' +
					'You need to set Papa.SCRIPT_PATH manually.'
				);
			var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
			// Append 'papaworker' to the search string to tell papaparse that this is our worker.
			workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
			var w = new global.Worker(workerUrl);
			w.onmessage = mainThreadReceivedMessage;
			w.id = workerIdCounter++;
			workers[w.id] = w;
			return w;
		}
	
		/** Callback when main thread receives a message */
		function mainThreadReceivedMessage(e)
		{
			var msg = e.data;
			var worker = workers[msg.workerId];
			var aborted = false;
	
			if (msg.error)
				worker.userError(msg.error, msg.file);
			else if (msg.results && msg.results.data)
			{
				var abort = function() {
					aborted = true;
					completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
				};
	
				var handle = {
					abort: abort,
					pause: notImplemented,
					resume: notImplemented
				};
	
				if (isFunction(worker.userStep))
				{
					for (var i = 0; i < msg.results.data.length; i++)
					{
						worker.userStep({
							data: [msg.results.data[i]],
							errors: msg.results.errors,
							meta: msg.results.meta
						}, handle);
						if (aborted)
							break;
					}
					delete msg.results;	// free memory ASAP
				}
				else if (isFunction(worker.userChunk))
				{
					worker.userChunk(msg.results, handle, msg.file);
					delete msg.results;
				}
			}
	
			if (msg.finished && !aborted)
				completeWorker(msg.workerId, msg.results);
		}
	
		function completeWorker(workerId, results) {
			var worker = workers[workerId];
			if (isFunction(worker.userComplete))
				worker.userComplete(results);
			worker.terminate();
			delete workers[workerId];
		}
	
		function notImplemented() {
			throw 'Not implemented.';
		}
	
		/** Callback when worker thread receives a message */
		function workerThreadReceivedMessage(e)
		{
			var msg = e.data;
	
			if (typeof Papa.WORKER_ID === 'undefined' && msg)
				Papa.WORKER_ID = msg.workerId;
	
			if (typeof msg.input === 'string')
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: Papa.parse(msg.input, msg.config),
					finished: true
				});
			}
			else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
			{
				var results = Papa.parse(msg.input, msg.config);
				if (results)
					global.postMessage({
						workerId: Papa.WORKER_ID,
						results: results,
						finished: true
					});
			}
		}
	
		/** Makes a deep copy of an array or object (mostly) */
		function copy(obj)
		{
			if (typeof obj !== 'object')
				return obj;
			var cpy = obj instanceof Array ? [] : {};
			for (var key in obj)
				cpy[key] = copy(obj[key]);
			return cpy;
		}
	
		function bindFunction(f, self)
		{
			return function() { f.apply(self, arguments); };
		}
	
		function isFunction(func)
		{
			return typeof func === 'function';
		}
	
		return Papa;
	}));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(163).EventEmitter;
	var inherits = __webpack_require__(41);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(169);
	Stream.Writable = __webpack_require__(1759);
	Stream.Duplex = __webpack_require__(1754);
	Stream.Transform = __webpack_require__(1758);
	Stream.PassThrough = __webpack_require__(1757);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DeferredReadyMixin = exports.DeferredReady = undefined;
	
	var _promise = __webpack_require__(48);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * 1. Create a DeferredReady plugin.
	 *
	 * a. Updates options.configMergeStrategies to handle our new hook correctly (using Promise.all!)
	 *
	 * 2. VueGoogleMaps uses a DeferredReady mixin.
	 *
	 *     a. Each component checks for ancestors that are also DeferredReady (via dispatch/emit)
	 *     b. If no, then run DeferredReady after ready.
	 *     c. If yes, then run DeferredReady after parent's deferredReady.
	 *
	 *
	 * Say we have the following inheritance:
	 *
	 * --> == 'child of'
	 *
	 * A --> B --> C
	 *
	 * ready is called in the following order:
	 *
	 * A.ready, B.ready, C.ready
	 *
	 * C.ready -- no further ancestors supporting mixin, so in ready() we run+
	 *
	   **/
	
	var DeferredReady = exports.DeferredReady = {
	  install: function install(Vue, options) {
	    // eslint-disable-line no-unused-vars
	    // Use the same merge strategy as regular hooks
	    Vue.config.optionMergeStrategies.deferredReady = Vue.config.optionMergeStrategies.created;
	    Vue.config.optionMergeStrategies.beforeDeferredReady = Vue.config.optionMergeStrategies.beforeDeferredReady;
	  }
	};
	
	function runHooks(vm) {
	  var hooks = vm.$options.deferredReady || [];
	
	  // Run the beforeDeferredReady methods first
	  var beforePromise = vm.beforeDeferredReady ? typeof vm.beforeDeferredReady.then === 'function' ? vm.beforeDeferredReady : _promise2.default.all(vm.beforeDeferredReady) : _promise2.default.resolve(null);
	
	  beforePromise.then(function () {
	    if (typeof hooks === 'function') {
	      hooks = [hooks];
	    }
	    return _promise2.default.all(hooks.map(function (x) {
	      try {
	        return x.apply(vm);
	      } catch (err) {
	        console.error(err.stack); // eslint-disable-line no-console
	      }
	    }));
	    // execute all handlers, expecting them to return promises
	    // wait for the promises to complete, before allowing child to execute
	  }).then(function () {
	    vm.$deferredReadyPromiseResolve();
	  });
	}
	
	var DeferredReadyMixin = exports.DeferredReadyMixin = {
	  /* Resolved after the deferredReady has been called
	    and the (optional) promise it returns has been
	    resolved */
	  $deferredReadyPromise: false,
	  $deferredReadyPromiseResolve: false,
	  $deferredReadyAncestor: false,
	
	  created: function created() {
	    var _this = this;
	
	    this.$deferredReadyPromise = new _promise2.default(function (resolve, reject) {
	      // eslint-disable-line no-unused-vars
	      _this.$deferredReadyPromiseResolve = resolve;
	    });
	
	    var search = this.$parent;
	    while (search) {
	      if (search.$deferredReadyPromise) {
	        this.$deferredReadyAncestor = search;
	        break;
	      }
	      search = search.$parent;
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    // Execute the hooks only if this is the first
	    // ancestor that is a DeferredReady
	    // this.$deferredReadyMountedPromiseResolve();
	
	    if (!this.$deferredReadyAncestor) {
	      runHooks(this);
	    } else {
	      this.$deferredReadyAncestor.$deferredReadyPromise.then(function () {
	        runHooks(_this2);
	      });
	    }
	  }
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(53);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(24);
	var normalizeHeaderName = __webpack_require__(402);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(173);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(173);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 121 */,
/* 122 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(124)
	  , $export        = __webpack_require__(43)
	  , redefine       = __webpack_require__(127)
	  , hide           = __webpack_require__(84)
	  , has            = __webpack_require__(96)
	  , Iterators      = __webpack_require__(74)
	  , $iterCreate    = __webpack_require__(482)
	  , setToStringTag = __webpack_require__(85)
	  , getProto       = __webpack_require__(17).getProto
	  , ITERATOR       = __webpack_require__(25)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = true;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(127);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(84);

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(94);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(93)
	  , ITERATOR  = __webpack_require__(25)('iterator')
	  , Iterators = __webpack_require__(74);
	module.exports = __webpack_require__(16).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 132 */
/***/ (function(module, exports) {



/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(117).Transform;
	var inherits = __webpack_require__(41);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(14);
	var toAbsoluteIndex = __webpack_require__(67);
	var toLength = __webpack_require__(13);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(509);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(12);
	var createDesc = __webpack_require__(64);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var document = __webpack_require__(5).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(10)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(5).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var setPrototypeOf = __webpack_require__(151).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(75);
	var ITERATOR = __webpack_require__(10)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(61);
	var descriptor = __webpack_require__(64);
	var setToStringTag = __webpack_require__(76);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(21)(IteratorPrototype, __webpack_require__(10)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(60);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(22);
	var hide = __webpack_require__(21);
	var has = __webpack_require__(20);
	var Iterators = __webpack_require__(75);
	var $iterCreate = __webpack_require__(145);
	var setToStringTag = __webpack_require__(76);
	var getPrototypeOf = __webpack_require__(27);
	var ITERATOR = __webpack_require__(10)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var macrotask = __webpack_require__(157).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(29)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(18);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(7);
	var anObject = __webpack_require__(4);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(30)(Function.call, __webpack_require__(26).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(111)('keys');
	var uid = __webpack_require__(68);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39);
	var defined = __webpack_require__(37);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(105);
	var defined = __webpack_require__(37);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(39);
	var defined = __webpack_require__(37);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(30);
	var invoke = __webpack_require__(216);
	var html = __webpack_require__(142);
	var cel = __webpack_require__(139);
	var global = __webpack_require__(5);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(29)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var DESCRIPTORS = __webpack_require__(11);
	var LIBRARY = __webpack_require__(60);
	var $typed = __webpack_require__(113);
	var hide = __webpack_require__(21);
	var redefineAll = __webpack_require__(65);
	var fails = __webpack_require__(6);
	var anInstance = __webpack_require__(58);
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(13);
	var toIndex = __webpack_require__(234);
	var gOPN = __webpack_require__(62).f;
	var dP = __webpack_require__(12).f;
	var arrayFill = __webpack_require__(136);
	var setToStringTag = __webpack_require__(76);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(36);
	var LIBRARY = __webpack_require__(60);
	var wksExt = __webpack_require__(235);
	var defineProperty = __webpack_require__(12).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(87);
	var ITERATOR = __webpack_require__(10)('iterator');
	var Iterators = __webpack_require__(75);
	module.exports = __webpack_require__(36).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(51);
	var step = __webpack_require__(219);
	var Iterators = __webpack_require__(75);
	var toIObject = __webpack_require__(28);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(146)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/*global exports*/
	var SignStream = __webpack_require__(1715);
	var VerifyStream = __webpack_require__(1716);
	
	var ALGORITHMS = [
	  'HS256', 'HS384', 'HS512',
	  'RS256', 'RS384', 'RS512',
	  'PS256', 'PS384', 'PS512',
	  'ES256', 'ES384', 'ES512'
	];
	
	exports.ALGORITHMS = ALGORITHMS;
	exports.sign = SignStream.sign;
	exports.verify = VerifyStream.verify;
	exports.decode = VerifyStream.decode;
	exports.isValid = VerifyStream.isValid;
	exports.createSign = function createSign(opts) {
	  return new SignStream(opts);
	};
	exports.createVerify = function createVerify(opts) {
	  return new VerifyStream(opts);
	};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateDimensions = calculateDimensions;
	exports.parseCellCoordinates = parseCellCoordinates;
	// Maps "A1"-like coordinates to `{ row, column }` numeric coordinates.
	var LETTERS = ["", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
	
	function calculateDimensions(cells) {
	  var comparator = function comparator(a, b) {
	    return a - b;
	  };
	
	  var allRows = cells.map(function (cell) {
	    return cell.row;
	  }).sort(comparator);
	  var allCols = cells.map(function (cell) {
	    return cell.column;
	  }).sort(comparator);
	  var minRow = allRows[0];
	  var maxRow = allRows[allRows.length - 1];
	  var minCol = allCols[0];
	  var maxCol = allCols[allCols.length - 1];
	  return [{
	    row: minRow,
	    column: minCol
	  }, {
	    row: maxRow,
	    column: maxCol
	  }];
	} // Converts a letter coordinate to a digit coordinate.
	// Examples: "A" -> 1, "B" -> 2, "Z" -> 26, "AA" -> 27, etc.
	
	
	function columnLettersToNumber(columnLetters) {
	  // `for ... of ...` would require Babel polyfill for iterating a string.
	  var n = 0;
	  var i = 0;
	
	  while (i < columnLetters.length) {
	    n *= 26;
	    n += LETTERS.indexOf(columnLetters[i]);
	    i++;
	  }
	
	  return n;
	}
	
	function parseCellCoordinates(coords) {
	  // Coordinate examples: "AA2091", "R988", "B1".
	  coords = coords.split(/(\d+)/);
	  return [// Row.
	  parseInt(coords[1]), // Column.
	  columnLettersToNumber(coords[0].trim())];
	}
	//# sourceMappingURL=coordinates.js.map

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseExcelDate;
	
	// Parses an Excel Date ("serial") into a corresponding javascript Date in UTC+0 timezone.
	// (with time equal to 00:00)
	//
	// https://www.pcworld.com/article/3063622/software/mastering-excel-date-time-serial-numbers-networkdays-datevalue-and-more.html
	// "If you need to calculate dates in your spreadsheets,
	//  Excel uses its own unique system, which it calls Serial Numbers".
	//
	function parseExcelDate(excelSerialDate, options) {
	  // https://support.microsoft.com/en-gb/help/214330/differences-between-the-1900-and-the-1904-date-system-in-excel
	  if (options && options.epoch1904) {
	    excelSerialDate += 1462;
	  } // "Excel serial date" is just
	  // the count of days since `01/01/1900`
	  // (seems that it may be even fractional).
	  //
	  // The count of days elapsed
	  // since `01/01/1900` (Excel epoch)
	  // till `01/01/1970` (Unix epoch).
	  // Accounts for leap years
	  // (19 of them, yielding 19 extra days).
	
	
	  var daysBeforeUnixEpoch = 70 * 365 + 19; // An hour, approximately, because a minute
	  // may be longer than 60 seconds, due to "leap seconds".
	  //
	  // Still, Javascript `Date` (and UNIX time in general) intentionally
	  // drops the concept of "leap seconds" in order to make things simpler.
	  // So it's fine.
	  // https://stackoverflow.com/questions/53019726/where-are-the-leap-seconds-in-javascript
	  //
	  // "The JavaScript Date object specifically adheres to the concept of Unix Time
	  //  (albeit with higher precision). This is part of the POSIX specification,
	  //  and thus is sometimes called "POSIX Time". It does not count leap seconds,
	  //  but rather assumes every day had exactly 86,400 seconds. You can read about
	  //  this in section 20.3.1.1 of the current ECMAScript specification, which states:
	  //
	  //  "Time is measured in ECMAScript in milliseconds since 01 January, 1970 UTC.
	  //   In time values leap seconds are ignored. It is assumed that there are exactly
	  //   86,400,000 milliseconds per day."
	  //
	  //  The fact is, that the unpredictable nature of leap seconds makes them very
	  //  difficult to work with in APIs. One can't generally pass timestamps around
	  //  that need leap seconds tables to be interpreted correctly, and expect that
	  //  one system will interpret them the same as another. For example, while your
	  //  example timestamp 1483228826 is 2017-01-01T00:00:00Z on your system,
	  //  it would be interpreted as 2017-01-01T00:00:26Z on POSIX based systems,
	  //  or systems without leap second tables. So they aren't portable.
	  //  Even on systems that have full updated tables, there's no telling what those
	  //  tables will contain in the future (beyond the 6-month IERS announcement period),
	  //  so I can't produce a future timestamp without risk that it may eventually change.
	  //
	  //  To be clear - to support leap seconds in a programming language, the implementation
	  //  must go out of its way to do so, and must make tradeoffs that are not always acceptable.
	  //  Though there are exceptions, the general position is to not support them - not because
	  //  of any subversion or active countermeasures, but because supporting them properly is much,
	  //  much harder."
	  //
	  // https://en.wikipedia.org/wiki/Unix_time#Leap_seconds
	  // https://en.wikipedia.org/wiki/Leap_year
	  // https://en.wikipedia.org/wiki/Leap_second
	  //
	
	  var hour = 60 * 60 * 1000;
	  return new Date(Math.round((excelSerialDate - daysBeforeUnixEpoch) * 24 * hour));
	}
	//# sourceMappingURL=parseDate.js.map

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = readXlsxFile;
	
	var _xmlBrowser = _interopRequireDefault(__webpack_require__(1752));
	
	var _unpackXlsxFileBrowser = _interopRequireDefault(__webpack_require__(1745));
	
	var _readXlsxFileContents = _interopRequireDefault(__webpack_require__(1742));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Reads XLSX file into a 2D array of cells in a browser.
	 * @param  {file} file - A file being uploaded in the browser.
	 * @param  {object?} options
	 * @param  {(number|string)?} options.sheet - Excel document sheet to read. Defaults to `1`. Will only read this sheet and skip others.
	 * @return {Promise} Resolves to a 2D array of cells: an array of rows, each row being an array of cells.
	 */
	function readXlsxFile(file) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return (0, _unpackXlsxFileBrowser["default"])(file).then(function (entries) {
	    return (0, _readXlsxFileContents["default"])(entries, _xmlBrowser["default"], options);
	  });
	}
	//# sourceMappingURL=readXlsxFileBrowser.js.map

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(116);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(90);
	util.inherits = __webpack_require__(41);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1769)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(375);
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(46).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(374);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(71);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(71);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = _isUint8Array(chunk) && !state.objectMode;
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    processNextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    processNextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      processNextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(377).setImmediate, (function() { return this; }())))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(372);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(168);
	exports.Duplex = __webpack_require__(71);
	exports.Transform = __webpack_require__(373);
	exports.PassThrough = __webpack_require__(1755);


/***/ }),
/* 170 */,
/* 171 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	Mixin for objects that are mounted by Google Maps
	Javascript API.
	
	These are objects that are sensitive to element resize
	operations so it exposes a property which accepts a bus
	
	*/
	
	exports.default = {
	  props: ['resizeBus'],
	
	  data: function data() {
	    return {
	      _actualResizeBus: null
	    };
	  },
	  created: function created() {
	    if (typeof this.resizeBus === 'undefined') {
	      this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
	    } else {
	      this.$data._actualResizeBus = this.resizeBus;
	    }
	  },
	
	
	  methods: {
	    _resizeCallback: function _resizeCallback() {
	      this.resize();
	    },
	    _delayedResizeCallback: function _delayedResizeCallback() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        return _this._resizeCallback();
	      });
	    }
	  },
	
	  watch: {
	    resizeBus: function resizeBus(newVal, oldVal) {
	      // eslint-disable-line no-unused-vars
	      this.$data._actualResizeBus = newVal;
	    },
	    '$data._actualResizeBus': function $data_actualResizeBus(newVal, oldVal) {
	      if (oldVal) {
	        oldVal.$off('resize', this._delayedResizeCallback);
	      }
	      if (newVal) {
	        newVal.$on('resize', this._delayedResizeCallback);
	      }
	    }
	  },
	
	  destroyed: function destroyed() {
	    if (this.$data._actualResizeBus) {
	      this.$data._actualResizeBus.$off('resize', this._delayedResizeCallback);
	    }
	  }
	};

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	module.exports=function(e){function t(n){if(r[n])return r[n].exports;var i=r[n]={exports:{},id:n,loaded:!1};return e[n].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var r={};return t.m=e,t.c=r,t.p="/dist/",t(0)}([function(e,t,r){"use strict";e.exports=r(75)},function(e,t){var r=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(e,t){var r={}.hasOwnProperty;e.exports=function(e,t){return r.call(e,t)}},function(e,t,r){var n=r(51),i=r(15);e.exports=function(e){return n(i(e))}},function(e,t,r){e.exports=!r(9)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t,r){var n=r(6),i=r(12);e.exports=r(4)?function(e,t,r){return n.f(e,t,i(1,r))}:function(e,t,r){return e[t]=r,e}},function(e,t,r){var n=r(8),i=r(31),a=r(24),o=Object.defineProperty;t.f=r(4)?Object.defineProperty:function(e,t,r){if(n(e),t=a(t,!0),n(r),i)try{return o(e,t,r)}catch(e){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(e[t]=r.value),e}},function(e,t,r){var n=r(22)("wks"),i=r(13),a=r(1).Symbol,o="function"==typeof a,s=e.exports=function(e){return n[e]||(n[e]=o&&a[e]||(o?a:i)("Symbol."+e))};s.store=n},function(e,t,r){var n=r(10);e.exports=function(e){if(!n(e))throw TypeError(e+" is not an object!");return e}},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t,r){var n=r(36),i=r(16);e.exports=Object.keys||function(e){return n(e,i)}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t){var r=0,n=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++r+n).toString(36))}},function(e,t){var r=e.exports={version:"2.4.0"};"number"==typeof __e&&(__e=r)},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t){e.exports={}},function(e,t){e.exports=!0},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,r){var n=r(6).f,i=r(2),a=r(7)("toStringTag");e.exports=function(e,t,r){e&&!i(e=r?e:e.prototype,a)&&n(e,a,{configurable:!0,value:t})}},function(e,t,r){var n=r(22)("keys"),i=r(13);e.exports=function(e){return n[e]||(n[e]=i(e))}},function(e,t,r){var n=r(1),i="__core-js_shared__",a=n[i]||(n[i]={});e.exports=function(e){return a[e]||(a[e]={})}},function(e,t){var r=Math.ceil,n=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?n:r)(e)}},function(e,t,r){var n=r(10);e.exports=function(e,t){if(!n(e))return e;var r,i;if(t&&"function"==typeof(r=e.toString)&&!n(i=r.call(e)))return i;if("function"==typeof(r=e.valueOf)&&!n(i=r.call(e)))return i;if(!t&&"function"==typeof(r=e.toString)&&!n(i=r.call(e)))return i;throw TypeError("Can't convert object to primitive value")}},function(e,t,r){var n=r(1),i=r(14),a=r(18),o=r(26),s=r(6).f;e.exports=function(e){var t=i.Symbol||(i.Symbol=a?{}:n.Symbol||{});"_"==e.charAt(0)||e in t||s(t,e,{value:o.f(e)})}},function(e,t,r){t.f=r(7)},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={translations:{ar:{months:{original:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"],abbr:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"]},days:["أحد","إثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"]},da:{months:{original:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"]},days:["Sø","Ma","Ti","On","To","Fr","Lø"]},en:{months:{original:["January","February","March","April","May","June","July","August","September","October","November","December"],abbr:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]},days:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]},es:{months:{original:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],abbr:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]},days:["Dom","Lun","Mar","Mié","Jue","Vie","Sab"]},fi:{months:{original:["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],abbr:["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"]},days:["su","ma","ti","ke","to","pe","la"]},fr:{months:{original:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],abbr:["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"]},days:["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"]},hu:{months:{original:["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],abbr:["Jan","Febr","Márc","Ápr","Máj","Jún","Júl","Aug","Szept","Okt","Nov","Dec"]},days:["Vas","Hét","Ke","Sze","Csü","Pén","Szo"]},hr:{months:{original:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],abbr:["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"]},days:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]},id:{months:{original:["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],abbr:["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"]},days:["Min","Sen","Sel","Rab","Kam","Jum","Sab"]},it:{months:{original:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],abbr:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"]},days:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"]},lt:{months:{original:["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],abbr:["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"]},days:["Sek","Pir","Ant","Tre","Ket","Pen","Šeš"]},nl:{months:{original:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],abbr:["jan","feb","maa","apr","mei","jun","jul","aug","sep","okt","nov","dec"]},days:["zo","ma","di","wo","do","vr","za"]},de:{months:{original:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],abbr:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"]},days:["So.","Mo.","Di.","Mi.","Do.","Fr.","Sa."]},"pt-br":{months:{original:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],abbr:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"]},days:["Dom","Seg","Ter","Qua","Qui","Sex","Sab"]},vi:{months:{original:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],abbr:["T 01","T 02","T 03","T 04","T 05","T 06","T 07","T 08","T 09","T 10","T 11","T 12"]},days:["CN","Thứ 2","Thứ 3","Thứ 4","Thứ 5","Thứ 6","Thứ 7"]},zh:{months:{original:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],abbr:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},days:["日","一","二","三","四","五","六"]},ja:{months:{original:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],abbr:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"]},days:["日","月","火","水","木","金","土"]},he:{months:{original:["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],abbr:["ינו","פבר","מרץ","אפר","מאי","יונ","יול","אוג","ספט","אוק","נוב","דצמ"]},days:["א","ב","ג","ד","ה","ו","ש"]},cs:{months:{original:["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],abbr:["led","úno","bře","dub","kvě","čer","čec","srp","zář","říj","lis","pro"]},days:["ne","po","út","st","čt","pá","so"]},sk:{months:{original:["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december"],abbr:["jan","feb","mar","apr","máj","jún","júl","aug","sep","okt","nov","dec"]},days:["ne","po","ut","st","št","pi","so"]},ru:{months:{original:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],abbr:["Янв","Февр","Март","Апр","Май","Июнь","Июль","Авг","Сент","Окт","Нояб","Дек"]},days:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"]},uk:{months:{original:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],abbr:["Січ","Лют","Бер","Квіт","Трав","Чер","Лип","Серп","Вер","Жовт","Лист","Груд"]},days:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]},bg:{months:{original:["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],abbr:["Ян","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Ное","Дек"]},days:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]},sv:{months:{original:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]},days:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"]},th:{months:{original:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],abbr:["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."]},days:["อา","จ","อ","พ","พฤ","ศ","ส"]},ro:{months:{original:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],abbr:["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Noi","Dec"]},days:["D","L","Ma","Mi","J","V","S"]},"sl-si":{months:{original:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"]},days:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"]},pl:{months:{original:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],abbr:["Sty","Lut","Mar","Kwi","Maj","Cze","Lip","Sie","Wrz","Paź","Lis","Gru"]},days:["Nd","Pn","Wt","Śr","Czw","Pt","Sob"]},"nb-no":{months:{original:["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"],abbr:["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"]},days:["Sø","Ma","Ti","On","To","Fr","Lø"]},ee:{months:{original:["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],abbr:["Jaan","Veebr","Märts","Apr","Mai","Juuni","Juuli","Aug","Sept","Okt","Nov","Dets"]},days:["P","E","T","K","N","R","L"]},ko:{months:{original:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],abbr:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"]},days:["일","월","화","수","목","금","토"]},tr:{months:{original:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],abbr:["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"]},days:["Pzt","Sal","Çar","Per","Cum","Cmt","Paz"]},bs:{months:{original:["Januar","Februar","Mart","April","Maj","Juni","Juli","Avgust","Septembar","Oktobar","Novembar","Decembar"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"]},days:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]},is:{months:{original:["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],abbr:["Jan","Feb","Mars","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"]},days:["Sun","Mán","Þri","Mið","Fim","Fös","Lau"]}}}},function(e,t){var r={}.toString;e.exports=function(e){return r.call(e).slice(8,-1)}},function(e,t,r){var n=r(10),i=r(1).document,a=n(i)&&n(i.createElement);e.exports=function(e){return a?i.createElement(e):{}}},function(e,t,r){var n=r(1),i=r(14),a=r(48),o=r(5),s="prototype",u=function(e,t,r){var l,d,c,f=e&u.F,h=e&u.G,p=e&u.S,b=e&u.P,g=e&u.B,v=e&u.W,y=h?i:i[t]||(i[t]={}),m=y[s],D=h?n:p?n[t]:(n[t]||{})[s];h&&(r=t);for(l in r)d=!f&&D&&void 0!==D[l],d&&l in y||(c=d?D[l]:r[l],y[l]=h&&"function"!=typeof D[l]?r[l]:g&&d?a(c,n):v&&D[l]==c?function(e){var t=function(t,r,n){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,r)}return new e(t,r,n)}return e.apply(this,arguments)};return t[s]=e[s],t}(c):b&&"function"==typeof c?a(Function.call,c):c,b&&((y.virtual||(y.virtual={}))[l]=c,e&u.R&&m&&!m[l]&&o(m,l,c)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,e.exports=u},function(e,t,r){e.exports=!r(4)&&!r(9)(function(){return 7!=Object.defineProperty(r(29)("div"),"a",{get:function(){return 7}}).a})},function(e,t,r){"use strict";var n=r(18),i=r(30),a=r(37),o=r(5),s=r(2),u=r(17),l=r(53),d=r(20),c=r(60),f=r(7)("iterator"),h=!([].keys&&"next"in[].keys()),p="@@iterator",b="keys",g="values",v=function(){return this};e.exports=function(e,t,r,y,m,D,M){l(r,t,y);var S,w,k,x=function(e){if(!h&&e in j)return j[e];switch(e){case b:return function(){return new r(this,e)};case g:return function(){return new r(this,e)}}return function(){return new r(this,e)}},_=t+" Iterator",O=m==g,F=!1,j=e.prototype,T=j[f]||j[p]||m&&j[m],A=T||x(m),Y=m?O?x("entries"):A:void 0,J="Array"==t?j.entries||T:T;if(J&&(k=c(J.call(new e)),k!==Object.prototype&&(d(k,_,!0),n||s(k,f)||o(k,f,v))),O&&T&&T.name!==g&&(F=!0,A=function(){return T.call(this)}),n&&!M||!h&&!F&&j[f]||o(j,f,A),u[t]=A,u[_]=v,m)if(S={values:O?A:x(g),keys:D?A:x(b),entries:Y},M)for(w in S)w in j||a(j,w,S[w]);else i(i.P+i.F*(h||F),t,S);return S}},function(e,t,r){var n=r(8),i=r(57),a=r(16),o=r(21)("IE_PROTO"),s=function(){},u="prototype",l=function(){var e,t=r(29)("iframe"),n=a.length,i="<",o=">";for(t.style.display="none",r(50).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write(i+"script"+o+"document.F=Object"+i+"/script"+o),e.close(),l=e.F;n--;)delete l[u][a[n]];return l()};e.exports=Object.create||function(e,t){var r;return null!==e?(s[u]=n(e),r=new s,s[u]=null,r[o]=e):r=l(),void 0===t?r:i(r,t)}},function(e,t,r){var n=r(36),i=r(16).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return n(e,i)}},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,r){var n=r(2),i=r(3),a=r(47)(!1),o=r(21)("IE_PROTO");e.exports=function(e,t){var r,s=i(e),u=0,l=[];for(r in s)r!=o&&n(s,r)&&l.push(r);for(;t.length>u;)n(s,r=t[u++])&&(~a(l,r)||l.push(r));return l}},function(e,t,r){e.exports=r(5)},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=r(42),a=n(i),o=r(27),s=n(o);t.default={isValidDate:function(e){return"[object Date]"===Object.prototype.toString.call(e)&&!isNaN(e.getTime())},getDayNameAbbr:function(e,t){if("object"!==("undefined"==typeof e?"undefined":(0,a.default)(e)))throw TypeError("Invalid Type");return t[e.getDay()]},getMonthName:function(e,t){if(!t)throw Error("missing 2nd parameter Months array");if("object"===("undefined"==typeof e?"undefined":(0,a.default)(e)))return t[e.getMonth()];if("number"==typeof e)return t[e];throw TypeError("Invalid type")},getMonthNameAbbr:function(e,t){if(!t)throw Error("missing 2nd paramter Months array");if("object"===("undefined"==typeof e?"undefined":(0,a.default)(e)))return t[e.getMonth()];if("number"==typeof e)return t[e];throw TypeError("Invalid type")},convertToUTC:function(e){return new Date(e.getTime()+6e4*e.getTimezoneOffset())},daysInMonth:function(e,t){return new Date(Date.UTC(e,t+1,0)).getUTCDate()},dayDiff:function(e,t){var r=864e5,n=Date.UTC(e.getFullYear(),e.getMonth(),e.getDate()),i=Date.UTC(t.getFullYear(),t.getMonth(),t.getDate());return Math.floor((i-n)/r)},getNthSuffix:function(e){switch(e){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th"}},formatDate:function(e,t,r){r=r?r:s.default.translations.en;var n=e.getFullYear(),i=e.getMonth()+1,a=e.getDate(),o=t.replace(/dd/,("0"+a).slice(-2)).replace(/d/,a).replace(/yyyy/,n).replace(/yy/,String(n).slice(2)).replace(/MMMM/,this.getMonthName(e.getMonth(),r.months.original)).replace(/MMM/,this.getMonthNameAbbr(e.getMonth(),r.months.abbr)).replace(/MM/,("0"+i).slice(-2)).replace(/M(?!a|ä)/,i).replace(/su/,this.getNthSuffix(e.getDate())).replace(/D(?!e|é|i)/,this.getDayNameAbbr(e,r.days));return o},createDateArray:function(e,t){for(var r=[];e<=t;)r.push(new Date(e)),e=new Date(e).setDate(new Date(e).getDate()+1);return r}}},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=r(38),a=n(i),o=r(27),s=n(o);t.default={props:{value:{validator:function(e){return null===e||e instanceof Date||"string"==typeof e}},name:{value:String},id:{value:String},format:{value:String,default:"dd MMM yyyy"},language:{value:String,default:"en"},disabled:{type:Object},highlighted:{type:Object},placeholder:{type:String},inline:{type:Boolean},inputClass:{type:String},wrapperClass:{type:String},mondayFirst:{type:Boolean,default:!1},clearButton:{type:Boolean,default:!1},clearButtonIcon:{type:String,default:""},calendarButton:{type:Boolean,default:!1},calendarButtonIcon:{type:String,default:""},bootstrapStyling:{type:Boolean,default:!1},initialView:{type:String,default:"day"},disabledPicker:{type:Boolean,default:!1},required:{type:Boolean,default:!1}},data:function(){return{currDate:new Date((new Date).getFullYear(),(new Date).getMonth(),1).getTime(),selectedDate:null,showDayView:!1,showMonthView:!1,showYearView:!1,calendarHeight:0}},watch:{value:function(e){this.setValue(e)}},computed:{formattedValue:function(){return this.selectedDate?a.default.formatDate(new Date(this.selectedDate),this.format,this.translation):null},translation:function(){return s.default.translations[this.language]},currMonthName:function(){var e=new Date(this.currDate);return a.default.getMonthNameAbbr(e.getMonth(),this.translation.months.abbr)},currYear:function(){var e=new Date(this.currDate);return e.getFullYear()},blankDays:function(){var e=new Date(this.currDate),t=new Date(e.getFullYear(),e.getMonth(),1,e.getHours(),e.getMinutes());return this.mondayFirst?t.getDay()>0?t.getDay()-1:6:t.getDay()},daysOfWeek:function(){if(this.mondayFirst){var e=this.translation.days.slice();return e.push(e.shift()),e}return this.translation.days},days:function e(){for(var t=new Date(this.currDate),e=[],r=new Date(t.getFullYear(),t.getMonth(),1,t.getHours(),t.getMinutes()),n=a.default.daysInMonth(r.getFullYear(),r.getMonth()),i=0;i<n;i++)e.push({date:r.getDate(),timestamp:r.getTime(),isSelected:this.isSelectedDate(r),isDisabled:this.isDisabledDate(r),isHighlighted:this.isHighlightedDate(r),isToday:r.toDateString()===(new Date).toDateString()}),r.setDate(r.getDate()+1);return e},months:function e(){for(var t=new Date(this.currDate),e=[],r=new Date(t.getFullYear(),0,t.getDate(),t.getHours(),t.getMinutes()),n=0;n<12;n++)e.push({month:a.default.getMonthName(n,this.translation.months.original),timestamp:r.getTime(),isSelected:this.isSelectedMonth(r),isDisabled:this.isDisabledMonth(r)}),r.setMonth(r.getMonth()+1);return e},years:function e(){for(var t=new Date(this.currDate),e=[],r=new Date(10*Math.floor(t.getFullYear()/10),t.getMonth(),t.getDate(),t.getHours(),t.getMinutes()),n=0;n<10;n++)e.push({year:r.getFullYear(),timestamp:r.getTime(),isSelected:this.isSelectedYear(r),isDisabled:this.isDisabledYear(r)}),r.setFullYear(r.getFullYear()+1);return e},calendarStyle:function(){var e={};return this.isInline&&(e.position="static"),e},isOpen:function(){return this.showDayView||this.showMonthView||this.showYearView},isInline:function(){return"undefined"!=typeof this.inline&&this.inline}},methods:{close:function(){this.showDayView=this.showMonthView=this.showYearView=!1,this.$emit("closed"),document.removeEventListener("click",this.clickOutside,!1)},getDefaultDate:function(){return new Date((new Date).getFullYear(),(new Date).getMonth(),1).getTime()},resetDefaultDate:function(){return null===this.selectedDate?void(this.currDate=this.getDefaultDate()):void(this.currDate=this.currDate=new Date(this.selectedDate.getFullYear(),this.selectedDate.getMonth(),1).getTime())},showCalendar:function(){if(this.isInline)return!1;if(this.isOpen)return this.close();switch(this.initialView){case"year":this.showYearCalendar();break;case"month":this.showMonthCalendar();break;default:this.showDayCalendar()}},showDayCalendar:function(){this.close(),this.showDayView=!0,this.$emit("opened"),document.addEventListener("click",this.clickOutside,!1)},showMonthCalendar:function(){this.close(),this.showMonthView=!0,document.addEventListener("click",this.clickOutside,!1)},showYearCalendar:function(){this.close(),this.showYearView=!0,document.addEventListener("click",this.clickOutside,!1)},setDate:function(e){this.selectedDate=new Date(e),this.currDate=new Date(this.selectedDate.getFullYear(),this.selectedDate.getMonth(),1).getTime(),this.$emit("selected",new Date(e)),this.$emit("input",new Date(e))},clearDate:function(){this.selectedDate=null,this.$emit("selected",null),this.$emit("input",null),this.$emit("cleared")},selectDate:function(e){return!e.isDisabled&&(this.setDate(e.timestamp),this.isInline?this.showDayCalendar():void this.close())},selectMonth:function(e){return!e.isDisabled&&(this.currDate=e.timestamp,this.showDayCalendar(),void this.$emit("changedMonth",e))},selectYear:function(e){return!e.isDisabled&&(this.currDate=e.timestamp,this.showMonthCalendar(),void this.$emit("changedYear",e))},getMonth:function(){var e=new Date(this.currDate);return e.getMonth()},getYear:function(){var e=new Date(this.currDate);return e.getFullYear()},getDecade:function(){var e=new Date(this.currDate),t=10*Math.floor(e.getFullYear()/10);return t+"'s"},previousMonth:function(){if(this.previousMonthDisabled())return!1;var e=new Date(this.currDate);e.setMonth(e.getMonth()-1),this.currDate=e.getTime(),this.$emit("changedMonth",e)},previousMonthDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.to||!this.disabled.to)return!1;var e=new Date(this.currDate);return this.disabled.to.getMonth()>=e.getMonth()&&this.disabled.to.getFullYear()>=e.getFullYear()},nextMonth:function(){if(this.nextMonthDisabled())return!1;var e=new Date(this.currDate),t=a.default.daysInMonth(e.getFullYear(),e.getMonth());e.setDate(e.getDate()+t),this.currDate=e.getTime(),this.$emit("changedMonth",e)},nextMonthDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.from||!this.disabled.from)return!1;var e=new Date(this.currDate);return this.disabled.from.getMonth()<=e.getMonth()&&this.disabled.from.getFullYear()<=e.getFullYear()},previousYear:function(){if(this.previousYearDisabled())return!1;var e=new Date(this.currDate);e.setYear(e.getFullYear()-1),this.currDate=e.getTime(),this.$emit("changedYear")},previousYearDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.to||!this.disabled.to)return!1;var e=new Date(this.currDate);return this.disabled.to.getFullYear()>=e.getFullYear()},nextYear:function(){if(this.nextYearDisabled())return!1;var e=new Date(this.currDate);e.setYear(e.getFullYear()+1),this.currDate=e.getTime(),this.$emit("changedYear")},nextYearDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.from||!this.disabled.from)return!1;var e=new Date(this.currDate);return this.disabled.from.getFullYear()<=e.getFullYear()},previousDecade:function(){if(this.previousDecadeDisabled())return!1;var e=new Date(this.currDate);e.setYear(e.getFullYear()-10),this.currDate=e.getTime(),this.$emit("changedDecade")},previousDecadeDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.to||!this.disabled.to)return!1;var e=new Date(this.currDate);return 10*Math.floor(this.disabled.to.getFullYear()/10)>=10*Math.floor(e.getFullYear()/10)},nextDecade:function(){if(this.nextDecadeDisabled())return!1;var e=new Date(this.currDate);e.setYear(e.getFullYear()+10),this.currDate=e.getTime(),this.$emit("changedDecade")},nextDecadeDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.from||!this.disabled.from)return!1;var e=new Date(this.currDate);return 10*Math.ceil(this.disabled.from.getFullYear()/10)<=10*Math.ceil(e.getFullYear()/10)},isSelectedDate:function(e){return this.selectedDate&&this.selectedDate.toDateString()===e.toDateString()},isDisabledDate:function(e){var t=!1;return"undefined"!=typeof this.disabled&&("undefined"!=typeof this.disabled.dates&&this.disabled.dates.forEach(function(r){if(e.toDateString()===r.toDateString())return t=!0,!0}),"undefined"!=typeof this.disabled.to&&this.disabled.to&&e<this.disabled.to&&(t=!0),"undefined"!=typeof this.disabled.from&&this.disabled.from&&e>this.disabled.from&&(t=!0),"undefined"!=typeof this.disabled.days&&this.disabled.days.indexOf(e.getDay())!==-1&&(t=!0),t)},isHighlightedDate:function(e){if(this.isDisabledDate(e))return!1;var t=!1;return"undefined"!=typeof this.highlighted&&("undefined"!=typeof this.highlighted.dates&&this.highlighted.dates.forEach(function(r){if(e.toDateString()===r.toDateString())return t=!0,!0}),this.isDefined(this.highlighted.from)&&this.isDefined(this.highlighted.to)&&(t=e>=this.highlighted.from&&e<=this.highlighted.to),"undefined"!=typeof this.highlighted.days&&this.highlighted.days.indexOf(e.getDay())!==-1&&(t=!0),t)},isDefined:function(e){return"undefined"!=typeof e&&e},isSelectedMonth:function(e){return this.selectedDate&&this.selectedDate.getFullYear()===e.getFullYear()&&this.selectedDate.getMonth()===e.getMonth()},isDisabledMonth:function(e){var t=!1;return"undefined"!=typeof this.disabled&&("undefined"!=typeof this.disabled.to&&this.disabled.to&&(e.getMonth()<this.disabled.to.getMonth()&&e.getFullYear()<=this.disabled.to.getFullYear()||e.getFullYear()<this.disabled.to.getFullYear())&&(t=!0),"undefined"!=typeof this.disabled.from&&this.disabled.from&&(this.disabled.from&&e.getMonth()>this.disabled.from.getMonth()&&e.getFullYear()>=this.disabled.from.getFullYear()||e.getFullYear()>this.disabled.from.getFullYear())&&(t=!0),t)},isSelectedYear:function(e){return this.selectedDate&&this.selectedDate.getFullYear()===e.getFullYear()},isDisabledYear:function(e){var t=!1;return!("undefined"==typeof this.disabled||!this.disabled)&&("undefined"!=typeof this.disabled.to&&this.disabled.to&&e.getFullYear()<this.disabled.to.getFullYear()&&(t=!0),"undefined"!=typeof this.disabled.from&&this.disabled.from&&e.getFullYear()>this.disabled.from.getFullYear()&&(t=!0),t)},setValue:function(e){if("string"==typeof e){var t=new Date(e);e=isNaN(t.valueOf())?null:t}if(!e){var r=new Date;return this.currDate=new Date(r.getFullYear(),r.getMonth(),1).getTime(),void(this.selectedDate=null)}this.selectedDate=e,this.currDate=new Date(e.getFullYear(),e.getMonth(),1).getTime()},clickOutside:function(e){if(this.$el&&!this.$el.contains(e.target)){if(this.isInline)return this.showDayCalendar();this.resetDefaultDate(),this.close(),document.removeEventListener("click",this.clickOutside,!1)}},init:function(){this.value&&this.setValue(this.value),this.isInline&&this.showDayCalendar()}},ready:function(){this.init()},mounted:function(){this.init()}}},function(e,t,r){e.exports={default:r(43),__esModule:!0}},function(e,t,r){e.exports={default:r(44),__esModule:!0}},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var i=r(41),a=n(i),o=r(40),s=n(o),u="function"==typeof s.default&&"symbol"==typeof a.default?function(e){return typeof e}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":typeof e};t.default="function"==typeof s.default&&"symbol"===u(a.default)?function(e){return"undefined"==typeof e?"undefined":u(e)}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":"undefined"==typeof e?"undefined":u(e)}},function(e,t,r){r(68),r(66),r(69),r(70),e.exports=r(14).Symbol},function(e,t,r){r(67),r(71),e.exports=r(26).f("iterator")},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t){e.exports=function(){}},function(e,t,r){var n=r(3),i=r(63),a=r(62);e.exports=function(e){return function(t,r,o){var s,u=n(t),l=i(u.length),d=a(o,l);if(e&&r!=r){for(;l>d;)if(s=u[d++],s!=s)return!0}else for(;l>d;d++)if((e||d in u)&&u[d]===r)return e||d||0;return!e&&-1}}},function(e,t,r){var n=r(45);e.exports=function(e,t,r){if(n(e),void 0===t)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,n){return e.call(t,r,n)};case 3:return function(r,n,i){return e.call(t,r,n,i)}}return function(){return e.apply(t,arguments)}}},function(e,t,r){var n=r(11),i=r(35),a=r(19);e.exports=function(e){var t=n(e),r=i.f;if(r)for(var o,s=r(e),u=a.f,l=0;s.length>l;)u.call(e,o=s[l++])&&t.push(o);return t}},function(e,t,r){e.exports=r(1).document&&document.documentElement},function(e,t,r){var n=r(28);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==n(e)?e.split(""):Object(e)}},function(e,t,r){var n=r(28);e.exports=Array.isArray||function(e){return"Array"==n(e)}},function(e,t,r){"use strict";var n=r(33),i=r(12),a=r(20),o={};r(5)(o,r(7)("iterator"),function(){return this}),e.exports=function(e,t,r){e.prototype=n(o,{next:i(1,r)}),a(e,t+" Iterator")}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,r){var n=r(11),i=r(3);e.exports=function(e,t){for(var r,a=i(e),o=n(a),s=o.length,u=0;s>u;)if(a[r=o[u++]]===t)return r}},function(e,t,r){var n=r(13)("meta"),i=r(10),a=r(2),o=r(6).f,s=0,u=Object.isExtensible||function(){return!0},l=!r(9)(function(){return u(Object.preventExtensions({}))}),d=function(e){o(e,n,{value:{i:"O"+ ++s,w:{}}})},c=function(e,t){if(!i(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!a(e,n)){if(!u(e))return"F";if(!t)return"E";d(e)}return e[n].i},f=function(e,t){if(!a(e,n)){if(!u(e))return!0;if(!t)return!1;d(e)}return e[n].w},h=function(e){return l&&p.NEED&&u(e)&&!a(e,n)&&d(e),e},p=e.exports={KEY:n,NEED:!1,fastKey:c,getWeak:f,onFreeze:h}},function(e,t,r){var n=r(6),i=r(8),a=r(11);e.exports=r(4)?Object.defineProperties:function(e,t){i(e);for(var r,o=a(t),s=o.length,u=0;s>u;)n.f(e,r=o[u++],t[r]);return e}},function(e,t,r){var n=r(19),i=r(12),a=r(3),o=r(24),s=r(2),u=r(31),l=Object.getOwnPropertyDescriptor;t.f=r(4)?l:function(e,t){if(e=a(e),t=o(t,!0),u)try{return l(e,t)}catch(e){}if(s(e,t))return i(!n.f.call(e,t),e[t])}},function(e,t,r){var n=r(3),i=r(34).f,a={}.toString,o="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],s=function(e){try{return i(e)}catch(e){return o.slice()}};e.exports.f=function(e){return o&&"[object Window]"==a.call(e)?s(e):i(n(e))}},function(e,t,r){var n=r(2),i=r(64),a=r(21)("IE_PROTO"),o=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=i(e),n(e,a)?e[a]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?o:null}},function(e,t,r){var n=r(23),i=r(15);e.exports=function(e){return function(t,r){var a,o,s=String(i(t)),u=n(r),l=s.length;return u<0||u>=l?e?"":void 0:(a=s.charCodeAt(u),a<55296||a>56319||u+1===l||(o=s.charCodeAt(u+1))<56320||o>57343?e?s.charAt(u):a:e?s.slice(u,u+2):(a-55296<<10)+(o-56320)+65536);
	}}},function(e,t,r){var n=r(23),i=Math.max,a=Math.min;e.exports=function(e,t){return e=n(e),e<0?i(e+t,0):a(e,t)}},function(e,t,r){var n=r(23),i=Math.min;e.exports=function(e){return e>0?i(n(e),9007199254740991):0}},function(e,t,r){var n=r(15);e.exports=function(e){return Object(n(e))}},function(e,t,r){"use strict";var n=r(46),i=r(54),a=r(17),o=r(3);e.exports=r(32)(Array,"Array",function(e,t){this._t=o(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,r=this._i++;return!e||r>=e.length?(this._t=void 0,i(1)):"keys"==t?i(0,r):"values"==t?i(0,e[r]):i(0,[r,e[r]])},"values"),a.Arguments=a.Array,n("keys"),n("values"),n("entries")},function(e,t){},function(e,t,r){"use strict";var n=r(61)(!0);r(32)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,r=this._i;return r>=t.length?{value:void 0,done:!0}:(e=n(t,r),this._i+=e.length,{value:e,done:!1})})},function(e,t,r){"use strict";var n=r(1),i=r(2),a=r(4),o=r(30),s=r(37),u=r(56).KEY,l=r(9),d=r(22),c=r(20),f=r(13),h=r(7),p=r(26),b=r(25),g=r(55),v=r(49),y=r(52),m=r(8),D=r(3),M=r(24),S=r(12),w=r(33),k=r(59),x=r(58),_=r(6),O=r(11),F=x.f,j=_.f,T=k.f,A=n.Symbol,Y=n.JSON,J=Y&&Y.stringify,N="prototype",C=h("_hidden"),P=h("toPrimitive"),E={}.propertyIsEnumerable,z=d("symbol-registry"),L=d("symbols"),I=d("op-symbols"),V=Object[N],B="function"==typeof A,R=n.QObject,$=!R||!R[N]||!R[N].findChild,K=a&&l(function(){return 7!=w(j({},"a",{get:function(){return j(this,"a",{value:7}).a}})).a})?function(e,t,r){var n=F(V,t);n&&delete V[t],j(e,t,r),n&&e!==V&&j(V,t,n)}:j,G=function(e){var t=L[e]=w(A[N]);return t._k=e,t},H=B&&"symbol"==typeof A.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof A},W=function(e,t,r){return e===V&&W(I,t,r),m(e),t=M(t,!0),m(r),i(L,t)?(r.enumerable?(i(e,C)&&e[C][t]&&(e[C][t]=!1),r=w(r,{enumerable:S(0,!1)})):(i(e,C)||j(e,C,S(1,{})),e[C][t]=!0),K(e,t,r)):j(e,t,r)},U=function(e,t){m(e);for(var r,n=v(t=D(t)),i=0,a=n.length;a>i;)W(e,r=n[i++],t[r]);return e},q=function(e,t){return void 0===t?w(e):U(w(e),t)},Q=function(e){var t=E.call(this,e=M(e,!0));return!(this===V&&i(L,e)&&!i(I,e))&&(!(t||!i(this,e)||!i(L,e)||i(this,C)&&this[C][e])||t)},X=function(e,t){if(e=D(e),t=M(t,!0),e!==V||!i(L,t)||i(I,t)){var r=F(e,t);return!r||!i(L,t)||i(e,C)&&e[C][t]||(r.enumerable=!0),r}},Z=function(e){for(var t,r=T(D(e)),n=[],a=0;r.length>a;)i(L,t=r[a++])||t==C||t==u||n.push(t);return n},ee=function(e){for(var t,r=e===V,n=T(r?I:D(e)),a=[],o=0;n.length>o;)!i(L,t=n[o++])||r&&!i(V,t)||a.push(L[t]);return a};B||(A=function(){if(this instanceof A)throw TypeError("Symbol is not a constructor!");var e=f(arguments.length>0?arguments[0]:void 0),t=function(r){this===V&&t.call(I,r),i(this,C)&&i(this[C],e)&&(this[C][e]=!1),K(this,e,S(1,r))};return a&&$&&K(V,e,{configurable:!0,set:t}),G(e)},s(A[N],"toString",function(){return this._k}),x.f=X,_.f=W,r(34).f=k.f=Z,r(19).f=Q,r(35).f=ee,a&&!r(18)&&s(V,"propertyIsEnumerable",Q,!0),p.f=function(e){return G(h(e))}),o(o.G+o.W+o.F*!B,{Symbol:A});for(var te="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),re=0;te.length>re;)h(te[re++]);for(var te=O(h.store),re=0;te.length>re;)b(te[re++]);o(o.S+o.F*!B,"Symbol",{for:function(e){return i(z,e+="")?z[e]:z[e]=A(e)},keyFor:function(e){if(H(e))return g(z,e);throw TypeError(e+" is not a symbol!")},useSetter:function(){$=!0},useSimple:function(){$=!1}}),o(o.S+o.F*!B,"Object",{create:q,defineProperty:W,defineProperties:U,getOwnPropertyDescriptor:X,getOwnPropertyNames:Z,getOwnPropertySymbols:ee}),Y&&o(o.S+o.F*(!B||l(function(){var e=A();return"[null]"!=J([e])||"{}"!=J({a:e})||"{}"!=J(Object(e))})),"JSON",{stringify:function(e){if(void 0!==e&&!H(e)){for(var t,r,n=[e],i=1;arguments.length>i;)n.push(arguments[i++]);return t=n[1],"function"==typeof t&&(r=t),!r&&y(t)||(t=function(e,t){if(r&&(t=r.call(this,e,t)),!H(t))return t}),n[1]=t,J.apply(Y,n)}}}),A[N][P]||r(5)(A[N],P,A[N].valueOf),c(A,"Symbol"),c(Math,"Math",!0),c(n.JSON,"JSON",!0)},function(e,t,r){r(25)("asyncIterator")},function(e,t,r){r(25)("observable")},function(e,t,r){r(65);for(var n=r(1),i=r(5),a=r(17),o=r(7)("toStringTag"),s=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],u=0;u<5;u++){var l=s[u],d=n[l],c=d&&d.prototype;c&&!c[o]&&i(c,o,l),a[l]=a.Array}},function(e,t,r){t=e.exports=r(73)(),t.push([e.id,'.vdp-datepicker{position:relative;text-align:left}.vdp-datepicker *{box-sizing:border-box}.vdp-datepicker__calendar{position:absolute;z-index:100;background:#fff;width:300px;border:1px solid #ccc}.vdp-datepicker__calendar header{display:block;line-height:40px}.vdp-datepicker__calendar header span{display:inline-block;text-align:center;width:71.42857142857143%;float:left}.vdp-datepicker__calendar header .next,.vdp-datepicker__calendar header .prev{width:14.285714285714286%;float:left;text-indent:-10000px;position:relative}.vdp-datepicker__calendar header .next:after,.vdp-datepicker__calendar header .prev:after{content:"";position:absolute;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);border:6px solid transparent}.vdp-datepicker__calendar header .prev:after{border-right:10px solid #000;margin-left:-5px}.vdp-datepicker__calendar header .prev.disabled:after{border-right:10px solid #ddd}.vdp-datepicker__calendar header .next:after{border-left:10px solid #000;margin-left:5px}.vdp-datepicker__calendar header .next.disabled:after{border-left:10px solid #ddd}.vdp-datepicker__calendar header .next:not(.disabled),.vdp-datepicker__calendar header .prev:not(.disabled),.vdp-datepicker__calendar header .up:not(.disabled){cursor:pointer}.vdp-datepicker__calendar header .next:not(.disabled):hover,.vdp-datepicker__calendar header .prev:not(.disabled):hover,.vdp-datepicker__calendar header .up:not(.disabled):hover{background:#eee}.vdp-datepicker__calendar .disabled{color:#ddd;cursor:default}.vdp-datepicker__calendar .cell{display:inline-block;padding:0 5px;width:14.285714285714286%;height:40px;line-height:40px;text-align:center;vertical-align:middle;border:1px solid transparent}.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year{cursor:pointer}.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover{border:1px solid #4bd}.vdp-datepicker__calendar .cell.selected,.vdp-datepicker__calendar .cell.selected.highlighted,.vdp-datepicker__calendar .cell.selected:hover{background:#4bd}.vdp-datepicker__calendar .cell.highlighted{background:#cae5ed}.vdp-datepicker__calendar .cell.grey{color:#888}.vdp-datepicker__calendar .cell.grey:hover{background:inherit}.vdp-datepicker__calendar .cell.day-header{font-size:75%;white-space:no-wrap;cursor:inherit}.vdp-datepicker__calendar .cell.day-header:hover{background:inherit}.vdp-datepicker__calendar .month,.vdp-datepicker__calendar .year{width:33.333%}.vdp-datepicker__calendar-button,.vdp-datepicker__clear-button{cursor:pointer;font-style:normal}',""])},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var r=this[t];r[2]?e.push("@media "+r[2]+"{"+r[1]+"}"):e.push(r[1])}return e.join("")},e.i=function(t,r){"string"==typeof t&&(t=[[null,t,""]]);for(var n={},i=0;i<this.length;i++){var a=this[i][0];"number"==typeof a&&(n[a]=!0)}for(i=0;i<t.length;i++){var o=t[i];"number"==typeof o[0]&&n[o[0]]||(r&&!o[2]?o[2]=r:r&&(o[2]="("+o[2]+") and ("+r+")"),e.push(o))}},e}},function(e,t){e.exports=' <div class=vdp-datepicker :class=wrapperClass> <div :class="{\'input-group\' : bootstrapStyling}"> <span class=vdp-datepicker__calendar-button :class="{\'input-group-addon\' : bootstrapStyling}" v-if=calendarButton @click=showCalendar><i :class=calendarButtonIcon><span v-if="calendarButtonIcon.length === 0">&hellip;</span></i></span> <input :type="inline ? \'hidden\' : \'text\'" :class="[ inputClass, { \'form-control\' : bootstrapStyling } ]" :name=name :id=id @click=showCalendar :value=formattedValue :placeholder=placeholder :clear-button=clearButton :disabled=disabledPicker :required=required readonly=readonly> <span class=vdp-datepicker__clear-button :class="{\'input-group-addon\' : bootstrapStyling}" v-if="clearButton && selectedDate" @click=clearDate()><i :class=clearButtonIcon><span v-if="calendarButtonIcon.length === 0">&times;</span></i></span> </div> <div class=vdp-datepicker__calendar v-show=showDayView v-bind:style=calendarStyle> <header> <span @click=previousMonth class=prev v-bind:class="{ \'disabled\' : previousMonthDisabled(currDate) }">&lt;</span> <span @click=showMonthCalendar class=up>{{ currMonthName }} {{ currYear }}</span> <span @click=nextMonth class=next v-bind:class="{ \'disabled\' : nextMonthDisabled(currDate) }">&gt;</span> </header> <span class="cell day-header" v-for="d in daysOfWeek">{{ d }}</span> <span class="cell day blank" v-for="d in blankDays"></span><span class="cell day" v-for="day in days" track-by=timestamp v-bind:class="{ \'selected\':day.isSelected, \'disabled\':day.isDisabled, \'highlighted\': day.isHighlighted, \'today\': day.isToday}" @click=selectDate(day)>{{ day.date }}</span> </div> <div class=vdp-datepicker__calendar v-show=showMonthView v-bind:style=calendarStyle> <header> <span @click=previousYear class=prev v-bind:class="{ \'disabled\' : previousYearDisabled(currDate) }">&lt;</span> <span @click=showYearCalendar class=up>{{ getYear() }}</span> <span @click=nextYear class=next v-bind:class="{ \'disabled\' : nextYearDisabled(currDate) }">&gt;</span> </header> <span class="cell month" v-for="month in months" track-by=timestamp v-bind:class="{ \'selected\': month.isSelected, \'disabled\': month.isDisabled }" @click.stop=selectMonth(month)>{{ month.month }}</span> </div> <div class=vdp-datepicker__calendar v-show=showYearView v-bind:style=calendarStyle> <header> <span @click=previousDecade class=prev v-bind:class="{ \'disabled\' : previousDecadeDisabled(currDate) }">&lt;</span> <span>{{ getDecade() }}</span> <span @click=nextDecade class=next v-bind:class="{ \'disabled\' : nextMonthDisabled(currDate) }">&gt;</span> </header> <span class="cell year" v-for="year in years" track-by=timestamp v-bind:class="{ \'selected\': year.isSelected, \'disabled\': year.isDisabled }" @click.stop=selectYear(year)>{{ year.year }}</span> </div> </div> '},function(e,t,r){var n,i,a={};r(77),n=r(39),i=r(74),e.exports=n||{},e.exports.__esModule&&(e.exports=e.exports.default);var o="function"==typeof e.exports?e.exports.options||(e.exports.options={}):e.exports;i&&(o.template=i),o.computed||(o.computed={}),Object.keys(a).forEach(function(e){var t=a[e];o.computed[e]=function(){return t}})},function(e,t,r){function n(e,t){for(var r=0;r<e.length;r++){var n=e[r],i=c[n.id];if(i){i.refs++;for(var a=0;a<i.parts.length;a++)i.parts[a](n.parts[a]);for(;a<n.parts.length;a++)i.parts.push(u(n.parts[a],t))}else{for(var o=[],a=0;a<n.parts.length;a++)o.push(u(n.parts[a],t));c[n.id]={id:n.id,refs:1,parts:o}}}}function i(e){for(var t=[],r={},n=0;n<e.length;n++){var i=e[n],a=i[0],o=i[1],s=i[2],u=i[3],l={css:o,media:s,sourceMap:u};r[a]?r[a].parts.push(l):t.push(r[a]={id:a,parts:[l]})}return t}function a(e,t){var r=p(),n=v[v.length-1];if("top"===e.insertAt)n?n.nextSibling?r.insertBefore(t,n.nextSibling):r.appendChild(t):r.insertBefore(t,r.firstChild),v.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");r.appendChild(t)}}function o(e){e.parentNode.removeChild(e);var t=v.indexOf(e);t>=0&&v.splice(t,1)}function s(e){var t=document.createElement("style");return t.type="text/css",a(e,t),t}function u(e,t){var r,n,i;if(t.singleton){var a=g++;r=b||(b=s(t)),n=l.bind(null,r,a,!1),i=l.bind(null,r,a,!0)}else r=s(t),n=d.bind(null,r),i=function(){o(r)};return n(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;n(e=t)}else i()}}function l(e,t,r,n){var i=r?"":n.css;if(e.styleSheet)e.styleSheet.cssText=y(t,i);else{var a=document.createTextNode(i),o=e.childNodes;o[t]&&e.removeChild(o[t]),o.length?e.insertBefore(a,o[t]):e.appendChild(a)}}function d(e,t){var r=t.css,n=t.media,i=t.sourceMap;if(n&&e.setAttribute("media",n),i&&(r+="\n/*# sourceURL="+i.sources[0]+" */",r+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),e.styleSheet)e.styleSheet.cssText=r;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(r))}}var c={},f=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},h=f(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),p=f(function(){return document.head||document.getElementsByTagName("head")[0]}),b=null,g=0,v=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=h()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var r=i(e);return n(r,t),function(e){for(var a=[],o=0;o<r.length;o++){var s=r[o],u=c[s.id];u.refs--,a.push(u)}if(e){var l=i(e);n(l,t)}for(var o=0;o<a.length;o++){var u=a[o];if(0===u.refs){for(var d=0;d<u.parts.length;d++)u.parts[d]();delete c[u.id]}}}};var y=function(){var e=[];return function(t,r){return e[t]=r,e.filter(Boolean).join("\n")}}()},function(e,t,r){var n=r(72);"string"==typeof n&&(n=[[e.id,n,""]]);r(76)(n,{});n.locals&&(e.exports=n.locals)}]);
	//# sourceMappingURL=build.js.map

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(24);
	var settle = __webpack_require__(394);
	var buildURL = __webpack_require__(397);
	var parseHeaders = __webpack_require__(403);
	var isURLSameOrigin = __webpack_require__(401);
	var createError = __webpack_require__(176);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(396);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(399);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(393);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(462), __esModule: true };

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(465), __esModule: true };

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(470), __esModule: true };

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(471), __esModule: true };

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(454);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(184);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(82);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(74)
	  , ITERATOR   = __webpack_require__(25)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(56);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(25)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(17).getDesc
	  , isObject = __webpack_require__(73)
	  , anObject = __webpack_require__(56);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(57)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var core        = __webpack_require__(16)
	  , $           = __webpack_require__(17)
	  , DESCRIPTORS = __webpack_require__(72)
	  , SPECIES     = __webpack_require__(25)('species');
	
	module.exports = function(KEY){
	  var C = core[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(34)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(197)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(99);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(99);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(99);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(99);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(133);
	var Transform = __webpack_require__(134);
	var inherits = __webpack_require__(41);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(29);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(14);
	var toAbsoluteIndex = __webpack_require__(67);
	var toLength = __webpack_require__(13);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(59);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(18);
	var toObject = __webpack_require__(14);
	var IObject = __webpack_require__(88);
	var toLength = __webpack_require__(13);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(18);
	var isObject = __webpack_require__(7);
	var invoke = __webpack_require__(216);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(12).f;
	var create = __webpack_require__(61);
	var redefineAll = __webpack_require__(65);
	var ctx = __webpack_require__(30);
	var anInstance = __webpack_require__(58);
	var forOf = __webpack_require__(59);
	var $iterDefine = __webpack_require__(146);
	var step = __webpack_require__(219);
	var setSpecies = __webpack_require__(66);
	var DESCRIPTORS = __webpack_require__(11);
	var fastKey = __webpack_require__(52).fastKey;
	var validate = __webpack_require__(78);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(87);
	var from = __webpack_require__(208);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(65);
	var getWeak = __webpack_require__(52).getWeak;
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var anInstance = __webpack_require__(58);
	var forOf = __webpack_require__(59);
	var createArrayMethod = __webpack_require__(35);
	var $has = __webpack_require__(20);
	var validate = __webpack_require__(78);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(104);
	var isObject = __webpack_require__(7);
	var toLength = __webpack_require__(13);
	var ctx = __webpack_require__(30);
	var IS_CONCAT_SPREADABLE = __webpack_require__(10)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(11) && !__webpack_require__(6)(function () {
	  return Object.defineProperty(__webpack_require__(139)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(7);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(4);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(148);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 221 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 222 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(63);
	var gOPS = __webpack_require__(108);
	var pIE = __webpack_require__(89);
	var toObject = __webpack_require__(14);
	var IObject = __webpack_require__(88);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(6)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(12);
	var anObject = __webpack_require__(4);
	var getKeys = __webpack_require__(63);
	
	module.exports = __webpack_require__(11) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(28);
	var gOPN = __webpack_require__(62).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(20);
	var toIObject = __webpack_require__(28);
	var arrayIndexOf = __webpack_require__(100)(false);
	var IE_PROTO = __webpack_require__(152)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(63);
	var toIObject = __webpack_require__(28);
	var isEnum = __webpack_require__(89).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(62);
	var gOPS = __webpack_require__(108);
	var anObject = __webpack_require__(4);
	var Reflect = __webpack_require__(5).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(5).parseFloat;
	var $trim = __webpack_require__(77).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(156) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(5).parseInt;
	var $trim = __webpack_require__(77).trim;
	var ws = __webpack_require__(156);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var newPromiseCapability = __webpack_require__(150);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(13);
	var repeat = __webpack_require__(155);
	var defined = __webpack_require__(37);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(13);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(10);


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(211);
	var validate = __webpack_require__(78);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(101)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(11) && /./g.flags != 'g') __webpack_require__(12).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(103)
	});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(211);
	var validate = __webpack_require__(78);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(101)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(35)(0);
	var redefine = __webpack_require__(22);
	var meta = __webpack_require__(52);
	var assign = __webpack_require__(223);
	var weak = __webpack_require__(213);
	var isObject = __webpack_require__(7);
	var fails = __webpack_require__(6);
	var validate = __webpack_require__(78);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(101)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(1764)
	
	var md5 = toConstructor(__webpack_require__(711))
	var rmd160 = toConstructor(__webpack_require__(1761))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var mersenne = __webpack_require__(1703);
	
	/**
	 *
	 * @namespace faker.random
	 */
	function Random (faker, seed) {
	  // Use a user provided seed if it exists
	  if (seed) {
	    if (Array.isArray(seed) && seed.length) {
	      mersenne.seed_array(seed);
	    }
	    else {
	      mersenne.seed(seed);
	    }
	  }
	  /**
	   * returns a single random number based on a max number or range
	   *
	   * @method faker.random.number
	   * @param {mixed} options
	   */
	  this.number = function (options) {
	
	    if (typeof options === "number") {
	      options = {
	        max: options
	      };
	    }
	
	    options = options || {};
	
	    if (typeof options.min === "undefined") {
	      options.min = 0;
	    }
	
	    if (typeof options.max === "undefined") {
	      options.max = 99999;
	    }
	    if (typeof options.precision === "undefined") {
	      options.precision = 1;
	    }
	
	    // Make the range inclusive of the max value
	    var max = options.max;
	    if (max >= 0) {
	      max += options.precision;
	    }
	
	    var randomNumber = options.precision * Math.floor(
	      mersenne.rand(max / options.precision, options.min / options.precision));
	
	    return randomNumber;
	
	  }
	
	  /**
	   * takes an array and returns a random element of the array
	   *
	   * @method faker.random.arrayElement
	   * @param {array} array
	   */
	  this.arrayElement = function (array) {
	      array = array || ["a", "b", "c"];
	      var r = faker.random.number({ max: array.length - 1 });
	      return array[r];
	  }
	
	  /**
	   * takes an object and returns the randomly key or value
	   *
	   * @method faker.random.objectElement
	   * @param {object} object
	   * @param {mixed} field
	   */
	  this.objectElement = function (object, field) {
	      object = object || { "foo": "bar", "too": "car" };
	      var array = Object.keys(object);
	      var key = faker.random.arrayElement(array);
	
	      return field === "key" ? key : object[key];
	  }
	
	  /**
	   * uuid
	   *
	   * @method faker.random.uuid
	   */
	  this.uuid = function () {
	      var self = this;
	      var RFC4122_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	      var replacePlaceholders = function (placeholder) {
	          var random = self.number({ min: 0, max: 15 });
	          var value = placeholder == 'x' ? random : (random &0x3 | 0x8);
	          return value.toString(16);
	      };
	      return RFC4122_TEMPLATE.replace(/[xy]/g, replacePlaceholders);
	  }
	
	  /**
	   * boolean
	   *
	   * @method faker.random.boolean
	   */
	  this.boolean = function () {
	      return !!faker.random.number(1)
	  }
	
	  // TODO: have ability to return specific type of word? As in: noun, adjective, verb, etc
	  /**
	   * word
	   *
	   * @method faker.random.word
	   * @param {string} type
	   */
	  this.word = function randomWord (type) {
	
	    var wordMethods = [
	    'commerce.department',
	    'commerce.productName',
	    'commerce.productAdjective',
	    'commerce.productMaterial',
	    'commerce.product',
	    'commerce.color',
	
	    'company.catchPhraseAdjective',
	    'company.catchPhraseDescriptor',
	    'company.catchPhraseNoun',
	    'company.bsAdjective',
	    'company.bsBuzz',
	    'company.bsNoun',
	    'address.streetSuffix',
	    'address.county',
	    'address.country',
	    'address.state',
	
	    'finance.accountName',
	    'finance.transactionType',
	    'finance.currencyName',
	
	    'hacker.noun',
	    'hacker.verb',
	    'hacker.adjective',
	    'hacker.ingverb',
	    'hacker.abbreviation',
	
	    'name.jobDescriptor',
	    'name.jobArea',
	    'name.jobType'];
	
	    // randomly pick from the many faker methods that can generate words
	    var randomWordMethod = faker.random.arrayElement(wordMethods);
	    return faker.fake('{{' + randomWordMethod + '}}');
	
	  }
	
	  /**
	   * randomWords
	   *
	   * @method faker.random.words
	   * @param {number} count defaults to a random value between 1 and 3
	   */
	  this.words = function randomWords (count) {
	    var words = [];
	    if (typeof count === "undefined") {
	      count = faker.random.number({min:1, max: 3});
	    }
	    for (var i = 0; i<count; i++) {
	      words.push(faker.random.word());
	    }
	    return words.join(' ');
	  }
	
	  /**
	   * locale
	   *
	   * @method faker.random.image
	   */
	  this.image = function randomImage () {
	    return faker.image.image();
	  }
	
	  /**
	   * locale
	   *
	   * @method faker.random.locale
	   */
	  this.locale = function randomLocale () {
	    return faker.random.arrayElement(Object.keys(faker.locales));
	  };
	
	  /**
	   * alphaNumeric
	   *
	   * @method faker.random.alphaNumeric
	   */
	  this.alphaNumeric = function alphaNumeric() {
	    return faker.random.arrayElement(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]);
	  }
	
	  return this;
	
	}
	
	module['exports'] = Random;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var jws = __webpack_require__(164);
	
	module.exports = function (jwt, options) {
	  options = options || {};
	  var decoded = jws.decode(jwt, options);
	  if (!decoded) { return null; }
	  var payload = decoded.payload;
	
	  //try parse the payload
	  if(typeof payload === 'string') {
	    try {
	      var obj = JSON.parse(payload);
	      if(obj !== null && typeof obj === 'object') {
	        payload = obj;
	      }
	    } catch (e) { }
	  }
	
	  //return header if `complete` option is enabled.  header includes claims
	  //such as `kid` and `alg` used to select the key within a JWKS needed to
	  //verify the signature
	  if (options.complete === true) {
	    return {
	      header: decoded.header,
	      payload: payload,
	      signature: decoded.signature
	    };
	  }
	  return payload;
	};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var JsonWebTokenError = __webpack_require__(114);
	
	var NotBeforeError = function (message, date) {
	  JsonWebTokenError.call(this, message);
	  this.name = 'NotBeforeError';
	  this.date = date;
	};
	
	NotBeforeError.prototype = Object.create(JsonWebTokenError.prototype);
	
	NotBeforeError.prototype.constructor = NotBeforeError;
	
	module.exports = NotBeforeError;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var JsonWebTokenError = __webpack_require__(114);
	
	var TokenExpiredError = function (message, expiredAt) {
	  JsonWebTokenError.call(this, message);
	  this.name = 'TokenExpiredError';
	  this.expiredAt = expiredAt;
	};
	
	TokenExpiredError.prototype = Object.create(JsonWebTokenError.prototype);
	
	TokenExpiredError.prototype.constructor = TokenExpiredError;
	
	module.exports = TokenExpiredError;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var semver = __webpack_require__(1712);
	
	module.exports = semver.satisfies(process.version, '^6.12.0 || >=8.0.0');
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var ms = __webpack_require__(1711);
	
	module.exports = function (time, iat) {
	  var timestamp = iat || Math.floor(Date.now() / 1000);
	
	  if (typeof time === 'string') {
	    var milliseconds = ms(time);
	    if (typeof milliseconds === 'undefined') {
	      return;
	    }
	    return Math.floor(timestamp + milliseconds / 1000);
	  } else if (typeof time === 'number') {
	    return timestamp + time;
	  } else {
	    return;
	  }
	
	};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var bufferEqual = __webpack_require__(507);
	var Buffer = __webpack_require__(46).Buffer;
	var crypto = __webpack_require__(710);
	var formatEcdsa = __webpack_require__(714);
	var util = __webpack_require__(53);
	
	var MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".'
	var MSG_INVALID_SECRET = 'secret must be a string or buffer';
	var MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
	var MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';
	
	var supportsKeyObjects = typeof crypto.createPublicKey === 'function';
	if (supportsKeyObjects) {
	  MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
	  MSG_INVALID_SECRET += 'or a KeyObject';
	}
	
	function checkIsPublicKey(key) {
	  if (Buffer.isBuffer(key)) {
	    return;
	  }
	
	  if (typeof key === 'string') {
	    return;
	  }
	
	  if (!supportsKeyObjects) {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key !== 'object') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key.type !== 'string') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key.asymmetricKeyType !== 'string') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key.export !== 'function') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	};
	
	function checkIsPrivateKey(key) {
	  if (Buffer.isBuffer(key)) {
	    return;
	  }
	
	  if (typeof key === 'string') {
	    return;
	  }
	
	  if (typeof key === 'object') {
	    return;
	  }
	
	  throw typeError(MSG_INVALID_SIGNER_KEY);
	};
	
	function checkIsSecretKey(key) {
	  if (Buffer.isBuffer(key)) {
	    return;
	  }
	
	  if (typeof key === 'string') {
	    return key;
	  }
	
	  if (!supportsKeyObjects) {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	
	  if (typeof key !== 'object') {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	
	  if (key.type !== 'secret') {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	
	  if (typeof key.export !== 'function') {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	}
	
	function fromBase64(base64) {
	  return base64
	    .replace(/=/g, '')
	    .replace(/\+/g, '-')
	    .replace(/\//g, '_');
	}
	
	function toBase64(base64url) {
	  base64url = base64url.toString();
	
	  var padding = 4 - base64url.length % 4;
	  if (padding !== 4) {
	    for (var i = 0; i < padding; ++i) {
	      base64url += '=';
	    }
	  }
	
	  return base64url
	    .replace(/\-/g, '+')
	    .replace(/_/g, '/');
	}
	
	function typeError(template) {
	  var args = [].slice.call(arguments, 1);
	  var errMsg = util.format.bind(util, template).apply(null, args);
	  return new TypeError(errMsg);
	}
	
	function bufferOrString(obj) {
	  return Buffer.isBuffer(obj) || typeof obj === 'string';
	}
	
	function normalizeInput(thing) {
	  if (!bufferOrString(thing))
	    thing = JSON.stringify(thing);
	  return thing;
	}
	
	function createHmacSigner(bits) {
	  return function sign(thing, secret) {
	    checkIsSecretKey(secret);
	    thing = normalizeInput(thing);
	    var hmac = crypto.createHmac('sha' + bits, secret);
	    var sig = (hmac.update(thing), hmac.digest('base64'))
	    return fromBase64(sig);
	  }
	}
	
	function createHmacVerifier(bits) {
	  return function verify(thing, signature, secret) {
	    var computedSig = createHmacSigner(bits)(thing, secret);
	    return bufferEqual(Buffer.from(signature), Buffer.from(computedSig));
	  }
	}
	
	function createKeySigner(bits) {
	 return function sign(thing, privateKey) {
	    checkIsPrivateKey(privateKey);
	    thing = normalizeInput(thing);
	    // Even though we are specifying "RSA" here, this works with ECDSA
	    // keys as well.
	    var signer = crypto.createSign('RSA-SHA' + bits);
	    var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
	    return fromBase64(sig);
	  }
	}
	
	function createKeyVerifier(bits) {
	  return function verify(thing, signature, publicKey) {
	    checkIsPublicKey(publicKey);
	    thing = normalizeInput(thing);
	    signature = toBase64(signature);
	    var verifier = crypto.createVerify('RSA-SHA' + bits);
	    verifier.update(thing);
	    return verifier.verify(publicKey, signature, 'base64');
	  }
	}
	
	function createPSSKeySigner(bits) {
	  return function sign(thing, privateKey) {
	    checkIsPrivateKey(privateKey);
	    thing = normalizeInput(thing);
	    var signer = crypto.createSign('RSA-SHA' + bits);
	    var sig = (signer.update(thing), signer.sign({
	      key: privateKey,
	      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
	      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
	    }, 'base64'));
	    return fromBase64(sig);
	  }
	}
	
	function createPSSKeyVerifier(bits) {
	  return function verify(thing, signature, publicKey) {
	    checkIsPublicKey(publicKey);
	    thing = normalizeInput(thing);
	    signature = toBase64(signature);
	    var verifier = crypto.createVerify('RSA-SHA' + bits);
	    verifier.update(thing);
	    return verifier.verify({
	      key: publicKey,
	      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
	      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
	    }, signature, 'base64');
	  }
	}
	
	function createECDSASigner(bits) {
	  var inner = createKeySigner(bits);
	  return function sign() {
	    var signature = inner.apply(null, arguments);
	    signature = formatEcdsa.derToJose(signature, 'ES' + bits);
	    return signature;
	  };
	}
	
	function createECDSAVerifer(bits) {
	  var inner = createKeyVerifier(bits);
	  return function verify(thing, signature, publicKey) {
	    signature = formatEcdsa.joseToDer(signature, 'ES' + bits).toString('base64');
	    var result = inner(thing, signature, publicKey);
	    return result;
	  };
	}
	
	function createNoneSigner() {
	  return function sign() {
	    return '';
	  }
	}
	
	function createNoneVerifier() {
	  return function verify(thing, signature) {
	    return signature === '';
	  }
	}
	
	module.exports = function jwa(algorithm) {
	  var signerFactories = {
	    hs: createHmacSigner,
	    rs: createKeySigner,
	    ps: createPSSKeySigner,
	    es: createECDSASigner,
	    none: createNoneSigner,
	  }
	  var verifierFactories = {
	    hs: createHmacVerifier,
	    rs: createKeyVerifier,
	    ps: createPSSKeyVerifier,
	    es: createECDSAVerifer,
	    none: createNoneVerifier,
	  }
	  var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
	  if (!match)
	    throw typeError(MSG_INVALID_ALGORITHM, algorithm);
	  var algo = (match[1] || match[3]).toLowerCase();
	  var bits = match[2];
	
	  return {
	    sign: signerFactories[algo](bits),
	    verify: verifierFactories[algo](bits),
	  }
	};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*global module, process*/
	var Buffer = __webpack_require__(46).Buffer;
	var Stream = __webpack_require__(117);
	var util = __webpack_require__(53);
	
	function DataStream(data) {
	  this.buffer = null;
	  this.writable = true;
	  this.readable = true;
	
	  // No input
	  if (!data) {
	    this.buffer = Buffer.alloc(0);
	    return this;
	  }
	
	  // Stream
	  if (typeof data.pipe === 'function') {
	    this.buffer = Buffer.alloc(0);
	    data.pipe(this);
	    return this;
	  }
	
	  // Buffer or String
	  // or Object (assumedly a passworded key)
	  if (data.length || typeof data === 'object') {
	    this.buffer = data;
	    this.writable = false;
	    process.nextTick(function () {
	      this.emit('end', data);
	      this.readable = false;
	      this.emit('close');
	    }.bind(this));
	    return this;
	  }
	
	  throw new TypeError('Unexpected data type ('+ typeof data + ')');
	}
	util.inherits(DataStream, Stream);
	
	DataStream.prototype.write = function write(data) {
	  this.buffer = Buffer.concat([this.buffer, Buffer.from(data)]);
	  this.emit('data', data);
	};
	
	DataStream.prototype.end = function end(data) {
	  if (data)
	    this.write(data);
	  this.emit('end', data);
	  this.emit('close');
	  this.writable = false;
	  this.readable = false;
	};
	
	module.exports = DataStream;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/*global module*/
	var Buffer = __webpack_require__(9).Buffer;
	
	module.exports = function toString(obj) {
	  if (typeof obj === 'string')
	    return obj;
	  if (typeof obj === 'number' || Buffer.isBuffer(obj))
	    return obj.toString();
	  return JSON.stringify(obj);
	};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        ss : '%d sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss : '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        ss : '%d saniyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	// Language contact person : Abdoufata Kane : https://github.com/abdoufata
	
	var bm = moment.defineLocale('bm', {
	    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'MMMM [tile] D [san] YYYY',
	        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bi lɛrɛ] LT',
	        nextDay : '[Sini lɛrɛ] LT',
	        nextWeek : 'dddd [don lɛrɛ] LT',
	        lastDay : '[Kunu lɛrɛ] LT',
	        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s kɔnɔ',
	        past : 'a bɛ %s bɔ',
	        s : 'sanga dama dama',
	        ss : 'sekondi %d',
	        m : 'miniti kelen',
	        mm : 'miniti %d',
	        h : 'lɛrɛ kelen',
	        hh : 'lɛrɛ %d',
	        d : 'tile kelen',
	        dd : 'tile %d',
	        M : 'kalo kelen',
	        MM : 'kalo %d',
	        y : 'san kelen',
	        yy : 'san %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return bm;
	
	})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        ss : '%d সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        ss : '%d སྐར་ཆ།',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        ss : '%d eilenn',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : 'D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        ss : '%d segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        ss : '%d ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        ss: '%d eiliad',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        ss : '%d sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        ss : 'd% ސިކުންތު',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        ss : '%d δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        ss : '%d sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esUs = moment.defineLocale('es-us', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'MM/DD/YYYY',
	        LL : 'MMMM [de] D [de] YYYY',
	        LLL : 'MMMM [de] D [de] YYYY h:mm A',
	        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return esUs;
	
	})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex : monthsRegex,
	    monthsShortRegex : monthsRegex,
	    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'ss': [number + 'sekundi', number + 'sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        ss : '%d segundo',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        ss : 'ثانیه d%',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'ss':
	            return isFuture ? 'sekunnin' : 'sekuntia';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        ss : '%d sekundir',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        ss : '%d sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        ss : '%d diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'ss': [number + ' secondanim', number + ' second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	        '1': '૧',
	        '2': '૨',
	        '3': '૩',
	        '4': '૪',
	        '5': '૫',
	        '6': '૬',
	        '7': '૭',
	        '8': '૮',
	        '9': '૯',
	        '0': '૦'
	    };
	var numberMap = {
	        '૧': '1',
	        '૨': '2',
	        '૩': '3',
	        '૪': '4',
	        '૫': '5',
	        '૬': '6',
	        '૭': '7',
	        '૮': '8',
	        '૯': '9',
	        '૦': '0'
	    };
	
	var gu = moment.defineLocale('gu', {
	    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm વાગ્યે',
	        LTS: 'A h:mm:ss વાગ્યે',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	    },
	    calendar: {
	        sameDay: '[આજ] LT',
	        nextDay: '[કાલે] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ગઇકાલે] LT',
	        lastWeek: '[પાછલા] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s મા',
	        past: '%s પેહલા',
	        s: 'અમુક પળો',
	        ss: '%d સેકંડ',
	        m: 'એક મિનિટ',
	        mm: '%d મિનિટ',
	        h: 'એક કલાક',
	        hh: '%d કલાક',
	        d: 'એક દિવસ',
	        dd: '%d દિવસ',
	        M: 'એક મહિનો',
	        MM: '%d મહિનો',
	        y: 'એક વર્ષ',
	        yy: '%d વર્ષ'
	    },
	    preparse: function (string) {
	        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'રાત') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'સવાર') {
	            return hour;
	        } else if (meridiem === 'બપોર') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'સાંજ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'રાત';
	        } else if (hour < 10) {
	            return 'સવાર';
	        } else if (hour < 17) {
	            return 'બપોર';
	        } else if (hour < 20) {
	            return 'સાંજ';
	        } else {
	            return 'રાત';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return gu;
	
	})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        ss : '%d שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        ss : '%d सेकंड',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'ss':
	            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        ss : '%d վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        ss : '%d detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'ss':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	            }
	            return result + 'sekúnda';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        ss : '%d secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        ss : '%d秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        ss : '%d detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        ss : '%d წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        ss : '%d секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        ss: '%d វិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        ss : '%d ಸೆಕೆಂಡುಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '일';
	            case 'M':
	                return number + '월';
	            case 'w':
	            case 'W':
	                return number + '주';
	            default:
	                return number;
	        }
	    },
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        ss : '%d секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        ss : '%d Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        ss : '%d ວິນາທີ' ,
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss' : 'sekundė_sekundžių_sekundes',
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        ss : translate,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekund', 'sekunda', 'sekundi'],
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        ss: '%d hēkona',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        ss : '%d സെക്കൻഡ്',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'ss': output = '%d सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'ss': output = '%d सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        ss: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mt = moment.defineLocale('mt', {
	    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Illum fil-]LT',
	        nextDay : '[Għada fil-]LT',
	        nextWeek : 'dddd [fil-]LT',
	        lastDay : '[Il-bieraħ fil-]LT',
	        lastWeek : 'dddd [li għadda] [fil-]LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'f’ %s',
	        past : '%s ilu',
	        s : 'ftit sekondi',
	        ss : '%d sekondi',
	        m : 'minuta',
	        mm : '%d minuti',
	        h : 'siegħa',
	        hh : '%d siegħat',
	        d : 'ġurnata',
	        dd : '%d ġranet',
	        M : 'xahar',
	        MM : '%d xhur',
	        y : 'sena',
	        yy : '%d sni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mt;
	
	})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        ss : '%d စက္ကန့်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        ss : '%d sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        ss : '%d सेकेण्ड',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        ss : '%d sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        ss : '%d ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            return result + (plural(number) ? 'sekundy' : 'sekund');
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';
	
	                case 2:
	                    return '[We wtorek o] LT';
	
	                case 3:
	                    return '[W środę o] LT';
	
	                case 6:
	                    return '[W sobotę o] LT';
	
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'ss': 'secunde',
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        ss : relativeTimeWithPlural,
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., H:mm',
	        LLLL : 'dddd, D MMMM YYYY г., H:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        ss : '%d سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        ss: '%d sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        ss : 'තත්පර %d',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekúnd');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'ss':
	            if (number === 1) {
	                result += withoutSuffix ? 'sekundo' : 'sekundi';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	            } else {
	                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        ss : '%d sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['секунда', 'секунде', 'секунди'],
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekunda', 'sekunde', 'sekundi'],
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        ss : '%d mzuzwana',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        ss : '%d sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        ss : 'sekunde %d',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        ss : '%d விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        ss : '%d సెకన్లు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        ss : 'minutu %d',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        ss : '%d วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        ss : '%d segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'ss':
	            return numberNoun + ' lup';
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        ss : translate,
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[gelecek] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        ss : '%d saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'ss': [number + ' secunds', '' + number + ' secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        ss : '%d imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        ss : '%d ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        ss : '%d سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        ss : '%d soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        ss : '%d фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        ss : '%d giây' ,
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        ss : '%d s~écóñ~ds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        ss :'aayá %d',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah点mm分',
	        LLLL : 'YYYY年M月D日ddddAh点mm分',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        ss : '%d 秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = NumberType;
	
	var _InvalidError = _interopRequireDefault(__webpack_require__(69));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function NumberType(value) {
	  // An XLSX file editing software might not always correctly
	  // detect numeric values in string-type cells. Users won't bother
	  // manually selecting a cell type, so the editing software has to guess
	  // based on the user's input. One can assume that such auto-detection
	  // might not always work.
	  //
	  // So, if a cell is supposed to be a numeric one, convert a string value to a number.
	  //
	  if (typeof value === 'string') {
	    var stringifiedValue = value;
	    value = Number(value);
	
	    if (String(value) !== stringifiedValue) {
	      throw new _InvalidError["default"]('not_a_number');
	    }
	  }
	
	  if (typeof value !== 'number') {
	    throw new _InvalidError["default"]('not_a_number');
	  }
	
	  if (isNaN(value)) {
	    throw new _InvalidError["default"]('invalid_number');
	  } // At this point, `value` can only be a number.
	  //
	  // The global `isFinite()` function filters out:
	  // * NaN
	  // * -Infinity
	  // * Infinity
	  //
	  // All other values pass (including non-numbers).
	  //
	
	
	  if (!isFinite(value)) {
	    throw new _InvalidError["default"]('out_of_bounds');
	  }
	
	  return value;
	}
	//# sourceMappingURL=Number.js.map

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findChild = findChild;
	exports.findChildren = findChildren;
	exports.forEach = forEach;
	exports.getOuterXml = getOuterXml;
	exports.getTagName = getTagName;
	exports.map = map;
	
	function findChild(node, tagName) {
	  var i = 0;
	
	  while (i < node.childNodes.length) {
	    var childNode = node.childNodes[i]; // `nodeType: 1` means "Element".
	    // https://www.w3schools.com/xml/prop_element_nodetype.asp
	
	    if (childNode.nodeType === 1 && getTagName(childNode) === tagName) {
	      return childNode;
	    }
	
	    i++;
	  }
	}
	
	function findChildren(node, tagName) {
	  var results = [];
	  var i = 0;
	
	  while (i < node.childNodes.length) {
	    var childNode = node.childNodes[i]; // `nodeType: 1` means "Element".
	    // https://www.w3schools.com/xml/prop_element_nodetype.asp
	
	    if (childNode.nodeType === 1 && getTagName(childNode) === tagName) {
	      results.push(childNode);
	    }
	
	    i++;
	  }
	
	  return results;
	}
	
	function forEach(node, tagName, func) {
	  // if (typeof tagName === 'function') {
	  // 	func = tagName
	  // 	tagName = undefined
	  // }
	  var i = 0;
	
	  while (i < node.childNodes.length) {
	    var childNode = node.childNodes[i];
	
	    if (tagName) {
	      // `nodeType: 1` means "Element".
	      // https://www.w3schools.com/xml/prop_element_nodetype.asp
	      if (childNode.nodeType === 1 && getTagName(childNode) === tagName) {
	        func(childNode, i);
	      }
	    } else {
	      func(childNode, i);
	    }
	
	    i++;
	  }
	}
	
	function map(node, tagName, func) {
	  var results = [];
	  forEach(node, tagName, function (node, i) {
	    results.push(func(node, i));
	  });
	  return results;
	}
	
	var NAMESPACE_REG_EXP = /.+\:/;
	
	function getTagName(element) {
	  // For some weird reason, if an element is declared as,
	  // for example, `<x:sheets/>`, then its `.tagName` will be
	  // "x:sheets" instead of just "sheets".
	  // https://gitlab.com/catamphetamine/read-excel-file/-/issues/25
	  // Its not clear how to tell it to ignore any namespaces
	  // when getting `.tagName`, so just replacing anything
	  // before a colon, if any.
	  return element.tagName.replace(NAMESPACE_REG_EXP, '');
	} // This function is only used for occasional debug messages.
	
	
	function getOuterXml(node) {
	  // `nodeType: 1` means "Element".
	  // https://www.w3schools.com/xml/prop_element_nodetype.asp
	  if (node.nodeType !== 1) {
	    return node.textContent;
	  }
	
	  var xml = '<' + getTagName(node);
	  var j = 0;
	
	  while (j < node.attributes.length) {
	    xml += ' ' + node.attributes[j].name + '=' + '"' + node.attributes[j].value + '"';
	    j++;
	  }
	
	  xml += '>';
	  var i = 0;
	
	  while (i < node.childNodes.length) {
	    xml += getOuterXml(node.childNodes[i]);
	    i++;
	  }
	
	  xml += '</' + getTagName(node) + '>';
	  return xml;
	}
	//# sourceMappingURL=dom.js.map

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(116);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(242);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(163).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(375);
	/*</replacement>*/
	
	// TODO(bmeurer): Change this back to const once hole checks are
	// properly optimized away early in Ignition+TurboFan.
	/*<replacement>*/
	var Buffer = __webpack_require__(46).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(90);
	util.inherits = __webpack_require__(41);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1851);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1756);
	var destroyImpl = __webpack_require__(374);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') {
	    return emitter.prependListener(event, fn);
	  } else {
	    // This is a hack to make sure that our error handler is attached before any
	    // userland ones.  NEVER DO THIS. This is here only because this code needs
	    // to continue to work with older versions of Node.js that do not include
	    // the prependListener() method. The goal is to eventually remove this hack.
	    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	  }
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(71);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(376).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(71);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(376).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(32)))

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(71);
	
	/*<replacement>*/
	var util = __webpack_require__(90);
	util.inherits = __webpack_require__(41);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return stream.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er, data) {
	      done(stream, er, data);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(116);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      processNextTick(emitErrorNT, this, err);
	    }
	    return;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      processNextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(163).EventEmitter;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(46).Buffer;
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return -1;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd'.repeat(p);
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd'.repeat(p + 1);
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd'.repeat(p + 2);
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1762);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueMultiselect=e():t.VueMultiselect=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=60)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var i=n(49)("wks"),r=n(30),o=n(0).Symbol,s="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=s&&o[t]||(s?o:r)("Symbol."+t))}).store=i},function(t,e,n){var i=n(5);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var i=n(0),r=n(10),o=n(8),s=n(6),u=n(11),a=function(t,e,n){var l,c,f,p,h=t&a.F,d=t&a.G,v=t&a.S,g=t&a.P,y=t&a.B,m=d?i:v?i[e]||(i[e]={}):(i[e]||{}).prototype,b=d?r:r[e]||(r[e]={}),_=b.prototype||(b.prototype={});d&&(n=e);for(l in n)c=!h&&m&&void 0!==m[l],f=(c?m:n)[l],p=y&&c?u(f,i):g&&"function"==typeof f?u(Function.call,f):f,m&&s(m,l,f,t&a.U),b[l]!=f&&o(b,l,p),g&&_[l]!=f&&(_[l]=f)};i.core=r,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var i=n(0),r=n(8),o=n(12),s=n(30)("src"),u=Function.toString,a=(""+u).split("toString");n(10).inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,u){var l="function"==typeof n;l&&(o(n,"name")||r(n,"name",e)),t[e]!==n&&(l&&(o(n,s)||r(n,s,t[e]?""+t[e]:a.join(String(e)))),t===i?t[e]=n:u?t[e]?t[e]=n:r(t,e,n):(delete t[e],r(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[s]||u.call(this)})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(13),r=n(25);t.exports=n(4)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(14);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var i=n(2),r=n(41),o=n(29),s=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var i=n(7);t.exports=function(t,e){return!!t&&i(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var i=n(23),r=n(16);t.exports=function(t){return i(r(t))}},function(t,e,n){var i=n(53),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e,n){var i=n(11),r=n(23),o=n(28),s=n(19),u=n(64);t.exports=function(t,e){var n=1==t,a=2==t,l=3==t,c=4==t,f=6==t,p=5==t||f,h=e||u;return function(e,u,d){for(var v,g,y=o(e),m=r(y),b=i(u,d,3),_=s(m.length),x=0,w=n?h(e,_):a?h(e,0):void 0;_>x;x++)if((p||x in m)&&(v=m[x],g=b(v,x,y),t))if(n)w[x]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:w.push(v)}else if(c)return!1;return f?-1:l||c?c:w}}},function(t,e,n){var i=n(5),r=n(0).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var i=n(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e){t.exports=!1},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var i=n(13).f,r=n(12),o=n(1)("toStringTag");t.exports=function(t,e,n){t&&!r(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},function(t,e,n){var i=n(49)("keys"),r=n(30);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){var i=n(16);t.exports=function(t){return Object(i(t))}},function(t,e,n){var i=n(5);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},function(t,e,n){"use strict";var i=n(0),r=n(12),o=n(9),s=n(67),u=n(29),a=n(7),l=n(77).f,c=n(45).f,f=n(13).f,p=n(51).trim,h=i.Number,d=h,v=h.prototype,g="Number"==o(n(44)(v)),y="trim"in String.prototype,m=function(t){var e=u(t,!1);if("string"==typeof e&&e.length>2){e=y?e.trim():p(e,3);var n,i,r,o=e.charCodeAt(0);if(43===o||45===o){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+e}for(var s,a=e.slice(2),l=0,c=a.length;l<c;l++)if((s=a.charCodeAt(l))<48||s>r)return NaN;return parseInt(a,i)}}return+e};if(!h(" 0o1")||!h("0b1")||h("+0x1")){h=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof h&&(g?a(function(){v.valueOf.call(n)}):"Number"!=o(n))?s(new d(m(e)),n,h):m(e)};for(var b,_=n(4)?l(d):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;_.length>x;x++)r(d,b=_[x])&&!r(h,b)&&f(h,b,c(d,b));h.prototype=v,v.constructor=h,n(6)(i,"Number",h)}},function(t,e,n){"use strict";function i(t){return 0!==t&&(!(!Array.isArray(t)||0!==t.length)||!t)}function r(t){return function(){return!t.apply(void 0,arguments)}}function o(t,e){return void 0===t&&(t="undefined"),null===t&&(t="null"),!1===t&&(t="false"),-1!==t.toString().toLowerCase().indexOf(e.trim())}function s(t,e,n,i){return t.filter(function(t){return o(i(t,n),e)})}function u(t){return t.filter(function(t){return!t.$isLabel})}function a(t,e){return function(n){return n.reduce(function(n,i){return i[t]&&i[t].length?(n.push({$groupLabel:i[e],$isLabel:!0}),n.concat(i[t])):n},[])}}function l(t,e,i,r,o){return function(u){return u.map(function(u){var a;if(!u[i])return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."),[];var l=s(u[i],t,e,o);return l.length?(a={},n.i(d.a)(a,r,u[r]),n.i(d.a)(a,i,l),a):[]})}}var c=n(59),f=n(54),p=(n.n(f),n(95)),h=(n.n(p),n(31)),d=(n.n(h),n(58)),v=n(91),g=(n.n(v),n(98)),y=(n.n(g),n(92)),m=(n.n(y),n(88)),b=(n.n(m),n(97)),_=(n.n(b),n(89)),x=(n.n(_),n(96)),w=(n.n(x),n(93)),S=(n.n(w),n(90)),O=(n.n(S),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return function(t){return e.reduce(function(t,e){return e(t)},t)}});e.a={data:function(){return{search:"",isOpen:!1,preferredOpenDirection:"below",optimizedHeight:this.maxHeight}},props:{internalSearch:{type:Boolean,default:!0},options:{type:Array,required:!0},multiple:{type:Boolean,default:!1},value:{type:null,default:function(){return[]}},trackBy:{type:String},label:{type:String},searchable:{type:Boolean,default:!0},clearOnSelect:{type:Boolean,default:!0},hideSelected:{type:Boolean,default:!1},placeholder:{type:String,default:"Select option"},allowEmpty:{type:Boolean,default:!0},resetAfter:{type:Boolean,default:!1},closeOnSelect:{type:Boolean,default:!0},customLabel:{type:Function,default:function(t,e){return i(t)?"":e?t[e]:t}},taggable:{type:Boolean,default:!1},tagPlaceholder:{type:String,default:"Press enter to create a tag"},tagPosition:{type:String,default:"top"},max:{type:[Number,Boolean],default:!1},id:{default:null},optionsLimit:{type:Number,default:1e3},groupValues:{type:String},groupLabel:{type:String},groupSelect:{type:Boolean,default:!1},blockKeys:{type:Array,default:function(){return[]}},preserveSearch:{type:Boolean,default:!1},preselectFirst:{type:Boolean,default:!1}},mounted:function(){!this.multiple&&this.max&&console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."),this.preselectFirst&&!this.internalValue.length&&this.options.length&&this.select(this.filteredOptions[0])},computed:{internalValue:function(){return this.value||0===this.value?Array.isArray(this.value)?this.value:[this.value]:[]},filteredOptions:function(){var t=this.search||"",e=t.toLowerCase().trim(),n=this.options.concat();return n=this.internalSearch?this.groupValues?this.filterAndFlat(n,e,this.label):s(n,e,this.label,this.customLabel):this.groupValues?a(this.groupValues,this.groupLabel)(n):n,n=this.hideSelected?n.filter(r(this.isSelected)):n,this.taggable&&e.length&&!this.isExistingOption(e)&&("bottom"===this.tagPosition?n.push({isTag:!0,label:t}):n.unshift({isTag:!0,label:t})),n.slice(0,this.optionsLimit)},valueKeys:function(){var t=this;return this.trackBy?this.internalValue.map(function(e){return e[t.trackBy]}):this.internalValue},optionKeys:function(){var t=this;return(this.groupValues?this.flatAndStrip(this.options):this.options).map(function(e){return t.customLabel(e,t.label).toString().toLowerCase()})},currentOptionLabel:function(){return this.multiple?this.searchable?"":this.placeholder:this.internalValue.length?this.getOptionLabel(this.internalValue[0]):this.searchable?"":this.placeholder}},watch:{internalValue:function(){this.resetAfter&&this.internalValue.length&&(this.search="",this.$emit("input",this.multiple?[]:null))},search:function(){this.$emit("search-change",this.search,this.id)}},methods:{getValue:function(){return this.multiple?this.internalValue:0===this.internalValue.length?null:this.internalValue[0]},filterAndFlat:function(t,e,n){return O(l(e,n,this.groupValues,this.groupLabel,this.customLabel),a(this.groupValues,this.groupLabel))(t)},flatAndStrip:function(t){return O(a(this.groupValues,this.groupLabel),u)(t)},updateSearch:function(t){this.search=t},isExistingOption:function(t){return!!this.options&&this.optionKeys.indexOf(t)>-1},isSelected:function(t){var e=this.trackBy?t[this.trackBy]:t;return this.valueKeys.indexOf(e)>-1},isOptionDisabled:function(t){return!!t.$isDisabled},getOptionLabel:function(t){if(i(t))return"";if(t.isTag)return t.label;if(t.$isLabel)return t.$groupLabel;var e=this.customLabel(t,this.label);return i(e)?"":e},select:function(t,e){if(t.$isLabel&&this.groupSelect)return void this.selectGroup(t);if(!(-1!==this.blockKeys.indexOf(e)||this.disabled||t.$isDisabled||t.$isLabel)&&(!this.max||!this.multiple||this.internalValue.length!==this.max)&&("Tab"!==e||this.pointerDirty)){if(t.isTag)this.$emit("tag",t.label,this.id),this.search="",this.closeOnSelect&&!this.multiple&&this.deactivate();else{if(this.isSelected(t))return void("Tab"!==e&&this.removeElement(t));this.$emit("select",t,this.id),this.multiple?this.$emit("input",this.internalValue.concat([t]),this.id):this.$emit("input",t,this.id),this.clearOnSelect&&(this.search="")}this.closeOnSelect&&this.deactivate()}},selectGroup:function(t){var e=this,n=this.options.find(function(n){return n[e.groupLabel]===t.$groupLabel});if(n)if(this.wholeGroupSelected(n)){this.$emit("remove",n[this.groupValues],this.id);var i=this.internalValue.filter(function(t){return-1===n[e.groupValues].indexOf(t)});this.$emit("input",i,this.id)}else{var r=n[this.groupValues].filter(function(t){return!(e.isOptionDisabled(t)||e.isSelected(t))});this.$emit("select",r,this.id),this.$emit("input",this.internalValue.concat(r),this.id)}},wholeGroupSelected:function(t){var e=this;return t[this.groupValues].every(function(t){return e.isSelected(t)||e.isOptionDisabled(t)})},wholeGroupDisabled:function(t){return t[this.groupValues].every(this.isOptionDisabled)},removeElement:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!this.disabled&&!t.$isDisabled){if(!this.allowEmpty&&this.internalValue.length<=1)return void this.deactivate();var i="object"===n.i(c.a)(t)?this.valueKeys.indexOf(t[this.trackBy]):this.valueKeys.indexOf(t);if(this.$emit("remove",t,this.id),this.multiple){var r=this.internalValue.slice(0,i).concat(this.internalValue.slice(i+1));this.$emit("input",r,this.id)}else this.$emit("input",null,this.id);this.closeOnSelect&&e&&this.deactivate()}},removeLastElement:function(){-1===this.blockKeys.indexOf("Delete")&&0===this.search.length&&Array.isArray(this.internalValue)&&this.internalValue.length&&this.removeElement(this.internalValue[this.internalValue.length-1],!1)},activate:function(){var t=this;this.isOpen||this.disabled||(this.adjustPosition(),this.groupValues&&0===this.pointer&&this.filteredOptions.length&&(this.pointer=1),this.isOpen=!0,this.searchable?(this.preserveSearch||(this.search=""),this.$nextTick(function(){return t.$refs.search.focus()})):this.$el.focus(),this.$emit("open",this.id))},deactivate:function(){this.isOpen&&(this.isOpen=!1,this.searchable?this.$refs.search.blur():this.$el.blur(),this.preserveSearch||(this.search=""),this.$emit("close",this.getValue(),this.id))},toggle:function(){this.isOpen?this.deactivate():this.activate()},adjustPosition:function(){if("undefined"!=typeof window){var t=this.$el.getBoundingClientRect().top,e=window.innerHeight-this.$el.getBoundingClientRect().bottom;e>this.maxHeight||e>t||"below"===this.openDirection||"bottom"===this.openDirection?(this.preferredOpenDirection="below",this.optimizedHeight=Math.min(e-40,this.maxHeight)):(this.preferredOpenDirection="above",this.optimizedHeight=Math.min(t-40,this.maxHeight))}}}}},function(t,e,n){"use strict";var i=n(54),r=(n.n(i),n(31));n.n(r);e.a={data:function(){return{pointer:0,pointerDirty:!1}},props:{showPointer:{type:Boolean,default:!0},optionHeight:{type:Number,default:40}},computed:{pointerPosition:function(){return this.pointer*this.optionHeight},visibleElements:function(){return this.optimizedHeight/this.optionHeight}},watch:{filteredOptions:function(){this.pointerAdjust()},isOpen:function(){this.pointerDirty=!1}},methods:{optionHighlight:function(t,e){return{"multiselect__option--highlight":t===this.pointer&&this.showPointer,"multiselect__option--selected":this.isSelected(e)}},groupHighlight:function(t,e){var n=this;if(!this.groupSelect)return["multiselect__option--group","multiselect__option--disabled"];var i=this.options.find(function(t){return t[n.groupLabel]===e.$groupLabel});return i&&!this.wholeGroupDisabled(i)?["multiselect__option--group",{"multiselect__option--highlight":t===this.pointer&&this.showPointer},{"multiselect__option--group-selected":this.wholeGroupSelected(i)}]:"multiselect__option--disabled"},addPointerElement:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"Enter",e=t.key;this.filteredOptions.length>0&&this.select(this.filteredOptions[this.pointer],e),this.pointerReset()},pointerForward:function(){this.pointer<this.filteredOptions.length-1&&(this.pointer++,this.$refs.list.scrollTop<=this.pointerPosition-(this.visibleElements-1)*this.optionHeight&&(this.$refs.list.scrollTop=this.pointerPosition-(this.visibleElements-1)*this.optionHeight),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()),this.pointerDirty=!0},pointerBackward:function(){this.pointer>0?(this.pointer--,this.$refs.list.scrollTop>=this.pointerPosition&&(this.$refs.list.scrollTop=this.pointerPosition),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerBackward()):this.filteredOptions[this.pointer]&&this.filteredOptions[0].$isLabel&&!this.groupSelect&&this.pointerForward(),this.pointerDirty=!0},pointerReset:function(){this.closeOnSelect&&(this.pointer=0,this.$refs.list&&(this.$refs.list.scrollTop=0))},pointerAdjust:function(){this.pointer>=this.filteredOptions.length-1&&(this.pointer=this.filteredOptions.length?this.filteredOptions.length-1:0),this.filteredOptions.length>0&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()},pointerSet:function(t){this.pointer=t,this.pointerDirty=!0}}}},function(t,e,n){"use strict";var i=n(36),r=n(74),o=n(15),s=n(18);t.exports=n(72)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,r(1)):"keys"==e?r(0,n):"values"==e?r(0,t[n]):r(0,[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var i=n(31),r=(n.n(i),n(32)),o=n(33);e.a={name:"vue-multiselect",mixins:[r.a,o.a],props:{name:{type:String,default:""},selectLabel:{type:String,default:"Press enter to select"},selectGroupLabel:{type:String,default:"Press enter to select group"},selectedLabel:{type:String,default:"Selected"},deselectLabel:{type:String,default:"Press enter to remove"},deselectGroupLabel:{type:String,default:"Press enter to deselect group"},showLabels:{type:Boolean,default:!0},limit:{type:Number,default:99999},maxHeight:{type:Number,default:300},limitText:{type:Function,default:function(t){return"and ".concat(t," more")}},loading:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},openDirection:{type:String,default:""},showNoOptions:{type:Boolean,default:!0},showNoResults:{type:Boolean,default:!0},tabindex:{type:Number,default:0}},computed:{isSingleLabelVisible:function(){return(this.singleValue||0===this.singleValue)&&(!this.isOpen||!this.searchable)&&!this.visibleValues.length},isPlaceholderVisible:function(){return!(this.internalValue.length||this.searchable&&this.isOpen)},visibleValues:function(){return this.multiple?this.internalValue.slice(0,this.limit):[]},singleValue:function(){return this.internalValue[0]},deselectLabelText:function(){return this.showLabels?this.deselectLabel:""},deselectGroupLabelText:function(){return this.showLabels?this.deselectGroupLabel:""},selectLabelText:function(){return this.showLabels?this.selectLabel:""},selectGroupLabelText:function(){return this.showLabels?this.selectGroupLabel:""},selectedLabelText:function(){return this.showLabels?this.selectedLabel:""},inputStyle:function(){if(this.searchable||this.multiple&&this.value&&this.value.length)return this.isOpen?{width:"100%"}:{width:"0",position:"absolute",padding:"0"}},contentStyle:function(){return this.options.length?{display:"inline-block"}:{display:"block"}},isAbove:function(){return"above"===this.openDirection||"top"===this.openDirection||"below"!==this.openDirection&&"bottom"!==this.openDirection&&"above"===this.preferredOpenDirection},showSearchInput:function(){return this.searchable&&(!this.hasSingleSelectedSlot||!this.visibleSingleValue&&0!==this.visibleSingleValue||this.isOpen)}}}},function(t,e,n){var i=n(1)("unscopables"),r=Array.prototype;void 0==r[i]&&n(8)(r,i,{}),t.exports=function(t){r[i][t]=!0}},function(t,e,n){var i=n(18),r=n(19),o=n(85);t.exports=function(t){return function(e,n,s){var u,a=i(e),l=r(a.length),c=o(s,l);if(t&&n!=n){for(;l>c;)if((u=a[c++])!=u)return!0}else for(;l>c;c++)if((t||c in a)&&a[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var i=n(9),r=n(1)("toStringTag"),o="Arguments"==i(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=s(e=Object(t),r))?n:o?i(e):"Object"==(u=i(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){"use strict";var i=n(2);t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var i=n(0).document;t.exports=i&&i.documentElement},function(t,e,n){t.exports=!n(4)&&!n(7)(function(){return 7!=Object.defineProperty(n(21)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var i=n(9);t.exports=Array.isArray||function(t){return"Array"==i(t)}},function(t,e,n){"use strict";function i(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=r(e),this.reject=r(n)}var r=n(14);t.exports.f=function(t){return new i(t)}},function(t,e,n){var i=n(2),r=n(76),o=n(22),s=n(27)("IE_PROTO"),u=function(){},a=function(){var t,e=n(21)("iframe"),i=o.length;for(e.style.display="none",n(40).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;i--;)delete a.prototype[o[i]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=i(t),n=new u,u.prototype=null,n[s]=t):n=a(),void 0===e?n:r(n,e)}},function(t,e,n){var i=n(79),r=n(25),o=n(18),s=n(29),u=n(12),a=n(41),l=Object.getOwnPropertyDescriptor;e.f=n(4)?l:function(t,e){if(t=o(t),e=s(e,!0),a)try{return l(t,e)}catch(t){}if(u(t,e))return r(!i.f.call(t,e),t[e])}},function(t,e,n){var i=n(12),r=n(18),o=n(37)(!1),s=n(27)("IE_PROTO");t.exports=function(t,e){var n,u=r(t),a=0,l=[];for(n in u)n!=s&&i(u,n)&&l.push(n);for(;e.length>a;)i(u,n=e[a++])&&(~o(l,n)||l.push(n));return l}},function(t,e,n){var i=n(46),r=n(22);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){var i=n(2),r=n(5),o=n(43);t.exports=function(t,e){if(i(t),r(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var i=n(10),r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n(24)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var i=n(2),r=n(14),o=n(1)("species");t.exports=function(t,e){var n,s=i(t).constructor;return void 0===s||void 0==(n=i(s)[o])?e:r(n)}},function(t,e,n){var i=n(3),r=n(16),o=n(7),s=n(84),u="["+s+"]",a="​",l=RegExp("^"+u+u+"*"),c=RegExp(u+u+"*$"),f=function(t,e,n){var r={},u=o(function(){return!!s[t]()||a[t]()!=a}),l=r[t]=u?e(p):s[t];n&&(r[n]=l),i(i.P+i.F*u,"String",r)},p=f.trim=function(t,e){return t=String(r(t)),1&e&&(t=t.replace(l,"")),2&e&&(t=t.replace(c,"")),t};t.exports=f},function(t,e,n){var i,r,o,s=n(11),u=n(68),a=n(40),l=n(21),c=n(0),f=c.process,p=c.setImmediate,h=c.clearImmediate,d=c.MessageChannel,v=c.Dispatch,g=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},b=function(t){m.call(t.data)};p&&h||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){u("function"==typeof t?t:Function(t),e)},i(g),g},h=function(t){delete y[t]},"process"==n(9)(f)?i=function(t){f.nextTick(s(m,t,1))}:v&&v.now?i=function(t){v.now(s(m,t,1))}:d?(r=new d,o=r.port2,r.port1.onmessage=b,i=s(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(i=function(t){c.postMessage(t+"","*")},c.addEventListener("message",b,!1)):i="onreadystatechange"in l("script")?function(t){a.appendChild(l("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(s(m,t,1),0)}),t.exports={set:p,clear:h}},function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},function(t,e,n){"use strict";var i=n(3),r=n(20)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),i(i.P+i.F*o,"Array",{find:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(36)("find")},function(t,e,n){"use strict";var i,r,o,s,u=n(24),a=n(0),l=n(11),c=n(38),f=n(3),p=n(5),h=n(14),d=n(61),v=n(66),g=n(50),y=n(52).set,m=n(75)(),b=n(43),_=n(80),x=n(86),w=n(48),S=a.TypeError,O=a.process,L=O&&O.versions,k=L&&L.v8||"",P=a.Promise,T="process"==c(O),V=function(){},E=r=b.f,A=!!function(){try{var t=P.resolve(1),e=(t.constructor={})[n(1)("species")]=function(t){t(V,V)};return(T||"function"==typeof PromiseRejectionEvent)&&t.then(V)instanceof e&&0!==k.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),C=function(t){var e;return!(!p(t)||"function"!=typeof(e=t.then))&&e},D=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var i=t._v,r=1==t._s,o=0;n.length>o;)!function(e){var n,o,s,u=r?e.ok:e.fail,a=e.resolve,l=e.reject,c=e.domain;try{u?(r||(2==t._h&&$(t),t._h=1),!0===u?n=i:(c&&c.enter(),n=u(i),c&&(c.exit(),s=!0)),n===e.promise?l(S("Promise-chain cycle")):(o=C(n))?o.call(n,a,l):a(n)):l(i)}catch(t){c&&!s&&c.exit(),l(t)}}(n[o++]);t._c=[],t._n=!1,e&&!t._h&&j(t)})}},j=function(t){y.call(a,function(){var e,n,i,r=t._v,o=N(t);if(o&&(e=_(function(){T?O.emit("unhandledRejection",r,t):(n=a.onunhandledrejection)?n({promise:t,reason:r}):(i=a.console)&&i.error&&i.error("Unhandled promise rejection",r)}),t._h=T||N(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},N=function(t){return 1!==t._h&&0===(t._a||t._c).length},$=function(t){y.call(a,function(){var e;T?O.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),D(e,!0))},M=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw S("Promise can't be resolved itself");(e=C(t))?m(function(){var i={_w:n,_d:!1};try{e.call(t,l(M,i,1),l(F,i,1))}catch(t){F.call(i,t)}}):(n._v=t,n._s=1,D(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};A||(P=function(t){d(this,P,"Promise","_h"),h(t),i.call(this);try{t(l(M,this,1),l(F,this,1))}catch(t){F.call(this,t)}},i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},i.prototype=n(81)(P.prototype,{then:function(t,e){var n=E(g(this,P));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=T?O.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&D(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=l(M,t,1),this.reject=l(F,t,1)},b.f=E=function(t){return t===P||t===s?new o(t):r(t)}),f(f.G+f.W+f.F*!A,{Promise:P}),n(26)(P,"Promise"),n(83)("Promise"),s=n(10).Promise,f(f.S+f.F*!A,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!A),"Promise",{resolve:function(t){return w(u&&this===s?P:this,t)}}),f(f.S+f.F*!(A&&n(73)(function(t){P.all(t).catch(V)})),"Promise",{all:function(t){var e=this,n=E(e),i=n.resolve,r=n.reject,o=_(function(){var n=[],o=0,s=1;v(t,!1,function(t){var u=o++,a=!1;n.push(void 0),s++,e.resolve(t).then(function(t){a||(a=!0,n[u]=t,--s||i(n))},r)}),--s||i(n)});return o.e&&r(o.v),n.promise},race:function(t){var e=this,n=E(e),i=n.reject,r=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return r.e&&i(r.v),n.promise}})},function(t,e,n){"use strict";var i=n(3),r=n(10),o=n(0),s=n(50),u=n(48);i(i.P+i.R,"Promise",{finally:function(t){var e=s(this,r.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";function i(t){n(99)}var r=n(35),o=n(101),s=n(100),u=i,a=s(r.a,o.a,!1,u,null,null);e.a=a.exports},function(t,e,n){"use strict";function i(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}e.a=i},function(t,e,n){"use strict";function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t){return(r="function"==typeof Symbol&&"symbol"===i(Symbol.iterator)?function(t){return i(t)}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":i(t)})(t)}e.a=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(34),r=(n.n(i),n(55)),o=(n.n(r),n(56)),s=(n.n(o),n(57)),u=n(32),a=n(33);n.d(e,"Multiselect",function(){return s.a}),n.d(e,"multiselectMixin",function(){return u.a}),n.d(e,"pointerMixin",function(){return a.a}),e.default=s.a},function(t,e){t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var i=n(14),r=n(28),o=n(23),s=n(19);t.exports=function(t,e,n,u,a){i(e);var l=r(t),c=o(l),f=s(l.length),p=a?f-1:0,h=a?-1:1;if(n<2)for(;;){if(p in c){u=c[p],p+=h;break}if(p+=h,a?p<0:f<=p)throw TypeError("Reduce of empty array with no initial value")}for(;a?p>=0:f>p;p+=h)p in c&&(u=e(u,c[p],p,l));return u}},function(t,e,n){var i=n(5),r=n(42),o=n(1)("species");t.exports=function(t){var e;return r(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!r(e.prototype)||(e=void 0),i(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var i=n(63);t.exports=function(t,e){return new(i(t))(e)}},function(t,e,n){"use strict";var i=n(8),r=n(6),o=n(7),s=n(16),u=n(1);t.exports=function(t,e,n){var a=u(t),l=n(s,a,""[t]),c=l[0],f=l[1];o(function(){var e={};return e[a]=function(){return 7},7!=""[t](e)})&&(r(String.prototype,t,c),i(RegExp.prototype,a,2==e?function(t,e){return f.call(t,this,e)}:function(t){return f.call(t,this)}))}},function(t,e,n){var i=n(11),r=n(70),o=n(69),s=n(2),u=n(19),a=n(87),l={},c={},e=t.exports=function(t,e,n,f,p){var h,d,v,g,y=p?function(){return t}:a(t),m=i(n,f,e?2:1),b=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(o(y)){for(h=u(t.length);h>b;b++)if((g=e?m(s(d=t[b])[0],d[1]):m(t[b]))===l||g===c)return g}else for(v=y.call(t);!(d=v.next()).done;)if((g=r(v,m,d.value,e))===l||g===c)return g};e.BREAK=l,e.RETURN=c},function(t,e,n){var i=n(5),r=n(82).set;t.exports=function(t,e,n){var o,s=e.constructor;return s!==n&&"function"==typeof s&&(o=s.prototype)!==n.prototype&&i(o)&&r&&r(t,o),t}},function(t,e){t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var i=n(15),r=n(1)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[r]===t)}},function(t,e,n){var i=n(2);t.exports=function(t,e,n,r){try{return r?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},function(t,e,n){"use strict";var i=n(44),r=n(25),o=n(26),s={};n(8)(s,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(s,{next:r(1,n)}),o(t,e+" Iterator")}},function(t,e,n){"use strict";var i=n(24),r=n(3),o=n(6),s=n(8),u=n(15),a=n(71),l=n(26),c=n(78),f=n(1)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,d,v,g,y){a(n,e,d);var m,b,_,x=function(t){if(!p&&t in L)return L[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",S="values"==v,O=!1,L=t.prototype,k=L[f]||L["@@iterator"]||v&&L[v],P=k||x(v),T=v?S?x("entries"):P:void 0,V="Array"==e?L.entries||k:k;if(V&&(_=c(V.call(new t)))!==Object.prototype&&_.next&&(l(_,w,!0),i||"function"==typeof _[f]||s(_,f,h)),S&&k&&"values"!==k.name&&(O=!0,P=function(){return k.call(this)}),i&&!y||!p&&!O&&L[f]||s(L,f,P),u[e]=P,u[w]=h,v)if(m={values:S?P:x("values"),keys:g?P:x("keys"),entries:T},y)for(b in m)b in L||o(L,b,m[b]);else r(r.P+r.F*(p||O),e,m);return m}},function(t,e,n){var i=n(1)("iterator"),r=!1;try{var o=[7][i]();o.return=function(){r=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!r)return!1;var n=!1;try{var o=[7],s=o[i]();s.next=function(){return{done:n=!0}},o[i]=function(){return s},t(o)}catch(t){}return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var i=n(0),r=n(52).set,o=i.MutationObserver||i.WebKitMutationObserver,s=i.process,u=i.Promise,a="process"==n(9)(s);t.exports=function(){var t,e,n,l=function(){var i,r;for(a&&(i=s.domain)&&i.exit();t;){r=t.fn,t=t.next;try{r()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(a)n=function(){s.nextTick(l)};else if(!o||i.navigator&&i.navigator.standalone)if(u&&u.resolve){var c=u.resolve(void 0);n=function(){c.then(l)}}else n=function(){r.call(i,l)};else{var f=!0,p=document.createTextNode("");new o(l).observe(p,{characterData:!0}),n=function(){p.data=f=!f}}return function(i){var r={fn:i,next:void 0};e&&(e.next=r),t||(t=r,n()),e=r}}},function(t,e,n){var i=n(13),r=n(2),o=n(47);t.exports=n(4)?Object.defineProperties:function(t,e){r(t);for(var n,s=o(e),u=s.length,a=0;u>a;)i.f(t,n=s[a++],e[n]);return t}},function(t,e,n){var i=n(46),r=n(22).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,r)}},function(t,e,n){var i=n(12),r=n(28),o=n(27)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=r(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var i=n(6);t.exports=function(t,e,n){for(var r in e)i(t,r,e[r],n);return t}},function(t,e,n){var i=n(5),r=n(2),o=function(t,e){if(r(t),!i(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,i){try{i=n(11)(Function.call,n(45).f(Object.prototype,"__proto__").set,2),i(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:i(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(4),s=n(1)("species");t.exports=function(t){var e=i[t];o&&e&&!e[s]&&r.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var i=n(53),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){var i=n(0),r=i.navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var i=n(38),r=n(1)("iterator"),o=n(15);t.exports=n(10).getIteratorMethod=function(t){if(void 0!=t)return t[r]||t["@@iterator"]||o[i(t)]}},function(t,e,n){"use strict";var i=n(3),r=n(20)(2);i(i.P+i.F*!n(17)([].filter,!0),"Array",{filter:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(37)(!1),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0;i(i.P+i.F*(s||!n(17)(o)),"Array",{indexOf:function(t){return s?o.apply(this,arguments)||0:r(this,t,arguments[1])}})},function(t,e,n){var i=n(3);i(i.S,"Array",{isArray:n(42)})},function(t,e,n){"use strict";var i=n(3),r=n(20)(1);i(i.P+i.F*!n(17)([].map,!0),"Array",{map:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(62);i(i.P+i.F*!n(17)([].reduce,!0),"Array",{reduce:function(t){return r(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var i=Date.prototype,r=i.toString,o=i.getTime;new Date(NaN)+""!="Invalid Date"&&n(6)(i,"toString",function(){var t=o.call(this);return t===t?r.call(this):"Invalid Date"})},function(t,e,n){n(4)&&"g"!=/./g.flags&&n(13).f(RegExp.prototype,"flags",{configurable:!0,get:n(39)})},function(t,e,n){n(65)("search",1,function(t,e,n){return[function(n){"use strict";var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(94);var i=n(2),r=n(39),o=n(4),s=/./.toString,u=function(t){n(6)(RegExp.prototype,"toString",t,!0)};n(7)(function(){return"/a/b"!=s.call({source:"a",flags:"b"})})?u(function(){var t=i(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?r.call(t):void 0)}):"toString"!=s.name&&u(function(){return s.call(this)})},function(t,e,n){"use strict";n(51)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){for(var i=n(34),r=n(47),o=n(6),s=n(0),u=n(8),a=n(15),l=n(1),c=l("iterator"),f=l("toStringTag"),p=a.Array,h={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},d=r(h),v=0;v<d.length;v++){var g,y=d[v],m=h[y],b=s[y],_=b&&b.prototype;if(_&&(_[c]||u(_,c,p),_[f]||u(_,f,y),a[y]=p,m))for(g in i)_[g]||o(_,g,i[g],!0)}},function(t,e){},function(t,e){t.exports=function(t,e,n,i,r,o){var s,u=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(s=t,u=t.default);var l="function"==typeof u?u.options:u;e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),r&&(l._scopeId=r);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=c):i&&(c=i),c){var f=l.functional,p=f?l.render:l.beforeCreate;f?(l._injectStyles=c,l.render=function(t,e){return c.call(e),p(t,e)}):l.beforeCreate=p?[].concat(p,c):[c]}return{esModule:s,exports:u,options:l}}},function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"multiselect",class:{"multiselect--active":t.isOpen,"multiselect--disabled":t.disabled,"multiselect--above":t.isAbove},attrs:{tabindex:t.searchable?-1:t.tabindex},on:{focus:function(e){t.activate()},blur:function(e){!t.searchable&&t.deactivate()},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerForward()):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerBackward()):null}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")||!t._k(e.keyCode,"tab",9,e.key,"Tab")?(e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()}}},[t._t("caret",[n("div",{staticClass:"multiselect__select",on:{mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}}})],{toggle:t.toggle}),t._v(" "),t._t("clear",null,{search:t.search}),t._v(" "),n("div",{ref:"tags",staticClass:"multiselect__tags"},[t._t("selection",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.visibleValues.length>0,expression:"visibleValues.length > 0"}],staticClass:"multiselect__tags-wrap"},[t._l(t.visibleValues,function(e,i){return[t._t("tag",[n("span",{key:i,staticClass:"multiselect__tag"},[n("span",{domProps:{textContent:t._s(t.getOptionLabel(e))}}),t._v(" "),n("i",{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true",tabindex:"1"},on:{keypress:function(n){if(!("button"in n)&&t._k(n.keyCode,"enter",13,n.key,"Enter"))return null;n.preventDefault(),t.removeElement(e)},mousedown:function(n){n.preventDefault(),t.removeElement(e)}}})])],{option:e,search:t.search,remove:t.removeElement})]})],2),t._v(" "),t.internalValue&&t.internalValue.length>t.limit?[t._t("limit",[n("strong",{staticClass:"multiselect__strong",domProps:{textContent:t._s(t.limitText(t.internalValue.length-t.limit))}})])]:t._e()],{search:t.search,remove:t.removeElement,values:t.visibleValues,isOpen:t.isOpen}),t._v(" "),n("transition",{attrs:{name:"multiselect__loading"}},[t._t("loading",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.loading,expression:"loading"}],staticClass:"multiselect__spinner"})])],2),t._v(" "),t.searchable?n("input",{ref:"search",staticClass:"multiselect__input",style:t.inputStyle,attrs:{name:t.name,id:t.id,type:"text",autocomplete:"nope",placeholder:t.placeholder,disabled:t.disabled,tabindex:t.tabindex},domProps:{value:t.search},on:{input:function(e){t.updateSearch(e.target.value)},focus:function(e){e.preventDefault(),t.activate()},blur:function(e){e.preventDefault(),t.deactivate()},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()},keydown:[function(e){if(!("button"in e)&&t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"]))return null;e.preventDefault(),t.pointerForward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"]))return null;e.preventDefault(),t.pointerBackward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"delete",[8,46],e.key,["Backspace","Delete"]))return null;e.stopPropagation(),t.removeLastElement()}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?(e.preventDefault(),e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null}}}):t._e(),t._v(" "),t.isSingleLabelVisible?n("span",{staticClass:"multiselect__single",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("singleLabel",[[t._v(t._s(t.currentOptionLabel))]],{option:t.singleValue})],2):t._e(),t._v(" "),t.isPlaceholderVisible?n("span",{staticClass:"multiselect__placeholder",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("placeholder",[t._v("\n          "+t._s(t.placeholder)+"\n        ")])],2):t._e()],2),t._v(" "),n("transition",{attrs:{name:"multiselect"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isOpen,expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:{maxHeight:t.optimizedHeight+"px"},attrs:{tabindex:"-1"},on:{focus:t.activate,mousedown:function(t){t.preventDefault()}}},[n("ul",{staticClass:"multiselect__content",style:t.contentStyle},[t._t("beforeList"),t._v(" "),t.multiple&&t.max===t.internalValue.length?n("li",[n("span",{staticClass:"multiselect__option"},[t._t("maxElements",[t._v("Maximum of "+t._s(t.max)+" options selected. First remove a selected option to select another.")])],2)]):t._e(),t._v(" "),!t.max||t.internalValue.length<t.max?t._l(t.filteredOptions,function(e,i){return n("li",{key:i,staticClass:"multiselect__element"},[e&&(e.$isLabel||e.$isDisabled)?t._e():n("span",{staticClass:"multiselect__option",class:t.optionHighlight(i,e),attrs:{"data-select":e&&e.isTag?t.tagPlaceholder:t.selectLabelText,"data-selected":t.selectedLabelText,"data-deselect":t.deselectLabelText},on:{click:function(n){n.stopPropagation(),t.select(e)},mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.pointerSet(i)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2),t._v(" "),e&&(e.$isLabel||e.$isDisabled)?n("span",{staticClass:"multiselect__option",class:t.groupHighlight(i,e),attrs:{"data-select":t.groupSelect&&t.selectGroupLabelText,"data-deselect":t.groupSelect&&t.deselectGroupLabelText},on:{mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.groupSelect&&t.pointerSet(i)},mousedown:function(n){n.preventDefault(),t.selectGroup(e)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2):t._e()])}):t._e(),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoResults&&0===t.filteredOptions.length&&t.search&&!t.loading,expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noResult",[t._v("No elements found. Consider changing the search query.")],{search:t.search})],2)]),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoOptions&&0===t.options.length&&!t.search&&!t.loading,expression:"showNoOptions && (options.length === 0 && !search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noOptions",[t._v("List is empty.")])],2)]),t._v(" "),t._t("afterList")],2)])])],2)},r=[],o={render:i,staticRenderFns:r};e.a=o}])});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
	 * Vue.js v2.5.13
	 * (c) 2014-2017 Evan You
	 * Released under the MIT License.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Vue = factory());
	}(this, (function () { 'use strict';
	
	/*  */
	
	var emptyObject = Object.freeze({});
	
	// these helpers produces better vm code in JS engines due to their
	// explicitness and function inlining
	function isUndef (v) {
	  return v === undefined || v === null
	}
	
	function isDef (v) {
	  return v !== undefined && v !== null
	}
	
	function isTrue (v) {
	  return v === true
	}
	
	function isFalse (v) {
	  return v === false
	}
	
	/**
	 * Check if value is primitive
	 */
	function isPrimitive (value) {
	  return (
	    typeof value === 'string' ||
	    typeof value === 'number' ||
	    // $flow-disable-line
	    typeof value === 'symbol' ||
	    typeof value === 'boolean'
	  )
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 */
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	/**
	 * Get the raw type string of a value e.g. [object Object]
	 */
	var _toString = Object.prototype.toString;
	
	function toRawType (value) {
	  return _toString.call(value).slice(8, -1)
	}
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 */
	function isPlainObject (obj) {
	  return _toString.call(obj) === '[object Object]'
	}
	
	function isRegExp (v) {
	  return _toString.call(v) === '[object RegExp]'
	}
	
	/**
	 * Check if val is a valid array index.
	 */
	function isValidArrayIndex (val) {
	  var n = parseFloat(String(val));
	  return n >= 0 && Math.floor(n) === n && isFinite(val)
	}
	
	/**
	 * Convert a value to a string that is actually rendered.
	 */
	function toString (val) {
	  return val == null
	    ? ''
	    : typeof val === 'object'
	      ? JSON.stringify(val, null, 2)
	      : String(val)
	}
	
	/**
	 * Convert a input value to a number for persistence.
	 * If the conversion fails, return original string.
	 */
	function toNumber (val) {
	  var n = parseFloat(val);
	  return isNaN(n) ? val : n
	}
	
	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 */
	function makeMap (
	  str,
	  expectsLowerCase
	) {
	  var map = Object.create(null);
	  var list = str.split(',');
	  for (var i = 0; i < list.length; i++) {
	    map[list[i]] = true;
	  }
	  return expectsLowerCase
	    ? function (val) { return map[val.toLowerCase()]; }
	    : function (val) { return map[val]; }
	}
	
	/**
	 * Check if a tag is a built-in tag.
	 */
	var isBuiltInTag = makeMap('slot,component', true);
	
	/**
	 * Check if a attribute is a reserved attribute.
	 */
	var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
	
	/**
	 * Remove an item from an array
	 */
	function remove (arr, item) {
	  if (arr.length) {
	    var index = arr.indexOf(item);
	    if (index > -1) {
	      return arr.splice(index, 1)
	    }
	  }
	}
	
	/**
	 * Check whether the object has the property.
	 */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn (obj, key) {
	  return hasOwnProperty.call(obj, key)
	}
	
	/**
	 * Create a cached version of a pure function.
	 */
	function cached (fn) {
	  var cache = Object.create(null);
	  return (function cachedFn (str) {
	    var hit = cache[str];
	    return hit || (cache[str] = fn(str))
	  })
	}
	
	/**
	 * Camelize a hyphen-delimited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = cached(function (str) {
	  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
	});
	
	/**
	 * Capitalize a string.
	 */
	var capitalize = cached(function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	});
	
	/**
	 * Hyphenate a camelCase string.
	 */
	var hyphenateRE = /\B([A-Z])/g;
	var hyphenate = cached(function (str) {
	  return str.replace(hyphenateRE, '-$1').toLowerCase()
	});
	
	/**
	 * Simple bind, faster than native
	 */
	function bind (fn, ctx) {
	  function boundFn (a) {
	    var l = arguments.length;
	    return l
	      ? l > 1
	        ? fn.apply(ctx, arguments)
	        : fn.call(ctx, a)
	      : fn.call(ctx)
	  }
	  // record original fn length
	  boundFn._length = fn.length;
	  return boundFn
	}
	
	/**
	 * Convert an Array-like object to a real Array.
	 */
	function toArray (list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret
	}
	
	/**
	 * Mix properties into target object.
	 */
	function extend (to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to
	}
	
	/**
	 * Merge an Array of Objects into a single Object.
	 */
	function toObject (arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res
	}
	
	/**
	 * Perform no operation.
	 * Stubbing args to make Flow happy without leaving useless transpiled code
	 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
	 */
	function noop (a, b, c) {}
	
	/**
	 * Always return false.
	 */
	var no = function (a, b, c) { return false; };
	
	/**
	 * Return same value
	 */
	var identity = function (_) { return _; };
	
	/**
	 * Generate a static keys string from compiler modules.
	 */
	function genStaticKeys (modules) {
	  return modules.reduce(function (keys, m) {
	    return keys.concat(m.staticKeys || [])
	  }, []).join(',')
	}
	
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 */
	function looseEqual (a, b) {
	  if (a === b) { return true }
	  var isObjectA = isObject(a);
	  var isObjectB = isObject(b);
	  if (isObjectA && isObjectB) {
	    try {
	      var isArrayA = Array.isArray(a);
	      var isArrayB = Array.isArray(b);
	      if (isArrayA && isArrayB) {
	        return a.length === b.length && a.every(function (e, i) {
	          return looseEqual(e, b[i])
	        })
	      } else if (!isArrayA && !isArrayB) {
	        var keysA = Object.keys(a);
	        var keysB = Object.keys(b);
	        return keysA.length === keysB.length && keysA.every(function (key) {
	          return looseEqual(a[key], b[key])
	        })
	      } else {
	        /* istanbul ignore next */
	        return false
	      }
	    } catch (e) {
	      /* istanbul ignore next */
	      return false
	    }
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b)
	  } else {
	    return false
	  }
	}
	
	function looseIndexOf (arr, val) {
	  for (var i = 0; i < arr.length; i++) {
	    if (looseEqual(arr[i], val)) { return i }
	  }
	  return -1
	}
	
	/**
	 * Ensure a function is called only once.
	 */
	function once (fn) {
	  var called = false;
	  return function () {
	    if (!called) {
	      called = true;
	      fn.apply(this, arguments);
	    }
	  }
	}
	
	var SSR_ATTR = 'data-server-rendered';
	
	var ASSET_TYPES = [
	  'component',
	  'directive',
	  'filter'
	];
	
	var LIFECYCLE_HOOKS = [
	  'beforeCreate',
	  'created',
	  'beforeMount',
	  'mounted',
	  'beforeUpdate',
	  'updated',
	  'beforeDestroy',
	  'destroyed',
	  'activated',
	  'deactivated',
	  'errorCaptured'
	];
	
	/*  */
	
	var config = ({
	  /**
	   * Option merge strategies (used in core/util/options)
	   */
	  // $flow-disable-line
	  optionMergeStrategies: Object.create(null),
	
	  /**
	   * Whether to suppress warnings.
	   */
	  silent: false,
	
	  /**
	   * Show production mode tip message on boot?
	   */
	  productionTip: "development" !== 'production',
	
	  /**
	   * Whether to enable devtools
	   */
	  devtools: "development" !== 'production',
	
	  /**
	   * Whether to record perf
	   */
	  performance: false,
	
	  /**
	   * Error handler for watcher errors
	   */
	  errorHandler: null,
	
	  /**
	   * Warn handler for watcher warns
	   */
	  warnHandler: null,
	
	  /**
	   * Ignore certain custom elements
	   */
	  ignoredElements: [],
	
	  /**
	   * Custom user key aliases for v-on
	   */
	  // $flow-disable-line
	  keyCodes: Object.create(null),
	
	  /**
	   * Check if a tag is reserved so that it cannot be registered as a
	   * component. This is platform-dependent and may be overwritten.
	   */
	  isReservedTag: no,
	
	  /**
	   * Check if an attribute is reserved so that it cannot be used as a component
	   * prop. This is platform-dependent and may be overwritten.
	   */
	  isReservedAttr: no,
	
	  /**
	   * Check if a tag is an unknown element.
	   * Platform-dependent.
	   */
	  isUnknownElement: no,
	
	  /**
	   * Get the namespace of an element
	   */
	  getTagNamespace: noop,
	
	  /**
	   * Parse the real tag name for the specific platform.
	   */
	  parsePlatformTagName: identity,
	
	  /**
	   * Check if an attribute must be bound using property, e.g. value
	   * Platform-dependent.
	   */
	  mustUseProp: no,
	
	  /**
	   * Exposed for legacy reasons
	   */
	  _lifecycleHooks: LIFECYCLE_HOOKS
	});
	
	/*  */
	
	/**
	 * Check if a string starts with $ or _
	 */
	function isReserved (str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F
	}
	
	/**
	 * Define a property.
	 */
	function def (obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}
	
	/**
	 * Parse simple path.
	 */
	var bailRE = /[^\w.$]/;
	function parsePath (path) {
	  if (bailRE.test(path)) {
	    return
	  }
	  var segments = path.split('.');
	  return function (obj) {
	    for (var i = 0; i < segments.length; i++) {
	      if (!obj) { return }
	      obj = obj[segments[i]];
	    }
	    return obj
	  }
	}
	
	/*  */
	
	
	// can we use __proto__?
	var hasProto = '__proto__' in {};
	
	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined';
	var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
	var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && /msie|trident/.test(UA);
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isEdge = UA && UA.indexOf('edge/') > 0;
	var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
	var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
	var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
	
	// Firefox has a "watch" function on Object.prototype...
	var nativeWatch = ({}).watch;
	
	var supportsPassive = false;
	if (inBrowser) {
	  try {
	    var opts = {};
	    Object.defineProperty(opts, 'passive', ({
	      get: function get () {
	        /* istanbul ignore next */
	        supportsPassive = true;
	      }
	    })); // https://github.com/facebook/flow/issues/285
	    window.addEventListener('test-passive', null, opts);
	  } catch (e) {}
	}
	
	// this needs to be lazy-evaled because vue may be required before
	// vue-server-renderer can set VUE_ENV
	var _isServer;
	var isServerRendering = function () {
	  if (_isServer === undefined) {
	    /* istanbul ignore if */
	    if (!inBrowser && typeof global !== 'undefined') {
	      // detect presence of vue-server-renderer and avoid
	      // Webpack shimming the process
	      _isServer = global['process'].env.VUE_ENV === 'server';
	    } else {
	      _isServer = false;
	    }
	  }
	  return _isServer
	};
	
	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	/* istanbul ignore next */
	function isNative (Ctor) {
	  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
	}
	
	var hasSymbol =
	  typeof Symbol !== 'undefined' && isNative(Symbol) &&
	  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);
	
	var _Set;
	/* istanbul ignore if */ // $flow-disable-line
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = (function () {
	    function Set () {
	      this.set = Object.create(null);
	    }
	    Set.prototype.has = function has (key) {
	      return this.set[key] === true
	    };
	    Set.prototype.add = function add (key) {
	      this.set[key] = true;
	    };
	    Set.prototype.clear = function clear () {
	      this.set = Object.create(null);
	    };
	
	    return Set;
	  }());
	}
	
	/*  */
	
	var warn = noop;
	var tip = noop;
	var generateComponentTrace = (noop); // work around flow check
	var formatComponentName = (noop);
	
	{
	  var hasConsole = typeof console !== 'undefined';
	  var classifyRE = /(?:^|[-_])(\w)/g;
	  var classify = function (str) { return str
	    .replace(classifyRE, function (c) { return c.toUpperCase(); })
	    .replace(/[-_]/g, ''); };
	
	  warn = function (msg, vm) {
	    var trace = vm ? generateComponentTrace(vm) : '';
	
	    if (config.warnHandler) {
	      config.warnHandler.call(null, msg, vm, trace);
	    } else if (hasConsole && (!config.silent)) {
	      console.error(("[Vue warn]: " + msg + trace));
	    }
	  };
	
	  tip = function (msg, vm) {
	    if (hasConsole && (!config.silent)) {
	      console.warn("[Vue tip]: " + msg + (
	        vm ? generateComponentTrace(vm) : ''
	      ));
	    }
	  };
	
	  formatComponentName = function (vm, includeFile) {
	    if (vm.$root === vm) {
	      return '<Root>'
	    }
	    var options = typeof vm === 'function' && vm.cid != null
	      ? vm.options
	      : vm._isVue
	        ? vm.$options || vm.constructor.options
	        : vm || {};
	    var name = options.name || options._componentTag;
	    var file = options.__file;
	    if (!name && file) {
	      var match = file.match(/([^/\\]+)\.vue$/);
	      name = match && match[1];
	    }
	
	    return (
	      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
	      (file && includeFile !== false ? (" at " + file) : '')
	    )
	  };
	
	  var repeat = function (str, n) {
	    var res = '';
	    while (n) {
	      if (n % 2 === 1) { res += str; }
	      if (n > 1) { str += str; }
	      n >>= 1;
	    }
	    return res
	  };
	
	  generateComponentTrace = function (vm) {
	    if (vm._isVue && vm.$parent) {
	      var tree = [];
	      var currentRecursiveSequence = 0;
	      while (vm) {
	        if (tree.length > 0) {
	          var last = tree[tree.length - 1];
	          if (last.constructor === vm.constructor) {
	            currentRecursiveSequence++;
	            vm = vm.$parent;
	            continue
	          } else if (currentRecursiveSequence > 0) {
	            tree[tree.length - 1] = [last, currentRecursiveSequence];
	            currentRecursiveSequence = 0;
	          }
	        }
	        tree.push(vm);
	        vm = vm.$parent;
	      }
	      return '\n\nfound in\n\n' + tree
	        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
	            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
	            : formatComponentName(vm))); })
	        .join('\n')
	    } else {
	      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
	    }
	  };
	}
	
	/*  */
	
	
	var uid = 0;
	
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 */
	var Dep = function Dep () {
	  this.id = uid++;
	  this.subs = [];
	};
	
	Dep.prototype.addSub = function addSub (sub) {
	  this.subs.push(sub);
	};
	
	Dep.prototype.removeSub = function removeSub (sub) {
	  remove(this.subs, sub);
	};
	
	Dep.prototype.depend = function depend () {
	  if (Dep.target) {
	    Dep.target.addDep(this);
	  }
	};
	
	Dep.prototype.notify = function notify () {
	  // stabilize the subscriber list first
	  var subs = this.subs.slice();
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};
	
	// the current target watcher being evaluated.
	// this is globally unique because there could be only one
	// watcher being evaluated at any time.
	Dep.target = null;
	var targetStack = [];
	
	function pushTarget (_target) {
	  if (Dep.target) { targetStack.push(Dep.target); }
	  Dep.target = _target;
	}
	
	function popTarget () {
	  Dep.target = targetStack.pop();
	}
	
	/*  */
	
	var VNode = function VNode (
	  tag,
	  data,
	  children,
	  text,
	  elm,
	  context,
	  componentOptions,
	  asyncFactory
	) {
	  this.tag = tag;
	  this.data = data;
	  this.children = children;
	  this.text = text;
	  this.elm = elm;
	  this.ns = undefined;
	  this.context = context;
	  this.fnContext = undefined;
	  this.fnOptions = undefined;
	  this.fnScopeId = undefined;
	  this.key = data && data.key;
	  this.componentOptions = componentOptions;
	  this.componentInstance = undefined;
	  this.parent = undefined;
	  this.raw = false;
	  this.isStatic = false;
	  this.isRootInsert = true;
	  this.isComment = false;
	  this.isCloned = false;
	  this.isOnce = false;
	  this.asyncFactory = asyncFactory;
	  this.asyncMeta = undefined;
	  this.isAsyncPlaceholder = false;
	};
	
	var prototypeAccessors = { child: { configurable: true } };
	
	// DEPRECATED: alias for componentInstance for backwards compat.
	/* istanbul ignore next */
	prototypeAccessors.child.get = function () {
	  return this.componentInstance
	};
	
	Object.defineProperties( VNode.prototype, prototypeAccessors );
	
	var createEmptyVNode = function (text) {
	  if ( text === void 0 ) text = '';
	
	  var node = new VNode();
	  node.text = text;
	  node.isComment = true;
	  return node
	};
	
	function createTextVNode (val) {
	  return new VNode(undefined, undefined, undefined, String(val))
	}
	
	// optimized shallow clone
	// used for static nodes and slot nodes because they may be reused across
	// multiple renders, cloning them avoids errors when DOM manipulations rely
	// on their elm reference.
	function cloneVNode (vnode, deep) {
	  var componentOptions = vnode.componentOptions;
	  var cloned = new VNode(
	    vnode.tag,
	    vnode.data,
	    vnode.children,
	    vnode.text,
	    vnode.elm,
	    vnode.context,
	    componentOptions,
	    vnode.asyncFactory
	  );
	  cloned.ns = vnode.ns;
	  cloned.isStatic = vnode.isStatic;
	  cloned.key = vnode.key;
	  cloned.isComment = vnode.isComment;
	  cloned.fnContext = vnode.fnContext;
	  cloned.fnOptions = vnode.fnOptions;
	  cloned.fnScopeId = vnode.fnScopeId;
	  cloned.isCloned = true;
	  if (deep) {
	    if (vnode.children) {
	      cloned.children = cloneVNodes(vnode.children, true);
	    }
	    if (componentOptions && componentOptions.children) {
	      componentOptions.children = cloneVNodes(componentOptions.children, true);
	    }
	  }
	  return cloned
	}
	
	function cloneVNodes (vnodes, deep) {
	  var len = vnodes.length;
	  var res = new Array(len);
	  for (var i = 0; i < len; i++) {
	    res[i] = cloneVNode(vnodes[i], deep);
	  }
	  return res
	}
	
	/*
	 * not type checking this file because flow doesn't play well with
	 * dynamically accessing methods on Array prototype
	 */
	
	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto);[
	  'push',
	  'pop',
	  'shift',
	  'unshift',
	  'splice',
	  'sort',
	  'reverse'
	].forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	      case 'unshift':
	        inserted = args;
	        break
	      case 'splice':
	        inserted = args.slice(2);
	        break
	    }
	    if (inserted) { ob.observeArray(inserted); }
	    // notify change
	    ob.dep.notify();
	    return result
	  });
	});
	
	/*  */
	
	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	
	/**
	 * By default, when a reactive property is set, the new value is
	 * also converted to become reactive. However when passing down props,
	 * we don't want to force conversion because the value may be a nested value
	 * under a frozen data structure. Converting it would defeat the optimization.
	 */
	var observerState = {
	  shouldConvert: true
	};
	
	/**
	 * Observer class that are attached to each observed
	 * object. Once attached, the observer converts target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatches updates.
	 */
	var Observer = function Observer (value) {
	  this.value = value;
	  this.dep = new Dep();
	  this.vmCount = 0;
	  def(value, '__ob__', this);
	  if (Array.isArray(value)) {
	    var augment = hasProto
	      ? protoAugment
	      : copyAugment;
	    augment(value, arrayMethods, arrayKeys);
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	};
	
	/**
	 * Walk through each property and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 */
	Observer.prototype.walk = function walk (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0; i < keys.length; i++) {
	    defineReactive(obj, keys[i], obj[keys[i]]);
	  }
	};
	
	/**
	 * Observe a list of Array items.
	 */
	Observer.prototype.observeArray = function observeArray (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};
	
	// helpers
	
	/**
	 * Augment an target Object or Array by intercepting
	 * the prototype chain using __proto__
	 */
	function protoAugment (target, src, keys) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}
	
	/**
	 * Augment an target Object or Array by defining
	 * hidden properties.
	 */
	/* istanbul ignore next */
	function copyAugment (target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}
	
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 */
	function observe (value, asRootData) {
	  if (!isObject(value) || value instanceof VNode) {
	    return
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (
	    observerState.shouldConvert &&
	    !isServerRendering() &&
	    (Array.isArray(value) || isPlainObject(value)) &&
	    Object.isExtensible(value) &&
	    !value._isVue
	  ) {
	    ob = new Observer(value);
	  }
	  if (asRootData && ob) {
	    ob.vmCount++;
	  }
	  return ob
	}
	
	/**
	 * Define a reactive property on an Object.
	 */
	function defineReactive (
	  obj,
	  key,
	  val,
	  customSetter,
	  shallow
	) {
	  var dep = new Dep();
	
	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return
	  }
	
	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  var setter = property && property.set;
	
	  var childOb = !shallow && observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter () {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	          if (Array.isArray(value)) {
	            dependArray(value);
	          }
	        }
	      }
	      return value
	    },
	    set: function reactiveSetter (newVal) {
	      var value = getter ? getter.call(obj) : val;
	      /* eslint-disable no-self-compare */
	      if (newVal === value || (newVal !== newVal && value !== value)) {
	        return
	      }
	      /* eslint-enable no-self-compare */
	      if ("development" !== 'production' && customSetter) {
	        customSetter();
	      }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = !shallow && observe(newVal);
	      dep.notify();
	    }
	  });
	}
	
	/**
	 * Set a property on an object. Adds the new property and
	 * triggers change notification if the property doesn't
	 * already exist.
	 */
	function set (target, key, val) {
	  if (Array.isArray(target) && isValidArrayIndex(key)) {
	    target.length = Math.max(target.length, key);
	    target.splice(key, 1, val);
	    return val
	  }
	  if (key in target && !(key in Object.prototype)) {
	    target[key] = val;
	    return val
	  }
	  var ob = (target).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
	    "development" !== 'production' && warn(
	      'Avoid adding reactive properties to a Vue instance or its root $data ' +
	      'at runtime - declare it upfront in the data option.'
	    );
	    return val
	  }
	  if (!ob) {
	    target[key] = val;
	    return val
	  }
	  defineReactive(ob.value, key, val);
	  ob.dep.notify();
	  return val
	}
	
	/**
	 * Delete a property and trigger change if necessary.
	 */
	function del (target, key) {
	  if (Array.isArray(target) && isValidArrayIndex(key)) {
	    target.splice(key, 1);
	    return
	  }
	  var ob = (target).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
	    "development" !== 'production' && warn(
	      'Avoid deleting properties on a Vue instance or its root $data ' +
	      '- just set it to null.'
	    );
	    return
	  }
	  if (!hasOwn(target, key)) {
	    return
	  }
	  delete target[key];
	  if (!ob) {
	    return
	  }
	  ob.dep.notify();
	}
	
	/**
	 * Collect dependencies on array elements when the array is touched, since
	 * we cannot intercept array element access like property getters.
	 */
	function dependArray (value) {
	  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
	    e = value[i];
	    e && e.__ob__ && e.__ob__.dep.depend();
	    if (Array.isArray(e)) {
	      dependArray(e);
	    }
	  }
	}
	
	/*  */
	
	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 */
	var strats = config.optionMergeStrategies;
	
	/**
	 * Options with restrictions
	 */
	{
	  strats.el = strats.propsData = function (parent, child, vm, key) {
	    if (!vm) {
	      warn(
	        "option \"" + key + "\" can only be used during instance " +
	        'creation with the `new` keyword.'
	      );
	    }
	    return defaultStrat(parent, child)
	  };
	}
	
	/**
	 * Helper that recursively merges two data objects together.
	 */
	function mergeData (to, from) {
	  if (!from) { return to }
	  var key, toVal, fromVal;
	  var keys = Object.keys(from);
	  for (var i = 0; i < keys.length; i++) {
	    key = keys[i];
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set(to, key, fromVal);
	    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to
	}
	
	/**
	 * Data
	 */
	function mergeDataOrFn (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal
	    }
	    if (!parentVal) {
	      return childVal
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn () {
	      return mergeData(
	        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
	        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
	      )
	    }
	  } else {
	    return function mergedInstanceDataFn () {
	      // instance merge
	      var instanceData = typeof childVal === 'function'
	        ? childVal.call(vm, vm)
	        : childVal;
	      var defaultData = typeof parentVal === 'function'
	        ? parentVal.call(vm, vm)
	        : parentVal;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData)
	      } else {
	        return defaultData
	      }
	    }
	  }
	}
	
	strats.data = function (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    if (childVal && typeof childVal !== 'function') {
	      "development" !== 'production' && warn(
	        'The "data" option should be a function ' +
	        'that returns a per-instance value in component ' +
	        'definitions.',
	        vm
	      );
	
	      return parentVal
	    }
	    return mergeDataOrFn(parentVal, childVal)
	  }
	
	  return mergeDataOrFn(parentVal, childVal, vm)
	};
	
	/**
	 * Hooks and props are merged as arrays.
	 */
	function mergeHook (
	  parentVal,
	  childVal
	) {
	  return childVal
	    ? parentVal
	      ? parentVal.concat(childVal)
	      : Array.isArray(childVal)
	        ? childVal
	        : [childVal]
	    : parentVal
	}
	
	LIFECYCLE_HOOKS.forEach(function (hook) {
	  strats[hook] = mergeHook;
	});
	
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	function mergeAssets (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  var res = Object.create(parentVal || null);
	  if (childVal) {
	    "development" !== 'production' && assertObjectType(key, childVal, vm);
	    return extend(res, childVal)
	  } else {
	    return res
	  }
	}
	
	ASSET_TYPES.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});
	
	/**
	 * Watchers.
	 *
	 * Watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	strats.watch = function (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  // work around Firefox's Object.prototype.watch...
	  if (parentVal === nativeWatch) { parentVal = undefined; }
	  if (childVal === nativeWatch) { childVal = undefined; }
	  /* istanbul ignore if */
	  if (!childVal) { return Object.create(parentVal || null) }
	  {
	    assertObjectType(key, childVal, vm);
	  }
	  if (!parentVal) { return childVal }
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key$1 in childVal) {
	    var parent = ret[key$1];
	    var child = childVal[key$1];
	    if (parent && !Array.isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key$1] = parent
	      ? parent.concat(child)
	      : Array.isArray(child) ? child : [child];
	  }
	  return ret
	};
	
	/**
	 * Other object hashes.
	 */
	strats.props =
	strats.methods =
	strats.inject =
	strats.computed = function (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  if (childVal && "development" !== 'production') {
	    assertObjectType(key, childVal, vm);
	  }
	  if (!parentVal) { return childVal }
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  if (childVal) { extend(ret, childVal); }
	  return ret
	};
	strats.provide = mergeDataOrFn;
	
	/**
	 * Default strategy.
	 */
	var defaultStrat = function (parentVal, childVal) {
	  return childVal === undefined
	    ? parentVal
	    : childVal
	};
	
	/**
	 * Validate component names
	 */
	function checkComponents (options) {
	  for (var key in options.components) {
	    validateComponentName(key);
	  }
	}
	
	function validateComponentName (name) {
	  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
	    warn(
	      'Invalid component name: "' + name + '". Component names ' +
	      'can only contain alphanumeric characters and the hyphen, ' +
	      'and must start with a letter.'
	    );
	  }
	  if (isBuiltInTag(name) || config.isReservedTag(name)) {
	    warn(
	      'Do not use built-in or reserved HTML elements as component ' +
	      'id: ' + name
	    );
	  }
	}
	
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 */
	function normalizeProps (options, vm) {
	  var props = options.props;
	  if (!props) { return }
	  var res = {};
	  var i, val, name;
	  if (Array.isArray(props)) {
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        name = camelize(val);
	        res[name] = { type: null };
	      } else {
	        warn('props must be strings when using array syntax.');
	      }
	    }
	  } else if (isPlainObject(props)) {
	    for (var key in props) {
	      val = props[key];
	      name = camelize(key);
	      res[name] = isPlainObject(val)
	        ? val
	        : { type: val };
	    }
	  } else {
	    warn(
	      "Invalid value for option \"props\": expected an Array or an Object, " +
	      "but got " + (toRawType(props)) + ".",
	      vm
	    );
	  }
	  options.props = res;
	}
	
	/**
	 * Normalize all injections into Object-based format
	 */
	function normalizeInject (options, vm) {
	  var inject = options.inject;
	  if (!inject) { return }
	  var normalized = options.inject = {};
	  if (Array.isArray(inject)) {
	    for (var i = 0; i < inject.length; i++) {
	      normalized[inject[i]] = { from: inject[i] };
	    }
	  } else if (isPlainObject(inject)) {
	    for (var key in inject) {
	      var val = inject[key];
	      normalized[key] = isPlainObject(val)
	        ? extend({ from: key }, val)
	        : { from: val };
	    }
	  } else {
	    warn(
	      "Invalid value for option \"inject\": expected an Array or an Object, " +
	      "but got " + (toRawType(inject)) + ".",
	      vm
	    );
	  }
	}
	
	/**
	 * Normalize raw function directives into object format.
	 */
	function normalizeDirectives (options) {
	  var dirs = options.directives;
	  if (dirs) {
	    for (var key in dirs) {
	      var def = dirs[key];
	      if (typeof def === 'function') {
	        dirs[key] = { bind: def, update: def };
	      }
	    }
	  }
	}
	
	function assertObjectType (name, value, vm) {
	  if (!isPlainObject(value)) {
	    warn(
	      "Invalid value for option \"" + name + "\": expected an Object, " +
	      "but got " + (toRawType(value)) + ".",
	      vm
	    );
	  }
	}
	
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 */
	function mergeOptions (
	  parent,
	  child,
	  vm
	) {
	  {
	    checkComponents(child);
	  }
	
	  if (typeof child === 'function') {
	    child = child.options;
	  }
	
	  normalizeProps(child, vm);
	  normalizeInject(child, vm);
	  normalizeDirectives(child);
	  var extendsFrom = child.extends;
	  if (extendsFrom) {
	    parent = mergeOptions(parent, extendsFrom, vm);
	  }
	  if (child.mixins) {
	    for (var i = 0, l = child.mixins.length; i < l; i++) {
	      parent = mergeOptions(parent, child.mixins[i], vm);
	    }
	  }
	  var options = {};
	  var key;
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField (key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options
	}
	
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 */
	function resolveAsset (
	  options,
	  type,
	  id,
	  warnMissing
	) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return
	  }
	  var assets = options[type];
	  // check local registration variations first
	  if (hasOwn(assets, id)) { return assets[id] }
	  var camelizedId = camelize(id);
	  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
	  var PascalCaseId = capitalize(camelizedId);
	  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
	  // fallback to prototype chain
	  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
	  if ("development" !== 'production' && warnMissing && !res) {
	    warn(
	      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
	      options
	    );
	  }
	  return res
	}
	
	/*  */
	
	function validateProp (
	  key,
	  propOptions,
	  propsData,
	  vm
	) {
	  var prop = propOptions[key];
	  var absent = !hasOwn(propsData, key);
	  var value = propsData[key];
	  // handle boolean props
	  if (isType(Boolean, prop.type)) {
	    if (absent && !hasOwn(prop, 'default')) {
	      value = false;
	    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
	      value = true;
	    }
	  }
	  // check default value
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop, key);
	    // since the default value is a fresh copy,
	    // make sure to observe it.
	    var prevShouldConvert = observerState.shouldConvert;
	    observerState.shouldConvert = true;
	    observe(value);
	    observerState.shouldConvert = prevShouldConvert;
	  }
	  {
	    assertProp(prop, key, value, vm, absent);
	  }
	  return value
	}
	
	/**
	 * Get the default value of a prop.
	 */
	function getPropDefaultValue (vm, prop, key) {
	  // no default, return undefined
	  if (!hasOwn(prop, 'default')) {
	    return undefined
	  }
	  var def = prop.default;
	  // warn against non-factory defaults for Object & Array
	  if ("development" !== 'production' && isObject(def)) {
	    warn(
	      'Invalid default value for prop "' + key + '": ' +
	      'Props with type Object/Array must use a factory function ' +
	      'to return the default value.',
	      vm
	    );
	  }
	  // the raw prop value was also undefined from previous render,
	  // return previous default value to avoid unnecessary watcher trigger
	  if (vm && vm.$options.propsData &&
	    vm.$options.propsData[key] === undefined &&
	    vm._props[key] !== undefined
	  ) {
	    return vm._props[key]
	  }
	  // call factory function for non-Function types
	  // a value is Function if its prototype is function even across different execution context
	  return typeof def === 'function' && getType(prop.type) !== 'Function'
	    ? def.call(vm)
	    : def
	}
	
	/**
	 * Assert whether a prop is valid.
	 */
	function assertProp (
	  prop,
	  name,
	  value,
	  vm,
	  absent
	) {
	  if (prop.required && absent) {
	    warn(
	      'Missing required prop: "' + name + '"',
	      vm
	    );
	    return
	  }
	  if (value == null && !prop.required) {
	    return
	  }
	  var type = prop.type;
	  var valid = !type || type === true;
	  var expectedTypes = [];
	  if (type) {
	    if (!Array.isArray(type)) {
	      type = [type];
	    }
	    for (var i = 0; i < type.length && !valid; i++) {
	      var assertedType = assertType(value, type[i]);
	      expectedTypes.push(assertedType.expectedType || '');
	      valid = assertedType.valid;
	    }
	  }
	  if (!valid) {
	    warn(
	      "Invalid prop: type check failed for prop \"" + name + "\"." +
	      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
	      ", got " + (toRawType(value)) + ".",
	      vm
	    );
	    return
	  }
	  var validator = prop.validator;
	  if (validator) {
	    if (!validator(value)) {
	      warn(
	        'Invalid prop: custom validator check failed for prop "' + name + '".',
	        vm
	      );
	    }
	  }
	}
	
	var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;
	
	function assertType (value, type) {
	  var valid;
	  var expectedType = getType(type);
	  if (simpleCheckRE.test(expectedType)) {
	    var t = typeof value;
	    valid = t === expectedType.toLowerCase();
	    // for primitive wrapper objects
	    if (!valid && t === 'object') {
	      valid = value instanceof type;
	    }
	  } else if (expectedType === 'Object') {
	    valid = isPlainObject(value);
	  } else if (expectedType === 'Array') {
	    valid = Array.isArray(value);
	  } else {
	    valid = value instanceof type;
	  }
	  return {
	    valid: valid,
	    expectedType: expectedType
	  }
	}
	
	/**
	 * Use function string name to check built-in types,
	 * because a simple equality check will fail when running
	 * across different vms / iframes.
	 */
	function getType (fn) {
	  var match = fn && fn.toString().match(/^\s*function (\w+)/);
	  return match ? match[1] : ''
	}
	
	function isType (type, fn) {
	  if (!Array.isArray(fn)) {
	    return getType(fn) === getType(type)
	  }
	  for (var i = 0, len = fn.length; i < len; i++) {
	    if (getType(fn[i]) === getType(type)) {
	      return true
	    }
	  }
	  /* istanbul ignore next */
	  return false
	}
	
	/*  */
	
	function handleError (err, vm, info) {
	  if (vm) {
	    var cur = vm;
	    while ((cur = cur.$parent)) {
	      var hooks = cur.$options.errorCaptured;
	      if (hooks) {
	        for (var i = 0; i < hooks.length; i++) {
	          try {
	            var capture = hooks[i].call(cur, err, vm, info) === false;
	            if (capture) { return }
	          } catch (e) {
	            globalHandleError(e, cur, 'errorCaptured hook');
	          }
	        }
	      }
	    }
	  }
	  globalHandleError(err, vm, info);
	}
	
	function globalHandleError (err, vm, info) {
	  if (config.errorHandler) {
	    try {
	      return config.errorHandler.call(null, err, vm, info)
	    } catch (e) {
	      logError(e, null, 'config.errorHandler');
	    }
	  }
	  logError(err, vm, info);
	}
	
	function logError (err, vm, info) {
	  {
	    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
	  }
	  /* istanbul ignore else */
	  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
	    console.error(err);
	  } else {
	    throw err
	  }
	}
	
	/*  */
	/* globals MessageChannel */
	
	var callbacks = [];
	var pending = false;
	
	function flushCallbacks () {
	  pending = false;
	  var copies = callbacks.slice(0);
	  callbacks.length = 0;
	  for (var i = 0; i < copies.length; i++) {
	    copies[i]();
	  }
	}
	
	// Here we have async deferring wrappers using both micro and macro tasks.
	// In < 2.4 we used micro tasks everywhere, but there are some scenarios where
	// micro tasks have too high a priority and fires in between supposedly
	// sequential events (e.g. #4521, #6690) or even between bubbling of the same
	// event (#6566). However, using macro tasks everywhere also has subtle problems
	// when state is changed right before repaint (e.g. #6813, out-in transitions).
	// Here we use micro task by default, but expose a way to force macro task when
	// needed (e.g. in event handlers attached by v-on).
	var microTimerFunc;
	var macroTimerFunc;
	var useMacroTask = false;
	
	// Determine (macro) Task defer implementation.
	// Technically setImmediate should be the ideal choice, but it's only available
	// in IE. The only polyfill that consistently queues the callback after all DOM
	// events triggered in the same loop is by using MessageChannel.
	/* istanbul ignore if */
	if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
	  macroTimerFunc = function () {
	    setImmediate(flushCallbacks);
	  };
	} else if (typeof MessageChannel !== 'undefined' && (
	  isNative(MessageChannel) ||
	  // PhantomJS
	  MessageChannel.toString() === '[object MessageChannelConstructor]'
	)) {
	  var channel = new MessageChannel();
	  var port = channel.port2;
	  channel.port1.onmessage = flushCallbacks;
	  macroTimerFunc = function () {
	    port.postMessage(1);
	  };
	} else {
	  /* istanbul ignore next */
	  macroTimerFunc = function () {
	    setTimeout(flushCallbacks, 0);
	  };
	}
	
	// Determine MicroTask defer implementation.
	/* istanbul ignore next, $flow-disable-line */
	if (typeof Promise !== 'undefined' && isNative(Promise)) {
	  var p = Promise.resolve();
	  microTimerFunc = function () {
	    p.then(flushCallbacks);
	    // in problematic UIWebViews, Promise.then doesn't completely break, but
	    // it can get stuck in a weird state where callbacks are pushed into the
	    // microtask queue but the queue isn't being flushed, until the browser
	    // needs to do some other work, e.g. handle a timer. Therefore we can
	    // "force" the microtask queue to be flushed by adding an empty timer.
	    if (isIOS) { setTimeout(noop); }
	  };
	} else {
	  // fallback to macro
	  microTimerFunc = macroTimerFunc;
	}
	
	/**
	 * Wrap a function so that if any code inside triggers state change,
	 * the changes are queued using a Task instead of a MicroTask.
	 */
	function withMacroTask (fn) {
	  return fn._withTask || (fn._withTask = function () {
	    useMacroTask = true;
	    var res = fn.apply(null, arguments);
	    useMacroTask = false;
	    return res
	  })
	}
	
	function nextTick (cb, ctx) {
	  var _resolve;
	  callbacks.push(function () {
	    if (cb) {
	      try {
	        cb.call(ctx);
	      } catch (e) {
	        handleError(e, ctx, 'nextTick');
	      }
	    } else if (_resolve) {
	      _resolve(ctx);
	    }
	  });
	  if (!pending) {
	    pending = true;
	    if (useMacroTask) {
	      macroTimerFunc();
	    } else {
	      microTimerFunc();
	    }
	  }
	  // $flow-disable-line
	  if (!cb && typeof Promise !== 'undefined') {
	    return new Promise(function (resolve) {
	      _resolve = resolve;
	    })
	  }
	}
	
	/*  */
	
	var mark;
	var measure;
	
	{
	  var perf = inBrowser && window.performance;
	  /* istanbul ignore if */
	  if (
	    perf &&
	    perf.mark &&
	    perf.measure &&
	    perf.clearMarks &&
	    perf.clearMeasures
	  ) {
	    mark = function (tag) { return perf.mark(tag); };
	    measure = function (name, startTag, endTag) {
	      perf.measure(name, startTag, endTag);
	      perf.clearMarks(startTag);
	      perf.clearMarks(endTag);
	      perf.clearMeasures(name);
	    };
	  }
	}
	
	/* not type checking this file because flow doesn't play well with Proxy */
	
	var initProxy;
	
	{
	  var allowedGlobals = makeMap(
	    'Infinity,undefined,NaN,isFinite,isNaN,' +
	    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
	    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
	    'require' // for Webpack/Browserify
	  );
	
	  var warnNonPresent = function (target, key) {
	    warn(
	      "Property or method \"" + key + "\" is not defined on the instance but " +
	      'referenced during render. Make sure that this property is reactive, ' +
	      'either in the data option, or for class-based components, by ' +
	      'initializing the property. ' +
	      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
	      target
	    );
	  };
	
	  var hasProxy =
	    typeof Proxy !== 'undefined' &&
	    Proxy.toString().match(/native code/);
	
	  if (hasProxy) {
	    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
	    config.keyCodes = new Proxy(config.keyCodes, {
	      set: function set (target, key, value) {
	        if (isBuiltInModifier(key)) {
	          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
	          return false
	        } else {
	          target[key] = value;
	          return true
	        }
	      }
	    });
	  }
	
	  var hasHandler = {
	    has: function has (target, key) {
	      var has = key in target;
	      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
	      if (!has && !isAllowed) {
	        warnNonPresent(target, key);
	      }
	      return has || !isAllowed
	    }
	  };
	
	  var getHandler = {
	    get: function get (target, key) {
	      if (typeof key === 'string' && !(key in target)) {
	        warnNonPresent(target, key);
	      }
	      return target[key]
	    }
	  };
	
	  initProxy = function initProxy (vm) {
	    if (hasProxy) {
	      // determine which proxy handler to use
	      var options = vm.$options;
	      var handlers = options.render && options.render._withStripped
	        ? getHandler
	        : hasHandler;
	      vm._renderProxy = new Proxy(vm, handlers);
	    } else {
	      vm._renderProxy = vm;
	    }
	  };
	}
	
	/*  */
	
	var seenObjects = new _Set();
	
	/**
	 * Recursively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 */
	function traverse (val) {
	  _traverse(val, seenObjects);
	  seenObjects.clear();
	}
	
	function _traverse (val, seen) {
	  var i, keys;
	  var isA = Array.isArray(val);
	  if ((!isA && !isObject(val)) || Object.isFrozen(val)) {
	    return
	  }
	  if (val.__ob__) {
	    var depId = val.__ob__.dep.id;
	    if (seen.has(depId)) {
	      return
	    }
	    seen.add(depId);
	  }
	  if (isA) {
	    i = val.length;
	    while (i--) { _traverse(val[i], seen); }
	  } else {
	    keys = Object.keys(val);
	    i = keys.length;
	    while (i--) { _traverse(val[keys[i]], seen); }
	  }
	}
	
	/*  */
	
	var normalizeEvent = cached(function (name) {
	  var passive = name.charAt(0) === '&';
	  name = passive ? name.slice(1) : name;
	  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
	  name = once$$1 ? name.slice(1) : name;
	  var capture = name.charAt(0) === '!';
	  name = capture ? name.slice(1) : name;
	  return {
	    name: name,
	    once: once$$1,
	    capture: capture,
	    passive: passive
	  }
	});
	
	function createFnInvoker (fns) {
	  function invoker () {
	    var arguments$1 = arguments;
	
	    var fns = invoker.fns;
	    if (Array.isArray(fns)) {
	      var cloned = fns.slice();
	      for (var i = 0; i < cloned.length; i++) {
	        cloned[i].apply(null, arguments$1);
	      }
	    } else {
	      // return handler return value for single handlers
	      return fns.apply(null, arguments)
	    }
	  }
	  invoker.fns = fns;
	  return invoker
	}
	
	function updateListeners (
	  on,
	  oldOn,
	  add,
	  remove$$1,
	  vm
	) {
	  var name, def, cur, old, event;
	  for (name in on) {
	    def = cur = on[name];
	    old = oldOn[name];
	    event = normalizeEvent(name);
	    /* istanbul ignore if */
	    if (isUndef(cur)) {
	      "development" !== 'production' && warn(
	        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
	        vm
	      );
	    } else if (isUndef(old)) {
	      if (isUndef(cur.fns)) {
	        cur = on[name] = createFnInvoker(cur);
	      }
	      add(event.name, cur, event.once, event.capture, event.passive, event.params);
	    } else if (cur !== old) {
	      old.fns = cur;
	      on[name] = old;
	    }
	  }
	  for (name in oldOn) {
	    if (isUndef(on[name])) {
	      event = normalizeEvent(name);
	      remove$$1(event.name, oldOn[name], event.capture);
	    }
	  }
	}
	
	/*  */
	
	function mergeVNodeHook (def, hookKey, hook) {
	  if (def instanceof VNode) {
	    def = def.data.hook || (def.data.hook = {});
	  }
	  var invoker;
	  var oldHook = def[hookKey];
	
	  function wrappedHook () {
	    hook.apply(this, arguments);
	    // important: remove merged hook to ensure it's called only once
	    // and prevent memory leak
	    remove(invoker.fns, wrappedHook);
	  }
	
	  if (isUndef(oldHook)) {
	    // no existing hook
	    invoker = createFnInvoker([wrappedHook]);
	  } else {
	    /* istanbul ignore if */
	    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
	      // already a merged invoker
	      invoker = oldHook;
	      invoker.fns.push(wrappedHook);
	    } else {
	      // existing plain hook
	      invoker = createFnInvoker([oldHook, wrappedHook]);
	    }
	  }
	
	  invoker.merged = true;
	  def[hookKey] = invoker;
	}
	
	/*  */
	
	function extractPropsFromVNodeData (
	  data,
	  Ctor,
	  tag
	) {
	  // we are only extracting raw values here.
	  // validation and default values are handled in the child
	  // component itself.
	  var propOptions = Ctor.options.props;
	  if (isUndef(propOptions)) {
	    return
	  }
	  var res = {};
	  var attrs = data.attrs;
	  var props = data.props;
	  if (isDef(attrs) || isDef(props)) {
	    for (var key in propOptions) {
	      var altKey = hyphenate(key);
	      {
	        var keyInLowerCase = key.toLowerCase();
	        if (
	          key !== keyInLowerCase &&
	          attrs && hasOwn(attrs, keyInLowerCase)
	        ) {
	          tip(
	            "Prop \"" + keyInLowerCase + "\" is passed to component " +
	            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
	            " \"" + key + "\". " +
	            "Note that HTML attributes are case-insensitive and camelCased " +
	            "props need to use their kebab-case equivalents when using in-DOM " +
	            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
	          );
	        }
	      }
	      checkProp(res, props, key, altKey, true) ||
	      checkProp(res, attrs, key, altKey, false);
	    }
	  }
	  return res
	}
	
	function checkProp (
	  res,
	  hash,
	  key,
	  altKey,
	  preserve
	) {
	  if (isDef(hash)) {
	    if (hasOwn(hash, key)) {
	      res[key] = hash[key];
	      if (!preserve) {
	        delete hash[key];
	      }
	      return true
	    } else if (hasOwn(hash, altKey)) {
	      res[key] = hash[altKey];
	      if (!preserve) {
	        delete hash[altKey];
	      }
	      return true
	    }
	  }
	  return false
	}
	
	/*  */
	
	// The template compiler attempts to minimize the need for normalization by
	// statically analyzing the template at compile time.
	//
	// For plain HTML markup, normalization can be completely skipped because the
	// generated render function is guaranteed to return Array<VNode>. There are
	// two cases where extra normalization is needed:
	
	// 1. When the children contains components - because a functional component
	// may return an Array instead of a single root. In this case, just a simple
	// normalization is needed - if any child is an Array, we flatten the whole
	// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
	// because functional components already normalize their own children.
	function simpleNormalizeChildren (children) {
	  for (var i = 0; i < children.length; i++) {
	    if (Array.isArray(children[i])) {
	      return Array.prototype.concat.apply([], children)
	    }
	  }
	  return children
	}
	
	// 2. When the children contains constructs that always generated nested Arrays,
	// e.g. <template>, <slot>, v-for, or when the children is provided by user
	// with hand-written render functions / JSX. In such cases a full normalization
	// is needed to cater to all possible types of children values.
	function normalizeChildren (children) {
	  return isPrimitive(children)
	    ? [createTextVNode(children)]
	    : Array.isArray(children)
	      ? normalizeArrayChildren(children)
	      : undefined
	}
	
	function isTextNode (node) {
	  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
	}
	
	function normalizeArrayChildren (children, nestedIndex) {
	  var res = [];
	  var i, c, lastIndex, last;
	  for (i = 0; i < children.length; i++) {
	    c = children[i];
	    if (isUndef(c) || typeof c === 'boolean') { continue }
	    lastIndex = res.length - 1;
	    last = res[lastIndex];
	    //  nested
	    if (Array.isArray(c)) {
	      if (c.length > 0) {
	        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
	        // merge adjacent text nodes
	        if (isTextNode(c[0]) && isTextNode(last)) {
	          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
	          c.shift();
	        }
	        res.push.apply(res, c);
	      }
	    } else if (isPrimitive(c)) {
	      if (isTextNode(last)) {
	        // merge adjacent text nodes
	        // this is necessary for SSR hydration because text nodes are
	        // essentially merged when rendered to HTML strings
	        res[lastIndex] = createTextVNode(last.text + c);
	      } else if (c !== '') {
	        // convert primitive to vnode
	        res.push(createTextVNode(c));
	      }
	    } else {
	      if (isTextNode(c) && isTextNode(last)) {
	        // merge adjacent text nodes
	        res[lastIndex] = createTextVNode(last.text + c.text);
	      } else {
	        // default key for nested array children (likely generated by v-for)
	        if (isTrue(children._isVList) &&
	          isDef(c.tag) &&
	          isUndef(c.key) &&
	          isDef(nestedIndex)) {
	          c.key = "__vlist" + nestedIndex + "_" + i + "__";
	        }
	        res.push(c);
	      }
	    }
	  }
	  return res
	}
	
	/*  */
	
	function ensureCtor (comp, base) {
	  if (
	    comp.__esModule ||
	    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
	  ) {
	    comp = comp.default;
	  }
	  return isObject(comp)
	    ? base.extend(comp)
	    : comp
	}
	
	function createAsyncPlaceholder (
	  factory,
	  data,
	  context,
	  children,
	  tag
	) {
	  var node = createEmptyVNode();
	  node.asyncFactory = factory;
	  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
	  return node
	}
	
	function resolveAsyncComponent (
	  factory,
	  baseCtor,
	  context
	) {
	  if (isTrue(factory.error) && isDef(factory.errorComp)) {
	    return factory.errorComp
	  }
	
	  if (isDef(factory.resolved)) {
	    return factory.resolved
	  }
	
	  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
	    return factory.loadingComp
	  }
	
	  if (isDef(factory.contexts)) {
	    // already pending
	    factory.contexts.push(context);
	  } else {
	    var contexts = factory.contexts = [context];
	    var sync = true;
	
	    var forceRender = function () {
	      for (var i = 0, l = contexts.length; i < l; i++) {
	        contexts[i].$forceUpdate();
	      }
	    };
	
	    var resolve = once(function (res) {
	      // cache resolved
	      factory.resolved = ensureCtor(res, baseCtor);
	      // invoke callbacks only if this is not a synchronous resolve
	      // (async resolves are shimmed as synchronous during SSR)
	      if (!sync) {
	        forceRender();
	      }
	    });
	
	    var reject = once(function (reason) {
	      "development" !== 'production' && warn(
	        "Failed to resolve async component: " + (String(factory)) +
	        (reason ? ("\nReason: " + reason) : '')
	      );
	      if (isDef(factory.errorComp)) {
	        factory.error = true;
	        forceRender();
	      }
	    });
	
	    var res = factory(resolve, reject);
	
	    if (isObject(res)) {
	      if (typeof res.then === 'function') {
	        // () => Promise
	        if (isUndef(factory.resolved)) {
	          res.then(resolve, reject);
	        }
	      } else if (isDef(res.component) && typeof res.component.then === 'function') {
	        res.component.then(resolve, reject);
	
	        if (isDef(res.error)) {
	          factory.errorComp = ensureCtor(res.error, baseCtor);
	        }
	
	        if (isDef(res.loading)) {
	          factory.loadingComp = ensureCtor(res.loading, baseCtor);
	          if (res.delay === 0) {
	            factory.loading = true;
	          } else {
	            setTimeout(function () {
	              if (isUndef(factory.resolved) && isUndef(factory.error)) {
	                factory.loading = true;
	                forceRender();
	              }
	            }, res.delay || 200);
	          }
	        }
	
	        if (isDef(res.timeout)) {
	          setTimeout(function () {
	            if (isUndef(factory.resolved)) {
	              reject(
	                "timeout (" + (res.timeout) + "ms)"
	              );
	            }
	          }, res.timeout);
	        }
	      }
	    }
	
	    sync = false;
	    // return in case resolved synchronously
	    return factory.loading
	      ? factory.loadingComp
	      : factory.resolved
	  }
	}
	
	/*  */
	
	function isAsyncPlaceholder (node) {
	  return node.isComment && node.asyncFactory
	}
	
	/*  */
	
	function getFirstComponentChild (children) {
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      var c = children[i];
	      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
	        return c
	      }
	    }
	  }
	}
	
	/*  */
	
	/*  */
	
	function initEvents (vm) {
	  vm._events = Object.create(null);
	  vm._hasHookEvent = false;
	  // init parent attached events
	  var listeners = vm.$options._parentListeners;
	  if (listeners) {
	    updateComponentListeners(vm, listeners);
	  }
	}
	
	var target;
	
	function add (event, fn, once) {
	  if (once) {
	    target.$once(event, fn);
	  } else {
	    target.$on(event, fn);
	  }
	}
	
	function remove$1 (event, fn) {
	  target.$off(event, fn);
	}
	
	function updateComponentListeners (
	  vm,
	  listeners,
	  oldListeners
	) {
	  target = vm;
	  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
	  target = undefined;
	}
	
	function eventsMixin (Vue) {
	  var hookRE = /^hook:/;
	  Vue.prototype.$on = function (event, fn) {
	    var this$1 = this;
	
	    var vm = this;
	    if (Array.isArray(event)) {
	      for (var i = 0, l = event.length; i < l; i++) {
	        this$1.$on(event[i], fn);
	      }
	    } else {
	      (vm._events[event] || (vm._events[event] = [])).push(fn);
	      // optimize hook:event cost by using a boolean flag marked at registration
	      // instead of a hash lookup
	      if (hookRE.test(event)) {
	        vm._hasHookEvent = true;
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$once = function (event, fn) {
	    var vm = this;
	    function on () {
	      vm.$off(event, on);
	      fn.apply(vm, arguments);
	    }
	    on.fn = fn;
	    vm.$on(event, on);
	    return vm
	  };
	
	  Vue.prototype.$off = function (event, fn) {
	    var this$1 = this;
	
	    var vm = this;
	    // all
	    if (!arguments.length) {
	      vm._events = Object.create(null);
	      return vm
	    }
	    // array of events
	    if (Array.isArray(event)) {
	      for (var i = 0, l = event.length; i < l; i++) {
	        this$1.$off(event[i], fn);
	      }
	      return vm
	    }
	    // specific event
	    var cbs = vm._events[event];
	    if (!cbs) {
	      return vm
	    }
	    if (!fn) {
	      vm._events[event] = null;
	      return vm
	    }
	    if (fn) {
	      // specific handler
	      var cb;
	      var i$1 = cbs.length;
	      while (i$1--) {
	        cb = cbs[i$1];
	        if (cb === fn || cb.fn === fn) {
	          cbs.splice(i$1, 1);
	          break
	        }
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$emit = function (event) {
	    var vm = this;
	    {
	      var lowerCaseEvent = event.toLowerCase();
	      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
	        tip(
	          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
	          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
	          "Note that HTML attributes are case-insensitive and you cannot use " +
	          "v-on to listen to camelCase events when using in-DOM templates. " +
	          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
	        );
	      }
	    }
	    var cbs = vm._events[event];
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      var args = toArray(arguments, 1);
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        try {
	          cbs[i].apply(vm, args);
	        } catch (e) {
	          handleError(e, vm, ("event handler for \"" + event + "\""));
	        }
	      }
	    }
	    return vm
	  };
	}
	
	/*  */
	
	
	
	/**
	 * Runtime helper for resolving raw children VNodes into a slot object.
	 */
	function resolveSlots (
	  children,
	  context
	) {
	  var slots = {};
	  if (!children) {
	    return slots
	  }
	  for (var i = 0, l = children.length; i < l; i++) {
	    var child = children[i];
	    var data = child.data;
	    // remove slot attribute if the node is resolved as a Vue slot node
	    if (data && data.attrs && data.attrs.slot) {
	      delete data.attrs.slot;
	    }
	    // named slots should only be respected if the vnode was rendered in the
	    // same context.
	    if ((child.context === context || child.fnContext === context) &&
	      data && data.slot != null
	    ) {
	      var name = data.slot;
	      var slot = (slots[name] || (slots[name] = []));
	      if (child.tag === 'template') {
	        slot.push.apply(slot, child.children || []);
	      } else {
	        slot.push(child);
	      }
	    } else {
	      (slots.default || (slots.default = [])).push(child);
	    }
	  }
	  // ignore slots that contains only whitespace
	  for (var name$1 in slots) {
	    if (slots[name$1].every(isWhitespace)) {
	      delete slots[name$1];
	    }
	  }
	  return slots
	}
	
	function isWhitespace (node) {
	  return (node.isComment && !node.asyncFactory) || node.text === ' '
	}
	
	function resolveScopedSlots (
	  fns, // see flow/vnode
	  res
	) {
	  res = res || {};
	  for (var i = 0; i < fns.length; i++) {
	    if (Array.isArray(fns[i])) {
	      resolveScopedSlots(fns[i], res);
	    } else {
	      res[fns[i].key] = fns[i].fn;
	    }
	  }
	  return res
	}
	
	/*  */
	
	var activeInstance = null;
	var isUpdatingChildComponent = false;
	
	function initLifecycle (vm) {
	  var options = vm.$options;
	
	  // locate first non-abstract parent
	  var parent = options.parent;
	  if (parent && !options.abstract) {
	    while (parent.$options.abstract && parent.$parent) {
	      parent = parent.$parent;
	    }
	    parent.$children.push(vm);
	  }
	
	  vm.$parent = parent;
	  vm.$root = parent ? parent.$root : vm;
	
	  vm.$children = [];
	  vm.$refs = {};
	
	  vm._watcher = null;
	  vm._inactive = null;
	  vm._directInactive = false;
	  vm._isMounted = false;
	  vm._isDestroyed = false;
	  vm._isBeingDestroyed = false;
	}
	
	function lifecycleMixin (Vue) {
	  Vue.prototype._update = function (vnode, hydrating) {
	    var vm = this;
	    if (vm._isMounted) {
	      callHook(vm, 'beforeUpdate');
	    }
	    var prevEl = vm.$el;
	    var prevVnode = vm._vnode;
	    var prevActiveInstance = activeInstance;
	    activeInstance = vm;
	    vm._vnode = vnode;
	    // Vue.prototype.__patch__ is injected in entry points
	    // based on the rendering backend used.
	    if (!prevVnode) {
	      // initial render
	      vm.$el = vm.__patch__(
	        vm.$el, vnode, hydrating, false /* removeOnly */,
	        vm.$options._parentElm,
	        vm.$options._refElm
	      );
	      // no need for the ref nodes after initial patch
	      // this prevents keeping a detached DOM tree in memory (#5851)
	      vm.$options._parentElm = vm.$options._refElm = null;
	    } else {
	      // updates
	      vm.$el = vm.__patch__(prevVnode, vnode);
	    }
	    activeInstance = prevActiveInstance;
	    // update __vue__ reference
	    if (prevEl) {
	      prevEl.__vue__ = null;
	    }
	    if (vm.$el) {
	      vm.$el.__vue__ = vm;
	    }
	    // if parent is an HOC, update its $el as well
	    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
	      vm.$parent.$el = vm.$el;
	    }
	    // updated hook is called by the scheduler to ensure that children are
	    // updated in a parent's updated hook.
	  };
	
	  Vue.prototype.$forceUpdate = function () {
	    var vm = this;
	    if (vm._watcher) {
	      vm._watcher.update();
	    }
	  };
	
	  Vue.prototype.$destroy = function () {
	    var vm = this;
	    if (vm._isBeingDestroyed) {
	      return
	    }
	    callHook(vm, 'beforeDestroy');
	    vm._isBeingDestroyed = true;
	    // remove self from parent
	    var parent = vm.$parent;
	    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
	      remove(parent.$children, vm);
	    }
	    // teardown watchers
	    if (vm._watcher) {
	      vm._watcher.teardown();
	    }
	    var i = vm._watchers.length;
	    while (i--) {
	      vm._watchers[i].teardown();
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (vm._data.__ob__) {
	      vm._data.__ob__.vmCount--;
	    }
	    // call the last hook...
	    vm._isDestroyed = true;
	    // invoke destroy hooks on current rendered tree
	    vm.__patch__(vm._vnode, null);
	    // fire destroyed hook
	    callHook(vm, 'destroyed');
	    // turn off all instance listeners.
	    vm.$off();
	    // remove __vue__ reference
	    if (vm.$el) {
	      vm.$el.__vue__ = null;
	    }
	    // release circular reference (#6759)
	    if (vm.$vnode) {
	      vm.$vnode.parent = null;
	    }
	  };
	}
	
	function mountComponent (
	  vm,
	  el,
	  hydrating
	) {
	  vm.$el = el;
	  if (!vm.$options.render) {
	    vm.$options.render = createEmptyVNode;
	    {
	      /* istanbul ignore if */
	      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
	        vm.$options.el || el) {
	        warn(
	          'You are using the runtime-only build of Vue where the template ' +
	          'compiler is not available. Either pre-compile the templates into ' +
	          'render functions, or use the compiler-included build.',
	          vm
	        );
	      } else {
	        warn(
	          'Failed to mount component: template or render function not defined.',
	          vm
	        );
	      }
	    }
	  }
	  callHook(vm, 'beforeMount');
	
	  var updateComponent;
	  /* istanbul ignore if */
	  if ("development" !== 'production' && config.performance && mark) {
	    updateComponent = function () {
	      var name = vm._name;
	      var id = vm._uid;
	      var startTag = "vue-perf-start:" + id;
	      var endTag = "vue-perf-end:" + id;
	
	      mark(startTag);
	      var vnode = vm._render();
	      mark(endTag);
	      measure(("vue " + name + " render"), startTag, endTag);
	
	      mark(startTag);
	      vm._update(vnode, hydrating);
	      mark(endTag);
	      measure(("vue " + name + " patch"), startTag, endTag);
	    };
	  } else {
	    updateComponent = function () {
	      vm._update(vm._render(), hydrating);
	    };
	  }
	
	  // we set this to vm._watcher inside the watcher's constructor
	  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
	  // component's mounted hook), which relies on vm._watcher being already defined
	  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
	  hydrating = false;
	
	  // manually mounted instance, call mounted on self
	  // mounted is called for render-created child components in its inserted hook
	  if (vm.$vnode == null) {
	    vm._isMounted = true;
	    callHook(vm, 'mounted');
	  }
	  return vm
	}
	
	function updateChildComponent (
	  vm,
	  propsData,
	  listeners,
	  parentVnode,
	  renderChildren
	) {
	  {
	    isUpdatingChildComponent = true;
	  }
	
	  // determine whether component has slot children
	  // we need to do this before overwriting $options._renderChildren
	  var hasChildren = !!(
	    renderChildren ||               // has new static slots
	    vm.$options._renderChildren ||  // has old static slots
	    parentVnode.data.scopedSlots || // has new scoped slots
	    vm.$scopedSlots !== emptyObject // has old scoped slots
	  );
	
	  vm.$options._parentVnode = parentVnode;
	  vm.$vnode = parentVnode; // update vm's placeholder node without re-render
	
	  if (vm._vnode) { // update child tree's parent
	    vm._vnode.parent = parentVnode;
	  }
	  vm.$options._renderChildren = renderChildren;
	
	  // update $attrs and $listeners hash
	  // these are also reactive so they may trigger child update if the child
	  // used them during render
	  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
	  vm.$listeners = listeners || emptyObject;
	
	  // update props
	  if (propsData && vm.$options.props) {
	    observerState.shouldConvert = false;
	    var props = vm._props;
	    var propKeys = vm.$options._propKeys || [];
	    for (var i = 0; i < propKeys.length; i++) {
	      var key = propKeys[i];
	      props[key] = validateProp(key, vm.$options.props, propsData, vm);
	    }
	    observerState.shouldConvert = true;
	    // keep a copy of raw propsData
	    vm.$options.propsData = propsData;
	  }
	
	  // update listeners
	  if (listeners) {
	    var oldListeners = vm.$options._parentListeners;
	    vm.$options._parentListeners = listeners;
	    updateComponentListeners(vm, listeners, oldListeners);
	  }
	  // resolve slots + force update if has children
	  if (hasChildren) {
	    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
	    vm.$forceUpdate();
	  }
	
	  {
	    isUpdatingChildComponent = false;
	  }
	}
	
	function isInInactiveTree (vm) {
	  while (vm && (vm = vm.$parent)) {
	    if (vm._inactive) { return true }
	  }
	  return false
	}
	
	function activateChildComponent (vm, direct) {
	  if (direct) {
	    vm._directInactive = false;
	    if (isInInactiveTree(vm)) {
	      return
	    }
	  } else if (vm._directInactive) {
	    return
	  }
	  if (vm._inactive || vm._inactive === null) {
	    vm._inactive = false;
	    for (var i = 0; i < vm.$children.length; i++) {
	      activateChildComponent(vm.$children[i]);
	    }
	    callHook(vm, 'activated');
	  }
	}
	
	function deactivateChildComponent (vm, direct) {
	  if (direct) {
	    vm._directInactive = true;
	    if (isInInactiveTree(vm)) {
	      return
	    }
	  }
	  if (!vm._inactive) {
	    vm._inactive = true;
	    for (var i = 0; i < vm.$children.length; i++) {
	      deactivateChildComponent(vm.$children[i]);
	    }
	    callHook(vm, 'deactivated');
	  }
	}
	
	function callHook (vm, hook) {
	  var handlers = vm.$options[hook];
	  if (handlers) {
	    for (var i = 0, j = handlers.length; i < j; i++) {
	      try {
	        handlers[i].call(vm);
	      } catch (e) {
	        handleError(e, vm, (hook + " hook"));
	      }
	    }
	  }
	  if (vm._hasHookEvent) {
	    vm.$emit('hook:' + hook);
	  }
	}
	
	/*  */
	
	
	var MAX_UPDATE_COUNT = 100;
	
	var queue = [];
	var activatedChildren = [];
	var has = {};
	var circular = {};
	var waiting = false;
	var flushing = false;
	var index = 0;
	
	/**
	 * Reset the scheduler's state.
	 */
	function resetSchedulerState () {
	  index = queue.length = activatedChildren.length = 0;
	  has = {};
	  {
	    circular = {};
	  }
	  waiting = flushing = false;
	}
	
	/**
	 * Flush both queues and run the watchers.
	 */
	function flushSchedulerQueue () {
	  flushing = true;
	  var watcher, id;
	
	  // Sort queue before flush.
	  // This ensures that:
	  // 1. Components are updated from parent to child. (because parent is always
	  //    created before the child)
	  // 2. A component's user watchers are run before its render watcher (because
	  //    user watchers are created before the render watcher)
	  // 3. If a component is destroyed during a parent component's watcher run,
	  //    its watchers can be skipped.
	  queue.sort(function (a, b) { return a.id - b.id; });
	
	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (index = 0; index < queue.length; index++) {
	    watcher = queue[index];
	    id = watcher.id;
	    has[id] = null;
	    watcher.run();
	    // in dev build, check and stop circular updates.
	    if ("development" !== 'production' && has[id] != null) {
	      circular[id] = (circular[id] || 0) + 1;
	      if (circular[id] > MAX_UPDATE_COUNT) {
	        warn(
	          'You may have an infinite update loop ' + (
	            watcher.user
	              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
	              : "in a component render function."
	          ),
	          watcher.vm
	        );
	        break
	      }
	    }
	  }
	
	  // keep copies of post queues before resetting state
	  var activatedQueue = activatedChildren.slice();
	  var updatedQueue = queue.slice();
	
	  resetSchedulerState();
	
	  // call component updated and activated hooks
	  callActivatedHooks(activatedQueue);
	  callUpdatedHooks(updatedQueue);
	
	  // devtool hook
	  /* istanbul ignore if */
	  if (devtools && config.devtools) {
	    devtools.emit('flush');
	  }
	}
	
	function callUpdatedHooks (queue) {
	  var i = queue.length;
	  while (i--) {
	    var watcher = queue[i];
	    var vm = watcher.vm;
	    if (vm._watcher === watcher && vm._isMounted) {
	      callHook(vm, 'updated');
	    }
	  }
	}
	
	/**
	 * Queue a kept-alive component that was activated during patch.
	 * The queue will be processed after the entire tree has been patched.
	 */
	function queueActivatedComponent (vm) {
	  // setting _inactive to false here so that a render function can
	  // rely on checking whether it's in an inactive tree (e.g. router-view)
	  vm._inactive = false;
	  activatedChildren.push(vm);
	}
	
	function callActivatedHooks (queue) {
	  for (var i = 0; i < queue.length; i++) {
	    queue[i]._inactive = true;
	    activateChildComponent(queue[i], true /* true */);
	  }
	}
	
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 */
	function queueWatcher (watcher) {
	  var id = watcher.id;
	  if (has[id] == null) {
	    has[id] = true;
	    if (!flushing) {
	      queue.push(watcher);
	    } else {
	      // if already flushing, splice the watcher based on its id
	      // if already past its id, it will be run next immediately.
	      var i = queue.length - 1;
	      while (i > index && queue[i].id > watcher.id) {
	        i--;
	      }
	      queue.splice(i + 1, 0, watcher);
	    }
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushSchedulerQueue);
	    }
	  }
	}
	
	/*  */
	
	var uid$2 = 0;
	
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 */
	var Watcher = function Watcher (
	  vm,
	  expOrFn,
	  cb,
	  options,
	  isRenderWatcher
	) {
	  this.vm = vm;
	  if (isRenderWatcher) {
	    vm._watcher = this;
	  }
	  vm._watchers.push(this);
	  // options
	  if (options) {
	    this.deep = !!options.deep;
	    this.user = !!options.user;
	    this.lazy = !!options.lazy;
	    this.sync = !!options.sync;
	  } else {
	    this.deep = this.user = this.lazy = this.sync = false;
	  }
	  this.cb = cb;
	  this.id = ++uid$2; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.expression = expOrFn.toString();
	  // parse expression for getter
	  if (typeof expOrFn === 'function') {
	    this.getter = expOrFn;
	  } else {
	    this.getter = parsePath(expOrFn);
	    if (!this.getter) {
	      this.getter = function () {};
	      "development" !== 'production' && warn(
	        "Failed watching path: \"" + expOrFn + "\" " +
	        'Watcher only accepts simple dot-delimited paths. ' +
	        'For full control, use a function instead.',
	        vm
	      );
	    }
	  }
	  this.value = this.lazy
	    ? undefined
	    : this.get();
	};
	
	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	Watcher.prototype.get = function get () {
	  pushTarget(this);
	  var value;
	  var vm = this.vm;
	  try {
	    value = this.getter.call(vm, vm);
	  } catch (e) {
	    if (this.user) {
	      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
	    } else {
	      throw e
	    }
	  } finally {
	    // "touch" every property so they are all tracked as
	    // dependencies for deep watching
	    if (this.deep) {
	      traverse(value);
	    }
	    popTarget();
	    this.cleanupDeps();
	  }
	  return value
	};
	
	/**
	 * Add a dependency to this directive.
	 */
	Watcher.prototype.addDep = function addDep (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};
	
	/**
	 * Clean up for dependency collection.
	 */
	Watcher.prototype.cleanupDeps = function cleanupDeps () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    var dep = this$1.deps[i];
	    if (!this$1.newDepIds.has(dep.id)) {
	      dep.removeSub(this$1);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};
	
	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 */
	Watcher.prototype.update = function update () {
	  /* istanbul ignore else */
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync) {
	    this.run();
	  } else {
	    queueWatcher(this);
	  }
	};
	
	/**
	 * Scheduler job interface.
	 * Will be called by the scheduler.
	 */
	Watcher.prototype.run = function run () {
	  if (this.active) {
	    var value = this.get();
	    if (
	      value !== this.value ||
	      // Deep watchers and watchers on Object/Arrays should fire even
	      // when the value is the same, because the value may
	      // have mutated.
	      isObject(value) ||
	      this.deep
	    ) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      if (this.user) {
	        try {
	          this.cb.call(this.vm, value, oldValue);
	        } catch (e) {
	          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
	        }
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	  }
	};
	
	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	Watcher.prototype.evaluate = function evaluate () {
	  this.value = this.get();
	  this.dirty = false;
	};
	
	/**
	 * Depend on all deps collected by this watcher.
	 */
	Watcher.prototype.depend = function depend () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    this$1.deps[i].depend();
	  }
	};
	
	/**
	 * Remove self from all dependencies' subscriber list.
	 */
	Watcher.prototype.teardown = function teardown () {
	    var this$1 = this;
	
	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed.
	    if (!this.vm._isBeingDestroyed) {
	      remove(this.vm._watchers, this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this$1.deps[i].removeSub(this$1);
	    }
	    this.active = false;
	  }
	};
	
	/*  */
	
	var sharedPropertyDefinition = {
	  enumerable: true,
	  configurable: true,
	  get: noop,
	  set: noop
	};
	
	function proxy (target, sourceKey, key) {
	  sharedPropertyDefinition.get = function proxyGetter () {
	    return this[sourceKey][key]
	  };
	  sharedPropertyDefinition.set = function proxySetter (val) {
	    this[sourceKey][key] = val;
	  };
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}
	
	function initState (vm) {
	  vm._watchers = [];
	  var opts = vm.$options;
	  if (opts.props) { initProps(vm, opts.props); }
	  if (opts.methods) { initMethods(vm, opts.methods); }
	  if (opts.data) {
	    initData(vm);
	  } else {
	    observe(vm._data = {}, true /* asRootData */);
	  }
	  if (opts.computed) { initComputed(vm, opts.computed); }
	  if (opts.watch && opts.watch !== nativeWatch) {
	    initWatch(vm, opts.watch);
	  }
	}
	
	function initProps (vm, propsOptions) {
	  var propsData = vm.$options.propsData || {};
	  var props = vm._props = {};
	  // cache prop keys so that future props updates can iterate using Array
	  // instead of dynamic object key enumeration.
	  var keys = vm.$options._propKeys = [];
	  var isRoot = !vm.$parent;
	  // root instance props should be converted
	  observerState.shouldConvert = isRoot;
	  var loop = function ( key ) {
	    keys.push(key);
	    var value = validateProp(key, propsOptions, propsData, vm);
	    /* istanbul ignore else */
	    {
	      var hyphenatedKey = hyphenate(key);
	      if (isReservedAttribute(hyphenatedKey) ||
	          config.isReservedAttr(hyphenatedKey)) {
	        warn(
	          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
	          vm
	        );
	      }
	      defineReactive(props, key, value, function () {
	        if (vm.$parent && !isUpdatingChildComponent) {
	          warn(
	            "Avoid mutating a prop directly since the value will be " +
	            "overwritten whenever the parent component re-renders. " +
	            "Instead, use a data or computed property based on the prop's " +
	            "value. Prop being mutated: \"" + key + "\"",
	            vm
	          );
	        }
	      });
	    }
	    // static props are already proxied on the component's prototype
	    // during Vue.extend(). We only need to proxy props defined at
	    // instantiation here.
	    if (!(key in vm)) {
	      proxy(vm, "_props", key);
	    }
	  };
	
	  for (var key in propsOptions) loop( key );
	  observerState.shouldConvert = true;
	}
	
	function initData (vm) {
	  var data = vm.$options.data;
	  data = vm._data = typeof data === 'function'
	    ? getData(data, vm)
	    : data || {};
	  if (!isPlainObject(data)) {
	    data = {};
	    "development" !== 'production' && warn(
	      'data functions should return an object:\n' +
	      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
	      vm
	    );
	  }
	  // proxy data on instance
	  var keys = Object.keys(data);
	  var props = vm.$options.props;
	  var methods = vm.$options.methods;
	  var i = keys.length;
	  while (i--) {
	    var key = keys[i];
	    {
	      if (methods && hasOwn(methods, key)) {
	        warn(
	          ("Method \"" + key + "\" has already been defined as a data property."),
	          vm
	        );
	      }
	    }
	    if (props && hasOwn(props, key)) {
	      "development" !== 'production' && warn(
	        "The data property \"" + key + "\" is already declared as a prop. " +
	        "Use prop default value instead.",
	        vm
	      );
	    } else if (!isReserved(key)) {
	      proxy(vm, "_data", key);
	    }
	  }
	  // observe data
	  observe(data, true /* asRootData */);
	}
	
	function getData (data, vm) {
	  try {
	    return data.call(vm, vm)
	  } catch (e) {
	    handleError(e, vm, "data()");
	    return {}
	  }
	}
	
	var computedWatcherOptions = { lazy: true };
	
	function initComputed (vm, computed) {
	  // $flow-disable-line
	  var watchers = vm._computedWatchers = Object.create(null);
	  // computed properties are just getters during SSR
	  var isSSR = isServerRendering();
	
	  for (var key in computed) {
	    var userDef = computed[key];
	    var getter = typeof userDef === 'function' ? userDef : userDef.get;
	    if ("development" !== 'production' && getter == null) {
	      warn(
	        ("Getter is missing for computed property \"" + key + "\"."),
	        vm
	      );
	    }
	
	    if (!isSSR) {
	      // create internal watcher for the computed property.
	      watchers[key] = new Watcher(
	        vm,
	        getter || noop,
	        noop,
	        computedWatcherOptions
	      );
	    }
	
	    // component-defined computed properties are already defined on the
	    // component prototype. We only need to define computed properties defined
	    // at instantiation here.
	    if (!(key in vm)) {
	      defineComputed(vm, key, userDef);
	    } else {
	      if (key in vm.$data) {
	        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
	      } else if (vm.$options.props && key in vm.$options.props) {
	        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
	      }
	    }
	  }
	}
	
	function defineComputed (
	  target,
	  key,
	  userDef
	) {
	  var shouldCache = !isServerRendering();
	  if (typeof userDef === 'function') {
	    sharedPropertyDefinition.get = shouldCache
	      ? createComputedGetter(key)
	      : userDef;
	    sharedPropertyDefinition.set = noop;
	  } else {
	    sharedPropertyDefinition.get = userDef.get
	      ? shouldCache && userDef.cache !== false
	        ? createComputedGetter(key)
	        : userDef.get
	      : noop;
	    sharedPropertyDefinition.set = userDef.set
	      ? userDef.set
	      : noop;
	  }
	  if ("development" !== 'production' &&
	      sharedPropertyDefinition.set === noop) {
	    sharedPropertyDefinition.set = function () {
	      warn(
	        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
	        this
	      );
	    };
	  }
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}
	
	function createComputedGetter (key) {
	  return function computedGetter () {
	    var watcher = this._computedWatchers && this._computedWatchers[key];
	    if (watcher) {
	      if (watcher.dirty) {
	        watcher.evaluate();
	      }
	      if (Dep.target) {
	        watcher.depend();
	      }
	      return watcher.value
	    }
	  }
	}
	
	function initMethods (vm, methods) {
	  var props = vm.$options.props;
	  for (var key in methods) {
	    {
	      if (methods[key] == null) {
	        warn(
	          "Method \"" + key + "\" has an undefined value in the component definition. " +
	          "Did you reference the function correctly?",
	          vm
	        );
	      }
	      if (props && hasOwn(props, key)) {
	        warn(
	          ("Method \"" + key + "\" has already been defined as a prop."),
	          vm
	        );
	      }
	      if ((key in vm) && isReserved(key)) {
	        warn(
	          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
	          "Avoid defining component methods that start with _ or $."
	        );
	      }
	    }
	    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
	  }
	}
	
	function initWatch (vm, watch) {
	  for (var key in watch) {
	    var handler = watch[key];
	    if (Array.isArray(handler)) {
	      for (var i = 0; i < handler.length; i++) {
	        createWatcher(vm, key, handler[i]);
	      }
	    } else {
	      createWatcher(vm, key, handler);
	    }
	  }
	}
	
	function createWatcher (
	  vm,
	  keyOrFn,
	  handler,
	  options
	) {
	  if (isPlainObject(handler)) {
	    options = handler;
	    handler = handler.handler;
	  }
	  if (typeof handler === 'string') {
	    handler = vm[handler];
	  }
	  return vm.$watch(keyOrFn, handler, options)
	}
	
	function stateMixin (Vue) {
	  // flow somehow has problems with directly declared definition object
	  // when using Object.defineProperty, so we have to procedurally build up
	  // the object here.
	  var dataDef = {};
	  dataDef.get = function () { return this._data };
	  var propsDef = {};
	  propsDef.get = function () { return this._props };
	  {
	    dataDef.set = function (newData) {
	      warn(
	        'Avoid replacing instance root $data. ' +
	        'Use nested data properties instead.',
	        this
	      );
	    };
	    propsDef.set = function () {
	      warn("$props is readonly.", this);
	    };
	  }
	  Object.defineProperty(Vue.prototype, '$data', dataDef);
	  Object.defineProperty(Vue.prototype, '$props', propsDef);
	
	  Vue.prototype.$set = set;
	  Vue.prototype.$delete = del;
	
	  Vue.prototype.$watch = function (
	    expOrFn,
	    cb,
	    options
	  ) {
	    var vm = this;
	    if (isPlainObject(cb)) {
	      return createWatcher(vm, expOrFn, cb, options)
	    }
	    options = options || {};
	    options.user = true;
	    var watcher = new Watcher(vm, expOrFn, cb, options);
	    if (options.immediate) {
	      cb.call(vm, watcher.value);
	    }
	    return function unwatchFn () {
	      watcher.teardown();
	    }
	  };
	}
	
	/*  */
	
	function initProvide (vm) {
	  var provide = vm.$options.provide;
	  if (provide) {
	    vm._provided = typeof provide === 'function'
	      ? provide.call(vm)
	      : provide;
	  }
	}
	
	function initInjections (vm) {
	  var result = resolveInject(vm.$options.inject, vm);
	  if (result) {
	    observerState.shouldConvert = false;
	    Object.keys(result).forEach(function (key) {
	      /* istanbul ignore else */
	      {
	        defineReactive(vm, key, result[key], function () {
	          warn(
	            "Avoid mutating an injected value directly since the changes will be " +
	            "overwritten whenever the provided component re-renders. " +
	            "injection being mutated: \"" + key + "\"",
	            vm
	          );
	        });
	      }
	    });
	    observerState.shouldConvert = true;
	  }
	}
	
	function resolveInject (inject, vm) {
	  if (inject) {
	    // inject is :any because flow is not smart enough to figure out cached
	    var result = Object.create(null);
	    var keys = hasSymbol
	      ? Reflect.ownKeys(inject).filter(function (key) {
	        /* istanbul ignore next */
	        return Object.getOwnPropertyDescriptor(inject, key).enumerable
	      })
	      : Object.keys(inject);
	
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      var provideKey = inject[key].from;
	      var source = vm;
	      while (source) {
	        if (source._provided && provideKey in source._provided) {
	          result[key] = source._provided[provideKey];
	          break
	        }
	        source = source.$parent;
	      }
	      if (!source) {
	        if ('default' in inject[key]) {
	          var provideDefault = inject[key].default;
	          result[key] = typeof provideDefault === 'function'
	            ? provideDefault.call(vm)
	            : provideDefault;
	        } else {
	          warn(("Injection \"" + key + "\" not found"), vm);
	        }
	      }
	    }
	    return result
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering v-for lists.
	 */
	function renderList (
	  val,
	  render
	) {
	  var ret, i, l, keys, key;
	  if (Array.isArray(val) || typeof val === 'string') {
	    ret = new Array(val.length);
	    for (i = 0, l = val.length; i < l; i++) {
	      ret[i] = render(val[i], i);
	    }
	  } else if (typeof val === 'number') {
	    ret = new Array(val);
	    for (i = 0; i < val; i++) {
	      ret[i] = render(i + 1, i);
	    }
	  } else if (isObject(val)) {
	    keys = Object.keys(val);
	    ret = new Array(keys.length);
	    for (i = 0, l = keys.length; i < l; i++) {
	      key = keys[i];
	      ret[i] = render(val[key], key, i);
	    }
	  }
	  if (isDef(ret)) {
	    (ret)._isVList = true;
	  }
	  return ret
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering <slot>
	 */
	function renderSlot (
	  name,
	  fallback,
	  props,
	  bindObject
	) {
	  var scopedSlotFn = this.$scopedSlots[name];
	  var nodes;
	  if (scopedSlotFn) { // scoped slot
	    props = props || {};
	    if (bindObject) {
	      if ("development" !== 'production' && !isObject(bindObject)) {
	        warn(
	          'slot v-bind without argument expects an Object',
	          this
	        );
	      }
	      props = extend(extend({}, bindObject), props);
	    }
	    nodes = scopedSlotFn(props) || fallback;
	  } else {
	    var slotNodes = this.$slots[name];
	    // warn duplicate slot usage
	    if (slotNodes) {
	      if ("development" !== 'production' && slotNodes._rendered) {
	        warn(
	          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
	          "- this will likely cause render errors.",
	          this
	        );
	      }
	      slotNodes._rendered = true;
	    }
	    nodes = slotNodes || fallback;
	  }
	
	  var target = props && props.slot;
	  if (target) {
	    return this.$createElement('template', { slot: target }, nodes)
	  } else {
	    return nodes
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for resolving filters
	 */
	function resolveFilter (id) {
	  return resolveAsset(this.$options, 'filters', id, true) || identity
	}
	
	/*  */
	
	/**
	 * Runtime helper for checking keyCodes from config.
	 * exposed as Vue.prototype._k
	 * passing in eventKeyName as last argument separately for backwards compat
	 */
	function checkKeyCodes (
	  eventKeyCode,
	  key,
	  builtInAlias,
	  eventKeyName
	) {
	  var keyCodes = config.keyCodes[key] || builtInAlias;
	  if (keyCodes) {
	    if (Array.isArray(keyCodes)) {
	      return keyCodes.indexOf(eventKeyCode) === -1
	    } else {
	      return keyCodes !== eventKeyCode
	    }
	  } else if (eventKeyName) {
	    return hyphenate(eventKeyName) !== key
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for merging v-bind="object" into a VNode's data.
	 */
	function bindObjectProps (
	  data,
	  tag,
	  value,
	  asProp,
	  isSync
	) {
	  if (value) {
	    if (!isObject(value)) {
	      "development" !== 'production' && warn(
	        'v-bind without argument expects an Object or Array value',
	        this
	      );
	    } else {
	      if (Array.isArray(value)) {
	        value = toObject(value);
	      }
	      var hash;
	      var loop = function ( key ) {
	        if (
	          key === 'class' ||
	          key === 'style' ||
	          isReservedAttribute(key)
	        ) {
	          hash = data;
	        } else {
	          var type = data.attrs && data.attrs.type;
	          hash = asProp || config.mustUseProp(tag, type, key)
	            ? data.domProps || (data.domProps = {})
	            : data.attrs || (data.attrs = {});
	        }
	        if (!(key in hash)) {
	          hash[key] = value[key];
	
	          if (isSync) {
	            var on = data.on || (data.on = {});
	            on[("update:" + key)] = function ($event) {
	              value[key] = $event;
	            };
	          }
	        }
	      };
	
	      for (var key in value) loop( key );
	    }
	  }
	  return data
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering static trees.
	 */
	function renderStatic (
	  index,
	  isInFor
	) {
	  var cached = this._staticTrees || (this._staticTrees = []);
	  var tree = cached[index];
	  // if has already-rendered static tree and not inside v-for,
	  // we can reuse the same tree by doing a shallow clone.
	  if (tree && !isInFor) {
	    return Array.isArray(tree)
	      ? cloneVNodes(tree)
	      : cloneVNode(tree)
	  }
	  // otherwise, render a fresh tree.
	  tree = cached[index] = this.$options.staticRenderFns[index].call(
	    this._renderProxy,
	    null,
	    this // for render fns generated for functional component templates
	  );
	  markStatic(tree, ("__static__" + index), false);
	  return tree
	}
	
	/**
	 * Runtime helper for v-once.
	 * Effectively it means marking the node as static with a unique key.
	 */
	function markOnce (
	  tree,
	  index,
	  key
	) {
	  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
	  return tree
	}
	
	function markStatic (
	  tree,
	  key,
	  isOnce
	) {
	  if (Array.isArray(tree)) {
	    for (var i = 0; i < tree.length; i++) {
	      if (tree[i] && typeof tree[i] !== 'string') {
	        markStaticNode(tree[i], (key + "_" + i), isOnce);
	      }
	    }
	  } else {
	    markStaticNode(tree, key, isOnce);
	  }
	}
	
	function markStaticNode (node, key, isOnce) {
	  node.isStatic = true;
	  node.key = key;
	  node.isOnce = isOnce;
	}
	
	/*  */
	
	function bindObjectListeners (data, value) {
	  if (value) {
	    if (!isPlainObject(value)) {
	      "development" !== 'production' && warn(
	        'v-on without argument expects an Object value',
	        this
	      );
	    } else {
	      var on = data.on = data.on ? extend({}, data.on) : {};
	      for (var key in value) {
	        var existing = on[key];
	        var ours = value[key];
	        on[key] = existing ? [].concat(existing, ours) : ours;
	      }
	    }
	  }
	  return data
	}
	
	/*  */
	
	function installRenderHelpers (target) {
	  target._o = markOnce;
	  target._n = toNumber;
	  target._s = toString;
	  target._l = renderList;
	  target._t = renderSlot;
	  target._q = looseEqual;
	  target._i = looseIndexOf;
	  target._m = renderStatic;
	  target._f = resolveFilter;
	  target._k = checkKeyCodes;
	  target._b = bindObjectProps;
	  target._v = createTextVNode;
	  target._e = createEmptyVNode;
	  target._u = resolveScopedSlots;
	  target._g = bindObjectListeners;
	}
	
	/*  */
	
	function FunctionalRenderContext (
	  data,
	  props,
	  children,
	  parent,
	  Ctor
	) {
	  var options = Ctor.options;
	  this.data = data;
	  this.props = props;
	  this.children = children;
	  this.parent = parent;
	  this.listeners = data.on || emptyObject;
	  this.injections = resolveInject(options.inject, parent);
	  this.slots = function () { return resolveSlots(children, parent); };
	
	  // ensure the createElement function in functional components
	  // gets a unique context - this is necessary for correct named slot check
	  var contextVm = Object.create(parent);
	  var isCompiled = isTrue(options._compiled);
	  var needNormalization = !isCompiled;
	
	  // support for compiled functional template
	  if (isCompiled) {
	    // exposing $options for renderStatic()
	    this.$options = options;
	    // pre-resolve slots for renderSlot()
	    this.$slots = this.slots();
	    this.$scopedSlots = data.scopedSlots || emptyObject;
	  }
	
	  if (options._scopeId) {
	    this._c = function (a, b, c, d) {
	      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
	      if (vnode) {
	        vnode.fnScopeId = options._scopeId;
	        vnode.fnContext = parent;
	      }
	      return vnode
	    };
	  } else {
	    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
	  }
	}
	
	installRenderHelpers(FunctionalRenderContext.prototype);
	
	function createFunctionalComponent (
	  Ctor,
	  propsData,
	  data,
	  contextVm,
	  children
	) {
	  var options = Ctor.options;
	  var props = {};
	  var propOptions = options.props;
	  if (isDef(propOptions)) {
	    for (var key in propOptions) {
	      props[key] = validateProp(key, propOptions, propsData || emptyObject);
	    }
	  } else {
	    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
	    if (isDef(data.props)) { mergeProps(props, data.props); }
	  }
	
	  var renderContext = new FunctionalRenderContext(
	    data,
	    props,
	    children,
	    contextVm,
	    Ctor
	  );
	
	  var vnode = options.render.call(null, renderContext._c, renderContext);
	
	  if (vnode instanceof VNode) {
	    vnode.fnContext = contextVm;
	    vnode.fnOptions = options;
	    if (data.slot) {
	      (vnode.data || (vnode.data = {})).slot = data.slot;
	    }
	  }
	
	  return vnode
	}
	
	function mergeProps (to, from) {
	  for (var key in from) {
	    to[camelize(key)] = from[key];
	  }
	}
	
	/*  */
	
	
	
	
	// Register the component hook to weex native render engine.
	// The hook will be triggered by native, not javascript.
	
	
	// Updates the state of the component to weex native render engine.
	
	/*  */
	
	// https://github.com/Hanks10100/weex-native-directive/tree/master/component
	
	// listening on native callback
	
	/*  */
	
	/*  */
	
	// hooks to be invoked on component VNodes during patch
	var componentVNodeHooks = {
	  init: function init (
	    vnode,
	    hydrating,
	    parentElm,
	    refElm
	  ) {
	    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
	      var child = vnode.componentInstance = createComponentInstanceForVnode(
	        vnode,
	        activeInstance,
	        parentElm,
	        refElm
	      );
	      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
	    } else if (vnode.data.keepAlive) {
	      // kept-alive components, treat as a patch
	      var mountedNode = vnode; // work around flow
	      componentVNodeHooks.prepatch(mountedNode, mountedNode);
	    }
	  },
	
	  prepatch: function prepatch (oldVnode, vnode) {
	    var options = vnode.componentOptions;
	    var child = vnode.componentInstance = oldVnode.componentInstance;
	    updateChildComponent(
	      child,
	      options.propsData, // updated props
	      options.listeners, // updated listeners
	      vnode, // new parent vnode
	      options.children // new children
	    );
	  },
	
	  insert: function insert (vnode) {
	    var context = vnode.context;
	    var componentInstance = vnode.componentInstance;
	    if (!componentInstance._isMounted) {
	      componentInstance._isMounted = true;
	      callHook(componentInstance, 'mounted');
	    }
	    if (vnode.data.keepAlive) {
	      if (context._isMounted) {
	        // vue-router#1212
	        // During updates, a kept-alive component's child components may
	        // change, so directly walking the tree here may call activated hooks
	        // on incorrect children. Instead we push them into a queue which will
	        // be processed after the whole patch process ended.
	        queueActivatedComponent(componentInstance);
	      } else {
	        activateChildComponent(componentInstance, true /* direct */);
	      }
	    }
	  },
	
	  destroy: function destroy (vnode) {
	    var componentInstance = vnode.componentInstance;
	    if (!componentInstance._isDestroyed) {
	      if (!vnode.data.keepAlive) {
	        componentInstance.$destroy();
	      } else {
	        deactivateChildComponent(componentInstance, true /* direct */);
	      }
	    }
	  }
	};
	
	var hooksToMerge = Object.keys(componentVNodeHooks);
	
	function createComponent (
	  Ctor,
	  data,
	  context,
	  children,
	  tag
	) {
	  if (isUndef(Ctor)) {
	    return
	  }
	
	  var baseCtor = context.$options._base;
	
	  // plain options object: turn it into a constructor
	  if (isObject(Ctor)) {
	    Ctor = baseCtor.extend(Ctor);
	  }
	
	  // if at this stage it's not a constructor or an async component factory,
	  // reject.
	  if (typeof Ctor !== 'function') {
	    {
	      warn(("Invalid Component definition: " + (String(Ctor))), context);
	    }
	    return
	  }
	
	  // async component
	  var asyncFactory;
	  if (isUndef(Ctor.cid)) {
	    asyncFactory = Ctor;
	    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
	    if (Ctor === undefined) {
	      // return a placeholder node for async component, which is rendered
	      // as a comment node but preserves all the raw information for the node.
	      // the information will be used for async server-rendering and hydration.
	      return createAsyncPlaceholder(
	        asyncFactory,
	        data,
	        context,
	        children,
	        tag
	      )
	    }
	  }
	
	  data = data || {};
	
	  // resolve constructor options in case global mixins are applied after
	  // component constructor creation
	  resolveConstructorOptions(Ctor);
	
	  // transform component v-model data into props & events
	  if (isDef(data.model)) {
	    transformModel(Ctor.options, data);
	  }
	
	  // extract props
	  var propsData = extractPropsFromVNodeData(data, Ctor, tag);
	
	  // functional component
	  if (isTrue(Ctor.options.functional)) {
	    return createFunctionalComponent(Ctor, propsData, data, context, children)
	  }
	
	  // extract listeners, since these needs to be treated as
	  // child component listeners instead of DOM listeners
	  var listeners = data.on;
	  // replace with listeners with .native modifier
	  // so it gets processed during parent component patch.
	  data.on = data.nativeOn;
	
	  if (isTrue(Ctor.options.abstract)) {
	    // abstract components do not keep anything
	    // other than props & listeners & slot
	
	    // work around flow
	    var slot = data.slot;
	    data = {};
	    if (slot) {
	      data.slot = slot;
	    }
	  }
	
	  // merge component management hooks onto the placeholder node
	  mergeHooks(data);
	
	  // return a placeholder vnode
	  var name = Ctor.options.name || tag;
	  var vnode = new VNode(
	    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
	    data, undefined, undefined, undefined, context,
	    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
	    asyncFactory
	  );
	
	  // Weex specific: invoke recycle-list optimized @render function for
	  // extracting cell-slot template.
	  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
	  /* istanbul ignore if */
	  return vnode
	}
	
	function createComponentInstanceForVnode (
	  vnode, // we know it's MountedComponentVNode but flow doesn't
	  parent, // activeInstance in lifecycle state
	  parentElm,
	  refElm
	) {
	  var options = {
	    _isComponent: true,
	    parent: parent,
	    _parentVnode: vnode,
	    _parentElm: parentElm || null,
	    _refElm: refElm || null
	  };
	  // check inline-template render functions
	  var inlineTemplate = vnode.data.inlineTemplate;
	  if (isDef(inlineTemplate)) {
	    options.render = inlineTemplate.render;
	    options.staticRenderFns = inlineTemplate.staticRenderFns;
	  }
	  return new vnode.componentOptions.Ctor(options)
	}
	
	function mergeHooks (data) {
	  if (!data.hook) {
	    data.hook = {};
	  }
	  for (var i = 0; i < hooksToMerge.length; i++) {
	    var key = hooksToMerge[i];
	    var fromParent = data.hook[key];
	    var ours = componentVNodeHooks[key];
	    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
	  }
	}
	
	function mergeHook$1 (one, two) {
	  return function (a, b, c, d) {
	    one(a, b, c, d);
	    two(a, b, c, d);
	  }
	}
	
	// transform component v-model info (value and callback) into
	// prop and event handler respectively.
	function transformModel (options, data) {
	  var prop = (options.model && options.model.prop) || 'value';
	  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
	  var on = data.on || (data.on = {});
	  if (isDef(on[event])) {
	    on[event] = [data.model.callback].concat(on[event]);
	  } else {
	    on[event] = data.model.callback;
	  }
	}
	
	/*  */
	
	var SIMPLE_NORMALIZE = 1;
	var ALWAYS_NORMALIZE = 2;
	
	// wrapper function for providing a more flexible interface
	// without getting yelled at by flow
	function createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType,
	  alwaysNormalize
	) {
	  if (Array.isArray(data) || isPrimitive(data)) {
	    normalizationType = children;
	    children = data;
	    data = undefined;
	  }
	  if (isTrue(alwaysNormalize)) {
	    normalizationType = ALWAYS_NORMALIZE;
	  }
	  return _createElement(context, tag, data, children, normalizationType)
	}
	
	function _createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType
	) {
	  if (isDef(data) && isDef((data).__ob__)) {
	    "development" !== 'production' && warn(
	      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
	      'Always create fresh vnode data objects in each render!',
	      context
	    );
	    return createEmptyVNode()
	  }
	  // object syntax in v-bind
	  if (isDef(data) && isDef(data.is)) {
	    tag = data.is;
	  }
	  if (!tag) {
	    // in case of component :is set to falsy value
	    return createEmptyVNode()
	  }
	  // warn against non-primitive key
	  if ("development" !== 'production' &&
	    isDef(data) && isDef(data.key) && !isPrimitive(data.key)
	  ) {
	    {
	      warn(
	        'Avoid using non-primitive value as key, ' +
	        'use string/number value instead.',
	        context
	      );
	    }
	  }
	  // support single function children as default scoped slot
	  if (Array.isArray(children) &&
	    typeof children[0] === 'function'
	  ) {
	    data = data || {};
	    data.scopedSlots = { default: children[0] };
	    children.length = 0;
	  }
	  if (normalizationType === ALWAYS_NORMALIZE) {
	    children = normalizeChildren(children);
	  } else if (normalizationType === SIMPLE_NORMALIZE) {
	    children = simpleNormalizeChildren(children);
	  }
	  var vnode, ns;
	  if (typeof tag === 'string') {
	    var Ctor;
	    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
	    if (config.isReservedTag(tag)) {
	      // platform built-in elements
	      vnode = new VNode(
	        config.parsePlatformTagName(tag), data, children,
	        undefined, undefined, context
	      );
	    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
	      // component
	      vnode = createComponent(Ctor, data, context, children, tag);
	    } else {
	      // unknown or unlisted namespaced elements
	      // check at runtime because it may get assigned a namespace when its
	      // parent normalizes children
	      vnode = new VNode(
	        tag, data, children,
	        undefined, undefined, context
	      );
	    }
	  } else {
	    // direct component options / constructor
	    vnode = createComponent(tag, data, context, children);
	  }
	  if (isDef(vnode)) {
	    if (ns) { applyNS(vnode, ns); }
	    return vnode
	  } else {
	    return createEmptyVNode()
	  }
	}
	
	function applyNS (vnode, ns, force) {
	  vnode.ns = ns;
	  if (vnode.tag === 'foreignObject') {
	    // use default namespace inside foreignObject
	    ns = undefined;
	    force = true;
	  }
	  if (isDef(vnode.children)) {
	    for (var i = 0, l = vnode.children.length; i < l; i++) {
	      var child = vnode.children[i];
	      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force))) {
	        applyNS(child, ns, force);
	      }
	    }
	  }
	}
	
	/*  */
	
	function initRender (vm) {
	  vm._vnode = null; // the root of the child tree
	  vm._staticTrees = null; // v-once cached trees
	  var options = vm.$options;
	  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
	  var renderContext = parentVnode && parentVnode.context;
	  vm.$slots = resolveSlots(options._renderChildren, renderContext);
	  vm.$scopedSlots = emptyObject;
	  // bind the createElement fn to this instance
	  // so that we get proper render context inside it.
	  // args order: tag, data, children, normalizationType, alwaysNormalize
	  // internal version is used by render functions compiled from templates
	  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
	  // normalization is always applied for the public version, used in
	  // user-written render functions.
	  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
	
	  // $attrs & $listeners are exposed for easier HOC creation.
	  // they need to be reactive so that HOCs using them are always updated
	  var parentData = parentVnode && parentVnode.data;
	
	  /* istanbul ignore else */
	  {
	    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
	      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
	    }, true);
	    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
	      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
	    }, true);
	  }
	}
	
	function renderMixin (Vue) {
	  // install runtime convenience helpers
	  installRenderHelpers(Vue.prototype);
	
	  Vue.prototype.$nextTick = function (fn) {
	    return nextTick(fn, this)
	  };
	
	  Vue.prototype._render = function () {
	    var vm = this;
	    var ref = vm.$options;
	    var render = ref.render;
	    var _parentVnode = ref._parentVnode;
	
	    if (vm._isMounted) {
	      // if the parent didn't update, the slot nodes will be the ones from
	      // last render. They need to be cloned to ensure "freshness" for this render.
	      for (var key in vm.$slots) {
	        var slot = vm.$slots[key];
	        // _rendered is a flag added by renderSlot, but may not be present
	        // if the slot is passed from manually written render functions
	        if (slot._rendered || (slot[0] && slot[0].elm)) {
	          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
	        }
	      }
	    }
	
	    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;
	
	    // set parent vnode. this allows render functions to have access
	    // to the data on the placeholder node.
	    vm.$vnode = _parentVnode;
	    // render self
	    var vnode;
	    try {
	      vnode = render.call(vm._renderProxy, vm.$createElement);
	    } catch (e) {
	      handleError(e, vm, "render");
	      // return error render result,
	      // or previous vnode to prevent render error causing blank component
	      /* istanbul ignore else */
	      {
	        if (vm.$options.renderError) {
	          try {
	            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
	          } catch (e) {
	            handleError(e, vm, "renderError");
	            vnode = vm._vnode;
	          }
	        } else {
	          vnode = vm._vnode;
	        }
	      }
	    }
	    // return empty vnode in case the render function errored out
	    if (!(vnode instanceof VNode)) {
	      if ("development" !== 'production' && Array.isArray(vnode)) {
	        warn(
	          'Multiple root nodes returned from render function. Render function ' +
	          'should return a single root node.',
	          vm
	        );
	      }
	      vnode = createEmptyVNode();
	    }
	    // set parent
	    vnode.parent = _parentVnode;
	    return vnode
	  };
	}
	
	/*  */
	
	var uid$1 = 0;
	
	function initMixin (Vue) {
	  Vue.prototype._init = function (options) {
	    var vm = this;
	    // a uid
	    vm._uid = uid$1++;
	
	    var startTag, endTag;
	    /* istanbul ignore if */
	    if ("development" !== 'production' && config.performance && mark) {
	      startTag = "vue-perf-start:" + (vm._uid);
	      endTag = "vue-perf-end:" + (vm._uid);
	      mark(startTag);
	    }
	
	    // a flag to avoid this being observed
	    vm._isVue = true;
	    // merge options
	    if (options && options._isComponent) {
	      // optimize internal component instantiation
	      // since dynamic options merging is pretty slow, and none of the
	      // internal component options needs special treatment.
	      initInternalComponent(vm, options);
	    } else {
	      vm.$options = mergeOptions(
	        resolveConstructorOptions(vm.constructor),
	        options || {},
	        vm
	      );
	    }
	    /* istanbul ignore else */
	    {
	      initProxy(vm);
	    }
	    // expose real self
	    vm._self = vm;
	    initLifecycle(vm);
	    initEvents(vm);
	    initRender(vm);
	    callHook(vm, 'beforeCreate');
	    initInjections(vm); // resolve injections before data/props
	    initState(vm);
	    initProvide(vm); // resolve provide after data/props
	    callHook(vm, 'created');
	
	    /* istanbul ignore if */
	    if ("development" !== 'production' && config.performance && mark) {
	      vm._name = formatComponentName(vm, false);
	      mark(endTag);
	      measure(("vue " + (vm._name) + " init"), startTag, endTag);
	    }
	
	    if (vm.$options.el) {
	      vm.$mount(vm.$options.el);
	    }
	  };
	}
	
	function initInternalComponent (vm, options) {
	  var opts = vm.$options = Object.create(vm.constructor.options);
	  // doing this because it's faster than dynamic enumeration.
	  var parentVnode = options._parentVnode;
	  opts.parent = options.parent;
	  opts._parentVnode = parentVnode;
	  opts._parentElm = options._parentElm;
	  opts._refElm = options._refElm;
	
	  var vnodeComponentOptions = parentVnode.componentOptions;
	  opts.propsData = vnodeComponentOptions.propsData;
	  opts._parentListeners = vnodeComponentOptions.listeners;
	  opts._renderChildren = vnodeComponentOptions.children;
	  opts._componentTag = vnodeComponentOptions.tag;
	
	  if (options.render) {
	    opts.render = options.render;
	    opts.staticRenderFns = options.staticRenderFns;
	  }
	}
	
	function resolveConstructorOptions (Ctor) {
	  var options = Ctor.options;
	  if (Ctor.super) {
	    var superOptions = resolveConstructorOptions(Ctor.super);
	    var cachedSuperOptions = Ctor.superOptions;
	    if (superOptions !== cachedSuperOptions) {
	      // super option changed,
	      // need to resolve new options.
	      Ctor.superOptions = superOptions;
	      // check if there are any late-modified/attached options (#4976)
	      var modifiedOptions = resolveModifiedOptions(Ctor);
	      // update base extend options
	      if (modifiedOptions) {
	        extend(Ctor.extendOptions, modifiedOptions);
	      }
	      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
	      if (options.name) {
	        options.components[options.name] = Ctor;
	      }
	    }
	  }
	  return options
	}
	
	function resolveModifiedOptions (Ctor) {
	  var modified;
	  var latest = Ctor.options;
	  var extended = Ctor.extendOptions;
	  var sealed = Ctor.sealedOptions;
	  for (var key in latest) {
	    if (latest[key] !== sealed[key]) {
	      if (!modified) { modified = {}; }
	      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
	    }
	  }
	  return modified
	}
	
	function dedupe (latest, extended, sealed) {
	  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
	  // between merges
	  if (Array.isArray(latest)) {
	    var res = [];
	    sealed = Array.isArray(sealed) ? sealed : [sealed];
	    extended = Array.isArray(extended) ? extended : [extended];
	    for (var i = 0; i < latest.length; i++) {
	      // push original options and not sealed options to exclude duplicated options
	      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
	        res.push(latest[i]);
	      }
	    }
	    return res
	  } else {
	    return latest
	  }
	}
	
	function Vue$3 (options) {
	  if ("development" !== 'production' &&
	    !(this instanceof Vue$3)
	  ) {
	    warn('Vue is a constructor and should be called with the `new` keyword');
	  }
	  this._init(options);
	}
	
	initMixin(Vue$3);
	stateMixin(Vue$3);
	eventsMixin(Vue$3);
	lifecycleMixin(Vue$3);
	renderMixin(Vue$3);
	
	/*  */
	
	function initUse (Vue) {
	  Vue.use = function (plugin) {
	    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
	    if (installedPlugins.indexOf(plugin) > -1) {
	      return this
	    }
	
	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else if (typeof plugin === 'function') {
	      plugin.apply(null, args);
	    }
	    installedPlugins.push(plugin);
	    return this
	  };
	}
	
	/*  */
	
	function initMixin$1 (Vue) {
	  Vue.mixin = function (mixin) {
	    this.options = mergeOptions(this.options, mixin);
	    return this
	  };
	}
	
	/*  */
	
	function initExtend (Vue) {
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	  Vue.cid = 0;
	  var cid = 1;
	
	  /**
	   * Class inheritance
	   */
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var SuperId = Super.cid;
	    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
	    if (cachedCtors[SuperId]) {
	      return cachedCtors[SuperId]
	    }
	
	    var name = extendOptions.name || Super.options.name;
	    if ("development" !== 'production' && name) {
	      validateComponentName(name);
	    }
	
	    var Sub = function VueComponent (options) {
	      this._init(options);
	    };
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(
	      Super.options,
	      extendOptions
	    );
	    Sub['super'] = Super;
	
	    // For props and computed properties, we define the proxy getters on
	    // the Vue instances at extension time, on the extended prototype. This
	    // avoids Object.defineProperty calls for each instance created.
	    if (Sub.options.props) {
	      initProps$1(Sub);
	    }
	    if (Sub.options.computed) {
	      initComputed$1(Sub);
	    }
	
	    // allow further extension/mixin/plugin usage
	    Sub.extend = Super.extend;
	    Sub.mixin = Super.mixin;
	    Sub.use = Super.use;
	
	    // create asset registers, so extended classes
	    // can have their private assets too.
	    ASSET_TYPES.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }
	
	    // keep a reference to the super options at extension time.
	    // later at instantiation we can check if Super's options have
	    // been updated.
	    Sub.superOptions = Super.options;
	    Sub.extendOptions = extendOptions;
	    Sub.sealedOptions = extend({}, Sub.options);
	
	    // cache constructor
	    cachedCtors[SuperId] = Sub;
	    return Sub
	  };
	}
	
	function initProps$1 (Comp) {
	  var props = Comp.options.props;
	  for (var key in props) {
	    proxy(Comp.prototype, "_props", key);
	  }
	}
	
	function initComputed$1 (Comp) {
	  var computed = Comp.options.computed;
	  for (var key in computed) {
	    defineComputed(Comp.prototype, key, computed[key]);
	  }
	}
	
	/*  */
	
	function initAssetRegisters (Vue) {
	  /**
	   * Create asset registration methods.
	   */
	  ASSET_TYPES.forEach(function (type) {
	    Vue[type] = function (
	      id,
	      definition
	    ) {
	      if (!definition) {
	        return this.options[type + 's'][id]
	      } else {
	        /* istanbul ignore if */
	        if ("development" !== 'production' && type === 'component') {
	          validateComponentName(id);
	        }
	        if (type === 'component' && isPlainObject(definition)) {
	          definition.name = definition.name || id;
	          definition = this.options._base.extend(definition);
	        }
	        if (type === 'directive' && typeof definition === 'function') {
	          definition = { bind: definition, update: definition };
	        }
	        this.options[type + 's'][id] = definition;
	        return definition
	      }
	    };
	  });
	}
	
	/*  */
	
	function getComponentName (opts) {
	  return opts && (opts.Ctor.options.name || opts.tag)
	}
	
	function matches (pattern, name) {
	  if (Array.isArray(pattern)) {
	    return pattern.indexOf(name) > -1
	  } else if (typeof pattern === 'string') {
	    return pattern.split(',').indexOf(name) > -1
	  } else if (isRegExp(pattern)) {
	    return pattern.test(name)
	  }
	  /* istanbul ignore next */
	  return false
	}
	
	function pruneCache (keepAliveInstance, filter) {
	  var cache = keepAliveInstance.cache;
	  var keys = keepAliveInstance.keys;
	  var _vnode = keepAliveInstance._vnode;
	  for (var key in cache) {
	    var cachedNode = cache[key];
	    if (cachedNode) {
	      var name = getComponentName(cachedNode.componentOptions);
	      if (name && !filter(name)) {
	        pruneCacheEntry(cache, key, keys, _vnode);
	      }
	    }
	  }
	}
	
	function pruneCacheEntry (
	  cache,
	  key,
	  keys,
	  current
	) {
	  var cached$$1 = cache[key];
	  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
	    cached$$1.componentInstance.$destroy();
	  }
	  cache[key] = null;
	  remove(keys, key);
	}
	
	var patternTypes = [String, RegExp, Array];
	
	var KeepAlive = {
	  name: 'keep-alive',
	  abstract: true,
	
	  props: {
	    include: patternTypes,
	    exclude: patternTypes,
	    max: [String, Number]
	  },
	
	  created: function created () {
	    this.cache = Object.create(null);
	    this.keys = [];
	  },
	
	  destroyed: function destroyed () {
	    var this$1 = this;
	
	    for (var key in this$1.cache) {
	      pruneCacheEntry(this$1.cache, key, this$1.keys);
	    }
	  },
	
	  watch: {
	    include: function include (val) {
	      pruneCache(this, function (name) { return matches(val, name); });
	    },
	    exclude: function exclude (val) {
	      pruneCache(this, function (name) { return !matches(val, name); });
	    }
	  },
	
	  render: function render () {
	    var slot = this.$slots.default;
	    var vnode = getFirstComponentChild(slot);
	    var componentOptions = vnode && vnode.componentOptions;
	    if (componentOptions) {
	      // check pattern
	      var name = getComponentName(componentOptions);
	      var ref = this;
	      var include = ref.include;
	      var exclude = ref.exclude;
	      if (
	        // not included
	        (include && (!name || !matches(include, name))) ||
	        // excluded
	        (exclude && name && matches(exclude, name))
	      ) {
	        return vnode
	      }
	
	      var ref$1 = this;
	      var cache = ref$1.cache;
	      var keys = ref$1.keys;
	      var key = vnode.key == null
	        // same constructor may get registered as different local components
	        // so cid alone is not enough (#3269)
	        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
	        : vnode.key;
	      if (cache[key]) {
	        vnode.componentInstance = cache[key].componentInstance;
	        // make current key freshest
	        remove(keys, key);
	        keys.push(key);
	      } else {
	        cache[key] = vnode;
	        keys.push(key);
	        // prune oldest entry
	        if (this.max && keys.length > parseInt(this.max)) {
	          pruneCacheEntry(cache, keys[0], keys, this._vnode);
	        }
	      }
	
	      vnode.data.keepAlive = true;
	    }
	    return vnode || (slot && slot[0])
	  }
	};
	
	var builtInComponents = {
	  KeepAlive: KeepAlive
	};
	
	/*  */
	
	function initGlobalAPI (Vue) {
	  // config
	  var configDef = {};
	  configDef.get = function () { return config; };
	  {
	    configDef.set = function () {
	      warn(
	        'Do not replace the Vue.config object, set individual fields instead.'
	      );
	    };
	  }
	  Object.defineProperty(Vue, 'config', configDef);
	
	  // exposed util methods.
	  // NOTE: these are not considered part of the public API - avoid relying on
	  // them unless you are aware of the risk.
	  Vue.util = {
	    warn: warn,
	    extend: extend,
	    mergeOptions: mergeOptions,
	    defineReactive: defineReactive
	  };
	
	  Vue.set = set;
	  Vue.delete = del;
	  Vue.nextTick = nextTick;
	
	  Vue.options = Object.create(null);
	  ASSET_TYPES.forEach(function (type) {
	    Vue.options[type + 's'] = Object.create(null);
	  });
	
	  // this is used to identify the "base" constructor to extend all plain-object
	  // components with in Weex's multi-instance scenarios.
	  Vue.options._base = Vue;
	
	  extend(Vue.options.components, builtInComponents);
	
	  initUse(Vue);
	  initMixin$1(Vue);
	  initExtend(Vue);
	  initAssetRegisters(Vue);
	}
	
	initGlobalAPI(Vue$3);
	
	Object.defineProperty(Vue$3.prototype, '$isServer', {
	  get: isServerRendering
	});
	
	Object.defineProperty(Vue$3.prototype, '$ssrContext', {
	  get: function get () {
	    /* istanbul ignore next */
	    return this.$vnode && this.$vnode.ssrContext
	  }
	});
	
	Vue$3.version = '2.5.13';
	
	/*  */
	
	// these are reserved for web because they are directly compiled away
	// during template compilation
	var isReservedAttr = makeMap('style,class');
	
	// attributes that should be using props for binding
	var acceptValue = makeMap('input,textarea,option,select,progress');
	var mustUseProp = function (tag, type, attr) {
	  return (
	    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
	    (attr === 'selected' && tag === 'option') ||
	    (attr === 'checked' && tag === 'input') ||
	    (attr === 'muted' && tag === 'video')
	  )
	};
	
	var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
	
	var isBooleanAttr = makeMap(
	  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
	  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
	  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
	  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
	  'required,reversed,scoped,seamless,selected,sortable,translate,' +
	  'truespeed,typemustmatch,visible'
	);
	
	var xlinkNS = 'http://www.w3.org/1999/xlink';
	
	var isXlink = function (name) {
	  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
	};
	
	var getXlinkProp = function (name) {
	  return isXlink(name) ? name.slice(6, name.length) : ''
	};
	
	var isFalsyAttrValue = function (val) {
	  return val == null || val === false
	};
	
	/*  */
	
	function genClassForVnode (vnode) {
	  var data = vnode.data;
	  var parentNode = vnode;
	  var childNode = vnode;
	  while (isDef(childNode.componentInstance)) {
	    childNode = childNode.componentInstance._vnode;
	    if (childNode && childNode.data) {
	      data = mergeClassData(childNode.data, data);
	    }
	  }
	  while (isDef(parentNode = parentNode.parent)) {
	    if (parentNode && parentNode.data) {
	      data = mergeClassData(data, parentNode.data);
	    }
	  }
	  return renderClass(data.staticClass, data.class)
	}
	
	function mergeClassData (child, parent) {
	  return {
	    staticClass: concat(child.staticClass, parent.staticClass),
	    class: isDef(child.class)
	      ? [child.class, parent.class]
	      : parent.class
	  }
	}
	
	function renderClass (
	  staticClass,
	  dynamicClass
	) {
	  if (isDef(staticClass) || isDef(dynamicClass)) {
	    return concat(staticClass, stringifyClass(dynamicClass))
	  }
	  /* istanbul ignore next */
	  return ''
	}
	
	function concat (a, b) {
	  return a ? b ? (a + ' ' + b) : a : (b || '')
	}
	
	function stringifyClass (value) {
	  if (Array.isArray(value)) {
	    return stringifyArray(value)
	  }
	  if (isObject(value)) {
	    return stringifyObject(value)
	  }
	  if (typeof value === 'string') {
	    return value
	  }
	  /* istanbul ignore next */
	  return ''
	}
	
	function stringifyArray (value) {
	  var res = '';
	  var stringified;
	  for (var i = 0, l = value.length; i < l; i++) {
	    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
	      if (res) { res += ' '; }
	      res += stringified;
	    }
	  }
	  return res
	}
	
	function stringifyObject (value) {
	  var res = '';
	  for (var key in value) {
	    if (value[key]) {
	      if (res) { res += ' '; }
	      res += key;
	    }
	  }
	  return res
	}
	
	/*  */
	
	var namespaceMap = {
	  svg: 'http://www.w3.org/2000/svg',
	  math: 'http://www.w3.org/1998/Math/MathML'
	};
	
	var isHTMLTag = makeMap(
	  'html,body,base,head,link,meta,style,title,' +
	  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
	  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
	  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
	  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
	  'embed,object,param,source,canvas,script,noscript,del,ins,' +
	  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
	  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
	  'output,progress,select,textarea,' +
	  'details,dialog,menu,menuitem,summary,' +
	  'content,element,shadow,template,blockquote,iframe,tfoot'
	);
	
	// this map is intentionally selective, only covering SVG elements that may
	// contain child elements.
	var isSVG = makeMap(
	  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
	  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
	  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
	  true
	);
	
	var isPreTag = function (tag) { return tag === 'pre'; };
	
	var isReservedTag = function (tag) {
	  return isHTMLTag(tag) || isSVG(tag)
	};
	
	function getTagNamespace (tag) {
	  if (isSVG(tag)) {
	    return 'svg'
	  }
	  // basic support for MathML
	  // note it doesn't support other MathML elements being component roots
	  if (tag === 'math') {
	    return 'math'
	  }
	}
	
	var unknownElementCache = Object.create(null);
	function isUnknownElement (tag) {
	  /* istanbul ignore if */
	  if (!inBrowser) {
	    return true
	  }
	  if (isReservedTag(tag)) {
	    return false
	  }
	  tag = tag.toLowerCase();
	  /* istanbul ignore if */
	  if (unknownElementCache[tag] != null) {
	    return unknownElementCache[tag]
	  }
	  var el = document.createElement(tag);
	  if (tag.indexOf('-') > -1) {
	    // http://stackoverflow.com/a/28210364/1070244
	    return (unknownElementCache[tag] = (
	      el.constructor === window.HTMLUnknownElement ||
	      el.constructor === window.HTMLElement
	    ))
	  } else {
	    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
	  }
	}
	
	var isTextInputType = makeMap('text,number,password,search,email,tel,url');
	
	/*  */
	
	/**
	 * Query an element selector if it's not an element already.
	 */
	function query (el) {
	  if (typeof el === 'string') {
	    var selected = document.querySelector(el);
	    if (!selected) {
	      "development" !== 'production' && warn(
	        'Cannot find element: ' + el
	      );
	      return document.createElement('div')
	    }
	    return selected
	  } else {
	    return el
	  }
	}
	
	/*  */
	
	function createElement$1 (tagName, vnode) {
	  var elm = document.createElement(tagName);
	  if (tagName !== 'select') {
	    return elm
	  }
	  // false or null will remove the attribute but undefined will not
	  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
	    elm.setAttribute('multiple', 'multiple');
	  }
	  return elm
	}
	
	function createElementNS (namespace, tagName) {
	  return document.createElementNS(namespaceMap[namespace], tagName)
	}
	
	function createTextNode (text) {
	  return document.createTextNode(text)
	}
	
	function createComment (text) {
	  return document.createComment(text)
	}
	
	function insertBefore (parentNode, newNode, referenceNode) {
	  parentNode.insertBefore(newNode, referenceNode);
	}
	
	function removeChild (node, child) {
	  node.removeChild(child);
	}
	
	function appendChild (node, child) {
	  node.appendChild(child);
	}
	
	function parentNode (node) {
	  return node.parentNode
	}
	
	function nextSibling (node) {
	  return node.nextSibling
	}
	
	function tagName (node) {
	  return node.tagName
	}
	
	function setTextContent (node, text) {
	  node.textContent = text;
	}
	
	function setAttribute (node, key, val) {
	  node.setAttribute(key, val);
	}
	
	
	var nodeOps = Object.freeze({
		createElement: createElement$1,
		createElementNS: createElementNS,
		createTextNode: createTextNode,
		createComment: createComment,
		insertBefore: insertBefore,
		removeChild: removeChild,
		appendChild: appendChild,
		parentNode: parentNode,
		nextSibling: nextSibling,
		tagName: tagName,
		setTextContent: setTextContent,
		setAttribute: setAttribute
	});
	
	/*  */
	
	var ref = {
	  create: function create (_, vnode) {
	    registerRef(vnode);
	  },
	  update: function update (oldVnode, vnode) {
	    if (oldVnode.data.ref !== vnode.data.ref) {
	      registerRef(oldVnode, true);
	      registerRef(vnode);
	    }
	  },
	  destroy: function destroy (vnode) {
	    registerRef(vnode, true);
	  }
	};
	
	function registerRef (vnode, isRemoval) {
	  var key = vnode.data.ref;
	  if (!key) { return }
	
	  var vm = vnode.context;
	  var ref = vnode.componentInstance || vnode.elm;
	  var refs = vm.$refs;
	  if (isRemoval) {
	    if (Array.isArray(refs[key])) {
	      remove(refs[key], ref);
	    } else if (refs[key] === ref) {
	      refs[key] = undefined;
	    }
	  } else {
	    if (vnode.data.refInFor) {
	      if (!Array.isArray(refs[key])) {
	        refs[key] = [ref];
	      } else if (refs[key].indexOf(ref) < 0) {
	        // $flow-disable-line
	        refs[key].push(ref);
	      }
	    } else {
	      refs[key] = ref;
	    }
	  }
	}
	
	/**
	 * Virtual DOM patching algorithm based on Snabbdom by
	 * Simon Friis Vindum (@paldepind)
	 * Licensed under the MIT License
	 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
	 *
	 * modified by Evan You (@yyx990803)
	 *
	 * Not type-checking this because this file is perf-critical and the cost
	 * of making flow understand it is not worth it.
	 */
	
	var emptyNode = new VNode('', {}, []);
	
	var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
	
	function sameVnode (a, b) {
	  return (
	    a.key === b.key && (
	      (
	        a.tag === b.tag &&
	        a.isComment === b.isComment &&
	        isDef(a.data) === isDef(b.data) &&
	        sameInputType(a, b)
	      ) || (
	        isTrue(a.isAsyncPlaceholder) &&
	        a.asyncFactory === b.asyncFactory &&
	        isUndef(b.asyncFactory.error)
	      )
	    )
	  )
	}
	
	function sameInputType (a, b) {
	  if (a.tag !== 'input') { return true }
	  var i;
	  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
	  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
	  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
	}
	
	function createKeyToOldIdx (children, beginIdx, endIdx) {
	  var i, key;
	  var map = {};
	  for (i = beginIdx; i <= endIdx; ++i) {
	    key = children[i].key;
	    if (isDef(key)) { map[key] = i; }
	  }
	  return map
	}
	
	function createPatchFunction (backend) {
	  var i, j;
	  var cbs = {};
	
	  var modules = backend.modules;
	  var nodeOps = backend.nodeOps;
	
	  for (i = 0; i < hooks.length; ++i) {
	    cbs[hooks[i]] = [];
	    for (j = 0; j < modules.length; ++j) {
	      if (isDef(modules[j][hooks[i]])) {
	        cbs[hooks[i]].push(modules[j][hooks[i]]);
	      }
	    }
	  }
	
	  function emptyNodeAt (elm) {
	    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
	  }
	
	  function createRmCb (childElm, listeners) {
	    function remove () {
	      if (--remove.listeners === 0) {
	        removeNode(childElm);
	      }
	    }
	    remove.listeners = listeners;
	    return remove
	  }
	
	  function removeNode (el) {
	    var parent = nodeOps.parentNode(el);
	    // element may have already been removed due to v-html / v-text
	    if (isDef(parent)) {
	      nodeOps.removeChild(parent, el);
	    }
	  }
	
	  function isUnknownElement$$1 (vnode, inVPre) {
	    return (
	      !inVPre &&
	      !vnode.ns &&
	      !(
	        config.ignoredElements.length &&
	        config.ignoredElements.some(function (ignore) {
	          return isRegExp(ignore)
	            ? ignore.test(vnode.tag)
	            : ignore === vnode.tag
	        })
	      ) &&
	      config.isUnknownElement(vnode.tag)
	    )
	  }
	
	  var creatingElmInVPre = 0;
	  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
	    vnode.isRootInsert = !nested; // for transition enter check
	    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
	      return
	    }
	
	    var data = vnode.data;
	    var children = vnode.children;
	    var tag = vnode.tag;
	    if (isDef(tag)) {
	      {
	        if (data && data.pre) {
	          creatingElmInVPre++;
	        }
	        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
	          warn(
	            'Unknown custom element: <' + tag + '> - did you ' +
	            'register the component correctly? For recursive components, ' +
	            'make sure to provide the "name" option.',
	            vnode.context
	          );
	        }
	      }
	      vnode.elm = vnode.ns
	        ? nodeOps.createElementNS(vnode.ns, tag)
	        : nodeOps.createElement(tag, vnode);
	      setScope(vnode);
	
	      /* istanbul ignore if */
	      {
	        createChildren(vnode, children, insertedVnodeQueue);
	        if (isDef(data)) {
	          invokeCreateHooks(vnode, insertedVnodeQueue);
	        }
	        insert(parentElm, vnode.elm, refElm);
	      }
	
	      if ("development" !== 'production' && data && data.pre) {
	        creatingElmInVPre--;
	      }
	    } else if (isTrue(vnode.isComment)) {
	      vnode.elm = nodeOps.createComment(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    } else {
	      vnode.elm = nodeOps.createTextNode(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    }
	  }
	
	  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i = vnode.data;
	    if (isDef(i)) {
	      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
	      if (isDef(i = i.hook) && isDef(i = i.init)) {
	        i(vnode, false /* hydrating */, parentElm, refElm);
	      }
	      // after calling the init hook, if the vnode is a child component
	      // it should've created a child instance and mounted it. the child
	      // component also has set the placeholder vnode's elm.
	      // in that case we can just return the element and be done.
	      if (isDef(vnode.componentInstance)) {
	        initComponent(vnode, insertedVnodeQueue);
	        if (isTrue(isReactivated)) {
	          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
	        }
	        return true
	      }
	    }
	  }
	
	  function initComponent (vnode, insertedVnodeQueue) {
	    if (isDef(vnode.data.pendingInsert)) {
	      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
	      vnode.data.pendingInsert = null;
	    }
	    vnode.elm = vnode.componentInstance.$el;
	    if (isPatchable(vnode)) {
	      invokeCreateHooks(vnode, insertedVnodeQueue);
	      setScope(vnode);
	    } else {
	      // empty component root.
	      // skip all element-related modules except for ref (#3455)
	      registerRef(vnode);
	      // make sure to invoke the insert hook
	      insertedVnodeQueue.push(vnode);
	    }
	  }
	
	  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i;
	    // hack for #4339: a reactivated component with inner transition
	    // does not trigger because the inner node's created hooks are not called
	    // again. It's not ideal to involve module-specific logic in here but
	    // there doesn't seem to be a better way to do it.
	    var innerNode = vnode;
	    while (innerNode.componentInstance) {
	      innerNode = innerNode.componentInstance._vnode;
	      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
	        for (i = 0; i < cbs.activate.length; ++i) {
	          cbs.activate[i](emptyNode, innerNode);
	        }
	        insertedVnodeQueue.push(innerNode);
	        break
	      }
	    }
	    // unlike a newly created component,
	    // a reactivated keep-alive component doesn't insert itself
	    insert(parentElm, vnode.elm, refElm);
	  }
	
	  function insert (parent, elm, ref$$1) {
	    if (isDef(parent)) {
	      if (isDef(ref$$1)) {
	        if (ref$$1.parentNode === parent) {
	          nodeOps.insertBefore(parent, elm, ref$$1);
	        }
	      } else {
	        nodeOps.appendChild(parent, elm);
	      }
	    }
	  }
	
	  function createChildren (vnode, children, insertedVnodeQueue) {
	    if (Array.isArray(children)) {
	      {
	        checkDuplicateKeys(children);
	      }
	      for (var i = 0; i < children.length; ++i) {
	        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
	      }
	    } else if (isPrimitive(vnode.text)) {
	      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
	    }
	  }
	
	  function isPatchable (vnode) {
	    while (vnode.componentInstance) {
	      vnode = vnode.componentInstance._vnode;
	    }
	    return isDef(vnode.tag)
	  }
	
	  function invokeCreateHooks (vnode, insertedVnodeQueue) {
	    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	      cbs.create[i$1](emptyNode, vnode);
	    }
	    i = vnode.data.hook; // Reuse variable
	    if (isDef(i)) {
	      if (isDef(i.create)) { i.create(emptyNode, vnode); }
	      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
	    }
	  }
	
	  // set scope id attribute for scoped CSS.
	  // this is implemented as a special case to avoid the overhead
	  // of going through the normal attribute patching process.
	  function setScope (vnode) {
	    var i;
	    if (isDef(i = vnode.fnScopeId)) {
	      nodeOps.setAttribute(vnode.elm, i, '');
	    } else {
	      var ancestor = vnode;
	      while (ancestor) {
	        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
	          nodeOps.setAttribute(vnode.elm, i, '');
	        }
	        ancestor = ancestor.parent;
	      }
	    }
	    // for slot content they should also get the scopeId from the host instance.
	    if (isDef(i = activeInstance) &&
	      i !== vnode.context &&
	      i !== vnode.fnContext &&
	      isDef(i = i.$options._scopeId)
	    ) {
	      nodeOps.setAttribute(vnode.elm, i, '');
	    }
	  }
	
	  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
	    }
	  }
	
	  function invokeDestroyHook (vnode) {
	    var i, j;
	    var data = vnode.data;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
	      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
	    }
	    if (isDef(i = vnode.children)) {
	      for (j = 0; j < vnode.children.length; ++j) {
	        invokeDestroyHook(vnode.children[j]);
	      }
	    }
	  }
	
	  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      var ch = vnodes[startIdx];
	      if (isDef(ch)) {
	        if (isDef(ch.tag)) {
	          removeAndInvokeRemoveHook(ch);
	          invokeDestroyHook(ch);
	        } else { // Text node
	          removeNode(ch.elm);
	        }
	      }
	    }
	  }
	
	  function removeAndInvokeRemoveHook (vnode, rm) {
	    if (isDef(rm) || isDef(vnode.data)) {
	      var i;
	      var listeners = cbs.remove.length + 1;
	      if (isDef(rm)) {
	        // we have a recursively passed down rm callback
	        // increase the listeners count
	        rm.listeners += listeners;
	      } else {
	        // directly removing
	        rm = createRmCb(vnode.elm, listeners);
	      }
	      // recursively invoke hooks on child component root node
	      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
	        removeAndInvokeRemoveHook(i, rm);
	      }
	      for (i = 0; i < cbs.remove.length; ++i) {
	        cbs.remove[i](vnode, rm);
	      }
	      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
	        i(vnode, rm);
	      } else {
	        rm();
	      }
	    } else {
	      removeNode(vnode.elm);
	    }
	  }
	
	  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
	    var oldStartIdx = 0;
	    var newStartIdx = 0;
	    var oldEndIdx = oldCh.length - 1;
	    var oldStartVnode = oldCh[0];
	    var oldEndVnode = oldCh[oldEndIdx];
	    var newEndIdx = newCh.length - 1;
	    var newStartVnode = newCh[0];
	    var newEndVnode = newCh[newEndIdx];
	    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
	
	    // removeOnly is a special flag used only by <transition-group>
	    // to ensure removed elements stay in correct relative positions
	    // during leaving transitions
	    var canMove = !removeOnly;
	
	    {
	      checkDuplicateKeys(newCh);
	    }
	
	    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	      if (isUndef(oldStartVnode)) {
	        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
	      } else if (isUndef(oldEndVnode)) {
	        oldEndVnode = oldCh[--oldEndIdx];
	      } else if (sameVnode(oldStartVnode, newStartVnode)) {
	        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
	        oldStartVnode = oldCh[++oldStartIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else if (sameVnode(oldEndVnode, newEndVnode)) {
	        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
	        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
	        oldStartVnode = oldCh[++oldStartIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
	        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else {
	        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
	        idxInOld = isDef(newStartVnode.key)
	          ? oldKeyToIdx[newStartVnode.key]
	          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
	        if (isUndef(idxInOld)) { // New element
	          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
	        } else {
	          vnodeToMove = oldCh[idxInOld];
	          if (sameVnode(vnodeToMove, newStartVnode)) {
	            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
	            oldCh[idxInOld] = undefined;
	            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
	          } else {
	            // same key but different element. treat as new element
	            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
	          }
	        }
	        newStartVnode = newCh[++newStartIdx];
	      }
	    }
	    if (oldStartIdx > oldEndIdx) {
	      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
	      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	    } else if (newStartIdx > newEndIdx) {
	      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
	    }
	  }
	
	  function checkDuplicateKeys (children) {
	    var seenKeys = {};
	    for (var i = 0; i < children.length; i++) {
	      var vnode = children[i];
	      var key = vnode.key;
	      if (isDef(key)) {
	        if (seenKeys[key]) {
	          warn(
	            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
	            vnode.context
	          );
	        } else {
	          seenKeys[key] = true;
	        }
	      }
	    }
	  }
	
	  function findIdxInOld (node, oldCh, start, end) {
	    for (var i = start; i < end; i++) {
	      var c = oldCh[i];
	      if (isDef(c) && sameVnode(node, c)) { return i }
	    }
	  }
	
	  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
	    if (oldVnode === vnode) {
	      return
	    }
	
	    var elm = vnode.elm = oldVnode.elm;
	
	    if (isTrue(oldVnode.isAsyncPlaceholder)) {
	      if (isDef(vnode.asyncFactory.resolved)) {
	        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
	      } else {
	        vnode.isAsyncPlaceholder = true;
	      }
	      return
	    }
	
	    // reuse element for static trees.
	    // note we only do this if the vnode is cloned -
	    // if the new node is not cloned it means the render functions have been
	    // reset by the hot-reload-api and we need to do a proper re-render.
	    if (isTrue(vnode.isStatic) &&
	      isTrue(oldVnode.isStatic) &&
	      vnode.key === oldVnode.key &&
	      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
	    ) {
	      vnode.componentInstance = oldVnode.componentInstance;
	      return
	    }
	
	    var i;
	    var data = vnode.data;
	    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
	      i(oldVnode, vnode);
	    }
	
	    var oldCh = oldVnode.children;
	    var ch = vnode.children;
	    if (isDef(data) && isPatchable(vnode)) {
	      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
	      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
	    }
	    if (isUndef(vnode.text)) {
	      if (isDef(oldCh) && isDef(ch)) {
	        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
	      } else if (isDef(ch)) {
	        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
	        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	      } else if (isDef(oldCh)) {
	        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	      } else if (isDef(oldVnode.text)) {
	        nodeOps.setTextContent(elm, '');
	      }
	    } else if (oldVnode.text !== vnode.text) {
	      nodeOps.setTextContent(elm, vnode.text);
	    }
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
	    }
	  }
	
	  function invokeInsertHook (vnode, queue, initial) {
	    // delay insert hooks for component root nodes, invoke them after the
	    // element is really inserted
	    if (isTrue(initial) && isDef(vnode.parent)) {
	      vnode.parent.data.pendingInsert = queue;
	    } else {
	      for (var i = 0; i < queue.length; ++i) {
	        queue[i].data.hook.insert(queue[i]);
	      }
	    }
	  }
	
	  var hydrationBailed = false;
	  // list of modules that can skip create hook during hydration because they
	  // are already rendered on the client or has no need for initialization
	  // Note: style is excluded because it relies on initial clone for future
	  // deep updates (#7063).
	  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
	
	  // Note: this is a browser-only function so we can assume elms are DOM nodes.
	  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
	    var i;
	    var tag = vnode.tag;
	    var data = vnode.data;
	    var children = vnode.children;
	    inVPre = inVPre || (data && data.pre);
	    vnode.elm = elm;
	
	    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
	      vnode.isAsyncPlaceholder = true;
	      return true
	    }
	    // assert node match
	    {
	      if (!assertNodeMatch(elm, vnode, inVPre)) {
	        return false
	      }
	    }
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
	      if (isDef(i = vnode.componentInstance)) {
	        // child component. it should have hydrated its own tree.
	        initComponent(vnode, insertedVnodeQueue);
	        return true
	      }
	    }
	    if (isDef(tag)) {
	      if (isDef(children)) {
	        // empty element, allow client to pick up and populate children
	        if (!elm.hasChildNodes()) {
	          createChildren(vnode, children, insertedVnodeQueue);
	        } else {
	          // v-html and domProps: innerHTML
	          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
	            if (i !== elm.innerHTML) {
	              /* istanbul ignore if */
	              if ("development" !== 'production' &&
	                typeof console !== 'undefined' &&
	                !hydrationBailed
	              ) {
	                hydrationBailed = true;
	                console.warn('Parent: ', elm);
	                console.warn('server innerHTML: ', i);
	                console.warn('client innerHTML: ', elm.innerHTML);
	              }
	              return false
	            }
	          } else {
	            // iterate and compare children lists
	            var childrenMatch = true;
	            var childNode = elm.firstChild;
	            for (var i$1 = 0; i$1 < children.length; i$1++) {
	              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
	                childrenMatch = false;
	                break
	              }
	              childNode = childNode.nextSibling;
	            }
	            // if childNode is not null, it means the actual childNodes list is
	            // longer than the virtual children list.
	            if (!childrenMatch || childNode) {
	              /* istanbul ignore if */
	              if ("development" !== 'production' &&
	                typeof console !== 'undefined' &&
	                !hydrationBailed
	              ) {
	                hydrationBailed = true;
	                console.warn('Parent: ', elm);
	                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
	              }
	              return false
	            }
	          }
	        }
	      }
	      if (isDef(data)) {
	        var fullInvoke = false;
	        for (var key in data) {
	          if (!isRenderedModule(key)) {
	            fullInvoke = true;
	            invokeCreateHooks(vnode, insertedVnodeQueue);
	            break
	          }
	        }
	        if (!fullInvoke && data['class']) {
	          // ensure collecting deps for deep class bindings for future updates
	          traverse(data['class']);
	        }
	      }
	    } else if (elm.data !== vnode.text) {
	      elm.data = vnode.text;
	    }
	    return true
	  }
	
	  function assertNodeMatch (node, vnode, inVPre) {
	    if (isDef(vnode.tag)) {
	      return vnode.tag.indexOf('vue-component') === 0 || (
	        !isUnknownElement$$1(vnode, inVPre) &&
	        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
	      )
	    } else {
	      return node.nodeType === (vnode.isComment ? 8 : 3)
	    }
	  }
	
	  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
	    if (isUndef(vnode)) {
	      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
	      return
	    }
	
	    var isInitialPatch = false;
	    var insertedVnodeQueue = [];
	
	    if (isUndef(oldVnode)) {
	      // empty mount (likely as component), create new root element
	      isInitialPatch = true;
	      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
	    } else {
	      var isRealElement = isDef(oldVnode.nodeType);
	      if (!isRealElement && sameVnode(oldVnode, vnode)) {
	        // patch existing root node
	        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
	      } else {
	        if (isRealElement) {
	          // mounting to a real element
	          // check if this is server-rendered content and if we can perform
	          // a successful hydration.
	          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
	            oldVnode.removeAttribute(SSR_ATTR);
	            hydrating = true;
	          }
	          if (isTrue(hydrating)) {
	            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
	              invokeInsertHook(vnode, insertedVnodeQueue, true);
	              return oldVnode
	            } else {
	              warn(
	                'The client-side rendered virtual DOM tree is not matching ' +
	                'server-rendered content. This is likely caused by incorrect ' +
	                'HTML markup, for example nesting block-level elements inside ' +
	                '<p>, or missing <tbody>. Bailing hydration and performing ' +
	                'full client-side render.'
	              );
	            }
	          }
	          // either not server-rendered, or hydration failed.
	          // create an empty node and replace it
	          oldVnode = emptyNodeAt(oldVnode);
	        }
	
	        // replacing existing element
	        var oldElm = oldVnode.elm;
	        var parentElm$1 = nodeOps.parentNode(oldElm);
	
	        // create new node
	        createElm(
	          vnode,
	          insertedVnodeQueue,
	          // extremely rare edge case: do not insert if old element is in a
	          // leaving transition. Only happens when combining transition +
	          // keep-alive + HOCs. (#4590)
	          oldElm._leaveCb ? null : parentElm$1,
	          nodeOps.nextSibling(oldElm)
	        );
	
	        // update parent placeholder node element, recursively
	        if (isDef(vnode.parent)) {
	          var ancestor = vnode.parent;
	          var patchable = isPatchable(vnode);
	          while (ancestor) {
	            for (var i = 0; i < cbs.destroy.length; ++i) {
	              cbs.destroy[i](ancestor);
	            }
	            ancestor.elm = vnode.elm;
	            if (patchable) {
	              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	                cbs.create[i$1](emptyNode, ancestor);
	              }
	              // #6513
	              // invoke insert hooks that may have been merged by create hooks.
	              // e.g. for directives that uses the "inserted" hook.
	              var insert = ancestor.data.hook.insert;
	              if (insert.merged) {
	                // start at index 1 to avoid re-invoking component mounted hook
	                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
	                  insert.fns[i$2]();
	                }
	              }
	            } else {
	              registerRef(ancestor);
	            }
	            ancestor = ancestor.parent;
	          }
	        }
	
	        // destroy old node
	        if (isDef(parentElm$1)) {
	          removeVnodes(parentElm$1, [oldVnode], 0, 0);
	        } else if (isDef(oldVnode.tag)) {
	          invokeDestroyHook(oldVnode);
	        }
	      }
	    }
	
	    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
	    return vnode.elm
	  }
	}
	
	/*  */
	
	var directives = {
	  create: updateDirectives,
	  update: updateDirectives,
	  destroy: function unbindDirectives (vnode) {
	    updateDirectives(vnode, emptyNode);
	  }
	};
	
	function updateDirectives (oldVnode, vnode) {
	  if (oldVnode.data.directives || vnode.data.directives) {
	    _update(oldVnode, vnode);
	  }
	}
	
	function _update (oldVnode, vnode) {
	  var isCreate = oldVnode === emptyNode;
	  var isDestroy = vnode === emptyNode;
	  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
	  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
	
	  var dirsWithInsert = [];
	  var dirsWithPostpatch = [];
	
	  var key, oldDir, dir;
	  for (key in newDirs) {
	    oldDir = oldDirs[key];
	    dir = newDirs[key];
	    if (!oldDir) {
	      // new directive, bind
	      callHook$1(dir, 'bind', vnode, oldVnode);
	      if (dir.def && dir.def.inserted) {
	        dirsWithInsert.push(dir);
	      }
	    } else {
	      // existing directive, update
	      dir.oldValue = oldDir.value;
	      callHook$1(dir, 'update', vnode, oldVnode);
	      if (dir.def && dir.def.componentUpdated) {
	        dirsWithPostpatch.push(dir);
	      }
	    }
	  }
	
	  if (dirsWithInsert.length) {
	    var callInsert = function () {
	      for (var i = 0; i < dirsWithInsert.length; i++) {
	        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
	      }
	    };
	    if (isCreate) {
	      mergeVNodeHook(vnode, 'insert', callInsert);
	    } else {
	      callInsert();
	    }
	  }
	
	  if (dirsWithPostpatch.length) {
	    mergeVNodeHook(vnode, 'postpatch', function () {
	      for (var i = 0; i < dirsWithPostpatch.length; i++) {
	        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
	      }
	    });
	  }
	
	  if (!isCreate) {
	    for (key in oldDirs) {
	      if (!newDirs[key]) {
	        // no longer present, unbind
	        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
	      }
	    }
	  }
	}
	
	var emptyModifiers = Object.create(null);
	
	function normalizeDirectives$1 (
	  dirs,
	  vm
	) {
	  var res = Object.create(null);
	  if (!dirs) {
	    // $flow-disable-line
	    return res
	  }
	  var i, dir;
	  for (i = 0; i < dirs.length; i++) {
	    dir = dirs[i];
	    if (!dir.modifiers) {
	      // $flow-disable-line
	      dir.modifiers = emptyModifiers;
	    }
	    res[getRawDirName(dir)] = dir;
	    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
	  }
	  // $flow-disable-line
	  return res
	}
	
	function getRawDirName (dir) {
	  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
	}
	
	function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
	  var fn = dir.def && dir.def[hook];
	  if (fn) {
	    try {
	      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
	    } catch (e) {
	      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
	    }
	  }
	}
	
	var baseModules = [
	  ref,
	  directives
	];
	
	/*  */
	
	function updateAttrs (oldVnode, vnode) {
	  var opts = vnode.componentOptions;
	  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
	    return
	  }
	  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
	    return
	  }
	  var key, cur, old;
	  var elm = vnode.elm;
	  var oldAttrs = oldVnode.data.attrs || {};
	  var attrs = vnode.data.attrs || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(attrs.__ob__)) {
	    attrs = vnode.data.attrs = extend({}, attrs);
	  }
	
	  for (key in attrs) {
	    cur = attrs[key];
	    old = oldAttrs[key];
	    if (old !== cur) {
	      setAttr(elm, key, cur);
	    }
	  }
	  // #4391: in IE9, setting type can reset value for input[type=radio]
	  // #6666: IE/Edge forces progress value down to 1 before setting a max
	  /* istanbul ignore if */
	  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
	    setAttr(elm, 'value', attrs.value);
	  }
	  for (key in oldAttrs) {
	    if (isUndef(attrs[key])) {
	      if (isXlink(key)) {
	        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
	      } else if (!isEnumeratedAttr(key)) {
	        elm.removeAttribute(key);
	      }
	    }
	  }
	}
	
	function setAttr (el, key, value) {
	  if (isBooleanAttr(key)) {
	    // set attribute for blank value
	    // e.g. <option disabled>Select one</option>
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      // technically allowfullscreen is a boolean attribute for <iframe>,
	      // but Flash expects a value of "true" when used on <embed> tag
	      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
	        ? 'true'
	        : key;
	      el.setAttribute(key, value);
	    }
	  } else if (isEnumeratedAttr(key)) {
	    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
	  } else if (isXlink(key)) {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
	    } else {
	      el.setAttributeNS(xlinkNS, key, value);
	    }
	  } else {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      // #7138: IE10 & 11 fires input event when setting placeholder on
	      // <textarea>... block the first input event and remove the blocker
	      // immediately.
	      /* istanbul ignore if */
	      if (
	        isIE && !isIE9 &&
	        el.tagName === 'TEXTAREA' &&
	        key === 'placeholder' && !el.__ieph
	      ) {
	        var blocker = function (e) {
	          e.stopImmediatePropagation();
	          el.removeEventListener('input', blocker);
	        };
	        el.addEventListener('input', blocker);
	        // $flow-disable-line
	        el.__ieph = true; /* IE placeholder patched */
	      }
	      el.setAttribute(key, value);
	    }
	  }
	}
	
	var attrs = {
	  create: updateAttrs,
	  update: updateAttrs
	};
	
	/*  */
	
	function updateClass (oldVnode, vnode) {
	  var el = vnode.elm;
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	  if (
	    isUndef(data.staticClass) &&
	    isUndef(data.class) && (
	      isUndef(oldData) || (
	        isUndef(oldData.staticClass) &&
	        isUndef(oldData.class)
	      )
	    )
	  ) {
	    return
	  }
	
	  var cls = genClassForVnode(vnode);
	
	  // handle transition classes
	  var transitionClass = el._transitionClasses;
	  if (isDef(transitionClass)) {
	    cls = concat(cls, stringifyClass(transitionClass));
	  }
	
	  // set the class
	  if (cls !== el._prevClass) {
	    el.setAttribute('class', cls);
	    el._prevClass = cls;
	  }
	}
	
	var klass = {
	  create: updateClass,
	  update: updateClass
	};
	
	/*  */
	
	var validDivisionCharRE = /[\w).+\-_$\]]/;
	
	function parseFilters (exp) {
	  var inSingle = false;
	  var inDouble = false;
	  var inTemplateString = false;
	  var inRegex = false;
	  var curly = 0;
	  var square = 0;
	  var paren = 0;
	  var lastFilterIndex = 0;
	  var c, prev, i, expression, filters;
	
	  for (i = 0; i < exp.length; i++) {
	    prev = c;
	    c = exp.charCodeAt(i);
	    if (inSingle) {
	      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
	    } else if (inDouble) {
	      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
	    } else if (inTemplateString) {
	      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
	    } else if (inRegex) {
	      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
	    } else if (
	      c === 0x7C && // pipe
	      exp.charCodeAt(i + 1) !== 0x7C &&
	      exp.charCodeAt(i - 1) !== 0x7C &&
	      !curly && !square && !paren
	    ) {
	      if (expression === undefined) {
	        // first filter, end of expression
	        lastFilterIndex = i + 1;
	        expression = exp.slice(0, i).trim();
	      } else {
	        pushFilter();
	      }
	    } else {
	      switch (c) {
	        case 0x22: inDouble = true; break         // "
	        case 0x27: inSingle = true; break         // '
	        case 0x60: inTemplateString = true; break // `
	        case 0x28: paren++; break                 // (
	        case 0x29: paren--; break                 // )
	        case 0x5B: square++; break                // [
	        case 0x5D: square--; break                // ]
	        case 0x7B: curly++; break                 // {
	        case 0x7D: curly--; break                 // }
	      }
	      if (c === 0x2f) { // /
	        var j = i - 1;
	        var p = (void 0);
	        // find first non-whitespace prev char
	        for (; j >= 0; j--) {
	          p = exp.charAt(j);
	          if (p !== ' ') { break }
	        }
	        if (!p || !validDivisionCharRE.test(p)) {
	          inRegex = true;
	        }
	      }
	    }
	  }
	
	  if (expression === undefined) {
	    expression = exp.slice(0, i).trim();
	  } else if (lastFilterIndex !== 0) {
	    pushFilter();
	  }
	
	  function pushFilter () {
	    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
	    lastFilterIndex = i + 1;
	  }
	
	  if (filters) {
	    for (i = 0; i < filters.length; i++) {
	      expression = wrapFilter(expression, filters[i]);
	    }
	  }
	
	  return expression
	}
	
	function wrapFilter (exp, filter) {
	  var i = filter.indexOf('(');
	  if (i < 0) {
	    // _f: resolveFilter
	    return ("_f(\"" + filter + "\")(" + exp + ")")
	  } else {
	    var name = filter.slice(0, i);
	    var args = filter.slice(i + 1);
	    return ("_f(\"" + name + "\")(" + exp + "," + args)
	  }
	}
	
	/*  */
	
	function baseWarn (msg) {
	  console.error(("[Vue compiler]: " + msg));
	}
	
	function pluckModuleFunction (
	  modules,
	  key
	) {
	  return modules
	    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
	    : []
	}
	
	function addProp (el, name, value) {
	  (el.props || (el.props = [])).push({ name: name, value: value });
	  el.plain = false;
	}
	
	function addAttr (el, name, value) {
	  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
	  el.plain = false;
	}
	
	// add a raw attr (use this in preTransforms)
	function addRawAttr (el, name, value) {
	  el.attrsMap[name] = value;
	  el.attrsList.push({ name: name, value: value });
	}
	
	function addDirective (
	  el,
	  name,
	  rawName,
	  value,
	  arg,
	  modifiers
	) {
	  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
	  el.plain = false;
	}
	
	function addHandler (
	  el,
	  name,
	  value,
	  modifiers,
	  important,
	  warn
	) {
	  modifiers = modifiers || emptyObject;
	  // warn prevent and passive modifier
	  /* istanbul ignore if */
	  if (
	    "development" !== 'production' && warn &&
	    modifiers.prevent && modifiers.passive
	  ) {
	    warn(
	      'passive and prevent can\'t be used together. ' +
	      'Passive handler can\'t prevent default event.'
	    );
	  }
	
	  // check capture modifier
	  if (modifiers.capture) {
	    delete modifiers.capture;
	    name = '!' + name; // mark the event as captured
	  }
	  if (modifiers.once) {
	    delete modifiers.once;
	    name = '~' + name; // mark the event as once
	  }
	  /* istanbul ignore if */
	  if (modifiers.passive) {
	    delete modifiers.passive;
	    name = '&' + name; // mark the event as passive
	  }
	
	  // normalize click.right and click.middle since they don't actually fire
	  // this is technically browser-specific, but at least for now browsers are
	  // the only target envs that have right/middle clicks.
	  if (name === 'click') {
	    if (modifiers.right) {
	      name = 'contextmenu';
	      delete modifiers.right;
	    } else if (modifiers.middle) {
	      name = 'mouseup';
	    }
	  }
	
	  var events;
	  if (modifiers.native) {
	    delete modifiers.native;
	    events = el.nativeEvents || (el.nativeEvents = {});
	  } else {
	    events = el.events || (el.events = {});
	  }
	
	  var newHandler = { value: value };
	  if (modifiers !== emptyObject) {
	    newHandler.modifiers = modifiers;
	  }
	
	  var handlers = events[name];
	  /* istanbul ignore if */
	  if (Array.isArray(handlers)) {
	    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
	  } else if (handlers) {
	    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
	  } else {
	    events[name] = newHandler;
	  }
	
	  el.plain = false;
	}
	
	function getBindingAttr (
	  el,
	  name,
	  getStatic
	) {
	  var dynamicValue =
	    getAndRemoveAttr(el, ':' + name) ||
	    getAndRemoveAttr(el, 'v-bind:' + name);
	  if (dynamicValue != null) {
	    return parseFilters(dynamicValue)
	  } else if (getStatic !== false) {
	    var staticValue = getAndRemoveAttr(el, name);
	    if (staticValue != null) {
	      return JSON.stringify(staticValue)
	    }
	  }
	}
	
	// note: this only removes the attr from the Array (attrsList) so that it
	// doesn't get processed by processAttrs.
	// By default it does NOT remove it from the map (attrsMap) because the map is
	// needed during codegen.
	function getAndRemoveAttr (
	  el,
	  name,
	  removeFromMap
	) {
	  var val;
	  if ((val = el.attrsMap[name]) != null) {
	    var list = el.attrsList;
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (list[i].name === name) {
	        list.splice(i, 1);
	        break
	      }
	    }
	  }
	  if (removeFromMap) {
	    delete el.attrsMap[name];
	  }
	  return val
	}
	
	/*  */
	
	/**
	 * Cross-platform code generation for component v-model
	 */
	function genComponentModel (
	  el,
	  value,
	  modifiers
	) {
	  var ref = modifiers || {};
	  var number = ref.number;
	  var trim = ref.trim;
	
	  var baseValueExpression = '$$v';
	  var valueExpression = baseValueExpression;
	  if (trim) {
	    valueExpression =
	      "(typeof " + baseValueExpression + " === 'string'" +
	        "? " + baseValueExpression + ".trim()" +
	        ": " + baseValueExpression + ")";
	  }
	  if (number) {
	    valueExpression = "_n(" + valueExpression + ")";
	  }
	  var assignment = genAssignmentCode(value, valueExpression);
	
	  el.model = {
	    value: ("(" + value + ")"),
	    expression: ("\"" + value + "\""),
	    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
	  };
	}
	
	/**
	 * Cross-platform codegen helper for generating v-model value assignment code.
	 */
	function genAssignmentCode (
	  value,
	  assignment
	) {
	  var res = parseModel(value);
	  if (res.key === null) {
	    return (value + "=" + assignment)
	  } else {
	    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
	  }
	}
	
	/**
	 * Parse a v-model expression into a base path and a final key segment.
	 * Handles both dot-path and possible square brackets.
	 *
	 * Possible cases:
	 *
	 * - test
	 * - test[key]
	 * - test[test1[key]]
	 * - test["a"][key]
	 * - xxx.test[a[a].test1[key]]
	 * - test.xxx.a["asa"][test1[key]]
	 *
	 */
	
	var len;
	var str;
	var chr;
	var index$1;
	var expressionPos;
	var expressionEndPos;
	
	
	
	function parseModel (val) {
	  len = val.length;
	
	  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
	    index$1 = val.lastIndexOf('.');
	    if (index$1 > -1) {
	      return {
	        exp: val.slice(0, index$1),
	        key: '"' + val.slice(index$1 + 1) + '"'
	      }
	    } else {
	      return {
	        exp: val,
	        key: null
	      }
	    }
	  }
	
	  str = val;
	  index$1 = expressionPos = expressionEndPos = 0;
	
	  while (!eof()) {
	    chr = next();
	    /* istanbul ignore if */
	    if (isStringStart(chr)) {
	      parseString(chr);
	    } else if (chr === 0x5B) {
	      parseBracket(chr);
	    }
	  }
	
	  return {
	    exp: val.slice(0, expressionPos),
	    key: val.slice(expressionPos + 1, expressionEndPos)
	  }
	}
	
	function next () {
	  return str.charCodeAt(++index$1)
	}
	
	function eof () {
	  return index$1 >= len
	}
	
	function isStringStart (chr) {
	  return chr === 0x22 || chr === 0x27
	}
	
	function parseBracket (chr) {
	  var inBracket = 1;
	  expressionPos = index$1;
	  while (!eof()) {
	    chr = next();
	    if (isStringStart(chr)) {
	      parseString(chr);
	      continue
	    }
	    if (chr === 0x5B) { inBracket++; }
	    if (chr === 0x5D) { inBracket--; }
	    if (inBracket === 0) {
	      expressionEndPos = index$1;
	      break
	    }
	  }
	}
	
	function parseString (chr) {
	  var stringQuote = chr;
	  while (!eof()) {
	    chr = next();
	    if (chr === stringQuote) {
	      break
	    }
	  }
	}
	
	/*  */
	
	var warn$1;
	
	// in some cases, the event used has to be determined at runtime
	// so we used some reserved tokens during compile.
	var RANGE_TOKEN = '__r';
	var CHECKBOX_RADIO_TOKEN = '__c';
	
	function model (
	  el,
	  dir,
	  _warn
	) {
	  warn$1 = _warn;
	  var value = dir.value;
	  var modifiers = dir.modifiers;
	  var tag = el.tag;
	  var type = el.attrsMap.type;
	
	  {
	    // inputs with type="file" are read only and setting the input's
	    // value will throw an error.
	    if (tag === 'input' && type === 'file') {
	      warn$1(
	        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
	        "File inputs are read only. Use a v-on:change listener instead."
	      );
	    }
	  }
	
	  if (el.component) {
	    genComponentModel(el, value, modifiers);
	    // component v-model doesn't need extra runtime
	    return false
	  } else if (tag === 'select') {
	    genSelect(el, value, modifiers);
	  } else if (tag === 'input' && type === 'checkbox') {
	    genCheckboxModel(el, value, modifiers);
	  } else if (tag === 'input' && type === 'radio') {
	    genRadioModel(el, value, modifiers);
	  } else if (tag === 'input' || tag === 'textarea') {
	    genDefaultModel(el, value, modifiers);
	  } else if (!config.isReservedTag(tag)) {
	    genComponentModel(el, value, modifiers);
	    // component v-model doesn't need extra runtime
	    return false
	  } else {
	    warn$1(
	      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
	      "v-model is not supported on this element type. " +
	      'If you are working with contenteditable, it\'s recommended to ' +
	      'wrap a library dedicated for that purpose inside a custom component.'
	    );
	  }
	
	  // ensure runtime directive metadata
	  return true
	}
	
	function genCheckboxModel (
	  el,
	  value,
	  modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
	  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
	  addProp(el, 'checked',
	    "Array.isArray(" + value + ")" +
	    "?_i(" + value + "," + valueBinding + ")>-1" + (
	      trueValueBinding === 'true'
	        ? (":(" + value + ")")
	        : (":_q(" + value + "," + trueValueBinding + ")")
	    )
	  );
	  addHandler(el, 'change',
	    "var $$a=" + value + "," +
	        '$$el=$event.target,' +
	        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
	    'if(Array.isArray($$a)){' +
	      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
	          '$$i=_i($$a,$$v);' +
	      "if($$el.checked){$$i<0&&(" + value + "=$$a.concat([$$v]))}" +
	      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
	    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
	    null, true
	  );
	}
	
	function genRadioModel (
	  el,
	  value,
	  modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
	  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
	  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
	}
	
	function genSelect (
	  el,
	  value,
	  modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var selectedVal = "Array.prototype.filter" +
	    ".call($event.target.options,function(o){return o.selected})" +
	    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
	    "return " + (number ? '_n(val)' : 'val') + "})";
	
	  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
	  var code = "var $$selectedVal = " + selectedVal + ";";
	  code = code + " " + (genAssignmentCode(value, assignment));
	  addHandler(el, 'change', code, null, true);
	}
	
	function genDefaultModel (
	  el,
	  value,
	  modifiers
	) {
	  var type = el.attrsMap.type;
	
	  // warn if v-bind:value conflicts with v-model
	  {
	    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
	    if (value$1) {
	      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
	      warn$1(
	        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
	        'because the latter already expands to a value binding internally'
	      );
	    }
	  }
	
	  var ref = modifiers || {};
	  var lazy = ref.lazy;
	  var number = ref.number;
	  var trim = ref.trim;
	  var needCompositionGuard = !lazy && type !== 'range';
	  var event = lazy
	    ? 'change'
	    : type === 'range'
	      ? RANGE_TOKEN
	      : 'input';
	
	  var valueExpression = '$event.target.value';
	  if (trim) {
	    valueExpression = "$event.target.value.trim()";
	  }
	  if (number) {
	    valueExpression = "_n(" + valueExpression + ")";
	  }
	
	  var code = genAssignmentCode(value, valueExpression);
	  if (needCompositionGuard) {
	    code = "if($event.target.composing)return;" + code;
	  }
	
	  addProp(el, 'value', ("(" + value + ")"));
	  addHandler(el, event, code, null, true);
	  if (trim || number) {
	    addHandler(el, 'blur', '$forceUpdate()');
	  }
	}
	
	/*  */
	
	// normalize v-model event tokens that can only be determined at runtime.
	// it's important to place the event as the first in the array because
	// the whole point is ensuring the v-model callback gets called before
	// user-attached handlers.
	function normalizeEvents (on) {
	  /* istanbul ignore if */
	  if (isDef(on[RANGE_TOKEN])) {
	    // IE input[type=range] only supports `change` event
	    var event = isIE ? 'change' : 'input';
	    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
	    delete on[RANGE_TOKEN];
	  }
	  // This was originally intended to fix #4521 but no longer necessary
	  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
	  /* istanbul ignore if */
	  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
	    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
	    delete on[CHECKBOX_RADIO_TOKEN];
	  }
	}
	
	var target$1;
	
	function createOnceHandler (handler, event, capture) {
	  var _target = target$1; // save current target element in closure
	  return function onceHandler () {
	    var res = handler.apply(null, arguments);
	    if (res !== null) {
	      remove$2(event, onceHandler, capture, _target);
	    }
	  }
	}
	
	function add$1 (
	  event,
	  handler,
	  once$$1,
	  capture,
	  passive
	) {
	  handler = withMacroTask(handler);
	  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
	  target$1.addEventListener(
	    event,
	    handler,
	    supportsPassive
	      ? { capture: capture, passive: passive }
	      : capture
	  );
	}
	
	function remove$2 (
	  event,
	  handler,
	  capture,
	  _target
	) {
	  (_target || target$1).removeEventListener(
	    event,
	    handler._withTask || handler,
	    capture
	  );
	}
	
	function updateDOMListeners (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
	    return
	  }
	  var on = vnode.data.on || {};
	  var oldOn = oldVnode.data.on || {};
	  target$1 = vnode.elm;
	  normalizeEvents(on);
	  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
	  target$1 = undefined;
	}
	
	var events = {
	  create: updateDOMListeners,
	  update: updateDOMListeners
	};
	
	/*  */
	
	function updateDOMProps (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
	    return
	  }
	  var key, cur;
	  var elm = vnode.elm;
	  var oldProps = oldVnode.data.domProps || {};
	  var props = vnode.data.domProps || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(props.__ob__)) {
	    props = vnode.data.domProps = extend({}, props);
	  }
	
	  for (key in oldProps) {
	    if (isUndef(props[key])) {
	      elm[key] = '';
	    }
	  }
	  for (key in props) {
	    cur = props[key];
	    // ignore children if the node has textContent or innerHTML,
	    // as these will throw away existing DOM nodes and cause removal errors
	    // on subsequent patches (#3360)
	    if (key === 'textContent' || key === 'innerHTML') {
	      if (vnode.children) { vnode.children.length = 0; }
	      if (cur === oldProps[key]) { continue }
	      // #6601 work around Chrome version <= 55 bug where single textNode
	      // replaced by innerHTML/textContent retains its parentNode property
	      if (elm.childNodes.length === 1) {
	        elm.removeChild(elm.childNodes[0]);
	      }
	    }
	
	    if (key === 'value') {
	      // store value as _value as well since
	      // non-string values will be stringified
	      elm._value = cur;
	      // avoid resetting cursor position when value is the same
	      var strCur = isUndef(cur) ? '' : String(cur);
	      if (shouldUpdateValue(elm, strCur)) {
	        elm.value = strCur;
	      }
	    } else {
	      elm[key] = cur;
	    }
	  }
	}
	
	// check platforms/web/util/attrs.js acceptValue
	
	
	function shouldUpdateValue (elm, checkVal) {
	  return (!elm.composing && (
	    elm.tagName === 'OPTION' ||
	    isNotInFocusAndDirty(elm, checkVal) ||
	    isDirtyWithModifiers(elm, checkVal)
	  ))
	}
	
	function isNotInFocusAndDirty (elm, checkVal) {
	  // return true when textbox (.number and .trim) loses focus and its value is
	  // not equal to the updated value
	  var notInFocus = true;
	  // #6157
	  // work around IE bug when accessing document.activeElement in an iframe
	  try { notInFocus = document.activeElement !== elm; } catch (e) {}
	  return notInFocus && elm.value !== checkVal
	}
	
	function isDirtyWithModifiers (elm, newVal) {
	  var value = elm.value;
	  var modifiers = elm._vModifiers; // injected by v-model runtime
	  if (isDef(modifiers)) {
	    if (modifiers.lazy) {
	      // inputs with lazy should only be updated when not in focus
	      return false
	    }
	    if (modifiers.number) {
	      return toNumber(value) !== toNumber(newVal)
	    }
	    if (modifiers.trim) {
	      return value.trim() !== newVal.trim()
	    }
	  }
	  return value !== newVal
	}
	
	var domProps = {
	  create: updateDOMProps,
	  update: updateDOMProps
	};
	
	/*  */
	
	var parseStyleText = cached(function (cssText) {
	  var res = {};
	  var listDelimiter = /;(?![^(]*\))/g;
	  var propertyDelimiter = /:(.+)/;
	  cssText.split(listDelimiter).forEach(function (item) {
	    if (item) {
	      var tmp = item.split(propertyDelimiter);
	      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
	    }
	  });
	  return res
	});
	
	// merge static and dynamic style data on the same vnode
	function normalizeStyleData (data) {
	  var style = normalizeStyleBinding(data.style);
	  // static style is pre-processed into an object during compilation
	  // and is always a fresh object, so it's safe to merge into it
	  return data.staticStyle
	    ? extend(data.staticStyle, style)
	    : style
	}
	
	// normalize possible array / string values into Object
	function normalizeStyleBinding (bindingStyle) {
	  if (Array.isArray(bindingStyle)) {
	    return toObject(bindingStyle)
	  }
	  if (typeof bindingStyle === 'string') {
	    return parseStyleText(bindingStyle)
	  }
	  return bindingStyle
	}
	
	/**
	 * parent component style should be after child's
	 * so that parent component's style could override it
	 */
	function getStyle (vnode, checkChild) {
	  var res = {};
	  var styleData;
	
	  if (checkChild) {
	    var childNode = vnode;
	    while (childNode.componentInstance) {
	      childNode = childNode.componentInstance._vnode;
	      if (
	        childNode && childNode.data &&
	        (styleData = normalizeStyleData(childNode.data))
	      ) {
	        extend(res, styleData);
	      }
	    }
	  }
	
	  if ((styleData = normalizeStyleData(vnode.data))) {
	    extend(res, styleData);
	  }
	
	  var parentNode = vnode;
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
	      extend(res, styleData);
	    }
	  }
	  return res
	}
	
	/*  */
	
	var cssVarRE = /^--/;
	var importantRE = /\s*!important$/;
	var setProp = function (el, name, val) {
	  /* istanbul ignore if */
	  if (cssVarRE.test(name)) {
	    el.style.setProperty(name, val);
	  } else if (importantRE.test(val)) {
	    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
	  } else {
	    var normalizedName = normalize(name);
	    if (Array.isArray(val)) {
	      // Support values array created by autoprefixer, e.g.
	      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
	      // Set them one by one, and the browser will only set those it can recognize
	      for (var i = 0, len = val.length; i < len; i++) {
	        el.style[normalizedName] = val[i];
	      }
	    } else {
	      el.style[normalizedName] = val;
	    }
	  }
	};
	
	var vendorNames = ['Webkit', 'Moz', 'ms'];
	
	var emptyStyle;
	var normalize = cached(function (prop) {
	  emptyStyle = emptyStyle || document.createElement('div').style;
	  prop = camelize(prop);
	  if (prop !== 'filter' && (prop in emptyStyle)) {
	    return prop
	  }
	  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
	  for (var i = 0; i < vendorNames.length; i++) {
	    var name = vendorNames[i] + capName;
	    if (name in emptyStyle) {
	      return name
	    }
	  }
	});
	
	function updateStyle (oldVnode, vnode) {
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	
	  if (isUndef(data.staticStyle) && isUndef(data.style) &&
	    isUndef(oldData.staticStyle) && isUndef(oldData.style)
	  ) {
	    return
	  }
	
	  var cur, name;
	  var el = vnode.elm;
	  var oldStaticStyle = oldData.staticStyle;
	  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
	
	  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
	  var oldStyle = oldStaticStyle || oldStyleBinding;
	
	  var style = normalizeStyleBinding(vnode.data.style) || {};
	
	  // store normalized style under a different key for next diff
	  // make sure to clone it if it's reactive, since the user likely wants
	  // to mutate it.
	  vnode.data.normalizedStyle = isDef(style.__ob__)
	    ? extend({}, style)
	    : style;
	
	  var newStyle = getStyle(vnode, true);
	
	  for (name in oldStyle) {
	    if (isUndef(newStyle[name])) {
	      setProp(el, name, '');
	    }
	  }
	  for (name in newStyle) {
	    cur = newStyle[name];
	    if (cur !== oldStyle[name]) {
	      // ie9 setting to null has no effect, must use empty string
	      setProp(el, name, cur == null ? '' : cur);
	    }
	  }
	}
	
	var style = {
	  create: updateStyle,
	  update: updateStyle
	};
	
	/*  */
	
	/**
	 * Add class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function addClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
	    } else {
	      el.classList.add(cls);
	    }
	  } else {
	    var cur = " " + (el.getAttribute('class') || '') + " ";
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      el.setAttribute('class', (cur + cls).trim());
	    }
	  }
	}
	
	/**
	 * Remove class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function removeClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
	    } else {
	      el.classList.remove(cls);
	    }
	    if (!el.classList.length) {
	      el.removeAttribute('class');
	    }
	  } else {
	    var cur = " " + (el.getAttribute('class') || '') + " ";
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    cur = cur.trim();
	    if (cur) {
	      el.setAttribute('class', cur);
	    } else {
	      el.removeAttribute('class');
	    }
	  }
	}
	
	/*  */
	
	function resolveTransition (def) {
	  if (!def) {
	    return
	  }
	  /* istanbul ignore else */
	  if (typeof def === 'object') {
	    var res = {};
	    if (def.css !== false) {
	      extend(res, autoCssTransition(def.name || 'v'));
	    }
	    extend(res, def);
	    return res
	  } else if (typeof def === 'string') {
	    return autoCssTransition(def)
	  }
	}
	
	var autoCssTransition = cached(function (name) {
	  return {
	    enterClass: (name + "-enter"),
	    enterToClass: (name + "-enter-to"),
	    enterActiveClass: (name + "-enter-active"),
	    leaveClass: (name + "-leave"),
	    leaveToClass: (name + "-leave-to"),
	    leaveActiveClass: (name + "-leave-active")
	  }
	});
	
	var hasTransition = inBrowser && !isIE9;
	var TRANSITION = 'transition';
	var ANIMATION = 'animation';
	
	// Transition property/event sniffing
	var transitionProp = 'transition';
	var transitionEndEvent = 'transitionend';
	var animationProp = 'animation';
	var animationEndEvent = 'animationend';
	if (hasTransition) {
	  /* istanbul ignore if */
	  if (window.ontransitionend === undefined &&
	    window.onwebkittransitionend !== undefined
	  ) {
	    transitionProp = 'WebkitTransition';
	    transitionEndEvent = 'webkitTransitionEnd';
	  }
	  if (window.onanimationend === undefined &&
	    window.onwebkitanimationend !== undefined
	  ) {
	    animationProp = 'WebkitAnimation';
	    animationEndEvent = 'webkitAnimationEnd';
	  }
	}
	
	// binding to window is necessary to make hot reload work in IE in strict mode
	var raf = inBrowser
	  ? window.requestAnimationFrame
	    ? window.requestAnimationFrame.bind(window)
	    : setTimeout
	  : /* istanbul ignore next */ function (fn) { return fn(); };
	
	function nextFrame (fn) {
	  raf(function () {
	    raf(fn);
	  });
	}
	
	function addTransitionClass (el, cls) {
	  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
	  if (transitionClasses.indexOf(cls) < 0) {
	    transitionClasses.push(cls);
	    addClass(el, cls);
	  }
	}
	
	function removeTransitionClass (el, cls) {
	  if (el._transitionClasses) {
	    remove(el._transitionClasses, cls);
	  }
	  removeClass(el, cls);
	}
	
	function whenTransitionEnds (
	  el,
	  expectedType,
	  cb
	) {
	  var ref = getTransitionInfo(el, expectedType);
	  var type = ref.type;
	  var timeout = ref.timeout;
	  var propCount = ref.propCount;
	  if (!type) { return cb() }
	  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
	  var ended = 0;
	  var end = function () {
	    el.removeEventListener(event, onEnd);
	    cb();
	  };
	  var onEnd = function (e) {
	    if (e.target === el) {
	      if (++ended >= propCount) {
	        end();
	      }
	    }
	  };
	  setTimeout(function () {
	    if (ended < propCount) {
	      end();
	    }
	  }, timeout + 1);
	  el.addEventListener(event, onEnd);
	}
	
	var transformRE = /\b(transform|all)(,|$)/;
	
	function getTransitionInfo (el, expectedType) {
	  var styles = window.getComputedStyle(el);
	  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
	  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
	  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
	  var animationDelays = styles[animationProp + 'Delay'].split(', ');
	  var animationDurations = styles[animationProp + 'Duration'].split(', ');
	  var animationTimeout = getTimeout(animationDelays, animationDurations);
	
	  var type;
	  var timeout = 0;
	  var propCount = 0;
	  /* istanbul ignore if */
	  if (expectedType === TRANSITION) {
	    if (transitionTimeout > 0) {
	      type = TRANSITION;
	      timeout = transitionTimeout;
	      propCount = transitionDurations.length;
	    }
	  } else if (expectedType === ANIMATION) {
	    if (animationTimeout > 0) {
	      type = ANIMATION;
	      timeout = animationTimeout;
	      propCount = animationDurations.length;
	    }
	  } else {
	    timeout = Math.max(transitionTimeout, animationTimeout);
	    type = timeout > 0
	      ? transitionTimeout > animationTimeout
	        ? TRANSITION
	        : ANIMATION
	      : null;
	    propCount = type
	      ? type === TRANSITION
	        ? transitionDurations.length
	        : animationDurations.length
	      : 0;
	  }
	  var hasTransform =
	    type === TRANSITION &&
	    transformRE.test(styles[transitionProp + 'Property']);
	  return {
	    type: type,
	    timeout: timeout,
	    propCount: propCount,
	    hasTransform: hasTransform
	  }
	}
	
	function getTimeout (delays, durations) {
	  /* istanbul ignore next */
	  while (delays.length < durations.length) {
	    delays = delays.concat(delays);
	  }
	
	  return Math.max.apply(null, durations.map(function (d, i) {
	    return toMs(d) + toMs(delays[i])
	  }))
	}
	
	function toMs (s) {
	  return Number(s.slice(0, -1)) * 1000
	}
	
	/*  */
	
	function enter (vnode, toggleDisplay) {
	  var el = vnode.elm;
	
	  // call leave callback now
	  if (isDef(el._leaveCb)) {
	    el._leaveCb.cancelled = true;
	    el._leaveCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data)) {
	    return
	  }
	
	  /* istanbul ignore if */
	  if (isDef(el._enterCb) || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var enterClass = data.enterClass;
	  var enterToClass = data.enterToClass;
	  var enterActiveClass = data.enterActiveClass;
	  var appearClass = data.appearClass;
	  var appearToClass = data.appearToClass;
	  var appearActiveClass = data.appearActiveClass;
	  var beforeEnter = data.beforeEnter;
	  var enter = data.enter;
	  var afterEnter = data.afterEnter;
	  var enterCancelled = data.enterCancelled;
	  var beforeAppear = data.beforeAppear;
	  var appear = data.appear;
	  var afterAppear = data.afterAppear;
	  var appearCancelled = data.appearCancelled;
	  var duration = data.duration;
	
	  // activeInstance will always be the <transition> component managing this
	  // transition. One edge case to check is when the <transition> is placed
	  // as the root node of a child component. In that case we need to check
	  // <transition>'s parent for appear check.
	  var context = activeInstance;
	  var transitionNode = activeInstance.$vnode;
	  while (transitionNode && transitionNode.parent) {
	    transitionNode = transitionNode.parent;
	    context = transitionNode.context;
	  }
	
	  var isAppear = !context._isMounted || !vnode.isRootInsert;
	
	  if (isAppear && !appear && appear !== '') {
	    return
	  }
	
	  var startClass = isAppear && appearClass
	    ? appearClass
	    : enterClass;
	  var activeClass = isAppear && appearActiveClass
	    ? appearActiveClass
	    : enterActiveClass;
	  var toClass = isAppear && appearToClass
	    ? appearToClass
	    : enterToClass;
	
	  var beforeEnterHook = isAppear
	    ? (beforeAppear || beforeEnter)
	    : beforeEnter;
	  var enterHook = isAppear
	    ? (typeof appear === 'function' ? appear : enter)
	    : enter;
	  var afterEnterHook = isAppear
	    ? (afterAppear || afterEnter)
	    : afterEnter;
	  var enterCancelledHook = isAppear
	    ? (appearCancelled || enterCancelled)
	    : enterCancelled;
	
	  var explicitEnterDuration = toNumber(
	    isObject(duration)
	      ? duration.enter
	      : duration
	  );
	
	  if ("development" !== 'production' && explicitEnterDuration != null) {
	    checkDuration(explicitEnterDuration, 'enter', vnode);
	  }
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(enterHook);
	
	  var cb = el._enterCb = once(function () {
	    if (expectsCSS) {
	      removeTransitionClass(el, toClass);
	      removeTransitionClass(el, activeClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, startClass);
	      }
	      enterCancelledHook && enterCancelledHook(el);
	    } else {
	      afterEnterHook && afterEnterHook(el);
	    }
	    el._enterCb = null;
	  });
	
	  if (!vnode.data.show) {
	    // remove pending leave element on enter by injecting an insert hook
	    mergeVNodeHook(vnode, 'insert', function () {
	      var parent = el.parentNode;
	      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
	      if (pendingNode &&
	        pendingNode.tag === vnode.tag &&
	        pendingNode.elm._leaveCb
	      ) {
	        pendingNode.elm._leaveCb();
	      }
	      enterHook && enterHook(el, cb);
	    });
	  }
	
	  // start enter transition
	  beforeEnterHook && beforeEnterHook(el);
	  if (expectsCSS) {
	    addTransitionClass(el, startClass);
	    addTransitionClass(el, activeClass);
	    nextFrame(function () {
	      addTransitionClass(el, toClass);
	      removeTransitionClass(el, startClass);
	      if (!cb.cancelled && !userWantsControl) {
	        if (isValidDuration(explicitEnterDuration)) {
	          setTimeout(cb, explicitEnterDuration);
	        } else {
	          whenTransitionEnds(el, type, cb);
	        }
	      }
	    });
	  }
	
	  if (vnode.data.show) {
	    toggleDisplay && toggleDisplay();
	    enterHook && enterHook(el, cb);
	  }
	
	  if (!expectsCSS && !userWantsControl) {
	    cb();
	  }
	}
	
	function leave (vnode, rm) {
	  var el = vnode.elm;
	
	  // call enter callback now
	  if (isDef(el._enterCb)) {
	    el._enterCb.cancelled = true;
	    el._enterCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data) || el.nodeType !== 1) {
	    return rm()
	  }
	
	  /* istanbul ignore if */
	  if (isDef(el._leaveCb)) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var leaveClass = data.leaveClass;
	  var leaveToClass = data.leaveToClass;
	  var leaveActiveClass = data.leaveActiveClass;
	  var beforeLeave = data.beforeLeave;
	  var leave = data.leave;
	  var afterLeave = data.afterLeave;
	  var leaveCancelled = data.leaveCancelled;
	  var delayLeave = data.delayLeave;
	  var duration = data.duration;
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(leave);
	
	  var explicitLeaveDuration = toNumber(
	    isObject(duration)
	      ? duration.leave
	      : duration
	  );
	
	  if ("development" !== 'production' && isDef(explicitLeaveDuration)) {
	    checkDuration(explicitLeaveDuration, 'leave', vnode);
	  }
	
	  var cb = el._leaveCb = once(function () {
	    if (el.parentNode && el.parentNode._pending) {
	      el.parentNode._pending[vnode.key] = null;
	    }
	    if (expectsCSS) {
	      removeTransitionClass(el, leaveToClass);
	      removeTransitionClass(el, leaveActiveClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, leaveClass);
	      }
	      leaveCancelled && leaveCancelled(el);
	    } else {
	      rm();
	      afterLeave && afterLeave(el);
	    }
	    el._leaveCb = null;
	  });
	
	  if (delayLeave) {
	    delayLeave(performLeave);
	  } else {
	    performLeave();
	  }
	
	  function performLeave () {
	    // the delayed leave may have already been cancelled
	    if (cb.cancelled) {
	      return
	    }
	    // record leaving element
	    if (!vnode.data.show) {
	      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
	    }
	    beforeLeave && beforeLeave(el);
	    if (expectsCSS) {
	      addTransitionClass(el, leaveClass);
	      addTransitionClass(el, leaveActiveClass);
	      nextFrame(function () {
	        addTransitionClass(el, leaveToClass);
	        removeTransitionClass(el, leaveClass);
	        if (!cb.cancelled && !userWantsControl) {
	          if (isValidDuration(explicitLeaveDuration)) {
	            setTimeout(cb, explicitLeaveDuration);
	          } else {
	            whenTransitionEnds(el, type, cb);
	          }
	        }
	      });
	    }
	    leave && leave(el, cb);
	    if (!expectsCSS && !userWantsControl) {
	      cb();
	    }
	  }
	}
	
	// only used in dev mode
	function checkDuration (val, name, vnode) {
	  if (typeof val !== 'number') {
	    warn(
	      "<transition> explicit " + name + " duration is not a valid number - " +
	      "got " + (JSON.stringify(val)) + ".",
	      vnode.context
	    );
	  } else if (isNaN(val)) {
	    warn(
	      "<transition> explicit " + name + " duration is NaN - " +
	      'the duration expression might be incorrect.',
	      vnode.context
	    );
	  }
	}
	
	function isValidDuration (val) {
	  return typeof val === 'number' && !isNaN(val)
	}
	
	/**
	 * Normalize a transition hook's argument length. The hook may be:
	 * - a merged hook (invoker) with the original in .fns
	 * - a wrapped component method (check ._length)
	 * - a plain function (.length)
	 */
	function getHookArgumentsLength (fn) {
	  if (isUndef(fn)) {
	    return false
	  }
	  var invokerFns = fn.fns;
	  if (isDef(invokerFns)) {
	    // invoker
	    return getHookArgumentsLength(
	      Array.isArray(invokerFns)
	        ? invokerFns[0]
	        : invokerFns
	    )
	  } else {
	    return (fn._length || fn.length) > 1
	  }
	}
	
	function _enter (_, vnode) {
	  if (vnode.data.show !== true) {
	    enter(vnode);
	  }
	}
	
	var transition = inBrowser ? {
	  create: _enter,
	  activate: _enter,
	  remove: function remove$$1 (vnode, rm) {
	    /* istanbul ignore else */
	    if (vnode.data.show !== true) {
	      leave(vnode, rm);
	    } else {
	      rm();
	    }
	  }
	} : {};
	
	var platformModules = [
	  attrs,
	  klass,
	  events,
	  domProps,
	  style,
	  transition
	];
	
	/*  */
	
	// the directive module should be applied last, after all
	// built-in modules have been applied.
	var modules = platformModules.concat(baseModules);
	
	var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });
	
	/**
	 * Not type checking this file because flow doesn't like attaching
	 * properties to Elements.
	 */
	
	/* istanbul ignore if */
	if (isIE9) {
	  // http://www.matts411.com/post/internet-explorer-9-oninput/
	  document.addEventListener('selectionchange', function () {
	    var el = document.activeElement;
	    if (el && el.vmodel) {
	      trigger(el, 'input');
	    }
	  });
	}
	
	var directive = {
	  inserted: function inserted (el, binding, vnode, oldVnode) {
	    if (vnode.tag === 'select') {
	      // #6903
	      if (oldVnode.elm && !oldVnode.elm._vOptions) {
	        mergeVNodeHook(vnode, 'postpatch', function () {
	          directive.componentUpdated(el, binding, vnode);
	        });
	      } else {
	        setSelected(el, binding, vnode.context);
	      }
	      el._vOptions = [].map.call(el.options, getValue);
	    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
	      el._vModifiers = binding.modifiers;
	      if (!binding.modifiers.lazy) {
	        // Safari < 10.2 & UIWebView doesn't fire compositionend when
	        // switching focus before confirming composition choice
	        // this also fixes the issue where some browsers e.g. iOS Chrome
	        // fires "change" instead of "input" on autocomplete.
	        el.addEventListener('change', onCompositionEnd);
	        if (!isAndroid) {
	          el.addEventListener('compositionstart', onCompositionStart);
	          el.addEventListener('compositionend', onCompositionEnd);
	        }
	        /* istanbul ignore if */
	        if (isIE9) {
	          el.vmodel = true;
	        }
	      }
	    }
	  },
	
	  componentUpdated: function componentUpdated (el, binding, vnode) {
	    if (vnode.tag === 'select') {
	      setSelected(el, binding, vnode.context);
	      // in case the options rendered by v-for have changed,
	      // it's possible that the value is out-of-sync with the rendered options.
	      // detect such cases and filter out values that no longer has a matching
	      // option in the DOM.
	      var prevOptions = el._vOptions;
	      var curOptions = el._vOptions = [].map.call(el.options, getValue);
	      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
	        // trigger change event if
	        // no matching option found for at least one value
	        var needReset = el.multiple
	          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
	          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
	        if (needReset) {
	          trigger(el, 'change');
	        }
	      }
	    }
	  }
	};
	
	function setSelected (el, binding, vm) {
	  actuallySetSelected(el, binding, vm);
	  /* istanbul ignore if */
	  if (isIE || isEdge) {
	    setTimeout(function () {
	      actuallySetSelected(el, binding, vm);
	    }, 0);
	  }
	}
	
	function actuallySetSelected (el, binding, vm) {
	  var value = binding.value;
	  var isMultiple = el.multiple;
	  if (isMultiple && !Array.isArray(value)) {
	    "development" !== 'production' && warn(
	      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
	      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
	      vm
	    );
	    return
	  }
	  var selected, option;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    option = el.options[i];
	    if (isMultiple) {
	      selected = looseIndexOf(value, getValue(option)) > -1;
	      if (option.selected !== selected) {
	        option.selected = selected;
	      }
	    } else {
	      if (looseEqual(getValue(option), value)) {
	        if (el.selectedIndex !== i) {
	          el.selectedIndex = i;
	        }
	        return
	      }
	    }
	  }
	  if (!isMultiple) {
	    el.selectedIndex = -1;
	  }
	}
	
	function hasNoMatchingOption (value, options) {
	  return options.every(function (o) { return !looseEqual(o, value); })
	}
	
	function getValue (option) {
	  return '_value' in option
	    ? option._value
	    : option.value
	}
	
	function onCompositionStart (e) {
	  e.target.composing = true;
	}
	
	function onCompositionEnd (e) {
	  // prevent triggering an input event for no reason
	  if (!e.target.composing) { return }
	  e.target.composing = false;
	  trigger(e.target, 'input');
	}
	
	function trigger (el, type) {
	  var e = document.createEvent('HTMLEvents');
	  e.initEvent(type, true, true);
	  el.dispatchEvent(e);
	}
	
	/*  */
	
	// recursively search for possible transition defined inside the component root
	function locateNode (vnode) {
	  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
	    ? locateNode(vnode.componentInstance._vnode)
	    : vnode
	}
	
	var show = {
	  bind: function bind (el, ref, vnode) {
	    var value = ref.value;
	
	    vnode = locateNode(vnode);
	    var transition$$1 = vnode.data && vnode.data.transition;
	    var originalDisplay = el.__vOriginalDisplay =
	      el.style.display === 'none' ? '' : el.style.display;
	    if (value && transition$$1) {
	      vnode.data.show = true;
	      enter(vnode, function () {
	        el.style.display = originalDisplay;
	      });
	    } else {
	      el.style.display = value ? originalDisplay : 'none';
	    }
	  },
	
	  update: function update (el, ref, vnode) {
	    var value = ref.value;
	    var oldValue = ref.oldValue;
	
	    /* istanbul ignore if */
	    if (value === oldValue) { return }
	    vnode = locateNode(vnode);
	    var transition$$1 = vnode.data && vnode.data.transition;
	    if (transition$$1) {
	      vnode.data.show = true;
	      if (value) {
	        enter(vnode, function () {
	          el.style.display = el.__vOriginalDisplay;
	        });
	      } else {
	        leave(vnode, function () {
	          el.style.display = 'none';
	        });
	      }
	    } else {
	      el.style.display = value ? el.__vOriginalDisplay : 'none';
	    }
	  },
	
	  unbind: function unbind (
	    el,
	    binding,
	    vnode,
	    oldVnode,
	    isDestroy
	  ) {
	    if (!isDestroy) {
	      el.style.display = el.__vOriginalDisplay;
	    }
	  }
	};
	
	var platformDirectives = {
	  model: directive,
	  show: show
	};
	
	/*  */
	
	// Provides transition support for a single element/component.
	// supports transition mode (out-in / in-out)
	
	var transitionProps = {
	  name: String,
	  appear: Boolean,
	  css: Boolean,
	  mode: String,
	  type: String,
	  enterClass: String,
	  leaveClass: String,
	  enterToClass: String,
	  leaveToClass: String,
	  enterActiveClass: String,
	  leaveActiveClass: String,
	  appearClass: String,
	  appearActiveClass: String,
	  appearToClass: String,
	  duration: [Number, String, Object]
	};
	
	// in case the child is also an abstract component, e.g. <keep-alive>
	// we want to recursively retrieve the real component to be rendered
	function getRealChild (vnode) {
	  var compOptions = vnode && vnode.componentOptions;
	  if (compOptions && compOptions.Ctor.options.abstract) {
	    return getRealChild(getFirstComponentChild(compOptions.children))
	  } else {
	    return vnode
	  }
	}
	
	function extractTransitionData (comp) {
	  var data = {};
	  var options = comp.$options;
	  // props
	  for (var key in options.propsData) {
	    data[key] = comp[key];
	  }
	  // events.
	  // extract listeners and pass them directly to the transition methods
	  var listeners = options._parentListeners;
	  for (var key$1 in listeners) {
	    data[camelize(key$1)] = listeners[key$1];
	  }
	  return data
	}
	
	function placeholder (h, rawChild) {
	  if (/\d-keep-alive$/.test(rawChild.tag)) {
	    return h('keep-alive', {
	      props: rawChild.componentOptions.propsData
	    })
	  }
	}
	
	function hasParentTransition (vnode) {
	  while ((vnode = vnode.parent)) {
	    if (vnode.data.transition) {
	      return true
	    }
	  }
	}
	
	function isSameChild (child, oldChild) {
	  return oldChild.key === child.key && oldChild.tag === child.tag
	}
	
	var Transition = {
	  name: 'transition',
	  props: transitionProps,
	  abstract: true,
	
	  render: function render (h) {
	    var this$1 = this;
	
	    var children = this.$slots.default;
	    if (!children) {
	      return
	    }
	
	    // filter out text nodes (possible whitespaces)
	    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
	    /* istanbul ignore if */
	    if (!children.length) {
	      return
	    }
	
	    // warn multiple elements
	    if ("development" !== 'production' && children.length > 1) {
	      warn(
	        '<transition> can only be used on a single element. Use ' +
	        '<transition-group> for lists.',
	        this.$parent
	      );
	    }
	
	    var mode = this.mode;
	
	    // warn invalid mode
	    if ("development" !== 'production' &&
	      mode && mode !== 'in-out' && mode !== 'out-in'
	    ) {
	      warn(
	        'invalid <transition> mode: ' + mode,
	        this.$parent
	      );
	    }
	
	    var rawChild = children[0];
	
	    // if this is a component root node and the component's
	    // parent container node also has transition, skip.
	    if (hasParentTransition(this.$vnode)) {
	      return rawChild
	    }
	
	    // apply transition data to child
	    // use getRealChild() to ignore abstract components e.g. keep-alive
	    var child = getRealChild(rawChild);
	    /* istanbul ignore if */
	    if (!child) {
	      return rawChild
	    }
	
	    if (this._leaving) {
	      return placeholder(h, rawChild)
	    }
	
	    // ensure a key that is unique to the vnode type and to this transition
	    // component instance. This key will be used to remove pending leaving nodes
	    // during entering.
	    var id = "__transition-" + (this._uid) + "-";
	    child.key = child.key == null
	      ? child.isComment
	        ? id + 'comment'
	        : id + child.tag
	      : isPrimitive(child.key)
	        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
	        : child.key;
	
	    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
	    var oldRawChild = this._vnode;
	    var oldChild = getRealChild(oldRawChild);
	
	    // mark v-show
	    // so that the transition module can hand over the control to the directive
	    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
	      child.data.show = true;
	    }
	
	    if (
	      oldChild &&
	      oldChild.data &&
	      !isSameChild(child, oldChild) &&
	      !isAsyncPlaceholder(oldChild) &&
	      // #6687 component root is a comment node
	      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
	    ) {
	      // replace old child transition data with fresh one
	      // important for dynamic transitions!
	      var oldData = oldChild.data.transition = extend({}, data);
	      // handle transition mode
	      if (mode === 'out-in') {
	        // return placeholder node and queue update when leave finishes
	        this._leaving = true;
	        mergeVNodeHook(oldData, 'afterLeave', function () {
	          this$1._leaving = false;
	          this$1.$forceUpdate();
	        });
	        return placeholder(h, rawChild)
	      } else if (mode === 'in-out') {
	        if (isAsyncPlaceholder(child)) {
	          return oldRawChild
	        }
	        var delayedLeave;
	        var performLeave = function () { delayedLeave(); };
	        mergeVNodeHook(data, 'afterEnter', performLeave);
	        mergeVNodeHook(data, 'enterCancelled', performLeave);
	        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
	      }
	    }
	
	    return rawChild
	  }
	};
	
	/*  */
	
	// Provides transition support for list items.
	// supports move transitions using the FLIP technique.
	
	// Because the vdom's children update algorithm is "unstable" - i.e.
	// it doesn't guarantee the relative positioning of removed elements,
	// we force transition-group to update its children into two passes:
	// in the first pass, we remove all nodes that need to be removed,
	// triggering their leaving transition; in the second pass, we insert/move
	// into the final desired state. This way in the second pass removed
	// nodes will remain where they should be.
	
	var props = extend({
	  tag: String,
	  moveClass: String
	}, transitionProps);
	
	delete props.mode;
	
	var TransitionGroup = {
	  props: props,
	
	  render: function render (h) {
	    var tag = this.tag || this.$vnode.data.tag || 'span';
	    var map = Object.create(null);
	    var prevChildren = this.prevChildren = this.children;
	    var rawChildren = this.$slots.default || [];
	    var children = this.children = [];
	    var transitionData = extractTransitionData(this);
	
	    for (var i = 0; i < rawChildren.length; i++) {
	      var c = rawChildren[i];
	      if (c.tag) {
	        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
	          children.push(c);
	          map[c.key] = c
	          ;(c.data || (c.data = {})).transition = transitionData;
	        } else {
	          var opts = c.componentOptions;
	          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
	          warn(("<transition-group> children must be keyed: <" + name + ">"));
	        }
	      }
	    }
	
	    if (prevChildren) {
	      var kept = [];
	      var removed = [];
	      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
	        var c$1 = prevChildren[i$1];
	        c$1.data.transition = transitionData;
	        c$1.data.pos = c$1.elm.getBoundingClientRect();
	        if (map[c$1.key]) {
	          kept.push(c$1);
	        } else {
	          removed.push(c$1);
	        }
	      }
	      this.kept = h(tag, null, kept);
	      this.removed = removed;
	    }
	
	    return h(tag, null, children)
	  },
	
	  beforeUpdate: function beforeUpdate () {
	    // force removing pass
	    this.__patch__(
	      this._vnode,
	      this.kept,
	      false, // hydrating
	      true // removeOnly (!important avoids unnecessary moves)
	    );
	    this._vnode = this.kept;
	  },
	
	  updated: function updated () {
	    var children = this.prevChildren;
	    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
	    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
	      return
	    }
	
	    // we divide the work into three loops to avoid mixing DOM reads and writes
	    // in each iteration - which helps prevent layout thrashing.
	    children.forEach(callPendingCbs);
	    children.forEach(recordPosition);
	    children.forEach(applyTranslation);
	
	    // force reflow to put everything in position
	    // assign to this to avoid being removed in tree-shaking
	    // $flow-disable-line
	    this._reflow = document.body.offsetHeight;
	
	    children.forEach(function (c) {
	      if (c.data.moved) {
	        var el = c.elm;
	        var s = el.style;
	        addTransitionClass(el, moveClass);
	        s.transform = s.WebkitTransform = s.transitionDuration = '';
	        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
	          if (!e || /transform$/.test(e.propertyName)) {
	            el.removeEventListener(transitionEndEvent, cb);
	            el._moveCb = null;
	            removeTransitionClass(el, moveClass);
	          }
	        });
	      }
	    });
	  },
	
	  methods: {
	    hasMove: function hasMove (el, moveClass) {
	      /* istanbul ignore if */
	      if (!hasTransition) {
	        return false
	      }
	      /* istanbul ignore if */
	      if (this._hasMove) {
	        return this._hasMove
	      }
	      // Detect whether an element with the move class applied has
	      // CSS transitions. Since the element may be inside an entering
	      // transition at this very moment, we make a clone of it and remove
	      // all other transition classes applied to ensure only the move class
	      // is applied.
	      var clone = el.cloneNode();
	      if (el._transitionClasses) {
	        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
	      }
	      addClass(clone, moveClass);
	      clone.style.display = 'none';
	      this.$el.appendChild(clone);
	      var info = getTransitionInfo(clone);
	      this.$el.removeChild(clone);
	      return (this._hasMove = info.hasTransform)
	    }
	  }
	};
	
	function callPendingCbs (c) {
	  /* istanbul ignore if */
	  if (c.elm._moveCb) {
	    c.elm._moveCb();
	  }
	  /* istanbul ignore if */
	  if (c.elm._enterCb) {
	    c.elm._enterCb();
	  }
	}
	
	function recordPosition (c) {
	  c.data.newPos = c.elm.getBoundingClientRect();
	}
	
	function applyTranslation (c) {
	  var oldPos = c.data.pos;
	  var newPos = c.data.newPos;
	  var dx = oldPos.left - newPos.left;
	  var dy = oldPos.top - newPos.top;
	  if (dx || dy) {
	    c.data.moved = true;
	    var s = c.elm.style;
	    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
	    s.transitionDuration = '0s';
	  }
	}
	
	var platformComponents = {
	  Transition: Transition,
	  TransitionGroup: TransitionGroup
	};
	
	/*  */
	
	// install platform specific utils
	Vue$3.config.mustUseProp = mustUseProp;
	Vue$3.config.isReservedTag = isReservedTag;
	Vue$3.config.isReservedAttr = isReservedAttr;
	Vue$3.config.getTagNamespace = getTagNamespace;
	Vue$3.config.isUnknownElement = isUnknownElement;
	
	// install platform runtime directives & components
	extend(Vue$3.options.directives, platformDirectives);
	extend(Vue$3.options.components, platformComponents);
	
	// install platform patch function
	Vue$3.prototype.__patch__ = inBrowser ? patch : noop;
	
	// public mount method
	Vue$3.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && inBrowser ? query(el) : undefined;
	  return mountComponent(this, el, hydrating)
	};
	
	// devtools global hook
	/* istanbul ignore next */
	Vue$3.nextTick(function () {
	  if (config.devtools) {
	    if (devtools) {
	      devtools.emit('init', Vue$3);
	    } else if ("development" !== 'production' && isChrome) {
	      console[console.info ? 'info' : 'log'](
	        'Download the Vue Devtools extension for a better development experience:\n' +
	        'https://github.com/vuejs/vue-devtools'
	      );
	    }
	  }
	  if ("development" !== 'production' &&
	    config.productionTip !== false &&
	    inBrowser && typeof console !== 'undefined'
	  ) {
	    console[console.info ? 'info' : 'log'](
	      "You are running Vue in development mode.\n" +
	      "Make sure to turn on production mode when deploying for production.\n" +
	      "See more tips at https://vuejs.org/guide/deployment.html"
	    );
	  }
	}, 0);
	
	/*  */
	
	var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
	var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	
	var buildRegex = cached(function (delimiters) {
	  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
	  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
	  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
	});
	
	
	
	function parseText (
	  text,
	  delimiters
	) {
	  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
	  if (!tagRE.test(text)) {
	    return
	  }
	  var tokens = [];
	  var rawTokens = [];
	  var lastIndex = tagRE.lastIndex = 0;
	  var match, index, tokenValue;
	  while ((match = tagRE.exec(text))) {
	    index = match.index;
	    // push text token
	    if (index > lastIndex) {
	      rawTokens.push(tokenValue = text.slice(lastIndex, index));
	      tokens.push(JSON.stringify(tokenValue));
	    }
	    // tag token
	    var exp = parseFilters(match[1].trim());
	    tokens.push(("_s(" + exp + ")"));
	    rawTokens.push({ '@binding': exp });
	    lastIndex = index + match[0].length;
	  }
	  if (lastIndex < text.length) {
	    rawTokens.push(tokenValue = text.slice(lastIndex));
	    tokens.push(JSON.stringify(tokenValue));
	  }
	  return {
	    expression: tokens.join('+'),
	    tokens: rawTokens
	  }
	}
	
	/*  */
	
	function transformNode (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticClass = getAndRemoveAttr(el, 'class');
	  if ("development" !== 'production' && staticClass) {
	    var res = parseText(staticClass, options.delimiters);
	    if (res) {
	      warn(
	        "class=\"" + staticClass + "\": " +
	        'Interpolation inside attributes has been removed. ' +
	        'Use v-bind or the colon shorthand instead. For example, ' +
	        'instead of <div class="{{ val }}">, use <div :class="val">.'
	      );
	    }
	  }
	  if (staticClass) {
	    el.staticClass = JSON.stringify(staticClass);
	  }
	  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
	  if (classBinding) {
	    el.classBinding = classBinding;
	  }
	}
	
	function genData (el) {
	  var data = '';
	  if (el.staticClass) {
	    data += "staticClass:" + (el.staticClass) + ",";
	  }
	  if (el.classBinding) {
	    data += "class:" + (el.classBinding) + ",";
	  }
	  return data
	}
	
	var klass$1 = {
	  staticKeys: ['staticClass'],
	  transformNode: transformNode,
	  genData: genData
	};
	
	/*  */
	
	function transformNode$1 (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticStyle = getAndRemoveAttr(el, 'style');
	  if (staticStyle) {
	    /* istanbul ignore if */
	    {
	      var res = parseText(staticStyle, options.delimiters);
	      if (res) {
	        warn(
	          "style=\"" + staticStyle + "\": " +
	          'Interpolation inside attributes has been removed. ' +
	          'Use v-bind or the colon shorthand instead. For example, ' +
	          'instead of <div style="{{ val }}">, use <div :style="val">.'
	        );
	      }
	    }
	    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
	  }
	
	  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
	  if (styleBinding) {
	    el.styleBinding = styleBinding;
	  }
	}
	
	function genData$1 (el) {
	  var data = '';
	  if (el.staticStyle) {
	    data += "staticStyle:" + (el.staticStyle) + ",";
	  }
	  if (el.styleBinding) {
	    data += "style:(" + (el.styleBinding) + "),";
	  }
	  return data
	}
	
	var style$1 = {
	  staticKeys: ['staticStyle'],
	  transformNode: transformNode$1,
	  genData: genData$1
	};
	
	/*  */
	
	var decoder;
	
	var he = {
	  decode: function decode (html) {
	    decoder = decoder || document.createElement('div');
	    decoder.innerHTML = html;
	    return decoder.textContent
	  }
	};
	
	/*  */
	
	var isUnaryTag = makeMap(
	  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
	  'link,meta,param,source,track,wbr'
	);
	
	// Elements that you can, intentionally, leave open
	// (and which close themselves)
	var canBeLeftOpenTag = makeMap(
	  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
	);
	
	// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
	// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
	var isNonPhrasingTag = makeMap(
	  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
	  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
	  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
	  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
	  'title,tr,track'
	);
	
	/**
	 * Not type-checking this file because it's mostly vendor code.
	 */
	
	/*!
	 * HTML Parser By John Resig (ejohn.org)
	 * Modified by Juriy "kangax" Zaytsev
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 */
	
	// Regular Expressions for parsing tags and attributes
	var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
	// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
	// but for Vue templates we can enforce a simple charset
	var ncname = '[a-zA-Z_][\\w\\-\\.]*';
	var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
	var startTagOpen = new RegExp(("^<" + qnameCapture));
	var startTagClose = /^\s*(\/?)>/;
	var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
	var doctype = /^<!DOCTYPE [^>]+>/i;
	var comment = /^<!--/;
	var conditionalComment = /^<!\[/;
	
	var IS_REGEX_CAPTURING_BROKEN = false;
	'x'.replace(/x(.)?/g, function (m, g) {
	  IS_REGEX_CAPTURING_BROKEN = g === '';
	});
	
	// Special Elements (can contain anything)
	var isPlainTextElement = makeMap('script,style,textarea', true);
	var reCache = {};
	
	var decodingMap = {
	  '&lt;': '<',
	  '&gt;': '>',
	  '&quot;': '"',
	  '&amp;': '&',
	  '&#10;': '\n',
	  '&#9;': '\t'
	};
	var encodedAttr = /&(?:lt|gt|quot|amp);/g;
	var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;
	
	// #5992
	var isIgnoreNewlineTag = makeMap('pre,textarea', true);
	var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };
	
	function decodeAttr (value, shouldDecodeNewlines) {
	  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
	  return value.replace(re, function (match) { return decodingMap[match]; })
	}
	
	function parseHTML (html, options) {
	  var stack = [];
	  var expectHTML = options.expectHTML;
	  var isUnaryTag$$1 = options.isUnaryTag || no;
	  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
	  var index = 0;
	  var last, lastTag;
	  while (html) {
	    last = html;
	    // Make sure we're not in a plaintext content element like script/style
	    if (!lastTag || !isPlainTextElement(lastTag)) {
	      var textEnd = html.indexOf('<');
	      if (textEnd === 0) {
	        // Comment:
	        if (comment.test(html)) {
	          var commentEnd = html.indexOf('-->');
	
	          if (commentEnd >= 0) {
	            if (options.shouldKeepComment) {
	              options.comment(html.substring(4, commentEnd));
	            }
	            advance(commentEnd + 3);
	            continue
	          }
	        }
	
	        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
	        if (conditionalComment.test(html)) {
	          var conditionalEnd = html.indexOf(']>');
	
	          if (conditionalEnd >= 0) {
	            advance(conditionalEnd + 2);
	            continue
	          }
	        }
	
	        // Doctype:
	        var doctypeMatch = html.match(doctype);
	        if (doctypeMatch) {
	          advance(doctypeMatch[0].length);
	          continue
	        }
	
	        // End tag:
	        var endTagMatch = html.match(endTag);
	        if (endTagMatch) {
	          var curIndex = index;
	          advance(endTagMatch[0].length);
	          parseEndTag(endTagMatch[1], curIndex, index);
	          continue
	        }
	
	        // Start tag:
	        var startTagMatch = parseStartTag();
	        if (startTagMatch) {
	          handleStartTag(startTagMatch);
	          if (shouldIgnoreFirstNewline(lastTag, html)) {
	            advance(1);
	          }
	          continue
	        }
	      }
	
	      var text = (void 0), rest = (void 0), next = (void 0);
	      if (textEnd >= 0) {
	        rest = html.slice(textEnd);
	        while (
	          !endTag.test(rest) &&
	          !startTagOpen.test(rest) &&
	          !comment.test(rest) &&
	          !conditionalComment.test(rest)
	        ) {
	          // < in plain text, be forgiving and treat it as text
	          next = rest.indexOf('<', 1);
	          if (next < 0) { break }
	          textEnd += next;
	          rest = html.slice(textEnd);
	        }
	        text = html.substring(0, textEnd);
	        advance(textEnd);
	      }
	
	      if (textEnd < 0) {
	        text = html;
	        html = '';
	      }
	
	      if (options.chars && text) {
	        options.chars(text);
	      }
	    } else {
	      var endTagLength = 0;
	      var stackedTag = lastTag.toLowerCase();
	      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
	      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
	        endTagLength = endTag.length;
	        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
	          text = text
	            .replace(/<!--([\s\S]*?)-->/g, '$1')
	            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
	        }
	        if (shouldIgnoreFirstNewline(stackedTag, text)) {
	          text = text.slice(1);
	        }
	        if (options.chars) {
	          options.chars(text);
	        }
	        return ''
	      });
	      index += html.length - rest$1.length;
	      html = rest$1;
	      parseEndTag(stackedTag, index - endTagLength, index);
	    }
	
	    if (html === last) {
	      options.chars && options.chars(html);
	      if ("development" !== 'production' && !stack.length && options.warn) {
	        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
	      }
	      break
	    }
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function advance (n) {
	    index += n;
	    html = html.substring(n);
	  }
	
	  function parseStartTag () {
	    var start = html.match(startTagOpen);
	    if (start) {
	      var match = {
	        tagName: start[1],
	        attrs: [],
	        start: index
	      };
	      advance(start[0].length);
	      var end, attr;
	      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
	        advance(attr[0].length);
	        match.attrs.push(attr);
	      }
	      if (end) {
	        match.unarySlash = end[1];
	        advance(end[0].length);
	        match.end = index;
	        return match
	      }
	    }
	  }
	
	  function handleStartTag (match) {
	    var tagName = match.tagName;
	    var unarySlash = match.unarySlash;
	
	    if (expectHTML) {
	      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
	        parseEndTag(lastTag);
	      }
	      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
	        parseEndTag(tagName);
	      }
	    }
	
	    var unary = isUnaryTag$$1(tagName) || !!unarySlash;
	
	    var l = match.attrs.length;
	    var attrs = new Array(l);
	    for (var i = 0; i < l; i++) {
	      var args = match.attrs[i];
	      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
	      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
	        if (args[3] === '') { delete args[3]; }
	        if (args[4] === '') { delete args[4]; }
	        if (args[5] === '') { delete args[5]; }
	      }
	      var value = args[3] || args[4] || args[5] || '';
	      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
	        ? options.shouldDecodeNewlinesForHref
	        : options.shouldDecodeNewlines;
	      attrs[i] = {
	        name: args[1],
	        value: decodeAttr(value, shouldDecodeNewlines)
	      };
	    }
	
	    if (!unary) {
	      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
	      lastTag = tagName;
	    }
	
	    if (options.start) {
	      options.start(tagName, attrs, unary, match.start, match.end);
	    }
	  }
	
	  function parseEndTag (tagName, start, end) {
	    var pos, lowerCasedTagName;
	    if (start == null) { start = index; }
	    if (end == null) { end = index; }
	
	    if (tagName) {
	      lowerCasedTagName = tagName.toLowerCase();
	    }
	
	    // Find the closest opened tag of the same type
	    if (tagName) {
	      for (pos = stack.length - 1; pos >= 0; pos--) {
	        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
	          break
	        }
	      }
	    } else {
	      // If no tag name is provided, clean shop
	      pos = 0;
	    }
	
	    if (pos >= 0) {
	      // Close all the open elements, up the stack
	      for (var i = stack.length - 1; i >= pos; i--) {
	        if ("development" !== 'production' &&
	          (i > pos || !tagName) &&
	          options.warn
	        ) {
	          options.warn(
	            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
	          );
	        }
	        if (options.end) {
	          options.end(stack[i].tag, start, end);
	        }
	      }
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	      lastTag = pos && stack[pos - 1].tag;
	    } else if (lowerCasedTagName === 'br') {
	      if (options.start) {
	        options.start(tagName, [], true, start, end);
	      }
	    } else if (lowerCasedTagName === 'p') {
	      if (options.start) {
	        options.start(tagName, [], false, start, end);
	      }
	      if (options.end) {
	        options.end(tagName, start, end);
	      }
	    }
	  }
	}
	
	/*  */
	
	var onRE = /^@|^v-on:/;
	var dirRE = /^v-|^@|^:/;
	var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
	var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
	var stripParensRE = /^\(|\)$/g;
	
	var argRE = /:(.*)$/;
	var bindRE = /^:|^v-bind:/;
	var modifierRE = /\.[^.]+/g;
	
	var decodeHTMLCached = cached(he.decode);
	
	// configurable state
	var warn$2;
	var delimiters;
	var transforms;
	var preTransforms;
	var postTransforms;
	var platformIsPreTag;
	var platformMustUseProp;
	var platformGetTagNamespace;
	
	
	
	function createASTElement (
	  tag,
	  attrs,
	  parent
	) {
	  return {
	    type: 1,
	    tag: tag,
	    attrsList: attrs,
	    attrsMap: makeAttrsMap(attrs),
	    parent: parent,
	    children: []
	  }
	}
	
	/**
	 * Convert HTML string to AST.
	 */
	function parse (
	  template,
	  options
	) {
	  warn$2 = options.warn || baseWarn;
	
	  platformIsPreTag = options.isPreTag || no;
	  platformMustUseProp = options.mustUseProp || no;
	  platformGetTagNamespace = options.getTagNamespace || no;
	
	  transforms = pluckModuleFunction(options.modules, 'transformNode');
	  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
	  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
	
	  delimiters = options.delimiters;
	
	  var stack = [];
	  var preserveWhitespace = options.preserveWhitespace !== false;
	  var root;
	  var currentParent;
	  var inVPre = false;
	  var inPre = false;
	  var warned = false;
	
	  function warnOnce (msg) {
	    if (!warned) {
	      warned = true;
	      warn$2(msg);
	    }
	  }
	
	  function closeElement (element) {
	    // check pre state
	    if (element.pre) {
	      inVPre = false;
	    }
	    if (platformIsPreTag(element.tag)) {
	      inPre = false;
	    }
	    // apply post-transforms
	    for (var i = 0; i < postTransforms.length; i++) {
	      postTransforms[i](element, options);
	    }
	  }
	
	  parseHTML(template, {
	    warn: warn$2,
	    expectHTML: options.expectHTML,
	    isUnaryTag: options.isUnaryTag,
	    canBeLeftOpenTag: options.canBeLeftOpenTag,
	    shouldDecodeNewlines: options.shouldDecodeNewlines,
	    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
	    shouldKeepComment: options.comments,
	    start: function start (tag, attrs, unary) {
	      // check namespace.
	      // inherit parent ns if there is one
	      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
	
	      // handle IE svg bug
	      /* istanbul ignore if */
	      if (isIE && ns === 'svg') {
	        attrs = guardIESVGBug(attrs);
	      }
	
	      var element = createASTElement(tag, attrs, currentParent);
	      if (ns) {
	        element.ns = ns;
	      }
	
	      if (isForbiddenTag(element) && !isServerRendering()) {
	        element.forbidden = true;
	        "development" !== 'production' && warn$2(
	          'Templates should only be responsible for mapping the state to the ' +
	          'UI. Avoid placing tags with side-effects in your templates, such as ' +
	          "<" + tag + ">" + ', as they will not be parsed.'
	        );
	      }
	
	      // apply pre-transforms
	      for (var i = 0; i < preTransforms.length; i++) {
	        element = preTransforms[i](element, options) || element;
	      }
	
	      if (!inVPre) {
	        processPre(element);
	        if (element.pre) {
	          inVPre = true;
	        }
	      }
	      if (platformIsPreTag(element.tag)) {
	        inPre = true;
	      }
	      if (inVPre) {
	        processRawAttrs(element);
	      } else if (!element.processed) {
	        // structural directives
	        processFor(element);
	        processIf(element);
	        processOnce(element);
	        // element-scope stuff
	        processElement(element, options);
	      }
	
	      function checkRootConstraints (el) {
	        {
	          if (el.tag === 'slot' || el.tag === 'template') {
	            warnOnce(
	              "Cannot use <" + (el.tag) + "> as component root element because it may " +
	              'contain multiple nodes.'
	            );
	          }
	          if (el.attrsMap.hasOwnProperty('v-for')) {
	            warnOnce(
	              'Cannot use v-for on stateful component root element because ' +
	              'it renders multiple elements.'
	            );
	          }
	        }
	      }
	
	      // tree management
	      if (!root) {
	        root = element;
	        checkRootConstraints(root);
	      } else if (!stack.length) {
	        // allow root elements with v-if, v-else-if and v-else
	        if (root.if && (element.elseif || element.else)) {
	          checkRootConstraints(element);
	          addIfCondition(root, {
	            exp: element.elseif,
	            block: element
	          });
	        } else {
	          warnOnce(
	            "Component template should contain exactly one root element. " +
	            "If you are using v-if on multiple elements, " +
	            "use v-else-if to chain them instead."
	          );
	        }
	      }
	      if (currentParent && !element.forbidden) {
	        if (element.elseif || element.else) {
	          processIfConditions(element, currentParent);
	        } else if (element.slotScope) { // scoped slot
	          currentParent.plain = false;
	          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
	        } else {
	          currentParent.children.push(element);
	          element.parent = currentParent;
	        }
	      }
	      if (!unary) {
	        currentParent = element;
	        stack.push(element);
	      } else {
	        closeElement(element);
	      }
	    },
	
	    end: function end () {
	      // remove trailing whitespace
	      var element = stack[stack.length - 1];
	      var lastNode = element.children[element.children.length - 1];
	      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
	        element.children.pop();
	      }
	      // pop stack
	      stack.length -= 1;
	      currentParent = stack[stack.length - 1];
	      closeElement(element);
	    },
	
	    chars: function chars (text) {
	      if (!currentParent) {
	        {
	          if (text === template) {
	            warnOnce(
	              'Component template requires a root element, rather than just text.'
	            );
	          } else if ((text = text.trim())) {
	            warnOnce(
	              ("text \"" + text + "\" outside root element will be ignored.")
	            );
	          }
	        }
	        return
	      }
	      // IE textarea placeholder bug
	      /* istanbul ignore if */
	      if (isIE &&
	        currentParent.tag === 'textarea' &&
	        currentParent.attrsMap.placeholder === text
	      ) {
	        return
	      }
	      var children = currentParent.children;
	      text = inPre || text.trim()
	        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
	        // only preserve whitespace if its not right after a starting tag
	        : preserveWhitespace && children.length ? ' ' : '';
	      if (text) {
	        var res;
	        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
	          children.push({
	            type: 2,
	            expression: res.expression,
	            tokens: res.tokens,
	            text: text
	          });
	        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
	          children.push({
	            type: 3,
	            text: text
	          });
	        }
	      }
	    },
	    comment: function comment (text) {
	      currentParent.children.push({
	        type: 3,
	        text: text,
	        isComment: true
	      });
	    }
	  });
	  return root
	}
	
	function processPre (el) {
	  if (getAndRemoveAttr(el, 'v-pre') != null) {
	    el.pre = true;
	  }
	}
	
	function processRawAttrs (el) {
	  var l = el.attrsList.length;
	  if (l) {
	    var attrs = el.attrs = new Array(l);
	    for (var i = 0; i < l; i++) {
	      attrs[i] = {
	        name: el.attrsList[i].name,
	        value: JSON.stringify(el.attrsList[i].value)
	      };
	    }
	  } else if (!el.pre) {
	    // non root node in pre blocks with no attributes
	    el.plain = true;
	  }
	}
	
	function processElement (element, options) {
	  processKey(element);
	
	  // determine whether this is a plain element after
	  // removing structural attributes
	  element.plain = !element.key && !element.attrsList.length;
	
	  processRef(element);
	  processSlot(element);
	  processComponent(element);
	  for (var i = 0; i < transforms.length; i++) {
	    element = transforms[i](element, options) || element;
	  }
	  processAttrs(element);
	}
	
	function processKey (el) {
	  var exp = getBindingAttr(el, 'key');
	  if (exp) {
	    if ("development" !== 'production' && el.tag === 'template') {
	      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
	    }
	    el.key = exp;
	  }
	}
	
	function processRef (el) {
	  var ref = getBindingAttr(el, 'ref');
	  if (ref) {
	    el.ref = ref;
	    el.refInFor = checkInFor(el);
	  }
	}
	
	function processFor (el) {
	  var exp;
	  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
	    var res = parseFor(exp);
	    if (res) {
	      extend(el, res);
	    } else {
	      warn$2(
	        ("Invalid v-for expression: " + exp)
	      );
	    }
	  }
	}
	
	function parseFor (exp) {
	  var inMatch = exp.match(forAliasRE);
	  if (!inMatch) { return }
	  var res = {};
	  res.for = inMatch[2].trim();
	  var alias = inMatch[1].trim().replace(stripParensRE, '');
	  var iteratorMatch = alias.match(forIteratorRE);
	  if (iteratorMatch) {
	    res.alias = alias.replace(forIteratorRE, '');
	    res.iterator1 = iteratorMatch[1].trim();
	    if (iteratorMatch[2]) {
	      res.iterator2 = iteratorMatch[2].trim();
	    }
	  } else {
	    res.alias = alias;
	  }
	  return res
	}
	
	function processIf (el) {
	  var exp = getAndRemoveAttr(el, 'v-if');
	  if (exp) {
	    el.if = exp;
	    addIfCondition(el, {
	      exp: exp,
	      block: el
	    });
	  } else {
	    if (getAndRemoveAttr(el, 'v-else') != null) {
	      el.else = true;
	    }
	    var elseif = getAndRemoveAttr(el, 'v-else-if');
	    if (elseif) {
	      el.elseif = elseif;
	    }
	  }
	}
	
	function processIfConditions (el, parent) {
	  var prev = findPrevElement(parent.children);
	  if (prev && prev.if) {
	    addIfCondition(prev, {
	      exp: el.elseif,
	      block: el
	    });
	  } else {
	    warn$2(
	      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
	      "used on element <" + (el.tag) + "> without corresponding v-if."
	    );
	  }
	}
	
	function findPrevElement (children) {
	  var i = children.length;
	  while (i--) {
	    if (children[i].type === 1) {
	      return children[i]
	    } else {
	      if ("development" !== 'production' && children[i].text !== ' ') {
	        warn$2(
	          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
	          "will be ignored."
	        );
	      }
	      children.pop();
	    }
	  }
	}
	
	function addIfCondition (el, condition) {
	  if (!el.ifConditions) {
	    el.ifConditions = [];
	  }
	  el.ifConditions.push(condition);
	}
	
	function processOnce (el) {
	  var once$$1 = getAndRemoveAttr(el, 'v-once');
	  if (once$$1 != null) {
	    el.once = true;
	  }
	}
	
	function processSlot (el) {
	  if (el.tag === 'slot') {
	    el.slotName = getBindingAttr(el, 'name');
	    if ("development" !== 'production' && el.key) {
	      warn$2(
	        "`key` does not work on <slot> because slots are abstract outlets " +
	        "and can possibly expand into multiple elements. " +
	        "Use the key on a wrapping element instead."
	      );
	    }
	  } else {
	    var slotScope;
	    if (el.tag === 'template') {
	      slotScope = getAndRemoveAttr(el, 'scope');
	      /* istanbul ignore if */
	      if ("development" !== 'production' && slotScope) {
	        warn$2(
	          "the \"scope\" attribute for scoped slots have been deprecated and " +
	          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
	          "can also be used on plain elements in addition to <template> to " +
	          "denote scoped slots.",
	          true
	        );
	      }
	      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
	    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
	      /* istanbul ignore if */
	      if ("development" !== 'production' && el.attrsMap['v-for']) {
	        warn$2(
	          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
	          "(v-for takes higher priority). Use a wrapper <template> for the " +
	          "scoped slot to make it clearer.",
	          true
	        );
	      }
	      el.slotScope = slotScope;
	    }
	    var slotTarget = getBindingAttr(el, 'slot');
	    if (slotTarget) {
	      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
	      // preserve slot as an attribute for native shadow DOM compat
	      // only for non-scoped slots.
	      if (el.tag !== 'template' && !el.slotScope) {
	        addAttr(el, 'slot', slotTarget);
	      }
	    }
	  }
	}
	
	function processComponent (el) {
	  var binding;
	  if ((binding = getBindingAttr(el, 'is'))) {
	    el.component = binding;
	  }
	  if (getAndRemoveAttr(el, 'inline-template') != null) {
	    el.inlineTemplate = true;
	  }
	}
	
	function processAttrs (el) {
	  var list = el.attrsList;
	  var i, l, name, rawName, value, modifiers, isProp;
	  for (i = 0, l = list.length; i < l; i++) {
	    name = rawName = list[i].name;
	    value = list[i].value;
	    if (dirRE.test(name)) {
	      // mark element as dynamic
	      el.hasBindings = true;
	      // modifiers
	      modifiers = parseModifiers(name);
	      if (modifiers) {
	        name = name.replace(modifierRE, '');
	      }
	      if (bindRE.test(name)) { // v-bind
	        name = name.replace(bindRE, '');
	        value = parseFilters(value);
	        isProp = false;
	        if (modifiers) {
	          if (modifiers.prop) {
	            isProp = true;
	            name = camelize(name);
	            if (name === 'innerHtml') { name = 'innerHTML'; }
	          }
	          if (modifiers.camel) {
	            name = camelize(name);
	          }
	          if (modifiers.sync) {
	            addHandler(
	              el,
	              ("update:" + (camelize(name))),
	              genAssignmentCode(value, "$event")
	            );
	          }
	        }
	        if (isProp || (
	          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
	        )) {
	          addProp(el, name, value);
	        } else {
	          addAttr(el, name, value);
	        }
	      } else if (onRE.test(name)) { // v-on
	        name = name.replace(onRE, '');
	        addHandler(el, name, value, modifiers, false, warn$2);
	      } else { // normal directives
	        name = name.replace(dirRE, '');
	        // parse arg
	        var argMatch = name.match(argRE);
	        var arg = argMatch && argMatch[1];
	        if (arg) {
	          name = name.slice(0, -(arg.length + 1));
	        }
	        addDirective(el, name, rawName, value, arg, modifiers);
	        if ("development" !== 'production' && name === 'model') {
	          checkForAliasModel(el, value);
	        }
	      }
	    } else {
	      // literal attribute
	      {
	        var res = parseText(value, delimiters);
	        if (res) {
	          warn$2(
	            name + "=\"" + value + "\": " +
	            'Interpolation inside attributes has been removed. ' +
	            'Use v-bind or the colon shorthand instead. For example, ' +
	            'instead of <div id="{{ val }}">, use <div :id="val">.'
	          );
	        }
	      }
	      addAttr(el, name, JSON.stringify(value));
	      // #6887 firefox doesn't update muted state if set via attribute
	      // even immediately after element creation
	      if (!el.component &&
	          name === 'muted' &&
	          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
	        addProp(el, name, 'true');
	      }
	    }
	  }
	}
	
	function checkInFor (el) {
	  var parent = el;
	  while (parent) {
	    if (parent.for !== undefined) {
	      return true
	    }
	    parent = parent.parent;
	  }
	  return false
	}
	
	function parseModifiers (name) {
	  var match = name.match(modifierRE);
	  if (match) {
	    var ret = {};
	    match.forEach(function (m) { ret[m.slice(1)] = true; });
	    return ret
	  }
	}
	
	function makeAttrsMap (attrs) {
	  var map = {};
	  for (var i = 0, l = attrs.length; i < l; i++) {
	    if (
	      "development" !== 'production' &&
	      map[attrs[i].name] && !isIE && !isEdge
	    ) {
	      warn$2('duplicate attribute: ' + attrs[i].name);
	    }
	    map[attrs[i].name] = attrs[i].value;
	  }
	  return map
	}
	
	// for script (e.g. type="x/template") or style, do not decode content
	function isTextTag (el) {
	  return el.tag === 'script' || el.tag === 'style'
	}
	
	function isForbiddenTag (el) {
	  return (
	    el.tag === 'style' ||
	    (el.tag === 'script' && (
	      !el.attrsMap.type ||
	      el.attrsMap.type === 'text/javascript'
	    ))
	  )
	}
	
	var ieNSBug = /^xmlns:NS\d+/;
	var ieNSPrefix = /^NS\d+:/;
	
	/* istanbul ignore next */
	function guardIESVGBug (attrs) {
	  var res = [];
	  for (var i = 0; i < attrs.length; i++) {
	    var attr = attrs[i];
	    if (!ieNSBug.test(attr.name)) {
	      attr.name = attr.name.replace(ieNSPrefix, '');
	      res.push(attr);
	    }
	  }
	  return res
	}
	
	function checkForAliasModel (el, value) {
	  var _el = el;
	  while (_el) {
	    if (_el.for && _el.alias === value) {
	      warn$2(
	        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
	        "You are binding v-model directly to a v-for iteration alias. " +
	        "This will not be able to modify the v-for source array because " +
	        "writing to the alias is like modifying a function local variable. " +
	        "Consider using an array of objects and use v-model on an object property instead."
	      );
	    }
	    _el = _el.parent;
	  }
	}
	
	/*  */
	
	/**
	 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
	 * Turn this:
	 *   <input v-model="data[type]" :type="type">
	 * into this:
	 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
	 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
	 *   <input v-else :type="type" v-model="data[type]">
	 */
	
	function preTransformNode (el, options) {
	  if (el.tag === 'input') {
	    var map = el.attrsMap;
	    if (map['v-model'] && (map['v-bind:type'] || map[':type'])) {
	      var typeBinding = getBindingAttr(el, 'type');
	      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
	      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
	      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
	      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
	      // 1. checkbox
	      var branch0 = cloneASTElement(el);
	      // process for on the main node
	      processFor(branch0);
	      addRawAttr(branch0, 'type', 'checkbox');
	      processElement(branch0, options);
	      branch0.processed = true; // prevent it from double-processed
	      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
	      addIfCondition(branch0, {
	        exp: branch0.if,
	        block: branch0
	      });
	      // 2. add radio else-if condition
	      var branch1 = cloneASTElement(el);
	      getAndRemoveAttr(branch1, 'v-for', true);
	      addRawAttr(branch1, 'type', 'radio');
	      processElement(branch1, options);
	      addIfCondition(branch0, {
	        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
	        block: branch1
	      });
	      // 3. other
	      var branch2 = cloneASTElement(el);
	      getAndRemoveAttr(branch2, 'v-for', true);
	      addRawAttr(branch2, ':type', typeBinding);
	      processElement(branch2, options);
	      addIfCondition(branch0, {
	        exp: ifCondition,
	        block: branch2
	      });
	
	      if (hasElse) {
	        branch0.else = true;
	      } else if (elseIfCondition) {
	        branch0.elseif = elseIfCondition;
	      }
	
	      return branch0
	    }
	  }
	}
	
	function cloneASTElement (el) {
	  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
	}
	
	var model$2 = {
	  preTransformNode: preTransformNode
	};
	
	var modules$1 = [
	  klass$1,
	  style$1,
	  model$2
	];
	
	/*  */
	
	function text (el, dir) {
	  if (dir.value) {
	    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
	  }
	}
	
	/*  */
	
	function html (el, dir) {
	  if (dir.value) {
	    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
	  }
	}
	
	var directives$1 = {
	  model: model,
	  text: text,
	  html: html
	};
	
	/*  */
	
	var baseOptions = {
	  expectHTML: true,
	  modules: modules$1,
	  directives: directives$1,
	  isPreTag: isPreTag,
	  isUnaryTag: isUnaryTag,
	  mustUseProp: mustUseProp,
	  canBeLeftOpenTag: canBeLeftOpenTag,
	  isReservedTag: isReservedTag,
	  getTagNamespace: getTagNamespace,
	  staticKeys: genStaticKeys(modules$1)
	};
	
	/*  */
	
	var isStaticKey;
	var isPlatformReservedTag;
	
	var genStaticKeysCached = cached(genStaticKeys$1);
	
	/**
	 * Goal of the optimizer: walk the generated template AST tree
	 * and detect sub-trees that are purely static, i.e. parts of
	 * the DOM that never needs to change.
	 *
	 * Once we detect these sub-trees, we can:
	 *
	 * 1. Hoist them into constants, so that we no longer need to
	 *    create fresh nodes for them on each re-render;
	 * 2. Completely skip them in the patching process.
	 */
	function optimize (root, options) {
	  if (!root) { return }
	  isStaticKey = genStaticKeysCached(options.staticKeys || '');
	  isPlatformReservedTag = options.isReservedTag || no;
	  // first pass: mark all non-static nodes.
	  markStatic$1(root);
	  // second pass: mark static roots.
	  markStaticRoots(root, false);
	}
	
	function genStaticKeys$1 (keys) {
	  return makeMap(
	    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
	    (keys ? ',' + keys : '')
	  )
	}
	
	function markStatic$1 (node) {
	  node.static = isStatic(node);
	  if (node.type === 1) {
	    // do not make component slot content static. this avoids
	    // 1. components not able to mutate slot nodes
	    // 2. static slot content fails for hot-reloading
	    if (
	      !isPlatformReservedTag(node.tag) &&
	      node.tag !== 'slot' &&
	      node.attrsMap['inline-template'] == null
	    ) {
	      return
	    }
	    for (var i = 0, l = node.children.length; i < l; i++) {
	      var child = node.children[i];
	      markStatic$1(child);
	      if (!child.static) {
	        node.static = false;
	      }
	    }
	    if (node.ifConditions) {
	      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
	        var block = node.ifConditions[i$1].block;
	        markStatic$1(block);
	        if (!block.static) {
	          node.static = false;
	        }
	      }
	    }
	  }
	}
	
	function markStaticRoots (node, isInFor) {
	  if (node.type === 1) {
	    if (node.static || node.once) {
	      node.staticInFor = isInFor;
	    }
	    // For a node to qualify as a static root, it should have children that
	    // are not just static text. Otherwise the cost of hoisting out will
	    // outweigh the benefits and it's better off to just always render it fresh.
	    if (node.static && node.children.length && !(
	      node.children.length === 1 &&
	      node.children[0].type === 3
	    )) {
	      node.staticRoot = true;
	      return
	    } else {
	      node.staticRoot = false;
	    }
	    if (node.children) {
	      for (var i = 0, l = node.children.length; i < l; i++) {
	        markStaticRoots(node.children[i], isInFor || !!node.for);
	      }
	    }
	    if (node.ifConditions) {
	      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
	        markStaticRoots(node.ifConditions[i$1].block, isInFor);
	      }
	    }
	  }
	}
	
	function isStatic (node) {
	  if (node.type === 2) { // expression
	    return false
	  }
	  if (node.type === 3) { // text
	    return true
	  }
	  return !!(node.pre || (
	    !node.hasBindings && // no dynamic bindings
	    !node.if && !node.for && // not v-if or v-for or v-else
	    !isBuiltInTag(node.tag) && // not a built-in
	    isPlatformReservedTag(node.tag) && // not a component
	    !isDirectChildOfTemplateFor(node) &&
	    Object.keys(node).every(isStaticKey)
	  ))
	}
	
	function isDirectChildOfTemplateFor (node) {
	  while (node.parent) {
	    node = node.parent;
	    if (node.tag !== 'template') {
	      return false
	    }
	    if (node.for) {
	      return true
	    }
	  }
	  return false
	}
	
	/*  */
	
	var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
	var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;
	
	// keyCode aliases
	var keyCodes = {
	  esc: 27,
	  tab: 9,
	  enter: 13,
	  space: 32,
	  up: 38,
	  left: 37,
	  right: 39,
	  down: 40,
	  'delete': [8, 46]
	};
	
	// #4868: modifiers that prevent the execution of the listener
	// need to explicitly return null so that we can determine whether to remove
	// the listener for .once
	var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };
	
	var modifierCode = {
	  stop: '$event.stopPropagation();',
	  prevent: '$event.preventDefault();',
	  self: genGuard("$event.target !== $event.currentTarget"),
	  ctrl: genGuard("!$event.ctrlKey"),
	  shift: genGuard("!$event.shiftKey"),
	  alt: genGuard("!$event.altKey"),
	  meta: genGuard("!$event.metaKey"),
	  left: genGuard("'button' in $event && $event.button !== 0"),
	  middle: genGuard("'button' in $event && $event.button !== 1"),
	  right: genGuard("'button' in $event && $event.button !== 2")
	};
	
	function genHandlers (
	  events,
	  isNative,
	  warn
	) {
	  var res = isNative ? 'nativeOn:{' : 'on:{';
	  for (var name in events) {
	    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
	  }
	  return res.slice(0, -1) + '}'
	}
	
	function genHandler (
	  name,
	  handler
	) {
	  if (!handler) {
	    return 'function(){}'
	  }
	
	  if (Array.isArray(handler)) {
	    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
	  }
	
	  var isMethodPath = simplePathRE.test(handler.value);
	  var isFunctionExpression = fnExpRE.test(handler.value);
	
	  if (!handler.modifiers) {
	    if (isMethodPath || isFunctionExpression) {
	      return handler.value
	    }
	    /* istanbul ignore if */
	    return ("function($event){" + (handler.value) + "}") // inline statement
	  } else {
	    var code = '';
	    var genModifierCode = '';
	    var keys = [];
	    for (var key in handler.modifiers) {
	      if (modifierCode[key]) {
	        genModifierCode += modifierCode[key];
	        // left/right
	        if (keyCodes[key]) {
	          keys.push(key);
	        }
	      } else if (key === 'exact') {
	        var modifiers = (handler.modifiers);
	        genModifierCode += genGuard(
	          ['ctrl', 'shift', 'alt', 'meta']
	            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
	            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
	            .join('||')
	        );
	      } else {
	        keys.push(key);
	      }
	    }
	    if (keys.length) {
	      code += genKeyFilter(keys);
	    }
	    // Make sure modifiers like prevent and stop get executed after key filtering
	    if (genModifierCode) {
	      code += genModifierCode;
	    }
	    var handlerCode = isMethodPath
	      ? handler.value + '($event)'
	      : isFunctionExpression
	        ? ("(" + (handler.value) + ")($event)")
	        : handler.value;
	    /* istanbul ignore if */
	    return ("function($event){" + code + handlerCode + "}")
	  }
	}
	
	function genKeyFilter (keys) {
	  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
	}
	
	function genFilterCode (key) {
	  var keyVal = parseInt(key, 10);
	  if (keyVal) {
	    return ("$event.keyCode!==" + keyVal)
	  }
	  var code = keyCodes[key];
	  return (
	    "_k($event.keyCode," +
	    (JSON.stringify(key)) + "," +
	    (JSON.stringify(code)) + "," +
	    "$event.key)"
	  )
	}
	
	/*  */
	
	function on (el, dir) {
	  if ("development" !== 'production' && dir.modifiers) {
	    warn("v-on without argument does not support modifiers.");
	  }
	  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
	}
	
	/*  */
	
	function bind$1 (el, dir) {
	  el.wrapData = function (code) {
	    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
	  };
	}
	
	/*  */
	
	var baseDirectives = {
	  on: on,
	  bind: bind$1,
	  cloak: noop
	};
	
	/*  */
	
	var CodegenState = function CodegenState (options) {
	  this.options = options;
	  this.warn = options.warn || baseWarn;
	  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
	  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
	  this.directives = extend(extend({}, baseDirectives), options.directives);
	  var isReservedTag = options.isReservedTag || no;
	  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
	  this.onceId = 0;
	  this.staticRenderFns = [];
	};
	
	
	
	function generate (
	  ast,
	  options
	) {
	  var state = new CodegenState(options);
	  var code = ast ? genElement(ast, state) : '_c("div")';
	  return {
	    render: ("with(this){return " + code + "}"),
	    staticRenderFns: state.staticRenderFns
	  }
	}
	
	function genElement (el, state) {
	  if (el.staticRoot && !el.staticProcessed) {
	    return genStatic(el, state)
	  } else if (el.once && !el.onceProcessed) {
	    return genOnce(el, state)
	  } else if (el.for && !el.forProcessed) {
	    return genFor(el, state)
	  } else if (el.if && !el.ifProcessed) {
	    return genIf(el, state)
	  } else if (el.tag === 'template' && !el.slotTarget) {
	    return genChildren(el, state) || 'void 0'
	  } else if (el.tag === 'slot') {
	    return genSlot(el, state)
	  } else {
	    // component or element
	    var code;
	    if (el.component) {
	      code = genComponent(el.component, el, state);
	    } else {
	      var data = el.plain ? undefined : genData$2(el, state);
	
	      var children = el.inlineTemplate ? null : genChildren(el, state, true);
	      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
	    }
	    // module transforms
	    for (var i = 0; i < state.transforms.length; i++) {
	      code = state.transforms[i](el, code);
	    }
	    return code
	  }
	}
	
	// hoist static sub-trees out
	function genStatic (el, state) {
	  el.staticProcessed = true;
	  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
	  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
	}
	
	// v-once
	function genOnce (el, state) {
	  el.onceProcessed = true;
	  if (el.if && !el.ifProcessed) {
	    return genIf(el, state)
	  } else if (el.staticInFor) {
	    var key = '';
	    var parent = el.parent;
	    while (parent) {
	      if (parent.for) {
	        key = parent.key;
	        break
	      }
	      parent = parent.parent;
	    }
	    if (!key) {
	      "development" !== 'production' && state.warn(
	        "v-once can only be used inside v-for that is keyed. "
	      );
	      return genElement(el, state)
	    }
	    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
	  } else {
	    return genStatic(el, state)
	  }
	}
	
	function genIf (
	  el,
	  state,
	  altGen,
	  altEmpty
	) {
	  el.ifProcessed = true; // avoid recursion
	  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
	}
	
	function genIfConditions (
	  conditions,
	  state,
	  altGen,
	  altEmpty
	) {
	  if (!conditions.length) {
	    return altEmpty || '_e()'
	  }
	
	  var condition = conditions.shift();
	  if (condition.exp) {
	    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
	  } else {
	    return ("" + (genTernaryExp(condition.block)))
	  }
	
	  // v-if with v-once should generate code like (a)?_m(0):_m(1)
	  function genTernaryExp (el) {
	    return altGen
	      ? altGen(el, state)
	      : el.once
	        ? genOnce(el, state)
	        : genElement(el, state)
	  }
	}
	
	function genFor (
	  el,
	  state,
	  altGen,
	  altHelper
	) {
	  var exp = el.for;
	  var alias = el.alias;
	  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
	  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
	
	  if ("development" !== 'production' &&
	    state.maybeComponent(el) &&
	    el.tag !== 'slot' &&
	    el.tag !== 'template' &&
	    !el.key
	  ) {
	    state.warn(
	      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
	      "v-for should have explicit keys. " +
	      "See https://vuejs.org/guide/list.html#key for more info.",
	      true /* tip */
	    );
	  }
	
	  el.forProcessed = true; // avoid recursion
	  return (altHelper || '_l') + "((" + exp + ")," +
	    "function(" + alias + iterator1 + iterator2 + "){" +
	      "return " + ((altGen || genElement)(el, state)) +
	    '})'
	}
	
	function genData$2 (el, state) {
	  var data = '{';
	
	  // directives first.
	  // directives may mutate the el's other properties before they are generated.
	  var dirs = genDirectives(el, state);
	  if (dirs) { data += dirs + ','; }
	
	  // key
	  if (el.key) {
	    data += "key:" + (el.key) + ",";
	  }
	  // ref
	  if (el.ref) {
	    data += "ref:" + (el.ref) + ",";
	  }
	  if (el.refInFor) {
	    data += "refInFor:true,";
	  }
	  // pre
	  if (el.pre) {
	    data += "pre:true,";
	  }
	  // record original tag name for components using "is" attribute
	  if (el.component) {
	    data += "tag:\"" + (el.tag) + "\",";
	  }
	  // module data generation functions
	  for (var i = 0; i < state.dataGenFns.length; i++) {
	    data += state.dataGenFns[i](el);
	  }
	  // attributes
	  if (el.attrs) {
	    data += "attrs:{" + (genProps(el.attrs)) + "},";
	  }
	  // DOM props
	  if (el.props) {
	    data += "domProps:{" + (genProps(el.props)) + "},";
	  }
	  // event handlers
	  if (el.events) {
	    data += (genHandlers(el.events, false, state.warn)) + ",";
	  }
	  if (el.nativeEvents) {
	    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
	  }
	  // slot target
	  // only for non-scoped slots
	  if (el.slotTarget && !el.slotScope) {
	    data += "slot:" + (el.slotTarget) + ",";
	  }
	  // scoped slots
	  if (el.scopedSlots) {
	    data += (genScopedSlots(el.scopedSlots, state)) + ",";
	  }
	  // component v-model
	  if (el.model) {
	    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
	  }
	  // inline-template
	  if (el.inlineTemplate) {
	    var inlineTemplate = genInlineTemplate(el, state);
	    if (inlineTemplate) {
	      data += inlineTemplate + ",";
	    }
	  }
	  data = data.replace(/,$/, '') + '}';
	  // v-bind data wrap
	  if (el.wrapData) {
	    data = el.wrapData(data);
	  }
	  // v-on data wrap
	  if (el.wrapListeners) {
	    data = el.wrapListeners(data);
	  }
	  return data
	}
	
	function genDirectives (el, state) {
	  var dirs = el.directives;
	  if (!dirs) { return }
	  var res = 'directives:[';
	  var hasRuntime = false;
	  var i, l, dir, needRuntime;
	  for (i = 0, l = dirs.length; i < l; i++) {
	    dir = dirs[i];
	    needRuntime = true;
	    var gen = state.directives[dir.name];
	    if (gen) {
	      // compile-time directive that manipulates AST.
	      // returns true if it also needs a runtime counterpart.
	      needRuntime = !!gen(el, dir, state.warn);
	    }
	    if (needRuntime) {
	      hasRuntime = true;
	      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
	    }
	  }
	  if (hasRuntime) {
	    return res.slice(0, -1) + ']'
	  }
	}
	
	function genInlineTemplate (el, state) {
	  var ast = el.children[0];
	  if ("development" !== 'production' && (
	    el.children.length !== 1 || ast.type !== 1
	  )) {
	    state.warn('Inline-template components must have exactly one child element.');
	  }
	  if (ast.type === 1) {
	    var inlineRenderFns = generate(ast, state.options);
	    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
	  }
	}
	
	function genScopedSlots (
	  slots,
	  state
	) {
	  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
	      return genScopedSlot(key, slots[key], state)
	    }).join(',')) + "])")
	}
	
	function genScopedSlot (
	  key,
	  el,
	  state
	) {
	  if (el.for && !el.forProcessed) {
	    return genForScopedSlot(key, el, state)
	  }
	  var fn = "function(" + (String(el.slotScope)) + "){" +
	    "return " + (el.tag === 'template'
	      ? el.if
	        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
	        : genChildren(el, state) || 'undefined'
	      : genElement(el, state)) + "}";
	  return ("{key:" + key + ",fn:" + fn + "}")
	}
	
	function genForScopedSlot (
	  key,
	  el,
	  state
	) {
	  var exp = el.for;
	  var alias = el.alias;
	  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
	  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
	  el.forProcessed = true; // avoid recursion
	  return "_l((" + exp + ")," +
	    "function(" + alias + iterator1 + iterator2 + "){" +
	      "return " + (genScopedSlot(key, el, state)) +
	    '})'
	}
	
	function genChildren (
	  el,
	  state,
	  checkSkip,
	  altGenElement,
	  altGenNode
	) {
	  var children = el.children;
	  if (children.length) {
	    var el$1 = children[0];
	    // optimize single v-for
	    if (children.length === 1 &&
	      el$1.for &&
	      el$1.tag !== 'template' &&
	      el$1.tag !== 'slot'
	    ) {
	      return (altGenElement || genElement)(el$1, state)
	    }
	    var normalizationType = checkSkip
	      ? getNormalizationType(children, state.maybeComponent)
	      : 0;
	    var gen = altGenNode || genNode;
	    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
	  }
	}
	
	// determine the normalization needed for the children array.
	// 0: no normalization needed
	// 1: simple normalization needed (possible 1-level deep nested array)
	// 2: full normalization needed
	function getNormalizationType (
	  children,
	  maybeComponent
	) {
	  var res = 0;
	  for (var i = 0; i < children.length; i++) {
	    var el = children[i];
	    if (el.type !== 1) {
	      continue
	    }
	    if (needsNormalization(el) ||
	        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
	      res = 2;
	      break
	    }
	    if (maybeComponent(el) ||
	        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
	      res = 1;
	    }
	  }
	  return res
	}
	
	function needsNormalization (el) {
	  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
	}
	
	function genNode (node, state) {
	  if (node.type === 1) {
	    return genElement(node, state)
	  } if (node.type === 3 && node.isComment) {
	    return genComment(node)
	  } else {
	    return genText(node)
	  }
	}
	
	function genText (text) {
	  return ("_v(" + (text.type === 2
	    ? text.expression // no need for () because already wrapped in _s()
	    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
	}
	
	function genComment (comment) {
	  return ("_e(" + (JSON.stringify(comment.text)) + ")")
	}
	
	function genSlot (el, state) {
	  var slotName = el.slotName || '"default"';
	  var children = genChildren(el, state);
	  var res = "_t(" + slotName + (children ? ("," + children) : '');
	  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
	  var bind$$1 = el.attrsMap['v-bind'];
	  if ((attrs || bind$$1) && !children) {
	    res += ",null";
	  }
	  if (attrs) {
	    res += "," + attrs;
	  }
	  if (bind$$1) {
	    res += (attrs ? '' : ',null') + "," + bind$$1;
	  }
	  return res + ')'
	}
	
	// componentName is el.component, take it as argument to shun flow's pessimistic refinement
	function genComponent (
	  componentName,
	  el,
	  state
	) {
	  var children = el.inlineTemplate ? null : genChildren(el, state, true);
	  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
	}
	
	function genProps (props) {
	  var res = '';
	  for (var i = 0; i < props.length; i++) {
	    var prop = props[i];
	    /* istanbul ignore if */
	    {
	      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
	    }
	  }
	  return res.slice(0, -1)
	}
	
	// #3895, #4268
	function transformSpecialNewlines (text) {
	  return text
	    .replace(/\u2028/g, '\\u2028')
	    .replace(/\u2029/g, '\\u2029')
	}
	
	/*  */
	
	// these keywords should not appear inside expressions, but operators like
	// typeof, instanceof and in are allowed
	var prohibitedKeywordRE = new RegExp('\\b' + (
	  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
	  'super,throw,while,yield,delete,export,import,return,switch,default,' +
	  'extends,finally,continue,debugger,function,arguments'
	).split(',').join('\\b|\\b') + '\\b');
	
	// these unary operators should not be used as property/method names
	var unaryOperatorsRE = new RegExp('\\b' + (
	  'delete,typeof,void'
	).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');
	
	// strip strings in expressions
	var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
	
	// detect problematic expressions in a template
	function detectErrors (ast) {
	  var errors = [];
	  if (ast) {
	    checkNode(ast, errors);
	  }
	  return errors
	}
	
	function checkNode (node, errors) {
	  if (node.type === 1) {
	    for (var name in node.attrsMap) {
	      if (dirRE.test(name)) {
	        var value = node.attrsMap[name];
	        if (value) {
	          if (name === 'v-for') {
	            checkFor(node, ("v-for=\"" + value + "\""), errors);
	          } else if (onRE.test(name)) {
	            checkEvent(value, (name + "=\"" + value + "\""), errors);
	          } else {
	            checkExpression(value, (name + "=\"" + value + "\""), errors);
	          }
	        }
	      }
	    }
	    if (node.children) {
	      for (var i = 0; i < node.children.length; i++) {
	        checkNode(node.children[i], errors);
	      }
	    }
	  } else if (node.type === 2) {
	    checkExpression(node.expression, node.text, errors);
	  }
	}
	
	function checkEvent (exp, text, errors) {
	  var stipped = exp.replace(stripStringRE, '');
	  var keywordMatch = stipped.match(unaryOperatorsRE);
	  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
	    errors.push(
	      "avoid using JavaScript unary operator as property name: " +
	      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
	    );
	  }
	  checkExpression(exp, text, errors);
	}
	
	function checkFor (node, text, errors) {
	  checkExpression(node.for || '', text, errors);
	  checkIdentifier(node.alias, 'v-for alias', text, errors);
	  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
	  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
	}
	
	function checkIdentifier (
	  ident,
	  type,
	  text,
	  errors
	) {
	  if (typeof ident === 'string') {
	    try {
	      new Function(("var " + ident + "=_"));
	    } catch (e) {
	      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
	    }
	  }
	}
	
	function checkExpression (exp, text, errors) {
	  try {
	    new Function(("return " + exp));
	  } catch (e) {
	    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
	    if (keywordMatch) {
	      errors.push(
	        "avoid using JavaScript keyword as property name: " +
	        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
	      );
	    } else {
	      errors.push(
	        "invalid expression: " + (e.message) + " in\n\n" +
	        "    " + exp + "\n\n" +
	        "  Raw expression: " + (text.trim()) + "\n"
	      );
	    }
	  }
	}
	
	/*  */
	
	function createFunction (code, errors) {
	  try {
	    return new Function(code)
	  } catch (err) {
	    errors.push({ err: err, code: code });
	    return noop
	  }
	}
	
	function createCompileToFunctionFn (compile) {
	  var cache = Object.create(null);
	
	  return function compileToFunctions (
	    template,
	    options,
	    vm
	  ) {
	    options = extend({}, options);
	    var warn$$1 = options.warn || warn;
	    delete options.warn;
	
	    /* istanbul ignore if */
	    {
	      // detect possible CSP restriction
	      try {
	        new Function('return 1');
	      } catch (e) {
	        if (e.toString().match(/unsafe-eval|CSP/)) {
	          warn$$1(
	            'It seems you are using the standalone build of Vue.js in an ' +
	            'environment with Content Security Policy that prohibits unsafe-eval. ' +
	            'The template compiler cannot work in this environment. Consider ' +
	            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
	            'templates into render functions.'
	          );
	        }
	      }
	    }
	
	    // check cache
	    var key = options.delimiters
	      ? String(options.delimiters) + template
	      : template;
	    if (cache[key]) {
	      return cache[key]
	    }
	
	    // compile
	    var compiled = compile(template, options);
	
	    // check compilation errors/tips
	    {
	      if (compiled.errors && compiled.errors.length) {
	        warn$$1(
	          "Error compiling template:\n\n" + template + "\n\n" +
	          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
	          vm
	        );
	      }
	      if (compiled.tips && compiled.tips.length) {
	        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
	      }
	    }
	
	    // turn code into functions
	    var res = {};
	    var fnGenErrors = [];
	    res.render = createFunction(compiled.render, fnGenErrors);
	    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
	      return createFunction(code, fnGenErrors)
	    });
	
	    // check function generation errors.
	    // this should only happen if there is a bug in the compiler itself.
	    // mostly for codegen development use
	    /* istanbul ignore if */
	    {
	      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
	        warn$$1(
	          "Failed to generate render function:\n\n" +
	          fnGenErrors.map(function (ref) {
	            var err = ref.err;
	            var code = ref.code;
	
	            return ((err.toString()) + " in\n\n" + code + "\n");
	        }).join('\n'),
	          vm
	        );
	      }
	    }
	
	    return (cache[key] = res)
	  }
	}
	
	/*  */
	
	function createCompilerCreator (baseCompile) {
	  return function createCompiler (baseOptions) {
	    function compile (
	      template,
	      options
	    ) {
	      var finalOptions = Object.create(baseOptions);
	      var errors = [];
	      var tips = [];
	      finalOptions.warn = function (msg, tip) {
	        (tip ? tips : errors).push(msg);
	      };
	
	      if (options) {
	        // merge custom modules
	        if (options.modules) {
	          finalOptions.modules =
	            (baseOptions.modules || []).concat(options.modules);
	        }
	        // merge custom directives
	        if (options.directives) {
	          finalOptions.directives = extend(
	            Object.create(baseOptions.directives || null),
	            options.directives
	          );
	        }
	        // copy other options
	        for (var key in options) {
	          if (key !== 'modules' && key !== 'directives') {
	            finalOptions[key] = options[key];
	          }
	        }
	      }
	
	      var compiled = baseCompile(template, finalOptions);
	      {
	        errors.push.apply(errors, detectErrors(compiled.ast));
	      }
	      compiled.errors = errors;
	      compiled.tips = tips;
	      return compiled
	    }
	
	    return {
	      compile: compile,
	      compileToFunctions: createCompileToFunctionFn(compile)
	    }
	  }
	}
	
	/*  */
	
	// `createCompilerCreator` allows creating compilers that use alternative
	// parser/optimizer/codegen, e.g the SSR optimizing compiler.
	// Here we just export a default compiler using the default parts.
	var createCompiler = createCompilerCreator(function baseCompile (
	  template,
	  options
	) {
	  var ast = parse(template.trim(), options);
	  if (options.optimize !== false) {
	    optimize(ast, options);
	  }
	  var code = generate(ast, options);
	  return {
	    ast: ast,
	    render: code.render,
	    staticRenderFns: code.staticRenderFns
	  }
	});
	
	/*  */
	
	var ref$1 = createCompiler(baseOptions);
	var compileToFunctions = ref$1.compileToFunctions;
	
	/*  */
	
	// check whether current browser encodes a char inside attribute values
	var div;
	function getShouldDecode (href) {
	  div = div || document.createElement('div');
	  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
	  return div.innerHTML.indexOf('&#10;') > 0
	}
	
	// #3663: IE encodes newlines inside attribute values while other browsers don't
	var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
	// #6828: chrome encodes content in a[href]
	var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;
	
	/*  */
	
	var idToTemplate = cached(function (id) {
	  var el = query(id);
	  return el && el.innerHTML
	});
	
	var mount = Vue$3.prototype.$mount;
	Vue$3.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && query(el);
	
	  /* istanbul ignore if */
	  if (el === document.body || el === document.documentElement) {
	    "development" !== 'production' && warn(
	      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
	    );
	    return this
	  }
	
	  var options = this.$options;
	  // resolve template/el and convert to render function
	  if (!options.render) {
	    var template = options.template;
	    if (template) {
	      if (typeof template === 'string') {
	        if (template.charAt(0) === '#') {
	          template = idToTemplate(template);
	          /* istanbul ignore if */
	          if ("development" !== 'production' && !template) {
	            warn(
	              ("Template element not found or is empty: " + (options.template)),
	              this
	            );
	          }
	        }
	      } else if (template.nodeType) {
	        template = template.innerHTML;
	      } else {
	        {
	          warn('invalid template option:' + template, this);
	        }
	        return this
	      }
	    } else if (el) {
	      template = getOuterHTML(el);
	    }
	    if (template) {
	      /* istanbul ignore if */
	      if ("development" !== 'production' && config.performance && mark) {
	        mark('compile');
	      }
	
	      var ref = compileToFunctions(template, {
	        shouldDecodeNewlines: shouldDecodeNewlines,
	        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
	        delimiters: options.delimiters,
	        comments: options.comments
	      }, this);
	      var render = ref.render;
	      var staticRenderFns = ref.staticRenderFns;
	      options.render = render;
	      options.staticRenderFns = staticRenderFns;
	
	      /* istanbul ignore if */
	      if ("development" !== 'production' && config.performance && mark) {
	        mark('compile end');
	        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
	      }
	    }
	  }
	  return mount.call(this, el, hydrating)
	};
	
	/**
	 * Get outerHTML of elements, taking care
	 * of SVG elements in IE as well.
	 */
	function getOuterHTML (el) {
	  if (el.outerHTML) {
	    return el.outerHTML
	  } else {
	    var container = document.createElement('div');
	    container.appendChild(el.cloneNode(true));
	    return container.innerHTML
	  }
	}
	
	Vue$3.compile = compileToFunctions;
	
	return Vue$3;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(377).setImmediate))

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	//This piece of code was orignally written by amirnissim and can be seen here
	//http://stackoverflow.com/a/11703018/2694653
	//This has been ported to Vanilla.js by GuillaumeLeclerc
	exports.default = function (input) {
	  var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;
	
	  function addEventListenerWrapper(type, listener) {
	    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
	    // and then trigger the original listener.
	    if (type == 'keydown') {
	      var orig_listener = listener;
	      listener = function listener(event) {
	        var suggestion_selected = document.getElementsByClassName('pac-item-selected').length > 0;
	        if (event.which == 13 && !suggestion_selected) {
	          var simulatedEvent = document.createEvent('Event');
	          simulatedEvent.keyCode = 40;
	          simulatedEvent.which = 40;
	          orig_listener.apply(input, [simulatedEvent]);
	        }
	        orig_listener.apply(input, [event]);
	      };
	    }
	    _addEventListener.apply(input, [type, listener]);
	  }
	
	  input.addEventListener = addEventListenerWrapper;
	  input.attachEvent = addEventListenerWrapper;
	};

/***/ }),
/* 386 */,
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(388);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(24);
	var bind = __webpack_require__(177);
	var Axios = __webpack_require__(390);
	var defaults = __webpack_require__(120);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(174);
	axios.CancelToken = __webpack_require__(389);
	axios.isCancel = __webpack_require__(175);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(404);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(174);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(120);
	var utils = __webpack_require__(24);
	var InterceptorManager = __webpack_require__(391);
	var dispatchRequest = __webpack_require__(392);
	var isAbsoluteURL = __webpack_require__(400);
	var combineURLs = __webpack_require__(398);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(24);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(24);
	var transformData = __webpack_require__(395);
	var isCancel = __webpack_require__(175);
	var defaults = __webpack_require__(120);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(176);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(24);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 396 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(24);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(24);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(24);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(24);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(24);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 404 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _simulateArrowDown = __webpack_require__(385);
	
	var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);
	
	var _getPropsValuesMixin = __webpack_require__(42);
	
	var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);
	
	var _manager = __webpack_require__(91);
	
	var _assert = __webpack_require__(119);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var props = {
	  bounds: {
	    type: Object
	  },
	  componentRestrictions: {
	    type: Object
	  },
	  types: {
	    type: Array,
	    default: function _default() {
	      return [];
	    }
	  },
	  placeholder: {
	    required: false,
	    type: String
	  },
	  selectFirstOnEnter: {
	    require: false,
	    type: Boolean,
	    default: false
	  },
	  value: {
	    type: String,
	    default: ''
	  },
	  options: {
	    type: Object
	  }
	};
	
	exports.default = {
	  mixins: [_getPropsValuesMixin2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    _manager.loaded.then(function () {
	      var options = _lodash2.default.clone(_this.getPropsValues());
	      if (_this.selectFirstOnEnter) {
	        (0, _simulateArrowDown2.default)(_this.$refs.input);
	      }
	
	      (0, _assert2.default)(typeof google.maps.places.Autocomplete === 'function', 'google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
	
	      /* eslint-disable no-unused-vars */
	      var finalOptions = _lodash2.default.pickBy(_lodash2.default.defaults({}, options.options, _lodash2.default.omit(options, ['options', 'selectFirstOnEnter', 'value', 'place', 'placeholder'])), function (v, k) {
	        return v !== undefined;
	      });
	
	      // Component restrictions is rather particular. Undefined not allowed
	      _this.$watch('componentRestrictions', function (v) {
	        if (v !== undefined) {
	          _this.$autocomplete.setComponentRestrictions(v);
	        }
	      });
	
	      _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
	      (0, _propsBinder2.default)(_this, _this.$autocomplete, _lodash2.default.omit(props, ['placeholder', 'place', 'selectFirstOnEnter', 'value', 'componentRestrictions']));
	
	      _this.$autocomplete.addListener('place_changed', function () {
	        _this.$emit('place_changed', _this.$autocomplete.getPlace());
	      });
	    });
	  },
	
	  props: props
	};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _eventsBinder = __webpack_require__(47);
	
	var _eventsBinder2 = _interopRequireDefault(_eventsBinder);
	
	var _mapElementMixin = __webpack_require__(55);
	
	var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var props = {
	  options: {
	    type: Object,
	    required: false,
	    default: function _default() {
	      return {};
	    }
	  },
	  content: {},
	  opened: {
	    type: Boolean,
	    default: true
	  },
	  position: {
	    type: Object,
	    twoWay: true
	  },
	  zIndex: {
	    type: Number,
	    twoWay: true
	  }
	};
	
	var events = ['domready', 'closeclick', 'content_changed'];
	
	exports.default = {
	  mixins: [_mapElementMixin2.default],
	  replace: false,
	  props: props,
	
	  mounted: function mounted() {
	    var el = this.$refs.flyaway;
	    el.parentNode.removeChild(el);
	  },
	  deferredReady: function deferredReady() {
	    this.$markerObject = null;
	    this.$markerComponent = this.$findAncestor(function (ans) {
	      return ans.$markerObject;
	    });
	
	    if (this.$markerComponent) {
	      this.$markerObject = this.$markerComponent.$markerObject;
	    }
	    this.createInfoWindow();
	  },
	  destroyed: function destroyed() {
	    if (this.disconnect) {
	      this.disconnect();
	    }
	    if (this.$infoWindow) {
	      this.$infoWindow.setMap(null);
	    }
	  },
	
	  methods: {
	    openInfoWindow: function openInfoWindow() {
	      if (this.opened) {
	        if (this.$markerObject !== null) {
	          this.$infoWindow.open(this.$map, this.$markerObject);
	        } else {
	          this.$infoWindow.open(this.$map);
	        }
	      } else {
	        this.$infoWindow.close();
	      }
	    },
	    createInfoWindow: function createInfoWindow() {
	      var _this = this;
	
	      // setting options
	      var options = _lodash2.default.clone(this.options);
	      options.content = this.$refs.flyaway;
	
	      // only set the position if the info window is not bound to a marker
	      if (this.$markerComponent === null) {
	        options.position = this.position;
	      }
	
	      this.$infoWindow = new google.maps.InfoWindow(options);
	
	      // Binding
	      (0, _propsBinder2.default)(this, this.$infoWindow, _lodash2.default.omit(props, ['opened']));
	      (0, _eventsBinder2.default)(this, this.$infoWindow, events);
	
	      this.openInfoWindow();
	      this.$watch('opened', function () {
	        _this.openInfoWindow();
	      });
	    }
	  }
	};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(48);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _manager = __webpack_require__(91);
	
	var _deferredReady = __webpack_require__(118);
	
	var _eventsBinder = __webpack_require__(47);
	
	var _eventsBinder2 = _interopRequireDefault(_eventsBinder);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _getPropsValuesMixin = __webpack_require__(42);
	
	var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);
	
	var _mountableMixin = __webpack_require__(171);
	
	var _mountableMixin2 = _interopRequireDefault(_mountableMixin);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var props = {
	  center: {
	    required: true,
	    twoWay: true,
	    type: Object
	  },
	  zoom: {
	    required: false,
	    twoWay: true,
	    type: Number
	  },
	  heading: {
	    type: Number,
	    twoWay: true
	  },
	  mapTypeId: {
	    twoWay: true,
	    type: String
	  },
	  bounds: {
	    twoWay: true,
	    type: Object
	  },
	  tilt: {
	    twoWay: true,
	    type: Number
	  },
	  options: {
	    type: Object,
	    default: function _default() {
	      return {};
	    }
	  }
	};
	
	var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'idle', 'mousemove', 'mouseout', 'mouseover', 'resize', 'rightclick', 'tilesloaded'];
	
	// Plain Google Maps methods exposed here for convenience
	var linkedMethods = (0, _lodash2.default)(['panBy', 'panTo', 'panToBounds', 'fitBounds']).map(function (methodName) {
	  return [methodName, function () {
	    if (this.$mapObject) this.$mapObject[methodName].apply(this.$mapObject, arguments);
	  }];
	}).fromPairs().value();
	
	// Other convenience methods exposed by Vue Google Maps
	var customMethods = {
	  resize: function resize() {
	    if (this.$mapObject) {
	      google.maps.event.trigger(this.$mapObject, 'resize');
	    }
	  },
	  resizePreserveCenter: function resizePreserveCenter() {
	    if (!this.$mapObject) return;
	
	    var oldCenter = this.$mapObject.getCenter();
	    google.maps.event.trigger(this.$mapObject, 'resize');
	    this.$mapObject.setCenter(oldCenter);
	  },
	
	  /// Override mountableMixin::_resizeCallback
	  /// because resizePreserveCenter is usually the
	  /// expected behaviour
	  _resizeCallback: function _resizeCallback() {
	    this.resizePreserveCenter();
	  }
	};
	
	// Methods is a combination of customMethods and linkedMethods
	var methods = _lodash2.default.assign({}, customMethods, linkedMethods);
	
	exports.default = {
	  mixins: [_getPropsValuesMixin2.default, _deferredReady.DeferredReadyMixin, _mountableMixin2.default],
	  props: props,
	  replace: false, // necessary for css styles
	
	  created: function created() {
	    var _this = this;
	
	    this.$mapCreated = new _promise2.default(function (resolve, reject) {
	      _this.$mapCreatedDeferred = { resolve: resolve, reject: reject };
	    });
	
	    var updateCenter = function updateCenter() {
	      if (!_this.$mapObject) return;
	
	      _this.$mapObject.setCenter({
	        lat: _this.finalLat,
	        lng: _this.finalLng
	      });
	    };
	    this.$watch('finalLat', updateCenter);
	    this.$watch('finalLng', updateCenter);
	  },
	
	  computed: {
	    finalLat: function finalLat() {
	      return this.center && typeof this.center.lat === 'function' ? this.center.lat() : this.center.lat;
	    },
	    finalLng: function finalLng() {
	      return this.center && typeof this.center.lng === 'function' ? this.center.lng() : this.center.lng;
	    }
	  },
	
	  watch: {
	    zoom: function zoom(_zoom) {
	      if (this.$mapObject) {
	        this.$mapObject.setZoom(_zoom);
	      }
	    }
	  },
	
	  deferredReady: function deferredReady() {
	    var _this2 = this;
	
	    return _manager.loaded.then(function () {
	      // getting the DOM element where to create the map
	      var element = _this2.$refs['vue-map'];
	
	      // creating the map
	      var copiedData = _lodash2.default.clone(_this2.getPropsValues());
	      delete copiedData.options;
	      var options = _lodash2.default.clone(_this2.options);
	      _lodash2.default.assign(options, copiedData);
	      _this2.$mapObject = new google.maps.Map(element, options);
	
	      // binding properties (two and one way)
	      (0, _propsBinder2.default)(_this2, _this2.$mapObject, _lodash2.default.omit(props, ['center', 'zoom', 'bounds']));
	
	      // manually trigger center and zoom
	      _this2.$mapObject.addListener('center_changed', function () {
	        _this2.$emit('center_changed', _this2.$mapObject.getCenter());
	      });
	      _this2.$mapObject.addListener('zoom_changed', function () {
	        _this2.$emit('zoom_changed', _this2.$mapObject.getZoom());
	      });
	      _this2.$mapObject.addListener('bounds_changed', function () {
	        _this2.$emit('bounds_changed', _this2.$mapObject.getBounds());
	      });
	
	      //binding events
	      (0, _eventsBinder2.default)(_this2, _this2.$mapObject, events);
	
	      _this2.$mapCreatedDeferred.resolve(_this2.$mapObject);
	
	      return _this2.$mapCreated;
	    }).catch(function (error) {
	      throw error;
	    });
	  },
	
	  methods: methods
	};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _simulateArrowDown = __webpack_require__(385);
	
	var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);
	
	var _getPropsValuesMixin = __webpack_require__(42);
	
	var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);
	
	var _manager = __webpack_require__(91);
	
	var _assert = __webpack_require__(119);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var props = {
	  bounds: {
	    type: Object
	  },
	  defaultPlace: {
	    type: String,
	    default: ''
	  },
	  componentRestrictions: {
	    type: Object,
	    default: null
	  },
	  types: {
	    type: Array,
	    default: function _default() {
	      return [];
	    }
	  },
	  placeholder: {
	    required: false,
	    type: String
	  },
	  className: {
	    required: false,
	    type: String
	  },
	  label: {
	    required: false,
	    type: String,
	    default: null
	  },
	  selectFirstOnEnter: {
	    require: false,
	    type: Boolean,
	    default: false
	  }
	};
	
	exports.default = {
	  mixins: [_getPropsValuesMixin2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var input = this.$refs.input;
	
	    // Allow default place to be set
	    input.value = this.defaultPlace;
	    this.$watch('defaultPlace', function () {
	      input.value = _this.defaultPlace;
	    });
	
	    _manager.loaded.then(function () {
	      var options = _lodash2.default.clone(_this.getPropsValues());
	      if (_this.selectFirstOnEnter) {
	        (0, _simulateArrowDown2.default)(_this.$refs.input);
	      }
	
	      (0, _assert2.default)(typeof google.maps.places.Autocomplete === 'function', 'google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
	
	      _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);
	      (0, _propsBinder2.default)(_this, _this.autoCompleter, _lodash2.default.omit(props, ['placeholder', 'place', 'selectFirstOnEnter', 'defaultPlace', 'className', 'label']));
	
	      _this.autoCompleter.addListener('place_changed', function () {
	        _this.$emit('place_changed', _this.autoCompleter.getPlace());
	      });
	    });
	  },
	  created: function created() {
	    console.warn('The PlaceInput class is deprecated! Please consider using the Autocomplete input instead'); //eslint-disable-line no-console
	  },
	
	  props: props
	};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(48);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _manager = __webpack_require__(91);
	
	var _deferredReady = __webpack_require__(118);
	
	var _eventsBinder = __webpack_require__(47);
	
	var _eventsBinder2 = _interopRequireDefault(_eventsBinder);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _getPropsValuesMixin = __webpack_require__(42);
	
	var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);
	
	var _mountableMixin = __webpack_require__(171);
	
	var _mountableMixin2 = _interopRequireDefault(_mountableMixin);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var props = {
	  zoom: {
	    twoWay: true,
	    type: Number
	  },
	  pov: {
	    twoWay: true,
	    type: Object,
	    trackProperties: ['pitch', 'heading']
	  },
	  position: {
	    twoWay: true,
	    type: Object
	  },
	  pano: {
	    twoWay: true,
	    type: String
	  },
	  motionTracking: {
	    twoWay: false,
	    type: Boolean
	  },
	  visible: {
	    twoWay: true,
	    type: Boolean,
	    default: true
	  },
	  options: {
	    twoWay: false,
	    type: Object,
	    default: function _default() {
	      return {};
	    }
	  }
	};
	
	var events = ['closeclick', 'status_changed'];
	
	// Other convenience methods exposed by Vue Google Maps
	var customMethods = {
	  resize: function resize() {
	    if (this.$panoObject) {
	      google.maps.event.trigger(this.$panoObject, 'resize');
	    }
	  }
	};
	
	// Methods is a combination of customMethods and linkedMethods
	var methods = _lodash2.default.assign({}, customMethods);
	
	exports.default = {
	  mixins: [_getPropsValuesMixin2.default, _deferredReady.DeferredReadyMixin, _mountableMixin2.default],
	  props: props,
	  replace: false, // necessary for css styles
	  methods: methods,
	
	  created: function created() {
	    var _this = this;
	
	    this.$panoCreated = new _promise2.default(function (resolve, reject) {
	      _this.$panoCreatedDeferred = { resolve: resolve, reject: reject };
	    });
	
	    var updateCenter = function updateCenter() {
	      if (!_this.panoObject) return;
	
	      _this.$panoObject.setPosition({
	        lat: _this.finalLat,
	        lng: _this.finalLng
	      });
	    };
	    this.$watch('finalLat', updateCenter);
	    this.$watch('finalLng', updateCenter);
	  },
	
	  computed: {
	    finalLat: function finalLat() {
	      return this.position && typeof this.position.lat === 'function' ? this.position.lat() : this.position.lat;
	    },
	    finalLng: function finalLng() {
	      return this.position && typeof this.position.lng === 'function' ? this.position.lng() : this.position.lng;
	    }
	  },
	
	  watch: {
	    zoom: function zoom(_zoom) {
	      if (this.$panoObject) {
	        this.$panoObject.setZoom(_zoom);
	      }
	    }
	  },
	
	  deferredReady: function deferredReady() {
	    var _this2 = this;
	
	    return _manager.loaded.then(function () {
	      // getting the DOM element where to create the map
	      var element = _this2.$refs['vue-street-view-pano'];
	
	      // creating the map
	      var options = _lodash2.default.defaults({}, _lodash2.default.omit(_this2.getPropsValues(), ['options']), _this2.options);
	
	      _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);
	
	      // binding properties (two and one way)
	      (0, _propsBinder2.default)(_this2, _this2.$panoObject, _lodash2.default.omit(props, ['position', 'zoom']));
	
	      //binding events
	      (0, _eventsBinder2.default)(_this2, _this2.$panoObject, events);
	
	      _this2.$panoCreatedDeferred.resolve(_this2.$panoObject);
	
	      return _this2.$panoCreated;
	    }).catch(function (error) {
	      throw error;
	    });
	  }
	};

/***/ }),
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(707);
	
	__webpack_require__(1760);
	
	__webpack_require__(508);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(461), __esModule: true };

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(463), __esModule: true };

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(464), __esModule: true };

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(466), __esModule: true };

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(467), __esModule: true };

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(468), __esModule: true };

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(453);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Symbol = __webpack_require__(187)["default"];
	
	exports["default"] = function (obj) {
	  return obj && obj.constructor === _Symbol ? "symbol" : typeof obj;
	};
	
	exports.__esModule = true;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(86);
	__webpack_require__(493);
	module.exports = __webpack_require__(16).Array.from;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(98);
	__webpack_require__(86);
	module.exports = __webpack_require__(491);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(98);
	__webpack_require__(86);
	module.exports = __webpack_require__(492);

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(16);
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return (core.JSON && core.JSON.stringify || JSON.stringify).apply(JSON, arguments);
	};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(495);
	module.exports = __webpack_require__(16).Object.assign;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(17);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(496);
	module.exports = __webpack_require__(16).Object.keys;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(497);
	module.exports = __webpack_require__(16).Object.setPrototypeOf;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(132);
	__webpack_require__(86);
	__webpack_require__(98);
	__webpack_require__(498);
	module.exports = __webpack_require__(16).Promise;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(132);
	__webpack_require__(86);
	__webpack_require__(98);
	__webpack_require__(499);
	__webpack_require__(501);
	module.exports = __webpack_require__(16).Set;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(500);
	__webpack_require__(132);
	module.exports = __webpack_require__(16).Symbol;

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(17)
	  , hide         = __webpack_require__(84)
	  , redefineAll  = __webpack_require__(126)
	  , ctx          = __webpack_require__(57)
	  , strictNew    = __webpack_require__(128)
	  , defined      = __webpack_require__(94)
	  , forOf        = __webpack_require__(95)
	  , $iterDefine  = __webpack_require__(123)
	  , step         = __webpack_require__(193)
	  , ID           = __webpack_require__(130)('id')
	  , $has         = __webpack_require__(96)
	  , isObject     = __webpack_require__(73)
	  , setSpecies   = __webpack_require__(195)
	  , DESCRIPTORS  = __webpack_require__(72)
	  , isExtensible = Object.isExtensible || isObject
	  , SIZE         = DESCRIPTORS ? '_s' : 'size'
	  , id           = 0;
	
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!$has(it, ID)){
	    // can't set id to frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add id
	    if(!create)return 'E';
	    // add missing object id
	    hide(it, ID, ++id);
	  // return object id with prefix
	  } return 'O' + it[ID];
	};
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var forOf   = __webpack_require__(95)
	  , classof = __webpack_require__(93);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    var arr = [];
	    forOf(this, false, arr.push, arr);
	    return arr;
	  };
	};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(17)
	  , global         = __webpack_require__(34)
	  , $export        = __webpack_require__(43)
	  , fails          = __webpack_require__(83)
	  , hide           = __webpack_require__(84)
	  , redefineAll    = __webpack_require__(126)
	  , forOf          = __webpack_require__(95)
	  , strictNew      = __webpack_require__(128)
	  , isObject       = __webpack_require__(73)
	  , setToStringTag = __webpack_require__(85)
	  , DESCRIPTORS    = __webpack_require__(72);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	  } else {
	    C = wrapper(function(target, iterable){
	      strictNew(target, C, NAME);
	      target._c = new Base;
	      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    $.each.call('add,clear,delete,forEach,get,has,set,keys,values,entries'.split(','),function(KEY){
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
	        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    if('size' in proto)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(73)
	  , document = __webpack_require__(34).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(17);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(97)
	  , getNames  = __webpack_require__(17).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(34).document && document.documentElement;

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(82);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(17)
	  , descriptor     = __webpack_require__(125)
	  , setToStringTag = __webpack_require__(85)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(84)(IteratorPrototype, __webpack_require__(25)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(17)
	  , toIObject = __webpack_require__(97);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(34)
	  , macrotask = __webpack_require__(490).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(82)(process) == 'process'
	  , head, last, notify;
	
	var flush = function(){
	  var parent, domain, fn;
	  if(isNode && (parent = process.domain)){
	    process.domain = null;
	    parent.exit();
	  }
	  while(head){
	    domain = head.domain;
	    fn     = head.fn;
	    if(domain)domain.enter();
	    fn(); // <- currently we use it only for Promise - try / catch not required
	    if(domain)domain.exit();
	    head = head.next;
	  } last = undefined;
	  if(parent)parent.enter();
	};
	
	// Node.js
	if(isNode){
	  notify = function(){
	    process.nextTick(flush);
	  };
	// browsers with MutationObserver
	} else if(Observer){
	  var toggle = 1
	    , node   = document.createTextNode('');
	  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	  notify = function(){
	    node.data = toggle = -toggle;
	  };
	// environments with maybe non-completely correct, but existent Promise
	} else if(Promise && Promise.resolve){
	  notify = function(){
	    Promise.resolve().then(flush);
	  };
	// for other environments - macrotask based on:
	// - setImmediate
	// - MessageChannel
	// - window.postMessag
	// - onreadystatechange
	// - setTimeout
	} else {
	  notify = function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    macrotask.call(global, flush);
	  };
	}
	
	module.exports = function asap(fn){
	  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
	  if(last)last.next = task;
	  if(!head){
	    head = task;
	    notify();
	  } last = task;
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(17)
	  , toObject = __webpack_require__(129)
	  , IObject  = __webpack_require__(189);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(83)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(43)
	  , core    = __webpack_require__(16)
	  , fails   = __webpack_require__(83);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(56)
	  , aFunction = __webpack_require__(122)
	  , SPECIES   = __webpack_require__(25)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(197)
	  , defined   = __webpack_require__(94);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(57)
	  , invoke             = __webpack_require__(480)
	  , html               = __webpack_require__(479)
	  , cel                = __webpack_require__(476)
	  , global             = __webpack_require__(34)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listner = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(82)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listner, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(56)
	  , get      = __webpack_require__(131);
	module.exports = __webpack_require__(16).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(93)
	  , ITERATOR  = __webpack_require__(25)('iterator')
	  , Iterators = __webpack_require__(74);
	module.exports = __webpack_require__(16).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx         = __webpack_require__(57)
	  , $export     = __webpack_require__(43)
	  , toObject    = __webpack_require__(129)
	  , call        = __webpack_require__(191)
	  , isArrayIter = __webpack_require__(190)
	  , toLength    = __webpack_require__(198)
	  , getIterFn   = __webpack_require__(131);
	$export($export.S + $export.F * !__webpack_require__(192)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , $$      = arguments
	      , $$len   = $$.length
	      , mapfn   = $$len > 1 ? $$[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(472)
	  , step             = __webpack_require__(193)
	  , Iterators        = __webpack_require__(74)
	  , toIObject        = __webpack_require__(97);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(123)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(43);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(485)});

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(129);
	
	__webpack_require__(486)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(43);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(194).set});

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(17)
	  , LIBRARY    = __webpack_require__(124)
	  , global     = __webpack_require__(34)
	  , ctx        = __webpack_require__(57)
	  , classof    = __webpack_require__(93)
	  , $export    = __webpack_require__(43)
	  , isObject   = __webpack_require__(73)
	  , anObject   = __webpack_require__(56)
	  , aFunction  = __webpack_require__(122)
	  , strictNew  = __webpack_require__(128)
	  , forOf      = __webpack_require__(95)
	  , setProto   = __webpack_require__(194).set
	  , same       = __webpack_require__(487)
	  , SPECIES    = __webpack_require__(25)('species')
	  , speciesConstructor = __webpack_require__(488)
	  , asap       = __webpack_require__(484)
	  , PROMISE    = 'Promise'
	  , process    = global.process
	  , isNode     = classof(process) == 'process'
	  , P          = global[PROMISE]
	  , empty      = function(){ /* empty */ }
	  , Wrapper;
	
	var testResolve = function(sub){
	  var test = new P(empty), promise;
	  if(sub)test.constructor = function(exec){
	    exec(empty, empty);
	  };
	  (promise = P.resolve(test))['catch'](empty);
	  return promise === test;
	};
	
	var USE_NATIVE = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = P && P.resolve && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && __webpack_require__(72)){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // library wrapper special case
	  if(LIBRARY && a === P && b === Wrapper)return true;
	  return same(a, b);
	};
	var getConstructor = function(C){
	  var S = anObject(C)[SPECIES];
	  return S != undefined ? S : C;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var PromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve),
	  this.reject  = aFunction(reject)
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(record, isReject){
	  if(record.n)return;
	  record.n = true;
	  var chain = record.c;
	  asap(function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , result, then;
	      try {
	        if(handler){
	          if(!ok)record.h = true;
	          result = handler === true ? value : handler(value);
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	    record.n = false;
	    if(isReject)setTimeout(function(){
	      var promise = record.p
	        , handler, console;
	      if(isUnhandled(promise)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      } record.a = undefined;
	    }, 1);
	  });
	};
	var isUnhandled = function(promise){
	  var record = promise._d
	    , chain  = record.a || record.c
	    , i      = 0
	    , reaction;
	  if(record.h)return false;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var $reject = function(value){
	  var record = this;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  notify(record, true);
	};
	var $resolve = function(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(record.p === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      asap(function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record, false);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    aFunction(executor);
	    var record = this._d = {
	      p: strictNew(this, P, PROMISE),         // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false,                               // <- handled rejection
	      n: false                                // <- notify
	    };
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(126)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction = new PromiseCapability(speciesConstructor(this, P))
	        , promise  = reaction.promise
	        , record   = this._d;
	      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      record.c.push(reaction);
	      if(record.a)record.a.push(reaction);
	      if(record.s)notify(record, false);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
	__webpack_require__(85)(P, PROMISE);
	__webpack_require__(195)(PROMISE);
	Wrapper = __webpack_require__(16)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = new PromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof P && sameConstructor(x.constructor, this))return x;
	    var capability = new PromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(192)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject
	      , values     = [];
	    var abrupt = perform(function(){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        var alreadyCalled = false;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled = true;
	          results[index] = value;
	          --remaining || resolve(results);
	        }, reject);
	      });
	      else resolve(results);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(473);
	
	// 23.2 Set Objects
	__webpack_require__(475)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(17)
	  , global         = __webpack_require__(34)
	  , has            = __webpack_require__(96)
	  , DESCRIPTORS    = __webpack_require__(72)
	  , $export        = __webpack_require__(43)
	  , redefine       = __webpack_require__(127)
	  , $fails         = __webpack_require__(83)
	  , shared         = __webpack_require__(196)
	  , setToStringTag = __webpack_require__(85)
	  , uid            = __webpack_require__(130)
	  , wks            = __webpack_require__(25)
	  , keyOf          = __webpack_require__(483)
	  , $names         = __webpack_require__(478)
	  , enumKeys       = __webpack_require__(477)
	  , isArray        = __webpack_require__(481)
	  , anObject       = __webpack_require__(56)
	  , toIObject      = __webpack_require__(97)
	  , createDesc     = __webpack_require__(125)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(124)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(43);
	
	$export($export.P, 'Set', {toJSON: __webpack_require__(474)('Set')});

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	"use strict";
	
	var _Symbol = __webpack_require__(187)["default"];
	
	var _Object$create = __webpack_require__(456)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(458)["default"];
	
	var _Promise = __webpack_require__(48)["default"];
	
	!(function (global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof _Symbol === "function" ? _Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = _Object$create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      prototype[method] = function (arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function (genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor ? ctor === GeneratorFunction ||
	    // For the native GeneratorFunction constructor, the best we can
	    // do is to check its .name property.
	    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	  };
	
	  runtime.mark = function (genFun) {
	    if (_Object$setPrototypeOf) {
	      _Object$setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = _Object$create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function (arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return _Promise.resolve(value.arg).then(function (value) {
	            invoke("next", value, resolve, reject);
	          }, function (err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return _Promise.resolve(value).then(function (unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new _Promise(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	      // If enqueue has been called before, then we want to wait until
	      // all previous Promises have been resolved before calling invoke,
	      // so that results are always delivered in the correct order. If
	      // enqueue has not been called before, then it is important to
	      // call invoke immediately, without waiting on a callback to fire,
	      // so that the async generator function has the opportunity to do
	      // any necessary setup in a predictable way. This predictability
	      // is why the Promise constructor synchronously invokes its
	      // executor callback, and why async functions synchronously
	      // execute code before the first await. Since we implement simple
	      // async functions in terms of async generators, it is especially
	      // important to get this right, even though it requires care.
	      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
	      // Avoid propagating failures to Promises returned by later
	      // invocations of the iterator.
	      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
	
	    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	    : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" || method === "throw" && delegate.iterator[method] === undefined) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(delegate.iterator[method], delegate.iterator, arg);
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function () {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function () {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function (object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function reset(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function stop() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function dispatchException(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function complete(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" || record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	// Among the various tricks for obtaining a reference to the global
	// object, this seems to be the most reliable technique that does not
	// use indirect eval (which violates Content Security Policy).
	typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(32)))

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(133);
	var Transform = __webpack_require__(134);
	var inherits = __webpack_require__(41);
	var modes = __webpack_require__(135);
	var StreamCipher = __webpack_require__(205);
	var ebtk = __webpack_require__(199);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(203),
	  CBC: __webpack_require__(200),
	  CFB: __webpack_require__(201),
	  OFB: __webpack_require__(204),
	  CTR: __webpack_require__(202)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(133);
	var Transform = __webpack_require__(134);
	var inherits = __webpack_require__(41);
	var modes = __webpack_require__(135);
	var ebtk = __webpack_require__(199);
	var StreamCipher = __webpack_require__(205);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(203),
	  CBC: __webpack_require__(200),
	  CFB: __webpack_require__(201),
	  OFB: __webpack_require__(204),
	  CTR: __webpack_require__(202)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(505)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(504)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(135);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	/*jshint node:true */
	'use strict';
	var Buffer = __webpack_require__(9).Buffer; // browserify
	var SlowBuffer = __webpack_require__(9).SlowBuffer;
	
	module.exports = bufferEq;
	
	function bufferEq(a, b) {
	
	  // shortcutting on type is necessary for correctness
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    return false;
	  }
	
	  // buffer sizes should be well-known information, so despite this
	  // shortcutting, it doesn't leak any information about the *contents* of the
	  // buffers.
	  if (a.length !== b.length) {
	    return false;
	  }
	
	  var c = 0;
	  for (var i = 0; i < a.length; i++) {
	    /*jshint bitwise:false */
	    c |= a[i] ^ b[i]; // XOR
	  }
	  return c === 0;
	}
	
	bufferEq.install = function() {
	  Buffer.prototype.equal = SlowBuffer.prototype.equal = function equal(that) {
	    return bufferEq(this, that);
	  };
	};
	
	var origBufEqual = Buffer.prototype.equal;
	var origSlowBufEqual = SlowBuffer.prototype.equal;
	bufferEq.restore = function() {
	  Buffer.prototype.equal = origBufEqual;
	  SlowBuffer.prototype.equal = origSlowBufEqual;
	};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(515);
	module.exports = __webpack_require__(36).RegExp.escape;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var isArray = __webpack_require__(104);
	var SPECIES = __webpack_require__(10)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(6);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(4);
	var toPrimitive = __webpack_require__(40);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(63);
	var gOPS = __webpack_require__(108);
	var pIE = __webpack_require__(89);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 513 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 514 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(2);
	var $re = __webpack_require__(513)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(207) });
	
	__webpack_require__(51)('copyWithin');


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $every = __webpack_require__(35)(4);
	
	$export($export.P + $export.F * !__webpack_require__(31)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { fill: __webpack_require__(136) });
	
	__webpack_require__(51)('fill');


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $filter = __webpack_require__(35)(2);
	
	$export($export.P + $export.F * !__webpack_require__(31)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(35)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(51)(KEY);


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(35)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(51)(KEY);


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $forEach = __webpack_require__(35)(0);
	var STRICT = __webpack_require__(31)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(30);
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(14);
	var call = __webpack_require__(218);
	var isArrayIter = __webpack_require__(144);
	var toLength = __webpack_require__(13);
	var createProperty = __webpack_require__(138);
	var getIterFn = __webpack_require__(161);
	
	$export($export.S + $export.F * !__webpack_require__(106)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $indexOf = __webpack_require__(100)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(31)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(104) });


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(28);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(88) != Object || !__webpack_require__(31)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(28);
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(13);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(31)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $map = __webpack_require__(35)(1);
	
	$export($export.P + $export.F * !__webpack_require__(31)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var createProperty = __webpack_require__(138);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(209);
	
	$export($export.P + $export.F * !__webpack_require__(31)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(209);
	
	$export($export.P + $export.F * !__webpack_require__(31)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var html = __webpack_require__(142);
	var cof = __webpack_require__(29);
	var toAbsoluteIndex = __webpack_require__(67);
	var toLength = __webpack_require__(13);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(6)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $some = __webpack_require__(35)(3);
	
	$export($export.P + $export.F * !__webpack_require__(31)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(18);
	var toObject = __webpack_require__(14);
	var fails = __webpack_require__(6);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(31)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66)('Array');


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(2);
	var toISOString = __webpack_require__(510);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(14);
	var toPrimitive = __webpack_require__(40);
	
	$export($export.P + $export.F * __webpack_require__(6)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(10)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(21)(proto, TO_PRIMITIVE, __webpack_require__(511));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(22)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Function', { bind: __webpack_require__(210) });


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(7);
	var getPrototypeOf = __webpack_require__(27);
	var HAS_INSTANCE = __webpack_require__(10)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(12).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(12).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(11) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(2);
	var log1p = __webpack_require__(221);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(2);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(2);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(2);
	var sign = __webpack_require__(148);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(2);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(2);
	var $expm1 = __webpack_require__(147);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { fround: __webpack_require__(220) });


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(2);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(2);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(221) });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { sign: __webpack_require__(148) });


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(147);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(147);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var has = __webpack_require__(20);
	var cof = __webpack_require__(29);
	var inheritIfRequired = __webpack_require__(143);
	var toPrimitive = __webpack_require__(40);
	var fails = __webpack_require__(6);
	var gOPN = __webpack_require__(62).f;
	var gOPD = __webpack_require__(26).f;
	var dP = __webpack_require__(12).f;
	var $trim = __webpack_require__(77).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(61)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(11) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(22)(global, NUMBER, $Number);
	}


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(2);
	var _isFinite = __webpack_require__(5).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(217) });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(2);
	var isInteger = __webpack_require__(217);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(229);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(230);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toInteger = __webpack_require__(39);
	var aNumberValue = __webpack_require__(206);
	var repeat = __webpack_require__(155);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(6)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $fails = __webpack_require__(6);
	var aNumberValue = __webpack_require__(206);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(2);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(223) });


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(61) });


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(11), 'Object', { defineProperties: __webpack_require__(224) });


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(11), 'Object', { defineProperty: __webpack_require__(12).f });


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(7);
	var meta = __webpack_require__(52).onFreeze;
	
	__webpack_require__(38)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(28);
	var $getOwnPropertyDescriptor = __webpack_require__(26).f;
	
	__webpack_require__(38)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(38)('getOwnPropertyNames', function () {
	  return __webpack_require__(225).f;
	});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(14);
	var $getPrototypeOf = __webpack_require__(27);
	
	__webpack_require__(38)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(7);
	
	__webpack_require__(38)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(7);
	
	__webpack_require__(38)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(7);
	
	__webpack_require__(38)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { is: __webpack_require__(514) });


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(14);
	var $keys = __webpack_require__(63);
	
	__webpack_require__(38)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(7);
	var meta = __webpack_require__(52).onFreeze;
	
	__webpack_require__(38)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(7);
	var meta = __webpack_require__(52).onFreeze;
	
	__webpack_require__(38)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(151).set });


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(87);
	var test = {};
	test[__webpack_require__(10)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(22)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(229);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(230);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(60);
	var global = __webpack_require__(5);
	var ctx = __webpack_require__(30);
	var classof = __webpack_require__(87);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(7);
	var aFunction = __webpack_require__(18);
	var anInstance = __webpack_require__(58);
	var forOf = __webpack_require__(59);
	var speciesConstructor = __webpack_require__(112);
	var task = __webpack_require__(157).set;
	var microtask = __webpack_require__(149)();
	var newPromiseCapabilityModule = __webpack_require__(150);
	var perform = __webpack_require__(231);
	var promiseResolve = __webpack_require__(232);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(10)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(65)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(76)($Promise, PROMISE);
	__webpack_require__(66)(PROMISE);
	Wrapper = __webpack_require__(36)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(106)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(18);
	var anObject = __webpack_require__(4);
	var rApply = (__webpack_require__(5).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(6)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(2);
	var create = __webpack_require__(61);
	var aFunction = __webpack_require__(18);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var fails = __webpack_require__(6);
	var bind = __webpack_require__(210);
	var rConstruct = (__webpack_require__(5).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(12);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(4);
	var toPrimitive = __webpack_require__(40);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(2);
	var gOPD = __webpack_require__(26).f;
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(4);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(145)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(26);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(2);
	var getProto = __webpack_require__(27);
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(26);
	var getPrototypeOf = __webpack_require__(27);
	var has = __webpack_require__(20);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(7);
	var anObject = __webpack_require__(4);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(4);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(228) });


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(4);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(2);
	var setProto = __webpack_require__(151);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(12);
	var gOPD = __webpack_require__(26);
	var getPrototypeOf = __webpack_require__(27);
	var has = __webpack_require__(20);
	var $export = __webpack_require__(2);
	var createDesc = __webpack_require__(64);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var inheritIfRequired = __webpack_require__(143);
	var dP = __webpack_require__(12).f;
	var gOPN = __webpack_require__(62).f;
	var isRegExp = __webpack_require__(105);
	var $flags = __webpack_require__(103);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(11) && (!CORRECT_NEW || __webpack_require__(6)(function () {
	  re2[__webpack_require__(10)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(22)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(66)('RegExp');


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(102)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(102)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(102)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(102)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(105);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(237);
	var anObject = __webpack_require__(4);
	var $flags = __webpack_require__(103);
	var DESCRIPTORS = __webpack_require__(11);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(22)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(6)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(23)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(23)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(23)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(23)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(153)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(13);
	var context = __webpack_require__(154);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(141)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(23)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(23)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(23)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toAbsoluteIndex = __webpack_require__(67);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(2);
	var context = __webpack_require__(154);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(141)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(23)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(153)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(146)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(23)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(28);
	var toLength = __webpack_require__(13);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(155)
	});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(23)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(13);
	var context = __webpack_require__(154);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(141)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(23)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(23)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(23)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(77)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(5);
	var has = __webpack_require__(20);
	var DESCRIPTORS = __webpack_require__(11);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(22);
	var META = __webpack_require__(52).KEY;
	var $fails = __webpack_require__(6);
	var shared = __webpack_require__(111);
	var setToStringTag = __webpack_require__(76);
	var uid = __webpack_require__(68);
	var wks = __webpack_require__(10);
	var wksExt = __webpack_require__(235);
	var wksDefine = __webpack_require__(160);
	var enumKeys = __webpack_require__(512);
	var isArray = __webpack_require__(104);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var toIObject = __webpack_require__(28);
	var toPrimitive = __webpack_require__(40);
	var createDesc = __webpack_require__(64);
	var _create = __webpack_require__(61);
	var gOPNExt = __webpack_require__(225);
	var $GOPD = __webpack_require__(26);
	var $DP = __webpack_require__(12);
	var $keys = __webpack_require__(63);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(62).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(89).f = $propertyIsEnumerable;
	  __webpack_require__(108).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(60)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(21)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $typed = __webpack_require__(113);
	var buffer = __webpack_require__(158);
	var anObject = __webpack_require__(4);
	var toAbsoluteIndex = __webpack_require__(67);
	var toLength = __webpack_require__(13);
	var isObject = __webpack_require__(7);
	var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
	var speciesConstructor = __webpack_require__(112);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(6)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(66)(ARRAY_BUFFER);


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	$export($export.G + $export.W + $export.F * !__webpack_require__(113).ABV, {
	  DataView: __webpack_require__(158).DataView
	});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(213);
	var validate = __webpack_require__(78);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(101)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(214);
	var toObject = __webpack_require__(14);
	var toLength = __webpack_require__(13);
	var aFunction = __webpack_require__(18);
	var arraySpeciesCreate = __webpack_require__(137);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(51)('flatMap');


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(214);
	var toObject = __webpack_require__(14);
	var toLength = __webpack_require__(13);
	var toInteger = __webpack_require__(39);
	var arraySpeciesCreate = __webpack_require__(137);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(51)('flatten');


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(2);
	var $includes = __webpack_require__(100)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(51)('includes');


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(2);
	var microtask = __webpack_require__(149)();
	var process = __webpack_require__(5).process;
	var isNode = __webpack_require__(29)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(2);
	var cof = __webpack_require__(29);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(109)('Map');


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(110)('Map');


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(212)('Map') });


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var scale = __webpack_require__(222);
	var fround = __webpack_require__(220);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { scale: __webpack_require__(222) });


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(14);
	var aFunction = __webpack_require__(18);
	var $defineProperty = __webpack_require__(12);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(11) && $export($export.P + __webpack_require__(107), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(14);
	var aFunction = __webpack_require__(18);
	var $defineProperty = __webpack_require__(12);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(11) && $export($export.P + __webpack_require__(107), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $entries = __webpack_require__(227)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(2);
	var ownKeys = __webpack_require__(228);
	var toIObject = __webpack_require__(28);
	var gOPD = __webpack_require__(26);
	var createProperty = __webpack_require__(138);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(14);
	var toPrimitive = __webpack_require__(40);
	var getPrototypeOf = __webpack_require__(27);
	var getOwnPropertyDescriptor = __webpack_require__(26).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(11) && $export($export.P + __webpack_require__(107), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(14);
	var toPrimitive = __webpack_require__(40);
	var getPrototypeOf = __webpack_require__(27);
	var getOwnPropertyDescriptor = __webpack_require__(26).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(11) && $export($export.P + __webpack_require__(107), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $values = __webpack_require__(227)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(2);
	var global = __webpack_require__(5);
	var core = __webpack_require__(36);
	var microtask = __webpack_require__(149)();
	var OBSERVABLE = __webpack_require__(10)('observable');
	var aFunction = __webpack_require__(18);
	var anObject = __webpack_require__(4);
	var anInstance = __webpack_require__(58);
	var redefineAll = __webpack_require__(65);
	var hide = __webpack_require__(21);
	var forOf = __webpack_require__(59);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(66)('Observable');


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(2);
	var core = __webpack_require__(36);
	var global = __webpack_require__(5);
	var speciesConstructor = __webpack_require__(112);
	var promiseResolve = __webpack_require__(232);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(2);
	var newPromiseCapability = __webpack_require__(150);
	var perform = __webpack_require__(231);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(44);
	var anObject = __webpack_require__(4);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(44);
	var anObject = __webpack_require__(4);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(238);
	var from = __webpack_require__(208);
	var metadata = __webpack_require__(44);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(27);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(44);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(27);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(44);
	var anObject = __webpack_require__(4);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(44);
	var anObject = __webpack_require__(4);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(44);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(27);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(44);
	var anObject = __webpack_require__(4);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(44);
	var anObject = __webpack_require__(4);
	var aFunction = __webpack_require__(18);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(109)('Set');


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(110)('Set');


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(212)('Set') });


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(153)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(2);
	var defined = __webpack_require__(37);
	var toLength = __webpack_require__(13);
	var isRegExp = __webpack_require__(105);
	var getFlags = __webpack_require__(103);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(145)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(233);
	var userAgent = __webpack_require__(159);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(233);
	var userAgent = __webpack_require__(159);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(77)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(77)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(160)('asyncIterator');


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(160)('observable');


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(109)('WeakMap');


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(110)('WeakMap');


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(109)('WeakSet');


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(110)('WeakSet');


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(162);
	var getKeys = __webpack_require__(63);
	var redefine = __webpack_require__(22);
	var global = __webpack_require__(5);
	var hide = __webpack_require__(21);
	var Iterators = __webpack_require__(75);
	var wks = __webpack_require__(10);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $task = __webpack_require__(157);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(5);
	var $export = __webpack_require__(2);
	var userAgent = __webpack_require__(159);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(635);
	__webpack_require__(574);
	__webpack_require__(576);
	__webpack_require__(575);
	__webpack_require__(578);
	__webpack_require__(580);
	__webpack_require__(585);
	__webpack_require__(579);
	__webpack_require__(577);
	__webpack_require__(587);
	__webpack_require__(586);
	__webpack_require__(582);
	__webpack_require__(583);
	__webpack_require__(581);
	__webpack_require__(573);
	__webpack_require__(584);
	__webpack_require__(588);
	__webpack_require__(589);
	__webpack_require__(541);
	__webpack_require__(543);
	__webpack_require__(542);
	__webpack_require__(591);
	__webpack_require__(590);
	__webpack_require__(561);
	__webpack_require__(571);
	__webpack_require__(572);
	__webpack_require__(562);
	__webpack_require__(563);
	__webpack_require__(564);
	__webpack_require__(565);
	__webpack_require__(566);
	__webpack_require__(567);
	__webpack_require__(568);
	__webpack_require__(569);
	__webpack_require__(570);
	__webpack_require__(544);
	__webpack_require__(545);
	__webpack_require__(546);
	__webpack_require__(547);
	__webpack_require__(548);
	__webpack_require__(549);
	__webpack_require__(550);
	__webpack_require__(551);
	__webpack_require__(552);
	__webpack_require__(553);
	__webpack_require__(554);
	__webpack_require__(555);
	__webpack_require__(556);
	__webpack_require__(557);
	__webpack_require__(558);
	__webpack_require__(559);
	__webpack_require__(560);
	__webpack_require__(622);
	__webpack_require__(627);
	__webpack_require__(634);
	__webpack_require__(625);
	__webpack_require__(617);
	__webpack_require__(618);
	__webpack_require__(623);
	__webpack_require__(628);
	__webpack_require__(630);
	__webpack_require__(613);
	__webpack_require__(614);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(619);
	__webpack_require__(620);
	__webpack_require__(621);
	__webpack_require__(624);
	__webpack_require__(626);
	__webpack_require__(629);
	__webpack_require__(631);
	__webpack_require__(632);
	__webpack_require__(633);
	__webpack_require__(536);
	__webpack_require__(538);
	__webpack_require__(537);
	__webpack_require__(540);
	__webpack_require__(539);
	__webpack_require__(525);
	__webpack_require__(523);
	__webpack_require__(529);
	__webpack_require__(526);
	__webpack_require__(532);
	__webpack_require__(534);
	__webpack_require__(522);
	__webpack_require__(528);
	__webpack_require__(519);
	__webpack_require__(533);
	__webpack_require__(517);
	__webpack_require__(531);
	__webpack_require__(530);
	__webpack_require__(524);
	__webpack_require__(527);
	__webpack_require__(516);
	__webpack_require__(518);
	__webpack_require__(521);
	__webpack_require__(520);
	__webpack_require__(535);
	__webpack_require__(162);
	__webpack_require__(607);
	__webpack_require__(612);
	__webpack_require__(237);
	__webpack_require__(608);
	__webpack_require__(609);
	__webpack_require__(610);
	__webpack_require__(611);
	__webpack_require__(592);
	__webpack_require__(236);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(647);
	__webpack_require__(636);
	__webpack_require__(637);
	__webpack_require__(642);
	__webpack_require__(645);
	__webpack_require__(646);
	__webpack_require__(640);
	__webpack_require__(643);
	__webpack_require__(641);
	__webpack_require__(644);
	__webpack_require__(638);
	__webpack_require__(639);
	__webpack_require__(593);
	__webpack_require__(594);
	__webpack_require__(595);
	__webpack_require__(596);
	__webpack_require__(597);
	__webpack_require__(600);
	__webpack_require__(598);
	__webpack_require__(599);
	__webpack_require__(601);
	__webpack_require__(602);
	__webpack_require__(603);
	__webpack_require__(604);
	__webpack_require__(606);
	__webpack_require__(605);
	__webpack_require__(650);
	__webpack_require__(648);
	__webpack_require__(649);
	__webpack_require__(691);
	__webpack_require__(694);
	__webpack_require__(693);
	__webpack_require__(695);
	__webpack_require__(696);
	__webpack_require__(692);
	__webpack_require__(697);
	__webpack_require__(698);
	__webpack_require__(672);
	__webpack_require__(675);
	__webpack_require__(671);
	__webpack_require__(669);
	__webpack_require__(670);
	__webpack_require__(673);
	__webpack_require__(674);
	__webpack_require__(656);
	__webpack_require__(690);
	__webpack_require__(655);
	__webpack_require__(689);
	__webpack_require__(701);
	__webpack_require__(703);
	__webpack_require__(654);
	__webpack_require__(688);
	__webpack_require__(700);
	__webpack_require__(702);
	__webpack_require__(653);
	__webpack_require__(699);
	__webpack_require__(652);
	__webpack_require__(657);
	__webpack_require__(658);
	__webpack_require__(659);
	__webpack_require__(660);
	__webpack_require__(661);
	__webpack_require__(663);
	__webpack_require__(662);
	__webpack_require__(664);
	__webpack_require__(665);
	__webpack_require__(666);
	__webpack_require__(668);
	__webpack_require__(667);
	__webpack_require__(677);
	__webpack_require__(678);
	__webpack_require__(679);
	__webpack_require__(680);
	__webpack_require__(682);
	__webpack_require__(681);
	__webpack_require__(684);
	__webpack_require__(683);
	__webpack_require__(685);
	__webpack_require__(686);
	__webpack_require__(687);
	__webpack_require__(651);
	__webpack_require__(676);
	__webpack_require__(706);
	__webpack_require__(705);
	__webpack_require__(704);
	module.exports = __webpack_require__(36);


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(240)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(713)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(240)
	
	exports.createHmac = __webpack_require__(708)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(712)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(506)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(709);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(1726)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(1850)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(9).Buffer))

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(46).Buffer;
	
	var getParamBytesForAlg = __webpack_require__(715);
	
	var MAX_OCTET = 0x80,
		CLASS_UNIVERSAL = 0,
		PRIMITIVE_BIT = 0x20,
		TAG_SEQ = 0x10,
		TAG_INT = 0x02,
		ENCODED_TAG_SEQ = (TAG_SEQ | PRIMITIVE_BIT) | (CLASS_UNIVERSAL << 6),
		ENCODED_TAG_INT = TAG_INT | (CLASS_UNIVERSAL << 6);
	
	function base64Url(base64) {
		return base64
			.replace(/=/g, '')
			.replace(/\+/g, '-')
			.replace(/\//g, '_');
	}
	
	function signatureAsBuffer(signature) {
		if (Buffer.isBuffer(signature)) {
			return signature;
		} else if ('string' === typeof signature) {
			return Buffer.from(signature, 'base64');
		}
	
		throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
	}
	
	function derToJose(signature, alg) {
		signature = signatureAsBuffer(signature);
		var paramBytes = getParamBytesForAlg(alg);
	
		// the DER encoded param should at most be the param size, plus a padding
		// zero, since due to being a signed integer
		var maxEncodedParamLength = paramBytes + 1;
	
		var inputLength = signature.length;
	
		var offset = 0;
		if (signature[offset++] !== ENCODED_TAG_SEQ) {
			throw new Error('Could not find expected "seq"');
		}
	
		var seqLength = signature[offset++];
		if (seqLength === (MAX_OCTET | 1)) {
			seqLength = signature[offset++];
		}
	
		if (inputLength - offset < seqLength) {
			throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
		}
	
		if (signature[offset++] !== ENCODED_TAG_INT) {
			throw new Error('Could not find expected "int" for "r"');
		}
	
		var rLength = signature[offset++];
	
		if (inputLength - offset - 2 < rLength) {
			throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
		}
	
		if (maxEncodedParamLength < rLength) {
			throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
		}
	
		var rOffset = offset;
		offset += rLength;
	
		if (signature[offset++] !== ENCODED_TAG_INT) {
			throw new Error('Could not find expected "int" for "s"');
		}
	
		var sLength = signature[offset++];
	
		if (inputLength - offset !== sLength) {
			throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
		}
	
		if (maxEncodedParamLength < sLength) {
			throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
		}
	
		var sOffset = offset;
		offset += sLength;
	
		if (offset !== inputLength) {
			throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
		}
	
		var rPadding = paramBytes - rLength,
			sPadding = paramBytes - sLength;
	
		var dst = Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
	
		for (offset = 0; offset < rPadding; ++offset) {
			dst[offset] = 0;
		}
		signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
	
		offset = paramBytes;
	
		for (var o = offset; offset < o + sPadding; ++offset) {
			dst[offset] = 0;
		}
		signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
	
		dst = dst.toString('base64');
		dst = base64Url(dst);
	
		return dst;
	}
	
	function countPadding(buf, start, stop) {
		var padding = 0;
		while (start + padding < stop && buf[start + padding] === 0) {
			++padding;
		}
	
		var needsSign = buf[start + padding] >= MAX_OCTET;
		if (needsSign) {
			--padding;
		}
	
		return padding;
	}
	
	function joseToDer(signature, alg) {
		signature = signatureAsBuffer(signature);
		var paramBytes = getParamBytesForAlg(alg);
	
		var signatureBytes = signature.length;
		if (signatureBytes !== paramBytes * 2) {
			throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
		}
	
		var rPadding = countPadding(signature, 0, paramBytes);
		var sPadding = countPadding(signature, paramBytes, signature.length);
		var rLength = paramBytes - rPadding;
		var sLength = paramBytes - sPadding;
	
		var rsBytes = 1 + 1 + rLength + 1 + 1 + sLength;
	
		var shortLength = rsBytes < MAX_OCTET;
	
		var dst = Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
	
		var offset = 0;
		dst[offset++] = ENCODED_TAG_SEQ;
		if (shortLength) {
			// Bit 8 has value "0"
			// bits 7-1 give the length.
			dst[offset++] = rsBytes;
		} else {
			// Bit 8 of first octet has value "1"
			// bits 7-1 give the number of additional length octets.
			dst[offset++] = MAX_OCTET	| 1;
			// length, base 256
			dst[offset++] = rsBytes & 0xff;
		}
		dst[offset++] = ENCODED_TAG_INT;
		dst[offset++] = rLength;
		if (rPadding < 0) {
			dst[offset++] = 0;
			offset += signature.copy(dst, offset, 0, paramBytes);
		} else {
			offset += signature.copy(dst, offset, rPadding, paramBytes);
		}
		dst[offset++] = ENCODED_TAG_INT;
		dst[offset++] = sLength;
		if (sPadding < 0) {
			dst[offset++] = 0;
			signature.copy(dst, offset, paramBytes);
		} else {
			signature.copy(dst, offset, paramBytes + sPadding);
		}
	
		return dst;
	}
	
	module.exports = {
		derToJose: derToJose,
		joseToDer: joseToDer
	};


/***/ }),
/* 715 */
/***/ (function(module, exports) {

	'use strict';
	
	function getParamSize(keySize) {
		var result = ((keySize / 8) | 0) + (keySize % 8 === 0 ? 0 : 1);
		return result;
	}
	
	var paramBytesForAlg = {
		ES256: getParamSize(256),
		ES384: getParamSize(384),
		ES512: getParamSize(521)
	};
	
	function getParamBytesForAlg(alg) {
		var paramBytes = paramBytesForAlg[alg];
		if (paramBytes) {
			return paramBytes;
		}
	
		throw new Error('Unknown algorithm "' + alg + '"');
	}
	
	module.exports = getParamBytesForAlg;


/***/ }),
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// since we are requiring the top level of faker, load all locales by default
	var Faker = __webpack_require__(756);
	var faker = new Faker({ locales: __webpack_require__(758) });
	module['exports'] = faker;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	/**
	 *
	 * @namespace faker.address
	 */
	function Address (faker) {
	  var f = faker.fake,
	      Helpers = faker.helpers;
	
	  /**
	   * Generates random zipcode from format. If format is not specified, the
	   * locale's zip format is used.
	   *
	   * @method faker.address.zipCode
	   * @param {String} format
	   */
	  this.zipCode = function(format) {
	    // if zip format is not specified, use the zip format defined for the locale
	    if (typeof format === 'undefined') {
	      var localeFormat = faker.definitions.address.postcode;
	      if (typeof localeFormat === 'string') {
	        format = localeFormat;
	      } else {
	        format = faker.random.arrayElement(localeFormat);
	      }
	    }
	    return Helpers.replaceSymbols(format);
	  }
	
	  /**
	   * Generates a random localized city name. The format string can contain any
	   * method provided by faker wrapped in `{{}}`, e.g. `{{name.firstName}}` in
	   * order to build the city name.
	   *
	   * If no format string is provided one of the following is randomly used:
	   * 
	   * * `{{address.cityPrefix}} {{name.firstName}}{{address.citySuffix}}`
	   * * `{{address.cityPrefix}} {{name.firstName}}`
	   * * `{{name.firstName}}{{address.citySuffix}}`
	   * * `{{name.lastName}}{{address.citySuffix}}`
	   *
	   * @method faker.address.city
	   * @param {String} format
	   */
	  this.city = function (format) {
	    var formats = [
	      '{{address.cityPrefix}} {{name.firstName}}{{address.citySuffix}}',
	      '{{address.cityPrefix}} {{name.firstName}}',
	      '{{name.firstName}}{{address.citySuffix}}',
	      '{{name.lastName}}{{address.citySuffix}}'
	    ];
	
	    if (typeof format !== "number") {
	      format = faker.random.number(formats.length - 1);
	    }
	
	    return f(formats[format]);
	
	  }
	
	  /**
	   * Return a random localized city prefix
	   * @method faker.address.cityPrefix
	   */
	  this.cityPrefix = function () {
	    return faker.random.arrayElement(faker.definitions.address.city_prefix);
	  }
	
	  /**
	   * Return a random localized city suffix
	   *
	   * @method faker.address.citySuffix
	   */
	  this.citySuffix = function () {
	    return faker.random.arrayElement(faker.definitions.address.city_suffix);
	  }
	
	  /**
	   * Returns a random localized street name
	   *
	   * @method faker.address.streetName
	   */
	  this.streetName = function () {
	      var result;
	      var suffix = faker.address.streetSuffix();
	      if (suffix !== "") {
	          suffix = " " + suffix
	      }
	
	      switch (faker.random.number(1)) {
	      case 0:
	          result = faker.name.lastName() + suffix;
	          break;
	      case 1:
	          result = faker.name.firstName() + suffix;
	          break;
	      }
	      return result;
	  }
	
	  //
	  // TODO: change all these methods that accept a boolean to instead accept an options hash.
	  //
	  /**
	   * Returns a random localized street address
	   *
	   * @method faker.address.streetAddress
	   * @param {Boolean} useFullAddress
	   */
	  this.streetAddress = function (useFullAddress) {
	      if (useFullAddress === undefined) { useFullAddress = false; }
	      var address = "";
	      switch (faker.random.number(2)) {
	      case 0:
	          address = Helpers.replaceSymbolWithNumber("#####") + " " + faker.address.streetName();
	          break;
	      case 1:
	          address = Helpers.replaceSymbolWithNumber("####") +  " " + faker.address.streetName();
	          break;
	      case 2:
	          address = Helpers.replaceSymbolWithNumber("###") + " " + faker.address.streetName();
	          break;
	      }
	      return useFullAddress ? (address + " " + faker.address.secondaryAddress()) : address;
	  }
	
	  /**
	   * streetSuffix
	   *
	   * @method faker.address.streetSuffix
	   */
	  this.streetSuffix = function () {
	      return faker.random.arrayElement(faker.definitions.address.street_suffix);
	  }
	  
	  /**
	   * streetPrefix
	   *
	   * @method faker.address.streetPrefix
	   */
	  this.streetPrefix = function () {
	      return faker.random.arrayElement(faker.definitions.address.street_prefix);
	  }
	
	  /**
	   * secondaryAddress
	   *
	   * @method faker.address.secondaryAddress
	   */
	  this.secondaryAddress = function () {
	      return Helpers.replaceSymbolWithNumber(faker.random.arrayElement(
	          [
	              'Apt. ###',
	              'Suite ###'
	          ]
	      ));
	  }
	
	  /**
	   * county
	   *
	   * @method faker.address.county
	   */
	  this.county = function () {
	    return faker.random.arrayElement(faker.definitions.address.county);
	  }
	
	  /**
	   * country
	   *
	   * @method faker.address.country
	   */
	  this.country = function () {
	    return faker.random.arrayElement(faker.definitions.address.country);
	  }
	
	  /**
	   * countryCode
	   *
	   * @method faker.address.countryCode
	   */
	  this.countryCode = function () {
	    return faker.random.arrayElement(faker.definitions.address.country_code);
	  }
	
	  /**
	   * state
	   *
	   * @method faker.address.state
	   * @param {Boolean} useAbbr
	   */
	  this.state = function (useAbbr) {
	      return faker.random.arrayElement(faker.definitions.address.state);
	  }
	
	  /**
	   * stateAbbr
	   *
	   * @method faker.address.stateAbbr
	   */
	  this.stateAbbr = function () {
	      return faker.random.arrayElement(faker.definitions.address.state_abbr);
	  }
	
	  /**
	   * latitude
	   *
	   * @method faker.address.latitude
	   */
	  this.latitude = function () {
	      return (faker.random.number(180 * 10000) / 10000.0 - 90.0).toFixed(4);
	  }
	
	  /**
	   * longitude
	   *
	   * @method faker.address.longitude
	   */
	  this.longitude = function () {
	      return (faker.random.number(360 * 10000) / 10000.0 - 180.0).toFixed(4);
	  }
	  
	  return this;
	}
	
	
	module.exports = Address;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.commerce
	 */
	var Commerce = function (faker) {
	  var self = this;
	
	  /**
	   * color
	   *
	   * @method faker.commerce.color
	   */
	  self.color = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.color);
	  };
	
	  /**
	   * department
	   *
	   * @method faker.commerce.department
	   * @param {number} max
	   * @param {number} fixedAmount
	   */
	  self.department = function(max, fixedAmount) {
	      return faker.random.arrayElement(faker.definitions.commerce.department);
	  };
	
	  /**
	   * productName
	   *
	   * @method faker.commerce.productName
	   */
	  self.productName = function() {
	      return faker.commerce.productAdjective() + " " +
	              faker.commerce.productMaterial() + " " +
	              faker.commerce.product();
	  };
	
	  /**
	   * price
	   *
	   * @method faker.commerce.price
	   * @param {number} min
	   * @param {number} max
	   * @param {number} dec
	   * @param {string} symbol
	   */
	  self.price = function(min, max, dec, symbol) {
	      min = min || 0;
	      max = max || 1000;
	      dec = dec || 2;
	      symbol = symbol || '';
	
	      if(min < 0 || max < 0) {
	          return symbol + 0.00;
	      }
	
	      var randValue = faker.random.number({ max: max, min: min });
	
	      return symbol + (Math.round(randValue * Math.pow(10, dec)) / Math.pow(10, dec)).toFixed(dec);
	  };
	
	  /*
	  self.categories = function(num) {
	      var categories = [];
	
	      do {
	          var category = faker.random.arrayElement(faker.definitions.commerce.department);
	          if(categories.indexOf(category) === -1) {
	              categories.push(category);
	          }
	      } while(categories.length < num);
	
	      return categories;
	  };
	
	  */
	  /*
	  self.mergeCategories = function(categories) {
	      var separator = faker.definitions.separator || " &";
	      // TODO: find undefined here
	      categories = categories || faker.definitions.commerce.categories;
	      var commaSeparated = categories.slice(0, -1).join(', ');
	
	      return [commaSeparated, categories[categories.length - 1]].join(separator + " ");
	  };
	  */
	
	  /**
	   * productAdjective
	   *
	   * @method faker.commerce.productAdjective
	   */
	  self.productAdjective = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.product_name.adjective);
	  };
	
	  /**
	   * productMaterial
	   *
	   * @method faker.commerce.productMaterial
	   */
	  self.productMaterial = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.product_name.material);
	  };
	
	  /**
	   * product
	   *
	   * @method faker.commerce.product
	   */
	  self.product = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.product_name.product);
	  }
	
	  return self;
	};
	
	module['exports'] = Commerce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.company
	 */
	var Company = function (faker) {
	  
	  var self = this;
	  var f = faker.fake;
	  
	  /**
	   * suffixes
	   *
	   * @method faker.company.suffixes
	   */
	  this.suffixes = function () {
	    // Don't want the source array exposed to modification, so return a copy
	    return faker.definitions.company.suffix.slice(0);
	  }
	
	  /**
	   * companyName
	   *
	   * @method faker.company.companyName
	   * @param {string} format
	   */
	  this.companyName = function (format) {
	
	    var formats = [
	      '{{name.lastName}} {{company.companySuffix}}',
	      '{{name.lastName}} - {{name.lastName}}',
	      '{{name.lastName}}, {{name.lastName}} and {{name.lastName}}'
	    ];
	
	    if (typeof format !== "number") {
	      format = faker.random.number(formats.length - 1);
	    }
	
	    return f(formats[format]);
	  }
	
	  /**
	   * companySuffix
	   *
	   * @method faker.company.companySuffix
	   */
	  this.companySuffix = function () {
	      return faker.random.arrayElement(faker.company.suffixes());
	  }
	
	  /**
	   * catchPhrase
	   *
	   * @method faker.company.catchPhrase
	   */
	  this.catchPhrase = function () {
	    return f('{{company.catchPhraseAdjective}} {{company.catchPhraseDescriptor}} {{company.catchPhraseNoun}}')
	  }
	
	  /**
	   * bs
	   *
	   * @method faker.company.bs
	   */
	  this.bs = function () {
	    return f('{{company.bsAdjective}} {{company.bsBuzz}} {{company.bsNoun}}');
	  }
	
	  /**
	   * catchPhraseAdjective
	   *
	   * @method faker.company.catchPhraseAdjective
	   */
	  this.catchPhraseAdjective = function () {
	      return faker.random.arrayElement(faker.definitions.company.adjective);
	  }
	
	  /**
	   * catchPhraseDescriptor
	   *
	   * @method faker.company.catchPhraseDescriptor
	   */
	  this.catchPhraseDescriptor = function () {
	      return faker.random.arrayElement(faker.definitions.company.descriptor);
	  }
	
	  /**
	   * catchPhraseNoun
	   *
	   * @method faker.company.catchPhraseNoun
	   */
	  this.catchPhraseNoun = function () {
	      return faker.random.arrayElement(faker.definitions.company.noun);
	  }
	
	  /**
	   * bsAdjective
	   *
	   * @method faker.company.bsAdjective
	   */
	  this.bsAdjective = function () {
	      return faker.random.arrayElement(faker.definitions.company.bs_adjective);
	  }
	
	  /**
	   * bsBuzz
	   *
	   * @method faker.company.bsBuzz
	   */
	  this.bsBuzz = function () {
	      return faker.random.arrayElement(faker.definitions.company.bs_verb);
	  }
	
	  /**
	   * bsNoun
	   *
	   * @method faker.company.bsNoun
	   */
	  this.bsNoun = function () {
	      return faker.random.arrayElement(faker.definitions.company.bs_noun);
	  }
	  
	}
	
	module['exports'] = Company;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.date
	 */
	var _Date = function (faker) {
	  var self = this;
	  /**
	   * past
	   *
	   * @method faker.date.past
	   * @param {number} years
	   * @param {date} refDate
	   */
	  self.past = function (years, refDate) {
	      var date = (refDate) ? new Date(Date.parse(refDate)) : new Date();
	      var range = {
	        min: 1000,
	        max: (years || 1) * 365 * 24 * 3600 * 1000
	      };
	
	      var past = date.getTime();
	      past -= faker.random.number(range); // some time from now to N years ago, in milliseconds
	      date.setTime(past);
	
	      return date;
	  };
	
	  /**
	   * future
	   *
	   * @method faker.date.future
	   * @param {number} years
	   * @param {date} refDate
	   */
	  self.future = function (years, refDate) {
	      var date = (refDate) ? new Date(Date.parse(refDate)) : new Date();
	      var range = {
	        min: 1000,
	        max: (years || 1) * 365 * 24 * 3600 * 1000
	      };
	
	      var future = date.getTime();
	      future += faker.random.number(range); // some time from now to N years later, in milliseconds
	      date.setTime(future);
	
	      return date;
	  };
	
	  /**
	   * between
	   *
	   * @method faker.date.between
	   * @param {date} from
	   * @param {date} to
	   */
	  self.between = function (from, to) {
	      var fromMilli = Date.parse(from);
	      var dateOffset = faker.random.number(Date.parse(to) - fromMilli);
	
	      var newDate = new Date(fromMilli + dateOffset);
	
	      return newDate;
	  };
	
	  /**
	   * recent
	   *
	   * @method faker.date.recent
	   * @param {number} days
	   */
	  self.recent = function (days) {
	      var date = new Date();
	      var range = {
	        min: 1000,
	        max: (days || 1) * 24 * 3600 * 1000
	      };
	
	      var future = date.getTime();
	      future -= faker.random.number(range); // some time from now to N days ago, in milliseconds
	      date.setTime(future);
	
	      return date;
	  };
	
	  /**
	   * month
	   *
	   * @method faker.date.month
	   * @param {object} options
	   */
	  self.month = function (options) {
	      options = options || {};
	
	      var type = 'wide';
	      if (options.abbr) {
	          type = 'abbr';
	      }
	      if (options.context && typeof faker.definitions.date.month[type + '_context'] !== 'undefined') {
	          type += '_context';
	      }
	
	      var source = faker.definitions.date.month[type];
	
	      return faker.random.arrayElement(source);
	  };
	
	  /**
	   * weekday
	   *
	   * @param {object} options
	   * @method faker.date.weekday
	   */
	  self.weekday = function (options) {
	      options = options || {};
	
	      var type = 'wide';
	      if (options.abbr) {
	          type = 'abbr';
	      }
	      if (options.context && typeof faker.definitions.date.weekday[type + '_context'] !== 'undefined') {
	          type += '_context';
	      }
	
	      var source = faker.definitions.date.weekday[type];
	
	      return faker.random.arrayElement(source);
	  };
	  
	  return self;
	  
	};
	
	module['exports'] = _Date;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	  fake.js - generator method for combining faker methods based on string input
	
	*/
	
	function Fake (faker) {
	  
	  /**
	   * Generator method for combining faker methods based on string input
	   *
	   * __Example:__
	   *
	   * ```
	   * console.log(faker.fake('{{name.lastName}}, {{name.firstName}} {{name.suffix}}'));
	   * //outputs: "Marks, Dean Sr."
	   * ```
	   *
	   * This will interpolate the format string with the value of methods
	   * [name.lastName]{@link faker.name.lastName}, [name.firstName]{@link faker.name.firstName},
	   * and [name.suffix]{@link faker.name.suffix}
	   *
	   * @method faker.fake
	   * @param {string} str
	   */
	  this.fake = function fake (str) {
	    // setup default response as empty string
	    var res = '';
	
	    // if incoming str parameter is not provided, return error message
	    if (typeof str !== 'string' || str.length === 0) {
	      res = 'string parameter is required!';
	      return res;
	    }
	
	    // find first matching {{ and }}
	    var start = str.search('{{');
	    var end = str.search('}}');
	
	    // if no {{ and }} is found, we are done
	    if (start === -1 && end === -1) {
	      return str;
	    }
	
	    // console.log('attempting to parse', str);
	
	    // extract method name from between the {{ }} that we found
	    // for example: {{name.firstName}}
	    var token = str.substr(start + 2,  end - start - 2);
	    var method = token.replace('}}', '').replace('{{', '');
	
	    // console.log('method', method)
	
	    // extract method parameters
	    var regExp = /\(([^)]+)\)/;
	    var matches = regExp.exec(method);
	    var parameters = '';
	    if (matches) {
	      method = method.replace(regExp, '');
	      parameters = matches[1];
	    }
	
	    // split the method into module and function
	    var parts = method.split('.');
	
	    if (typeof faker[parts[0]] === "undefined") {
	      throw new Error('Invalid module: ' + parts[0]);
	    }
	
	    if (typeof faker[parts[0]][parts[1]] === "undefined") {
	      throw new Error('Invalid method: ' + parts[0] + "." + parts[1]);
	    }
	
	    // assign the function from the module.function namespace
	    var fn = faker[parts[0]][parts[1]];
	
	    // If parameters are populated here, they are always going to be of string type
	    // since we might actually be dealing with an object or array,
	    // we always attempt to the parse the incoming parameters into JSON
	    var params;
	    // Note: we experience a small performance hit here due to JSON.parse try / catch
	    // If anyone actually needs to optimize this specific code path, please open a support issue on github
	    try {
	      params = JSON.parse(parameters)
	    } catch (err) {
	      // since JSON.parse threw an error, assume parameters was actually a string
	      params = parameters;
	    }
	
	    var result;
	    if (typeof params === "string" && params.length === 0) {
	      result = fn.call(this);
	    } else {
	      result = fn.call(this, params);
	    }
	
	    // replace the found tag with the returned fake value
	    res = str.replace('{{' + token + '}}', result);
	
	    // return the response recursively until we are done finding all tags
	    return fake(res);    
	  }
	  
	  return this;
	  
	  
	}
	
	module['exports'] = Fake;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.finance
	 */
	var Finance = function (faker) {
	  var Helpers = faker.helpers,
	      self = this;
	
	  /**
	   * account
	   *
	   * @method faker.finance.account
	   * @param {number} length
	   */
	  self.account = function (length) {
	
	      length = length || 8;
	
	      var template = '';
	
	      for (var i = 0; i < length; i++) {
	          template = template + '#';
	      }
	      length = null;
	      return Helpers.replaceSymbolWithNumber(template);
	  }
	
	  /**
	   * accountName
	   *
	   * @method faker.finance.accountName
	   */
	  self.accountName = function () {
	
	      return [Helpers.randomize(faker.definitions.finance.account_type), 'Account'].join(' ');
	  }
	
	  /**
	   * mask
	   *
	   * @method faker.finance.mask
	   * @param {number} length
	   * @param {boolean} parens
	   * @param {boolean} elipsis
	   */
	  self.mask = function (length, parens, elipsis) {
	
	
	      //set defaults
	      length = (length == 0 || !length || typeof length == 'undefined') ? 4 : length;
	      parens = (parens === null) ? true : parens;
	      elipsis = (elipsis === null) ? true : elipsis;
	
	      //create a template for length
	      var template = '';
	
	      for (var i = 0; i < length; i++) {
	          template = template + '#';
	      }
	
	      //prefix with elipsis
	      template = (elipsis) ? ['...', template].join('') : template;
	
	      template = (parens) ? ['(', template, ')'].join('') : template;
	
	      //generate random numbers
	      template = Helpers.replaceSymbolWithNumber(template);
	
	      return template;
	
	  }
	
	  //min and max take in minimum and maximum amounts, dec is the decimal place you want rounded to, symbol is $, €, £, etc
	  //NOTE: this returns a string representation of the value, if you want a number use parseFloat and no symbol
	
	  /**
	   * amount
	   *
	   * @method faker.finance.amount
	   * @param {number} min
	   * @param {number} max
	   * @param {number} dec
	   * @param {string} symbol
	   */
	  self.amount = function (min, max, dec, symbol) {
	
	      min = min || 0;
	      max = max || 1000;
	      dec = dec || 2;
	      symbol = symbol || '';
	      var randValue = faker.random.number({ max: max, min: min });
	
	      return symbol + (Math.round(randValue * Math.pow(10, dec)) / Math.pow(10, dec)).toFixed(dec);
	
	  }
	
	  /**
	   * transactionType
	   *
	   * @method faker.finance.transactionType
	   */
	  self.transactionType = function () {
	      return Helpers.randomize(faker.definitions.finance.transaction_type);
	  }
	
	  /**
	   * currencyCode
	   *
	   * @method faker.finance.currencyCode
	   */
	  self.currencyCode = function () {
	      return faker.random.objectElement(faker.definitions.finance.currency)['code'];
	  }
	
	  /**
	   * currencyName
	   *
	   * @method faker.finance.currencyName
	   */
	  self.currencyName = function () {
	      return faker.random.objectElement(faker.definitions.finance.currency, 'key');
	  }
	
	  /**
	   * currencySymbol
	   *
	   * @method faker.finance.currencySymbol
	   */
	  self.currencySymbol = function () {
	      var symbol;
	
	      while (!symbol) {
	          symbol = faker.random.objectElement(faker.definitions.finance.currency)['symbol'];
	      }
	      return symbol;
	  }
	
	  /**
	   * bitcoinAddress
	   *
	   * @method  faker.finance.bitcoinAddress
	   */
	  self.bitcoinAddress = function () {
	    var addressLength = faker.random.number({ min: 27, max: 34 });
	
	    var address = faker.random.arrayElement(['1', '3']);
	
	    for (var i = 0; i < addressLength - 1; i++)
	      address += faker.random.alphaNumeric().toUpperCase();
	
	    return address;
	  }
	}
	
	module['exports'] = Finance;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.hacker
	 */
	var Hacker = function (faker) {
	  var self = this;
	  
	  /**
	   * abbreviation
	   *
	   * @method faker.hacker.abbreviation
	   */
	  self.abbreviation = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.abbreviation);
	  };
	
	  /**
	   * adjective
	   *
	   * @method faker.hacker.adjective
	   */
	  self.adjective = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.adjective);
	  };
	
	  /**
	   * noun
	   *
	   * @method faker.hacker.noun
	   */
	  self.noun = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.noun);
	  };
	
	  /**
	   * verb
	   *
	   * @method faker.hacker.verb
	   */
	  self.verb = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.verb);
	  };
	
	  /**
	   * ingverb
	   *
	   * @method faker.hacker.ingverb
	   */
	  self.ingverb = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.ingverb);
	  };
	
	  /**
	   * phrase
	   *
	   * @method faker.hacker.phrase
	   */
	  self.phrase = function () {
	
	    var data = {
	      abbreviation: self.abbreviation,
	      adjective: self.adjective,
	      ingverb: self.ingverb,
	      noun: self.noun,
	      verb: self.verb
	    };
	
	    var phrase = faker.random.arrayElement([ "If we {{verb}} the {{noun}}, we can get to the {{abbreviation}} {{noun}} through the {{adjective}} {{abbreviation}} {{noun}}!",
	      "We need to {{verb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "Try to {{verb}} the {{abbreviation}} {{noun}}, maybe it will {{verb}} the {{adjective}} {{noun}}!",
	      "You can't {{verb}} the {{noun}} without {{ingverb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "Use the {{adjective}} {{abbreviation}} {{noun}}, then you can {{verb}} the {{adjective}} {{noun}}!",
	      "The {{abbreviation}} {{noun}} is down, {{verb}} the {{adjective}} {{noun}} so we can {{verb}} the {{abbreviation}} {{noun}}!",
	      "{{ingverb}} the {{noun}} won't do anything, we need to {{verb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "I'll {{verb}} the {{adjective}} {{abbreviation}} {{noun}}, that should {{noun}} the {{abbreviation}} {{noun}}!"
	   ]);
	
	   return faker.helpers.mustache(phrase, data);
	
	  };
	  
	  return self;
	};
	
	module['exports'] = Hacker;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.helpers
	 */
	var Helpers = function (faker) {
	
	  var self = this;
	
	  /**
	   * backword-compatibility
	   *
	   * @method faker.helpers.randomize
	   * @param {array} array
	   */
	  self.randomize = function (array) {
	      array = array || ["a", "b", "c"];
	      return faker.random.arrayElement(array);
	  };
	
	  /**
	   * slugifies string
	   *
	   * @method faker.helpers.slugify
	   * @param {string} string
	   */
	  self.slugify = function (string) {
	      string = string || "";
	      return string.replace(/ /g, '-').replace(/[^\w\.\-]+/g, '');
	  };
	
	  /**
	   * parses string for a symbol and replace it with a random number from 1-10
	   *
	   * @method faker.helpers.replaceSymbolWithNumber
	   * @param {string} string
	   * @param {string} symbol defaults to `"#"`
	   */
	  self.replaceSymbolWithNumber = function (string, symbol) {
	      string = string || "";
	      // default symbol is '#'
	      if (symbol === undefined) {
	          symbol = '#';
	      }
	
	      var str = '';
	      for (var i = 0; i < string.length; i++) {
	          if (string.charAt(i) == symbol) {
	              str += faker.random.number(9);
	          } else {
	              str += string.charAt(i);
	          }
	      }
	      return str;
	  };
	
	  /**
	   * parses string for symbols (numbers or letters) and replaces them appropriately
	   *
	   * @method faker.helpers.replaceSymbols
	   * @param {string} string
	   */
	  self.replaceSymbols = function (string) {
	      string = string || "";
	  	var alpha = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
	      var str = '';
	
	      for (var i = 0; i < string.length; i++) {
	          if (string.charAt(i) == "#") {
	              str += faker.random.number(9);
	  		} else if (string.charAt(i) == "?") {
	  			str += faker.random.arrayElement(alpha);
	          } else {
	              str += string.charAt(i);
	          }
	      }
	      return str;
	  };
	
	  /**
	   * takes an array and returns it randomized
	   *
	   * @method faker.helpers.shuffle
	   * @param {array} o
	   */
	  self.shuffle = function (o) {
	      o = o || ["a", "b", "c"];
	      for (var j, x, i = o.length-1; i; j = faker.random.number(i), x = o[--i], o[i] = o[j], o[j] = x);
	      return o;
	  };
	
	  /**
	   * mustache
	   *
	   * @method faker.helpers.mustache
	   * @param {string} str
	   * @param {object} data
	   */
	  self.mustache = function (str, data) {
	    if (typeof str === 'undefined') {
	      return '';
	    }
	    for(var p in data) {
	      var re = new RegExp('{{' + p + '}}', 'g')
	      str = str.replace(re, data[p]);
	    }
	    return str;
	  };
	
	  /**
	   * createCard
	   *
	   * @method faker.helpers.createCard
	   */
	  self.createCard = function () {
	      return {
	          "name": faker.name.findName(),
	          "username": faker.internet.userName(),
	          "email": faker.internet.email(),
	          "address": {
	              "streetA": faker.address.streetName(),
	              "streetB": faker.address.streetAddress(),
	              "streetC": faker.address.streetAddress(true),
	              "streetD": faker.address.secondaryAddress(),
	              "city": faker.address.city(),
	              "state": faker.address.state(),
	              "country": faker.address.country(),
	              "zipcode": faker.address.zipCode(),
	              "geo": {
	                  "lat": faker.address.latitude(),
	                  "lng": faker.address.longitude()
	              }
	          },
	          "phone": faker.phone.phoneNumber(),
	          "website": faker.internet.domainName(),
	          "company": {
	              "name": faker.company.companyName(),
	              "catchPhrase": faker.company.catchPhrase(),
	              "bs": faker.company.bs()
	          },
	          "posts": [
	              {
	                  "words": faker.lorem.words(),
	                  "sentence": faker.lorem.sentence(),
	                  "sentences": faker.lorem.sentences(),
	                  "paragraph": faker.lorem.paragraph()
	              },
	              {
	                  "words": faker.lorem.words(),
	                  "sentence": faker.lorem.sentence(),
	                  "sentences": faker.lorem.sentences(),
	                  "paragraph": faker.lorem.paragraph()
	              },
	              {
	                  "words": faker.lorem.words(),
	                  "sentence": faker.lorem.sentence(),
	                  "sentences": faker.lorem.sentences(),
	                  "paragraph": faker.lorem.paragraph()
	              }
	          ],
	          "accountHistory": [faker.helpers.createTransaction(), faker.helpers.createTransaction(), faker.helpers.createTransaction()]
	      };
	  };
	
	  /**
	   * contextualCard
	   *
	   * @method faker.helpers.contextualCard
	   */
	  self.contextualCard = function () {
	    var name = faker.name.firstName(),
	        userName = faker.internet.userName(name);
	    return {
	        "name": name,
	        "username": userName,
	        "avatar": faker.internet.avatar(),
	        "email": faker.internet.email(userName),
	        "dob": faker.date.past(50, new Date("Sat Sep 20 1992 21:35:02 GMT+0200 (CEST)")),
	        "phone": faker.phone.phoneNumber(),
	        "address": {
	            "street": faker.address.streetName(true),
	            "suite": faker.address.secondaryAddress(),
	            "city": faker.address.city(),
	            "zipcode": faker.address.zipCode(),
	            "geo": {
	                "lat": faker.address.latitude(),
	                "lng": faker.address.longitude()
	            }
	        },
	        "website": faker.internet.domainName(),
	        "company": {
	            "name": faker.company.companyName(),
	            "catchPhrase": faker.company.catchPhrase(),
	            "bs": faker.company.bs()
	        }
	    };
	  };
	
	
	  /**
	   * userCard
	   *
	   * @method faker.helpers.userCard
	   */
	  self.userCard = function () {
	      return {
	          "name": faker.name.findName(),
	          "username": faker.internet.userName(),
	          "email": faker.internet.email(),
	          "address": {
	              "street": faker.address.streetName(true),
	              "suite": faker.address.secondaryAddress(),
	              "city": faker.address.city(),
	              "zipcode": faker.address.zipCode(),
	              "geo": {
	                  "lat": faker.address.latitude(),
	                  "lng": faker.address.longitude()
	              }
	          },
	          "phone": faker.phone.phoneNumber(),
	          "website": faker.internet.domainName(),
	          "company": {
	              "name": faker.company.companyName(),
	              "catchPhrase": faker.company.catchPhrase(),
	              "bs": faker.company.bs()
	          }
	      };
	  };
	
	  /**
	   * createTransaction
	   *
	   * @method faker.helpers.createTransaction
	   */
	  self.createTransaction = function(){
	    return {
	      "amount" : faker.finance.amount(),
	      "date" : new Date(2012, 1, 2),  //TODO: add a ranged date method
	      "business": faker.company.companyName(),
	      "name": [faker.finance.accountName(), faker.finance.mask()].join(' '),
	      "type" : self.randomize(faker.definitions.finance.transaction_type),
	      "account" : faker.finance.account()
	    };
	  };
	
	  return self;
	
	};
	
	
	/*
	String.prototype.capitalize = function () { //v1.0
	    return this.replace(/\w+/g, function (a) {
	        return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase();
	    });
	};
	*/
	
	module['exports'] = Helpers;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.image
	 */
	var Image = function (faker) {
	
	  var self = this;
	
	  /**
	   * image
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.image
	   */
	  self.image = function (width, height, randomize) {
	    var categories = ["abstract", "animals", "business", "cats", "city", "food", "nightlife", "fashion", "people", "nature", "sports", "technics", "transport"];
	    return self[faker.random.arrayElement(categories)](width, height, randomize);
	  };
	  /**
	   * avatar
	   *
	   * @method faker.image.avatar
	   */
	  self.avatar = function () {
	    return faker.internet.avatar();
	  };
	  /**
	   * imageUrl
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {string} category
	   * @param {boolean} randomize
	   * @method faker.image.imageUrl
	   */
	  self.imageUrl = function (width, height, category, randomize) {
	      var width = width || 640;
	      var height = height || 480;
	
	      var url ='http://lorempixel.com/' + width + '/' + height;
	      if (typeof category !== 'undefined') {
	        url += '/' + category;
	      }
	
	      if (randomize) {
	        url += '?' + faker.random.number()
	      }
	
	      return url;
	  };
	  /**
	   * abstract
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.abstract
	   */
	  self.abstract = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'abstract', randomize);
	  };
	  /**
	   * animals
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.animals
	   */
	  self.animals = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'animals', randomize);
	  };
	  /**
	   * business
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.business
	   */
	  self.business = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'business', randomize);
	  };
	  /**
	   * cats
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.cats
	   */
	  self.cats = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'cats', randomize);
	  };
	  /**
	   * city
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.city
	   */
	  self.city = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'city', randomize);
	  };
	  /**
	   * food
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.food
	   */
	  self.food = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'food', randomize);
	  };
	  /**
	   * nightlife
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.nightlife
	   */
	  self.nightlife = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'nightlife', randomize);
	  };
	  /**
	   * fashion
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.fashion
	   */
	  self.fashion = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'fashion', randomize);
	  };
	  /**
	   * people
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.people
	   */
	  self.people = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'people', randomize);
	  };
	  /**
	   * nature
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.nature
	   */
	  self.nature = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'nature', randomize);
	  };
	  /**
	   * sports
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.sports
	   */
	  self.sports = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'sports', randomize);
	  };
	  /**
	   * technics
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.technics
	   */
	  self.technics = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'technics', randomize);
	  };
	  /**
	   * transport
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.transport
	   */
	  self.transport = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'transport', randomize);
	  }  
	}
	
	module["exports"] = Image;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	
	   this index.js file is used for including the faker library as a CommonJS module, instead of a bundle
	
	   you can include the faker library into your existing node.js application by requiring the entire /faker directory
	
	    var faker = require(./faker);
	    var randomName = faker.name.findName();
	
	   you can also simply include the "faker.js" file which is the auto-generated bundled version of the faker library
	
	    var faker = require(./customAppPath/faker);
	    var randomName = faker.name.findName();
	
	
	  if you plan on modifying the faker library you should be performing your changes in the /lib/ directory
	
	*/
	
	/**
	 *
	 * @namespace faker
	 */
	function Faker (opts) {
	
	  var self = this;
	
	  opts = opts || {};
	
	  // assign options
	  var locales = self.locales || opts.locales || {};
	  var locale = self.locale || opts.locale || "en";
	  var localeFallback = self.localeFallback || opts.localeFallback || "en";
	
	  self.locales = locales;
	  self.locale = locale;
	  self.localeFallback = localeFallback;
	
	  self.definitions = {};
	
	  var Fake = __webpack_require__(751);
	  self.fake = new Fake(self).fake;
	
	  var Random = __webpack_require__(241);
	  self.random = new Random(self);
	  // self.random = require('./random');
	
	  var Helpers = __webpack_require__(754);
	  self.helpers = new Helpers(self);
	
	  var Name = __webpack_require__(1700);
	  self.name = new Name(self);
	  // self.name = require('./name');
	
	  var Address = __webpack_require__(747);
	  self.address = new Address(self);
	
	  var Company = __webpack_require__(749);
	  self.company = new Company(self);
	
	  var Finance = __webpack_require__(752);
	  self.finance = new Finance(self);
	
	  var Image = __webpack_require__(755);
	  self.image = new Image(self);
	
	  var Lorem = __webpack_require__(1699);
	  self.lorem = new Lorem(self);
	
	  var Hacker = __webpack_require__(753);
	  self.hacker = new Hacker(self);
	
	  var Internet = __webpack_require__(757);
	  self.internet = new Internet(self);
	
	  var Phone = __webpack_require__(1701);
	  self.phone = new Phone(self);
	
	  var _Date = __webpack_require__(750);
	  self.date = new _Date(self);
	
	  var Commerce = __webpack_require__(748);
	  self.commerce = new Commerce(self);
	
	  var System = __webpack_require__(1702);
	  self.system = new System(self);
	
	  var _definitions = {
	    "name": ["first_name", "last_name", "prefix", "suffix", "title", "male_first_name", "female_first_name", "male_middle_name", "female_middle_name", "male_last_name", "female_last_name"],
	    "address": ["city_prefix", "city_suffix", "street_suffix", "county", "country", "country_code", "state", "state_abbr", "street_prefix", "postcode"],
	    "company": ["adjective", "noun", "descriptor", "bs_adjective", "bs_noun", "bs_verb", "suffix"],
	    "lorem": ["words"],
	    "hacker": ["abbreviation", "adjective", "noun", "verb", "ingverb"],
	    "phone_number": ["formats"],
	    "finance": ["account_type", "transaction_type", "currency"],
	    "internet": ["avatar_uri", "domain_suffix", "free_email", "example_email", "password"],
	    "commerce": ["color", "department", "product_name", "price", "categories"],
	    "system": ["mimeTypes"],
	    "date": ["month", "weekday"],
	    "title": "",
	    "separator": ""
	  };
	
	  // Create a Getter for all definitions.foo.bar propetries
	  Object.keys(_definitions).forEach(function(d){
	    if (typeof self.definitions[d] === "undefined") {
	      self.definitions[d] = {};
	    }
	
	    if (typeof _definitions[d] === "string") {
	        self.definitions[d] = _definitions[d];
	      return;
	    }
	
	    _definitions[d].forEach(function(p){
	      Object.defineProperty(self.definitions[d], p, {
	        get: function () {
	          if (typeof self.locales[self.locale][d] === "undefined" || typeof self.locales[self.locale][d][p] === "undefined") {
	            // certain localization sets contain less data then others.
	            // in the case of a missing defintion, use the default localeFallback to substitute the missing set data
	            // throw new Error('unknown property ' + d + p)
	            return self.locales[localeFallback][d][p];
	          } else {
	            // return localized data
	            return self.locales[self.locale][d][p];
	          }
	        }
	      });
	    });
	  });
	
	};
	
	Faker.prototype.seed = function(value) {
	  var Random = __webpack_require__(241);
	  this.seedValue = value;
	  this.random = new Random(this, this.seedValue);
	}
	module['exports'] = Faker;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var password_generator = __webpack_require__(1704),
	    random_ua = __webpack_require__(1705);
	
	/**
	 *
	 * @namespace faker.internet
	 */
	var Internet = function (faker) {
	  var self = this;
	  /**
	   * avatar
	   *
	   * @method faker.internet.avatar
	   */
	  self.avatar = function () {
	      return faker.random.arrayElement(faker.definitions.internet.avatar_uri);
	  };
	
	  self.avatar.schema = {
	    "description": "Generates a URL for an avatar.",
	    "sampleResults": ["https://s3.amazonaws.com/uifaces/faces/twitter/igorgarybaldi/128.jpg"]
	  };
	
	  /**
	   * email
	   *
	   * @method faker.internet.email
	   * @param {string} firstName
	   * @param {string} lastName
	   * @param {string} provider
	   */
	  self.email = function (firstName, lastName, provider) {
	      provider = provider || faker.random.arrayElement(faker.definitions.internet.free_email);
	      return  faker.helpers.slugify(faker.internet.userName(firstName, lastName)) + "@" + provider;
	  };
	
	  self.email.schema = {
	    "description": "Generates a valid email address based on optional input criteria",
	    "sampleResults": ["foo.bar@gmail.com"],
	    "properties": {
	      "firstName": {
	        "type": "string",
	        "required": false,
	        "description": "The first name of the user"
	      },
	      "lastName": {
	        "type": "string",
	        "required": false,
	        "description": "The last name of the user"
	      },
	      "provider": {
	        "type": "string",
	        "required": false,
	        "description": "The domain of the user"
	      }
	    }
	  };
	  /**
	   * exampleEmail
	   *
	   * @method faker.internet.exampleEmail
	   * @param {string} firstName
	   * @param {string} lastName
	   */
	  self.exampleEmail = function (firstName, lastName) {
	      var provider = faker.random.arrayElement(faker.definitions.internet.example_email);
	      return self.email(firstName, lastName, provider);
	  };
	
	  /**
	   * userName
	   *
	   * @method faker.internet.userName
	   * @param {string} firstName
	   * @param {string} lastName
	   */
	  self.userName = function (firstName, lastName) {
	      var result;
	      firstName = firstName || faker.name.firstName();
	      lastName = lastName || faker.name.lastName();
	      switch (faker.random.number(2)) {
	      case 0:
	          result = firstName + faker.random.number(99);
	          break;
	      case 1:
	          result = firstName + faker.random.arrayElement([".", "_"]) + lastName;
	          break;
	      case 2:
	          result = firstName + faker.random.arrayElement([".", "_"]) + lastName + faker.random.number(99);
	          break;
	      }
	      result = result.toString().replace(/'/g, "");
	      result = result.replace(/ /g, "");
	      return result;
	  };
	
	  self.userName.schema = {
	    "description": "Generates a username based on one of several patterns. The pattern is chosen randomly.",
	    "sampleResults": [
	      "Kirstin39",
	      "Kirstin.Smith",
	      "Kirstin.Smith39",
	      "KirstinSmith",
	      "KirstinSmith39",
	    ],
	    "properties": {
	      "firstName": {
	        "type": "string",
	        "required": false,
	        "description": "The first name of the user"
	      },
	      "lastName": {
	        "type": "string",
	        "required": false,
	        "description": "The last name of the user"
	      }
	    }
	  };
	
	  /**
	   * protocol
	   *
	   * @method faker.internet.protocol
	   */
	  self.protocol = function () {
	      var protocols = ['http','https'];
	      return faker.random.arrayElement(protocols);
	  };
	
	  self.protocol.schema = {
	    "description": "Randomly generates http or https",
	    "sampleResults": ["https", "http"]
	  };
	
	  /**
	   * url
	   *
	   * @method faker.internet.url
	   */
	  self.url = function () {
	      return faker.internet.protocol() + '://' + faker.internet.domainName();
	  };
	
	  self.url.schema = {
	    "description": "Generates a random URL. The URL could be secure or insecure.",
	    "sampleResults": [
	      "http://rashawn.name",
	      "https://rashawn.name"
	    ]
	  };
	
	  /**
	   * domainName
	   *
	   * @method faker.internet.domainName
	   */
	  self.domainName = function () {
	      return faker.internet.domainWord() + "." + faker.internet.domainSuffix();
	  };
	
	  self.domainName.schema = {
	    "description": "Generates a random domain name.",
	    "sampleResults": ["marvin.org"]
	  };
	
	  /**
	   * domainSuffix
	   *
	   * @method faker.internet.domainSuffix
	   */
	  self.domainSuffix = function () {
	      return faker.random.arrayElement(faker.definitions.internet.domain_suffix);
	  };
	
	  self.domainSuffix.schema = {
	    "description": "Generates a random domain suffix.",
	    "sampleResults": ["net"]
	  };
	
	  /**
	   * domainWord
	   *
	   * @method faker.internet.domainWord
	   */
	  self.domainWord = function () {
	      return faker.name.firstName().replace(/([\\~#&*{}/:<>?|\"'])/ig, '').toLowerCase();
	  };
	
	  self.domainWord.schema = {
	    "description": "Generates a random domain word.",
	    "sampleResults": ["alyce"]
	  };
	
	  /**
	   * ip
	   *
	   * @method faker.internet.ip
	   */
	  self.ip = function () {
	      var randNum = function () {
	          return (faker.random.number(255)).toFixed(0);
	      };
	
	      var result = [];
	      for (var i = 0; i < 4; i++) {
	          result[i] = randNum();
	      }
	
	      return result.join(".");
	  };
	
	  self.ip.schema = {
	    "description": "Generates a random IP.",
	    "sampleResults": ["97.238.241.11"]
	  };
	
	  /**
	   * userAgent
	   *
	   * @method faker.internet.userAgent
	   */
	  self.userAgent = function () {
	    return random_ua.generate();
	  };
	
	  self.userAgent.schema = {
	    "description": "Generates a random user agent.",
	    "sampleResults": ["Mozilla/5.0 (Macintosh; U; PPC Mac OS X 10_7_5 rv:6.0; SL) AppleWebKit/532.0.1 (KHTML, like Gecko) Version/7.1.6 Safari/532.0.1"]
	  };
	
	  /**
	   * color
	   *
	   * @method faker.internet.color
	   * @param {number} baseRed255
	   * @param {number} baseGreen255
	   * @param {number} baseBlue255
	   */
	  self.color = function (baseRed255, baseGreen255, baseBlue255) {
	      baseRed255 = baseRed255 || 0;
	      baseGreen255 = baseGreen255 || 0;
	      baseBlue255 = baseBlue255 || 0;
	      // based on awesome response : http://stackoverflow.com/questions/43044/algorithm-to-randomly-generate-an-aesthetically-pleasing-color-palette
	      var red = Math.floor((faker.random.number(256) + baseRed255) / 2);
	      var green = Math.floor((faker.random.number(256) + baseGreen255) / 2);
	      var blue = Math.floor((faker.random.number(256) + baseBlue255) / 2);
	      var redStr = red.toString(16);
	      var greenStr = green.toString(16);
	      var blueStr = blue.toString(16);
	      return '#' +
	        (redStr.length === 1 ? '0' : '') + redStr +
	        (greenStr.length === 1 ? '0' : '') + greenStr +
	        (blueStr.length === 1 ? '0': '') + blueStr;
	
	  };
	
	  self.color.schema = {
	    "description": "Generates a random hexadecimal color.",
	    "sampleResults": ["#06267f"],
	    "properties": {
	      "baseRed255": {
	        "type": "number",
	        "required": false,
	        "description": "The red value. Valid values are 0 - 255."
	      },
	      "baseGreen255": {
	        "type": "number",
	        "required": false,
	        "description": "The green value. Valid values are 0 - 255."
	      },
	      "baseBlue255": {
	        "type": "number",
	        "required": false,
	        "description": "The blue value. Valid values are 0 - 255."
	      }
	    }
	  };
	
	  /**
	   * mac
	   *
	   * @method faker.internet.mac
	   */
	  self.mac = function(){
	      var i, mac = "";
	      for (i=0; i < 12; i++) {
	          mac+= faker.random.number(15).toString(16);
	          if (i%2==1 && i != 11) {
	              mac+=":";
	          }
	      }
	      return mac;
	  };
	
	  self.mac.schema = {
	    "description": "Generates a random mac address.",
	    "sampleResults": ["78:06:cc:ae:b3:81"]
	  };
	
	  /**
	   * password
	   *
	   * @method faker.internet.password
	   * @param {number} len
	   * @param {boolean} memorable
	   * @param {string} pattern
	   * @param {string} prefix
	   */
	  self.password = function (len, memorable, pattern, prefix) {
	    len = len || 15;
	    if (typeof memorable === "undefined") {
	      memorable = false;
	    }
	    return password_generator(len, memorable, pattern, prefix);
	  }
	
	  self.password.schema = {
	    "description": "Generates a random password.",
	    "sampleResults": [
	      "AM7zl6Mg",
	      "susejofe"
	    ],
	    "properties": {
	      "length": {
	        "type": "number",
	        "required": false,
	        "description": "The number of characters in the password."
	      },
	      "memorable": {
	        "type": "boolean",
	        "required": false,
	        "description": "Whether a password should be easy to remember."
	      },
	      "pattern": {
	        "type": "regex",
	        "required": false,
	        "description": "A regex to match each character of the password against. This parameter will be negated if the memorable setting is turned on."
	      },
	      "prefix": {
	        "type": "string",
	        "required": false,
	        "description": "A value to prepend to the generated password. The prefix counts towards the length of the password."
	      }
	    }
	  };
	
	};
	
	
	module["exports"] = Internet;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	exports['de'] = __webpack_require__(779);
	exports['de_AT'] = __webpack_require__(812);
	exports['de_CH'] = __webpack_require__(831);
	exports['en'] = __webpack_require__(906);
	exports['en_AU'] = __webpack_require__(938);
	exports['en_BORK'] = __webpack_require__(946);
	exports['en_CA'] = __webpack_require__(954);
	exports['en_GB'] = __webpack_require__(967);
	exports['en_IE'] = __webpack_require__(977);
	exports['en_IND'] = __webpack_require__(989);
	exports['en_US'] = __webpack_require__(1001);
	exports['en_au_ocker'] = __webpack_require__(1021);
	exports['es'] = __webpack_require__(1053);
	exports['es_MX'] = __webpack_require__(1097);
	exports['fa'] = __webpack_require__(1116);
	exports['fr'] = __webpack_require__(1142);
	exports['fr_CA'] = __webpack_require__(1162);
	exports['ge'] = __webpack_require__(1188);
	exports['id_ID'] = __webpack_require__(1217);
	exports['it'] = __webpack_require__(1254);
	exports['ja'] = __webpack_require__(1276);
	exports['ko'] = __webpack_require__(1297);
	exports['nb_NO'] = __webpack_require__(1327);
	exports['nep'] = __webpack_require__(1347);
	exports['nl'] = __webpack_require__(1371);
	exports['pl'] = __webpack_require__(1411);
	exports['pt_BR'] = __webpack_require__(1440);
	exports['ru'] = __webpack_require__(1477);
	exports['sk'] = __webpack_require__(1517);
	exports['sv'] = __webpack_require__(1564);
	exports['tr'] = __webpack_require__(1590);
	exports['uk'] = __webpack_require__(1623);
	exports['vi'] = __webpack_require__(1650);
	exports['zh_CN'] = __webpack_require__(1673);
	exports['zh_TW'] = __webpack_require__(1692);


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#",
	  "##a",
	  "##b",
	  "##c"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nord",
	  "Ost",
	  "West",
	  "Süd",
	  "Neu",
	  "Alt",
	  "Bad"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "stadt",
	  "dorf",
	  "land",
	  "scheid",
	  "burg"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ägypten",
	  "Äquatorialguinea",
	  "Äthiopien",
	  "Österreich",
	  "Afghanistan",
	  "Albanien",
	  "Algerien",
	  "Amerikanisch-Samoa",
	  "Amerikanische Jungferninseln",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarktis",
	  "Antigua und Barbuda",
	  "Argentinien",
	  "Armenien",
	  "Aruba",
	  "Aserbaidschan",
	  "Australien",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesch",
	  "Barbados",
	  "Belarus",
	  "Belgien",
	  "Belize",
	  "Benin",
	  "die Bermudas",
	  "Bhutan",
	  "Bolivien",
	  "Bosnien und Herzegowina",
	  "Botsuana",
	  "Bouvetinsel",
	  "Brasilien",
	  "Britische Jungferninseln",
	  "Britisches Territorium im Indischen Ozean",
	  "Brunei Darussalam",
	  "Bulgarien",
	  "Burkina Faso",
	  "Burundi",
	  "Chile",
	  "China",
	  "Cookinseln",
	  "Costa Rica",
	  "Dänemark",
	  "Demokratische Republik Kongo",
	  "Demokratische Volksrepublik Korea",
	  "Deutschland",
	  "Dominica",
	  "Dominikanische Republik",
	  "Dschibuti",
	  "Ecuador",
	  "El Salvador",
	  "Eritrea",
	  "Estland",
	  "Färöer",
	  "Falklandinseln",
	  "Fidschi",
	  "Finnland",
	  "Frankreich",
	  "Französisch-Guayana",
	  "Französisch-Polynesien",
	  "Französische Gebiete im südlichen Indischen Ozean",
	  "Gabun",
	  "Gambia",
	  "Georgien",
	  "Ghana",
	  "Gibraltar",
	  "Grönland",
	  "Grenada",
	  "Griechenland",
	  "Guadeloupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard und McDonaldinseln",
	  "Honduras",
	  "Hongkong",
	  "Indien",
	  "Indonesien",
	  "Irak",
	  "Iran",
	  "Irland",
	  "Island",
	  "Israel",
	  "Italien",
	  "Jamaika",
	  "Japan",
	  "Jemen",
	  "Jordanien",
	  "Jugoslawien",
	  "Kaimaninseln",
	  "Kambodscha",
	  "Kamerun",
	  "Kanada",
	  "Kap Verde",
	  "Kasachstan",
	  "Katar",
	  "Kenia",
	  "Kirgisistan",
	  "Kiribati",
	  "Kleinere amerikanische Überseeinseln",
	  "Kokosinseln",
	  "Kolumbien",
	  "Komoren",
	  "Kongo",
	  "Kroatien",
	  "Kuba",
	  "Kuwait",
	  "Laos",
	  "Lesotho",
	  "Lettland",
	  "Libanon",
	  "Liberia",
	  "Libyen",
	  "Liechtenstein",
	  "Litauen",
	  "Luxemburg",
	  "Macau",
	  "Madagaskar",
	  "Malawi",
	  "Malaysia",
	  "Malediven",
	  "Mali",
	  "Malta",
	  "ehemalige jugoslawische Republik Mazedonien",
	  "Marokko",
	  "Marshallinseln",
	  "Martinique",
	  "Mauretanien",
	  "Mauritius",
	  "Mayotte",
	  "Mexiko",
	  "Mikronesien",
	  "Monaco",
	  "Mongolei",
	  "Montserrat",
	  "Mosambik",
	  "Myanmar",
	  "Nördliche Marianen",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Neukaledonien",
	  "Neuseeland",
	  "Nicaragua",
	  "Niederländische Antillen",
	  "Niederlande",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Norfolkinsel",
	  "Norwegen",
	  "Oman",
	  "Osttimor",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papua-Neuguinea",
	  "Paraguay",
	  "Peru",
	  "Philippinen",
	  "Pitcairninseln",
	  "Polen",
	  "Portugal",
	  "Puerto Rico",
	  "Réunion",
	  "Republik Korea",
	  "Republik Moldau",
	  "Ruanda",
	  "Rumänien",
	  "Russische Föderation",
	  "São Tomé und Príncipe",
	  "Südafrika",
	  "Südgeorgien und Südliche Sandwichinseln",
	  "Salomonen",
	  "Sambia",
	  "Samoa",
	  "San Marino",
	  "Saudi-Arabien",
	  "Schweden",
	  "Schweiz",
	  "Senegal",
	  "Seychellen",
	  "Sierra Leone",
	  "Simbabwe",
	  "Singapur",
	  "Slowakei",
	  "Slowenien",
	  "Somalien",
	  "Spanien",
	  "Sri Lanka",
	  "St. Helena",
	  "St. Kitts und Nevis",
	  "St. Lucia",
	  "St. Pierre und Miquelon",
	  "St. Vincent und die Grenadinen",
	  "Sudan",
	  "Surinam",
	  "Svalbard und Jan Mayen",
	  "Swasiland",
	  "Syrien",
	  "Türkei",
	  "Tadschikistan",
	  "Taiwan",
	  "Tansania",
	  "Thailand",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad und Tobago",
	  "Tschad",
	  "Tschechische Republik",
	  "Tunesien",
	  "Turkmenistan",
	  "Turks- und Caicosinseln",
	  "Tuvalu",
	  "Uganda",
	  "Ukraine",
	  "Ungarn",
	  "Uruguay",
	  "Usbekistan",
	  "Vanuatu",
	  "Vatikanstadt",
	  "Venezuela",
	  "Vereinigte Arabische Emirate",
	  "Vereinigte Staaten",
	  "Vereinigtes Königreich",
	  "Vietnam",
	  "Wallis und Futuna",
	  "Weihnachtsinsel",
	  "Westsahara",
	  "Zentralafrikanische Republik",
	  "Zypern"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Deutschland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(761);
	address.city_suffix = __webpack_require__(762);
	address.country = __webpack_require__(763);
	address.street_root = __webpack_require__(772);
	address.building_number = __webpack_require__(759);
	address.secondary_address = __webpack_require__(767);
	address.postcode = __webpack_require__(766);
	address.state = __webpack_require__(768);
	address.state_abbr = __webpack_require__(769);
	address.city = __webpack_require__(760);
	address.street_name = __webpack_require__(771);
	address.street_address = __webpack_require__(770);
	address.default_country = __webpack_require__(764);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Zimmer ###",
	  "# OG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Baden-Württemberg",
	  "Bayern",
	  "Berlin",
	  "Brandenburg",
	  "Bremen",
	  "Hamburg",
	  "Hessen",
	  "Mecklenburg-Vorpommern",
	  "Niedersachsen",
	  "Nordrhein-Westfalen",
	  "Rheinland-Pfalz",
	  "Saarland",
	  "Sachsen",
	  "Sachsen-Anhalt",
	  "Schleswig-Holstein",
	  "Thüringen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "BW",
	  "BY",
	  "BE",
	  "BB",
	  "HB",
	  "HH",
	  "HE",
	  "MV",
	  "NI",
	  "NW",
	  "RP",
	  "SL",
	  "SN",
	  "ST",
	  "SH",
	  "TH"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ackerweg",
	  "Adalbert-Stifter-Str.",
	  "Adalbertstr.",
	  "Adolf-Baeyer-Str.",
	  "Adolf-Kaschny-Str.",
	  "Adolf-Reichwein-Str.",
	  "Adolfsstr.",
	  "Ahornweg",
	  "Ahrstr.",
	  "Akazienweg",
	  "Albert-Einstein-Str.",
	  "Albert-Schweitzer-Str.",
	  "Albertus-Magnus-Str.",
	  "Albert-Zarthe-Weg",
	  "Albin-Edelmann-Str.",
	  "Albrecht-Haushofer-Str.",
	  "Aldegundisstr.",
	  "Alexanderstr.",
	  "Alfred-Delp-Str.",
	  "Alfred-Kubin-Str.",
	  "Alfred-Stock-Str.",
	  "Alkenrather Str.",
	  "Allensteiner Str.",
	  "Alsenstr.",
	  "Alt Steinbücheler Weg",
	  "Alte Garten",
	  "Alte Heide",
	  "Alte Landstr.",
	  "Alte Ziegelei",
	  "Altenberger Str.",
	  "Altenhof",
	  "Alter Grenzweg",
	  "Altstadtstr.",
	  "Am Alten Gaswerk",
	  "Am Alten Schafstall",
	  "Am Arenzberg",
	  "Am Benthal",
	  "Am Birkenberg",
	  "Am Blauen Berg",
	  "Am Borsberg",
	  "Am Brungen",
	  "Am Büchelter Hof",
	  "Am Buttermarkt",
	  "Am Ehrenfriedhof",
	  "Am Eselsdamm",
	  "Am Falkenberg",
	  "Am Frankenberg",
	  "Am Gesundheitspark",
	  "Am Gierlichshof",
	  "Am Graben",
	  "Am Hagelkreuz",
	  "Am Hang",
	  "Am Heidkamp",
	  "Am Hemmelrather Hof",
	  "Am Hofacker",
	  "Am Hohen Ufer",
	  "Am Höllers Eck",
	  "Am Hühnerberg",
	  "Am Jägerhof",
	  "Am Junkernkamp",
	  "Am Kemperstiegel",
	  "Am Kettnersbusch",
	  "Am Kiesberg",
	  "Am Klösterchen",
	  "Am Knechtsgraben",
	  "Am Köllerweg",
	  "Am Köttersbach",
	  "Am Kreispark",
	  "Am Kronefeld",
	  "Am Küchenhof",
	  "Am Kühnsbusch",
	  "Am Lindenfeld",
	  "Am Märchen",
	  "Am Mittelberg",
	  "Am Mönchshof",
	  "Am Mühlenbach",
	  "Am Neuenhof",
	  "Am Nonnenbruch",
	  "Am Plattenbusch",
	  "Am Quettinger Feld",
	  "Am Rosenhügel",
	  "Am Sandberg",
	  "Am Scherfenbrand",
	  "Am Schokker",
	  "Am Silbersee",
	  "Am Sonnenhang",
	  "Am Sportplatz",
	  "Am Stadtpark",
	  "Am Steinberg",
	  "Am Telegraf",
	  "Am Thelenhof",
	  "Am Vogelkreuz",
	  "Am Vogelsang",
	  "Am Vogelsfeldchen",
	  "Am Wambacher Hof",
	  "Am Wasserturm",
	  "Am Weidenbusch",
	  "Am Weiher",
	  "Am Weingarten",
	  "Am Werth",
	  "Amselweg",
	  "An den Irlen",
	  "An den Rheinauen",
	  "An der Bergerweide",
	  "An der Dingbank",
	  "An der Evangelischen Kirche",
	  "An der Evgl. Kirche",
	  "An der Feldgasse",
	  "An der Fettehenne",
	  "An der Kante",
	  "An der Laach",
	  "An der Lehmkuhle",
	  "An der Lichtenburg",
	  "An der Luisenburg",
	  "An der Robertsburg",
	  "An der Schmitten",
	  "An der Schusterinsel",
	  "An der Steinrütsch",
	  "An St. Andreas",
	  "An St. Remigius",
	  "Andreasstr.",
	  "Ankerweg",
	  "Annette-Kolb-Str.",
	  "Apenrader Str.",
	  "Arnold-Ohletz-Str.",
	  "Atzlenbacher Str.",
	  "Auerweg",
	  "Auestr.",
	  "Auf dem Acker",
	  "Auf dem Blahnenhof",
	  "Auf dem Bohnbüchel",
	  "Auf dem Bruch",
	  "Auf dem End",
	  "Auf dem Forst",
	  "Auf dem Herberg",
	  "Auf dem Lehn",
	  "Auf dem Stein",
	  "Auf dem Weierberg",
	  "Auf dem Weiherhahn",
	  "Auf den Reien",
	  "Auf der Donnen",
	  "Auf der Grieße",
	  "Auf der Ohmer",
	  "Auf der Weide",
	  "Auf'm Berg",
	  "Auf'm Kamp",
	  "Augustastr.",
	  "August-Kekulé-Str.",
	  "A.-W.-v.-Hofmann-Str.",
	  "Bahnallee",
	  "Bahnhofstr.",
	  "Baltrumstr.",
	  "Bamberger Str.",
	  "Baumberger Str.",
	  "Bebelstr.",
	  "Beckers Kämpchen",
	  "Beerenstr.",
	  "Beethovenstr.",
	  "Behringstr.",
	  "Bendenweg",
	  "Bensberger Str.",
	  "Benzstr.",
	  "Bergische Landstr.",
	  "Bergstr.",
	  "Berliner Platz",
	  "Berliner Str.",
	  "Bernhard-Letterhaus-Str.",
	  "Bernhard-Lichtenberg-Str.",
	  "Bernhard-Ridder-Str.",
	  "Bernsteinstr.",
	  "Bertha-Middelhauve-Str.",
	  "Bertha-von-Suttner-Str.",
	  "Bertolt-Brecht-Str.",
	  "Berzeliusstr.",
	  "Bielertstr.",
	  "Biesenbach",
	  "Billrothstr.",
	  "Birkenbergstr.",
	  "Birkengartenstr.",
	  "Birkenweg",
	  "Bismarckstr.",
	  "Bitterfelder Str.",
	  "Blankenburg",
	  "Blaukehlchenweg",
	  "Blütenstr.",
	  "Boberstr.",
	  "Böcklerstr.",
	  "Bodelschwinghstr.",
	  "Bodestr.",
	  "Bogenstr.",
	  "Bohnenkampsweg",
	  "Bohofsweg",
	  "Bonifatiusstr.",
	  "Bonner Str.",
	  "Borkumstr.",
	  "Bornheimer Str.",
	  "Borsigstr.",
	  "Borussiastr.",
	  "Bracknellstr.",
	  "Brahmsweg",
	  "Brandenburger Str.",
	  "Breidenbachstr.",
	  "Breslauer Str.",
	  "Bruchhauser Str.",
	  "Brückenstr.",
	  "Brucknerstr.",
	  "Brüder-Bonhoeffer-Str.",
	  "Buchenweg",
	  "Bürgerbuschweg",
	  "Burgloch",
	  "Burgplatz",
	  "Burgstr.",
	  "Burgweg",
	  "Bürriger Weg",
	  "Burscheider Str.",
	  "Buschkämpchen",
	  "Butterheider Str.",
	  "Carl-Duisberg-Platz",
	  "Carl-Duisberg-Str.",
	  "Carl-Leverkus-Str.",
	  "Carl-Maria-von-Weber-Platz",
	  "Carl-Maria-von-Weber-Str.",
	  "Carlo-Mierendorff-Str.",
	  "Carl-Rumpff-Str.",
	  "Carl-von-Ossietzky-Str.",
	  "Charlottenburger Str.",
	  "Christian-Heß-Str.",
	  "Claasbruch",
	  "Clemens-Winkler-Str.",
	  "Concordiastr.",
	  "Cranachstr.",
	  "Dahlemer Str.",
	  "Daimlerstr.",
	  "Damaschkestr.",
	  "Danziger Str.",
	  "Debengasse",
	  "Dechant-Fein-Str.",
	  "Dechant-Krey-Str.",
	  "Deichtorstr.",
	  "Dhünnberg",
	  "Dhünnstr.",
	  "Dianastr.",
	  "Diedenhofener Str.",
	  "Diepental",
	  "Diepenthaler Str.",
	  "Dieselstr.",
	  "Dillinger Str.",
	  "Distelkamp",
	  "Dohrgasse",
	  "Domblick",
	  "Dönhoffstr.",
	  "Dornierstr.",
	  "Drachenfelsstr.",
	  "Dr.-August-Blank-Str.",
	  "Dresdener Str.",
	  "Driescher Hecke",
	  "Drosselweg",
	  "Dudweilerstr.",
	  "Dünenweg",
	  "Dünfelder Str.",
	  "Dünnwalder Grenzweg",
	  "Düppeler Str.",
	  "Dürerstr.",
	  "Dürscheider Weg",
	  "Düsseldorfer Str.",
	  "Edelrather Weg",
	  "Edmund-Husserl-Str.",
	  "Eduard-Spranger-Str.",
	  "Ehrlichstr.",
	  "Eichenkamp",
	  "Eichenweg",
	  "Eidechsenweg",
	  "Eifelstr.",
	  "Eifgenstr.",
	  "Eintrachtstr.",
	  "Elbestr.",
	  "Elisabeth-Langgässer-Str.",
	  "Elisabethstr.",
	  "Elisabeth-von-Thadden-Str.",
	  "Elisenstr.",
	  "Elsa-Brändström-Str.",
	  "Elsbachstr.",
	  "Else-Lasker-Schüler-Str.",
	  "Elsterstr.",
	  "Emil-Fischer-Str.",
	  "Emil-Nolde-Str.",
	  "Engelbertstr.",
	  "Engstenberger Weg",
	  "Entenpfuhl",
	  "Erbelegasse",
	  "Erftstr.",
	  "Erfurter Str.",
	  "Erich-Heckel-Str.",
	  "Erich-Klausener-Str.",
	  "Erich-Ollenhauer-Str.",
	  "Erlenweg",
	  "Ernst-Bloch-Str.",
	  "Ernst-Ludwig-Kirchner-Str.",
	  "Erzbergerstr.",
	  "Eschenallee",
	  "Eschenweg",
	  "Esmarchstr.",
	  "Espenweg",
	  "Euckenstr.",
	  "Eulengasse",
	  "Eulenkamp",
	  "Ewald-Flamme-Str.",
	  "Ewald-Röll-Str.",
	  "Fährstr.",
	  "Farnweg",
	  "Fasanenweg",
	  "Faßbacher Hof",
	  "Felderstr.",
	  "Feldkampstr.",
	  "Feldsiefer Weg",
	  "Feldsiefer Wiesen",
	  "Feldstr.",
	  "Feldtorstr.",
	  "Felix-von-Roll-Str.",
	  "Ferdinand-Lassalle-Str.",
	  "Fester Weg",
	  "Feuerbachstr.",
	  "Feuerdornweg",
	  "Fichtenweg",
	  "Fichtestr.",
	  "Finkelsteinstr.",
	  "Finkenweg",
	  "Fixheider Str.",
	  "Flabbenhäuschen",
	  "Flensburger Str.",
	  "Fliederweg",
	  "Florastr.",
	  "Florianweg",
	  "Flotowstr.",
	  "Flurstr.",
	  "Föhrenweg",
	  "Fontanestr.",
	  "Forellental",
	  "Fortunastr.",
	  "Franz-Esser-Str.",
	  "Franz-Hitze-Str.",
	  "Franz-Kail-Str.",
	  "Franz-Marc-Str.",
	  "Freiburger Str.",
	  "Freiheitstr.",
	  "Freiherr-vom-Stein-Str.",
	  "Freudenthal",
	  "Freudenthaler Weg",
	  "Fridtjof-Nansen-Str.",
	  "Friedenberger Str.",
	  "Friedensstr.",
	  "Friedhofstr.",
	  "Friedlandstr.",
	  "Friedlieb-Ferdinand-Runge-Str.",
	  "Friedrich-Bayer-Str.",
	  "Friedrich-Bergius-Platz",
	  "Friedrich-Ebert-Platz",
	  "Friedrich-Ebert-Str.",
	  "Friedrich-Engels-Str.",
	  "Friedrich-List-Str.",
	  "Friedrich-Naumann-Str.",
	  "Friedrich-Sertürner-Str.",
	  "Friedrichstr.",
	  "Friedrich-Weskott-Str.",
	  "Friesenweg",
	  "Frischenberg",
	  "Fritz-Erler-Str.",
	  "Fritz-Henseler-Str.",
	  "Fröbelstr.",
	  "Fürstenbergplatz",
	  "Fürstenbergstr.",
	  "Gabriele-Münter-Str.",
	  "Gartenstr.",
	  "Gebhardstr.",
	  "Geibelstr.",
	  "Gellertstr.",
	  "Georg-von-Vollmar-Str.",
	  "Gerhard-Domagk-Str.",
	  "Gerhart-Hauptmann-Str.",
	  "Gerichtsstr.",
	  "Geschwister-Scholl-Str.",
	  "Gezelinallee",
	  "Gierener Weg",
	  "Ginsterweg",
	  "Gisbert-Cremer-Str.",
	  "Glücksburger Str.",
	  "Gluckstr.",
	  "Gneisenaustr.",
	  "Goetheplatz",
	  "Goethestr.",
	  "Golo-Mann-Str.",
	  "Görlitzer Str.",
	  "Görresstr.",
	  "Graebestr.",
	  "Graf-Galen-Platz",
	  "Gregor-Mendel-Str.",
	  "Greifswalder Str.",
	  "Grillenweg",
	  "Gronenborner Weg",
	  "Große Kirchstr.",
	  "Grunder Wiesen",
	  "Grundermühle",
	  "Grundermühlenhof",
	  "Grundermühlenweg",
	  "Grüner Weg",
	  "Grunewaldstr.",
	  "Grünstr.",
	  "Günther-Weisenborn-Str.",
	  "Gustav-Freytag-Str.",
	  "Gustav-Heinemann-Str.",
	  "Gustav-Radbruch-Str.",
	  "Gut Reuschenberg",
	  "Gutenbergstr.",
	  "Haberstr.",
	  "Habichtgasse",
	  "Hafenstr.",
	  "Hagenauer Str.",
	  "Hahnenblecher",
	  "Halenseestr.",
	  "Halfenleimbach",
	  "Hallesche Str.",
	  "Halligstr.",
	  "Hamberger Str.",
	  "Hammerweg",
	  "Händelstr.",
	  "Hannah-Höch-Str.",
	  "Hans-Arp-Str.",
	  "Hans-Gerhard-Str.",
	  "Hans-Sachs-Str.",
	  "Hans-Schlehahn-Str.",
	  "Hans-von-Dohnanyi-Str.",
	  "Hardenbergstr.",
	  "Haselweg",
	  "Hauptstr.",
	  "Haus-Vorster-Str.",
	  "Hauweg",
	  "Havelstr.",
	  "Havensteinstr.",
	  "Haydnstr.",
	  "Hebbelstr.",
	  "Heckenweg",
	  "Heerweg",
	  "Hegelstr.",
	  "Heidberg",
	  "Heidehöhe",
	  "Heidestr.",
	  "Heimstättenweg",
	  "Heinrich-Böll-Str.",
	  "Heinrich-Brüning-Str.",
	  "Heinrich-Claes-Str.",
	  "Heinrich-Heine-Str.",
	  "Heinrich-Hörlein-Str.",
	  "Heinrich-Lübke-Str.",
	  "Heinrich-Lützenkirchen-Weg",
	  "Heinrichstr.",
	  "Heinrich-Strerath-Str.",
	  "Heinrich-von-Kleist-Str.",
	  "Heinrich-von-Stephan-Str.",
	  "Heisterbachstr.",
	  "Helenenstr.",
	  "Helmestr.",
	  "Hemmelrather Weg",
	  "Henry-T.-v.-Böttinger-Str.",
	  "Herderstr.",
	  "Heribertstr.",
	  "Hermann-Ehlers-Str.",
	  "Hermann-Hesse-Str.",
	  "Hermann-König-Str.",
	  "Hermann-Löns-Str.",
	  "Hermann-Milde-Str.",
	  "Hermann-Nörrenberg-Str.",
	  "Hermann-von-Helmholtz-Str.",
	  "Hermann-Waibel-Str.",
	  "Herzogstr.",
	  "Heymannstr.",
	  "Hindenburgstr.",
	  "Hirzenberg",
	  "Hitdorfer Kirchweg",
	  "Hitdorfer Str.",
	  "Höfer Mühle",
	  "Höfer Weg",
	  "Hohe Str.",
	  "Höhenstr.",
	  "Höltgestal",
	  "Holunderweg",
	  "Holzer Weg",
	  "Holzer Wiesen",
	  "Hornpottweg",
	  "Hubertusweg",
	  "Hufelandstr.",
	  "Hufer Weg",
	  "Humboldtstr.",
	  "Hummelsheim",
	  "Hummelweg",
	  "Humperdinckstr.",
	  "Hüscheider Gärten",
	  "Hüscheider Str.",
	  "Hütte",
	  "Ilmstr.",
	  "Im Bergischen Heim",
	  "Im Bruch",
	  "Im Buchenhain",
	  "Im Bühl",
	  "Im Burgfeld",
	  "Im Dorf",
	  "Im Eisholz",
	  "Im Friedenstal",
	  "Im Frohental",
	  "Im Grunde",
	  "Im Hederichsfeld",
	  "Im Jücherfeld",
	  "Im Kalkfeld",
	  "Im Kirberg",
	  "Im Kirchfeld",
	  "Im Kreuzbruch",
	  "Im Mühlenfeld",
	  "Im Nesselrader Kamp",
	  "Im Oberdorf",
	  "Im Oberfeld",
	  "Im Rosengarten",
	  "Im Rottland",
	  "Im Scheffengarten",
	  "Im Staderfeld",
	  "Im Steinfeld",
	  "Im Weidenblech",
	  "Im Winkel",
	  "Im Ziegelfeld",
	  "Imbach",
	  "Imbacher Weg",
	  "Immenweg",
	  "In den Blechenhöfen",
	  "In den Dehlen",
	  "In der Birkenau",
	  "In der Dasladen",
	  "In der Felderhütten",
	  "In der Hartmannswiese",
	  "In der Höhle",
	  "In der Schaafsdellen",
	  "In der Wasserkuhl",
	  "In der Wüste",
	  "In Holzhausen",
	  "Insterstr.",
	  "Jacob-Fröhlen-Str.",
	  "Jägerstr.",
	  "Jahnstr.",
	  "Jakob-Eulenberg-Weg",
	  "Jakobistr.",
	  "Jakob-Kaiser-Str.",
	  "Jenaer Str.",
	  "Johannes-Baptist-Str.",
	  "Johannes-Dott-Str.",
	  "Johannes-Popitz-Str.",
	  "Johannes-Wislicenus-Str.",
	  "Johannisburger Str.",
	  "Johann-Janssen-Str.",
	  "Johann-Wirtz-Weg",
	  "Josefstr.",
	  "Jüch",
	  "Julius-Doms-Str.",
	  "Julius-Leber-Str.",
	  "Kaiserplatz",
	  "Kaiserstr.",
	  "Kaiser-Wilhelm-Allee",
	  "Kalkstr.",
	  "Kämpchenstr.",
	  "Kämpenwiese",
	  "Kämper Weg",
	  "Kamptalweg",
	  "Kanalstr.",
	  "Kandinskystr.",
	  "Kantstr.",
	  "Kapellenstr.",
	  "Karl-Arnold-Str.",
	  "Karl-Bosch-Str.",
	  "Karl-Bückart-Str.",
	  "Karl-Carstens-Ring",
	  "Karl-Friedrich-Goerdeler-Str.",
	  "Karl-Jaspers-Str.",
	  "Karl-König-Str.",
	  "Karl-Krekeler-Str.",
	  "Karl-Marx-Str.",
	  "Karlstr.",
	  "Karl-Ulitzka-Str.",
	  "Karl-Wichmann-Str.",
	  "Karl-Wingchen-Str.",
	  "Käsenbrod",
	  "Käthe-Kollwitz-Str.",
	  "Katzbachstr.",
	  "Kerschensteinerstr.",
	  "Kiefernweg",
	  "Kieler Str.",
	  "Kieselstr.",
	  "Kiesweg",
	  "Kinderhausen",
	  "Kleiberweg",
	  "Kleine Kirchstr.",
	  "Kleingansweg",
	  "Kleinheider Weg",
	  "Klief",
	  "Kneippstr.",
	  "Knochenbergsweg",
	  "Kochergarten",
	  "Kocherstr.",
	  "Kockelsberg",
	  "Kolberger Str.",
	  "Kolmarer Str.",
	  "Kölner Gasse",
	  "Kölner Str.",
	  "Kolpingstr.",
	  "Königsberger Platz",
	  "Konrad-Adenauer-Platz",
	  "Köpenicker Str.",
	  "Kopernikusstr.",
	  "Körnerstr.",
	  "Köschenberg",
	  "Köttershof",
	  "Kreuzbroicher Str.",
	  "Kreuzkamp",
	  "Krummer Weg",
	  "Kruppstr.",
	  "Kuhlmannweg",
	  "Kump",
	  "Kumper Weg",
	  "Kunstfeldstr.",
	  "Küppersteger Str.",
	  "Kursiefen",
	  "Kursiefer Weg",
	  "Kurtekottenweg",
	  "Kurt-Schumacher-Ring",
	  "Kyllstr.",
	  "Langenfelder Str.",
	  "Längsleimbach",
	  "Lärchenweg",
	  "Legienstr.",
	  "Lehner Mühle",
	  "Leichlinger Str.",
	  "Leimbacher Hof",
	  "Leinestr.",
	  "Leineweberstr.",
	  "Leipziger Str.",
	  "Lerchengasse",
	  "Lessingstr.",
	  "Libellenweg",
	  "Lichstr.",
	  "Liebigstr.",
	  "Lindenstr.",
	  "Lingenfeld",
	  "Linienstr.",
	  "Lippe",
	  "Löchergraben",
	  "Löfflerstr.",
	  "Loheweg",
	  "Lohrbergstr.",
	  "Lohrstr.",
	  "Löhstr.",
	  "Lortzingstr.",
	  "Lötzener Str.",
	  "Löwenburgstr.",
	  "Lucasstr.",
	  "Ludwig-Erhard-Platz",
	  "Ludwig-Girtler-Str.",
	  "Ludwig-Knorr-Str.",
	  "Luisenstr.",
	  "Lupinenweg",
	  "Lurchenweg",
	  "Lützenkirchener Str.",
	  "Lycker Str.",
	  "Maashofstr.",
	  "Manforter Str.",
	  "Marc-Chagall-Str.",
	  "Maria-Dresen-Str.",
	  "Maria-Terwiel-Str.",
	  "Marie-Curie-Str.",
	  "Marienburger Str.",
	  "Mariendorfer Str.",
	  "Marienwerderstr.",
	  "Marie-Schlei-Str.",
	  "Marktplatz",
	  "Markusweg",
	  "Martin-Buber-Str.",
	  "Martin-Heidegger-Str.",
	  "Martin-Luther-Str.",
	  "Masurenstr.",
	  "Mathildenweg",
	  "Maurinusstr.",
	  "Mauspfad",
	  "Max-Beckmann-Str.",
	  "Max-Delbrück-Str.",
	  "Max-Ernst-Str.",
	  "Max-Holthausen-Platz",
	  "Max-Horkheimer-Str.",
	  "Max-Liebermann-Str.",
	  "Max-Pechstein-Str.",
	  "Max-Planck-Str.",
	  "Max-Scheler-Str.",
	  "Max-Schönenberg-Str.",
	  "Maybachstr.",
	  "Meckhofer Feld",
	  "Meisenweg",
	  "Memelstr.",
	  "Menchendahler Str.",
	  "Mendelssohnstr.",
	  "Merziger Str.",
	  "Mettlacher Str.",
	  "Metzer Str.",
	  "Michaelsweg",
	  "Miselohestr.",
	  "Mittelstr.",
	  "Mohlenstr.",
	  "Moltkestr.",
	  "Monheimer Str.",
	  "Montanusstr.",
	  "Montessoriweg",
	  "Moosweg",
	  "Morsbroicher Str.",
	  "Moselstr.",
	  "Moskauer Str.",
	  "Mozartstr.",
	  "Mühlenweg",
	  "Muhrgasse",
	  "Muldestr.",
	  "Mülhausener Str.",
	  "Mülheimer Str.",
	  "Münsters Gäßchen",
	  "Münzstr.",
	  "Müritzstr.",
	  "Myliusstr.",
	  "Nachtigallenweg",
	  "Nauener Str.",
	  "Neißestr.",
	  "Nelly-Sachs-Str.",
	  "Netzestr.",
	  "Neuendriesch",
	  "Neuenhausgasse",
	  "Neuenkamp",
	  "Neujudenhof",
	  "Neukronenberger Str.",
	  "Neustadtstr.",
	  "Nicolai-Hartmann-Str.",
	  "Niederblecher",
	  "Niederfeldstr.",
	  "Nietzschestr.",
	  "Nikolaus-Groß-Str.",
	  "Nobelstr.",
	  "Norderneystr.",
	  "Nordstr.",
	  "Ober dem Hof",
	  "Obere Lindenstr.",
	  "Obere Str.",
	  "Oberölbach",
	  "Odenthaler Str.",
	  "Oderstr.",
	  "Okerstr.",
	  "Olof-Palme-Str.",
	  "Ophovener Str.",
	  "Opladener Platz",
	  "Opladener Str.",
	  "Ortelsburger Str.",
	  "Oskar-Moll-Str.",
	  "Oskar-Schlemmer-Str.",
	  "Oststr.",
	  "Oswald-Spengler-Str.",
	  "Otto-Dix-Str.",
	  "Otto-Grimm-Str.",
	  "Otto-Hahn-Str.",
	  "Otto-Müller-Str.",
	  "Otto-Stange-Str.",
	  "Ottostr.",
	  "Otto-Varnhagen-Str.",
	  "Otto-Wels-Str.",
	  "Ottweilerstr.",
	  "Oulustr.",
	  "Overfeldweg",
	  "Pappelweg",
	  "Paracelsusstr.",
	  "Parkstr.",
	  "Pastor-Louis-Str.",
	  "Pastor-Scheibler-Str.",
	  "Pastorskamp",
	  "Paul-Klee-Str.",
	  "Paul-Löbe-Str.",
	  "Paulstr.",
	  "Peenestr.",
	  "Pescher Busch",
	  "Peschstr.",
	  "Pestalozzistr.",
	  "Peter-Grieß-Str.",
	  "Peter-Joseph-Lenné-Str.",
	  "Peter-Neuenheuser-Str.",
	  "Petersbergstr.",
	  "Peterstr.",
	  "Pfarrer-Jekel-Str.",
	  "Pfarrer-Klein-Str.",
	  "Pfarrer-Röhr-Str.",
	  "Pfeilshofstr.",
	  "Philipp-Ott-Str.",
	  "Piet-Mondrian-Str.",
	  "Platanenweg",
	  "Pommernstr.",
	  "Porschestr.",
	  "Poststr.",
	  "Potsdamer Str.",
	  "Pregelstr.",
	  "Prießnitzstr.",
	  "Pützdelle",
	  "Quarzstr.",
	  "Quettinger Str.",
	  "Rat-Deycks-Str.",
	  "Rathenaustr.",
	  "Ratherkämp",
	  "Ratiborer Str.",
	  "Raushofstr.",
	  "Regensburger Str.",
	  "Reinickendorfer Str.",
	  "Renkgasse",
	  "Rennbaumplatz",
	  "Rennbaumstr.",
	  "Reuschenberger Str.",
	  "Reusrather Str.",
	  "Reuterstr.",
	  "Rheinallee",
	  "Rheindorfer Str.",
	  "Rheinstr.",
	  "Rhein-Wupper-Platz",
	  "Richard-Wagner-Str.",
	  "Rilkestr.",
	  "Ringstr.",
	  "Robert-Blum-Str.",
	  "Robert-Koch-Str.",
	  "Robert-Medenwald-Str.",
	  "Rolandstr.",
	  "Romberg",
	  "Röntgenstr.",
	  "Roonstr.",
	  "Ropenstall",
	  "Ropenstaller Weg",
	  "Rosenthal",
	  "Rostocker Str.",
	  "Rotdornweg",
	  "Röttgerweg",
	  "Rückertstr.",
	  "Rudolf-Breitscheid-Str.",
	  "Rudolf-Mann-Platz",
	  "Rudolf-Stracke-Str.",
	  "Ruhlachplatz",
	  "Ruhlachstr.",
	  "Rüttersweg",
	  "Saalestr.",
	  "Saarbrücker Str.",
	  "Saarlauterner Str.",
	  "Saarstr.",
	  "Salamanderweg",
	  "Samlandstr.",
	  "Sanddornstr.",
	  "Sandstr.",
	  "Sauerbruchstr.",
	  "Schäfershütte",
	  "Scharnhorststr.",
	  "Scheffershof",
	  "Scheidemannstr.",
	  "Schellingstr.",
	  "Schenkendorfstr.",
	  "Schießbergstr.",
	  "Schillerstr.",
	  "Schlangenhecke",
	  "Schlebuscher Heide",
	  "Schlebuscher Str.",
	  "Schlebuschrath",
	  "Schlehdornstr.",
	  "Schleiermacherstr.",
	  "Schloßstr.",
	  "Schmalenbruch",
	  "Schnepfenflucht",
	  "Schöffenweg",
	  "Schöllerstr.",
	  "Schöne Aussicht",
	  "Schöneberger Str.",
	  "Schopenhauerstr.",
	  "Schubertplatz",
	  "Schubertstr.",
	  "Schulberg",
	  "Schulstr.",
	  "Schumannstr.",
	  "Schwalbenweg",
	  "Schwarzastr.",
	  "Sebastianusweg",
	  "Semmelweisstr.",
	  "Siebelplatz",
	  "Siemensstr.",
	  "Solinger Str.",
	  "Sonderburger Str.",
	  "Spandauer Str.",
	  "Speestr.",
	  "Sperberweg",
	  "Sperlingsweg",
	  "Spitzwegstr.",
	  "Sporrenberger Mühle",
	  "Spreestr.",
	  "St. Ingberter Str.",
	  "Starenweg",
	  "Stauffenbergstr.",
	  "Stefan-Zweig-Str.",
	  "Stegerwaldstr.",
	  "Steglitzer Str.",
	  "Steinbücheler Feld",
	  "Steinbücheler Str.",
	  "Steinstr.",
	  "Steinweg",
	  "Stephan-Lochner-Str.",
	  "Stephanusstr.",
	  "Stettiner Str.",
	  "Stixchesstr.",
	  "Stöckenstr.",
	  "Stralsunder Str.",
	  "Straßburger Str.",
	  "Stresemannplatz",
	  "Strombergstr.",
	  "Stromstr.",
	  "Stüttekofener Str.",
	  "Sudestr.",
	  "Sürderstr.",
	  "Syltstr.",
	  "Talstr.",
	  "Tannenbergstr.",
	  "Tannenweg",
	  "Taubenweg",
	  "Teitscheider Weg",
	  "Telegrafenstr.",
	  "Teltower Str.",
	  "Tempelhofer Str.",
	  "Theodor-Adorno-Str.",
	  "Theodor-Fliedner-Str.",
	  "Theodor-Gierath-Str.",
	  "Theodor-Haubach-Str.",
	  "Theodor-Heuss-Ring",
	  "Theodor-Storm-Str.",
	  "Theodorstr.",
	  "Thomas-Dehler-Str.",
	  "Thomas-Morus-Str.",
	  "Thomas-von-Aquin-Str.",
	  "Tönges Feld",
	  "Torstr.",
	  "Treptower Str.",
	  "Treuburger Str.",
	  "Uhlandstr.",
	  "Ulmenweg",
	  "Ulmer Str.",
	  "Ulrichstr.",
	  "Ulrich-von-Hassell-Str.",
	  "Umlag",
	  "Unstrutstr.",
	  "Unter dem Schildchen",
	  "Unterölbach",
	  "Unterstr.",
	  "Uppersberg",
	  "Van\\'t-Hoff-Str.",
	  "Veit-Stoß-Str.",
	  "Vereinsstr.",
	  "Viktor-Meyer-Str.",
	  "Vincent-van-Gogh-Str.",
	  "Virchowstr.",
	  "Voigtslach",
	  "Volhardstr.",
	  "Völklinger Str.",
	  "Von-Brentano-Str.",
	  "Von-Diergardt-Str.",
	  "Von-Eichendorff-Str.",
	  "Von-Ketteler-Str.",
	  "Von-Knoeringen-Str.",
	  "Von-Pettenkofer-Str.",
	  "Von-Siebold-Str.",
	  "Wacholderweg",
	  "Waldstr.",
	  "Walter-Flex-Str.",
	  "Walter-Hempel-Str.",
	  "Walter-Hochapfel-Str.",
	  "Walter-Nernst-Str.",
	  "Wannseestr.",
	  "Warnowstr.",
	  "Warthestr.",
	  "Weddigenstr.",
	  "Weichselstr.",
	  "Weidenstr.",
	  "Weidfeldstr.",
	  "Weiherfeld",
	  "Weiherstr.",
	  "Weinhäuser Str.",
	  "Weißdornweg",
	  "Weißenseestr.",
	  "Weizkamp",
	  "Werftstr.",
	  "Werkstättenstr.",
	  "Werner-Heisenberg-Str.",
	  "Werrastr.",
	  "Weyerweg",
	  "Widdauener Str.",
	  "Wiebertshof",
	  "Wiehbachtal",
	  "Wiembachallee",
	  "Wiesdorfer Platz",
	  "Wiesenstr.",
	  "Wilhelm-Busch-Str.",
	  "Wilhelm-Hastrich-Str.",
	  "Wilhelm-Leuschner-Str.",
	  "Wilhelm-Liebknecht-Str.",
	  "Wilhelmsgasse",
	  "Wilhelmstr.",
	  "Willi-Baumeister-Str.",
	  "Willy-Brandt-Ring",
	  "Winand-Rossi-Str.",
	  "Windthorststr.",
	  "Winkelweg",
	  "Winterberg",
	  "Wittenbergstr.",
	  "Wolf-Vostell-Str.",
	  "Wolkenburgstr.",
	  "Wupperstr.",
	  "Wuppertalstr.",
	  "Wüstenhof",
	  "Yitzhak-Rabin-Str.",
	  "Zauberkuhle",
	  "Zedernweg",
	  "Zehlendorfer Str.",
	  "Zehntenweg",
	  "Zeisigweg",
	  "Zeppelinstr.",
	  "Zschopaustr.",
	  "Zum Claashäuschen",
	  "Zündhütchenweg",
	  "Zur Alten Brauerei",
	  "Zur alten Fabrik"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+49-1##-#######",
	  "+49-1###-########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(773);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(778);
	company.legal_form = __webpack_require__(776);
	company.name = __webpack_require__(777);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de = {};
	module['exports'] = de;
	de.title = "German";
	de.address = __webpack_require__(765);
	de.company = __webpack_require__(775);
	de.internet = __webpack_require__(782);
	de.lorem = __webpack_require__(783);
	de.name = __webpack_require__(786);
	de.phone_number = __webpack_require__(792);
	de.cell_phone = __webpack_require__(774);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "info",
	  "name",
	  "net",
	  "org",
	  "de",
	  "ch"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(781);
	internet.domain_suffix = __webpack_require__(780);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(784);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Abdul",
	  "Abdullah",
	  "Adam",
	  "Adrian",
	  "Adriano",
	  "Ahmad",
	  "Ahmed",
	  "Ahmet",
	  "Alan",
	  "Albert",
	  "Alessandro",
	  "Alessio",
	  "Alex",
	  "Alexander",
	  "Alfred",
	  "Ali",
	  "Amar",
	  "Amir",
	  "Amon",
	  "Andre",
	  "Andreas",
	  "Andrew",
	  "Angelo",
	  "Ansgar",
	  "Anthony",
	  "Anton",
	  "Antonio",
	  "Arda",
	  "Arian",
	  "Armin",
	  "Arne",
	  "Arno",
	  "Arthur",
	  "Artur",
	  "Arved",
	  "Arvid",
	  "Ayman",
	  "Baran",
	  "Baris",
	  "Bastian",
	  "Batuhan",
	  "Bela",
	  "Ben",
	  "Benedikt",
	  "Benjamin",
	  "Bennet",
	  "Bennett",
	  "Benno",
	  "Bent",
	  "Berat",
	  "Berkay",
	  "Bernd",
	  "Bilal",
	  "Bjarne",
	  "Björn",
	  "Bo",
	  "Boris",
	  "Brandon",
	  "Brian",
	  "Bruno",
	  "Bryan",
	  "Burak",
	  "Calvin",
	  "Can",
	  "Carl",
	  "Carlo",
	  "Carlos",
	  "Caspar",
	  "Cedric",
	  "Cedrik",
	  "Cem",
	  "Charlie",
	  "Chris",
	  "Christian",
	  "Christiano",
	  "Christoph",
	  "Christopher",
	  "Claas",
	  "Clemens",
	  "Colin",
	  "Collin",
	  "Conner",
	  "Connor",
	  "Constantin",
	  "Corvin",
	  "Curt",
	  "Damian",
	  "Damien",
	  "Daniel",
	  "Danilo",
	  "Danny",
	  "Darian",
	  "Dario",
	  "Darius",
	  "Darren",
	  "David",
	  "Davide",
	  "Davin",
	  "Dean",
	  "Deniz",
	  "Dennis",
	  "Denny",
	  "Devin",
	  "Diego",
	  "Dion",
	  "Domenic",
	  "Domenik",
	  "Dominic",
	  "Dominik",
	  "Dorian",
	  "Dustin",
	  "Dylan",
	  "Ecrin",
	  "Eddi",
	  "Eddy",
	  "Edgar",
	  "Edwin",
	  "Efe",
	  "Ege",
	  "Elia",
	  "Eliah",
	  "Elias",
	  "Elijah",
	  "Emanuel",
	  "Emil",
	  "Emilian",
	  "Emilio",
	  "Emir",
	  "Emirhan",
	  "Emre",
	  "Enes",
	  "Enno",
	  "Enrico",
	  "Eren",
	  "Eric",
	  "Erik",
	  "Etienne",
	  "Fabian",
	  "Fabien",
	  "Fabio",
	  "Fabrice",
	  "Falk",
	  "Felix",
	  "Ferdinand",
	  "Fiete",
	  "Filip",
	  "Finlay",
	  "Finley",
	  "Finn",
	  "Finnley",
	  "Florian",
	  "Francesco",
	  "Franz",
	  "Frederic",
	  "Frederick",
	  "Frederik",
	  "Friedrich",
	  "Fritz",
	  "Furkan",
	  "Fynn",
	  "Gabriel",
	  "Georg",
	  "Gerrit",
	  "Gian",
	  "Gianluca",
	  "Gino",
	  "Giuliano",
	  "Giuseppe",
	  "Gregor",
	  "Gustav",
	  "Hagen",
	  "Hamza",
	  "Hannes",
	  "Hanno",
	  "Hans",
	  "Hasan",
	  "Hassan",
	  "Hauke",
	  "Hendrik",
	  "Hennes",
	  "Henning",
	  "Henri",
	  "Henrick",
	  "Henrik",
	  "Henry",
	  "Hugo",
	  "Hussein",
	  "Ian",
	  "Ibrahim",
	  "Ilias",
	  "Ilja",
	  "Ilyas",
	  "Immanuel",
	  "Ismael",
	  "Ismail",
	  "Ivan",
	  "Iven",
	  "Jack",
	  "Jacob",
	  "Jaden",
	  "Jakob",
	  "Jamal",
	  "James",
	  "Jamie",
	  "Jan",
	  "Janek",
	  "Janis",
	  "Janne",
	  "Jannek",
	  "Jannes",
	  "Jannik",
	  "Jannis",
	  "Jano",
	  "Janosch",
	  "Jared",
	  "Jari",
	  "Jarne",
	  "Jarno",
	  "Jaron",
	  "Jason",
	  "Jasper",
	  "Jay",
	  "Jayden",
	  "Jayson",
	  "Jean",
	  "Jens",
	  "Jeremias",
	  "Jeremie",
	  "Jeremy",
	  "Jermaine",
	  "Jerome",
	  "Jesper",
	  "Jesse",
	  "Jim",
	  "Jimmy",
	  "Joe",
	  "Joel",
	  "Joey",
	  "Johann",
	  "Johannes",
	  "John",
	  "Johnny",
	  "Jon",
	  "Jona",
	  "Jonah",
	  "Jonas",
	  "Jonathan",
	  "Jonte",
	  "Joost",
	  "Jordan",
	  "Joris",
	  "Joscha",
	  "Joschua",
	  "Josef",
	  "Joseph",
	  "Josh",
	  "Joshua",
	  "Josua",
	  "Juan",
	  "Julian",
	  "Julien",
	  "Julius",
	  "Juri",
	  "Justin",
	  "Justus",
	  "Kaan",
	  "Kai",
	  "Kalle",
	  "Karim",
	  "Karl",
	  "Karlo",
	  "Kay",
	  "Keanu",
	  "Kenan",
	  "Kenny",
	  "Keno",
	  "Kerem",
	  "Kerim",
	  "Kevin",
	  "Kian",
	  "Kilian",
	  "Kim",
	  "Kimi",
	  "Kjell",
	  "Klaas",
	  "Klemens",
	  "Konrad",
	  "Konstantin",
	  "Koray",
	  "Korbinian",
	  "Kurt",
	  "Lars",
	  "Lasse",
	  "Laurence",
	  "Laurens",
	  "Laurenz",
	  "Laurin",
	  "Lean",
	  "Leander",
	  "Leandro",
	  "Leif",
	  "Len",
	  "Lenn",
	  "Lennard",
	  "Lennart",
	  "Lennert",
	  "Lennie",
	  "Lennox",
	  "Lenny",
	  "Leo",
	  "Leon",
	  "Leonard",
	  "Leonardo",
	  "Leonhard",
	  "Leonidas",
	  "Leopold",
	  "Leroy",
	  "Levent",
	  "Levi",
	  "Levin",
	  "Lewin",
	  "Lewis",
	  "Liam",
	  "Lian",
	  "Lias",
	  "Lino",
	  "Linus",
	  "Lio",
	  "Lion",
	  "Lionel",
	  "Logan",
	  "Lorenz",
	  "Lorenzo",
	  "Loris",
	  "Louis",
	  "Luan",
	  "Luc",
	  "Luca",
	  "Lucas",
	  "Lucian",
	  "Lucien",
	  "Ludwig",
	  "Luis",
	  "Luiz",
	  "Luk",
	  "Luka",
	  "Lukas",
	  "Luke",
	  "Lutz",
	  "Maddox",
	  "Mads",
	  "Magnus",
	  "Maik",
	  "Maksim",
	  "Malik",
	  "Malte",
	  "Manuel",
	  "Marc",
	  "Marcel",
	  "Marco",
	  "Marcus",
	  "Marek",
	  "Marian",
	  "Mario",
	  "Marius",
	  "Mark",
	  "Marko",
	  "Markus",
	  "Marlo",
	  "Marlon",
	  "Marten",
	  "Martin",
	  "Marvin",
	  "Marwin",
	  "Mateo",
	  "Mathis",
	  "Matis",
	  "Mats",
	  "Matteo",
	  "Mattes",
	  "Matthias",
	  "Matthis",
	  "Matti",
	  "Mattis",
	  "Maurice",
	  "Max",
	  "Maxim",
	  "Maximilian",
	  "Mehmet",
	  "Meik",
	  "Melvin",
	  "Merlin",
	  "Mert",
	  "Michael",
	  "Michel",
	  "Mick",
	  "Miguel",
	  "Mika",
	  "Mikail",
	  "Mike",
	  "Milan",
	  "Milo",
	  "Mio",
	  "Mirac",
	  "Mirco",
	  "Mirko",
	  "Mohamed",
	  "Mohammad",
	  "Mohammed",
	  "Moritz",
	  "Morten",
	  "Muhammed",
	  "Murat",
	  "Mustafa",
	  "Nathan",
	  "Nathanael",
	  "Nelson",
	  "Neo",
	  "Nevio",
	  "Nick",
	  "Niclas",
	  "Nico",
	  "Nicolai",
	  "Nicolas",
	  "Niels",
	  "Nikita",
	  "Niklas",
	  "Niko",
	  "Nikolai",
	  "Nikolas",
	  "Nils",
	  "Nino",
	  "Noah",
	  "Noel",
	  "Norman",
	  "Odin",
	  "Oke",
	  "Ole",
	  "Oliver",
	  "Omar",
	  "Onur",
	  "Oscar",
	  "Oskar",
	  "Pascal",
	  "Patrice",
	  "Patrick",
	  "Paul",
	  "Peer",
	  "Pepe",
	  "Peter",
	  "Phil",
	  "Philip",
	  "Philipp",
	  "Pierre",
	  "Piet",
	  "Pit",
	  "Pius",
	  "Quentin",
	  "Quirin",
	  "Rafael",
	  "Raik",
	  "Ramon",
	  "Raphael",
	  "Rasmus",
	  "Raul",
	  "Rayan",
	  "René",
	  "Ricardo",
	  "Riccardo",
	  "Richard",
	  "Rick",
	  "Rico",
	  "Robert",
	  "Robin",
	  "Rocco",
	  "Roman",
	  "Romeo",
	  "Ron",
	  "Ruben",
	  "Ryan",
	  "Said",
	  "Salih",
	  "Sam",
	  "Sami",
	  "Sammy",
	  "Samuel",
	  "Sandro",
	  "Santino",
	  "Sascha",
	  "Sean",
	  "Sebastian",
	  "Selim",
	  "Semih",
	  "Shawn",
	  "Silas",
	  "Simeon",
	  "Simon",
	  "Sinan",
	  "Sky",
	  "Stefan",
	  "Steffen",
	  "Stephan",
	  "Steve",
	  "Steven",
	  "Sven",
	  "Sönke",
	  "Sören",
	  "Taha",
	  "Tamino",
	  "Tammo",
	  "Tarik",
	  "Tayler",
	  "Taylor",
	  "Teo",
	  "Theo",
	  "Theodor",
	  "Thies",
	  "Thilo",
	  "Thomas",
	  "Thorben",
	  "Thore",
	  "Thorge",
	  "Tiago",
	  "Til",
	  "Till",
	  "Tillmann",
	  "Tim",
	  "Timm",
	  "Timo",
	  "Timon",
	  "Timothy",
	  "Tino",
	  "Titus",
	  "Tizian",
	  "Tjark",
	  "Tobias",
	  "Tom",
	  "Tommy",
	  "Toni",
	  "Tony",
	  "Torben",
	  "Tore",
	  "Tristan",
	  "Tyler",
	  "Tyron",
	  "Umut",
	  "Valentin",
	  "Valentino",
	  "Veit",
	  "Victor",
	  "Viktor",
	  "Vin",
	  "Vincent",
	  "Vito",
	  "Vitus",
	  "Wilhelm",
	  "Willi",
	  "William",
	  "Willy",
	  "Xaver",
	  "Yannic",
	  "Yannick",
	  "Yannik",
	  "Yannis",
	  "Yasin",
	  "Youssef",
	  "Yunus",
	  "Yusuf",
	  "Yven",
	  "Yves",
	  "Ömer",
	  "Aaliyah",
	  "Abby",
	  "Abigail",
	  "Ada",
	  "Adelina",
	  "Adriana",
	  "Aileen",
	  "Aimee",
	  "Alana",
	  "Alea",
	  "Alena",
	  "Alessa",
	  "Alessia",
	  "Alexa",
	  "Alexandra",
	  "Alexia",
	  "Alexis",
	  "Aleyna",
	  "Alia",
	  "Alica",
	  "Alice",
	  "Alicia",
	  "Alina",
	  "Alisa",
	  "Alisha",
	  "Alissa",
	  "Aliya",
	  "Aliyah",
	  "Allegra",
	  "Alma",
	  "Alyssa",
	  "Amalia",
	  "Amanda",
	  "Amelia",
	  "Amelie",
	  "Amina",
	  "Amira",
	  "Amy",
	  "Ana",
	  "Anabel",
	  "Anastasia",
	  "Andrea",
	  "Angela",
	  "Angelina",
	  "Angelique",
	  "Anja",
	  "Ann",
	  "Anna",
	  "Annabel",
	  "Annabell",
	  "Annabelle",
	  "Annalena",
	  "Anne",
	  "Anneke",
	  "Annelie",
	  "Annemarie",
	  "Anni",
	  "Annie",
	  "Annika",
	  "Anny",
	  "Anouk",
	  "Antonia",
	  "Arda",
	  "Ariana",
	  "Ariane",
	  "Arwen",
	  "Ashley",
	  "Asya",
	  "Aurelia",
	  "Aurora",
	  "Ava",
	  "Ayleen",
	  "Aylin",
	  "Ayse",
	  "Azra",
	  "Betty",
	  "Bianca",
	  "Bianka",
	  "Caitlin",
	  "Cara",
	  "Carina",
	  "Carla",
	  "Carlotta",
	  "Carmen",
	  "Carolin",
	  "Carolina",
	  "Caroline",
	  "Cassandra",
	  "Catharina",
	  "Catrin",
	  "Cecile",
	  "Cecilia",
	  "Celia",
	  "Celina",
	  "Celine",
	  "Ceyda",
	  "Ceylin",
	  "Chantal",
	  "Charleen",
	  "Charlotta",
	  "Charlotte",
	  "Chayenne",
	  "Cheyenne",
	  "Chiara",
	  "Christin",
	  "Christina",
	  "Cindy",
	  "Claire",
	  "Clara",
	  "Clarissa",
	  "Colleen",
	  "Collien",
	  "Cora",
	  "Corinna",
	  "Cosima",
	  "Dana",
	  "Daniela",
	  "Daria",
	  "Darleen",
	  "Defne",
	  "Delia",
	  "Denise",
	  "Diana",
	  "Dilara",
	  "Dina",
	  "Dorothea",
	  "Ecrin",
	  "Eda",
	  "Eileen",
	  "Ela",
	  "Elaine",
	  "Elanur",
	  "Elea",
	  "Elena",
	  "Eleni",
	  "Eleonora",
	  "Eliana",
	  "Elif",
	  "Elina",
	  "Elisa",
	  "Elisabeth",
	  "Ella",
	  "Ellen",
	  "Elli",
	  "Elly",
	  "Elsa",
	  "Emelie",
	  "Emely",
	  "Emilia",
	  "Emilie",
	  "Emily",
	  "Emma",
	  "Emmely",
	  "Emmi",
	  "Emmy",
	  "Enie",
	  "Enna",
	  "Enya",
	  "Esma",
	  "Estelle",
	  "Esther",
	  "Eva",
	  "Evelin",
	  "Evelina",
	  "Eveline",
	  "Evelyn",
	  "Fabienne",
	  "Fatima",
	  "Fatma",
	  "Felicia",
	  "Felicitas",
	  "Felina",
	  "Femke",
	  "Fenja",
	  "Fine",
	  "Finia",
	  "Finja",
	  "Finnja",
	  "Fiona",
	  "Flora",
	  "Florentine",
	  "Francesca",
	  "Franka",
	  "Franziska",
	  "Frederike",
	  "Freya",
	  "Frida",
	  "Frieda",
	  "Friederike",
	  "Giada",
	  "Gina",
	  "Giulia",
	  "Giuliana",
	  "Greta",
	  "Hailey",
	  "Hana",
	  "Hanna",
	  "Hannah",
	  "Heidi",
	  "Helen",
	  "Helena",
	  "Helene",
	  "Helin",
	  "Henriette",
	  "Henrike",
	  "Hermine",
	  "Ida",
	  "Ilayda",
	  "Imke",
	  "Ina",
	  "Ines",
	  "Inga",
	  "Inka",
	  "Irem",
	  "Isa",
	  "Isabel",
	  "Isabell",
	  "Isabella",
	  "Isabelle",
	  "Ivonne",
	  "Jacqueline",
	  "Jamie",
	  "Jamila",
	  "Jana",
	  "Jane",
	  "Janin",
	  "Janina",
	  "Janine",
	  "Janna",
	  "Janne",
	  "Jara",
	  "Jasmin",
	  "Jasmina",
	  "Jasmine",
	  "Jella",
	  "Jenna",
	  "Jennifer",
	  "Jenny",
	  "Jessica",
	  "Jessy",
	  "Jette",
	  "Jil",
	  "Jill",
	  "Joana",
	  "Joanna",
	  "Joelina",
	  "Joeline",
	  "Joelle",
	  "Johanna",
	  "Joleen",
	  "Jolie",
	  "Jolien",
	  "Jolin",
	  "Jolina",
	  "Joline",
	  "Jona",
	  "Jonah",
	  "Jonna",
	  "Josefin",
	  "Josefine",
	  "Josephin",
	  "Josephine",
	  "Josie",
	  "Josy",
	  "Joy",
	  "Joyce",
	  "Judith",
	  "Judy",
	  "Jule",
	  "Julia",
	  "Juliana",
	  "Juliane",
	  "Julie",
	  "Julienne",
	  "Julika",
	  "Julina",
	  "Juna",
	  "Justine",
	  "Kaja",
	  "Karina",
	  "Karla",
	  "Karlotta",
	  "Karolina",
	  "Karoline",
	  "Kassandra",
	  "Katarina",
	  "Katharina",
	  "Kathrin",
	  "Katja",
	  "Katrin",
	  "Kaya",
	  "Kayra",
	  "Kiana",
	  "Kiara",
	  "Kim",
	  "Kimberley",
	  "Kimberly",
	  "Kira",
	  "Klara",
	  "Korinna",
	  "Kristin",
	  "Kyra",
	  "Laila",
	  "Lana",
	  "Lara",
	  "Larissa",
	  "Laura",
	  "Laureen",
	  "Lavinia",
	  "Lea",
	  "Leah",
	  "Leana",
	  "Leandra",
	  "Leann",
	  "Lee",
	  "Leila",
	  "Lena",
	  "Lene",
	  "Leni",
	  "Lenia",
	  "Lenja",
	  "Lenya",
	  "Leona",
	  "Leoni",
	  "Leonie",
	  "Leonora",
	  "Leticia",
	  "Letizia",
	  "Levke",
	  "Leyla",
	  "Lia",
	  "Liah",
	  "Liana",
	  "Lili",
	  "Lilia",
	  "Lilian",
	  "Liliana",
	  "Lilith",
	  "Lilli",
	  "Lillian",
	  "Lilly",
	  "Lily",
	  "Lina",
	  "Linda",
	  "Lindsay",
	  "Line",
	  "Linn",
	  "Linnea",
	  "Lisa",
	  "Lisann",
	  "Lisanne",
	  "Liv",
	  "Livia",
	  "Liz",
	  "Lola",
	  "Loreen",
	  "Lorena",
	  "Lotta",
	  "Lotte",
	  "Louisa",
	  "Louise",
	  "Luana",
	  "Luca",
	  "Lucia",
	  "Lucie",
	  "Lucienne",
	  "Lucy",
	  "Luisa",
	  "Luise",
	  "Luka",
	  "Luna",
	  "Luzie",
	  "Lya",
	  "Lydia",
	  "Lyn",
	  "Lynn",
	  "Madeleine",
	  "Madita",
	  "Madleen",
	  "Madlen",
	  "Magdalena",
	  "Maike",
	  "Mailin",
	  "Maira",
	  "Maja",
	  "Malena",
	  "Malia",
	  "Malin",
	  "Malina",
	  "Mandy",
	  "Mara",
	  "Marah",
	  "Mareike",
	  "Maren",
	  "Maria",
	  "Mariam",
	  "Marie",
	  "Marieke",
	  "Mariella",
	  "Marika",
	  "Marina",
	  "Marisa",
	  "Marissa",
	  "Marit",
	  "Marla",
	  "Marleen",
	  "Marlen",
	  "Marlena",
	  "Marlene",
	  "Marta",
	  "Martha",
	  "Mary",
	  "Maryam",
	  "Mathilda",
	  "Mathilde",
	  "Matilda",
	  "Maxi",
	  "Maxima",
	  "Maxine",
	  "Maya",
	  "Mayra",
	  "Medina",
	  "Medine",
	  "Meike",
	  "Melanie",
	  "Melek",
	  "Melike",
	  "Melina",
	  "Melinda",
	  "Melis",
	  "Melisa",
	  "Melissa",
	  "Merle",
	  "Merve",
	  "Meryem",
	  "Mette",
	  "Mia",
	  "Michaela",
	  "Michelle",
	  "Mieke",
	  "Mila",
	  "Milana",
	  "Milena",
	  "Milla",
	  "Mina",
	  "Mira",
	  "Miray",
	  "Miriam",
	  "Mirja",
	  "Mona",
	  "Monique",
	  "Nadine",
	  "Nadja",
	  "Naemi",
	  "Nancy",
	  "Naomi",
	  "Natalia",
	  "Natalie",
	  "Nathalie",
	  "Neele",
	  "Nela",
	  "Nele",
	  "Nelli",
	  "Nelly",
	  "Nia",
	  "Nicole",
	  "Nika",
	  "Nike",
	  "Nikita",
	  "Nila",
	  "Nina",
	  "Nisa",
	  "Noemi",
	  "Nora",
	  "Olivia",
	  "Patricia",
	  "Patrizia",
	  "Paula",
	  "Paulina",
	  "Pauline",
	  "Penelope",
	  "Philine",
	  "Phoebe",
	  "Pia",
	  "Rahel",
	  "Rania",
	  "Rebecca",
	  "Rebekka",
	  "Riana",
	  "Rieke",
	  "Rike",
	  "Romina",
	  "Romy",
	  "Ronja",
	  "Rosa",
	  "Rosalie",
	  "Ruby",
	  "Sabrina",
	  "Sahra",
	  "Sally",
	  "Salome",
	  "Samantha",
	  "Samia",
	  "Samira",
	  "Sandra",
	  "Sandy",
	  "Sanja",
	  "Saphira",
	  "Sara",
	  "Sarah",
	  "Saskia",
	  "Selin",
	  "Selina",
	  "Selma",
	  "Sena",
	  "Sidney",
	  "Sienna",
	  "Silja",
	  "Sina",
	  "Sinja",
	  "Smilla",
	  "Sofia",
	  "Sofie",
	  "Sonja",
	  "Sophia",
	  "Sophie",
	  "Soraya",
	  "Stefanie",
	  "Stella",
	  "Stephanie",
	  "Stina",
	  "Sude",
	  "Summer",
	  "Susanne",
	  "Svea",
	  "Svenja",
	  "Sydney",
	  "Tabea",
	  "Talea",
	  "Talia",
	  "Tamara",
	  "Tamia",
	  "Tamina",
	  "Tanja",
	  "Tara",
	  "Tarja",
	  "Teresa",
	  "Tessa",
	  "Thalea",
	  "Thalia",
	  "Thea",
	  "Theresa",
	  "Tia",
	  "Tina",
	  "Tomke",
	  "Tuana",
	  "Valentina",
	  "Valeria",
	  "Valerie",
	  "Vanessa",
	  "Vera",
	  "Veronika",
	  "Victoria",
	  "Viktoria",
	  "Viola",
	  "Vivian",
	  "Vivien",
	  "Vivienne",
	  "Wibke",
	  "Wiebke",
	  "Xenia",
	  "Yara",
	  "Yaren",
	  "Yasmin",
	  "Ylvi",
	  "Ylvie",
	  "Yvonne",
	  "Zara",
	  "Zehra",
	  "Zeynep",
	  "Zoe",
	  "Zoey",
	  "Zoé"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(785);
	name.last_name = __webpack_require__(787);
	name.prefix = __webpack_require__(790);
	name.nobility_title_prefix = __webpack_require__(789);
	name.name = __webpack_require__(788);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abel",
	  "Abicht",
	  "Abraham",
	  "Abramovic",
	  "Abt",
	  "Achilles",
	  "Achkinadze",
	  "Ackermann",
	  "Adam",
	  "Adams",
	  "Ade",
	  "Agostini",
	  "Ahlke",
	  "Ahrenberg",
	  "Ahrens",
	  "Aigner",
	  "Albert",
	  "Albrecht",
	  "Alexa",
	  "Alexander",
	  "Alizadeh",
	  "Allgeyer",
	  "Amann",
	  "Amberg",
	  "Anding",
	  "Anggreny",
	  "Apitz",
	  "Arendt",
	  "Arens",
	  "Arndt",
	  "Aryee",
	  "Aschenbroich",
	  "Assmus",
	  "Astafei",
	  "Auer",
	  "Axmann",
	  "Baarck",
	  "Bachmann",
	  "Badane",
	  "Bader",
	  "Baganz",
	  "Bahl",
	  "Bak",
	  "Balcer",
	  "Balck",
	  "Balkow",
	  "Balnuweit",
	  "Balzer",
	  "Banse",
	  "Barr",
	  "Bartels",
	  "Barth",
	  "Barylla",
	  "Baseda",
	  "Battke",
	  "Bauer",
	  "Bauermeister",
	  "Baumann",
	  "Baumeister",
	  "Bauschinger",
	  "Bauschke",
	  "Bayer",
	  "Beavogui",
	  "Beck",
	  "Beckel",
	  "Becker",
	  "Beckmann",
	  "Bedewitz",
	  "Beele",
	  "Beer",
	  "Beggerow",
	  "Beh",
	  "Behr",
	  "Behrenbruch",
	  "Belz",
	  "Bender",
	  "Benecke",
	  "Benner",
	  "Benninger",
	  "Benzing",
	  "Berends",
	  "Berger",
	  "Berner",
	  "Berning",
	  "Bertenbreiter",
	  "Best",
	  "Bethke",
	  "Betz",
	  "Beushausen",
	  "Beutelspacher",
	  "Beyer",
	  "Biba",
	  "Bichler",
	  "Bickel",
	  "Biedermann",
	  "Bieler",
	  "Bielert",
	  "Bienasch",
	  "Bienias",
	  "Biesenbach",
	  "Bigdeli",
	  "Birkemeyer",
	  "Bittner",
	  "Blank",
	  "Blaschek",
	  "Blassneck",
	  "Bloch",
	  "Blochwitz",
	  "Blockhaus",
	  "Blum",
	  "Blume",
	  "Bock",
	  "Bode",
	  "Bogdashin",
	  "Bogenrieder",
	  "Bohge",
	  "Bolm",
	  "Borgschulze",
	  "Bork",
	  "Bormann",
	  "Bornscheuer",
	  "Borrmann",
	  "Borsch",
	  "Boruschewski",
	  "Bos",
	  "Bosler",
	  "Bourrouag",
	  "Bouschen",
	  "Boxhammer",
	  "Boyde",
	  "Bozsik",
	  "Brand",
	  "Brandenburg",
	  "Brandis",
	  "Brandt",
	  "Brauer",
	  "Braun",
	  "Brehmer",
	  "Breitenstein",
	  "Bremer",
	  "Bremser",
	  "Brenner",
	  "Brettschneider",
	  "Breu",
	  "Breuer",
	  "Briesenick",
	  "Bringmann",
	  "Brinkmann",
	  "Brix",
	  "Broening",
	  "Brosch",
	  "Bruckmann",
	  "Bruder",
	  "Bruhns",
	  "Brunner",
	  "Bruns",
	  "Bräutigam",
	  "Brömme",
	  "Brüggmann",
	  "Buchholz",
	  "Buchrucker",
	  "Buder",
	  "Bultmann",
	  "Bunjes",
	  "Burger",
	  "Burghagen",
	  "Burkhard",
	  "Burkhardt",
	  "Burmeister",
	  "Busch",
	  "Buschbaum",
	  "Busemann",
	  "Buss",
	  "Busse",
	  "Bussmann",
	  "Byrd",
	  "Bäcker",
	  "Böhm",
	  "Bönisch",
	  "Börgeling",
	  "Börner",
	  "Böttner",
	  "Büchele",
	  "Bühler",
	  "Büker",
	  "Büngener",
	  "Bürger",
	  "Bürklein",
	  "Büscher",
	  "Büttner",
	  "Camara",
	  "Carlowitz",
	  "Carlsohn",
	  "Caspari",
	  "Caspers",
	  "Chapron",
	  "Christ",
	  "Cierpinski",
	  "Clarius",
	  "Cleem",
	  "Cleve",
	  "Co",
	  "Conrad",
	  "Cordes",
	  "Cornelsen",
	  "Cors",
	  "Cotthardt",
	  "Crews",
	  "Cronjäger",
	  "Crosskofp",
	  "Da",
	  "Dahm",
	  "Dahmen",
	  "Daimer",
	  "Damaske",
	  "Danneberg",
	  "Danner",
	  "Daub",
	  "Daubner",
	  "Daudrich",
	  "Dauer",
	  "Daum",
	  "Dauth",
	  "Dautzenberg",
	  "De",
	  "Decker",
	  "Deckert",
	  "Deerberg",
	  "Dehmel",
	  "Deja",
	  "Delonge",
	  "Demut",
	  "Dengler",
	  "Denner",
	  "Denzinger",
	  "Derr",
	  "Dertmann",
	  "Dethloff",
	  "Deuschle",
	  "Dieckmann",
	  "Diedrich",
	  "Diekmann",
	  "Dienel",
	  "Dies",
	  "Dietrich",
	  "Dietz",
	  "Dietzsch",
	  "Diezel",
	  "Dilla",
	  "Dingelstedt",
	  "Dippl",
	  "Dittmann",
	  "Dittmar",
	  "Dittmer",
	  "Dix",
	  "Dobbrunz",
	  "Dobler",
	  "Dohring",
	  "Dolch",
	  "Dold",
	  "Dombrowski",
	  "Donie",
	  "Doskoczynski",
	  "Dragu",
	  "Drechsler",
	  "Drees",
	  "Dreher",
	  "Dreier",
	  "Dreissigacker",
	  "Dressler",
	  "Drews",
	  "Duma",
	  "Dutkiewicz",
	  "Dyett",
	  "Dylus",
	  "Dächert",
	  "Döbel",
	  "Döring",
	  "Dörner",
	  "Dörre",
	  "Dück",
	  "Eberhard",
	  "Eberhardt",
	  "Ecker",
	  "Eckhardt",
	  "Edorh",
	  "Effler",
	  "Eggenmueller",
	  "Ehm",
	  "Ehmann",
	  "Ehrig",
	  "Eich",
	  "Eichmann",
	  "Eifert",
	  "Einert",
	  "Eisenlauer",
	  "Ekpo",
	  "Elbe",
	  "Eleyth",
	  "Elss",
	  "Emert",
	  "Emmelmann",
	  "Ender",
	  "Engel",
	  "Engelen",
	  "Engelmann",
	  "Eplinius",
	  "Erdmann",
	  "Erhardt",
	  "Erlei",
	  "Erm",
	  "Ernst",
	  "Ertl",
	  "Erwes",
	  "Esenwein",
	  "Esser",
	  "Evers",
	  "Everts",
	  "Ewald",
	  "Fahner",
	  "Faller",
	  "Falter",
	  "Farber",
	  "Fassbender",
	  "Faulhaber",
	  "Fehrig",
	  "Feld",
	  "Felke",
	  "Feller",
	  "Fenner",
	  "Fenske",
	  "Feuerbach",
	  "Fietz",
	  "Figl",
	  "Figura",
	  "Filipowski",
	  "Filsinger",
	  "Fincke",
	  "Fink",
	  "Finke",
	  "Fischer",
	  "Fitschen",
	  "Fleischer",
	  "Fleischmann",
	  "Floder",
	  "Florczak",
	  "Flore",
	  "Flottmann",
	  "Forkel",
	  "Forst",
	  "Frahmeke",
	  "Frank",
	  "Franke",
	  "Franta",
	  "Frantz",
	  "Franz",
	  "Franzis",
	  "Franzmann",
	  "Frauen",
	  "Frauendorf",
	  "Freigang",
	  "Freimann",
	  "Freimuth",
	  "Freisen",
	  "Frenzel",
	  "Frey",
	  "Fricke",
	  "Fried",
	  "Friedek",
	  "Friedenberg",
	  "Friedmann",
	  "Friedrich",
	  "Friess",
	  "Frisch",
	  "Frohn",
	  "Frosch",
	  "Fuchs",
	  "Fuhlbrügge",
	  "Fusenig",
	  "Fust",
	  "Förster",
	  "Gaba",
	  "Gabius",
	  "Gabler",
	  "Gadschiew",
	  "Gakstädter",
	  "Galander",
	  "Gamlin",
	  "Gamper",
	  "Gangnus",
	  "Ganzmann",
	  "Garatva",
	  "Gast",
	  "Gastel",
	  "Gatzka",
	  "Gauder",
	  "Gebhardt",
	  "Geese",
	  "Gehre",
	  "Gehrig",
	  "Gehring",
	  "Gehrke",
	  "Geiger",
	  "Geisler",
	  "Geissler",
	  "Gelling",
	  "Gens",
	  "Gerbennow",
	  "Gerdel",
	  "Gerhardt",
	  "Gerschler",
	  "Gerson",
	  "Gesell",
	  "Geyer",
	  "Ghirmai",
	  "Ghosh",
	  "Giehl",
	  "Gierisch",
	  "Giesa",
	  "Giesche",
	  "Gilde",
	  "Glatting",
	  "Goebel",
	  "Goedicke",
	  "Goldbeck",
	  "Goldfuss",
	  "Goldkamp",
	  "Goldkühle",
	  "Goller",
	  "Golling",
	  "Gollnow",
	  "Golomski",
	  "Gombert",
	  "Gotthardt",
	  "Gottschalk",
	  "Gotz",
	  "Goy",
	  "Gradzki",
	  "Graf",
	  "Grams",
	  "Grasse",
	  "Gratzky",
	  "Grau",
	  "Greb",
	  "Green",
	  "Greger",
	  "Greithanner",
	  "Greschner",
	  "Griem",
	  "Griese",
	  "Grimm",
	  "Gromisch",
	  "Gross",
	  "Grosser",
	  "Grossheim",
	  "Grosskopf",
	  "Grothaus",
	  "Grothkopp",
	  "Grotke",
	  "Grube",
	  "Gruber",
	  "Grundmann",
	  "Gruning",
	  "Gruszecki",
	  "Gröss",
	  "Grötzinger",
	  "Grün",
	  "Grüner",
	  "Gummelt",
	  "Gunkel",
	  "Gunther",
	  "Gutjahr",
	  "Gutowicz",
	  "Gutschank",
	  "Göbel",
	  "Göckeritz",
	  "Göhler",
	  "Görlich",
	  "Görmer",
	  "Götz",
	  "Götzelmann",
	  "Güldemeister",
	  "Günther",
	  "Günz",
	  "Gürbig",
	  "Haack",
	  "Haaf",
	  "Habel",
	  "Hache",
	  "Hackbusch",
	  "Hackelbusch",
	  "Hadfield",
	  "Hadwich",
	  "Haferkamp",
	  "Hahn",
	  "Hajek",
	  "Hallmann",
	  "Hamann",
	  "Hanenberger",
	  "Hannecker",
	  "Hanniske",
	  "Hansen",
	  "Hardy",
	  "Hargasser",
	  "Harms",
	  "Harnapp",
	  "Harter",
	  "Harting",
	  "Hartlieb",
	  "Hartmann",
	  "Hartwig",
	  "Hartz",
	  "Haschke",
	  "Hasler",
	  "Hasse",
	  "Hassfeld",
	  "Haug",
	  "Hauke",
	  "Haupt",
	  "Haverney",
	  "Heberstreit",
	  "Hechler",
	  "Hecht",
	  "Heck",
	  "Hedermann",
	  "Hehl",
	  "Heidelmann",
	  "Heidler",
	  "Heinemann",
	  "Heinig",
	  "Heinke",
	  "Heinrich",
	  "Heinze",
	  "Heiser",
	  "Heist",
	  "Hellmann",
	  "Helm",
	  "Helmke",
	  "Helpling",
	  "Hengmith",
	  "Henkel",
	  "Hennes",
	  "Henry",
	  "Hense",
	  "Hensel",
	  "Hentel",
	  "Hentschel",
	  "Hentschke",
	  "Hepperle",
	  "Herberger",
	  "Herbrand",
	  "Hering",
	  "Hermann",
	  "Hermecke",
	  "Herms",
	  "Herold",
	  "Herrmann",
	  "Herschmann",
	  "Hertel",
	  "Herweg",
	  "Herwig",
	  "Herzenberg",
	  "Hess",
	  "Hesse",
	  "Hessek",
	  "Hessler",
	  "Hetzler",
	  "Heuck",
	  "Heydemüller",
	  "Hiebl",
	  "Hildebrand",
	  "Hildenbrand",
	  "Hilgendorf",
	  "Hillard",
	  "Hiller",
	  "Hingsen",
	  "Hingst",
	  "Hinrichs",
	  "Hirsch",
	  "Hirschberg",
	  "Hirt",
	  "Hodea",
	  "Hoffman",
	  "Hoffmann",
	  "Hofmann",
	  "Hohenberger",
	  "Hohl",
	  "Hohn",
	  "Hohnheiser",
	  "Hold",
	  "Holdt",
	  "Holinski",
	  "Holl",
	  "Holtfreter",
	  "Holz",
	  "Holzdeppe",
	  "Holzner",
	  "Hommel",
	  "Honz",
	  "Hooss",
	  "Hoppe",
	  "Horak",
	  "Horn",
	  "Horna",
	  "Hornung",
	  "Hort",
	  "Howard",
	  "Huber",
	  "Huckestein",
	  "Hudak",
	  "Huebel",
	  "Hugo",
	  "Huhn",
	  "Hujo",
	  "Huke",
	  "Huls",
	  "Humbert",
	  "Huneke",
	  "Huth",
	  "Häber",
	  "Häfner",
	  "Höcke",
	  "Höft",
	  "Höhne",
	  "Hönig",
	  "Hördt",
	  "Hübenbecker",
	  "Hübl",
	  "Hübner",
	  "Hügel",
	  "Hüttcher",
	  "Hütter",
	  "Ibe",
	  "Ihly",
	  "Illing",
	  "Isak",
	  "Isekenmeier",
	  "Itt",
	  "Jacob",
	  "Jacobs",
	  "Jagusch",
	  "Jahn",
	  "Jahnke",
	  "Jakobs",
	  "Jakubczyk",
	  "Jambor",
	  "Jamrozy",
	  "Jander",
	  "Janich",
	  "Janke",
	  "Jansen",
	  "Jarets",
	  "Jaros",
	  "Jasinski",
	  "Jasper",
	  "Jegorov",
	  "Jellinghaus",
	  "Jeorga",
	  "Jerschabek",
	  "Jess",
	  "John",
	  "Jonas",
	  "Jossa",
	  "Jucken",
	  "Jung",
	  "Jungbluth",
	  "Jungton",
	  "Just",
	  "Jürgens",
	  "Kaczmarek",
	  "Kaesmacher",
	  "Kahl",
	  "Kahlert",
	  "Kahles",
	  "Kahlmeyer",
	  "Kaiser",
	  "Kalinowski",
	  "Kallabis",
	  "Kallensee",
	  "Kampf",
	  "Kampschulte",
	  "Kappe",
	  "Kappler",
	  "Karhoff",
	  "Karrass",
	  "Karst",
	  "Karsten",
	  "Karus",
	  "Kass",
	  "Kasten",
	  "Kastner",
	  "Katzinski",
	  "Kaufmann",
	  "Kaul",
	  "Kausemann",
	  "Kawohl",
	  "Kazmarek",
	  "Kedzierski",
	  "Keil",
	  "Keiner",
	  "Keller",
	  "Kelm",
	  "Kempe",
	  "Kemper",
	  "Kempter",
	  "Kerl",
	  "Kern",
	  "Kesselring",
	  "Kesselschläger",
	  "Kette",
	  "Kettenis",
	  "Keutel",
	  "Kick",
	  "Kiessling",
	  "Kinadeter",
	  "Kinzel",
	  "Kinzy",
	  "Kirch",
	  "Kirst",
	  "Kisabaka",
	  "Klaas",
	  "Klabuhn",
	  "Klapper",
	  "Klauder",
	  "Klaus",
	  "Kleeberg",
	  "Kleiber",
	  "Klein",
	  "Kleinert",
	  "Kleininger",
	  "Kleinmann",
	  "Kleinsteuber",
	  "Kleiss",
	  "Klemme",
	  "Klimczak",
	  "Klinger",
	  "Klink",
	  "Klopsch",
	  "Klose",
	  "Kloss",
	  "Kluge",
	  "Kluwe",
	  "Knabe",
	  "Kneifel",
	  "Knetsch",
	  "Knies",
	  "Knippel",
	  "Knobel",
	  "Knoblich",
	  "Knoll",
	  "Knorr",
	  "Knorscheidt",
	  "Knut",
	  "Kobs",
	  "Koch",
	  "Kochan",
	  "Kock",
	  "Koczulla",
	  "Koderisch",
	  "Koehl",
	  "Koehler",
	  "Koenig",
	  "Koester",
	  "Kofferschlager",
	  "Koha",
	  "Kohle",
	  "Kohlmann",
	  "Kohnle",
	  "Kohrt",
	  "Koj",
	  "Kolb",
	  "Koleiski",
	  "Kolokas",
	  "Komoll",
	  "Konieczny",
	  "Konig",
	  "Konow",
	  "Konya",
	  "Koob",
	  "Kopf",
	  "Kosenkow",
	  "Koster",
	  "Koszewski",
	  "Koubaa",
	  "Kovacs",
	  "Kowalick",
	  "Kowalinski",
	  "Kozakiewicz",
	  "Krabbe",
	  "Kraft",
	  "Kral",
	  "Kramer",
	  "Krauel",
	  "Kraus",
	  "Krause",
	  "Krauspe",
	  "Kreb",
	  "Krebs",
	  "Kreissig",
	  "Kresse",
	  "Kreutz",
	  "Krieger",
	  "Krippner",
	  "Krodinger",
	  "Krohn",
	  "Krol",
	  "Kron",
	  "Krueger",
	  "Krug",
	  "Kruger",
	  "Krull",
	  "Kruschinski",
	  "Krämer",
	  "Kröckert",
	  "Kröger",
	  "Krüger",
	  "Kubera",
	  "Kufahl",
	  "Kuhlee",
	  "Kuhnen",
	  "Kulimann",
	  "Kulma",
	  "Kumbernuss",
	  "Kummle",
	  "Kunz",
	  "Kupfer",
	  "Kupprion",
	  "Kuprion",
	  "Kurnicki",
	  "Kurrat",
	  "Kurschilgen",
	  "Kuschewitz",
	  "Kuschmann",
	  "Kuske",
	  "Kustermann",
	  "Kutscherauer",
	  "Kutzner",
	  "Kwadwo",
	  "Kähler",
	  "Käther",
	  "Köhler",
	  "Köhrbrück",
	  "Köhre",
	  "Kölotzei",
	  "König",
	  "Köpernick",
	  "Köseoglu",
	  "Kúhn",
	  "Kúhnert",
	  "Kühn",
	  "Kühnel",
	  "Kühnemund",
	  "Kühnert",
	  "Kühnke",
	  "Küsters",
	  "Küter",
	  "Laack",
	  "Lack",
	  "Ladewig",
	  "Lakomy",
	  "Lammert",
	  "Lamos",
	  "Landmann",
	  "Lang",
	  "Lange",
	  "Langfeld",
	  "Langhirt",
	  "Lanig",
	  "Lauckner",
	  "Lauinger",
	  "Laurén",
	  "Lausecker",
	  "Laux",
	  "Laws",
	  "Lax",
	  "Leberer",
	  "Lehmann",
	  "Lehner",
	  "Leibold",
	  "Leide",
	  "Leimbach",
	  "Leipold",
	  "Leist",
	  "Leiter",
	  "Leiteritz",
	  "Leitheim",
	  "Leiwesmeier",
	  "Lenfers",
	  "Lenk",
	  "Lenz",
	  "Lenzen",
	  "Leo",
	  "Lepthin",
	  "Lesch",
	  "Leschnik",
	  "Letzelter",
	  "Lewin",
	  "Lewke",
	  "Leyckes",
	  "Lg",
	  "Lichtenfeld",
	  "Lichtenhagen",
	  "Lichtl",
	  "Liebach",
	  "Liebe",
	  "Liebich",
	  "Liebold",
	  "Lieder",
	  "Lienshöft",
	  "Linden",
	  "Lindenberg",
	  "Lindenmayer",
	  "Lindner",
	  "Linke",
	  "Linnenbaum",
	  "Lippe",
	  "Lipske",
	  "Lipus",
	  "Lischka",
	  "Lobinger",
	  "Logsch",
	  "Lohmann",
	  "Lohre",
	  "Lohse",
	  "Lokar",
	  "Loogen",
	  "Lorenz",
	  "Losch",
	  "Loska",
	  "Lott",
	  "Loy",
	  "Lubina",
	  "Ludolf",
	  "Lufft",
	  "Lukoschek",
	  "Lutje",
	  "Lutz",
	  "Löser",
	  "Löwa",
	  "Lübke",
	  "Maak",
	  "Maczey",
	  "Madetzky",
	  "Madubuko",
	  "Mai",
	  "Maier",
	  "Maisch",
	  "Malek",
	  "Malkus",
	  "Mallmann",
	  "Malucha",
	  "Manns",
	  "Manz",
	  "Marahrens",
	  "Marchewski",
	  "Margis",
	  "Markowski",
	  "Marl",
	  "Marner",
	  "Marquart",
	  "Marschek",
	  "Martel",
	  "Marten",
	  "Martin",
	  "Marx",
	  "Marxen",
	  "Mathes",
	  "Mathies",
	  "Mathiszik",
	  "Matschke",
	  "Mattern",
	  "Matthes",
	  "Matula",
	  "Mau",
	  "Maurer",
	  "Mauroff",
	  "May",
	  "Maybach",
	  "Mayer",
	  "Mebold",
	  "Mehl",
	  "Mehlhorn",
	  "Mehlorn",
	  "Meier",
	  "Meisch",
	  "Meissner",
	  "Meloni",
	  "Melzer",
	  "Menga",
	  "Menne",
	  "Mensah",
	  "Mensing",
	  "Merkel",
	  "Merseburg",
	  "Mertens",
	  "Mesloh",
	  "Metzger",
	  "Metzner",
	  "Mewes",
	  "Meyer",
	  "Michallek",
	  "Michel",
	  "Mielke",
	  "Mikitenko",
	  "Milde",
	  "Minah",
	  "Mintzlaff",
	  "Mockenhaupt",
	  "Moede",
	  "Moedl",
	  "Moeller",
	  "Moguenara",
	  "Mohr",
	  "Mohrhard",
	  "Molitor",
	  "Moll",
	  "Moller",
	  "Molzan",
	  "Montag",
	  "Moormann",
	  "Mordhorst",
	  "Morgenstern",
	  "Morhelfer",
	  "Moritz",
	  "Moser",
	  "Motchebon",
	  "Motzenbbäcker",
	  "Mrugalla",
	  "Muckenthaler",
	  "Mues",
	  "Muller",
	  "Mulrain",
	  "Mächtig",
	  "Mäder",
	  "Möcks",
	  "Mögenburg",
	  "Möhsner",
	  "Möldner",
	  "Möllenbeck",
	  "Möller",
	  "Möllinger",
	  "Mörsch",
	  "Mühleis",
	  "Müller",
	  "Münch",
	  "Nabein",
	  "Nabow",
	  "Nagel",
	  "Nannen",
	  "Nastvogel",
	  "Nau",
	  "Naubert",
	  "Naumann",
	  "Ne",
	  "Neimke",
	  "Nerius",
	  "Neubauer",
	  "Neubert",
	  "Neuendorf",
	  "Neumair",
	  "Neumann",
	  "Neupert",
	  "Neurohr",
	  "Neuschwander",
	  "Newton",
	  "Ney",
	  "Nicolay",
	  "Niedermeier",
	  "Nieklauson",
	  "Niklaus",
	  "Nitzsche",
	  "Noack",
	  "Nodler",
	  "Nolte",
	  "Normann",
	  "Norris",
	  "Northoff",
	  "Nowak",
	  "Nussbeck",
	  "Nwachukwu",
	  "Nytra",
	  "Nöh",
	  "Oberem",
	  "Obergföll",
	  "Obermaier",
	  "Ochs",
	  "Oeser",
	  "Olbrich",
	  "Onnen",
	  "Ophey",
	  "Oppong",
	  "Orth",
	  "Orthmann",
	  "Oschkenat",
	  "Osei",
	  "Osenberg",
	  "Ostendarp",
	  "Ostwald",
	  "Otte",
	  "Otto",
	  "Paesler",
	  "Pajonk",
	  "Pallentin",
	  "Panzig",
	  "Paschke",
	  "Patzwahl",
	  "Paukner",
	  "Peselman",
	  "Peter",
	  "Peters",
	  "Petzold",
	  "Pfeiffer",
	  "Pfennig",
	  "Pfersich",
	  "Pfingsten",
	  "Pflieger",
	  "Pflügner",
	  "Philipp",
	  "Pichlmaier",
	  "Piesker",
	  "Pietsch",
	  "Pingpank",
	  "Pinnock",
	  "Pippig",
	  "Pitschugin",
	  "Plank",
	  "Plass",
	  "Platzer",
	  "Plauk",
	  "Plautz",
	  "Pletsch",
	  "Plotzitzka",
	  "Poehn",
	  "Poeschl",
	  "Pogorzelski",
	  "Pohl",
	  "Pohland",
	  "Pohle",
	  "Polifka",
	  "Polizzi",
	  "Pollmächer",
	  "Pomp",
	  "Ponitzsch",
	  "Porsche",
	  "Porth",
	  "Poschmann",
	  "Poser",
	  "Pottel",
	  "Prah",
	  "Prange",
	  "Prediger",
	  "Pressler",
	  "Preuk",
	  "Preuss",
	  "Prey",
	  "Priemer",
	  "Proske",
	  "Pusch",
	  "Pöche",
	  "Pöge",
	  "Raabe",
	  "Rabenstein",
	  "Rach",
	  "Radtke",
	  "Rahn",
	  "Ranftl",
	  "Rangen",
	  "Ranz",
	  "Rapp",
	  "Rath",
	  "Rau",
	  "Raubuch",
	  "Raukuc",
	  "Rautenkranz",
	  "Rehwagen",
	  "Reiber",
	  "Reichardt",
	  "Reichel",
	  "Reichling",
	  "Reif",
	  "Reifenrath",
	  "Reimann",
	  "Reinberg",
	  "Reinelt",
	  "Reinhardt",
	  "Reinke",
	  "Reitze",
	  "Renk",
	  "Rentz",
	  "Renz",
	  "Reppin",
	  "Restle",
	  "Restorff",
	  "Retzke",
	  "Reuber",
	  "Reumann",
	  "Reus",
	  "Reuss",
	  "Reusse",
	  "Rheder",
	  "Rhoden",
	  "Richards",
	  "Richter",
	  "Riedel",
	  "Riediger",
	  "Rieger",
	  "Riekmann",
	  "Riepl",
	  "Riermeier",
	  "Riester",
	  "Riethmüller",
	  "Rietmüller",
	  "Rietscher",
	  "Ringel",
	  "Ringer",
	  "Rink",
	  "Ripken",
	  "Ritosek",
	  "Ritschel",
	  "Ritter",
	  "Rittweg",
	  "Ritz",
	  "Roba",
	  "Rockmeier",
	  "Rodehau",
	  "Rodowski",
	  "Roecker",
	  "Roggatz",
	  "Rohländer",
	  "Rohrer",
	  "Rokossa",
	  "Roleder",
	  "Roloff",
	  "Roos",
	  "Rosbach",
	  "Roschinsky",
	  "Rose",
	  "Rosenauer",
	  "Rosenbauer",
	  "Rosenthal",
	  "Rosksch",
	  "Rossberg",
	  "Rossler",
	  "Roth",
	  "Rother",
	  "Ruch",
	  "Ruckdeschel",
	  "Rumpf",
	  "Rupprecht",
	  "Ruth",
	  "Ryjikh",
	  "Ryzih",
	  "Rädler",
	  "Räntsch",
	  "Rödiger",
	  "Röse",
	  "Röttger",
	  "Rücker",
	  "Rüdiger",
	  "Rüter",
	  "Sachse",
	  "Sack",
	  "Saflanis",
	  "Sagafe",
	  "Sagonas",
	  "Sahner",
	  "Saile",
	  "Sailer",
	  "Salow",
	  "Salzer",
	  "Salzmann",
	  "Sammert",
	  "Sander",
	  "Sarvari",
	  "Sattelmaier",
	  "Sauer",
	  "Sauerland",
	  "Saumweber",
	  "Savoia",
	  "Scc",
	  "Schacht",
	  "Schaefer",
	  "Schaffarzik",
	  "Schahbasian",
	  "Scharf",
	  "Schedler",
	  "Scheer",
	  "Schelk",
	  "Schellenbeck",
	  "Schembera",
	  "Schenk",
	  "Scherbarth",
	  "Scherer",
	  "Schersing",
	  "Scherz",
	  "Scheurer",
	  "Scheuring",
	  "Scheytt",
	  "Schielke",
	  "Schieskow",
	  "Schildhauer",
	  "Schilling",
	  "Schima",
	  "Schimmer",
	  "Schindzielorz",
	  "Schirmer",
	  "Schirrmeister",
	  "Schlachter",
	  "Schlangen",
	  "Schlawitz",
	  "Schlechtweg",
	  "Schley",
	  "Schlicht",
	  "Schlitzer",
	  "Schmalzle",
	  "Schmid",
	  "Schmidt",
	  "Schmidtchen",
	  "Schmitt",
	  "Schmitz",
	  "Schmuhl",
	  "Schneider",
	  "Schnelting",
	  "Schnieder",
	  "Schniedermeier",
	  "Schnürer",
	  "Schoberg",
	  "Scholz",
	  "Schonberg",
	  "Schondelmaier",
	  "Schorr",
	  "Schott",
	  "Schottmann",
	  "Schouren",
	  "Schrader",
	  "Schramm",
	  "Schreck",
	  "Schreiber",
	  "Schreiner",
	  "Schreiter",
	  "Schroder",
	  "Schröder",
	  "Schuermann",
	  "Schuff",
	  "Schuhaj",
	  "Schuldt",
	  "Schult",
	  "Schulte",
	  "Schultz",
	  "Schultze",
	  "Schulz",
	  "Schulze",
	  "Schumacher",
	  "Schumann",
	  "Schupp",
	  "Schuri",
	  "Schuster",
	  "Schwab",
	  "Schwalm",
	  "Schwanbeck",
	  "Schwandke",
	  "Schwanitz",
	  "Schwarthoff",
	  "Schwartz",
	  "Schwarz",
	  "Schwarzer",
	  "Schwarzkopf",
	  "Schwarzmeier",
	  "Schwatlo",
	  "Schweisfurth",
	  "Schwennen",
	  "Schwerdtner",
	  "Schwidde",
	  "Schwirkschlies",
	  "Schwuchow",
	  "Schäfer",
	  "Schäffel",
	  "Schäffer",
	  "Schäning",
	  "Schöckel",
	  "Schönball",
	  "Schönbeck",
	  "Schönberg",
	  "Schönebeck",
	  "Schönenberger",
	  "Schönfeld",
	  "Schönherr",
	  "Schönlebe",
	  "Schötz",
	  "Schüler",
	  "Schüppel",
	  "Schütz",
	  "Schütze",
	  "Seeger",
	  "Seelig",
	  "Sehls",
	  "Seibold",
	  "Seidel",
	  "Seiders",
	  "Seigel",
	  "Seiler",
	  "Seitz",
	  "Semisch",
	  "Senkel",
	  "Sewald",
	  "Siebel",
	  "Siebert",
	  "Siegling",
	  "Sielemann",
	  "Siemon",
	  "Siener",
	  "Sievers",
	  "Siewert",
	  "Sihler",
	  "Sillah",
	  "Simon",
	  "Sinnhuber",
	  "Sischka",
	  "Skibicki",
	  "Sladek",
	  "Slotta",
	  "Smieja",
	  "Soboll",
	  "Sokolowski",
	  "Soller",
	  "Sollner",
	  "Sommer",
	  "Somssich",
	  "Sonn",
	  "Sonnabend",
	  "Spahn",
	  "Spank",
	  "Spelmeyer",
	  "Spiegelburg",
	  "Spielvogel",
	  "Spinner",
	  "Spitzmüller",
	  "Splinter",
	  "Sporrer",
	  "Sprenger",
	  "Spöttel",
	  "Stahl",
	  "Stang",
	  "Stanger",
	  "Stauss",
	  "Steding",
	  "Steffen",
	  "Steffny",
	  "Steidl",
	  "Steigauf",
	  "Stein",
	  "Steinecke",
	  "Steinert",
	  "Steinkamp",
	  "Steinmetz",
	  "Stelkens",
	  "Stengel",
	  "Stengl",
	  "Stenzel",
	  "Stepanov",
	  "Stephan",
	  "Stern",
	  "Steuk",
	  "Stief",
	  "Stifel",
	  "Stoll",
	  "Stolle",
	  "Stolz",
	  "Storl",
	  "Storp",
	  "Stoutjesdijk",
	  "Stratmann",
	  "Straub",
	  "Strausa",
	  "Streck",
	  "Streese",
	  "Strege",
	  "Streit",
	  "Streller",
	  "Strieder",
	  "Striezel",
	  "Strogies",
	  "Strohschank",
	  "Strunz",
	  "Strutz",
	  "Stube",
	  "Stöckert",
	  "Stöppler",
	  "Stöwer",
	  "Stürmer",
	  "Suffa",
	  "Sujew",
	  "Sussmann",
	  "Suthe",
	  "Sutschet",
	  "Swillims",
	  "Szendrei",
	  "Sören",
	  "Sürth",
	  "Tafelmeier",
	  "Tang",
	  "Tasche",
	  "Taufratshofer",
	  "Tegethof",
	  "Teichmann",
	  "Tepper",
	  "Terheiden",
	  "Terlecki",
	  "Teufel",
	  "Theele",
	  "Thieke",
	  "Thimm",
	  "Thiomas",
	  "Thomas",
	  "Thriene",
	  "Thränhardt",
	  "Thust",
	  "Thyssen",
	  "Thöne",
	  "Tidow",
	  "Tiedtke",
	  "Tietze",
	  "Tilgner",
	  "Tillack",
	  "Timmermann",
	  "Tischler",
	  "Tischmann",
	  "Tittman",
	  "Tivontschik",
	  "Tonat",
	  "Tonn",
	  "Trampeli",
	  "Trauth",
	  "Trautmann",
	  "Travan",
	  "Treff",
	  "Tremmel",
	  "Tress",
	  "Tsamonikian",
	  "Tschiers",
	  "Tschirch",
	  "Tuch",
	  "Tucholke",
	  "Tudow",
	  "Tuschmo",
	  "Tächl",
	  "Többen",
	  "Töpfer",
	  "Uhlemann",
	  "Uhlig",
	  "Uhrig",
	  "Uibel",
	  "Uliczka",
	  "Ullmann",
	  "Ullrich",
	  "Umbach",
	  "Umlauft",
	  "Umminger",
	  "Unger",
	  "Unterpaintner",
	  "Urban",
	  "Urbaniak",
	  "Urbansky",
	  "Urhig",
	  "Vahlensieck",
	  "Van",
	  "Vangermain",
	  "Vater",
	  "Venghaus",
	  "Verniest",
	  "Verzi",
	  "Vey",
	  "Viellehner",
	  "Vieweg",
	  "Voelkel",
	  "Vogel",
	  "Vogelgsang",
	  "Vogt",
	  "Voigt",
	  "Vokuhl",
	  "Volk",
	  "Volker",
	  "Volkmann",
	  "Von",
	  "Vona",
	  "Vontein",
	  "Wachenbrunner",
	  "Wachtel",
	  "Wagner",
	  "Waibel",
	  "Wakan",
	  "Waldmann",
	  "Wallner",
	  "Wallstab",
	  "Walter",
	  "Walther",
	  "Walton",
	  "Walz",
	  "Wanner",
	  "Wartenberg",
	  "Waschbüsch",
	  "Wassilew",
	  "Wassiluk",
	  "Weber",
	  "Wehrsen",
	  "Weidlich",
	  "Weidner",
	  "Weigel",
	  "Weight",
	  "Weiler",
	  "Weimer",
	  "Weis",
	  "Weiss",
	  "Weller",
	  "Welsch",
	  "Welz",
	  "Welzel",
	  "Weniger",
	  "Wenk",
	  "Werle",
	  "Werner",
	  "Werrmann",
	  "Wessel",
	  "Wessinghage",
	  "Weyel",
	  "Wezel",
	  "Wichmann",
	  "Wickert",
	  "Wiebe",
	  "Wiechmann",
	  "Wiegelmann",
	  "Wierig",
	  "Wiese",
	  "Wieser",
	  "Wilhelm",
	  "Wilky",
	  "Will",
	  "Willwacher",
	  "Wilts",
	  "Wimmer",
	  "Winkelmann",
	  "Winkler",
	  "Winter",
	  "Wischek",
	  "Wischer",
	  "Wissing",
	  "Wittich",
	  "Wittl",
	  "Wolf",
	  "Wolfarth",
	  "Wolff",
	  "Wollenberg",
	  "Wollmann",
	  "Woytkowska",
	  "Wujak",
	  "Wurm",
	  "Wyludda",
	  "Wölpert",
	  "Wöschler",
	  "Wühn",
	  "Wünsche",
	  "Zach",
	  "Zaczkiewicz",
	  "Zahn",
	  "Zaituc",
	  "Zandt",
	  "Zanner",
	  "Zapletal",
	  "Zauber",
	  "Zeidler",
	  "Zekl",
	  "Zender",
	  "Zeuch",
	  "Zeyen",
	  "Zeyhle",
	  "Ziegler",
	  "Zimanyi",
	  "Zimmer",
	  "Zimmermann",
	  "Zinser",
	  "Zintl",
	  "Zipp",
	  "Zipse",
	  "Zschunke",
	  "Zuber",
	  "Zwiener",
	  "Zümsande",
	  "Östringer",
	  "Überacker"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{nobility_title_prefix} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "zu",
	  "von",
	  "vom",
	  "von der"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Hr.",
	  "Fr.",
	  "Dr.",
	  "Prof. Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(0###) #########",
	  "(0####) #######",
	  "+49-###-#######",
	  "+49-####-########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(791);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#",
	  "##a",
	  "##b",
	  "##c"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aigen im Mühlkreis",
	  "Allerheiligen bei Wildon",
	  "Altenfelden",
	  "Arriach",
	  "Axams",
	  "Baumgartenberg",
	  "Bergern im Dunkelsteinerwald",
	  "Berndorf bei Salzburg",
	  "Bregenz",
	  "Breitenbach am Inn",
	  "Deutsch-Wagram",
	  "Dienten am Hochkönig",
	  "Dietach",
	  "Dornbirn",
	  "Dürnkrut",
	  "Eben im Pongau",
	  "Ebenthal in Kärnten",
	  "Eichgraben",
	  "Eisenstadt",
	  "Ellmau",
	  "Feistritz am Wechsel",
	  "Finkenberg",
	  "Fiss",
	  "Frantschach-St. Gertraud",
	  "Fritzens",
	  "Gams bei Hieflau",
	  "Geiersberg",
	  "Graz",
	  "Großhöflein",
	  "Gößnitz",
	  "Hartl",
	  "Hausleiten",
	  "Herzogenburg",
	  "Hinterhornbach",
	  "Hochwolkersdorf",
	  "Ilz",
	  "Ilztal",
	  "Innerbraz",
	  "Innsbruck",
	  "Itter",
	  "Jagerberg",
	  "Jeging",
	  "Johnsbach",
	  "Johnsdorf-Brunn",
	  "Jungholz",
	  "Kirchdorf am Inn",
	  "Klagenfurt",
	  "Kottes-Purk",
	  "Krumau am Kamp",
	  "Krumbach",
	  "Lavamünd",
	  "Lech",
	  "Linz",
	  "Ludesch",
	  "Lödersdorf",
	  "Marbach an der Donau",
	  "Mattsee",
	  "Mautern an der Donau",
	  "Mauterndorf",
	  "Mitterbach am Erlaufsee",
	  "Neudorf bei Passail",
	  "Neudorf bei Staatz",
	  "Neukirchen an der Enknach",
	  "Neustift an der Lafnitz",
	  "Niederleis",
	  "Oberndorf in Tirol",
	  "Oberstorcha",
	  "Oberwaltersdorf",
	  "Oed-Oehling",
	  "Ort im Innkreis",
	  "Pilgersdorf",
	  "Pitschgau",
	  "Pollham",
	  "Preitenegg",
	  "Purbach am Neusiedler See",
	  "Rabenwald",
	  "Raiding",
	  "Rastenfeld",
	  "Ratten",
	  "Rettenegg",
	  "Salzburg",
	  "Sankt Johann im Saggautal",
	  "St. Peter am Kammersberg",
	  "St. Pölten",
	  "St. Veit an der Glan",
	  "Taxenbach",
	  "Tragwein",
	  "Trebesing",
	  "Trieben",
	  "Turnau",
	  "Ungerdorf",
	  "Unterauersbach",
	  "Unterstinkenbrunn",
	  "Untertilliach",
	  "Uttendorf",
	  "Vals",
	  "Velden am Wörther See",
	  "Viehhofen",
	  "Villach",
	  "Vitis",
	  "Waidhofen an der Thaya",
	  "Waldkirchen am Wesen",
	  "Weißkirchen an der Traun",
	  "Wien",
	  "Wimpassing im Schwarzatale",
	  "Ybbs an der Donau",
	  "Ybbsitz",
	  "Yspertal",
	  "Zeillern",
	  "Zell am Pettenfirst",
	  "Zell an der Pram",
	  "Zerlach",
	  "Zwölfaxing",
	  "Öblarn",
	  "Übelbach",
	  "Überackern",
	  "Übersaxen",
	  "Übersbach"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ägypten",
	  "Äquatorialguinea",
	  "Äthiopien",
	  "Österreich",
	  "Afghanistan",
	  "Albanien",
	  "Algerien",
	  "Amerikanisch-Samoa",
	  "Amerikanische Jungferninseln",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarktis",
	  "Antigua und Barbuda",
	  "Argentinien",
	  "Armenien",
	  "Aruba",
	  "Aserbaidschan",
	  "Australien",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesch",
	  "Barbados",
	  "Belarus",
	  "Belgien",
	  "Belize",
	  "Benin",
	  "die Bermudas",
	  "Bhutan",
	  "Bolivien",
	  "Bosnien und Herzegowina",
	  "Botsuana",
	  "Bouvetinsel",
	  "Brasilien",
	  "Britische Jungferninseln",
	  "Britisches Territorium im Indischen Ozean",
	  "Brunei Darussalam",
	  "Bulgarien",
	  "Burkina Faso",
	  "Burundi",
	  "Chile",
	  "China",
	  "Cookinseln",
	  "Costa Rica",
	  "Dänemark",
	  "Demokratische Republik Kongo",
	  "Demokratische Volksrepublik Korea",
	  "Deutschland",
	  "Dominica",
	  "Dominikanische Republik",
	  "Dschibuti",
	  "Ecuador",
	  "El Salvador",
	  "Eritrea",
	  "Estland",
	  "Färöer",
	  "Falklandinseln",
	  "Fidschi",
	  "Finnland",
	  "Frankreich",
	  "Französisch-Guayana",
	  "Französisch-Polynesien",
	  "Französische Gebiete im südlichen Indischen Ozean",
	  "Gabun",
	  "Gambia",
	  "Georgien",
	  "Ghana",
	  "Gibraltar",
	  "Grönland",
	  "Grenada",
	  "Griechenland",
	  "Guadeloupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard und McDonaldinseln",
	  "Honduras",
	  "Hongkong",
	  "Indien",
	  "Indonesien",
	  "Irak",
	  "Iran",
	  "Irland",
	  "Island",
	  "Israel",
	  "Italien",
	  "Jamaika",
	  "Japan",
	  "Jemen",
	  "Jordanien",
	  "Jugoslawien",
	  "Kaimaninseln",
	  "Kambodscha",
	  "Kamerun",
	  "Kanada",
	  "Kap Verde",
	  "Kasachstan",
	  "Katar",
	  "Kenia",
	  "Kirgisistan",
	  "Kiribati",
	  "Kleinere amerikanische Überseeinseln",
	  "Kokosinseln",
	  "Kolumbien",
	  "Komoren",
	  "Kongo",
	  "Kroatien",
	  "Kuba",
	  "Kuwait",
	  "Laos",
	  "Lesotho",
	  "Lettland",
	  "Libanon",
	  "Liberia",
	  "Libyen",
	  "Liechtenstein",
	  "Litauen",
	  "Luxemburg",
	  "Macau",
	  "Madagaskar",
	  "Malawi",
	  "Malaysia",
	  "Malediven",
	  "Mali",
	  "Malta",
	  "ehemalige jugoslawische Republik Mazedonien",
	  "Marokko",
	  "Marshallinseln",
	  "Martinique",
	  "Mauretanien",
	  "Mauritius",
	  "Mayotte",
	  "Mexiko",
	  "Mikronesien",
	  "Monaco",
	  "Mongolei",
	  "Montserrat",
	  "Mosambik",
	  "Myanmar",
	  "Nördliche Marianen",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Neukaledonien",
	  "Neuseeland",
	  "Nicaragua",
	  "Niederländische Antillen",
	  "Niederlande",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Norfolkinsel",
	  "Norwegen",
	  "Oman",
	  "Osttimor",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papua-Neuguinea",
	  "Paraguay",
	  "Peru",
	  "Philippinen",
	  "Pitcairninseln",
	  "Polen",
	  "Portugal",
	  "Puerto Rico",
	  "Réunion",
	  "Republik Korea",
	  "Republik Moldau",
	  "Ruanda",
	  "Rumänien",
	  "Russische Föderation",
	  "São Tomé und Príncipe",
	  "Südafrika",
	  "Südgeorgien und Südliche Sandwichinseln",
	  "Salomonen",
	  "Sambia",
	  "Samoa",
	  "San Marino",
	  "Saudi-Arabien",
	  "Schweden",
	  "Schweiz",
	  "Senegal",
	  "Seychellen",
	  "Sierra Leone",
	  "Simbabwe",
	  "Singapur",
	  "Slowakei",
	  "Slowenien",
	  "Somalien",
	  "Spanien",
	  "Sri Lanka",
	  "St. Helena",
	  "St. Kitts und Nevis",
	  "St. Lucia",
	  "St. Pierre und Miquelon",
	  "St. Vincent und die Grenadinen",
	  "Sudan",
	  "Surinam",
	  "Svalbard und Jan Mayen",
	  "Swasiland",
	  "Syrien",
	  "Türkei",
	  "Tadschikistan",
	  "Taiwan",
	  "Tansania",
	  "Thailand",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad und Tobago",
	  "Tschad",
	  "Tschechische Republik",
	  "Tunesien",
	  "Turkmenistan",
	  "Turks- und Caicosinseln",
	  "Tuvalu",
	  "Uganda",
	  "Ukraine",
	  "Ungarn",
	  "Uruguay",
	  "Usbekistan",
	  "Vanuatu",
	  "Vatikanstadt",
	  "Venezuela",
	  "Vereinigte Arabische Emirate",
	  "Vereinigte Staaten",
	  "Vereinigtes Königreich",
	  "Vietnam",
	  "Wallis und Futuna",
	  "Weihnachtsinsel",
	  "Westsahara",
	  "Zentralafrikanische Republik",
	  "Zypern"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Österreich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(796);
	address.street_root = __webpack_require__(805);
	address.building_number = __webpack_require__(793);
	address.secondary_address = __webpack_require__(800);
	address.postcode = __webpack_require__(799);
	address.state = __webpack_require__(801);
	address.state_abbr = __webpack_require__(802);
	address.city_name = __webpack_require__(795);
	address.city = __webpack_require__(794);
	address.street_name = __webpack_require__(804);
	address.street_address = __webpack_require__(803);
	address.default_country = __webpack_require__(797);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Zimmer ###",
	  "# OG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Burgenland",
	  "Kärnten",
	  "Niederösterreich",
	  "Oberösterreich",
	  "Salzburg",
	  "Steiermark",
	  "Tirol",
	  "Vorarlberg",
	  "Wien"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bgld.",
	  "Ktn.",
	  "NÖ",
	  "OÖ",
	  "Sbg.",
	  "Stmk.",
	  "T",
	  "Vbg.",
	  "W"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ahorn",
	  "Ahorngasse (St. Andrä)",
	  "Alleestraße (Poysbrunn)",
	  "Alpenlandstraße",
	  "Alte Poststraße",
	  "Alte Ufergasse",
	  "Am Kronawett (Hagenbrunn)",
	  "Am Mühlwasser",
	  "Am Rebenhang",
	  "Am Sternweg",
	  "Anton Wildgans-Straße",
	  "Auer-von-Welsbach-Weg",
	  "Auf der Stift",
	  "Aufeldgasse",
	  "Bahngasse",
	  "Bahnhofstraße",
	  "Bahnstraße (Gerhaus)",
	  "Basteigasse",
	  "Berggasse",
	  "Bergstraße",
	  "Birkenweg",
	  "Blasiussteig",
	  "Blattur",
	  "Bruderhofgasse",
	  "Brunnelligasse",
	  "Bühelweg",
	  "Darnautgasse",
	  "Donaugasse",
	  "Dorfplatz (Haselbach)",
	  "Dr.-Oberreiter-Straße",
	  "Dr.Karl Holoubek-Str.",
	  "Drautal Bundesstraße",
	  "Dürnrohrer Straße",
	  "Ebenthalerstraße",
	  "Eckgrabenweg",
	  "Erlenstraße",
	  "Erlenweg",
	  "Eschenweg",
	  "Etrichgasse",
	  "Fassergasse",
	  "Feichteggerwiese",
	  "Feld-Weg",
	  "Feldgasse",
	  "Feldstapfe",
	  "Fischpointweg",
	  "Flachbergstraße",
	  "Flurweg",
	  "Franz Schubert-Gasse",
	  "Franz-Schneeweiß-Weg",
	  "Franz-von-Assisi-Straße",
	  "Fritz-Pregl-Straße",
	  "Fuchsgrubenweg",
	  "Födlerweg",
	  "Föhrenweg",
	  "Fünfhaus (Paasdorf)",
	  "Gabelsbergerstraße",
	  "Gartenstraße",
	  "Geigen",
	  "Geigergasse",
	  "Gemeindeaugasse",
	  "Gemeindeplatz",
	  "Georg-Aichinger-Straße",
	  "Glanfeldbachweg",
	  "Graben (Burgauberg)",
	  "Grub",
	  "Gröretgasse",
	  "Grünbach",
	  "Gösting",
	  "Hainschwang",
	  "Hans-Mauracher-Straße",
	  "Hart",
	  "Teichstraße",
	  "Hauptplatz",
	  "Hauptstraße",
	  "Heideweg",
	  "Heinrich Landauer Gasse",
	  "Helenengasse",
	  "Hermann von Gilmweg",
	  "Hermann-Löns-Gasse",
	  "Herminengasse",
	  "Hernstorferstraße",
	  "Hirsdorf",
	  "Hochfeistritz",
	  "Hochhaus Neue Donau",
	  "Hof",
	  "Hussovits Gasse",
	  "Höggen",
	  "Hütten",
	  "Janzgasse",
	  "Jochriemgutstraße",
	  "Johann-Strauß-Gasse",
	  "Julius-Raab-Straße",
	  "Kahlenberger Straße",
	  "Karl Kraft-Straße",
	  "Kegelprielstraße",
	  "Keltenberg-Eponaweg",
	  "Kennedybrücke",
	  "Kerpelystraße",
	  "Kindergartenstraße",
	  "Kinderheimgasse",
	  "Kirchenplatz",
	  "Kirchweg",
	  "Klagenfurter Straße",
	  "Klamm",
	  "Kleinbaumgarten",
	  "Klingergasse",
	  "Koloniestraße",
	  "Konrad-Duden-Gasse",
	  "Krankenhausstraße",
	  "Kubinstraße",
	  "Köhldorfergasse",
	  "Lackenweg",
	  "Lange Mekotte",
	  "Leifling",
	  "Leopold Frank-Straße (Pellendorf)",
	  "Lerchengasse (Pirka)",
	  "Lichtensternsiedlung V",
	  "Lindenhofstraße",
	  "Lindenweg",
	  "Luegstraße",
	  "Maierhof",
	  "Malerweg",
	  "Mitterweg",
	  "Mittlere Hauptstraße",
	  "Moosbachgasse",
	  "Morettigasse",
	  "Musikpavillon Riezlern",
	  "Mühlboden",
	  "Mühle",
	  "Mühlenweg",
	  "Neustiftgasse",
	  "Niederegg",
	  "Niedergams",
	  "Nordwestbahnbrücke",
	  "Oberbödenalm",
	  "Obere Berggasse",
	  "Oedt",
	  "Am Färberberg",
	  "Ottogasse",
	  "Paul Peters-Gasse",
	  "Perspektivstraße",
	  "Poppichl",
	  "Privatweg",
	  "Prixgasse",
	  "Pyhra",
	  "Radetzkystraße",
	  "Raiden",
	  "Reichensteinstraße",
	  "Reitbauernstraße",
	  "Reiterweg",
	  "Reitschulgasse",
	  "Ringweg",
	  "Rupertistraße",
	  "Römerstraße",
	  "Römerweg",
	  "Sackgasse",
	  "Schaunbergerstraße",
	  "Schloßweg",
	  "Schulgasse (Langeck)",
	  "Schönholdsiedlung",
	  "Seeblick",
	  "Seestraße",
	  "Semriacherstraße",
	  "Simling",
	  "Sipbachzeller Straße",
	  "Sonnenweg",
	  "Spargelfeldgasse",
	  "Spiesmayrweg",
	  "Sportplatzstraße",
	  "St.Ulrich",
	  "Steilmannstraße",
	  "Steingrüneredt",
	  "Strassfeld",
	  "Straßerau",
	  "Stöpflweg",
	  "Stüra",
	  "Taferngasse",
	  "Tennweg",
	  "Thomas Koschat-Gasse",
	  "Tiroler Straße",
	  "Torrogasse",
	  "Uferstraße (Schwarzau am Steinfeld)",
	  "Unterdörfl",
	  "Unterer Sonnrainweg",
	  "Verwaltersiedlung",
	  "Waldhang",
	  "Wasen",
	  "Weidenstraße",
	  "Weiherweg",
	  "Wettsteingasse",
	  "Wiener Straße",
	  "Windisch",
	  "Zebragasse",
	  "Zellerstraße",
	  "Ziehrerstraße",
	  "Zulechnerweg",
	  "Zwergjoch",
	  "Ötzbruck"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+43-6##-#######",
	  "06##-########",
	  "+436#########",
	  "06##########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(806);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(811);
	company.legal_form = __webpack_require__(809);
	company.name = __webpack_require__(810);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de_AT = {};
	module['exports'] = de_AT;
	de_AT.title = "German (Austria)";
	de_AT.address = __webpack_require__(798);
	de_AT.company = __webpack_require__(808);
	de_AT.internet = __webpack_require__(815);
	de_AT.name = __webpack_require__(817);
	de_AT.phone_number = __webpack_require__(823);
	de_AT.cell_phone = __webpack_require__(807);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "info",
	  "name",
	  "net",
	  "org",
	  "de",
	  "ch",
	  "at"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(814);
	internet.domain_suffix = __webpack_require__(813);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Abdul",
	  "Abdullah",
	  "Adam",
	  "Adrian",
	  "Adriano",
	  "Ahmad",
	  "Ahmed",
	  "Ahmet",
	  "Alan",
	  "Albert",
	  "Alessandro",
	  "Alessio",
	  "Alex",
	  "Alexander",
	  "Alfred",
	  "Ali",
	  "Amar",
	  "Amir",
	  "Amon",
	  "Andre",
	  "Andreas",
	  "Andrew",
	  "Angelo",
	  "Ansgar",
	  "Anthony",
	  "Anton",
	  "Antonio",
	  "Arda",
	  "Arian",
	  "Armin",
	  "Arne",
	  "Arno",
	  "Arthur",
	  "Artur",
	  "Arved",
	  "Arvid",
	  "Ayman",
	  "Baran",
	  "Baris",
	  "Bastian",
	  "Batuhan",
	  "Bela",
	  "Ben",
	  "Benedikt",
	  "Benjamin",
	  "Bennet",
	  "Bennett",
	  "Benno",
	  "Bent",
	  "Berat",
	  "Berkay",
	  "Bernd",
	  "Bilal",
	  "Bjarne",
	  "Björn",
	  "Bo",
	  "Boris",
	  "Brandon",
	  "Brian",
	  "Bruno",
	  "Bryan",
	  "Burak",
	  "Calvin",
	  "Can",
	  "Carl",
	  "Carlo",
	  "Carlos",
	  "Caspar",
	  "Cedric",
	  "Cedrik",
	  "Cem",
	  "Charlie",
	  "Chris",
	  "Christian",
	  "Christiano",
	  "Christoph",
	  "Christopher",
	  "Claas",
	  "Clemens",
	  "Colin",
	  "Collin",
	  "Conner",
	  "Connor",
	  "Constantin",
	  "Corvin",
	  "Curt",
	  "Damian",
	  "Damien",
	  "Daniel",
	  "Danilo",
	  "Danny",
	  "Darian",
	  "Dario",
	  "Darius",
	  "Darren",
	  "David",
	  "Davide",
	  "Davin",
	  "Dean",
	  "Deniz",
	  "Dennis",
	  "Denny",
	  "Devin",
	  "Diego",
	  "Dion",
	  "Domenic",
	  "Domenik",
	  "Dominic",
	  "Dominik",
	  "Dorian",
	  "Dustin",
	  "Dylan",
	  "Ecrin",
	  "Eddi",
	  "Eddy",
	  "Edgar",
	  "Edwin",
	  "Efe",
	  "Ege",
	  "Elia",
	  "Eliah",
	  "Elias",
	  "Elijah",
	  "Emanuel",
	  "Emil",
	  "Emilian",
	  "Emilio",
	  "Emir",
	  "Emirhan",
	  "Emre",
	  "Enes",
	  "Enno",
	  "Enrico",
	  "Eren",
	  "Eric",
	  "Erik",
	  "Etienne",
	  "Fabian",
	  "Fabien",
	  "Fabio",
	  "Fabrice",
	  "Falk",
	  "Felix",
	  "Ferdinand",
	  "Fiete",
	  "Filip",
	  "Finlay",
	  "Finley",
	  "Finn",
	  "Finnley",
	  "Florian",
	  "Francesco",
	  "Franz",
	  "Frederic",
	  "Frederick",
	  "Frederik",
	  "Friedrich",
	  "Fritz",
	  "Furkan",
	  "Fynn",
	  "Gabriel",
	  "Georg",
	  "Gerrit",
	  "Gian",
	  "Gianluca",
	  "Gino",
	  "Giuliano",
	  "Giuseppe",
	  "Gregor",
	  "Gustav",
	  "Hagen",
	  "Hamza",
	  "Hannes",
	  "Hanno",
	  "Hans",
	  "Hasan",
	  "Hassan",
	  "Hauke",
	  "Hendrik",
	  "Hennes",
	  "Henning",
	  "Henri",
	  "Henrick",
	  "Henrik",
	  "Henry",
	  "Hugo",
	  "Hussein",
	  "Ian",
	  "Ibrahim",
	  "Ilias",
	  "Ilja",
	  "Ilyas",
	  "Immanuel",
	  "Ismael",
	  "Ismail",
	  "Ivan",
	  "Iven",
	  "Jack",
	  "Jacob",
	  "Jaden",
	  "Jakob",
	  "Jamal",
	  "James",
	  "Jamie",
	  "Jan",
	  "Janek",
	  "Janis",
	  "Janne",
	  "Jannek",
	  "Jannes",
	  "Jannik",
	  "Jannis",
	  "Jano",
	  "Janosch",
	  "Jared",
	  "Jari",
	  "Jarne",
	  "Jarno",
	  "Jaron",
	  "Jason",
	  "Jasper",
	  "Jay",
	  "Jayden",
	  "Jayson",
	  "Jean",
	  "Jens",
	  "Jeremias",
	  "Jeremie",
	  "Jeremy",
	  "Jermaine",
	  "Jerome",
	  "Jesper",
	  "Jesse",
	  "Jim",
	  "Jimmy",
	  "Joe",
	  "Joel",
	  "Joey",
	  "Johann",
	  "Johannes",
	  "John",
	  "Johnny",
	  "Jon",
	  "Jona",
	  "Jonah",
	  "Jonas",
	  "Jonathan",
	  "Jonte",
	  "Joost",
	  "Jordan",
	  "Joris",
	  "Joscha",
	  "Joschua",
	  "Josef",
	  "Joseph",
	  "Josh",
	  "Joshua",
	  "Josua",
	  "Juan",
	  "Julian",
	  "Julien",
	  "Julius",
	  "Juri",
	  "Justin",
	  "Justus",
	  "Kaan",
	  "Kai",
	  "Kalle",
	  "Karim",
	  "Karl",
	  "Karlo",
	  "Kay",
	  "Keanu",
	  "Kenan",
	  "Kenny",
	  "Keno",
	  "Kerem",
	  "Kerim",
	  "Kevin",
	  "Kian",
	  "Kilian",
	  "Kim",
	  "Kimi",
	  "Kjell",
	  "Klaas",
	  "Klemens",
	  "Konrad",
	  "Konstantin",
	  "Koray",
	  "Korbinian",
	  "Kurt",
	  "Lars",
	  "Lasse",
	  "Laurence",
	  "Laurens",
	  "Laurenz",
	  "Laurin",
	  "Lean",
	  "Leander",
	  "Leandro",
	  "Leif",
	  "Len",
	  "Lenn",
	  "Lennard",
	  "Lennart",
	  "Lennert",
	  "Lennie",
	  "Lennox",
	  "Lenny",
	  "Leo",
	  "Leon",
	  "Leonard",
	  "Leonardo",
	  "Leonhard",
	  "Leonidas",
	  "Leopold",
	  "Leroy",
	  "Levent",
	  "Levi",
	  "Levin",
	  "Lewin",
	  "Lewis",
	  "Liam",
	  "Lian",
	  "Lias",
	  "Lino",
	  "Linus",
	  "Lio",
	  "Lion",
	  "Lionel",
	  "Logan",
	  "Lorenz",
	  "Lorenzo",
	  "Loris",
	  "Louis",
	  "Luan",
	  "Luc",
	  "Luca",
	  "Lucas",
	  "Lucian",
	  "Lucien",
	  "Ludwig",
	  "Luis",
	  "Luiz",
	  "Luk",
	  "Luka",
	  "Lukas",
	  "Luke",
	  "Lutz",
	  "Maddox",
	  "Mads",
	  "Magnus",
	  "Maik",
	  "Maksim",
	  "Malik",
	  "Malte",
	  "Manuel",
	  "Marc",
	  "Marcel",
	  "Marco",
	  "Marcus",
	  "Marek",
	  "Marian",
	  "Mario",
	  "Marius",
	  "Mark",
	  "Marko",
	  "Markus",
	  "Marlo",
	  "Marlon",
	  "Marten",
	  "Martin",
	  "Marvin",
	  "Marwin",
	  "Mateo",
	  "Mathis",
	  "Matis",
	  "Mats",
	  "Matteo",
	  "Mattes",
	  "Matthias",
	  "Matthis",
	  "Matti",
	  "Mattis",
	  "Maurice",
	  "Max",
	  "Maxim",
	  "Maximilian",
	  "Mehmet",
	  "Meik",
	  "Melvin",
	  "Merlin",
	  "Mert",
	  "Michael",
	  "Michel",
	  "Mick",
	  "Miguel",
	  "Mika",
	  "Mikail",
	  "Mike",
	  "Milan",
	  "Milo",
	  "Mio",
	  "Mirac",
	  "Mirco",
	  "Mirko",
	  "Mohamed",
	  "Mohammad",
	  "Mohammed",
	  "Moritz",
	  "Morten",
	  "Muhammed",
	  "Murat",
	  "Mustafa",
	  "Nathan",
	  "Nathanael",
	  "Nelson",
	  "Neo",
	  "Nevio",
	  "Nick",
	  "Niclas",
	  "Nico",
	  "Nicolai",
	  "Nicolas",
	  "Niels",
	  "Nikita",
	  "Niklas",
	  "Niko",
	  "Nikolai",
	  "Nikolas",
	  "Nils",
	  "Nino",
	  "Noah",
	  "Noel",
	  "Norman",
	  "Odin",
	  "Oke",
	  "Ole",
	  "Oliver",
	  "Omar",
	  "Onur",
	  "Oscar",
	  "Oskar",
	  "Pascal",
	  "Patrice",
	  "Patrick",
	  "Paul",
	  "Peer",
	  "Pepe",
	  "Peter",
	  "Phil",
	  "Philip",
	  "Philipp",
	  "Pierre",
	  "Piet",
	  "Pit",
	  "Pius",
	  "Quentin",
	  "Quirin",
	  "Rafael",
	  "Raik",
	  "Ramon",
	  "Raphael",
	  "Rasmus",
	  "Raul",
	  "Rayan",
	  "René",
	  "Ricardo",
	  "Riccardo",
	  "Richard",
	  "Rick",
	  "Rico",
	  "Robert",
	  "Robin",
	  "Rocco",
	  "Roman",
	  "Romeo",
	  "Ron",
	  "Ruben",
	  "Ryan",
	  "Said",
	  "Salih",
	  "Sam",
	  "Sami",
	  "Sammy",
	  "Samuel",
	  "Sandro",
	  "Santino",
	  "Sascha",
	  "Sean",
	  "Sebastian",
	  "Selim",
	  "Semih",
	  "Shawn",
	  "Silas",
	  "Simeon",
	  "Simon",
	  "Sinan",
	  "Sky",
	  "Stefan",
	  "Steffen",
	  "Stephan",
	  "Steve",
	  "Steven",
	  "Sven",
	  "Sönke",
	  "Sören",
	  "Taha",
	  "Tamino",
	  "Tammo",
	  "Tarik",
	  "Tayler",
	  "Taylor",
	  "Teo",
	  "Theo",
	  "Theodor",
	  "Thies",
	  "Thilo",
	  "Thomas",
	  "Thorben",
	  "Thore",
	  "Thorge",
	  "Tiago",
	  "Til",
	  "Till",
	  "Tillmann",
	  "Tim",
	  "Timm",
	  "Timo",
	  "Timon",
	  "Timothy",
	  "Tino",
	  "Titus",
	  "Tizian",
	  "Tjark",
	  "Tobias",
	  "Tom",
	  "Tommy",
	  "Toni",
	  "Tony",
	  "Torben",
	  "Tore",
	  "Tristan",
	  "Tyler",
	  "Tyron",
	  "Umut",
	  "Valentin",
	  "Valentino",
	  "Veit",
	  "Victor",
	  "Viktor",
	  "Vin",
	  "Vincent",
	  "Vito",
	  "Vitus",
	  "Wilhelm",
	  "Willi",
	  "William",
	  "Willy",
	  "Xaver",
	  "Yannic",
	  "Yannick",
	  "Yannik",
	  "Yannis",
	  "Yasin",
	  "Youssef",
	  "Yunus",
	  "Yusuf",
	  "Yven",
	  "Yves",
	  "Ömer",
	  "Aaliyah",
	  "Abby",
	  "Abigail",
	  "Ada",
	  "Adelina",
	  "Adriana",
	  "Aileen",
	  "Aimee",
	  "Alana",
	  "Alea",
	  "Alena",
	  "Alessa",
	  "Alessia",
	  "Alexa",
	  "Alexandra",
	  "Alexia",
	  "Alexis",
	  "Aleyna",
	  "Alia",
	  "Alica",
	  "Alice",
	  "Alicia",
	  "Alina",
	  "Alisa",
	  "Alisha",
	  "Alissa",
	  "Aliya",
	  "Aliyah",
	  "Allegra",
	  "Alma",
	  "Alyssa",
	  "Amalia",
	  "Amanda",
	  "Amelia",
	  "Amelie",
	  "Amina",
	  "Amira",
	  "Amy",
	  "Ana",
	  "Anabel",
	  "Anastasia",
	  "Andrea",
	  "Angela",
	  "Angelina",
	  "Angelique",
	  "Anja",
	  "Ann",
	  "Anna",
	  "Annabel",
	  "Annabell",
	  "Annabelle",
	  "Annalena",
	  "Anne",
	  "Anneke",
	  "Annelie",
	  "Annemarie",
	  "Anni",
	  "Annie",
	  "Annika",
	  "Anny",
	  "Anouk",
	  "Antonia",
	  "Arda",
	  "Ariana",
	  "Ariane",
	  "Arwen",
	  "Ashley",
	  "Asya",
	  "Aurelia",
	  "Aurora",
	  "Ava",
	  "Ayleen",
	  "Aylin",
	  "Ayse",
	  "Azra",
	  "Betty",
	  "Bianca",
	  "Bianka",
	  "Caitlin",
	  "Cara",
	  "Carina",
	  "Carla",
	  "Carlotta",
	  "Carmen",
	  "Carolin",
	  "Carolina",
	  "Caroline",
	  "Cassandra",
	  "Catharina",
	  "Catrin",
	  "Cecile",
	  "Cecilia",
	  "Celia",
	  "Celina",
	  "Celine",
	  "Ceyda",
	  "Ceylin",
	  "Chantal",
	  "Charleen",
	  "Charlotta",
	  "Charlotte",
	  "Chayenne",
	  "Cheyenne",
	  "Chiara",
	  "Christin",
	  "Christina",
	  "Cindy",
	  "Claire",
	  "Clara",
	  "Clarissa",
	  "Colleen",
	  "Collien",
	  "Cora",
	  "Corinna",
	  "Cosima",
	  "Dana",
	  "Daniela",
	  "Daria",
	  "Darleen",
	  "Defne",
	  "Delia",
	  "Denise",
	  "Diana",
	  "Dilara",
	  "Dina",
	  "Dorothea",
	  "Ecrin",
	  "Eda",
	  "Eileen",
	  "Ela",
	  "Elaine",
	  "Elanur",
	  "Elea",
	  "Elena",
	  "Eleni",
	  "Eleonora",
	  "Eliana",
	  "Elif",
	  "Elina",
	  "Elisa",
	  "Elisabeth",
	  "Ella",
	  "Ellen",
	  "Elli",
	  "Elly",
	  "Elsa",
	  "Emelie",
	  "Emely",
	  "Emilia",
	  "Emilie",
	  "Emily",
	  "Emma",
	  "Emmely",
	  "Emmi",
	  "Emmy",
	  "Enie",
	  "Enna",
	  "Enya",
	  "Esma",
	  "Estelle",
	  "Esther",
	  "Eva",
	  "Evelin",
	  "Evelina",
	  "Eveline",
	  "Evelyn",
	  "Fabienne",
	  "Fatima",
	  "Fatma",
	  "Felicia",
	  "Felicitas",
	  "Felina",
	  "Femke",
	  "Fenja",
	  "Fine",
	  "Finia",
	  "Finja",
	  "Finnja",
	  "Fiona",
	  "Flora",
	  "Florentine",
	  "Francesca",
	  "Franka",
	  "Franziska",
	  "Frederike",
	  "Freya",
	  "Frida",
	  "Frieda",
	  "Friederike",
	  "Giada",
	  "Gina",
	  "Giulia",
	  "Giuliana",
	  "Greta",
	  "Hailey",
	  "Hana",
	  "Hanna",
	  "Hannah",
	  "Heidi",
	  "Helen",
	  "Helena",
	  "Helene",
	  "Helin",
	  "Henriette",
	  "Henrike",
	  "Hermine",
	  "Ida",
	  "Ilayda",
	  "Imke",
	  "Ina",
	  "Ines",
	  "Inga",
	  "Inka",
	  "Irem",
	  "Isa",
	  "Isabel",
	  "Isabell",
	  "Isabella",
	  "Isabelle",
	  "Ivonne",
	  "Jacqueline",
	  "Jamie",
	  "Jamila",
	  "Jana",
	  "Jane",
	  "Janin",
	  "Janina",
	  "Janine",
	  "Janna",
	  "Janne",
	  "Jara",
	  "Jasmin",
	  "Jasmina",
	  "Jasmine",
	  "Jella",
	  "Jenna",
	  "Jennifer",
	  "Jenny",
	  "Jessica",
	  "Jessy",
	  "Jette",
	  "Jil",
	  "Jill",
	  "Joana",
	  "Joanna",
	  "Joelina",
	  "Joeline",
	  "Joelle",
	  "Johanna",
	  "Joleen",
	  "Jolie",
	  "Jolien",
	  "Jolin",
	  "Jolina",
	  "Joline",
	  "Jona",
	  "Jonah",
	  "Jonna",
	  "Josefin",
	  "Josefine",
	  "Josephin",
	  "Josephine",
	  "Josie",
	  "Josy",
	  "Joy",
	  "Joyce",
	  "Judith",
	  "Judy",
	  "Jule",
	  "Julia",
	  "Juliana",
	  "Juliane",
	  "Julie",
	  "Julienne",
	  "Julika",
	  "Julina",
	  "Juna",
	  "Justine",
	  "Kaja",
	  "Karina",
	  "Karla",
	  "Karlotta",
	  "Karolina",
	  "Karoline",
	  "Kassandra",
	  "Katarina",
	  "Katharina",
	  "Kathrin",
	  "Katja",
	  "Katrin",
	  "Kaya",
	  "Kayra",
	  "Kiana",
	  "Kiara",
	  "Kim",
	  "Kimberley",
	  "Kimberly",
	  "Kira",
	  "Klara",
	  "Korinna",
	  "Kristin",
	  "Kyra",
	  "Laila",
	  "Lana",
	  "Lara",
	  "Larissa",
	  "Laura",
	  "Laureen",
	  "Lavinia",
	  "Lea",
	  "Leah",
	  "Leana",
	  "Leandra",
	  "Leann",
	  "Lee",
	  "Leila",
	  "Lena",
	  "Lene",
	  "Leni",
	  "Lenia",
	  "Lenja",
	  "Lenya",
	  "Leona",
	  "Leoni",
	  "Leonie",
	  "Leonora",
	  "Leticia",
	  "Letizia",
	  "Levke",
	  "Leyla",
	  "Lia",
	  "Liah",
	  "Liana",
	  "Lili",
	  "Lilia",
	  "Lilian",
	  "Liliana",
	  "Lilith",
	  "Lilli",
	  "Lillian",
	  "Lilly",
	  "Lily",
	  "Lina",
	  "Linda",
	  "Lindsay",
	  "Line",
	  "Linn",
	  "Linnea",
	  "Lisa",
	  "Lisann",
	  "Lisanne",
	  "Liv",
	  "Livia",
	  "Liz",
	  "Lola",
	  "Loreen",
	  "Lorena",
	  "Lotta",
	  "Lotte",
	  "Louisa",
	  "Louise",
	  "Luana",
	  "Luca",
	  "Lucia",
	  "Lucie",
	  "Lucienne",
	  "Lucy",
	  "Luisa",
	  "Luise",
	  "Luka",
	  "Luna",
	  "Luzie",
	  "Lya",
	  "Lydia",
	  "Lyn",
	  "Lynn",
	  "Madeleine",
	  "Madita",
	  "Madleen",
	  "Madlen",
	  "Magdalena",
	  "Maike",
	  "Mailin",
	  "Maira",
	  "Maja",
	  "Malena",
	  "Malia",
	  "Malin",
	  "Malina",
	  "Mandy",
	  "Mara",
	  "Marah",
	  "Mareike",
	  "Maren",
	  "Maria",
	  "Mariam",
	  "Marie",
	  "Marieke",
	  "Mariella",
	  "Marika",
	  "Marina",
	  "Marisa",
	  "Marissa",
	  "Marit",
	  "Marla",
	  "Marleen",
	  "Marlen",
	  "Marlena",
	  "Marlene",
	  "Marta",
	  "Martha",
	  "Mary",
	  "Maryam",
	  "Mathilda",
	  "Mathilde",
	  "Matilda",
	  "Maxi",
	  "Maxima",
	  "Maxine",
	  "Maya",
	  "Mayra",
	  "Medina",
	  "Medine",
	  "Meike",
	  "Melanie",
	  "Melek",
	  "Melike",
	  "Melina",
	  "Melinda",
	  "Melis",
	  "Melisa",
	  "Melissa",
	  "Merle",
	  "Merve",
	  "Meryem",
	  "Mette",
	  "Mia",
	  "Michaela",
	  "Michelle",
	  "Mieke",
	  "Mila",
	  "Milana",
	  "Milena",
	  "Milla",
	  "Mina",
	  "Mira",
	  "Miray",
	  "Miriam",
	  "Mirja",
	  "Mona",
	  "Monique",
	  "Nadine",
	  "Nadja",
	  "Naemi",
	  "Nancy",
	  "Naomi",
	  "Natalia",
	  "Natalie",
	  "Nathalie",
	  "Neele",
	  "Nela",
	  "Nele",
	  "Nelli",
	  "Nelly",
	  "Nia",
	  "Nicole",
	  "Nika",
	  "Nike",
	  "Nikita",
	  "Nila",
	  "Nina",
	  "Nisa",
	  "Noemi",
	  "Nora",
	  "Olivia",
	  "Patricia",
	  "Patrizia",
	  "Paula",
	  "Paulina",
	  "Pauline",
	  "Penelope",
	  "Philine",
	  "Phoebe",
	  "Pia",
	  "Rahel",
	  "Rania",
	  "Rebecca",
	  "Rebekka",
	  "Riana",
	  "Rieke",
	  "Rike",
	  "Romina",
	  "Romy",
	  "Ronja",
	  "Rosa",
	  "Rosalie",
	  "Ruby",
	  "Sabrina",
	  "Sahra",
	  "Sally",
	  "Salome",
	  "Samantha",
	  "Samia",
	  "Samira",
	  "Sandra",
	  "Sandy",
	  "Sanja",
	  "Saphira",
	  "Sara",
	  "Sarah",
	  "Saskia",
	  "Selin",
	  "Selina",
	  "Selma",
	  "Sena",
	  "Sidney",
	  "Sienna",
	  "Silja",
	  "Sina",
	  "Sinja",
	  "Smilla",
	  "Sofia",
	  "Sofie",
	  "Sonja",
	  "Sophia",
	  "Sophie",
	  "Soraya",
	  "Stefanie",
	  "Stella",
	  "Stephanie",
	  "Stina",
	  "Sude",
	  "Summer",
	  "Susanne",
	  "Svea",
	  "Svenja",
	  "Sydney",
	  "Tabea",
	  "Talea",
	  "Talia",
	  "Tamara",
	  "Tamia",
	  "Tamina",
	  "Tanja",
	  "Tara",
	  "Tarja",
	  "Teresa",
	  "Tessa",
	  "Thalea",
	  "Thalia",
	  "Thea",
	  "Theresa",
	  "Tia",
	  "Tina",
	  "Tomke",
	  "Tuana",
	  "Valentina",
	  "Valeria",
	  "Valerie",
	  "Vanessa",
	  "Vera",
	  "Veronika",
	  "Victoria",
	  "Viktoria",
	  "Viola",
	  "Vivian",
	  "Vivien",
	  "Vivienne",
	  "Wibke",
	  "Wiebke",
	  "Xenia",
	  "Yara",
	  "Yaren",
	  "Yasmin",
	  "Ylvi",
	  "Ylvie",
	  "Yvonne",
	  "Zara",
	  "Zehra",
	  "Zeynep",
	  "Zoe",
	  "Zoey",
	  "Zoé"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(816);
	name.last_name = __webpack_require__(818);
	name.prefix = __webpack_require__(821);
	name.nobility_title_prefix = __webpack_require__(820);
	name.name = __webpack_require__(819);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abel",
	  "Abicht",
	  "Abraham",
	  "Abramovic",
	  "Abt",
	  "Achilles",
	  "Achkinadze",
	  "Ackermann",
	  "Adam",
	  "Adams",
	  "Ade",
	  "Agostini",
	  "Ahlke",
	  "Ahrenberg",
	  "Ahrens",
	  "Aigner",
	  "Albert",
	  "Albrecht",
	  "Alexa",
	  "Alexander",
	  "Alizadeh",
	  "Allgeyer",
	  "Amann",
	  "Amberg",
	  "Anding",
	  "Anggreny",
	  "Apitz",
	  "Arendt",
	  "Arens",
	  "Arndt",
	  "Aryee",
	  "Aschenbroich",
	  "Assmus",
	  "Astafei",
	  "Auer",
	  "Axmann",
	  "Baarck",
	  "Bachmann",
	  "Badane",
	  "Bader",
	  "Baganz",
	  "Bahl",
	  "Bak",
	  "Balcer",
	  "Balck",
	  "Balkow",
	  "Balnuweit",
	  "Balzer",
	  "Banse",
	  "Barr",
	  "Bartels",
	  "Barth",
	  "Barylla",
	  "Baseda",
	  "Battke",
	  "Bauer",
	  "Bauermeister",
	  "Baumann",
	  "Baumeister",
	  "Bauschinger",
	  "Bauschke",
	  "Bayer",
	  "Beavogui",
	  "Beck",
	  "Beckel",
	  "Becker",
	  "Beckmann",
	  "Bedewitz",
	  "Beele",
	  "Beer",
	  "Beggerow",
	  "Beh",
	  "Behr",
	  "Behrenbruch",
	  "Belz",
	  "Bender",
	  "Benecke",
	  "Benner",
	  "Benninger",
	  "Benzing",
	  "Berends",
	  "Berger",
	  "Berner",
	  "Berning",
	  "Bertenbreiter",
	  "Best",
	  "Bethke",
	  "Betz",
	  "Beushausen",
	  "Beutelspacher",
	  "Beyer",
	  "Biba",
	  "Bichler",
	  "Bickel",
	  "Biedermann",
	  "Bieler",
	  "Bielert",
	  "Bienasch",
	  "Bienias",
	  "Biesenbach",
	  "Bigdeli",
	  "Birkemeyer",
	  "Bittner",
	  "Blank",
	  "Blaschek",
	  "Blassneck",
	  "Bloch",
	  "Blochwitz",
	  "Blockhaus",
	  "Blum",
	  "Blume",
	  "Bock",
	  "Bode",
	  "Bogdashin",
	  "Bogenrieder",
	  "Bohge",
	  "Bolm",
	  "Borgschulze",
	  "Bork",
	  "Bormann",
	  "Bornscheuer",
	  "Borrmann",
	  "Borsch",
	  "Boruschewski",
	  "Bos",
	  "Bosler",
	  "Bourrouag",
	  "Bouschen",
	  "Boxhammer",
	  "Boyde",
	  "Bozsik",
	  "Brand",
	  "Brandenburg",
	  "Brandis",
	  "Brandt",
	  "Brauer",
	  "Braun",
	  "Brehmer",
	  "Breitenstein",
	  "Bremer",
	  "Bremser",
	  "Brenner",
	  "Brettschneider",
	  "Breu",
	  "Breuer",
	  "Briesenick",
	  "Bringmann",
	  "Brinkmann",
	  "Brix",
	  "Broening",
	  "Brosch",
	  "Bruckmann",
	  "Bruder",
	  "Bruhns",
	  "Brunner",
	  "Bruns",
	  "Bräutigam",
	  "Brömme",
	  "Brüggmann",
	  "Buchholz",
	  "Buchrucker",
	  "Buder",
	  "Bultmann",
	  "Bunjes",
	  "Burger",
	  "Burghagen",
	  "Burkhard",
	  "Burkhardt",
	  "Burmeister",
	  "Busch",
	  "Buschbaum",
	  "Busemann",
	  "Buss",
	  "Busse",
	  "Bussmann",
	  "Byrd",
	  "Bäcker",
	  "Böhm",
	  "Bönisch",
	  "Börgeling",
	  "Börner",
	  "Böttner",
	  "Büchele",
	  "Bühler",
	  "Büker",
	  "Büngener",
	  "Bürger",
	  "Bürklein",
	  "Büscher",
	  "Büttner",
	  "Camara",
	  "Carlowitz",
	  "Carlsohn",
	  "Caspari",
	  "Caspers",
	  "Chapron",
	  "Christ",
	  "Cierpinski",
	  "Clarius",
	  "Cleem",
	  "Cleve",
	  "Co",
	  "Conrad",
	  "Cordes",
	  "Cornelsen",
	  "Cors",
	  "Cotthardt",
	  "Crews",
	  "Cronjäger",
	  "Crosskofp",
	  "Da",
	  "Dahm",
	  "Dahmen",
	  "Daimer",
	  "Damaske",
	  "Danneberg",
	  "Danner",
	  "Daub",
	  "Daubner",
	  "Daudrich",
	  "Dauer",
	  "Daum",
	  "Dauth",
	  "Dautzenberg",
	  "De",
	  "Decker",
	  "Deckert",
	  "Deerberg",
	  "Dehmel",
	  "Deja",
	  "Delonge",
	  "Demut",
	  "Dengler",
	  "Denner",
	  "Denzinger",
	  "Derr",
	  "Dertmann",
	  "Dethloff",
	  "Deuschle",
	  "Dieckmann",
	  "Diedrich",
	  "Diekmann",
	  "Dienel",
	  "Dies",
	  "Dietrich",
	  "Dietz",
	  "Dietzsch",
	  "Diezel",
	  "Dilla",
	  "Dingelstedt",
	  "Dippl",
	  "Dittmann",
	  "Dittmar",
	  "Dittmer",
	  "Dix",
	  "Dobbrunz",
	  "Dobler",
	  "Dohring",
	  "Dolch",
	  "Dold",
	  "Dombrowski",
	  "Donie",
	  "Doskoczynski",
	  "Dragu",
	  "Drechsler",
	  "Drees",
	  "Dreher",
	  "Dreier",
	  "Dreissigacker",
	  "Dressler",
	  "Drews",
	  "Duma",
	  "Dutkiewicz",
	  "Dyett",
	  "Dylus",
	  "Dächert",
	  "Döbel",
	  "Döring",
	  "Dörner",
	  "Dörre",
	  "Dück",
	  "Eberhard",
	  "Eberhardt",
	  "Ecker",
	  "Eckhardt",
	  "Edorh",
	  "Effler",
	  "Eggenmueller",
	  "Ehm",
	  "Ehmann",
	  "Ehrig",
	  "Eich",
	  "Eichmann",
	  "Eifert",
	  "Einert",
	  "Eisenlauer",
	  "Ekpo",
	  "Elbe",
	  "Eleyth",
	  "Elss",
	  "Emert",
	  "Emmelmann",
	  "Ender",
	  "Engel",
	  "Engelen",
	  "Engelmann",
	  "Eplinius",
	  "Erdmann",
	  "Erhardt",
	  "Erlei",
	  "Erm",
	  "Ernst",
	  "Ertl",
	  "Erwes",
	  "Esenwein",
	  "Esser",
	  "Evers",
	  "Everts",
	  "Ewald",
	  "Fahner",
	  "Faller",
	  "Falter",
	  "Farber",
	  "Fassbender",
	  "Faulhaber",
	  "Fehrig",
	  "Feld",
	  "Felke",
	  "Feller",
	  "Fenner",
	  "Fenske",
	  "Feuerbach",
	  "Fietz",
	  "Figl",
	  "Figura",
	  "Filipowski",
	  "Filsinger",
	  "Fincke",
	  "Fink",
	  "Finke",
	  "Fischer",
	  "Fitschen",
	  "Fleischer",
	  "Fleischmann",
	  "Floder",
	  "Florczak",
	  "Flore",
	  "Flottmann",
	  "Forkel",
	  "Forst",
	  "Frahmeke",
	  "Frank",
	  "Franke",
	  "Franta",
	  "Frantz",
	  "Franz",
	  "Franzis",
	  "Franzmann",
	  "Frauen",
	  "Frauendorf",
	  "Freigang",
	  "Freimann",
	  "Freimuth",
	  "Freisen",
	  "Frenzel",
	  "Frey",
	  "Fricke",
	  "Fried",
	  "Friedek",
	  "Friedenberg",
	  "Friedmann",
	  "Friedrich",
	  "Friess",
	  "Frisch",
	  "Frohn",
	  "Frosch",
	  "Fuchs",
	  "Fuhlbrügge",
	  "Fusenig",
	  "Fust",
	  "Förster",
	  "Gaba",
	  "Gabius",
	  "Gabler",
	  "Gadschiew",
	  "Gakstädter",
	  "Galander",
	  "Gamlin",
	  "Gamper",
	  "Gangnus",
	  "Ganzmann",
	  "Garatva",
	  "Gast",
	  "Gastel",
	  "Gatzka",
	  "Gauder",
	  "Gebhardt",
	  "Geese",
	  "Gehre",
	  "Gehrig",
	  "Gehring",
	  "Gehrke",
	  "Geiger",
	  "Geisler",
	  "Geissler",
	  "Gelling",
	  "Gens",
	  "Gerbennow",
	  "Gerdel",
	  "Gerhardt",
	  "Gerschler",
	  "Gerson",
	  "Gesell",
	  "Geyer",
	  "Ghirmai",
	  "Ghosh",
	  "Giehl",
	  "Gierisch",
	  "Giesa",
	  "Giesche",
	  "Gilde",
	  "Glatting",
	  "Goebel",
	  "Goedicke",
	  "Goldbeck",
	  "Goldfuss",
	  "Goldkamp",
	  "Goldkühle",
	  "Goller",
	  "Golling",
	  "Gollnow",
	  "Golomski",
	  "Gombert",
	  "Gotthardt",
	  "Gottschalk",
	  "Gotz",
	  "Goy",
	  "Gradzki",
	  "Graf",
	  "Grams",
	  "Grasse",
	  "Gratzky",
	  "Grau",
	  "Greb",
	  "Green",
	  "Greger",
	  "Greithanner",
	  "Greschner",
	  "Griem",
	  "Griese",
	  "Grimm",
	  "Gromisch",
	  "Gross",
	  "Grosser",
	  "Grossheim",
	  "Grosskopf",
	  "Grothaus",
	  "Grothkopp",
	  "Grotke",
	  "Grube",
	  "Gruber",
	  "Grundmann",
	  "Gruning",
	  "Gruszecki",
	  "Gröss",
	  "Grötzinger",
	  "Grün",
	  "Grüner",
	  "Gummelt",
	  "Gunkel",
	  "Gunther",
	  "Gutjahr",
	  "Gutowicz",
	  "Gutschank",
	  "Göbel",
	  "Göckeritz",
	  "Göhler",
	  "Görlich",
	  "Görmer",
	  "Götz",
	  "Götzelmann",
	  "Güldemeister",
	  "Günther",
	  "Günz",
	  "Gürbig",
	  "Haack",
	  "Haaf",
	  "Habel",
	  "Hache",
	  "Hackbusch",
	  "Hackelbusch",
	  "Hadfield",
	  "Hadwich",
	  "Haferkamp",
	  "Hahn",
	  "Hajek",
	  "Hallmann",
	  "Hamann",
	  "Hanenberger",
	  "Hannecker",
	  "Hanniske",
	  "Hansen",
	  "Hardy",
	  "Hargasser",
	  "Harms",
	  "Harnapp",
	  "Harter",
	  "Harting",
	  "Hartlieb",
	  "Hartmann",
	  "Hartwig",
	  "Hartz",
	  "Haschke",
	  "Hasler",
	  "Hasse",
	  "Hassfeld",
	  "Haug",
	  "Hauke",
	  "Haupt",
	  "Haverney",
	  "Heberstreit",
	  "Hechler",
	  "Hecht",
	  "Heck",
	  "Hedermann",
	  "Hehl",
	  "Heidelmann",
	  "Heidler",
	  "Heinemann",
	  "Heinig",
	  "Heinke",
	  "Heinrich",
	  "Heinze",
	  "Heiser",
	  "Heist",
	  "Hellmann",
	  "Helm",
	  "Helmke",
	  "Helpling",
	  "Hengmith",
	  "Henkel",
	  "Hennes",
	  "Henry",
	  "Hense",
	  "Hensel",
	  "Hentel",
	  "Hentschel",
	  "Hentschke",
	  "Hepperle",
	  "Herberger",
	  "Herbrand",
	  "Hering",
	  "Hermann",
	  "Hermecke",
	  "Herms",
	  "Herold",
	  "Herrmann",
	  "Herschmann",
	  "Hertel",
	  "Herweg",
	  "Herwig",
	  "Herzenberg",
	  "Hess",
	  "Hesse",
	  "Hessek",
	  "Hessler",
	  "Hetzler",
	  "Heuck",
	  "Heydemüller",
	  "Hiebl",
	  "Hildebrand",
	  "Hildenbrand",
	  "Hilgendorf",
	  "Hillard",
	  "Hiller",
	  "Hingsen",
	  "Hingst",
	  "Hinrichs",
	  "Hirsch",
	  "Hirschberg",
	  "Hirt",
	  "Hodea",
	  "Hoffman",
	  "Hoffmann",
	  "Hofmann",
	  "Hohenberger",
	  "Hohl",
	  "Hohn",
	  "Hohnheiser",
	  "Hold",
	  "Holdt",
	  "Holinski",
	  "Holl",
	  "Holtfreter",
	  "Holz",
	  "Holzdeppe",
	  "Holzner",
	  "Hommel",
	  "Honz",
	  "Hooss",
	  "Hoppe",
	  "Horak",
	  "Horn",
	  "Horna",
	  "Hornung",
	  "Hort",
	  "Howard",
	  "Huber",
	  "Huckestein",
	  "Hudak",
	  "Huebel",
	  "Hugo",
	  "Huhn",
	  "Hujo",
	  "Huke",
	  "Huls",
	  "Humbert",
	  "Huneke",
	  "Huth",
	  "Häber",
	  "Häfner",
	  "Höcke",
	  "Höft",
	  "Höhne",
	  "Hönig",
	  "Hördt",
	  "Hübenbecker",
	  "Hübl",
	  "Hübner",
	  "Hügel",
	  "Hüttcher",
	  "Hütter",
	  "Ibe",
	  "Ihly",
	  "Illing",
	  "Isak",
	  "Isekenmeier",
	  "Itt",
	  "Jacob",
	  "Jacobs",
	  "Jagusch",
	  "Jahn",
	  "Jahnke",
	  "Jakobs",
	  "Jakubczyk",
	  "Jambor",
	  "Jamrozy",
	  "Jander",
	  "Janich",
	  "Janke",
	  "Jansen",
	  "Jarets",
	  "Jaros",
	  "Jasinski",
	  "Jasper",
	  "Jegorov",
	  "Jellinghaus",
	  "Jeorga",
	  "Jerschabek",
	  "Jess",
	  "John",
	  "Jonas",
	  "Jossa",
	  "Jucken",
	  "Jung",
	  "Jungbluth",
	  "Jungton",
	  "Just",
	  "Jürgens",
	  "Kaczmarek",
	  "Kaesmacher",
	  "Kahl",
	  "Kahlert",
	  "Kahles",
	  "Kahlmeyer",
	  "Kaiser",
	  "Kalinowski",
	  "Kallabis",
	  "Kallensee",
	  "Kampf",
	  "Kampschulte",
	  "Kappe",
	  "Kappler",
	  "Karhoff",
	  "Karrass",
	  "Karst",
	  "Karsten",
	  "Karus",
	  "Kass",
	  "Kasten",
	  "Kastner",
	  "Katzinski",
	  "Kaufmann",
	  "Kaul",
	  "Kausemann",
	  "Kawohl",
	  "Kazmarek",
	  "Kedzierski",
	  "Keil",
	  "Keiner",
	  "Keller",
	  "Kelm",
	  "Kempe",
	  "Kemper",
	  "Kempter",
	  "Kerl",
	  "Kern",
	  "Kesselring",
	  "Kesselschläger",
	  "Kette",
	  "Kettenis",
	  "Keutel",
	  "Kick",
	  "Kiessling",
	  "Kinadeter",
	  "Kinzel",
	  "Kinzy",
	  "Kirch",
	  "Kirst",
	  "Kisabaka",
	  "Klaas",
	  "Klabuhn",
	  "Klapper",
	  "Klauder",
	  "Klaus",
	  "Kleeberg",
	  "Kleiber",
	  "Klein",
	  "Kleinert",
	  "Kleininger",
	  "Kleinmann",
	  "Kleinsteuber",
	  "Kleiss",
	  "Klemme",
	  "Klimczak",
	  "Klinger",
	  "Klink",
	  "Klopsch",
	  "Klose",
	  "Kloss",
	  "Kluge",
	  "Kluwe",
	  "Knabe",
	  "Kneifel",
	  "Knetsch",
	  "Knies",
	  "Knippel",
	  "Knobel",
	  "Knoblich",
	  "Knoll",
	  "Knorr",
	  "Knorscheidt",
	  "Knut",
	  "Kobs",
	  "Koch",
	  "Kochan",
	  "Kock",
	  "Koczulla",
	  "Koderisch",
	  "Koehl",
	  "Koehler",
	  "Koenig",
	  "Koester",
	  "Kofferschlager",
	  "Koha",
	  "Kohle",
	  "Kohlmann",
	  "Kohnle",
	  "Kohrt",
	  "Koj",
	  "Kolb",
	  "Koleiski",
	  "Kolokas",
	  "Komoll",
	  "Konieczny",
	  "Konig",
	  "Konow",
	  "Konya",
	  "Koob",
	  "Kopf",
	  "Kosenkow",
	  "Koster",
	  "Koszewski",
	  "Koubaa",
	  "Kovacs",
	  "Kowalick",
	  "Kowalinski",
	  "Kozakiewicz",
	  "Krabbe",
	  "Kraft",
	  "Kral",
	  "Kramer",
	  "Krauel",
	  "Kraus",
	  "Krause",
	  "Krauspe",
	  "Kreb",
	  "Krebs",
	  "Kreissig",
	  "Kresse",
	  "Kreutz",
	  "Krieger",
	  "Krippner",
	  "Krodinger",
	  "Krohn",
	  "Krol",
	  "Kron",
	  "Krueger",
	  "Krug",
	  "Kruger",
	  "Krull",
	  "Kruschinski",
	  "Krämer",
	  "Kröckert",
	  "Kröger",
	  "Krüger",
	  "Kubera",
	  "Kufahl",
	  "Kuhlee",
	  "Kuhnen",
	  "Kulimann",
	  "Kulma",
	  "Kumbernuss",
	  "Kummle",
	  "Kunz",
	  "Kupfer",
	  "Kupprion",
	  "Kuprion",
	  "Kurnicki",
	  "Kurrat",
	  "Kurschilgen",
	  "Kuschewitz",
	  "Kuschmann",
	  "Kuske",
	  "Kustermann",
	  "Kutscherauer",
	  "Kutzner",
	  "Kwadwo",
	  "Kähler",
	  "Käther",
	  "Köhler",
	  "Köhrbrück",
	  "Köhre",
	  "Kölotzei",
	  "König",
	  "Köpernick",
	  "Köseoglu",
	  "Kúhn",
	  "Kúhnert",
	  "Kühn",
	  "Kühnel",
	  "Kühnemund",
	  "Kühnert",
	  "Kühnke",
	  "Küsters",
	  "Küter",
	  "Laack",
	  "Lack",
	  "Ladewig",
	  "Lakomy",
	  "Lammert",
	  "Lamos",
	  "Landmann",
	  "Lang",
	  "Lange",
	  "Langfeld",
	  "Langhirt",
	  "Lanig",
	  "Lauckner",
	  "Lauinger",
	  "Laurén",
	  "Lausecker",
	  "Laux",
	  "Laws",
	  "Lax",
	  "Leberer",
	  "Lehmann",
	  "Lehner",
	  "Leibold",
	  "Leide",
	  "Leimbach",
	  "Leipold",
	  "Leist",
	  "Leiter",
	  "Leiteritz",
	  "Leitheim",
	  "Leiwesmeier",
	  "Lenfers",
	  "Lenk",
	  "Lenz",
	  "Lenzen",
	  "Leo",
	  "Lepthin",
	  "Lesch",
	  "Leschnik",
	  "Letzelter",
	  "Lewin",
	  "Lewke",
	  "Leyckes",
	  "Lg",
	  "Lichtenfeld",
	  "Lichtenhagen",
	  "Lichtl",
	  "Liebach",
	  "Liebe",
	  "Liebich",
	  "Liebold",
	  "Lieder",
	  "Lienshöft",
	  "Linden",
	  "Lindenberg",
	  "Lindenmayer",
	  "Lindner",
	  "Linke",
	  "Linnenbaum",
	  "Lippe",
	  "Lipske",
	  "Lipus",
	  "Lischka",
	  "Lobinger",
	  "Logsch",
	  "Lohmann",
	  "Lohre",
	  "Lohse",
	  "Lokar",
	  "Loogen",
	  "Lorenz",
	  "Losch",
	  "Loska",
	  "Lott",
	  "Loy",
	  "Lubina",
	  "Ludolf",
	  "Lufft",
	  "Lukoschek",
	  "Lutje",
	  "Lutz",
	  "Löser",
	  "Löwa",
	  "Lübke",
	  "Maak",
	  "Maczey",
	  "Madetzky",
	  "Madubuko",
	  "Mai",
	  "Maier",
	  "Maisch",
	  "Malek",
	  "Malkus",
	  "Mallmann",
	  "Malucha",
	  "Manns",
	  "Manz",
	  "Marahrens",
	  "Marchewski",
	  "Margis",
	  "Markowski",
	  "Marl",
	  "Marner",
	  "Marquart",
	  "Marschek",
	  "Martel",
	  "Marten",
	  "Martin",
	  "Marx",
	  "Marxen",
	  "Mathes",
	  "Mathies",
	  "Mathiszik",
	  "Matschke",
	  "Mattern",
	  "Matthes",
	  "Matula",
	  "Mau",
	  "Maurer",
	  "Mauroff",
	  "May",
	  "Maybach",
	  "Mayer",
	  "Mebold",
	  "Mehl",
	  "Mehlhorn",
	  "Mehlorn",
	  "Meier",
	  "Meisch",
	  "Meissner",
	  "Meloni",
	  "Melzer",
	  "Menga",
	  "Menne",
	  "Mensah",
	  "Mensing",
	  "Merkel",
	  "Merseburg",
	  "Mertens",
	  "Mesloh",
	  "Metzger",
	  "Metzner",
	  "Mewes",
	  "Meyer",
	  "Michallek",
	  "Michel",
	  "Mielke",
	  "Mikitenko",
	  "Milde",
	  "Minah",
	  "Mintzlaff",
	  "Mockenhaupt",
	  "Moede",
	  "Moedl",
	  "Moeller",
	  "Moguenara",
	  "Mohr",
	  "Mohrhard",
	  "Molitor",
	  "Moll",
	  "Moller",
	  "Molzan",
	  "Montag",
	  "Moormann",
	  "Mordhorst",
	  "Morgenstern",
	  "Morhelfer",
	  "Moritz",
	  "Moser",
	  "Motchebon",
	  "Motzenbbäcker",
	  "Mrugalla",
	  "Muckenthaler",
	  "Mues",
	  "Muller",
	  "Mulrain",
	  "Mächtig",
	  "Mäder",
	  "Möcks",
	  "Mögenburg",
	  "Möhsner",
	  "Möldner",
	  "Möllenbeck",
	  "Möller",
	  "Möllinger",
	  "Mörsch",
	  "Mühleis",
	  "Müller",
	  "Münch",
	  "Nabein",
	  "Nabow",
	  "Nagel",
	  "Nannen",
	  "Nastvogel",
	  "Nau",
	  "Naubert",
	  "Naumann",
	  "Ne",
	  "Neimke",
	  "Nerius",
	  "Neubauer",
	  "Neubert",
	  "Neuendorf",
	  "Neumair",
	  "Neumann",
	  "Neupert",
	  "Neurohr",
	  "Neuschwander",
	  "Newton",
	  "Ney",
	  "Nicolay",
	  "Niedermeier",
	  "Nieklauson",
	  "Niklaus",
	  "Nitzsche",
	  "Noack",
	  "Nodler",
	  "Nolte",
	  "Normann",
	  "Norris",
	  "Northoff",
	  "Nowak",
	  "Nussbeck",
	  "Nwachukwu",
	  "Nytra",
	  "Nöh",
	  "Oberem",
	  "Obergföll",
	  "Obermaier",
	  "Ochs",
	  "Oeser",
	  "Olbrich",
	  "Onnen",
	  "Ophey",
	  "Oppong",
	  "Orth",
	  "Orthmann",
	  "Oschkenat",
	  "Osei",
	  "Osenberg",
	  "Ostendarp",
	  "Ostwald",
	  "Otte",
	  "Otto",
	  "Paesler",
	  "Pajonk",
	  "Pallentin",
	  "Panzig",
	  "Paschke",
	  "Patzwahl",
	  "Paukner",
	  "Peselman",
	  "Peter",
	  "Peters",
	  "Petzold",
	  "Pfeiffer",
	  "Pfennig",
	  "Pfersich",
	  "Pfingsten",
	  "Pflieger",
	  "Pflügner",
	  "Philipp",
	  "Pichlmaier",
	  "Piesker",
	  "Pietsch",
	  "Pingpank",
	  "Pinnock",
	  "Pippig",
	  "Pitschugin",
	  "Plank",
	  "Plass",
	  "Platzer",
	  "Plauk",
	  "Plautz",
	  "Pletsch",
	  "Plotzitzka",
	  "Poehn",
	  "Poeschl",
	  "Pogorzelski",
	  "Pohl",
	  "Pohland",
	  "Pohle",
	  "Polifka",
	  "Polizzi",
	  "Pollmächer",
	  "Pomp",
	  "Ponitzsch",
	  "Porsche",
	  "Porth",
	  "Poschmann",
	  "Poser",
	  "Pottel",
	  "Prah",
	  "Prange",
	  "Prediger",
	  "Pressler",
	  "Preuk",
	  "Preuss",
	  "Prey",
	  "Priemer",
	  "Proske",
	  "Pusch",
	  "Pöche",
	  "Pöge",
	  "Raabe",
	  "Rabenstein",
	  "Rach",
	  "Radtke",
	  "Rahn",
	  "Ranftl",
	  "Rangen",
	  "Ranz",
	  "Rapp",
	  "Rath",
	  "Rau",
	  "Raubuch",
	  "Raukuc",
	  "Rautenkranz",
	  "Rehwagen",
	  "Reiber",
	  "Reichardt",
	  "Reichel",
	  "Reichling",
	  "Reif",
	  "Reifenrath",
	  "Reimann",
	  "Reinberg",
	  "Reinelt",
	  "Reinhardt",
	  "Reinke",
	  "Reitze",
	  "Renk",
	  "Rentz",
	  "Renz",
	  "Reppin",
	  "Restle",
	  "Restorff",
	  "Retzke",
	  "Reuber",
	  "Reumann",
	  "Reus",
	  "Reuss",
	  "Reusse",
	  "Rheder",
	  "Rhoden",
	  "Richards",
	  "Richter",
	  "Riedel",
	  "Riediger",
	  "Rieger",
	  "Riekmann",
	  "Riepl",
	  "Riermeier",
	  "Riester",
	  "Riethmüller",
	  "Rietmüller",
	  "Rietscher",
	  "Ringel",
	  "Ringer",
	  "Rink",
	  "Ripken",
	  "Ritosek",
	  "Ritschel",
	  "Ritter",
	  "Rittweg",
	  "Ritz",
	  "Roba",
	  "Rockmeier",
	  "Rodehau",
	  "Rodowski",
	  "Roecker",
	  "Roggatz",
	  "Rohländer",
	  "Rohrer",
	  "Rokossa",
	  "Roleder",
	  "Roloff",
	  "Roos",
	  "Rosbach",
	  "Roschinsky",
	  "Rose",
	  "Rosenauer",
	  "Rosenbauer",
	  "Rosenthal",
	  "Rosksch",
	  "Rossberg",
	  "Rossler",
	  "Roth",
	  "Rother",
	  "Ruch",
	  "Ruckdeschel",
	  "Rumpf",
	  "Rupprecht",
	  "Ruth",
	  "Ryjikh",
	  "Ryzih",
	  "Rädler",
	  "Räntsch",
	  "Rödiger",
	  "Röse",
	  "Röttger",
	  "Rücker",
	  "Rüdiger",
	  "Rüter",
	  "Sachse",
	  "Sack",
	  "Saflanis",
	  "Sagafe",
	  "Sagonas",
	  "Sahner",
	  "Saile",
	  "Sailer",
	  "Salow",
	  "Salzer",
	  "Salzmann",
	  "Sammert",
	  "Sander",
	  "Sarvari",
	  "Sattelmaier",
	  "Sauer",
	  "Sauerland",
	  "Saumweber",
	  "Savoia",
	  "Scc",
	  "Schacht",
	  "Schaefer",
	  "Schaffarzik",
	  "Schahbasian",
	  "Scharf",
	  "Schedler",
	  "Scheer",
	  "Schelk",
	  "Schellenbeck",
	  "Schembera",
	  "Schenk",
	  "Scherbarth",
	  "Scherer",
	  "Schersing",
	  "Scherz",
	  "Scheurer",
	  "Scheuring",
	  "Scheytt",
	  "Schielke",
	  "Schieskow",
	  "Schildhauer",
	  "Schilling",
	  "Schima",
	  "Schimmer",
	  "Schindzielorz",
	  "Schirmer",
	  "Schirrmeister",
	  "Schlachter",
	  "Schlangen",
	  "Schlawitz",
	  "Schlechtweg",
	  "Schley",
	  "Schlicht",
	  "Schlitzer",
	  "Schmalzle",
	  "Schmid",
	  "Schmidt",
	  "Schmidtchen",
	  "Schmitt",
	  "Schmitz",
	  "Schmuhl",
	  "Schneider",
	  "Schnelting",
	  "Schnieder",
	  "Schniedermeier",
	  "Schnürer",
	  "Schoberg",
	  "Scholz",
	  "Schonberg",
	  "Schondelmaier",
	  "Schorr",
	  "Schott",
	  "Schottmann",
	  "Schouren",
	  "Schrader",
	  "Schramm",
	  "Schreck",
	  "Schreiber",
	  "Schreiner",
	  "Schreiter",
	  "Schroder",
	  "Schröder",
	  "Schuermann",
	  "Schuff",
	  "Schuhaj",
	  "Schuldt",
	  "Schult",
	  "Schulte",
	  "Schultz",
	  "Schultze",
	  "Schulz",
	  "Schulze",
	  "Schumacher",
	  "Schumann",
	  "Schupp",
	  "Schuri",
	  "Schuster",
	  "Schwab",
	  "Schwalm",
	  "Schwanbeck",
	  "Schwandke",
	  "Schwanitz",
	  "Schwarthoff",
	  "Schwartz",
	  "Schwarz",
	  "Schwarzer",
	  "Schwarzkopf",
	  "Schwarzmeier",
	  "Schwatlo",
	  "Schweisfurth",
	  "Schwennen",
	  "Schwerdtner",
	  "Schwidde",
	  "Schwirkschlies",
	  "Schwuchow",
	  "Schäfer",
	  "Schäffel",
	  "Schäffer",
	  "Schäning",
	  "Schöckel",
	  "Schönball",
	  "Schönbeck",
	  "Schönberg",
	  "Schönebeck",
	  "Schönenberger",
	  "Schönfeld",
	  "Schönherr",
	  "Schönlebe",
	  "Schötz",
	  "Schüler",
	  "Schüppel",
	  "Schütz",
	  "Schütze",
	  "Seeger",
	  "Seelig",
	  "Sehls",
	  "Seibold",
	  "Seidel",
	  "Seiders",
	  "Seigel",
	  "Seiler",
	  "Seitz",
	  "Semisch",
	  "Senkel",
	  "Sewald",
	  "Siebel",
	  "Siebert",
	  "Siegling",
	  "Sielemann",
	  "Siemon",
	  "Siener",
	  "Sievers",
	  "Siewert",
	  "Sihler",
	  "Sillah",
	  "Simon",
	  "Sinnhuber",
	  "Sischka",
	  "Skibicki",
	  "Sladek",
	  "Slotta",
	  "Smieja",
	  "Soboll",
	  "Sokolowski",
	  "Soller",
	  "Sollner",
	  "Sommer",
	  "Somssich",
	  "Sonn",
	  "Sonnabend",
	  "Spahn",
	  "Spank",
	  "Spelmeyer",
	  "Spiegelburg",
	  "Spielvogel",
	  "Spinner",
	  "Spitzmüller",
	  "Splinter",
	  "Sporrer",
	  "Sprenger",
	  "Spöttel",
	  "Stahl",
	  "Stang",
	  "Stanger",
	  "Stauss",
	  "Steding",
	  "Steffen",
	  "Steffny",
	  "Steidl",
	  "Steigauf",
	  "Stein",
	  "Steinecke",
	  "Steinert",
	  "Steinkamp",
	  "Steinmetz",
	  "Stelkens",
	  "Stengel",
	  "Stengl",
	  "Stenzel",
	  "Stepanov",
	  "Stephan",
	  "Stern",
	  "Steuk",
	  "Stief",
	  "Stifel",
	  "Stoll",
	  "Stolle",
	  "Stolz",
	  "Storl",
	  "Storp",
	  "Stoutjesdijk",
	  "Stratmann",
	  "Straub",
	  "Strausa",
	  "Streck",
	  "Streese",
	  "Strege",
	  "Streit",
	  "Streller",
	  "Strieder",
	  "Striezel",
	  "Strogies",
	  "Strohschank",
	  "Strunz",
	  "Strutz",
	  "Stube",
	  "Stöckert",
	  "Stöppler",
	  "Stöwer",
	  "Stürmer",
	  "Suffa",
	  "Sujew",
	  "Sussmann",
	  "Suthe",
	  "Sutschet",
	  "Swillims",
	  "Szendrei",
	  "Sören",
	  "Sürth",
	  "Tafelmeier",
	  "Tang",
	  "Tasche",
	  "Taufratshofer",
	  "Tegethof",
	  "Teichmann",
	  "Tepper",
	  "Terheiden",
	  "Terlecki",
	  "Teufel",
	  "Theele",
	  "Thieke",
	  "Thimm",
	  "Thiomas",
	  "Thomas",
	  "Thriene",
	  "Thränhardt",
	  "Thust",
	  "Thyssen",
	  "Thöne",
	  "Tidow",
	  "Tiedtke",
	  "Tietze",
	  "Tilgner",
	  "Tillack",
	  "Timmermann",
	  "Tischler",
	  "Tischmann",
	  "Tittman",
	  "Tivontschik",
	  "Tonat",
	  "Tonn",
	  "Trampeli",
	  "Trauth",
	  "Trautmann",
	  "Travan",
	  "Treff",
	  "Tremmel",
	  "Tress",
	  "Tsamonikian",
	  "Tschiers",
	  "Tschirch",
	  "Tuch",
	  "Tucholke",
	  "Tudow",
	  "Tuschmo",
	  "Tächl",
	  "Többen",
	  "Töpfer",
	  "Uhlemann",
	  "Uhlig",
	  "Uhrig",
	  "Uibel",
	  "Uliczka",
	  "Ullmann",
	  "Ullrich",
	  "Umbach",
	  "Umlauft",
	  "Umminger",
	  "Unger",
	  "Unterpaintner",
	  "Urban",
	  "Urbaniak",
	  "Urbansky",
	  "Urhig",
	  "Vahlensieck",
	  "Van",
	  "Vangermain",
	  "Vater",
	  "Venghaus",
	  "Verniest",
	  "Verzi",
	  "Vey",
	  "Viellehner",
	  "Vieweg",
	  "Voelkel",
	  "Vogel",
	  "Vogelgsang",
	  "Vogt",
	  "Voigt",
	  "Vokuhl",
	  "Volk",
	  "Volker",
	  "Volkmann",
	  "Von",
	  "Vona",
	  "Vontein",
	  "Wachenbrunner",
	  "Wachtel",
	  "Wagner",
	  "Waibel",
	  "Wakan",
	  "Waldmann",
	  "Wallner",
	  "Wallstab",
	  "Walter",
	  "Walther",
	  "Walton",
	  "Walz",
	  "Wanner",
	  "Wartenberg",
	  "Waschbüsch",
	  "Wassilew",
	  "Wassiluk",
	  "Weber",
	  "Wehrsen",
	  "Weidlich",
	  "Weidner",
	  "Weigel",
	  "Weight",
	  "Weiler",
	  "Weimer",
	  "Weis",
	  "Weiss",
	  "Weller",
	  "Welsch",
	  "Welz",
	  "Welzel",
	  "Weniger",
	  "Wenk",
	  "Werle",
	  "Werner",
	  "Werrmann",
	  "Wessel",
	  "Wessinghage",
	  "Weyel",
	  "Wezel",
	  "Wichmann",
	  "Wickert",
	  "Wiebe",
	  "Wiechmann",
	  "Wiegelmann",
	  "Wierig",
	  "Wiese",
	  "Wieser",
	  "Wilhelm",
	  "Wilky",
	  "Will",
	  "Willwacher",
	  "Wilts",
	  "Wimmer",
	  "Winkelmann",
	  "Winkler",
	  "Winter",
	  "Wischek",
	  "Wischer",
	  "Wissing",
	  "Wittich",
	  "Wittl",
	  "Wolf",
	  "Wolfarth",
	  "Wolff",
	  "Wollenberg",
	  "Wollmann",
	  "Woytkowska",
	  "Wujak",
	  "Wurm",
	  "Wyludda",
	  "Wölpert",
	  "Wöschler",
	  "Wühn",
	  "Wünsche",
	  "Zach",
	  "Zaczkiewicz",
	  "Zahn",
	  "Zaituc",
	  "Zandt",
	  "Zanner",
	  "Zapletal",
	  "Zauber",
	  "Zeidler",
	  "Zekl",
	  "Zender",
	  "Zeuch",
	  "Zeyen",
	  "Zeyhle",
	  "Ziegler",
	  "Zimanyi",
	  "Zimmer",
	  "Zimmermann",
	  "Zinser",
	  "Zintl",
	  "Zipp",
	  "Zipse",
	  "Zschunke",
	  "Zuber",
	  "Zwiener",
	  "Zümsande",
	  "Östringer",
	  "Überacker"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{nobility_title_prefix} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "zu",
	  "von",
	  "vom",
	  "von der"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dr.",
	  "Prof. Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01 #######",
	  "01#######",
	  "+43-1-#######",
	  "+431#######",
	  "0#### ####",
	  "0#########",
	  "+43-####-####",
	  "+43 ########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(822);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "CH",
	  "CH",
	  "CH",
	  "DE",
	  "AT",
	  "US",
	  "LI",
	  "US",
	  "HK",
	  "VN"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Schweiz"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country_code = __webpack_require__(824);
	address.postcode = __webpack_require__(827);
	address.default_country = __webpack_require__(825);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1###",
	  "2###",
	  "3###",
	  "4###",
	  "5###",
	  "6###",
	  "7###",
	  "8###",
	  "9###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(830);
	company.name = __webpack_require__(829);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AG",
	  "GmbH",
	  "und Söhne",
	  "und Partner",
	  "& Co.",
	  "Gruppe",
	  "LLC",
	  "Inc."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de_CH = {};
	module['exports'] = de_CH;
	de_CH.title = "German (Switzerland)";
	de_CH.address = __webpack_require__(826);
	de_CH.company = __webpack_require__(828);
	de_CH.internet = __webpack_require__(833);
	de_CH.name = __webpack_require__(835);
	de_CH.phone_number = __webpack_require__(840);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "net",
	  "biz",
	  "ch",
	  "de",
	  "li",
	  "at",
	  "ch",
	  "ch"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(832);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	    "Adolf",
	    "Adrian",
	    "Agnes",
	    "Alain",
	    "Albert",
	    "Alberto",
	    "Aldo",
	    "Alex",
	    "Alexander",
	    "Alexandre",
	    "Alfons",
	    "Alfred",
	    "Alice",
	    "Alois",
	    "André",
	    "Andrea",
	    "Andreas",
	    "Angela",
	    "Angelo",
	    "Anita",
	    "Anna",
	    "Anne",
	    "Anne-Marie",
	    "Annemarie",
	    "Antoine",
	    "Anton",
	    "Antonio",
	    "Armin",
	    "Arnold",
	    "Arthur",
	    "Astrid",
	    "Barbara",
	    "Beat",
	    "Beatrice",
	    "Beatrix",
	    "Bernadette",
	    "Bernard",
	    "Bernhard",
	    "Bettina",
	    "Brigitta",
	    "Brigitte",
	    "Bruno",
	    "Carlo",
	    "Carmen",
	    "Caroline",
	    "Catherine",
	    "Chantal",
	    "Charles",
	    "Charlotte",
	    "Christa",
	    "Christian",
	    "Christiane",
	    "Christina",
	    "Christine",
	    "Christoph",
	    "Christophe",
	    "Claire",
	    "Claude",
	    "Claudia",
	    "Claudine",
	    "Claudio",
	    "Corinne",
	    "Cornelia",
	    "Daniel",
	    "Daniela",
	    "Daniele",
	    "Danielle",
	    "David",
	    "Denis",
	    "Denise",
	    "Didier",
	    "Dieter",
	    "Dominik",
	    "Dominique",
	    "Dora",
	    "Doris",
	    "Edgar",
	    "Edith",
	    "Eduard",
	    "Edwin",
	    "Eliane",
	    "Elisabeth",
	    "Elsa",
	    "Elsbeth",
	    "Emil",
	    "Enrico",
	    "Eric",
	    "Erica",
	    "Erich",
	    "Erika",
	    "Ernst",
	    "Erwin",
	    "Esther",
	    "Eugen",
	    "Eva",
	    "Eveline",
	    "Evelyne",
	    "Fabienne",
	    "Felix",
	    "Ferdinand",
	    "Florence",
	    "Francesco",
	    "Francis",
	    "Franco",
	    "François",
	    "Françoise",
	    "Frank",
	    "Franz",
	    "Franziska",
	    "Frédéric",
	    "Fredy",
	    "Fridolin",
	    "Friedrich",
	    "Fritz",
	    "Gabriel",
	    "Gabriela",
	    "Gabrielle",
	    "Georg",
	    "Georges",
	    "Gérald",
	    "Gérard",
	    "Gerhard",
	    "Gertrud",
	    "Gianni",
	    "Gilbert",
	    "Giorgio",
	    "Giovanni",
	    "Gisela",
	    "Giuseppe",
	    "Gottfried",
	    "Guido",
	    "Guy",
	    "Hanna",
	    "Hans",
	    "Hans-Peter",
	    "Hans-Rudolf",
	    "Hans-Ulrich",
	    "Hansjörg",
	    "Hanspeter",
	    "Hansruedi",
	    "Hansueli",
	    "Harry",
	    "Heidi",
	    "Heinrich",
	    "Heinz",
	    "Helen",
	    "Helena",
	    "Helene",
	    "Helmut",
	    "Henri",
	    "Herbert",
	    "Hermann",
	    "Hildegard",
	    "Hubert",
	    "Hugo",
	    "Ingrid",
	    "Irene",
	    "Iris",
	    "Isabelle",
	    "Jacqueline",
	    "Jacques",
	    "Jakob",
	    "Jan",
	    "Janine",
	    "Jean",
	    "Jean-Claude",
	    "Jean-Daniel",
	    "Jean-François",
	    "Jean-Jacques",
	    "Jean-Louis",
	    "Jean-Luc",
	    "Jean-Marc",
	    "Jean-Marie",
	    "Jean-Paul",
	    "Jean-Pierre",
	    "Johann",
	    "Johanna",
	    "Johannes",
	    "John",
	    "Jolanda",
	    "Jörg",
	    "Josef",
	    "Joseph",
	    "Josette",
	    "Josiane",
	    "Judith",
	    "Julia",
	    "Jürg",
	    "Karin",
	    "Karl",
	    "Katharina",
	    "Klaus",
	    "Konrad",
	    "Kurt",
	    "Laura",
	    "Laurence",
	    "Laurent",
	    "Leo",
	    "Liliane",
	    "Liselotte",
	    "Louis",
	    "Luca",
	    "Luigi",
	    "Lukas",
	    "Lydia",
	    "Madeleine",
	    "Maja",
	    "Manfred",
	    "Manuel",
	    "Manuela",
	    "Marc",
	    "Marcel",
	    "Marco",
	    "Margrit",
	    "Margrith",
	    "Maria",
	    "Marianne",
	    "Mario",
	    "Marion",
	    "Markus",
	    "Marlène",
	    "Marlies",
	    "Marlis",
	    "Martha",
	    "Martin",
	    "Martina",
	    "Martine",
	    "Massimo",
	    "Matthias",
	    "Maurice",
	    "Max",
	    "Maya",
	    "Michael",
	    "Michel",
	    "Michele",
	    "Micheline",
	    "Monica",
	    "Monika",
	    "Monique",
	    "Myriam",
	    "Nadia",
	    "Nadja",
	    "Nathalie",
	    "Nelly",
	    "Nicolas",
	    "Nicole",
	    "Niklaus",
	    "Norbert",
	    "Olivier",
	    "Oskar",
	    "Otto",
	    "Paola",
	    "Paolo",
	    "Pascal",
	    "Patricia",
	    "Patrick",
	    "Paul",
	    "Peter",
	    "Petra",
	    "Philipp",
	    "Philippe",
	    "Pia",
	    "Pierre",
	    "Pierre-Alain",
	    "Pierre-André",
	    "Pius",
	    "Priska",
	    "Rainer",
	    "Raymond",
	    "Regina",
	    "Regula",
	    "Reinhard",
	    "Remo",
	    "Renata",
	    "Renate",
	    "Renato",
	    "Rene",
	    "René",
	    "Reto",
	    "Richard",
	    "Rita",
	    "Robert",
	    "Roberto",
	    "Roger",
	    "Roland",
	    "Rolf",
	    "Roman",
	    "Rosa",
	    "Rosemarie",
	    "Rosmarie",
	    "Rudolf",
	    "Ruedi",
	    "Ruth",
	    "Sabine",
	    "Samuel",
	    "Sandra",
	    "Sandro",
	    "Serge",
	    "Silvia",
	    "Silvio",
	    "Simon",
	    "Simone",
	    "Sonia",
	    "Sonja",
	    "Stefan",
	    "Stephan",
	    "Stéphane",
	    "Stéphanie",
	    "Susanna",
	    "Susanne",
	    "Suzanne",
	    "Sylvia",
	    "Sylvie",
	    "Theo",
	    "Theodor",
	    "Therese",
	    "Thomas",
	    "Toni",
	    "Ueli",
	    "Ulrich",
	    "Urs",
	    "Ursula",
	    "Verena",
	    "Véronique",
	    "Victor",
	    "Viktor",
	    "Vreni",
	    "Walter",
	    "Werner",
	    "Willi",
	    "Willy",
	    "Wolfgang",
	    "Yolande",
	    "Yves",
	    "Yvette",
	    "Yvonne",
	
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(834);
	name.last_name = __webpack_require__(836);
	name.prefix = __webpack_require__(838);
	name.name = __webpack_require__(837);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	    "Ackermann",
	    "Aebi",
	    "Albrecht",
	    "Ammann",
	    "Amrein",
	    "Arnold",
	    "Bachmann",
	    "Bader",
	    "Bär",
	    "Bättig",
	    "Bauer",
	    "Baumann",
	    "Baumgartner",
	    "Baur",
	    "Beck",
	    "Benz",
	    "Berger",
	    "Bernasconi",
	    "Betschart",
	    "Bianchi",
	    "Bieri",
	    "Blaser",
	    "Blum",
	    "Bolliger",
	    "Bosshard",
	    "Braun",
	    "Brun",
	    "Brunner",
	    "Bucher",
	    "Bühler",
	    "Bühlmann",
	    "Burri",
	    "Christen",
	    "Egger",
	    "Egli",
	    "Eichenberger",
	    "Erni",
	    "Ernst",
	    "Eugster",
	    "Fankhauser",
	    "Favre",
	    "Fehr",
	    "Felber",
	    "Felder",
	    "Ferrari",
	    "Fischer",
	    "Flückiger",
	    "Forster",
	    "Frei",
	    "Frey",
	    "Frick",
	    "Friedli",
	    "Fuchs",
	    "Furrer",
	    "Gasser",
	    "Geiger",
	    "Gerber",
	    "Gfeller",
	    "Giger",
	    "Gloor",
	    "Graf",
	    "Grob",
	    "Gross",
	    "Gut",
	    "Haas",
	    "Häfliger",
	    "Hafner",
	    "Hartmann",
	    "Hasler",
	    "Hauser",
	    "Hermann",
	    "Herzog",
	    "Hess",
	    "Hirt",
	    "Hodel",
	    "Hofer",
	    "Hoffmann",
	    "Hofmann",
	    "Hofstetter",
	    "Hotz",
	    "Huber",
	    "Hug",
	    "Hunziker",
	    "Hürlimann",
	    "Imhof",
	    "Isler",
	    "Iten",
	    "Jäggi",
	    "Jenni",
	    "Jost",
	    "Kägi",
	    "Kaiser",
	    "Kälin",
	    "Käser",
	    "Kaufmann",
	    "Keller",
	    "Kern",
	    "Kessler",
	    "Knecht",
	    "Koch",
	    "Kohler",
	    "Kuhn",
	    "Küng",
	    "Kunz",
	    "Lang",
	    "Lanz",
	    "Lehmann",
	    "Leu",
	    "Leunberger",
	    "Lüscher",
	    "Lustenberger",
	    "Lüthi",
	    "Lutz",
	    "Mäder",
	    "Maier",
	    "Marti",
	    "Martin",
	    "Maurer",
	    "Mayer",
	    "Meier",
	    "Meili",
	    "Meister",
	    "Merz",
	    "Mettler",
	    "Meyer",
	    "Michel",
	    "Moser",
	    "Müller",
	    "Näf",
	    "Ott",
	    "Peter",
	    "Pfister",
	    "Portmann",
	    "Probst",
	    "Rey",
	    "Ritter",
	    "Roos",
	    "Roth",
	    "Rüegg",
	    "Schäfer",
	    "Schaller",
	    "Schär",
	    "Schärer",
	    "Schaub",
	    "Scheidegger",
	    "Schenk",
	    "Scherrer",
	    "Schlatter",
	    "Schmid",
	    "Schmidt",
	    "Schneider",
	    "Schnyder",
	    "Schoch",
	    "Schuler",
	    "Schumacher",
	    "Schürch",
	    "Schwab",
	    "Schwarz",
	    "Schweizer",
	    "Seiler",
	    "Senn",
	    "Sidler",
	    "Siegrist",
	    "Sigrist",
	    "Spörri",
	    "Stadelmann",
	    "Stalder",
	    "Staub",
	    "Stauffer",
	    "Steffen",
	    "Steiger",
	    "Steiner",
	    "Steinmann",
	    "Stettler",
	    "Stocker",
	    "Stöckli",
	    "Stucki",
	    "Studer",
	    "Stutz",
	    "Suter",
	    "Sutter",
	    "Tanner",
	    "Thommen",
	    "Tobler",
	    "Vogel",
	    "Vogt",
	    "Wagner",
	    "Walder",
	    "Walter",
	    "Weber",
	    "Wegmann",
	    "Wehrli",
	    "Weibel",
	    "Wenger",
	    "Wettstein",
	    "Widmer",
	    "Winkler",
	    "Wirth",
	    "Wirz",
	    "Wolf",
	    "Wüthrich",
	    "Wyss",
	    "Zbinden",
	    "Zehnder",
	    "Ziegler",
	    "Zimmermann",
	    "Zingg",
	    "Zollinger",
	    "Zürcher"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Hr.",
	  "Fr.",
	  "Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0800 ### ###",
	  "0800 ## ## ##",
	  "0## ### ## ##",
	  "0## ### ## ##",
	  "+41 ## ### ## ##",
	  "0900 ### ###",
	  "076 ### ## ##",
	  "+4178 ### ## ##",
	  "0041 79 ### ## ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(839);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "North",
	  "East",
	  "West",
	  "South",
	  "New",
	  "Lake",
	  "Port"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "town",
	  "ton",
	  "land",
	  "ville",
	  "berg",
	  "burgh",
	  "borough",
	  "bury",
	  "view",
	  "port",
	  "mouth",
	  "stad",
	  "furt",
	  "chester",
	  "mouth",
	  "fort",
	  "haven",
	  "side",
	  "shire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afghanistan",
	  "Albania",
	  "Algeria",
	  "American Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarctica (the territory South of 60 deg S)",
	  "Antigua and Barbuda",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbaijan",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesh",
	  "Barbados",
	  "Belarus",
	  "Belgium",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolivia",
	  "Bosnia and Herzegovina",
	  "Botswana",
	  "Bouvet Island (Bouvetoya)",
	  "Brazil",
	  "British Indian Ocean Territory (Chagos Archipelago)",
	  "Brunei Darussalam",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Cambodia",
	  "Cameroon",
	  "Canada",
	  "Cape Verde",
	  "Cayman Islands",
	  "Central African Republic",
	  "Chad",
	  "Chile",
	  "China",
	  "Christmas Island",
	  "Cocos (Keeling) Islands",
	  "Colombia",
	  "Comoros",
	  "Congo",
	  "Congo",
	  "Cook Islands",
	  "Costa Rica",
	  "Cote d'Ivoire",
	  "Croatia",
	  "Cuba",
	  "Cyprus",
	  "Czech Republic",
	  "Denmark",
	  "Djibouti",
	  "Dominica",
	  "Dominican Republic",
	  "Ecuador",
	  "Egypt",
	  "El Salvador",
	  "Equatorial Guinea",
	  "Eritrea",
	  "Estonia",
	  "Ethiopia",
	  "Faroe Islands",
	  "Falkland Islands (Malvinas)",
	  "Fiji",
	  "Finland",
	  "France",
	  "French Guiana",
	  "French Polynesia",
	  "French Southern Territories",
	  "Gabon",
	  "Gambia",
	  "Georgia",
	  "Germany",
	  "Ghana",
	  "Gibraltar",
	  "Greece",
	  "Greenland",
	  "Grenada",
	  "Guadeloupe",
	  "Guam",
	  "Guatemala",
	  "Guernsey",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard Island and McDonald Islands",
	  "Holy See (Vatican City State)",
	  "Honduras",
	  "Hong Kong",
	  "Hungary",
	  "Iceland",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Iraq",
	  "Ireland",
	  "Isle of Man",
	  "Israel",
	  "Italy",
	  "Jamaica",
	  "Japan",
	  "Jersey",
	  "Jordan",
	  "Kazakhstan",
	  "Kenya",
	  "Kiribati",
	  "Democratic People's Republic of Korea",
	  "Republic of Korea",
	  "Kuwait",
	  "Kyrgyz Republic",
	  "Lao People's Democratic Republic",
	  "Latvia",
	  "Lebanon",
	  "Lesotho",
	  "Liberia",
	  "Libyan Arab Jamahiriya",
	  "Liechtenstein",
	  "Lithuania",
	  "Luxembourg",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malaysia",
	  "Maldives",
	  "Mali",
	  "Malta",
	  "Marshall Islands",
	  "Martinique",
	  "Mauritania",
	  "Mauritius",
	  "Mayotte",
	  "Mexico",
	  "Micronesia",
	  "Moldova",
	  "Monaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Morocco",
	  "Mozambique",
	  "Myanmar",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Netherlands Antilles",
	  "Netherlands",
	  "New Caledonia",
	  "New Zealand",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Norfolk Island",
	  "Northern Mariana Islands",
	  "Norway",
	  "Oman",
	  "Pakistan",
	  "Palau",
	  "Palestinian Territory",
	  "Panama",
	  "Papua New Guinea",
	  "Paraguay",
	  "Peru",
	  "Philippines",
	  "Pitcairn Islands",
	  "Poland",
	  "Portugal",
	  "Puerto Rico",
	  "Qatar",
	  "Reunion",
	  "Romania",
	  "Russian Federation",
	  "Rwanda",
	  "Saint Barthelemy",
	  "Saint Helena",
	  "Saint Kitts and Nevis",
	  "Saint Lucia",
	  "Saint Martin",
	  "Saint Pierre and Miquelon",
	  "Saint Vincent and the Grenadines",
	  "Samoa",
	  "San Marino",
	  "Sao Tome and Principe",
	  "Saudi Arabia",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leone",
	  "Singapore",
	  "Slovakia (Slovak Republic)",
	  "Slovenia",
	  "Solomon Islands",
	  "Somalia",
	  "South Africa",
	  "South Georgia and the South Sandwich Islands",
	  "Spain",
	  "Sri Lanka",
	  "Sudan",
	  "Suriname",
	  "Svalbard & Jan Mayen Islands",
	  "Swaziland",
	  "Sweden",
	  "Switzerland",
	  "Syrian Arab Republic",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Thailand",
	  "Timor-Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad and Tobago",
	  "Tunisia",
	  "Turkey",
	  "Turkmenistan",
	  "Turks and Caicos Islands",
	  "Tuvalu",
	  "Uganda",
	  "Ukraine",
	  "United Arab Emirates",
	  "United Kingdom",
	  "United States of America",
	  "United States Minor Outlying Islands",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Virgin Islands, British",
	  "Virgin Islands, U.S.",
	  "Wallis and Futuna",
	  "Western Sahara",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AD",
	  "AE",
	  "AF",
	  "AG",
	  "AI",
	  "AL",
	  "AM",
	  "AO",
	  "AQ",
	  "AR",
	  "AS",
	  "AT",
	  "AU",
	  "AW",
	  "AX",
	  "AZ",
	  "BA",
	  "BB",
	  "BD",
	  "BE",
	  "BF",
	  "BG",
	  "BH",
	  "BI",
	  "BJ",
	  "BL",
	  "BM",
	  "BN",
	  "BO",
	  "BQ",
	  "BQ",
	  "BR",
	  "BS",
	  "BT",
	  "BV",
	  "BW",
	  "BY",
	  "BZ",
	  "CA",
	  "CC",
	  "CD",
	  "CF",
	  "CG",
	  "CH",
	  "CI",
	  "CK",
	  "CL",
	  "CM",
	  "CN",
	  "CO",
	  "CR",
	  "CU",
	  "CV",
	  "CW",
	  "CX",
	  "CY",
	  "CZ",
	  "DE",
	  "DJ",
	  "DK",
	  "DM",
	  "DO",
	  "DZ",
	  "EC",
	  "EE",
	  "EG",
	  "EH",
	  "ER",
	  "ES",
	  "ET",
	  "FI",
	  "FJ",
	  "FK",
	  "FM",
	  "FO",
	  "FR",
	  "GA",
	  "GB",
	  "GD",
	  "GE",
	  "GF",
	  "GG",
	  "GH",
	  "GI",
	  "GL",
	  "GM",
	  "GN",
	  "GP",
	  "GQ",
	  "GR",
	  "GS",
	  "GT",
	  "GU",
	  "GW",
	  "GY",
	  "HK",
	  "HM",
	  "HN",
	  "HR",
	  "HT",
	  "HU",
	  "ID",
	  "IE",
	  "IL",
	  "IM",
	  "IN",
	  "IO",
	  "IQ",
	  "IR",
	  "IS",
	  "IT",
	  "JE",
	  "JM",
	  "JO",
	  "JP",
	  "KE",
	  "KG",
	  "KH",
	  "KI",
	  "KM",
	  "KN",
	  "KP",
	  "KR",
	  "KW",
	  "KY",
	  "KZ",
	  "LA",
	  "LB",
	  "LC",
	  "LI",
	  "LK",
	  "LR",
	  "LS",
	  "LT",
	  "LU",
	  "LV",
	  "LY",
	  "MA",
	  "MC",
	  "MD",
	  "ME",
	  "MF",
	  "MG",
	  "MH",
	  "MK",
	  "ML",
	  "MM",
	  "MN",
	  "MO",
	  "MP",
	  "MQ",
	  "MR",
	  "MS",
	  "MT",
	  "MU",
	  "MV",
	  "MW",
	  "MX",
	  "MY",
	  "MZ",
	  "NA",
	  "NC",
	  "NE",
	  "NF",
	  "NG",
	  "NI",
	  "NL",
	  "NO",
	  "NP",
	  "NR",
	  "NU",
	  "NZ",
	  "OM",
	  "PA",
	  "PE",
	  "PF",
	  "PG",
	  "PH",
	  "PK",
	  "PL",
	  "PM",
	  "PN",
	  "PR",
	  "PS",
	  "PT",
	  "PW",
	  "PY",
	  "QA",
	  "RE",
	  "RO",
	  "RS",
	  "RU",
	  "RW",
	  "SA",
	  "SB",
	  "SC",
	  "SD",
	  "SE",
	  "SG",
	  "SH",
	  "SI",
	  "SJ",
	  "SK",
	  "SL",
	  "SM",
	  "SN",
	  "SO",
	  "SR",
	  "SS",
	  "ST",
	  "SV",
	  "SX",
	  "SY",
	  "SZ",
	  "TC",
	  "TD",
	  "TF",
	  "TG",
	  "TH",
	  "TJ",
	  "TK",
	  "TL",
	  "TM",
	  "TN",
	  "TO",
	  "TR",
	  "TT",
	  "TV",
	  "TW",
	  "TZ",
	  "UA",
	  "UG",
	  "UM",
	  "US",
	  "UY",
	  "UZ",
	  "VA",
	  "VC",
	  "VE",
	  "VG",
	  "VI",
	  "VN",
	  "VU",
	  "WF",
	  "WS",
	  "YE",
	  "YT",
	  "ZA",
	  "ZM",
	  "ZW"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avon",
	  "Bedfordshire",
	  "Berkshire",
	  "Borders",
	  "Buckinghamshire",
	  "Cambridgeshire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "United States of America"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(843);
	address.city_suffix = __webpack_require__(844);
	address.county = __webpack_require__(847);
	address.country = __webpack_require__(845);
	address.country_code = __webpack_require__(846);
	address.building_number = __webpack_require__(841);
	address.street_suffix = __webpack_require__(857);
	address.secondary_address = __webpack_require__(852);
	address.postcode = __webpack_require__(850);
	address.postcode_by_state = __webpack_require__(851);
	address.state = __webpack_require__(853);
	address.state_abbr = __webpack_require__(854);
	address.time_zone = __webpack_require__(858);
	address.city = __webpack_require__(842);
	address.street_name = __webpack_require__(856);
	address.street_address = __webpack_require__(855);
	address.default_country = __webpack_require__(848);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Suite ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alabama",
	  "Alaska",
	  "Arizona",
	  "Arkansas",
	  "California",
	  "Colorado",
	  "Connecticut",
	  "Delaware",
	  "Florida",
	  "Georgia",
	  "Hawaii",
	  "Idaho",
	  "Illinois",
	  "Indiana",
	  "Iowa",
	  "Kansas",
	  "Kentucky",
	  "Louisiana",
	  "Maine",
	  "Maryland",
	  "Massachusetts",
	  "Michigan",
	  "Minnesota",
	  "Mississippi",
	  "Missouri",
	  "Montana",
	  "Nebraska",
	  "Nevada",
	  "New Hampshire",
	  "New Jersey",
	  "New Mexico",
	  "New York",
	  "North Carolina",
	  "North Dakota",
	  "Ohio",
	  "Oklahoma",
	  "Oregon",
	  "Pennsylvania",
	  "Rhode Island",
	  "South Carolina",
	  "South Dakota",
	  "Tennessee",
	  "Texas",
	  "Utah",
	  "Vermont",
	  "Virginia",
	  "Washington",
	  "West Virginia",
	  "Wisconsin",
	  "Wyoming"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AL",
	  "AK",
	  "AZ",
	  "AR",
	  "CA",
	  "CO",
	  "CT",
	  "DE",
	  "FL",
	  "GA",
	  "HI",
	  "ID",
	  "IL",
	  "IN",
	  "IA",
	  "KS",
	  "KY",
	  "LA",
	  "ME",
	  "MD",
	  "MA",
	  "MI",
	  "MN",
	  "MS",
	  "MO",
	  "MT",
	  "NE",
	  "NV",
	  "NH",
	  "NJ",
	  "NM",
	  "NY",
	  "NC",
	  "ND",
	  "OH",
	  "OK",
	  "OR",
	  "PA",
	  "RI",
	  "SC",
	  "SD",
	  "TN",
	  "TX",
	  "UT",
	  "VT",
	  "VA",
	  "WA",
	  "WV",
	  "WI",
	  "WY"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{building_number} #{street_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name} #{street_suffix}",
	  "#{Name.last_name} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alley",
	  "Avenue",
	  "Branch",
	  "Bridge",
	  "Brook",
	  "Brooks",
	  "Burg",
	  "Burgs",
	  "Bypass",
	  "Camp",
	  "Canyon",
	  "Cape",
	  "Causeway",
	  "Center",
	  "Centers",
	  "Circle",
	  "Circles",
	  "Cliff",
	  "Cliffs",
	  "Club",
	  "Common",
	  "Corner",
	  "Corners",
	  "Course",
	  "Court",
	  "Courts",
	  "Cove",
	  "Coves",
	  "Creek",
	  "Crescent",
	  "Crest",
	  "Crossing",
	  "Crossroad",
	  "Curve",
	  "Dale",
	  "Dam",
	  "Divide",
	  "Drive",
	  "Drive",
	  "Drives",
	  "Estate",
	  "Estates",
	  "Expressway",
	  "Extension",
	  "Extensions",
	  "Fall",
	  "Falls",
	  "Ferry",
	  "Field",
	  "Fields",
	  "Flat",
	  "Flats",
	  "Ford",
	  "Fords",
	  "Forest",
	  "Forge",
	  "Forges",
	  "Fork",
	  "Forks",
	  "Fort",
	  "Freeway",
	  "Garden",
	  "Gardens",
	  "Gateway",
	  "Glen",
	  "Glens",
	  "Green",
	  "Greens",
	  "Grove",
	  "Groves",
	  "Harbor",
	  "Harbors",
	  "Haven",
	  "Heights",
	  "Highway",
	  "Hill",
	  "Hills",
	  "Hollow",
	  "Inlet",
	  "Inlet",
	  "Island",
	  "Island",
	  "Islands",
	  "Islands",
	  "Isle",
	  "Isle",
	  "Junction",
	  "Junctions",
	  "Key",
	  "Keys",
	  "Knoll",
	  "Knolls",
	  "Lake",
	  "Lakes",
	  "Land",
	  "Landing",
	  "Lane",
	  "Light",
	  "Lights",
	  "Loaf",
	  "Lock",
	  "Locks",
	  "Locks",
	  "Lodge",
	  "Lodge",
	  "Loop",
	  "Mall",
	  "Manor",
	  "Manors",
	  "Meadow",
	  "Meadows",
	  "Mews",
	  "Mill",
	  "Mills",
	  "Mission",
	  "Mission",
	  "Motorway",
	  "Mount",
	  "Mountain",
	  "Mountain",
	  "Mountains",
	  "Mountains",
	  "Neck",
	  "Orchard",
	  "Oval",
	  "Overpass",
	  "Park",
	  "Parks",
	  "Parkway",
	  "Parkways",
	  "Pass",
	  "Passage",
	  "Path",
	  "Pike",
	  "Pine",
	  "Pines",
	  "Place",
	  "Plain",
	  "Plains",
	  "Plains",
	  "Plaza",
	  "Plaza",
	  "Point",
	  "Points",
	  "Port",
	  "Port",
	  "Ports",
	  "Ports",
	  "Prairie",
	  "Prairie",
	  "Radial",
	  "Ramp",
	  "Ranch",
	  "Rapid",
	  "Rapids",
	  "Rest",
	  "Ridge",
	  "Ridges",
	  "River",
	  "Road",
	  "Road",
	  "Roads",
	  "Roads",
	  "Route",
	  "Row",
	  "Rue",
	  "Run",
	  "Shoal",
	  "Shoals",
	  "Shore",
	  "Shores",
	  "Skyway",
	  "Spring",
	  "Springs",
	  "Springs",
	  "Spur",
	  "Spurs",
	  "Square",
	  "Square",
	  "Squares",
	  "Squares",
	  "Station",
	  "Station",
	  "Stravenue",
	  "Stravenue",
	  "Stream",
	  "Stream",
	  "Street",
	  "Street",
	  "Streets",
	  "Summit",
	  "Summit",
	  "Terrace",
	  "Throughway",
	  "Trace",
	  "Track",
	  "Trafficway",
	  "Trail",
	  "Trail",
	  "Tunnel",
	  "Tunnel",
	  "Turnpike",
	  "Turnpike",
	  "Underpass",
	  "Union",
	  "Unions",
	  "Valley",
	  "Valleys",
	  "Via",
	  "Viaduct",
	  "View",
	  "Views",
	  "Village",
	  "Village",
	  "Villages",
	  "Ville",
	  "Vista",
	  "Vista",
	  "Walk",
	  "Walks",
	  "Wall",
	  "Way",
	  "Ways",
	  "Well",
	  "Wells"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacific/Midway",
	  "Pacific/Pago_Pago",
	  "Pacific/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europe/Dublin",
	  "Europe/London",
	  "Europe/Lisbon",
	  "Europe/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europe/Belgrade",
	  "Europe/Bratislava",
	  "Europe/Budapest",
	  "Europe/Ljubljana",
	  "Europe/Prague",
	  "Europe/Sarajevo",
	  "Europe/Skopje",
	  "Europe/Warsaw",
	  "Europe/Zagreb",
	  "Europe/Brussels",
	  "Europe/Copenhagen",
	  "Europe/Madrid",
	  "Europe/Paris",
	  "Europe/Amsterdam",
	  "Europe/Berlin",
	  "Europe/Berlin",
	  "Europe/Rome",
	  "Europe/Stockholm",
	  "Europe/Vienna",
	  "Africa/Algiers",
	  "Europe/Bucharest",
	  "Africa/Cairo",
	  "Europe/Helsinki",
	  "Europe/Kiev",
	  "Europe/Riga",
	  "Europe/Sofia",
	  "Europe/Tallinn",
	  "Europe/Vilnius",
	  "Europe/Athens",
	  "Europe/Istanbul",
	  "Europe/Minsk",
	  "Asia/Jerusalem",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacific/Guam",
	  "Pacific/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacific/Noumea",
	  "Pacific/Fiji",
	  "Asia/Kamchatka",
	  "Pacific/Majuro",
	  "Pacific/Auckland",
	  "Pacific/Auckland",
	  "Pacific/Tongatapu",
	  "Pacific/Fakaofo",
	  "Pacific/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.name}",
	  "#{Company.name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var app = {};
	module['exports'] = app;
	app.name = __webpack_require__(861);
	app.version = __webpack_require__(862);
	app.author = __webpack_require__(859);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Redhold",
	  "Treeflex",
	  "Trippledex",
	  "Kanlam",
	  "Bigtax",
	  "Daltfresh",
	  "Toughjoyfax",
	  "Mat Lam Tam",
	  "Otcom",
	  "Tres-Zap",
	  "Y-Solowarm",
	  "Tresom",
	  "Voltsillam",
	  "Biodex",
	  "Greenlam",
	  "Viva",
	  "Matsoft",
	  "Temp",
	  "Zoolab",
	  "Subin",
	  "Rank",
	  "Job",
	  "Stringtough",
	  "Tin",
	  "It",
	  "Home Ing",
	  "Zamit",
	  "Sonsing",
	  "Konklab",
	  "Alpha",
	  "Latlux",
	  "Voyatouch",
	  "Alphazap",
	  "Holdlamis",
	  "Zaam-Dox",
	  "Sub-Ex",
	  "Quo Lux",
	  "Bamity",
	  "Ventosanzap",
	  "Lotstring",
	  "Hatity",
	  "Tempsoft",
	  "Overhold",
	  "Fixflex",
	  "Konklux",
	  "Zontrax",
	  "Tampflex",
	  "Span",
	  "Namfix",
	  "Transcof",
	  "Stim",
	  "Fix San",
	  "Sonair",
	  "Stronghold",
	  "Fintone",
	  "Y-find",
	  "Opela",
	  "Lotlux",
	  "Ronstring",
	  "Zathin",
	  "Duobam",
	  "Keylex"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0.#.#",
	  "0.##",
	  "#.##",
	  "#.#",
	  "#.#.#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "2011-10-12",
	  "2012-11-12",
	  "2015-11-11",
	  "2013-9-12"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1234-2121-1221-1211",
	  "1212-1221-1121-1234",
	  "1211-1221-1234-2201",
	  "1228-1221-1221-1431"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "visa",
	  "mastercard",
	  "americanexpress",
	  "discover"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var business = {};
	module['exports'] = business;
	business.credit_card_numbers = __webpack_require__(864);
	business.credit_card_expiry_dates = __webpack_require__(863);
	business.credit_card_types = __webpack_require__(865);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###-####",
	  "(###) ###-####",
	  "1-###-###-####",
	  "###.###.####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(867);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "red",
	  "green",
	  "blue",
	  "yellow",
	  "purple",
	  "mint green",
	  "teal",
	  "white",
	  "black",
	  "orange",
	  "pink",
	  "grey",
	  "maroon",
	  "violet",
	  "turquoise",
	  "tan",
	  "sky blue",
	  "salmon",
	  "plum",
	  "orchid",
	  "olive",
	  "magenta",
	  "lime",
	  "ivory",
	  "indigo",
	  "gold",
	  "fuchsia",
	  "cyan",
	  "azure",
	  "lavender",
	  "silver"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Books",
	  "Movies",
	  "Music",
	  "Games",
	  "Electronics",
	  "Computers",
	  "Home",
	  "Garden",
	  "Tools",
	  "Grocery",
	  "Health",
	  "Beauty",
	  "Toys",
	  "Kids",
	  "Baby",
	  "Clothing",
	  "Shoes",
	  "Jewelery",
	  "Sports",
	  "Outdoors",
	  "Automotive",
	  "Industrial"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(869);
	commerce.department = __webpack_require__(870);
	commerce.product_name = __webpack_require__(872);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "adjective": [
	    "Small",
	    "Ergonomic",
	    "Rustic",
	    "Intelligent",
	    "Gorgeous",
	    "Incredible",
	    "Fantastic",
	    "Practical",
	    "Sleek",
	    "Awesome",
	    "Generic",
	    "Handcrafted",
	    "Handmade",
	    "Licensed",
	    "Refined",
	    "Unbranded",
	    "Tasty"
	  ],
	  "material": [
	    "Steel",
	    "Wooden",
	    "Concrete",
	    "Plastic",
	    "Cotton",
	    "Granite",
	    "Rubber",
	    "Metal",
	    "Soft",
	    "Fresh",
	    "Frozen"
	  ],
	  "product": [
	    "Chair",
	    "Car",
	    "Computer",
	    "Keyboard",
	    "Mouse",
	    "Bike",
	    "Ball",
	    "Gloves",
	    "Pants",
	    "Shirt",
	    "Table",
	    "Shoes",
	    "Hat",
	    "Towels",
	    "Soap",
	    "Tuna",
	    "Chicken",
	    "Fish",
	    "Cheese",
	    "Bacon",
	    "Pizza",
	    "Salad",
	    "Sausages",
	    "Chips"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(881);
	company.adjective = __webpack_require__(873);
	company.descriptor = __webpack_require__(877);
	company.noun = __webpack_require__(880);
	company.bs_verb = __webpack_require__(876);
	company.bs_adjective = __webpack_require__(874);
	company.bs_noun = __webpack_require__(875);
	company.name = __webpack_require__(879);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Inc",
	  "and Sons",
	  "LLC",
	  "Group"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/34##-######-####L/",
	  "/37##-######-####L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/30[0-5]#-######-###L/",
	  "/368#-######-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6011-####-####-###L/",
	  "/65##-####-####-###L/",
	  "/64[4-9]#-####-####-###L/",
	  "/6011-62##-####-####-###L/",
	  "/65##-62##-####-####-###L/",
	  "/64[4-9]#-62##-####-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var credit_card = {};
	module['exports'] = credit_card;
	credit_card.visa = __webpack_require__(892);
	credit_card.mastercard = __webpack_require__(889);
	credit_card.discover = __webpack_require__(884);
	credit_card.american_express = __webpack_require__(882);
	credit_card.diners_club = __webpack_require__(883);
	credit_card.jcb = __webpack_require__(886);
	credit_card.switch = __webpack_require__(891);
	credit_card.solo = __webpack_require__(890);
	credit_card.maestro = __webpack_require__(888);
	credit_card.laser = __webpack_require__(887);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/3528-####-####-###L/",
	  "/3529-####-####-###L/",
	  "/35[3-8]#-####-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6304###########L/",
	  "/6706###########L/",
	  "/6771###########L/",
	  "/6709###########L/",
	  "/6304#########{5,6}L/",
	  "/6706#########{5,6}L/",
	  "/6771#########{5,6}L/",
	  "/6709#########{5,6}L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/50#{9,16}L/",
	  "/5[6-8]#{9,16}L/",
	  "/56##{9,16}L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/5[1-5]##-####-####-###L/",
	  "/6771-89##-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6767-####-####-###L/",
	  "/6767-####-####-####-#L/",
	  "/6767-####-####-####-##L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6759-####-####-###L/",
	  "/6759-####-####-####-#L/",
	  "/6759-####-####-####-##L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/4###########L/",
	  "/4###-####-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(894);
	date.weekday = __webpack_require__(895);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1799
	module["exports"] = {
	  wide: [
	    "January",
	    "February",
	    "March",
	    "April",
	    "May",
	    "June",
	    "July",
	    "August",
	    "September",
	    "October",
	    "November",
	    "December"
	  ],
	  // Property "wide_context" is optional, if not set then "wide" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  wide_context: [
	    "January",
	    "February",
	    "March",
	    "April",
	    "May",
	    "June",
	    "July",
	    "August",
	    "September",
	    "October",
	    "November",
	    "December"
	  ],
	  abbr: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "May",
	    "Jun",
	    "Jul",
	    "Aug",
	    "Sep",
	    "Oct",
	    "Nov",
	    "Dec"
	  ],
	  // Property "abbr_context" is optional, if not set then "abbr" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  abbr_context: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "May",
	    "Jun",
	    "Jul",
	    "Aug",
	    "Sep",
	    "Oct",
	    "Nov",
	    "Dec"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1847
	module["exports"] = {
	  wide: [
	    "Sunday",
	    "Monday",
	    "Tuesday",
	    "Wednesday",
	    "Thursday",
	    "Friday",
	    "Saturday"
	  ],
	  // Property "wide_context" is optional, if not set then "wide" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  wide_context: [
	    "Sunday",
	    "Monday",
	    "Tuesday",
	    "Wednesday",
	    "Thursday",
	    "Friday",
	    "Saturday"
	  ],
	  abbr: [
	    "Sun",
	    "Mon",
	    "Tue",
	    "Wed",
	    "Thu",
	    "Fri",
	    "Sat"
	  ],
	  // Property "abbr_context" is optional, if not set then "abbr" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  abbr_context: [
	    "Sun",
	    "Mon",
	    "Tue",
	    "Wed",
	    "Thu",
	    "Fri",
	    "Sat"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Checking",
	  "Savings",
	  "Money Market",
	  "Investment",
	  "Home Loan",
	  "Credit Card",
	  "Auto Loan",
	  "Personal Loan"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "UAE Dirham": {
	    "code": "AED",
	    "symbol": ""
	  },
	  "Afghani": {
	    "code": "AFN",
	    "symbol": "؋"
	  },
	  "Lek": {
	    "code": "ALL",
	    "symbol": "Lek"
	  },
	  "Armenian Dram": {
	    "code": "AMD",
	    "symbol": ""
	  },
	  "Netherlands Antillian Guilder": {
	    "code": "ANG",
	    "symbol": "ƒ"
	  },
	  "Kwanza": {
	    "code": "AOA",
	    "symbol": ""
	  },
	  "Argentine Peso": {
	    "code": "ARS",
	    "symbol": "$"
	  },
	  "Australian Dollar": {
	    "code": "AUD",
	    "symbol": "$"
	  },
	  "Aruban Guilder": {
	    "code": "AWG",
	    "symbol": "ƒ"
	  },
	  "Azerbaijanian Manat": {
	    "code": "AZN",
	    "symbol": "ман"
	  },
	  "Convertible Marks": {
	    "code": "BAM",
	    "symbol": "KM"
	  },
	  "Barbados Dollar": {
	    "code": "BBD",
	    "symbol": "$"
	  },
	  "Taka": {
	    "code": "BDT",
	    "symbol": ""
	  },
	  "Bulgarian Lev": {
	    "code": "BGN",
	    "symbol": "лв"
	  },
	  "Bahraini Dinar": {
	    "code": "BHD",
	    "symbol": ""
	  },
	  "Burundi Franc": {
	    "code": "BIF",
	    "symbol": ""
	  },
	  "Bermudian Dollar (customarily known as Bermuda Dollar)": {
	    "code": "BMD",
	    "symbol": "$"
	  },
	  "Brunei Dollar": {
	    "code": "BND",
	    "symbol": "$"
	  },
	  "Boliviano Mvdol": {
	    "code": "BOB BOV",
	    "symbol": "$b"
	  },
	  "Brazilian Real": {
	    "code": "BRL",
	    "symbol": "R$"
	  },
	  "Bahamian Dollar": {
	    "code": "BSD",
	    "symbol": "$"
	  },
	  "Pula": {
	    "code": "BWP",
	    "symbol": "P"
	  },
	  "Belarussian Ruble": {
	    "code": "BYR",
	    "symbol": "p."
	  },
	  "Belize Dollar": {
	    "code": "BZD",
	    "symbol": "BZ$"
	  },
	  "Canadian Dollar": {
	    "code": "CAD",
	    "symbol": "$"
	  },
	  "Congolese Franc": {
	    "code": "CDF",
	    "symbol": ""
	  },
	  "Swiss Franc": {
	    "code": "CHF",
	    "symbol": "CHF"
	  },
	  "Chilean Peso Unidades de fomento": {
	    "code": "CLP CLF",
	    "symbol": "$"
	  },
	  "Yuan Renminbi": {
	    "code": "CNY",
	    "symbol": "¥"
	  },
	  "Colombian Peso Unidad de Valor Real": {
	    "code": "COP COU",
	    "symbol": "$"
	  },
	  "Costa Rican Colon": {
	    "code": "CRC",
	    "symbol": "₡"
	  },
	  "Cuban Peso Peso Convertible": {
	    "code": "CUP CUC",
	    "symbol": "₱"
	  },
	  "Cape Verde Escudo": {
	    "code": "CVE",
	    "symbol": ""
	  },
	  "Czech Koruna": {
	    "code": "CZK",
	    "symbol": "Kč"
	  },
	  "Djibouti Franc": {
	    "code": "DJF",
	    "symbol": ""
	  },
	  "Danish Krone": {
	    "code": "DKK",
	    "symbol": "kr"
	  },
	  "Dominican Peso": {
	    "code": "DOP",
	    "symbol": "RD$"
	  },
	  "Algerian Dinar": {
	    "code": "DZD",
	    "symbol": ""
	  },
	  "Kroon": {
	    "code": "EEK",
	    "symbol": ""
	  },
	  "Egyptian Pound": {
	    "code": "EGP",
	    "symbol": "£"
	  },
	  "Nakfa": {
	    "code": "ERN",
	    "symbol": ""
	  },
	  "Ethiopian Birr": {
	    "code": "ETB",
	    "symbol": ""
	  },
	  "Euro": {
	    "code": "EUR",
	    "symbol": "€"
	  },
	  "Fiji Dollar": {
	    "code": "FJD",
	    "symbol": "$"
	  },
	  "Falkland Islands Pound": {
	    "code": "FKP",
	    "symbol": "£"
	  },
	  "Pound Sterling": {
	    "code": "GBP",
	    "symbol": "£"
	  },
	  "Lari": {
	    "code": "GEL",
	    "symbol": ""
	  },
	  "Cedi": {
	    "code": "GHS",
	    "symbol": ""
	  },
	  "Gibraltar Pound": {
	    "code": "GIP",
	    "symbol": "£"
	  },
	  "Dalasi": {
	    "code": "GMD",
	    "symbol": ""
	  },
	  "Guinea Franc": {
	    "code": "GNF",
	    "symbol": ""
	  },
	  "Quetzal": {
	    "code": "GTQ",
	    "symbol": "Q"
	  },
	  "Guyana Dollar": {
	    "code": "GYD",
	    "symbol": "$"
	  },
	  "Hong Kong Dollar": {
	    "code": "HKD",
	    "symbol": "$"
	  },
	  "Lempira": {
	    "code": "HNL",
	    "symbol": "L"
	  },
	  "Croatian Kuna": {
	    "code": "HRK",
	    "symbol": "kn"
	  },
	  "Gourde US Dollar": {
	    "code": "HTG USD",
	    "symbol": ""
	  },
	  "Forint": {
	    "code": "HUF",
	    "symbol": "Ft"
	  },
	  "Rupiah": {
	    "code": "IDR",
	    "symbol": "Rp"
	  },
	  "New Israeli Sheqel": {
	    "code": "ILS",
	    "symbol": "₪"
	  },
	  "Indian Rupee": {
	    "code": "INR",
	    "symbol": ""
	  },
	  "Indian Rupee Ngultrum": {
	    "code": "INR BTN",
	    "symbol": ""
	  },
	  "Iraqi Dinar": {
	    "code": "IQD",
	    "symbol": ""
	  },
	  "Iranian Rial": {
	    "code": "IRR",
	    "symbol": "﷼"
	  },
	  "Iceland Krona": {
	    "code": "ISK",
	    "symbol": "kr"
	  },
	  "Jamaican Dollar": {
	    "code": "JMD",
	    "symbol": "J$"
	  },
	  "Jordanian Dinar": {
	    "code": "JOD",
	    "symbol": ""
	  },
	  "Yen": {
	    "code": "JPY",
	    "symbol": "¥"
	  },
	  "Kenyan Shilling": {
	    "code": "KES",
	    "symbol": ""
	  },
	  "Som": {
	    "code": "KGS",
	    "symbol": "лв"
	  },
	  "Riel": {
	    "code": "KHR",
	    "symbol": "៛"
	  },
	  "Comoro Franc": {
	    "code": "KMF",
	    "symbol": ""
	  },
	  "North Korean Won": {
	    "code": "KPW",
	    "symbol": "₩"
	  },
	  "Won": {
	    "code": "KRW",
	    "symbol": "₩"
	  },
	  "Kuwaiti Dinar": {
	    "code": "KWD",
	    "symbol": ""
	  },
	  "Cayman Islands Dollar": {
	    "code": "KYD",
	    "symbol": "$"
	  },
	  "Tenge": {
	    "code": "KZT",
	    "symbol": "лв"
	  },
	  "Kip": {
	    "code": "LAK",
	    "symbol": "₭"
	  },
	  "Lebanese Pound": {
	    "code": "LBP",
	    "symbol": "£"
	  },
	  "Sri Lanka Rupee": {
	    "code": "LKR",
	    "symbol": "₨"
	  },
	  "Liberian Dollar": {
	    "code": "LRD",
	    "symbol": "$"
	  },
	  "Lithuanian Litas": {
	    "code": "LTL",
	    "symbol": "Lt"
	  },
	  "Latvian Lats": {
	    "code": "LVL",
	    "symbol": "Ls"
	  },
	  "Libyan Dinar": {
	    "code": "LYD",
	    "symbol": ""
	  },
	  "Moroccan Dirham": {
	    "code": "MAD",
	    "symbol": ""
	  },
	  "Moldovan Leu": {
	    "code": "MDL",
	    "symbol": ""
	  },
	  "Malagasy Ariary": {
	    "code": "MGA",
	    "symbol": ""
	  },
	  "Denar": {
	    "code": "MKD",
	    "symbol": "ден"
	  },
	  "Kyat": {
	    "code": "MMK",
	    "symbol": ""
	  },
	  "Tugrik": {
	    "code": "MNT",
	    "symbol": "₮"
	  },
	  "Pataca": {
	    "code": "MOP",
	    "symbol": ""
	  },
	  "Ouguiya": {
	    "code": "MRO",
	    "symbol": ""
	  },
	  "Mauritius Rupee": {
	    "code": "MUR",
	    "symbol": "₨"
	  },
	  "Rufiyaa": {
	    "code": "MVR",
	    "symbol": ""
	  },
	  "Kwacha": {
	    "code": "MWK",
	    "symbol": ""
	  },
	  "Mexican Peso Mexican Unidad de Inversion (UDI)": {
	    "code": "MXN MXV",
	    "symbol": "$"
	  },
	  "Malaysian Ringgit": {
	    "code": "MYR",
	    "symbol": "RM"
	  },
	  "Metical": {
	    "code": "MZN",
	    "symbol": "MT"
	  },
	  "Naira": {
	    "code": "NGN",
	    "symbol": "₦"
	  },
	  "Cordoba Oro": {
	    "code": "NIO",
	    "symbol": "C$"
	  },
	  "Norwegian Krone": {
	    "code": "NOK",
	    "symbol": "kr"
	  },
	  "Nepalese Rupee": {
	    "code": "NPR",
	    "symbol": "₨"
	  },
	  "New Zealand Dollar": {
	    "code": "NZD",
	    "symbol": "$"
	  },
	  "Rial Omani": {
	    "code": "OMR",
	    "symbol": "﷼"
	  },
	  "Balboa US Dollar": {
	    "code": "PAB USD",
	    "symbol": "B/."
	  },
	  "Nuevo Sol": {
	    "code": "PEN",
	    "symbol": "S/."
	  },
	  "Kina": {
	    "code": "PGK",
	    "symbol": ""
	  },
	  "Philippine Peso": {
	    "code": "PHP",
	    "symbol": "Php"
	  },
	  "Pakistan Rupee": {
	    "code": "PKR",
	    "symbol": "₨"
	  },
	  "Zloty": {
	    "code": "PLN",
	    "symbol": "zł"
	  },
	  "Guarani": {
	    "code": "PYG",
	    "symbol": "Gs"
	  },
	  "Qatari Rial": {
	    "code": "QAR",
	    "symbol": "﷼"
	  },
	  "New Leu": {
	    "code": "RON",
	    "symbol": "lei"
	  },
	  "Serbian Dinar": {
	    "code": "RSD",
	    "symbol": "Дин."
	  },
	  "Russian Ruble": {
	    "code": "RUB",
	    "symbol": "руб"
	  },
	  "Rwanda Franc": {
	    "code": "RWF",
	    "symbol": ""
	  },
	  "Saudi Riyal": {
	    "code": "SAR",
	    "symbol": "﷼"
	  },
	  "Solomon Islands Dollar": {
	    "code": "SBD",
	    "symbol": "$"
	  },
	  "Seychelles Rupee": {
	    "code": "SCR",
	    "symbol": "₨"
	  },
	  "Sudanese Pound": {
	    "code": "SDG",
	    "symbol": ""
	  },
	  "Swedish Krona": {
	    "code": "SEK",
	    "symbol": "kr"
	  },
	  "Singapore Dollar": {
	    "code": "SGD",
	    "symbol": "$"
	  },
	  "Saint Helena Pound": {
	    "code": "SHP",
	    "symbol": "£"
	  },
	  "Leone": {
	    "code": "SLL",
	    "symbol": ""
	  },
	  "Somali Shilling": {
	    "code": "SOS",
	    "symbol": "S"
	  },
	  "Surinam Dollar": {
	    "code": "SRD",
	    "symbol": "$"
	  },
	  "Dobra": {
	    "code": "STD",
	    "symbol": ""
	  },
	  "El Salvador Colon US Dollar": {
	    "code": "SVC USD",
	    "symbol": "$"
	  },
	  "Syrian Pound": {
	    "code": "SYP",
	    "symbol": "£"
	  },
	  "Lilangeni": {
	    "code": "SZL",
	    "symbol": ""
	  },
	  "Baht": {
	    "code": "THB",
	    "symbol": "฿"
	  },
	  "Somoni": {
	    "code": "TJS",
	    "symbol": ""
	  },
	  "Manat": {
	    "code": "TMT",
	    "symbol": ""
	  },
	  "Tunisian Dinar": {
	    "code": "TND",
	    "symbol": ""
	  },
	  "Pa'anga": {
	    "code": "TOP",
	    "symbol": ""
	  },
	  "Turkish Lira": {
	    "code": "TRY",
	    "symbol": "TL"
	  },
	  "Trinidad and Tobago Dollar": {
	    "code": "TTD",
	    "symbol": "TT$"
	  },
	  "New Taiwan Dollar": {
	    "code": "TWD",
	    "symbol": "NT$"
	  },
	  "Tanzanian Shilling": {
	    "code": "TZS",
	    "symbol": ""
	  },
	  "Hryvnia": {
	    "code": "UAH",
	    "symbol": "₴"
	  },
	  "Uganda Shilling": {
	    "code": "UGX",
	    "symbol": ""
	  },
	  "US Dollar": {
	    "code": "USD",
	    "symbol": "$"
	  },
	  "Peso Uruguayo Uruguay Peso en Unidades Indexadas": {
	    "code": "UYU UYI",
	    "symbol": "$U"
	  },
	  "Uzbekistan Sum": {
	    "code": "UZS",
	    "symbol": "лв"
	  },
	  "Bolivar Fuerte": {
	    "code": "VEF",
	    "symbol": "Bs"
	  },
	  "Dong": {
	    "code": "VND",
	    "symbol": "₫"
	  },
	  "Vatu": {
	    "code": "VUV",
	    "symbol": ""
	  },
	  "Tala": {
	    "code": "WST",
	    "symbol": ""
	  },
	  "CFA Franc BEAC": {
	    "code": "XAF",
	    "symbol": ""
	  },
	  "Silver": {
	    "code": "XAG",
	    "symbol": ""
	  },
	  "Gold": {
	    "code": "XAU",
	    "symbol": ""
	  },
	  "Bond Markets Units European Composite Unit (EURCO)": {
	    "code": "XBA",
	    "symbol": ""
	  },
	  "European Monetary Unit (E.M.U.-6)": {
	    "code": "XBB",
	    "symbol": ""
	  },
	  "European Unit of Account 9(E.U.A.-9)": {
	    "code": "XBC",
	    "symbol": ""
	  },
	  "European Unit of Account 17(E.U.A.-17)": {
	    "code": "XBD",
	    "symbol": ""
	  },
	  "East Caribbean Dollar": {
	    "code": "XCD",
	    "symbol": "$"
	  },
	  "SDR": {
	    "code": "XDR",
	    "symbol": ""
	  },
	  "UIC-Franc": {
	    "code": "XFU",
	    "symbol": ""
	  },
	  "CFA Franc BCEAO": {
	    "code": "XOF",
	    "symbol": ""
	  },
	  "Palladium": {
	    "code": "XPD",
	    "symbol": ""
	  },
	  "CFP Franc": {
	    "code": "XPF",
	    "symbol": ""
	  },
	  "Platinum": {
	    "code": "XPT",
	    "symbol": ""
	  },
	  "Codes specifically reserved for testing purposes": {
	    "code": "XTS",
	    "symbol": ""
	  },
	  "Yemeni Rial": {
	    "code": "YER",
	    "symbol": "﷼"
	  },
	  "Rand": {
	    "code": "ZAR",
	    "symbol": "R"
	  },
	  "Rand Loti": {
	    "code": "ZAR LSL",
	    "symbol": ""
	  },
	  "Rand Namibia Dollar": {
	    "code": "ZAR NAD",
	    "symbol": ""
	  },
	  "Zambian Kwacha": {
	    "code": "ZMK",
	    "symbol": ""
	  },
	  "Zimbabwe Dollar": {
	    "code": "ZWL",
	    "symbol": ""
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var finance = {};
	module['exports'] = finance;
	finance.account_type = __webpack_require__(896);
	finance.transaction_type = __webpack_require__(899);
	finance.currency = __webpack_require__(897);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "deposit",
	  "withdrawal",
	  "payment",
	  "invoice"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "TCP",
	  "HTTP",
	  "SDD",
	  "RAM",
	  "GB",
	  "CSS",
	  "SSL",
	  "AGP",
	  "SQL",
	  "FTP",
	  "PCI",
	  "AI",
	  "ADP",
	  "RSS",
	  "XML",
	  "EXE",
	  "COM",
	  "HDD",
	  "THX",
	  "SMTP",
	  "SMS",
	  "USB",
	  "PNG",
	  "SAS",
	  "IB",
	  "SCSI",
	  "JSON",
	  "XSS",
	  "JBOD"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "auxiliary",
	  "primary",
	  "back-end",
	  "digital",
	  "open-source",
	  "virtual",
	  "cross-platform",
	  "redundant",
	  "online",
	  "haptic",
	  "multi-byte",
	  "bluetooth",
	  "wireless",
	  "1080p",
	  "neural",
	  "optical",
	  "solid state",
	  "mobile"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var hacker = {};
	module['exports'] = hacker;
	hacker.abbreviation = __webpack_require__(900);
	hacker.adjective = __webpack_require__(901);
	hacker.noun = __webpack_require__(904);
	hacker.verb = __webpack_require__(905);
	hacker.ingverb = __webpack_require__(903);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "backing up",
	  "bypassing",
	  "hacking",
	  "overriding",
	  "compressing",
	  "copying",
	  "navigating",
	  "indexing",
	  "connecting",
	  "generating",
	  "quantifying",
	  "calculating",
	  "synthesizing",
	  "transmitting",
	  "programming",
	  "parsing"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "driver",
	  "protocol",
	  "bandwidth",
	  "panel",
	  "microchip",
	  "program",
	  "port",
	  "card",
	  "array",
	  "interface",
	  "system",
	  "sensor",
	  "firewall",
	  "hard drive",
	  "pixel",
	  "alarm",
	  "feed",
	  "monitor",
	  "application",
	  "transmitter",
	  "bus",
	  "circuit",
	  "capacitor",
	  "matrix"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "back up",
	  "bypass",
	  "hack",
	  "override",
	  "compress",
	  "copy",
	  "navigate",
	  "index",
	  "connect",
	  "generate",
	  "quantify",
	  "calculate",
	  "synthesize",
	  "input",
	  "transmit",
	  "program",
	  "reboot",
	  "parse"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en = {};
	module['exports'] = en;
	en.title = "English";
	en.separator = " & ";
	en.address = __webpack_require__(849);
	en.credit_card = __webpack_require__(885);
	en.company = __webpack_require__(878);
	en.internet = __webpack_require__(911);
	en.lorem = __webpack_require__(912);
	en.name = __webpack_require__(916);
	en.phone_number = __webpack_require__(923);
	en.cell_phone = __webpack_require__(868);
	en.business = __webpack_require__(866);
	en.commerce = __webpack_require__(871);
	en.team = __webpack_require__(927);
	en.hacker = __webpack_require__(902);
	en.app = __webpack_require__(860);
	en.finance = __webpack_require__(898);
	en.date = __webpack_require__(893);
	en.system = __webpack_require__(924);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jarjan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mahdif/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sprayaga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ruzinav/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Skyhartman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/moscoz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kurafire/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/91bilal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/igorgarybaldi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/calebogden/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/malykhinv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joelhelin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kushsolitary/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coreyweb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/snowshade/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/areus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/holdenweb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/heyimjuani/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/envex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/unterdreht/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/collegeman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peejfancher/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andyisonline/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ultragex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fuck_you_two/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adellecharles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ateneupopular/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ahmetalpbalkan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Stievius/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kerem/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/osvaldas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/angelceballos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thierrykoblentz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peterlandt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/catarino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/weglov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandclay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/flame_kaizar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ahmetsulek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicolasfolliot/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jayrobinson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorerixon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kolage/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michzen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markjenkins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicolai_larsen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/noxdzine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alagoon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/idiot/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mizko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chadengle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mutlu82/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/simobenso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vocino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/guiiipontes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/soyjavi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshaustin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tomaslau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/VinThomas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ManikRathee/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/langate/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cemshid/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leemunroe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_shahedk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/enda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BillSKenney/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/divya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshhemsley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sindresorhus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/soffes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/9lessons/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/linux29/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Chakintosh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anaami/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joreira/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shadeed9/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottkclark/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jedbridges/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/salleedesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marakasina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ariil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BrianPurkiss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelmartinho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bublienko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/devankoshal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ZacharyZorbas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timmillwood/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshuasortino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/damenleeturks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tomas_janousek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/herrhaase/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/RussellBishop/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brajeshwar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nachtmeister/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cbracco/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bermonpainter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abdullindenis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/isacosta/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/suprb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yalozhkin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chandlervdw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamgarth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_victa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/commadelimited/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/roybarberuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/axel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vladarbatov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ffbel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/syropian/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ankitind/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/traneblow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/flashmurphy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ChrisFarina78/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baliomega/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saschamt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jm_denis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anoff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kennyadr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chatyrko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dingyi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mds/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/terryxlife/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aaroni/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kinday/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/prrstn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eduardostuart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhilipsiva/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/GavicoInd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baires/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rohixx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bigmancho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/blakesimkins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leeiio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tjrus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uberschizo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kylefoundry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/claudioguglieri/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ripplemdk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/exentrich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jakemoore/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joaoedumedeiros/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/poormini/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tereshenkov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/keryilmaz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/haydn_woods/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rude/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/llun/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sgaurav_baghel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jamiebrittain/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/badlittleduck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pifagor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/agromov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/benefritz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/erwanhesry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/diesellaws/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremiaha/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/koridhandy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chaensel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewcohen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/smaczny/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gonzalorobaina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nandini_m/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sydlawrence/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cdharrison/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tgerken/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lewisainslie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/charliecwaite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robbschiller/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/flexrs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattdetails/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/raquelwilson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karsh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrmartineau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/opnsrce/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hgharrygo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maximseshuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uxalex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samihah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chanpory/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sharvin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josemarques/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jefffis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/krystalfister/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lokesh_coder/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thedamianhdez/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dpmachado/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/funwatercat/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timothycd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ivanfilipovbg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/picard102/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcobarbosa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/krasnoukhov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/g3d/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ademilter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rickdt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/operatino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bungiwan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hugomano/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/logorado/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dc_user/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/horaciobella/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/SlaapMe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/teeragit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iqonicd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ilya_pestov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewarrow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ssiskind/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/HenryHoffman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rdsaunders/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adamsxu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/curiousoffice/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/themadray/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michigangraham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kohette/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nickfratter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/runningskull/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madysondesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brenton_clarke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jennyshen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bradenhamm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kurtinc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amanruzaini/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coreyhaggard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Karimmove/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aaronalfred/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wtrsld/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jitachi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/therealmarvin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pmeissner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ooomz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chacky14/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jesseddy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thinmatt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shanehudson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/akmur/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/IsaryAmairani/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arthurholcombe1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andychipster/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/boxmodel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ehsandiary/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/LucasPerdidao/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shalt0ni/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/swaplord/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kaelifa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/plbabin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/guillemboti/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arindam_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/renbyrd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thiagovernetti/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jmillspaysbills/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mikemai2awesome/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jervo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mekal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sta1ex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robergd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/felipecsl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrea211087/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/garand/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhooyenga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abovefunction/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pcridesagain/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/randomlies/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BryanHorsey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/heykenneth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dahparra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/allthingssmitty/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danvernon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/beweinreich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/increase/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/falvarad/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alxndrustinov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/souuf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/orkuncaylar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/AM_Kn2/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gearpixels/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bassamology/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vimarethomas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kosmar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/SULiik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrjamesnoble/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/silvanmuhlemann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shaneIxD/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nacho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yigitpinarbasi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buzzusborne/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aaronkwhite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rmlewisuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/giancarlon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nbirckel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d_nny_m_cher/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sdidonato/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/atariboy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abotap/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karalek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/psdesignuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ludwiczakpawel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nemanjaivanovic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baluli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ahmadajmi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vovkasolovev/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samgrover/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/derienzo777/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jonathansimmons/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nelsonjoyce/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/S0ufi4n3/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xtopherpaul/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oaktreemedia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nateschulte/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/findingjenny/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/namankreative/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antonyzotov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/we_social/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leehambley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/solid_color/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abelcabans/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mbilderbach/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kkusaa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jordyvdboom/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosgavina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pechkinator/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vc27/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rdbannon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/croakx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/suribbles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kerihenare/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/catadeleon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gcmorley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/duivvv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saschadroste/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorDubugras/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wintopia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattbilotti/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/taylorling/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/megdraws/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/meln1ks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mahmoudmetwally/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Silveredge9/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/derekebradley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/happypeter1983/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/travis_arnold/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/artem_kostenko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adobi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/daykiine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alek_djuric/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scips/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/miguelmendes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justinrhee/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alsobrooks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fronx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mcflydesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/santi_urso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/allfordesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stayuber/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bertboerland/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marosholly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adamnac/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cynthiasavard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/muringa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hiemil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jackiesaik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zacsnider/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iduuck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antjanus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aroon_sharma/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dshster/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thehacker/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelbrooksjr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryanmclaughlin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/clubb3rry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/taybenlor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xripunov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/myastro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adityasutomo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/digitalmaverick/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hjartstrorn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itolmach/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vaughanmoffitt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abdots/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/isnifer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sergeysafonov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scrapdnb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrismj83/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vitorleal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sokaniwaal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zaki3d/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/illyzoren/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mocabyte/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/osmanince/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/djsherman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidhemphill/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/waghner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/necodymiconer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/praveen_vijaya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fabbrucci/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cliffseal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/travishines/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kuldarkalvik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Elt_n/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/phillapier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okseanjay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/id835559/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kudretkeskin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anjhero/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/duck4fuck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scott_riley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/noufalibrahim/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/h1brd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/borges_marcos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/devinhalladay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ciaranr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefooo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mikebeecham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tonymillion/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshuaraichur/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/irae/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/petrangr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dmitriychuta/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/charliegann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arashmanteghi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adhamdannaway/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ainsleywagon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/svenlen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/faisalabid/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/beshur/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlyson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dutchnadia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/teddyzetterlund/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samuelkraft/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aoimedia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/toddrew/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/codepoet_ru/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/artvavs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/benoitboucart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jomarmen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kolmarlopez/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/creartinc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/homka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gaborenton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robinclediere/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maximsorokin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/plasticine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/j2deme/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peachananr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kapaluccio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/de_ascanio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rikas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dawidwu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcoramires/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/angelcreative/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rpatey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/popey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rehatkathuria/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/the_purplebunny/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/1markiz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ajaxy_ru/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brenmurrell/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dudestein/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oskarlevinson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorstuber/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nehfy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vicivadeline/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leandrovaranda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottgallant/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victor_haydin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sawrb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryhanhassan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amayvs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/a_brixen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karolkrakowiak_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/herkulano/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geran7/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cggaurav/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chris_witko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lososina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/polarity/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattlat/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandonburke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/constantx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/teylorfeliz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/craigelimeliah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rachelreveley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/reabo101/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rahmeen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rickyyean/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/j04ntoh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/spbroma/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sebashton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jpenico/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/francis_vega/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oktayelipek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kikillo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fabbianz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/larrygerard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BroumiYoussef/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/0therplanet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mbilalsiddique1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ionuss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/grrr_nl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/liminha/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rawdiggie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryandownie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sethlouey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pixage/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arpitnj/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/switmer777/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josevnclch/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kanickairaj/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/puzik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tbakdesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/besbujupi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/supjoey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lowie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/linkibol/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/balintorosz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imcoding/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/agustincruiz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gusoto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thomasschrijer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/superoutman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kalmerrautam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gabrielizalo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gojeanyn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidbaldie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_vojto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/laurengray/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jydesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mymyboy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nellleo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marciotoledo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ninjad3m0/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/to_soham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hasslunsford/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/muridrahhal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/levisan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/grahamkennery/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lepetitogre/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antongenkin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nessoila/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amandabuzard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/safrankov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cocolero/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dss49/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matt3224/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bluesix/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/quailandquasar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/AlbertoCococi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lepinski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sementiy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mhudobivnik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thibaut_re/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/olgary/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shojberg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mtolokonnikov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bereto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/naupintos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wegotvices/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xadhix/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/macxim/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rodnylobos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madcampos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madebyvadim/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bartoszdawydzik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/supervova/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markretzloff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vonachoo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/darylws/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stevedesigner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mylesb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/herbigt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/depaulawagner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geshan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gizmeedevil1991/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_scottburgess/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lisovsky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidsasda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/artd_sign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/YoungCutlass/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mgonto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itstotallyamy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorquinn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/osmond/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oksanafrewer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zauerkraut/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamkeithmason/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nitinhayaran/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lmjabreu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mandalareopens/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thinkleft/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ponchomendivil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juamperro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brunodesign1206/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/caseycavanagh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/luxe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dotgridline/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/spedwig/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madewulf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattsapii/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/helderleal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrisstumph/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jayphen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nsamoylov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrisvanderkooi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justme_timothyg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/otozk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/prinzadi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gu5taf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cyril_gaillard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d_kobelyatsky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/daniloc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nwdsha/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/romanbulah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/skkirilov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dvdwinden/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dannol/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thekevinjones/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jwalter14/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timgthomas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buddhasource/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uxpiper/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thatonetommy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/diansigitp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adrienths/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/klimmka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gkaam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/derekcramer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jennyyo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nerrsoft/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xalionmalik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edhenderson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/keyuri85/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/roxanejammet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kimcool/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edkf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matkins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alessandroribe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jacksonlatka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lebronjennan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kostaspt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karlkanall/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/moynihan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danpliego/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saulihirvi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wesleytrankin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fjaguero/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bowbrick/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mashaaaaal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yassiryahya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dparrelli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fotomagin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aka_james/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/denisepires/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iqbalperkasa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/martinansty/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jarsen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/r_oy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justinrob/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gabrielrosser/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/malgordon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlfairclough/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelabehsera/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pierrestoffe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/enjoythetau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/loganjlambert/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rpeezy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coreyginnivan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michalhron/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/msveet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lingeswaran/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kolsvein/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peter576/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/reideiredale/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joeymurdah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/raphaelnikson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mvdheuvel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maxlinderman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jimmuirhead/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/begreative/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/frankiefreesbie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robturlinckx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Talbi_ConSept/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/longlivemyword/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vanchesz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maiklam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hermanobrother/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rez___a/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gregsqueeb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/greenbes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_ragzor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anthonysukow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fluidbrush/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dactrtr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jehnglynn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bergmartin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hugocornejo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_kkga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dzantievm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sawalazar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sovesove/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jonsgotwood/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/byryan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vytautas_a/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mizhgan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cicerobr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nilshelmersson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d33pthought/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davecraige/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nckjrvs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alexandermayes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jcubic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/craigrcoles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bagawarman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rob_thomas10/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cofla/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maikelk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rtgibbons/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/russell_baylis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mhesslow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/codysanfilippo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/webtanya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madebybrenton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dcalonaci/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/perfectflow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jjsiii/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saarabpreet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kumarrajan12123/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamsteffen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/themikenagle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ceekaytweet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/larrybolt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/conspirator/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dallasbpeters/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/n3dmax/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/terpimost/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kirillz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/byrnecore/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/j_drake_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/calebjoyce/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/russoedu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hoangloi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tobysaxon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gofrasdesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dimaposnyy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tjisousa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okandungel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/billyroshan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oskamaya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/motionthinks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/knilob/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ashocka18/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marrimo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bartjo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/omnizya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ernestsemerda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andreas_pr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edgarchris99/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thomasgeisen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gseguin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joannefournier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/demersdesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adammarsbar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nasirwd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/n_tassone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/javorszky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/themrdave/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yecidsm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicollerich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/canapud/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicoleglynn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/judzhin_miles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/designervzm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kianoshp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/evandrix/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alterchuca/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhrubo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ma_tiax/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ssbb_me/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dorphern/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mauriolg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bruno_mart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mactopus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/the_winslet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joemdesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Shriiiiimp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jacobbennett/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nfedoroff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamglimy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/allagringaus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aiiaiiaii/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/olaolusoga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buryaknick/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wim1k/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicklacke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/a1chapone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/steynviljoen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/strikewan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryankirkman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewabogado/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/doooon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jagan123/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ariffsetiawan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elenadissi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mwarkentin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thierrymeier_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/r_garcia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dmackerman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/borantula/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/konus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/spacewood_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryuchi311/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/evanshajed/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tristanlegros/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shoaib253/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aislinnkelly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okcoker/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timpetricola/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sunshinedgirl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chadami/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aleclarsoniv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nomidesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/petebernardo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottiedude/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/millinet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imsoper/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imammuht/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/benjamin_knight/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nepdud/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joki4/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lanceguyatt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bboy1895/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amywebbb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rweve/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/haruintesettden/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ricburton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nelshd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/batsirai/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/primozcigler/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jffgrdnr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/8d3k/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geneseleznev/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/al_li/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/souperphly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mslarkina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/2fockus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cdavis565/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xiel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/turkutuuli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uxward/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lebinoclard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gauravjassal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidmerrique/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mdsisto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewofficer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kojourin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dnirmal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kevka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mr_shiznit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aluisio_azevedo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cloudstudio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danvierich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alexivanichkin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fran_mchamy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/perretmagali/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/betraydan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cadikkara/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matbeedotcom/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremyworboys/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bpartridge/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelkoper/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/silv3rgvn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alevizio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johnsmithagency/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lawlbwoy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vitor376/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/desastrozo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thimo_cz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jasonmarkjones/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lhausermann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xravil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/guischmitt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vigobronx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/panghal0/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/miguelkooreman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/surgeonist/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/christianoliff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/caspergrl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamkarna/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ipavelek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pierre_nel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/y2graphic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sterlingrules/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elbuscainfo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bennyjien/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stushona/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/estebanuribe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/embrcecreations/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danillos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elliotlewis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/charlesrpratt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vladyn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emmeffess/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosblanco_eu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leonfedotov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rangafangs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chris_frees/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tgormtx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bryan_topham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jpscribbles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mighty55/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carbontwelve/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/isaacfifth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamjdeleon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/snowwrite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/barputro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/drewbyreese/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sachacorazzi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bistrianiosip/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/magoo04/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pehamondello/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yayteejay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/a_harris88/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/algunsanabria/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zforrester/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ovall/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosjgsousa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geobikas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ah_lice/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/looneydoodle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nerdgr8/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ddggccaa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zackeeler/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/normanbox/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/el_fuertisimo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ismail_biltagi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juangomezw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jnmnrd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/patrickcoombe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryanjohnson_me/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markolschesky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeffgolenski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kvasnic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lindseyzilla/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gauchomatt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/afusinatto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kevinoh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okansurreel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adamawesomeface/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emileboudeling/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arishi_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juanmamartinez/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wikiziner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danthms/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mkginfo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/terrorpixel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/curiousonaut/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/prheemo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelcolenso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/foczzi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/martip07/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thaodang17/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johncafazza/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robinlayfield/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/franciscoamk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abdulhyeuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marklamb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edobene/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andresenfredrik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mikaeljorhult/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrisslowik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vinciarts/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/meelford/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elliotnolten/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yehudab/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vijaykarthik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bfrohs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josep_martins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/attacks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sur4dye/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tumski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/instalox/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mangosango/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/paulfarino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kazaky999/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kiwiupover/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nvkznemo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tom_even/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ratbus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/woodsman001/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshmedeski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thewillbeard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/psaikali/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joe_black/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aleinadsays/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcusgorillius/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hota_v/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jghyllebert/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shinze/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/janpalounek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremiespoken/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/her_ruu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dansowter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/felipeapiress/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/magugzbrand2d/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/posterjob/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nathalie_fs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bobbytwoshoes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dreizle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremymouton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elisabethkjaer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/notbadart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mohanrohith/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jlsolerdeltoro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itskawsar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/slowspock/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zvchkelly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wiljanslofstra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/craighenneberry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/trubeatto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juaumlol/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samscouto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BenouarradeM/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gipsy_raf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/netonet_il/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arkokoley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itsajimithing/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/smalonso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victordeanda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_dwite_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/richardgarretts/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gregrwilkinson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anatolinicolae/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lu4sh1i/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefanotirloni/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ostirbu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/darcystonge/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/naitanamoreno/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelcomiskey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adhiardana/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcomano_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidcazalis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/falconerie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gregkilian/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bcrad/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bolzanmarco/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/low_res/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vlajki/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/petar_prog/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jonkspr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/akmalfikri/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mfacchinello/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/atanism/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/harry_sistalam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/murrayswift/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bobwassermann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gavr1l0/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madshensel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mr_subtle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/deviljho_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/salimianoff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joetruesdell/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/twittypork/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/airskylar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dnezkumar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dgajjar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cherif_b/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/salvafc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/louis_currie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/deeenright/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cybind/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eyronn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vickyshits/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sweetdelisa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cboller1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andresdjasso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/melvindidit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andysolomon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thaisselenator_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lvovenok/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/giuliusa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/belyaev_rs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/overcloacked/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kamal_chaneman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/incubo82/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hellofeverrrr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mhaligowski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sunlandictwin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bu7921/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andytlaw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremery/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/finchjke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/manigm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/umurgdk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottfeltham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ganserene/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mutu_krish/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jodytaggart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ntfblog/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tanveerrao/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hfalucas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alxleroydeval/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kucingbelang4/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bargaorobalo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/colgruv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stalewine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kylefrost/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baumannzone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/angelcolberg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sachingawas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jjshaw14/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ramanathan_pdy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johndezember/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nilshoenson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandonmorreale/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nutzumi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandonflatsoda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sergeyalmone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/klefue/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kirangopal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baumann_alex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matthewkay_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jay_wilburn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shesgared/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/apriendeau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johnriordan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wake_gs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aleksitappura/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emsgulam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xilantra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imomenui/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sircalebgrove/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/newbrushes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hsinyo23/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/m4rio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/katiemdaly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/s4f1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ecommerceil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marlinjayakody/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/swooshycueb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sangdth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coderdiaz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bluefx_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vivekprvr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sasha_shestakov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eugeneeweb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dgclegg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/n1ght_coder/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dixchen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/blakehawksworth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/trueblood_33/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hai_ninh_nguyen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marclgonzales/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yesmeck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stephcoue/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/doronmalki/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ruehldesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anasnakawa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kijanmaharjan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wearesavas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefvdham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tweetubhai/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alecarpentier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fiterik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antonyryndya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d00maz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/theonlyzeke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/missaaamy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/manekenthe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/reetajayendra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremyshimko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justinrgraham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefanozoffoli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/overra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrebay007/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shvelo96/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pyronite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thedjpetersen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rtyukmaev/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_williamguerra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/albertaugustin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vikashpathak18/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kevinjohndayy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vj_demien/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/colirpixoil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/goddardlewis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/laasli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jqiuss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/heycamtaylor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nastya_mane/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mastermindesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ccinojasso1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nyancecom/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sandywoodruff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bighanddesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sbtransparent/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aviddayentonbay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/richwild/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kaysix_dizzy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tur8le/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/seyedhossein1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/privetwagner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emmandenn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dev_essentials/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jmfsocial/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_yardenoon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mateaodviteza/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/weavermedia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mufaddal_mw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hafeeskhan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ashernatali/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sulaqo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eddiechen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josecarlospsh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vm_f/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/enricocicconi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danmartin70/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gmourier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/donjain/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrxloka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_pedropinho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eitarafa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oscarowusu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ralph_lam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/panchajanyag/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/woodydotmx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jerrybai1907/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marshallchen_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xamorep/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aio___/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chaabane_wail/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/txcx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/akashsharma39/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/falling_soul/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sainraja/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mugukamil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johannesneu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markwienands/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karthipanraj/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/balakayuriy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alan_zhang_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/layerssss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kaspernordkvist/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mirfanqureshi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hanna_smi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/VMilescu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aeon56/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/m_kalibry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sreejithexp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dicesales/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhoot_amit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/smenov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lonesomelemon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vladimirdevic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joelcipriano/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/haligaliharun/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buleswapnil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/serefka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ifarafonow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vikasvinfotech/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/urrutimeoli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/areandacom/128.jpg"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "example.org",
	  "example.com",
	  "example.net"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(910);
	internet.example_email = __webpack_require__(909);
	internet.domain_suffix = __webpack_require__(908);
	internet.avatar_uri = __webpack_require__(907);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(914);
	lorem.supplemental = __webpack_require__(913);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaliyah",
	  "Aaron",
	  "Abagail",
	  "Abbey",
	  "Abbie",
	  "Abbigail",
	  "Abby",
	  "Abdiel",
	  "Abdul",
	  "Abdullah",
	  "Abe",
	  "Abel",
	  "Abelardo",
	  "Abigail",
	  "Abigale",
	  "Abigayle",
	  "Abner",
	  "Abraham",
	  "Ada",
	  "Adah",
	  "Adalberto",
	  "Adaline",
	  "Adam",
	  "Adan",
	  "Addie",
	  "Addison",
	  "Adela",
	  "Adelbert",
	  "Adele",
	  "Adelia",
	  "Adeline",
	  "Adell",
	  "Adella",
	  "Adelle",
	  "Aditya",
	  "Adolf",
	  "Adolfo",
	  "Adolph",
	  "Adolphus",
	  "Adonis",
	  "Adrain",
	  "Adrian",
	  "Adriana",
	  "Adrianna",
	  "Adriel",
	  "Adrien",
	  "Adrienne",
	  "Afton",
	  "Aglae",
	  "Agnes",
	  "Agustin",
	  "Agustina",
	  "Ahmad",
	  "Ahmed",
	  "Aida",
	  "Aidan",
	  "Aiden",
	  "Aileen",
	  "Aimee",
	  "Aisha",
	  "Aiyana",
	  "Akeem",
	  "Al",
	  "Alaina",
	  "Alan",
	  "Alana",
	  "Alanis",
	  "Alanna",
	  "Alayna",
	  "Alba",
	  "Albert",
	  "Alberta",
	  "Albertha",
	  "Alberto",
	  "Albin",
	  "Albina",
	  "Alda",
	  "Alden",
	  "Alec",
	  "Aleen",
	  "Alejandra",
	  "Alejandrin",
	  "Alek",
	  "Alena",
	  "Alene",
	  "Alessandra",
	  "Alessandro",
	  "Alessia",
	  "Aletha",
	  "Alex",
	  "Alexa",
	  "Alexander",
	  "Alexandra",
	  "Alexandre",
	  "Alexandrea",
	  "Alexandria",
	  "Alexandrine",
	  "Alexandro",
	  "Alexane",
	  "Alexanne",
	  "Alexie",
	  "Alexis",
	  "Alexys",
	  "Alexzander",
	  "Alf",
	  "Alfonso",
	  "Alfonzo",
	  "Alford",
	  "Alfred",
	  "Alfreda",
	  "Alfredo",
	  "Ali",
	  "Alia",
	  "Alice",
	  "Alicia",
	  "Alisa",
	  "Alisha",
	  "Alison",
	  "Alivia",
	  "Aliya",
	  "Aliyah",
	  "Aliza",
	  "Alize",
	  "Allan",
	  "Allen",
	  "Allene",
	  "Allie",
	  "Allison",
	  "Ally",
	  "Alphonso",
	  "Alta",
	  "Althea",
	  "Alva",
	  "Alvah",
	  "Alvena",
	  "Alvera",
	  "Alverta",
	  "Alvina",
	  "Alvis",
	  "Alyce",
	  "Alycia",
	  "Alysa",
	  "Alysha",
	  "Alyson",
	  "Alysson",
	  "Amalia",
	  "Amanda",
	  "Amani",
	  "Amara",
	  "Amari",
	  "Amaya",
	  "Amber",
	  "Ambrose",
	  "Amelia",
	  "Amelie",
	  "Amely",
	  "America",
	  "Americo",
	  "Amie",
	  "Amina",
	  "Amir",
	  "Amira",
	  "Amiya",
	  "Amos",
	  "Amparo",
	  "Amy",
	  "Amya",
	  "Ana",
	  "Anabel",
	  "Anabelle",
	  "Anahi",
	  "Anais",
	  "Anastacio",
	  "Anastasia",
	  "Anderson",
	  "Andre",
	  "Andreane",
	  "Andreanne",
	  "Andres",
	  "Andrew",
	  "Andy",
	  "Angel",
	  "Angela",
	  "Angelica",
	  "Angelina",
	  "Angeline",
	  "Angelita",
	  "Angelo",
	  "Angie",
	  "Angus",
	  "Anibal",
	  "Anika",
	  "Anissa",
	  "Anita",
	  "Aniya",
	  "Aniyah",
	  "Anjali",
	  "Anna",
	  "Annabel",
	  "Annabell",
	  "Annabelle",
	  "Annalise",
	  "Annamae",
	  "Annamarie",
	  "Anne",
	  "Annetta",
	  "Annette",
	  "Annie",
	  "Ansel",
	  "Ansley",
	  "Anthony",
	  "Antoinette",
	  "Antone",
	  "Antonetta",
	  "Antonette",
	  "Antonia",
	  "Antonietta",
	  "Antonina",
	  "Antonio",
	  "Antwan",
	  "Antwon",
	  "Anya",
	  "April",
	  "Ara",
	  "Araceli",
	  "Aracely",
	  "Arch",
	  "Archibald",
	  "Ardella",
	  "Arden",
	  "Ardith",
	  "Arely",
	  "Ari",
	  "Ariane",
	  "Arianna",
	  "Aric",
	  "Ariel",
	  "Arielle",
	  "Arjun",
	  "Arlene",
	  "Arlie",
	  "Arlo",
	  "Armand",
	  "Armando",
	  "Armani",
	  "Arnaldo",
	  "Arne",
	  "Arno",
	  "Arnold",
	  "Arnoldo",
	  "Arnulfo",
	  "Aron",
	  "Art",
	  "Arthur",
	  "Arturo",
	  "Arvel",
	  "Arvid",
	  "Arvilla",
	  "Aryanna",
	  "Asa",
	  "Asha",
	  "Ashlee",
	  "Ashleigh",
	  "Ashley",
	  "Ashly",
	  "Ashlynn",
	  "Ashton",
	  "Ashtyn",
	  "Asia",
	  "Assunta",
	  "Astrid",
	  "Athena",
	  "Aubree",
	  "Aubrey",
	  "Audie",
	  "Audra",
	  "Audreanne",
	  "Audrey",
	  "August",
	  "Augusta",
	  "Augustine",
	  "Augustus",
	  "Aurelia",
	  "Aurelie",
	  "Aurelio",
	  "Aurore",
	  "Austen",
	  "Austin",
	  "Austyn",
	  "Autumn",
	  "Ava",
	  "Avery",
	  "Avis",
	  "Axel",
	  "Ayana",
	  "Ayden",
	  "Ayla",
	  "Aylin",
	  "Baby",
	  "Bailee",
	  "Bailey",
	  "Barbara",
	  "Barney",
	  "Baron",
	  "Barrett",
	  "Barry",
	  "Bart",
	  "Bartholome",
	  "Barton",
	  "Baylee",
	  "Beatrice",
	  "Beau",
	  "Beaulah",
	  "Bell",
	  "Bella",
	  "Belle",
	  "Ben",
	  "Benedict",
	  "Benjamin",
	  "Bennett",
	  "Bennie",
	  "Benny",
	  "Benton",
	  "Berenice",
	  "Bernadette",
	  "Bernadine",
	  "Bernard",
	  "Bernardo",
	  "Berneice",
	  "Bernhard",
	  "Bernice",
	  "Bernie",
	  "Berniece",
	  "Bernita",
	  "Berry",
	  "Bert",
	  "Berta",
	  "Bertha",
	  "Bertram",
	  "Bertrand",
	  "Beryl",
	  "Bessie",
	  "Beth",
	  "Bethany",
	  "Bethel",
	  "Betsy",
	  "Bette",
	  "Bettie",
	  "Betty",
	  "Bettye",
	  "Beulah",
	  "Beverly",
	  "Bianka",
	  "Bill",
	  "Billie",
	  "Billy",
	  "Birdie",
	  "Blair",
	  "Blaise",
	  "Blake",
	  "Blanca",
	  "Blanche",
	  "Blaze",
	  "Bo",
	  "Bobbie",
	  "Bobby",
	  "Bonita",
	  "Bonnie",
	  "Boris",
	  "Boyd",
	  "Brad",
	  "Braden",
	  "Bradford",
	  "Bradley",
	  "Bradly",
	  "Brady",
	  "Braeden",
	  "Brain",
	  "Brandi",
	  "Brando",
	  "Brandon",
	  "Brandt",
	  "Brandy",
	  "Brandyn",
	  "Brannon",
	  "Branson",
	  "Brant",
	  "Braulio",
	  "Braxton",
	  "Brayan",
	  "Breana",
	  "Breanna",
	  "Breanne",
	  "Brenda",
	  "Brendan",
	  "Brenden",
	  "Brendon",
	  "Brenna",
	  "Brennan",
	  "Brennon",
	  "Brent",
	  "Bret",
	  "Brett",
	  "Bria",
	  "Brian",
	  "Briana",
	  "Brianne",
	  "Brice",
	  "Bridget",
	  "Bridgette",
	  "Bridie",
	  "Brielle",
	  "Brigitte",
	  "Brionna",
	  "Brisa",
	  "Britney",
	  "Brittany",
	  "Brock",
	  "Broderick",
	  "Brody",
	  "Brook",
	  "Brooke",
	  "Brooklyn",
	  "Brooks",
	  "Brown",
	  "Bruce",
	  "Bryana",
	  "Bryce",
	  "Brycen",
	  "Bryon",
	  "Buck",
	  "Bud",
	  "Buddy",
	  "Buford",
	  "Bulah",
	  "Burdette",
	  "Burley",
	  "Burnice",
	  "Buster",
	  "Cade",
	  "Caden",
	  "Caesar",
	  "Caitlyn",
	  "Cale",
	  "Caleb",
	  "Caleigh",
	  "Cali",
	  "Calista",
	  "Callie",
	  "Camden",
	  "Cameron",
	  "Camila",
	  "Camilla",
	  "Camille",
	  "Camren",
	  "Camron",
	  "Camryn",
	  "Camylle",
	  "Candace",
	  "Candelario",
	  "Candice",
	  "Candida",
	  "Candido",
	  "Cara",
	  "Carey",
	  "Carissa",
	  "Carlee",
	  "Carleton",
	  "Carley",
	  "Carli",
	  "Carlie",
	  "Carlo",
	  "Carlos",
	  "Carlotta",
	  "Carmel",
	  "Carmela",
	  "Carmella",
	  "Carmelo",
	  "Carmen",
	  "Carmine",
	  "Carol",
	  "Carolanne",
	  "Carole",
	  "Carolina",
	  "Caroline",
	  "Carolyn",
	  "Carolyne",
	  "Carrie",
	  "Carroll",
	  "Carson",
	  "Carter",
	  "Cary",
	  "Casandra",
	  "Casey",
	  "Casimer",
	  "Casimir",
	  "Casper",
	  "Cassandra",
	  "Cassandre",
	  "Cassidy",
	  "Cassie",
	  "Catalina",
	  "Caterina",
	  "Catharine",
	  "Catherine",
	  "Cathrine",
	  "Cathryn",
	  "Cathy",
	  "Cayla",
	  "Ceasar",
	  "Cecelia",
	  "Cecil",
	  "Cecile",
	  "Cecilia",
	  "Cedrick",
	  "Celestine",
	  "Celestino",
	  "Celia",
	  "Celine",
	  "Cesar",
	  "Chad",
	  "Chadd",
	  "Chadrick",
	  "Chaim",
	  "Chance",
	  "Chandler",
	  "Chanel",
	  "Chanelle",
	  "Charity",
	  "Charlene",
	  "Charles",
	  "Charley",
	  "Charlie",
	  "Charlotte",
	  "Chase",
	  "Chasity",
	  "Chauncey",
	  "Chaya",
	  "Chaz",
	  "Chelsea",
	  "Chelsey",
	  "Chelsie",
	  "Chesley",
	  "Chester",
	  "Chet",
	  "Cheyanne",
	  "Cheyenne",
	  "Chloe",
	  "Chris",
	  "Christ",
	  "Christa",
	  "Christelle",
	  "Christian",
	  "Christiana",
	  "Christina",
	  "Christine",
	  "Christop",
	  "Christophe",
	  "Christopher",
	  "Christy",
	  "Chyna",
	  "Ciara",
	  "Cicero",
	  "Cielo",
	  "Cierra",
	  "Cindy",
	  "Citlalli",
	  "Clair",
	  "Claire",
	  "Clara",
	  "Clarabelle",
	  "Clare",
	  "Clarissa",
	  "Clark",
	  "Claud",
	  "Claude",
	  "Claudia",
	  "Claudie",
	  "Claudine",
	  "Clay",
	  "Clemens",
	  "Clement",
	  "Clementina",
	  "Clementine",
	  "Clemmie",
	  "Cleo",
	  "Cleora",
	  "Cleta",
	  "Cletus",
	  "Cleve",
	  "Cleveland",
	  "Clifford",
	  "Clifton",
	  "Clint",
	  "Clinton",
	  "Clotilde",
	  "Clovis",
	  "Cloyd",
	  "Clyde",
	  "Coby",
	  "Cody",
	  "Colby",
	  "Cole",
	  "Coleman",
	  "Colin",
	  "Colleen",
	  "Collin",
	  "Colt",
	  "Colten",
	  "Colton",
	  "Columbus",
	  "Concepcion",
	  "Conner",
	  "Connie",
	  "Connor",
	  "Conor",
	  "Conrad",
	  "Constance",
	  "Constantin",
	  "Consuelo",
	  "Cooper",
	  "Cora",
	  "Coralie",
	  "Corbin",
	  "Cordelia",
	  "Cordell",
	  "Cordia",
	  "Cordie",
	  "Corene",
	  "Corine",
	  "Cornelius",
	  "Cornell",
	  "Corrine",
	  "Cortez",
	  "Cortney",
	  "Cory",
	  "Coty",
	  "Courtney",
	  "Coy",
	  "Craig",
	  "Crawford",
	  "Creola",
	  "Cristal",
	  "Cristian",
	  "Cristina",
	  "Cristobal",
	  "Cristopher",
	  "Cruz",
	  "Crystal",
	  "Crystel",
	  "Cullen",
	  "Curt",
	  "Curtis",
	  "Cydney",
	  "Cynthia",
	  "Cyril",
	  "Cyrus",
	  "Dagmar",
	  "Dahlia",
	  "Daija",
	  "Daisha",
	  "Daisy",
	  "Dakota",
	  "Dale",
	  "Dallas",
	  "Dallin",
	  "Dalton",
	  "Damaris",
	  "Dameon",
	  "Damian",
	  "Damien",
	  "Damion",
	  "Damon",
	  "Dan",
	  "Dana",
	  "Dandre",
	  "Dane",
	  "D'angelo",
	  "Dangelo",
	  "Danial",
	  "Daniela",
	  "Daniella",
	  "Danielle",
	  "Danika",
	  "Dannie",
	  "Danny",
	  "Dante",
	  "Danyka",
	  "Daphne",
	  "Daphnee",
	  "Daphney",
	  "Darby",
	  "Daren",
	  "Darian",
	  "Dariana",
	  "Darien",
	  "Dario",
	  "Darion",
	  "Darius",
	  "Darlene",
	  "Daron",
	  "Darrel",
	  "Darrell",
	  "Darren",
	  "Darrick",
	  "Darrin",
	  "Darrion",
	  "Darron",
	  "Darryl",
	  "Darwin",
	  "Daryl",
	  "Dashawn",
	  "Dasia",
	  "Dave",
	  "David",
	  "Davin",
	  "Davion",
	  "Davon",
	  "Davonte",
	  "Dawn",
	  "Dawson",
	  "Dax",
	  "Dayana",
	  "Dayna",
	  "Dayne",
	  "Dayton",
	  "Dean",
	  "Deangelo",
	  "Deanna",
	  "Deborah",
	  "Declan",
	  "Dedric",
	  "Dedrick",
	  "Dee",
	  "Deion",
	  "Deja",
	  "Dejah",
	  "Dejon",
	  "Dejuan",
	  "Delaney",
	  "Delbert",
	  "Delfina",
	  "Delia",
	  "Delilah",
	  "Dell",
	  "Della",
	  "Delmer",
	  "Delores",
	  "Delpha",
	  "Delphia",
	  "Delphine",
	  "Delta",
	  "Demarco",
	  "Demarcus",
	  "Demario",
	  "Demetris",
	  "Demetrius",
	  "Demond",
	  "Dena",
	  "Denis",
	  "Dennis",
	  "Deon",
	  "Deondre",
	  "Deontae",
	  "Deonte",
	  "Dereck",
	  "Derek",
	  "Derick",
	  "Deron",
	  "Derrick",
	  "Deshaun",
	  "Deshawn",
	  "Desiree",
	  "Desmond",
	  "Dessie",
	  "Destany",
	  "Destin",
	  "Destinee",
	  "Destiney",
	  "Destini",
	  "Destiny",
	  "Devan",
	  "Devante",
	  "Deven",
	  "Devin",
	  "Devon",
	  "Devonte",
	  "Devyn",
	  "Dewayne",
	  "Dewitt",
	  "Dexter",
	  "Diamond",
	  "Diana",
	  "Dianna",
	  "Diego",
	  "Dillan",
	  "Dillon",
	  "Dimitri",
	  "Dina",
	  "Dino",
	  "Dion",
	  "Dixie",
	  "Dock",
	  "Dolly",
	  "Dolores",
	  "Domenic",
	  "Domenica",
	  "Domenick",
	  "Domenico",
	  "Domingo",
	  "Dominic",
	  "Dominique",
	  "Don",
	  "Donald",
	  "Donato",
	  "Donavon",
	  "Donna",
	  "Donnell",
	  "Donnie",
	  "Donny",
	  "Dora",
	  "Dorcas",
	  "Dorian",
	  "Doris",
	  "Dorothea",
	  "Dorothy",
	  "Dorris",
	  "Dortha",
	  "Dorthy",
	  "Doug",
	  "Douglas",
	  "Dovie",
	  "Doyle",
	  "Drake",
	  "Drew",
	  "Duane",
	  "Dudley",
	  "Dulce",
	  "Duncan",
	  "Durward",
	  "Dustin",
	  "Dusty",
	  "Dwight",
	  "Dylan",
	  "Earl",
	  "Earlene",
	  "Earline",
	  "Earnest",
	  "Earnestine",
	  "Easter",
	  "Easton",
	  "Ebba",
	  "Ebony",
	  "Ed",
	  "Eda",
	  "Edd",
	  "Eddie",
	  "Eden",
	  "Edgar",
	  "Edgardo",
	  "Edison",
	  "Edmond",
	  "Edmund",
	  "Edna",
	  "Eduardo",
	  "Edward",
	  "Edwardo",
	  "Edwin",
	  "Edwina",
	  "Edyth",
	  "Edythe",
	  "Effie",
	  "Efrain",
	  "Efren",
	  "Eileen",
	  "Einar",
	  "Eino",
	  "Eladio",
	  "Elaina",
	  "Elbert",
	  "Elda",
	  "Eldon",
	  "Eldora",
	  "Eldred",
	  "Eldridge",
	  "Eleanora",
	  "Eleanore",
	  "Eleazar",
	  "Electa",
	  "Elena",
	  "Elenor",
	  "Elenora",
	  "Eleonore",
	  "Elfrieda",
	  "Eli",
	  "Elian",
	  "Eliane",
	  "Elias",
	  "Eliezer",
	  "Elijah",
	  "Elinor",
	  "Elinore",
	  "Elisa",
	  "Elisabeth",
	  "Elise",
	  "Eliseo",
	  "Elisha",
	  "Elissa",
	  "Eliza",
	  "Elizabeth",
	  "Ella",
	  "Ellen",
	  "Ellie",
	  "Elliot",
	  "Elliott",
	  "Ellis",
	  "Ellsworth",
	  "Elmer",
	  "Elmira",
	  "Elmo",
	  "Elmore",
	  "Elna",
	  "Elnora",
	  "Elody",
	  "Eloisa",
	  "Eloise",
	  "Elouise",
	  "Eloy",
	  "Elroy",
	  "Elsa",
	  "Else",
	  "Elsie",
	  "Elta",
	  "Elton",
	  "Elva",
	  "Elvera",
	  "Elvie",
	  "Elvis",
	  "Elwin",
	  "Elwyn",
	  "Elyse",
	  "Elyssa",
	  "Elza",
	  "Emanuel",
	  "Emelia",
	  "Emelie",
	  "Emely",
	  "Emerald",
	  "Emerson",
	  "Emery",
	  "Emie",
	  "Emil",
	  "Emile",
	  "Emilia",
	  "Emiliano",
	  "Emilie",
	  "Emilio",
	  "Emily",
	  "Emma",
	  "Emmalee",
	  "Emmanuel",
	  "Emmanuelle",
	  "Emmet",
	  "Emmett",
	  "Emmie",
	  "Emmitt",
	  "Emmy",
	  "Emory",
	  "Ena",
	  "Enid",
	  "Enoch",
	  "Enola",
	  "Enos",
	  "Enrico",
	  "Enrique",
	  "Ephraim",
	  "Era",
	  "Eriberto",
	  "Eric",
	  "Erica",
	  "Erich",
	  "Erick",
	  "Ericka",
	  "Erik",
	  "Erika",
	  "Erin",
	  "Erling",
	  "Erna",
	  "Ernest",
	  "Ernestina",
	  "Ernestine",
	  "Ernesto",
	  "Ernie",
	  "Ervin",
	  "Erwin",
	  "Eryn",
	  "Esmeralda",
	  "Esperanza",
	  "Esta",
	  "Esteban",
	  "Estefania",
	  "Estel",
	  "Estell",
	  "Estella",
	  "Estelle",
	  "Estevan",
	  "Esther",
	  "Estrella",
	  "Etha",
	  "Ethan",
	  "Ethel",
	  "Ethelyn",
	  "Ethyl",
	  "Ettie",
	  "Eudora",
	  "Eugene",
	  "Eugenia",
	  "Eula",
	  "Eulah",
	  "Eulalia",
	  "Euna",
	  "Eunice",
	  "Eusebio",
	  "Eva",
	  "Evalyn",
	  "Evan",
	  "Evangeline",
	  "Evans",
	  "Eve",
	  "Eveline",
	  "Evelyn",
	  "Everardo",
	  "Everett",
	  "Everette",
	  "Evert",
	  "Evie",
	  "Ewald",
	  "Ewell",
	  "Ezekiel",
	  "Ezequiel",
	  "Ezra",
	  "Fabian",
	  "Fabiola",
	  "Fae",
	  "Fannie",
	  "Fanny",
	  "Fatima",
	  "Faustino",
	  "Fausto",
	  "Favian",
	  "Fay",
	  "Faye",
	  "Federico",
	  "Felicia",
	  "Felicita",
	  "Felicity",
	  "Felipa",
	  "Felipe",
	  "Felix",
	  "Felton",
	  "Fermin",
	  "Fern",
	  "Fernando",
	  "Ferne",
	  "Fidel",
	  "Filiberto",
	  "Filomena",
	  "Finn",
	  "Fiona",
	  "Flavie",
	  "Flavio",
	  "Fleta",
	  "Fletcher",
	  "Flo",
	  "Florence",
	  "Florencio",
	  "Florian",
	  "Florida",
	  "Florine",
	  "Flossie",
	  "Floy",
	  "Floyd",
	  "Ford",
	  "Forest",
	  "Forrest",
	  "Foster",
	  "Frances",
	  "Francesca",
	  "Francesco",
	  "Francis",
	  "Francisca",
	  "Francisco",
	  "Franco",
	  "Frank",
	  "Frankie",
	  "Franz",
	  "Fred",
	  "Freda",
	  "Freddie",
	  "Freddy",
	  "Frederic",
	  "Frederick",
	  "Frederik",
	  "Frederique",
	  "Fredrick",
	  "Fredy",
	  "Freeda",
	  "Freeman",
	  "Freida",
	  "Frida",
	  "Frieda",
	  "Friedrich",
	  "Fritz",
	  "Furman",
	  "Gabe",
	  "Gabriel",
	  "Gabriella",
	  "Gabrielle",
	  "Gaetano",
	  "Gage",
	  "Gail",
	  "Gardner",
	  "Garett",
	  "Garfield",
	  "Garland",
	  "Garnet",
	  "Garnett",
	  "Garret",
	  "Garrett",
	  "Garrick",
	  "Garrison",
	  "Garry",
	  "Garth",
	  "Gaston",
	  "Gavin",
	  "Gay",
	  "Gayle",
	  "Gaylord",
	  "Gene",
	  "General",
	  "Genesis",
	  "Genevieve",
	  "Gennaro",
	  "Genoveva",
	  "Geo",
	  "Geoffrey",
	  "George",
	  "Georgette",
	  "Georgiana",
	  "Georgianna",
	  "Geovanni",
	  "Geovanny",
	  "Geovany",
	  "Gerald",
	  "Geraldine",
	  "Gerard",
	  "Gerardo",
	  "Gerda",
	  "Gerhard",
	  "Germaine",
	  "German",
	  "Gerry",
	  "Gerson",
	  "Gertrude",
	  "Gia",
	  "Gianni",
	  "Gideon",
	  "Gilbert",
	  "Gilberto",
	  "Gilda",
	  "Giles",
	  "Gillian",
	  "Gina",
	  "Gino",
	  "Giovani",
	  "Giovanna",
	  "Giovanni",
	  "Giovanny",
	  "Gisselle",
	  "Giuseppe",
	  "Gladyce",
	  "Gladys",
	  "Glen",
	  "Glenda",
	  "Glenna",
	  "Glennie",
	  "Gloria",
	  "Godfrey",
	  "Golda",
	  "Golden",
	  "Gonzalo",
	  "Gordon",
	  "Grace",
	  "Gracie",
	  "Graciela",
	  "Grady",
	  "Graham",
	  "Grant",
	  "Granville",
	  "Grayce",
	  "Grayson",
	  "Green",
	  "Greg",
	  "Gregg",
	  "Gregoria",
	  "Gregorio",
	  "Gregory",
	  "Greta",
	  "Gretchen",
	  "Greyson",
	  "Griffin",
	  "Grover",
	  "Guadalupe",
	  "Gudrun",
	  "Guido",
	  "Guillermo",
	  "Guiseppe",
	  "Gunnar",
	  "Gunner",
	  "Gus",
	  "Gussie",
	  "Gust",
	  "Gustave",
	  "Guy",
	  "Gwen",
	  "Gwendolyn",
	  "Hadley",
	  "Hailee",
	  "Hailey",
	  "Hailie",
	  "Hal",
	  "Haleigh",
	  "Haley",
	  "Halie",
	  "Halle",
	  "Hallie",
	  "Hank",
	  "Hanna",
	  "Hannah",
	  "Hans",
	  "Hardy",
	  "Harley",
	  "Harmon",
	  "Harmony",
	  "Harold",
	  "Harrison",
	  "Harry",
	  "Harvey",
	  "Haskell",
	  "Hassan",
	  "Hassie",
	  "Hattie",
	  "Haven",
	  "Hayden",
	  "Haylee",
	  "Hayley",
	  "Haylie",
	  "Hazel",
	  "Hazle",
	  "Heath",
	  "Heather",
	  "Heaven",
	  "Heber",
	  "Hector",
	  "Heidi",
	  "Helen",
	  "Helena",
	  "Helene",
	  "Helga",
	  "Hellen",
	  "Helmer",
	  "Heloise",
	  "Henderson",
	  "Henri",
	  "Henriette",
	  "Henry",
	  "Herbert",
	  "Herman",
	  "Hermann",
	  "Hermina",
	  "Herminia",
	  "Herminio",
	  "Hershel",
	  "Herta",
	  "Hertha",
	  "Hester",
	  "Hettie",
	  "Hilario",
	  "Hilbert",
	  "Hilda",
	  "Hildegard",
	  "Hillard",
	  "Hillary",
	  "Hilma",
	  "Hilton",
	  "Hipolito",
	  "Hiram",
	  "Hobart",
	  "Holden",
	  "Hollie",
	  "Hollis",
	  "Holly",
	  "Hope",
	  "Horace",
	  "Horacio",
	  "Hortense",
	  "Hosea",
	  "Houston",
	  "Howard",
	  "Howell",
	  "Hoyt",
	  "Hubert",
	  "Hudson",
	  "Hugh",
	  "Hulda",
	  "Humberto",
	  "Hunter",
	  "Hyman",
	  "Ian",
	  "Ibrahim",
	  "Icie",
	  "Ida",
	  "Idell",
	  "Idella",
	  "Ignacio",
	  "Ignatius",
	  "Ike",
	  "Ila",
	  "Ilene",
	  "Iliana",
	  "Ima",
	  "Imani",
	  "Imelda",
	  "Immanuel",
	  "Imogene",
	  "Ines",
	  "Irma",
	  "Irving",
	  "Irwin",
	  "Isaac",
	  "Isabel",
	  "Isabell",
	  "Isabella",
	  "Isabelle",
	  "Isac",
	  "Isadore",
	  "Isai",
	  "Isaiah",
	  "Isaias",
	  "Isidro",
	  "Ismael",
	  "Isobel",
	  "Isom",
	  "Israel",
	  "Issac",
	  "Itzel",
	  "Iva",
	  "Ivah",
	  "Ivory",
	  "Ivy",
	  "Izabella",
	  "Izaiah",
	  "Jabari",
	  "Jace",
	  "Jacey",
	  "Jacinthe",
	  "Jacinto",
	  "Jack",
	  "Jackeline",
	  "Jackie",
	  "Jacklyn",
	  "Jackson",
	  "Jacky",
	  "Jaclyn",
	  "Jacquelyn",
	  "Jacques",
	  "Jacynthe",
	  "Jada",
	  "Jade",
	  "Jaden",
	  "Jadon",
	  "Jadyn",
	  "Jaeden",
	  "Jaida",
	  "Jaiden",
	  "Jailyn",
	  "Jaime",
	  "Jairo",
	  "Jakayla",
	  "Jake",
	  "Jakob",
	  "Jaleel",
	  "Jalen",
	  "Jalon",
	  "Jalyn",
	  "Jamaal",
	  "Jamal",
	  "Jamar",
	  "Jamarcus",
	  "Jamel",
	  "Jameson",
	  "Jamey",
	  "Jamie",
	  "Jamil",
	  "Jamir",
	  "Jamison",
	  "Jammie",
	  "Jan",
	  "Jana",
	  "Janae",
	  "Jane",
	  "Janelle",
	  "Janessa",
	  "Janet",
	  "Janice",
	  "Janick",
	  "Janie",
	  "Janis",
	  "Janiya",
	  "Jannie",
	  "Jany",
	  "Jaquan",
	  "Jaquelin",
	  "Jaqueline",
	  "Jared",
	  "Jaren",
	  "Jarod",
	  "Jaron",
	  "Jarred",
	  "Jarrell",
	  "Jarret",
	  "Jarrett",
	  "Jarrod",
	  "Jarvis",
	  "Jasen",
	  "Jasmin",
	  "Jason",
	  "Jasper",
	  "Jaunita",
	  "Javier",
	  "Javon",
	  "Javonte",
	  "Jay",
	  "Jayce",
	  "Jaycee",
	  "Jayda",
	  "Jayde",
	  "Jayden",
	  "Jaydon",
	  "Jaylan",
	  "Jaylen",
	  "Jaylin",
	  "Jaylon",
	  "Jayme",
	  "Jayne",
	  "Jayson",
	  "Jazlyn",
	  "Jazmin",
	  "Jazmyn",
	  "Jazmyne",
	  "Jean",
	  "Jeanette",
	  "Jeanie",
	  "Jeanne",
	  "Jed",
	  "Jedediah",
	  "Jedidiah",
	  "Jeff",
	  "Jefferey",
	  "Jeffery",
	  "Jeffrey",
	  "Jeffry",
	  "Jena",
	  "Jenifer",
	  "Jennie",
	  "Jennifer",
	  "Jennings",
	  "Jennyfer",
	  "Jensen",
	  "Jerad",
	  "Jerald",
	  "Jeramie",
	  "Jeramy",
	  "Jerel",
	  "Jeremie",
	  "Jeremy",
	  "Jermain",
	  "Jermaine",
	  "Jermey",
	  "Jerod",
	  "Jerome",
	  "Jeromy",
	  "Jerrell",
	  "Jerrod",
	  "Jerrold",
	  "Jerry",
	  "Jess",
	  "Jesse",
	  "Jessica",
	  "Jessie",
	  "Jessika",
	  "Jessy",
	  "Jessyca",
	  "Jesus",
	  "Jett",
	  "Jettie",
	  "Jevon",
	  "Jewel",
	  "Jewell",
	  "Jillian",
	  "Jimmie",
	  "Jimmy",
	  "Jo",
	  "Joan",
	  "Joana",
	  "Joanie",
	  "Joanne",
	  "Joannie",
	  "Joanny",
	  "Joany",
	  "Joaquin",
	  "Jocelyn",
	  "Jodie",
	  "Jody",
	  "Joe",
	  "Joel",
	  "Joelle",
	  "Joesph",
	  "Joey",
	  "Johan",
	  "Johann",
	  "Johanna",
	  "Johathan",
	  "John",
	  "Johnathan",
	  "Johnathon",
	  "Johnnie",
	  "Johnny",
	  "Johnpaul",
	  "Johnson",
	  "Jolie",
	  "Jon",
	  "Jonas",
	  "Jonatan",
	  "Jonathan",
	  "Jonathon",
	  "Jordan",
	  "Jordane",
	  "Jordi",
	  "Jordon",
	  "Jordy",
	  "Jordyn",
	  "Jorge",
	  "Jose",
	  "Josefa",
	  "Josefina",
	  "Joseph",
	  "Josephine",
	  "Josh",
	  "Joshua",
	  "Joshuah",
	  "Josiah",
	  "Josiane",
	  "Josianne",
	  "Josie",
	  "Josue",
	  "Jovan",
	  "Jovani",
	  "Jovanny",
	  "Jovany",
	  "Joy",
	  "Joyce",
	  "Juana",
	  "Juanita",
	  "Judah",
	  "Judd",
	  "Jude",
	  "Judge",
	  "Judson",
	  "Judy",
	  "Jules",
	  "Julia",
	  "Julian",
	  "Juliana",
	  "Julianne",
	  "Julie",
	  "Julien",
	  "Juliet",
	  "Julio",
	  "Julius",
	  "June",
	  "Junior",
	  "Junius",
	  "Justen",
	  "Justice",
	  "Justina",
	  "Justine",
	  "Juston",
	  "Justus",
	  "Justyn",
	  "Juvenal",
	  "Juwan",
	  "Kacey",
	  "Kaci",
	  "Kacie",
	  "Kade",
	  "Kaden",
	  "Kadin",
	  "Kaela",
	  "Kaelyn",
	  "Kaia",
	  "Kailee",
	  "Kailey",
	  "Kailyn",
	  "Kaitlin",
	  "Kaitlyn",
	  "Kale",
	  "Kaleb",
	  "Kaleigh",
	  "Kaley",
	  "Kali",
	  "Kallie",
	  "Kameron",
	  "Kamille",
	  "Kamren",
	  "Kamron",
	  "Kamryn",
	  "Kane",
	  "Kara",
	  "Kareem",
	  "Karelle",
	  "Karen",
	  "Kari",
	  "Kariane",
	  "Karianne",
	  "Karina",
	  "Karine",
	  "Karl",
	  "Karlee",
	  "Karley",
	  "Karli",
	  "Karlie",
	  "Karolann",
	  "Karson",
	  "Kasandra",
	  "Kasey",
	  "Kassandra",
	  "Katarina",
	  "Katelin",
	  "Katelyn",
	  "Katelynn",
	  "Katharina",
	  "Katherine",
	  "Katheryn",
	  "Kathleen",
	  "Kathlyn",
	  "Kathryn",
	  "Kathryne",
	  "Katlyn",
	  "Katlynn",
	  "Katrina",
	  "Katrine",
	  "Kattie",
	  "Kavon",
	  "Kay",
	  "Kaya",
	  "Kaycee",
	  "Kayden",
	  "Kayla",
	  "Kaylah",
	  "Kaylee",
	  "Kayleigh",
	  "Kayley",
	  "Kayli",
	  "Kaylie",
	  "Kaylin",
	  "Keagan",
	  "Keanu",
	  "Keara",
	  "Keaton",
	  "Keegan",
	  "Keeley",
	  "Keely",
	  "Keenan",
	  "Keira",
	  "Keith",
	  "Kellen",
	  "Kelley",
	  "Kelli",
	  "Kellie",
	  "Kelly",
	  "Kelsi",
	  "Kelsie",
	  "Kelton",
	  "Kelvin",
	  "Ken",
	  "Kendall",
	  "Kendra",
	  "Kendrick",
	  "Kenna",
	  "Kennedi",
	  "Kennedy",
	  "Kenneth",
	  "Kennith",
	  "Kenny",
	  "Kenton",
	  "Kenya",
	  "Kenyatta",
	  "Kenyon",
	  "Keon",
	  "Keshaun",
	  "Keshawn",
	  "Keven",
	  "Kevin",
	  "Kevon",
	  "Keyon",
	  "Keyshawn",
	  "Khalid",
	  "Khalil",
	  "Kian",
	  "Kiana",
	  "Kianna",
	  "Kiara",
	  "Kiarra",
	  "Kiel",
	  "Kiera",
	  "Kieran",
	  "Kiley",
	  "Kim",
	  "Kimberly",
	  "King",
	  "Kip",
	  "Kira",
	  "Kirk",
	  "Kirsten",
	  "Kirstin",
	  "Kitty",
	  "Kobe",
	  "Koby",
	  "Kody",
	  "Kolby",
	  "Kole",
	  "Korbin",
	  "Korey",
	  "Kory",
	  "Kraig",
	  "Kris",
	  "Krista",
	  "Kristian",
	  "Kristin",
	  "Kristina",
	  "Kristofer",
	  "Kristoffer",
	  "Kristopher",
	  "Kristy",
	  "Krystal",
	  "Krystel",
	  "Krystina",
	  "Kurt",
	  "Kurtis",
	  "Kyla",
	  "Kyle",
	  "Kylee",
	  "Kyleigh",
	  "Kyler",
	  "Kylie",
	  "Kyra",
	  "Lacey",
	  "Lacy",
	  "Ladarius",
	  "Lafayette",
	  "Laila",
	  "Laisha",
	  "Lamar",
	  "Lambert",
	  "Lamont",
	  "Lance",
	  "Landen",
	  "Lane",
	  "Laney",
	  "Larissa",
	  "Laron",
	  "Larry",
	  "Larue",
	  "Laura",
	  "Laurel",
	  "Lauren",
	  "Laurence",
	  "Lauretta",
	  "Lauriane",
	  "Laurianne",
	  "Laurie",
	  "Laurine",
	  "Laury",
	  "Lauryn",
	  "Lavada",
	  "Lavern",
	  "Laverna",
	  "Laverne",
	  "Lavina",
	  "Lavinia",
	  "Lavon",
	  "Lavonne",
	  "Lawrence",
	  "Lawson",
	  "Layla",
	  "Layne",
	  "Lazaro",
	  "Lea",
	  "Leann",
	  "Leanna",
	  "Leanne",
	  "Leatha",
	  "Leda",
	  "Lee",
	  "Leif",
	  "Leila",
	  "Leilani",
	  "Lela",
	  "Lelah",
	  "Leland",
	  "Lelia",
	  "Lempi",
	  "Lemuel",
	  "Lenna",
	  "Lennie",
	  "Lenny",
	  "Lenora",
	  "Lenore",
	  "Leo",
	  "Leola",
	  "Leon",
	  "Leonard",
	  "Leonardo",
	  "Leone",
	  "Leonel",
	  "Leonie",
	  "Leonor",
	  "Leonora",
	  "Leopold",
	  "Leopoldo",
	  "Leora",
	  "Lera",
	  "Lesley",
	  "Leslie",
	  "Lesly",
	  "Lessie",
	  "Lester",
	  "Leta",
	  "Letha",
	  "Letitia",
	  "Levi",
	  "Lew",
	  "Lewis",
	  "Lexi",
	  "Lexie",
	  "Lexus",
	  "Lia",
	  "Liam",
	  "Liana",
	  "Libbie",
	  "Libby",
	  "Lila",
	  "Lilian",
	  "Liliana",
	  "Liliane",
	  "Lilla",
	  "Lillian",
	  "Lilliana",
	  "Lillie",
	  "Lilly",
	  "Lily",
	  "Lilyan",
	  "Lina",
	  "Lincoln",
	  "Linda",
	  "Lindsay",
	  "Lindsey",
	  "Linnea",
	  "Linnie",
	  "Linwood",
	  "Lionel",
	  "Lisa",
	  "Lisandro",
	  "Lisette",
	  "Litzy",
	  "Liza",
	  "Lizeth",
	  "Lizzie",
	  "Llewellyn",
	  "Lloyd",
	  "Logan",
	  "Lois",
	  "Lola",
	  "Lolita",
	  "Loma",
	  "Lon",
	  "London",
	  "Lonie",
	  "Lonnie",
	  "Lonny",
	  "Lonzo",
	  "Lora",
	  "Loraine",
	  "Loren",
	  "Lorena",
	  "Lorenz",
	  "Lorenza",
	  "Lorenzo",
	  "Lori",
	  "Lorine",
	  "Lorna",
	  "Lottie",
	  "Lou",
	  "Louie",
	  "Louisa",
	  "Lourdes",
	  "Louvenia",
	  "Lowell",
	  "Loy",
	  "Loyal",
	  "Loyce",
	  "Lucas",
	  "Luciano",
	  "Lucie",
	  "Lucienne",
	  "Lucile",
	  "Lucinda",
	  "Lucio",
	  "Lucious",
	  "Lucius",
	  "Lucy",
	  "Ludie",
	  "Ludwig",
	  "Lue",
	  "Luella",
	  "Luigi",
	  "Luis",
	  "Luisa",
	  "Lukas",
	  "Lula",
	  "Lulu",
	  "Luna",
	  "Lupe",
	  "Lura",
	  "Lurline",
	  "Luther",
	  "Luz",
	  "Lyda",
	  "Lydia",
	  "Lyla",
	  "Lynn",
	  "Lyric",
	  "Lysanne",
	  "Mabel",
	  "Mabelle",
	  "Mable",
	  "Mac",
	  "Macey",
	  "Maci",
	  "Macie",
	  "Mack",
	  "Mackenzie",
	  "Macy",
	  "Madaline",
	  "Madalyn",
	  "Maddison",
	  "Madeline",
	  "Madelyn",
	  "Madelynn",
	  "Madge",
	  "Madie",
	  "Madilyn",
	  "Madisen",
	  "Madison",
	  "Madisyn",
	  "Madonna",
	  "Madyson",
	  "Mae",
	  "Maegan",
	  "Maeve",
	  "Mafalda",
	  "Magali",
	  "Magdalen",
	  "Magdalena",
	  "Maggie",
	  "Magnolia",
	  "Magnus",
	  "Maia",
	  "Maida",
	  "Maiya",
	  "Major",
	  "Makayla",
	  "Makenna",
	  "Makenzie",
	  "Malachi",
	  "Malcolm",
	  "Malika",
	  "Malinda",
	  "Mallie",
	  "Mallory",
	  "Malvina",
	  "Mandy",
	  "Manley",
	  "Manuel",
	  "Manuela",
	  "Mara",
	  "Marc",
	  "Marcel",
	  "Marcelina",
	  "Marcelino",
	  "Marcella",
	  "Marcelle",
	  "Marcellus",
	  "Marcelo",
	  "Marcia",
	  "Marco",
	  "Marcos",
	  "Marcus",
	  "Margaret",
	  "Margarete",
	  "Margarett",
	  "Margaretta",
	  "Margarette",
	  "Margarita",
	  "Marge",
	  "Margie",
	  "Margot",
	  "Margret",
	  "Marguerite",
	  "Maria",
	  "Mariah",
	  "Mariam",
	  "Marian",
	  "Mariana",
	  "Mariane",
	  "Marianna",
	  "Marianne",
	  "Mariano",
	  "Maribel",
	  "Marie",
	  "Mariela",
	  "Marielle",
	  "Marietta",
	  "Marilie",
	  "Marilou",
	  "Marilyne",
	  "Marina",
	  "Mario",
	  "Marion",
	  "Marisa",
	  "Marisol",
	  "Maritza",
	  "Marjolaine",
	  "Marjorie",
	  "Marjory",
	  "Mark",
	  "Markus",
	  "Marlee",
	  "Marlen",
	  "Marlene",
	  "Marley",
	  "Marlin",
	  "Marlon",
	  "Marques",
	  "Marquis",
	  "Marquise",
	  "Marshall",
	  "Marta",
	  "Martin",
	  "Martina",
	  "Martine",
	  "Marty",
	  "Marvin",
	  "Mary",
	  "Maryam",
	  "Maryjane",
	  "Maryse",
	  "Mason",
	  "Mateo",
	  "Mathew",
	  "Mathias",
	  "Mathilde",
	  "Matilda",
	  "Matilde",
	  "Matt",
	  "Matteo",
	  "Mattie",
	  "Maud",
	  "Maude",
	  "Maudie",
	  "Maureen",
	  "Maurice",
	  "Mauricio",
	  "Maurine",
	  "Maverick",
	  "Mavis",
	  "Max",
	  "Maxie",
	  "Maxime",
	  "Maximilian",
	  "Maximillia",
	  "Maximillian",
	  "Maximo",
	  "Maximus",
	  "Maxine",
	  "Maxwell",
	  "May",
	  "Maya",
	  "Maybell",
	  "Maybelle",
	  "Maye",
	  "Maymie",
	  "Maynard",
	  "Mayra",
	  "Mazie",
	  "Mckayla",
	  "Mckenna",
	  "Mckenzie",
	  "Meagan",
	  "Meaghan",
	  "Meda",
	  "Megane",
	  "Meggie",
	  "Meghan",
	  "Mekhi",
	  "Melany",
	  "Melba",
	  "Melisa",
	  "Melissa",
	  "Mellie",
	  "Melody",
	  "Melvin",
	  "Melvina",
	  "Melyna",
	  "Melyssa",
	  "Mercedes",
	  "Meredith",
	  "Merl",
	  "Merle",
	  "Merlin",
	  "Merritt",
	  "Mertie",
	  "Mervin",
	  "Meta",
	  "Mia",
	  "Micaela",
	  "Micah",
	  "Michael",
	  "Michaela",
	  "Michale",
	  "Micheal",
	  "Michel",
	  "Michele",
	  "Michelle",
	  "Miguel",
	  "Mikayla",
	  "Mike",
	  "Mikel",
	  "Milan",
	  "Miles",
	  "Milford",
	  "Miller",
	  "Millie",
	  "Milo",
	  "Milton",
	  "Mina",
	  "Minerva",
	  "Minnie",
	  "Miracle",
	  "Mireille",
	  "Mireya",
	  "Misael",
	  "Missouri",
	  "Misty",
	  "Mitchel",
	  "Mitchell",
	  "Mittie",
	  "Modesta",
	  "Modesto",
	  "Mohamed",
	  "Mohammad",
	  "Mohammed",
	  "Moises",
	  "Mollie",
	  "Molly",
	  "Mona",
	  "Monica",
	  "Monique",
	  "Monroe",
	  "Monserrat",
	  "Monserrate",
	  "Montana",
	  "Monte",
	  "Monty",
	  "Morgan",
	  "Moriah",
	  "Morris",
	  "Mortimer",
	  "Morton",
	  "Mose",
	  "Moses",
	  "Moshe",
	  "Mossie",
	  "Mozell",
	  "Mozelle",
	  "Muhammad",
	  "Muriel",
	  "Murl",
	  "Murphy",
	  "Murray",
	  "Mustafa",
	  "Mya",
	  "Myah",
	  "Mylene",
	  "Myles",
	  "Myra",
	  "Myriam",
	  "Myrl",
	  "Myrna",
	  "Myron",
	  "Myrtice",
	  "Myrtie",
	  "Myrtis",
	  "Myrtle",
	  "Nadia",
	  "Nakia",
	  "Name",
	  "Nannie",
	  "Naomi",
	  "Naomie",
	  "Napoleon",
	  "Narciso",
	  "Nash",
	  "Nasir",
	  "Nat",
	  "Natalia",
	  "Natalie",
	  "Natasha",
	  "Nathan",
	  "Nathanael",
	  "Nathanial",
	  "Nathaniel",
	  "Nathen",
	  "Nayeli",
	  "Neal",
	  "Ned",
	  "Nedra",
	  "Neha",
	  "Neil",
	  "Nelda",
	  "Nella",
	  "Nelle",
	  "Nellie",
	  "Nels",
	  "Nelson",
	  "Neoma",
	  "Nestor",
	  "Nettie",
	  "Neva",
	  "Newell",
	  "Newton",
	  "Nia",
	  "Nicholas",
	  "Nicholaus",
	  "Nichole",
	  "Nick",
	  "Nicklaus",
	  "Nickolas",
	  "Nico",
	  "Nicola",
	  "Nicolas",
	  "Nicole",
	  "Nicolette",
	  "Nigel",
	  "Nikita",
	  "Nikki",
	  "Nikko",
	  "Niko",
	  "Nikolas",
	  "Nils",
	  "Nina",
	  "Noah",
	  "Noble",
	  "Noe",
	  "Noel",
	  "Noelia",
	  "Noemi",
	  "Noemie",
	  "Noemy",
	  "Nola",
	  "Nolan",
	  "Nona",
	  "Nora",
	  "Norbert",
	  "Norberto",
	  "Norene",
	  "Norma",
	  "Norris",
	  "Norval",
	  "Norwood",
	  "Nova",
	  "Novella",
	  "Nya",
	  "Nyah",
	  "Nyasia",
	  "Obie",
	  "Oceane",
	  "Ocie",
	  "Octavia",
	  "Oda",
	  "Odell",
	  "Odessa",
	  "Odie",
	  "Ofelia",
	  "Okey",
	  "Ola",
	  "Olaf",
	  "Ole",
	  "Olen",
	  "Oleta",
	  "Olga",
	  "Olin",
	  "Oliver",
	  "Ollie",
	  "Oma",
	  "Omari",
	  "Omer",
	  "Ona",
	  "Onie",
	  "Opal",
	  "Ophelia",
	  "Ora",
	  "Oral",
	  "Oran",
	  "Oren",
	  "Orie",
	  "Orin",
	  "Orion",
	  "Orland",
	  "Orlando",
	  "Orlo",
	  "Orpha",
	  "Orrin",
	  "Orval",
	  "Orville",
	  "Osbaldo",
	  "Osborne",
	  "Oscar",
	  "Osvaldo",
	  "Oswald",
	  "Oswaldo",
	  "Otha",
	  "Otho",
	  "Otilia",
	  "Otis",
	  "Ottilie",
	  "Ottis",
	  "Otto",
	  "Ova",
	  "Owen",
	  "Ozella",
	  "Pablo",
	  "Paige",
	  "Palma",
	  "Pamela",
	  "Pansy",
	  "Paolo",
	  "Paris",
	  "Parker",
	  "Pascale",
	  "Pasquale",
	  "Pat",
	  "Patience",
	  "Patricia",
	  "Patrick",
	  "Patsy",
	  "Pattie",
	  "Paul",
	  "Paula",
	  "Pauline",
	  "Paxton",
	  "Payton",
	  "Pearl",
	  "Pearlie",
	  "Pearline",
	  "Pedro",
	  "Peggie",
	  "Penelope",
	  "Percival",
	  "Percy",
	  "Perry",
	  "Pete",
	  "Peter",
	  "Petra",
	  "Peyton",
	  "Philip",
	  "Phoebe",
	  "Phyllis",
	  "Pierce",
	  "Pierre",
	  "Pietro",
	  "Pink",
	  "Pinkie",
	  "Piper",
	  "Polly",
	  "Porter",
	  "Precious",
	  "Presley",
	  "Preston",
	  "Price",
	  "Prince",
	  "Princess",
	  "Priscilla",
	  "Providenci",
	  "Prudence",
	  "Queen",
	  "Queenie",
	  "Quentin",
	  "Quincy",
	  "Quinn",
	  "Quinten",
	  "Quinton",
	  "Rachael",
	  "Rachel",
	  "Rachelle",
	  "Rae",
	  "Raegan",
	  "Rafael",
	  "Rafaela",
	  "Raheem",
	  "Rahsaan",
	  "Rahul",
	  "Raina",
	  "Raleigh",
	  "Ralph",
	  "Ramiro",
	  "Ramon",
	  "Ramona",
	  "Randal",
	  "Randall",
	  "Randi",
	  "Randy",
	  "Ransom",
	  "Raoul",
	  "Raphael",
	  "Raphaelle",
	  "Raquel",
	  "Rashad",
	  "Rashawn",
	  "Rasheed",
	  "Raul",
	  "Raven",
	  "Ray",
	  "Raymond",
	  "Raymundo",
	  "Reagan",
	  "Reanna",
	  "Reba",
	  "Rebeca",
	  "Rebecca",
	  "Rebeka",
	  "Rebekah",
	  "Reece",
	  "Reed",
	  "Reese",
	  "Regan",
	  "Reggie",
	  "Reginald",
	  "Reid",
	  "Reilly",
	  "Reina",
	  "Reinhold",
	  "Remington",
	  "Rene",
	  "Renee",
	  "Ressie",
	  "Reta",
	  "Retha",
	  "Retta",
	  "Reuben",
	  "Reva",
	  "Rex",
	  "Rey",
	  "Reyes",
	  "Reymundo",
	  "Reyna",
	  "Reynold",
	  "Rhea",
	  "Rhett",
	  "Rhianna",
	  "Rhiannon",
	  "Rhoda",
	  "Ricardo",
	  "Richard",
	  "Richie",
	  "Richmond",
	  "Rick",
	  "Rickey",
	  "Rickie",
	  "Ricky",
	  "Rico",
	  "Rigoberto",
	  "Riley",
	  "Rita",
	  "River",
	  "Robb",
	  "Robbie",
	  "Robert",
	  "Roberta",
	  "Roberto",
	  "Robin",
	  "Robyn",
	  "Rocio",
	  "Rocky",
	  "Rod",
	  "Roderick",
	  "Rodger",
	  "Rodolfo",
	  "Rodrick",
	  "Rodrigo",
	  "Roel",
	  "Rogelio",
	  "Roger",
	  "Rogers",
	  "Rolando",
	  "Rollin",
	  "Roma",
	  "Romaine",
	  "Roman",
	  "Ron",
	  "Ronaldo",
	  "Ronny",
	  "Roosevelt",
	  "Rory",
	  "Rosa",
	  "Rosalee",
	  "Rosalia",
	  "Rosalind",
	  "Rosalinda",
	  "Rosalyn",
	  "Rosamond",
	  "Rosanna",
	  "Rosario",
	  "Roscoe",
	  "Rose",
	  "Rosella",
	  "Roselyn",
	  "Rosemarie",
	  "Rosemary",
	  "Rosendo",
	  "Rosetta",
	  "Rosie",
	  "Rosina",
	  "Roslyn",
	  "Ross",
	  "Rossie",
	  "Rowan",
	  "Rowena",
	  "Rowland",
	  "Roxane",
	  "Roxanne",
	  "Roy",
	  "Royal",
	  "Royce",
	  "Rozella",
	  "Ruben",
	  "Rubie",
	  "Ruby",
	  "Rubye",
	  "Rudolph",
	  "Rudy",
	  "Rupert",
	  "Russ",
	  "Russel",
	  "Russell",
	  "Rusty",
	  "Ruth",
	  "Ruthe",
	  "Ruthie",
	  "Ryan",
	  "Ryann",
	  "Ryder",
	  "Rylan",
	  "Rylee",
	  "Ryleigh",
	  "Ryley",
	  "Sabina",
	  "Sabrina",
	  "Sabryna",
	  "Sadie",
	  "Sadye",
	  "Sage",
	  "Saige",
	  "Sallie",
	  "Sally",
	  "Salma",
	  "Salvador",
	  "Salvatore",
	  "Sam",
	  "Samanta",
	  "Samantha",
	  "Samara",
	  "Samir",
	  "Sammie",
	  "Sammy",
	  "Samson",
	  "Sandra",
	  "Sandrine",
	  "Sandy",
	  "Sanford",
	  "Santa",
	  "Santiago",
	  "Santina",
	  "Santino",
	  "Santos",
	  "Sarah",
	  "Sarai",
	  "Sarina",
	  "Sasha",
	  "Saul",
	  "Savanah",
	  "Savanna",
	  "Savannah",
	  "Savion",
	  "Scarlett",
	  "Schuyler",
	  "Scot",
	  "Scottie",
	  "Scotty",
	  "Seamus",
	  "Sean",
	  "Sebastian",
	  "Sedrick",
	  "Selena",
	  "Selina",
	  "Selmer",
	  "Serena",
	  "Serenity",
	  "Seth",
	  "Shad",
	  "Shaina",
	  "Shakira",
	  "Shana",
	  "Shane",
	  "Shanel",
	  "Shanelle",
	  "Shania",
	  "Shanie",
	  "Shaniya",
	  "Shanna",
	  "Shannon",
	  "Shanny",
	  "Shanon",
	  "Shany",
	  "Sharon",
	  "Shaun",
	  "Shawn",
	  "Shawna",
	  "Shaylee",
	  "Shayna",
	  "Shayne",
	  "Shea",
	  "Sheila",
	  "Sheldon",
	  "Shemar",
	  "Sheridan",
	  "Sherman",
	  "Sherwood",
	  "Shirley",
	  "Shyann",
	  "Shyanne",
	  "Sibyl",
	  "Sid",
	  "Sidney",
	  "Sienna",
	  "Sierra",
	  "Sigmund",
	  "Sigrid",
	  "Sigurd",
	  "Silas",
	  "Sim",
	  "Simeon",
	  "Simone",
	  "Sincere",
	  "Sister",
	  "Skye",
	  "Skyla",
	  "Skylar",
	  "Sofia",
	  "Soledad",
	  "Solon",
	  "Sonia",
	  "Sonny",
	  "Sonya",
	  "Sophia",
	  "Sophie",
	  "Spencer",
	  "Stacey",
	  "Stacy",
	  "Stan",
	  "Stanford",
	  "Stanley",
	  "Stanton",
	  "Stefan",
	  "Stefanie",
	  "Stella",
	  "Stephan",
	  "Stephania",
	  "Stephanie",
	  "Stephany",
	  "Stephen",
	  "Stephon",
	  "Sterling",
	  "Steve",
	  "Stevie",
	  "Stewart",
	  "Stone",
	  "Stuart",
	  "Summer",
	  "Sunny",
	  "Susan",
	  "Susana",
	  "Susanna",
	  "Susie",
	  "Suzanne",
	  "Sven",
	  "Syble",
	  "Sydnee",
	  "Sydney",
	  "Sydni",
	  "Sydnie",
	  "Sylvan",
	  "Sylvester",
	  "Sylvia",
	  "Tabitha",
	  "Tad",
	  "Talia",
	  "Talon",
	  "Tamara",
	  "Tamia",
	  "Tania",
	  "Tanner",
	  "Tanya",
	  "Tara",
	  "Taryn",
	  "Tate",
	  "Tatum",
	  "Tatyana",
	  "Taurean",
	  "Tavares",
	  "Taya",
	  "Taylor",
	  "Teagan",
	  "Ted",
	  "Telly",
	  "Terence",
	  "Teresa",
	  "Terrance",
	  "Terrell",
	  "Terrence",
	  "Terrill",
	  "Terry",
	  "Tess",
	  "Tessie",
	  "Tevin",
	  "Thad",
	  "Thaddeus",
	  "Thalia",
	  "Thea",
	  "Thelma",
	  "Theo",
	  "Theodora",
	  "Theodore",
	  "Theresa",
	  "Therese",
	  "Theresia",
	  "Theron",
	  "Thomas",
	  "Thora",
	  "Thurman",
	  "Tia",
	  "Tiana",
	  "Tianna",
	  "Tiara",
	  "Tierra",
	  "Tiffany",
	  "Tillman",
	  "Timmothy",
	  "Timmy",
	  "Timothy",
	  "Tina",
	  "Tito",
	  "Titus",
	  "Tobin",
	  "Toby",
	  "Tod",
	  "Tom",
	  "Tomas",
	  "Tomasa",
	  "Tommie",
	  "Toney",
	  "Toni",
	  "Tony",
	  "Torey",
	  "Torrance",
	  "Torrey",
	  "Toy",
	  "Trace",
	  "Tracey",
	  "Tracy",
	  "Travis",
	  "Travon",
	  "Tre",
	  "Tremaine",
	  "Tremayne",
	  "Trent",
	  "Trenton",
	  "Tressa",
	  "Tressie",
	  "Treva",
	  "Trever",
	  "Trevion",
	  "Trevor",
	  "Trey",
	  "Trinity",
	  "Trisha",
	  "Tristian",
	  "Tristin",
	  "Triston",
	  "Troy",
	  "Trudie",
	  "Trycia",
	  "Trystan",
	  "Turner",
	  "Twila",
	  "Tyler",
	  "Tyra",
	  "Tyree",
	  "Tyreek",
	  "Tyrel",
	  "Tyrell",
	  "Tyrese",
	  "Tyrique",
	  "Tyshawn",
	  "Tyson",
	  "Ubaldo",
	  "Ulices",
	  "Ulises",
	  "Una",
	  "Unique",
	  "Urban",
	  "Uriah",
	  "Uriel",
	  "Ursula",
	  "Vada",
	  "Valentin",
	  "Valentina",
	  "Valentine",
	  "Valerie",
	  "Vallie",
	  "Van",
	  "Vance",
	  "Vanessa",
	  "Vaughn",
	  "Veda",
	  "Velda",
	  "Vella",
	  "Velma",
	  "Velva",
	  "Vena",
	  "Verda",
	  "Verdie",
	  "Vergie",
	  "Verla",
	  "Verlie",
	  "Vern",
	  "Verna",
	  "Verner",
	  "Vernice",
	  "Vernie",
	  "Vernon",
	  "Verona",
	  "Veronica",
	  "Vesta",
	  "Vicenta",
	  "Vicente",
	  "Vickie",
	  "Vicky",
	  "Victor",
	  "Victoria",
	  "Vida",
	  "Vidal",
	  "Vilma",
	  "Vince",
	  "Vincent",
	  "Vincenza",
	  "Vincenzo",
	  "Vinnie",
	  "Viola",
	  "Violet",
	  "Violette",
	  "Virgie",
	  "Virgil",
	  "Virginia",
	  "Virginie",
	  "Vita",
	  "Vito",
	  "Viva",
	  "Vivian",
	  "Viviane",
	  "Vivianne",
	  "Vivien",
	  "Vivienne",
	  "Vladimir",
	  "Wade",
	  "Waino",
	  "Waldo",
	  "Walker",
	  "Wallace",
	  "Walter",
	  "Walton",
	  "Wanda",
	  "Ward",
	  "Warren",
	  "Watson",
	  "Wava",
	  "Waylon",
	  "Wayne",
	  "Webster",
	  "Weldon",
	  "Wellington",
	  "Wendell",
	  "Wendy",
	  "Werner",
	  "Westley",
	  "Weston",
	  "Whitney",
	  "Wilber",
	  "Wilbert",
	  "Wilburn",
	  "Wiley",
	  "Wilford",
	  "Wilfred",
	  "Wilfredo",
	  "Wilfrid",
	  "Wilhelm",
	  "Wilhelmine",
	  "Will",
	  "Willa",
	  "Willard",
	  "William",
	  "Willie",
	  "Willis",
	  "Willow",
	  "Willy",
	  "Wilma",
	  "Wilmer",
	  "Wilson",
	  "Wilton",
	  "Winfield",
	  "Winifred",
	  "Winnifred",
	  "Winona",
	  "Winston",
	  "Woodrow",
	  "Wyatt",
	  "Wyman",
	  "Xander",
	  "Xavier",
	  "Xzavier",
	  "Yadira",
	  "Yasmeen",
	  "Yasmin",
	  "Yasmine",
	  "Yazmin",
	  "Yesenia",
	  "Yessenia",
	  "Yolanda",
	  "Yoshiko",
	  "Yvette",
	  "Yvonne",
	  "Zachariah",
	  "Zachary",
	  "Zachery",
	  "Zack",
	  "Zackary",
	  "Zackery",
	  "Zakary",
	  "Zander",
	  "Zane",
	  "Zaria",
	  "Zechariah",
	  "Zelda",
	  "Zella",
	  "Zelma",
	  "Zena",
	  "Zetta",
	  "Zion",
	  "Zita",
	  "Zoe",
	  "Zoey",
	  "Zoie",
	  "Zoila",
	  "Zola",
	  "Zora",
	  "Zula"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(915);
	name.last_name = __webpack_require__(917);
	name.prefix = __webpack_require__(919);
	name.suffix = __webpack_require__(920);
	name.title = __webpack_require__(921);
	name.name = __webpack_require__(918);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abbott",
	  "Abernathy",
	  "Abshire",
	  "Adams",
	  "Altenwerth",
	  "Anderson",
	  "Ankunding",
	  "Armstrong",
	  "Auer",
	  "Aufderhar",
	  "Bahringer",
	  "Bailey",
	  "Balistreri",
	  "Barrows",
	  "Bartell",
	  "Bartoletti",
	  "Barton",
	  "Bashirian",
	  "Batz",
	  "Bauch",
	  "Baumbach",
	  "Bayer",
	  "Beahan",
	  "Beatty",
	  "Bechtelar",
	  "Becker",
	  "Bednar",
	  "Beer",
	  "Beier",
	  "Berge",
	  "Bergnaum",
	  "Bergstrom",
	  "Bernhard",
	  "Bernier",
	  "Bins",
	  "Blanda",
	  "Blick",
	  "Block",
	  "Bode",
	  "Boehm",
	  "Bogan",
	  "Bogisich",
	  "Borer",
	  "Bosco",
	  "Botsford",
	  "Boyer",
	  "Boyle",
	  "Bradtke",
	  "Brakus",
	  "Braun",
	  "Breitenberg",
	  "Brekke",
	  "Brown",
	  "Bruen",
	  "Buckridge",
	  "Carroll",
	  "Carter",
	  "Cartwright",
	  "Casper",
	  "Cassin",
	  "Champlin",
	  "Christiansen",
	  "Cole",
	  "Collier",
	  "Collins",
	  "Conn",
	  "Connelly",
	  "Conroy",
	  "Considine",
	  "Corkery",
	  "Cormier",
	  "Corwin",
	  "Cremin",
	  "Crist",
	  "Crona",
	  "Cronin",
	  "Crooks",
	  "Cruickshank",
	  "Cummerata",
	  "Cummings",
	  "Dach",
	  "D'Amore",
	  "Daniel",
	  "Dare",
	  "Daugherty",
	  "Davis",
	  "Deckow",
	  "Denesik",
	  "Dibbert",
	  "Dickens",
	  "Dicki",
	  "Dickinson",
	  "Dietrich",
	  "Donnelly",
	  "Dooley",
	  "Douglas",
	  "Doyle",
	  "DuBuque",
	  "Durgan",
	  "Ebert",
	  "Effertz",
	  "Eichmann",
	  "Emard",
	  "Emmerich",
	  "Erdman",
	  "Ernser",
	  "Fadel",
	  "Fahey",
	  "Farrell",
	  "Fay",
	  "Feeney",
	  "Feest",
	  "Feil",
	  "Ferry",
	  "Fisher",
	  "Flatley",
	  "Frami",
	  "Franecki",
	  "Friesen",
	  "Fritsch",
	  "Funk",
	  "Gaylord",
	  "Gerhold",
	  "Gerlach",
	  "Gibson",
	  "Gislason",
	  "Gleason",
	  "Gleichner",
	  "Glover",
	  "Goldner",
	  "Goodwin",
	  "Gorczany",
	  "Gottlieb",
	  "Goyette",
	  "Grady",
	  "Graham",
	  "Grant",
	  "Green",
	  "Greenfelder",
	  "Greenholt",
	  "Grimes",
	  "Gulgowski",
	  "Gusikowski",
	  "Gutkowski",
	  "Gutmann",
	  "Haag",
	  "Hackett",
	  "Hagenes",
	  "Hahn",
	  "Haley",
	  "Halvorson",
	  "Hamill",
	  "Hammes",
	  "Hand",
	  "Hane",
	  "Hansen",
	  "Harber",
	  "Harris",
	  "Hartmann",
	  "Harvey",
	  "Hauck",
	  "Hayes",
	  "Heaney",
	  "Heathcote",
	  "Hegmann",
	  "Heidenreich",
	  "Heller",
	  "Herman",
	  "Hermann",
	  "Hermiston",
	  "Herzog",
	  "Hessel",
	  "Hettinger",
	  "Hickle",
	  "Hilll",
	  "Hills",
	  "Hilpert",
	  "Hintz",
	  "Hirthe",
	  "Hodkiewicz",
	  "Hoeger",
	  "Homenick",
	  "Hoppe",
	  "Howe",
	  "Howell",
	  "Hudson",
	  "Huel",
	  "Huels",
	  "Hyatt",
	  "Jacobi",
	  "Jacobs",
	  "Jacobson",
	  "Jakubowski",
	  "Jaskolski",
	  "Jast",
	  "Jenkins",
	  "Jerde",
	  "Johns",
	  "Johnson",
	  "Johnston",
	  "Jones",
	  "Kassulke",
	  "Kautzer",
	  "Keebler",
	  "Keeling",
	  "Kemmer",
	  "Kerluke",
	  "Kertzmann",
	  "Kessler",
	  "Kiehn",
	  "Kihn",
	  "Kilback",
	  "King",
	  "Kirlin",
	  "Klein",
	  "Kling",
	  "Klocko",
	  "Koch",
	  "Koelpin",
	  "Koepp",
	  "Kohler",
	  "Konopelski",
	  "Koss",
	  "Kovacek",
	  "Kozey",
	  "Krajcik",
	  "Kreiger",
	  "Kris",
	  "Kshlerin",
	  "Kub",
	  "Kuhic",
	  "Kuhlman",
	  "Kuhn",
	  "Kulas",
	  "Kunde",
	  "Kunze",
	  "Kuphal",
	  "Kutch",
	  "Kuvalis",
	  "Labadie",
	  "Lakin",
	  "Lang",
	  "Langosh",
	  "Langworth",
	  "Larkin",
	  "Larson",
	  "Leannon",
	  "Lebsack",
	  "Ledner",
	  "Leffler",
	  "Legros",
	  "Lehner",
	  "Lemke",
	  "Lesch",
	  "Leuschke",
	  "Lind",
	  "Lindgren",
	  "Littel",
	  "Little",
	  "Lockman",
	  "Lowe",
	  "Lubowitz",
	  "Lueilwitz",
	  "Luettgen",
	  "Lynch",
	  "Macejkovic",
	  "MacGyver",
	  "Maggio",
	  "Mann",
	  "Mante",
	  "Marks",
	  "Marquardt",
	  "Marvin",
	  "Mayer",
	  "Mayert",
	  "McClure",
	  "McCullough",
	  "McDermott",
	  "McGlynn",
	  "McKenzie",
	  "McLaughlin",
	  "Medhurst",
	  "Mertz",
	  "Metz",
	  "Miller",
	  "Mills",
	  "Mitchell",
	  "Moen",
	  "Mohr",
	  "Monahan",
	  "Moore",
	  "Morar",
	  "Morissette",
	  "Mosciski",
	  "Mraz",
	  "Mueller",
	  "Muller",
	  "Murazik",
	  "Murphy",
	  "Murray",
	  "Nader",
	  "Nicolas",
	  "Nienow",
	  "Nikolaus",
	  "Nitzsche",
	  "Nolan",
	  "Oberbrunner",
	  "O'Connell",
	  "O'Conner",
	  "O'Hara",
	  "O'Keefe",
	  "O'Kon",
	  "Okuneva",
	  "Olson",
	  "Ondricka",
	  "O'Reilly",
	  "Orn",
	  "Ortiz",
	  "Osinski",
	  "Pacocha",
	  "Padberg",
	  "Pagac",
	  "Parisian",
	  "Parker",
	  "Paucek",
	  "Pfannerstill",
	  "Pfeffer",
	  "Pollich",
	  "Pouros",
	  "Powlowski",
	  "Predovic",
	  "Price",
	  "Prohaska",
	  "Prosacco",
	  "Purdy",
	  "Quigley",
	  "Quitzon",
	  "Rath",
	  "Ratke",
	  "Rau",
	  "Raynor",
	  "Reichel",
	  "Reichert",
	  "Reilly",
	  "Reinger",
	  "Rempel",
	  "Renner",
	  "Reynolds",
	  "Rice",
	  "Rippin",
	  "Ritchie",
	  "Robel",
	  "Roberts",
	  "Rodriguez",
	  "Rogahn",
	  "Rohan",
	  "Rolfson",
	  "Romaguera",
	  "Roob",
	  "Rosenbaum",
	  "Rowe",
	  "Ruecker",
	  "Runolfsdottir",
	  "Runolfsson",
	  "Runte",
	  "Russel",
	  "Rutherford",
	  "Ryan",
	  "Sanford",
	  "Satterfield",
	  "Sauer",
	  "Sawayn",
	  "Schaden",
	  "Schaefer",
	  "Schamberger",
	  "Schiller",
	  "Schimmel",
	  "Schinner",
	  "Schmeler",
	  "Schmidt",
	  "Schmitt",
	  "Schneider",
	  "Schoen",
	  "Schowalter",
	  "Schroeder",
	  "Schulist",
	  "Schultz",
	  "Schumm",
	  "Schuppe",
	  "Schuster",
	  "Senger",
	  "Shanahan",
	  "Shields",
	  "Simonis",
	  "Sipes",
	  "Skiles",
	  "Smith",
	  "Smitham",
	  "Spencer",
	  "Spinka",
	  "Sporer",
	  "Stamm",
	  "Stanton",
	  "Stark",
	  "Stehr",
	  "Steuber",
	  "Stiedemann",
	  "Stokes",
	  "Stoltenberg",
	  "Stracke",
	  "Streich",
	  "Stroman",
	  "Strosin",
	  "Swaniawski",
	  "Swift",
	  "Terry",
	  "Thiel",
	  "Thompson",
	  "Tillman",
	  "Torp",
	  "Torphy",
	  "Towne",
	  "Toy",
	  "Trantow",
	  "Tremblay",
	  "Treutel",
	  "Tromp",
	  "Turcotte",
	  "Turner",
	  "Ullrich",
	  "Upton",
	  "Vandervort",
	  "Veum",
	  "Volkman",
	  "Von",
	  "VonRueden",
	  "Waelchi",
	  "Walker",
	  "Walsh",
	  "Walter",
	  "Ward",
	  "Waters",
	  "Watsica",
	  "Weber",
	  "Wehner",
	  "Weimann",
	  "Weissnat",
	  "Welch",
	  "West",
	  "White",
	  "Wiegand",
	  "Wilderman",
	  "Wilkinson",
	  "Will",
	  "Williamson",
	  "Willms",
	  "Windler",
	  "Wintheiser",
	  "Wisoky",
	  "Wisozk",
	  "Witting",
	  "Wiza",
	  "Wolf",
	  "Wolff",
	  "Wuckert",
	  "Wunsch",
	  "Wyman",
	  "Yost",
	  "Yundt",
	  "Zboncak",
	  "Zemlak",
	  "Ziemann",
	  "Zieme",
	  "Zulauf"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{suffix}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Mr.",
	  "Mrs.",
	  "Ms.",
	  "Miss",
	  "Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V",
	  "MD",
	  "DDS",
	  "PhD",
	  "DVM"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###-####",
	  "(###) ###-####",
	  "1-###-###-####",
	  "###.###.####",
	  "###-###-####",
	  "(###) ###-####",
	  "1-###-###-####",
	  "###.###.####",
	  "###-###-#### x###",
	  "(###) ###-#### x###",
	  "1-###-###-#### x###",
	  "###.###.#### x###",
	  "###-###-#### x####",
	  "(###) ###-#### x####",
	  "1-###-###-#### x####",
	  "###.###.#### x####",
	  "###-###-#### x#####",
	  "(###) ###-#### x#####",
	  "1-###-###-#### x#####",
	  "###.###.#### x#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(922);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var system = {};
	module['exports'] = system;
	system.mimeTypes = __webpack_require__(925);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	
	The MIT License (MIT)
	
	Copyright (c) 2014 Jonathan Ong me@jongleberry.com
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	Definitions from mime-db v1.21.0
	For updates check: https://github.com/jshttp/mime-db/blob/master/db.json
	
	*/
	
	module['exports'] = {
	  "application/1d-interleaved-parityfec": {
	    "source": "iana"
	  },
	  "application/3gpdash-qoe-report+xml": {
	    "source": "iana"
	  },
	  "application/3gpp-ims+xml": {
	    "source": "iana"
	  },
	  "application/a2l": {
	    "source": "iana"
	  },
	  "application/activemessage": {
	    "source": "iana"
	  },
	  "application/alto-costmap+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-costmapfilter+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-directory+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointcost+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointcostparams+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointprop+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointpropparams+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-error+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-networkmap+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-networkmapfilter+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/aml": {
	    "source": "iana"
	  },
	  "application/andrew-inset": {
	    "source": "iana",
	    "extensions": ["ez"]
	  },
	  "application/applefile": {
	    "source": "iana"
	  },
	  "application/applixware": {
	    "source": "apache",
	    "extensions": ["aw"]
	  },
	  "application/atf": {
	    "source": "iana"
	  },
	  "application/atfx": {
	    "source": "iana"
	  },
	  "application/atom+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["atom"]
	  },
	  "application/atomcat+xml": {
	    "source": "iana",
	    "extensions": ["atomcat"]
	  },
	  "application/atomdeleted+xml": {
	    "source": "iana"
	  },
	  "application/atomicmail": {
	    "source": "iana"
	  },
	  "application/atomsvc+xml": {
	    "source": "iana",
	    "extensions": ["atomsvc"]
	  },
	  "application/atxml": {
	    "source": "iana"
	  },
	  "application/auth-policy+xml": {
	    "source": "iana"
	  },
	  "application/bacnet-xdd+zip": {
	    "source": "iana"
	  },
	  "application/batch-smtp": {
	    "source": "iana"
	  },
	  "application/bdoc": {
	    "compressible": false,
	    "extensions": ["bdoc"]
	  },
	  "application/beep+xml": {
	    "source": "iana"
	  },
	  "application/calendar+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/calendar+xml": {
	    "source": "iana"
	  },
	  "application/call-completion": {
	    "source": "iana"
	  },
	  "application/cals-1840": {
	    "source": "iana"
	  },
	  "application/cbor": {
	    "source": "iana"
	  },
	  "application/ccmp+xml": {
	    "source": "iana"
	  },
	  "application/ccxml+xml": {
	    "source": "iana",
	    "extensions": ["ccxml"]
	  },
	  "application/cdfx+xml": {
	    "source": "iana"
	  },
	  "application/cdmi-capability": {
	    "source": "iana",
	    "extensions": ["cdmia"]
	  },
	  "application/cdmi-container": {
	    "source": "iana",
	    "extensions": ["cdmic"]
	  },
	  "application/cdmi-domain": {
	    "source": "iana",
	    "extensions": ["cdmid"]
	  },
	  "application/cdmi-object": {
	    "source": "iana",
	    "extensions": ["cdmio"]
	  },
	  "application/cdmi-queue": {
	    "source": "iana",
	    "extensions": ["cdmiq"]
	  },
	  "application/cdni": {
	    "source": "iana"
	  },
	  "application/cea": {
	    "source": "iana"
	  },
	  "application/cea-2018+xml": {
	    "source": "iana"
	  },
	  "application/cellml+xml": {
	    "source": "iana"
	  },
	  "application/cfw": {
	    "source": "iana"
	  },
	  "application/cms": {
	    "source": "iana"
	  },
	  "application/cnrp+xml": {
	    "source": "iana"
	  },
	  "application/coap-group+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/commonground": {
	    "source": "iana"
	  },
	  "application/conference-info+xml": {
	    "source": "iana"
	  },
	  "application/cpl+xml": {
	    "source": "iana"
	  },
	  "application/csrattrs": {
	    "source": "iana"
	  },
	  "application/csta+xml": {
	    "source": "iana"
	  },
	  "application/cstadata+xml": {
	    "source": "iana"
	  },
	  "application/csvm+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/cu-seeme": {
	    "source": "apache",
	    "extensions": ["cu"]
	  },
	  "application/cybercash": {
	    "source": "iana"
	  },
	  "application/dart": {
	    "compressible": true
	  },
	  "application/dash+xml": {
	    "source": "iana",
	    "extensions": ["mdp"]
	  },
	  "application/dashdelta": {
	    "source": "iana"
	  },
	  "application/davmount+xml": {
	    "source": "iana",
	    "extensions": ["davmount"]
	  },
	  "application/dca-rft": {
	    "source": "iana"
	  },
	  "application/dcd": {
	    "source": "iana"
	  },
	  "application/dec-dx": {
	    "source": "iana"
	  },
	  "application/dialog-info+xml": {
	    "source": "iana"
	  },
	  "application/dicom": {
	    "source": "iana"
	  },
	  "application/dii": {
	    "source": "iana"
	  },
	  "application/dit": {
	    "source": "iana"
	  },
	  "application/dns": {
	    "source": "iana"
	  },
	  "application/docbook+xml": {
	    "source": "apache",
	    "extensions": ["dbk"]
	  },
	  "application/dskpp+xml": {
	    "source": "iana"
	  },
	  "application/dssc+der": {
	    "source": "iana",
	    "extensions": ["dssc"]
	  },
	  "application/dssc+xml": {
	    "source": "iana",
	    "extensions": ["xdssc"]
	  },
	  "application/dvcs": {
	    "source": "iana"
	  },
	  "application/ecmascript": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["ecma"]
	  },
	  "application/edi-consent": {
	    "source": "iana"
	  },
	  "application/edi-x12": {
	    "source": "iana",
	    "compressible": false
	  },
	  "application/edifact": {
	    "source": "iana",
	    "compressible": false
	  },
	  "application/emergencycalldata.comment+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.deviceinfo+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.providerinfo+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.serviceinfo+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.subscriberinfo+xml": {
	    "source": "iana"
	  },
	  "application/emma+xml": {
	    "source": "iana",
	    "extensions": ["emma"]
	  },
	  "application/emotionml+xml": {
	    "source": "iana"
	  },
	  "application/encaprtp": {
	    "source": "iana"
	  },
	  "application/epp+xml": {
	    "source": "iana"
	  },
	  "application/epub+zip": {
	    "source": "iana",
	    "extensions": ["epub"]
	  },
	  "application/eshop": {
	    "source": "iana"
	  },
	  "application/exi": {
	    "source": "iana",
	    "extensions": ["exi"]
	  },
	  "application/fastinfoset": {
	    "source": "iana"
	  },
	  "application/fastsoap": {
	    "source": "iana"
	  },
	  "application/fdt+xml": {
	    "source": "iana"
	  },
	  "application/fits": {
	    "source": "iana"
	  },
	  "application/font-sfnt": {
	    "source": "iana"
	  },
	  "application/font-tdpfr": {
	    "source": "iana",
	    "extensions": ["pfr"]
	  },
	  "application/font-woff": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["woff"]
	  },
	  "application/font-woff2": {
	    "compressible": false,
	    "extensions": ["woff2"]
	  },
	  "application/framework-attributes+xml": {
	    "source": "iana"
	  },
	  "application/gml+xml": {
	    "source": "apache",
	    "extensions": ["gml"]
	  },
	  "application/gpx+xml": {
	    "source": "apache",
	    "extensions": ["gpx"]
	  },
	  "application/gxf": {
	    "source": "apache",
	    "extensions": ["gxf"]
	  },
	  "application/gzip": {
	    "source": "iana",
	    "compressible": false
	  },
	  "application/h224": {
	    "source": "iana"
	  },
	  "application/held+xml": {
	    "source": "iana"
	  },
	  "application/http": {
	    "source": "iana"
	  },
	  "application/hyperstudio": {
	    "source": "iana",
	    "extensions": ["stk"]
	  },
	  "application/ibe-key-request+xml": {
	    "source": "iana"
	  },
	  "application/ibe-pkg-reply+xml": {
	    "source": "iana"
	  },
	  "application/ibe-pp-data": {
	    "source": "iana"
	  },
	  "application/iges": {
	    "source": "iana"
	  },
	  "application/im-iscomposing+xml": {
	    "source": "iana"
	  },
	  "application/index": {
	    "source": "iana"
	  },
	  "application/index.cmd": {
	    "source": "iana"
	  },
	  "application/index.obj": {
	    "source": "iana"
	  },
	  "application/index.response": {
	    "source": "iana"
	  },
	  "application/index.vnd": {
	    "source": "iana"
	  },
	  "application/inkml+xml": {
	    "source": "iana",
	    "extensions": ["ink","inkml"]
	  },
	  "application/iotp": {
	    "source": "iana"
	  },
	  "application/ipfix": {
	    "source": "iana",
	    "extensions": ["ipfix"]
	  },
	  "application/ipp": {
	    "source": "iana"
	  },
	  "application/isup": {
	    "source": "iana"
	  },
	  "application/its+xml": {
	    "source": "iana"
	  },
	  "application/java-archive": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["jar","war","ear"]
	  },
	  "application/java-serialized-object": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["ser"]
	  },
	  "application/java-vm": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["class"]
	  },
	  "application/javascript": {
	    "source": "iana",
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["js"]
	  },
	  "application/jose": {
	    "source": "iana"
	  },
	  "application/jose+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/jrd+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/json": {
	    "source": "iana",
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["json","map"]
	  },
	  "application/json-patch+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/json-seq": {
	    "source": "iana"
	  },
	  "application/json5": {
	    "extensions": ["json5"]
	  },
	  "application/jsonml+json": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["jsonml"]
	  },
	  "application/jwk+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/jwk-set+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/jwt": {
	    "source": "iana"
	  },
	  "application/kpml-request+xml": {
	    "source": "iana"
	  },
	  "application/kpml-response+xml": {
	    "source": "iana"
	  },
	  "application/ld+json": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["jsonld"]
	  },
	  "application/link-format": {
	    "source": "iana"
	  },
	  "application/load-control+xml": {
	    "source": "iana"
	  },
	  "application/lost+xml": {
	    "source": "iana",
	    "extensions": ["lostxml"]
	  },
	  "application/lostsync+xml": {
	    "source": "iana"
	  },
	  "application/lxf": {
	    "source": "iana"
	  },
	  "application/mac-binhex40": {
	    "source": "iana",
	    "extensions": ["hqx"]
	  },
	  "application/mac-compactpro": {
	    "source": "apache",
	    "extensions": ["cpt"]
	  },
	  "application/macwriteii": {
	    "source": "iana"
	  },
	  "application/mads+xml": {
	    "source": "iana",
	    "extensions": ["mads"]
	  },
	  "application/manifest+json": {
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["webmanifest"]
	  },
	  "application/marc": {
	    "source": "iana",
	    "extensions": ["mrc"]
	  },
	  "application/marcxml+xml": {
	    "source": "iana",
	    "extensions": ["mrcx"]
	  },
	  "application/mathematica": {
	    "source": "iana",
	    "extensions": ["ma","nb","mb"]
	  },
	  "application/mathml+xml": {
	    "source": "iana",
	    "extensions": ["mathml"]
	  },
	  "application/mathml-content+xml": {
	    "source": "iana"
	  },
	  "application/mathml-presentation+xml": {
	    "source": "iana"
	  },
	  "application/mbms-associated-procedure-description+xml": {
	    "source": "iana"
	  },
	  "application/mbms-deregister+xml": {
	    "source": "iana"
	  },
	  "application/mbms-envelope+xml": {
	    "source": "iana"
	  },
	  "application/mbms-msk+xml": {
	    "source": "iana"
	  },
	  "application/mbms-msk-response+xml": {
	    "source": "iana"
	  },
	  "application/mbms-protection-description+xml": {
	    "source": "iana"
	  },
	  "application/mbms-reception-report+xml": {
	    "source": "iana"
	  },
	  "application/mbms-register+xml": {
	    "source": "iana"
	  },
	  "application/mbms-register-response+xml": {
	    "source": "iana"
	  },
	  "application/mbms-schedule+xml": {
	    "source": "iana"
	  },
	  "application/mbms-user-service-description+xml": {
	    "source": "iana"
	  },
	  "application/mbox": {
	    "source": "iana",
	    "extensions": ["mbox"]
	  },
	  "application/media-policy-dataset+xml": {
	    "source": "iana"
	  },
	  "application/media_control+xml": {
	    "source": "iana"
	  },
	  "application/mediaservercontrol+xml": {
	    "source": "iana",
	    "extensions": ["mscml"]
	  },
	  "application/merge-patch+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/metalink+xml": {
	    "source": "apache",
	    "extensions": ["metalink"]
	  },
	  "application/metalink4+xml": {
	    "source": "iana",
	    "extensions": ["meta4"]
	  },
	  "application/mets+xml": {
	    "source": "iana",
	    "extensions": ["mets"]
	  },
	  "application/mf4": {
	    "source": "iana"
	  },
	  "application/mikey": {
	    "source": "iana"
	  },
	  "application/mods+xml": {
	    "source": "iana",
	    "extensions": ["mods"]
	  },
	  "application/moss-keys": {
	    "source": "iana"
	  },
	  "application/moss-signature": {
	    "source": "iana"
	  },
	  "application/mosskey-data": {
	    "source": "iana"
	  },
	  "application/mosskey-request": {
	    "source": "iana"
	  },
	  "application/mp21": {
	    "source": "iana",
	    "extensions": ["m21","mp21"]
	  },
	  "application/mp4": {
	    "source": "iana",
	    "extensions": ["mp4s","m4p"]
	  },
	  "application/mpeg4-generic": {
	    "source": "iana"
	  },
	  "application/mpeg4-iod": {
	    "source": "iana"
	  },
	  "application/mpeg4-iod-xmt": {
	    "source": "iana"
	  },
	  "application/mrb-consumer+xml": {
	    "source": "iana"
	  },
	  "application/mrb-publish+xml": {
	    "source": "iana"
	  },
	  "application/msc-ivr+xml": {
	    "source": "iana"
	  },
	  "application/msc-mixer+xml": {
	    "source": "iana"
	  },
	  "application/msword": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["doc","dot"]
	  },
	  "application/mxf": {
	    "source": "iana",
	    "extensions": ["mxf"]
	  },
	  "application/nasdata": {
	    "source": "iana"
	  },
	  "application/news-checkgroups": {
	    "source": "iana"
	  },
	  "application/news-groupinfo": {
	    "source": "iana"
	  },
	  "application/news-transmission": {
	    "source": "iana"
	  },
	  "application/nlsml+xml": {
	    "source": "iana"
	  },
	  "application/nss": {
	    "source": "iana"
	  },
	  "application/ocsp-request": {
	    "source": "iana"
	  },
	  "application/ocsp-response": {
	    "source": "iana"
	  },
	  "application/octet-stream": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]
	  },
	  "application/oda": {
	    "source": "iana",
	    "extensions": ["oda"]
	  },
	  "application/odx": {
	    "source": "iana"
	  },
	  "application/oebps-package+xml": {
	    "source": "iana",
	    "extensions": ["opf"]
	  },
	  "application/ogg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["ogx"]
	  },
	  "application/omdoc+xml": {
	    "source": "apache",
	    "extensions": ["omdoc"]
	  },
	  "application/onenote": {
	    "source": "apache",
	    "extensions": ["onetoc","onetoc2","onetmp","onepkg"]
	  },
	  "application/oxps": {
	    "source": "iana",
	    "extensions": ["oxps"]
	  },
	  "application/p2p-overlay+xml": {
	    "source": "iana"
	  },
	  "application/parityfec": {
	    "source": "iana"
	  },
	  "application/patch-ops-error+xml": {
	    "source": "iana",
	    "extensions": ["xer"]
	  },
	  "application/pdf": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["pdf"]
	  },
	  "application/pdx": {
	    "source": "iana"
	  },
	  "application/pgp-encrypted": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["pgp"]
	  },
	  "application/pgp-keys": {
	    "source": "iana"
	  },
	  "application/pgp-signature": {
	    "source": "iana",
	    "extensions": ["asc","sig"]
	  },
	  "application/pics-rules": {
	    "source": "apache",
	    "extensions": ["prf"]
	  },
	  "application/pidf+xml": {
	    "source": "iana"
	  },
	  "application/pidf-diff+xml": {
	    "source": "iana"
	  },
	  "application/pkcs10": {
	    "source": "iana",
	    "extensions": ["p10"]
	  },
	  "application/pkcs12": {
	    "source": "iana"
	  },
	  "application/pkcs7-mime": {
	    "source": "iana",
	    "extensions": ["p7m","p7c"]
	  },
	  "application/pkcs7-signature": {
	    "source": "iana",
	    "extensions": ["p7s"]
	  },
	  "application/pkcs8": {
	    "source": "iana",
	    "extensions": ["p8"]
	  },
	  "application/pkix-attr-cert": {
	    "source": "iana",
	    "extensions": ["ac"]
	  },
	  "application/pkix-cert": {
	    "source": "iana",
	    "extensions": ["cer"]
	  },
	  "application/pkix-crl": {
	    "source": "iana",
	    "extensions": ["crl"]
	  },
	  "application/pkix-pkipath": {
	    "source": "iana",
	    "extensions": ["pkipath"]
	  },
	  "application/pkixcmp": {
	    "source": "iana",
	    "extensions": ["pki"]
	  },
	  "application/pls+xml": {
	    "source": "iana",
	    "extensions": ["pls"]
	  },
	  "application/poc-settings+xml": {
	    "source": "iana"
	  },
	  "application/postscript": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["ai","eps","ps"]
	  },
	  "application/provenance+xml": {
	    "source": "iana"
	  },
	  "application/prs.alvestrand.titrax-sheet": {
	    "source": "iana"
	  },
	  "application/prs.cww": {
	    "source": "iana",
	    "extensions": ["cww"]
	  },
	  "application/prs.hpub+zip": {
	    "source": "iana"
	  },
	  "application/prs.nprend": {
	    "source": "iana"
	  },
	  "application/prs.plucker": {
	    "source": "iana"
	  },
	  "application/prs.rdf-xml-crypt": {
	    "source": "iana"
	  },
	  "application/prs.xsf+xml": {
	    "source": "iana"
	  },
	  "application/pskc+xml": {
	    "source": "iana",
	    "extensions": ["pskcxml"]
	  },
	  "application/qsig": {
	    "source": "iana"
	  },
	  "application/raptorfec": {
	    "source": "iana"
	  },
	  "application/rdap+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/rdf+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rdf"]
	  },
	  "application/reginfo+xml": {
	    "source": "iana",
	    "extensions": ["rif"]
	  },
	  "application/relax-ng-compact-syntax": {
	    "source": "iana",
	    "extensions": ["rnc"]
	  },
	  "application/remote-printing": {
	    "source": "iana"
	  },
	  "application/reputon+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/resource-lists+xml": {
	    "source": "iana",
	    "extensions": ["rl"]
	  },
	  "application/resource-lists-diff+xml": {
	    "source": "iana",
	    "extensions": ["rld"]
	  },
	  "application/rfc+xml": {
	    "source": "iana"
	  },
	  "application/riscos": {
	    "source": "iana"
	  },
	  "application/rlmi+xml": {
	    "source": "iana"
	  },
	  "application/rls-services+xml": {
	    "source": "iana",
	    "extensions": ["rs"]
	  },
	  "application/rpki-ghostbusters": {
	    "source": "iana",
	    "extensions": ["gbr"]
	  },
	  "application/rpki-manifest": {
	    "source": "iana",
	    "extensions": ["mft"]
	  },
	  "application/rpki-roa": {
	    "source": "iana",
	    "extensions": ["roa"]
	  },
	  "application/rpki-updown": {
	    "source": "iana"
	  },
	  "application/rsd+xml": {
	    "source": "apache",
	    "extensions": ["rsd"]
	  },
	  "application/rss+xml": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["rss"]
	  },
	  "application/rtf": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rtf"]
	  },
	  "application/rtploopback": {
	    "source": "iana"
	  },
	  "application/rtx": {
	    "source": "iana"
	  },
	  "application/samlassertion+xml": {
	    "source": "iana"
	  },
	  "application/samlmetadata+xml": {
	    "source": "iana"
	  },
	  "application/sbml+xml": {
	    "source": "iana",
	    "extensions": ["sbml"]
	  },
	  "application/scaip+xml": {
	    "source": "iana"
	  },
	  "application/scim+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/scvp-cv-request": {
	    "source": "iana",
	    "extensions": ["scq"]
	  },
	  "application/scvp-cv-response": {
	    "source": "iana",
	    "extensions": ["scs"]
	  },
	  "application/scvp-vp-request": {
	    "source": "iana",
	    "extensions": ["spq"]
	  },
	  "application/scvp-vp-response": {
	    "source": "iana",
	    "extensions": ["spp"]
	  },
	  "application/sdp": {
	    "source": "iana",
	    "extensions": ["sdp"]
	  },
	  "application/sep+xml": {
	    "source": "iana"
	  },
	  "application/sep-exi": {
	    "source": "iana"
	  },
	  "application/session-info": {
	    "source": "iana"
	  },
	  "application/set-payment": {
	    "source": "iana"
	  },
	  "application/set-payment-initiation": {
	    "source": "iana",
	    "extensions": ["setpay"]
	  },
	  "application/set-registration": {
	    "source": "iana"
	  },
	  "application/set-registration-initiation": {
	    "source": "iana",
	    "extensions": ["setreg"]
	  },
	  "application/sgml": {
	    "source": "iana"
	  },
	  "application/sgml-open-catalog": {
	    "source": "iana"
	  },
	  "application/shf+xml": {
	    "source": "iana",
	    "extensions": ["shf"]
	  },
	  "application/sieve": {
	    "source": "iana"
	  },
	  "application/simple-filter+xml": {
	    "source": "iana"
	  },
	  "application/simple-message-summary": {
	    "source": "iana"
	  },
	  "application/simplesymbolcontainer": {
	    "source": "iana"
	  },
	  "application/slate": {
	    "source": "iana"
	  },
	  "application/smil": {
	    "source": "iana"
	  },
	  "application/smil+xml": {
	    "source": "iana",
	    "extensions": ["smi","smil"]
	  },
	  "application/smpte336m": {
	    "source": "iana"
	  },
	  "application/soap+fastinfoset": {
	    "source": "iana"
	  },
	  "application/soap+xml": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/sparql-query": {
	    "source": "iana",
	    "extensions": ["rq"]
	  },
	  "application/sparql-results+xml": {
	    "source": "iana",
	    "extensions": ["srx"]
	  },
	  "application/spirits-event+xml": {
	    "source": "iana"
	  },
	  "application/sql": {
	    "source": "iana"
	  },
	  "application/srgs": {
	    "source": "iana",
	    "extensions": ["gram"]
	  },
	  "application/srgs+xml": {
	    "source": "iana",
	    "extensions": ["grxml"]
	  },
	  "application/sru+xml": {
	    "source": "iana",
	    "extensions": ["sru"]
	  },
	  "application/ssdl+xml": {
	    "source": "apache",
	    "extensions": ["ssdl"]
	  },
	  "application/ssml+xml": {
	    "source": "iana",
	    "extensions": ["ssml"]
	  },
	  "application/tamp-apex-update": {
	    "source": "iana"
	  },
	  "application/tamp-apex-update-confirm": {
	    "source": "iana"
	  },
	  "application/tamp-community-update": {
	    "source": "iana"
	  },
	  "application/tamp-community-update-confirm": {
	    "source": "iana"
	  },
	  "application/tamp-error": {
	    "source": "iana"
	  },
	  "application/tamp-sequence-adjust": {
	    "source": "iana"
	  },
	  "application/tamp-sequence-adjust-confirm": {
	    "source": "iana"
	  },
	  "application/tamp-status-query": {
	    "source": "iana"
	  },
	  "application/tamp-status-response": {
	    "source": "iana"
	  },
	  "application/tamp-update": {
	    "source": "iana"
	  },
	  "application/tamp-update-confirm": {
	    "source": "iana"
	  },
	  "application/tar": {
	    "compressible": true
	  },
	  "application/tei+xml": {
	    "source": "iana",
	    "extensions": ["tei","teicorpus"]
	  },
	  "application/thraud+xml": {
	    "source": "iana",
	    "extensions": ["tfi"]
	  },
	  "application/timestamp-query": {
	    "source": "iana"
	  },
	  "application/timestamp-reply": {
	    "source": "iana"
	  },
	  "application/timestamped-data": {
	    "source": "iana",
	    "extensions": ["tsd"]
	  },
	  "application/ttml+xml": {
	    "source": "iana"
	  },
	  "application/tve-trigger": {
	    "source": "iana"
	  },
	  "application/ulpfec": {
	    "source": "iana"
	  },
	  "application/urc-grpsheet+xml": {
	    "source": "iana"
	  },
	  "application/urc-ressheet+xml": {
	    "source": "iana"
	  },
	  "application/urc-targetdesc+xml": {
	    "source": "iana"
	  },
	  "application/urc-uisocketdesc+xml": {
	    "source": "iana"
	  },
	  "application/vcard+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vcard+xml": {
	    "source": "iana"
	  },
	  "application/vemmi": {
	    "source": "iana"
	  },
	  "application/vividence.scriptfile": {
	    "source": "apache"
	  },
	  "application/vnd.3gpp-prose+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp-prose-pc3ch+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.access-transfer-events+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.bsf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.mid-call+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.pic-bw-large": {
	    "source": "iana",
	    "extensions": ["plb"]
	  },
	  "application/vnd.3gpp.pic-bw-small": {
	    "source": "iana",
	    "extensions": ["psb"]
	  },
	  "application/vnd.3gpp.pic-bw-var": {
	    "source": "iana",
	    "extensions": ["pvb"]
	  },
	  "application/vnd.3gpp.sms": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.srvcc-ext+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.srvcc-info+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.state-and-event-info+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.ussd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp2.bcmcsinfo+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp2.sms": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp2.tcap": {
	    "source": "iana",
	    "extensions": ["tcap"]
	  },
	  "application/vnd.3m.post-it-notes": {
	    "source": "iana",
	    "extensions": ["pwn"]
	  },
	  "application/vnd.accpac.simply.aso": {
	    "source": "iana",
	    "extensions": ["aso"]
	  },
	  "application/vnd.accpac.simply.imp": {
	    "source": "iana",
	    "extensions": ["imp"]
	  },
	  "application/vnd.acucobol": {
	    "source": "iana",
	    "extensions": ["acu"]
	  },
	  "application/vnd.acucorp": {
	    "source": "iana",
	    "extensions": ["atc","acutc"]
	  },
	  "application/vnd.adobe.air-application-installer-package+zip": {
	    "source": "apache",
	    "extensions": ["air"]
	  },
	  "application/vnd.adobe.flash.movie": {
	    "source": "iana"
	  },
	  "application/vnd.adobe.formscentral.fcdt": {
	    "source": "iana",
	    "extensions": ["fcdt"]
	  },
	  "application/vnd.adobe.fxp": {
	    "source": "iana",
	    "extensions": ["fxp","fxpl"]
	  },
	  "application/vnd.adobe.partial-upload": {
	    "source": "iana"
	  },
	  "application/vnd.adobe.xdp+xml": {
	    "source": "iana",
	    "extensions": ["xdp"]
	  },
	  "application/vnd.adobe.xfdf": {
	    "source": "iana",
	    "extensions": ["xfdf"]
	  },
	  "application/vnd.aether.imp": {
	    "source": "iana"
	  },
	  "application/vnd.ah-barcode": {
	    "source": "iana"
	  },
	  "application/vnd.ahead.space": {
	    "source": "iana",
	    "extensions": ["ahead"]
	  },
	  "application/vnd.airzip.filesecure.azf": {
	    "source": "iana",
	    "extensions": ["azf"]
	  },
	  "application/vnd.airzip.filesecure.azs": {
	    "source": "iana",
	    "extensions": ["azs"]
	  },
	  "application/vnd.amazon.ebook": {
	    "source": "apache",
	    "extensions": ["azw"]
	  },
	  "application/vnd.americandynamics.acc": {
	    "source": "iana",
	    "extensions": ["acc"]
	  },
	  "application/vnd.amiga.ami": {
	    "source": "iana",
	    "extensions": ["ami"]
	  },
	  "application/vnd.amundsen.maze+xml": {
	    "source": "iana"
	  },
	  "application/vnd.android.package-archive": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["apk"]
	  },
	  "application/vnd.anki": {
	    "source": "iana"
	  },
	  "application/vnd.anser-web-certificate-issue-initiation": {
	    "source": "iana",
	    "extensions": ["cii"]
	  },
	  "application/vnd.anser-web-funds-transfer-initiation": {
	    "source": "apache",
	    "extensions": ["fti"]
	  },
	  "application/vnd.antix.game-component": {
	    "source": "iana",
	    "extensions": ["atx"]
	  },
	  "application/vnd.apache.thrift.binary": {
	    "source": "iana"
	  },
	  "application/vnd.apache.thrift.compact": {
	    "source": "iana"
	  },
	  "application/vnd.apache.thrift.json": {
	    "source": "iana"
	  },
	  "application/vnd.api+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.apple.installer+xml": {
	    "source": "iana",
	    "extensions": ["mpkg"]
	  },
	  "application/vnd.apple.mpegurl": {
	    "source": "iana",
	    "extensions": ["m3u8"]
	  },
	  "application/vnd.apple.pkpass": {
	    "compressible": false,
	    "extensions": ["pkpass"]
	  },
	  "application/vnd.arastra.swi": {
	    "source": "iana"
	  },
	  "application/vnd.aristanetworks.swi": {
	    "source": "iana",
	    "extensions": ["swi"]
	  },
	  "application/vnd.artsquare": {
	    "source": "iana"
	  },
	  "application/vnd.astraea-software.iota": {
	    "source": "iana",
	    "extensions": ["iota"]
	  },
	  "application/vnd.audiograph": {
	    "source": "iana",
	    "extensions": ["aep"]
	  },
	  "application/vnd.autopackage": {
	    "source": "iana"
	  },
	  "application/vnd.avistar+xml": {
	    "source": "iana"
	  },
	  "application/vnd.balsamiq.bmml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.balsamiq.bmpr": {
	    "source": "iana"
	  },
	  "application/vnd.bekitzur-stech+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.biopax.rdf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.blueice.multipass": {
	    "source": "iana",
	    "extensions": ["mpm"]
	  },
	  "application/vnd.bluetooth.ep.oob": {
	    "source": "iana"
	  },
	  "application/vnd.bluetooth.le.oob": {
	    "source": "iana"
	  },
	  "application/vnd.bmi": {
	    "source": "iana",
	    "extensions": ["bmi"]
	  },
	  "application/vnd.businessobjects": {
	    "source": "iana",
	    "extensions": ["rep"]
	  },
	  "application/vnd.cab-jscript": {
	    "source": "iana"
	  },
	  "application/vnd.canon-cpdl": {
	    "source": "iana"
	  },
	  "application/vnd.canon-lips": {
	    "source": "iana"
	  },
	  "application/vnd.cendio.thinlinc.clientconf": {
	    "source": "iana"
	  },
	  "application/vnd.century-systems.tcp_stream": {
	    "source": "iana"
	  },
	  "application/vnd.chemdraw+xml": {
	    "source": "iana",
	    "extensions": ["cdxml"]
	  },
	  "application/vnd.chipnuts.karaoke-mmd": {
	    "source": "iana",
	    "extensions": ["mmd"]
	  },
	  "application/vnd.cinderella": {
	    "source": "iana",
	    "extensions": ["cdy"]
	  },
	  "application/vnd.cirpack.isdn-ext": {
	    "source": "iana"
	  },
	  "application/vnd.citationstyles.style+xml": {
	    "source": "iana"
	  },
	  "application/vnd.claymore": {
	    "source": "iana",
	    "extensions": ["cla"]
	  },
	  "application/vnd.cloanto.rp9": {
	    "source": "iana",
	    "extensions": ["rp9"]
	  },
	  "application/vnd.clonk.c4group": {
	    "source": "iana",
	    "extensions": ["c4g","c4d","c4f","c4p","c4u"]
	  },
	  "application/vnd.cluetrust.cartomobile-config": {
	    "source": "iana",
	    "extensions": ["c11amc"]
	  },
	  "application/vnd.cluetrust.cartomobile-config-pkg": {
	    "source": "iana",
	    "extensions": ["c11amz"]
	  },
	  "application/vnd.coffeescript": {
	    "source": "iana"
	  },
	  "application/vnd.collection+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.collection.doc+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.collection.next+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.commerce-battelle": {
	    "source": "iana"
	  },
	  "application/vnd.commonspace": {
	    "source": "iana",
	    "extensions": ["csp"]
	  },
	  "application/vnd.contact.cmsg": {
	    "source": "iana",
	    "extensions": ["cdbcmsg"]
	  },
	  "application/vnd.cosmocaller": {
	    "source": "iana",
	    "extensions": ["cmc"]
	  },
	  "application/vnd.crick.clicker": {
	    "source": "iana",
	    "extensions": ["clkx"]
	  },
	  "application/vnd.crick.clicker.keyboard": {
	    "source": "iana",
	    "extensions": ["clkk"]
	  },
	  "application/vnd.crick.clicker.palette": {
	    "source": "iana",
	    "extensions": ["clkp"]
	  },
	  "application/vnd.crick.clicker.template": {
	    "source": "iana",
	    "extensions": ["clkt"]
	  },
	  "application/vnd.crick.clicker.wordbank": {
	    "source": "iana",
	    "extensions": ["clkw"]
	  },
	  "application/vnd.criticaltools.wbs+xml": {
	    "source": "iana",
	    "extensions": ["wbs"]
	  },
	  "application/vnd.ctc-posml": {
	    "source": "iana",
	    "extensions": ["pml"]
	  },
	  "application/vnd.ctct.ws+xml": {
	    "source": "iana"
	  },
	  "application/vnd.cups-pdf": {
	    "source": "iana"
	  },
	  "application/vnd.cups-postscript": {
	    "source": "iana"
	  },
	  "application/vnd.cups-ppd": {
	    "source": "iana",
	    "extensions": ["ppd"]
	  },
	  "application/vnd.cups-raster": {
	    "source": "iana"
	  },
	  "application/vnd.cups-raw": {
	    "source": "iana"
	  },
	  "application/vnd.curl": {
	    "source": "iana"
	  },
	  "application/vnd.curl.car": {
	    "source": "apache",
	    "extensions": ["car"]
	  },
	  "application/vnd.curl.pcurl": {
	    "source": "apache",
	    "extensions": ["pcurl"]
	  },
	  "application/vnd.cyan.dean.root+xml": {
	    "source": "iana"
	  },
	  "application/vnd.cybank": {
	    "source": "iana"
	  },
	  "application/vnd.dart": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["dart"]
	  },
	  "application/vnd.data-vision.rdz": {
	    "source": "iana",
	    "extensions": ["rdz"]
	  },
	  "application/vnd.debian.binary-package": {
	    "source": "iana"
	  },
	  "application/vnd.dece.data": {
	    "source": "iana",
	    "extensions": ["uvf","uvvf","uvd","uvvd"]
	  },
	  "application/vnd.dece.ttml+xml": {
	    "source": "iana",
	    "extensions": ["uvt","uvvt"]
	  },
	  "application/vnd.dece.unspecified": {
	    "source": "iana",
	    "extensions": ["uvx","uvvx"]
	  },
	  "application/vnd.dece.zip": {
	    "source": "iana",
	    "extensions": ["uvz","uvvz"]
	  },
	  "application/vnd.denovo.fcselayout-link": {
	    "source": "iana",
	    "extensions": ["fe_launch"]
	  },
	  "application/vnd.desmume-movie": {
	    "source": "iana"
	  },
	  "application/vnd.dir-bi.plate-dl-nosuffix": {
	    "source": "iana"
	  },
	  "application/vnd.dm.delegation+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dna": {
	    "source": "iana",
	    "extensions": ["dna"]
	  },
	  "application/vnd.document+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.dolby.mlp": {
	    "source": "apache",
	    "extensions": ["mlp"]
	  },
	  "application/vnd.dolby.mobile.1": {
	    "source": "iana"
	  },
	  "application/vnd.dolby.mobile.2": {
	    "source": "iana"
	  },
	  "application/vnd.doremir.scorecloud-binary-document": {
	    "source": "iana"
	  },
	  "application/vnd.dpgraph": {
	    "source": "iana",
	    "extensions": ["dpg"]
	  },
	  "application/vnd.dreamfactory": {
	    "source": "iana",
	    "extensions": ["dfac"]
	  },
	  "application/vnd.drive+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ds-keypoint": {
	    "source": "apache",
	    "extensions": ["kpxx"]
	  },
	  "application/vnd.dtg.local": {
	    "source": "iana"
	  },
	  "application/vnd.dtg.local.flash": {
	    "source": "iana"
	  },
	  "application/vnd.dtg.local.html": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ait": {
	    "source": "iana",
	    "extensions": ["ait"]
	  },
	  "application/vnd.dvb.dvbj": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.esgcontainer": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcdftnotifaccess": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcesgaccess": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcesgaccess2": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcesgpdd": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcroaming": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.iptv.alfec-base": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.iptv.alfec-enhancement": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-aggregate-root+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-container+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-generic+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-ia-msglist+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-ia-registration-request+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-ia-registration-response+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-init+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.pfr": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.service": {
	    "source": "iana",
	    "extensions": ["svc"]
	  },
	  "application/vnd.dxr": {
	    "source": "iana"
	  },
	  "application/vnd.dynageo": {
	    "source": "iana",
	    "extensions": ["geo"]
	  },
	  "application/vnd.dzr": {
	    "source": "iana"
	  },
	  "application/vnd.easykaraoke.cdgdownload": {
	    "source": "iana"
	  },
	  "application/vnd.ecdis-update": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.chart": {
	    "source": "iana",
	    "extensions": ["mag"]
	  },
	  "application/vnd.ecowin.filerequest": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.fileupdate": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.series": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.seriesrequest": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.seriesupdate": {
	    "source": "iana"
	  },
	  "application/vnd.emclient.accessrequest+xml": {
	    "source": "iana"
	  },
	  "application/vnd.enliven": {
	    "source": "iana",
	    "extensions": ["nml"]
	  },
	  "application/vnd.enphase.envoy": {
	    "source": "iana"
	  },
	  "application/vnd.eprints.data+xml": {
	    "source": "iana"
	  },
	  "application/vnd.epson.esf": {
	    "source": "iana",
	    "extensions": ["esf"]
	  },
	  "application/vnd.epson.msf": {
	    "source": "iana",
	    "extensions": ["msf"]
	  },
	  "application/vnd.epson.quickanime": {
	    "source": "iana",
	    "extensions": ["qam"]
	  },
	  "application/vnd.epson.salt": {
	    "source": "iana",
	    "extensions": ["slt"]
	  },
	  "application/vnd.epson.ssf": {
	    "source": "iana",
	    "extensions": ["ssf"]
	  },
	  "application/vnd.ericsson.quickcall": {
	    "source": "iana"
	  },
	  "application/vnd.eszigno3+xml": {
	    "source": "iana",
	    "extensions": ["es3","et3"]
	  },
	  "application/vnd.etsi.aoc+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.asic-e+zip": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.asic-s+zip": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.cug+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvcommand+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvdiscovery+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsad-bc+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsad-cod+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsad-npvr+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvservice+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsync+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvueprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.mcid+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.mheg5": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.overload-control-policy-dataset+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.pstn+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.sci+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.simservs+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.timestamp-token": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.tsl+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.tsl.der": {
	    "source": "iana"
	  },
	  "application/vnd.eudora.data": {
	    "source": "iana"
	  },
	  "application/vnd.ezpix-album": {
	    "source": "iana",
	    "extensions": ["ez2"]
	  },
	  "application/vnd.ezpix-package": {
	    "source": "iana",
	    "extensions": ["ez3"]
	  },
	  "application/vnd.f-secure.mobile": {
	    "source": "iana"
	  },
	  "application/vnd.fastcopy-disk-image": {
	    "source": "iana"
	  },
	  "application/vnd.fdf": {
	    "source": "iana",
	    "extensions": ["fdf"]
	  },
	  "application/vnd.fdsn.mseed": {
	    "source": "iana",
	    "extensions": ["mseed"]
	  },
	  "application/vnd.fdsn.seed": {
	    "source": "iana",
	    "extensions": ["seed","dataless"]
	  },
	  "application/vnd.ffsns": {
	    "source": "iana"
	  },
	  "application/vnd.filmit.zfc": {
	    "source": "iana"
	  },
	  "application/vnd.fints": {
	    "source": "iana"
	  },
	  "application/vnd.firemonkeys.cloudcell": {
	    "source": "iana"
	  },
	  "application/vnd.flographit": {
	    "source": "iana",
	    "extensions": ["gph"]
	  },
	  "application/vnd.fluxtime.clip": {
	    "source": "iana",
	    "extensions": ["ftc"]
	  },
	  "application/vnd.font-fontforge-sfd": {
	    "source": "iana"
	  },
	  "application/vnd.framemaker": {
	    "source": "iana",
	    "extensions": ["fm","frame","maker","book"]
	  },
	  "application/vnd.frogans.fnc": {
	    "source": "iana",
	    "extensions": ["fnc"]
	  },
	  "application/vnd.frogans.ltf": {
	    "source": "iana",
	    "extensions": ["ltf"]
	  },
	  "application/vnd.fsc.weblaunch": {
	    "source": "iana",
	    "extensions": ["fsc"]
	  },
	  "application/vnd.fujitsu.oasys": {
	    "source": "iana",
	    "extensions": ["oas"]
	  },
	  "application/vnd.fujitsu.oasys2": {
	    "source": "iana",
	    "extensions": ["oa2"]
	  },
	  "application/vnd.fujitsu.oasys3": {
	    "source": "iana",
	    "extensions": ["oa3"]
	  },
	  "application/vnd.fujitsu.oasysgp": {
	    "source": "iana",
	    "extensions": ["fg5"]
	  },
	  "application/vnd.fujitsu.oasysprs": {
	    "source": "iana",
	    "extensions": ["bh2"]
	  },
	  "application/vnd.fujixerox.art-ex": {
	    "source": "iana"
	  },
	  "application/vnd.fujixerox.art4": {
	    "source": "iana"
	  },
	  "application/vnd.fujixerox.ddd": {
	    "source": "iana",
	    "extensions": ["ddd"]
	  },
	  "application/vnd.fujixerox.docuworks": {
	    "source": "iana",
	    "extensions": ["xdw"]
	  },
	  "application/vnd.fujixerox.docuworks.binder": {
	    "source": "iana",
	    "extensions": ["xbd"]
	  },
	  "application/vnd.fujixerox.docuworks.container": {
	    "source": "iana"
	  },
	  "application/vnd.fujixerox.hbpl": {
	    "source": "iana"
	  },
	  "application/vnd.fut-misnet": {
	    "source": "iana"
	  },
	  "application/vnd.fuzzysheet": {
	    "source": "iana",
	    "extensions": ["fzs"]
	  },
	  "application/vnd.genomatix.tuxedo": {
	    "source": "iana",
	    "extensions": ["txd"]
	  },
	  "application/vnd.geo+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.geocube+xml": {
	    "source": "iana"
	  },
	  "application/vnd.geogebra.file": {
	    "source": "iana",
	    "extensions": ["ggb"]
	  },
	  "application/vnd.geogebra.tool": {
	    "source": "iana",
	    "extensions": ["ggt"]
	  },
	  "application/vnd.geometry-explorer": {
	    "source": "iana",
	    "extensions": ["gex","gre"]
	  },
	  "application/vnd.geonext": {
	    "source": "iana",
	    "extensions": ["gxt"]
	  },
	  "application/vnd.geoplan": {
	    "source": "iana",
	    "extensions": ["g2w"]
	  },
	  "application/vnd.geospace": {
	    "source": "iana",
	    "extensions": ["g3w"]
	  },
	  "application/vnd.gerber": {
	    "source": "iana"
	  },
	  "application/vnd.globalplatform.card-content-mgt": {
	    "source": "iana"
	  },
	  "application/vnd.globalplatform.card-content-mgt-response": {
	    "source": "iana"
	  },
	  "application/vnd.gmx": {
	    "source": "iana",
	    "extensions": ["gmx"]
	  },
	  "application/vnd.google-apps.document": {
	    "compressible": false,
	    "extensions": ["gdoc"]
	  },
	  "application/vnd.google-apps.presentation": {
	    "compressible": false,
	    "extensions": ["gslides"]
	  },
	  "application/vnd.google-apps.spreadsheet": {
	    "compressible": false,
	    "extensions": ["gsheet"]
	  },
	  "application/vnd.google-earth.kml+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["kml"]
	  },
	  "application/vnd.google-earth.kmz": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["kmz"]
	  },
	  "application/vnd.gov.sk.e-form+xml": {
	    "source": "iana"
	  },
	  "application/vnd.gov.sk.e-form+zip": {
	    "source": "iana"
	  },
	  "application/vnd.gov.sk.xmldatacontainer+xml": {
	    "source": "iana"
	  },
	  "application/vnd.grafeq": {
	    "source": "iana",
	    "extensions": ["gqf","gqs"]
	  },
	  "application/vnd.gridmp": {
	    "source": "iana"
	  },
	  "application/vnd.groove-account": {
	    "source": "iana",
	    "extensions": ["gac"]
	  },
	  "application/vnd.groove-help": {
	    "source": "iana",
	    "extensions": ["ghf"]
	  },
	  "application/vnd.groove-identity-message": {
	    "source": "iana",
	    "extensions": ["gim"]
	  },
	  "application/vnd.groove-injector": {
	    "source": "iana",
	    "extensions": ["grv"]
	  },
	  "application/vnd.groove-tool-message": {
	    "source": "iana",
	    "extensions": ["gtm"]
	  },
	  "application/vnd.groove-tool-template": {
	    "source": "iana",
	    "extensions": ["tpl"]
	  },
	  "application/vnd.groove-vcard": {
	    "source": "iana",
	    "extensions": ["vcg"]
	  },
	  "application/vnd.hal+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.hal+xml": {
	    "source": "iana",
	    "extensions": ["hal"]
	  },
	  "application/vnd.handheld-entertainment+xml": {
	    "source": "iana",
	    "extensions": ["zmm"]
	  },
	  "application/vnd.hbci": {
	    "source": "iana",
	    "extensions": ["hbci"]
	  },
	  "application/vnd.hcl-bireports": {
	    "source": "iana"
	  },
	  "application/vnd.heroku+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.hhe.lesson-player": {
	    "source": "iana",
	    "extensions": ["les"]
	  },
	  "application/vnd.hp-hpgl": {
	    "source": "iana",
	    "extensions": ["hpgl"]
	  },
	  "application/vnd.hp-hpid": {
	    "source": "iana",
	    "extensions": ["hpid"]
	  },
	  "application/vnd.hp-hps": {
	    "source": "iana",
	    "extensions": ["hps"]
	  },
	  "application/vnd.hp-jlyt": {
	    "source": "iana",
	    "extensions": ["jlt"]
	  },
	  "application/vnd.hp-pcl": {
	    "source": "iana",
	    "extensions": ["pcl"]
	  },
	  "application/vnd.hp-pclxl": {
	    "source": "iana",
	    "extensions": ["pclxl"]
	  },
	  "application/vnd.httphone": {
	    "source": "iana"
	  },
	  "application/vnd.hydrostatix.sof-data": {
	    "source": "iana",
	    "extensions": ["sfd-hdstx"]
	  },
	  "application/vnd.hyperdrive+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.hzn-3d-crossword": {
	    "source": "iana"
	  },
	  "application/vnd.ibm.afplinedata": {
	    "source": "iana"
	  },
	  "application/vnd.ibm.electronic-media": {
	    "source": "iana"
	  },
	  "application/vnd.ibm.minipay": {
	    "source": "iana",
	    "extensions": ["mpy"]
	  },
	  "application/vnd.ibm.modcap": {
	    "source": "iana",
	    "extensions": ["afp","listafp","list3820"]
	  },
	  "application/vnd.ibm.rights-management": {
	    "source": "iana",
	    "extensions": ["irm"]
	  },
	  "application/vnd.ibm.secure-container": {
	    "source": "iana",
	    "extensions": ["sc"]
	  },
	  "application/vnd.iccprofile": {
	    "source": "iana",
	    "extensions": ["icc","icm"]
	  },
	  "application/vnd.ieee.1905": {
	    "source": "iana"
	  },
	  "application/vnd.igloader": {
	    "source": "iana",
	    "extensions": ["igl"]
	  },
	  "application/vnd.immervision-ivp": {
	    "source": "iana",
	    "extensions": ["ivp"]
	  },
	  "application/vnd.immervision-ivu": {
	    "source": "iana",
	    "extensions": ["ivu"]
	  },
	  "application/vnd.ims.imsccv1p1": {
	    "source": "iana"
	  },
	  "application/vnd.ims.imsccv1p2": {
	    "source": "iana"
	  },
	  "application/vnd.ims.imsccv1p3": {
	    "source": "iana"
	  },
	  "application/vnd.ims.lis.v2.result+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolconsumerprofile+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolproxy+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolproxy.id+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolsettings+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolsettings.simple+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.informedcontrol.rms+xml": {
	    "source": "iana"
	  },
	  "application/vnd.informix-visionary": {
	    "source": "iana"
	  },
	  "application/vnd.infotech.project": {
	    "source": "iana"
	  },
	  "application/vnd.infotech.project+xml": {
	    "source": "iana"
	  },
	  "application/vnd.innopath.wamp.notification": {
	    "source": "iana"
	  },
	  "application/vnd.insors.igm": {
	    "source": "iana",
	    "extensions": ["igm"]
	  },
	  "application/vnd.intercon.formnet": {
	    "source": "iana",
	    "extensions": ["xpw","xpx"]
	  },
	  "application/vnd.intergeo": {
	    "source": "iana",
	    "extensions": ["i2g"]
	  },
	  "application/vnd.intertrust.digibox": {
	    "source": "iana"
	  },
	  "application/vnd.intertrust.nncp": {
	    "source": "iana"
	  },
	  "application/vnd.intu.qbo": {
	    "source": "iana",
	    "extensions": ["qbo"]
	  },
	  "application/vnd.intu.qfx": {
	    "source": "iana",
	    "extensions": ["qfx"]
	  },
	  "application/vnd.iptc.g2.catalogitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.conceptitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.knowledgeitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.newsitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.newsmessage+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.packageitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.planningitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ipunplugged.rcprofile": {
	    "source": "iana",
	    "extensions": ["rcprofile"]
	  },
	  "application/vnd.irepository.package+xml": {
	    "source": "iana",
	    "extensions": ["irp"]
	  },
	  "application/vnd.is-xpr": {
	    "source": "iana",
	    "extensions": ["xpr"]
	  },
	  "application/vnd.isac.fcs": {
	    "source": "iana",
	    "extensions": ["fcs"]
	  },
	  "application/vnd.jam": {
	    "source": "iana",
	    "extensions": ["jam"]
	  },
	  "application/vnd.japannet-directory-service": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-jpnstore-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-payment-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-registration": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-registration-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-setstore-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-verification": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-verification-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.jcp.javame.midlet-rms": {
	    "source": "iana",
	    "extensions": ["rms"]
	  },
	  "application/vnd.jisp": {
	    "source": "iana",
	    "extensions": ["jisp"]
	  },
	  "application/vnd.joost.joda-archive": {
	    "source": "iana",
	    "extensions": ["joda"]
	  },
	  "application/vnd.jsk.isdn-ngn": {
	    "source": "iana"
	  },
	  "application/vnd.kahootz": {
	    "source": "iana",
	    "extensions": ["ktz","ktr"]
	  },
	  "application/vnd.kde.karbon": {
	    "source": "iana",
	    "extensions": ["karbon"]
	  },
	  "application/vnd.kde.kchart": {
	    "source": "iana",
	    "extensions": ["chrt"]
	  },
	  "application/vnd.kde.kformula": {
	    "source": "iana",
	    "extensions": ["kfo"]
	  },
	  "application/vnd.kde.kivio": {
	    "source": "iana",
	    "extensions": ["flw"]
	  },
	  "application/vnd.kde.kontour": {
	    "source": "iana",
	    "extensions": ["kon"]
	  },
	  "application/vnd.kde.kpresenter": {
	    "source": "iana",
	    "extensions": ["kpr","kpt"]
	  },
	  "application/vnd.kde.kspread": {
	    "source": "iana",
	    "extensions": ["ksp"]
	  },
	  "application/vnd.kde.kword": {
	    "source": "iana",
	    "extensions": ["kwd","kwt"]
	  },
	  "application/vnd.kenameaapp": {
	    "source": "iana",
	    "extensions": ["htke"]
	  },
	  "application/vnd.kidspiration": {
	    "source": "iana",
	    "extensions": ["kia"]
	  },
	  "application/vnd.kinar": {
	    "source": "iana",
	    "extensions": ["kne","knp"]
	  },
	  "application/vnd.koan": {
	    "source": "iana",
	    "extensions": ["skp","skd","skt","skm"]
	  },
	  "application/vnd.kodak-descriptor": {
	    "source": "iana",
	    "extensions": ["sse"]
	  },
	  "application/vnd.las.las+xml": {
	    "source": "iana",
	    "extensions": ["lasxml"]
	  },
	  "application/vnd.liberty-request+xml": {
	    "source": "iana"
	  },
	  "application/vnd.llamagraphics.life-balance.desktop": {
	    "source": "iana",
	    "extensions": ["lbd"]
	  },
	  "application/vnd.llamagraphics.life-balance.exchange+xml": {
	    "source": "iana",
	    "extensions": ["lbe"]
	  },
	  "application/vnd.lotus-1-2-3": {
	    "source": "iana",
	    "extensions": ["123"]
	  },
	  "application/vnd.lotus-approach": {
	    "source": "iana",
	    "extensions": ["apr"]
	  },
	  "application/vnd.lotus-freelance": {
	    "source": "iana",
	    "extensions": ["pre"]
	  },
	  "application/vnd.lotus-notes": {
	    "source": "iana",
	    "extensions": ["nsf"]
	  },
	  "application/vnd.lotus-organizer": {
	    "source": "iana",
	    "extensions": ["org"]
	  },
	  "application/vnd.lotus-screencam": {
	    "source": "iana",
	    "extensions": ["scm"]
	  },
	  "application/vnd.lotus-wordpro": {
	    "source": "iana",
	    "extensions": ["lwp"]
	  },
	  "application/vnd.macports.portpkg": {
	    "source": "iana",
	    "extensions": ["portpkg"]
	  },
	  "application/vnd.mapbox-vector-tile": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.actiontoken+xml": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.conftoken+xml": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.license+xml": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.mdcf": {
	    "source": "iana"
	  },
	  "application/vnd.mason+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.maxmind.maxmind-db": {
	    "source": "iana"
	  },
	  "application/vnd.mcd": {
	    "source": "iana",
	    "extensions": ["mcd"]
	  },
	  "application/vnd.medcalcdata": {
	    "source": "iana",
	    "extensions": ["mc1"]
	  },
	  "application/vnd.mediastation.cdkey": {
	    "source": "iana",
	    "extensions": ["cdkey"]
	  },
	  "application/vnd.meridian-slingshot": {
	    "source": "iana"
	  },
	  "application/vnd.mfer": {
	    "source": "iana",
	    "extensions": ["mwf"]
	  },
	  "application/vnd.mfmp": {
	    "source": "iana",
	    "extensions": ["mfm"]
	  },
	  "application/vnd.micro+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.micrografx.flo": {
	    "source": "iana",
	    "extensions": ["flo"]
	  },
	  "application/vnd.micrografx.igx": {
	    "source": "iana",
	    "extensions": ["igx"]
	  },
	  "application/vnd.microsoft.portable-executable": {
	    "source": "iana"
	  },
	  "application/vnd.miele+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.mif": {
	    "source": "iana",
	    "extensions": ["mif"]
	  },
	  "application/vnd.minisoft-hp3000-save": {
	    "source": "iana"
	  },
	  "application/vnd.mitsubishi.misty-guard.trustweb": {
	    "source": "iana"
	  },
	  "application/vnd.mobius.daf": {
	    "source": "iana",
	    "extensions": ["daf"]
	  },
	  "application/vnd.mobius.dis": {
	    "source": "iana",
	    "extensions": ["dis"]
	  },
	  "application/vnd.mobius.mbk": {
	    "source": "iana",
	    "extensions": ["mbk"]
	  },
	  "application/vnd.mobius.mqy": {
	    "source": "iana",
	    "extensions": ["mqy"]
	  },
	  "application/vnd.mobius.msl": {
	    "source": "iana",
	    "extensions": ["msl"]
	  },
	  "application/vnd.mobius.plc": {
	    "source": "iana",
	    "extensions": ["plc"]
	  },
	  "application/vnd.mobius.txf": {
	    "source": "iana",
	    "extensions": ["txf"]
	  },
	  "application/vnd.mophun.application": {
	    "source": "iana",
	    "extensions": ["mpn"]
	  },
	  "application/vnd.mophun.certificate": {
	    "source": "iana",
	    "extensions": ["mpc"]
	  },
	  "application/vnd.motorola.flexsuite": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.adsi": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.fis": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.gotap": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.kmr": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.ttc": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.wem": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.iprm": {
	    "source": "iana"
	  },
	  "application/vnd.mozilla.xul+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xul"]
	  },
	  "application/vnd.ms-3mfdocument": {
	    "source": "iana"
	  },
	  "application/vnd.ms-artgalry": {
	    "source": "iana",
	    "extensions": ["cil"]
	  },
	  "application/vnd.ms-asf": {
	    "source": "iana"
	  },
	  "application/vnd.ms-cab-compressed": {
	    "source": "iana",
	    "extensions": ["cab"]
	  },
	  "application/vnd.ms-color.iccprofile": {
	    "source": "apache"
	  },
	  "application/vnd.ms-excel": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["xls","xlm","xla","xlc","xlt","xlw"]
	  },
	  "application/vnd.ms-excel.addin.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xlam"]
	  },
	  "application/vnd.ms-excel.sheet.binary.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xlsb"]
	  },
	  "application/vnd.ms-excel.sheet.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xlsm"]
	  },
	  "application/vnd.ms-excel.template.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xltm"]
	  },
	  "application/vnd.ms-fontobject": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["eot"]
	  },
	  "application/vnd.ms-htmlhelp": {
	    "source": "iana",
	    "extensions": ["chm"]
	  },
	  "application/vnd.ms-ims": {
	    "source": "iana",
	    "extensions": ["ims"]
	  },
	  "application/vnd.ms-lrm": {
	    "source": "iana",
	    "extensions": ["lrm"]
	  },
	  "application/vnd.ms-office.activex+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ms-officetheme": {
	    "source": "iana",
	    "extensions": ["thmx"]
	  },
	  "application/vnd.ms-opentype": {
	    "source": "apache",
	    "compressible": true
	  },
	  "application/vnd.ms-package.obfuscated-opentype": {
	    "source": "apache"
	  },
	  "application/vnd.ms-pki.seccat": {
	    "source": "apache",
	    "extensions": ["cat"]
	  },
	  "application/vnd.ms-pki.stl": {
	    "source": "apache",
	    "extensions": ["stl"]
	  },
	  "application/vnd.ms-playready.initiator+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ms-powerpoint": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["ppt","pps","pot"]
	  },
	  "application/vnd.ms-powerpoint.addin.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["ppam"]
	  },
	  "application/vnd.ms-powerpoint.presentation.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["pptm"]
	  },
	  "application/vnd.ms-powerpoint.slide.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["sldm"]
	  },
	  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["ppsm"]
	  },
	  "application/vnd.ms-powerpoint.template.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["potm"]
	  },
	  "application/vnd.ms-printdevicecapabilities+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ms-printing.printticket+xml": {
	    "source": "apache"
	  },
	  "application/vnd.ms-project": {
	    "source": "iana",
	    "extensions": ["mpp","mpt"]
	  },
	  "application/vnd.ms-tnef": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.devicepairing": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.nwprinting.oob": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.printerpairing": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.wsd.oob": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.lic-chlg-req": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.lic-resp": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.meter-chlg-req": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.meter-resp": {
	    "source": "iana"
	  },
	  "application/vnd.ms-word.document.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["docm"]
	  },
	  "application/vnd.ms-word.template.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["dotm"]
	  },
	  "application/vnd.ms-works": {
	    "source": "iana",
	    "extensions": ["wps","wks","wcm","wdb"]
	  },
	  "application/vnd.ms-wpl": {
	    "source": "iana",
	    "extensions": ["wpl"]
	  },
	  "application/vnd.ms-xpsdocument": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["xps"]
	  },
	  "application/vnd.msa-disk-image": {
	    "source": "iana"
	  },
	  "application/vnd.mseq": {
	    "source": "iana",
	    "extensions": ["mseq"]
	  },
	  "application/vnd.msign": {
	    "source": "iana"
	  },
	  "application/vnd.multiad.creator": {
	    "source": "iana"
	  },
	  "application/vnd.multiad.creator.cif": {
	    "source": "iana"
	  },
	  "application/vnd.music-niff": {
	    "source": "iana"
	  },
	  "application/vnd.musician": {
	    "source": "iana",
	    "extensions": ["mus"]
	  },
	  "application/vnd.muvee.style": {
	    "source": "iana",
	    "extensions": ["msty"]
	  },
	  "application/vnd.mynfc": {
	    "source": "iana",
	    "extensions": ["taglet"]
	  },
	  "application/vnd.ncd.control": {
	    "source": "iana"
	  },
	  "application/vnd.ncd.reference": {
	    "source": "iana"
	  },
	  "application/vnd.nervana": {
	    "source": "iana"
	  },
	  "application/vnd.netfpx": {
	    "source": "iana"
	  },
	  "application/vnd.neurolanguage.nlu": {
	    "source": "iana",
	    "extensions": ["nlu"]
	  },
	  "application/vnd.nintendo.nitro.rom": {
	    "source": "iana"
	  },
	  "application/vnd.nintendo.snes.rom": {
	    "source": "iana"
	  },
	  "application/vnd.nitf": {
	    "source": "iana",
	    "extensions": ["ntf","nitf"]
	  },
	  "application/vnd.noblenet-directory": {
	    "source": "iana",
	    "extensions": ["nnd"]
	  },
	  "application/vnd.noblenet-sealer": {
	    "source": "iana",
	    "extensions": ["nns"]
	  },
	  "application/vnd.noblenet-web": {
	    "source": "iana",
	    "extensions": ["nnw"]
	  },
	  "application/vnd.nokia.catalogs": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.conml+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.conml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.iptv.config+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.isds-radio-presets": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.landmark+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.landmark+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.landmarkcollection+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.n-gage.ac+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.n-gage.data": {
	    "source": "iana",
	    "extensions": ["ngdat"]
	  },
	  "application/vnd.nokia.n-gage.symbian.install": {
	    "source": "iana",
	    "extensions": ["n-gage"]
	  },
	  "application/vnd.nokia.ncd": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.pcd+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.pcd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.radio-preset": {
	    "source": "iana",
	    "extensions": ["rpst"]
	  },
	  "application/vnd.nokia.radio-presets": {
	    "source": "iana",
	    "extensions": ["rpss"]
	  },
	  "application/vnd.novadigm.edm": {
	    "source": "iana",
	    "extensions": ["edm"]
	  },
	  "application/vnd.novadigm.edx": {
	    "source": "iana",
	    "extensions": ["edx"]
	  },
	  "application/vnd.novadigm.ext": {
	    "source": "iana",
	    "extensions": ["ext"]
	  },
	  "application/vnd.ntt-local.content-share": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.file-transfer": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.ogw_remote-access": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.sip-ta_remote": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.sip-ta_tcp_stream": {
	    "source": "iana"
	  },
	  "application/vnd.oasis.opendocument.chart": {
	    "source": "iana",
	    "extensions": ["odc"]
	  },
	  "application/vnd.oasis.opendocument.chart-template": {
	    "source": "iana",
	    "extensions": ["otc"]
	  },
	  "application/vnd.oasis.opendocument.database": {
	    "source": "iana",
	    "extensions": ["odb"]
	  },
	  "application/vnd.oasis.opendocument.formula": {
	    "source": "iana",
	    "extensions": ["odf"]
	  },
	  "application/vnd.oasis.opendocument.formula-template": {
	    "source": "iana",
	    "extensions": ["odft"]
	  },
	  "application/vnd.oasis.opendocument.graphics": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["odg"]
	  },
	  "application/vnd.oasis.opendocument.graphics-template": {
	    "source": "iana",
	    "extensions": ["otg"]
	  },
	  "application/vnd.oasis.opendocument.image": {
	    "source": "iana",
	    "extensions": ["odi"]
	  },
	  "application/vnd.oasis.opendocument.image-template": {
	    "source": "iana",
	    "extensions": ["oti"]
	  },
	  "application/vnd.oasis.opendocument.presentation": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["odp"]
	  },
	  "application/vnd.oasis.opendocument.presentation-template": {
	    "source": "iana",
	    "extensions": ["otp"]
	  },
	  "application/vnd.oasis.opendocument.spreadsheet": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["ods"]
	  },
	  "application/vnd.oasis.opendocument.spreadsheet-template": {
	    "source": "iana",
	    "extensions": ["ots"]
	  },
	  "application/vnd.oasis.opendocument.text": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["odt"]
	  },
	  "application/vnd.oasis.opendocument.text-master": {
	    "source": "iana",
	    "extensions": ["odm"]
	  },
	  "application/vnd.oasis.opendocument.text-template": {
	    "source": "iana",
	    "extensions": ["ott"]
	  },
	  "application/vnd.oasis.opendocument.text-web": {
	    "source": "iana",
	    "extensions": ["oth"]
	  },
	  "application/vnd.obn": {
	    "source": "iana"
	  },
	  "application/vnd.oftn.l10n+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.oipf.contentaccessdownload+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.contentaccessstreaming+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.cspg-hexbinary": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.dae.svg+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.dae.xhtml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.mippvcontrolmessage+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.pae.gem": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.spdiscovery+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.spdlist+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.ueprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.userprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.olpc-sugar": {
	    "source": "iana",
	    "extensions": ["xo"]
	  },
	  "application/vnd.oma-scws-config": {
	    "source": "iana"
	  },
	  "application/vnd.oma-scws-http-request": {
	    "source": "iana"
	  },
	  "application/vnd.oma-scws-http-response": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.associated-procedure-parameter+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.drm-trigger+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.imd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.ltkm": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.notification+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.provisioningtrigger": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sgboot": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sgdd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sgdu": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.simple-symbol-container": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.smartcard-trigger+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sprov+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.stkm": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-address-book+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-feature-handler+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-pcc+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-subs-invite+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-user-prefs+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.dcd": {
	    "source": "iana"
	  },
	  "application/vnd.oma.dcdc": {
	    "source": "iana"
	  },
	  "application/vnd.oma.dd2+xml": {
	    "source": "iana",
	    "extensions": ["dd2"]
	  },
	  "application/vnd.oma.drm.risd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.group-usage-list+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.pal+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.detailed-progress-report+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.final-report+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.groups+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.invocation-descriptor+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.optimized-progress-report+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.push": {
	    "source": "iana"
	  },
	  "application/vnd.oma.scidm.messages+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.xcap-directory+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omads-email+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omads-file+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omads-folder+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omaloc-supl-init": {
	    "source": "iana"
	  },
	  "application/vnd.openblox.game+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openblox.game-binary": {
	    "source": "iana"
	  },
	  "application/vnd.openeye.oeb": {
	    "source": "iana"
	  },
	  "application/vnd.openofficeorg.extension": {
	    "source": "apache",
	    "extensions": ["oxt"]
	  },
	  "application/vnd.openxmlformats-officedocument.custom-properties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawing+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.extended-properties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml-template": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["pptx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slide": {
	    "source": "iana",
	    "extensions": ["sldx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": {
	    "source": "iana",
	    "extensions": ["ppsx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.template": {
	    "source": "apache",
	    "extensions": ["potx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml-template": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["xlsx"]
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": {
	    "source": "apache",
	    "extensions": ["xltx"]
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.theme+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.themeoverride+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.vmldrawing": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml-template": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["docx"]
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": {
	    "source": "apache",
	    "extensions": ["dotx"]
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-package.core-properties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-package.relationships+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oracle.resource+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.orange.indata": {
	    "source": "iana"
	  },
	  "application/vnd.osa.netdeploy": {
	    "source": "iana"
	  },
	  "application/vnd.osgeo.mapguide.package": {
	    "source": "iana",
	    "extensions": ["mgp"]
	  },
	  "application/vnd.osgi.bundle": {
	    "source": "iana"
	  },
	  "application/vnd.osgi.dp": {
	    "source": "iana",
	    "extensions": ["dp"]
	  },
	  "application/vnd.osgi.subsystem": {
	    "source": "iana",
	    "extensions": ["esa"]
	  },
	  "application/vnd.otps.ct-kip+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oxli.countgraph": {
	    "source": "iana"
	  },
	  "application/vnd.pagerduty+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.palm": {
	    "source": "iana",
	    "extensions": ["pdb","pqa","oprc"]
	  },
	  "application/vnd.panoply": {
	    "source": "iana"
	  },
	  "application/vnd.paos+xml": {
	    "source": "iana"
	  },
	  "application/vnd.paos.xml": {
	    "source": "apache"
	  },
	  "application/vnd.pawaafile": {
	    "source": "iana",
	    "extensions": ["paw"]
	  },
	  "application/vnd.pcos": {
	    "source": "iana"
	  },
	  "application/vnd.pg.format": {
	    "source": "iana",
	    "extensions": ["str"]
	  },
	  "application/vnd.pg.osasli": {
	    "source": "iana",
	    "extensions": ["ei6"]
	  },
	  "application/vnd.piaccess.application-licence": {
	    "source": "iana"
	  },
	  "application/vnd.picsel": {
	    "source": "iana",
	    "extensions": ["efif"]
	  },
	  "application/vnd.pmi.widget": {
	    "source": "iana",
	    "extensions": ["wg"]
	  },
	  "application/vnd.poc.group-advertisement+xml": {
	    "source": "iana"
	  },
	  "application/vnd.pocketlearn": {
	    "source": "iana",
	    "extensions": ["plf"]
	  },
	  "application/vnd.powerbuilder6": {
	    "source": "iana",
	    "extensions": ["pbd"]
	  },
	  "application/vnd.powerbuilder6-s": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder7": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder7-s": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder75": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder75-s": {
	    "source": "iana"
	  },
	  "application/vnd.preminet": {
	    "source": "iana"
	  },
	  "application/vnd.previewsystems.box": {
	    "source": "iana",
	    "extensions": ["box"]
	  },
	  "application/vnd.proteus.magazine": {
	    "source": "iana",
	    "extensions": ["mgz"]
	  },
	  "application/vnd.publishare-delta-tree": {
	    "source": "iana",
	    "extensions": ["qps"]
	  },
	  "application/vnd.pvi.ptid1": {
	    "source": "iana",
	    "extensions": ["ptid"]
	  },
	  "application/vnd.pwg-multiplexed": {
	    "source": "iana"
	  },
	  "application/vnd.pwg-xhtml-print+xml": {
	    "source": "iana"
	  },
	  "application/vnd.qualcomm.brew-app-res": {
	    "source": "iana"
	  },
	  "application/vnd.quark.quarkxpress": {
	    "source": "iana",
	    "extensions": ["qxd","qxt","qwd","qwt","qxl","qxb"]
	  },
	  "application/vnd.quobject-quoxdocument": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.moml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-conf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-conn+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-dialog+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-stream+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-conf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-base+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-fax-detect+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-group+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-speech+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-transform+xml": {
	    "source": "iana"
	  },
	  "application/vnd.rainstor.data": {
	    "source": "iana"
	  },
	  "application/vnd.rapid": {
	    "source": "iana"
	  },
	  "application/vnd.realvnc.bed": {
	    "source": "iana",
	    "extensions": ["bed"]
	  },
	  "application/vnd.recordare.musicxml": {
	    "source": "iana",
	    "extensions": ["mxl"]
	  },
	  "application/vnd.recordare.musicxml+xml": {
	    "source": "iana",
	    "extensions": ["musicxml"]
	  },
	  "application/vnd.renlearn.rlprint": {
	    "source": "iana"
	  },
	  "application/vnd.rig.cryptonote": {
	    "source": "iana",
	    "extensions": ["cryptonote"]
	  },
	  "application/vnd.rim.cod": {
	    "source": "apache",
	    "extensions": ["cod"]
	  },
	  "application/vnd.rn-realmedia": {
	    "source": "apache",
	    "extensions": ["rm"]
	  },
	  "application/vnd.rn-realmedia-vbr": {
	    "source": "apache",
	    "extensions": ["rmvb"]
	  },
	  "application/vnd.route66.link66+xml": {
	    "source": "iana",
	    "extensions": ["link66"]
	  },
	  "application/vnd.rs-274x": {
	    "source": "iana"
	  },
	  "application/vnd.ruckus.download": {
	    "source": "iana"
	  },
	  "application/vnd.s3sms": {
	    "source": "iana"
	  },
	  "application/vnd.sailingtracker.track": {
	    "source": "iana",
	    "extensions": ["st"]
	  },
	  "application/vnd.sbm.cid": {
	    "source": "iana"
	  },
	  "application/vnd.sbm.mid2": {
	    "source": "iana"
	  },
	  "application/vnd.scribus": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.3df": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.csf": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.doc": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.eml": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.mht": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.net": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.ppt": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.tiff": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.xls": {
	    "source": "iana"
	  },
	  "application/vnd.sealedmedia.softseal.html": {
	    "source": "iana"
	  },
	  "application/vnd.sealedmedia.softseal.pdf": {
	    "source": "iana"
	  },
	  "application/vnd.seemail": {
	    "source": "iana",
	    "extensions": ["see"]
	  },
	  "application/vnd.sema": {
	    "source": "iana",
	    "extensions": ["sema"]
	  },
	  "application/vnd.semd": {
	    "source": "iana",
	    "extensions": ["semd"]
	  },
	  "application/vnd.semf": {
	    "source": "iana",
	    "extensions": ["semf"]
	  },
	  "application/vnd.shana.informed.formdata": {
	    "source": "iana",
	    "extensions": ["ifm"]
	  },
	  "application/vnd.shana.informed.formtemplate": {
	    "source": "iana",
	    "extensions": ["itp"]
	  },
	  "application/vnd.shana.informed.interchange": {
	    "source": "iana",
	    "extensions": ["iif"]
	  },
	  "application/vnd.shana.informed.package": {
	    "source": "iana",
	    "extensions": ["ipk"]
	  },
	  "application/vnd.simtech-mindmapper": {
	    "source": "iana",
	    "extensions": ["twd","twds"]
	  },
	  "application/vnd.siren+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.smaf": {
	    "source": "iana",
	    "extensions": ["mmf"]
	  },
	  "application/vnd.smart.notebook": {
	    "source": "iana"
	  },
	  "application/vnd.smart.teacher": {
	    "source": "iana",
	    "extensions": ["teacher"]
	  },
	  "application/vnd.software602.filler.form+xml": {
	    "source": "iana"
	  },
	  "application/vnd.software602.filler.form-xml-zip": {
	    "source": "iana"
	  },
	  "application/vnd.solent.sdkm+xml": {
	    "source": "iana",
	    "extensions": ["sdkm","sdkd"]
	  },
	  "application/vnd.spotfire.dxp": {
	    "source": "iana",
	    "extensions": ["dxp"]
	  },
	  "application/vnd.spotfire.sfs": {
	    "source": "iana",
	    "extensions": ["sfs"]
	  },
	  "application/vnd.sss-cod": {
	    "source": "iana"
	  },
	  "application/vnd.sss-dtf": {
	    "source": "iana"
	  },
	  "application/vnd.sss-ntf": {
	    "source": "iana"
	  },
	  "application/vnd.stardivision.calc": {
	    "source": "apache",
	    "extensions": ["sdc"]
	  },
	  "application/vnd.stardivision.draw": {
	    "source": "apache",
	    "extensions": ["sda"]
	  },
	  "application/vnd.stardivision.impress": {
	    "source": "apache",
	    "extensions": ["sdd"]
	  },
	  "application/vnd.stardivision.math": {
	    "source": "apache",
	    "extensions": ["smf"]
	  },
	  "application/vnd.stardivision.writer": {
	    "source": "apache",
	    "extensions": ["sdw","vor"]
	  },
	  "application/vnd.stardivision.writer-global": {
	    "source": "apache",
	    "extensions": ["sgl"]
	  },
	  "application/vnd.stepmania.package": {
	    "source": "iana",
	    "extensions": ["smzip"]
	  },
	  "application/vnd.stepmania.stepchart": {
	    "source": "iana",
	    "extensions": ["sm"]
	  },
	  "application/vnd.street-stream": {
	    "source": "iana"
	  },
	  "application/vnd.sun.wadl+xml": {
	    "source": "iana"
	  },
	  "application/vnd.sun.xml.calc": {
	    "source": "apache",
	    "extensions": ["sxc"]
	  },
	  "application/vnd.sun.xml.calc.template": {
	    "source": "apache",
	    "extensions": ["stc"]
	  },
	  "application/vnd.sun.xml.draw": {
	    "source": "apache",
	    "extensions": ["sxd"]
	  },
	  "application/vnd.sun.xml.draw.template": {
	    "source": "apache",
	    "extensions": ["std"]
	  },
	  "application/vnd.sun.xml.impress": {
	    "source": "apache",
	    "extensions": ["sxi"]
	  },
	  "application/vnd.sun.xml.impress.template": {
	    "source": "apache",
	    "extensions": ["sti"]
	  },
	  "application/vnd.sun.xml.math": {
	    "source": "apache",
	    "extensions": ["sxm"]
	  },
	  "application/vnd.sun.xml.writer": {
	    "source": "apache",
	    "extensions": ["sxw"]
	  },
	  "application/vnd.sun.xml.writer.global": {
	    "source": "apache",
	    "extensions": ["sxg"]
	  },
	  "application/vnd.sun.xml.writer.template": {
	    "source": "apache",
	    "extensions": ["stw"]
	  },
	  "application/vnd.sus-calendar": {
	    "source": "iana",
	    "extensions": ["sus","susp"]
	  },
	  "application/vnd.svd": {
	    "source": "iana",
	    "extensions": ["svd"]
	  },
	  "application/vnd.swiftview-ics": {
	    "source": "iana"
	  },
	  "application/vnd.symbian.install": {
	    "source": "apache",
	    "extensions": ["sis","sisx"]
	  },
	  "application/vnd.syncml+xml": {
	    "source": "iana",
	    "extensions": ["xsm"]
	  },
	  "application/vnd.syncml.dm+wbxml": {
	    "source": "iana",
	    "extensions": ["bdm"]
	  },
	  "application/vnd.syncml.dm+xml": {
	    "source": "iana",
	    "extensions": ["xdm"]
	  },
	  "application/vnd.syncml.dm.notification": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmddf+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmddf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmtnds+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmtnds+xml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.ds.notification": {
	    "source": "iana"
	  },
	  "application/vnd.tao.intent-module-archive": {
	    "source": "iana",
	    "extensions": ["tao"]
	  },
	  "application/vnd.tcpdump.pcap": {
	    "source": "iana",
	    "extensions": ["pcap","cap","dmp"]
	  },
	  "application/vnd.tmd.mediaflex.api+xml": {
	    "source": "iana"
	  },
	  "application/vnd.tml": {
	    "source": "iana"
	  },
	  "application/vnd.tmobile-livetv": {
	    "source": "iana",
	    "extensions": ["tmo"]
	  },
	  "application/vnd.trid.tpt": {
	    "source": "iana",
	    "extensions": ["tpt"]
	  },
	  "application/vnd.triscape.mxs": {
	    "source": "iana",
	    "extensions": ["mxs"]
	  },
	  "application/vnd.trueapp": {
	    "source": "iana",
	    "extensions": ["tra"]
	  },
	  "application/vnd.truedoc": {
	    "source": "iana"
	  },
	  "application/vnd.ubisoft.webplayer": {
	    "source": "iana"
	  },
	  "application/vnd.ufdl": {
	    "source": "iana",
	    "extensions": ["ufd","ufdl"]
	  },
	  "application/vnd.uiq.theme": {
	    "source": "iana",
	    "extensions": ["utz"]
	  },
	  "application/vnd.umajin": {
	    "source": "iana",
	    "extensions": ["umj"]
	  },
	  "application/vnd.unity": {
	    "source": "iana",
	    "extensions": ["unityweb"]
	  },
	  "application/vnd.uoml+xml": {
	    "source": "iana",
	    "extensions": ["uoml"]
	  },
	  "application/vnd.uplanet.alert": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.alert-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.bearer-choice": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.bearer-choice-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.cacheop": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.cacheop-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.channel": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.channel-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.list": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.list-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.listcmd": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.listcmd-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.signal": {
	    "source": "iana"
	  },
	  "application/vnd.uri-map": {
	    "source": "iana"
	  },
	  "application/vnd.valve.source.material": {
	    "source": "iana"
	  },
	  "application/vnd.vcx": {
	    "source": "iana",
	    "extensions": ["vcx"]
	  },
	  "application/vnd.vd-study": {
	    "source": "iana"
	  },
	  "application/vnd.vectorworks": {
	    "source": "iana"
	  },
	  "application/vnd.verimatrix.vcas": {
	    "source": "iana"
	  },
	  "application/vnd.vidsoft.vidconference": {
	    "source": "iana"
	  },
	  "application/vnd.visio": {
	    "source": "iana",
	    "extensions": ["vsd","vst","vss","vsw"]
	  },
	  "application/vnd.visionary": {
	    "source": "iana",
	    "extensions": ["vis"]
	  },
	  "application/vnd.vividence.scriptfile": {
	    "source": "iana"
	  },
	  "application/vnd.vsf": {
	    "source": "iana",
	    "extensions": ["vsf"]
	  },
	  "application/vnd.wap.sic": {
	    "source": "iana"
	  },
	  "application/vnd.wap.slc": {
	    "source": "iana"
	  },
	  "application/vnd.wap.wbxml": {
	    "source": "iana",
	    "extensions": ["wbxml"]
	  },
	  "application/vnd.wap.wmlc": {
	    "source": "iana",
	    "extensions": ["wmlc"]
	  },
	  "application/vnd.wap.wmlscriptc": {
	    "source": "iana",
	    "extensions": ["wmlsc"]
	  },
	  "application/vnd.webturbo": {
	    "source": "iana",
	    "extensions": ["wtb"]
	  },
	  "application/vnd.wfa.p2p": {
	    "source": "iana"
	  },
	  "application/vnd.wfa.wsc": {
	    "source": "iana"
	  },
	  "application/vnd.windows.devicepairing": {
	    "source": "iana"
	  },
	  "application/vnd.wmc": {
	    "source": "iana"
	  },
	  "application/vnd.wmf.bootstrap": {
	    "source": "iana"
	  },
	  "application/vnd.wolfram.mathematica": {
	    "source": "iana"
	  },
	  "application/vnd.wolfram.mathematica.package": {
	    "source": "iana"
	  },
	  "application/vnd.wolfram.player": {
	    "source": "iana",
	    "extensions": ["nbp"]
	  },
	  "application/vnd.wordperfect": {
	    "source": "iana",
	    "extensions": ["wpd"]
	  },
	  "application/vnd.wqd": {
	    "source": "iana",
	    "extensions": ["wqd"]
	  },
	  "application/vnd.wrq-hp3000-labelled": {
	    "source": "iana"
	  },
	  "application/vnd.wt.stf": {
	    "source": "iana",
	    "extensions": ["stf"]
	  },
	  "application/vnd.wv.csp+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.wv.csp+xml": {
	    "source": "iana"
	  },
	  "application/vnd.wv.ssp+xml": {
	    "source": "iana"
	  },
	  "application/vnd.xacml+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.xara": {
	    "source": "iana",
	    "extensions": ["xar"]
	  },
	  "application/vnd.xfdl": {
	    "source": "iana",
	    "extensions": ["xfdl"]
	  },
	  "application/vnd.xfdl.webform": {
	    "source": "iana"
	  },
	  "application/vnd.xmi+xml": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.cpkg": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.dpkg": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.plan": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.ppkg": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.xlim": {
	    "source": "iana"
	  },
	  "application/vnd.yamaha.hv-dic": {
	    "source": "iana",
	    "extensions": ["hvd"]
	  },
	  "application/vnd.yamaha.hv-script": {
	    "source": "iana",
	    "extensions": ["hvs"]
	  },
	  "application/vnd.yamaha.hv-voice": {
	    "source": "iana",
	    "extensions": ["hvp"]
	  },
	  "application/vnd.yamaha.openscoreformat": {
	    "source": "iana",
	    "extensions": ["osf"]
	  },
	  "application/vnd.yamaha.openscoreformat.osfpvg+xml": {
	    "source": "iana",
	    "extensions": ["osfpvg"]
	  },
	  "application/vnd.yamaha.remote-setup": {
	    "source": "iana"
	  },
	  "application/vnd.yamaha.smaf-audio": {
	    "source": "iana",
	    "extensions": ["saf"]
	  },
	  "application/vnd.yamaha.smaf-phrase": {
	    "source": "iana",
	    "extensions": ["spf"]
	  },
	  "application/vnd.yamaha.through-ngn": {
	    "source": "iana"
	  },
	  "application/vnd.yamaha.tunnel-udpencap": {
	    "source": "iana"
	  },
	  "application/vnd.yaoweme": {
	    "source": "iana"
	  },
	  "application/vnd.yellowriver-custom-menu": {
	    "source": "iana",
	    "extensions": ["cmp"]
	  },
	  "application/vnd.zul": {
	    "source": "iana",
	    "extensions": ["zir","zirz"]
	  },
	  "application/vnd.zzazz.deck+xml": {
	    "source": "iana",
	    "extensions": ["zaz"]
	  },
	  "application/voicexml+xml": {
	    "source": "iana",
	    "extensions": ["vxml"]
	  },
	  "application/vq-rtcpxr": {
	    "source": "iana"
	  },
	  "application/watcherinfo+xml": {
	    "source": "iana"
	  },
	  "application/whoispp-query": {
	    "source": "iana"
	  },
	  "application/whoispp-response": {
	    "source": "iana"
	  },
	  "application/widget": {
	    "source": "iana",
	    "extensions": ["wgt"]
	  },
	  "application/winhlp": {
	    "source": "apache",
	    "extensions": ["hlp"]
	  },
	  "application/wita": {
	    "source": "iana"
	  },
	  "application/wordperfect5.1": {
	    "source": "iana"
	  },
	  "application/wsdl+xml": {
	    "source": "iana",
	    "extensions": ["wsdl"]
	  },
	  "application/wspolicy+xml": {
	    "source": "iana",
	    "extensions": ["wspolicy"]
	  },
	  "application/x-7z-compressed": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["7z"]
	  },
	  "application/x-abiword": {
	    "source": "apache",
	    "extensions": ["abw"]
	  },
	  "application/x-ace-compressed": {
	    "source": "apache",
	    "extensions": ["ace"]
	  },
	  "application/x-amf": {
	    "source": "apache"
	  },
	  "application/x-apple-diskimage": {
	    "source": "apache",
	    "extensions": ["dmg"]
	  },
	  "application/x-authorware-bin": {
	    "source": "apache",
	    "extensions": ["aab","x32","u32","vox"]
	  },
	  "application/x-authorware-map": {
	    "source": "apache",
	    "extensions": ["aam"]
	  },
	  "application/x-authorware-seg": {
	    "source": "apache",
	    "extensions": ["aas"]
	  },
	  "application/x-bcpio": {
	    "source": "apache",
	    "extensions": ["bcpio"]
	  },
	  "application/x-bdoc": {
	    "compressible": false,
	    "extensions": ["bdoc"]
	  },
	  "application/x-bittorrent": {
	    "source": "apache",
	    "extensions": ["torrent"]
	  },
	  "application/x-blorb": {
	    "source": "apache",
	    "extensions": ["blb","blorb"]
	  },
	  "application/x-bzip": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["bz"]
	  },
	  "application/x-bzip2": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["bz2","boz"]
	  },
	  "application/x-cbr": {
	    "source": "apache",
	    "extensions": ["cbr","cba","cbt","cbz","cb7"]
	  },
	  "application/x-cdlink": {
	    "source": "apache",
	    "extensions": ["vcd"]
	  },
	  "application/x-cfs-compressed": {
	    "source": "apache",
	    "extensions": ["cfs"]
	  },
	  "application/x-chat": {
	    "source": "apache",
	    "extensions": ["chat"]
	  },
	  "application/x-chess-pgn": {
	    "source": "apache",
	    "extensions": ["pgn"]
	  },
	  "application/x-chrome-extension": {
	    "extensions": ["crx"]
	  },
	  "application/x-cocoa": {
	    "source": "nginx",
	    "extensions": ["cco"]
	  },
	  "application/x-compress": {
	    "source": "apache"
	  },
	  "application/x-conference": {
	    "source": "apache",
	    "extensions": ["nsc"]
	  },
	  "application/x-cpio": {
	    "source": "apache",
	    "extensions": ["cpio"]
	  },
	  "application/x-csh": {
	    "source": "apache",
	    "extensions": ["csh"]
	  },
	  "application/x-deb": {
	    "compressible": false
	  },
	  "application/x-debian-package": {
	    "source": "apache",
	    "extensions": ["deb","udeb"]
	  },
	  "application/x-dgc-compressed": {
	    "source": "apache",
	    "extensions": ["dgc"]
	  },
	  "application/x-director": {
	    "source": "apache",
	    "extensions": ["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]
	  },
	  "application/x-doom": {
	    "source": "apache",
	    "extensions": ["wad"]
	  },
	  "application/x-dtbncx+xml": {
	    "source": "apache",
	    "extensions": ["ncx"]
	  },
	  "application/x-dtbook+xml": {
	    "source": "apache",
	    "extensions": ["dtb"]
	  },
	  "application/x-dtbresource+xml": {
	    "source": "apache",
	    "extensions": ["res"]
	  },
	  "application/x-dvi": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["dvi"]
	  },
	  "application/x-envoy": {
	    "source": "apache",
	    "extensions": ["evy"]
	  },
	  "application/x-eva": {
	    "source": "apache",
	    "extensions": ["eva"]
	  },
	  "application/x-font-bdf": {
	    "source": "apache",
	    "extensions": ["bdf"]
	  },
	  "application/x-font-dos": {
	    "source": "apache"
	  },
	  "application/x-font-framemaker": {
	    "source": "apache"
	  },
	  "application/x-font-ghostscript": {
	    "source": "apache",
	    "extensions": ["gsf"]
	  },
	  "application/x-font-libgrx": {
	    "source": "apache"
	  },
	  "application/x-font-linux-psf": {
	    "source": "apache",
	    "extensions": ["psf"]
	  },
	  "application/x-font-otf": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["otf"]
	  },
	  "application/x-font-pcf": {
	    "source": "apache",
	    "extensions": ["pcf"]
	  },
	  "application/x-font-snf": {
	    "source": "apache",
	    "extensions": ["snf"]
	  },
	  "application/x-font-speedo": {
	    "source": "apache"
	  },
	  "application/x-font-sunos-news": {
	    "source": "apache"
	  },
	  "application/x-font-ttf": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["ttf","ttc"]
	  },
	  "application/x-font-type1": {
	    "source": "apache",
	    "extensions": ["pfa","pfb","pfm","afm"]
	  },
	  "application/x-font-vfont": {
	    "source": "apache"
	  },
	  "application/x-freearc": {
	    "source": "apache",
	    "extensions": ["arc"]
	  },
	  "application/x-futuresplash": {
	    "source": "apache",
	    "extensions": ["spl"]
	  },
	  "application/x-gca-compressed": {
	    "source": "apache",
	    "extensions": ["gca"]
	  },
	  "application/x-glulx": {
	    "source": "apache",
	    "extensions": ["ulx"]
	  },
	  "application/x-gnumeric": {
	    "source": "apache",
	    "extensions": ["gnumeric"]
	  },
	  "application/x-gramps-xml": {
	    "source": "apache",
	    "extensions": ["gramps"]
	  },
	  "application/x-gtar": {
	    "source": "apache",
	    "extensions": ["gtar"]
	  },
	  "application/x-gzip": {
	    "source": "apache"
	  },
	  "application/x-hdf": {
	    "source": "apache",
	    "extensions": ["hdf"]
	  },
	  "application/x-httpd-php": {
	    "compressible": true,
	    "extensions": ["php"]
	  },
	  "application/x-install-instructions": {
	    "source": "apache",
	    "extensions": ["install"]
	  },
	  "application/x-iso9660-image": {
	    "source": "apache",
	    "extensions": ["iso"]
	  },
	  "application/x-java-archive-diff": {
	    "source": "nginx",
	    "extensions": ["jardiff"]
	  },
	  "application/x-java-jnlp-file": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["jnlp"]
	  },
	  "application/x-javascript": {
	    "compressible": true
	  },
	  "application/x-latex": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["latex"]
	  },
	  "application/x-lua-bytecode": {
	    "extensions": ["luac"]
	  },
	  "application/x-lzh-compressed": {
	    "source": "apache",
	    "extensions": ["lzh","lha"]
	  },
	  "application/x-makeself": {
	    "source": "nginx",
	    "extensions": ["run"]
	  },
	  "application/x-mie": {
	    "source": "apache",
	    "extensions": ["mie"]
	  },
	  "application/x-mobipocket-ebook": {
	    "source": "apache",
	    "extensions": ["prc","mobi"]
	  },
	  "application/x-mpegurl": {
	    "compressible": false
	  },
	  "application/x-ms-application": {
	    "source": "apache",
	    "extensions": ["application"]
	  },
	  "application/x-ms-shortcut": {
	    "source": "apache",
	    "extensions": ["lnk"]
	  },
	  "application/x-ms-wmd": {
	    "source": "apache",
	    "extensions": ["wmd"]
	  },
	  "application/x-ms-wmz": {
	    "source": "apache",
	    "extensions": ["wmz"]
	  },
	  "application/x-ms-xbap": {
	    "source": "apache",
	    "extensions": ["xbap"]
	  },
	  "application/x-msaccess": {
	    "source": "apache",
	    "extensions": ["mdb"]
	  },
	  "application/x-msbinder": {
	    "source": "apache",
	    "extensions": ["obd"]
	  },
	  "application/x-mscardfile": {
	    "source": "apache",
	    "extensions": ["crd"]
	  },
	  "application/x-msclip": {
	    "source": "apache",
	    "extensions": ["clp"]
	  },
	  "application/x-msdos-program": {
	    "extensions": ["exe"]
	  },
	  "application/x-msdownload": {
	    "source": "apache",
	    "extensions": ["exe","dll","com","bat","msi"]
	  },
	  "application/x-msmediaview": {
	    "source": "apache",
	    "extensions": ["mvb","m13","m14"]
	  },
	  "application/x-msmetafile": {
	    "source": "apache",
	    "extensions": ["wmf","wmz","emf","emz"]
	  },
	  "application/x-msmoney": {
	    "source": "apache",
	    "extensions": ["mny"]
	  },
	  "application/x-mspublisher": {
	    "source": "apache",
	    "extensions": ["pub"]
	  },
	  "application/x-msschedule": {
	    "source": "apache",
	    "extensions": ["scd"]
	  },
	  "application/x-msterminal": {
	    "source": "apache",
	    "extensions": ["trm"]
	  },
	  "application/x-mswrite": {
	    "source": "apache",
	    "extensions": ["wri"]
	  },
	  "application/x-netcdf": {
	    "source": "apache",
	    "extensions": ["nc","cdf"]
	  },
	  "application/x-ns-proxy-autoconfig": {
	    "compressible": true,
	    "extensions": ["pac"]
	  },
	  "application/x-nzb": {
	    "source": "apache",
	    "extensions": ["nzb"]
	  },
	  "application/x-perl": {
	    "source": "nginx",
	    "extensions": ["pl","pm"]
	  },
	  "application/x-pilot": {
	    "source": "nginx",
	    "extensions": ["prc","pdb"]
	  },
	  "application/x-pkcs12": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["p12","pfx"]
	  },
	  "application/x-pkcs7-certificates": {
	    "source": "apache",
	    "extensions": ["p7b","spc"]
	  },
	  "application/x-pkcs7-certreqresp": {
	    "source": "apache",
	    "extensions": ["p7r"]
	  },
	  "application/x-rar-compressed": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["rar"]
	  },
	  "application/x-redhat-package-manager": {
	    "source": "nginx",
	    "extensions": ["rpm"]
	  },
	  "application/x-research-info-systems": {
	    "source": "apache",
	    "extensions": ["ris"]
	  },
	  "application/x-sea": {
	    "source": "nginx",
	    "extensions": ["sea"]
	  },
	  "application/x-sh": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["sh"]
	  },
	  "application/x-shar": {
	    "source": "apache",
	    "extensions": ["shar"]
	  },
	  "application/x-shockwave-flash": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["swf"]
	  },
	  "application/x-silverlight-app": {
	    "source": "apache",
	    "extensions": ["xap"]
	  },
	  "application/x-sql": {
	    "source": "apache",
	    "extensions": ["sql"]
	  },
	  "application/x-stuffit": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["sit"]
	  },
	  "application/x-stuffitx": {
	    "source": "apache",
	    "extensions": ["sitx"]
	  },
	  "application/x-subrip": {
	    "source": "apache",
	    "extensions": ["srt"]
	  },
	  "application/x-sv4cpio": {
	    "source": "apache",
	    "extensions": ["sv4cpio"]
	  },
	  "application/x-sv4crc": {
	    "source": "apache",
	    "extensions": ["sv4crc"]
	  },
	  "application/x-t3vm-image": {
	    "source": "apache",
	    "extensions": ["t3"]
	  },
	  "application/x-tads": {
	    "source": "apache",
	    "extensions": ["gam"]
	  },
	  "application/x-tar": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["tar"]
	  },
	  "application/x-tcl": {
	    "source": "apache",
	    "extensions": ["tcl","tk"]
	  },
	  "application/x-tex": {
	    "source": "apache",
	    "extensions": ["tex"]
	  },
	  "application/x-tex-tfm": {
	    "source": "apache",
	    "extensions": ["tfm"]
	  },
	  "application/x-texinfo": {
	    "source": "apache",
	    "extensions": ["texinfo","texi"]
	  },
	  "application/x-tgif": {
	    "source": "apache",
	    "extensions": ["obj"]
	  },
	  "application/x-ustar": {
	    "source": "apache",
	    "extensions": ["ustar"]
	  },
	  "application/x-wais-source": {
	    "source": "apache",
	    "extensions": ["src"]
	  },
	  "application/x-web-app-manifest+json": {
	    "compressible": true,
	    "extensions": ["webapp"]
	  },
	  "application/x-www-form-urlencoded": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/x-x509-ca-cert": {
	    "source": "apache",
	    "extensions": ["der","crt","pem"]
	  },
	  "application/x-xfig": {
	    "source": "apache",
	    "extensions": ["fig"]
	  },
	  "application/x-xliff+xml": {
	    "source": "apache",
	    "extensions": ["xlf"]
	  },
	  "application/x-xpinstall": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["xpi"]
	  },
	  "application/x-xz": {
	    "source": "apache",
	    "extensions": ["xz"]
	  },
	  "application/x-zmachine": {
	    "source": "apache",
	    "extensions": ["z1","z2","z3","z4","z5","z6","z7","z8"]
	  },
	  "application/x400-bp": {
	    "source": "iana"
	  },
	  "application/xacml+xml": {
	    "source": "iana"
	  },
	  "application/xaml+xml": {
	    "source": "apache",
	    "extensions": ["xaml"]
	  },
	  "application/xcap-att+xml": {
	    "source": "iana"
	  },
	  "application/xcap-caps+xml": {
	    "source": "iana"
	  },
	  "application/xcap-diff+xml": {
	    "source": "iana",
	    "extensions": ["xdf"]
	  },
	  "application/xcap-el+xml": {
	    "source": "iana"
	  },
	  "application/xcap-error+xml": {
	    "source": "iana"
	  },
	  "application/xcap-ns+xml": {
	    "source": "iana"
	  },
	  "application/xcon-conference-info+xml": {
	    "source": "iana"
	  },
	  "application/xcon-conference-info-diff+xml": {
	    "source": "iana"
	  },
	  "application/xenc+xml": {
	    "source": "iana",
	    "extensions": ["xenc"]
	  },
	  "application/xhtml+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xhtml","xht"]
	  },
	  "application/xhtml-voice+xml": {
	    "source": "apache"
	  },
	  "application/xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xml","xsl","xsd"]
	  },
	  "application/xml-dtd": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["dtd"]
	  },
	  "application/xml-external-parsed-entity": {
	    "source": "iana"
	  },
	  "application/xml-patch+xml": {
	    "source": "iana"
	  },
	  "application/xmpp+xml": {
	    "source": "iana"
	  },
	  "application/xop+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xop"]
	  },
	  "application/xproc+xml": {
	    "source": "apache",
	    "extensions": ["xpl"]
	  },
	  "application/xslt+xml": {
	    "source": "iana",
	    "extensions": ["xslt"]
	  },
	  "application/xspf+xml": {
	    "source": "apache",
	    "extensions": ["xspf"]
	  },
	  "application/xv+xml": {
	    "source": "iana",
	    "extensions": ["mxml","xhvml","xvml","xvm"]
	  },
	  "application/yang": {
	    "source": "iana",
	    "extensions": ["yang"]
	  },
	  "application/yin+xml": {
	    "source": "iana",
	    "extensions": ["yin"]
	  },
	  "application/zip": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["zip"]
	  },
	  "application/zlib": {
	    "source": "iana"
	  },
	  "audio/1d-interleaved-parityfec": {
	    "source": "iana"
	  },
	  "audio/32kadpcm": {
	    "source": "iana"
	  },
	  "audio/3gpp": {
	    "source": "iana"
	  },
	  "audio/3gpp2": {
	    "source": "iana"
	  },
	  "audio/ac3": {
	    "source": "iana"
	  },
	  "audio/adpcm": {
	    "source": "apache",
	    "extensions": ["adp"]
	  },
	  "audio/amr": {
	    "source": "iana"
	  },
	  "audio/amr-wb": {
	    "source": "iana"
	  },
	  "audio/amr-wb+": {
	    "source": "iana"
	  },
	  "audio/aptx": {
	    "source": "iana"
	  },
	  "audio/asc": {
	    "source": "iana"
	  },
	  "audio/atrac-advanced-lossless": {
	    "source": "iana"
	  },
	  "audio/atrac-x": {
	    "source": "iana"
	  },
	  "audio/atrac3": {
	    "source": "iana"
	  },
	  "audio/basic": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["au","snd"]
	  },
	  "audio/bv16": {
	    "source": "iana"
	  },
	  "audio/bv32": {
	    "source": "iana"
	  },
	  "audio/clearmode": {
	    "source": "iana"
	  },
	  "audio/cn": {
	    "source": "iana"
	  },
	  "audio/dat12": {
	    "source": "iana"
	  },
	  "audio/dls": {
	    "source": "iana"
	  },
	  "audio/dsr-es201108": {
	    "source": "iana"
	  },
	  "audio/dsr-es202050": {
	    "source": "iana"
	  },
	  "audio/dsr-es202211": {
	    "source": "iana"
	  },
	  "audio/dsr-es202212": {
	    "source": "iana"
	  },
	  "audio/dv": {
	    "source": "iana"
	  },
	  "audio/dvi4": {
	    "source": "iana"
	  },
	  "audio/eac3": {
	    "source": "iana"
	  },
	  "audio/encaprtp": {
	    "source": "iana"
	  },
	  "audio/evrc": {
	    "source": "iana"
	  },
	  "audio/evrc-qcp": {
	    "source": "iana"
	  },
	  "audio/evrc0": {
	    "source": "iana"
	  },
	  "audio/evrc1": {
	    "source": "iana"
	  },
	  "audio/evrcb": {
	    "source": "iana"
	  },
	  "audio/evrcb0": {
	    "source": "iana"
	  },
	  "audio/evrcb1": {
	    "source": "iana"
	  },
	  "audio/evrcnw": {
	    "source": "iana"
	  },
	  "audio/evrcnw0": {
	    "source": "iana"
	  },
	  "audio/evrcnw1": {
	    "source": "iana"
	  },
	  "audio/evrcwb": {
	    "source": "iana"
	  },
	  "audio/evrcwb0": {
	    "source": "iana"
	  },
	  "audio/evrcwb1": {
	    "source": "iana"
	  },
	  "audio/evs": {
	    "source": "iana"
	  },
	  "audio/fwdred": {
	    "source": "iana"
	  },
	  "audio/g711-0": {
	    "source": "iana"
	  },
	  "audio/g719": {
	    "source": "iana"
	  },
	  "audio/g722": {
	    "source": "iana"
	  },
	  "audio/g7221": {
	    "source": "iana"
	  },
	  "audio/g723": {
	    "source": "iana"
	  },
	  "audio/g726-16": {
	    "source": "iana"
	  },
	  "audio/g726-24": {
	    "source": "iana"
	  },
	  "audio/g726-32": {
	    "source": "iana"
	  },
	  "audio/g726-40": {
	    "source": "iana"
	  },
	  "audio/g728": {
	    "source": "iana"
	  },
	  "audio/g729": {
	    "source": "iana"
	  },
	  "audio/g7291": {
	    "source": "iana"
	  },
	  "audio/g729d": {
	    "source": "iana"
	  },
	  "audio/g729e": {
	    "source": "iana"
	  },
	  "audio/gsm": {
	    "source": "iana"
	  },
	  "audio/gsm-efr": {
	    "source": "iana"
	  },
	  "audio/gsm-hr-08": {
	    "source": "iana"
	  },
	  "audio/ilbc": {
	    "source": "iana"
	  },
	  "audio/ip-mr_v2.5": {
	    "source": "iana"
	  },
	  "audio/isac": {
	    "source": "apache"
	  },
	  "audio/l16": {
	    "source": "iana"
	  },
	  "audio/l20": {
	    "source": "iana"
	  },
	  "audio/l24": {
	    "source": "iana",
	    "compressible": false
	  },
	  "audio/l8": {
	    "source": "iana"
	  },
	  "audio/lpc": {
	    "source": "iana"
	  },
	  "audio/midi": {
	    "source": "apache",
	    "extensions": ["mid","midi","kar","rmi"]
	  },
	  "audio/mobile-xmf": {
	    "source": "iana"
	  },
	  "audio/mp4": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["mp4a","m4a"]
	  },
	  "audio/mp4a-latm": {
	    "source": "iana"
	  },
	  "audio/mpa": {
	    "source": "iana"
	  },
	  "audio/mpa-robust": {
	    "source": "iana"
	  },
	  "audio/mpeg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["mpga","mp2","mp2a","mp3","m2a","m3a"]
	  },
	  "audio/mpeg4-generic": {
	    "source": "iana"
	  },
	  "audio/musepack": {
	    "source": "apache"
	  },
	  "audio/ogg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["oga","ogg","spx"]
	  },
	  "audio/opus": {
	    "source": "iana"
	  },
	  "audio/parityfec": {
	    "source": "iana"
	  },
	  "audio/pcma": {
	    "source": "iana"
	  },
	  "audio/pcma-wb": {
	    "source": "iana"
	  },
	  "audio/pcmu": {
	    "source": "iana"
	  },
	  "audio/pcmu-wb": {
	    "source": "iana"
	  },
	  "audio/prs.sid": {
	    "source": "iana"
	  },
	  "audio/qcelp": {
	    "source": "iana"
	  },
	  "audio/raptorfec": {
	    "source": "iana"
	  },
	  "audio/red": {
	    "source": "iana"
	  },
	  "audio/rtp-enc-aescm128": {
	    "source": "iana"
	  },
	  "audio/rtp-midi": {
	    "source": "iana"
	  },
	  "audio/rtploopback": {
	    "source": "iana"
	  },
	  "audio/rtx": {
	    "source": "iana"
	  },
	  "audio/s3m": {
	    "source": "apache",
	    "extensions": ["s3m"]
	  },
	  "audio/silk": {
	    "source": "apache",
	    "extensions": ["sil"]
	  },
	  "audio/smv": {
	    "source": "iana"
	  },
	  "audio/smv-qcp": {
	    "source": "iana"
	  },
	  "audio/smv0": {
	    "source": "iana"
	  },
	  "audio/sp-midi": {
	    "source": "iana"
	  },
	  "audio/speex": {
	    "source": "iana"
	  },
	  "audio/t140c": {
	    "source": "iana"
	  },
	  "audio/t38": {
	    "source": "iana"
	  },
	  "audio/telephone-event": {
	    "source": "iana"
	  },
	  "audio/tone": {
	    "source": "iana"
	  },
	  "audio/uemclip": {
	    "source": "iana"
	  },
	  "audio/ulpfec": {
	    "source": "iana"
	  },
	  "audio/vdvi": {
	    "source": "iana"
	  },
	  "audio/vmr-wb": {
	    "source": "iana"
	  },
	  "audio/vnd.3gpp.iufp": {
	    "source": "iana"
	  },
	  "audio/vnd.4sb": {
	    "source": "iana"
	  },
	  "audio/vnd.audiokoz": {
	    "source": "iana"
	  },
	  "audio/vnd.celp": {
	    "source": "iana"
	  },
	  "audio/vnd.cisco.nse": {
	    "source": "iana"
	  },
	  "audio/vnd.cmles.radio-events": {
	    "source": "iana"
	  },
	  "audio/vnd.cns.anp1": {
	    "source": "iana"
	  },
	  "audio/vnd.cns.inf1": {
	    "source": "iana"
	  },
	  "audio/vnd.dece.audio": {
	    "source": "iana",
	    "extensions": ["uva","uvva"]
	  },
	  "audio/vnd.digital-winds": {
	    "source": "iana",
	    "extensions": ["eol"]
	  },
	  "audio/vnd.dlna.adts": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.heaac.1": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.heaac.2": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.mlp": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.mps": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pl2": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pl2x": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pl2z": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pulse.1": {
	    "source": "iana"
	  },
	  "audio/vnd.dra": {
	    "source": "iana",
	    "extensions": ["dra"]
	  },
	  "audio/vnd.dts": {
	    "source": "iana",
	    "extensions": ["dts"]
	  },
	  "audio/vnd.dts.hd": {
	    "source": "iana",
	    "extensions": ["dtshd"]
	  },
	  "audio/vnd.dvb.file": {
	    "source": "iana"
	  },
	  "audio/vnd.everad.plj": {
	    "source": "iana"
	  },
	  "audio/vnd.hns.audio": {
	    "source": "iana"
	  },
	  "audio/vnd.lucent.voice": {
	    "source": "iana",
	    "extensions": ["lvp"]
	  },
	  "audio/vnd.ms-playready.media.pya": {
	    "source": "iana",
	    "extensions": ["pya"]
	  },
	  "audio/vnd.nokia.mobile-xmf": {
	    "source": "iana"
	  },
	  "audio/vnd.nortel.vbk": {
	    "source": "iana"
	  },
	  "audio/vnd.nuera.ecelp4800": {
	    "source": "iana",
	    "extensions": ["ecelp4800"]
	  },
	  "audio/vnd.nuera.ecelp7470": {
	    "source": "iana",
	    "extensions": ["ecelp7470"]
	  },
	  "audio/vnd.nuera.ecelp9600": {
	    "source": "iana",
	    "extensions": ["ecelp9600"]
	  },
	  "audio/vnd.octel.sbc": {
	    "source": "iana"
	  },
	  "audio/vnd.qcelp": {
	    "source": "iana"
	  },
	  "audio/vnd.rhetorex.32kadpcm": {
	    "source": "iana"
	  },
	  "audio/vnd.rip": {
	    "source": "iana",
	    "extensions": ["rip"]
	  },
	  "audio/vnd.rn-realaudio": {
	    "compressible": false
	  },
	  "audio/vnd.sealedmedia.softseal.mpeg": {
	    "source": "iana"
	  },
	  "audio/vnd.vmx.cvsd": {
	    "source": "iana"
	  },
	  "audio/vnd.wave": {
	    "compressible": false
	  },
	  "audio/vorbis": {
	    "source": "iana",
	    "compressible": false
	  },
	  "audio/vorbis-config": {
	    "source": "iana"
	  },
	  "audio/wav": {
	    "compressible": false,
	    "extensions": ["wav"]
	  },
	  "audio/wave": {
	    "compressible": false,
	    "extensions": ["wav"]
	  },
	  "audio/webm": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["weba"]
	  },
	  "audio/x-aac": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["aac"]
	  },
	  "audio/x-aiff": {
	    "source": "apache",
	    "extensions": ["aif","aiff","aifc"]
	  },
	  "audio/x-caf": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["caf"]
	  },
	  "audio/x-flac": {
	    "source": "apache",
	    "extensions": ["flac"]
	  },
	  "audio/x-m4a": {
	    "source": "nginx",
	    "extensions": ["m4a"]
	  },
	  "audio/x-matroska": {
	    "source": "apache",
	    "extensions": ["mka"]
	  },
	  "audio/x-mpegurl": {
	    "source": "apache",
	    "extensions": ["m3u"]
	  },
	  "audio/x-ms-wax": {
	    "source": "apache",
	    "extensions": ["wax"]
	  },
	  "audio/x-ms-wma": {
	    "source": "apache",
	    "extensions": ["wma"]
	  },
	  "audio/x-pn-realaudio": {
	    "source": "apache",
	    "extensions": ["ram","ra"]
	  },
	  "audio/x-pn-realaudio-plugin": {
	    "source": "apache",
	    "extensions": ["rmp"]
	  },
	  "audio/x-realaudio": {
	    "source": "nginx",
	    "extensions": ["ra"]
	  },
	  "audio/x-tta": {
	    "source": "apache"
	  },
	  "audio/x-wav": {
	    "source": "apache",
	    "extensions": ["wav"]
	  },
	  "audio/xm": {
	    "source": "apache",
	    "extensions": ["xm"]
	  },
	  "chemical/x-cdx": {
	    "source": "apache",
	    "extensions": ["cdx"]
	  },
	  "chemical/x-cif": {
	    "source": "apache",
	    "extensions": ["cif"]
	  },
	  "chemical/x-cmdf": {
	    "source": "apache",
	    "extensions": ["cmdf"]
	  },
	  "chemical/x-cml": {
	    "source": "apache",
	    "extensions": ["cml"]
	  },
	  "chemical/x-csml": {
	    "source": "apache",
	    "extensions": ["csml"]
	  },
	  "chemical/x-pdb": {
	    "source": "apache"
	  },
	  "chemical/x-xyz": {
	    "source": "apache",
	    "extensions": ["xyz"]
	  },
	  "font/opentype": {
	    "compressible": true,
	    "extensions": ["otf"]
	  },
	  "image/bmp": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["bmp"]
	  },
	  "image/cgm": {
	    "source": "iana",
	    "extensions": ["cgm"]
	  },
	  "image/fits": {
	    "source": "iana"
	  },
	  "image/g3fax": {
	    "source": "iana",
	    "extensions": ["g3"]
	  },
	  "image/gif": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["gif"]
	  },
	  "image/ief": {
	    "source": "iana",
	    "extensions": ["ief"]
	  },
	  "image/jp2": {
	    "source": "iana"
	  },
	  "image/jpeg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["jpeg","jpg","jpe"]
	  },
	  "image/jpm": {
	    "source": "iana"
	  },
	  "image/jpx": {
	    "source": "iana"
	  },
	  "image/ktx": {
	    "source": "iana",
	    "extensions": ["ktx"]
	  },
	  "image/naplps": {
	    "source": "iana"
	  },
	  "image/pjpeg": {
	    "compressible": false
	  },
	  "image/png": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["png"]
	  },
	  "image/prs.btif": {
	    "source": "iana",
	    "extensions": ["btif"]
	  },
	  "image/prs.pti": {
	    "source": "iana"
	  },
	  "image/pwg-raster": {
	    "source": "iana"
	  },
	  "image/sgi": {
	    "source": "apache",
	    "extensions": ["sgi"]
	  },
	  "image/svg+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["svg","svgz"]
	  },
	  "image/t38": {
	    "source": "iana"
	  },
	  "image/tiff": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["tiff","tif"]
	  },
	  "image/tiff-fx": {
	    "source": "iana"
	  },
	  "image/vnd.adobe.photoshop": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["psd"]
	  },
	  "image/vnd.airzip.accelerator.azv": {
	    "source": "iana"
	  },
	  "image/vnd.cns.inf2": {
	    "source": "iana"
	  },
	  "image/vnd.dece.graphic": {
	    "source": "iana",
	    "extensions": ["uvi","uvvi","uvg","uvvg"]
	  },
	  "image/vnd.djvu": {
	    "source": "iana",
	    "extensions": ["djvu","djv"]
	  },
	  "image/vnd.dvb.subtitle": {
	    "source": "iana",
	    "extensions": ["sub"]
	  },
	  "image/vnd.dwg": {
	    "source": "iana",
	    "extensions": ["dwg"]
	  },
	  "image/vnd.dxf": {
	    "source": "iana",
	    "extensions": ["dxf"]
	  },
	  "image/vnd.fastbidsheet": {
	    "source": "iana",
	    "extensions": ["fbs"]
	  },
	  "image/vnd.fpx": {
	    "source": "iana",
	    "extensions": ["fpx"]
	  },
	  "image/vnd.fst": {
	    "source": "iana",
	    "extensions": ["fst"]
	  },
	  "image/vnd.fujixerox.edmics-mmr": {
	    "source": "iana",
	    "extensions": ["mmr"]
	  },
	  "image/vnd.fujixerox.edmics-rlc": {
	    "source": "iana",
	    "extensions": ["rlc"]
	  },
	  "image/vnd.globalgraphics.pgb": {
	    "source": "iana"
	  },
	  "image/vnd.microsoft.icon": {
	    "source": "iana"
	  },
	  "image/vnd.mix": {
	    "source": "iana"
	  },
	  "image/vnd.mozilla.apng": {
	    "source": "iana"
	  },
	  "image/vnd.ms-modi": {
	    "source": "iana",
	    "extensions": ["mdi"]
	  },
	  "image/vnd.ms-photo": {
	    "source": "apache",
	    "extensions": ["wdp"]
	  },
	  "image/vnd.net-fpx": {
	    "source": "iana",
	    "extensions": ["npx"]
	  },
	  "image/vnd.radiance": {
	    "source": "iana"
	  },
	  "image/vnd.sealed.png": {
	    "source": "iana"
	  },
	  "image/vnd.sealedmedia.softseal.gif": {
	    "source": "iana"
	  },
	  "image/vnd.sealedmedia.softseal.jpg": {
	    "source": "iana"
	  },
	  "image/vnd.svf": {
	    "source": "iana"
	  },
	  "image/vnd.tencent.tap": {
	    "source": "iana"
	  },
	  "image/vnd.valve.source.texture": {
	    "source": "iana"
	  },
	  "image/vnd.wap.wbmp": {
	    "source": "iana",
	    "extensions": ["wbmp"]
	  },
	  "image/vnd.xiff": {
	    "source": "iana",
	    "extensions": ["xif"]
	  },
	  "image/vnd.zbrush.pcx": {
	    "source": "iana"
	  },
	  "image/webp": {
	    "source": "apache",
	    "extensions": ["webp"]
	  },
	  "image/x-3ds": {
	    "source": "apache",
	    "extensions": ["3ds"]
	  },
	  "image/x-cmu-raster": {
	    "source": "apache",
	    "extensions": ["ras"]
	  },
	  "image/x-cmx": {
	    "source": "apache",
	    "extensions": ["cmx"]
	  },
	  "image/x-freehand": {
	    "source": "apache",
	    "extensions": ["fh","fhc","fh4","fh5","fh7"]
	  },
	  "image/x-icon": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["ico"]
	  },
	  "image/x-jng": {
	    "source": "nginx",
	    "extensions": ["jng"]
	  },
	  "image/x-mrsid-image": {
	    "source": "apache",
	    "extensions": ["sid"]
	  },
	  "image/x-ms-bmp": {
	    "source": "nginx",
	    "compressible": true,
	    "extensions": ["bmp"]
	  },
	  "image/x-pcx": {
	    "source": "apache",
	    "extensions": ["pcx"]
	  },
	  "image/x-pict": {
	    "source": "apache",
	    "extensions": ["pic","pct"]
	  },
	  "image/x-portable-anymap": {
	    "source": "apache",
	    "extensions": ["pnm"]
	  },
	  "image/x-portable-bitmap": {
	    "source": "apache",
	    "extensions": ["pbm"]
	  },
	  "image/x-portable-graymap": {
	    "source": "apache",
	    "extensions": ["pgm"]
	  },
	  "image/x-portable-pixmap": {
	    "source": "apache",
	    "extensions": ["ppm"]
	  },
	  "image/x-rgb": {
	    "source": "apache",
	    "extensions": ["rgb"]
	  },
	  "image/x-tga": {
	    "source": "apache",
	    "extensions": ["tga"]
	  },
	  "image/x-xbitmap": {
	    "source": "apache",
	    "extensions": ["xbm"]
	  },
	  "image/x-xcf": {
	    "compressible": false
	  },
	  "image/x-xpixmap": {
	    "source": "apache",
	    "extensions": ["xpm"]
	  },
	  "image/x-xwindowdump": {
	    "source": "apache",
	    "extensions": ["xwd"]
	  },
	  "message/cpim": {
	    "source": "iana"
	  },
	  "message/delivery-status": {
	    "source": "iana"
	  },
	  "message/disposition-notification": {
	    "source": "iana"
	  },
	  "message/external-body": {
	    "source": "iana"
	  },
	  "message/feedback-report": {
	    "source": "iana"
	  },
	  "message/global": {
	    "source": "iana"
	  },
	  "message/global-delivery-status": {
	    "source": "iana"
	  },
	  "message/global-disposition-notification": {
	    "source": "iana"
	  },
	  "message/global-headers": {
	    "source": "iana"
	  },
	  "message/http": {
	    "source": "iana",
	    "compressible": false
	  },
	  "message/imdn+xml": {
	    "source": "iana",
	    "compressible": true
	  },
	  "message/news": {
	    "source": "iana"
	  },
	  "message/partial": {
	    "source": "iana",
	    "compressible": false
	  },
	  "message/rfc822": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["eml","mime"]
	  },
	  "message/s-http": {
	    "source": "iana"
	  },
	  "message/sip": {
	    "source": "iana"
	  },
	  "message/sipfrag": {
	    "source": "iana"
	  },
	  "message/tracking-status": {
	    "source": "iana"
	  },
	  "message/vnd.si.simp": {
	    "source": "iana"
	  },
	  "message/vnd.wfa.wsc": {
	    "source": "iana"
	  },
	  "model/iges": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["igs","iges"]
	  },
	  "model/mesh": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["msh","mesh","silo"]
	  },
	  "model/vnd.collada+xml": {
	    "source": "iana",
	    "extensions": ["dae"]
	  },
	  "model/vnd.dwf": {
	    "source": "iana",
	    "extensions": ["dwf"]
	  },
	  "model/vnd.flatland.3dml": {
	    "source": "iana"
	  },
	  "model/vnd.gdl": {
	    "source": "iana",
	    "extensions": ["gdl"]
	  },
	  "model/vnd.gs-gdl": {
	    "source": "apache"
	  },
	  "model/vnd.gs.gdl": {
	    "source": "iana"
	  },
	  "model/vnd.gtw": {
	    "source": "iana",
	    "extensions": ["gtw"]
	  },
	  "model/vnd.moml+xml": {
	    "source": "iana"
	  },
	  "model/vnd.mts": {
	    "source": "iana",
	    "extensions": ["mts"]
	  },
	  "model/vnd.opengex": {
	    "source": "iana"
	  },
	  "model/vnd.parasolid.transmit.binary": {
	    "source": "iana"
	  },
	  "model/vnd.parasolid.transmit.text": {
	    "source": "iana"
	  },
	  "model/vnd.valve.source.compiled-map": {
	    "source": "iana"
	  },
	  "model/vnd.vtu": {
	    "source": "iana",
	    "extensions": ["vtu"]
	  },
	  "model/vrml": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["wrl","vrml"]
	  },
	  "model/x3d+binary": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["x3db","x3dbz"]
	  },
	  "model/x3d+fastinfoset": {
	    "source": "iana"
	  },
	  "model/x3d+vrml": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["x3dv","x3dvz"]
	  },
	  "model/x3d+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["x3d","x3dz"]
	  },
	  "model/x3d-vrml": {
	    "source": "iana"
	  },
	  "multipart/alternative": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/appledouble": {
	    "source": "iana"
	  },
	  "multipart/byteranges": {
	    "source": "iana"
	  },
	  "multipart/digest": {
	    "source": "iana"
	  },
	  "multipart/encrypted": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/form-data": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/header-set": {
	    "source": "iana"
	  },
	  "multipart/mixed": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/parallel": {
	    "source": "iana"
	  },
	  "multipart/related": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/report": {
	    "source": "iana"
	  },
	  "multipart/signed": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/voice-message": {
	    "source": "iana"
	  },
	  "multipart/x-mixed-replace": {
	    "source": "iana"
	  },
	  "text/1d-interleaved-parityfec": {
	    "source": "iana"
	  },
	  "text/cache-manifest": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["appcache","manifest"]
	  },
	  "text/calendar": {
	    "source": "iana",
	    "extensions": ["ics","ifb"]
	  },
	  "text/calender": {
	    "compressible": true
	  },
	  "text/cmd": {
	    "compressible": true
	  },
	  "text/coffeescript": {
	    "extensions": ["coffee","litcoffee"]
	  },
	  "text/css": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["css"]
	  },
	  "text/csv": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["csv"]
	  },
	  "text/csv-schema": {
	    "source": "iana"
	  },
	  "text/directory": {
	    "source": "iana"
	  },
	  "text/dns": {
	    "source": "iana"
	  },
	  "text/ecmascript": {
	    "source": "iana"
	  },
	  "text/encaprtp": {
	    "source": "iana"
	  },
	  "text/enriched": {
	    "source": "iana"
	  },
	  "text/fwdred": {
	    "source": "iana"
	  },
	  "text/grammar-ref-list": {
	    "source": "iana"
	  },
	  "text/hjson": {
	    "extensions": ["hjson"]
	  },
	  "text/html": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["html","htm","shtml"]
	  },
	  "text/jade": {
	    "extensions": ["jade"]
	  },
	  "text/javascript": {
	    "source": "iana",
	    "compressible": true
	  },
	  "text/jcr-cnd": {
	    "source": "iana"
	  },
	  "text/jsx": {
	    "compressible": true,
	    "extensions": ["jsx"]
	  },
	  "text/less": {
	    "extensions": ["less"]
	  },
	  "text/markdown": {
	    "source": "iana"
	  },
	  "text/mathml": {
	    "source": "nginx",
	    "extensions": ["mml"]
	  },
	  "text/mizar": {
	    "source": "iana"
	  },
	  "text/n3": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["n3"]
	  },
	  "text/parameters": {
	    "source": "iana"
	  },
	  "text/parityfec": {
	    "source": "iana"
	  },
	  "text/plain": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["txt","text","conf","def","list","log","in","ini"]
	  },
	  "text/provenance-notation": {
	    "source": "iana"
	  },
	  "text/prs.fallenstein.rst": {
	    "source": "iana"
	  },
	  "text/prs.lines.tag": {
	    "source": "iana",
	    "extensions": ["dsc"]
	  },
	  "text/raptorfec": {
	    "source": "iana"
	  },
	  "text/red": {
	    "source": "iana"
	  },
	  "text/rfc822-headers": {
	    "source": "iana"
	  },
	  "text/richtext": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rtx"]
	  },
	  "text/rtf": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rtf"]
	  },
	  "text/rtp-enc-aescm128": {
	    "source": "iana"
	  },
	  "text/rtploopback": {
	    "source": "iana"
	  },
	  "text/rtx": {
	    "source": "iana"
	  },
	  "text/sgml": {
	    "source": "iana",
	    "extensions": ["sgml","sgm"]
	  },
	  "text/stylus": {
	    "extensions": ["stylus","styl"]
	  },
	  "text/t140": {
	    "source": "iana"
	  },
	  "text/tab-separated-values": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["tsv"]
	  },
	  "text/troff": {
	    "source": "iana",
	    "extensions": ["t","tr","roff","man","me","ms"]
	  },
	  "text/turtle": {
	    "source": "iana",
	    "extensions": ["ttl"]
	  },
	  "text/ulpfec": {
	    "source": "iana"
	  },
	  "text/uri-list": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["uri","uris","urls"]
	  },
	  "text/vcard": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["vcard"]
	  },
	  "text/vnd.a": {
	    "source": "iana"
	  },
	  "text/vnd.abc": {
	    "source": "iana"
	  },
	  "text/vnd.curl": {
	    "source": "iana",
	    "extensions": ["curl"]
	  },
	  "text/vnd.curl.dcurl": {
	    "source": "apache",
	    "extensions": ["dcurl"]
	  },
	  "text/vnd.curl.mcurl": {
	    "source": "apache",
	    "extensions": ["mcurl"]
	  },
	  "text/vnd.curl.scurl": {
	    "source": "apache",
	    "extensions": ["scurl"]
	  },
	  "text/vnd.debian.copyright": {
	    "source": "iana"
	  },
	  "text/vnd.dmclientscript": {
	    "source": "iana"
	  },
	  "text/vnd.dvb.subtitle": {
	    "source": "iana",
	    "extensions": ["sub"]
	  },
	  "text/vnd.esmertec.theme-descriptor": {
	    "source": "iana"
	  },
	  "text/vnd.fly": {
	    "source": "iana",
	    "extensions": ["fly"]
	  },
	  "text/vnd.fmi.flexstor": {
	    "source": "iana",
	    "extensions": ["flx"]
	  },
	  "text/vnd.graphviz": {
	    "source": "iana",
	    "extensions": ["gv"]
	  },
	  "text/vnd.in3d.3dml": {
	    "source": "iana",
	    "extensions": ["3dml"]
	  },
	  "text/vnd.in3d.spot": {
	    "source": "iana",
	    "extensions": ["spot"]
	  },
	  "text/vnd.iptc.newsml": {
	    "source": "iana"
	  },
	  "text/vnd.iptc.nitf": {
	    "source": "iana"
	  },
	  "text/vnd.latex-z": {
	    "source": "iana"
	  },
	  "text/vnd.motorola.reflex": {
	    "source": "iana"
	  },
	  "text/vnd.ms-mediapackage": {
	    "source": "iana"
	  },
	  "text/vnd.net2phone.commcenter.command": {
	    "source": "iana"
	  },
	  "text/vnd.radisys.msml-basic-layout": {
	    "source": "iana"
	  },
	  "text/vnd.si.uricatalogue": {
	    "source": "iana"
	  },
	  "text/vnd.sun.j2me.app-descriptor": {
	    "source": "iana",
	    "extensions": ["jad"]
	  },
	  "text/vnd.trolltech.linguist": {
	    "source": "iana"
	  },
	  "text/vnd.wap.si": {
	    "source": "iana"
	  },
	  "text/vnd.wap.sl": {
	    "source": "iana"
	  },
	  "text/vnd.wap.wml": {
	    "source": "iana",
	    "extensions": ["wml"]
	  },
	  "text/vnd.wap.wmlscript": {
	    "source": "iana",
	    "extensions": ["wmls"]
	  },
	  "text/vtt": {
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["vtt"]
	  },
	  "text/x-asm": {
	    "source": "apache",
	    "extensions": ["s","asm"]
	  },
	  "text/x-c": {
	    "source": "apache",
	    "extensions": ["c","cc","cxx","cpp","h","hh","dic"]
	  },
	  "text/x-component": {
	    "source": "nginx",
	    "extensions": ["htc"]
	  },
	  "text/x-fortran": {
	    "source": "apache",
	    "extensions": ["f","for","f77","f90"]
	  },
	  "text/x-gwt-rpc": {
	    "compressible": true
	  },
	  "text/x-handlebars-template": {
	    "extensions": ["hbs"]
	  },
	  "text/x-java-source": {
	    "source": "apache",
	    "extensions": ["java"]
	  },
	  "text/x-jquery-tmpl": {
	    "compressible": true
	  },
	  "text/x-lua": {
	    "extensions": ["lua"]
	  },
	  "text/x-markdown": {
	    "compressible": true,
	    "extensions": ["markdown","md","mkd"]
	  },
	  "text/x-nfo": {
	    "source": "apache",
	    "extensions": ["nfo"]
	  },
	  "text/x-opml": {
	    "source": "apache",
	    "extensions": ["opml"]
	  },
	  "text/x-pascal": {
	    "source": "apache",
	    "extensions": ["p","pas"]
	  },
	  "text/x-processing": {
	    "compressible": true,
	    "extensions": ["pde"]
	  },
	  "text/x-sass": {
	    "extensions": ["sass"]
	  },
	  "text/x-scss": {
	    "extensions": ["scss"]
	  },
	  "text/x-setext": {
	    "source": "apache",
	    "extensions": ["etx"]
	  },
	  "text/x-sfv": {
	    "source": "apache",
	    "extensions": ["sfv"]
	  },
	  "text/x-suse-ymp": {
	    "compressible": true,
	    "extensions": ["ymp"]
	  },
	  "text/x-uuencode": {
	    "source": "apache",
	    "extensions": ["uu"]
	  },
	  "text/x-vcalendar": {
	    "source": "apache",
	    "extensions": ["vcs"]
	  },
	  "text/x-vcard": {
	    "source": "apache",
	    "extensions": ["vcf"]
	  },
	  "text/xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xml"]
	  },
	  "text/xml-external-parsed-entity": {
	    "source": "iana"
	  },
	  "text/yaml": {
	    "extensions": ["yaml","yml"]
	  },
	  "video/1d-interleaved-parityfec": {
	    "source": "apache"
	  },
	  "video/3gpp": {
	    "source": "apache",
	    "extensions": ["3gp","3gpp"]
	  },
	  "video/3gpp-tt": {
	    "source": "apache"
	  },
	  "video/3gpp2": {
	    "source": "apache",
	    "extensions": ["3g2"]
	  },
	  "video/bmpeg": {
	    "source": "apache"
	  },
	  "video/bt656": {
	    "source": "apache"
	  },
	  "video/celb": {
	    "source": "apache"
	  },
	  "video/dv": {
	    "source": "apache"
	  },
	  "video/h261": {
	    "source": "apache",
	    "extensions": ["h261"]
	  },
	  "video/h263": {
	    "source": "apache",
	    "extensions": ["h263"]
	  },
	  "video/h263-1998": {
	    "source": "apache"
	  },
	  "video/h263-2000": {
	    "source": "apache"
	  },
	  "video/h264": {
	    "source": "apache",
	    "extensions": ["h264"]
	  },
	  "video/h264-rcdo": {
	    "source": "apache"
	  },
	  "video/h264-svc": {
	    "source": "apache"
	  },
	  "video/jpeg": {
	    "source": "apache",
	    "extensions": ["jpgv"]
	  },
	  "video/jpeg2000": {
	    "source": "apache"
	  },
	  "video/jpm": {
	    "source": "apache",
	    "extensions": ["jpm","jpgm"]
	  },
	  "video/mj2": {
	    "source": "apache",
	    "extensions": ["mj2","mjp2"]
	  },
	  "video/mp1s": {
	    "source": "apache"
	  },
	  "video/mp2p": {
	    "source": "apache"
	  },
	  "video/mp2t": {
	    "source": "apache",
	    "extensions": ["ts"]
	  },
	  "video/mp4": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["mp4","mp4v","mpg4"]
	  },
	  "video/mp4v-es": {
	    "source": "apache"
	  },
	  "video/mpeg": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["mpeg","mpg","mpe","m1v","m2v"]
	  },
	  "video/mpeg4-generic": {
	    "source": "apache"
	  },
	  "video/mpv": {
	    "source": "apache"
	  },
	  "video/nv": {
	    "source": "apache"
	  },
	  "video/ogg": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["ogv"]
	  },
	  "video/parityfec": {
	    "source": "apache"
	  },
	  "video/pointer": {
	    "source": "apache"
	  },
	  "video/quicktime": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["qt","mov"]
	  },
	  "video/raw": {
	    "source": "apache"
	  },
	  "video/rtp-enc-aescm128": {
	    "source": "apache"
	  },
	  "video/rtx": {
	    "source": "apache"
	  },
	  "video/smpte292m": {
	    "source": "apache"
	  },
	  "video/ulpfec": {
	    "source": "apache"
	  },
	  "video/vc1": {
	    "source": "apache"
	  },
	  "video/vnd.cctv": {
	    "source": "apache"
	  },
	  "video/vnd.dece.hd": {
	    "source": "apache",
	    "extensions": ["uvh","uvvh"]
	  },
	  "video/vnd.dece.mobile": {
	    "source": "apache",
	    "extensions": ["uvm","uvvm"]
	  },
	  "video/vnd.dece.mp4": {
	    "source": "apache"
	  },
	  "video/vnd.dece.pd": {
	    "source": "apache",
	    "extensions": ["uvp","uvvp"]
	  },
	  "video/vnd.dece.sd": {
	    "source": "apache",
	    "extensions": ["uvs","uvvs"]
	  },
	  "video/vnd.dece.video": {
	    "source": "apache",
	    "extensions": ["uvv","uvvv"]
	  },
	  "video/vnd.directv.mpeg": {
	    "source": "apache"
	  },
	  "video/vnd.directv.mpeg-tts": {
	    "source": "apache"
	  },
	  "video/vnd.dlna.mpeg-tts": {
	    "source": "apache"
	  },
	  "video/vnd.dvb.file": {
	    "source": "apache",
	    "extensions": ["dvb"]
	  },
	  "video/vnd.fvt": {
	    "source": "apache",
	    "extensions": ["fvt"]
	  },
	  "video/vnd.hns.video": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.1dparityfec-1010": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.1dparityfec-2005": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.2dparityfec-1010": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.2dparityfec-2005": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.ttsavc": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.ttsmpeg2": {
	    "source": "apache"
	  },
	  "video/vnd.motorola.video": {
	    "source": "apache"
	  },
	  "video/vnd.motorola.videop": {
	    "source": "apache"
	  },
	  "video/vnd.mpegurl": {
	    "source": "apache",
	    "extensions": ["mxu","m4u"]
	  },
	  "video/vnd.ms-playready.media.pyv": {
	    "source": "apache",
	    "extensions": ["pyv"]
	  },
	  "video/vnd.nokia.interleaved-multimedia": {
	    "source": "apache"
	  },
	  "video/vnd.nokia.videovoip": {
	    "source": "apache"
	  },
	  "video/vnd.objectvideo": {
	    "source": "apache"
	  },
	  "video/vnd.sealed.mpeg1": {
	    "source": "apache"
	  },
	  "video/vnd.sealed.mpeg4": {
	    "source": "apache"
	  },
	  "video/vnd.sealed.swf": {
	    "source": "apache"
	  },
	  "video/vnd.sealedmedia.softseal.mov": {
	    "source": "apache"
	  },
	  "video/vnd.uvvu.mp4": {
	    "source": "apache",
	    "extensions": ["uvu","uvvu"]
	  },
	  "video/vnd.vivo": {
	    "source": "apache",
	    "extensions": ["viv"]
	  },
	  "video/webm": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["webm"]
	  },
	  "video/x-f4v": {
	    "source": "apache",
	    "extensions": ["f4v"]
	  },
	  "video/x-fli": {
	    "source": "apache",
	    "extensions": ["fli"]
	  },
	  "video/x-flv": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["flv"]
	  },
	  "video/x-m4v": {
	    "source": "apache",
	    "extensions": ["m4v"]
	  },
	  "video/x-matroska": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["mkv","mk3d","mks"]
	  },
	  "video/x-mng": {
	    "source": "apache",
	    "extensions": ["mng"]
	  },
	  "video/x-ms-asf": {
	    "source": "apache",
	    "extensions": ["asf","asx"]
	  },
	  "video/x-ms-vob": {
	    "source": "apache",
	    "extensions": ["vob"]
	  },
	  "video/x-ms-wm": {
	    "source": "apache",
	    "extensions": ["wm"]
	  },
	  "video/x-ms-wmv": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["wmv"]
	  },
	  "video/x-ms-wmx": {
	    "source": "apache",
	    "extensions": ["wmx"]
	  },
	  "video/x-ms-wvx": {
	    "source": "apache",
	    "extensions": ["wvx"]
	  },
	  "video/x-msvideo": {
	    "source": "apache",
	    "extensions": ["avi"]
	  },
	  "video/x-sgi-movie": {
	    "source": "apache",
	    "extensions": ["movie"]
	  },
	  "video/x-smv": {
	    "source": "apache",
	    "extensions": ["smv"]
	  },
	  "x-conference/x-cooltalk": {
	    "source": "apache",
	    "extensions": ["ice"]
	  },
	  "x-shader/x-fragment": {
	    "compressible": true
	  },
	  "x-shader/x-vertex": {
	    "compressible": true
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ants",
	  "bats",
	  "bears",
	  "bees",
	  "birds",
	  "buffalo",
	  "cats",
	  "chickens",
	  "cattle",
	  "dogs",
	  "dolphins",
	  "ducks",
	  "elephants",
	  "fishes",
	  "foxes",
	  "frogs",
	  "geese",
	  "goats",
	  "horses",
	  "kangaroos",
	  "lions",
	  "monkeys",
	  "owls",
	  "oxen",
	  "penguins",
	  "people",
	  "pigs",
	  "rabbits",
	  "sheep",
	  "tigers",
	  "whales",
	  "wolves",
	  "zebras",
	  "banshees",
	  "crows",
	  "black cats",
	  "chimeras",
	  "ghosts",
	  "conspirators",
	  "dragons",
	  "dwarves",
	  "elves",
	  "enchanters",
	  "exorcists",
	  "sons",
	  "foes",
	  "giants",
	  "gnomes",
	  "goblins",
	  "gooses",
	  "griffins",
	  "lycanthropes",
	  "nemesis",
	  "ogres",
	  "oracles",
	  "prophets",
	  "sorcerors",
	  "spiders",
	  "spirits",
	  "vampires",
	  "warlocks",
	  "vixens",
	  "werewolves",
	  "witches",
	  "worshipers",
	  "zombies",
	  "druids"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var team = {};
	module['exports'] = team;
	team.creature = __webpack_require__(926);
	team.name = __webpack_require__(928);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.state} #{creature}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Australia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.state_abbr = __webpack_require__(934);
	address.state = __webpack_require__(933);
	address.postcode = __webpack_require__(932);
	address.building_number = __webpack_require__(929);
	address.street_suffix = __webpack_require__(935);
	address.default_country = __webpack_require__(930);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0###",
	  "2###",
	  "3###",
	  "4###",
	  "5###",
	  "6###",
	  "7###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "New South Wales",
	  "Queensland",
	  "Northern Territory",
	  "South Australia",
	  "Western Australia",
	  "Tasmania",
	  "Australian Capital Territory",
	  "Victoria"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "NSW",
	  "QLD",
	  "NT",
	  "SA",
	  "WA",
	  "TAS",
	  "ACT",
	  "VIC"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avenue",
	  "Boulevard",
	  "Circle",
	  "Circuit",
	  "Court",
	  "Crescent",
	  "Crest",
	  "Drive",
	  "Estate Dr",
	  "Grove",
	  "Hill",
	  "Island",
	  "Junction",
	  "Knoll",
	  "Lane",
	  "Loop",
	  "Mall",
	  "Manor",
	  "Meadow",
	  "Mews",
	  "Parade",
	  "Parkway",
	  "Pass",
	  "Place",
	  "Plaza",
	  "Ridge",
	  "Road",
	  "Run",
	  "Square",
	  "Station St",
	  "Street",
	  "Summit",
	  "Terrace",
	  "Track",
	  "Trail",
	  "View Rd",
	  "Way"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(937);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pty Ltd",
	  "and Sons",
	  "Corp",
	  "Group",
	  "Brothers",
	  "Partners"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_AU = {};
	module['exports'] = en_AU;
	en_AU.title = "Australia (English)";
	en_AU.name = __webpack_require__(942);
	en_AU.company = __webpack_require__(936);
	en_AU.internet = __webpack_require__(940);
	en_AU.address = __webpack_require__(931);
	en_AU.phone_number = __webpack_require__(945);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com.au",
	  "com",
	  "net.au",
	  "net",
	  "org.au",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(939);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "William",
	  "Jack",
	  "Oliver",
	  "Joshua",
	  "Thomas",
	  "Lachlan",
	  "Cooper",
	  "Noah",
	  "Ethan",
	  "Lucas",
	  "James",
	  "Samuel",
	  "Jacob",
	  "Liam",
	  "Alexander",
	  "Benjamin",
	  "Max",
	  "Isaac",
	  "Daniel",
	  "Riley",
	  "Ryan",
	  "Charlie",
	  "Tyler",
	  "Jake",
	  "Matthew",
	  "Xavier",
	  "Harry",
	  "Jayden",
	  "Nicholas",
	  "Harrison",
	  "Levi",
	  "Luke",
	  "Adam",
	  "Henry",
	  "Aiden",
	  "Dylan",
	  "Oscar",
	  "Michael",
	  "Jackson",
	  "Logan",
	  "Joseph",
	  "Blake",
	  "Nathan",
	  "Connor",
	  "Elijah",
	  "Nate",
	  "Archie",
	  "Bailey",
	  "Marcus",
	  "Cameron",
	  "Jordan",
	  "Zachary",
	  "Caleb",
	  "Hunter",
	  "Ashton",
	  "Toby",
	  "Aidan",
	  "Hayden",
	  "Mason",
	  "Hamish",
	  "Edward",
	  "Angus",
	  "Eli",
	  "Sebastian",
	  "Christian",
	  "Patrick",
	  "Andrew",
	  "Anthony",
	  "Luca",
	  "Kai",
	  "Beau",
	  "Alex",
	  "George",
	  "Callum",
	  "Finn",
	  "Zac",
	  "Mitchell",
	  "Jett",
	  "Jesse",
	  "Gabriel",
	  "Leo",
	  "Declan",
	  "Charles",
	  "Jasper",
	  "Jonathan",
	  "Aaron",
	  "Hugo",
	  "David",
	  "Christopher",
	  "Chase",
	  "Owen",
	  "Justin",
	  "Ali",
	  "Darcy",
	  "Lincoln",
	  "Cody",
	  "Phoenix",
	  "Sam",
	  "John",
	  "Joel",
	  "Isabella",
	  "Ruby",
	  "Chloe",
	  "Olivia",
	  "Charlotte",
	  "Mia",
	  "Lily",
	  "Emily",
	  "Ella",
	  "Sienna",
	  "Sophie",
	  "Amelia",
	  "Grace",
	  "Ava",
	  "Zoe",
	  "Emma",
	  "Sophia",
	  "Matilda",
	  "Hannah",
	  "Jessica",
	  "Lucy",
	  "Georgia",
	  "Sarah",
	  "Abigail",
	  "Zara",
	  "Eva",
	  "Scarlett",
	  "Jasmine",
	  "Chelsea",
	  "Lilly",
	  "Ivy",
	  "Isla",
	  "Evie",
	  "Isabelle",
	  "Maddison",
	  "Layla",
	  "Summer",
	  "Annabelle",
	  "Alexis",
	  "Elizabeth",
	  "Bella",
	  "Holly",
	  "Lara",
	  "Madison",
	  "Alyssa",
	  "Maya",
	  "Tahlia",
	  "Claire",
	  "Hayley",
	  "Imogen",
	  "Jade",
	  "Ellie",
	  "Sofia",
	  "Addison",
	  "Molly",
	  "Phoebe",
	  "Alice",
	  "Savannah",
	  "Gabriella",
	  "Kayla",
	  "Mikayla",
	  "Abbey",
	  "Eliza",
	  "Willow",
	  "Alexandra",
	  "Poppy",
	  "Samantha",
	  "Stella",
	  "Amy",
	  "Amelie",
	  "Anna",
	  "Piper",
	  "Gemma",
	  "Isabel",
	  "Victoria",
	  "Stephanie",
	  "Caitlin",
	  "Heidi",
	  "Paige",
	  "Rose",
	  "Amber",
	  "Audrey",
	  "Claudia",
	  "Taylor",
	  "Madeline",
	  "Angelina",
	  "Natalie",
	  "Charli",
	  "Lauren",
	  "Ashley",
	  "Violet",
	  "Mackenzie",
	  "Abby",
	  "Skye",
	  "Lillian",
	  "Alana",
	  "Lola",
	  "Leah",
	  "Eve",
	  "Kiara"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(941);
	name.last_name = __webpack_require__(943);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Smith",
	  "Jones",
	  "Williams",
	  "Brown",
	  "Wilson",
	  "Taylor",
	  "Johnson",
	  "White",
	  "Martin",
	  "Anderson",
	  "Thompson",
	  "Nguyen",
	  "Thomas",
	  "Walker",
	  "Harris",
	  "Lee",
	  "Ryan",
	  "Robinson",
	  "Kelly",
	  "King",
	  "Davis",
	  "Wright",
	  "Evans",
	  "Roberts",
	  "Green",
	  "Hall",
	  "Wood",
	  "Jackson",
	  "Clarke",
	  "Patel",
	  "Khan",
	  "Lewis",
	  "James",
	  "Phillips",
	  "Mason",
	  "Mitchell",
	  "Rose",
	  "Davies",
	  "Rodriguez",
	  "Cox",
	  "Alexander",
	  "Garden",
	  "Campbell",
	  "Johnston",
	  "Moore",
	  "Smyth",
	  "O'neill",
	  "Doherty",
	  "Stewart",
	  "Quinn",
	  "Murphy",
	  "Graham",
	  "Mclaughlin",
	  "Hamilton",
	  "Murray",
	  "Hughes",
	  "Robertson",
	  "Thomson",
	  "Scott",
	  "Macdonald",
	  "Reid",
	  "Clark",
	  "Ross",
	  "Young",
	  "Watson",
	  "Paterson",
	  "Morrison",
	  "Morgan",
	  "Griffiths",
	  "Edwards",
	  "Rees",
	  "Jenkins",
	  "Owen",
	  "Price",
	  "Moss",
	  "Richards",
	  "Abbott",
	  "Adams",
	  "Armstrong",
	  "Bahringer",
	  "Bailey",
	  "Barrows",
	  "Bartell",
	  "Bartoletti",
	  "Barton",
	  "Bauch",
	  "Baumbach",
	  "Bayer",
	  "Beahan",
	  "Beatty",
	  "Becker",
	  "Beier",
	  "Berge",
	  "Bergstrom",
	  "Bode",
	  "Bogan",
	  "Borer",
	  "Bosco",
	  "Botsford",
	  "Boyer",
	  "Boyle",
	  "Braun",
	  "Bruen",
	  "Carroll",
	  "Carter",
	  "Cartwright",
	  "Casper",
	  "Cassin",
	  "Champlin",
	  "Christiansen",
	  "Cole",
	  "Collier",
	  "Collins",
	  "Connelly",
	  "Conroy",
	  "Corkery",
	  "Cormier",
	  "Corwin",
	  "Cronin",
	  "Crooks",
	  "Cruickshank",
	  "Cummings",
	  "D'amore",
	  "Daniel",
	  "Dare",
	  "Daugherty",
	  "Dickens",
	  "Dickinson",
	  "Dietrich",
	  "Donnelly",
	  "Dooley",
	  "Douglas",
	  "Doyle",
	  "Durgan",
	  "Ebert",
	  "Emard",
	  "Emmerich",
	  "Erdman",
	  "Ernser",
	  "Fadel",
	  "Fahey",
	  "Farrell",
	  "Fay",
	  "Feeney",
	  "Feil",
	  "Ferry",
	  "Fisher",
	  "Flatley",
	  "Gibson",
	  "Gleason",
	  "Glover",
	  "Goldner",
	  "Goodwin",
	  "Grady",
	  "Grant",
	  "Greenfelder",
	  "Greenholt",
	  "Grimes",
	  "Gutmann",
	  "Hackett",
	  "Hahn",
	  "Haley",
	  "Hammes",
	  "Hand",
	  "Hane",
	  "Hansen",
	  "Harber",
	  "Hartmann",
	  "Harvey",
	  "Hayes",
	  "Heaney",
	  "Heathcote",
	  "Heller",
	  "Hermann",
	  "Hermiston",
	  "Hessel",
	  "Hettinger",
	  "Hickle",
	  "Hill",
	  "Hills",
	  "Hoppe",
	  "Howe",
	  "Howell",
	  "Hudson",
	  "Huel",
	  "Hyatt",
	  "Jacobi",
	  "Jacobs",
	  "Jacobson",
	  "Jerde",
	  "Johns",
	  "Keeling",
	  "Kemmer",
	  "Kessler",
	  "Kiehn",
	  "Kirlin",
	  "Klein",
	  "Koch",
	  "Koelpin",
	  "Kohler",
	  "Koss",
	  "Kovacek",
	  "Kreiger",
	  "Kris",
	  "Kuhlman",
	  "Kuhn",
	  "Kulas",
	  "Kunde",
	  "Kutch",
	  "Lakin",
	  "Lang",
	  "Langworth",
	  "Larkin",
	  "Larson",
	  "Leannon",
	  "Leffler",
	  "Little",
	  "Lockman",
	  "Lowe",
	  "Lynch",
	  "Mann",
	  "Marks",
	  "Marvin",
	  "Mayer",
	  "Mccullough",
	  "Mcdermott",
	  "Mckenzie",
	  "Miller",
	  "Mills",
	  "Monahan",
	  "Morissette",
	  "Mueller",
	  "Muller",
	  "Nader",
	  "Nicolas",
	  "Nolan",
	  "O'connell",
	  "O'conner",
	  "O'hara",
	  "O'keefe",
	  "Olson",
	  "O'reilly",
	  "Parisian",
	  "Parker",
	  "Quigley",
	  "Reilly",
	  "Reynolds",
	  "Rice",
	  "Ritchie",
	  "Rohan",
	  "Rolfson",
	  "Rowe",
	  "Russel",
	  "Rutherford",
	  "Sanford",
	  "Sauer",
	  "Schmidt",
	  "Schmitt",
	  "Schneider",
	  "Schroeder",
	  "Schultz",
	  "Shields",
	  "Smitham",
	  "Spencer",
	  "Stanton",
	  "Stark",
	  "Stokes",
	  "Swift",
	  "Tillman",
	  "Towne",
	  "Tremblay",
	  "Tromp",
	  "Turcotte",
	  "Turner",
	  "Walsh",
	  "Walter",
	  "Ward",
	  "Waters",
	  "Weber",
	  "Welch",
	  "West",
	  "Wilderman",
	  "Wilkinson",
	  "Williamson",
	  "Windler",
	  "Wolf"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0# #### ####",
	  "+61 # #### ####",
	  "04## ### ###",
	  "+61 4## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(944);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_BORK = {};
	module['exports'] = en_BORK;
	en_BORK.title = "Bork (English)";
	en_BORK.lorem = __webpack_require__(947);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(948);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Boot",
	  "I",
	  "Nu",
	  "Nur",
	  "Tu",
	  "Um",
	  "a",
	  "becoose-a",
	  "boot",
	  "bork",
	  "burn",
	  "chuuses",
	  "cumplete-a",
	  "cun",
	  "cunseqooences",
	  "curcoomstunces",
	  "dee",
	  "deeslikes",
	  "denuoonceeng",
	  "desures",
	  "du",
	  "eccuoont",
	  "ectooel",
	  "edfuntege-a",
	  "efueeds",
	  "egeeen",
	  "ell",
	  "ere-a",
	  "feend",
	  "foolt",
	  "frum",
	  "geefe-a",
	  "gesh",
	  "greet",
	  "heem",
	  "heppeeness",
	  "hes",
	  "hoo",
	  "hoomun",
	  "idea",
	  "ifer",
	  "in",
	  "incuoonter",
	  "injuy",
	  "itselff",
	  "ixcept",
	  "ixemple-a",
	  "ixerceese-a",
	  "ixpleeen",
	  "ixplurer",
	  "ixpuoond",
	  "ixtremely",
	  "knoo",
	  "lebureeuoos",
	  "lufes",
	  "meestekee",
	  "mester-booeelder",
	  "moost",
	  "mun",
	  "nu",
	  "nut",
	  "oobteeen",
	  "oocceseeunelly",
	  "ooccoor",
	  "ooff",
	  "oone-a",
	  "oor",
	  "peeen",
	  "peeenffool",
	  "physeecel",
	  "pleesoore-a",
	  "poorsooe-a",
	  "poorsooes",
	  "preeesing",
	  "prucoore-a",
	  "prudooces",
	  "reeght",
	  "reshunelly",
	  "resooltunt",
	  "sume-a",
	  "teecheengs",
	  "teke-a",
	  "thees",
	  "thet",
	  "thuse-a",
	  "treefiel",
	  "troot",
	  "tu",
	  "tueel",
	  "und",
	  "undertekes",
	  "unnuyeeng",
	  "uny",
	  "unyune-a",
	  "us",
	  "veell",
	  "veet",
	  "ves",
	  "vheech",
	  "vhu",
	  "yuoo",
	  "zee",
	  "zeere-a"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Canada"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.state = __webpack_require__(952);
	address.state_abbr = __webpack_require__(953);
	address.default_country = __webpack_require__(949);
	address.postcode = __webpack_require__(951);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "?#? #?#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alberta",
	  "British Columbia",
	  "Manitoba",
	  "New Brunswick",
	  "Newfoundland and Labrador",
	  "Nova Scotia",
	  "Northwest Territories",
	  "Nunavut",
	  "Ontario",
	  "Prince Edward Island",
	  "Quebec",
	  "Saskatchewan",
	  "Yukon"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AB",
	  "BC",
	  "MB",
	  "NB",
	  "NL",
	  "NS",
	  "NU",
	  "NT",
	  "ON",
	  "PE",
	  "QC",
	  "SK",
	  "YT"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_CA = {};
	module['exports'] = en_CA;
	en_CA.title = "Canada (English)";
	en_CA.address = __webpack_require__(950);
	en_CA.internet = __webpack_require__(957);
	en_CA.phone_number = __webpack_require__(959);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ca",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.ca",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(956);
	internet.domain_suffix = __webpack_require__(955);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###-####",
	  "(###)###-####",
	  "###.###.####",
	  "1-###-###-####",
	  "###-###-#### x###",
	  "(###)###-#### x###",
	  "1-###-###-#### x###",
	  "###.###.#### x###",
	  "###-###-#### x####",
	  "(###)###-#### x####",
	  "1-###-###-#### x####",
	  "###.###.#### x####",
	  "###-###-#### x#####",
	  "(###)###-#### x#####",
	  "1-###-###-#### x#####",
	  "###.###.#### x#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(958);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avon",
	  "Bedfordshire",
	  "Berkshire",
	  "Borders",
	  "Buckinghamshire",
	  "Cambridgeshire",
	  "Central",
	  "Cheshire",
	  "Cleveland",
	  "Clwyd",
	  "Cornwall",
	  "County Antrim",
	  "County Armagh",
	  "County Down",
	  "County Fermanagh",
	  "County Londonderry",
	  "County Tyrone",
	  "Cumbria",
	  "Derbyshire",
	  "Devon",
	  "Dorset",
	  "Dumfries and Galloway",
	  "Durham",
	  "Dyfed",
	  "East Sussex",
	  "Essex",
	  "Fife",
	  "Gloucestershire",
	  "Grampian",
	  "Greater Manchester",
	  "Gwent",
	  "Gwynedd County",
	  "Hampshire",
	  "Herefordshire",
	  "Hertfordshire",
	  "Highlands and Islands",
	  "Humberside",
	  "Isle of Wight",
	  "Kent",
	  "Lancashire",
	  "Leicestershire",
	  "Lincolnshire",
	  "Lothian",
	  "Merseyside",
	  "Mid Glamorgan",
	  "Norfolk",
	  "North Yorkshire",
	  "Northamptonshire",
	  "Northumberland",
	  "Nottinghamshire",
	  "Oxfordshire",
	  "Powys",
	  "Rutland",
	  "Shropshire",
	  "Somerset",
	  "South Glamorgan",
	  "South Yorkshire",
	  "Staffordshire",
	  "Strathclyde",
	  "Suffolk",
	  "Surrey",
	  "Tayside",
	  "Tyne and Wear",
	  "Warwickshire",
	  "West Glamorgan",
	  "West Midlands",
	  "West Sussex",
	  "West Yorkshire",
	  "Wiltshire",
	  "Worcestershire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "England",
	  "Scotland",
	  "Wales",
	  "Northern Ireland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.county = __webpack_require__(960);
	address.uk_country = __webpack_require__(964);
	address.default_country = __webpack_require__(961);
	address.postcode = __webpack_require__(963);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "??# #??",
	  "??## #??",
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "England",
	  "Scotland",
	  "Wales",
	  "Northern Ireland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "074## ######",
	  "075## ######",
	  "076## ######",
	  "077## ######",
	  "078## ######",
	  "079## ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(965);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_GB = {};
	module['exports'] = en_GB;
	en_GB.title = "Great Britain (English)";
	en_GB.address = __webpack_require__(962);
	en_GB.internet = __webpack_require__(969);
	en_GB.phone_number = __webpack_require__(971);
	en_GB.cell_phone = __webpack_require__(966);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "co.uk",
	  "com",
	  "biz",
	  "info",
	  "name"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(968);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01#### #####",
	  "01### ######",
	  "01#1 ### ####",
	  "011# ### ####",
	  "02# #### ####",
	  "03## ### ####",
	  "055 #### ####",
	  "056 #### ####",
	  "0800 ### ####",
	  "08## ### ####",
	  "09## ### ####",
	  "016977 ####",
	  "01### #####",
	  "0500 ######",
	  "0800 ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(970);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Carlow",
	  "Cavan",
	  "Clare",
	  "Cork",
	  "Donegal",
	  "Dublin",
	  "Galway",
	  "Kerry",
	  "Kildare",
	  "Kilkenny",
	  "Laois",
	  "Leitrim",
	  "Limerick",
	  "Longford",
	  "Louth",
	  "Mayo",
	  "Meath",
	  "Monaghan",
	  "Offaly",
	  "Roscommon",
	  "Sligo",
	  "Tipperary",
	  "Waterford",
	  "Westmeath",
	  "Wexford",
	  "Wicklow"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ireland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.county = __webpack_require__(972);
	address.default_country = __webpack_require__(973);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "082 ### ####",
	  "083 ### ####",
	  "085 ### ####",
	  "086 ### ####",
	  "087 ### ####",
	  "089 ### ####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(975);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_IE = {};
	module['exports'] = en_IE;
	en_IE.title = "Ireland (English)";
	en_IE.address = __webpack_require__(974);
	en_IE.internet = __webpack_require__(979);
	en_IE.phone_number = __webpack_require__(981);
	en_IE.cell_phone = __webpack_require__(976);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ie",
	  "com",
	  "net",
	  "info",
	  "eu"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(978);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01 #######",
	  "021 #######",
	  "022 #######",
	  "023 #######",
	  "024 #######",
	  "025 #######",
	  "026 #######",
	  "027 #######",
	  "028 #######",
	  "029 #######",
	  "0402 #######",
	  "0404 #######",
	  "041 #######",
	  "042 #######",
	  "043 #######",
	  "044 #######",
	  "045 #######",
	  "046 #######",
	  "047 #######",
	  "049 #######",
	  "0504 #######",
	  "0505 #######",
	  "051 #######",
	  "052 #######",
	  "053 #######",
	  "056 #######",
	  "057 #######",
	  "058 #######",
	  "059 #######",
	  "061 #######",
	  "062 #######",
	  "063 #######",
	  "064 #######",
	  "065 #######",
	  "066 #######",
	  "067 #######",
	  "068 #######",
	  "069 #######",
	  "071 #######",
	  "074 #######",
	  "090 #######",
	  "091 #######",
	  "093 #######",
	  "094 #######",
	  "095 #######",
	  "096 #######",
	  "097 #######",
	  "098 #######",
	  "099 #######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(980);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "India",
	  "Indian Republic",
	  "Bharat",
	  "Hindustan"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(984);
	address.state = __webpack_require__(985);
	address.state_abbr = __webpack_require__(986);
	address.default_country = __webpack_require__(982);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "?#? #?#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Andra Pradesh",
	  "Arunachal Pradesh",
	  "Assam",
	  "Bihar",
	  "Chhattisgarh",
	  "Goa",
	  "Gujarat",
	  "Haryana",
	  "Himachal Pradesh",
	  "Jammu and Kashmir",
	  "Jharkhand",
	  "Karnataka",
	  "Kerala",
	  "Madya Pradesh",
	  "Maharashtra",
	  "Manipur",
	  "Meghalaya",
	  "Mizoram",
	  "Nagaland",
	  "Orissa",
	  "Punjab",
	  "Rajasthan",
	  "Sikkim",
	  "Tamil Nadu",
	  "Tripura",
	  "Uttaranchal",
	  "Uttar Pradesh",
	  "West Bengal",
	  "Andaman and Nicobar Islands",
	  "Chandigarh",
	  "Dadar and Nagar Haveli",
	  "Daman and Diu",
	  "Delhi",
	  "Lakshadweep",
	  "Pondicherry"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AP",
	  "AR",
	  "AS",
	  "BR",
	  "CG",
	  "DL",
	  "GA",
	  "GJ",
	  "HR",
	  "HP",
	  "JK",
	  "JS",
	  "KA",
	  "KL",
	  "MP",
	  "MH",
	  "MN",
	  "ML",
	  "MZ",
	  "NL",
	  "OR",
	  "PB",
	  "RJ",
	  "SK",
	  "TN",
	  "TR",
	  "UK",
	  "UP",
	  "WB",
	  "AN",
	  "CH",
	  "DN",
	  "DD",
	  "LD",
	  "PY"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(988);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pvt Ltd",
	  "Limited",
	  "Ltd",
	  "and Sons",
	  "Corp",
	  "Group",
	  "Brothers"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_IND = {};
	module['exports'] = en_IND;
	en_IND.title = "India (English)";
	en_IND.name = __webpack_require__(994);
	en_IND.address = __webpack_require__(983);
	en_IND.internet = __webpack_require__(992);
	en_IND.company = __webpack_require__(987);
	en_IND.phone_number = __webpack_require__(997);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "in",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org",
	  "co.in"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.co.in",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(991);
	internet.domain_suffix = __webpack_require__(990);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aadrika",
	  "Aanandinii",
	  "Aaratrika",
	  "Aarya",
	  "Arya",
	  "Aashritha",
	  "Aatmaja",
	  "Atmaja",
	  "Abhaya",
	  "Adwitiya",
	  "Agrata",
	  "Ahilya",
	  "Ahalya",
	  "Aishani",
	  "Akshainie",
	  "Akshata",
	  "Akshita",
	  "Akula",
	  "Ambar",
	  "Amodini",
	  "Amrita",
	  "Amritambu",
	  "Anala",
	  "Anamika",
	  "Ananda",
	  "Anandamayi",
	  "Ananta",
	  "Anila",
	  "Anjali",
	  "Anjushri",
	  "Anjushree",
	  "Annapurna",
	  "Anshula",
	  "Anuja",
	  "Anusuya",
	  "Anasuya",
	  "Anasooya",
	  "Anwesha",
	  "Apsara",
	  "Aruna",
	  "Asha",
	  "Aasa",
	  "Aasha",
	  "Aslesha",
	  "Atreyi",
	  "Atreyee",
	  "Avani",
	  "Abani",
	  "Avantika",
	  "Ayushmati",
	  "Baidehi",
	  "Vaidehi",
	  "Bala",
	  "Baala",
	  "Balamani",
	  "Basanti",
	  "Vasanti",
	  "Bela",
	  "Bhadra",
	  "Bhagirathi",
	  "Bhagwanti",
	  "Bhagwati",
	  "Bhamini",
	  "Bhanumati",
	  "Bhaanumati",
	  "Bhargavi",
	  "Bhavani",
	  "Bhilangana",
	  "Bilwa",
	  "Bilva",
	  "Buddhana",
	  "Chakrika",
	  "Chanda",
	  "Chandi",
	  "Chandni",
	  "Chandini",
	  "Chandani",
	  "Chandra",
	  "Chandira",
	  "Chandrabhaga",
	  "Chandrakala",
	  "Chandrakin",
	  "Chandramani",
	  "Chandrani",
	  "Chandraprabha",
	  "Chandraswaroopa",
	  "Chandravati",
	  "Chapala",
	  "Charumati",
	  "Charvi",
	  "Chatura",
	  "Chitrali",
	  "Chitramala",
	  "Chitrangada",
	  "Daksha",
	  "Dakshayani",
	  "Damayanti",
	  "Darshwana",
	  "Deepali",
	  "Dipali",
	  "Deeptimoyee",
	  "Deeptimayee",
	  "Devangana",
	  "Devani",
	  "Devasree",
	  "Devi",
	  "Daevi",
	  "Devika",
	  "Daevika",
	  "Dhaanyalakshmi",
	  "Dhanalakshmi",
	  "Dhana",
	  "Dhanadeepa",
	  "Dhara",
	  "Dharani",
	  "Dharitri",
	  "Dhatri",
	  "Diksha",
	  "Deeksha",
	  "Divya",
	  "Draupadi",
	  "Dulari",
	  "Durga",
	  "Durgeshwari",
	  "Ekaparnika",
	  "Elakshi",
	  "Enakshi",
	  "Esha",
	  "Eshana",
	  "Eshita",
	  "Gautami",
	  "Gayatri",
	  "Geeta",
	  "Geetanjali",
	  "Gitanjali",
	  "Gemine",
	  "Gemini",
	  "Girja",
	  "Girija",
	  "Gita",
	  "Hamsini",
	  "Harinakshi",
	  "Harita",
	  "Heema",
	  "Himadri",
	  "Himani",
	  "Hiranya",
	  "Indira",
	  "Jaimini",
	  "Jaya",
	  "Jyoti",
	  "Jyotsana",
	  "Kali",
	  "Kalinda",
	  "Kalpana",
	  "Kalyani",
	  "Kama",
	  "Kamala",
	  "Kamla",
	  "Kanchan",
	  "Kanishka",
	  "Kanti",
	  "Kashyapi",
	  "Kumari",
	  "Kumuda",
	  "Lakshmi",
	  "Laxmi",
	  "Lalita",
	  "Lavanya",
	  "Leela",
	  "Lila",
	  "Leela",
	  "Madhuri",
	  "Malti",
	  "Malati",
	  "Mandakini",
	  "Mandaakin",
	  "Mangala",
	  "Mangalya",
	  "Mani",
	  "Manisha",
	  "Manjusha",
	  "Meena",
	  "Mina",
	  "Meenakshi",
	  "Minakshi",
	  "Menka",
	  "Menaka",
	  "Mohana",
	  "Mohini",
	  "Nalini",
	  "Nikita",
	  "Ojaswini",
	  "Omana",
	  "Oormila",
	  "Urmila",
	  "Opalina",
	  "Opaline",
	  "Padma",
	  "Parvati",
	  "Poornima",
	  "Purnima",
	  "Pramila",
	  "Prasanna",
	  "Preity",
	  "Prema",
	  "Priya",
	  "Priyala",
	  "Pushti",
	  "Radha",
	  "Rageswari",
	  "Rageshwari",
	  "Rajinder",
	  "Ramaa",
	  "Rati",
	  "Rita",
	  "Rohana",
	  "Rukhmani",
	  "Rukmin",
	  "Rupinder",
	  "Sanya",
	  "Sarada",
	  "Sharda",
	  "Sarala",
	  "Sarla",
	  "Saraswati",
	  "Sarisha",
	  "Saroja",
	  "Shakti",
	  "Shakuntala",
	  "Shanti",
	  "Sharmila",
	  "Shashi",
	  "Shashikala",
	  "Sheela",
	  "Shivakari",
	  "Shobhana",
	  "Shresth",
	  "Shresthi",
	  "Shreya",
	  "Shreyashi",
	  "Shridevi",
	  "Shrishti",
	  "Shubha",
	  "Shubhaprada",
	  "Siddhi",
	  "Sitara",
	  "Sloka",
	  "Smita",
	  "Smriti",
	  "Soma",
	  "Subhashini",
	  "Subhasini",
	  "Sucheta",
	  "Sudeva",
	  "Sujata",
	  "Sukanya",
	  "Suma",
	  "Suma",
	  "Sumitra",
	  "Sunita",
	  "Suryakantam",
	  "Sushma",
	  "Swara",
	  "Swarnalata",
	  "Sweta",
	  "Shwet",
	  "Tanirika",
	  "Tanushree",
	  "Tanushri",
	  "Tanushri",
	  "Tanya",
	  "Tara",
	  "Trisha",
	  "Uma",
	  "Usha",
	  "Vaijayanti",
	  "Vaijayanthi",
	  "Baijayanti",
	  "Vaishvi",
	  "Vaishnavi",
	  "Vaishno",
	  "Varalakshmi",
	  "Vasudha",
	  "Vasundhara",
	  "Veda",
	  "Vedanshi",
	  "Vidya",
	  "Vimala",
	  "Vrinda",
	  "Vrund",
	  "Aadi",
	  "Aadidev",
	  "Aadinath",
	  "Aaditya",
	  "Aagam",
	  "Aagney",
	  "Aamod",
	  "Aanandaswarup",
	  "Anand Swarup",
	  "Aanjaneya",
	  "Anjaneya",
	  "Aaryan",
	  "Aryan",
	  "Aatmaj",
	  "Aatreya",
	  "Aayushmaan",
	  "Aayushman",
	  "Abhaidev",
	  "Abhaya",
	  "Abhirath",
	  "Abhisyanta",
	  "Acaryatanaya",
	  "Achalesvara",
	  "Acharyanandana",
	  "Acharyasuta",
	  "Achintya",
	  "Achyut",
	  "Adheesh",
	  "Adhiraj",
	  "Adhrit",
	  "Adikavi",
	  "Adinath",
	  "Aditeya",
	  "Aditya",
	  "Adityanandan",
	  "Adityanandana",
	  "Adripathi",
	  "Advaya",
	  "Agasti",
	  "Agastya",
	  "Agneya",
	  "Aagneya",
	  "Agnimitra",
	  "Agniprava",
	  "Agnivesh",
	  "Agrata",
	  "Ajit",
	  "Ajeet",
	  "Akroor",
	  "Akshaj",
	  "Akshat",
	  "Akshayakeerti",
	  "Alok",
	  "Aalok",
	  "Amaranaath",
	  "Amarnath",
	  "Amaresh",
	  "Ambar",
	  "Ameyatma",
	  "Amish",
	  "Amogh",
	  "Amrit",
	  "Anaadi",
	  "Anagh",
	  "Anal",
	  "Anand",
	  "Aanand",
	  "Anang",
	  "Anil",
	  "Anilaabh",
	  "Anilabh",
	  "Anish",
	  "Ankal",
	  "Anunay",
	  "Anurag",
	  "Anuraag",
	  "Archan",
	  "Arindam",
	  "Arjun",
	  "Arnesh",
	  "Arun",
	  "Ashlesh",
	  "Ashok",
	  "Atmanand",
	  "Atmananda",
	  "Avadhesh",
	  "Baalaaditya",
	  "Baladitya",
	  "Baalagopaal",
	  "Balgopal",
	  "Balagopal",
	  "Bahula",
	  "Bakula",
	  "Bala",
	  "Balaaditya",
	  "Balachandra",
	  "Balagovind",
	  "Bandhu",
	  "Bandhul",
	  "Bankim",
	  "Bankimchandra",
	  "Bhadrak",
	  "Bhadraksh",
	  "Bhadran",
	  "Bhagavaan",
	  "Bhagvan",
	  "Bharadwaj",
	  "Bhardwaj",
	  "Bharat",
	  "Bhargava",
	  "Bhasvan",
	  "Bhaasvan",
	  "Bhaswar",
	  "Bhaaswar",
	  "Bhaumik",
	  "Bhaves",
	  "Bheeshma",
	  "Bhisham",
	  "Bhishma",
	  "Bhima",
	  "Bhoj",
	  "Bhramar",
	  "Bhudev",
	  "Bhudeva",
	  "Bhupati",
	  "Bhoopati",
	  "Bhoopat",
	  "Bhupen",
	  "Bhushan",
	  "Bhooshan",
	  "Bhushit",
	  "Bhooshit",
	  "Bhuvanesh",
	  "Bhuvaneshwar",
	  "Bilva",
	  "Bodhan",
	  "Brahma",
	  "Brahmabrata",
	  "Brahmanandam",
	  "Brahmaanand",
	  "Brahmdev",
	  "Brajendra",
	  "Brajesh",
	  "Brijesh",
	  "Birjesh",
	  "Budhil",
	  "Chakor",
	  "Chakradhar",
	  "Chakravartee",
	  "Chakravarti",
	  "Chanakya",
	  "Chaanakya",
	  "Chandak",
	  "Chandan",
	  "Chandra",
	  "Chandraayan",
	  "Chandrabhan",
	  "Chandradev",
	  "Chandraketu",
	  "Chandramauli",
	  "Chandramohan",
	  "Chandran",
	  "Chandranath",
	  "Chapal",
	  "Charak",
	  "Charuchandra",
	  "Chaaruchandra",
	  "Charuvrat",
	  "Chatur",
	  "Chaturaanan",
	  "Chaturbhuj",
	  "Chetan",
	  "Chaten",
	  "Chaitan",
	  "Chetanaanand",
	  "Chidaakaash",
	  "Chidaatma",
	  "Chidambar",
	  "Chidambaram",
	  "Chidananda",
	  "Chinmayanand",
	  "Chinmayananda",
	  "Chiranjeev",
	  "Chiranjeeve",
	  "Chitraksh",
	  "Daiwik",
	  "Daksha",
	  "Damodara",
	  "Dandak",
	  "Dandapaani",
	  "Darshan",
	  "Datta",
	  "Dayaamay",
	  "Dayamayee",
	  "Dayaananda",
	  "Dayaanidhi",
	  "Kin",
	  "Deenabandhu",
	  "Deepan",
	  "Deepankar",
	  "Dipankar",
	  "Deependra",
	  "Dipendra",
	  "Deepesh",
	  "Dipesh",
	  "Deeptanshu",
	  "Deeptendu",
	  "Diptendu",
	  "Deeptiman",
	  "Deeptimoy",
	  "Deeptimay",
	  "Dev",
	  "Deb",
	  "Devadatt",
	  "Devagya",
	  "Devajyoti",
	  "Devak",
	  "Devdan",
	  "Deven",
	  "Devesh",
	  "Deveshwar",
	  "Devi",
	  "Devvrat",
	  "Dhananjay",
	  "Dhanapati",
	  "Dhanpati",
	  "Dhanesh",
	  "Dhanu",
	  "Dhanvin",
	  "Dharmaketu",
	  "Dhruv",
	  "Dhyanesh",
	  "Dhyaneshwar",
	  "Digambar",
	  "Digambara",
	  "Dinakar",
	  "Dinkar",
	  "Dinesh",
	  "Divaakar",
	  "Divakar",
	  "Deevakar",
	  "Divjot",
	  "Dron",
	  "Drona",
	  "Dwaipayan",
	  "Dwaipayana",
	  "Eekalabya",
	  "Ekalavya",
	  "Ekaksh",
	  "Ekaaksh",
	  "Ekaling",
	  "Ekdant",
	  "Ekadant",
	  "Gajaadhar",
	  "Gajadhar",
	  "Gajbaahu",
	  "Gajabahu",
	  "Ganak",
	  "Ganaka",
	  "Ganapati",
	  "Gandharv",
	  "Gandharva",
	  "Ganesh",
	  "Gangesh",
	  "Garud",
	  "Garuda",
	  "Gati",
	  "Gatik",
	  "Gaurang",
	  "Gauraang",
	  "Gauranga",
	  "Gouranga",
	  "Gautam",
	  "Gautama",
	  "Goutam",
	  "Ghanaanand",
	  "Ghanshyam",
	  "Ghanashyam",
	  "Giri",
	  "Girik",
	  "Girika",
	  "Girindra",
	  "Giriraaj",
	  "Giriraj",
	  "Girish",
	  "Gopal",
	  "Gopaal",
	  "Gopi",
	  "Gopee",
	  "Gorakhnath",
	  "Gorakhanatha",
	  "Goswamee",
	  "Goswami",
	  "Gotum",
	  "Gautam",
	  "Govinda",
	  "Gobinda",
	  "Gudakesha",
	  "Gudakesa",
	  "Gurdev",
	  "Guru",
	  "Hari",
	  "Harinarayan",
	  "Harit",
	  "Himadri",
	  "Hiranmay",
	  "Hiranmaya",
	  "Hiranya",
	  "Inder",
	  "Indra",
	  "Indra",
	  "Jagadish",
	  "Jagadisha",
	  "Jagathi",
	  "Jagdeep",
	  "Jagdish",
	  "Jagmeet",
	  "Jahnu",
	  "Jai",
	  "Javas",
	  "Jay",
	  "Jitendra",
	  "Jitender",
	  "Jyotis",
	  "Kailash",
	  "Kama",
	  "Kamalesh",
	  "Kamlesh",
	  "Kanak",
	  "Kanaka",
	  "Kannan",
	  "Kannen",
	  "Karan",
	  "Karthik",
	  "Kartik",
	  "Karunanidhi",
	  "Kashyap",
	  "Kiran",
	  "Kirti",
	  "Keerti",
	  "Krishna",
	  "Krishnadas",
	  "Krishnadasa",
	  "Kumar",
	  "Lai",
	  "Lakshman",
	  "Laxman",
	  "Lakshmidhar",
	  "Lakshminath",
	  "Lal",
	  "Laal",
	  "Mahendra",
	  "Mohinder",
	  "Mahesh",
	  "Maheswar",
	  "Mani",
	  "Manik",
	  "Manikya",
	  "Manoj",
	  "Marut",
	  "Mayoor",
	  "Meghnad",
	  "Meghnath",
	  "Mohan",
	  "Mukesh",
	  "Mukul",
	  "Nagabhushanam",
	  "Nanda",
	  "Narayan",
	  "Narendra",
	  "Narinder",
	  "Naveen",
	  "Navin",
	  "Nawal",
	  "Naval",
	  "Nimit",
	  "Niranjan",
	  "Nirbhay",
	  "Niro",
	  "Param",
	  "Paramartha",
	  "Pran",
	  "Pranay",
	  "Prasad",
	  "Prathamesh",
	  "Prayag",
	  "Prem",
	  "Puneet",
	  "Purushottam",
	  "Rahul",
	  "Raj",
	  "Rajan",
	  "Rajendra",
	  "Rajinder",
	  "Rajiv",
	  "Rakesh",
	  "Ramesh",
	  "Rameshwar",
	  "Ranjit",
	  "Ranjeet",
	  "Ravi",
	  "Ritesh",
	  "Rohan",
	  "Rohit",
	  "Rudra",
	  "Sachin",
	  "Sameer",
	  "Samir",
	  "Sanjay",
	  "Sanka",
	  "Sarvin",
	  "Satish",
	  "Satyen",
	  "Shankar",
	  "Shantanu",
	  "Shashi",
	  "Sher",
	  "Shiv",
	  "Siddarth",
	  "Siddhran",
	  "Som",
	  "Somu",
	  "Somnath",
	  "Subhash",
	  "Subodh",
	  "Suman",
	  "Suresh",
	  "Surya",
	  "Suryakant",
	  "Suryakanta",
	  "Sushil",
	  "Susheel",
	  "Swami",
	  "Swapnil",
	  "Tapan",
	  "Tara",
	  "Tarun",
	  "Tej",
	  "Tejas",
	  "Trilochan",
	  "Trilochana",
	  "Trilok",
	  "Trilokesh",
	  "Triloki",
	  "Triloki Nath",
	  "Trilokanath",
	  "Tushar",
	  "Udai",
	  "Udit",
	  "Ujjawal",
	  "Ujjwal",
	  "Umang",
	  "Upendra",
	  "Uttam",
	  "Vasudev",
	  "Vasudeva",
	  "Vedang",
	  "Vedanga",
	  "Vidhya",
	  "Vidur",
	  "Vidhur",
	  "Vijay",
	  "Vimal",
	  "Vinay",
	  "Vishnu",
	  "Bishnu",
	  "Vishwamitra",
	  "Vyas",
	  "Yogendra",
	  "Yoginder",
	  "Yogesh"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(993);
	name.last_name = __webpack_require__(995);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abbott",
	  "Achari",
	  "Acharya",
	  "Adiga",
	  "Agarwal",
	  "Ahluwalia",
	  "Ahuja",
	  "Arora",
	  "Asan",
	  "Bandopadhyay",
	  "Banerjee",
	  "Bharadwaj",
	  "Bhat",
	  "Butt",
	  "Bhattacharya",
	  "Bhattathiri",
	  "Chaturvedi",
	  "Chattopadhyay",
	  "Chopra",
	  "Desai",
	  "Deshpande",
	  "Devar",
	  "Dhawan",
	  "Dubashi",
	  "Dutta",
	  "Dwivedi",
	  "Embranthiri",
	  "Ganaka",
	  "Gandhi",
	  "Gill",
	  "Gowda",
	  "Guha",
	  "Guneta",
	  "Gupta",
	  "Iyer",
	  "Iyengar",
	  "Jain",
	  "Jha",
	  "Johar",
	  "Joshi",
	  "Kakkar",
	  "Kaniyar",
	  "Kapoor",
	  "Kaul",
	  "Kaur",
	  "Khan",
	  "Khanna",
	  "Khatri",
	  "Kocchar",
	  "Mahajan",
	  "Malik",
	  "Marar",
	  "Menon",
	  "Mehra",
	  "Mehrotra",
	  "Mishra",
	  "Mukhopadhyay",
	  "Nayar",
	  "Naik",
	  "Nair",
	  "Nambeesan",
	  "Namboothiri",
	  "Nehru",
	  "Pandey",
	  "Panicker",
	  "Patel",
	  "Patil",
	  "Pilla",
	  "Pillai",
	  "Pothuvaal",
	  "Prajapat",
	  "Rana",
	  "Reddy",
	  "Saini",
	  "Sethi",
	  "Shah",
	  "Sharma",
	  "Shukla",
	  "Singh",
	  "Sinha",
	  "Somayaji",
	  "Tagore",
	  "Talwar",
	  "Tandon",
	  "Trivedi",
	  "Varrier",
	  "Varma",
	  "Varman",
	  "Verma"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+91###-###-####",
	  "+91##########",
	  "+91-###-#######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(996);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "United States",
	  "United States of America",
	  "USA"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.default_country = __webpack_require__(998);
	address.postcode_by_state = __webpack_require__(1000);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "AL": "350##",
	  "AK": "995##",
	  "AS": "967##",
	  "AZ": "850##",
	  "AR": "717##",
	  "CA": "900##",
	  "CO": "800##",
	  "CT": "061##",
	  "DC": "204##",
	  "DE": "198##",
	  "FL": "322##",
	  "GA": "301##",
	  "HI": "967##",
	  "ID": "832##",
	  "IL": "600##",
	  "IN": "463##",
	  "IA": "510##",
	  "KS": "666##",
	  "KY": "404##",
	  "LA": "701##",
	  "ME": "042##",
	  "MD": "210##",
	  "MA": "026##",
	  "MI": "480##",
	  "MN": "555##",
	  "MS": "387##",
	  "MO": "650##",
	  "MT": "590##",
	  "NE": "688##",
	  "NV": "898##",
	  "NH": "036##",
	  "NJ": "076##",
	  "NM": "880##",
	  "NY": "122##",
	  "NC": "288##",
	  "ND": "586##",
	  "OH": "444##",
	  "OK": "730##",
	  "OR": "979##",
	  "PA": "186##",
	  "RI": "029##",
	  "SC": "299##",
	  "SD": "577##",
	  "TN": "383##",
	  "TX": "798##",
	  "UT": "847##",
	  "VT": "050##",
	  "VA": "222##",
	  "WA": "990##",
	  "WV": "247##",
	  "WI": "549##",
	  "WY": "831##"
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_US = {};
	module['exports'] = en_US;
	en_US.title = "United States (English)";
	en_US.internet = __webpack_require__(1003);
	en_US.address = __webpack_require__(999);
	en_US.phone_number = __webpack_require__(1006);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "us",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(1002);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "201",
	  "202",
	  "203",
	  "205",
	  "206",
	  "207",
	  "208",
	  "209",
	  "210",
	  "212",
	  "213",
	  "214",
	  "215",
	  "216",
	  "217",
	  "218",
	  "219",
	  "224",
	  "225",
	  "227",
	  "228",
	  "229",
	  "231",
	  "234",
	  "239",
	  "240",
	  "248",
	  "251",
	  "252",
	  "253",
	  "254",
	  "256",
	  "260",
	  "262",
	  "267",
	  "269",
	  "270",
	  "276",
	  "281",
	  "283",
	  "301",
	  "302",
	  "303",
	  "304",
	  "305",
	  "307",
	  "308",
	  "309",
	  "310",
	  "312",
	  "313",
	  "314",
	  "315",
	  "316",
	  "317",
	  "318",
	  "319",
	  "320",
	  "321",
	  "323",
	  "330",
	  "331",
	  "334",
	  "336",
	  "337",
	  "339",
	  "347",
	  "351",
	  "352",
	  "360",
	  "361",
	  "386",
	  "401",
	  "402",
	  "404",
	  "405",
	  "406",
	  "407",
	  "408",
	  "409",
	  "410",
	  "412",
	  "413",
	  "414",
	  "415",
	  "417",
	  "419",
	  "423",
	  "424",
	  "425",
	  "434",
	  "435",
	  "440",
	  "443",
	  "445",
	  "464",
	  "469",
	  "470",
	  "475",
	  "478",
	  "479",
	  "480",
	  "484",
	  "501",
	  "502",
	  "503",
	  "504",
	  "505",
	  "507",
	  "508",
	  "509",
	  "510",
	  "512",
	  "513",
	  "515",
	  "516",
	  "517",
	  "518",
	  "520",
	  "530",
	  "540",
	  "541",
	  "551",
	  "557",
	  "559",
	  "561",
	  "562",
	  "563",
	  "564",
	  "567",
	  "570",
	  "571",
	  "573",
	  "574",
	  "580",
	  "585",
	  "586",
	  "601",
	  "602",
	  "603",
	  "605",
	  "606",
	  "607",
	  "608",
	  "609",
	  "610",
	  "612",
	  "614",
	  "615",
	  "616",
	  "617",
	  "618",
	  "619",
	  "620",
	  "623",
	  "626",
	  "630",
	  "631",
	  "636",
	  "641",
	  "646",
	  "650",
	  "651",
	  "660",
	  "661",
	  "662",
	  "667",
	  "678",
	  "682",
	  "701",
	  "702",
	  "703",
	  "704",
	  "706",
	  "707",
	  "708",
	  "712",
	  "713",
	  "714",
	  "715",
	  "716",
	  "717",
	  "718",
	  "719",
	  "720",
	  "724",
	  "727",
	  "731",
	  "732",
	  "734",
	  "737",
	  "740",
	  "754",
	  "757",
	  "760",
	  "763",
	  "765",
	  "770",
	  "772",
	  "773",
	  "774",
	  "775",
	  "781",
	  "785",
	  "786",
	  "801",
	  "802",
	  "803",
	  "804",
	  "805",
	  "806",
	  "808",
	  "810",
	  "812",
	  "813",
	  "814",
	  "815",
	  "816",
	  "817",
	  "818",
	  "828",
	  "830",
	  "831",
	  "832",
	  "835",
	  "843",
	  "845",
	  "847",
	  "848",
	  "850",
	  "856",
	  "857",
	  "858",
	  "859",
	  "860",
	  "862",
	  "863",
	  "864",
	  "865",
	  "870",
	  "872",
	  "878",
	  "901",
	  "903",
	  "904",
	  "906",
	  "907",
	  "908",
	  "909",
	  "910",
	  "912",
	  "913",
	  "914",
	  "915",
	  "916",
	  "917",
	  "918",
	  "919",
	  "920",
	  "925",
	  "928",
	  "931",
	  "936",
	  "937",
	  "940",
	  "941",
	  "947",
	  "949",
	  "952",
	  "954",
	  "956",
	  "959",
	  "970",
	  "971",
	  "972",
	  "973",
	  "975",
	  "978",
	  "979",
	  "980",
	  "984",
	  "985",
	  "989"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "201",
	  "202",
	  "203",
	  "205",
	  "206",
	  "207",
	  "208",
	  "209",
	  "210",
	  "212",
	  "213",
	  "214",
	  "215",
	  "216",
	  "217",
	  "218",
	  "219",
	  "224",
	  "225",
	  "227",
	  "228",
	  "229",
	  "231",
	  "234",
	  "239",
	  "240",
	  "248",
	  "251",
	  "252",
	  "253",
	  "254",
	  "256",
	  "260",
	  "262",
	  "267",
	  "269",
	  "270",
	  "276",
	  "281",
	  "283",
	  "301",
	  "302",
	  "303",
	  "304",
	  "305",
	  "307",
	  "308",
	  "309",
	  "310",
	  "312",
	  "313",
	  "314",
	  "315",
	  "316",
	  "317",
	  "318",
	  "319",
	  "320",
	  "321",
	  "323",
	  "330",
	  "331",
	  "334",
	  "336",
	  "337",
	  "339",
	  "347",
	  "351",
	  "352",
	  "360",
	  "361",
	  "386",
	  "401",
	  "402",
	  "404",
	  "405",
	  "406",
	  "407",
	  "408",
	  "409",
	  "410",
	  "412",
	  "413",
	  "414",
	  "415",
	  "417",
	  "419",
	  "423",
	  "424",
	  "425",
	  "434",
	  "435",
	  "440",
	  "443",
	  "445",
	  "464",
	  "469",
	  "470",
	  "475",
	  "478",
	  "479",
	  "480",
	  "484",
	  "501",
	  "502",
	  "503",
	  "504",
	  "505",
	  "507",
	  "508",
	  "509",
	  "510",
	  "512",
	  "513",
	  "515",
	  "516",
	  "517",
	  "518",
	  "520",
	  "530",
	  "540",
	  "541",
	  "551",
	  "557",
	  "559",
	  "561",
	  "562",
	  "563",
	  "564",
	  "567",
	  "570",
	  "571",
	  "573",
	  "574",
	  "580",
	  "585",
	  "586",
	  "601",
	  "602",
	  "603",
	  "605",
	  "606",
	  "607",
	  "608",
	  "609",
	  "610",
	  "612",
	  "614",
	  "615",
	  "616",
	  "617",
	  "618",
	  "619",
	  "620",
	  "623",
	  "626",
	  "630",
	  "631",
	  "636",
	  "641",
	  "646",
	  "650",
	  "651",
	  "660",
	  "661",
	  "662",
	  "667",
	  "678",
	  "682",
	  "701",
	  "702",
	  "703",
	  "704",
	  "706",
	  "707",
	  "708",
	  "712",
	  "713",
	  "714",
	  "715",
	  "716",
	  "717",
	  "718",
	  "719",
	  "720",
	  "724",
	  "727",
	  "731",
	  "732",
	  "734",
	  "737",
	  "740",
	  "754",
	  "757",
	  "760",
	  "763",
	  "765",
	  "770",
	  "772",
	  "773",
	  "774",
	  "775",
	  "781",
	  "785",
	  "786",
	  "801",
	  "802",
	  "803",
	  "804",
	  "805",
	  "806",
	  "808",
	  "810",
	  "812",
	  "813",
	  "814",
	  "815",
	  "816",
	  "817",
	  "818",
	  "828",
	  "830",
	  "831",
	  "832",
	  "835",
	  "843",
	  "845",
	  "847",
	  "848",
	  "850",
	  "856",
	  "857",
	  "858",
	  "859",
	  "860",
	  "862",
	  "863",
	  "864",
	  "865",
	  "870",
	  "872",
	  "878",
	  "901",
	  "903",
	  "904",
	  "906",
	  "907",
	  "908",
	  "909",
	  "910",
	  "912",
	  "913",
	  "914",
	  "915",
	  "916",
	  "917",
	  "918",
	  "919",
	  "920",
	  "925",
	  "928",
	  "931",
	  "936",
	  "937",
	  "940",
	  "941",
	  "947",
	  "949",
	  "952",
	  "954",
	  "956",
	  "959",
	  "970",
	  "971",
	  "972",
	  "973",
	  "975",
	  "978",
	  "979",
	  "980",
	  "984",
	  "985",
	  "989"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.area_code = __webpack_require__(1004);
	phone_number.exchange_code = __webpack_require__(1005);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bondi",
	  "Burleigh Heads",
	  "Carlton",
	  "Fitzroy",
	  "Fremantle",
	  "Glenelg",
	  "Manly",
	  "Noosa",
	  "Stones Corner",
	  "St Kilda",
	  "Surry Hills",
	  "Yarra Valley"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Australia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.street_root = __webpack_require__(1017);
	address.street_name = __webpack_require__(1016);
	address.city_prefix = __webpack_require__(1009);
	address.city = __webpack_require__(1008);
	address.state_abbr = __webpack_require__(1015);
	address.region = __webpack_require__(1013);
	address.state = __webpack_require__(1014);
	address.postcode = __webpack_require__(1012);
	address.building_number = __webpack_require__(1007);
	address.street_suffix = __webpack_require__(1018);
	address.default_country = __webpack_require__(1010);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0###",
	  "2###",
	  "3###",
	  "4###",
	  "5###",
	  "6###",
	  "7###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "South East Queensland",
	  "Wide Bay Burnett",
	  "Margaret River",
	  "Port Pirie",
	  "Gippsland",
	  "Elizabeth",
	  "Barossa"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "New South Wales",
	  "Queensland",
	  "Northern Territory",
	  "South Australia",
	  "Western Australia",
	  "Tasmania",
	  "Australian Capital Territory",
	  "Victoria"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "NSW",
	  "QLD",
	  "NT",
	  "SA",
	  "WA",
	  "TAS",
	  "ACT",
	  "VIC"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ramsay Street",
	  "Bonnie Doon",
	  "Cavill Avenue",
	  "Queen Street"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avenue",
	  "Boulevard",
	  "Circle",
	  "Circuit",
	  "Court",
	  "Crescent",
	  "Crest",
	  "Drive",
	  "Estate Dr",
	  "Grove",
	  "Hill",
	  "Island",
	  "Junction",
	  "Knoll",
	  "Lane",
	  "Loop",
	  "Mall",
	  "Manor",
	  "Meadow",
	  "Mews",
	  "Parade",
	  "Parkway",
	  "Pass",
	  "Place",
	  "Plaza",
	  "Ridge",
	  "Road",
	  "Run",
	  "Square",
	  "Station St",
	  "Street",
	  "Summit",
	  "Terrace",
	  "Track",
	  "Trail",
	  "View Rd",
	  "Way"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1020);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pty Ltd",
	  "and Sons",
	  "Corp",
	  "Group",
	  "Brothers",
	  "Partners"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_au_ocker = {};
	module['exports'] = en_au_ocker;
	en_au_ocker.title = "Australia Ocker (English)";
	en_au_ocker.name = __webpack_require__(1025);
	en_au_ocker.company = __webpack_require__(1019);
	en_au_ocker.internet = __webpack_require__(1023);
	en_au_ocker.address = __webpack_require__(1011);
	en_au_ocker.phone_number = __webpack_require__(1029);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com.au",
	  "com",
	  "net.au",
	  "net",
	  "org.au",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(1022);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Charlotte",
	  "Ava",
	  "Chloe",
	  "Emily",
	  "Olivia",
	  "Zoe",
	  "Lily",
	  "Sophie",
	  "Amelia",
	  "Sofia",
	  "Ella",
	  "Isabella",
	  "Ruby",
	  "Sienna",
	  "Mia+3",
	  "Grace",
	  "Emma",
	  "Ivy",
	  "Layla",
	  "Abigail",
	  "Isla",
	  "Hannah",
	  "Zara",
	  "Lucy",
	  "Evie",
	  "Annabelle",
	  "Madison",
	  "Alice",
	  "Georgia",
	  "Maya",
	  "Madeline",
	  "Audrey",
	  "Scarlett",
	  "Isabelle",
	  "Chelsea",
	  "Mila",
	  "Holly",
	  "Indiana",
	  "Poppy",
	  "Harper",
	  "Sarah",
	  "Alyssa",
	  "Jasmine",
	  "Imogen",
	  "Hayley",
	  "Pheobe",
	  "Eva",
	  "Evelyn",
	  "Mackenzie",
	  "Ayla",
	  "Oliver",
	  "Jack",
	  "Jackson",
	  "William",
	  "Ethan",
	  "Charlie",
	  "Lucas",
	  "Cooper",
	  "Lachlan",
	  "Noah",
	  "Liam",
	  "Alexander",
	  "Max",
	  "Isaac",
	  "Thomas",
	  "Xavier",
	  "Oscar",
	  "Benjamin",
	  "Aiden",
	  "Mason",
	  "Samuel",
	  "James",
	  "Levi",
	  "Riley",
	  "Harrison",
	  "Ryan",
	  "Henry",
	  "Jacob",
	  "Joshua",
	  "Leo",
	  "Zach",
	  "Harry",
	  "Hunter",
	  "Flynn",
	  "Archie",
	  "Tyler",
	  "Elijah",
	  "Hayden",
	  "Jayden",
	  "Blake",
	  "Archer",
	  "Ashton",
	  "Sebastian",
	  "Zachery",
	  "Lincoln",
	  "Mitchell",
	  "Luca",
	  "Nathan",
	  "Kai",
	  "Connor",
	  "Tom",
	  "Nigel",
	  "Matt",
	  "Sean"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1024);
	name.last_name = __webpack_require__(1026);
	name.ocker_first_name = __webpack_require__(1027);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Smith",
	  "Jones",
	  "Williams",
	  "Brown",
	  "Wilson",
	  "Taylor",
	  "Morton",
	  "White",
	  "Martin",
	  "Anderson",
	  "Thompson",
	  "Nguyen",
	  "Thomas",
	  "Walker",
	  "Harris",
	  "Lee",
	  "Ryan",
	  "Robinson",
	  "Kelly",
	  "King",
	  "Rausch",
	  "Ridge",
	  "Connolly",
	  "LeQuesne"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bazza",
	  "Bluey",
	  "Davo",
	  "Johno",
	  "Shano",
	  "Shazza"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0# #### ####",
	  "+61 # #### ####",
	  "04## ### ###",
	  "+61 4## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1028);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  " s/n.",
	  ", #",
	  ", ##",
	  " #",
	  " ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Parla",
	  "Telde",
	  "Baracaldo",
	  "San Fernando",
	  "Torrevieja",
	  "Lugo",
	  "Santiago de Compostela",
	  "Gerona",
	  "Cáceres",
	  "Lorca",
	  "Coslada",
	  "Talavera de la Reina",
	  "El Puerto de Santa María",
	  "Cornellá de Llobregat",
	  "Avilés",
	  "Palencia",
	  "Gecho",
	  "Orihuela",
	  "Pontevedra",
	  "Pozuelo de Alarcón",
	  "Toledo",
	  "El Ejido",
	  "Guadalajara",
	  "Gandía",
	  "Ceuta",
	  "Ferrol",
	  "Chiclana de la Frontera",
	  "Manresa",
	  "Roquetas de Mar",
	  "Ciudad Real",
	  "Rubí",
	  "Benidorm",
	  "San Sebastían de los Reyes",
	  "Ponferrada",
	  "Zamora",
	  "Alcalá de Guadaira",
	  "Fuengirola",
	  "Mijas",
	  "Sanlúcar de Barrameda",
	  "La Línea de la Concepción",
	  "Majadahonda",
	  "Sagunto",
	  "El Prat de LLobregat",
	  "Viladecans",
	  "Linares",
	  "Alcoy",
	  "Irún",
	  "Estepona",
	  "Torremolinos",
	  "Rivas-Vaciamadrid",
	  "Molina de Segura",
	  "Paterna",
	  "Granollers",
	  "Santa Lucía de Tirajana",
	  "Motril",
	  "Cerdañola del Vallés",
	  "Arrecife",
	  "Segovia",
	  "Torrelavega",
	  "Elda",
	  "Mérida",
	  "Ávila",
	  "Valdemoro",
	  "Cuenta",
	  "Collado Villalba",
	  "Benalmádena",
	  "Mollet del Vallés",
	  "Puertollano",
	  "Madrid",
	  "Barcelona",
	  "Valencia",
	  "Sevilla",
	  "Zaragoza",
	  "Málaga",
	  "Murcia",
	  "Palma de Mallorca",
	  "Las Palmas de Gran Canaria",
	  "Bilbao",
	  "Córdoba",
	  "Alicante",
	  "Valladolid",
	  "Vigo",
	  "Gijón",
	  "Hospitalet de LLobregat",
	  "La Coruña",
	  "Granada",
	  "Vitoria",
	  "Elche",
	  "Santa Cruz de Tenerife",
	  "Oviedo",
	  "Badalona",
	  "Cartagena",
	  "Móstoles",
	  "Jerez de la Frontera",
	  "Tarrasa",
	  "Sabadell",
	  "Alcalá de Henares",
	  "Pamplona",
	  "Fuenlabrada",
	  "Almería",
	  "San Sebastián",
	  "Leganés",
	  "Santander",
	  "Burgos",
	  "Castellón de la Plana",
	  "Alcorcón",
	  "Albacete",
	  "Getafe",
	  "Salamanca",
	  "Huelva",
	  "Logroño",
	  "Badajoz",
	  "San Cristróbal de la Laguna",
	  "León",
	  "Tarragona",
	  "Cádiz",
	  "Lérida",
	  "Marbella",
	  "Mataró",
	  "Dos Hermanas",
	  "Santa Coloma de Gramanet",
	  "Jaén",
	  "Algeciras",
	  "Torrejón de Ardoz",
	  "Orense",
	  "Alcobendas",
	  "Reus",
	  "Calahorra",
	  "Inca"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistán",
	  "Albania",
	  "Argelia",
	  "Andorra",
	  "Angola",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbayán",
	  "Bahamas",
	  "Barein",
	  "Bangladesh",
	  "Barbados",
	  "Bielorusia",
	  "Bélgica",
	  "Belice",
	  "Bermuda",
	  "Bután",
	  "Bolivia",
	  "Bosnia Herzegovina",
	  "Botswana",
	  "Brasil",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Camboya",
	  "Camerún",
	  "Canada",
	  "Cabo Verde",
	  "Islas Caimán",
	  "Chad",
	  "Chile",
	  "China",
	  "Isla de Navidad",
	  "Colombia",
	  "Comodos",
	  "Congo",
	  "Costa Rica",
	  "Costa de Marfil",
	  "Croacia",
	  "Cuba",
	  "Chipre",
	  "República Checa",
	  "Dinamarca",
	  "Dominica",
	  "República Dominicana",
	  "Ecuador",
	  "Egipto",
	  "El Salvador",
	  "Guinea Ecuatorial",
	  "Eritrea",
	  "Estonia",
	  "Etiopía",
	  "Islas Faro",
	  "Fiji",
	  "Finlandia",
	  "Francia",
	  "Gabón",
	  "Gambia",
	  "Georgia",
	  "Alemania",
	  "Ghana",
	  "Grecia",
	  "Groenlandia",
	  "Granada",
	  "Guadalupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bisau",
	  "Guayana",
	  "Haiti",
	  "Honduras",
	  "Hong Kong",
	  "Hungria",
	  "Islandia",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Irak",
	  "Irlanda",
	  "Italia",
	  "Jamaica",
	  "Japón",
	  "Jordania",
	  "Kazajistan",
	  "Kenia",
	  "Kiribati",
	  "Corea",
	  "Kuwait",
	  "Letonia",
	  "Líbano",
	  "Liberia",
	  "Liechtenstein",
	  "Lituania",
	  "Luxemburgo",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malasia",
	  "Maldivas",
	  "Mali",
	  "Malta",
	  "Martinica",
	  "Mauritania",
	  "Méjico",
	  "Micronesia",
	  "Moldavia",
	  "Mónaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Marruecos",
	  "Mozambique",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Holanda",
	  "Nueva Zelanda",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Noruega",
	  "Omán",
	  "Pakistan",
	  "Panamá",
	  "Papúa Nueva Guinea",
	  "Paraguay",
	  "Perú",
	  "Filipinas",
	  "Poland",
	  "Portugal",
	  "Puerto Rico",
	  "Rusia",
	  "Ruanda",
	  "Samoa",
	  "San Marino",
	  "Santo Tomé y Principe",
	  "Arabia Saudí",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leona",
	  "Singapur",
	  "Eslovaquia",
	  "Eslovenia",
	  "Somalia",
	  "España",
	  "Sri Lanka",
	  "Sudán",
	  "Suriname",
	  "Suecia",
	  "Suiza",
	  "Siria",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Tailandia",
	  "Timor-Leste",
	  "Togo",
	  "Tonga",
	  "Trinidad y Tobago",
	  "Tunez",
	  "Turquia",
	  "Uganda",
	  "Ucrania",
	  "Emiratos Árabes Unidos",
	  "Reino Unido",
	  "Estados Unidos de América",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "España"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1032);
	address.country = __webpack_require__(1033);
	address.building_number = __webpack_require__(1030);
	address.street_suffix = __webpack_require__(1043);
	address.secondary_address = __webpack_require__(1038);
	address.postcode = __webpack_require__(1036);
	address.province = __webpack_require__(1037);
	address.state = __webpack_require__(1039);
	address.state_abbr = __webpack_require__(1040);
	address.time_zone = __webpack_require__(1044);
	address.city = __webpack_require__(1031);
	address.street_name = __webpack_require__(1042);
	address.street_address = __webpack_require__(1041);
	address.default_country = __webpack_require__(1034);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Álava",
	  "Albacete",
	  "Alicante",
	  "Almería",
	  "Asturias",
	  "Ávila",
	  "Badajoz",
	  "Barcelona",
	  "Burgos",
	  "Cantabria",
	  "Castellón",
	  "Ciudad Real",
	  "Cuenca",
	  "Cáceres",
	  "Cádiz",
	  "Córdoba",
	  "Gerona",
	  "Granada",
	  "Guadalajara",
	  "Guipúzcoa",
	  "Huelva",
	  "Huesca",
	  "Islas Baleares",
	  "Jaén",
	  "La Coruña",
	  "La Rioja",
	  "Las Palmas",
	  "León",
	  "Lugo",
	  "lérida",
	  "Madrid",
	  "Murcia",
	  "Málaga",
	  "Navarra",
	  "Orense",
	  "Palencia",
	  "Pontevedra",
	  "Salamanca",
	  "Santa Cruz de Tenerife",
	  "Segovia",
	  "Sevilla",
	  "Soria",
	  "Tarragona",
	  "Teruel",
	  "Toledo",
	  "Valencia",
	  "Valladolid",
	  "Vizcaya",
	  "Zamora",
	  "Zaragoza"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Esc. ###",
	  "Puerta ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Andalucía",
	  "Aragón",
	  "Principado de Asturias",
	  "Baleares",
	  "Canarias",
	  "Cantabria",
	  "Castilla-La Mancha",
	  "Castilla y León",
	  "Cataluña",
	  "Comunidad Valenciana",
	  "Extremadura",
	  "Galicia",
	  "La Rioja",
	  "Comunidad de Madrid",
	  "Navarra",
	  "País Vasco",
	  "Región de Murcia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "And",
	  "Ara",
	  "Ast",
	  "Bal",
	  "Can",
	  "Cbr",
	  "Man",
	  "Leo",
	  "Cat",
	  "Com",
	  "Ext",
	  "Gal",
	  "Rio",
	  "Mad",
	  "Nav",
	  "Vas",
	  "Mur"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}",
	  "#{street_name}#{building_number} #{secondary_address}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Name.first_name}",
	  "#{street_suffix} #{Name.first_name} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aldea",
	  "Apartamento",
	  "Arrabal",
	  "Arroyo",
	  "Avenida",
	  "Bajada",
	  "Barranco",
	  "Barrio",
	  "Bloque",
	  "Calle",
	  "Calleja",
	  "Camino",
	  "Carretera",
	  "Caserio",
	  "Colegio",
	  "Colonia",
	  "Conjunto",
	  "Cuesta",
	  "Chalet",
	  "Edificio",
	  "Entrada",
	  "Escalinata",
	  "Explanada",
	  "Extramuros",
	  "Extrarradio",
	  "Ferrocarril",
	  "Glorieta",
	  "Gran Subida",
	  "Grupo",
	  "Huerta",
	  "Jardines",
	  "Lado",
	  "Lugar",
	  "Manzana",
	  "Masía",
	  "Mercado",
	  "Monte",
	  "Muelle",
	  "Municipio",
	  "Parcela",
	  "Parque",
	  "Partida",
	  "Pasaje",
	  "Paseo",
	  "Plaza",
	  "Poblado",
	  "Polígono",
	  "Prolongación",
	  "Puente",
	  "Puerta",
	  "Quinta",
	  "Ramal",
	  "Rambla",
	  "Rampa",
	  "Riera",
	  "Rincón",
	  "Ronda",
	  "Rua",
	  "Salida",
	  "Sector",
	  "Sección",
	  "Senda",
	  "Solar",
	  "Subida",
	  "Terrenos",
	  "Torrente",
	  "Travesía",
	  "Urbanización",
	  "Vía",
	  "Vía Pública"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacífico/Midway",
	  "Pacífico/Pago_Pago",
	  "Pacífico/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europa/Dublin",
	  "Europa/London",
	  "Europa/Lisbon",
	  "Europa/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europa/Belgrade",
	  "Europa/Bratislava",
	  "Europa/Budapest",
	  "Europa/Ljubljana",
	  "Europa/Prague",
	  "Europa/Sarajevo",
	  "Europa/Skopje",
	  "Europa/Warsaw",
	  "Europa/Zagreb",
	  "Europa/Brussels",
	  "Europa/Copenhagen",
	  "Europa/Madrid",
	  "Europa/Paris",
	  "Europa/Amsterdam",
	  "Europa/Berlin",
	  "Europa/Berlin",
	  "Europa/Rome",
	  "Europa/Stockholm",
	  "Europa/Vienna",
	  "Africa/Algiers",
	  "Europa/Bucharest",
	  "Africa/Cairo",
	  "Europa/Helsinki",
	  "Europa/Kiev",
	  "Europa/Riga",
	  "Europa/Sofia",
	  "Europa/Tallinn",
	  "Europa/Vilnius",
	  "Europa/Athens",
	  "Europa/Istanbul",
	  "Europa/Minsk",
	  "Asia/Jerusalen",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacífico/Guam",
	  "Pacífico/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacífico/Noumea",
	  "Pacífico/Fiji",
	  "Asia/Kamchatka",
	  "Pacífico/Majuro",
	  "Pacífico/Auckland",
	  "Pacífico/Auckland",
	  "Pacífico/Tongatapu",
	  "Pacífico/Fakaofo",
	  "Pacífico/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "6##-###-###",
	  "6##.###.###",
	  "6## ### ###",
	  "6########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1045);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptativo",
	  "Avanzado",
	  "Asimilado",
	  "Automatizado",
	  "Equilibrado",
	  "Centrado en el negocio",
	  "Centralizado",
	  "Clonado",
	  "Compatible",
	  "Configurable",
	  "Multi grupo",
	  "Multi plataforma",
	  "Centrado en el usuario",
	  "Configurable",
	  "Descentralizado",
	  "Digitalizado",
	  "Distribuido",
	  "Diverso",
	  "Reducido",
	  "Mejorado",
	  "Para toda la empresa",
	  "Ergonomico",
	  "Exclusivo",
	  "Expandido",
	  "Extendido",
	  "Cara a cara",
	  "Enfocado",
	  "Totalmente configurable",
	  "Fundamental",
	  "Orígenes",
	  "Horizontal",
	  "Implementado",
	  "Innovador",
	  "Integrado",
	  "Intuitivo",
	  "Inverso",
	  "Gestionado",
	  "Obligatorio",
	  "Monitorizado",
	  "Multi canal",
	  "Multi lateral",
	  "Multi capa",
	  "En red",
	  "Orientado a objetos",
	  "Open-source",
	  "Operativo",
	  "Optimizado",
	  "Opcional",
	  "Organico",
	  "Organizado",
	  "Perseverando",
	  "Persistente",
	  "en fases",
	  "Polarizado",
	  "Pre-emptivo",
	  "Proactivo",
	  "Enfocado a benficios",
	  "Profundo",
	  "Programable",
	  "Progresivo",
	  "Public-key",
	  "Enfocado en la calidad",
	  "Reactivo",
	  "Realineado",
	  "Re-contextualizado",
	  "Re-implementado",
	  "Reducido",
	  "Ingenieria inversa",
	  "Robusto",
	  "Fácil",
	  "Seguro",
	  "Auto proporciona",
	  "Compartible",
	  "Intercambiable",
	  "Sincronizado",
	  "Orientado a equipos",
	  "Total",
	  "Universal",
	  "Mejorado",
	  "Actualizable",
	  "Centrado en el usuario",
	  "Amigable",
	  "Versatil",
	  "Virtual",
	  "Visionario"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 horas",
	  "24/7",
	  "3rd generación",
	  "4th generación",
	  "5th generación",
	  "6th generación",
	  "analizada",
	  "asimétrica",
	  "asíncrona",
	  "monitorizada por red",
	  "bidireccional",
	  "bifurcada",
	  "generada por el cliente",
	  "cliente servidor",
	  "coherente",
	  "cohesiva",
	  "compuesto",
	  "sensible al contexto",
	  "basado en el contexto",
	  "basado en contenido",
	  "dedicada",
	  "generado por la demanda",
	  "didactica",
	  "direccional",
	  "discreta",
	  "dinámica",
	  "potenciada",
	  "acompasada",
	  "ejecutiva",
	  "explícita",
	  "tolerante a fallos",
	  "innovadora",
	  "amplio ábanico",
	  "global",
	  "heurística",
	  "alto nivel",
	  "holística",
	  "homogénea",
	  "hibrida",
	  "incremental",
	  "intangible",
	  "interactiva",
	  "intermedia",
	  "local",
	  "logística",
	  "maximizada",
	  "metódica",
	  "misión crítica",
	  "móbil",
	  "modular",
	  "motivadora",
	  "multimedia",
	  "multiestado",
	  "multitarea",
	  "nacional",
	  "basado en necesidades",
	  "neutral",
	  "nueva generación",
	  "no-volátil",
	  "orientado a objetos",
	  "óptima",
	  "optimizada",
	  "radical",
	  "tiempo real",
	  "recíproca",
	  "regional",
	  "escalable",
	  "secundaria",
	  "orientada a soluciones",
	  "estable",
	  "estatica",
	  "sistemática",
	  "sistémica",
	  "tangible",
	  "terciaria",
	  "transicional",
	  "uniforme",
	  "valor añadido",
	  "vía web",
	  "defectos cero",
	  "tolerancia cero"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1052);
	company.noun = __webpack_require__(1051);
	company.descriptor = __webpack_require__(1048);
	company.adjective = __webpack_require__(1047);
	company.name = __webpack_require__(1050);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} y #{Name.last_name}",
	  "#{Name.last_name} #{Name.last_name} #{suffix}",
	  "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "habilidad",
	  "acceso",
	  "adaptador",
	  "algoritmo",
	  "alianza",
	  "analista",
	  "aplicación",
	  "enfoque",
	  "arquitectura",
	  "archivo",
	  "inteligencia artificial",
	  "array",
	  "actitud",
	  "medición",
	  "gestión presupuestaria",
	  "capacidad",
	  "desafío",
	  "circuito",
	  "colaboración",
	  "complejidad",
	  "concepto",
	  "conglomeración",
	  "contingencia",
	  "núcleo",
	  "fidelidad",
	  "base de datos",
	  "data-warehouse",
	  "definición",
	  "emulación",
	  "codificar",
	  "encriptar",
	  "extranet",
	  "firmware",
	  "flexibilidad",
	  "focus group",
	  "previsión",
	  "base de trabajo",
	  "función",
	  "funcionalidad",
	  "Interfaz Gráfica",
	  "groupware",
	  "Interfaz gráfico de usuario",
	  "hardware",
	  "Soporte",
	  "jerarquía",
	  "conjunto",
	  "implementación",
	  "infraestructura",
	  "iniciativa",
	  "instalación",
	  "conjunto de instrucciones",
	  "interfaz",
	  "intranet",
	  "base del conocimiento",
	  "red de area local",
	  "aprovechar",
	  "matrices",
	  "metodologías",
	  "middleware",
	  "migración",
	  "modelo",
	  "moderador",
	  "monitorizar",
	  "arquitectura abierta",
	  "sistema abierto",
	  "orquestar",
	  "paradigma",
	  "paralelismo",
	  "política",
	  "portal",
	  "estructura de precios",
	  "proceso de mejora",
	  "producto",
	  "productividad",
	  "proyecto",
	  "proyección",
	  "protocolo",
	  "línea segura",
	  "software",
	  "solución",
	  "estandardización",
	  "estrategia",
	  "estructura",
	  "éxito",
	  "superestructura",
	  "soporte",
	  "sinergia",
	  "mediante",
	  "marco de tiempo",
	  "caja de herramientas",
	  "utilización",
	  "website",
	  "fuerza de trabajo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.L.",
	  "e Hijos",
	  "S.A.",
	  "Hermanos"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var es = {};
	module['exports'] = es;
	es.title = "Spanish";
	es.address = __webpack_require__(1035);
	es.company = __webpack_require__(1049);
	es.internet = __webpack_require__(1056);
	es.name = __webpack_require__(1058);
	es.phone_number = __webpack_require__(1065);
	es.cell_phone = __webpack_require__(1046);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "es",
	  "info",
	  "com.es",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1055);
	internet.domain_suffix = __webpack_require__(1054);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adán",
	  "Agustín",
	  "Alberto",
	  "Alejandro",
	  "Alfonso",
	  "Alfredo",
	  "Andrés",
	  "Antonio",
	  "Armando",
	  "Arturo",
	  "Benito",
	  "Benjamín",
	  "Bernardo",
	  "Carlos",
	  "César",
	  "Claudio",
	  "Clemente",
	  "Cristian",
	  "Cristobal",
	  "Daniel",
	  "David",
	  "Diego",
	  "Eduardo",
	  "Emilio",
	  "Enrique",
	  "Ernesto",
	  "Esteban",
	  "Federico",
	  "Felipe",
	  "Fernando",
	  "Francisco",
	  "Gabriel",
	  "Gerardo",
	  "Germán",
	  "Gilberto",
	  "Gonzalo",
	  "Gregorio",
	  "Guillermo",
	  "Gustavo",
	  "Hernán",
	  "Homero",
	  "Horacio",
	  "Hugo",
	  "Ignacio",
	  "Jacobo",
	  "Jaime",
	  "Javier",
	  "Jerónimo",
	  "Jesús",
	  "Joaquín",
	  "Jorge",
	  "Jorge Luis",
	  "José",
	  "José Eduardo",
	  "José Emilio",
	  "José Luis",
	  "José María",
	  "Juan",
	  "Juan Carlos",
	  "Julio",
	  "Julio César",
	  "Lorenzo",
	  "Lucas",
	  "Luis",
	  "Luis Miguel",
	  "Manuel",
	  "Marco Antonio",
	  "Marcos",
	  "Mariano",
	  "Mario",
	  "Martín",
	  "Mateo",
	  "Miguel",
	  "Miguel Ángel",
	  "Nicolás",
	  "Octavio",
	  "Óscar",
	  "Pablo",
	  "Patricio",
	  "Pedro",
	  "Rafael",
	  "Ramiro",
	  "Ramón",
	  "Raúl",
	  "Ricardo",
	  "Roberto",
	  "Rodrigo",
	  "Rubén",
	  "Salvador",
	  "Samuel",
	  "Sancho",
	  "Santiago",
	  "Sergio",
	  "Teodoro",
	  "Timoteo",
	  "Tomás",
	  "Vicente",
	  "Víctor",
	  "Adela",
	  "Adriana",
	  "Alejandra",
	  "Alicia",
	  "Amalia",
	  "Ana",
	  "Ana Luisa",
	  "Ana María",
	  "Andrea",
	  "Anita",
	  "Ángela",
	  "Antonia",
	  "Ariadna",
	  "Barbara",
	  "Beatriz",
	  "Berta",
	  "Blanca",
	  "Caridad",
	  "Carla",
	  "Carlota",
	  "Carmen",
	  "Carolina",
	  "Catalina",
	  "Cecilia",
	  "Clara",
	  "Claudia",
	  "Concepción",
	  "Conchita",
	  "Cristina",
	  "Daniela",
	  "Débora",
	  "Diana",
	  "Dolores",
	  "Lola",
	  "Dorotea",
	  "Elena",
	  "Elisa",
	  "Eloisa",
	  "Elsa",
	  "Elvira",
	  "Emilia",
	  "Esperanza",
	  "Estela",
	  "Ester",
	  "Eva",
	  "Florencia",
	  "Francisca",
	  "Gabriela",
	  "Gloria",
	  "Graciela",
	  "Guadalupe",
	  "Guillermina",
	  "Inés",
	  "Irene",
	  "Isabel",
	  "Isabela",
	  "Josefina",
	  "Juana",
	  "Julia",
	  "Laura",
	  "Leonor",
	  "Leticia",
	  "Lilia",
	  "Lorena",
	  "Lourdes",
	  "Lucia",
	  "Luisa",
	  "Luz",
	  "Magdalena",
	  "Manuela",
	  "Marcela",
	  "Margarita",
	  "María",
	  "María del Carmen",
	  "María Cristina",
	  "María Elena",
	  "María Eugenia",
	  "María José",
	  "María Luisa",
	  "María Soledad",
	  "María Teresa",
	  "Mariana",
	  "Maricarmen",
	  "Marilu",
	  "Marisol",
	  "Marta",
	  "Mayte",
	  "Mercedes",
	  "Micaela",
	  "Mónica",
	  "Natalia",
	  "Norma",
	  "Olivia",
	  "Patricia",
	  "Pilar",
	  "Ramona",
	  "Raquel",
	  "Rebeca",
	  "Reina",
	  "Rocio",
	  "Rosa",
	  "Rosalia",
	  "Rosario",
	  "Sara",
	  "Silvia",
	  "Sofia",
	  "Soledad",
	  "Sonia",
	  "Susana",
	  "Teresa",
	  "Verónica",
	  "Victoria",
	  "Virginia",
	  "Yolanda"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1057);
	name.last_name = __webpack_require__(1059);
	name.prefix = __webpack_require__(1061);
	name.suffix = __webpack_require__(1062);
	name.title = __webpack_require__(1063);
	name.name = __webpack_require__(1060);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abeyta",
	  "Abrego",
	  "Abreu",
	  "Acevedo",
	  "Acosta",
	  "Acuña",
	  "Adame",
	  "Adorno",
	  "Agosto",
	  "Aguayo",
	  "Águilar",
	  "Aguilera",
	  "Aguirre",
	  "Alanis",
	  "Alaniz",
	  "Alarcón",
	  "Alba",
	  "Alcala",
	  "Alcántar",
	  "Alcaraz",
	  "Alejandro",
	  "Alemán",
	  "Alfaro",
	  "Alicea",
	  "Almanza",
	  "Almaraz",
	  "Almonte",
	  "Alonso",
	  "Alonzo",
	  "Altamirano",
	  "Alva",
	  "Alvarado",
	  "Alvarez",
	  "Amador",
	  "Amaya",
	  "Anaya",
	  "Anguiano",
	  "Angulo",
	  "Aparicio",
	  "Apodaca",
	  "Aponte",
	  "Aragón",
	  "Araña",
	  "Aranda",
	  "Arce",
	  "Archuleta",
	  "Arellano",
	  "Arenas",
	  "Arevalo",
	  "Arguello",
	  "Arias",
	  "Armas",
	  "Armendáriz",
	  "Armenta",
	  "Armijo",
	  "Arredondo",
	  "Arreola",
	  "Arriaga",
	  "Arroyo",
	  "Arteaga",
	  "Atencio",
	  "Ávalos",
	  "Ávila",
	  "Avilés",
	  "Ayala",
	  "Baca",
	  "Badillo",
	  "Báez",
	  "Baeza",
	  "Bahena",
	  "Balderas",
	  "Ballesteros",
	  "Banda",
	  "Bañuelos",
	  "Barajas",
	  "Barela",
	  "Barragán",
	  "Barraza",
	  "Barrera",
	  "Barreto",
	  "Barrientos",
	  "Barrios",
	  "Batista",
	  "Becerra",
	  "Beltrán",
	  "Benavides",
	  "Benavídez",
	  "Benítez",
	  "Bermúdez",
	  "Bernal",
	  "Berríos",
	  "Bétancourt",
	  "Blanco",
	  "Bonilla",
	  "Borrego",
	  "Botello",
	  "Bravo",
	  "Briones",
	  "Briseño",
	  "Brito",
	  "Bueno",
	  "Burgos",
	  "Bustamante",
	  "Bustos",
	  "Caballero",
	  "Cabán",
	  "Cabrera",
	  "Cadena",
	  "Caldera",
	  "Calderón",
	  "Calvillo",
	  "Camacho",
	  "Camarillo",
	  "Campos",
	  "Canales",
	  "Candelaria",
	  "Cano",
	  "Cantú",
	  "Caraballo",
	  "Carbajal",
	  "Cardenas",
	  "Cardona",
	  "Carmona",
	  "Carranza",
	  "Carrasco",
	  "Carrasquillo",
	  "Carreón",
	  "Carrera",
	  "Carrero",
	  "Carrillo",
	  "Carrion",
	  "Carvajal",
	  "Casanova",
	  "Casares",
	  "Casárez",
	  "Casas",
	  "Casillas",
	  "Castañeda",
	  "Castellanos",
	  "Castillo",
	  "Castro",
	  "Cavazos",
	  "Cazares",
	  "Ceballos",
	  "Cedillo",
	  "Ceja",
	  "Centeno",
	  "Cepeda",
	  "Cerda",
	  "Cervantes",
	  "Cervántez",
	  "Chacón",
	  "Chapa",
	  "Chavarría",
	  "Chávez",
	  "Cintrón",
	  "Cisneros",
	  "Collado",
	  "Collazo",
	  "Colón",
	  "Colunga",
	  "Concepción",
	  "Contreras",
	  "Cordero",
	  "Córdova",
	  "Cornejo",
	  "Corona",
	  "Coronado",
	  "Corral",
	  "Corrales",
	  "Correa",
	  "Cortés",
	  "Cortez",
	  "Cotto",
	  "Covarrubias",
	  "Crespo",
	  "Cruz",
	  "Cuellar",
	  "Curiel",
	  "Dávila",
	  "de Anda",
	  "de Jesús",
	  "Delacrúz",
	  "Delafuente",
	  "Delagarza",
	  "Delao",
	  "Delapaz",
	  "Delarosa",
	  "Delatorre",
	  "Deleón",
	  "Delgadillo",
	  "Delgado",
	  "Delrío",
	  "Delvalle",
	  "Díaz",
	  "Domínguez",
	  "Domínquez",
	  "Duarte",
	  "Dueñas",
	  "Duran",
	  "Echevarría",
	  "Elizondo",
	  "Enríquez",
	  "Escalante",
	  "Escamilla",
	  "Escobar",
	  "Escobedo",
	  "Esparza",
	  "Espinal",
	  "Espino",
	  "Espinosa",
	  "Espinoza",
	  "Esquibel",
	  "Esquivel",
	  "Estévez",
	  "Estrada",
	  "Fajardo",
	  "Farías",
	  "Feliciano",
	  "Fernández",
	  "Ferrer",
	  "Fierro",
	  "Figueroa",
	  "Flores",
	  "Flórez",
	  "Fonseca",
	  "Franco",
	  "Frías",
	  "Fuentes",
	  "Gaitán",
	  "Galarza",
	  "Galindo",
	  "Gallardo",
	  "Gallegos",
	  "Galván",
	  "Gálvez",
	  "Gamboa",
	  "Gamez",
	  "Gaona",
	  "Garay",
	  "García",
	  "Garibay",
	  "Garica",
	  "Garrido",
	  "Garza",
	  "Gastélum",
	  "Gaytán",
	  "Gil",
	  "Girón",
	  "Godínez",
	  "Godoy",
	  "Gómez",
	  "Gonzales",
	  "González",
	  "Gollum",
	  "Gracia",
	  "Granado",
	  "Granados",
	  "Griego",
	  "Grijalva",
	  "Guajardo",
	  "Guardado",
	  "Guerra",
	  "Guerrero",
	  "Guevara",
	  "Guillen",
	  "Gurule",
	  "Gutiérrez",
	  "Guzmán",
	  "Haro",
	  "Henríquez",
	  "Heredia",
	  "Hernádez",
	  "Hernandes",
	  "Hernández",
	  "Herrera",
	  "Hidalgo",
	  "Hinojosa",
	  "Holguín",
	  "Huerta",
	  "Hurtado",
	  "Ibarra",
	  "Iglesias",
	  "Irizarry",
	  "Jaime",
	  "Jaimes",
	  "Jáquez",
	  "Jaramillo",
	  "Jasso",
	  "Jiménez",
	  "Jimínez",
	  "Juárez",
	  "Jurado",
	  "Laboy",
	  "Lara",
	  "Laureano",
	  "Leal",
	  "Lebrón",
	  "Ledesma",
	  "Leiva",
	  "Lemus",
	  "León",
	  "Lerma",
	  "Leyva",
	  "Limón",
	  "Linares",
	  "Lira",
	  "Llamas",
	  "Loera",
	  "Lomeli",
	  "Longoria",
	  "López",
	  "Lovato",
	  "Loya",
	  "Lozada",
	  "Lozano",
	  "Lucero",
	  "Lucio",
	  "Luevano",
	  "Lugo",
	  "Luna",
	  "Macías",
	  "Madera",
	  "Madrid",
	  "Madrigal",
	  "Maestas",
	  "Magaña",
	  "Malave",
	  "Maldonado",
	  "Manzanares",
	  "Mares",
	  "Marín",
	  "Márquez",
	  "Marrero",
	  "Marroquín",
	  "Martínez",
	  "Mascareñas",
	  "Mata",
	  "Mateo",
	  "Matías",
	  "Matos",
	  "Maya",
	  "Mayorga",
	  "Medina",
	  "Medrano",
	  "Mejía",
	  "Meléndez",
	  "Melgar",
	  "Mena",
	  "Menchaca",
	  "Méndez",
	  "Mendoza",
	  "Menéndez",
	  "Meraz",
	  "Mercado",
	  "Merino",
	  "Mesa",
	  "Meza",
	  "Miramontes",
	  "Miranda",
	  "Mireles",
	  "Mojica",
	  "Molina",
	  "Mondragón",
	  "Monroy",
	  "Montalvo",
	  "Montañez",
	  "Montaño",
	  "Montemayor",
	  "Montenegro",
	  "Montero",
	  "Montes",
	  "Montez",
	  "Montoya",
	  "Mora",
	  "Morales",
	  "Moreno",
	  "Mota",
	  "Moya",
	  "Munguía",
	  "Muñiz",
	  "Muñoz",
	  "Murillo",
	  "Muro",
	  "Nájera",
	  "Naranjo",
	  "Narváez",
	  "Nava",
	  "Navarrete",
	  "Navarro",
	  "Nazario",
	  "Negrete",
	  "Negrón",
	  "Nevárez",
	  "Nieto",
	  "Nieves",
	  "Niño",
	  "Noriega",
	  "Núñez",
	  "Ocampo",
	  "Ocasio",
	  "Ochoa",
	  "Ojeda",
	  "Olivares",
	  "Olivárez",
	  "Olivas",
	  "Olivera",
	  "Olivo",
	  "Olmos",
	  "Olvera",
	  "Ontiveros",
	  "Oquendo",
	  "Ordóñez",
	  "Orellana",
	  "Ornelas",
	  "Orosco",
	  "Orozco",
	  "Orta",
	  "Ortega",
	  "Ortiz",
	  "Osorio",
	  "Otero",
	  "Ozuna",
	  "Pabón",
	  "Pacheco",
	  "Padilla",
	  "Padrón",
	  "Páez",
	  "Pagan",
	  "Palacios",
	  "Palomino",
	  "Palomo",
	  "Pantoja",
	  "Paredes",
	  "Parra",
	  "Partida",
	  "Patiño",
	  "Paz",
	  "Pedraza",
	  "Pedroza",
	  "Pelayo",
	  "Peña",
	  "Perales",
	  "Peralta",
	  "Perea",
	  "Peres",
	  "Pérez",
	  "Pichardo",
	  "Piña",
	  "Pineda",
	  "Pizarro",
	  "Polanco",
	  "Ponce",
	  "Porras",
	  "Portillo",
	  "Posada",
	  "Prado",
	  "Preciado",
	  "Prieto",
	  "Puente",
	  "Puga",
	  "Pulido",
	  "Quesada",
	  "Quezada",
	  "Quiñones",
	  "Quiñónez",
	  "Quintana",
	  "Quintanilla",
	  "Quintero",
	  "Quiroz",
	  "Rael",
	  "Ramírez",
	  "Ramón",
	  "Ramos",
	  "Rangel",
	  "Rascón",
	  "Raya",
	  "Razo",
	  "Regalado",
	  "Rendón",
	  "Rentería",
	  "Reséndez",
	  "Reyes",
	  "Reyna",
	  "Reynoso",
	  "Rico",
	  "Rincón",
	  "Riojas",
	  "Ríos",
	  "Rivas",
	  "Rivera",
	  "Rivero",
	  "Robledo",
	  "Robles",
	  "Rocha",
	  "Rodarte",
	  "Rodrígez",
	  "Rodríguez",
	  "Rodríquez",
	  "Rojas",
	  "Rojo",
	  "Roldán",
	  "Rolón",
	  "Romero",
	  "Romo",
	  "Roque",
	  "Rosado",
	  "Rosales",
	  "Rosario",
	  "Rosas",
	  "Roybal",
	  "Rubio",
	  "Ruelas",
	  "Ruiz",
	  "Saavedra",
	  "Sáenz",
	  "Saiz",
	  "Salas",
	  "Salazar",
	  "Salcedo",
	  "Salcido",
	  "Saldaña",
	  "Saldivar",
	  "Salgado",
	  "Salinas",
	  "Samaniego",
	  "Sanabria",
	  "Sanches",
	  "Sánchez",
	  "Sandoval",
	  "Santacruz",
	  "Santana",
	  "Santiago",
	  "Santillán",
	  "Sarabia",
	  "Sauceda",
	  "Saucedo",
	  "Sedillo",
	  "Segovia",
	  "Segura",
	  "Sepúlveda",
	  "Serna",
	  "Serrano",
	  "Serrato",
	  "Sevilla",
	  "Sierra",
	  "Sisneros",
	  "Solano",
	  "Solís",
	  "Soliz",
	  "Solorio",
	  "Solorzano",
	  "Soria",
	  "Sosa",
	  "Sotelo",
	  "Soto",
	  "Suárez",
	  "Tafoya",
	  "Tamayo",
	  "Tamez",
	  "Tapia",
	  "Tejada",
	  "Tejeda",
	  "Téllez",
	  "Tello",
	  "Terán",
	  "Terrazas",
	  "Tijerina",
	  "Tirado",
	  "Toledo",
	  "Toro",
	  "Torres",
	  "Tórrez",
	  "Tovar",
	  "Trejo",
	  "Treviño",
	  "Trujillo",
	  "Ulibarri",
	  "Ulloa",
	  "Urbina",
	  "Ureña",
	  "Urías",
	  "Uribe",
	  "Urrutia",
	  "Vaca",
	  "Valadez",
	  "Valdés",
	  "Valdez",
	  "Valdivia",
	  "Valencia",
	  "Valentín",
	  "Valenzuela",
	  "Valladares",
	  "Valle",
	  "Vallejo",
	  "Valles",
	  "Valverde",
	  "Vanegas",
	  "Varela",
	  "Vargas",
	  "Vásquez",
	  "Vázquez",
	  "Vega",
	  "Vela",
	  "Velasco",
	  "Velásquez",
	  "Velázquez",
	  "Vélez",
	  "Véliz",
	  "Venegas",
	  "Vera",
	  "Verdugo",
	  "Verduzco",
	  "Vergara",
	  "Viera",
	  "Vigil",
	  "Villa",
	  "Villagómez",
	  "Villalobos",
	  "Villalpando",
	  "Villanueva",
	  "Villareal",
	  "Villarreal",
	  "Villaseñor",
	  "Villegas",
	  "Yáñez",
	  "Ybarra",
	  "Zambrano",
	  "Zamora",
	  "Zamudio",
	  "Zapata",
	  "Zaragoza",
	  "Zarate",
	  "Zavala",
	  "Zayas",
	  "Zelaya",
	  "Zepeda",
	  "Zúñiga"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sr.",
	  "Sra.",
	  "Sta."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V",
	  "MD",
	  "DDS",
	  "PhD",
	  "DVM"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Jefe",
	    "Senior",
	    "Directo",
	    "Corporativo",
	    "Dinánmico",
	    "Futuro",
	    "Producto",
	    "Nacional",
	    "Regional",
	    "Distrito",
	    "Central",
	    "Global",
	    "Cliente",
	    "Inversor",
	    "International",
	    "Heredado",
	    "Adelante",
	    "Interno",
	    "Humano",
	    "Gerente",
	    "Director"
	  ],
	  "level": [
	    "Soluciones",
	    "Programa",
	    "Marca",
	    "Seguridada",
	    "Investigación",
	    "Marketing",
	    "Normas",
	    "Implementación",
	    "Integración",
	    "Funcionalidad",
	    "Respuesta",
	    "Paradigma",
	    "Tácticas",
	    "Identidad",
	    "Mercados",
	    "Grupo",
	    "División",
	    "Aplicaciones",
	    "Optimización",
	    "Operaciones",
	    "Infraestructura",
	    "Intranet",
	    "Comunicaciones",
	    "Web",
	    "Calidad",
	    "Seguro",
	    "Mobilidad",
	    "Cuentas",
	    "Datos",
	    "Creativo",
	    "Configuración",
	    "Contabilidad",
	    "Interacciones",
	    "Factores",
	    "Usabilidad",
	    "Métricas"
	  ],
	  "job": [
	    "Supervisor",
	    "Asociado",
	    "Ejecutivo",
	    "Relacciones",
	    "Oficial",
	    "Gerente",
	    "Ingeniero",
	    "Especialista",
	    "Director",
	    "Coordinador",
	    "Administrador",
	    "Arquitecto",
	    "Analista",
	    "Diseñador",
	    "Planificador",
	    "Técnico",
	    "Funcionario",
	    "Desarrollador",
	    "Productor",
	    "Consultor",
	    "Asistente",
	    "Facilitador",
	    "Agente",
	    "Representante",
	    "Estratega"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "9##-###-###",
	  "9##.###.###",
	  "9## ### ###",
	  "9########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1064);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  " s/n.",
	  ", #",
	  ", ##",
	  " #",
	  " ##",
	  " ###",
	  " ####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aguascalientes",
	  "Apodaca",
	  "Buenavista",
	  "Campeche",
	  "Cancún",
	  "Cárdenas",
	  "Celaya",
	  "Chalco",
	  "Chetumal",
	  "Chicoloapan",
	  "Chignahuapan",
	  "Chihuahua",
	  "Chilpancingo",
	  "Chimalhuacán",
	  "Ciudad Acuña",
	  "Ciudad de México",
	  "Ciudad del Carmen",
	  "Ciudad López Mateos",
	  "Ciudad Madero",
	  "Ciudad Obregón",
	  "Ciudad Valles",
	  "Ciudad Victoria",
	  "Coatzacoalcos",
	  "Colima-Villa de Álvarez",
	  "Comitán de Dominguez",
	  "Córdoba",
	  "Cuautitlán Izcalli",
	  "Cuautla",
	  "Cuernavaca",
	  "Culiacán",
	  "Delicias",
	  "Durango",
	  "Ensenada",
	  "Fresnillo",
	  "General Escobedo",
	  "Gómez Palacio",
	  "Guadalajara",
	  "Guadalupe",
	  "Guanajuato",
	  "Guaymas",
	  "Hermosillo",
	  "Hidalgo del Parral",
	  "Iguala",
	  "Irapuato",
	  "Ixtapaluca",
	  "Jiutepec",
	  "Juárez",
	  "La Laguna",
	  "La Paz",
	  "La Piedad-Pénjamo",
	  "León",
	  "Los Cabos",
	  "Los Mochis",
	  "Manzanillo",
	  "Matamoros",
	  "Mazatlán",
	  "Mérida",
	  "Mexicali",
	  "Minatitlán",
	  "Miramar",
	  "Monclova",
	  "Monclova-Frontera",
	  "Monterrey",
	  "Morelia",
	  "Naucalpan de Juárez",
	  "Navojoa",
	  "Nezahualcóyotl",
	  "Nogales",
	  "Nuevo Laredo",
	  "Oaxaca",
	  "Ocotlán",
	  "Ojo de agua",
	  "Orizaba",
	  "Pachuca",
	  "Piedras Negras",
	  "Poza Rica",
	  "Puebla",
	  "Puerto Vallarta",
	  "Querétaro",
	  "Reynosa-Río Bravo",
	  "Rioverde-Ciudad Fernández",
	  "Salamanca",
	  "Saltillo",
	  "San Cristobal de las Casas",
	  "San Francisco Coacalco",
	  "San Francisco del Rincón",
	  "San Juan Bautista Tuxtepec",
	  "San Juan del Río",
	  "San Luis Potosí-Soledad",
	  "San Luis Río Colorado",
	  "San Nicolás de los Garza",
	  "San Pablo de las Salinas",
	  "San Pedro Garza García",
	  "Santa Catarina",
	  "Soledad de Graciano Sánchez",
	  "Tampico-Pánuco",
	  "Tapachula",
	  "Tecomán",
	  "Tehuacán",
	  "Tehuacán",
	  "Tehuantepec-Salina Cruz",
	  "Tepexpan",
	  "Tepic",
	  "Tetela de Ocampo",
	  "Texcoco de Mora",
	  "Tijuana",
	  "Tlalnepantla",
	  "Tlaquepaque",
	  "Tlaxcala-Apizaco",
	  "Toluca",
	  "Tonalá",
	  "Torreón",
	  "Tula",
	  "Tulancingo",
	  "Tulancingo de Bravo",
	  "Tuxtla Gutiérrez",
	  "Uruapan",
	  "Uruapan del Progreso",
	  "Valle de México",
	  "Veracruz",
	  "Villa de Álvarez",
	  "Villa Nicolás Romero",
	  "Villahermosa",
	  "Xalapa",
	  "Zacatecas-Guadalupe",
	  "Zacatlan",
	  "Zacatzingo",
	  "Zamora-Jacona",
	  "Zapopan",
	  "Zitacuaro"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "town",
	  "ton",
	  "land",
	  "ville",
	  "berg",
	  "burgh",
	  "borough",
	  "bury",
	  "view",
	  "port",
	  "mouth",
	  "stad",
	  "furt",
	  "chester",
	  "mouth",
	  "fort",
	  "haven",
	  "side",
	  "shire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistán",
	  "Albania",
	  "Argelia",
	  "Andorra",
	  "Angola",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbayán",
	  "Bahamas",
	  "Barein",
	  "Bangladesh",
	  "Barbados",
	  "Bielorusia",
	  "Bélgica",
	  "Belice",
	  "Bermuda",
	  "Bután",
	  "Bolivia",
	  "Bosnia Herzegovina",
	  "Botswana",
	  "Brasil",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Camboya",
	  "Camerún",
	  "Canada",
	  "Cabo Verde",
	  "Islas Caimán",
	  "Chad",
	  "Chile",
	  "China",
	  "Isla de Navidad",
	  "Colombia",
	  "Comodos",
	  "Congo",
	  "Costa Rica",
	  "Costa de Marfil",
	  "Croacia",
	  "Cuba",
	  "Chipre",
	  "República Checa",
	  "Dinamarca",
	  "Dominica",
	  "República Dominicana",
	  "Ecuador",
	  "Egipto",
	  "El Salvador",
	  "Guinea Ecuatorial",
	  "Eritrea",
	  "Estonia",
	  "Etiopía",
	  "Islas Faro",
	  "Fiji",
	  "Finlandia",
	  "Francia",
	  "Gabón",
	  "Gambia",
	  "Georgia",
	  "Alemania",
	  "Ghana",
	  "Grecia",
	  "Groenlandia",
	  "Granada",
	  "Guadalupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bisau",
	  "Guayana",
	  "Haiti",
	  "Honduras",
	  "Hong Kong",
	  "Hungria",
	  "Islandia",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Irak",
	  "Irlanda",
	  "Italia",
	  "Jamaica",
	  "Japón",
	  "Jordania",
	  "Kazajistan",
	  "Kenia",
	  "Kiribati",
	  "Corea",
	  "Kuwait",
	  "Letonia",
	  "Líbano",
	  "Liberia",
	  "Liechtenstein",
	  "Lituania",
	  "Luxemburgo",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malasia",
	  "Maldivas",
	  "Mali",
	  "Malta",
	  "Martinica",
	  "Mauritania",
	  "México",
	  "Micronesia",
	  "Moldavia",
	  "Mónaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Marruecos",
	  "Mozambique",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Holanda",
	  "Nueva Zelanda",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Noruega",
	  "Omán",
	  "Pakistan",
	  "Panamá",
	  "Papúa Nueva Guinea",
	  "Paraguay",
	  "Perú",
	  "Filipinas",
	  "Poland",
	  "Portugal",
	  "Puerto Rico",
	  "Rusia",
	  "Ruanda",
	  "Samoa",
	  "San Marino",
	  "Santo Tomé y Principe",
	  "Arabia Saudí",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leona",
	  "Singapur",
	  "Eslovaquia",
	  "Eslovenia",
	  "Somalia",
	  "España",
	  "Sri Lanka",
	  "Sudán",
	  "Suriname",
	  "Suecia",
	  "Suiza",
	  "Siria",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Tailandia",
	  "Timor-Leste",
	  "Togo",
	  "Tonga",
	  "Trinidad y Tobago",
	  "Tunez",
	  "Turquia",
	  "Uganda",
	  "Ucrania",
	  "Emiratos Árabes Unidos",
	  "Reino Unido",
	  "Estados Unidos de América",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "México"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1068);
	address.city_suffix = __webpack_require__(1069);
	address.country = __webpack_require__(1070);
	address.building_number = __webpack_require__(1066);
	address.street_suffix = __webpack_require__(1080);
	address.secondary_address = __webpack_require__(1074);
	address.postcode = __webpack_require__(1073);
	address.state = __webpack_require__(1075);
	address.state_abbr = __webpack_require__(1076);
	address.time_zone = __webpack_require__(1081);
	address.city = __webpack_require__(1067);
	address.street = __webpack_require__(1077);
	address.street_name = __webpack_require__(1079);
	address.street_address = __webpack_require__(1078);
	address.default_country = __webpack_require__(1071);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Esc. ###",
	  "Puerta ###",
	  "Edificio #"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aguascalientes",
	  "Baja California Norte",
	  "Baja California Sur",
	  'Estado de México',
	  "Campeche",
	  "Chiapas",
	  "Chihuahua",
	  "Coahuila",
	  "Colima",
	  "Durango",
	  "Guanajuato",
	  "Guerrero",
	  "Hidalgo",
	  "Jalisco",
	  "Michoacan",
	  "Morelos",
	  "Nayarit",
	  'Nuevo León',
	  "Oaxaca",
	  "Puebla",
	  "Querétaro",
	  "Quintana Roo",
	  "San Luis Potosí",
	  "Sinaloa",
	  "Sonora",
	  "Tabasco",
	  "Tamaulipas",
	  "Tlaxcala",
	  "Veracruz",
	  "Yucatán",
	  "Zacatecas"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AS",
	  "BC",
	  "BS",
	  "CC",
	  "CS",
	  "CH",
	  "CL",
	  "CM",
	  "DF",
	  "DG",
	  "GT",
	  "GR",
	  "HG",
	  "JC",
	  "MC",
	  "MN",
	  "MS",
	  "NT",
	  "NL",
	  "OC",
	  "PL",
	  "QT",
	  "QR",
	  "SP",
	  "SL",
	  "SR",
	  "TC",
	  "TS",
	  "TL",
	  "VZ",
	  "YN",
	  "ZS"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
		"20 de Noviembre",
		"Cinco de Mayo",
		"Cuahutemoc",
		"Manzanares",
		"Donceles",
		"Francisco I. Madero",
		"Juárez",
		"Repúplica de Cuba",
		"Repúplica de Chile",
		"Repúplica de Argentina",
		"Repúplica de Uruguay",
		"Isabel la Católica",
		"Izazaga",
		"Eje Central",
		"Eje 6",
		"Eje 5",
		"La viga",
		"Aniceto Ortega",
		"Miguel Ángel de Quevedo",
		"Amores",
		"Coyoacán",
		"Coruña",
		"Batalla de Naco",
		"La otra banda",
		"Piedra del Comal",
		"Balcón de los edecanes",
		"Barrio la Lonja",
		"Jicolapa",
		"Zacatlán",
		"Zapata",
		"Polotitlan",
		"Calimaya",
		"Flor Marina",
		"Flor Solvestre",
		"San Miguel",
		"Naranjo",
		"Cedro",
		"Jalisco",
		"Avena"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}",
	  "#{street_name}#{building_number} #{secondary_address}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Name.first_name}",
	  "#{street_suffix} #{Name.first_name} #{Name.last_name}",
	  "#{street_suffix} #{street}",
	  "#{street_suffix} #{street}",
	  "#{street_suffix} #{street}",
	  "#{street_suffix} #{street}"
	
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aldea",
	  "Apartamento",
	  "Arrabal",
	  "Arroyo",
	  "Avenida",
	  "Bajada",
	  "Barranco",
	  "Barrio",
	  "Bloque",
	  "Calle",
	  "Calleja",
	  "Camino",
	  "Carretera",
	  "Caserio",
	  "Colegio",
	  "Colonia",
	  "Conjunto",
	  "Cuesta",
	  "Chalet",
	  "Edificio",
	  "Entrada",
	  "Escalinata",
	  "Explanada",
	  "Extramuros",
	  "Extrarradio",
	  "Ferrocarril",
	  "Glorieta",
	  "Gran Subida",
	  "Grupo",
	  "Huerta",
	  "Jardines",
	  "Lado",
	  "Lugar",
	  "Manzana",
	  "Masía",
	  "Mercado",
	  "Monte",
	  "Muelle",
	  "Municipio",
	  "Parcela",
	  "Parque",
	  "Partida",
	  "Pasaje",
	  "Paseo",
	  "Plaza",
	  "Poblado",
	  "Polígono",
	  "Prolongación",
	  "Puente",
	  "Puerta",
	  "Quinta",
	  "Ramal",
	  "Rambla",
	  "Rampa",
	  "Riera",
	  "Rincón",
	  "Ronda",
	  "Rua",
	  "Salida",
	  "Sector",
	  "Sección",
	  "Senda",
	  "Solar",
	  "Subida",
	  "Terrenos",
	  "Torrente",
	  "Travesía",
	  "Urbanización",
	  "Vía",
	  "Vía Pública"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacífico/Midway",
	  "Pacífico/Pago_Pago",
	  "Pacífico/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europa/Dublin",
	  "Europa/London",
	  "Europa/Lisbon",
	  "Europa/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europa/Belgrade",
	  "Europa/Bratislava",
	  "Europa/Budapest",
	  "Europa/Ljubljana",
	  "Europa/Prague",
	  "Europa/Sarajevo",
	  "Europa/Skopje",
	  "Europa/Warsaw",
	  "Europa/Zagreb",
	  "Europa/Brussels",
	  "Europa/Copenhagen",
	  "Europa/Madrid",
	  "Europa/Paris",
	  "Europa/Amsterdam",
	  "Europa/Berlin",
	  "Europa/Berlin",
	  "Europa/Rome",
	  "Europa/Stockholm",
	  "Europa/Vienna",
	  "Africa/Algiers",
	  "Europa/Bucharest",
	  "Africa/Cairo",
	  "Europa/Helsinki",
	  "Europa/Kiev",
	  "Europa/Riga",
	  "Europa/Sofia",
	  "Europa/Tallinn",
	  "Europa/Vilnius",
	  "Europa/Athens",
	  "Europa/Istanbul",
	  "Europa/Minsk",
	  "Asia/Jerusalen",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacífico/Guam",
	  "Pacífico/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacífico/Noumea",
	  "Pacífico/Fiji",
	  "Asia/Kamchatka",
	  "Pacífico/Majuro",
	  "Pacífico/Auckland",
	  "Pacífico/Auckland",
	  "Pacífico/Tongatapu",
	  "Pacífico/Fakaofo",
	  "Pacífico/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "5##-###-###",
	  "5##.###.###",
	  "5## ### ###",
	  "5########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1082);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "rojo",
	   "verde",
	   "azul",
	   "amarillo",
	   "morado",
	   "Menta verde",
	   "teal",
	   "blanco",
	   "negro",
	   "Naranja",
	   "Rosa",
	   "gris",
	   "marrón",
	   "violeta",
	   "turquesa",
	   "tan",
	   "cielo azul",
	   "salmón",
	   "ciruela",
	   "orquídea",
	   "aceituna",
	   "magenta",
	   "Lima",
	   "marfil",
	   "índigo",
	   "oro",
	   "fucsia",
	   "cian",
	   "azul",
	   "lavanda",
	   "plata"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "Libros",
	   "Películas",
	   "Música",
	   "Juegos",
	   "Electrónica",
	   "Ordenadores",
	   "Hogar",
	   "Jardín",
	   "Herramientas",
	   "Ultramarinos",
	   "Salud",
	   "Belleza",
	   "Juguetes",
	   "Kids",
	   "Baby",
	   "Ropa",
	   "Zapatos",
	   "Joyería",
	   "Deportes",
	   "Aire libre",
	   "Automoción",
	   "Industrial"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(1084);
	commerce.department = __webpack_require__(1085);
	commerce.product_name = __webpack_require__(1087);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	"adjective": [
	     "Pequeño",
	     "Ergonómico",
	     "Rústico",
	     "Inteligente",
	     "Gorgeous",
	     "Increíble",
	     "Fantástico",
	     "Práctica",
	     "Elegante",
	     "Increíble",
	     "Genérica",
	     "Artesanal",
	     "Hecho a mano",
	     "Licencia",
	     "Refinado",
	     "Sin marca",
	     "Sabrosa"
	   ],
	"material": [
	     "Acero",
	     "Madera",
	     "Hormigón",
	     "Plástico",
	     "Cotton",
	     "Granito",
	     "Caucho",
	     "Metal",
	     "Soft",
	     "Fresco",
	     "Frozen"
	   ],
	"product": [
	     "Presidente",
	     "Auto",
	     "Computadora",
	     "Teclado",
	     "Ratón",
	     "Bike",
	     "Pelota",
	     "Guantes",
	     "Pantalones",
	     "Camisa",
	     "Mesa",
	     "Zapatos",
	     "Sombrero",
	     "Toallas",
	     "Jabón",
	     "Tuna",
	     "Pollo",
	     "Pescado",
	     "Queso",
	     "Tocino",
	     "Pizza",
	     "Ensalada",
	     "Embutidos"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptativo",
	  "Avanzado",
	  "Asimilado",
	  "Automatizado",
	  "Equilibrado",
	  "Centrado en el negocio",
	  "Centralizado",
	  "Clonado",
	  "Compatible",
	  "Configurable",
	  "Multi grupo",
	  "Multi plataforma",
	  "Centrado en el usuario",
	  "Configurable",
	  "Descentralizado",
	  "Digitalizado",
	  "Distribuido",
	  "Diverso",
	  "Reducido",
	  "Mejorado",
	  "Para toda la empresa",
	  "Ergonomico",
	  "Exclusivo",
	  "Expandido",
	  "Extendido",
	  "Cara a cara",
	  "Enfocado",
	  "Totalmente configurable",
	  "Fundamental",
	  "Orígenes",
	  "Horizontal",
	  "Implementado",
	  "Innovador",
	  "Integrado",
	  "Intuitivo",
	  "Inverso",
	  "Gestionado",
	  "Obligatorio",
	  "Monitorizado",
	  "Multi canal",
	  "Multi lateral",
	  "Multi capa",
	  "En red",
	  "Orientado a objetos",
	  "Open-source",
	  "Operativo",
	  "Optimizado",
	  "Opcional",
	  "Organico",
	  "Organizado",
	  "Perseverando",
	  "Persistente",
	  "en fases",
	  "Polarizado",
	  "Pre-emptivo",
	  "Proactivo",
	  "Enfocado a benficios",
	  "Profundo",
	  "Programable",
	  "Progresivo",
	  "Public-key",
	  "Enfocado en la calidad",
	  "Reactivo",
	  "Realineado",
	  "Re-contextualizado",
	  "Re-implementado",
	  "Reducido",
	  "Ingenieria inversa",
	  "Robusto",
	  "Fácil",
	  "Seguro",
	  "Auto proporciona",
	  "Compartible",
	  "Intercambiable",
	  "Sincronizado",
	  "Orientado a equipos",
	  "Total",
	  "Universal",
	  "Mejorado",
	  "Actualizable",
	  "Centrado en el usuario",
	  "Amigable",
	  "Versatil",
	  "Virtual",
	  "Visionario"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Clics y mortero",
	  "Valor añadido",
	  "Vertical",
	  "Proactivo",
	  "Robusto",
	  "Revolucionario",
	  "Escalable",
	  "De vanguardia",
	  "Innovador",
	  "Intuitivo",
	  "Estratégico",
	  "E-business",
	  "Misión crítica",
	  "Pegajosa",
	  "Doce y cincuenta y nueve de la noche",
	  "24/7",
	  "De extremo a extremo",
	  "Global",
	  "B2B",
	  "B2C",
	  "Granular",
	  "Fricción",
	  "Virtual",
	  "Viral",
	  "Dinámico",
	  "24/365",
	  "Mejor de su clase",
	  "Asesino",
	  "Magnética",
	  "Filo sangriento",
	  "Habilitado web",
	  "Interactiva",
	  "Punto com",
	  "Sexy",
	  "Back-end",
	  "Tiempo real",
	  "Eficiente",
	  "Frontal",
	  "Distribuida",
	  "Sin costura",
	  "Extensible",
	  "Llave en mano",
	  "Clase mundial",
	  "Código abierto",
	  "Multiplataforma",
	  "Cross-media",
	  "Sinérgico",
	  "ladrillos y clics",
	  "Fuera de la caja",
	  "Empresa",
	  "Integrado",
	  "Impactante",
	  "Inalámbrico",
	  "Transparente",
	  "Próxima generación",
	  "Innovador",
	  "User-centric",
	  "Visionario",
	  "A medida",
	  "Ubicua",
	  "Enchufa y juega",
	  "Colaboración",
	  "Convincente",
	  "Holístico",
	  "Ricos"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "sinergias",
	   "web-readiness",
	   "paradigmas",
	   "mercados",
	   "asociaciones",
	   "infraestructuras",
	   "plataformas",
	   "iniciativas",
	   "canales",
	   "ojos",
	   "comunidades",
	   "ROI",
	   "soluciones",
	   "minoristas electrónicos",
	   "e-servicios",
	   "elementos de acción",
	   "portales",
	   "nichos",
	   "tecnologías",
	   "contenido",
	   "vortales",
	   "cadenas de suministro",
	   "convergencia",
	   "relaciones",
	   "arquitecturas",
	   "interfaces",
	   "mercados electrónicos",
	   "e-commerce",
	   "sistemas",
	   "ancho de banda",
	   "infomediarios",
	   "modelos",
	   "Mindshare",
	   "entregables",
	   "usuarios",
	   "esquemas",
	   "redes",
	   "aplicaciones",
	   "métricas",
	   "e-business",
	   "funcionalidades",
	   "experiencias",
	   "servicios web",
	   "metodologías"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "poner en práctica",
	   "utilizar",
	   "integrar",
	   "racionalizar",
	   "optimizar",
	   "evolucionar",
	   "transformar",
	   "abrazar",
	   "habilitar",
	   "orquestar",
	   "apalancamiento",
	   "reinventar",
	   "agregado",
	   "arquitecto",
	   "mejorar",
	   "incentivar",
	   "transformarse",
	   "empoderar",
	   "Envisioneer",
	   "monetizar",
	   "arnés",
	   "facilitar",
	   "aprovechar",
	   "desintermediar",
	   "sinergia",
	   "estrategias",
	   "desplegar",
	   "marca",
	   "crecer",
	   "objetivo",
	   "sindicato",
	   "sintetizar",
	   "entregue",
	   "malla",
	   "incubar",
	   "enganchar",
	   "maximizar",
	   "punto de referencia",
	   "acelerar",
	   "reintermediate",
	   "pizarra",
	   "visualizar",
	   "reutilizar",
	   "innovar",
	   "escala",
	   "desatar",
	   "conducir",
	   "extender",
	   "ingeniero",
	   "revolucionar",
	   "generar",
	   "explotar",
	   "transición",
	   "e-enable",
	   "repetir",
	   "cultivar",
	   "matriz",
	   "productize",
	   "redefinir",
	   "recontextualizar"
	]
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 horas",
	  "24/7",
	  "3rd generación",
	  "4th generación",
	  "5th generación",
	  "6th generación",
	  "analizada",
	  "asimétrica",
	  "asíncrona",
	  "monitorizada por red",
	  "bidireccional",
	  "bifurcada",
	  "generada por el cliente",
	  "cliente servidor",
	  "coherente",
	  "cohesiva",
	  "compuesto",
	  "sensible al contexto",
	  "basado en el contexto",
	  "basado en contenido",
	  "dedicada",
	  "generado por la demanda",
	  "didactica",
	  "direccional",
	  "discreta",
	  "dinámica",
	  "potenciada",
	  "acompasada",
	  "ejecutiva",
	  "explícita",
	  "tolerante a fallos",
	  "innovadora",
	  "amplio ábanico",
	  "global",
	  "heurística",
	  "alto nivel",
	  "holística",
	  "homogénea",
	  "hibrida",
	  "incremental",
	  "intangible",
	  "interactiva",
	  "intermedia",
	  "local",
	  "logística",
	  "maximizada",
	  "metódica",
	  "misión crítica",
	  "móbil",
	  "modular",
	  "motivadora",
	  "multimedia",
	  "multiestado",
	  "multitarea",
	  "nacional",
	  "basado en necesidades",
	  "neutral",
	  "nueva generación",
	  "no-volátil",
	  "orientado a objetos",
	  "óptima",
	  "optimizada",
	  "radical",
	  "tiempo real",
	  "recíproca",
	  "regional",
	  "escalable",
	  "secundaria",
	  "orientada a soluciones",
	  "estable",
	  "estatica",
	  "sistemática",
	  "sistémica",
	  "tangible",
	  "terciaria",
	  "transicional",
	  "uniforme",
	  "valor añadido",
	  "vía web",
	  "defectos cero",
	  "tolerancia cero"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1096);
	company.adjective = __webpack_require__(1088);
	company.descriptor = __webpack_require__(1092);
	company.noun = __webpack_require__(1095);
	company.bs_verb = __webpack_require__(1091);
	company.name = __webpack_require__(1094);
	company.bs_adjective = __webpack_require__(1089);
	company.bs_noun = __webpack_require__(1090);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} y #{Name.last_name}",
	  "#{Name.last_name} #{Name.last_name} #{suffix}",
	  "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "habilidad",
	  "acceso",
	  "adaptador",
	  "algoritmo",
	  "alianza",
	  "analista",
	  "aplicación",
	  "enfoque",
	  "arquitectura",
	  "archivo",
	  "inteligencia artificial",
	  "array",
	  "actitud",
	  "medición",
	  "gestión presupuestaria",
	  "capacidad",
	  "desafío",
	  "circuito",
	  "colaboración",
	  "complejidad",
	  "concepto",
	  "conglomeración",
	  "contingencia",
	  "núcleo",
	  "fidelidad",
	  "base de datos",
	  "data-warehouse",
	  "definición",
	  "emulación",
	  "codificar",
	  "encriptar",
	  "extranet",
	  "firmware",
	  "flexibilidad",
	  "focus group",
	  "previsión",
	  "base de trabajo",
	  "función",
	  "funcionalidad",
	  "Interfaz Gráfica",
	  "groupware",
	  "Interfaz gráfico de usuario",
	  "hardware",
	  "Soporte",
	  "jerarquía",
	  "conjunto",
	  "implementación",
	  "infraestructura",
	  "iniciativa",
	  "instalación",
	  "conjunto de instrucciones",
	  "interfaz",
	  "intranet",
	  "base del conocimiento",
	  "red de area local",
	  "aprovechar",
	  "matrices",
	  "metodologías",
	  "middleware",
	  "migración",
	  "modelo",
	  "moderador",
	  "monitorizar",
	  "arquitectura abierta",
	  "sistema abierto",
	  "orquestar",
	  "paradigma",
	  "paralelismo",
	  "política",
	  "portal",
	  "estructura de precios",
	  "proceso de mejora",
	  "producto",
	  "productividad",
	  "proyecto",
	  "proyección",
	  "protocolo",
	  "línea segura",
	  "software",
	  "solución",
	  "estandardización",
	  "estrategia",
	  "estructura",
	  "éxito",
	  "superestructura",
	  "soporte",
	  "sinergia",
	  "mediante",
	  "marco de tiempo",
	  "caja de herramientas",
	  "utilización",
	  "website",
	  "fuerza de trabajo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.L.",
	  "e Hijos",
	  "S.A.",
	  "Hermanos"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var es_MX = {};
	module['exports'] = es_MX;
	es_MX.title = "Spanish Mexico";
	es_MX.separator = " & ";
	es_MX.name = __webpack_require__(1105);
	es_MX.address = __webpack_require__(1072);
	es_MX.company = __webpack_require__(1093);
	es_MX.internet = __webpack_require__(1100);
	es_MX.phone_number = __webpack_require__(1112);
	es_MX.cell_phone = __webpack_require__(1083);
	es_MX.lorem = __webpack_require__(1101);
	es_MX.commerce = __webpack_require__(1086);
	es_MX.team = __webpack_require__(1114);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "mx",
	  "info",
	  "com.mx",
	  "org",
	  "gob.mx"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com",
	  "nearbpo.com",
	  "corpfolder.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1099);
	internet.domain_suffix = __webpack_require__(1098);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1103);
	lorem.supplemental = __webpack_require__(1102);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	"Abacalero",
	"Abacería",
	"Abacero",
	"Abacial",
	"Abaco",
	"Abacora",
	"Abacorar",
	"Abad",
	"Abada",
	"Abadejo",
	"Abadengo",
	"Abadernar",
	"Abadesa",
	"Abadí",
	"Abadía",
	"Abadiado",
	"Abadiato",
	"Abajadero",
	"Abajamiento",
	"Abajar",
	"Abajeño",
	"Abajera",
	"Abajo",
	"Abalada",
	"Abalanzar",
	"Abalar",
	"Abalaustrado",
	"Abaldonadamente",
	"Abaldonamiento",
	"Bastonada",
	"Bastonazo",
	"Bastoncillo",
	"Bastonear",
	"Bastonero",
	"Bástulo",
	"Basura",
	"Basural",
	"Basurear",
	"Basurero",
	"Bata",
	"Batacazo",
	"Batahola",
	"Batalán",
	"Batalla",
	"Batallador",
	"Batallar",
	"Batallaroso",
	"Batallola",
	"Batallón",
	"Batallona",
	"Batalloso",
	"Batán",
	"Batanar",
	"Batanear",
	"Batanero",
	"Batanga",
	"Bataola",
	"Batata",
	"Batatazo",
	"Batato",
	"Batavia",
	"Bátavo",
	"Batayola",
	"Batazo",
	"Bate",
	"Batea",
	"Bateador",
	"Bateaguas",
	"Cenagar",
	"Cenagoso",
	"Cenal",
	"Cenaoscuras",
	"Ceñar",
	"Cenata",
	"Cenca",
	"Cencapa",
	"Cencellada",
	"Cenceñada",
	"Cenceño",
	"Cencero",
	"Cencerra",
	"Cencerrada",
	"Cencerrado",
	"Cencerrear",
	"Cencerreo",
	"Cencerril",
	"Cencerrillas",
	"Cencerro",
	"Cencerrón",
	"Cencha",
	"Cencido",
	"Cencío",
	"Cencivera",
	"Cenco",
	"Cencuate",
	"Cendal",
	"Cendalí",
	"Céndea",
	"Cendolilla",
	"Cendra",
	"Cendrada",
	"Cendradilla",
	"Cendrado",
	"Cendrar",
	"Cendrazo",
	"Cenefa",
	"Cenegar",
	"Ceneque",
	"Cenero",
	"Cenestesia",
	"Desceñir",
	"Descensión",
	"Descenso",
	"Descentrado",
	"Descentralización",
	"Descentralizador",
	"Descentralizar",
	"Descentrar",
	"Descepar",
	"Descerar",
	"Descercado",
	"Descercador",
	"Descercar",
	"Descerco",
	"Descerebración",
	"Descerebrado",
	"Descerebrar",
	"Descerezar",
	"Descerrajado",
	"Descerrajadura",
	"Descerrajar",
	"Descerrar",
	"Descerrumarse",
	"Descervigamiento",
	"Descervigar",
	"Deschapar",
	"Descharchar",
	"Deschavetado",
	"Deschavetarse",
	"Deschuponar",
	"Descifrable",
	"Descifrador",
	"Desciframiento",
	"Descifrar",
	"Descifre",
	"Descimbramiento",
	"Descimbrar",
	"Engarbarse",
	"Engarberar",
	"Engarbullar",
	"Engarce",
	"Engarfiar",
	"Engargantadura",
	"Engargantar",
	"Engargante",
	"Engargolado",
	"Engargolar",
	"Engaritar",
	"Engarmarse",
	"Engarnio",
	"Engarrafador",
	"Engarrafar",
	"Engarrar",
	"Engarro",
	"Engarronar",
	"Engarrotar",
	"Engarzador",
	"Engarzadura",
	"Engarzar",
	"Engasgarse",
	"Engastador",
	"Engastadura",
	"Engastar",
	"Engaste",
	"Ficción",
	"Fice",
	"Ficha",
	"Fichaje",
	"Fichar",
	"Fichero",
	"Ficoideo",
	"Ficticio",
	"Fidalgo",
	"Fidecomiso",
	"Fidedigno",
	"Fideero",
	"Fideicomisario",
	"Fideicomiso",
	"Fideicomitente",
	"Fideísmo",
	"Fidelidad",
	"Fidelísimo",
	"Fideo",
	"Fido",
	"Fiducia",
	"Geminación",
	"Geminado",
	"Geminar",
	"Géminis",
	"Gémino",
	"Gemíparo",
	"Gemiquear",
	"Gemiqueo",
	"Gemir",
	"Gemología",
	"Gemológico",
	"Gemólogo",
	"Gemonias",
	"Gemoso",
	"Gemoterapia",
	"Gen",
	"Genciana",
	"Gencianáceo",
	"Gencianeo",
	"Gendarme",
	"Gendarmería",
	"Genealogía",
	"Genealógico",
	"Genealogista",
	"Genearca",
	"Geneático",
	"Generable",
	"Generación",
	"Generacional",
	"Generador",
	"General",
	"Generala",
	"Generalato",
	"Generalidad",
	"Generalísimo",
	"Incordio",
	"Incorporación",
	"Incorporal",
	"Incorporalmente",
	"Incorporar",
	"Incorporeidad",
	"Incorpóreo",
	"Incorporo",
	"Incorrección",
	"Incorrectamente",
	"Incorrecto",
	"Incorregibilidad",
	"Incorregible",
	"Incorregiblemente",
	"Incorrupción",
	"Incorruptamente",
	"Incorruptibilidad",
	"Incorruptible",
	"Incorrupto",
	"Incrasar",
	"Increado",
	"Incredibilidad",
	"Incrédulamente",
	"Incredulidad",
	"Incrédulo",
	"Increíble",
	"Increíblemente",
	"Incrementar",
	"Incremento",
	"Increpación",
	"Increpador",
	"Increpar",
	"Incriminación",
	"Incriminar",
	"Incristalizable",
	"Incruentamente",
	"Incruento",
	"Incrustación"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	"Aarón",
	"Abraham",
	"Adán",
	"Agustín",
	"Alan",
	"Alberto",
	"Alejandro",
	"Alexander",
	"Alexis",
	"Alfonso",
	"Alfredo",
	"Andrés",
	"Ángel Daniel",
	"Ángel Gabriel",
	"Antonio",
	"Armando",
	"Arturo",
	"Axel",
	"Benito",
	"Benjamín",
	"Bernardo",
	"Brandon",
	"Brayan",
	"Carlos",
	"César",
	"Claudio",
	"Clemente",
	"Cristian",
	"Cristobal",
	"Damián",
	"Daniel",
	"David",
	"Diego",
	"Eduardo",
	"Elías",
	"Emiliano",
	"Emilio",
	"Emilio",
	"Emmanuel",
	"Enrique",
	"Erick",
	"Ernesto",
	"Esteban",
	"Federico",
	"Felipe",
	"Fernando",
	"Fernando Javier",
	"Francisco",
	"Francisco Javier",
	"Gabriel",
	"Gael",
	"Gerardo",
	"Germán",
	"Gilberto",
	"Gonzalo",
	"Gregorio",
	"Guillermo",
	"Gustavo",
	"Hernán",
	"Homero",
	"Horacio",
	"Hugo",
	"Ignacio",
	"Iker",
	"Isaac",
	"Isaias",
	"Israel",
	"Ivan",
	"Jacobo",
	"Jaime",
	"Javier",
	"Jerónimo",
	"Jesús",
	"Joaquín",
	"Jorge",
	"Jorge Luis",
	"José",
	"José Antonio",
	"Jose Daniel",
	"José Eduardo",
	"José Emilio",
	"José Luis",
	"José María",
	"José Miguel",
	"Juan",
	"Juan Carlos",
	"Juan Manuel",
	"Juan Pablo",
	"Julio",
	"Julio César",
	"Kevin",
	"Leonardo",
	"Lorenzo",
	"Lucas",
	"Luis",
	"Luis Ángel",
	"Luis Fernando",
	"Luis Gabino",
	"Luis Miguel",
	"Manuel",
	"Marco Antonio",
	"Marcos",
	"Mariano",
	"Mario",
	"Martín",
	"Mateo",
	"Matías",
	"Mauricio",
	"Maximiliano",
	"Miguel",
	"Miguel Ángel",
	"Nicolás",
	"Octavio",
	"Óscar",
	"Pablo",
	"Patricio",
	"Pedro",
	"Rafael",
	"Ramiro",
	"Ramón",
	"Raúl",
	"Ricardo",
	"Roberto",
	"Rodrigo",
	"Rubén",
	"Salvador",
	"Samuel",
	"Sancho",
	"Santiago",
	"Saúl",
	"Sebastian",
	"Sergio",
	"Tadeo",
	"Teodoro",
	"Timoteo",
	"Tomás",
	"Uriel",
	"Vicente",
	"Víctor",
	"Victor Manuel",
	"Adriana",
	"Alejandra",
	"Alicia",
	"Amalia",
	"Ana",
	"Ana Luisa",
	"Ana María",
	"Andrea",
	"Ángela",
	"Anita",
	"Antonia",
	"Araceli",
	"Ariadna",
	"Barbara",
	"Beatriz",
	"Berta",
	"Blanca",
	"Caridad",
	"Carla",
	"Carlota",
	"Carmen",
	"Carolina",
	"Catalina",
	"Cecilia",
	"Clara",
	"Claudia",
	"Concepción",
	"Conchita",
	"Cristina",
	"Daniela",
	"Débora",
	"Diana",
	"Dolores",
	"Dorotea",
	"Elena",
	"Elisa",
	"Elizabeth",
	"Eloisa",
	"Elsa",
	"Elvira",
	"Emilia",
	"Esperanza",
	"Estela",
	"Ester",
	"Eva",
	"Florencia",
	"Francisca",
	"Gabriela",
	"Gloria",
	"Graciela",
	"Guadalupe",
	"Guillermina",
	"Inés",
	"Irene",
	"Isabel",
	"Isabela",
	"Josefina",
	"Juana",
	"Julia",
	"Laura",
	"Leonor",
	"Leticia",
	"Lilia",
	"Lola",
	"Lorena",
	"Lourdes",
	"Lucia",
	"Luisa",
	"Luz",
	"Magdalena",
	"Manuela",
	"Marcela",
	"Margarita",
	"María",
	"María Cristina",
	"María de Jesús",
	"María de los Ángeles",
	"María del Carmen",
	"María Elena",
	"María Eugenia",
	"María Guadalupe",
	"María José",
	"María Luisa",
	"María Soledad",
	"María Teresa",
	"Mariana",
	"Maricarmen",
	"Marilu",
	"Marisol",
	"Marta",
	"Mayte",
	"Mercedes",
	"Micaela",
	"Mónica",
	"Natalia",
	"Norma",
	"Olivia",
	"Patricia",
	"Pilar",
	"Ramona",
	"Raquel",
	"Rebeca",
	"Reina",
	"Rocio",
	"Rosa",
	"Rosa María",
	"Rosalia",
	"Rosario",
	"Sara",
	"Silvia",
	"Sofia",
	"Soledad",
	"Sonia",
	"Susana",
	"Teresa",
	"Verónica",
	"Victoria",
	"Virginia",
	"Xochitl",
	"Yolanda",
	"Abigail",
	"Abril",
	"Adela",
	"Alexa",
	"Alondra Romina",
	"Ana Sofía",
	"Ana Victoria",
	"Camila",
	"Carolina",
	"Daniela",
	"Dulce María",
	"Emily",
	"Esmeralda",
	"Estefanía",
	"Evelyn",
	"Fatima",
	"Ivanna",
	"Jazmin",
	"Jennifer",
	"Jimena",
	"Julieta",
	"Kimberly",
	"Liliana",
	"Lizbeth",
	"María Fernanda",
	"Melany",
	"Melissa",
	"Miranda",
	"Monserrat",
	"Naomi",
	"Natalia",
	"Nicole",
	"Paola",
	"Paulina",
	"Regina",
	"Renata",
	"Valentina",
	"Valeria",
	"Vanessa",
	"Ximena",
	"Ximena Guadalupe",
	"Yamileth",
	"Yaretzi",
	"Zoe"
	]
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1104);
	name.last_name = __webpack_require__(1106);
	name.prefix = __webpack_require__(1108);
	name.suffix = __webpack_require__(1109);
	name.title = __webpack_require__(1110);
	name.name = __webpack_require__(1107);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abeyta",
	"Abrego",
	"Abreu",
	"Acevedo",
	"Acosta",
	"Acuña",
	"Adame",
	"Adorno",
	"Agosto",
	"Aguayo",
	"Águilar",
	"Aguilera",
	"Aguirre",
	"Alanis",
	"Alaniz",
	"Alarcón",
	"Alba",
	"Alcala",
	"Alcántar",
	"Alcaraz",
	"Alejandro",
	"Alemán",
	"Alfaro",
	"Alicea",
	"Almanza",
	"Almaraz",
	"Almonte",
	"Alonso",
	"Alonzo",
	"Altamirano",
	"Alva",
	"Alvarado",
	"Alvarez",
	"Amador",
	"Amaya",
	"Anaya",
	"Anguiano",
	"Angulo",
	"Aparicio",
	"Apodaca",
	"Aponte",
	"Aragón",
	"Aranda",
	"Araña",
	"Arce",
	"Archuleta",
	"Arellano",
	"Arenas",
	"Arevalo",
	"Arguello",
	"Arias",
	"Armas",
	"Armendáriz",
	"Armenta",
	"Armijo",
	"Arredondo",
	"Arreola",
	"Arriaga",
	"Arroyo",
	"Arteaga",
	"Atencio",
	"Ávalos",
	"Ávila",
	"Avilés",
	"Ayala",
	"Baca",
	"Badillo",
	"Báez",
	"Baeza",
	"Bahena",
	"Balderas",
	"Ballesteros",
	"Banda",
	"Bañuelos",
	"Barajas",
	"Barela",
	"Barragán",
	"Barraza",
	"Barrera",
	"Barreto",
	"Barrientos",
	"Barrios",
	"Batista",
	"Becerra",
	"Beltrán",
	"Benavides",
	"Benavídez",
	"Benítez",
	"Bermúdez",
	"Bernal",
	"Berríos",
	"Bétancourt",
	"Blanco",
	"Bonilla",
	"Borrego",
	"Botello",
	"Bravo",
	"Briones",
	"Briseño",
	"Brito",
	"Bueno",
	"Burgos",
	"Bustamante",
	"Bustos",
	"Caballero",
	"Cabán",
	"Cabrera",
	"Cadena",
	"Caldera",
	"Calderón",
	"Calvillo",
	"Camacho",
	"Camarillo",
	"Campos",
	"Canales",
	"Candelaria",
	"Cano",
	"Cantú",
	"Caraballo",
	"Carbajal",
	"Cardenas",
	"Cardona",
	"Carmona",
	"Carranza",
	"Carrasco",
	"Carrasquillo",
	"Carreón",
	"Carrera",
	"Carrero",
	"Carrillo",
	"Carrion",
	"Carvajal",
	"Casanova",
	"Casares",
	"Casárez",
	"Casas",
	"Casillas",
	"Castañeda",
	"Castellanos",
	"Castillo",
	"Castro",
	"Cavazos",
	"Cazares",
	"Ceballos",
	"Cedillo",
	"Ceja",
	"Centeno",
	"Cepeda",
	"Cerda",
	"Cervantes",
	"Cervántez",
	"Chacón",
	"Chapa",
	"Chavarría",
	"Chávez",
	"Cintrón",
	"Cisneros",
	"Collado",
	"Collazo",
	"Colón",
	"Colunga",
	"Concepción",
	"Contreras",
	"Cordero",
	"Córdova",
	"Cornejo",
	"Corona",
	"Coronado",
	"Corral",
	"Corrales",
	"Correa",
	"Cortés",
	"Cortez",
	"Cotto",
	"Covarrubias",
	"Crespo",
	"Cruz",
	"Cuellar",
	"Curiel",
	"Dávila",
	"de Anda",
	"de Jesús",
	"Delacrúz",
	"Delafuente",
	"Delagarza",
	"Delao",
	"Delapaz",
	"Delarosa",
	"Delatorre",
	"Deleón",
	"Delgadillo",
	"Delgado",
	"Delrío",
	"Delvalle",
	"Díaz",
	"Domínguez",
	"Domínquez",
	"Duarte",
	"Dueñas",
	"Duran",
	"Echevarría",
	"Elizondo",
	"Enríquez",
	"Escalante",
	"Escamilla",
	"Escobar",
	"Escobedo",
	"Esparza",
	"Espinal",
	"Espino",
	"Espinosa",
	"Espinoza",
	"Esquibel",
	"Esquivel",
	"Estévez",
	"Estrada",
	"Fajardo",
	"Farías",
	"Feliciano",
	"Fernández",
	"Ferrer",
	"Fierro",
	"Figueroa",
	"Flores",
	"Flórez",
	"Fonseca",
	"Franco",
	"Frías",
	"Fuentes",
	"Gaitán",
	"Galarza",
	"Galindo",
	"Gallardo",
	"Gallegos",
	"Galván",
	"Gálvez",
	"Gamboa",
	"Gamez",
	"Gaona",
	"Garay",
	"García",
	"Garibay",
	"Garica",
	"Garrido",
	"Garza",
	"Gastélum",
	"Gaytán",
	"Gil",
	"Girón",
	"Godínez",
	"Godoy",
	"Gollum",
	"Gómez",
	"Gonzales",
	"González",
	"Gracia",
	"Granado",
	"Granados",
	"Griego",
	"Grijalva",
	"Guajardo",
	"Guardado",
	"Guerra",
	"Guerrero",
	"Guevara",
	"Guillen",
	"Gurule",
	"Gutiérrez",
	"Guzmán",
	"Haro",
	"Henríquez",
	"Heredia",
	"Hernádez",
	"Hernandes",
	"Hernández",
	"Herrera",
	"Hidalgo",
	"Hinojosa",
	"Holguín",
	"Huerta",
	"Huixtlacatl",
	"Hurtado",
	"Ibarra",
	"Iglesias",
	"Irizarry",
	"Jaime",
	"Jaimes",
	"Jáquez",
	"Jaramillo",
	"Jasso",
	"Jiménez",
	"Jimínez",
	"Juárez",
	"Jurado",
	"Kadar rodriguez",
	"Kamal",
	"Kamat",
	"Kanaria",
	"Kanea",
	"Kanimal",
	"Kano",
	"Kanzaki",
	"Kaplan",
	"Kara",
	"Karam",
	"Karan",
	"Kardache soto",
	"Karem",
	"Karen",
	"Khalid",
	"Kindelan",
	"Koenig",
	"Korta",
	"Korta hernandez",
	"Kortajarena",
	"Kranz sans",
	"Krasnova",
	"Krauel natera",
	"Kuzmina",
	"Kyra",
	"Laboy",
	"Lara",
	"Laureano",
	"Leal",
	"Lebrón",
	"Ledesma",
	"Leiva",
	"Lemus",
	"León",
	"Lerma",
	"Leyva",
	"Limón",
	"Linares",
	"Lira",
	"Llamas",
	"Loera",
	"Lomeli",
	"Longoria",
	"López",
	"Lovato",
	"Loya",
	"Lozada",
	"Lozano",
	"Lucero",
	"Lucio",
	"Luevano",
	"Lugo",
	"Luna",
	"Macías",
	"Madera",
	"Madrid",
	"Madrigal",
	"Maestas",
	"Magaña",
	"Malave",
	"Maldonado",
	"Manzanares",
	"Mares",
	"Marín",
	"Márquez",
	"Marrero",
	"Marroquín",
	"Martínez",
	"Mascareñas",
	"Mata",
	"Mateo",
	"Matías",
	"Matos",
	"Maya",
	"Mayorga",
	"Medina",
	"Medrano",
	"Mejía",
	"Meléndez",
	"Melgar",
	"Mena",
	"Menchaca",
	"Méndez",
	"Mendoza",
	"Menéndez",
	"Meraz",
	"Mercado",
	"Merino",
	"Mesa",
	"Meza",
	"Miramontes",
	"Miranda",
	"Mireles",
	"Mojica",
	"Molina",
	"Mondragón",
	"Monroy",
	"Montalvo",
	"Montañez",
	"Montaño",
	"Montemayor",
	"Montenegro",
	"Montero",
	"Montes",
	"Montez",
	"Montoya",
	"Mora",
	"Morales",
	"Moreno",
	"Mota",
	"Moya",
	"Munguía",
	"Muñiz",
	"Muñoz",
	"Murillo",
	"Muro",
	"Nájera",
	"Naranjo",
	"Narváez",
	"Nava",
	"Navarrete",
	"Navarro",
	"Nazario",
	"Negrete",
	"Negrón",
	"Nevárez",
	"Nieto",
	"Nieves",
	"Niño",
	"Noriega",
	"Núñez",
	"Ñañez",
	"Ocampo",
	"Ocasio",
	"Ochoa",
	"Ojeda",
	"Olivares",
	"Olivárez",
	"Olivas",
	"Olivera",
	"Olivo",
	"Olmos",
	"Olvera",
	"Ontiveros",
	"Oquendo",
	"Ordóñez",
	"Orellana",
	"Ornelas",
	"Orosco",
	"Orozco",
	"Orta",
	"Ortega",
	"Ortiz",
	"Osorio",
	"Otero",
	"Ozuna",
	"Pabón",
	"Pacheco",
	"Padilla",
	"Padrón",
	"Páez",
	"Pagan",
	"Palacios",
	"Palomino",
	"Palomo",
	"Pantoja",
	"Paredes",
	"Parra",
	"Partida",
	"Patiño",
	"Paz",
	"Pedraza",
	"Pedroza",
	"Pelayo",
	"Peña",
	"Perales",
	"Peralta",
	"Perea",
	"Peres",
	"Pérez",
	"Pichardo",
	"Pineda",
	"Piña",
	"Pizarro",
	"Polanco",
	"Ponce",
	"Porras",
	"Portillo",
	"Posada",
	"Prado",
	"Preciado",
	"Prieto",
	"Puente",
	"Puga",
	"Pulido",
	"Quesada",
	"Quevedo",
	"Quezada",
	"Quinta",
	"Quintairos",
	"Quintana",
	"Quintanilla",
	"Quintero",
	"Quintero cruz",
	"Quintero de la cruz",
	"Quiñones",
	"Quiñónez",
	"Quiros",
	"Quiroz",
	"Rael",
	"Ramírez",
	"Ramón",
	"Ramos",
	"Rangel",
	"Rascón",
	"Raya",
	"Razo",
	"Regalado",
	"Rendón",
	"Rentería",
	"Reséndez",
	"Reyes",
	"Reyna",
	"Reynoso",
	"Rico",
	"Rincón",
	"Riojas",
	"Ríos",
	"Rivas",
	"Rivera",
	"Rivero",
	"Robledo",
	"Robles",
	"Rocha",
	"Rodarte",
	"Rodrígez",
	"Rodríguez",
	"Rodríquez",
	"Rojas",
	"Rojo",
	"Roldán",
	"Rolón",
	"Romero",
	"Romo",
	"Roque",
	"Rosado",
	"Rosales",
	"Rosario",
	"Rosas",
	"Roybal",
	"Rubio",
	"Ruelas",
	"Ruiz",
	"Saavedra",
	"Sáenz",
	"Saiz",
	"Salas",
	"Salazar",
	"Salcedo",
	"Salcido",
	"Saldaña",
	"Saldivar",
	"Salgado",
	"Salinas",
	"Samaniego",
	"Sanabria",
	"Sanches",
	"Sánchez",
	"Sandoval",
	"Santacruz",
	"Santana",
	"Santiago",
	"Santillán",
	"Sarabia",
	"Sauceda",
	"Saucedo",
	"Sedillo",
	"Segovia",
	"Segura",
	"Sepúlveda",
	"Serna",
	"Serrano",
	"Serrato",
	"Sevilla",
	"Sierra",
	"Sisneros",
	"Solano",
	"Solís",
	"Soliz",
	"Solorio",
	"Solorzano",
	"Soria",
	"Sosa",
	"Sotelo",
	"Soto",
	"Suárez",
	"Tafoya",
	"Tamayo",
	"Tamez",
	"Tapia",
	"Tejada",
	"Tejeda",
	"Téllez",
	"Tello",
	"Terán",
	"Terrazas",
	"Tijerina",
	"Tirado",
	"Toledo",
	"Toro",
	"Torres",
	"Tórrez",
	"Tovar",
	"Trejo",
	"Treviño",
	"Trujillo",
	"Ulibarri",
	"Ulloa",
	"Urbina",
	"Ureña",
	"Urías",
	"Uribe",
	"Urrutia",
	"Vaca",
	"Valadez",
	"Valdés",
	"Valdez",
	"Valdivia",
	"Valencia",
	"Valentín",
	"Valenzuela",
	"Valladares",
	"Valle",
	"Vallejo",
	"Valles",
	"Valverde",
	"Vanegas",
	"Varela",
	"Vargas",
	"Vásquez",
	"Vázquez",
	"Vega",
	"Vela",
	"Velasco",
	"Velásquez",
	"Velázquez",
	"Vélez",
	"Véliz",
	"Venegas",
	"Vera",
	"Verdugo",
	"Verduzco",
	"Vergara",
	"Viera",
	"Vigil",
	"Villa",
	"Villagómez",
	"Villalobos",
	"Villalpando",
	"Villanueva",
	"Villareal",
	"Villarreal",
	"Villaseñor",
	"Villegas",
	"Xacon",
	"Xairo Belmonte",
	"Xana",
	"Xenia",
	"Xiana",
	"Xicoy",
	"Yago",
	"Yami",
	"Yanes",
	"Yáñez",
	"Ybarra",
	"Yebra",
	"Yunta",
	"Zabaleta",
	"Zamarreno",
	"Zamarripa",
	"Zambrana",
	"Zambrano",
	"Zamora",
	"Zamudio",
	"Zapata",
	"Zaragoza",
	"Zarate",
	"Zavala",
	"Zayas",
	"Zelaya",
	"Zepeda",
	"Zúñiga"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} de #{last_name}",
	  "#{suffix} #{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sr.",
	  "Sra.",
	  "Sta."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V",
	  "MD",
	  "DDS",
	  "PhD",
	  "DVM",
	  "Ing.",
	  "Lic.",
	  "Dr.",
	  "Mtro."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) { module["exports"] = {
	  "descriptor": [
	    "Jefe",
	    "Senior",
	    "Directo",
	    "Corporativo",
	    "Dinánmico",
	    "Futuro",
	    "Producto",
	    "Nacional",
	    "Regional",
	    "Distrito",
	    "Central",
	    "Global",
	    "Cliente",
	    "Inversor",
	    "International",
	    "Heredado",
	    "Adelante",
	    "Interno",
	    "Humano",
	    "Gerente",
	    "SubGerente",
	    "Director"
	  ],
	  "level": [
	    "Soluciones",
	    "Programa",
	    "Marca",
	    "Seguridad",
	    "Investigación",
	    "Marketing",
	    "Normas",
	    "Implementación",
	    "Integración",
	    "Funcionalidad",
	    "Respuesta",
	    "Paradigma",
	    "Tácticas",
	    "Identidad",
	    "Mercados",
	    "Grupo",
	    "División",
	    "Aplicaciones",
	    "Optimización",
	    "Operaciones",
	    "Infraestructura",
	    "Intranet",
	    "Comunicaciones",
	    "Web",
	    "Calidad",
	    "Seguro",
	    "Mobilidad",
	    "Cuentas",
	    "Datos",
	    "Creativo",
	    "Configuración",
	    "Contabilidad",
	    "Interacciones",
	    "Factores",
	    "Usabilidad",
	    "Métricas",
	  ],
	  "job": [
	    "Supervisor",
	    "Asociado",
	    "Ejecutivo",
	    "Relacciones",
	    "Oficial",
	    "Gerente",
	    "Ingeniero",
	    "Especialista",
	    "Director",
	    "Coordinador",
	    "Administrador",
	    "Arquitecto",
	    "Analista",
	    "Diseñador",
	    "Planificador",
	    "Técnico",
	    "Funcionario",
	    "Desarrollador",
	    "Productor",
	    "Consultor",
	    "Asistente",
	    "Facilitador",
	    "Agente",
	    "Representante",
	    "Estratega",
	    "Scrum Master",
	    "Scrum Owner",
	    "Product Owner",
	    "Scrum Developer"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "5###-###-###",
	  "5##.###.###",
	  "5## ### ###",
	  "5########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1111);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "hormigas",
	   "murciélagos",
	   "osos",
	   "abejas",
	   "pájaros",
	   "búfalo",
	   "gatos",
	   "pollos",
	   "ganado",
	   "perros",
	   "delfines",
	   "patos",
	   "elefantes",
	   "peces",
	   "zorros",
	   "ranas",
	   "gansos",
	   "cabras",
	   "caballos",
	   "canguros",
	   "leones",
	   "monos",
	   "búhos",
	   "bueyes",
	   "pingüinos",
	   "pueblo",
	   "cerdos",
	   "conejos",
	   "ovejas",
	   "tigres",
	   "ballenas",
	   "lobos",
	   "cebras",
	   "almas en pena",
	   "cuervos",
	   "gatos negros",
	   "quimeras",
	   "fantasmas",
	   "conspiradores",
	   "dragones",
	   "enanos",
	   "duendes",
	   "encantadores",
	   "exorcistas",
	   "hijos",
	   "enemigos",
	   "gigantes",
	   "gnomos",
	   "duendes",
	   "gansos",
	   "grifos",
	   "licántropos",
	   "némesis",
	   "ogros",
	   "oráculos",
	   "profetas",
	   "hechiceros",
	   "arañas",
	   "espíritus",
	   "vampiros",
	   "brujos",
	   "zorras",
	   "hombres lobo",
	   "brujas",
	   "adoradores",
	   "zombies",
	   "druidas"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var team = {};
	module['exports'] = team;
	team.creature = __webpack_require__(1113);
	team.name = __webpack_require__(1115);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.state} #{creature}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fa = {};
	module['exports'] = fa;
	fa.title = "Farsi";
	fa.name = __webpack_require__(1118);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "آبان دخت",
	  "آبتین",
	  "آتوسا",
	  "آفر",
	  "آفره دخت",
	  "آذرنوش‌",
	  "آذین",
	  "آراه",
	  "آرزو",
	  "آرش",
	  "آرتین",
	  "آرتام",
	  "آرتمن",
	  "آرشام",
	  "آرمان",
	  "آرمین",
	  "آرمیتا",
	  "آریا فر",
	  "آریا",
	  "آریا مهر",
	  "آرین",
	  "آزاده",
	  "آزرم",
	  "آزرمدخت",
	  "آزیتا",
	  "آناهیتا",
	  "آونگ",
	  "آهو",
	  "آیدا",
	  "اتسز",
	  "اختر",
	  "ارد",
	  "ارد شیر",
	  "اردوان",
	  "ارژن",
	  "ارژنگ",
	  "ارسلان",
	  "ارغوان",
	  "ارمغان",
	  "ارنواز",
	  "اروانه",
	  "استر",
	  "اسفندیار",
	  "اشکان",
	  "اشکبوس",
	  "افسانه",
	  "افسون",
	  "افشین",
	  "امید",
	  "انوش (‌ آنوشا )",
	  "انوشروان",
	  "اورنگ",
	  "اوژن",
	  "اوستا",
	  "اهورا",
	  "ایاز",
	  "ایران",
	  "ایراندخت",
	  "ایرج",
	  "ایزدیار",
	  "بابک",
	  "باپوک",
	  "باربد",
	  "بارمان",
	  "بامداد",
	  "بامشاد",
	  "بانو",
	  "بختیار",
	  "برانوش",
	  "بردیا",
	  "برزو",
	  "برزویه",
	  "برزین",
	  "برمک",
	  "بزرگمهر",
	  "بنفشه",
	  "بوژان",
	  "بویان",
	  "بهار",
	  "بهارک",
	  "بهاره",
	  "بهتاش",
	  "بهداد",
	  "بهرام",
	  "بهدیس",
	  "بهرخ",
	  "بهرنگ",
	  "بهروز",
	  "بهزاد",
	  "بهشاد",
	  "بهمن",
	  "بهناز",
	  "بهنام",
	  "بهنود",
	  "بهنوش",
	  "بیتا",
	  "بیژن",
	  "پارسا",
	  "پاکان",
	  "پاکتن",
	  "پاکدخت",
	  "پانته آ",
	  "پدرام",
	  "پرتو",
	  "پرشنگ",
	  "پرتو",
	  "پرستو",
	  "پرویز",
	  "پردیس",
	  "پرهام",
	  "پژمان",
	  "پژوا",
	  "پرنیا",
	  "پشنگ",
	  "پروانه",
	  "پروین",
	  "پری",
	  "پریچهر",
	  "پریدخت",
	  "پریسا",
	  "پرناز",
	  "پریوش",
	  "پریا",
	  "پوپک",
	  "پوران",
	  "پوراندخت",
	  "پوریا",
	  "پولاد",
	  "پویا",
	  "پونه",
	  "پیام",
	  "پیروز",
	  "پیمان",
	  "تابان",
	  "تاباندخت",
	  "تاجی",
	  "تارا",
	  "تاویار",
	  "ترانه",
	  "تناز",
	  "توران",
	  "توراندخت",
	  "تورج",
	  "تورتک",
	  "توفان",
	  "توژال",
	  "تیر داد",
	  "تینا",
	  "تینو",
	  "جابان",
	  "جامین",
	  "جاوید",
	  "جریره",
	  "جمشید",
	  "جوان",
	  "جویا",
	  "جهان",
	  "جهانبخت",
	  "جهانبخش",
	  "جهاندار",
	  "جهانگیر",
	  "جهان بانو",
	  "جهاندخت",
	  "جهان ناز",
	  "جیران",
	  "چابک",
	  "چالاک",
	  "چاوش",
	  "چترا",
	  "چوبین",
	  "چهرزاد",
	  "خاوردخت",
	  "خداداد",
	  "خدایار",
	  "خرم",
	  "خرمدخت",
	  "خسرو",
	  "خشایار",
	  "خورشید",
	  "دادمهر",
	  "دارا",
	  "داراب",
	  "داریا",
	  "داریوش",
	  "دانوش",
	  "داور‌",
	  "دایان",
	  "دریا",
	  "دل آرا",
	  "دل آویز",
	  "دلارام",
	  "دل انگیز",
	  "دلبر",
	  "دلبند",
	  "دلربا",
	  "دلشاد",
	  "دلکش",
	  "دلناز",
	  "دلنواز",
	  "دورشاسب",
	  "دنیا",
	  "دیااکو",
	  "دیانوش",
	  "دیبا",
	  "دیبا دخت",
	  "رابو",
	  "رابین",
	  "رادبانو",
	  "رادمان",
	  "رازبان",
	  "راژانه",
	  "راسا",
	  "رامتین",
	  "رامش",
	  "رامشگر",
	  "رامونا",
	  "رامیار",
	  "رامیلا",
	  "رامین",
	  "راویار",
	  "رژینا",
	  "رخپاک",
	  "رخسار",
	  "رخشانه",
	  "رخشنده",
	  "رزمیار",
	  "رستم",
	  "رکسانا",
	  "روبینا",
	  "رودابه",
	  "روزبه",
	  "روشنک",
	  "روناک",
	  "رهام",
	  "رهی",
	  "ریبار",
	  "راسپینا",
	  "زادبخت",
	  "زاد به",
	  "زاد چهر",
	  "زاد فر",
	  "زال",
	  "زادماسب",
	  "زاوا",
	  "زردشت",
	  "زرنگار",
	  "زری",
	  "زرین",
	  "زرینه",
	  "زمانه",
	  "زونا",
	  "زیبا",
	  "زیبار",
	  "زیما",
	  "زینو",
	  "ژاله",
	  "ژالان",
	  "ژیار",
	  "ژینا",
	  "ژیوار",
	  "سارا",
	  "سارک",
	  "سارنگ",
	  "ساره",
	  "ساسان",
	  "ساغر",
	  "سام",
	  "سامان",
	  "سانا",
	  "ساناز",
	  "سانیار",
	  "ساویز",
	  "ساهی",
	  "ساینا",
	  "سایه",
	  "سپنتا",
	  "سپند",
	  "سپهر",
	  "سپهرداد",
	  "سپیدار",
	  "سپید بانو",
	  "سپیده",
	  "ستاره",
	  "ستی",
	  "سرافراز",
	  "سرور",
	  "سروش",
	  "سرور",
	  "سوبا",
	  "سوبار",
	  "سنبله",
	  "سودابه",
	  "سوری",
	  "سورن",
	  "سورنا",
	  "سوزان",
	  "سوزه",
	  "سوسن",
	  "سومار",
	  "سولان",
	  "سولماز",
	  "سوگند",
	  "سهراب",
	  "سهره",
	  "سهند",
	  "سیامک",
	  "سیاوش",
	  "سیبوبه ‌",
	  "سیما",
	  "سیمدخت",
	  "سینا",
	  "سیمین",
	  "سیمین دخت",
	  "شاپرک",
	  "شادی",
	  "شادمهر",
	  "شاران",
	  "شاهپور",
	  "شاهدخت",
	  "شاهرخ",
	  "شاهین",
	  "شاهیندخت",
	  "شایسته",
	  "شباهنگ",
	  "شب بو",
	  "شبدیز",
	  "شبنم",
	  "شراره",
	  "شرمین",
	  "شروین",
	  "شکوفه",
	  "شکفته",
	  "شمشاد",
	  "شمین",
	  "شوان",
	  "شمیلا",
	  "شورانگیز",
	  "شوری",
	  "شهاب",
	  "شهبار",
	  "شهباز",
	  "شهبال",
	  "شهپر",
	  "شهداد",
	  "شهرآرا",
	  "شهرام",
	  "شهربانو",
	  "شهرزاد",
	  "شهرناز",
	  "شهرنوش",
	  "شهره",
	  "شهریار",
	  "شهرزاد",
	  "شهلا",
	  "شهنواز",
	  "شهین",
	  "شیبا",
	  "شیدا",
	  "شیده",
	  "شیردل",
	  "شیرزاد",
	  "شیرنگ",
	  "شیرو",
	  "شیرین دخت",
	  "شیما",
	  "شینا",
	  "شیرین",
	  "شیوا",
	  "طوس",
	  "طوطی",
	  "طهماسب",
	  "طهمورث",
	  "غوغا",
	  "غنچه",
	  "فتانه",
	  "فدا",
	  "فراز",
	  "فرامرز",
	  "فرانک",
	  "فراهان",
	  "فربد",
	  "فربغ",
	  "فرجاد",
	  "فرخ",
	  "فرخ پی",
	  "فرخ داد",
	  "فرخ رو",
	  "فرخ زاد",
	  "فرخ لقا",
	  "فرخ مهر",
	  "فرداد",
	  "فردیس",
	  "فرین",
	  "فرزاد",
	  "فرزام",
	  "فرزان",
	  "فرزانه",
	  "فرزین",
	  "فرشاد",
	  "فرشته",
	  "فرشید",
	  "فرمان",
	  "فرناز",
	  "فرنگیس",
	  "فرنود",
	  "فرنوش",
	  "فرنیا",
	  "فروتن",
	  "فرود",
	  "فروز",
	  "فروزان",
	  "فروزش",
	  "فروزنده",
	  "فروغ",
	  "فرهاد",
	  "فرهنگ",
	  "فرهود",
	  "فربار",
	  "فریبا",
	  "فرید",
	  "فریدخت",
	  "فریدون",
	  "فریمان",
	  "فریناز",
	  "فرینوش",
	  "فریوش",
	  "فیروز",
	  "فیروزه",
	  "قابوس",
	  "قباد",
	  "قدسی",
	  "کابان",
	  "کابوک",
	  "کارا",
	  "کارو",
	  "کاراکو",
	  "کامبخت",
	  "کامبخش",
	  "کامبیز",
	  "کامجو",
	  "کامدین",
	  "کامران",
	  "کامراوا",
	  "کامک",
	  "کامنوش",
	  "کامیار",
	  "کانیار",
	  "کاووس",
	  "کاوه",
	  "کتایون",
	  "کرشمه",
	  "کسری",
	  "کلاله",
	  "کمبوجیه",
	  "کوشا",
	  "کهبد",
	  "کهرام",
	  "کهزاد",
	  "کیارش",
	  "کیان",
	  "کیانا",
	  "کیانچهر",
	  "کیاندخت",
	  "کیانوش",
	  "کیاوش",
	  "کیخسرو",
	  "کیقباد",
	  "کیکاووس",
	  "کیوان",
	  "کیوان دخت",
	  "کیومرث",
	  "کیهان",
	  "کیاندخت",
	  "کیهانه",
	  "گرد آفرید",
	  "گردان",
	  "گرشا",
	  "گرشاسب",
	  "گرشین",
	  "گرگین",
	  "گزل",
	  "گشتاسب",
	  "گشسب",
	  "گشسب بانو",
	  "گل",
	  "گل آذین",
	  "گل آرا‌",
	  "گلاره",
	  "گل افروز",
	  "گلاله",
	  "گل اندام",
	  "گلاویز",
	  "گلباد",
	  "گلبار",
	  "گلبام",
	  "گلبان",
	  "گلبانو",
	  "گلبرگ",
	  "گلبو",
	  "گلبهار",
	  "گلبیز",
	  "گلپاره",
	  "گلپر",
	  "گلپری",
	  "گلپوش",
	  "گل پونه",
	  "گلچین",
	  "گلدخت",
	  "گلدیس",
	  "گلربا",
	  "گلرخ",
	  "گلرنگ",
	  "گلرو",
	  "گلشن",
	  "گلریز",
	  "گلزاد",
	  "گلزار",
	  "گلسا",
	  "گلشید",
	  "گلنار",
	  "گلناز",
	  "گلنسا",
	  "گلنواز",
	  "گلنوش",
	  "گلی",
	  "گودرز",
	  "گوماتو",
	  "گهر چهر",
	  "گوهر ناز",
	  "گیتی",
	  "گیسو",
	  "گیلدا",
	  "گیو",
	  "لادن",
	  "لاله",
	  "لاله رخ",
	  "لاله دخت",
	  "لبخند",
	  "لقاء",
	  "لومانا",
	  "لهراسب",
	  "مارال",
	  "ماری",
	  "مازیار",
	  "ماکان",
	  "مامک",
	  "مانا",
	  "ماندانا",
	  "مانوش",
	  "مانی",
	  "مانیا",
	  "ماهان",
	  "ماهاندخت",
	  "ماه برزین",
	  "ماه جهان",
	  "ماهچهر",
	  "ماهدخت",
	  "ماهور",
	  "ماهرخ",
	  "ماهزاد",
	  "مردآویز",
	  "مرداس",
	  "مرزبان",
	  "مرمر",
	  "مزدک",
	  "مژده",
	  "مژگان",
	  "مستان",
	  "مستانه",
	  "مشکاندخت",
	  "مشکناز",
	  "مشکین دخت",
	  "منیژه",
	  "منوچهر",
	  "مهبانو",
	  "مهبد",
	  "مه داد",
	  "مهتاب",
	  "مهدیس",
	  "مه جبین",
	  "مه دخت",
	  "مهر آذر",
	  "مهر آرا",
	  "مهر آسا",
	  "مهر آفاق",
	  "مهر افرین",
	  "مهرآب",
	  "مهرداد",
	  "مهر افزون",
	  "مهرام",
	  "مهران",
	  "مهراندخت",
	  "مهراندیش",
	  "مهرانفر",
	  "مهرانگیز",
	  "مهرداد",
	  "مهر دخت",
	  "مهرزاده ‌",
	  "مهرناز",
	  "مهرنوش",
	  "مهرنکار",
	  "مهرنیا",
	  "مهروز",
	  "مهری",
	  "مهریار",
	  "مهسا",
	  "مهستی",
	  "مه سیما",
	  "مهشاد",
	  "مهشید",
	  "مهنام",
	  "مهناز",
	  "مهنوش",
	  "مهوش",
	  "مهیار",
	  "مهین",
	  "مهین دخت",
	  "میترا",
	  "میخک",
	  "مینا",
	  "مینا دخت",
	  "مینو",
	  "مینودخت",
	  "مینو فر",
	  "نادر",
	  "ناز آفرین",
	  "نازبانو",
	  "نازپرور",
	  "نازچهر",
	  "نازفر",
	  "نازلی",
	  "نازی",
	  "نازیدخت",
	  "نامور",
	  "ناهید",
	  "ندا",
	  "نرسی",
	  "نرگس",
	  "نرمک",
	  "نرمین",
	  "نریمان",
	  "نسترن",
	  "نسرین",
	  "نسرین دخت",
	  "نسرین نوش",
	  "نکیسا",
	  "نگار",
	  "نگاره",
	  "نگارین",
	  "نگین",
	  "نوا",
	  "نوش",
	  "نوش آذر",
	  "نوش آور",
	  "نوشا",
	  "نوش آفرین",
	  "نوشدخت",
	  "نوشروان",
	  "نوشفر",
	  "نوشناز",
	  "نوشین",
	  "نوید",
	  "نوین",
	  "نوین دخت",
	  "نیش ا",
	  "نیک بین",
	  "نیک پی",
	  "نیک چهر",
	  "نیک خواه",
	  "نیکداد",
	  "نیکدخت",
	  "نیکدل",
	  "نیکزاد",
	  "نیلوفر",
	  "نیما",
	  "وامق",
	  "ورجاوند",
	  "وریا",
	  "وشمگیر",
	  "وهرز",
	  "وهسودان",
	  "ویدا",
	  "ویس",
	  "ویشتاسب",
	  "ویگن",
	  "هژیر",
	  "هخامنش",
	  "هربد( هیربد )",
	  "هرمز",
	  "همایون",
	  "هما",
	  "همادخت",
	  "همدم",
	  "همراز",
	  "همراه",
	  "هنگامه",
	  "هوتن",
	  "هور",
	  "هورتاش",
	  "هورچهر",
	  "هورداد",
	  "هوردخت",
	  "هورزاد",
	  "هورمند",
	  "هوروش",
	  "هوشنگ",
	  "هوشیار",
	  "هومان",
	  "هومن",
	  "هونام",
	  "هویدا",
	  "هیتاسب",
	  "هیرمند",
	  "هیما",
	  "هیوا",
	  "یادگار",
	  "یاسمن ( یاسمین )",
	  "یاشار",
	  "یاور",
	  "یزدان",
	  "یگانه",
	  "یوشیتا"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1117);
	name.last_name = __webpack_require__(1119);
	name.prefix = __webpack_require__(1120);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "عارف",
	  "عاشوری",
	  "عالی",
	  "عبادی",
	  "عبدالکریمی",
	  "عبدالملکی",
	  "عراقی",
	  "عزیزی",
	  "عصار",
	  "عقیلی",
	  "علم",
	  "علم‌الهدی",
	  "علی عسگری",
	  "علی‌آبادی",
	  "علیا",
	  "علی‌پور",
	  "علی‌زمانی",
	  "عنایت",
	  "غضنفری",
	  "غنی",
	  "فارسی",
	  "فاطمی",
	  "فانی",
	  "فتاحی",
	  "فرامرزی",
	  "فرج",
	  "فرشیدورد",
	  "فرمانفرمائیان",
	  "فروتن",
	  "فرهنگ",
	  "فریاد",
	  "فنایی",
	  "فنی‌زاده",
	  "فولادوند",
	  "فهمیده",
	  "قاضی",
	  "قانعی",
	  "قانونی",
	  "قمیشی",
	  "قنبری",
	  "قهرمان",
	  "قهرمانی",
	  "قهرمانیان",
	  "قهستانی",
	  "کاشی",
	  "کاکاوند",
	  "کامکار",
	  "کاملی",
	  "کاویانی",
	  "کدیور",
	  "کردبچه",
	  "کرمانی",
	  "کریمی",
	  "کلباسی",
	  "کمالی",
	  "کوشکی",
	  "کهنمویی",
	  "کیان",
	  "کیانی (نام خانوادگی)",
	  "کیمیایی",
	  "گل محمدی",
	  "گلپایگانی",
	  "گنجی",
	  "لاجوردی",
	  "لاچینی",
	  "لاهوتی",
	  "لنکرانی",
	  "لوکس",
	  "مجاهد",
	  "مجتبایی",
	  "مجتبوی",
	  "مجتهد شبستری",
	  "مجتهدی",
	  "مجرد",
	  "محجوب",
	  "محجوبی",
	  "محدثی",
	  "محمدرضایی",
	  "محمدی",
	  "مددی",
	  "مرادخانی",
	  "مرتضوی",
	  "مستوفی",
	  "مشا",
	  "مصاحب",
	  "مصباح",
	  "مصباح‌زاده",
	  "مطهری",
	  "مظفر",
	  "معارف",
	  "معروف",
	  "معین",
	  "مفتاح",
	  "مفتح",
	  "مقدم",
	  "ملایری",
	  "ملک",
	  "ملکیان",
	  "منوچهری",
	  "موحد",
	  "موسوی",
	  "موسویان",
	  "مهاجرانی",
	  "مهدی‌پور",
	  "میرباقری",
	  "میردامادی",
	  "میرزاده",
	  "میرسپاسی",
	  "میزبانی",
	  "ناظری",
	  "نامور",
	  "نجفی",
	  "ندوشن",
	  "نراقی",
	  "نعمت‌زاده",
	  "نقدی",
	  "نقیب‌زاده",
	  "نواب",
	  "نوبخت",
	  "نوبختی",
	  "نهاوندی",
	  "نیشابوری",
	  "نیلوفری",
	  "واثقی",
	  "واعظ",
	  "واعظ‌زاده",
	  "واعظی",
	  "وکیلی",
	  "هاشمی",
	  "هاشمی رفسنجانی",
	  "هاشمیان",
	  "هامون",
	  "هدایت",
	  "هراتی",
	  "هروی",
	  "همایون",
	  "همت",
	  "همدانی",
	  "هوشیار",
	  "هومن",
	  "یاحقی",
	  "یادگار",
	  "یثربی",
	  "یلدا"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "آقای",
	  "خانم",
	  "دکتر"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Paris",
	  "Marseille",
	  "Lyon",
	  "Toulouse",
	  "Nice",
	  "Nantes",
	  "Strasbourg",
	  "Montpellier",
	  "Bordeaux",
	  "Lille13",
	  "Rennes",
	  "Reims",
	  "Le Havre",
	  "Saint-Étienne",
	  "Toulon",
	  "Grenoble",
	  "Dijon",
	  "Angers",
	  "Saint-Denis",
	  "Villeurbanne",
	  "Le Mans",
	  "Aix-en-Provence",
	  "Brest",
	  "Nîmes",
	  "Limoges",
	  "Clermont-Ferrand",
	  "Tours",
	  "Amiens",
	  "Metz",
	  "Perpignan",
	  "Besançon",
	  "Orléans",
	  "Boulogne-Billancourt",
	  "Mulhouse",
	  "Rouen",
	  "Caen",
	  "Nancy",
	  "Saint-Denis",
	  "Saint-Paul",
	  "Montreuil",
	  "Argenteuil",
	  "Roubaix",
	  "Dunkerque14",
	  "Tourcoing",
	  "Nanterre",
	  "Avignon",
	  "Créteil",
	  "Poitiers",
	  "Fort-de-France",
	  "Courbevoie",
	  "Versailles",
	  "Vitry-sur-Seine",
	  "Colombes",
	  "Pau",
	  "Aulnay-sous-Bois",
	  "Asnières-sur-Seine",
	  "Rueil-Malmaison",
	  "Saint-Pierre",
	  "Antibes",
	  "Saint-Maur-des-Fossés",
	  "Champigny-sur-Marne",
	  "La Rochelle",
	  "Aubervilliers",
	  "Calais",
	  "Cannes",
	  "Le Tampon",
	  "Béziers",
	  "Colmar",
	  "Bourges",
	  "Drancy",
	  "Mérignac",
	  "Saint-Nazaire",
	  "Valence",
	  "Ajaccio",
	  "Issy-les-Moulineaux",
	  "Villeneuve-d'Ascq",
	  "Levallois-Perret",
	  "Noisy-le-Grand",
	  "Quimper",
	  "La Seyne-sur-Mer",
	  "Antony",
	  "Troyes",
	  "Neuilly-sur-Seine",
	  "Sarcelles",
	  "Les Abymes",
	  "Vénissieux",
	  "Clichy",
	  "Lorient",
	  "Pessac",
	  "Ivry-sur-Seine",
	  "Cergy",
	  "Cayenne",
	  "Niort",
	  "Chambéry",
	  "Montauban",
	  "Saint-Quentin",
	  "Villejuif",
	  "Hyères",
	  "Beauvais",
	  "Cholet"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "France"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.building_number = __webpack_require__(1121);
	address.street_prefix = __webpack_require__(1131);
	address.secondary_address = __webpack_require__(1127);
	address.postcode = __webpack_require__(1126);
	address.state = __webpack_require__(1128);
	address.city_name = __webpack_require__(1123);
	address.city = __webpack_require__(1122);
	address.street_suffix = __webpack_require__(1132);
	address.street_name = __webpack_require__(1130);
	address.street_address = __webpack_require__(1129);
	address.default_country = __webpack_require__(1124);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "# étage"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alsace",
	  "Aquitaine",
	  "Auvergne",
	  "Basse-Normandie",
	  "Bourgogne",
	  "Bretagne",
	  "Centre",
	  "Champagne-Ardenne",
	  "Corse",
	  "Franche-Comté",
	  "Haute-Normandie",
	  "Île-de-France",
	  "Languedoc-Roussillon",
	  "Limousin",
	  "Lorraine",
	  "Midi-Pyrénées",
	  "Nord-Pas-de-Calais",
	  "Pays de la Loire",
	  "Picardie",
	  "Poitou-Charentes",
	  "Provence-Alpes-Côte d'Azur",
	  "Rhône-Alpes"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{building_number} #{street_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Allée, Voie",
	  "Rue",
	  "Avenue",
	  "Boulevard",
	  "Quai",
	  "Passage",
	  "Impasse",
	  "Place"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "de l'Abbaye",
	  "Adolphe Mille",
	  "d'Alésia",
	  "d'Argenteuil",
	  "d'Assas",
	  "du Bac",
	  "de Paris",
	  "La Boétie",
	  "Bonaparte",
	  "de la Bûcherie",
	  "de Caumartin",
	  "Charlemagne",
	  "du Chat-qui-Pêche",
	  "de la Chaussée-d'Antin",
	  "du Dahomey",
	  "Dauphine",
	  "Delesseux",
	  "du Faubourg Saint-Honoré",
	  "du Faubourg-Saint-Denis",
	  "de la Ferronnerie",
	  "des Francs-Bourgeois",
	  "des Grands Augustins",
	  "de la Harpe",
	  "du Havre",
	  "de la Huchette",
	  "Joubert",
	  "Laffitte",
	  "Lepic",
	  "des Lombards",
	  "Marcadet",
	  "Molière",
	  "Monsieur-le-Prince",
	  "de Montmorency",
	  "Montorgueil",
	  "Mouffetard",
	  "de Nesle",
	  "Oberkampf",
	  "de l'Odéon",
	  "d'Orsel",
	  "de la Paix",
	  "des Panoramas",
	  "Pastourelle",
	  "Pierre Charron",
	  "de la Pompe",
	  "de Presbourg",
	  "de Provence",
	  "de Richelieu",
	  "de Rivoli",
	  "des Rosiers",
	  "Royale",
	  "d'Abbeville",
	  "Saint-Honoré",
	  "Saint-Bernard",
	  "Saint-Denis",
	  "Saint-Dominique",
	  "Saint-Jacques",
	  "Saint-Séverin",
	  "des Saussaies",
	  "de Seine",
	  "de Solférino",
	  "Du Sommerard",
	  "de Tilsitt",
	  "Vaneau",
	  "de Vaugirard",
	  "de la Victoire",
	  "Zadkine"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1141);
	company.adjective = __webpack_require__(1133);
	company.descriptor = __webpack_require__(1137);
	company.noun = __webpack_require__(1140);
	company.bs_verb = __webpack_require__(1136);
	company.bs_adjective = __webpack_require__(1134);
	company.bs_noun = __webpack_require__(1135);
	company.name = __webpack_require__(1139);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} et #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "SARL",
	  "SA",
	  "EURL",
	  "SAS",
	  "SEM",
	  "SCOP",
	  "GIE",
	  "EI"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fr = {};
	module['exports'] = fr;
	fr.title = "French";
	fr.address = __webpack_require__(1125);
	fr.company = __webpack_require__(1138);
	fr.internet = __webpack_require__(1145);
	fr.lorem = __webpack_require__(1146);
	fr.name = __webpack_require__(1150);
	fr.phone_number = __webpack_require__(1156);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "fr",
	  "eu",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.fr",
	  "hotmail.fr"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1144);
	internet.domain_suffix = __webpack_require__(1143);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1148);
	lorem.supplemental = __webpack_require__(1147);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Enzo",
	  "Lucas",
	  "Mathis",
	  "Nathan",
	  "Thomas",
	  "Hugo",
	  "Théo",
	  "Tom",
	  "Louis",
	  "Raphaël",
	  "Clément",
	  "Léo",
	  "Mathéo",
	  "Maxime",
	  "Alexandre",
	  "Antoine",
	  "Yanis",
	  "Paul",
	  "Baptiste",
	  "Alexis",
	  "Gabriel",
	  "Arthur",
	  "Jules",
	  "Ethan",
	  "Noah",
	  "Quentin",
	  "Axel",
	  "Evan",
	  "Mattéo",
	  "Romain",
	  "Valentin",
	  "Maxence",
	  "Noa",
	  "Adam",
	  "Nicolas",
	  "Julien",
	  "Mael",
	  "Pierre",
	  "Rayan",
	  "Victor",
	  "Mohamed",
	  "Adrien",
	  "Kylian",
	  "Sacha",
	  "Benjamin",
	  "Léa",
	  "Clara",
	  "Manon",
	  "Chloé",
	  "Camille",
	  "Ines",
	  "Sarah",
	  "Jade",
	  "Lola",
	  "Anaïs",
	  "Lucie",
	  "Océane",
	  "Lilou",
	  "Marie",
	  "Eva",
	  "Romane",
	  "Lisa",
	  "Zoe",
	  "Julie",
	  "Mathilde",
	  "Louise",
	  "Juliette",
	  "Clémence",
	  "Célia",
	  "Laura",
	  "Lena",
	  "Maëlys",
	  "Charlotte",
	  "Ambre",
	  "Maeva",
	  "Pauline",
	  "Lina",
	  "Jeanne",
	  "Lou",
	  "Noémie",
	  "Justine",
	  "Louna",
	  "Elisa",
	  "Alice",
	  "Emilie",
	  "Carla",
	  "Maëlle",
	  "Alicia",
	  "Mélissa"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1149);
	name.last_name = __webpack_require__(1151);
	name.prefix = __webpack_require__(1153);
	name.title = __webpack_require__(1154);
	name.name = __webpack_require__(1152);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Martin",
	  "Bernard",
	  "Dubois",
	  "Thomas",
	  "Robert",
	  "Richard",
	  "Petit",
	  "Durand",
	  "Leroy",
	  "Moreau",
	  "Simon",
	  "Laurent",
	  "Lefebvre",
	  "Michel",
	  "Garcia",
	  "David",
	  "Bertrand",
	  "Roux",
	  "Vincent",
	  "Fournier",
	  "Morel",
	  "Girard",
	  "Andre",
	  "Lefevre",
	  "Mercier",
	  "Dupont",
	  "Lambert",
	  "Bonnet",
	  "Francois",
	  "Martinez",
	  "Legrand",
	  "Garnier",
	  "Faure",
	  "Rousseau",
	  "Blanc",
	  "Guerin",
	  "Muller",
	  "Henry",
	  "Roussel",
	  "Nicolas",
	  "Perrin",
	  "Morin",
	  "Mathieu",
	  "Clement",
	  "Gauthier",
	  "Dumont",
	  "Lopez",
	  "Fontaine",
	  "Chevalier",
	  "Robin",
	  "Masson",
	  "Sanchez",
	  "Gerard",
	  "Nguyen",
	  "Boyer",
	  "Denis",
	  "Lemaire",
	  "Duval",
	  "Joly",
	  "Gautier",
	  "Roger",
	  "Roche",
	  "Roy",
	  "Noel",
	  "Meyer",
	  "Lucas",
	  "Meunier",
	  "Jean",
	  "Perez",
	  "Marchand",
	  "Dufour",
	  "Blanchard",
	  "Marie",
	  "Barbier",
	  "Brun",
	  "Dumas",
	  "Brunet",
	  "Schmitt",
	  "Leroux",
	  "Colin",
	  "Fernandez",
	  "Pierre",
	  "Renard",
	  "Arnaud",
	  "Rolland",
	  "Caron",
	  "Aubert",
	  "Giraud",
	  "Leclerc",
	  "Vidal",
	  "Bourgeois",
	  "Renaud",
	  "Lemoine",
	  "Picard",
	  "Gaillard",
	  "Philippe",
	  "Leclercq",
	  "Lacroix",
	  "Fabre",
	  "Dupuis",
	  "Olivier",
	  "Rodriguez",
	  "Da silva",
	  "Hubert",
	  "Louis",
	  "Charles",
	  "Guillot",
	  "Riviere",
	  "Le gall",
	  "Guillaume",
	  "Adam",
	  "Rey",
	  "Moulin",
	  "Gonzalez",
	  "Berger",
	  "Lecomte",
	  "Menard",
	  "Fleury",
	  "Deschamps",
	  "Carpentier",
	  "Julien",
	  "Benoit",
	  "Paris",
	  "Maillard",
	  "Marchal",
	  "Aubry",
	  "Vasseur",
	  "Le roux",
	  "Renault",
	  "Jacquet",
	  "Collet",
	  "Prevost",
	  "Poirier",
	  "Charpentier",
	  "Royer",
	  "Huet",
	  "Baron",
	  "Dupuy",
	  "Pons",
	  "Paul",
	  "Laine",
	  "Carre",
	  "Breton",
	  "Remy",
	  "Schneider",
	  "Perrot",
	  "Guyot",
	  "Barre",
	  "Marty",
	  "Cousin"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{last_name} #{first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "M",
	  "Mme",
	  "Mlle",
	  "Dr",
	  "Prof"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "job": [
	    "Superviseur",
	    "Executif",
	    "Manager",
	    "Ingenieur",
	    "Specialiste",
	    "Directeur",
	    "Coordinateur",
	    "Administrateur",
	    "Architecte",
	    "Analyste",
	    "Designer",
	    "Technicien",
	    "Developpeur",
	    "Producteur",
	    "Consultant",
	    "Assistant",
	    "Agent",
	    "Stagiaire"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01########",
	  "02########",
	  "03########",
	  "04########",
	  "05########",
	  "06########",
	  "07########",
	  "+33 1########",
	  "+33 2########",
	  "+33 3########",
	  "+33 4########",
	  "+33 5########",
	  "+33 6########",
	  "+33 7########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1155);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Canada"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(1159);
	address.state = __webpack_require__(1160);
	address.state_abbr = __webpack_require__(1161);
	address.default_country = __webpack_require__(1157);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "?#? #?#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alberta",
	  "Colombie-Britannique",
	  "Manitoba",
	  "Nouveau-Brunswick",
	  "Terre-Neuve-et-Labrador",
	  "Nouvelle-Écosse",
	  "Territoires du Nord-Ouest",
	  "Nunavut",
	  "Ontario",
	  "Île-du-Prince-Édouard",
	  "Québec",
	  "Saskatchewan",
	  "Yukon"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AB",
	  "BC",
	  "MB",
	  "NB",
	  "NL",
	  "NS",
	  "NU",
	  "NT",
	  "ON",
	  "PE",
	  "QC",
	  "SK",
	  "YK"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fr_CA = {};
	module['exports'] = fr_CA;
	fr_CA.title = "Canada (French)";
	fr_CA.address = __webpack_require__(1158);
	fr_CA.internet = __webpack_require__(1165);
	fr_CA.phone_number = __webpack_require__(1167);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "qc.ca",
	  "ca",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.ca",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1164);
	internet.domain_suffix = __webpack_require__(1163);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "### ###-####",
	  "1 ### ###-####",
	  "### ###-####, poste ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1166);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აბასთუმანი",
	  "აბაშა",
	  "ადიგენი",
	  "ამბროლაური",
	  "ანაკლია",
	  "ასპინძა",
	  "ახალგორი",
	  "ახალქალაქი",
	  "ახალციხე",
	  "ახმეტა",
	  "ბათუმი",
	  "ბაკურიანი",
	  "ბაღდათი",
	  "ბახმარო",
	  "ბოლნისი",
	  "ბორჯომი",
	  "გარდაბანი",
	  "გონიო",
	  "გორი",
	  "გრიგოლეთი",
	  "გუდაური",
	  "გურჯაანი",
	  "დედოფლისწყარო",
	  "დმანისი",
	  "დუშეთი",
	  "ვანი",
	  "ზესტაფონი",
	  "ზუგდიდი",
	  "თბილისი",
	  "თეთრიწყარო",
	  "თელავი",
	  "თერჯოლა",
	  "თიანეთი",
	  "კასპი",
	  "კვარიათი",
	  "კიკეთი",
	  "კოჯორი",
	  "ლაგოდეხი",
	  "ლანჩხუთი",
	  "ლენტეხი",
	  "მარნეული",
	  "მარტვილი",
	  "მესტია",
	  "მცხეთა",
	  "მწვანე კონცხი",
	  "ნინოწმინდა",
	  "ოზურგეთი",
	  "ონი",
	  "რუსთავი",
	  "საგარეჯო",
	  "საგურამო",
	  "საირმე",
	  "სამტრედია",
	  "სარფი",
	  "საჩხერე",
	  "სენაკი",
	  "სიღნაღი",
	  "სტეფანწმინდა",
	  "სურამი",
	  "ტაბახმელა",
	  "ტყიბული",
	  "ურეკი",
	  "ფოთი",
	  "ქარელი",
	  "ქედა",
	  "ქობულეთი",
	  "ქუთაისი",
	  "ყვარელი",
	  "შუახევი",
	  "ჩაქვი",
	  "ჩოხატაური",
	  "ცაგერი",
	  "ცხოროჭყუ",
	  "წავკისი",
	  "წალენჯიხა",
	  "წალკა",
	  "წაღვერი",
	  "წეროვანი",
	  "წნორი",
	  "წყალტუბო",
	  "წყნეთი",
	  "ჭიათურა",
	  "ხარაგაული",
	  "ხაშური",
	  "ხელვაჩაური",
	  "ხობი",
	  "ხონი",
	  "ხულო"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ახალი",
	  "ძველი",
	  "ზემო",
	  "ქვემო"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "სოფელი",
	  "ძირი",
	  "სკარი",
	  "დაბა"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ავსტრალია",
	  "ავსტრია",
	  "ავღანეთი",
	  "აზავადი",
	  "აზერბაიჯანი",
	  "აზიაში",
	  "აზიის",
	  "ალბანეთი",
	  "ალჟირი",
	  "ამაღლება და ტრისტანი-და-კუნია",
	  "ამერიკის ვირჯინიის კუნძულები",
	  "ამერიკის სამოა",
	  "ამერიკის შეერთებული შტატები",
	  "ამერიკის",
	  "ანგილია",
	  "ანგოლა",
	  "ანდორა",
	  "ანტიგუა და ბარბუდა",
	  "არაბეთის საემიროები",
	  "არაბთა გაერთიანებული საამიროები",
	  "არაბული ქვეყნების ლიგის",
	  "არგენტინა",
	  "არუბა",
	  "არცნობილი ქვეყნების სია",
	  "აფრიკაში",
	  "აფრიკაშია",
	  "აღდგომის კუნძული",
	  "აღმ. ტიმორი",
	  "აღმოსავლეთი აფრიკა",
	  "აღმოსავლეთი ტიმორი",
	  "აშშ",
	  "აშშ-ის ვირჯინის კუნძულები",
	  "ახალი ზელანდია",
	  "ახალი კალედონია",
	  "ბანგლადეში",
	  "ბარბადოსი",
	  "ბაჰამის კუნძულები",
	  "ბაჰრეინი",
	  "ბელარუსი",
	  "ბელგია",
	  "ბელიზი",
	  "ბენინი",
	  "ბერმუდა",
	  "ბერმუდის კუნძულები",
	  "ბოლივია",
	  "ბოსნია და ჰერცეგოვინა",
	  "ბოტსვანა",
	  "ბრაზილია",
	  "ბრიტანეთის ვირჯინიის კუნძულები",
	  "ბრიტანეთის ვირჯინის კუნძულები",
	  "ბრიტანეთის ინდოეთის ოკეანის ტერიტორია",
	  "ბრუნეი",
	  "ბულგარეთი",
	  "ბურკინა ფასო",
	  "ბურკინა-ფასო",
	  "ბურუნდი",
	  "ბჰუტანი",
	  "გაბონი",
	  "გაერთიანებული სამეფო",
	  "გაეროს",
	  "გაიანა",
	  "გამბია",
	  "განა",
	  "გერმანია",
	  "გვადელუპა",
	  "გვატემალა",
	  "გვინეა",
	  "გვინეა-ბისაუ",
	  "გიბრალტარი",
	  "გრენადა",
	  "გრენლანდია",
	  "გუამი",
	  "დამოკიდებული ტერ.",
	  "დამოკიდებული ტერიტორია",
	  "დამოკიდებული",
	  "დანია",
	  "დასავლეთი აფრიკა",
	  "დასავლეთი საჰარა",
	  "დიდი ბრიტანეთი",
	  "დომინიკა",
	  "დომინიკელთა რესპუბლიკა",
	  "ეგვიპტე",
	  "ევროკავშირის",
	  "ევროპასთან",
	  "ევროპაშია",
	  "ევროპის ქვეყნები",
	  "ეთიოპია",
	  "ეკვადორი",
	  "ეკვატორული გვინეა",
	  "ეპარსეს კუნძული",
	  "ერაყი",
	  "ერიტრეა",
	  "ესპანეთი",
	  "ესპანეთის სუვერენული ტერიტორიები",
	  "ესტონეთი",
	  "ეშმორის და კარტიეს კუნძულები",
	  "ვანუატუ",
	  "ვატიკანი",
	  "ვენესუელა",
	  "ვიეტნამი",
	  "ზამბია",
	  "ზიმბაბვე",
	  "თურქეთი",
	  "თურქმენეთი",
	  "იამაიკა",
	  "იან მაიენი",
	  "იაპონია",
	  "იემენი",
	  "ინდოეთი",
	  "ინდონეზია",
	  "იორდანია",
	  "ირანი",
	  "ირლანდია",
	  "ისლანდია",
	  "ისრაელი",
	  "იტალია",
	  "კაბო-ვერდე",
	  "კაიმანის კუნძულები",
	  "კამბოჯა",
	  "კამერუნი",
	  "კანადა",
	  "კანარის კუნძულები",
	  "კარიბის ზღვის",
	  "კატარი",
	  "კენია",
	  "კვიპროსი",
	  "კინგმენის რიფი",
	  "კირიბატი",
	  "კლიპერტონი",
	  "კოლუმბია",
	  "კომორი",
	  "კომორის კუნძულები",
	  "კონგოს დემოკრატიული რესპუბლიკა",
	  "კონგოს რესპუბლიკა",
	  "კორეის რესპუბლიკა",
	  "კოსტა-რიკა",
	  "კოტ-დ’ივუარი",
	  "კუბა",
	  "კუკის კუნძულები",
	  "ლაოსი",
	  "ლატვია",
	  "ლესოთო",
	  "ლიბანი",
	  "ლიბერია",
	  "ლიბია",
	  "ლიტვა",
	  "ლიხტენშტაინი",
	  "ლუქსემბურგი",
	  "მადაგასკარი",
	  "მადეირა",
	  "მავრიკი",
	  "მავრიტანია",
	  "მაიოტა",
	  "მაკაო",
	  "მაკედონია",
	  "მალავი",
	  "მალაიზია",
	  "მალდივი",
	  "მალდივის კუნძულები",
	  "მალი",
	  "მალტა",
	  "მაროკო",
	  "მარტინიკა",
	  "მარშალის კუნძულები",
	  "მარჯნის ზღვის კუნძულები",
	  "მელილია",
	  "მექსიკა",
	  "მიანმარი",
	  "მიკრონეზია",
	  "მიკრონეზიის ფედერაციული შტატები",
	  "მიმდებარე კუნძულები",
	  "მოზამბიკი",
	  "მოლდოვა",
	  "მონაკო",
	  "მონსერატი",
	  "მონღოლეთი",
	  "ნამიბია",
	  "ნაურუ",
	  "ნაწილობრივ აფრიკაში",
	  "ნეპალი",
	  "ნიგერი",
	  "ნიგერია",
	  "ნიდერლანდი",
	  "ნიდერლანდის ანტილები",
	  "ნიკარაგუა",
	  "ნიუე",
	  "ნორვეგია",
	  "ნორფოლკის კუნძული",
	  "ოკეანეთის",
	  "ოკეანიას",
	  "ომანი",
	  "პაკისტანი",
	  "პალაუ",
	  "პალესტინა",
	  "პალმირა (ატოლი)",
	  "პანამა",
	  "პანტელერია",
	  "პაპუა-ახალი გვინეა",
	  "პარაგვაი",
	  "პერუ",
	  "პიტკერნის კუნძულები",
	  "პოლონეთი",
	  "პორტუგალია",
	  "პრინც-ედუარდის კუნძული",
	  "პუერტო-რიკო",
	  "რეუნიონი",
	  "როტუმა",
	  "რუანდა",
	  "რუმინეთი",
	  "რუსეთი",
	  "საბერძნეთი",
	  "სადავო ტერიტორიები",
	  "სალვადორი",
	  "სამოა",
	  "სამხ. კორეა",
	  "სამხრეთ ამერიკაშია",
	  "სამხრეთ ამერიკის",
	  "სამხრეთ აფრიკის რესპუბლიკა",
	  "სამხრეთი აფრიკა",
	  "სამხრეთი გეორგია და სამხრეთ სენდვიჩის კუნძულები",
	  "სამხრეთი სუდანი",
	  "სან-მარინო",
	  "სან-ტომე და პრინსიპი",
	  "საუდის არაბეთი",
	  "საფრანგეთი",
	  "საფრანგეთის გვიანა",
	  "საფრანგეთის პოლინეზია",
	  "საქართველო",
	  "საჰარის არაბთა დემოკრატიული რესპუბლიკა",
	  "სეიშელის კუნძულები",
	  "სენ-ბართელმი",
	  "სენ-მარტენი",
	  "სენ-პიერი და მიკელონი",
	  "სენეგალი",
	  "სენტ-ვინსენტი და გრენადინები",
	  "სენტ-კიტსი და ნევისი",
	  "სენტ-ლუსია",
	  "სერბეთი",
	  "სეუტა",
	  "სვაზილენდი",
	  "სვალბარდი",
	  "სიერა-ლეონე",
	  "სინგაპური",
	  "სირია",
	  "სლოვაკეთი",
	  "სლოვენია",
	  "სოკოტრა",
	  "სოლომონის კუნძულები",
	  "სომალი",
	  "სომალილენდი",
	  "სომხეთი",
	  "სუდანი",
	  "სუვერენული სახელმწიფოები",
	  "სურინამი",
	  "ტაივანი",
	  "ტაილანდი",
	  "ტანზანია",
	  "ტაჯიკეთი",
	  "ტერიტორიები",
	  "ტერქსისა და კაიკოსის კუნძულები",
	  "ტოგო",
	  "ტოკელაუ",
	  "ტონგა",
	  "ტრანსკონტინენტური ქვეყანა",
	  "ტრინიდადი და ტობაგო",
	  "ტუვალუ",
	  "ტუნისი",
	  "უგანდა",
	  "უზბეკეთი",
	  "უკრაინა",
	  "უნგრეთი",
	  "უოლისი და ფუტუნა",
	  "ურუგვაი",
	  "ფარერის კუნძულები",
	  "ფილიპინები",
	  "ფინეთი",
	  "ფიჯი",
	  "ფოლკლენდის კუნძულები",
	  "ქვეყნები",
	  "ქოქოსის კუნძულები",
	  "ქუვეითი",
	  "ღაზის სექტორი",
	  "ყაზახეთი",
	  "ყირგიზეთი",
	  "შვედეთი",
	  "შვეიცარია",
	  "შობის კუნძული",
	  "შრი-ლანკა",
	  "ჩადი",
	  "ჩერნოგორია",
	  "ჩეჩნეთის რესპუბლიკა იჩქერია",
	  "ჩეხეთი",
	  "ჩილე",
	  "ჩინეთი",
	  "ჩრდ. კორეა",
	  "ჩრდილოეთ ამერიკის",
	  "ჩრდილოეთ მარიანას კუნძულები",
	  "ჩრდილოეთი აფრიკა",
	  "ჩრდილოეთი კორეა",
	  "ჩრდილოეთი მარიანას კუნძულები",
	  "ცენტრალური აფრიკა",
	  "ცენტრალური აფრიკის რესპუბლიკა",
	  "წევრები",
	  "წმინდა ელენე",
	  "წმინდა ელენეს კუნძული",
	  "ხორვატია",
	  "ჯერსი",
	  "ჯიბუტი",
	  "ჰავაი",
	  "ჰაიტი",
	  "ჰერდი და მაკდონალდის კუნძულები",
	  "ჰონდურასი",
	  "ჰონკონგი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "საქართველო"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1171);
	address.city_suffix = __webpack_require__(1172);
	address.city = __webpack_require__(1169);
	address.country = __webpack_require__(1173);
	address.building_number = __webpack_require__(1168);
	address.street_suffix = __webpack_require__(1180);
	address.secondary_address = __webpack_require__(1177);
	address.postcode = __webpack_require__(1176);
	address.city_name = __webpack_require__(1170);
	address.street_title = __webpack_require__(1181);
	address.street_name = __webpack_require__(1179);
	address.street_address = __webpack_require__(1178);
	address.default_country = __webpack_require__(1174);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "კორპ. ##",
	  "შენობა ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_title} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "გამზ.",
	  "გამზირი",
	  "ქ.",
	  "ქუჩა",
	  "ჩიხი",
	  "ხეივანი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აბაშიძის",
	  "აბესაძის",
	  "აბულაძის",
	  "აგლაძის",
	  "ადლერის",
	  "ავიაქიმიის",
	  "ავლაბრის",
	  "ათარბეგოვის",
	  "ათონელის",
	  "ალავერდოვის",
	  "ალექსიძის",
	  "ალილუევის",
	  "ალმასიანის",
	  "ამაღლების",
	  "ამირეჯიბის",
	  "ანაგის",
	  "ანდრონიკაშვილის",
	  "ანთელავას",
	  "ანჯაფარიძის",
	  "არაგვის",
	  "არდონის",
	  "არეშიძის",
	  "ასათიანის",
	  "ასკურავას",
	  "ასლანიდის",
	  "ატენის",
	  "აფხაზი",
	  "აღმაშენებლის",
	  "ახალშენის",
	  "ახვლედიანის",
	  "ბააზოვის",
	  "ბაბისხევის",
	  "ბაბუშკინის",
	  "ბაგრატიონის",
	  "ბალანჩივაძეების",
	  "ბალანჩივაძის",
	  "ბალანჩინის",
	  "ბალმაშევის",
	  "ბარამიძის",
	  "ბარნოვის",
	  "ბაშალეიშვილის",
	  "ბევრეთის",
	  "ბელინსკის",
	  "ბელოსტოკის",
	  "ბენაშვილის",
	  "ბეჟანიშვილის",
	  "ბერიძის",
	  "ბოლქვაძის",
	  "ბოცვაძის",
	  "ბოჭორიშვილის",
	  "ბოჭორიძის",
	  "ბუაჩიძის",
	  "ბუდაპეშტის",
	  "ბურკიაშვილის",
	  "ბურძგლას",
	  "გაბესკირიას",
	  "გაგარინის",
	  "გაზაფხულის",
	  "გამრეკელის",
	  "გამსახურდიას",
	  "გარეჯელის",
	  "გეგეჭკორის",
	  "გედაურის",
	  "გელოვანი",
	  "გელოვანის",
	  "გერცენის",
	  "გლდანის",
	  "გოგებაშვილის",
	  "გოგიბერიძის",
	  "გოგოლის",
	  "გონაშვილის",
	  "გორგასლის",
	  "გრანელის",
	  "გრიზოდუბოვას",
	  "გრინევიცკის",
	  "გრომოვას",
	  "გრუზინსკის",
	  "გუდიაშვილის",
	  "გულრიფშის",
	  "გულუას",
	  "გურამიშვილის",
	  "გურგენიძის",
	  "დადიანის",
	  "დავითაშვილის",
	  "დამაკავშირებელი",
	  "დარიალის",
	  "დედოფლისწყაროს",
	  "დეპუტატის",
	  "დიდგორის",
	  "დიდი",
	  "დიდუბის",
	  "დიუმას",
	  "დიღმის",
	  "დიღომში",
	  "დოლიძის",
	  "დუნდუას",
	  "დურმიშიძის",
	  "ელიავას",
	  "ენგელსის",
	  "ენგურის",
	  "ეპისკოპოსის",
	  "ერისთავი",
	  "ერისთავის",
	  "ვაზისუბნის",
	  "ვაკელის",
	  "ვართაგავას",
	  "ვატუტინის",
	  "ვაჩნაძის",
	  "ვაცეკის",
	  "ვეკუას",
	  "ვეშაპურის",
	  "ვირსალაძის",
	  "ვოლოდარსკის",
	  "ვორონინის",
	  "ზაარბრიუკენის",
	  "ზაზიაშვილის",
	  "ზაზიშვილის",
	  "ზაკომოლდინის",
	  "ზანდუკელის",
	  "ზაქარაიას",
	  "ზაქარიაძის",
	  "ზახაროვის",
	  "ზაჰესის",
	  "ზნაურის",
	  "ზურაბაშვილის",
	  "ზღვის",
	  "თაბუკაშვილის",
	  "თავაძის",
	  "თავისუფლების",
	  "თამარაშვილის",
	  "თაქთაქიშვილის",
	  "თბილელის",
	  "თელიას",
	  "თორაძის",
	  "თოფურიძის",
	  "იალბუზის",
	  "იამანიძის",
	  "იაშვილის",
	  "იბერიის",
	  "იერუსალიმის",
	  "ივანიძის",
	  "ივერიელის",
	  "იზაშვილის",
	  "ილურიძის",
	  "იმედაშვილის",
	  "იმედაძის",
	  "იმედის",
	  "ინანიშვილის",
	  "ინგოროყვას",
	  "ინდუსტრიალიზაციის",
	  "ინჟინრის",
	  "ინწკირველის",
	  "ირბახის",
	  "ირემაშვილის",
	  "ისაკაძის",
	  "ისპასჰანლის",
	  "იტალიის",
	  "იუნკერთა",
	  "კათალიკოსის",
	  "კაიროს",
	  "კაკაბაძის",
	  "კაკაბეთის",
	  "კაკლიანის",
	  "კალანდაძის",
	  "კალიაევის",
	  "კალინინის",
	  "კამალოვის",
	  "კამოს",
	  "კაშენის",
	  "კახოვკის",
	  "კედიას",
	  "კელაპტრიშვილის",
	  "კერესელიძის",
	  "კეცხოველის",
	  "კიბალჩიჩის",
	  "კიკნაძის",
	  "კიროვის",
	  "კობარეთის",
	  "კოლექტივიზაციის",
	  "კოლმეურნეობის",
	  "კოლხეთის",
	  "კომკავშირის",
	  "კომუნისტური",
	  "კონსტიტუციის",
	  "კოოპერაციის",
	  "კოსტავას",
	  "კოტეტიშვილის",
	  "კოჩეტკოვის",
	  "კოჯრის",
	  "კრონშტადტის",
	  "კროპოტკინის",
	  "კრუპსკაიას",
	  "კუიბიშევის",
	  "კურნატოვსკის",
	  "კურტანოვსკის",
	  "კუტუზოვის",
	  "ლაღიძის",
	  "ლელაშვილის",
	  "ლენინაშენის",
	  "ლენინგრადის",
	  "ლენინის",
	  "ლენის",
	  "ლეონიძის",
	  "ლვოვის",
	  "ლორთქიფანიძის",
	  "ლოტკინის",
	  "ლუბლიანის",
	  "ლუბოვსკის",
	  "ლუნაჩარსკის",
	  "ლუქსემბურგის",
	  "მაგნიტოგორსკის",
	  "მაზნიაშვილის",
	  "მაისურაძის",
	  "მამარდაშვილის",
	  "მამაცაშვილის",
	  "მანაგაძის",
	  "მანჯგალაძის",
	  "მარის",
	  "მარუაშვილის",
	  "მარქსის",
	  "მარჯანის",
	  "მატროსოვის",
	  "მაჭავარიანი",
	  "მახალდიანის",
	  "მახარაძის",
	  "მებაღიშვილის",
	  "მეგობრობის",
	  "მელაანის",
	  "მერკვილაძის",
	  "მესხიას",
	  "მესხის",
	  "მეტეხის",
	  "მეტრეველი",
	  "მეჩნიკოვის",
	  "მთავარანგელოზის",
	  "მიასნიკოვის",
	  "მილორავას",
	  "მიმინოშვილის",
	  "მიროტაძის",
	  "მიქატაძის",
	  "მიქელაძის",
	  "მონტინის",
	  "მორეტის",
	  "მოსკოვის",
	  "მრევლიშვილის",
	  "მუშკორის",
	  "მუჯირიშვილის",
	  "მშვიდობის",
	  "მცხეთის",
	  "ნადირაძის",
	  "ნაკაშიძის",
	  "ნარიმანოვის",
	  "ნასიძის",
	  "ნაფარეულის",
	  "ნეკრასოვის",
	  "ნიაღვრის",
	  "ნინიძის",
	  "ნიშნიანიძის",
	  "ობოლაძის",
	  "ონიანის",
	  "ოჟიოს",
	  "ორახელაშვილის",
	  "ორბელიანის",
	  "ორჯონიკიძის",
	  "ოქტომბრის",
	  "ოცდაექვსი",
	  "პავლოვის",
	  "პარალელურის",
	  "პარიზის",
	  "პეკინის",
	  "პეროვსკაიას",
	  "პეტეფის",
	  "პიონერის",
	  "პირველი",
	  "პისარევის",
	  "პლეხანოვის",
	  "პრავდის",
	  "პროლეტარიატის",
	  "ჟელიაბოვის",
	  "ჟვანიას",
	  "ჟორდანიას",
	  "ჟღენტი",
	  "ჟღენტის",
	  "რადიანის",
	  "რამიშვილი",
	  "რასკოვას",
	  "რენინგერის",
	  "რინგის",
	  "რიჟინაშვილის",
	  "რობაქიძის",
	  "რობესპიერის",
	  "რუსის",
	  "რუხაძის",
	  "რჩეულიშვილის",
	  "სააკაძის",
	  "საბადურის",
	  "საბაშვილის",
	  "საბურთალოს",
	  "საბჭოს",
	  "საგურამოს",
	  "სამრეკლოს",
	  "სამღერეთის",
	  "სანაკოევის",
	  "სარაჯიშვილის",
	  "საჯაიას",
	  "სევასტოპოლის",
	  "სერგი",
	  "სვანიძის",
	  "სვერდლოვის",
	  "სტახანოვის",
	  "სულთნიშნის",
	  "სურგულაძის",
	  "სხირტლაძის",
	  "ტაბიძის",
	  "ტატიშვილის",
	  "ტელმანის",
	  "ტერევერკოს",
	  "ტეტელაშვილის",
	  "ტოვსტონოგოვის",
	  "ტოროშელიძის",
	  "ტრაქტორის",
	  "ტრიკოტაჟის",
	  "ტურბინის",
	  "უბილავას",
	  "უბინაშვილის",
	  "უზნაძის",
	  "უკლებას",
	  "ულიანოვის",
	  "ურიდიას",
	  "ფაბრიციუსის",
	  "ფაღავას",
	  "ფერისცვალების",
	  "ფიგნერის",
	  "ფიზკულტურის",
	  "ფიოლეტოვის",
	  "ფიფიების",
	  "ფოცხიშვილის",
	  "ქართველიშვილის",
	  "ქართლელიშვილის",
	  "ქინქლაძის",
	  "ქიქოძის",
	  "ქსოვრელის",
	  "ქუთათელაძის",
	  "ქუთათელის",
	  "ქურდიანის",
	  "ღოღობერიძის",
	  "ღუდუშაურის",
	  "ყავლაშვილის",
	  "ყაზბეგის",
	  "ყარყარაშვილის",
	  "ყიფიანის",
	  "ყუშიტაშვილის",
	  "შანიძის",
	  "შარტავას",
	  "შატილოვის",
	  "შაუმიანის",
	  "შენგელაიას",
	  "შერვაშიძის",
	  "შეროზიას",
	  "შირშოვის",
	  "შმიდტის",
	  "შრომის",
	  "შუშინის",
	  "შჩორსის",
	  "ჩალაუბნის",
	  "ჩანტლაძის",
	  "ჩაპაევის",
	  "ჩაჩავას",
	  "ჩელუსკინელების",
	  "ჩერნიახოვსკის",
	  "ჩერქეზიშვილი",
	  "ჩერქეზიშვილის",
	  "ჩვიდმეტი",
	  "ჩიტაიას",
	  "ჩიტაძის",
	  "ჩიქვანაიას",
	  "ჩიქობავას",
	  "ჩიხლაძის",
	  "ჩოდრიშვილის",
	  "ჩოლოყაშვილის",
	  "ჩუღურეთის",
	  "ცაბაძის",
	  "ცაგარელის",
	  "ცეტკინის",
	  "ცინცაძის",
	  "ცისკარიშვილის",
	  "ცურტაველის",
	  "ცქიტიშვილის",
	  "ცხაკაიას",
	  "ძმობის",
	  "ძნელაძის",
	  "წერეთლის",
	  "წითელი",
	  "წითელწყაროს",
	  "წინამძღვრიშვილის",
	  "წულაძის",
	  "წულუკიძის",
	  "ჭაბუკიანის",
	  "ჭავჭავაძის",
	  "ჭანტურიას",
	  "ჭოველიძის",
	  "ჭონქაძის",
	  "ჭყონდიდელის",
	  "ხანძთელის",
	  "ხვამლის",
	  "ხვინგიას",
	  "ხვიჩიას",
	  "ხიმშიაშვილის",
	  "ხმელნიცკის",
	  "ხორნაბუჯის",
	  "ხრამჰესის",
	  "ხუციშვილის",
	  "ჯავახიშვილის",
	  "ჯაფარიძის",
	  "ჯიბლაძის",
	  "ჯორჯიაშვილის"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(+995 32) 2-##-##-##",
	  "032-2-##-##-##",
	  "032-2-######",
	  "032-2-###-###",
	  "032 2 ## ## ##",
	  "032 2 ######",
	  "2 ## ## ##",
	  "2######",
	  "2 ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1182);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(1186);
	company.suffix = __webpack_require__(1187);
	company.name = __webpack_require__(1185);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.first_name}",
	  "#{prefix} #{Name.last_name}",
	  "#{prefix} #{Name.last_name} #{suffix}",
	  "#{prefix} #{Name.first_name} #{suffix}",
	  "#{prefix} #{Name.last_name}-#{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "შპს",
	  "სს",
	  "ააიპ",
	  "სსიპ"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ჯგუფი",
	  "და კომპანია",
	  "სტუდია",
	  "გრუპი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ge = {};
	module['exports'] = ge;
	ge.title = "Georgian";
	ge.separator = " და ";
	ge.name = __webpack_require__(1193);
	ge.address = __webpack_require__(1175);
	ge.internet = __webpack_require__(1191);
	ge.company = __webpack_require__(1184);
	ge.phone_number = __webpack_require__(1199);
	ge.cell_phone = __webpack_require__(1183);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ge",
	  "com",
	  "net",
	  "org",
	  "com.ge",
	  "org.ge"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "posta.ge"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1190);
	internet.domain_suffix = __webpack_require__(1189);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აგული",
	  "აგუნა",
	  "ადოლა",
	  "ავთანდილ",
	  "ავთო",
	  "აკაკი",
	  "აკო",
	  "ალეკო",
	  "ალექსანდრე",
	  "ალექსი",
	  "ალიო",
	  "ამირან",
	  "ანა",
	  "ანანო",
	  "ანზორ",
	  "ანნა",
	  "ანუკა",
	  "ანუკი",
	  "არჩილ",
	  "ასკილა",
	  "ასლანაზ",
	  "აჩიკო",
	  "ბადრი",
	  "ბაია",
	  "ბარბარე",
	  "ბაქარ",
	  "ბაჩა",
	  "ბაჩანა",
	  "ბაჭუა",
	  "ბაჭუკი",
	  "ბახვა",
	  "ბელა",
	  "ბერა",
	  "ბერდია",
	  "ბესიკ",
	  "ბესიკ",
	  "ბესო",
	  "ბექა",
	  "ბიძინა",
	  "ბიჭიკო",
	  "ბოჩია",
	  "ბოცო",
	  "ბროლა",
	  "ბუბუ",
	  "ბუდუ",
	  "ბუხუტი",
	  "გაგა",
	  "გაგი",
	  "გახა",
	  "გეგა",
	  "გეგი",
	  "გედია",
	  "გელა",
	  "გენადი",
	  "გვადი",
	  "გვანცა",
	  "გვანჯი",
	  "გვიტია",
	  "გვრიტა",
	  "გია",
	  "გიგა",
	  "გიგი",
	  "გიგილო",
	  "გიგლა",
	  "გიგოლი",
	  "გივი",
	  "გივიკო",
	  "გიორგი",
	  "გოგი",
	  "გოგიტა",
	  "გოგიჩა",
	  "გოგოთურ",
	  "გოგოლა",
	  "გოდერძი",
	  "გოლა",
	  "გოჩა",
	  "გრიგოლ",
	  "გუგა",
	  "გუგუ",
	  "გუგულა",
	  "გუგული",
	  "გუგუნა",
	  "გუკა",
	  "გულარისა",
	  "გულვარდი",
	  "გულვარდისა",
	  "გულთამზე",
	  "გულია",
	  "გულიკო",
	  "გულისა",
	  "გულნარა",
	  "გურამ",
	  "დავით",
	  "დალი",
	  "დარეჯან",
	  "დიანა",
	  "დიმიტრი",
	  "დოდო",
	  "დუტუ",
	  "ეთერ",
	  "ეთო",
	  "ეკა",
	  "ეკატერინე",
	  "ელგუჯა",
	  "ელენა",
	  "ელენე",
	  "ელზა",
	  "ელიკო",
	  "ელისო",
	  "ემზარ",
	  "ეშხა",
	  "ვალენტინა",
	  "ვალერი",
	  "ვანო",
	  "ვაჟა",
	  "ვაჟა",
	  "ვარდო",
	  "ვარსკვლავისა",
	  "ვასიკო",
	  "ვასილ",
	  "ვატო",
	  "ვახო",
	  "ვახტანგ",
	  "ვენერა",
	  "ვერა",
	  "ვერიკო",
	  "ზაზა",
	  "ზაირა",
	  "ზაურ",
	  "ზეზვა",
	  "ზვიად",
	  "ზინა",
	  "ზოია",
	  "ზუკა",
	  "ზურა",
	  "ზურაბ",
	  "ზურია",
	  "ზურიკო",
	  "თაზო",
	  "თათა",
	  "თათია",
	  "თათული",
	  "თაია",
	  "თაკო",
	  "თალიკო",
	  "თამაზ",
	  "თამარ",
	  "თამარა",
	  "თამთა",
	  "თამთიკე",
	  "თამი",
	  "თამილა",
	  "თამრიკო",
	  "თამრო",
	  "თამუნა",
	  "თამჩო",
	  "თანანა",
	  "თანდილა",
	  "თაყა",
	  "თეა",
	  "თებრონე",
	  "თეიმურაზ",
	  "თემურ",
	  "თენგიზ",
	  "თენგო",
	  "თეონა",
	  "თიკა",
	  "თიკო",
	  "თიკუნა",
	  "თინა",
	  "თინათინ",
	  "თინიკო",
	  "თმაგიშერა",
	  "თორნიკე",
	  "თუთა",
	  "თუთია",
	  "ია",
	  "იათამზე",
	  "იამზე",
	  "ივანე",
	  "ივერი",
	  "ივქირიონ",
	  "იზოლდა",
	  "ილია",
	  "ილიკო",
	  "იმედა",
	  "ინგა",
	  "იოსებ",
	  "ირაკლი",
	  "ირინა",
	  "ირინე",
	  "ირინკა",
	  "ირმა",
	  "იური",
	  "კაკო",
	  "კალე",
	  "კატო",
	  "კახა",
	  "კახაბერ",
	  "კეკელა",
	  "კესანე",
	  "კესო",
	  "კვირია",
	  "კიტა",
	  "კობა",
	  "კოკა",
	  "კონსტანტინე",
	  "კოსტა",
	  "კოტე",
	  "კუკური",
	  "ლადო",
	  "ლალი",
	  "ლამაზა",
	  "ლამარა",
	  "ლამზირა",
	  "ლაშა",
	  "ლევან",
	  "ლეილა",
	  "ლელა",
	  "ლენა",
	  "ლერწამისა",
	  "ლექსო",
	  "ლია",
	  "ლიანა",
	  "ლიზა",
	  "ლიზიკო",
	  "ლილე",
	  "ლილი",
	  "ლილიკო",
	  "ლომია",
	  "ლუიზა",
	  "მაგული",
	  "მადონა",
	  "მათიკო",
	  "მაია",
	  "მაიკო",
	  "მაისა",
	  "მაკა",
	  "მაკო",
	  "მაკუნა",
	  "მალხაზ",
	  "მამამზე",
	  "მამია",
	  "მამისა",
	  "მამისთვალი",
	  "მამისიმედი",
	  "მამუკა",
	  "მამულა",
	  "მანანა",
	  "მანჩო",
	  "მარადი",
	  "მარი",
	  "მარია",
	  "მარიამი",
	  "მარიკა",
	  "მარინა",
	  "მარინე",
	  "მარიტა",
	  "მაყვალა",
	  "მაყვალა",
	  "მაშიკო",
	  "მაშო",
	  "მაცაცო",
	  "მგელია",
	  "მგელიკა",
	  "მედეა",
	  "მეკაშო",
	  "მელანო",
	  "მერაბ",
	  "მერი",
	  "მეტია",
	  "მზაღო",
	  "მზევინარ",
	  "მზეთამზე",
	  "მზეთვალა",
	  "მზეონა",
	  "მზექალა",
	  "მზეხა",
	  "მზეხათუნი",
	  "მზია",
	  "მზირა",
	  "მზისადარ",
	  "მზისთანადარი",
	  "მზიულა",
	  "მთვარისა",
	  "მინდია",
	  "მიშა",
	  "მიშიკო",
	  "მიხეილ",
	  "მნათობი",
	  "მნათობისა",
	  "მოგელი",
	  "მონავარდისა",
	  "მურმან",
	  "მუხრან",
	  "ნაზი",
	  "ნაზიკო",
	  "ნათელა",
	  "ნათია",
	  "ნაირა",
	  "ნანა",
	  "ნანი",
	  "ნანიკო",
	  "ნანუკა",
	  "ნანული",
	  "ნარგიზი",
	  "ნასყიდა",
	  "ნატალია",
	  "ნატო",
	  "ნელი",
	  "ნენე",
	  "ნესტან",
	  "ნია",
	  "ნიაკო",
	  "ნიკა",
	  "ნიკოლოზ",
	  "ნინა",
	  "ნინაკა",
	  "ნინი",
	  "ნინიკო",
	  "ნინო",
	  "ნინუკა",
	  "ნინუცა",
	  "ნოდარ",
	  "ნოდო",
	  "ნონა",
	  "ნორა",
	  "ნუგზარ",
	  "ნუგო",
	  "ნუკა",
	  "ნუკი",
	  "ნუკრი",
	  "ნუნუ",
	  "ნუნუ",
	  "ნუნუკა",
	  "ნუცა",
	  "ნუცი",
	  "ოთარ",
	  "ოთია",
	  "ოთო",
	  "ომარ",
	  "ორბელ",
	  "ოტია",
	  "ოქროპირ",
	  "პაატა",
	  "პაპუნა",
	  "პატარკაცი",
	  "პატარქალი",
	  "პეპელა",
	  "პირვარდისა",
	  "პირიმზე",
	  "ჟამიერა",
	  "ჟამიტა",
	  "ჟამუტა",
	  "ჟუჟუნა",
	  "რამაზ",
	  "რევაზ",
	  "რეზი",
	  "რეზო",
	  "როზა",
	  "რომან",
	  "რუსკა",
	  "რუსუდან",
	  "საბა",
	  "სალი",
	  "სალომე",
	  "სანათა",
	  "სანდრო",
	  "სერგო",
	  "სესია",
	  "სეხნია",
	  "სვეტლანა",
	  "სიხარულა",
	  "სოსო",
	  "სოფიკო",
	  "სოფიო",
	  "სოფო",
	  "სულა",
	  "სულიკო",
	  "ტარიელ",
	  "ტასიკო",
	  "ტასო",
	  "ტატიანა",
	  "ტატო",
	  "ტეტია",
	  "ტურია",
	  "უმანკო",
	  "უტა",
	  "უჩა",
	  "ფაქიზო",
	  "ფაცია",
	  "ფეფელა",
	  "ფეფენა",
	  "ფეფიკო",
	  "ფეფო",
	  "ფოსო",
	  "ფოფო",
	  "ქაბატო",
	  "ქავთარი",
	  "ქალია",
	  "ქართლოს",
	  "ქეთათო",
	  "ქეთევან",
	  "ქეთი",
	  "ქეთინო",
	  "ქეთო",
	  "ქველი",
	  "ქიტესა",
	  "ქიშვარდი",
	  "ქობული",
	  "ქრისტესია",
	  "ქტისტეფორე",
	  "ქურციკა",
	  "ღარიბა",
	  "ღვთისავარი",
	  "ღვთისია",
	  "ღვთისო",
	  "ღვინია",
	  "ღუღუნა",
	  "ყაითამზა",
	  "ყაყიტა",
	  "ყვარყვარე",
	  "ყიასა",
	  "შაბური",
	  "შაკო",
	  "შალვა",
	  "შალიკო",
	  "შანშე",
	  "შარია",
	  "შაქარა",
	  "შაქრო",
	  "შოთა",
	  "შორენა",
	  "შოშია",
	  "შუქია",
	  "ჩიორა",
	  "ჩიტო",
	  "ჩიტო",
	  "ჩოყოლა",
	  "ცაგო",
	  "ცაგული",
	  "ცანგალა",
	  "ცარო",
	  "ცაცა",
	  "ცაცო",
	  "ციალა",
	  "ციკო",
	  "ცინარა",
	  "ცირა",
	  "ცისანა",
	  "ცისია",
	  "ცისკარა",
	  "ცისკარი",
	  "ცისმარა",
	  "ცისმარი",
	  "ციური",
	  "ციცი",
	  "ციცია",
	  "ციცინო",
	  "ცოტნე",
	  "ცოქალა",
	  "ცუცა",
	  "ცხვარი",
	  "ძაბული",
	  "ძამისა",
	  "ძაღინა",
	  "ძიძია",
	  "წათე",
	  "წყალობა",
	  "ჭაბუკა",
	  "ჭიაბერ",
	  "ჭიკჭიკა",
	  "ჭიჭია",
	  "ჭიჭიკო",
	  "ჭოლა",
	  "ხათუნა",
	  "ხარება",
	  "ხატია",
	  "ხახულა",
	  "ხახუტა",
	  "ხეჩუა",
	  "ხვიჩა",
	  "ხიზანა",
	  "ხირხელა",
	  "ხობელასი",
	  "ხოხია",
	  "ხოხიტა",
	  "ხუტა",
	  "ხუცია",
	  "ჯაბა",
	  "ჯავახი",
	  "ჯარჯი",
	  "ჯემალ",
	  "ჯონდო",
	  "ჯოტო",
	  "ჯუბი",
	  "ჯულიეტა",
	  "ჯუმბერ",
	  "ჰამლეტ"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1192);
	name.last_name = __webpack_require__(1194);
	name.prefix = __webpack_require__(1196);
	name.title = __webpack_require__(1197);
	name.name = __webpack_require__(1195);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აბაზაძე",
	  "აბაშიძე",
	  "აბრამაშვილი",
	  "აბუსერიძე",
	  "აბშილავა",
	  "ავაზნელი",
	  "ავალიშვილი",
	  "ამილახვარი",
	  "ანთაძე",
	  "ასლამაზიშვილი",
	  "ასპანიძე",
	  "აშკარელი",
	  "ახალბედაშვილი",
	  "ახალკაცი",
	  "ახვლედიანი",
	  "ბარათაშვილი",
	  "ბარდაველიძე",
	  "ბახტაძე",
	  "ბედიანიძე",
	  "ბერიძე",
	  "ბერუაშვილი",
	  "ბეჟანიშვილი",
	  "ბოგველიშვილი",
	  "ბოტკოველი",
	  "გაბრიჩიძე",
	  "გაგნიძე",
	  "გამრეკელი",
	  "გელაშვილი",
	  "გზირიშვილი",
	  "გიგაური",
	  "გურამიშვილი",
	  "გურგენიძე",
	  "დადიანი",
	  "დავითიშვილი",
	  "დათუაშვილი",
	  "დარბაისელი",
	  "დეკანოიძე",
	  "დვალი",
	  "დოლაბერიძე",
	  "ედიშერაშვილი",
	  "ელიზბარაშვილი",
	  "ელიოზაშვილი",
	  "ერისთავი",
	  "ვარამაშვილი",
	  "ვარდიაშვილი",
	  "ვაჩნაძე",
	  "ვარდანიძე",
	  "ველიაშვილი",
	  "ველიჯანაშვილი",
	  "ზარანდია",
	  "ზარიძე",
	  "ზედგინიძე",
	  "ზუბიაშვილი",
	  "თაბაგარი",
	  "თავდგირიძე",
	  "თათარაშვილი",
	  "თამაზაშვილი",
	  "თამარაშვილი",
	  "თაქთაქიშვილი",
	  "თაყაიშვილი",
	  "თბილელი",
	  "თუხარელი",
	  "იაშვილი",
	  "იგითხანიშვილი",
	  "ინასარიძე",
	  "იშხნელი",
	  "კანდელაკი",
	  "კაცია",
	  "კერესელიძე",
	  "კვირიკაშვილი",
	  "კიკნაძე",
	  "კლდიაშვილი",
	  "კოვზაძე",
	  "კოპაძე",
	  "კოპტონაშვილი",
	  "კოშკელაშვილი",
	  "ლაბაძე",
	  "ლეკიშვილი",
	  "ლიქოკელი",
	  "ლოლაძე",
	  "ლურსმანაშვილი",
	  "მაისურაძე",
	  "მარტოლეკი",
	  "მაღალაძე",
	  "მახარაშვილი",
	  "მგალობლიშვილი",
	  "მეგრელიშვილი",
	  "მელაშვილი",
	  "მელიქიძე",
	  "მერაბიშვილი",
	  "მეფარიშვილი",
	  "მუჯირი",
	  "მჭედლიძე",
	  "მხეიძე",
	  "ნათაძე",
	  "ნაჭყებია",
	  "ნოზაძე",
	  "ოდიშვილი",
	  "ონოფრიშვილი",
	  "პარეხელაშვილი",
	  "პეტრიაშვილი",
	  "სააკაძე",
	  "სააკაშვილი",
	  "საგინაშვილი",
	  "სადუნიშვილი",
	  "საძაგლიშვილი",
	  "სებისკვერიძე",
	  "სეთური",
	  "სუთიაშვილი",
	  "სულაშვილი",
	  "ტაბაღუა",
	  "ტყეშელაშვილი",
	  "ულუმბელაშვილი",
	  "უნდილაძე",
	  "ქავთარაძე",
	  "ქართველიშვილი",
	  "ყაზბეგი",
	  "ყაუხჩიშვილი",
	  "შავლაშვილი",
	  "შალიკაშვილი",
	  "შონია",
	  "ჩიბუხაშვილი",
	  "ჩიხრაძე",
	  "ჩიქოვანი",
	  "ჩუბინიძე",
	  "ჩოლოყაშვილი",
	  "ჩოხელი",
	  "ჩხვიმიანი",
	  "ცალუღელაშვილი",
	  "ცაძიკიძე",
	  "ციციშვილი",
	  "ციხელაშვილი",
	  "ციხისთავი",
	  "ცხოვრებაძე",
	  "ცხომარია",
	  "წამალაიძე",
	  "წერეთელი",
	  "წიკლაური",
	  "წიფურია",
	  "ჭაბუკაშვილი",
	  "ჭავჭავაძე",
	  "ჭანტურია",
	  "ჭარელიძე",
	  "ჭიორელი",
	  "ჭუმბურიძე",
	  "ხაბაზი",
	  "ხარაძე",
	  "ხარატიშვილი",
	  "ხარატასშვილი",
	  "ხარისჭირაშვილი",
	  "ხარხელაური",
	  "ხაშმელაშვილი",
	  "ხეთაგური",
	  "ხიზამბარელი",
	  "ხიზანიშვილი",
	  "ხიმშიაშვილი",
	  "ხოსრუაშვილი",
	  "ხოჯივანიშვილი",
	  "ხუციშვილი",
	  "ჯაბადარი",
	  "ჯავახი",
	  "ჯავახიშვილი",
	  "ჯანელიძე",
	  "ჯაფარიძე",
	  "ჯაყელი",
	  "ჯაჯანიძე",
	  "ჯვარელია",
	  "ჯინიუზაშვილი",
	  "ჯუღაშვილი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ბ-ნი",
	  "ბატონი",
	  "ქ-ნი",
	  "ქალბატონი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "გენერალური",
	    "მთავარი",
	    "სტაჟიორ",
	    "უმცროსი",
	    "ყოფილი",
	    "წამყვანი"
	  ],
	  "level": [
	    "აღრიცხვების",
	    "ბრენდინგის",
	    "ბრენიდს",
	    "ბუღალტერიის",
	    "განყოფილების",
	    "გაყიდვების",
	    "გუნდის",
	    "დახმარების",
	    "დიზაინის",
	    "თავდაცვის",
	    "ინფორმაციის",
	    "კვლევების",
	    "კომუნიკაციების",
	    "მარკეტინგის",
	    "ოპერაციათა",
	    "ოპტიმიზაციების",
	    "პიარ",
	    "პროგრამის",
	    "საქმეთა",
	    "ტაქტიკური",
	    "უსაფრთხოების",
	    "ფინანსთა",
	    "ქსელის",
	    "ხარისხის",
	    "ჯგუფის"
	  ],
	  "job": [
	    "აგენტი",
	    "ადვოკატი",
	    "ადმინისტრატორი",
	    "არქიტექტორი",
	    "ასისტენტი",
	    "აღმასრულებელი დირექტორი",
	    "დეველოპერი",
	    "დეკანი",
	    "დიზაინერი",
	    "დირექტორი",
	    "ელექტრიკოსი",
	    "ექსპერტი",
	    "ინჟინერი",
	    "იურისტი",
	    "კონსტრუქტორი",
	    "კონსულტანტი",
	    "კოორდინატორი",
	    "ლექტორი",
	    "მასაჟისტი",
	    "მემანქანე",
	    "მენეჯერი",
	    "მძღოლი",
	    "მწვრთნელი",
	    "ოპერატორი",
	    "ოფიცერი",
	    "პედაგოგი",
	    "პოლიციელი",
	    "პროგრამისტი",
	    "პროდიუსერი",
	    "პრორექტორი",
	    "ჟურნალისტი",
	    "რექტორი",
	    "სპეციალისტი",
	    "სტრატეგისტი",
	    "ტექნიკოსი",
	    "ფოტოგრაფი",
	    "წარმომადგენელი"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "5##-###-###",
	  "5########",
	  "5## ## ## ##",
	  "5## ######",
	  "5## ### ###",
	  "995 5##-###-###",
	  "995 5########",
	  "995 5## ## ## ##",
	  "995 5## ######",
	  "995 5## ### ###",
	  "+995 5##-###-###",
	  "+995 5########",
	  "+995 5## ## ## ##",
	  "+995 5## ######",
	  "+995 5## ### ###",
	  "(+995) 5##-###-###",
	  "(+995) 5########",
	  "(+995) 5## ## ## ##",
	  "(+995) 5## ######",
	  "(+995) 5## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1198);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [  
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Airmadidi",
	  "Ampana",
	  "Amurang",
	  "Andolo",
	  "Banggai",
	  "Bantaeng",
	  "Barru",
	  "Bau-Bau",
	  "Benteng",
	  "Bitung",
	  "Bolaang Uki",
	  "Boroko",
	  "Bulukumba",
	  "Bungku",
	  "Buol",
	  "Buranga",
	  "Donggala",
	  "Enrekang",
	  "Gorontalo",
	  "Jeneponto",
	  "Kawangkoan",
	  "Kendari",
	  "Kolaka",
	  "Kotamobagu",
	  "Kota Raha",
	  "Kwandang",
	  "Lasusua",
	  "Luwuk",
	  "Majene",
	  "Makale",
	  "Makassar",
	  "Malili",
	  "Mamasa",
	  "Mamuju",
	  "Manado",
	  "Marisa",
	  "Maros",
	  "Masamba",
	  "Melonguane",
	  "Ondong Siau",
	  "Palopo",
	  "Palu",
	  "Pangkajene",
	  "Pare-Pare",
	  "Parigi",
	  "Pasangkayu",
	  "Pinrang",
	  "Polewali",
	  "Poso",
	  "Rantepao",
	  "Ratahan",
	  "Rumbia",
	  "Sengkang",
	  "Sidenreng",
	  "Sigi Biromaru",
	  "Sinjai",
	  "Sunggu Minasa",
	  "Suwawa",
	  "Tahuna",
	  "Takalar",
	  "Tilamuta",
	  "Toli Toli",
	  "Tomohon",
	  "Tondano",
	  "Tutuyan",
	  "Unaaha",
	  "Wangi Wangi",
	  "Wanggudu",
	  "Watampone",
	  "Watan Soppeng",
	  "Ambarawa",
	  "Anyer",
	  "Bandung",
	  "Bangil",
	  "Banjar (Jawa Barat)",
	  "Banjarnegara",
	  "Bangkalan",
	  "Bantul",
	  "Banyumas",
	  "Banyuwangi",
	  "Batang",
	  "Batu",
	  "Bekasi",
	  "Blitar",
	  "Blora",
	  "Bogor",
	  "Bojonegoro",
	  "Bondowoso",
	  "Boyolali",
	  "Bumiayu",
	  "Brebes",
	  "Caruban",
	  "Cianjur",
	  "Ciamis",
	  "Cibinong",
	  "Cikampek",
	  "Cikarang",
	  "Cilacap",
	  "Cilegon",
	  "Cirebon",
	  "Demak",
	  "Depok",
	  "Garut",
	  "Gresik",
	  "Indramayu",
	  "Jakarta",
	  "Jember",
	  "Jepara",
	  "Jombang",
	  "Kajen",
	  "Karanganyar",
	  "Kebumen",
	  "Kediri",
	  "Kendal",
	  "Kepanjen",
	  "Klaten",
	  "Pelabuhan Ratu",
	  "Kraksaan",
	  "Kudus",
	  "Kuningan",
	  "Lamongan",
	  "Lumajang",
	  "Madiun",
	  "Magelang",
	  "Magetan",
	  "Majalengka",
	  "Malang",
	  "Mojokerto",
	  "Mojosari",
	  "Mungkid",
	  "Ngamprah",
	  "Nganjuk",
	  "Ngawi",
	  "Pacitan",
	  "Pamekasan",
	  "Pandeglang",
	  "Pare",
	  "Pati",
	  "Pasuruan",
	  "Pekalongan",
	  "Pemalang",
	  "Ponorogo",
	  "Probolinggo",
	  "Purbalingga",
	  "Purwakarta",
	  "Purwodadi",
	  "Purwokerto",
	  "Purworejo",
	  "Rangkasbitung",
	  "Rembang",
	  "Salatiga",
	  "Sampang",
	  "Semarang",
	  "Serang",
	  "Sidayu",
	  "Sidoarjo",
	  "Singaparna",
	  "Situbondo",
	  "Slawi",
	  "Sleman",
	  "Soreang",
	  "Sragen",
	  "Subang",
	  "Sukabumi",
	  "Sukoharjo",
	  "Sumber",
	  "Sumedang",
	  "Sumenep",
	  "Surabaya",
	  "Surakarta",
	  "Tasikmalaya",
	  "Tangerang",
	  "Tangerang Selatan",
	  "Tegal",
	  "Temanggung",
	  "Tigaraksa",
	  "Trenggalek",
	  "Tuban",
	  "Tulungagung",
	  "Ungaran",
	  "Wates",
	  "Wlingi",
	  "Wonogiri",
	  "Wonosari",
	  "Wonosobo",
	  "Yogyakarta",
	  "Atambua",
	  "Baa",
	  "Badung",
	  "Bajawa",
	  "Bangli",
	  "Bima",
	  "Denpasar",
	  "Dompu",
	  "Ende",
	  "Gianyar",
	  "Kalabahi",
	  "Karangasem",
	  "Kefamenanu",
	  "Klungkung",
	  "Kupang",
	  "Labuhan Bajo",
	  "Larantuka",
	  "Lewoleba",
	  "Maumere",
	  "Mataram",
	  "Mbay",
	  "Negara",
	  "Praya",
	  "Raba",
	  "Ruteng",
	  "Selong",
	  "Singaraja",
	  "Soe",
	  "Sumbawa Besar",
	  "Tabanan",
	  "Taliwang",
	  "Tambolaka",
	  "Tanjung",
	  "Waibakul",
	  "Waikabubak",
	  "Waingapu",
	  "Denpasar",
	  "Negara,Bali",
	  "Singaraja",
	  "Tabanan",
	  "Bangli"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Indonesia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.building_number = __webpack_require__(1200);
	address.postcode = __webpack_require__(1205);
	address.state = __webpack_require__(1206);
	address.city_name = __webpack_require__(1202);
	address.city = __webpack_require__(1201);
	address.street_prefix = __webpack_require__(1209);
	address.street_name = __webpack_require__(1208);
	address.street_address = __webpack_require__(1207);
	address.default_country = __webpack_require__(1203);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aceh",
	  "Sumatera Utara",
	  "Sumatera Barat",
	  "Jambi",
	  "Bangka Belitung",
	  "Riau",
	  "Kepulauan Riau",
	  "Bengkulu",
	  "Sumatera Selatan",
	  "Lampung",
	  "Banten",
	  "DKI Jakarta",
	  "Jawa Barat",
	  "Jawa Tengah",
	  "Jawa Timur",
	  "Nusa Tenggara Timur",
	  "DI Yogyakarta",
	  "Bali",
	  "Nusa Tenggara Barat",
	  "Kalimantan Barat",
	  "Kalimantan Tengah",
	  "Kalimantan Selatan",
	  "Kalimantan Timur",
	  "Kalimantan Utara",
	  "Sulawesi Selatan",
	  "Sulawesi Utara",
	  "Gorontalo",
	  "Sulawesi Tengah",
	  "Sulawesi Barat",
	  "Sulawesi Tenggara",
	  "Maluku",
	  "Maluku Utara",
	  "Papua Barat",
	  "Papua"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} no #{building_number}"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{Name.first_name}",
	  "#{street_prefix} #{Name.last_name}"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ds.",
	  "Dk.",
	  "Gg.",
	  "Jln.",
	  "Jr.",
	  "Kpg.",
	  "Ki.",
	  "Psr."
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(1212);
	company.suffix = __webpack_require__(1213);
	company.name = __webpack_require__(1211);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.last_name}",
	  "#{Name.last_name} #{suffix}",
	  "#{prefix} #{Name.last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "PT",
	  "CV",
	  "UD",
	  "PD",
	  "Perum"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(Persero) Tbk",
	  "Tbk"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(1215);
	date.weekday = __webpack_require__(1216);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  wide: [
	    "Januari",
	    "Februari",
	    "Maret",
	    "April",
	    "Mei",
	    "Juni",
	    "Juli",
	    "Agustus",
	    "September",
	    "Oktober",
	    "November",
	    "Desember"
	  ],
	  wide_context: [
	    "Januari",
	    "Februari",
	    "Maret",
	    "April",
	    "Mei",
	    "Juni",
	    "Juli",
	    "Agustus",
	    "September",
	    "Oktober",
	    "November",
	    "Desember"
	  ],
	  abbr: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "Mei",
	    "Jun",
	    "Jul",
	    "Ags",
	    "Sep",
	    "Okt",
	    "Nov",
	    "Des"
	  ],
	  abbr_context: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "Mei",
	    "Jun",
	    "Jul",
	    "Ags",
	    "Sep",
	    "Okt",
	    "Nov",
	    "Des"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  wide: [
	    "Minggu",
	    "Senin",
	    "Selasa",
	    "Rabu",
	    "Kamis",
	    "Jumat",
	    "Sabtu"
	  ],
	  wide_context: [
	    "Minggu",
	    "Senin",
	    "Selasa",
	    "Rabu",
	    "Kamis",
	    "Jumat",
	    "Sabtu"
	  ],
	  abbr: [
	    "Min",
	    "Sen",
	    "Sel",
	    "Rab",
	    "Kam",
	    "Jum",
	    "Sab"
	  ],
	  abbr_context: [
	    "Min",
	    "Sen",
	    "Sel",
	    "Rab",
	    "Kam",
	    "Jum",
	    "Sab"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var id = {};
	module['exports'] = id;
	id.title = "Indonesia";
	id.address = __webpack_require__(1204);
	id.company = __webpack_require__(1210);
	id.internet = __webpack_require__(1220);
	id.date = __webpack_require__(1214);
	id.name = __webpack_require__(1223);
	id.phone_number = __webpack_require__(1230);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "net",
	  "org",
	  "asia",
	  "tv",
	  "biz",
	  "info",
	  "in",
	  "name",
	  "co",
	  "ac.id",
	  "sch.id",
	  "go.id",
	  "mil.id",
	  "co.id",
	  "or.id",
	  "web.id",
	  "my.id",
	  "biz.id",
	  "desa.id"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  'gmail.com',
	  'yahoo.com',
	  'gmail.co.id',
	  'yahoo.co.id'
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1219);
	internet.domain_suffix = __webpack_require__(1218);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ade",
	  "Agnes",
	  "Ajeng",
	  "Amalia",
	  "Anita",
	  "Ayu",
	  "Aisyah",
	  "Ana",
	  "Ami",
	  "Ani",
	  "Azalea",
	  "Aurora",
	  "Alika",
	  "Anastasia",
	  "Amelia",
	  "Almira",
	  "Bella",
	  "Betania",
	  "Belinda",
	  "Citra",
	  "Cindy",
	  "Chelsea",
	  "Clara",
	  "Cornelia",
	  "Cinta",
	  "Cinthia",
	  "Ciaobella",
	  "Cici",
	  "Carla",
	  "Calista",
	  "Devi",
	  "Dewi","Dian",
	  "Diah",
	  "Diana",
	  "Dina",
	  "Dinda",
	  "Dalima",
	  "Eka",
	  "Eva",
	  "Endah",
	  "Elisa",
	  "Eli",
	  "Ella",
	  "Ellis",
	  "Elma",
	  "Elvina",
	  "Fitria",
	  "Fitriani",
	  "Febi",
	  "Faizah",
	  "Farah",
	  "Farhunnisa",
	  "Fathonah",
	  "Gabriella",
	  "Gasti",
	  "Gawati",
	  "Genta",
	  "Ghaliyati",
	  "Gina",
	  "Gilda",
	  "Halima",
	  "Hesti",
	  "Hilda",
	  "Hafshah",
	  "Hamima",
	  "Hana",
	  "Hani",
	  "Hasna",
	  "Humaira",
	  "Ika",
	  "Indah",
	  "Intan",
	  "Irma",
	  "Icha",
	  "Ida",
	  "Ifa",
	  "Ilsa",
	  "Ina",
	  "Ira",
	  "Iriana",
	  "Jamalia",
	  "Janet",
	  "Jane",
	  "Julia",
	  "Juli",
	  "Jessica",
	  "Jasmin",
	  "Jelita",
	  "Kamaria",
	  "Kamila",
	  "Kani",
	  "Karen",
	  "Karimah",
	  "Kartika",
	  "Kasiyah",
	  "Keisha",
	  "Kezia",
	  "Kiandra",
	  "Kayla",
	  "Kania",
	  "Lala",
	  "Lalita",
	  "Latika",
	  "Laila",
	  "Laras",
	  "Lidya",
	  "Lili",
	  "Lintang",
	  "Maria",
	  "Mala",
	  "Maya",
	  "Maida",
	  "Maimunah",
	  "Melinda",
	  "Mila",
	  "Mutia",
	  "Michelle",
	  "Malika",
	  "Nadia",
	  "Nadine",
	  "Nabila",
	  "Natalia",
	  "Novi",
	  "Nova",
	  "Nurul",
	  "Nilam",
	  "Najwa",
	  "Olivia",
	  "Ophelia",
	  "Oni",
	  "Oliva",
	  "Padma",
	  "Putri",
	  "Paramita",
	  "Paris",
	  "Patricia",
	  "Paulin",
	  "Puput",
	  "Puji",
	  "Pia",
	  "Puspa",
	  "Puti",
	  "Putri",
	  "Padmi",
	  "Qori",
	  "Queen",
	  "Ratih",
	  "Ratna",
	  "Restu",
	  "Rini",
	  "Rika",
	  "Rina",
	  "Rahayu",
	  "Rahmi",
	  "Rachel",
	  "Rahmi",
	  "Raisa",
	  "Raina",
	  "Sarah",
	  "Sari",
	  "Siti",
	  "Siska",
	  "Suci",
	  "Syahrini",
	  "Septi",
	  "Sadina",
	  "Safina",
	  "Sakura",
	  "Salimah",
	  "Salwa",
	  "Salsabila",
	  "Samiah",
	  "Shania",
	  "Sabrina",
	  "Silvia",
	  "Shakila",
	  "Talia",
	  "Tami",
	  "Tira",
	  "Tiara",
	  "Titin",
	  "Tania",
	  "Tina",
	  "Tantri",
	  "Tari",
	  "Titi",
	  "Uchita",
	  "Unjani",
	  "Ulya",
	  "Uli",
	  "Ulva",
	  "Umi",
	  "Usyi",
	  "Vanya",
	  "Vanesa",
	  "Vivi",
	  "Vera",
	  "Vicky",
	  "Victoria",
	  "Violet",
	  "Winda",
	  "Widya",
	  "Wulan",
	  "Wirda",
	  "Wani",
	  "Yani",
	  "Yessi",
	  "Yulia",
	  "Yuliana",
	  "Yuni",
	  "Yunita",
	  "Yance",
	  "Zahra",
	  "Zalindra",
	  "Zaenab",
	  "Zulfa",
	  "Zizi",
	  "Zulaikha",
	  "Zamira",
	  "Zelda",
	  "Zelaya"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Agustina",
	  "Andriani",
	  "Anggraini",
	  "Aryani",
	  "Astuti",
	  "Fujiati",
	  "Farida",
	  "Handayani",
	  "Hassanah",
	  "Hartati",
	  "Hasanah",
	  "Haryanti",
	  "Hariyah",
	  "Hastuti",
	  "Halimah",
	  "Kusmawati",
	  "Kuswandari",
	  "Laksmiwati",
	  "Laksita",
	  "Lestari",
	  "Lailasari",
	  "Mandasari",
	  "Mardhiyah",
	  "Mayasari",
	  "Melani",
	  "Mulyani",
	  "Maryati",
	  "Nurdiyanti",
	  "Novitasari",
	  "Nuraini",
	  "Nasyidah",
	  "Nasyiah",
	  "Namaga",
	  "Palastri",
	  "Pudjiastuti",
	  "Puspasari",
	  "Puspita",
	  "Purwanti",
	  "Pratiwi",
	  "Purnawati",
	  "Pertiwi",
	  "Permata",
	  "Prastuti",
	  "Padmasari",
	  "Rahmawati",
	  "Rahayu",
	  "Riyanti",
	  "Rahimah",
	  "Suartini",
	  "Sudiati",
	  "Suryatmi",
	  "Susanti",
	  "Safitri",
	  "Oktaviani",
	  "Utami",
	  "Usamah",
	  "Usada",
	  "Uyainah",
	  "Yuniar",
	  "Yuliarti",
	  "Yulianti",
	  "Yolanda",
	  "Wahyuni",
	  "Wijayanti",
	  "Widiastuti",
	  "Winarsih",
	  "Wulandari",
	  "Wastuti",
	  "Zulaika"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(1224);
	name.male_last_name = __webpack_require__(1225);
	name.female_first_name = __webpack_require__(1221);
	name.female_last_name = __webpack_require__(1222);
	name.prefix = __webpack_require__(1227);
	name.suffix = __webpack_require__(1228);
	name.name = __webpack_require__(1226);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abyasa",
	  "Ade",
	  "Adhiarja",
	  "Adiarja",
	  "Adika",
	  "Adikara",
	  "Adinata",
	  "Aditya",
	  "Agus",
	  "Ajiman",
	  "Ajimat",
	  "Ajimin",
	  "Ajiono",
	  "Akarsana",
	  "Alambana",
	  "Among",
	  "Anggabaya",
	  "Anom",
	  "Argono",
	  "Aris",
	  "Arta",
	  "Artanto",
	  "Artawan",
	  "Arsipatra",
	  "Asirwada",
	  "Asirwanda",
	  "Aslijan",
	  "Asmadi",
	  "Asman",
	  "Asmianto",
	  "Asmuni",
	  "Aswani",
	  "Atma",
	  "Atmaja",
	  "Bagas",
	  "Bagiya",
	  "Bagus",
	  "Bagya",
	  "Bahuraksa",
	  "Bahuwarna",
	  "Bahuwirya",
	  "Bajragin",
	  "Bakda",
	  "Bakiadi",
	  "Bakianto",
	  "Bakidin",
	  "Bakijan",
	  "Bakiman",
	  "Bakiono",
	  "Bakti",
	  "Baktiadi",
	  "Baktianto",
	  "Baktiono",
	  "Bala",
	  "Balamantri",
	  "Balangga",
	  "Balapati",
	  "Balidin",
	  "Balijan",
	  "Bambang",
	  "Banara",
	  "Banawa",
	  "Banawi",
	  "Bancar",
	  "Budi",
	  "Cagak",
	  "Cager",
	  "Cahyadi",
	  "Cahyanto",
	  "Cahya",
	  "Cahyo",
	  "Cahyono",
	  "Caket",
	  "Cakrabirawa",
	  "Cakrabuana",
	  "Cakrajiya",
	  "Cakrawala",
	  "Cakrawangsa",
	  "Candra",
	  "Chandra",
	  "Candrakanta",
	  "Capa",
	  "Caraka",
	  "Carub",
	  "Catur",
	  "Caturangga",
	  "Cawisadi",
	  "Cawisono",
	  "Cawuk",
	  "Cayadi",
	  "Cecep",
	  "Cemani",
	  "Cemeti",
	  "Cemplunk",
	  "Cengkal",
	  "Cengkir",
	  "Dacin",
	  "Dadap",
	  "Dadi",
	  "Dagel",
	  "Daliman",
	  "Dalimin",
	  "Daliono",
	  "Damar",
	  "Damu",
	  "Danang",
	  "Daniswara",
	  "Danu",
	  "Danuja",
	  "Dariati",
	  "Darijan",
	  "Darimin",
	  "Darmaji",
	  "Darman",
	  "Darmana",
	  "Darmanto",
	  "Darsirah",
	  "Dartono",
	  "Daru",
	  "Daruna",
	  "Daryani",
	  "Dasa",
	  "Digdaya",
	  "Dimas",
	  "Dimaz",
	  "Dipa",
	  "Dirja",
	  "Drajat",
	  "Dwi",
	  "Dono",
	  "Dodo",
	  "Edi",
	  "Eka",
	  "Elon",
	  "Eluh",
	  "Eman",
	  "Emas",
	  "Embuh",
	  "Emong",
	  "Empluk",
	  "Endra",
	  "Enteng",
	  "Estiawan",
	  "Estiono",
	  "Eko",
	  "Edi",
	  "Edison",
	  "Edward",
	  "Elvin",
	  "Erik",
	  "Emil",
	  "Ega",
	  "Emin",
	  "Eja",
	  "Gada",
	  "Gadang",
	  "Gaduh",
	  "Gaiman",
	  "Galak",
	  "Galang",
	  "Galar",
	  "Galih",
	  "Galiono",
	  "Galuh",
	  "Galur",
	  "Gaman",
	  "Gamani",
	  "Gamanto",
	  "Gambira",
	  "Gamblang",
	  "Ganda",
	  "Gandewa",
	  "Gandi",
	  "Gandi",
	  "Ganep",
	  "Gangsa",
	  "Gangsar",
	  "Ganjaran",
	  "Gantar",
	  "Gara",
	  "Garan",
	  "Garang",
	  "Garda",
	  "Gatot",
	  "Gatra",
	  "Gilang",
	  "Galih",
	  "Ghani",
	  "Gading",
	  "Hairyanto",
	  "Hardana",
	  "Hardi",
	  "Harimurti",
	  "Harja",
	  "Harjasa",
	  "Harjaya",
	  "Harjo",
	  "Harsana",
	  "Harsanto",
	  "Harsaya",
	  "Hartaka",
	  "Hartana",
	  "Harto",
	  "Hasta",
	  "Heru",
	  "Himawan",
	  "Hadi",
	  "Halim",
	  "Hasim",
	  "Hasan",
	  "Hendra",
	  "Hendri",
	  "Heryanto",
	  "Hamzah",
	  "Hari",
	  "Imam",
	  "Indra",
	  "Irwan",
	  "Irsad",
	  "Ikhsan",
	  "Irfan",
	  "Ian",
	  "Ibrahim",
	  "Ibrani",
	  "Ismail",
	  "Irnanto",
	  "Ilyas",
	  "Ibun",
	  "Ivan",
	  "Ikin",
	  "Ihsan",
	  "Jabal",
	  "Jaeman",
	  "Jaga",
	  "Jagapati",
	  "Jagaraga",
	  "Jail",
	  "Jaiman",
	  "Jaka",
	  "Jarwa",
	  "Jarwadi",
	  "Jarwi",
	  "Jasmani",
	  "Jaswadi",
	  "Jati",
	  "Jatmiko",
	  "Jaya",
	  "Jayadi",
	  "Jayeng",
	  "Jinawi",
	  "Jindra",
	  "Joko",
	  "Jumadi",
	  "Jumari",
	  "Jamal",
	  "Jamil",
	  "Jais",
	  "Jefri",
	  "Johan",
	  "Jono",
	  "Kacung",
	  "Kajen",
	  "Kambali",
	  "Kamidin",
	  "Kariman",
	  "Karja",
	  "Karma",
	  "Karman",
	  "Karna",
	  "Karsa",
	  "Karsana",
	  "Karta",
	  "Kasiran",
	  "Kasusra",
	  "Kawaca",
	  "Kawaya",
	  "Kayun",
	  "Kemba",
	  "Kenari",
	  "Kenes",
	  "Kuncara",
	  "Kunthara",
	  "Kusuma",
	  "Kadir",
	  "Kala",
	  "Kalim",
	  "Kurnia",
	  "Kanda",
	  "Kardi",
	  "Karya",
	  "Kasim",
	  "Kairav",
	  "Kenzie",
	  "Kemal",
	  "Kamal",
	  "Koko",
	  "Labuh",
	  "Laksana",
	  "Lamar",
	  "Lanang",
	  "Langgeng",
	  "Lanjar",
	  "Lantar",
	  "Lega",
	  "Legawa",
	  "Lembah",
	  "Liman",
	  "Limar",
	  "Luhung",
	  "Lukita",
	  "Luluh",
	  "Lulut",
	  "Lurhur",
	  "Luwar",
	  "Luwes",
	  "Latif",
	  "Lasmanto",
	  "Lukman",
	  "Luthfi",
	  "Leo",
	  "Luis",
	  "Lutfan",
	  "Lasmono",
	  "Laswi",
	  "Mahesa",
	  "Makara",
	  "Makuta",
	  "Manah",
	  "Maras",
	  "Margana",
	  "Mariadi",
	  "Marsudi",
	  "Martaka",
	  "Martana",
	  "Martani",
	  "Marwata",
	  "Maryadi",
	  "Maryanto",
	  "Mitra",
	  "Mujur",
	  "Mulya",
	  "Mulyanto",
	  "Mulyono",
	  "Mumpuni",
	  "Muni",
	  "Mursita",
	  "Murti",
	  "Mustika",
	  "Maman",
	  "Mahmud",
	  "Mahdi",
	  "Mahfud",
	  "Malik",
	  "Muhammad",
	  "Mustofa",
	  "Marsito",
	  "Mursinin",
	  "Nalar",
	  "Naradi",
	  "Nardi",
	  "Niyaga",
	  "Nrima",
	  "Nugraha",
	  "Nyana",
	  "Narji",
	  "Nasab",
	  "Nasrullah",
	  "Nasim",
	  "Najib",
	  "Najam",
	  "Nyoman",
	  "Olga",
	  "Ozy",
	  "Omar",
	  "Opan",
	  "Oskar",
	  "Oman",
	  "Okto",
	  "Okta",
	  "Opung",
	  "Paiman",
	  "Panca",
	  "Pangeran",
	  "Pangestu",
	  "Pardi",
	  "Parman",
	  "Perkasa",
	  "Praba",
	  "Prabu",
	  "Prabawa",
	  "Prabowo",
	  "Prakosa",
	  "Pranata",
	  "Pranawa",
	  "Prasetya",
	  "Prasetyo",
	  "Prayitna",
	  "Prayoga",
	  "Prayogo",
	  "Purwadi",
	  "Purwa",
	  "Purwanto",
	  "Panji",
	  "Pandu",
	  "Paiman",
	  "Prima",
	  "Putu",
	  "Raden",
	  "Raditya",
	  "Raharja",
	  "Rama",
	  "Rangga",
	  "Reksa",
	  "Respati",
	  "Rusman",
	  "Rosman",
	  "Rahmat",
	  "Rahman",
	  "Rendy",
	  "Reza",
	  "Rizki",
	  "Ridwan",
	  "Rudi",
	  "Raden",
	  "Radit",
	  "Radika",
	  "Rafi",
	  "Rafid",
	  "Raihan",
	  "Salman",
	  "Saadat",
	  "Saiful",
	  "Surya",
	  "Slamet",
	  "Samsul",
	  "Soleh",
	  "Simon",
	  "Sabar",
	  "Sabri",
	  "Sidiq",
	  "Satya",
	  "Setya",
	  "Saka",
	  "Sakti",
	  "Taswir",
	  "Tedi",
	  "Teddy",
	  "Taufan",
	  "Taufik",
	  "Tomi",
	  "Tasnim",
	  "Teguh",
	  "Tasdik",
	  "Timbul",
	  "Tirta",
	  "Tirtayasa",
	  "Tri",
	  "Tugiman",
	  "Umar",
	  "Usman",
	  "Uda",
	  "Umay",
	  "Unggul",
	  "Utama",
	  "Umaya",
	  "Upik",
	  "Viktor",
	  "Vino",
	  "Vinsen",
	  "Vero",
	  "Vega",
	  "Viman",
	  "Virman",
	  "Wahyu",
	  "Wira",
	  "Wisnu",
	  "Wadi",
	  "Wardi",
	  "Warji",
	  "Waluyo",
	  "Wakiman",
	  "Wage",
	  "Wardaya",
	  "Warsa",
	  "Warsita",
	  "Warta",
	  "Wasis",
	  "Wawan",
	  "Xanana",
	  "Yahya",
	  "Yusuf",
	  "Yosef",
	  "Yono",
	  "Yoga"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adriansyah",
	  "Ardianto",
	  "Anggriawan",
	  "Budiman",
	  "Budiyanto",
	  "Damanik",
	  "Dongoran",
	  "Dabukke",
	  "Firmansyah",
	  "Firgantoro",
	  "Gunarto",
	  "Gunawan",
	  "Hardiansyah",
	  "Habibi",
	  "Hakim",
	  "Halim",
	  "Haryanto",
	  "Hidayat",
	  "Hidayanto",
	  "Hutagalung",
	  "Hutapea",
	  "Hutasoit",
	  "Irawan",
	  "Iswahyudi",
	  "Kuswoyo",
	  "Januar",
	  "Jailani",
	  "Kurniawan",
	  "Kusumo",
	  "Latupono",
	  "Lazuardi",
	  "Maheswara",
	  "Mahendra",
	  "Mustofa",
	  "Mansur",
	  "Mandala",
	  "Megantara",
	  "Maulana",
	  "Maryadi",
	  "Mangunsong",
	  "Manullang",
	  "Marpaung",
	  "Marbun",
	  "Narpati",
	  "Natsir",
	  "Nugroho",
	  "Najmudin",
	  "Nashiruddin",
	  "Nainggolan",
	  "Nababan",
	  "Napitupulu",
	  "Pangestu",
	  "Putra",
	  "Pranowo",
	  "Prabowo",
	  "Pratama",
	  "Prasetya",
	  "Prasetyo",
	  "Pradana",
	  "Pradipta",
	  "Prakasa",
	  "Permadi",
	  "Prasasta",
	  "Prayoga",
	  "Ramadan",
	  "Rajasa",
	  "Rajata",
	  "Saptono",
	  "Santoso",
	  "Saputra",
	  "Saefullah",
	  "Setiawan",
	  "Suryono",
	  "Suwarno",
	  "Siregar",
	  "Sihombing",
	  "Salahudin",
	  "Sihombing",
	  "Samosir",
	  "Saragih",
	  "Sihotang",
	  "Simanjuntak",
	  "Sinaga",
	  "Simbolon",
	  "Sitompul",
	  "Sitorus",
	  "Sirait",
	  "Siregar",
	  "Situmorang",
	  "Tampubolon",
	  "Thamrin",
	  "Tamba",
	  "Tarihoran",
	  "Utama",
	  "Uwais",
	  "Wahyudin",
	  "Waluyo",
	  "Wibowo",
	  "Winarno",
	  "Wibisono",
	  "Wijaya",
	  "Widodo",
	  "Wacana",
	  "Waskita",
	  "Wasita",
	  "Zulkarnain"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{male_first_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name}",
	  "#{male_first_name} #{male_first_name} #{male_last_name}",
	  "#{female_first_name} #{female_last_name}",
	  "#{female_first_name} #{male_last_name}",
	  "#{female_last_name} #{female_first_name}",
	  "#{female_first_name} #{female_first_name} #{female_last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.Ked",
	  "S.Gz",
	  "S.Pt",
	  "S.IP",
	  "S.E.I",
	  "S.E.",
	  "S.Kom",
	  "S.H.",
	  "S.T.",
	  "S.Pd",
	  "S.Psi",
	  "S.I.Kom",
	  "S.Sos",
	  "S.Farm",
	  "M.M.",
	  "M.Kom.",
	  "M.TI.",
	  "M.Pd",
	  "M.Farm",
	  "M.Ak"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "02# #### ###",
	  "02## #### ###",
	  "03## #### ###",
	  "04## #### ###",
	  "05## #### ###",
	  "06## #### ###",
	  "07## #### ###",
	  "09## #### ###",
	  "02# #### ####",
	  "02## #### ####",
	  "03## #### ####",
	  "04## #### ####",
	  "05## #### ####",
	  "06## #### ####",
	  "07## #### ####",
	  "09## #### ####",
	  "08## ### ###",
	  "08## #### ###",
	  "08## #### ####",
	  "(+62) 8## ### ###",
	  "(+62) 2# #### ###",
	  "(+62) 2## #### ###",
	  "(+62) 3## #### ###",
	  "(+62) 4## #### ###",
	  "(+62) 5## #### ###",
	  "(+62) 6## #### ###",
	  "(+62) 7## #### ###",
	  "(+62) 8## #### ###",
	  "(+62) 9## #### ###",
	  "(+62) 2# #### ####",
	  "(+62) 2## #### ####",
	  "(+62) 3## #### ####",
	  "(+62) 4## #### ####",
	  "(+62) 5## #### ####",
	  "(+62) 6## #### ####",
	  "(+62) 7## #### ####",
	  "(+62) 8## #### ####",
	  "(+62) 9## #### ####"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1229);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name} #{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name} #{city_suffix}",
	  "#{Name.last_name} #{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "San",
	  "Borgo",
	  "Sesto",
	  "Quarto",
	  "Settimo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "a mare",
	  "lido",
	  "ligure",
	  "del friuli",
	  "salentino",
	  "calabro",
	  "veneto",
	  "nell'emilia",
	  "umbro",
	  "laziale",
	  "terme",
	  "sardo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afghanistan",
	  "Albania",
	  "Algeria",
	  "American Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antartide (territori a sud del 60° parallelo)",
	  "Antigua e Barbuda",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbaijan",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesh",
	  "Barbados",
	  "Bielorussia",
	  "Belgio",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolivia",
	  "Bosnia e Herzegovina",
	  "Botswana",
	  "Bouvet Island (Bouvetoya)",
	  "Brasile",
	  "Territorio dell'arcipelago indiano",
	  "Isole Vergini Britanniche",
	  "Brunei Darussalam",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Cambogia",
	  "Cameroon",
	  "Canada",
	  "Capo Verde",
	  "Isole Cayman",
	  "Repubblica Centrale Africana",
	  "Chad",
	  "Cile",
	  "Cina",
	  "Isola di Pasqua",
	  "Isola di Cocos (Keeling)",
	  "Colombia",
	  "Comoros",
	  "Congo",
	  "Isole Cook",
	  "Costa Rica",
	  "Costa d'Avorio",
	  "Croazia",
	  "Cuba",
	  "Cipro",
	  "Repubblica Ceca",
	  "Danimarca",
	  "Gibuti",
	  "Repubblica Dominicana",
	  "Equador",
	  "Egitto",
	  "El Salvador",
	  "Guinea Equatoriale",
	  "Eritrea",
	  "Estonia",
	  "Etiopia",
	  "Isole Faroe",
	  "Isole Falkland (Malvinas)",
	  "Fiji",
	  "Finlandia",
	  "Francia",
	  "Guyana Francese",
	  "Polinesia Francese",
	  "Territori Francesi del sud",
	  "Gabon",
	  "Gambia",
	  "Georgia",
	  "Germania",
	  "Ghana",
	  "Gibilterra",
	  "Grecia",
	  "Groenlandia",
	  "Grenada",
	  "Guadalupa",
	  "Guam",
	  "Guatemala",
	  "Guernsey",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard Island and McDonald Islands",
	  "Città del Vaticano",
	  "Honduras",
	  "Hong Kong",
	  "Ungheria",
	  "Islanda",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Iraq",
	  "Irlanda",
	  "Isola di Man",
	  "Israele",
	  "Italia",
	  "Giamaica",
	  "Giappone",
	  "Jersey",
	  "Giordania",
	  "Kazakhstan",
	  "Kenya",
	  "Kiribati",
	  "Korea",
	  "Kuwait",
	  "Republicca Kirgiza",
	  "Repubblica del Laos",
	  "Latvia",
	  "Libano",
	  "Lesotho",
	  "Liberia",
	  "Libyan Arab Jamahiriya",
	  "Liechtenstein",
	  "Lituania",
	  "Lussemburgo",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malesia",
	  "Maldive",
	  "Mali",
	  "Malta",
	  "Isole Marshall",
	  "Martinica",
	  "Mauritania",
	  "Mauritius",
	  "Mayotte",
	  "Messico",
	  "Micronesia",
	  "Moldova",
	  "Principato di Monaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Marocco",
	  "Mozambico",
	  "Myanmar",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Antille Olandesi",
	  "Olanda",
	  "Nuova Caledonia",
	  "Nuova Zelanda",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Isole Norfolk",
	  "Northern Mariana Islands",
	  "Norvegia",
	  "Oman",
	  "Pakistan",
	  "Palau",
	  "Palestina",
	  "Panama",
	  "Papua Nuova Guinea",
	  "Paraguay",
	  "Peru",
	  "Filippine",
	  "Pitcairn Islands",
	  "Polonia",
	  "Portogallo",
	  "Porto Rico",
	  "Qatar",
	  "Reunion",
	  "Romania",
	  "Russia",
	  "Rwanda",
	  "San Bartolomeo",
	  "Sant'Elena",
	  "Saint Kitts and Nevis",
	  "Saint Lucia",
	  "Saint Martin",
	  "Saint Pierre and Miquelon",
	  "Saint Vincent and the Grenadines",
	  "Samoa",
	  "San Marino",
	  "Sao Tome and Principe",
	  "Arabia Saudita",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leone",
	  "Singapore",
	  "Slovenia",
	  "Isole Solomon",
	  "Somalia",
	  "Sud Africa",
	  "Georgia del sud e South Sandwich Islands",
	  "Spagna",
	  "Sri Lanka",
	  "Sudan",
	  "Suriname",
	  "Svalbard & Jan Mayen Islands",
	  "Swaziland",
	  "Svezia",
	  "Svizzera",
	  "Siria",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Tailandia",
	  "Timor-Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad e Tobago",
	  "Tunisia",
	  "Turchia",
	  "Turkmenistan",
	  "Isole di Turks and Caicos",
	  "Tuvalu",
	  "Uganda",
	  "Ucraina",
	  "Emirati Arabi Uniti",
	  "Regno Unito",
	  "Stati Uniti d'America",
	  "United States Minor Outlying Islands",
	  "Isole Vergini Statunitensi",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Wallis and Futuna",
	  "Western Sahara",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Italia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1233);
	address.city_suffix = __webpack_require__(1234);
	address.country = __webpack_require__(1235);
	address.building_number = __webpack_require__(1231);
	address.street_suffix = __webpack_require__(1244);
	address.secondary_address = __webpack_require__(1239);
	address.postcode = __webpack_require__(1238);
	address.state = __webpack_require__(1240);
	address.state_abbr = __webpack_require__(1241);
	address.city = __webpack_require__(1232);
	address.street_name = __webpack_require__(1243);
	address.street_address = __webpack_require__(1242);
	address.default_country = __webpack_require__(1236);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Appartamento ##",
	  "Piano #"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Agrigento",
	  "Alessandria",
	  "Ancona",
	  "Aosta",
	  "Arezzo",
	  "Ascoli Piceno",
	  "Asti",
	  "Avellino",
	  "Bari",
	  "Barletta-Andria-Trani",
	  "Belluno",
	  "Benevento",
	  "Bergamo",
	  "Biella",
	  "Bologna",
	  "Bolzano",
	  "Brescia",
	  "Brindisi",
	  "Cagliari",
	  "Caltanissetta",
	  "Campobasso",
	  "Carbonia-Iglesias",
	  "Caserta",
	  "Catania",
	  "Catanzaro",
	  "Chieti",
	  "Como",
	  "Cosenza",
	  "Cremona",
	  "Crotone",
	  "Cuneo",
	  "Enna",
	  "Fermo",
	  "Ferrara",
	  "Firenze",
	  "Foggia",
	  "Forlì-Cesena",
	  "Frosinone",
	  "Genova",
	  "Gorizia",
	  "Grosseto",
	  "Imperia",
	  "Isernia",
	  "La Spezia",
	  "L'Aquila",
	  "Latina",
	  "Lecce",
	  "Lecco",
	  "Livorno",
	  "Lodi",
	  "Lucca",
	  "Macerata",
	  "Mantova",
	  "Massa-Carrara",
	  "Matera",
	  "Messina",
	  "Milano",
	  "Modena",
	  "Monza e della Brianza",
	  "Napoli",
	  "Novara",
	  "Nuoro",
	  "Olbia-Tempio",
	  "Oristano",
	  "Padova",
	  "Palermo",
	  "Parma",
	  "Pavia",
	  "Perugia",
	  "Pesaro e Urbino",
	  "Pescara",
	  "Piacenza",
	  "Pisa",
	  "Pistoia",
	  "Pordenone",
	  "Potenza",
	  "Prato",
	  "Ragusa",
	  "Ravenna",
	  "Reggio Calabria",
	  "Reggio Emilia",
	  "Rieti",
	  "Rimini",
	  "Roma",
	  "Rovigo",
	  "Salerno",
	  "Medio Campidano",
	  "Sassari",
	  "Savona",
	  "Siena",
	  "Siracusa",
	  "Sondrio",
	  "Taranto",
	  "Teramo",
	  "Terni",
	  "Torino",
	  "Ogliastra",
	  "Trapani",
	  "Trento",
	  "Treviso",
	  "Trieste",
	  "Udine",
	  "Varese",
	  "Venezia",
	  "Verbano-Cusio-Ossola",
	  "Vercelli",
	  "Verona",
	  "Vibo Valentia",
	  "Vicenza",
	  "Viterbo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AG",
	  "AL",
	  "AN",
	  "AO",
	  "AR",
	  "AP",
	  "AT",
	  "AV",
	  "BA",
	  "BT",
	  "BL",
	  "BN",
	  "BG",
	  "BI",
	  "BO",
	  "BZ",
	  "BS",
	  "BR",
	  "CA",
	  "CL",
	  "CB",
	  "CI",
	  "CE",
	  "CT",
	  "CZ",
	  "CH",
	  "CO",
	  "CS",
	  "CR",
	  "KR",
	  "CN",
	  "EN",
	  "FM",
	  "FE",
	  "FI",
	  "FG",
	  "FC",
	  "FR",
	  "GE",
	  "GO",
	  "GR",
	  "IM",
	  "IS",
	  "SP",
	  "AQ",
	  "LT",
	  "LE",
	  "LC",
	  "LI",
	  "LO",
	  "LU",
	  "MC",
	  "MN",
	  "MS",
	  "MT",
	  "ME",
	  "MI",
	  "MO",
	  "MB",
	  "NA",
	  "NO",
	  "NU",
	  "OT",
	  "OR",
	  "PD",
	  "PA",
	  "PR",
	  "PV",
	  "PG",
	  "PU",
	  "PE",
	  "PC",
	  "PI",
	  "PT",
	  "PN",
	  "PZ",
	  "PO",
	  "RG",
	  "RA",
	  "RC",
	  "RE",
	  "RI",
	  "RN",
	  "RM",
	  "RO",
	  "SA",
	  "VS",
	  "SS",
	  "SV",
	  "SI",
	  "SR",
	  "SO",
	  "TA",
	  "TE",
	  "TR",
	  "TO",
	  "OG",
	  "TP",
	  "TN",
	  "TV",
	  "TS",
	  "UD",
	  "VA",
	  "VE",
	  "VB",
	  "VC",
	  "VR",
	  "VV",
	  "VI",
	  "VT"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}",
	  "#{street_name} #{building_number}, #{secondary_address}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Name.first_name}",
	  "#{street_suffix} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Piazza",
	  "Strada",
	  "Via",
	  "Borgo",
	  "Contrada",
	  "Rotonda",
	  "Incrocio"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 ore",
	  "24/7",
	  "terza generazione",
	  "quarta generazione",
	  "quinta generazione",
	  "sesta generazione",
	  "asimmetrica",
	  "asincrona",
	  "background",
	  "bi-direzionale",
	  "biforcata",
	  "bottom-line",
	  "coerente",
	  "coesiva",
	  "composita",
	  "sensibile al contesto",
	  "basta sul contesto",
	  "basata sul contenuto",
	  "dedicata",
	  "didattica",
	  "direzionale",
	  "discreta",
	  "dinamica",
	  "eco-centrica",
	  "esecutiva",
	  "esplicita",
	  "full-range",
	  "globale",
	  "euristica",
	  "alto livello",
	  "olistica",
	  "omogenea",
	  "ibrida",
	  "impattante",
	  "incrementale",
	  "intangibile",
	  "interattiva",
	  "intermediaria",
	  "locale",
	  "logistica",
	  "massimizzata",
	  "metodica",
	  "mission-critical",
	  "mobile",
	  "modulare",
	  "motivazionale",
	  "multimedia",
	  "multi-tasking",
	  "nazionale",
	  "neutrale",
	  "nextgeneration",
	  "non-volatile",
	  "object-oriented",
	  "ottima",
	  "ottimizzante",
	  "radicale",
	  "real-time",
	  "reciproca",
	  "regionale",
	  "responsiva",
	  "scalabile",
	  "secondaria",
	  "stabile",
	  "statica",
	  "sistematica",
	  "sistemica",
	  "tangibile",
	  "terziaria",
	  "uniforme",
	  "valore aggiunto"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "valore aggiunto",
	  "verticalizzate",
	  "proattive",
	  "forti",
	  "rivoluzionari",
	  "scalabili",
	  "innovativi",
	  "intuitivi",
	  "strategici",
	  "e-business",
	  "mission-critical",
	  "24/7",
	  "globali",
	  "B2B",
	  "B2C",
	  "granulari",
	  "virtuali",
	  "virali",
	  "dinamiche",
	  "magnetiche",
	  "web",
	  "interattive",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficienti",
	  "front-end",
	  "distributivi",
	  "estensibili",
	  "mondiali",
	  "open-source",
	  "cross-platform",
	  "sinergiche",
	  "out-of-the-box",
	  "enterprise",
	  "integrate",
	  "di impatto",
	  "wireless",
	  "trasparenti",
	  "next-generation",
	  "cutting-edge",
	  "visionari",
	  "plug-and-play",
	  "collaborative",
	  "olistiche",
	  "ricche"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "partnerships",
	  "comunità",
	  "ROI",
	  "soluzioni",
	  "e-services",
	  "nicchie",
	  "tecnologie",
	  "contenuti",
	  "supply-chains",
	  "convergenze",
	  "relazioni",
	  "architetture",
	  "interfacce",
	  "mercati",
	  "e-commerce",
	  "sistemi",
	  "modelli",
	  "schemi",
	  "reti",
	  "applicazioni",
	  "metriche",
	  "e-business",
	  "funzionalità",
	  "esperienze",
	  "webservices",
	  "metodologie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implementate",
	  "utilizzo",
	  "integrate",
	  "ottimali",
	  "evolutive",
	  "abilitate",
	  "reinventate",
	  "aggregate",
	  "migliorate",
	  "incentivate",
	  "monetizzate",
	  "sinergizzate",
	  "strategiche",
	  "deploy",
	  "marchi",
	  "accrescitive",
	  "target",
	  "sintetizzate",
	  "spedizioni",
	  "massimizzate",
	  "innovazione",
	  "guida",
	  "estensioni",
	  "generate",
	  "exploit",
	  "transizionali",
	  "matrici",
	  "ricontestualizzate"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "adattiva",
	  "avanzata",
	  "migliorata",
	  "assimilata",
	  "automatizzata",
	  "bilanciata",
	  "centralizzata",
	  "compatibile",
	  "configurabile",
	  "cross-platform",
	  "decentralizzata",
	  "digitalizzata",
	  "distribuita",
	  "piccola",
	  "ergonomica",
	  "esclusiva",
	  "espansa",
	  "estesa",
	  "configurabile",
	  "fondamentale",
	  "orizzontale",
	  "implementata",
	  "innovativa",
	  "integrata",
	  "intuitiva",
	  "inversa",
	  "gestita",
	  "obbligatoria",
	  "monitorata",
	  "multi-canale",
	  "multi-laterale",
	  "open-source",
	  "operativa",
	  "ottimizzata",
	  "organica",
	  "persistente",
	  "polarizzata",
	  "proattiva",
	  "programmabile",
	  "progressiva",
	  "reattiva",
	  "riallineata",
	  "ricontestualizzata",
	  "ridotta",
	  "robusta",
	  "sicura",
	  "condivisibile",
	  "stand-alone",
	  "switchabile",
	  "sincronizzata",
	  "sinergica",
	  "totale",
	  "universale",
	  "user-friendly",
	  "versatile",
	  "virtuale",
	  "visionaria"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1253);
	company.noun = __webpack_require__(1252);
	company.descriptor = __webpack_require__(1249);
	company.adjective = __webpack_require__(1245);
	company.bs_noun = __webpack_require__(1247);
	company.bs_verb = __webpack_require__(1248);
	company.bs_adjective = __webpack_require__(1246);
	company.name = __webpack_require__(1251);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name} #{suffix}",
	  "#{Name.last_name}, #{Name.last_name} e #{Name.last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abilità",
	  "Access",
	  "Adattatore",
	  "Algoritmo",
	  "Alleanza",
	  "Analizzatore",
	  "Applicazione",
	  "Approccio",
	  "Architettura",
	  "Archivio",
	  "Intelligenza artificiale",
	  "Array",
	  "Attitudine",
	  "Benchmark",
	  "Capacità",
	  "Sfida",
	  "Circuito",
	  "Collaborazione",
	  "Complessità",
	  "Concetto",
	  "Conglomerato",
	  "Contingenza",
	  "Core",
	  "Database",
	  "Data-warehouse",
	  "Definizione",
	  "Emulazione",
	  "Codifica",
	  "Criptazione",
	  "Firmware",
	  "Flessibilità",
	  "Previsione",
	  "Frame",
	  "framework",
	  "Funzione",
	  "Funzionalità",
	  "Interfaccia grafica",
	  "Hardware",
	  "Help-desk",
	  "Gerarchia",
	  "Hub",
	  "Implementazione",
	  "Infrastruttura",
	  "Iniziativa",
	  "Installazione",
	  "Set di istruzioni",
	  "Interfaccia",
	  "Soluzione internet",
	  "Intranet",
	  "Conoscenza base",
	  "Matrici",
	  "Matrice",
	  "Metodologia",
	  "Middleware",
	  "Migrazione",
	  "Modello",
	  "Moderazione",
	  "Monitoraggio",
	  "Moratoria",
	  "Rete",
	  "Architettura aperta",
	  "Sistema aperto",
	  "Orchestrazione",
	  "Paradigma",
	  "Parallelismo",
	  "Policy",
	  "Portale",
	  "Struttura di prezzo",
	  "Prodotto",
	  "Produttività",
	  "Progetto",
	  "Proiezione",
	  "Protocollo",
	  "Servizio clienti",
	  "Software",
	  "Soluzione",
	  "Standardizzazione",
	  "Strategia",
	  "Struttura",
	  "Successo",
	  "Sovrastruttura",
	  "Supporto",
	  "Sinergia",
	  "Task-force",
	  "Finestra temporale",
	  "Strumenti",
	  "Utilizzazione",
	  "Sito web",
	  "Forza lavoro"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "SPA",
	  "e figli",
	  "Group",
	  "s.r.l."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var it = {};
	module['exports'] = it;
	it.title = "Italian";
	it.address = __webpack_require__(1237);
	it.company = __webpack_require__(1250);
	it.internet = __webpack_require__(1257);
	it.name = __webpack_require__(1259);
	it.phone_number = __webpack_require__(1265);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "com",
	  "com",
	  "net",
	  "org",
	  "it",
	  "it",
	  "it"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com",
	  "email.it",
	  "libero.it",
	  "yahoo.it"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1256);
	internet.domain_suffix = __webpack_require__(1255);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Akira",
	  "Alberto",
	  "Alessandro",
	  "Alighieri",
	  "Amedeo",
	  "Amos",
	  "Anselmo",
	  "Antonino",
	  "Arcibaldo",
	  "Armando",
	  "Artes",
	  "Audenico",
	  "Ausonio",
	  "Bacchisio",
	  "Battista",
	  "Bernardo",
	  "Boris",
	  "Caio",
	  "Carlo",
	  "Cecco",
	  "Cirino",
	  "Cleros",
	  "Costantino",
	  "Damiano",
	  "Danny",
	  "Davide",
	  "Demian",
	  "Dimitri",
	  "Domingo",
	  "Dylan",
	  "Edilio",
	  "Egidio",
	  "Elio",
	  "Emanuel",
	  "Enrico",
	  "Ercole",
	  "Ermes",
	  "Ethan",
	  "Eusebio",
	  "Evangelista",
	  "Fabiano",
	  "Ferdinando",
	  "Fiorentino",
	  "Flavio",
	  "Fulvio",
	  "Gabriele",
	  "Gastone",
	  "Germano",
	  "Giacinto",
	  "Gianantonio",
	  "Gianleonardo",
	  "Gianmarco",
	  "Gianriccardo",
	  "Gioacchino",
	  "Giordano",
	  "Giuliano",
	  "Graziano",
	  "Guido",
	  "Harry",
	  "Iacopo",
	  "Ilario",
	  "Ione",
	  "Italo",
	  "Jack",
	  "Jari",
	  "Joey",
	  "Joseph",
	  "Kai",
	  "Kociss",
	  "Laerte",
	  "Lauro",
	  "Leonardo",
	  "Liborio",
	  "Lorenzo",
	  "Ludovico",
	  "Maggiore",
	  "Manuele",
	  "Mariano",
	  "Marvin",
	  "Matteo",
	  "Mauro",
	  "Michael",
	  "Mirco",
	  "Modesto",
	  "Muzio",
	  "Nabil",
	  "Nathan",
	  "Nick",
	  "Noah",
	  "Odino",
	  "Olo",
	  "Oreste",
	  "Osea",
	  "Pablo",
	  "Patrizio",
	  "Piererminio",
	  "Pierfrancesco",
	  "Piersilvio",
	  "Priamo",
	  "Quarto",
	  "Quirino",
	  "Radames",
	  "Raniero",
	  "Renato",
	  "Rocco",
	  "Romeo",
	  "Rosalino",
	  "Rudy",
	  "Sabatino",
	  "Samuel",
	  "Santo",
	  "Sebastian",
	  "Serse",
	  "Silvano",
	  "Sirio",
	  "Tancredi",
	  "Terzo",
	  "Timoteo",
	  "Tolomeo",
	  "Trevis",
	  "Ubaldo",
	  "Ulrico",
	  "Valdo",
	  "Neri",
	  "Vinicio",
	  "Walter",
	  "Xavier",
	  "Yago",
	  "Zaccaria",
	  "Abramo",
	  "Adriano",
	  "Alan",
	  "Albino",
	  "Alessio",
	  "Alighiero",
	  "Amerigo",
	  "Anastasio",
	  "Antimo",
	  "Antonio",
	  "Arduino",
	  "Aroldo",
	  "Arturo",
	  "Augusto",
	  "Avide",
	  "Baldassarre",
	  "Bettino",
	  "Bortolo",
	  "Caligola",
	  "Carmelo",
	  "Celeste",
	  "Ciro",
	  "Costanzo",
	  "Dante",
	  "Danthon",
	  "Davis",
	  "Demis",
	  "Dindo",
	  "Domiziano",
	  "Edipo",
	  "Egisto",
	  "Eliziario",
	  "Emidio",
	  "Enzo",
	  "Eriberto",
	  "Erminio",
	  "Ettore",
	  "Eustachio",
	  "Fabio",
	  "Fernando",
	  "Fiorenzo",
	  "Folco",
	  "Furio",
	  "Gaetano",
	  "Gavino",
	  "Gerlando",
	  "Giacobbe",
	  "Giancarlo",
	  "Gianmaria",
	  "Giobbe",
	  "Giorgio",
	  "Giulio",
	  "Gregorio",
	  "Hector",
	  "Ian",
	  "Ippolito",
	  "Ivano",
	  "Jacopo",
	  "Jarno",
	  "Joannes",
	  "Joshua",
	  "Karim",
	  "Kris",
	  "Lamberto",
	  "Lazzaro",
	  "Leone",
	  "Lino",
	  "Loris",
	  "Luigi",
	  "Manfredi",
	  "Marco",
	  "Marino",
	  "Marzio",
	  "Mattia",
	  "Max",
	  "Michele",
	  "Mirko",
	  "Moreno",
	  "Nadir",
	  "Nazzareno",
	  "Nestore",
	  "Nico",
	  "Noel",
	  "Odone",
	  "Omar",
	  "Orfeo",
	  "Osvaldo",
	  "Pacifico",
	  "Pericle",
	  "Pietro",
	  "Primo",
	  "Quasimodo",
	  "Radio",
	  "Raoul",
	  "Renzo",
	  "Rodolfo",
	  "Romolo",
	  "Rosolino",
	  "Rufo",
	  "Sabino",
	  "Sandro",
	  "Sasha",
	  "Secondo",
	  "Sesto",
	  "Silverio",
	  "Siro",
	  "Tazio",
	  "Teseo",
	  "Timothy",
	  "Tommaso",
	  "Tristano",
	  "Umberto",
	  "Ariel",
	  "Artemide",
	  "Assia",
	  "Azue",
	  "Benedetta",
	  "Bibiana",
	  "Brigitta",
	  "Carmela",
	  "Cassiopea",
	  "Cesidia",
	  "Cira",
	  "Clea",
	  "Cleopatra",
	  "Clodovea",
	  "Concetta",
	  "Cosetta",
	  "Cristyn",
	  "Damiana",
	  "Danuta",
	  "Deborah",
	  "Demi",
	  "Diamante",
	  "Diana",
	  "Donatella",
	  "Doriana",
	  "Edvige",
	  "Elda",
	  "Elga",
	  "Elsa",
	  "Emilia",
	  "Enrica",
	  "Erminia",
	  "Eufemia",
	  "Evita",
	  "Fatima",
	  "Felicia",
	  "Filomena",
	  "Flaviana",
	  "Fortunata",
	  "Gelsomina",
	  "Genziana",
	  "Giacinta",
	  "Gilda",
	  "Giovanna",
	  "Giulietta",
	  "Grazia",
	  "Guendalina",
	  "Helga",
	  "Ileana",
	  "Ingrid",
	  "Irene",
	  "Isabel",
	  "Isira",
	  "Ivonne",
	  "Jelena",
	  "Jole",
	  "Claudia",
	  "Kayla",
	  "Kristel",
	  "Laura",
	  "Lucia",
	  "Lia",
	  "Lidia",
	  "Lisa",
	  "Loredana",
	  "Loretta",
	  "Luce",
	  "Lucrezia",
	  "Luna",
	  "Maika",
	  "Marcella",
	  "Maria",
	  "Mariagiulia",
	  "Marianita",
	  "Mariapia",
	  "Marieva",
	  "Marina",
	  "Maristella",
	  "Maruska",
	  "Matilde",
	  "Mecren",
	  "Mercedes",
	  "Mietta",
	  "Miriana",
	  "Miriam",
	  "Monia",
	  "Morgana",
	  "Naomi",
	  "Nayade",
	  "Nicoletta",
	  "Ninfa",
	  "Noemi",
	  "Nunzia",
	  "Olimpia",
	  "Oretta",
	  "Ortensia",
	  "Penelope",
	  "Piccarda",
	  "Prisca",
	  "Rebecca",
	  "Rita",
	  "Rosalba",
	  "Rosaria",
	  "Rosita",
	  "Ruth",
	  "Samira",
	  "Sarita",
	  "Selvaggia",
	  "Shaira",
	  "Sibilla",
	  "Soriana",
	  "Thea",
	  "Tosca",
	  "Ursula",
	  "Vania",
	  "Vera",
	  "Vienna",
	  "Violante",
	  "Vitalba",
	  "Zelida"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1258);
	name.last_name = __webpack_require__(1260);
	name.prefix = __webpack_require__(1262);
	name.suffix = __webpack_require__(1263);
	name.name = __webpack_require__(1261);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Amato",
	  "Barbieri",
	  "Barone",
	  "Basile",
	  "Battaglia",
	  "Bellini",
	  "Benedetti",
	  "Bernardi",
	  "Bianc",
	  "Bianchi",
	  "Bruno",
	  "Caputo",
	  "Carbon",
	  "Caruso",
	  "Cattaneo",
	  "Colombo",
	  "Cont",
	  "Conte",
	  "Coppola",
	  "Costa",
	  "Costantin",
	  "D'amico",
	  "D'angelo",
	  "Damico",
	  "De Angelis",
	  "De luca",
	  "De rosa",
	  "De Santis",
	  "Donati",
	  "Esposito",
	  "Fabbri",
	  "Farin",
	  "Ferrara",
	  "Ferrari",
	  "Ferraro",
	  "Ferretti",
	  "Ferri",
	  "Fior",
	  "Fontana",
	  "Galli",
	  "Gallo",
	  "Gatti",
	  "Gentile",
	  "Giordano",
	  "Giuliani",
	  "Grassi",
	  "Grasso",
	  "Greco",
	  "Guerra",
	  "Leone",
	  "Lombardi",
	  "Lombardo",
	  "Longo",
	  "Mancini",
	  "Marchetti",
	  "Marian",
	  "Marini",
	  "Marino",
	  "Martinelli",
	  "Martini",
	  "Martino",
	  "Mazza",
	  "Messina",
	  "Milani",
	  "Montanari",
	  "Monti",
	  "Morelli",
	  "Moretti",
	  "Negri",
	  "Neri",
	  "Orlando",
	  "Pagano",
	  "Palmieri",
	  "Palumbo",
	  "Parisi",
	  "Pellegrini",
	  "Pellegrino",
	  "Piras",
	  "Ricci",
	  "Rinaldi",
	  "Riva",
	  "Rizzi",
	  "Rizzo",
	  "Romano",
	  "Ross",
	  "Rossetti",
	  "Ruggiero",
	  "Russo",
	  "Sala",
	  "Sanna",
	  "Santoro",
	  "Sartori",
	  "Serr",
	  "Silvestri",
	  "Sorrentino",
	  "Testa",
	  "Valentini",
	  "Villa",
	  "Vitale",
	  "Vitali"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sig.",
	  "Dott.",
	  "Dr.",
	  "Ing."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+## ### ## ## ####",
	  "+## ## #######",
	  "+## ## ########",
	  "+## ### #######",
	  "+## ### ########",
	  "+## #### #######",
	  "+## #### ########",
	  "0## ### ####",
	  "+39 0## ### ###",
	  "3## ### ###",
	  "+39 3## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1264);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{Name.first_name}#{city_suffix}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{city_prefix}#{Name.last_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北",
	  "東",
	  "西",
	  "南",
	  "新",
	  "湖",
	  "港"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "市",
	  "区",
	  "町",
	  "村"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(1270);
	address.state = __webpack_require__(1271);
	address.state_abbr = __webpack_require__(1272);
	address.city_prefix = __webpack_require__(1267);
	address.city_suffix = __webpack_require__(1268);
	address.city = __webpack_require__(1266);
	address.street_name = __webpack_require__(1273);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北海道",
	  "青森県",
	  "岩手県",
	  "宮城県",
	  "秋田県",
	  "山形県",
	  "福島県",
	  "茨城県",
	  "栃木県",
	  "群馬県",
	  "埼玉県",
	  "千葉県",
	  "東京都",
	  "神奈川県",
	  "新潟県",
	  "富山県",
	  "石川県",
	  "福井県",
	  "山梨県",
	  "長野県",
	  "岐阜県",
	  "静岡県",
	  "愛知県",
	  "三重県",
	  "滋賀県",
	  "京都府",
	  "大阪府",
	  "兵庫県",
	  "奈良県",
	  "和歌山県",
	  "鳥取県",
	  "島根県",
	  "岡山県",
	  "広島県",
	  "山口県",
	  "徳島県",
	  "香川県",
	  "愛媛県",
	  "高知県",
	  "福岡県",
	  "佐賀県",
	  "長崎県",
	  "熊本県",
	  "大分県",
	  "宮崎県",
	  "鹿児島県",
	  "沖縄県"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1",
	  "2",
	  "3",
	  "4",
	  "5",
	  "6",
	  "7",
	  "8",
	  "9",
	  "10",
	  "11",
	  "12",
	  "13",
	  "14",
	  "15",
	  "16",
	  "17",
	  "18",
	  "19",
	  "20",
	  "21",
	  "22",
	  "23",
	  "24",
	  "25",
	  "26",
	  "27",
	  "28",
	  "29",
	  "30",
	  "31",
	  "32",
	  "33",
	  "34",
	  "35",
	  "36",
	  "37",
	  "38",
	  "39",
	  "40",
	  "41",
	  "42",
	  "43",
	  "44",
	  "45",
	  "46",
	  "47"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name}#{street_suffix}",
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "090-####-####",
	  "080-####-####",
	  "070-####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1274);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ja = {};
	module['exports'] = ja;
	ja.title = "Japanese";
	ja.address = __webpack_require__(1269);
	ja.phone_number = __webpack_require__(1282);
	ja.cell_phone = __webpack_require__(1275);
	ja.name = __webpack_require__(1278);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "大翔",
	  "蓮",
	  "颯太",
	  "樹",
	  "大和",
	  "陽翔",
	  "陸斗",
	  "太一",
	  "海翔",
	  "蒼空",
	  "翼",
	  "陽菜",
	  "結愛",
	  "結衣",
	  "杏",
	  "莉子",
	  "美羽",
	  "結菜",
	  "心愛",
	  "愛菜",
	  "美咲"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.last_name = __webpack_require__(1279);
	name.first_name = __webpack_require__(1277);
	name.name = __webpack_require__(1280);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "佐藤",
	  "鈴木",
	  "高橋",
	  "田中",
	  "渡辺",
	  "伊藤",
	  "山本",
	  "中村",
	  "小林",
	  "加藤",
	  "吉田",
	  "山田",
	  "佐々木",
	  "山口",
	  "斎藤",
	  "松本",
	  "井上",
	  "木村",
	  "林",
	  "清水"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{last_name} #{first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0####-#-####",
	  "0###-##-####",
	  "0##-###-####",
	  "0#-####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1281);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "강릉",
	  "양양",
	  "인제",
	  "광주",
	  "구리",
	  "부천",
	  "밀양",
	  "통영",
	  "창원",
	  "거창",
	  "고성",
	  "양산",
	  "김천",
	  "구미",
	  "영주",
	  "광산",
	  "남",
	  "북",
	  "고창",
	  "군산",
	  "남원",
	  "동작",
	  "마포",
	  "송파",
	  "용산",
	  "부평",
	  "강화",
	  "수성"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "구",
	  "시",
	  "군"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(1287);
	address.state = __webpack_require__(1288);
	address.state_abbr = __webpack_require__(1289);
	address.city_suffix = __webpack_require__(1285);
	address.city_name = __webpack_require__(1284);
	address.city = __webpack_require__(1283);
	address.street_root = __webpack_require__(1291);
	address.street_suffix = __webpack_require__(1292);
	address.street_name = __webpack_require__(1290);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "강원",
	  "경기",
	  "경남",
	  "경북",
	  "광주",
	  "대구",
	  "대전",
	  "부산",
	  "서울",
	  "울산",
	  "인천",
	  "전남",
	  "전북",
	  "제주",
	  "충남",
	  "충북",
	  "세종"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "강원",
	  "경기",
	  "경남",
	  "경북",
	  "광주",
	  "대구",
	  "대전",
	  "부산",
	  "서울",
	  "울산",
	  "인천",
	  "전남",
	  "전북",
	  "제주",
	  "충남",
	  "충북",
	  "세종"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "상계",
	  "화곡",
	  "신정",
	  "목",
	  "잠실",
	  "면목",
	  "주안",
	  "안양",
	  "중",
	  "정왕",
	  "구로",
	  "신월",
	  "연산",
	  "부평",
	  "창",
	  "만수",
	  "중계",
	  "검단",
	  "시흥",
	  "상도",
	  "방배",
	  "장유",
	  "상",
	  "광명",
	  "신길",
	  "행신",
	  "대명",
	  "동탄"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "읍",
	  "면",
	  "동"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1296);
	company.prefix = __webpack_require__(1295);
	company.name = __webpack_require__(1294);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.first_name}",
	  "#{Name.first_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "주식회사",
	  "한국"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "연구소",
	  "게임즈",
	  "그룹",
	  "전자",
	  "물산",
	  "코리아"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ko = {};
	module['exports'] = ko;
	ko.title = "Korean";
	ko.address = __webpack_require__(1286);
	ko.phone_number = __webpack_require__(1308);
	ko.company = __webpack_require__(1293);
	ko.internet = __webpack_require__(1300);
	ko.lorem = __webpack_require__(1301);
	ko.name = __webpack_require__(1304);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "co.kr",
	  "com",
	  "biz",
	  "info",
	  "ne.kr",
	  "net",
	  "or.kr",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.co.kr",
	  "hanmail.net",
	  "naver.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1299);
	internet.domain_suffix = __webpack_require__(1298);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1302);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "국가는",
	  "법률이",
	  "정하는",
	  "바에",
	  "의하여",
	  "재외국민을",
	  "보호할",
	  "의무를",
	  "진다.",
	  "모든",
	  "국민은",
	  "신체의",
	  "자유를",
	  "가진다.",
	  "국가는",
	  "전통문화의",
	  "계승·발전과",
	  "민족문화의",
	  "창달에",
	  "노력하여야",
	  "한다.",
	  "통신·방송의",
	  "시설기준과",
	  "신문의",
	  "기능을",
	  "보장하기",
	  "위하여",
	  "필요한",
	  "사항은",
	  "법률로",
	  "정한다.",
	  "헌법에",
	  "의하여",
	  "체결·공포된",
	  "조약과",
	  "일반적으로",
	  "승인된",
	  "국제법규는",
	  "국내법과",
	  "같은",
	  "효력을",
	  "가진다.",
	  "다만,",
	  "현행범인인",
	  "경우와",
	  "장기",
	  "3년",
	  "이상의",
	  "형에",
	  "해당하는",
	  "죄를",
	  "범하고",
	  "도피",
	  "또는",
	  "증거인멸의",
	  "염려가",
	  "있을",
	  "때에는",
	  "사후에",
	  "영장을",
	  "청구할",
	  "수",
	  "있다.",
	  "저작자·발명가·과학기술자와",
	  "예술가의",
	  "권리는",
	  "법률로써",
	  "보호한다.",
	  "형사피고인은",
	  "유죄의",
	  "판결이",
	  "확정될",
	  "때까지는",
	  "무죄로",
	  "추정된다.",
	  "모든",
	  "국민은",
	  "행위시의",
	  "법률에",
	  "의하여",
	  "범죄를",
	  "구성하지",
	  "아니하는",
	  "행위로",
	  "소추되지",
	  "아니하며,",
	  "동일한",
	  "범죄에",
	  "대하여",
	  "거듭",
	  "처벌받지",
	  "아니한다.",
	  "국가는",
	  "평생교육을",
	  "진흥하여야",
	  "한다.",
	  "모든",
	  "국민은",
	  "사생활의",
	  "비밀과",
	  "자유를",
	  "침해받지",
	  "아니한다.",
	  "의무교육은",
	  "무상으로",
	  "한다.",
	  "저작자·발명가·과학기술자와",
	  "예술가의",
	  "권리는",
	  "법률로써",
	  "보호한다.",
	  "국가는",
	  "모성의",
	  "보호를",
	  "위하여",
	  "노력하여야",
	  "한다.",
	  "헌법에",
	  "의하여",
	  "체결·공포된",
	  "조약과",
	  "일반적으로",
	  "승인된",
	  "국제법규는",
	  "국내법과",
	  "같은",
	  "효력을",
	  "가진다."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "서연",
	  "민서",
	  "서현",
	  "지우",
	  "서윤",
	  "지민",
	  "수빈",
	  "하은",
	  "예은",
	  "윤서",
	  "민준",
	  "지후",
	  "지훈",
	  "준서",
	  "현우",
	  "예준",
	  "건우",
	  "현준",
	  "민재",
	  "우진",
	  "은주"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.last_name = __webpack_require__(1305);
	name.first_name = __webpack_require__(1303);
	name.name = __webpack_require__(1306);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "김",
	  "이",
	  "박",
	  "최",
	  "정",
	  "강",
	  "조",
	  "윤",
	  "장",
	  "임",
	  "오",
	  "한",
	  "신",
	  "서",
	  "권",
	  "황",
	  "안",
	  "송",
	  "류",
	  "홍"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{last_name} #{first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0#-#####-####",
	  "0##-###-####",
	  "0##-####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1307);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_root}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Fet",
	  "Gjes",
	  "Høy",
	  "Inn",
	  "Fager",
	  "Lille",
	  "Lo",
	  "Mal",
	  "Nord",
	  "Nær",
	  "Sand",
	  "Sme",
	  "Stav",
	  "Stor",
	  "Tand",
	  "Ut",
	  "Vest"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "berg",
	  "borg",
	  "by",
	  "bø",
	  "dal",
	  "eid",
	  "fjell",
	  "fjord",
	  "foss",
	  "grunn",
	  "hamn",
	  "havn",
	  "helle",
	  "mark",
	  "nes",
	  "odden",
	  "sand",
	  "sjøen",
	  "stad",
	  "strand",
	  "strøm",
	  "sund",
	  "vik",
	  "vær",
	  "våg",
	  "ø",
	  "øy",
	  "ås"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "sgate",
	  "svei",
	  "s Gate",
	  "s Vei",
	  "gata",
	  "veien"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Norge"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_root = __webpack_require__(1311);
	address.city_suffix = __webpack_require__(1312);
	address.street_prefix = __webpack_require__(1321);
	address.street_root = __webpack_require__(1322);
	address.street_suffix = __webpack_require__(1323);
	address.common_street_suffix = __webpack_require__(1313);
	address.building_number = __webpack_require__(1309);
	address.secondary_address = __webpack_require__(1317);
	address.postcode = __webpack_require__(1316);
	address.state = __webpack_require__(1318);
	address.city = __webpack_require__(1310);
	address.street_name = __webpack_require__(1320);
	address.street_address = __webpack_require__(1319);
	address.default_country = __webpack_require__(1314);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "####",
	  "####",
	  "0###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Leil. ###",
	  "Oppgang A",
	  "Oppgang B"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  ""
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}#{street_suffix}",
	  "#{street_prefix} #{street_root}#{street_suffix}",
	  "#{Name.first_name}#{common_street_suffix}",
	  "#{Name.last_name}#{common_street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Øvre",
	  "Nedre",
	  "Søndre",
	  "Gamle",
	  "Østre",
	  "Vestre"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Eike",
	  "Bjørke",
	  "Gran",
	  "Vass",
	  "Furu",
	  "Litj",
	  "Lille",
	  "Høy",
	  "Fosse",
	  "Elve",
	  "Ku",
	  "Konvall",
	  "Soldugg",
	  "Hestemyr",
	  "Granitt",
	  "Hegge",
	  "Rogne",
	  "Fiol",
	  "Sol",
	  "Ting",
	  "Malm",
	  "Klokker",
	  "Preste",
	  "Dam",
	  "Geiterygg",
	  "Bekke",
	  "Berg",
	  "Kirke",
	  "Kors",
	  "Bru",
	  "Blåveis",
	  "Torg",
	  "Sjø"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alléen",
	  "bakken",
	  "berget",
	  "bråten",
	  "eggen",
	  "engen",
	  "ekra",
	  "faret",
	  "flata",
	  "gata",
	  "gjerdet",
	  "grenda",
	  "gropa",
	  "hagen",
	  "haugen",
	  "havna",
	  "holtet",
	  "høgda",
	  "jordet",
	  "kollen",
	  "kroken",
	  "lia",
	  "lunden",
	  "lyngen",
	  "løkka",
	  "marka",
	  "moen",
	  "myra",
	  "plassen",
	  "ringen",
	  "roa",
	  "røa",
	  "skogen",
	  "skrenten",
	  "spranget",
	  "stien",
	  "stranda",
	  "stubben",
	  "stykket",
	  "svingen",
	  "tjernet",
	  "toppen",
	  "tunet",
	  "vollen",
	  "vika",
	  "åsen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1326);
	company.name = __webpack_require__(1325);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} og #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Gruppen",
	  "AS",
	  "ASA",
	  "BA",
	  "RFH",
	  "og Sønner"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nb_NO = {};
	module['exports'] = nb_NO;
	nb_NO.title = "Norwegian";
	nb_NO.address = __webpack_require__(1315);
	nb_NO.company = __webpack_require__(1324);
	nb_NO.internet = __webpack_require__(1329);
	nb_NO.name = __webpack_require__(1332);
	nb_NO.phone_number = __webpack_require__(1339);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "no",
	  "com",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(1328);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Emma",
	  "Sara",
	  "Thea",
	  "Ida",
	  "Julie",
	  "Nora",
	  "Emilie",
	  "Ingrid",
	  "Hanna",
	  "Maria",
	  "Sofie",
	  "Anna",
	  "Malin",
	  "Amalie",
	  "Vilde",
	  "Frida",
	  "Andrea",
	  "Tuva",
	  "Victoria",
	  "Mia",
	  "Karoline",
	  "Mathilde",
	  "Martine",
	  "Linnea",
	  "Marte",
	  "Hedda",
	  "Marie",
	  "Helene",
	  "Silje",
	  "Leah",
	  "Maja",
	  "Elise",
	  "Oda",
	  "Kristine",
	  "Aurora",
	  "Kaja",
	  "Camilla",
	  "Mari",
	  "Maren",
	  "Mina",
	  "Selma",
	  "Jenny",
	  "Celine",
	  "Eline",
	  "Sunniva",
	  "Natalie",
	  "Tiril",
	  "Synne",
	  "Sandra",
	  "Madeleine"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Emma",
	  "Sara",
	  "Thea",
	  "Ida",
	  "Julie",
	  "Nora",
	  "Emilie",
	  "Ingrid",
	  "Hanna",
	  "Maria",
	  "Sofie",
	  "Anna",
	  "Malin",
	  "Amalie",
	  "Vilde",
	  "Frida",
	  "Andrea",
	  "Tuva",
	  "Victoria",
	  "Mia",
	  "Karoline",
	  "Mathilde",
	  "Martine",
	  "Linnea",
	  "Marte",
	  "Hedda",
	  "Marie",
	  "Helene",
	  "Silje",
	  "Leah",
	  "Maja",
	  "Elise",
	  "Oda",
	  "Kristine",
	  "Aurora",
	  "Kaja",
	  "Camilla",
	  "Mari",
	  "Maren",
	  "Mina",
	  "Selma",
	  "Jenny",
	  "Celine",
	  "Eline",
	  "Sunniva",
	  "Natalie",
	  "Tiril",
	  "Synne",
	  "Sandra",
	  "Madeleine",
	  "Markus",
	  "Mathias",
	  "Kristian",
	  "Jonas",
	  "Andreas",
	  "Alexander",
	  "Martin",
	  "Sander",
	  "Daniel",
	  "Magnus",
	  "Henrik",
	  "Tobias",
	  "Kristoffer",
	  "Emil",
	  "Adrian",
	  "Sebastian",
	  "Marius",
	  "Elias",
	  "Fredrik",
	  "Thomas",
	  "Sondre",
	  "Benjamin",
	  "Jakob",
	  "Oliver",
	  "Lucas",
	  "Oskar",
	  "Nikolai",
	  "Filip",
	  "Mats",
	  "William",
	  "Erik",
	  "Simen",
	  "Ole",
	  "Eirik",
	  "Isak",
	  "Kasper",
	  "Noah",
	  "Lars",
	  "Joakim",
	  "Johannes",
	  "Håkon",
	  "Sindre",
	  "Jørgen",
	  "Herman",
	  "Anders",
	  "Jonathan",
	  "Even",
	  "Theodor",
	  "Mikkel",
	  "Aksel"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1331);
	name.feminine_name = __webpack_require__(1330);
	name.masculine_name = __webpack_require__(1334);
	name.last_name = __webpack_require__(1333);
	name.prefix = __webpack_require__(1336);
	name.suffix = __webpack_require__(1337);
	name.name = __webpack_require__(1335);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Johansen",
	  "Hansen",
	  "Andersen",
	  "Kristiansen",
	  "Larsen",
	  "Olsen",
	  "Solberg",
	  "Andresen",
	  "Pedersen",
	  "Nilsen",
	  "Berg",
	  "Halvorsen",
	  "Karlsen",
	  "Svendsen",
	  "Jensen",
	  "Haugen",
	  "Martinsen",
	  "Eriksen",
	  "Sørensen",
	  "Johnsen",
	  "Myhrer",
	  "Johannessen",
	  "Nielsen",
	  "Hagen",
	  "Pettersen",
	  "Bakke",
	  "Skuterud",
	  "Løken",
	  "Gundersen",
	  "Strand",
	  "Jørgensen",
	  "Kvarme",
	  "Røed",
	  "Sæther",
	  "Stensrud",
	  "Moe",
	  "Kristoffersen",
	  "Jakobsen",
	  "Holm",
	  "Aas",
	  "Lie",
	  "Moen",
	  "Andreassen",
	  "Vedvik",
	  "Nguyen",
	  "Jacobsen",
	  "Torgersen",
	  "Ruud",
	  "Krogh",
	  "Christiansen",
	  "Bjerke",
	  "Aalerud",
	  "Borge",
	  "Sørlie",
	  "Berge",
	  "Østli",
	  "Ødegård",
	  "Torp",
	  "Henriksen",
	  "Haukelidsæter",
	  "Fjeld",
	  "Danielsen",
	  "Aasen",
	  "Fredriksen",
	  "Dahl",
	  "Berntsen",
	  "Arnesen",
	  "Wold",
	  "Thoresen",
	  "Solheim",
	  "Skoglund",
	  "Bakken",
	  "Amundsen",
	  "Solli",
	  "Smogeli",
	  "Kristensen",
	  "Glosli",
	  "Fossum",
	  "Evensen",
	  "Eide",
	  "Carlsen",
	  "Østby",
	  "Vegge",
	  "Tangen",
	  "Smedsrud",
	  "Olstad",
	  "Lunde",
	  "Kleven",
	  "Huseby",
	  "Bjørnstad",
	  "Ryan",
	  "Rasmussen",
	  "Nygård",
	  "Nordskaug",
	  "Nordby",
	  "Mathisen",
	  "Hopland",
	  "Gran",
	  "Finstad",
	  "Edvardsen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Markus",
	  "Mathias",
	  "Kristian",
	  "Jonas",
	  "Andreas",
	  "Alexander",
	  "Martin",
	  "Sander",
	  "Daniel",
	  "Magnus",
	  "Henrik",
	  "Tobias",
	  "Kristoffer",
	  "Emil",
	  "Adrian",
	  "Sebastian",
	  "Marius",
	  "Elias",
	  "Fredrik",
	  "Thomas",
	  "Sondre",
	  "Benjamin",
	  "Jakob",
	  "Oliver",
	  "Lucas",
	  "Oskar",
	  "Nikolai",
	  "Filip",
	  "Mats",
	  "William",
	  "Erik",
	  "Simen",
	  "Ole",
	  "Eirik",
	  "Isak",
	  "Kasper",
	  "Noah",
	  "Lars",
	  "Joakim",
	  "Johannes",
	  "Håkon",
	  "Sindre",
	  "Jørgen",
	  "Herman",
	  "Anders",
	  "Jonathan",
	  "Even",
	  "Theodor",
	  "Mikkel",
	  "Aksel"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{suffix}",
	  "#{feminine_name} #{feminine_name} #{last_name}",
	  "#{masculine_name} #{masculine_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dr.",
	  "Prof."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "########",
	  "## ## ## ##",
	  "### ## ###",
	  "+47 ## ## ## ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1338);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bhaktapur",
	  "Biratnagar",
	  "Birendranagar",
	  "Birgunj",
	  "Butwal",
	  "Damak",
	  "Dharan",
	  "Gaur",
	  "Gorkha",
	  "Hetauda",
	  "Itahari",
	  "Janakpur",
	  "Kathmandu",
	  "Lahan",
	  "Nepalgunj",
	  "Pokhara"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nepal"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(1343);
	address.state = __webpack_require__(1344);
	address.city = __webpack_require__(1340);
	address.default_country = __webpack_require__(1341);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  0
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Baglung",
	  "Banke",
	  "Bara",
	  "Bardiya",
	  "Bhaktapur",
	  "Bhojupu",
	  "Chitwan",
	  "Dailekh",
	  "Dang",
	  "Dhading",
	  "Dhankuta",
	  "Dhanusa",
	  "Dolakha",
	  "Dolpha",
	  "Gorkha",
	  "Gulmi",
	  "Humla",
	  "Ilam",
	  "Jajarkot",
	  "Jhapa",
	  "Jumla",
	  "Kabhrepalanchok",
	  "Kalikot",
	  "Kapilvastu",
	  "Kaski",
	  "Kathmandu",
	  "Lalitpur",
	  "Lamjung",
	  "Manang",
	  "Mohottari",
	  "Morang",
	  "Mugu",
	  "Mustang",
	  "Myagdi",
	  "Nawalparasi",
	  "Nuwakot",
	  "Palpa",
	  "Parbat",
	  "Parsa",
	  "Ramechhap",
	  "Rauswa",
	  "Rautahat",
	  "Rolpa",
	  "Rupandehi",
	  "Sankhuwasabha",
	  "Sarlahi",
	  "Sindhuli",
	  "Sindhupalchok",
	  "Sunsari",
	  "Surket",
	  "Syangja",
	  "Tanahu",
	  "Terhathum"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1346);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pvt Ltd",
	  "Group",
	  "Ltd",
	  "Limited"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nep = {};
	module['exports'] = nep;
	nep.title = "Nepalese";
	nep.name = __webpack_require__(1352);
	nep.address = __webpack_require__(1342);
	nep.internet = __webpack_require__(1350);
	nep.company = __webpack_require__(1345);
	nep.phone_number = __webpack_require__(1355);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "np",
	  "com",
	  "info",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "worldlink.com.np",
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1349);
	internet.domain_suffix = __webpack_require__(1348);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aarav",
	  "Ajita",
	  "Amit",
	  "Amita",
	  "Amrit",
	  "Arijit",
	  "Ashmi",
	  "Asmita",
	  "Bibek",
	  "Bijay",
	  "Bikash",
	  "Bina",
	  "Bishal",
	  "Bishnu",
	  "Buddha",
	  "Deepika",
	  "Dipendra",
	  "Gagan",
	  "Ganesh",
	  "Khem",
	  "Krishna",
	  "Laxmi",
	  "Manisha",
	  "Nabin",
	  "Nikita",
	  "Niraj",
	  "Nischal",
	  "Padam",
	  "Pooja",
	  "Prabin",
	  "Prakash",
	  "Prashant",
	  "Prem",
	  "Purna",
	  "Rajendra",
	  "Rajina",
	  "Raju",
	  "Rakesh",
	  "Ranjan",
	  "Ratna",
	  "Sagar",
	  "Sandeep",
	  "Sanjay",
	  "Santosh",
	  "Sarita",
	  "Shilpa",
	  "Shirisha",
	  "Shristi",
	  "Siddhartha",
	  "Subash",
	  "Sumeet",
	  "Sunita",
	  "Suraj",
	  "Susan",
	  "Sushant"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1351);
	name.last_name = __webpack_require__(1353);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adhikari",
	  "Aryal",
	  "Baral",
	  "Basnet",
	  "Bastola",
	  "Basynat",
	  "Bhandari",
	  "Bhattarai",
	  "Chettri",
	  "Devkota",
	  "Dhakal",
	  "Dongol",
	  "Ghale",
	  "Gurung",
	  "Gyawali",
	  "Hamal",
	  "Jung",
	  "KC",
	  "Kafle",
	  "Karki",
	  "Khadka",
	  "Koirala",
	  "Lama",
	  "Limbu",
	  "Magar",
	  "Maharjan",
	  "Niroula",
	  "Pandey",
	  "Pradhan",
	  "Rana",
	  "Raut",
	  "Sai",
	  "Shai",
	  "Shakya",
	  "Sherpa",
	  "Shrestha",
	  "Subedi",
	  "Tamang",
	  "Thapa"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "##-#######",
	  "+977-#-#######",
	  "+977########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1354);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##",
	  "###",
	  "###a",
	  "###b",
	  "###c",
	  "### I",
	  "### II",
	  "### III"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Noord",
	  "Oost",
	  "West",
	  "Zuid",
	  "Nieuw",
	  "Oud"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "dam",
	  "berg",
	  " aan de Rijn",
	  " aan de IJssel",
	  "swaerd",
	  "endrecht",
	  "recht",
	  "ambacht",
	  "enmaes",
	  "wijk",
	  "sland",
	  "stroom",
	  "sluus",
	  "dijk",
	  "dorp",
	  "burg",
	  "veld",
	  "sluis",
	  "koop",
	  "lek",
	  "hout",
	  "geest",
	  "kerk",
	  "woude",
	  "hoven",
	  "hoten",
	  "ingen",
	  "plas",
	  "meer"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afghanistan",
	  "Akrotiri",
	  "Albanië",
	  "Algerije",
	  "Amerikaanse Maagdeneilanden",
	  "Amerikaans-Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarctica",
	  "Antigua en Barbuda",
	  "Arctic Ocean",
	  "Argentinië",
	  "Armenië",
	  "Aruba",
	  "Ashmore and Cartier Islands",
	  "Atlantic Ocean",
	  "Australië",
	  "Azerbeidzjan",
	  "Bahama's",
	  "Bahrein",
	  "Bangladesh",
	  "Barbados",
	  "Belarus",
	  "België",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolivië",
	  "Bosnië-Herzegovina",
	  "Botswana",
	  "Bouvet Island",
	  "Brazilië",
	  "British Indian Ocean Territory",
	  "Britse Maagdeneilanden",
	  "Brunei",
	  "Bulgarije",
	  "Burkina Faso",
	  "Burundi",
	  "Cambodja",
	  "Canada",
	  "Caymaneilanden",
	  "Centraal-Afrikaanse Republiek",
	  "Chili",
	  "China",
	  "Christmas Island",
	  "Clipperton Island",
	  "Cocos (Keeling) Islands",
	  "Colombia",
	  "Comoren (Unie)",
	  "Congo (Democratische Republiek)",
	  "Congo (Volksrepubliek)",
	  "Cook",
	  "Coral Sea Islands",
	  "Costa Rica",
	  "Cuba",
	  "Cyprus",
	  "Denemarken",
	  "Dhekelia",
	  "Djibouti",
	  "Dominica",
	  "Dominicaanse Republiek",
	  "Duitsland",
	  "Ecuador",
	  "Egypte",
	  "El Salvador",
	  "Equatoriaal-Guinea",
	  "Eritrea",
	  "Estland",
	  "Ethiopië",
	  "European Union",
	  "Falkland",
	  "Faroe Islands",
	  "Fiji",
	  "Filipijnen",
	  "Finland",
	  "Frankrijk",
	  "Frans-Polynesië",
	  "French Southern and Antarctic Lands",
	  "Gabon",
	  "Gambia",
	  "Gaza Strip",
	  "Georgië",
	  "Ghana",
	  "Gibraltar",
	  "Grenada",
	  "Griekenland",
	  "Groenland",
	  "Guam",
	  "Guatemala",
	  "Guernsey",
	  "Guinea",
	  "Guinee-Bissau",
	  "Guyana",
	  "Haïti",
	  "Heard Island and McDonald Islands",
	  "Heilige Stoel",
	  "Honduras",
	  "Hongarije",
	  "Hongkong",
	  "Ierland",
	  "IJsland",
	  "India",
	  "Indian Ocean",
	  "Indonesië",
	  "Irak",
	  "Iran",
	  "Isle of Man",
	  "Israël",
	  "Italië",
	  "Ivoorkust",
	  "Jamaica",
	  "Jan Mayen",
	  "Japan",
	  "Jemen",
	  "Jersey",
	  "Jordanië",
	  "Kaapverdië",
	  "Kameroen",
	  "Kazachstan",
	  "Kenia",
	  "Kirgizstan",
	  "Kiribati",
	  "Koeweit",
	  "Kroatië",
	  "Laos",
	  "Lesotho",
	  "Letland",
	  "Libanon",
	  "Liberia",
	  "Libië",
	  "Liechtenstein",
	  "Litouwen",
	  "Luxemburg",
	  "Macao",
	  "Macedonië",
	  "Madagaskar",
	  "Malawi",
	  "Maldiven",
	  "Maleisië",
	  "Mali",
	  "Malta",
	  "Marokko",
	  "Marshall Islands",
	  "Mauritanië",
	  "Mauritius",
	  "Mayotte",
	  "Mexico",
	  "Micronesia, Federated States of",
	  "Moldavië",
	  "Monaco",
	  "Mongolië",
	  "Montenegro",
	  "Montserrat",
	  "Mozambique",
	  "Myanmar",
	  "Namibië",
	  "Nauru",
	  "Navassa Island",
	  "Nederland",
	  "Nederlandse Antillen",
	  "Nepal",
	  "Ngwane",
	  "Nicaragua",
	  "Nieuw-Caledonië",
	  "Nieuw-Zeeland",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Noordelijke Marianen",
	  "Noord-Korea",
	  "Noorwegen",
	  "Norfolk Island",
	  "Oekraïne",
	  "Oezbekistan",
	  "Oman",
	  "Oostenrijk",
	  "Pacific Ocean",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papoea-Nieuw-Guinea",
	  "Paracel Islands",
	  "Paraguay",
	  "Peru",
	  "Pitcairn",
	  "Polen",
	  "Portugal",
	  "Puerto Rico",
	  "Qatar",
	  "Roemenië",
	  "Rusland",
	  "Rwanda",
	  "Saint Helena",
	  "Saint Lucia",
	  "Saint Vincent en de Grenadines",
	  "Saint-Pierre en Miquelon",
	  "Salomon",
	  "Samoa",
	  "San Marino",
	  "São Tomé en Principe",
	  "Saudi-Arabië",
	  "Senegal",
	  "Servië",
	  "Seychellen",
	  "Sierra Leone",
	  "Singapore",
	  "Sint-Kitts en Nevis",
	  "Slovenië",
	  "Slowakije",
	  "Soedan",
	  "Somalië",
	  "South Georgia and the South Sandwich Islands",
	  "Southern Ocean",
	  "Spanje",
	  "Spratly Islands",
	  "Sri Lanka",
	  "Suriname",
	  "Svalbard",
	  "Syrië",
	  "Tadzjikistan",
	  "Taiwan",
	  "Tanzania",
	  "Thailand",
	  "Timor Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad en Tobago",
	  "Tsjaad",
	  "Tsjechië",
	  "Tunesië",
	  "Turkije",
	  "Turkmenistan",
	  "Turks-en Caicoseilanden",
	  "Tuvalu",
	  "Uganda",
	  "Uruguay",
	  "Vanuatu",
	  "Venezuela",
	  "Verenigd Koninkrijk",
	  "Verenigde Arabische Emiraten",
	  "Verenigde Staten van Amerika",
	  "Vietnam",
	  "Wake Island",
	  "Wallis en Futuna",
	  "Wereld",
	  "West Bank",
	  "Westelijke Sahara",
	  "Zambia",
	  "Zimbabwe",
	  "Zuid-Afrika",
	  "Zuid-Korea",
	  "Zweden",
	  "Zwitserland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nederland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1358);
	address.city_suffix = __webpack_require__(1359);
	address.city = __webpack_require__(1357);
	address.country = __webpack_require__(1360);
	address.building_number = __webpack_require__(1356);
	address.street_suffix = __webpack_require__(1368);
	address.secondary_address = __webpack_require__(1364);
	address.street_name = __webpack_require__(1367);
	address.street_address = __webpack_require__(1366);
	address.postcode = __webpack_require__(1363);
	address.state = __webpack_require__(1365);
	address.default_country = __webpack_require__(1361);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#### ??"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1 hoog",
	  "2 hoog",
	  "3 hoog"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Noord-Holland",
	  "Zuid-Holland",
	  "Utrecht",
	  "Zeeland",
	  "Overijssel",
	  "Gelderland",
	  "Drenthe",
	  "Friesland",
	  "Groningen",
	  "Noord-Brabant",
	  "Limburg",
	  "Flevoland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name}#{street_suffix}",
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "straat",
	  "laan",
	  "weg",
	  "plantsoen",
	  "park"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1370);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "BV",
	  "V.O.F.",
	  "Group",
	  "en Zonen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nl = {};
	module['exports'] = nl;
	nl.title = "Dutch";
	nl.address = __webpack_require__(1362);
	nl.company = __webpack_require__(1369);
	nl.internet = __webpack_require__(1374);
	nl.lorem = __webpack_require__(1375);
	nl.name = __webpack_require__(1379);
	nl.phone_number = __webpack_require__(1386);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "nl",
	  "com",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1373);
	internet.domain_suffix = __webpack_require__(1372);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1377);
	lorem.supplemental = __webpack_require__(1376);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Amber",
	  "Anna",
	  "Anne",
	  "Anouk",
	  "Bas",
	  "Bram",
	  "Britt",
	  "Daan",
	  "Emma",
	  "Eva",
	  "Femke",
	  "Finn",
	  "Fleur",
	  "Iris",
	  "Isa",
	  "Jan",
	  "Jasper",
	  "Jayden",
	  "Jesse",
	  "Johannes",
	  "Julia",
	  "Julian",
	  "Kevin",
	  "Lars",
	  "Lieke",
	  "Lisa",
	  "Lotte",
	  "Lucas",
	  "Luuk",
	  "Maud",
	  "Max",
	  "Mike",
	  "Milan",
	  "Nick",
	  "Niels",
	  "Noa",
	  "Rick",
	  "Roos",
	  "Ruben",
	  "Sander",
	  "Sanne",
	  "Sem",
	  "Sophie",
	  "Stijn",
	  "Sven",
	  "Thijs",
	  "Thijs",
	  "Thomas",
	  "Tim",
	  "Tom"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1378);
	name.tussenvoegsel = __webpack_require__(1384);
	name.last_name = __webpack_require__(1380);
	name.prefix = __webpack_require__(1382);
	name.suffix = __webpack_require__(1383);
	name.name = __webpack_require__(1381);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bakker",
	  "Beek",
	  "Berg",
	  "Boer",
	  "Bos",
	  "Bosch",
	  "Brink",
	  "Broek",
	  "Brouwer",
	  "Bruin",
	  "Dam",
	  "Dekker",
	  "Dijk",
	  "Dijkstra",
	  "Graaf",
	  "Groot",
	  "Haan",
	  "Hendriks",
	  "Heuvel",
	  "Hoek",
	  "Jacobs",
	  "Jansen",
	  "Janssen",
	  "Jong",
	  "Klein",
	  "Kok",
	  "Koning",
	  "Koster",
	  "Leeuwen",
	  "Linden",
	  "Maas",
	  "Meer",
	  "Meijer",
	  "Mulder",
	  "Peters",
	  "Ruiter",
	  "Schouten",
	  "Smit",
	  "Smits",
	  "Stichting",
	  "Veen",
	  "Ven",
	  "Vermeulen",
	  "Visser",
	  "Vliet",
	  "Vos",
	  "Vries",
	  "Wal",
	  "Willems",
	  "Wit"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{suffix}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{tussenvoegsel} #{last_name}",
	  "#{first_name} #{tussenvoegsel} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dhr.",
	  "Mevr. Dr.",
	  "Bsc",
	  "Msc",
	  "Prof."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "van",
	  "van de",
	  "van den",
	  "van 't",
	  "van het",
	  "de",
	  "den"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(####) ######",
	  "##########",
	  "06########",
	  "06 #### ####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1385);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aleksandrów Kujawski",
	  "Aleksandrów Łódzki",
	  "Alwernia",
	  "Andrychów",
	  "Annopol",
	  "Augustów",
	  "Babimost",
	  "Baborów",
	  "Baranów Sandomierski",
	  "Barcin",
	  "Barczewo",
	  "Bardo",
	  "Barlinek",
	  "Bartoszyce",
	  "Barwice",
	  "Bełchatów",
	  "Bełżyce",
	  "Będzin",
	  "Biała",
	  "Biała Piska",
	  "Biała Podlaska",
	  "Biała Rawska",
	  "Białobrzegi",
	  "Białogard",
	  "Biały Bór",
	  "Białystok",
	  "Biecz",
	  "Bielawa",
	  "Bielsk Podlaski",
	  "Bielsko-Biała",
	  "Bieruń",
	  "Bierutów",
	  "Bieżuń",
	  "Biłgoraj",
	  "Biskupiec",
	  "Bisztynek",
	  "Blachownia",
	  "Błaszki",
	  "Błażowa",
	  "Błonie",
	  "Bobolice",
	  "Bobowa",
	  "Bochnia",
	  "Bodzentyn",
	  "Bogatynia",
	  "Boguchwała",
	  "Boguszów-Gorce",
	  "Bojanowo",
	  "Bolesławiec",
	  "Bolków",
	  "Borek Wielkopolski",
	  "Borne Sulinowo",
	  "Braniewo",
	  "Brańsk",
	  "Brodnica",
	  "Brok",
	  "Brusy",
	  "Brwinów",
	  "Brzeg",
	  "Brzeg Dolny",
	  "Brzesko",
	  "Brzeszcze",
	  "Brześć Kujawski",
	  "Brzeziny",
	  "Brzostek",
	  "Brzozów",
	  "Buk",
	  "Bukowno",
	  "Busko-Zdrój",
	  "Bychawa",
	  "Byczyna",
	  "Bydgoszcz",
	  "Bystrzyca Kłodzka",
	  "Bytom",
	  "Bytom Odrzański",
	  "Bytów",
	  "Cedynia",
	  "Chełm",
	  "Chełmek",
	  "Chełmno",
	  "Chełmża",
	  "Chęciny",
	  "Chmielnik",
	  "Chocianów",
	  "Chociwel",
	  "Chodecz",
	  "Chodzież",
	  "Chojna",
	  "Chojnice",
	  "Chojnów",
	  "Choroszcz",
	  "Chorzele",
	  "Chorzów",
	  "Choszczno",
	  "Chrzanów",
	  "Ciechanowiec",
	  "Ciechanów",
	  "Ciechocinek",
	  "Cieszanów",
	  "Cieszyn",
	  "Ciężkowice",
	  "Cybinka",
	  "Czaplinek",
	  "Czarna Białostocka",
	  "Czarna Woda",
	  "Czarne",
	  "Czarnków",
	  "Czchów",
	  "Czechowice-Dziedzice",
	  "Czeladź",
	  "Czempiń",
	  "Czerniejewo",
	  "Czersk",
	  "Czerwieńsk",
	  "Czerwionka-Leszczyny",
	  "Częstochowa",
	  "Człopa",
	  "Człuchów",
	  "Czyżew",
	  "Ćmielów",
	  "Daleszyce",
	  "Darłowo",
	  "Dąbie",
	  "Dąbrowa Białostocka",
	  "Dąbrowa Górnicza",
	  "Dąbrowa Tarnowska",
	  "Debrzno",
	  "Dębica",
	  "Dęblin",
	  "Dębno",
	  "Dobczyce",
	  "Dobiegniew",
	  "Dobra (powiat łobeski)",
	  "Dobra (powiat turecki)",
	  "Dobre Miasto",
	  "Dobrodzień",
	  "Dobrzany",
	  "Dobrzyń nad Wisłą",
	  "Dolsk",
	  "Drawno",
	  "Drawsko Pomorskie",
	  "Drezdenko",
	  "Drobin",
	  "Drohiczyn",
	  "Drzewica",
	  "Dukla",
	  "Duszniki-Zdrój",
	  "Dynów",
	  "Działdowo",
	  "Działoszyce",
	  "Działoszyn",
	  "Dzierzgoń",
	  "Dzierżoniów",
	  "Dziwnów",
	  "Elbląg",
	  "Ełk",
	  "Frampol",
	  "Frombork",
	  "Garwolin",
	  "Gąbin",
	  "Gdańsk",
	  "Gdynia",
	  "Giżycko",
	  "Glinojeck",
	  "Gliwice",
	  "Głogów",
	  "Głogów Małopolski",
	  "Głogówek",
	  "Głowno",
	  "Głubczyce",
	  "Głuchołazy",
	  "Głuszyca",
	  "Gniew",
	  "Gniewkowo",
	  "Gniezno",
	  "Gogolin",
	  "Golczewo",
	  "Goleniów",
	  "Golina",
	  "Golub-Dobrzyń",
	  "Gołańcz",
	  "Gołdap",
	  "Goniądz",
	  "Gorlice",
	  "Gorzów Śląski",
	  "Gorzów Wielkopolski",
	  "Gostynin",
	  "Gostyń",
	  "Gościno",
	  "Gozdnica",
	  "Góra",
	  "Góra Kalwaria",
	  "Górowo Iławeckie",
	  "Górzno",
	  "Grabów nad Prosną",
	  "Grajewo",
	  "Grodków",
	  "Grodzisk Mazowiecki",
	  "Grodzisk Wielkopolski",
	  "Grójec",
	  "Grudziądz",
	  "Grybów",
	  "Gryfice",
	  "Gryfino",
	  "Gryfów Śląski",
	  "Gubin",
	  "Hajnówka",
	  "Halinów",
	  "Hel",
	  "Hrubieszów",
	  "Iława",
	  "Iłowa",
	  "Iłża",
	  "Imielin",
	  "Inowrocław",
	  "Ińsko",
	  "Iwonicz-Zdrój",
	  "Izbica Kujawska",
	  "Jabłonowo Pomorskie",
	  "Janikowo",
	  "Janowiec Wielkopolski",
	  "Janów Lubelski",
	  "Jarocin",
	  "Jarosław",
	  "Jasień",
	  "Jasło",
	  "Jastarnia",
	  "Jastrowie",
	  "Jastrzębie-Zdrój",
	  "Jawor",
	  "Jaworzno",
	  "Jaworzyna Śląska",
	  "Jedlicze",
	  "Jedlina-Zdrój",
	  "Jedwabne",
	  "Jelcz-Laskowice",
	  "Jelenia Góra",
	  "Jeziorany",
	  "Jędrzejów",
	  "Jordanów",
	  "Józefów (powiat biłgorajski)",
	  "Józefów (powiat otwocki)",
	  "Jutrosin",
	  "Kalety",
	  "Kalisz",
	  "Kalisz Pomorski",
	  "Kalwaria Zebrzydowska",
	  "Kałuszyn",
	  "Kamienna Góra",
	  "Kamień Krajeński",
	  "Kamień Pomorski",
	  "Kamieńsk",
	  "Kańczuga",
	  "Karczew",
	  "Kargowa",
	  "Karlino",
	  "Karpacz",
	  "Kartuzy",
	  "Katowice",
	  "Kazimierz Dolny",
	  "Kazimierza Wielka",
	  "Kąty Wrocławskie",
	  "Kcynia",
	  "Kędzierzyn-Koźle",
	  "Kępice",
	  "Kępno",
	  "Kętrzyn",
	  "Kęty",
	  "Kielce",
	  "Kietrz",
	  "Kisielice",
	  "Kleczew",
	  "Kleszczele",
	  "Kluczbork",
	  "Kłecko",
	  "Kłobuck",
	  "Kłodawa",
	  "Kłodzko",
	  "Knurów",
	  "Knyszyn",
	  "Kobylin",
	  "Kobyłka",
	  "Kock",
	  "Kolbuszowa",
	  "Kolno",
	  "Kolonowskie",
	  "Koluszki",
	  "Kołaczyce",
	  "Koło",
	  "Kołobrzeg",
	  "Koniecpol",
	  "Konin",
	  "Konstancin-Jeziorna",
	  "Konstantynów Łódzki",
	  "Końskie",
	  "Koprzywnica",
	  "Korfantów",
	  "Koronowo",
	  "Korsze",
	  "Kosów Lacki",
	  "Kostrzyn",
	  "Kostrzyn nad Odrą",
	  "Koszalin",
	  "Kościan",
	  "Kościerzyna",
	  "Kowal",
	  "Kowalewo Pomorskie",
	  "Kowary",
	  "Koziegłowy",
	  "Kozienice",
	  "Koźmin Wielkopolski",
	  "Kożuchów",
	  "Kórnik",
	  "Krajenka",
	  "Kraków",
	  "Krapkowice",
	  "Krasnobród",
	  "Krasnystaw",
	  "Kraśnik",
	  "Krobia",
	  "Krosno",
	  "Krosno Odrzańskie",
	  "Krośniewice",
	  "Krotoszyn",
	  "Kruszwica",
	  "Krynica Morska",
	  "Krynica-Zdrój",
	  "Krynki",
	  "Krzanowice",
	  "Krzepice",
	  "Krzeszowice",
	  "Krzywiń",
	  "Krzyż Wielkopolski",
	  "Książ Wielkopolski",
	  "Kudowa-Zdrój",
	  "Kunów",
	  "Kutno",
	  "Kuźnia Raciborska",
	  "Kwidzyn",
	  "Lądek-Zdrój",
	  "Legionowo",
	  "Legnica",
	  "Lesko",
	  "Leszno",
	  "Leśna",
	  "Leśnica",
	  "Lewin Brzeski",
	  "Leżajsk",
	  "Lębork",
	  "Lędziny",
	  "Libiąż",
	  "Lidzbark",
	  "Lidzbark Warmiński",
	  "Limanowa",
	  "Lipiany",
	  "Lipno",
	  "Lipsk",
	  "Lipsko",
	  "Lubaczów",
	  "Lubań",
	  "Lubartów",
	  "Lubawa",
	  "Lubawka",
	  "Lubień Kujawski",
	  "Lubin",
	  "Lublin",
	  "Lubliniec",
	  "Lubniewice",
	  "Lubomierz",
	  "Luboń",
	  "Lubraniec",
	  "Lubsko",
	  "Lwówek",
	  "Lwówek Śląski",
	  "Łabiszyn",
	  "Łańcut",
	  "Łapy",
	  "Łasin",
	  "Łask",
	  "Łaskarzew",
	  "Łaszczów",
	  "Łaziska Górne",
	  "Łazy",
	  "Łeba",
	  "Łęczna",
	  "Łęczyca",
	  "Łęknica",
	  "Łobez",
	  "Łobżenica",
	  "Łochów",
	  "Łomianki",
	  "Łomża",
	  "Łosice",
	  "Łowicz",
	  "Łódź",
	  "Łuków",
	  "Maków Mazowiecki",
	  "Maków Podhalański",
	  "Malbork",
	  "Małogoszcz",
	  "Małomice",
	  "Margonin",
	  "Marki",
	  "Maszewo",
	  "Miasteczko Śląskie",
	  "Miastko",
	  "Michałowo",
	  "Miechów",
	  "Miejska Górka",
	  "Mielec",
	  "Mieroszów",
	  "Mieszkowice",
	  "Międzybórz",
	  "Międzychód",
	  "Międzylesie",
	  "Międzyrzec Podlaski",
	  "Międzyrzecz",
	  "Międzyzdroje",
	  "Mikołajki",
	  "Mikołów",
	  "Mikstat",
	  "Milanówek",
	  "Milicz",
	  "Miłakowo",
	  "Miłomłyn",
	  "Miłosław",
	  "Mińsk Mazowiecki",
	  "Mirosławiec",
	  "Mirsk",
	  "Mława",
	  "Młynary",
	  "Mogielnica",
	  "Mogilno",
	  "Mońki",
	  "Morąg",
	  "Mordy",
	  "Moryń",
	  "Mosina",
	  "Mrągowo",
	  "Mrocza",
	  "Mszana Dolna",
	  "Mszczonów",
	  "Murowana Goślina",
	  "Muszyna",
	  "Mysłowice",
	  "Myszków",
	  "Myszyniec",
	  "Myślenice",
	  "Myślibórz",
	  "Nakło nad Notecią",
	  "Nałęczów",
	  "Namysłów",
	  "Narol",
	  "Nasielsk",
	  "Nekla",
	  "Nidzica",
	  "Niemcza",
	  "Niemodlin",
	  "Niepołomice",
	  "Nieszawa",
	  "Nisko",
	  "Nowa Dęba",
	  "Nowa Ruda",
	  "Nowa Sarzyna",
	  "Nowa Sól",
	  "Nowe",
	  "Nowe Brzesko",
	  "Nowe Miasteczko",
	  "Nowe Miasto Lubawskie",
	  "Nowe Miasto nad Pilicą",
	  "Nowe Skalmierzyce",
	  "Nowe Warpno",
	  "Nowogard",
	  "Nowogrodziec",
	  "Nowogród",
	  "Nowogród Bobrzański",
	  "Nowy Dwór Gdański",
	  "Nowy Dwór Mazowiecki",
	  "Nowy Sącz",
	  "Nowy Staw",
	  "Nowy Targ",
	  "Nowy Tomyśl",
	  "Nowy Wiśnicz",
	  "Nysa",
	  "Oborniki",
	  "Oborniki Śląskie",
	  "Obrzycko",
	  "Odolanów",
	  "Ogrodzieniec",
	  "Okonek",
	  "Olecko",
	  "Olesno",
	  "Oleszyce",
	  "Oleśnica",
	  "Olkusz",
	  "Olsztyn",
	  "Olsztynek",
	  "Olszyna",
	  "Oława",
	  "Opalenica",
	  "Opatów",
	  "Opoczno",
	  "Opole",
	  "Opole Lubelskie",
	  "Orneta",
	  "Orzesze",
	  "Orzysz",
	  "Osieczna",
	  "Osiek",
	  "Ostrołęka",
	  "Ostroróg",
	  "Ostrowiec Świętokrzyski",
	  "Ostróda",
	  "Ostrów Lubelski",
	  "Ostrów Mazowiecka",
	  "Ostrów Wielkopolski",
	  "Ostrzeszów",
	  "Ośno Lubuskie",
	  "Oświęcim",
	  "Otmuchów",
	  "Otwock",
	  "Ozimek",
	  "Ozorków",
	  "Ożarów",
	  "Ożarów Mazowiecki",
	  "Pabianice",
	  "Paczków",
	  "Pajęczno",
	  "Pakość",
	  "Parczew",
	  "Pasłęk",
	  "Pasym",
	  "Pelplin",
	  "Pełczyce",
	  "Piaseczno",
	  "Piaski",
	  "Piastów",
	  "Piechowice",
	  "Piekary Śląskie",
	  "Pieniężno",
	  "Pieńsk",
	  "Pieszyce",
	  "Pilawa",
	  "Pilica",
	  "Pilzno",
	  "Piła",
	  "Piława Górna",
	  "Pińczów",
	  "Pionki",
	  "Piotrków Kujawski",
	  "Piotrków Trybunalski",
	  "Pisz",
	  "Piwniczna-Zdrój",
	  "Pleszew",
	  "Płock",
	  "Płońsk",
	  "Płoty",
	  "Pniewy",
	  "Pobiedziska",
	  "Poddębice",
	  "Podkowa Leśna",
	  "Pogorzela",
	  "Polanica-Zdrój",
	  "Polanów",
	  "Police",
	  "Polkowice",
	  "Połaniec",
	  "Połczyn-Zdrój",
	  "Poniatowa",
	  "Poniec",
	  "Poręba",
	  "Poznań",
	  "Prabuty",
	  "Praszka",
	  "Prochowice",
	  "Proszowice",
	  "Prószków",
	  "Pruchnik",
	  "Prudnik",
	  "Prusice",
	  "Pruszcz Gdański",
	  "Pruszków",
	  "Przasnysz",
	  "Przecław",
	  "Przedbórz",
	  "Przedecz",
	  "Przemków",
	  "Przemyśl",
	  "Przeworsk",
	  "Przysucha",
	  "Pszczyna",
	  "Pszów",
	  "Puck",
	  "Puławy",
	  "Pułtusk",
	  "Puszczykowo",
	  "Pyrzyce",
	  "Pyskowice",
	  "Pyzdry",
	  "Rabka-Zdrój",
	  "Raciąż",
	  "Racibórz",
	  "Radków",
	  "Radlin",
	  "Radłów",
	  "Radom",
	  "Radomsko",
	  "Radomyśl Wielki",
	  "Radymno",
	  "Radziejów",
	  "Radzionków",
	  "Radzymin",
	  "Radzyń Chełmiński",
	  "Radzyń Podlaski",
	  "Rajgród",
	  "Rakoniewice",
	  "Raszków",
	  "Rawa Mazowiecka",
	  "Rawicz",
	  "Recz",
	  "Reda",
	  "Rejowiec Fabryczny",
	  "Resko",
	  "Reszel",
	  "Rogoźno",
	  "Ropczyce",
	  "Różan",
	  "Ruciane-Nida",
	  "Ruda Śląska",
	  "Rudnik nad Sanem",
	  "Rumia",
	  "Rybnik",
	  "Rychwał",
	  "Rydułtowy",
	  "Rydzyna",
	  "Ryglice",
	  "Ryki",
	  "Rymanów",
	  "Ryn",
	  "Rypin",
	  "Rzepin",
	  "Rzeszów",
	  "Rzgów",
	  "Sandomierz",
	  "Sanok",
	  "Sejny",
	  "Serock",
	  "Sędziszów",
	  "Sędziszów Małopolski",
	  "Sępopol",
	  "Sępólno Krajeńskie",
	  "Sianów",
	  "Siechnice",
	  "Siedlce",
	  "Siemianowice Śląskie",
	  "Siemiatycze",
	  "Sieniawa",
	  "Sieradz",
	  "Sieraków",
	  "Sierpc",
	  "Siewierz",
	  "Skalbmierz",
	  "Skała",
	  "Skarszewy",
	  "Skaryszew",
	  "Skarżysko-Kamienna",
	  "Skawina",
	  "Skępe",
	  "Skierniewice",
	  "Skoczów",
	  "Skoki",
	  "Skórcz",
	  "Skwierzyna",
	  "Sława",
	  "Sławków",
	  "Sławno",
	  "Słomniki",
	  "Słubice",
	  "Słupca",
	  "Słupsk",
	  "Sobótka",
	  "Sochaczew",
	  "Sokołów Małopolski",
	  "Sokołów Podlaski",
	  "Sokółka",
	  "Solec Kujawski",
	  "Sompolno",
	  "Sopot",
	  "Sosnowiec",
	  "Sośnicowice",
	  "Stalowa Wola",
	  "Starachowice",
	  "Stargard Szczeciński",
	  "Starogard Gdański",
	  "Stary Sącz",
	  "Staszów",
	  "Stawiski",
	  "Stawiszyn",
	  "Stąporków",
	  "Stęszew",
	  "Stoczek Łukowski",
	  "Stronie Śląskie",
	  "Strumień",
	  "Stryków",
	  "Strzegom",
	  "Strzelce Krajeńskie",
	  "Strzelce Opolskie",
	  "Strzelin",
	  "Strzelno",
	  "Strzyżów",
	  "Sucha Beskidzka",
	  "Suchań",
	  "Suchedniów",
	  "Suchowola",
	  "Sulechów",
	  "Sulejów",
	  "Sulejówek",
	  "Sulęcin",
	  "Sulmierzyce",
	  "Sułkowice",
	  "Supraśl",
	  "Suraż",
	  "Susz",
	  "Suwałki",
	  "Swarzędz",
	  "Syców",
	  "Szadek",
	  "Szamocin",
	  "Szamotuły",
	  "Szczawnica",
	  "Szczawno-Zdrój",
	  "Szczebrzeszyn",
	  "Szczecin",
	  "Szczecinek",
	  "Szczekociny",
	  "Szczucin",
	  "Szczuczyn",
	  "Szczyrk",
	  "Szczytna",
	  "Szczytno",
	  "Szepietowo",
	  "Szklarska Poręba",
	  "Szlichtyngowa",
	  "Szprotawa",
	  "Sztum",
	  "Szubin",
	  "Szydłowiec",
	  "Ścinawa",
	  "Ślesin",
	  "Śmigiel",
	  "Śrem",
	  "Środa Śląska",
	  "Środa Wielkopolska",
	  "Świątniki Górne",
	  "Świdnica",
	  "Świdnik",
	  "Świdwin",
	  "Świebodzice",
	  "Świebodzin",
	  "Świecie",
	  "Świeradów-Zdrój",
	  "Świerzawa",
	  "Świętochłowice",
	  "Świnoujście",
	  "Tarczyn",
	  "Tarnobrzeg",
	  "Tarnogród",
	  "Tarnowskie Góry",
	  "Tarnów",
	  "Tczew",
	  "Terespol",
	  "Tłuszcz",
	  "Tolkmicko",
	  "Tomaszów Lubelski",
	  "Tomaszów Mazowiecki",
	  "Toruń",
	  "Torzym",
	  "Toszek",
	  "Trzcianka",
	  "Trzciel",
	  "Trzcińsko-Zdrój",
	  "Trzebiatów",
	  "Trzebinia",
	  "Trzebnica",
	  "Trzemeszno",
	  "Tuchola",
	  "Tuchów",
	  "Tuczno",
	  "Tuliszków",
	  "Turek",
	  "Tuszyn",
	  "Twardogóra",
	  "Tychowo",
	  "Tychy",
	  "Tyczyn",
	  "Tykocin",
	  "Tyszowce",
	  "Ujazd",
	  "Ujście",
	  "Ulanów",
	  "Uniejów",
	  "Ustka",
	  "Ustroń",
	  "Ustrzyki Dolne",
	  "Wadowice",
	  "Wałbrzych",
	  "Wałcz",
	  "Warka",
	  "Warszawa",
	  "Warta",
	  "Wasilków",
	  "Wąbrzeźno",
	  "Wąchock",
	  "Wągrowiec",
	  "Wąsosz",
	  "Wejherowo",
	  "Węgliniec",
	  "Węgorzewo",
	  "Węgorzyno",
	  "Węgrów",
	  "Wiązów",
	  "Wieleń",
	  "Wielichowo",
	  "Wieliczka",
	  "Wieluń",
	  "Wieruszów",
	  "Więcbork",
	  "Wilamowice",
	  "Wisła",
	  "Witkowo",
	  "Witnica",
	  "Wleń",
	  "Władysławowo",
	  "Włocławek",
	  "Włodawa",
	  "Włoszczowa",
	  "Wodzisław Śląski",
	  "Wojcieszów",
	  "Wojkowice",
	  "Wojnicz",
	  "Wolbórz",
	  "Wolbrom",
	  "Wolin",
	  "Wolsztyn",
	  "Wołczyn",
	  "Wołomin",
	  "Wołów",
	  "Woźniki",
	  "Wrocław",
	  "Wronki",
	  "Września",
	  "Wschowa",
	  "Wyrzysk",
	  "Wysoka",
	  "Wysokie Mazowieckie",
	  "Wyszków",
	  "Wyszogród",
	  "Wyśmierzyce",
	  "Zabłudów",
	  "Zabrze",
	  "Zagórów",
	  "Zagórz",
	  "Zakliczyn",
	  "Zakopane",
	  "Zakroczym",
	  "Zalewo",
	  "Zambrów",
	  "Zamość",
	  "Zator",
	  "Zawadzkie",
	  "Zawichost",
	  "Zawidów",
	  "Zawiercie",
	  "Ząbki",
	  "Ząbkowice Śląskie",
	  "Zbąszynek",
	  "Zbąszyń",
	  "Zduny",
	  "Zduńska Wola",
	  "Zdzieszowice",
	  "Zelów",
	  "Zgierz",
	  "Zgorzelec",
	  "Zielona Góra",
	  "Zielonka",
	  "Ziębice",
	  "Złocieniec",
	  "Złoczew",
	  "Złotoryja",
	  "Złotów",
	  "Złoty Stok",
	  "Zwierzyniec",
	  "Zwoleń",
	  "Żabno",
	  "Żagań",
	  "Żarki",
	  "Żarów",
	  "Żary",
	  "Żelechów",
	  "Żerków",
	  "Żmigród",
	  "Żnin",
	  "Żory",
	  "Żukowo",
	  "Żuromin",
	  "Żychlin",
	  "Żyrardów",
	  "Żywiec"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistan",
	  "Albania",
	  "Algieria",
	  "Andora",
	  "Angola",
	  "Antigua i Barbuda",
	  "Arabia Saudyjska",
	  "Argentyna",
	  "Armenia",
	  "Australia",
	  "Austria",
	  "Azerbejdżan",
	  "Bahamy",
	  "Bahrajn",
	  "Bangladesz",
	  "Barbados",
	  "Belgia",
	  "Belize",
	  "Benin",
	  "Bhutan",
	  "Białoruś",
	  "Birma",
	  "Boliwia",
	  "Sucre",
	  "Bośnia i Hercegowina",
	  "Botswana",
	  "Brazylia",
	  "Brunei",
	  "Bułgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Chile",
	  "Chiny",
	  "Chorwacja",
	  "Cypr",
	  "Czad",
	  "Czarnogóra",
	  "Czechy",
	  "Dania",
	  "Demokratyczna Republika Konga",
	  "Dominika",
	  "Dominikana",
	  "Dżibuti",
	  "Egipt",
	  "Ekwador",
	  "Erytrea",
	  "Estonia",
	  "Etiopia",
	  "Fidżi",
	  "Filipiny",
	  "Finlandia",
	  "Francja",
	  "Gabon",
	  "Gambia",
	  "Ghana",
	  "Grecja",
	  "Grenada",
	  "Gruzja",
	  "Gujana",
	  "Gwatemala",
	  "Gwinea",
	  "Gwinea Bissau",
	  "Gwinea Równikowa",
	  "Haiti",
	  "Hiszpania",
	  "Holandia",
	  "Haga",
	  "Honduras",
	  "Indie",
	  "Indonezja",
	  "Irak",
	  "Iran",
	  "Irlandia",
	  "Islandia",
	  "Izrael",
	  "Jamajka",
	  "Japonia",
	  "Jemen",
	  "Jordania",
	  "Kambodża",
	  "Kamerun",
	  "Kanada",
	  "Katar",
	  "Kazachstan",
	  "Kenia",
	  "Kirgistan",
	  "Kiribati",
	  "Kolumbia",
	  "Komory",
	  "Kongo",
	  "Korea Południowa",
	  "Korea Północna",
	  "Kostaryka",
	  "Kuba",
	  "Kuwejt",
	  "Laos",
	  "Lesotho",
	  "Liban",
	  "Liberia",
	  "Libia",
	  "Liechtenstein",
	  "Litwa",
	  "Luksemburg",
	  "Łotwa",
	  "Macedonia",
	  "Madagaskar",
	  "Malawi",
	  "Malediwy",
	  "Malezja",
	  "Mali",
	  "Malta",
	  "Maroko",
	  "Mauretania",
	  "Mauritius",
	  "Meksyk",
	  "Mikronezja",
	  "Mołdawia",
	  "Monako",
	  "Mongolia",
	  "Mozambik",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Niemcy",
	  "Niger",
	  "Nigeria",
	  "Nikaragua",
	  "Norwegia",
	  "Nowa Zelandia",
	  "Oman",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papua-Nowa Gwinea",
	  "Paragwaj",
	  "Peru",
	  "Polska",
	  "322 575",
	  "Portugalia",
	  "Republika Południowej Afryki",
	  "Republika Środkowoafrykańska",
	  "Republika Zielonego Przylądka",
	  "Rosja",
	  "Rumunia",
	  "Rwanda",
	  "Saint Kitts i Nevis",
	  "Saint Lucia",
	  "Saint Vincent i Grenadyny",
	  "Salwador",
	  "Samoa",
	  "San Marino",
	  "Senegal",
	  "Serbia",
	  "Seszele",
	  "Sierra Leone",
	  "Singapur",
	  "Słowacja",
	  "Słowenia",
	  "Somalia",
	  "Sri Lanka",
	  "Stany Zjednoczone",
	  "Suazi",
	  "Sudan",
	  "Sudan Południowy",
	  "Surinam",
	  "Syria",
	  "Szwajcaria",
	  "Szwecja",
	  "Tadżykistan",
	  "Tajlandia",
	  "Tanzania",
	  "Timor Wschodni",
	  "Togo",
	  "Tonga",
	  "Trynidad i Tobago",
	  "Tunezja",
	  "Turcja",
	  "Turkmenistan",
	  "Tuvalu",
	  "Funafuti",
	  "Uganda",
	  "Ukraina",
	  "Urugwaj",
	  2008,
	  "Uzbekistan",
	  "Vanuatu",
	  "Watykan",
	  "Wenezuela",
	  "Węgry",
	  "Wielka Brytania",
	  "Wietnam",
	  "Włochy",
	  "Wybrzeże Kości Słoniowej",
	  "Wyspy Marshalla",
	  "Wyspy Salomona",
	  "Wyspy Świętego Tomasza i Książęca",
	  "Zambia",
	  "Zimbabwe",
	  "Zjednoczone Emiraty Arabskie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Polska"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(1390);
	address.building_number = __webpack_require__(1387);
	address.street_prefix = __webpack_require__(1399);
	address.secondary_address = __webpack_require__(1394);
	address.postcode = __webpack_require__(1393);
	address.state = __webpack_require__(1395);
	address.state_abbr = __webpack_require__(1396);
	address.city_name = __webpack_require__(1389);
	address.city = __webpack_require__(1388);
	address.street_name = __webpack_require__(1398);
	address.street_address = __webpack_require__(1397);
	address.default_country = __webpack_require__(1391);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "##-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Suite ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dolnośląskie",
	  "Kujawsko-pomorskie",
	  "Lubelskie",
	  "Lubuskie",
	  "Łódzkie",
	  "Małopolskie",
	  "Mazowieckie",
	  "Opolskie",
	  "Podkarpackie",
	  "Podlaskie",
	  "Pomorskie",
	  "Śląskie",
	  "Świętokrzyskie",
	  "Warmińsko-mazurskie",
	  "Wielkopolskie",
	  "Zachodniopomorskie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "DŚ",
	  "KP",
	  "LB",
	  "LS",
	  "ŁD",
	  "MP",
	  "MZ",
	  "OP",
	  "PK",
	  "PL",
	  "PM",
	  "ŚL",
	  "ŚK",
	  "WM",
	  "WP",
	  "ZP"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ul.",
	  "al."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "50-###-##-##",
	  "51-###-##-##",
	  "53-###-##-##",
	  "57-###-##-##",
	  "60-###-##-##",
	  "66-###-##-##",
	  "69-###-##-##",
	  "72-###-##-##",
	  "73-###-##-##",
	  "78-###-##-##",
	  "79-###-##-##",
	  "88-###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1400);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1410);
	company.adjetive = __webpack_require__(1402);
	company.descriptor = __webpack_require__(1406);
	company.noun = __webpack_require__(1409);
	company.bs_verb = __webpack_require__(1405);
	company.bs_adjective = __webpack_require__(1403);
	company.bs_noun = __webpack_require__(1404);
	company.name = __webpack_require__(1408);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Inc",
	  "and Sons",
	  "LLC",
	  "Group"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var pl = {};
	module['exports'] = pl;
	pl.title = "Polish";
	pl.name = __webpack_require__(1419);
	pl.address = __webpack_require__(1392);
	pl.company = __webpack_require__(1407);
	pl.internet = __webpack_require__(1414);
	pl.lorem = __webpack_require__(1415);
	pl.phone_number = __webpack_require__(1425);
	pl.cell_phone = __webpack_require__(1401);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "pl",
	  "com.pl",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1413);
	internet.domain_suffix = __webpack_require__(1412);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1417);
	lorem.supplemental = __webpack_require__(1416);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Abraham",
	  "Adam",
	  "Adrian",
	  "Atanazy",
	  "Agaton",
	  "Alan",
	  "Albert",
	  "Aleksander",
	  "Aleksy",
	  "Alfred",
	  "Alwar",
	  "Ambroży",
	  "Anatol",
	  "Andrzej",
	  "Antoni",
	  "Apollinary",
	  "Apollo",
	  "Arkady",
	  "Arkadiusz",
	  "Archibald",
	  "Arystarch",
	  "Arnold",
	  "Arseniusz",
	  "Artur",
	  "August",
	  "Baldwin",
	  "Bazyli",
	  "Benedykt",
	  "Beniamin",
	  "Bernard",
	  "Bertrand",
	  "Bertram",
	  "Borys",
	  "Brajan",
	  "Bruno",
	  "Cezary",
	  "Cecyliusz",
	  "Karol",
	  "Krystian",
	  "Krzysztof",
	  "Klarencjusz",
	  "Klaudiusz",
	  "Klemens",
	  "Konrad",
	  "Konstanty",
	  "Konstantyn",
	  "Kornel",
	  "Korneliusz",
	  "Korneli",
	  "Cyryl",
	  "Cyrus",
	  "Damian",
	  "Daniel",
	  "Dariusz",
	  "Dawid",
	  "Dionizy",
	  "Demetriusz",
	  "Dominik",
	  "Donald",
	  "Dorian",
	  "Edgar",
	  "Edmund",
	  "Edward",
	  "Edwin",
	  "Efrem",
	  "Efraim",
	  "Eliasz",
	  "Eleazar",
	  "Emil",
	  "Emanuel",
	  "Erast",
	  "Ernest",
	  "Eugeniusz",
	  "Eustracjusz",
	  "Fabian",
	  "Feliks",
	  "Florian",
	  "Franciszek",
	  "Fryderyk",
	  "Gabriel",
	  "Gedeon",
	  "Galfryd",
	  "Jerzy",
	  "Gerald",
	  "Gerazym",
	  "Gilbert",
	  "Gonsalwy",
	  "Grzegorz",
	  "Gwido",
	  "Harald",
	  "Henryk",
	  "Herbert",
	  "Herman",
	  "Hilary",
	  "Horacy",
	  "Hubert",
	  "Hugo",
	  "Ignacy",
	  "Igor",
	  "Hilarion",
	  "Innocenty",
	  "Hipolit",
	  "Ireneusz",
	  "Erwin",
	  "Izaak",
	  "Izajasz",
	  "Izydor",
	  "Jakub",
	  "Jeremi",
	  "Jeremiasz",
	  "Hieronim",
	  "Gerald",
	  "Joachim",
	  "Jan",
	  "Janusz",
	  "Jonatan",
	  "Józef",
	  "Jozue",
	  "Julian",
	  "Juliusz",
	  "Justyn",
	  "Kalistrat",
	  "Kazimierz",
	  "Wawrzyniec",
	  "Laurenty",
	  "Laurencjusz",
	  "Łazarz",
	  "Leon",
	  "Leonard",
	  "Leonid",
	  "Leon",
	  "Ludwik",
	  "Łukasz",
	  "Lucjan",
	  "Magnus",
	  "Makary",
	  "Marceli",
	  "Marek",
	  "Marcin",
	  "Mateusz",
	  "Maurycy",
	  "Maksym",
	  "Maksymilian",
	  "Michał",
	  "Miron",
	  "Modest",
	  "Mojżesz",
	  "Natan",
	  "Natanael",
	  "Nazariusz",
	  "Nazary",
	  "Nestor",
	  "Mikołaj",
	  "Nikodem",
	  "Olaf",
	  "Oleg",
	  "Oliwier",
	  "Onufry",
	  "Orestes",
	  "Oskar",
	  "Ansgary",
	  "Osmund",
	  "Pankracy",
	  "Pantaleon",
	  "Patryk",
	  "Patrycjusz",
	  "Patrycy",
	  "Paweł",
	  "Piotr",
	  "Filemon",
	  "Filip",
	  "Platon",
	  "Polikarp",
	  "Porfiry",
	  "Porfiriusz",
	  "Prokles",
	  "Prokul",
	  "Prokop",
	  "Kwintyn",
	  "Randolf",
	  "Rafał",
	  "Rajmund",
	  "Reginald",
	  "Rajnold",
	  "Ryszard",
	  "Robert",
	  "Roderyk",
	  "Roger",
	  "Roland",
	  "Roman",
	  "Romeo",
	  "Reginald",
	  "Rudolf",
	  "Samson",
	  "Samuel",
	  "Salwator",
	  "Sebastian",
	  "Serafin",
	  "Sergiusz",
	  "Seweryn",
	  "Zygmunt",
	  "Sylwester",
	  "Szymon",
	  "Salomon",
	  "Spirydion",
	  "Stanisław",
	  "Szczepan",
	  "Stefan",
	  "Terencjusz",
	  "Teodor",
	  "Tomasz",
	  "Tymoteusz",
	  "Tobiasz",
	  "Walenty",
	  "Walentyn",
	  "Walerian",
	  "Walery",
	  "Wiktor",
	  "Wincenty",
	  "Witalis",
	  "Włodzimierz",
	  "Władysław",
	  "Błażej",
	  "Walter",
	  "Walgierz",
	  "Wacław",
	  "Wilfryd",
	  "Wilhelm",
	  "Ksawery",
	  "Ksenofont",
	  "Jerzy",
	  "Zachariasz",
	  "Zachary",
	  "Ada",
	  "Adelajda",
	  "Agata",
	  "Agnieszka",
	  "Agrypina",
	  "Aida",
	  "Aleksandra",
	  "Alicja",
	  "Alina",
	  "Amanda",
	  "Anastazja",
	  "Angela",
	  "Andżelika",
	  "Angelina",
	  "Anna",
	  "Hanna",
	  "—",
	  "Antonina",
	  "Ariadna",
	  "Aurora",
	  "Barbara",
	  "Beatrycze",
	  "Berta",
	  "Brygida",
	  "Kamila",
	  "Karolina",
	  "Karolina",
	  "Kornelia",
	  "Katarzyna",
	  "Cecylia",
	  "Karolina",
	  "Chloe",
	  "Krystyna",
	  "Klara",
	  "Klaudia",
	  "Klementyna",
	  "Konstancja",
	  "Koralia",
	  "Daria",
	  "Diana",
	  "Dina",
	  "Dorota",
	  "Edyta",
	  "Eleonora",
	  "Eliza",
	  "Elżbieta",
	  "Izabela",
	  "Elwira",
	  "Emilia",
	  "Estera",
	  "Eudoksja",
	  "Eudokia",
	  "Eugenia",
	  "Ewa",
	  "Ewelina",
	  "Ferdynanda",
	  "Florencja",
	  "Franciszka",
	  "Gabriela",
	  "Gertruda",
	  "Gloria",
	  "Gracja",
	  "Jadwiga",
	  "Helena",
	  "Henryka",
	  "Nadzieja",
	  "Ida",
	  "Ilona",
	  "Helena",
	  "Irena",
	  "Irma",
	  "Izabela",
	  "Izolda",
	  "Jakubina",
	  "Joanna",
	  "Janina",
	  "Żaneta",
	  "Joanna",
	  "Ginewra",
	  "Józefina",
	  "Judyta",
	  "Julia",
	  "Julia",
	  "Julita",
	  "Justyna",
	  "Kira",
	  "Cyra",
	  "Kleopatra",
	  "Larysa",
	  "Laura",
	  "Laurencja",
	  "Laurentyna",
	  "Lea",
	  "Leila",
	  "Eleonora",
	  "Liliana",
	  "Lilianna",
	  "Lilia",
	  "Lilla",
	  "Liza",
	  "Eliza",
	  "Laura",
	  "Ludwika",
	  "Luiza",
	  "Łucja",
	  "Lucja",
	  "Lidia",
	  "Amabela",
	  "Magdalena",
	  "Malwina",
	  "Małgorzata",
	  "Greta",
	  "Marianna",
	  "Maryna",
	  "Marta",
	  "Martyna",
	  "Maria",
	  "Matylda",
	  "Maja",
	  "Maja",
	  "Melania",
	  "Michalina",
	  "Monika",
	  "Nadzieja",
	  "Noemi",
	  "Natalia",
	  "Nikola",
	  "Nina",
	  "Olga",
	  "Olimpia",
	  "Oliwia",
	  "Ofelia",
	  "Patrycja",
	  "Paula",
	  "Pelagia",
	  "Penelopa",
	  "Filipa",
	  "Paulina",
	  "Rachela",
	  "Rebeka",
	  "Regina",
	  "Renata",
	  "Rozalia",
	  "Róża",
	  "Roksana",
	  "Rufina",
	  "Ruta",
	  "Sabina",
	  "Sara",
	  "Serafina",
	  "Sybilla",
	  "Sylwia",
	  "Zofia",
	  "Stella",
	  "Stefania",
	  "Zuzanna",
	  "Tamara",
	  "Tacjana",
	  "Tekla",
	  "Teodora",
	  "Teresa",
	  "Walentyna",
	  "Waleria",
	  "Wanesa",
	  "Wiara",
	  "Weronika",
	  "Wiktoria",
	  "Wirginia",
	  "Bibiana",
	  "Bibianna",
	  "Wanda",
	  "Wilhelmina",
	  "Ksawera",
	  "Ksenia",
	  "Zoe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1418);
	name.last_name = __webpack_require__(1420);
	name.prefix = __webpack_require__(1422);
	name.title = __webpack_require__(1423);
	name.name = __webpack_require__(1421);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adamczak",
	  "Adamczyk",
	  "Adamek",
	  "Adamiak",
	  "Adamiec",
	  "Adamowicz",
	  "Adamski",
	  "Adamus",
	  "Aleksandrowicz",
	  "Andrzejczak",
	  "Andrzejewski",
	  "Antczak",
	  "Augustyn",
	  "Augustyniak",
	  "Bagiński",
	  "Balcerzak",
	  "Banach",
	  "Banasiak",
	  "Banasik",
	  "Banaś",
	  "Baran",
	  "Baranowski",
	  "Barański",
	  "Bartczak",
	  "Bartkowiak",
	  "Bartnik",
	  "Bartosik",
	  "Bednarczyk",
	  "Bednarek",
	  "Bednarski",
	  "Bednarz",
	  "Białas",
	  "Białek",
	  "Białkowski",
	  "Bielak",
	  "Bielawski",
	  "Bielecki",
	  "Bielski",
	  "Bieniek",
	  "Biernacki",
	  "Biernat",
	  "Bieńkowski",
	  "Bilski",
	  "Bober",
	  "Bochenek",
	  "Bogucki",
	  "Bogusz",
	  "Borek",
	  "Borkowski",
	  "Borowiec",
	  "Borowski",
	  "Bożek",
	  "Broda",
	  "Brzeziński",
	  "Brzozowski",
	  "Buczek",
	  "Buczkowski",
	  "Buczyński",
	  "Budziński",
	  "Budzyński",
	  "Bujak",
	  "Bukowski",
	  "Burzyński",
	  "Bąk",
	  "Bąkowski",
	  "Błaszczak",
	  "Błaszczyk",
	  "Cebula",
	  "Chmiel",
	  "Chmielewski",
	  "Chmura",
	  "Chojnacki",
	  "Chojnowski",
	  "Cholewa",
	  "Chrzanowski",
	  "Chudzik",
	  "Cichocki",
	  "Cichoń",
	  "Cichy",
	  "Ciesielski",
	  "Cieśla",
	  "Cieślak",
	  "Cieślik",
	  "Ciszewski",
	  "Cybulski",
	  "Cygan",
	  "Czaja",
	  "Czajka",
	  "Czajkowski",
	  "Czapla",
	  "Czarnecki",
	  "Czech",
	  "Czechowski",
	  "Czekaj",
	  "Czerniak",
	  "Czerwiński",
	  "Czyż",
	  "Czyżewski",
	  "Dec",
	  "Dobosz",
	  "Dobrowolski",
	  "Dobrzyński",
	  "Domagała",
	  "Domański",
	  "Dominiak",
	  "Drabik",
	  "Drozd",
	  "Drozdowski",
	  "Drzewiecki",
	  "Dróżdż",
	  "Dubiel",
	  "Duda",
	  "Dudek",
	  "Dudziak",
	  "Dudzik",
	  "Dudziński",
	  "Duszyński",
	  "Dziedzic",
	  "Dziuba",
	  "Dąbek",
	  "Dąbkowski",
	  "Dąbrowski",
	  "Dębowski",
	  "Dębski",
	  "Długosz",
	  "Falkowski",
	  "Fijałkowski",
	  "Filipek",
	  "Filipiak",
	  "Filipowicz",
	  "Flak",
	  "Flis",
	  "Florczak",
	  "Florek",
	  "Frankowski",
	  "Frąckowiak",
	  "Frączek",
	  "Frątczak",
	  "Furman",
	  "Gadomski",
	  "Gajda",
	  "Gajewski",
	  "Gaweł",
	  "Gawlik",
	  "Gawron",
	  "Gawroński",
	  "Gałka",
	  "Gałązka",
	  "Gil",
	  "Godlewski",
	  "Golec",
	  "Gołąb",
	  "Gołębiewski",
	  "Gołębiowski",
	  "Grabowski",
	  "Graczyk",
	  "Grochowski",
	  "Grudzień",
	  "Gruszczyński",
	  "Gruszka",
	  "Grzegorczyk",
	  "Grzelak",
	  "Grzesiak",
	  "Grzesik",
	  "Grześkowiak",
	  "Grzyb",
	  "Grzybowski",
	  "Grzywacz",
	  "Gutowski",
	  "Guzik",
	  "Gwóźdź",
	  "Góra",
	  "Góral",
	  "Górecki",
	  "Górka",
	  "Górniak",
	  "Górny",
	  "Górski",
	  "Gąsior",
	  "Gąsiorowski",
	  "Głogowski",
	  "Głowacki",
	  "Głąb",
	  "Hajduk",
	  "Herman",
	  "Iwański",
	  "Izdebski",
	  "Jabłoński",
	  "Jackowski",
	  "Jagielski",
	  "Jagiełło",
	  "Jagodziński",
	  "Jakubiak",
	  "Jakubowski",
	  "Janas",
	  "Janiak",
	  "Janicki",
	  "Janik",
	  "Janiszewski",
	  "Jankowiak",
	  "Jankowski",
	  "Janowski",
	  "Janus",
	  "Janusz",
	  "Januszewski",
	  "Jaros",
	  "Jarosz",
	  "Jarząbek",
	  "Jasiński",
	  "Jastrzębski",
	  "Jaworski",
	  "Jaśkiewicz",
	  "Jezierski",
	  "Jurek",
	  "Jurkiewicz",
	  "Jurkowski",
	  "Juszczak",
	  "Jóźwiak",
	  "Jóźwik",
	  "Jędrzejczak",
	  "Jędrzejczyk",
	  "Jędrzejewski",
	  "Kacprzak",
	  "Kaczmarczyk",
	  "Kaczmarek",
	  "Kaczmarski",
	  "Kaczor",
	  "Kaczorowski",
	  "Kaczyński",
	  "Kaleta",
	  "Kalinowski",
	  "Kalisz",
	  "Kamiński",
	  "Kania",
	  "Kaniewski",
	  "Kapusta",
	  "Karaś",
	  "Karczewski",
	  "Karpiński",
	  "Karwowski",
	  "Kasperek",
	  "Kasprzak",
	  "Kasprzyk",
	  "Kaszuba",
	  "Kawa",
	  "Kawecki",
	  "Kałuża",
	  "Kaźmierczak",
	  "Kiełbasa",
	  "Kisiel",
	  "Kita",
	  "Klimczak",
	  "Klimek",
	  "Kmiecik",
	  "Kmieć",
	  "Knapik",
	  "Kobus",
	  "Kogut",
	  "Kolasa",
	  "Komorowski",
	  "Konieczna",
	  "Konieczny",
	  "Konopka",
	  "Kopczyński",
	  "Koper",
	  "Kopeć",
	  "Korzeniowski",
	  "Kos",
	  "Kosiński",
	  "Kosowski",
	  "Kostecki",
	  "Kostrzewa",
	  "Kot",
	  "Kotowski",
	  "Kowal",
	  "Kowalczuk",
	  "Kowalczyk",
	  "Kowalewski",
	  "Kowalik",
	  "Kowalski",
	  "Koza",
	  "Kozak",
	  "Kozieł",
	  "Kozioł",
	  "Kozłowski",
	  "Kołakowski",
	  "Kołodziej",
	  "Kołodziejczyk",
	  "Kołodziejski",
	  "Krajewski",
	  "Krakowiak",
	  "Krawczyk",
	  "Krawiec",
	  "Kruk",
	  "Krukowski",
	  "Krupa",
	  "Krupiński",
	  "Kruszewski",
	  "Krysiak",
	  "Krzemiński",
	  "Krzyżanowski",
	  "Król",
	  "Królikowski",
	  "Książek",
	  "Kubacki",
	  "Kubiak",
	  "Kubica",
	  "Kubicki",
	  "Kubik",
	  "Kuc",
	  "Kucharczyk",
	  "Kucharski",
	  "Kuchta",
	  "Kuciński",
	  "Kuczyński",
	  "Kujawa",
	  "Kujawski",
	  "Kula",
	  "Kulesza",
	  "Kulig",
	  "Kulik",
	  "Kuliński",
	  "Kurek",
	  "Kurowski",
	  "Kuś",
	  "Kwaśniewski",
	  "Kwiatkowski",
	  "Kwiecień",
	  "Kwieciński",
	  "Kędzierski",
	  "Kędziora",
	  "Kępa",
	  "Kłos",
	  "Kłosowski",
	  "Lach",
	  "Laskowski",
	  "Lasota",
	  "Lech",
	  "Lenart",
	  "Lesiak",
	  "Leszczyński",
	  "Lewandowski",
	  "Lewicki",
	  "Leśniak",
	  "Leśniewski",
	  "Lipiński",
	  "Lipka",
	  "Lipski",
	  "Lis",
	  "Lisiecki",
	  "Lisowski",
	  "Maciejewski",
	  "Maciąg",
	  "Mackiewicz",
	  "Madej",
	  "Maj",
	  "Majcher",
	  "Majchrzak",
	  "Majewski",
	  "Majka",
	  "Makowski",
	  "Malec",
	  "Malicki",
	  "Malinowski",
	  "Maliszewski",
	  "Marchewka",
	  "Marciniak",
	  "Marcinkowski",
	  "Marczak",
	  "Marek",
	  "Markiewicz",
	  "Markowski",
	  "Marszałek",
	  "Marzec",
	  "Masłowski",
	  "Matusiak",
	  "Matuszak",
	  "Matuszewski",
	  "Matysiak",
	  "Mazur",
	  "Mazurek",
	  "Mazurkiewicz",
	  "Maćkowiak",
	  "Małecki",
	  "Małek",
	  "Maślanka",
	  "Michalak",
	  "Michalczyk",
	  "Michalik",
	  "Michalski",
	  "Michałek",
	  "Michałowski",
	  "Mielczarek",
	  "Mierzejewski",
	  "Mika",
	  "Mikołajczak",
	  "Mikołajczyk",
	  "Mikulski",
	  "Milczarek",
	  "Milewski",
	  "Miller",
	  "Misiak",
	  "Misztal",
	  "Miśkiewicz",
	  "Modzelewski",
	  "Molenda",
	  "Morawski",
	  "Motyka",
	  "Mroczek",
	  "Mroczkowski",
	  "Mrozek",
	  "Mróz",
	  "Mucha",
	  "Murawski",
	  "Musiał",
	  "Muszyński",
	  "Młynarczyk",
	  "Napierała",
	  "Nawrocki",
	  "Nawrot",
	  "Niedziela",
	  "Niedzielski",
	  "Niedźwiecki",
	  "Niemczyk",
	  "Niemiec",
	  "Niewiadomski",
	  "Noga",
	  "Nowacki",
	  "Nowaczyk",
	  "Nowak",
	  "Nowakowski",
	  "Nowicki",
	  "Nowiński",
	  "Olczak",
	  "Olejniczak",
	  "Olejnik",
	  "Olszewski",
	  "Orzechowski",
	  "Orłowski",
	  "Osiński",
	  "Ossowski",
	  "Ostrowski",
	  "Owczarek",
	  "Paczkowski",
	  "Pająk",
	  "Pakuła",
	  "Paluch",
	  "Panek",
	  "Partyka",
	  "Pasternak",
	  "Paszkowski",
	  "Pawelec",
	  "Pawlak",
	  "Pawlicki",
	  "Pawlik",
	  "Pawlikowski",
	  "Pawłowski",
	  "Pałka",
	  "Piasecki",
	  "Piechota",
	  "Piekarski",
	  "Pietras",
	  "Pietruszka",
	  "Pietrzak",
	  "Pietrzyk",
	  "Pilarski",
	  "Pilch",
	  "Piotrowicz",
	  "Piotrowski",
	  "Piwowarczyk",
	  "Piórkowski",
	  "Piątek",
	  "Piątkowski",
	  "Piłat",
	  "Pluta",
	  "Podgórski",
	  "Polak",
	  "Popławski",
	  "Porębski",
	  "Prokop",
	  "Prus",
	  "Przybylski",
	  "Przybysz",
	  "Przybył",
	  "Przybyła",
	  "Ptak",
	  "Puchalski",
	  "Pytel",
	  "Płonka",
	  "Raczyński",
	  "Radecki",
	  "Radomski",
	  "Rak",
	  "Rakowski",
	  "Ratajczak",
	  "Robak",
	  "Rogala",
	  "Rogalski",
	  "Rogowski",
	  "Rojek",
	  "Romanowski",
	  "Rosa",
	  "Rosiak",
	  "Rosiński",
	  "Ruciński",
	  "Rudnicki",
	  "Rudziński",
	  "Rudzki",
	  "Rusin",
	  "Rutkowski",
	  "Rybak",
	  "Rybarczyk",
	  "Rybicki",
	  "Rzepka",
	  "Różański",
	  "Różycki",
	  "Sadowski",
	  "Sawicki",
	  "Serafin",
	  "Siedlecki",
	  "Sienkiewicz",
	  "Sieradzki",
	  "Sikora",
	  "Sikorski",
	  "Sitek",
	  "Siwek",
	  "Skalski",
	  "Skiba",
	  "Skibiński",
	  "Skoczylas",
	  "Skowron",
	  "Skowronek",
	  "Skowroński",
	  "Skrzypczak",
	  "Skrzypek",
	  "Skóra",
	  "Smoliński",
	  "Sobczak",
	  "Sobczyk",
	  "Sobieraj",
	  "Sobolewski",
	  "Socha",
	  "Sochacki",
	  "Sokołowski",
	  "Sokół",
	  "Sosnowski",
	  "Sowa",
	  "Sowiński",
	  "Sołtys",
	  "Sołtysiak",
	  "Sroka",
	  "Stachowiak",
	  "Stachowicz",
	  "Stachura",
	  "Stachurski",
	  "Stanek",
	  "Staniszewski",
	  "Stanisławski",
	  "Stankiewicz",
	  "Stasiak",
	  "Staszewski",
	  "Stawicki",
	  "Stec",
	  "Stefaniak",
	  "Stefański",
	  "Stelmach",
	  "Stolarczyk",
	  "Stolarski",
	  "Strzelczyk",
	  "Strzelecki",
	  "Stępień",
	  "Stępniak",
	  "Surma",
	  "Suski",
	  "Szafrański",
	  "Szatkowski",
	  "Szczepaniak",
	  "Szczepanik",
	  "Szczepański",
	  "Szczerba",
	  "Szcześniak",
	  "Szczygieł",
	  "Szczęsna",
	  "Szczęsny",
	  "Szeląg",
	  "Szewczyk",
	  "Szostak",
	  "Szulc",
	  "Szwarc",
	  "Szwed",
	  "Szydłowski",
	  "Szymański",
	  "Szymczak",
	  "Szymczyk",
	  "Szymkowiak",
	  "Szyszka",
	  "Sławiński",
	  "Słowik",
	  "Słowiński",
	  "Tarnowski",
	  "Tkaczyk",
	  "Tokarski",
	  "Tomala",
	  "Tomaszewski",
	  "Tomczak",
	  "Tomczyk",
	  "Tracz",
	  "Trojanowski",
	  "Trzciński",
	  "Trzeciak",
	  "Turek",
	  "Twardowski",
	  "Urban",
	  "Urbanek",
	  "Urbaniak",
	  "Urbanowicz",
	  "Urbańczyk",
	  "Urbański",
	  "Walczak",
	  "Walkowiak",
	  "Warchoł",
	  "Wasiak",
	  "Wasilewski",
	  "Wawrzyniak",
	  "Wesołowski",
	  "Wieczorek",
	  "Wierzbicki",
	  "Wilczek",
	  "Wilczyński",
	  "Wilk",
	  "Winiarski",
	  "Witczak",
	  "Witek",
	  "Witkowski",
	  "Wiącek",
	  "Więcek",
	  "Więckowski",
	  "Wiśniewski",
	  "Wnuk",
	  "Wojciechowski",
	  "Wojtas",
	  "Wojtasik",
	  "Wojtczak",
	  "Wojtkowiak",
	  "Wolak",
	  "Woliński",
	  "Wolny",
	  "Wolski",
	  "Woś",
	  "Woźniak",
	  "Wrona",
	  "Wroński",
	  "Wróbel",
	  "Wróblewski",
	  "Wypych",
	  "Wysocki",
	  "Wyszyński",
	  "Wójcicki",
	  "Wójcik",
	  "Wójtowicz",
	  "Wąsik",
	  "Węgrzyn",
	  "Włodarczyk",
	  "Włodarski",
	  "Zaborowski",
	  "Zabłocki",
	  "Zagórski",
	  "Zając",
	  "Zajączkowski",
	  "Zakrzewski",
	  "Zalewski",
	  "Zaremba",
	  "Zarzycki",
	  "Zaręba",
	  "Zawada",
	  "Zawadzki",
	  "Zdunek",
	  "Zieliński",
	  "Zielonka",
	  "Ziółkowski",
	  "Zięba",
	  "Ziętek",
	  "Zwoliński",
	  "Zych",
	  "Zygmunt",
	  "Łapiński",
	  "Łuczak",
	  "Łukasiewicz",
	  "Łukasik",
	  "Łukaszewski",
	  "Śliwa",
	  "Śliwiński",
	  "Ślusarczyk",
	  "Świderski",
	  "Świerczyński",
	  "Świątek",
	  "Żak",
	  "Żebrowski",
	  "Żmuda",
	  "Żuk",
	  "Żukowski",
	  "Żurawski",
	  "Żurek",
	  "Żyła"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pan",
	  "Pani"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "12-###-##-##",
	  "13-###-##-##",
	  "14-###-##-##",
	  "15-###-##-##",
	  "16-###-##-##",
	  "17-###-##-##",
	  "18-###-##-##",
	  "22-###-##-##",
	  "23-###-##-##",
	  "24-###-##-##",
	  "25-###-##-##",
	  "29-###-##-##",
	  "32-###-##-##",
	  "33-###-##-##",
	  "34-###-##-##",
	  "41-###-##-##",
	  "42-###-##-##",
	  "43-###-##-##",
	  "44-###-##-##",
	  "46-###-##-##",
	  "48-###-##-##",
	  "52-###-##-##",
	  "54-###-##-##",
	  "55-###-##-##",
	  "56-###-##-##",
	  "58-###-##-##",
	  "59-###-##-##",
	  "61-###-##-##",
	  "62-###-##-##",
	  "63-###-##-##",
	  "65-###-##-##",
	  "67-###-##-##",
	  "68-###-##-##",
	  "71-###-##-##",
	  "74-###-##-##",
	  "75-###-##-##",
	  "76-###-##-##",
	  "77-###-##-##",
	  "81-###-##-##",
	  "82-###-##-##",
	  "83-###-##-##",
	  "84-###-##-##",
	  "85-###-##-##",
	  "86-###-##-##",
	  "87-###-##-##",
	  "89-###-##-##",
	  "91-###-##-##",
	  "94-###-##-##",
	  "95-###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1424);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nova",
	  "Velha",
	  "Grande",
	  "Vila",
	  "Município de"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "do Descoberto",
	  "de Nossa Senhora",
	  "do Norte",
	  "do Sul"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afeganistão",
	  "Albânia",
	  "Algéria",
	  "Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antigua and Barbada",
	  "Argentina",
	  "Armênia",
	  "Aruba",
	  "Austrália",
	  "Áustria",
	  "Alzerbajão",
	  "Bahamas",
	  "Barém",
	  "Bangladesh",
	  "Barbado",
	  "Belgrado",
	  "Bélgica",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolívia",
	  "Bôsnia",
	  "Botuasuna",
	  "Bouvetoia",
	  "Brasil",
	  "Arquipélago de Chagos",
	  "Ilhas Virgens",
	  "Brunei",
	  "Bulgária",
	  "Burkina Faso",
	  "Burundi",
	  "Cambójia",
	  "Camarões",
	  "Canadá",
	  "Cabo Verde",
	  "Ilhas Caiman",
	  "República da África Central",
	  "Chad",
	  "Chile",
	  "China",
	  "Ilhas Natal",
	  "Ilhas Cocos",
	  "Colômbia",
	  "Comoros",
	  "Congo",
	  "Ilhas Cook",
	  "Costa Rica",
	  "Costa do Marfim",
	  "Croácia",
	  "Cuba",
	  "Cyprus",
	  "República Tcheca",
	  "Dinamarca",
	  "Djibouti",
	  "Dominica",
	  "República Dominicana",
	  "Equador",
	  "Egito",
	  "El Salvador",
	  "Guiné Equatorial",
	  "Eritrea",
	  "Estônia",
	  "Etiópia",
	  "Ilhas Faroe",
	  "Malvinas",
	  "Fiji",
	  "Finlândia",
	  "França",
	  "Guiné Francesa",
	  "Polinésia Francesa",
	  "Gabão",
	  "Gâmbia",
	  "Georgia",
	  "Alemanha",
	  "Gana",
	  "Gibraltar",
	  "Grécia",
	  "Groelândia",
	  "Granada",
	  "Guadalupe",
	  "Guano",
	  "Guatemala",
	  "Guernsey",
	  "Guiné",
	  "Guiné-Bissau",
	  "Guiana",
	  "Haiti",
	  "Heard Island and McDonald Islands",
	  "Vaticano",
	  "Honduras",
	  "Hong Kong",
	  "Hungria",
	  "Iceland",
	  "Índia",
	  "Indonésia",
	  "Irã",
	  "Iraque",
	  "Irlanda",
	  "Ilha de Man",
	  "Israel",
	  "Itália",
	  "Jamaica",
	  "Japão",
	  "Jersey",
	  "Jordânia",
	  "Cazaquistão",
	  "Quênia",
	  "Kiribati",
	  "Coreia do Norte",
	  "Coreia do Sul",
	  "Kuwait",
	  "Kyrgyz Republic",
	  "República Democrática de Lao People",
	  "Latvia",
	  "Líbano",
	  "Lesotho",
	  "Libéria",
	  "Libyan Arab Jamahiriya",
	  "Liechtenstein",
	  "Lituânia",
	  "Luxemburgo",
	  "Macao",
	  "Macedônia",
	  "Madagascar",
	  "Malawi",
	  "Malásia",
	  "Maldives",
	  "Mali",
	  "Malta",
	  "Ilhas Marshall",
	  "Martinica",
	  "Mauritânia",
	  "Mauritius",
	  "Mayotte",
	  "México",
	  "Micronésia",
	  "Moldova",
	  "Mônaco",
	  "Mongólia",
	  "Montenegro",
	  "Montserrat",
	  "Marrocos",
	  "Moçambique",
	  "Myanmar",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Antilhas Holandesas",
	  "Holanda",
	  "Nova Caledonia",
	  "Nova Zelândia",
	  "Nicarágua",
	  "Nigéria",
	  "Niue",
	  "Ilha Norfolk",
	  "Northern Mariana Islands",
	  "Noruega",
	  "Oman",
	  "Paquistão",
	  "Palau",
	  "Território da Palestina",
	  "Panamá",
	  "Nova Guiné Papua",
	  "Paraguai",
	  "Peru",
	  "Filipinas",
	  "Polônia",
	  "Portugal",
	  "Puerto Rico",
	  "Qatar",
	  "Romênia",
	  "Rússia",
	  "Ruanda",
	  "São Bartolomeu",
	  "Santa Helena",
	  "Santa Lúcia",
	  "Saint Martin",
	  "Saint Pierre and Miquelon",
	  "Saint Vincent and the Grenadines",
	  "Samoa",
	  "San Marino",
	  "Sao Tomé e Príncipe",
	  "Arábia Saudita",
	  "Senegal",
	  "Sérvia",
	  "Seychelles",
	  "Serra Leoa",
	  "Singapura",
	  "Eslováquia",
	  "Eslovênia",
	  "Ilhas Salomão",
	  "Somália",
	  "África do Sul",
	  "South Georgia and the South Sandwich Islands",
	  "Spanha",
	  "Sri Lanka",
	  "Sudão",
	  "Suriname",
	  "Svalbard & Jan Mayen Islands",
	  "Swaziland",
	  "Suécia",
	  "Suíça",
	  "Síria",
	  "Taiwan",
	  "Tajiquistão",
	  "Tanzânia",
	  "Tailândia",
	  "Timor-Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidá e Tobago",
	  "Tunísia",
	  "Turquia",
	  "Turcomenistão",
	  "Turks and Caicos Islands",
	  "Tuvalu",
	  "Uganda",
	  "Ucrânia",
	  "Emirados Árabes Unidos",
	  "Reino Unido",
	  "Estados Unidos da América",
	  "Estados Unidos das Ilhas Virgens",
	  "Uruguai",
	  "Uzbequistão",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnã",
	  "Wallis and Futuna",
	  "Sahara",
	  "Yemen",
	  "Zâmbia",
	  "Zimbábue"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Brasil"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1427);
	address.city_suffix = __webpack_require__(1428);
	address.country = __webpack_require__(1429);
	address.building_number = __webpack_require__(1426);
	address.street_suffix = __webpack_require__(1436);
	address.secondary_address = __webpack_require__(1433);
	address.postcode = __webpack_require__(1432);
	address.state = __webpack_require__(1434);
	address.state_abbr = __webpack_require__(1435);
	address.default_country = __webpack_require__(1430);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apto. ###",
	  "Sobrado ##",
	  "Casa #",
	  "Lote ##",
	  "Quadra ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Acre",
	  "Alagoas",
	  "Amapá",
	  "Amazonas",
	  "Bahia",
	  "Ceará",
	  "Distrito Federal",
	  "Espírito Santo",
	  "Goiás",
	  "Maranhão",
	  "Mato Grosso",
	  "Mato Grosso do Sul",
	  "Minas Gerais",
	  "Pará",
	  "Paraíba",
	  "Paraná",
	  "Pernambuco",
	  "Piauí",
	  "Rio de Janeiro",
	  "Rio Grande do Norte",
	  "Rio Grande do Sul",
	  "Rondônia",
	  "Roraima",
	  "Santa Catarina",
	  "São Paulo",
	  "Sergipe",
	  "Tocantins"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AC",
	  "AL",
	  "AP",
	  "AM",
	  "BA",
	  "CE",
	  "DF",
	  "ES",
	  "GO",
	  "MA",
	  "MT",
	  "MS",
	  "PA",
	  "PB",
	  "PR",
	  "PE",
	  "PI",
	  "RJ",
	  "RN",
	  "RS",
	  "RO",
	  "RR",
	  "SC",
	  "SP"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Rua",
	  "Avenida",
	  "Travessa",
	  "Ponte",
	  "Alameda",
	  "Marginal",
	  "Viela",
	  "Rodovia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1439);
	company.name = __webpack_require__(1438);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} e #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.A.",
	  "LTDA",
	  "e Associados",
	  "Comércio"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var pt_BR = {};
	module['exports'] = pt_BR;
	pt_BR.title = "Portuguese (Brazil)";
	pt_BR.address = __webpack_require__(1431);
	pt_BR.company = __webpack_require__(1437);
	pt_BR.internet = __webpack_require__(1443);
	pt_BR.lorem = __webpack_require__(1444);
	pt_BR.name = __webpack_require__(1447);
	pt_BR.phone_number = __webpack_require__(1452);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "br",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com",
	  "live.com",
	  "bol.com.br"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1442);
	internet.domain_suffix = __webpack_require__(1441);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1445);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alessandro",
	  "Alessandra",
	  "Alexandre",
	  "Aline",
	  "Antônio",
	  "Breno",
	  "Bruna",
	  "Carlos",
	  "Carla",
	  "Célia",
	  "Cecília",
	  "César",
	  "Danilo",
	  "Dalila",
	  "Deneval",
	  "Eduardo",
	  "Eduarda",
	  "Esther",
	  "Elísio",
	  "Fábio",
	  "Fabrício",
	  "Fabrícia",
	  "Félix",
	  "Felícia",
	  "Feliciano",
	  "Frederico",
	  "Fabiano",
	  "Gustavo",
	  "Guilherme",
	  "Gúbio",
	  "Heitor",
	  "Hélio",
	  "Hugo",
	  "Isabel",
	  "Isabela",
	  "Ígor",
	  "João",
	  "Joana",
	  "Júlio César",
	  "Júlio",
	  "Júlia",
	  "Janaína",
	  "Karla",
	  "Kléber",
	  "Lucas",
	  "Lorena",
	  "Lorraine",
	  "Larissa",
	  "Ladislau",
	  "Marcos",
	  "Meire",
	  "Marcelo",
	  "Marcela",
	  "Margarida",
	  "Mércia",
	  "Márcia",
	  "Marli",
	  "Morgana",
	  "Maria",
	  "Norberto",
	  "Natália",
	  "Nataniel",
	  "Núbia",
	  "Ofélia",
	  "Paulo",
	  "Paula",
	  "Pablo",
	  "Pedro",
	  "Raul",
	  "Rafael",
	  "Rafaela",
	  "Ricardo",
	  "Roberto",
	  "Roberta",
	  "Sílvia",
	  "Sílvia",
	  "Silas",
	  "Suélen",
	  "Sara",
	  "Salvador",
	  "Sirineu",
	  "Talita",
	  "Tertuliano",
	  "Vicente",
	  "Víctor",
	  "Vitória",
	  "Yango",
	  "Yago",
	  "Yuri",
	  "Washington",
	  "Warley"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1446);
	name.last_name = __webpack_require__(1448);
	name.prefix = __webpack_require__(1449);
	name.suffix = __webpack_require__(1450);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Silva",
	  "Souza",
	  "Carvalho",
	  "Santos",
	  "Reis",
	  "Xavier",
	  "Franco",
	  "Braga",
	  "Macedo",
	  "Batista",
	  "Barros",
	  "Moraes",
	  "Costa",
	  "Pereira",
	  "Carvalho",
	  "Melo",
	  "Saraiva",
	  "Nogueira",
	  "Oliveira",
	  "Martins",
	  "Moreira",
	  "Albuquerque"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sr.",
	  "Sra.",
	  "Srta.",
	  "Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Neto",
	  "Filho"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(##) ####-####",
	  "+55 (##) ####-####",
	  "(##) #####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1451);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Москва",
	  "Владимир",
	  "Санкт-Петербург",
	  "Новосибирск",
	  "Екатеринбург",
	  "Нижний Новгород",
	  "Самара",
	  "Казань",
	  "Омск",
	  "Челябинск",
	  "Ростов-на-Дону",
	  "Уфа",
	  "Волгоград",
	  "Пермь",
	  "Красноярск",
	  "Воронеж",
	  "Саратов",
	  "Краснодар",
	  "Тольятти",
	  "Ижевск",
	  "Барнаул",
	  "Ульяновск",
	  "Тюмень",
	  "Иркутск",
	  "Владивосток",
	  "Ярославль",
	  "Хабаровск",
	  "Махачкала",
	  "Оренбург",
	  "Новокузнецк",
	  "Томск",
	  "Кемерово",
	  "Рязань",
	  "Астрахань",
	  "Пенза",
	  "Липецк",
	  "Тула",
	  "Киров",
	  "Чебоксары",
	  "Курск",
	  "Брянскm Магнитогорск",
	  "Иваново",
	  "Тверь",
	  "Ставрополь",
	  "Белгород",
	  "Сочи"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Австралия",
	  "Австрия",
	  "Азербайджан",
	  "Албания",
	  "Алжир",
	  "Американское Самоа (не признана)",
	  "Ангилья",
	  "Ангола",
	  "Андорра",
	  "Антарктика (не признана)",
	  "Антигуа и Барбуда",
	  "Антильские Острова (не признана)",
	  "Аомынь (не признана)",
	  "Аргентина",
	  "Армения",
	  "Афганистан",
	  "Багамские Острова",
	  "Бангладеш",
	  "Барбадос",
	  "Бахрейн",
	  "Беларусь",
	  "Белиз",
	  "Бельгия",
	  "Бенин",
	  "Болгария",
	  "Боливия",
	  "Босния и Герцеговина",
	  "Ботсвана",
	  "Бразилия",
	  "Бруней",
	  "Буркина-Фасо",
	  "Бурунди",
	  "Бутан",
	  "Вануату",
	  "Ватикан",
	  "Великобритания",
	  "Венгрия",
	  "Венесуэла",
	  "Восточный Тимор",
	  "Вьетнам",
	  "Габон",
	  "Гаити",
	  "Гайана",
	  "Гамбия",
	  "Гана",
	  "Гваделупа (не признана)",
	  "Гватемала",
	  "Гвиана (не признана)",
	  "Гвинея",
	  "Гвинея-Бисау",
	  "Германия",
	  "Гондурас",
	  "Гренада",
	  "Греция",
	  "Грузия",
	  "Дания",
	  "Джибути",
	  "Доминика",
	  "Доминиканская Республика",
	  "Египет",
	  "Замбия",
	  "Зимбабве",
	  "Израиль",
	  "Индия",
	  "Индонезия",
	  "Иордания",
	  "Ирак",
	  "Иран",
	  "Ирландия",
	  "Исландия",
	  "Испания",
	  "Италия",
	  "Йемен",
	  "Кабо-Верде",
	  "Казахстан",
	  "Камбоджа",
	  "Камерун",
	  "Канада",
	  "Катар",
	  "Кения",
	  "Кипр",
	  "Кирибати",
	  "Китай",
	  "Колумбия",
	  "Коморские Острова",
	  "Конго",
	  "Демократическая Республика",
	  "Корея (Северная)",
	  "Корея (Южная)",
	  "Косово",
	  "Коста-Рика",
	  "Кот-д'Ивуар",
	  "Куба",
	  "Кувейт",
	  "Кука острова",
	  "Кыргызстан",
	  "Лаос",
	  "Латвия",
	  "Лесото",
	  "Либерия",
	  "Ливан",
	  "Ливия",
	  "Литва",
	  "Лихтенштейн",
	  "Люксембург",
	  "Маврикий",
	  "Мавритания",
	  "Мадагаскар",
	  "Македония",
	  "Малави",
	  "Малайзия",
	  "Мали",
	  "Мальдивы",
	  "Мальта",
	  "Маршалловы Острова",
	  "Мексика",
	  "Микронезия",
	  "Мозамбик",
	  "Молдова",
	  "Монако",
	  "Монголия",
	  "Марокко",
	  "Мьянма",
	  "Намибия",
	  "Науру",
	  "Непал",
	  "Нигер",
	  "Нигерия",
	  "Нидерланды",
	  "Никарагуа",
	  "Новая Зеландия",
	  "Норвегия",
	  "Объединенные Арабские Эмираты",
	  "Оман",
	  "Пакистан",
	  "Палау",
	  "Панама",
	  "Папуа — Новая Гвинея",
	  "Парагвай",
	  "Перу",
	  "Польша",
	  "Португалия",
	  "Республика Конго",
	  "Россия",
	  "Руанда",
	  "Румыния",
	  "Сальвадор",
	  "Самоа",
	  "Сан-Марино",
	  "Сан-Томе и Принсипи",
	  "Саудовская Аравия",
	  "Свазиленд",
	  "Сейшельские острова",
	  "Сенегал",
	  "Сент-Винсент и Гренадины",
	  "Сент-Киттс и Невис",
	  "Сент-Люсия",
	  "Сербия",
	  "Сингапур",
	  "Сирия",
	  "Словакия",
	  "Словения",
	  "Соединенные Штаты Америки",
	  "Соломоновы Острова",
	  "Сомали",
	  "Судан",
	  "Суринам",
	  "Сьерра-Леоне",
	  "Таджикистан",
	  "Таиланд",
	  "Тайвань (не признана)",
	  "Тамил-Илам (не признана)",
	  "Танзания",
	  "Тёркс и Кайкос (не признана)",
	  "Того",
	  "Токелау (не признана)",
	  "Тонга",
	  "Тринидад и Тобаго",
	  "Тувалу",
	  "Тунис",
	  "Турецкая Республика Северного Кипра (не признана)",
	  "Туркменистан",
	  "Турция",
	  "Уганда",
	  "Узбекистан",
	  "Украина",
	  "Уругвай",
	  "Фарерские Острова (не признана)",
	  "Фиджи",
	  "Филиппины",
	  "Финляндия",
	  "Франция",
	  "Французская Полинезия (не признана)",
	  "Хорватия",
	  "Центральноафриканская Республика",
	  "Чад",
	  "Черногория",
	  "Чехия",
	  "Чили",
	  "Швейцария",
	  "Швеция",
	  "Шри-Ланка",
	  "Эквадор",
	  "Экваториальная Гвинея",
	  "Эритрея",
	  "Эстония",
	  "Эфиопия",
	  "Южно-Африканская Республика",
	  "Ямайка",
	  "Япония"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Россия"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(1456);
	address.building_number = __webpack_require__(1453);
	address.street_suffix = __webpack_require__(1464);
	address.secondary_address = __webpack_require__(1460);
	address.postcode = __webpack_require__(1459);
	address.state = __webpack_require__(1461);
	address.street_title = __webpack_require__(1465);
	address.city_name = __webpack_require__(1455);
	address.city = __webpack_require__(1454);
	address.street_name = __webpack_require__(1463);
	address.street_address = __webpack_require__(1462);
	address.default_country = __webpack_require__(1457);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "кв. ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Республика Адыгея",
	  "Республика Башкортостан",
	  "Республика Бурятия",
	  "Республика Алтай Республика Дагестан",
	  "Республика Ингушетия",
	  "Кабардино-Балкарская Республика",
	  "Республика Калмыкия",
	  "Республика Карачаево-Черкессия",
	  "Республика Карелия",
	  "Республика Коми",
	  "Республика Марий Эл",
	  "Республика Мордовия",
	  "Республика Саха (Якутия)",
	  "Республика Северная Осетия-Алания",
	  "Республика Татарстан",
	  "Республика Тыва",
	  "Удмуртская Республика",
	  "Республика Хакасия",
	  "Чувашская Республика",
	  "Алтайский край",
	  "Краснодарский край",
	  "Красноярский край",
	  "Приморский край",
	  "Ставропольский край",
	  "Хабаровский край",
	  "Амурская область",
	  "Архангельская область",
	  "Астраханская область",
	  "Белгородская область",
	  "Брянская область",
	  "Владимирская область",
	  "Волгоградская область",
	  "Вологодская область",
	  "Воронежская область",
	  "Ивановская область",
	  "Иркутская область",
	  "Калиниградская область",
	  "Калужская область",
	  "Камчатская область",
	  "Кемеровская область",
	  "Кировская область",
	  "Костромская область",
	  "Курганская область",
	  "Курская область",
	  "Ленинградская область",
	  "Липецкая область",
	  "Магаданская область",
	  "Московская область",
	  "Мурманская область",
	  "Нижегородская область",
	  "Новгородская область",
	  "Новосибирская область",
	  "Омская область",
	  "Оренбургская область",
	  "Орловская область",
	  "Пензенская область",
	  "Пермская область",
	  "Псковская область",
	  "Ростовская область",
	  "Рязанская область",
	  "Самарская область",
	  "Саратовская область",
	  "Сахалинская область",
	  "Свердловская область",
	  "Смоленская область",
	  "Тамбовская область",
	  "Тверская область",
	  "Томская область",
	  "Тульская область",
	  "Тюменская область",
	  "Ульяновская область",
	  "Челябинская область",
	  "Читинская область",
	  "Ярославская область",
	  "Еврейская автономная область",
	  "Агинский Бурятский авт. округ",
	  "Коми-Пермяцкий автономный округ",
	  "Корякский автономный округ",
	  "Ненецкий автономный округ",
	  "Таймырский (Долгано-Ненецкий) автономный округ",
	  "Усть-Ордынский Бурятский автономный округ",
	  "Ханты-Мансийский автономный округ",
	  "Чукотский автономный округ",
	  "Эвенкийский автономный округ",
	  "Ямало-Ненецкий автономный округ",
	  "Чеченская Республика"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}, #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Address.street_title}",
	  "#{Address.street_title} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ул.",
	  "улица",
	  "проспект",
	  "пр.",
	  "площадь",
	  "пл."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Советская",
	  "Молодежная",
	  "Центральная",
	  "Школьная",
	  "Новая",
	  "Садовая",
	  "Лесная",
	  "Набережная",
	  "Ленина",
	  "Мира",
	  "Октябрьская",
	  "Зеленая",
	  "Комсомольская",
	  "Заречная",
	  "Первомайская",
	  "Гагарина",
	  "Полевая",
	  "Луговая",
	  "Пионерская",
	  "Кирова",
	  "Юбилейная",
	  "Северная",
	  "Пролетарская",
	  "Степная",
	  "Пушкина",
	  "Калинина",
	  "Южная",
	  "Колхозная",
	  "Рабочая",
	  "Солнечная",
	  "Железнодорожная",
	  "Восточная",
	  "Заводская",
	  "Чапаева",
	  "Нагорная",
	  "Строителей",
	  "Береговая",
	  "Победы",
	  "Горького",
	  "Кооперативная",
	  "Красноармейская",
	  "Совхозная",
	  "Речная",
	  "Школьный",
	  "Спортивная",
	  "Озерная",
	  "Строительная",
	  "Парковая",
	  "Чкалова",
	  "Мичурина",
	  "речень улиц",
	  "Подгорная",
	  "Дружбы",
	  "Почтовая",
	  "Партизанская",
	  "Вокзальная",
	  "Лермонтова",
	  "Свободы",
	  "Дорожная",
	  "Дачная",
	  "Маяковского",
	  "Западная",
	  "Фрунзе",
	  "Дзержинского",
	  "Московская",
	  "Свердлова",
	  "Некрасова",
	  "Гоголя",
	  "Красная",
	  "Трудовая",
	  "Шоссейная",
	  "Чехова",
	  "Коммунистическая",
	  "Труда",
	  "Комарова",
	  "Матросова",
	  "Островского",
	  "Сосновая",
	  "Клубная",
	  "Куйбышева",
	  "Крупской",
	  "Березовая",
	  "Карла Маркса",
	  "8 Марта",
	  "Больничная",
	  "Садовый",
	  "Интернациональная",
	  "Суворова",
	  "Цветочная",
	  "Трактовая",
	  "Ломоносова",
	  "Горная",
	  "Космонавтов",
	  "Энергетиков",
	  "Шевченко",
	  "Весенняя",
	  "Механизаторов",
	  "Коммунальная",
	  "Лесной",
	  "40 лет Победы",
	  "Майская"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "красный",
	  "зеленый",
	  "синий",
	  "желтый",
	  "багровый",
	  "мятный",
	  "зеленовато-голубой",
	  "белый",
	  "черный",
	  "оранжевый",
	  "розовый",
	  "серый",
	  "красно-коричневый",
	  "фиолетовый",
	  "бирюзовый",
	  "желто-коричневый",
	  "небесно голубой",
	  "оранжево-розовый",
	  "темно-фиолетовый",
	  "орхидный",
	  "оливковый",
	  "пурпурный",
	  "лимонный",
	  "кремовый",
	  "сине-фиолетовый",
	  "золотой",
	  "красно-пурпурный",
	  "голубой",
	  "лазурный",
	  "лиловый",
	  "серебряный"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Книги",
	  "Фильмы",
	  "музыка",
	  "игры",
	  "Электроника",
	  "компьютеры",
	  "Дом",
	  "садинструмент",
	  "Бакалея",
	  "здоровье",
	  "красота",
	  "Игрушки",
	  "детское",
	  "для малышей",
	  "Одежда",
	  "обувь",
	  "украшения",
	  "Спорт",
	  "туризм",
	  "Автомобильное",
	  "промышленное"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(1466);
	commerce.department = __webpack_require__(1467);
	commerce.product_name = __webpack_require__(1469);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "adjective": [
	    "Маленький",
	    "Эргономичный",
	    "Грубый",
	    "Интеллектуальный",
	    "Великолепный",
	    "Невероятный",
	    "Фантастический",
	    "Практчиный",
	    "Лоснящийся",
	    "Потрясающий"
	  ],
	  "material": [
	    "Стальной",
	    "Деревянный",
	    "Бетонный",
	    "Пластиковый",
	    "Хлопковый",
	    "Гранитный",
	    "Резиновый"
	  ],
	  "product": [
	    "Стул",
	    "Автомобиль",
	    "Компьютер",
	    "Берет",
	    "Кулон",
	    "Стол",
	    "Свитер",
	    "Ремень",
	    "Ботинок"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(1472);
	company.suffix = __webpack_require__(1473);
	company.name = __webpack_require__(1471);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.female_first_name}",
	  "#{prefix} #{Name.male_first_name}",
	  "#{prefix} #{Name.male_last_name}",
	  "#{prefix} #{suffix}#{suffix}",
	  "#{prefix} #{suffix}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}#{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ИП",
	  "ООО",
	  "ЗАО",
	  "ОАО",
	  "НКО",
	  "ТСЖ",
	  "ОП"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Снаб",
	  "Торг",
	  "Пром",
	  "Трейд",
	  "Сбыт"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(1475);
	date.weekday = __webpack_require__(1476);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/ru.xml#L1734
	module["exports"] = {
	  wide: [
	    "январь",
	    "февраль",
	    "март",
	    "апрель",
	    "май",
	    "июнь",
	    "июль",
	    "август",
	    "сентябрь",
	    "октябрь",
	    "ноябрь",
	    "декабрь"
	  ],
	  wide_context: [
	    "января",
	    "февраля",
	    "марта",
	    "апреля",
	    "мая",
	    "июня",
	    "июля",
	    "августа",
	    "сентября",
	    "октября",
	    "ноября",
	    "декабря"
	  ],
	  abbr: [
	    "янв.",
	    "февр.",
	    "март",
	    "апр.",
	    "май",
	    "июнь",
	    "июль",
	    "авг.",
	    "сент.",
	    "окт.",
	    "нояб.",
	    "дек."
	  ],
	  abbr_context: [
	    "янв.",
	    "февр.",
	    "марта",
	    "апр.",
	    "мая",
	    "июня",
	    "июля",
	    "авг.",
	    "сент.",
	    "окт.",
	    "нояб.",
	    "дек."
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/ru.xml#L1825
	module["exports"] = {
	  wide: [
	    "Воскресенье",
	    "Понедельник",
	    "Вторник",
	    "Среда",
	    "Четверг",
	    "Пятница",
	    "Суббота"
	  ],
	  wide_context: [
	    "воскресенье",
	    "понедельник",
	    "вторник",
	    "среда",
	    "четверг",
	    "пятница",
	    "суббота"
	  ],
	  abbr: [
	    "Вс",
	    "Пн",
	    "Вт",
	    "Ср",
	    "Чт",
	    "Пт",
	    "Сб"
	  ],
	  abbr_context: [
	    "вс",
	    "пн",
	    "вт",
	    "ср",
	    "чт",
	    "пт",
	    "сб"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ru = {};
	module['exports'] = ru;
	ru.title = "Russian";
	ru.separator = " и ";
	ru.address = __webpack_require__(1458);
	ru.internet = __webpack_require__(1480);
	ru.name = __webpack_require__(1484);
	ru.phone_number = __webpack_require__(1492);
	ru.commerce = __webpack_require__(1468);
	ru.company = __webpack_require__(1470);
	ru.date = __webpack_require__(1474);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "ru",
	  "info",
	  "рф",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "yandex.ru",
	  "ya.ru",
	  "mail.ru",
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1479);
	internet.domain_suffix = __webpack_require__(1478);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Анна",
	  "Алёна",
	  "Алевтина",
	  "Александра",
	  "Алина",
	  "Алла",
	  "Анастасия",
	  "Ангелина",
	  "Анжела",
	  "Анжелика",
	  "Антонида",
	  "Антонина",
	  "Анфиса",
	  "Арина",
	  "Валентина",
	  "Валерия",
	  "Варвара",
	  "Василиса",
	  "Вера",
	  "Вероника",
	  "Виктория",
	  "Галина",
	  "Дарья",
	  "Евгения",
	  "Екатерина",
	  "Елена",
	  "Елизавета",
	  "Жанна",
	  "Зинаида",
	  "Зоя",
	  "Ирина",
	  "Кира",
	  "Клавдия",
	  "Ксения",
	  "Лариса",
	  "Лидия",
	  "Любовь",
	  "Людмила",
	  "Маргарита",
	  "Марина",
	  "Мария",
	  "Надежда",
	  "Наталья",
	  "Нина",
	  "Оксана",
	  "Ольга",
	  "Раиса",
	  "Регина",
	  "Римма",
	  "Светлана",
	  "София",
	  "Таисия",
	  "Тамара",
	  "Татьяна",
	  "Ульяна",
	  "Юлия"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Смирнова",
	  "Иванова",
	  "Кузнецова",
	  "Попова",
	  "Соколова",
	  "Лебедева",
	  "Козлова",
	  "Новикова",
	  "Морозова",
	  "Петрова",
	  "Волкова",
	  "Соловьева",
	  "Васильева",
	  "Зайцева",
	  "Павлова",
	  "Семенова",
	  "Голубева",
	  "Виноградова",
	  "Богданова",
	  "Воробьева",
	  "Федорова",
	  "Михайлова",
	  "Беляева",
	  "Тарасова",
	  "Белова",
	  "Комарова",
	  "Орлова",
	  "Киселева",
	  "Макарова",
	  "Андреева",
	  "Ковалева",
	  "Ильина",
	  "Гусева",
	  "Титова",
	  "Кузьмина",
	  "Кудрявцева",
	  "Баранова",
	  "Куликова",
	  "Алексеева",
	  "Степанова",
	  "Яковлева",
	  "Сорокина",
	  "Сергеева",
	  "Романова",
	  "Захарова",
	  "Борисова",
	  "Королева",
	  "Герасимова",
	  "Пономарева",
	  "Григорьева",
	  "Лазарева",
	  "Медведева",
	  "Ершова",
	  "Никитина",
	  "Соболева",
	  "Рябова",
	  "Полякова",
	  "Цветкова",
	  "Данилова",
	  "Жукова",
	  "Фролова",
	  "Журавлева",
	  "Николаева",
	  "Крылова",
	  "Максимова",
	  "Сидорова",
	  "Осипова",
	  "Белоусова",
	  "Федотова",
	  "Дорофеева",
	  "Егорова",
	  "Матвеева",
	  "Боброва",
	  "Дмитриева",
	  "Калинина",
	  "Анисимова",
	  "Петухова",
	  "Антонова",
	  "Тимофеева",
	  "Никифорова",
	  "Веселова",
	  "Филиппова",
	  "Маркова",
	  "Большакова",
	  "Суханова",
	  "Миронова",
	  "Ширяева",
	  "Александрова",
	  "Коновалова",
	  "Шестакова",
	  "Казакова",
	  "Ефимова",
	  "Денисова",
	  "Громова",
	  "Фомина",
	  "Давыдова",
	  "Мельникова",
	  "Щербакова",
	  "Блинова",
	  "Колесникова",
	  "Карпова",
	  "Афанасьева",
	  "Власова",
	  "Маслова",
	  "Исакова",
	  "Тихонова",
	  "Аксенова",
	  "Гаврилова",
	  "Родионова",
	  "Котова",
	  "Горбунова",
	  "Кудряшова",
	  "Быкова",
	  "Зуева",
	  "Третьякова",
	  "Савельева",
	  "Панова",
	  "Рыбакова",
	  "Суворова",
	  "Абрамова",
	  "Воронова",
	  "Мухина",
	  "Архипова",
	  "Трофимова",
	  "Мартынова",
	  "Емельянова",
	  "Горшкова",
	  "Чернова",
	  "Овчинникова",
	  "Селезнева",
	  "Панфилова",
	  "Копылова",
	  "Михеева",
	  "Галкина",
	  "Назарова",
	  "Лобанова",
	  "Лукина",
	  "Белякова",
	  "Потапова",
	  "Некрасова",
	  "Хохлова",
	  "Жданова",
	  "Наумова",
	  "Шилова",
	  "Воронцова",
	  "Ермакова",
	  "Дроздова",
	  "Игнатьева",
	  "Савина",
	  "Логинова",
	  "Сафонова",
	  "Капустина",
	  "Кириллова",
	  "Моисеева",
	  "Елисеева",
	  "Кошелева",
	  "Костина",
	  "Горбачева",
	  "Орехова",
	  "Ефремова",
	  "Исаева",
	  "Евдокимова",
	  "Калашникова",
	  "Кабанова",
	  "Носкова",
	  "Юдина",
	  "Кулагина",
	  "Лапина",
	  "Прохорова",
	  "Нестерова",
	  "Харитонова",
	  "Агафонова",
	  "Муравьева",
	  "Ларионова",
	  "Федосеева",
	  "Зимина",
	  "Пахомова",
	  "Шубина",
	  "Игнатова",
	  "Филатова",
	  "Крюкова",
	  "Рогова",
	  "Кулакова",
	  "Терентьева",
	  "Молчанова",
	  "Владимирова",
	  "Артемьева",
	  "Гурьева",
	  "Зиновьева",
	  "Гришина",
	  "Кононова",
	  "Дементьева",
	  "Ситникова",
	  "Симонова",
	  "Мишина",
	  "Фадеева",
	  "Комиссарова",
	  "Мамонтова",
	  "Носова",
	  "Гуляева",
	  "Шарова",
	  "Устинова",
	  "Вишнякова",
	  "Евсеева",
	  "Лаврентьева",
	  "Брагина",
	  "Константинова",
	  "Корнилова",
	  "Авдеева",
	  "Зыкова",
	  "Бирюкова",
	  "Шарапова",
	  "Никонова",
	  "Щукина",
	  "Дьячкова",
	  "Одинцова",
	  "Сазонова",
	  "Якушева",
	  "Красильникова",
	  "Гордеева",
	  "Самойлова",
	  "Князева",
	  "Беспалова",
	  "Уварова",
	  "Шашкова",
	  "Бобылева",
	  "Доронина",
	  "Белозерова",
	  "Рожкова",
	  "Самсонова",
	  "Мясникова",
	  "Лихачева",
	  "Бурова",
	  "Сысоева",
	  "Фомичева",
	  "Русакова",
	  "Стрелкова",
	  "Гущина",
	  "Тетерина",
	  "Колобова",
	  "Субботина",
	  "Фокина",
	  "Блохина",
	  "Селиверстова",
	  "Пестова",
	  "Кондратьева",
	  "Силина",
	  "Меркушева",
	  "Лыткина",
	  "Турова"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Александровна",
	  "Алексеевна",
	  "Альбертовна",
	  "Анатольевна",
	  "Андреевна",
	  "Антоновна",
	  "Аркадьевна",
	  "Арсеньевна",
	  "Артёмовна",
	  "Борисовна",
	  "Вадимовна",
	  "Валентиновна",
	  "Валерьевна",
	  "Васильевна",
	  "Викторовна",
	  "Витальевна",
	  "Владимировна",
	  "Владиславовна",
	  "Вячеславовна",
	  "Геннадьевна",
	  "Георгиевна",
	  "Германовна",
	  "Григорьевна",
	  "Данииловна",
	  "Денисовна",
	  "Дмитриевна",
	  "Евгеньевна",
	  "Егоровна",
	  "Ивановна",
	  "Игнатьевна",
	  "Игоревна",
	  "Ильинична",
	  "Константиновна",
	  "Лаврентьевна",
	  "Леонидовна",
	  "Макаровна",
	  "Максимовна",
	  "Матвеевна",
	  "Михайловна",
	  "Никитична",
	  "Николаевна",
	  "Олеговна",
	  "Романовна",
	  "Семёновна",
	  "Сергеевна",
	  "Станиславовна",
	  "Степановна",
	  "Фёдоровна",
	  "Эдуардовна",
	  "Юрьевна",
	  "Ярославовна"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(1485);
	name.male_middle_name = __webpack_require__(1487);
	name.male_last_name = __webpack_require__(1486);
	name.female_first_name = __webpack_require__(1481);
	name.female_middle_name = __webpack_require__(1483);
	name.female_last_name = __webpack_require__(1482);
	name.prefix = __webpack_require__(1489);
	name.suffix = __webpack_require__(1490);
	name.name = __webpack_require__(1488);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Александр",
	  "Алексей",
	  "Альберт",
	  "Анатолий",
	  "Андрей",
	  "Антон",
	  "Аркадий",
	  "Арсений",
	  "Артём",
	  "Борис",
	  "Вадим",
	  "Валентин",
	  "Валерий",
	  "Василий",
	  "Виктор",
	  "Виталий",
	  "Владимир",
	  "Владислав",
	  "Вячеслав",
	  "Геннадий",
	  "Георгий",
	  "Герман",
	  "Григорий",
	  "Даниил",
	  "Денис",
	  "Дмитрий",
	  "Евгений",
	  "Егор",
	  "Иван",
	  "Игнатий",
	  "Игорь",
	  "Илья",
	  "Константин",
	  "Лаврентий",
	  "Леонид",
	  "Лука",
	  "Макар",
	  "Максим",
	  "Матвей",
	  "Михаил",
	  "Никита",
	  "Николай",
	  "Олег",
	  "Роман",
	  "Семён",
	  "Сергей",
	  "Станислав",
	  "Степан",
	  "Фёдор",
	  "Эдуард",
	  "Юрий",
	  "Ярослав"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Смирнов",
	  "Иванов",
	  "Кузнецов",
	  "Попов",
	  "Соколов",
	  "Лебедев",
	  "Козлов",
	  "Новиков",
	  "Морозов",
	  "Петров",
	  "Волков",
	  "Соловьев",
	  "Васильев",
	  "Зайцев",
	  "Павлов",
	  "Семенов",
	  "Голубев",
	  "Виноградов",
	  "Богданов",
	  "Воробьев",
	  "Федоров",
	  "Михайлов",
	  "Беляев",
	  "Тарасов",
	  "Белов",
	  "Комаров",
	  "Орлов",
	  "Киселев",
	  "Макаров",
	  "Андреев",
	  "Ковалев",
	  "Ильин",
	  "Гусев",
	  "Титов",
	  "Кузьмин",
	  "Кудрявцев",
	  "Баранов",
	  "Куликов",
	  "Алексеев",
	  "Степанов",
	  "Яковлев",
	  "Сорокин",
	  "Сергеев",
	  "Романов",
	  "Захаров",
	  "Борисов",
	  "Королев",
	  "Герасимов",
	  "Пономарев",
	  "Григорьев",
	  "Лазарев",
	  "Медведев",
	  "Ершов",
	  "Никитин",
	  "Соболев",
	  "Рябов",
	  "Поляков",
	  "Цветков",
	  "Данилов",
	  "Жуков",
	  "Фролов",
	  "Журавлев",
	  "Николаев",
	  "Крылов",
	  "Максимов",
	  "Сидоров",
	  "Осипов",
	  "Белоусов",
	  "Федотов",
	  "Дорофеев",
	  "Егоров",
	  "Матвеев",
	  "Бобров",
	  "Дмитриев",
	  "Калинин",
	  "Анисимов",
	  "Петухов",
	  "Антонов",
	  "Тимофеев",
	  "Никифоров",
	  "Веселов",
	  "Филиппов",
	  "Марков",
	  "Большаков",
	  "Суханов",
	  "Миронов",
	  "Ширяев",
	  "Александров",
	  "Коновалов",
	  "Шестаков",
	  "Казаков",
	  "Ефимов",
	  "Денисов",
	  "Громов",
	  "Фомин",
	  "Давыдов",
	  "Мельников",
	  "Щербаков",
	  "Блинов",
	  "Колесников",
	  "Карпов",
	  "Афанасьев",
	  "Власов",
	  "Маслов",
	  "Исаков",
	  "Тихонов",
	  "Аксенов",
	  "Гаврилов",
	  "Родионов",
	  "Котов",
	  "Горбунов",
	  "Кудряшов",
	  "Быков",
	  "Зуев",
	  "Третьяков",
	  "Савельев",
	  "Панов",
	  "Рыбаков",
	  "Суворов",
	  "Абрамов",
	  "Воронов",
	  "Мухин",
	  "Архипов",
	  "Трофимов",
	  "Мартынов",
	  "Емельянов",
	  "Горшков",
	  "Чернов",
	  "Овчинников",
	  "Селезнев",
	  "Панфилов",
	  "Копылов",
	  "Михеев",
	  "Галкин",
	  "Назаров",
	  "Лобанов",
	  "Лукин",
	  "Беляков",
	  "Потапов",
	  "Некрасов",
	  "Хохлов",
	  "Жданов",
	  "Наумов",
	  "Шилов",
	  "Воронцов",
	  "Ермаков",
	  "Дроздов",
	  "Игнатьев",
	  "Савин",
	  "Логинов",
	  "Сафонов",
	  "Капустин",
	  "Кириллов",
	  "Моисеев",
	  "Елисеев",
	  "Кошелев",
	  "Костин",
	  "Горбачев",
	  "Орехов",
	  "Ефремов",
	  "Исаев",
	  "Евдокимов",
	  "Калашников",
	  "Кабанов",
	  "Носков",
	  "Юдин",
	  "Кулагин",
	  "Лапин",
	  "Прохоров",
	  "Нестеров",
	  "Харитонов",
	  "Агафонов",
	  "Муравьев",
	  "Ларионов",
	  "Федосеев",
	  "Зимин",
	  "Пахомов",
	  "Шубин",
	  "Игнатов",
	  "Филатов",
	  "Крюков",
	  "Рогов",
	  "Кулаков",
	  "Терентьев",
	  "Молчанов",
	  "Владимиров",
	  "Артемьев",
	  "Гурьев",
	  "Зиновьев",
	  "Гришин",
	  "Кононов",
	  "Дементьев",
	  "Ситников",
	  "Симонов",
	  "Мишин",
	  "Фадеев",
	  "Комиссаров",
	  "Мамонтов",
	  "Носов",
	  "Гуляев",
	  "Шаров",
	  "Устинов",
	  "Вишняков",
	  "Евсеев",
	  "Лаврентьев",
	  "Брагин",
	  "Константинов",
	  "Корнилов",
	  "Авдеев",
	  "Зыков",
	  "Бирюков",
	  "Шарапов",
	  "Никонов",
	  "Щукин",
	  "Дьячков",
	  "Одинцов",
	  "Сазонов",
	  "Якушев",
	  "Красильников",
	  "Гордеев",
	  "Самойлов",
	  "Князев",
	  "Беспалов",
	  "Уваров",
	  "Шашков",
	  "Бобылев",
	  "Доронин",
	  "Белозеров",
	  "Рожков",
	  "Самсонов",
	  "Мясников",
	  "Лихачев",
	  "Буров",
	  "Сысоев",
	  "Фомичев",
	  "Русаков",
	  "Стрелков",
	  "Гущин",
	  "Тетерин",
	  "Колобов",
	  "Субботин",
	  "Фокин",
	  "Блохин",
	  "Селиверстов",
	  "Пестов",
	  "Кондратьев",
	  "Силин",
	  "Меркушев",
	  "Лыткин",
	  "Туров"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Александрович",
	  "Алексеевич",
	  "Альбертович",
	  "Анатольевич",
	  "Андреевич",
	  "Антонович",
	  "Аркадьевич",
	  "Арсеньевич",
	  "Артёмович",
	  "Борисович",
	  "Вадимович",
	  "Валентинович",
	  "Валерьевич",
	  "Васильевич",
	  "Викторович",
	  "Витальевич",
	  "Владимирович",
	  "Владиславович",
	  "Вячеславович",
	  "Геннадьевич",
	  "Георгиевич",
	  "Германович",
	  "Григорьевич",
	  "Даниилович",
	  "Денисович",
	  "Дмитриевич",
	  "Евгеньевич",
	  "Егорович",
	  "Иванович",
	  "Игнатьевич",
	  "Игоревич",
	  "Ильич",
	  "Константинович",
	  "Лаврентьевич",
	  "Леонидович",
	  "Лукич",
	  "Макарович",
	  "Максимович",
	  "Матвеевич",
	  "Михайлович",
	  "Никитич",
	  "Николаевич",
	  "Олегович",
	  "Романович",
	  "Семёнович",
	  "Сергеевич",
	  "Станиславович",
	  "Степанович",
	  "Фёдорович",
	  "Эдуардович",
	  "Юрьевич",
	  "Ярославович"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{male_first_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name}",
	  "#{male_first_name} #{male_middle_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name} #{male_middle_name}",
	  "#{female_first_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name}",
	  "#{female_first_name} #{female_middle_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name} #{female_middle_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(9##)###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1491);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bánovce nad Bebravou",
	  "Banská Bystrica",
	  "Banská Štiavnica",
	  "Bardejov",
	  "Bratislava I",
	  "Bratislava II",
	  "Bratislava III",
	  "Bratislava IV",
	  "Bratislava V",
	  "Brezno",
	  "Bytča",
	  "Čadca",
	  "Detva",
	  "Dolný Kubín",
	  "Dunajská Streda",
	  "Galanta",
	  "Gelnica",
	  "Hlohovec",
	  "Humenné",
	  "Ilava",
	  "Kežmarok",
	  "Komárno",
	  "Košice I",
	  "Košice II",
	  "Košice III",
	  "Košice IV",
	  "Košice-okolie",
	  "Krupina",
	  "Kysucké Nové Mesto",
	  "Levice",
	  "Levoča",
	  "Liptovský Mikuláš",
	  "Lučenec",
	  "Malacky",
	  "Martin",
	  "Medzilaborce",
	  "Michalovce",
	  "Myjava",
	  "Námestovo",
	  "Nitra",
	  "Nové Mesto n.Váhom",
	  "Nové Zámky",
	  "Partizánske",
	  "Pezinok",
	  "Piešťany",
	  "Poltár",
	  "Poprad",
	  "Považská Bystrica",
	  "Prešov",
	  "Prievidza",
	  "Púchov",
	  "Revúca",
	  "Rimavská Sobota",
	  "Rožňava",
	  "Ružomberok",
	  "Sabinov",
	  "Šaľa",
	  "Senec",
	  "Senica",
	  "Skalica",
	  "Snina",
	  "Sobrance",
	  "Spišská Nová Ves",
	  "Stará Ľubovňa",
	  "Stropkov",
	  "Svidník",
	  "Topoľčany",
	  "Trebišov",
	  "Trenčín",
	  "Trnava",
	  "Turčianske Teplice",
	  "Tvrdošín",
	  "Veľký Krtíš",
	  "Vranov nad Topľou",
	  "Žarnovica",
	  "Žiar nad Hronom",
	  "Žilina",
	  "Zlaté Moravce",
	  "Zvolen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "North",
	  "East",
	  "West",
	  "South",
	  "New",
	  "Lake",
	  "Port"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "town",
	  "ton",
	  "land",
	  "ville",
	  "berg",
	  "burgh",
	  "borough",
	  "bury",
	  "view",
	  "port",
	  "mouth",
	  "stad",
	  "furt",
	  "chester",
	  "mouth",
	  "fort",
	  "haven",
	  "side",
	  "shire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistan",
	  "Afgánsky islamský štát",
	  "Albánsko",
	  "Albánska republika",
	  "Alžírsko",
	  "Alžírska demokratická ľudová republika",
	  "Andorra",
	  "Andorrské kniežatsvo",
	  "Angola",
	  "Angolská republika",
	  "Antigua a Barbuda",
	  "Antigua a Barbuda",
	  "Argentína",
	  "Argentínska republika",
	  "Arménsko",
	  "Arménska republika",
	  "Austrália",
	  "Austrálsky zväz",
	  "Azerbajdžan",
	  "Azerbajdžanská republika",
	  "Bahamy",
	  "Bahamské spoločenstvo",
	  "Bahrajn",
	  "Bahrajnské kráľovstvo",
	  "Bangladéš",
	  "Bangladéšska ľudová republika",
	  "Barbados",
	  "Barbados",
	  "Belgicko",
	  "Belgické kráľovstvo",
	  "Belize",
	  "Belize",
	  "Benin",
	  "Beninská republika",
	  "Bhután",
	  "Bhutánske kráľovstvo",
	  "Bielorusko",
	  "Bieloruská republika",
	  "Bolívia",
	  "Bolívijská republika",
	  "Bosna a Hercegovina",
	  "Republika Bosny a Hercegoviny",
	  "Botswana",
	  "Botswanská republika",
	  "Brazília",
	  "Brazílska federatívna republika",
	  "Brunej",
	  "Brunejský sultanát",
	  "Bulharsko",
	  "Bulharská republika",
	  "Burkina Faso",
	  "Burkina Faso",
	  "Burundi",
	  "Burundská republika",
	  "Cyprus",
	  "Cyperská republika",
	  "Čad",
	  "Republika Čad",
	  "Česko",
	  "Česká republika",
	  "Čína",
	  "Čínska ľudová republika",
	  "Dánsko",
	  "Dánsko kráľovstvo",
	  "Dominika",
	  "Spoločenstvo Dominika",
	  "Dominikánska republika",
	  "Dominikánska republika",
	  "Džibutsko",
	  "Džibutská republika",
	  "Egypt",
	  "Egyptská arabská republika",
	  "Ekvádor",
	  "Ekvádorská republika",
	  "Eritrea",
	  "Eritrejský štát",
	  "Estónsko",
	  "Estónska republika",
	  "Etiópia",
	  "Etiópska federatívna demokratická republika",
	  "Fidži",
	  "Republika ostrovy Fidži",
	  "Filipíny",
	  "Filipínska republika",
	  "Fínsko",
	  "Fínska republika",
	  "Francúzsko",
	  "Francúzska republika",
	  "Gabon",
	  "Gabonská republika",
	  "Gambia",
	  "Gambijská republika",
	  "Ghana",
	  "Ghanská republika",
	  "Grécko",
	  "Helénska republika",
	  "Grenada",
	  "Grenada",
	  "Gruzínsko",
	  "Gruzínsko",
	  "Guatemala",
	  "Guatemalská republika",
	  "Guinea",
	  "Guinejská republika",
	  "Guinea-Bissau",
	  "Republika Guinea-Bissau",
	  "Guayana",
	  "Guayanská republika",
	  "Haiti",
	  "Republika Haiti",
	  "Holandsko",
	  "Holandské kráľovstvo",
	  "Honduras",
	  "Honduraská republika",
	  "Chile",
	  "Čílska republika",
	  "Chorvátsko",
	  "Chorvátska republika",
	  "India",
	  "Indická republika",
	  "Indonézia",
	  "Indonézska republika",
	  "Irak",
	  "Iracká republika",
	  "Irán",
	  "Iránska islamská republika",
	  "Island",
	  "Islandská republika",
	  "Izrael",
	  "Štát Izrael",
	  "Írsko",
	  "Írska republika",
	  "Jamajka",
	  "Jamajka",
	  "Japonsko",
	  "Japonsko",
	  "Jemen",
	  "Jemenská republika",
	  "Jordánsko",
	  "Jordánske hášimovské kráľovstvo",
	  "Južná Afrika",
	  "Juhoafrická republika",
	  "Kambodža",
	  "Kambodžské kráľovstvo",
	  "Kamerun",
	  "Kamerunská republika",
	  "Kanada",
	  "Kanada",
	  "Kapverdy",
	  "Kapverdská republika",
	  "Katar",
	  "Štát Katar",
	  "Kazachstan",
	  "Kazašská republika",
	  "Keňa",
	  "Kenská republika",
	  "Kirgizsko",
	  "Kirgizská republika",
	  "Kiribati",
	  "Kiribatská republika",
	  "Kolumbia",
	  "Kolumbijská republika",
	  "Komory",
	  "Komorská únia",
	  "Kongo",
	  "Konžská demokratická republika",
	  "Kongo (\"Brazzaville\")",
	  "Konžská republika",
	  "Kórea (\"Južná\")",
	  "Kórejská republika",
	  "Kórea (\"Severná\")",
	  "Kórejská ľudovodemokratická republika",
	  "Kostarika",
	  "Kostarická republika",
	  "Kuba",
	  "Kubánska republika",
	  "Kuvajt",
	  "Kuvajtský štát",
	  "Laos",
	  "Laoská ľudovodemokratická republika",
	  "Lesotho",
	  "Lesothské kráľovstvo",
	  "Libanon",
	  "Libanonská republika",
	  "Libéria",
	  "Libérijská republika",
	  "Líbya",
	  "Líbyjská arabská ľudová socialistická džamáhírija",
	  "Lichtenštajnsko",
	  "Lichtenštajnské kniežatstvo",
	  "Litva",
	  "Litovská republika",
	  "Lotyšsko",
	  "Lotyšská republika",
	  "Luxembursko",
	  "Luxemburské veľkovojvodstvo",
	  "Macedónsko",
	  "Macedónska republika",
	  "Madagaskar",
	  "Madagaskarská republika",
	  "Maďarsko",
	  "Maďarská republika",
	  "Malajzia",
	  "Malajzia",
	  "Malawi",
	  "Malawijská republika",
	  "Maldivy",
	  "Maldivská republika",
	  "Mali",
	  "Malijská republika",
	  "Malta",
	  "Malta",
	  "Maroko",
	  "Marocké kráľovstvo",
	  "Marshallove ostrovy",
	  "Republika Marshallových ostrovy",
	  "Mauritánia",
	  "Mauritánska islamská republika",
	  "Maurícius",
	  "Maurícijská republika",
	  "Mexiko",
	  "Spojené štáty mexické",
	  "Mikronézia",
	  "Mikronézske federatívne štáty",
	  "Mjanmarsko",
	  "Mjanmarský zväz",
	  "Moldavsko",
	  "Moldavská republika",
	  "Monako",
	  "Monacké kniežatstvo",
	  "Mongolsko",
	  "Mongolsko",
	  "Mozambik",
	  "Mozambická republika",
	  "Namíbia",
	  "Namíbijská republika",
	  "Nauru",
	  "Naurská republika",
	  "Nemecko",
	  "Nemecká spolková republika",
	  "Nepál",
	  "Nepálske kráľovstvo",
	  "Niger",
	  "Nigerská republika",
	  "Nigéria",
	  "Nigérijská federatívna republika",
	  "Nikaragua",
	  "Nikaragujská republika",
	  "Nový Zéland",
	  "Nový Zéland",
	  "Nórsko",
	  "Nórske kráľovstvo",
	  "Omán",
	  "Ománsky sultanát",
	  "Pakistan",
	  "Pakistanská islamská republika",
	  "Palau",
	  "Palauská republika",
	  "Panama",
	  "Panamská republika",
	  "Papua-Nová Guinea",
	  "Nezávislý štát Papua-Nová Guinea",
	  "Paraguaj",
	  "Paraguajská republika",
	  "Peru",
	  "Peruánska republika",
	  "Pobrežie Slonoviny",
	  "Republika Pobrežie Slonoviny",
	  "Poľsko",
	  "Poľská republika",
	  "Portugalsko",
	  "Portugalská republika",
	  "Rakúsko",
	  "Rakúska republika",
	  "Rovníková Guinea",
	  "Republika Rovníková Guinea",
	  "Rumunsko",
	  "Rumunsko",
	  "Rusko",
	  "Ruská federácia",
	  "Rwanda",
	  "Rwandská republika",
	  "Salvádor",
	  "Salvádorská republika",
	  "Samoa",
	  "Nezávislý štát Samoa",
	  "San Maríno",
	  "Sanmarínska republika",
	  "Saudská Arábia",
	  "Kráľovstvo Saudskej Arábie",
	  "Senegal",
	  "Senegalská republika",
	  "Seychely",
	  "Seychelská republika",
	  "Sierra Leone",
	  "Republika Sierra Leone",
	  "Singapur",
	  "Singapurska republika",
	  "Slovensko",
	  "Slovenská republika",
	  "Slovinsko",
	  "Slovinská republika",
	  "Somálsko",
	  "Somálska demokratická republika",
	  "Spojené arabské emiráty",
	  "Spojené arabské emiráty",
	  "Spojené štáty americké",
	  "Spojené štáty americké",
	  "Srbsko a Čierna Hora",
	  "Srbsko a Čierna Hora",
	  "Srí Lanka",
	  "Demokratická socialistická republika Srí Lanka",
	  "Stredoafrická republika",
	  "Stredoafrická republika",
	  "Sudán",
	  "Sudánska republika",
	  "Surinam",
	  "Surinamská republika",
	  "Svazijsko",
	  "Svazijské kráľovstvo",
	  "Svätá Lucia",
	  "Svätá Lucia",
	  "Svätý Krištof a Nevis",
	  "Federácia Svätý Krištof a Nevis",
	  "Sv. Tomáš a Princov Ostrov",
	  "Demokratická republika Svätý Tomáš a Princov Ostrov",
	  "Sv. Vincent a Grenadíny",
	  "Svätý Vincent a Grenadíny",
	  "Sýria",
	  "Sýrska arabská republika",
	  "Šalamúnove ostrovy",
	  "Šalamúnove ostrovy",
	  "Španielsko",
	  "Španielske kráľovstvo",
	  "Švajčiarsko",
	  "Švajčiarska konfederácia",
	  "Švédsko",
	  "Švédske kráľovstvo",
	  "Tadžikistan",
	  "Tadžická republika",
	  "Taliansko",
	  "Talianska republika",
	  "Tanzánia",
	  "Tanzánijská zjednotená republika",
	  "Thajsko",
	  "Thajské kráľovstvo",
	  "Togo",
	  "Tožská republika",
	  "Tonga",
	  "Tonžské kráľovstvo",
	  "Trinidad a Tobago",
	  "Republika Trinidad a Tobago",
	  "Tunisko",
	  "Tuniská republika",
	  "Turecko",
	  "Turecká republika",
	  "Turkménsko",
	  "Turkménsko",
	  "Tuvalu",
	  "Tuvalu",
	  "Uganda",
	  "Ugandská republika",
	  "Ukrajina",
	  "Uruguaj",
	  "Uruguajská východná republika",
	  "Uzbekistan",
	  "Vanuatu",
	  "Vanuatská republika",
	  "Vatikán",
	  "Svätá Stolica",
	  "Veľká Británia",
	  "Spojené kráľovstvo Veľkej Británie a Severného Írska",
	  "Venezuela",
	  "Venezuelská bolívarovská republika",
	  "Vietnam",
	  "Vietnamská socialistická republika",
	  "Východný Timor",
	  "Demokratická republika Východný Timor",
	  "Zambia",
	  "Zambijská republika",
	  "Zimbabwe",
	  "Zimbabwianska republika"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Slovensko"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1496);
	address.city_suffix = __webpack_require__(1497);
	address.country = __webpack_require__(1498);
	address.building_number = __webpack_require__(1493);
	address.secondary_address = __webpack_require__(1502);
	address.postcode = __webpack_require__(1501);
	address.state = __webpack_require__(1503);
	address.state_abbr = __webpack_require__(1504);
	address.time_zone = __webpack_require__(1508);
	address.city_name = __webpack_require__(1495);
	address.city = __webpack_require__(1494);
	address.street = __webpack_require__(1505);
	address.street_name = __webpack_require__(1507);
	address.street_address = __webpack_require__(1506);
	address.default_country = __webpack_require__(1499);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "### ##",
	  "## ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Suite ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adámiho",
	  "Ahoj",
	  "Albína Brunovského",
	  "Albrechtova",
	  "Alejová",
	  "Alešova",
	  "Alibernetová",
	  "Alžbetínska",
	  "Alžbety Gwerkovej",
	  "Ambroseho",
	  "Ambrušova",
	  "Americká",
	  "Americké námestie",
	  "Americké námestie",
	  "Andreja Mráza",
	  "Andreja Plávku",
	  "Andrusovova",
	  "Anenská",
	  "Anenská",
	  "Antolská",
	  "Astronomická",
	  "Astrová",
	  "Azalková",
	  "Azovská",
	  "Babuškova",
	  "Bachova",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajzova",
	  "Bancíkovej",
	  "Banícka",
	  "Baníkova",
	  "Banskobystrická",
	  "Banšelova",
	  "Bardejovská",
	  "Bartókova",
	  "Bartoňova",
	  "Bartoškova",
	  "Baštová",
	  "Bazová",
	  "Bažantia",
	  "Beblavého",
	  "Beckovská",
	  "Bedľová",
	  "Belániková",
	  "Belehradská",
	  "Belinského",
	  "Belopotockého",
	  "Beňadická",
	  "Bencúrova",
	  "Benediktiho",
	  "Beniakova",
	  "Bernolákova",
	  "Beskydská",
	  "Betliarska",
	  "Bezručova",
	  "Biela",
	  "Bielkova",
	  "Björnsonova",
	  "Blagoevova",
	  "Blatnická",
	  "Blumentálska",
	  "Blyskáčová",
	  "Bočná",
	  "Bohrova",
	  "Bohúňova",
	  "Bojnická",
	  "Borodáčova",
	  "Borská",
	  "Bosákova",
	  "Botanická",
	  "Bottova",
	  "Boženy Němcovej",
	  "Bôrik",
	  "Bradáčova",
	  "Bradlianska",
	  "Brančská",
	  "Bratská",
	  "Brestová",
	  "Brezovská",
	  "Briežky",
	  "Brnianska",
	  "Brodná",
	  "Brodská",
	  "Broskyňová",
	  "Břeclavská",
	  "Budatínska",
	  "Budatínska",
	  "Budatínska",
	  "Búdkova  cesta",
	  "Budovateľská",
	  "Budyšínska",
	  "Budyšínska",
	  "Buková",
	  "Bukureštská",
	  "Bulharská",
	  "Bulíkova",
	  "Bystrého",
	  "Bzovícka",
	  "Cablkova",
	  "Cesta na Červený most",
	  "Cesta na Červený most",
	  "Cesta na Senec",
	  "Cikkerova",
	  "Cintorínska",
	  "Cintulova",
	  "Cukrová",
	  "Cyrilova",
	  "Čajakova",
	  "Čajkovského",
	  "Čaklovská",
	  "Čalovská",
	  "Čapajevova",
	  "Čapkova",
	  "Čárskeho",
	  "Čavojského",
	  "Čečinová",
	  "Čelakovského",
	  "Čerešňová",
	  "Černyševského",
	  "Červeňova",
	  "Česká",
	  "Československých par",
	  "Čipkárska",
	  "Čmelíkova",
	  "Čmeľovec",
	  "Čulenova",
	  "Daliborovo námestie",
	  "Dankovského",
	  "Dargovská",
	  "Ďatelinová",
	  "Daxnerovo námestie",
	  "Devínska cesta",
	  "Dlhé diely I.",
	  "Dlhé diely II.",
	  "Dlhé diely III.",
	  "Dobrovičova",
	  "Dobrovičova",
	  "Dobrovského",
	  "Dobšinského",
	  "Dohnalova",
	  "Dohnányho",
	  "Doležalova",
	  "Dolná",
	  "Dolnozemská cesta",
	  "Domkárska",
	  "Domové role",
	  "Donnerova",
	  "Donovalova",
	  "Dostojevského rad",
	  "Dr. Vladimíra Clemen",
	  "Drevená",
	  "Drieňová",
	  "Drieňová",
	  "Drieňová",
	  "Drotárska cesta",
	  "Drotárska cesta",
	  "Drotárska cesta",
	  "Družicová",
	  "Družstevná",
	  "Dubnická",
	  "Dubová",
	  "Dúbravská cesta",
	  "Dudova",
	  "Dulovo námestie",
	  "Dulovo námestie",
	  "Dunajská",
	  "Dvořákovo nábrežie",
	  "Edisonova",
	  "Einsteinova",
	  "Elektrárenská",
	  "Exnárova",
	  "F. Kostku",
	  "Fadruszova",
	  "Fajnorovo nábrežie",
	  "Fándlyho",
	  "Farebná",
	  "Farská",
	  "Farského",
	  "Fazuľová",
	  "Fedinova",
	  "Ferienčíkova",
	  "Fialkové údolie",
	  "Fibichova",
	  "Filiálne nádražie",
	  "Flöglova",
	  "Floriánske námestie",
	  "Fraňa Kráľa",
	  "Francisciho",
	  "Francúzskych partizá",
	  "Františkánska",
	  "Františkánske námest",
	  "Furdekova",
	  "Furdekova",
	  "Gabčíkova",
	  "Gagarinova",
	  "Gagarinova",
	  "Gagarinova",
	  "Gajova",
	  "Galaktická",
	  "Galandova",
	  "Gallova",
	  "Galvaniho",
	  "Gašparíkova",
	  "Gaštanová",
	  "Gavlovičova",
	  "Gemerská",
	  "Gercenova",
	  "Gessayova",
	  "Gettingová",
	  "Godrova",
	  "Gogoľova",
	  "Goláňova",
	  "Gondova",
	  "Goralská",
	  "Gorazdova",
	  "Gorkého",
	  "Gregorovej",
	  "Grösslingova",
	  "Gruzínska",
	  "Gunduličova",
	  "Gusevova",
	  "Haanova",
	  "Haburská",
	  "Halašova",
	  "Hálkova",
	  "Hálova",
	  "Hamuliakova",
	  "Hanácka",
	  "Handlovská",
	  "Hany Meličkovej",
	  "Harmanecká",
	  "Hasičská",
	  "Hattalova",
	  "Havlíčkova",
	  "Havrania",
	  "Haydnova",
	  "Herlianska",
	  "Herlianska",
	  "Heydukova",
	  "Hlaváčikova",
	  "Hlavatého",
	  "Hlavné námestie",
	  "Hlboká cesta",
	  "Hlboká cesta",
	  "Hlivová",
	  "Hlučínska",
	  "Hodálova",
	  "Hodžovo námestie",
	  "Holekova",
	  "Holíčska",
	  "Hollého",
	  "Holubyho",
	  "Hontianska",
	  "Horárska",
	  "Horné Židiny",
	  "Horská",
	  "Horská",
	  "Hrad",
	  "Hradné údolie",
	  "Hrachová",
	  "Hraničná",
	  "Hrebendova",
	  "Hríbová",
	  "Hriňovská",
	  "Hrobákova",
	  "Hrobárska",
	  "Hroboňova",
	  "Hudecova",
	  "Humenské námestie",
	  "Hummelova",
	  "Hurbanovo námestie",
	  "Hurbanovo námestie",
	  "Hviezdoslavovo námes",
	  "Hýrošova",
	  "Chalupkova",
	  "Chemická",
	  "Chlumeckého",
	  "Chorvátska",
	  "Chorvátska",
	  "Iľjušinova",
	  "Ilkovičova",
	  "Inovecká",
	  "Inovecká",
	  "Iskerníková",
	  "Ivana Horvátha",
	  "Ivánska cesta",
	  "J.C.Hronského",
	  "Jabloňová",
	  "Jadrová",
	  "Jakabova",
	  "Jakubovo námestie",
	  "Jamnického",
	  "Jána Stanislava",
	  "Janáčkova",
	  "Jančova",
	  "Janíkove role",
	  "Jankolova",
	  "Jánošíkova",
	  "Jánoškova",
	  "Janotova",
	  "Jánska",
	  "Jantárová cesta",
	  "Jarabinková",
	  "Jarná",
	  "Jaroslavova",
	  "Jarošova",
	  "Jaseňová",
	  "Jasná",
	  "Jasovská",
	  "Jastrabia",
	  "Jašíkova",
	  "Javorinská",
	  "Javorová",
	  "Jazdecká",
	  "Jedlíkova",
	  "Jégého",
	  "Jelačičova",
	  "Jelenia",
	  "Jesenná",
	  "Jesenského",
	  "Jiráskova",
	  "Jiskrova",
	  "Jozefská",
	  "Junácka",
	  "Jungmannova",
	  "Jurigovo námestie",
	  "Jurovského",
	  "Jurská",
	  "Justičná",
	  "K lomu",
	  "K Železnej studienke",
	  "Kalinčiakova",
	  "Kamenárska",
	  "Kamenné námestie",
	  "Kapicova",
	  "Kapitulská",
	  "Kapitulský dvor",
	  "Kapucínska",
	  "Kapušianska",
	  "Karadžičova",
	  "Karadžičova",
	  "Karadžičova",
	  "Karadžičova",
	  "Karloveská",
	  "Karloveské rameno",
	  "Karpatská",
	  "Kašmírska",
	  "Kaštielska",
	  "Kaukazská",
	  "Kempelenova",
	  "Kežmarské námestie",
	  "Kladnianska",
	  "Klariská",
	  "Kláštorská",
	  "Klatovská",
	  "Klatovská",
	  "Klemensova",
	  "Klincová",
	  "Klobučnícka",
	  "Klokočova",
	  "Kľukatá",
	  "Kmeťovo námestie",
	  "Koceľova",
	  "Kočánkova",
	  "Kohútova",
	  "Kolárska",
	  "Kolískova",
	  "Kollárovo námestie",
	  "Kollárovo námestie",
	  "Kolmá",
	  "Komárňanská",
	  "Komárnická",
	  "Komárnická",
	  "Komenského námestie",
	  "Kominárska",
	  "Komonicová",
	  "Konopná",
	  "Konvalinková",
	  "Konventná",
	  "Kopanice",
	  "Kopčianska",
	  "Koperníkova",
	  "Korabinského",
	  "Koreničova",
	  "Kostlivého",
	  "Kostolná",
	  "Košická",
	  "Košická",
	  "Košická",
	  "Kováčska",
	  "Kovorobotnícka",
	  "Kozia",
	  "Koziarka",
	  "Kozmonautická",
	  "Krajná",
	  "Krakovská",
	  "Kráľovské údolie",
	  "Krasinského",
	  "Kraskova",
	  "Krásna",
	  "Krásnohorská",
	  "Krasovského",
	  "Krátka",
	  "Krčméryho",
	  "Kremnická",
	  "Kresánkova",
	  "Krivá",
	  "Križkova",
	  "Krížna",
	  "Krížna",
	  "Krížna",
	  "Krížna",
	  "Krmanova",
	  "Krompašská",
	  "Krupinská",
	  "Krupkova",
	  "Kubániho",
	  "Kubínska",
	  "Kuklovská",
	  "Kukučínova",
	  "Kukuričná",
	  "Kulíškova",
	  "Kultúrna",
	  "Kupeckého",
	  "Kúpeľná",
	  "Kutlíkova",
	  "Kutuzovova",
	  "Kuzmányho",
	  "Kvačalova",
	  "Kvetná",
	  "Kýčerského",
	  "Kyjevská",
	  "Kysucká",
	  "Laborecká",
	  "Lackova",
	  "Ladislava Sáru",
	  "Ľadová",
	  "Lachova",
	  "Ľaliová",
	  "Lamačská cesta",
	  "Lamačská cesta",
	  "Lamanského",
	  "Landererova",
	  "Langsfeldova",
	  "Ľanová",
	  "Laskomerského",
	  "Laučekova",
	  "Laurinská",
	  "Lazaretská",
	  "Lazaretská",
	  "Legerského",
	  "Legionárska",
	  "Legionárska",
	  "Lehockého",
	  "Lehockého",
	  "Lenardova",
	  "Lermontovova",
	  "Lesná",
	  "Leškova",
	  "Letecká",
	  "Letisko M.R.Štefánik",
	  "Letná",
	  "Levárska",
	  "Levická",
	  "Levočská",
	  "Lidická",
	  "Lietavská",
	  "Lichardova",
	  "Lipová",
	  "Lipovinová",
	  "Liptovská",
	  "Listová",
	  "Líščie nivy",
	  "Líščie údolie",
	  "Litovská",
	  "Lodná",
	  "Lombardiniho",
	  "Lomonosovova",
	  "Lopenícka",
	  "Lovinského",
	  "Ľubietovská",
	  "Ľubinská",
	  "Ľubľanská",
	  "Ľubochnianska",
	  "Ľubovnianska",
	  "Lúčna",
	  "Ľudové námestie",
	  "Ľudovíta Fullu",
	  "Luhačovická",
	  "Lužická",
	  "Lužná",
	  "Lýcejná",
	  "Lykovcová",
	  "M. Hella",
	  "Magnetová",
	  "Macharova",
	  "Majakovského",
	  "Majerníkova",
	  "Májkova",
	  "Májová",
	  "Makovického",
	  "Malá",
	  "Malé pálenisko",
	  "Malinová",
	  "Malý Draždiak",
	  "Malý trh",
	  "Mamateyova",
	  "Mamateyova",
	  "Mánesovo námestie",
	  "Mariánska",
	  "Marie Curie-Sklodows",
	  "Márie Medveďovej",
	  "Markova",
	  "Marótyho",
	  "Martákovej",
	  "Martinčekova",
	  "Martinčekova",
	  "Martinengova",
	  "Martinská",
	  "Mateja Bela",
	  "Matejkova",
	  "Matičná",
	  "Matúšova",
	  "Medená",
	  "Medzierka",
	  "Medzilaborecká",
	  "Merlotová",
	  "Mesačná",
	  "Mestská",
	  "Meteorová",
	  "Metodova",
	  "Mickiewiczova",
	  "Mierová",
	  "Michalská",
	  "Mikovíniho",
	  "Mikulášska",
	  "Miletičova",
	  "Miletičova",
	  "Mišíkova",
	  "Mišíkova",
	  "Mišíkova",
	  "Mliekárenská",
	  "Mlynarovičova",
	  "Mlynská dolina",
	  "Mlynská dolina",
	  "Mlynská dolina",
	  "Mlynské luhy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlyny",
	  "Modranská",
	  "Mojmírova",
	  "Mokráň záhon",
	  "Mokrohájska cesta",
	  "Moldavská",
	  "Molecova",
	  "Moravská",
	  "Moskovská",
	  "Most SNP",
	  "Mostová",
	  "Mošovského",
	  "Motýlia",
	  "Moyzesova",
	  "Mozartova",
	  "Mraziarenská",
	  "Mudroňova",
	  "Mudroňova",
	  "Mudroňova",
	  "Muchovo námestie",
	  "Murgašova",
	  "Muškátová",
	  "Muštová",
	  "Múzejná",
	  "Myjavská",
	  "Mýtna",
	  "Mýtna",
	  "Na Baránku",
	  "Na Brezinách",
	  "Na Hrebienku",
	  "Na Kalvárii",
	  "Na Kampárke",
	  "Na kopci",
	  "Na križovatkách",
	  "Na lánoch",
	  "Na paši",
	  "Na piesku",
	  "Na Riviére",
	  "Na Sitine",
	  "Na Slavíne",
	  "Na stráni",
	  "Na Štyridsiatku",
	  "Na úvrati",
	  "Na vŕšku",
	  "Na výslní",
	  "Nábělkova",
	  "Nábrežie arm. gen. L",
	  "Nábrežná",
	  "Nad Dunajom",
	  "Nad lomom",
	  "Nad lúčkami",
	  "Nad lúčkami",
	  "Nad ostrovom",
	  "Nad Sihoťou",
	  "Námestie 1. mája",
	  "Námestie Alexandra D",
	  "Námestie Biely kríž",
	  "Námestie Hraničiarov",
	  "Námestie Jána Pavla",
	  "Námestie Ľudovíta Št",
	  "Námestie Martina Ben",
	  "Nám. M.R.Štefánika",
	  "Námestie slobody",
	  "Námestie slobody",
	  "Námestie SNP",
	  "Námestie SNP",
	  "Námestie sv. Františ",
	  "Narcisová",
	  "Nedbalova",
	  "Nekrasovova",
	  "Neronetová",
	  "Nerudova",
	  "Nevädzová",
	  "Nezábudková",
	  "Niťová",
	  "Nitrianska",
	  "Nížinná",
	  "Nobelova",
	  "Nobelovo námestie",
	  "Nová",
	  "Nová Rožňavská",
	  "Novackého",
	  "Nové pálenisko",
	  "Nové záhrady I",
	  "Nové záhrady II",
	  "Nové záhrady III",
	  "Nové záhrady IV",
	  "Nové záhrady V",
	  "Nové záhrady VI",
	  "Nové záhrady VII",
	  "Novinárska",
	  "Novobanská",
	  "Novohradská",
	  "Novosvetská",
	  "Novosvetská",
	  "Novosvetská",
	  "Obežná",
	  "Obchodná",
	  "Očovská",
	  "Odbojárov",
	  "Odborárska",
	  "Odborárske námestie",
	  "Odborárske námestie",
	  "Ohnicová",
	  "Okánikova",
	  "Okružná",
	  "Olbrachtova",
	  "Olejkárska",
	  "Ondavská",
	  "Ondrejovova",
	  "Oravská",
	  "Orechová cesta",
	  "Orechový rad",
	  "Oriešková",
	  "Ormisova",
	  "Osadná",
	  "Ostravská",
	  "Ostredková",
	  "Osuského",
	  "Osvetová",
	  "Otonelská",
	  "Ovručská",
	  "Ovsištské námestie",
	  "Pajštúnska",
	  "Palackého",
	  "Palárikova",
	  "Palárikova",
	  "Pálavská",
	  "Palisády",
	  "Palisády",
	  "Palisády",
	  "Palkovičova",
	  "Panenská",
	  "Pankúchova",
	  "Panónska cesta",
	  "Panská",
	  "Papánkovo námestie",
	  "Papraďová",
	  "Páričkova",
	  "Parková",
	  "Partizánska",
	  "Pasienky",
	  "Paulínyho",
	  "Pavlovičova",
	  "Pavlovova",
	  "Pavlovská",
	  "Pažického",
	  "Pažítková",
	  "Pečnianska",
	  "Pernecká",
	  "Pestovateľská",
	  "Peterská",
	  "Petzvalova",
	  "Pezinská",
	  "Piesočná",
	  "Piešťanská",
	  "Pifflova",
	  "Pilárikova",
	  "Pionierska",
	  "Pivoňková",
	  "Planckova",
	  "Planét",
	  "Plátenícka",
	  "Pluhová",
	  "Plynárenská",
	  "Plzenská",
	  "Pobrežná",
	  "Pod Bôrikom",
	  "Pod Kalváriou",
	  "Pod lesom",
	  "Pod Rovnicami",
	  "Pod vinicami",
	  "Podhorského",
	  "Podjavorinskej",
	  "Podlučinského",
	  "Podniková",
	  "Podtatranského",
	  "Pohronská",
	  "Polárna",
	  "Poloreckého",
	  "Poľná",
	  "Poľská",
	  "Poludníková",
	  "Porubského",
	  "Poštová",
	  "Považská",
	  "Povraznícka",
	  "Povraznícka",
	  "Pražská",
	  "Predstaničné námesti",
	  "Prepoštská",
	  "Prešernova",
	  "Prešovská",
	  "Prešovská",
	  "Prešovská",
	  "Pri Bielom kríži",
	  "Pri dvore",
	  "Pri Dynamitke",
	  "Pri Habánskom mlyne",
	  "Pri hradnej studni",
	  "Pri seči",
	  "Pri Starej Prachárni",
	  "Pri Starom háji",
	  "Pri Starom Mýte",
	  "Pri strelnici",
	  "Pri Suchom mlyne",
	  "Pri zvonici",
	  "Pribinova",
	  "Pribinova",
	  "Pribinova",
	  "Pribišova",
	  "Pribylinská",
	  "Priečna",
	  "Priekopy",
	  "Priemyselná",
	  "Priemyselná",
	  "Prievozská",
	  "Prievozská",
	  "Prievozská",
	  "Príkopova",
	  "Primaciálne námestie",
	  "Prístav",
	  "Prístavná",
	  "Prokofievova",
	  "Prokopa Veľkého",
	  "Prokopova",
	  "Prúdová",
	  "Prvosienková",
	  "Púpavová",
	  "Pustá",
	  "Puškinova",
	  "Račianska",
	  "Račianska",
	  "Račianske mýto",
	  "Radarová",
	  "Rádiová",
	  "Radlinského",
	  "Radničná",
	  "Radničné námestie",
	  "Radvanská",
	  "Rajská",
	  "Raketová",
	  "Rákosová",
	  "Rastislavova",
	  "Rázusovo nábrežie",
	  "Repná",
	  "Rešetkova",
	  "Revolučná",
	  "Révová",
	  "Revúcka",
	  "Rezedová",
	  "Riazanská",
	  "Riazanská",
	  "Ribayová",
	  "Riečna",
	  "Rigeleho",
	  "Rízlingová",
	  "Riznerova",
	  "Robotnícka",
	  "Romanova",
	  "Röntgenova",
	  "Rosná",
	  "Rovná",
	  "Rovniankova",
	  "Rovníková",
	  "Rozmarínová",
	  "Rožňavská",
	  "Rožňavská",
	  "Rožňavská",
	  "Rubinsteinova",
	  "Rudnayovo námestie",
	  "Rumančeková",
	  "Rusovská cesta",
	  "Ružičková",
	  "Ružinovská",
	  "Ružinovská",
	  "Ružinovská",
	  "Ružomberská",
	  "Ružová dolina",
	  "Ružová dolina",
	  "Rybárska brána",
	  "Rybné námestie",
	  "Rýdziková",
	  "Sabinovská",
	  "Sabinovská",
	  "Sad Janka Kráľa",
	  "Sadová",
	  "Sartorisova",
	  "Sasinkova",
	  "Seberíniho",
	  "Sečovská",
	  "Sedlárska",
	  "Sedmokrásková",
	  "Segnerova",
	  "Sekulská",
	  "Semianova",
	  "Senická",
	  "Senná",
	  "Schillerova",
	  "Schody pri starej vo",
	  "Sibírska",
	  "Sienkiewiczova",
	  "Silvánska",
	  "Sinokvetná",
	  "Skalická cesta",
	  "Skalná",
	  "Sklenárova",
	  "Sklenárska",
	  "Sládkovičova",
	  "Sladová",
	  "Slávičie údolie",
	  "Slavín",
	  "Slepá",
	  "Sliačska",
	  "Sliezska",
	  "Slivková",
	  "Slnečná",
	  "Slovanská",
	  "Slovinská",
	  "Slovnaftská",
	  "Slowackého",
	  "Smetanova",
	  "Smikova",
	  "Smolenická",
	  "Smolnícka",
	  "Smrečianska",
	  "Soferove schody",
	  "Socháňova",
	  "Sokolská",
	  "Solivarská",
	  "Sološnická",
	  "Somolického",
	  "Somolického",
	  "Sosnová",
	  "Spišská",
	  "Spojná",
	  "Spoločenská",
	  "Sputniková",
	  "Sreznevského",
	  "Srnčia",
	  "Stachanovská",
	  "Stálicová",
	  "Staničná",
	  "Stará Černicová",
	  "Stará Ivánska cesta",
	  "Stará Prievozská",
	  "Stará Vajnorská",
	  "Stará vinárska",
	  "Staré Grunty",
	  "Staré ihrisko",
	  "Staré záhrady",
	  "Starhradská",
	  "Starohájska",
	  "Staromestská",
	  "Staroturský chodník",
	  "Staviteľská",
	  "Stodolova",
	  "Stoklasová",
	  "Strakova",
	  "Strážnická",
	  "Strážny dom",
	  "Strečnianska",
	  "Stredná",
	  "Strelecká",
	  "Strmá cesta",
	  "Strojnícka",
	  "Stropkovská",
	  "Struková",
	  "Studená",
	  "Stuhová",
	  "Súbežná",
	  "Súhvezdná",
	  "Suché mýto",
	  "Suchohradská",
	  "Súkennícka",
	  "Súľovská",
	  "Sumbalova",
	  "Súmračná",
	  "Súťažná",
	  "Svätého Vincenta",
	  "Svätoplukova",
	  "Svätoplukova",
	  "Svätovojtešská",
	  "Svetlá",
	  "Svíbová",
	  "Svidnícka",
	  "Svoradova",
	  "Svrčia",
	  "Syslia",
	  "Šafárikovo námestie",
	  "Šafárikovo námestie",
	  "Šafránová",
	  "Šagátova",
	  "Šalviová",
	  "Šancová",
	  "Šancová",
	  "Šancová",
	  "Šancová",
	  "Šándorova",
	  "Šarišská",
	  "Šášovská",
	  "Šaštínska",
	  "Ševčenkova",
	  "Šintavská",
	  "Šípková",
	  "Škarniclova",
	  "Školská",
	  "Škovránčia",
	  "Škultétyho",
	  "Šoltésovej",
	  "Špieszova",
	  "Špitálska",
	  "Športová",
	  "Šrobárovo námestie",
	  "Šťastná",
	  "Štedrá",
	  "Štefánikova",
	  "Štefánikova",
	  "Štefánikova",
	  "Štefanovičova",
	  "Štefunkova",
	  "Štetinova",
	  "Štiavnická",
	  "Štúrova",
	  "Štyndlova",
	  "Šulekova",
	  "Šulekova",
	  "Šulekova",
	  "Šumavská",
	  "Šuňavcova",
	  "Šustekova",
	  "Švabinského",
	  "Tabaková",
	  "Tablicova",
	  "Táborská",
	  "Tajovského",
	  "Tallerova",
	  "Tehelná",
	  "Technická",
	  "Tekovská",
	  "Telocvičná",
	  "Tematínska",
	  "Teplická",
	  "Terchovská",
	  "Teslova",
	  "Tetmayerova",
	  "Thurzova",
	  "Tichá",
	  "Tilgnerova",
	  "Timravina",
	  "Tobrucká",
	  "Tokajícka",
	  "Tolstého",
	  "Tománkova",
	  "Tomášikova",
	  "Tomášikova",
	  "Tomášikova",
	  "Tomášikova",
	  "Tomášikova",
	  "Topoľčianska",
	  "Topoľová",
	  "Továrenská",
	  "Trebišovská",
	  "Trebišovská",
	  "Trebišovská",
	  "Trenčianska",
	  "Treskoňova",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavské mýto",
	  "Tŕňová",
	  "Trojdomy",
	  "Tučkova",
	  "Tupolevova",
	  "Turbínova",
	  "Turčianska",
	  "Turnianska",
	  "Tvarožkova",
	  "Tylova",
	  "Tyršovo nábrežie",
	  "Údernícka",
	  "Údolná",
	  "Uhorková",
	  "Ukrajinská",
	  "Ulica 29. augusta",
	  "Ulica 29. augusta",
	  "Ulica 29. augusta",
	  "Ulica 29. augusta",
	  "Ulica Imricha Karvaš",
	  "Ulica Jozefa Krónera",
	  "Ulica Viktora Tegelh",
	  "Úprkova",
	  "Úradnícka",
	  "Uránová",
	  "Urbánkova",
	  "Ursínyho",
	  "Uršulínska",
	  "Úzka",
	  "V záhradách",
	  "Vajanského nábrežie",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Valašská",
	  "Valchárska",
	  "Vansovej",
	  "Vápenná",
	  "Varínska",
	  "Varšavská",
	  "Varšavská",
	  "Vavilovova",
	  "Vavrínova",
	  "Vazovova",
	  "Včelárska",
	  "Velehradská",
	  "Veltlínska",
	  "Ventúrska",
	  "Veterná",
	  "Veternicová",
	  "Vetvová",
	  "Viedenská cesta",
	  "Viedenská cesta",
	  "Vietnamská",
	  "Vígľašská",
	  "Vihorlatská",
	  "Viktorínova",
	  "Vilová",
	  "Vincenta Hložníka",
	  "Vínna",
	  "Vlastenecké námestie",
	  "Vlčkova",
	  "Vlčkova",
	  "Vlčkova",
	  "Vodný vrch",
	  "Votrubova",
	  "Vrábeľská",
	  "Vrakunská cesta",
	  "Vranovská",
	  "Vretenová",
	  "Vrchná",
	  "Vrútocká",
	  "Vyhliadka",
	  "Vyhnianska cesta",
	  "Vysoká",
	  "Vyšehradská",
	  "Vyšná",
	  "Wattova",
	  "Wilsonova",
	  "Wolkrova",
	  "Za Kasárňou",
	  "Za sokolovňou",
	  "Za Stanicou",
	  "Za tehelňou",
	  "Záborského",
	  "Zadunajská cesta",
	  "Záhorácka",
	  "Záhradnícka",
	  "Záhradnícka",
	  "Záhradnícka",
	  "Záhradnícka",
	  "Záhrebská",
	  "Záhrebská",
	  "Zálužická",
	  "Zámocká",
	  "Zámocké schody",
	  "Zámočnícka",
	  "Západná",
	  "Západný rad",
	  "Záporožská",
	  "Zátišie",
	  "Závodníkova",
	  "Zelená",
	  "Zelinárska",
	  "Zimná",
	  "Zlaté piesky",
	  "Zlaté schody",
	  "Znievska",
	  "Zohorská",
	  "Zochova",
	  "Zrinského",
	  "Zvolenská",
	  "Žabí majer",
	  "Žabotova",
	  "Žehrianska",
	  "Železná",
	  "Železničiarska",
	  "Žellova",
	  "Žiarska",
	  "Židovská",
	  "Žilinská",
	  "Žilinská",
	  "Živnostenská",
	  "Žižkova",
	  "Župné námestie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacific/Midway",
	  "Pacific/Pago_Pago",
	  "Pacific/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europe/Dublin",
	  "Europe/London",
	  "Europe/Lisbon",
	  "Europe/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europe/Belgrade",
	  "Europe/Bratislava",
	  "Europe/Budapest",
	  "Europe/Ljubljana",
	  "Europe/Prague",
	  "Europe/Sarajevo",
	  "Europe/Skopje",
	  "Europe/Warsaw",
	  "Europe/Zagreb",
	  "Europe/Brussels",
	  "Europe/Copenhagen",
	  "Europe/Madrid",
	  "Europe/Paris",
	  "Europe/Amsterdam",
	  "Europe/Berlin",
	  "Europe/Berlin",
	  "Europe/Rome",
	  "Europe/Stockholm",
	  "Europe/Vienna",
	  "Africa/Algiers",
	  "Europe/Bucharest",
	  "Africa/Cairo",
	  "Europe/Helsinki",
	  "Europe/Kiev",
	  "Europe/Riga",
	  "Europe/Sofia",
	  "Europe/Tallinn",
	  "Europe/Vilnius",
	  "Europe/Athens",
	  "Europe/Istanbul",
	  "Europe/Minsk",
	  "Asia/Jerusalem",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacific/Guam",
	  "Pacific/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacific/Noumea",
	  "Pacific/Fiji",
	  "Asia/Kamchatka",
	  "Pacific/Majuro",
	  "Pacific/Auckland",
	  "Pacific/Auckland",
	  "Pacific/Tongatapu",
	  "Pacific/Fakaofo",
	  "Pacific/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich",
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1516);
	company.adjective = __webpack_require__(1509);
	company.descriptor = __webpack_require__(1512);
	company.noun = __webpack_require__(1515);
	company.bs_verb = __webpack_require__(1511);
	company.bs_noun = __webpack_require__(1510);
	company.name = __webpack_require__(1514);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} #{suffix}",
	  "#{Name.man_last_name} a #{Name.man_last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "s.r.o.",
	  "a.s.",
	  "v.o.s."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var sk = {};
	module['exports'] = sk;
	sk.title = "Slovakian";
	sk.address = __webpack_require__(1500);
	sk.company = __webpack_require__(1513);
	sk.internet = __webpack_require__(1520);
	sk.lorem = __webpack_require__(1521);
	sk.name = __webpack_require__(1526);
	sk.phone_number = __webpack_require__(1534);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "sk",
	  "com",
	  "net",
	  "eu",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "zoznam.sk",
	  "azet.sk"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1519);
	internet.domain_suffix = __webpack_require__(1518);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1523);
	lorem.supplemental = __webpack_require__(1522);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alexandra",
	  "Karina",
	  "Daniela",
	  "Andrea",
	  "Antónia",
	  "Bohuslava",
	  "Dáša",
	  "Malvína",
	  "Kristína",
	  "Nataša",
	  "Bohdana",
	  "Drahomíra",
	  "Sára",
	  "Zora",
	  "Tamara",
	  "Ema",
	  "Tatiana",
	  "Erika",
	  "Veronika",
	  "Agáta",
	  "Dorota",
	  "Vanda",
	  "Zoja",
	  "Gabriela",
	  "Perla",
	  "Ida",
	  "Liana",
	  "Miloslava",
	  "Vlasta",
	  "Lívia",
	  "Eleonóra",
	  "Etela",
	  "Romana",
	  "Zlatica",
	  "Anežka",
	  "Bohumila",
	  "Františka",
	  "Angela",
	  "Matilda",
	  "Svetlana",
	  "Ľubica",
	  "Alena",
	  "Soňa",
	  "Vieroslava",
	  "Zita",
	  "Miroslava",
	  "Irena",
	  "Milena",
	  "Estera",
	  "Justína",
	  "Dana",
	  "Danica",
	  "Jela",
	  "Jaroslava",
	  "Jarmila",
	  "Lea",
	  "Anastázia",
	  "Galina",
	  "Lesana",
	  "Hermína",
	  "Monika",
	  "Ingrida",
	  "Viktória",
	  "Blažena",
	  "Žofia",
	  "Sofia",
	  "Gizela",
	  "Viola",
	  "Gertrúda",
	  "Zina",
	  "Júlia",
	  "Juliana",
	  "Želmíra",
	  "Ela",
	  "Vanesa",
	  "Iveta",
	  "Vilma",
	  "Petronela",
	  "Žaneta",
	  "Xénia",
	  "Karolína",
	  "Lenka",
	  "Laura",
	  "Stanislava",
	  "Margaréta",
	  "Dobroslava",
	  "Blanka",
	  "Valéria",
	  "Paulína",
	  "Sidónia",
	  "Adriána",
	  "Beáta",
	  "Petra",
	  "Melánia",
	  "Diana",
	  "Berta",
	  "Patrícia",
	  "Lujza",
	  "Amália",
	  "Milota",
	  "Nina",
	  "Margita",
	  "Kamila",
	  "Dušana",
	  "Magdaléna",
	  "Oľga",
	  "Anna",
	  "Hana",
	  "Božena",
	  "Marta",
	  "Libuša",
	  "Božidara",
	  "Dominika",
	  "Hortenzia",
	  "Jozefína",
	  "Štefánia",
	  "Ľubomíra",
	  "Zuzana",
	  "Darina",
	  "Marcela",
	  "Milica",
	  "Elena",
	  "Helena",
	  "Lýdia",
	  "Anabela",
	  "Jana",
	  "Silvia",
	  "Nikola",
	  "Ružena",
	  "Nora",
	  "Drahoslava",
	  "Linda",
	  "Melinda",
	  "Rebeka",
	  "Rozália",
	  "Regína",
	  "Alica",
	  "Marianna",
	  "Miriama",
	  "Martina",
	  "Mária",
	  "Jolana",
	  "Ľudomila",
	  "Ľudmila",
	  "Olympia",
	  "Eugénia",
	  "Ľuboslava",
	  "Zdenka",
	  "Edita",
	  "Michaela",
	  "Stela",
	  "Viera",
	  "Natália",
	  "Eliška",
	  "Brigita",
	  "Valentína",
	  "Terézia",
	  "Vladimíra",
	  "Hedviga",
	  "Uršuľa",
	  "Alojza",
	  "Kvetoslava",
	  "Sabína",
	  "Dobromila",
	  "Klára",
	  "Simona",
	  "Aurélia",
	  "Denisa",
	  "Renáta",
	  "Irma",
	  "Agnesa",
	  "Klaudia",
	  "Alžbeta",
	  "Elvíra",
	  "Cecília",
	  "Emília",
	  "Katarína",
	  "Henrieta",
	  "Bibiána",
	  "Barbora",
	  "Marína",
	  "Izabela",
	  "Hilda",
	  "Otília",
	  "Lucia",
	  "Branislava",
	  "Bronislava",
	  "Ivica",
	  "Albína",
	  "Kornélia",
	  "Sláva",
	  "Slávka",
	  "Judita",
	  "Dagmara",
	  "Adela",
	  "Nadežda",
	  "Eva",
	  "Filoména",
	  "Ivana",
	  "Milada"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Antalová",
	  "Babková",
	  "Bahnová",
	  "Balážová",
	  "Baranová",
	  "Baranková",
	  "Bartovičová",
	  "Bartošová",
	  "Bačová",
	  "Bernoláková",
	  "Beňová",
	  "Biceková",
	  "Bieliková",
	  "Blahová",
	  "Bondrová",
	  "Bosáková",
	  "Bošková",
	  "Brezinová",
	  "Bukovská",
	  "Chalupková",
	  "Chudíková",
	  "Cibulová",
	  "Cibulková",
	  "Cyprichová",
	  "Cígerová",
	  "Danková",
	  "Daňková",
	  "Daňová",
	  "Debnárová",
	  "Dejová",
	  "Dekýšová",
	  "Doležalová",
	  "Dočolomanská",
	  "Droppová",
	  "Dubovská",
	  "Dudeková",
	  "Dulová",
	  "Dullová",
	  "Dusíková",
	  "Dvončová",
	  "Dzurjaninová",
	  "Dávidová",
	  "Fabianová",
	  "Fabiánová",
	  "Fajnorová",
	  "Farkašovská",
	  "Ficová",
	  "Filcová",
	  "Filipová",
	  "Finková",
	  "Ftoreková",
	  "Gašparová",
	  "Gašparovičová",
	  "Gocníková",
	  "Gregorová",
	  "Gregušová",
	  "Grznárová",
	  "Habláková",
	  "Habšudová",
	  "Haldová",
	  "Halušková",
	  "Haláková",
	  "Hanková",
	  "Hanzalová",
	  "Haščáková",
	  "Heretiková",
	  "Hečková",
	  "Hlaváčeková",
	  "Hlinková",
	  "Holubová",
	  "Holubyová",
	  "Hossová",
	  "Hozová",
	  "Hrašková",
	  "Hricová",
	  "Hrmová",
	  "Hrušovská",
	  "Hubová",
	  "Ihnačáková",
	  "Janečeková",
	  "Janošková",
	  "Jantošovičová",
	  "Janíková",
	  "Jančeková",
	  "Jedľovská",
	  "Jendeková",
	  "Jonatová",
	  "Jurinová",
	  "Jurkovičová",
	  "Juríková",
	  "Jánošíková",
	  "Kafendová",
	  "Kaliská",
	  "Karulová",
	  "Kenížová",
	  "Klapková",
	  "Kmeťová",
	  "Kolesárová",
	  "Kollárová",
	  "Kolniková",
	  "Kolníková",
	  "Kolárová",
	  "Korecová",
	  "Kostkaová",
	  "Kostrecová",
	  "Kováčová",
	  "Kováčiková",
	  "Kozová",
	  "Kočišová",
	  "Krajíčeková",
	  "Krajčová",
	  "Krajčovičová",
	  "Krajčírová",
	  "Králiková",
	  "Krúpová",
	  "Kubíková",
	  "Kyseľová",
	  "Kállayová",
	  "Labudová",
	  "Lepšíková",
	  "Liptáková",
	  "Lisická",
	  "Lubinová",
	  "Lukáčová",
	  "Luptáková",
	  "Líšková",
	  "Madejová",
	  "Majeská",
	  "Malachovská",
	  "Malíšeková",
	  "Mamojková",
	  "Marcinková",
	  "Mariánová",
	  "Masaryková",
	  "Maslová",
	  "Matiašková",
	  "Medveďová",
	  "Melcerová",
	  "Mečiarová",
	  "Michalíková",
	  "Mihaliková",
	  "Mihálová",
	  "Miháliková",
	  "Miklošková",
	  "Mikulíková",
	  "Mikušová",
	  "Mikúšová",
	  "Milotová",
	  "Mináčová",
	  "Mišíková",
	  "Mojžišová",
	  "Mokrošová",
	  "Morová",
	  "Moravčíková",
	  "Mydlová",
	  "Nemcová",
	  "Nováková",
	  "Obšutová",
	  "Ondrušová",
	  "Otčenášová",
	  "Pauková",
	  "Pavlikovská",
	  "Pavúková",
	  "Pašeková",
	  "Pašková",
	  "Pelikánová",
	  "Petrovická",
	  "Petrušková",
	  "Pešková",
	  "Plchová",
	  "Plekanecová",
	  "Podhradská",
	  "Podkonická",
	  "Poliaková",
	  "Pupáková",
	  "Raková",
	  "Repiská",
	  "Romančíková",
	  "Rusová",
	  "Ružičková",
	  "Rybníčeková",
	  "Rybárová",
	  "Rybáriková",
	  "Samsonová",
	  "Sedliaková",
	  "Senková",
	  "Sklenková",
	  "Skokanová",
	  "Skutecká",
	  "Slašťanová",
	  "Slobodová",
	  "Slobodníková",
	  "Slotová",
	  "Slováková",
	  "Smreková",
	  "Stodolová",
	  "Straková",
	  "Strnisková",
	  "Svrbíková",
	  "Sámelová",
	  "Sýkorová",
	  "Tatarová",
	  "Tatarková",
	  "Tatárová",
	  "Tatárkaová",
	  "Thomková",
	  "Tomečeková",
	  "Tomková",
	  "Trubenová",
	  "Turčoková",
	  "Uramová",
	  "Urblíková",
	  "Vajcíková",
	  "Vajdová",
	  "Valachová",
	  "Valachovičová",
	  "Valentová",
	  "Valušková",
	  "Vaneková",
	  "Veselová",
	  "Vicenová",
	  "Višňovská",
	  "Vlachová",
	  "Vojteková",
	  "Vydarená",
	  "Zajacová",
	  "Zimová",
	  "Zimková",
	  "Záborská",
	  "Zúbriková",
	  "Čapkovičová",
	  "Čaplovičová",
	  "Čarnogurská",
	  "Čierná",
	  "Čobrdová",
	  "Ďaďová",
	  "Ďuricová",
	  "Ďurišová",
	  "Šidlová",
	  "Šimonovičová",
	  "Škriniarová",
	  "Škultétyová",
	  "Šmajdová",
	  "Šoltésová",
	  "Šoltýsová",
	  "Štefanová",
	  "Štefanková",
	  "Šulcová",
	  "Šurková",
	  "Švehlová",
	  "Šťastná"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(1527);
	name.female_first_name = __webpack_require__(1524);
	name.male_last_name = __webpack_require__(1528);
	name.female_last_name = __webpack_require__(1525);
	name.prefix = __webpack_require__(1530);
	name.suffix = __webpack_require__(1531);
	name.title = __webpack_require__(1532);
	name.name = __webpack_require__(1529);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Drahoslav",
	  "Severín",
	  "Alexej",
	  "Ernest",
	  "Rastislav",
	  "Radovan",
	  "Dobroslav",
	  "Dalibor",
	  "Vincent",
	  "Miloš",
	  "Timotej",
	  "Gejza",
	  "Bohuš",
	  "Alfonz",
	  "Gašpar",
	  "Emil",
	  "Erik",
	  "Blažej",
	  "Zdenko",
	  "Dezider",
	  "Arpád",
	  "Valentín",
	  "Pravoslav",
	  "Jaromír",
	  "Roman",
	  "Matej",
	  "Frederik",
	  "Viktor",
	  "Alexander",
	  "Radomír",
	  "Albín",
	  "Bohumil",
	  "Kazimír",
	  "Fridrich",
	  "Radoslav",
	  "Tomáš",
	  "Alan",
	  "Branislav",
	  "Bruno",
	  "Gregor",
	  "Vlastimil",
	  "Boleslav",
	  "Eduard",
	  "Jozef",
	  "Víťazoslav",
	  "Blahoslav",
	  "Beňadik",
	  "Adrián",
	  "Gabriel",
	  "Marián",
	  "Emanuel",
	  "Miroslav",
	  "Benjamín",
	  "Hugo",
	  "Richard",
	  "Izidor",
	  "Zoltán",
	  "Albert",
	  "Igor",
	  "Július",
	  "Aleš",
	  "Fedor",
	  "Rudolf",
	  "Valér",
	  "Marcel",
	  "Ervín",
	  "Slavomír",
	  "Vojtech",
	  "Juraj",
	  "Marek",
	  "Jaroslav",
	  "Žigmund",
	  "Florián",
	  "Roland",
	  "Pankrác",
	  "Servác",
	  "Bonifác",
	  "Svetozár",
	  "Bernard",
	  "Júlia",
	  "Urban",
	  "Dušan",
	  "Viliam",
	  "Ferdinand",
	  "Norbert",
	  "Róbert",
	  "Medard",
	  "Zlatko",
	  "Anton",
	  "Vasil",
	  "Vít",
	  "Adolf",
	  "Vratislav",
	  "Alfréd",
	  "Alojz",
	  "Ján",
	  "Tadeáš",
	  "Ladislav",
	  "Peter",
	  "Pavol",
	  "Miloslav",
	  "Prokop",
	  "Cyril",
	  "Metod",
	  "Patrik",
	  "Oliver",
	  "Ivan",
	  "Kamil",
	  "Henrich",
	  "Drahomír",
	  "Bohuslav",
	  "Iľja",
	  "Daniel",
	  "Vladimír",
	  "Jakub",
	  "Krištof",
	  "Ignác",
	  "Gustáv",
	  "Jerguš",
	  "Dominik",
	  "Oskar",
	  "Vavrinec",
	  "Ľubomír",
	  "Mojmír",
	  "Leonard",
	  "Tichomír",
	  "Filip",
	  "Bartolomej",
	  "Ľudovít",
	  "Samuel",
	  "Augustín",
	  "Belo",
	  "Oleg",
	  "Bystrík",
	  "Ctibor",
	  "Ľudomil",
	  "Konštantín",
	  "Ľuboslav",
	  "Matúš",
	  "Móric",
	  "Ľuboš",
	  "Ľubor",
	  "Vladislav",
	  "Cyprián",
	  "Václav",
	  "Michal",
	  "Jarolím",
	  "Arnold",
	  "Levoslav",
	  "František",
	  "Dionýz",
	  "Maximilián",
	  "Koloman",
	  "Boris",
	  "Lukáš",
	  "Kristián",
	  "Vendelín",
	  "Sergej",
	  "Aurel",
	  "Demeter",
	  "Denis",
	  "Hubert",
	  "Karol",
	  "Imrich",
	  "René",
	  "Bohumír",
	  "Teodor",
	  "Tibor",
	  "Maroš",
	  "Martin",
	  "Svätopluk",
	  "Stanislav",
	  "Leopold",
	  "Eugen",
	  "Félix",
	  "Klement",
	  "Kornel",
	  "Milan",
	  "Vratko",
	  "Ondrej",
	  "Andrej",
	  "Edmund",
	  "Oldrich",
	  "Oto",
	  "Mikuláš",
	  "Ambróz",
	  "Radúz",
	  "Bohdan",
	  "Adam",
	  "Štefan",
	  "Dávid",
	  "Silvester"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Antal",
	  "Babka",
	  "Bahna",
	  "Bahno",
	  "Baláž",
	  "Baran",
	  "Baranka",
	  "Bartovič",
	  "Bartoš",
	  "Bača",
	  "Bernolák",
	  "Beňo",
	  "Bicek",
	  "Bielik",
	  "Blaho",
	  "Bondra",
	  "Bosák",
	  "Boška",
	  "Brezina",
	  "Bukovský",
	  "Chalupka",
	  "Chudík",
	  "Cibula",
	  "Cibulka",
	  "Cibuľa",
	  "Cyprich",
	  "Cíger",
	  "Danko",
	  "Daňko",
	  "Daňo",
	  "Debnár",
	  "Dej",
	  "Dekýš",
	  "Doležal",
	  "Dočolomanský",
	  "Droppa",
	  "Dubovský",
	  "Dudek",
	  "Dula",
	  "Dulla",
	  "Dusík",
	  "Dvonč",
	  "Dzurjanin",
	  "Dávid",
	  "Fabian",
	  "Fabián",
	  "Fajnor",
	  "Farkašovský",
	  "Fico",
	  "Filc",
	  "Filip",
	  "Finka",
	  "Ftorek",
	  "Gašpar",
	  "Gašparovič",
	  "Gocník",
	  "Gregor",
	  "Greguš",
	  "Grznár",
	  "Hablák",
	  "Habšuda",
	  "Halda",
	  "Haluška",
	  "Halák",
	  "Hanko",
	  "Hanzal",
	  "Haščák",
	  "Heretik",
	  "Hečko",
	  "Hlaváček",
	  "Hlinka",
	  "Holub",
	  "Holuby",
	  "Hossa",
	  "Hoza",
	  "Hraško",
	  "Hric",
	  "Hrmo",
	  "Hrušovský",
	  "Huba",
	  "Ihnačák",
	  "Janeček",
	  "Janoška",
	  "Jantošovič",
	  "Janík",
	  "Janček",
	  "Jedľovský",
	  "Jendek",
	  "Jonata",
	  "Jurina",
	  "Jurkovič",
	  "Jurík",
	  "Jánošík",
	  "Kafenda",
	  "Kaliský",
	  "Karul",
	  "Keníž",
	  "Klapka",
	  "Kmeť",
	  "Kolesár",
	  "Kollár",
	  "Kolnik",
	  "Kolník",
	  "Kolár",
	  "Korec",
	  "Kostka",
	  "Kostrec",
	  "Kováč",
	  "Kováčik",
	  "Koza",
	  "Kočiš",
	  "Krajíček",
	  "Krajči",
	  "Krajčo",
	  "Krajčovič",
	  "Krajčír",
	  "Králik",
	  "Krúpa",
	  "Kubík",
	  "Kyseľ",
	  "Kállay",
	  "Labuda",
	  "Lepšík",
	  "Lipták",
	  "Lisický",
	  "Lubina",
	  "Lukáč",
	  "Lupták",
	  "Líška",
	  "Madej",
	  "Majeský",
	  "Malachovský",
	  "Malíšek",
	  "Mamojka",
	  "Marcinko",
	  "Marián",
	  "Masaryk",
	  "Maslo",
	  "Matiaško",
	  "Medveď",
	  "Melcer",
	  "Mečiar",
	  "Michalík",
	  "Mihalik",
	  "Mihál",
	  "Mihálik",
	  "Mikloško",
	  "Mikulík",
	  "Mikuš",
	  "Mikúš",
	  "Milota",
	  "Mináč",
	  "Mišík",
	  "Mojžiš",
	  "Mokroš",
	  "Mora",
	  "Moravčík",
	  "Mydlo",
	  "Nemec",
	  "Nitra",
	  "Novák",
	  "Obšut",
	  "Ondruš",
	  "Otčenáš",
	  "Pauko",
	  "Pavlikovský",
	  "Pavúk",
	  "Pašek",
	  "Paška",
	  "Paško",
	  "Pelikán",
	  "Petrovický",
	  "Petruška",
	  "Peško",
	  "Plch",
	  "Plekanec",
	  "Podhradský",
	  "Podkonický",
	  "Poliak",
	  "Pupák",
	  "Rak",
	  "Repiský",
	  "Romančík",
	  "Rus",
	  "Ružička",
	  "Rybníček",
	  "Rybár",
	  "Rybárik",
	  "Samson",
	  "Sedliak",
	  "Senko",
	  "Sklenka",
	  "Skokan",
	  "Skutecký",
	  "Slašťan",
	  "Sloboda",
	  "Slobodník",
	  "Slota",
	  "Slovák",
	  "Smrek",
	  "Stodola",
	  "Straka",
	  "Strnisko",
	  "Svrbík",
	  "Sámel",
	  "Sýkora",
	  "Tatar",
	  "Tatarka",
	  "Tatár",
	  "Tatárka",
	  "Thomka",
	  "Tomeček",
	  "Tomka",
	  "Tomko",
	  "Truben",
	  "Turčok",
	  "Uram",
	  "Urblík",
	  "Vajcík",
	  "Vajda",
	  "Valach",
	  "Valachovič",
	  "Valent",
	  "Valuška",
	  "Vanek",
	  "Vesel",
	  "Vicen",
	  "Višňovský",
	  "Vlach",
	  "Vojtek",
	  "Vydarený",
	  "Zajac",
	  "Zima",
	  "Zimka",
	  "Záborský",
	  "Zúbrik",
	  "Čapkovič",
	  "Čaplovič",
	  "Čarnogurský",
	  "Čierny",
	  "Čobrda",
	  "Ďaďo",
	  "Ďurica",
	  "Ďuriš",
	  "Šidlo",
	  "Šimonovič",
	  "Škriniar",
	  "Škultéty",
	  "Šmajda",
	  "Šoltés",
	  "Šoltýs",
	  "Štefan",
	  "Štefanka",
	  "Šulc",
	  "Šurka",
	  "Švehla",
	  "Šťastný"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{man_first_name} #{man_last_name}",
	  "#{prefix} #{woman_first_name} #{woman_last_name}",
	  "#{man_first_name} #{man_last_name} #{suffix}",
	  "#{woman_first_name} #{woman_last_name} #{suffix}",
	  "#{man_first_name} #{man_last_name}",
	  "#{man_first_name} #{man_last_name}",
	  "#{man_first_name} #{man_last_name}",
	  "#{woman_first_name} #{woman_last_name}",
	  "#{woman_first_name} #{woman_last_name}",
	  "#{woman_first_name} #{woman_last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ing.",
	  "Mgr.",
	  "JUDr.",
	  "MUDr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Phd."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "09## ### ###",
	  "0## #### ####",
	  "0# #### ####",
	  "+421 ### ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1533);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Söder",
	  "Norr",
	  "Väst",
	  "Öster",
	  "Aling",
	  "Ar",
	  "Av",
	  "Bo",
	  "Br",
	  "Bå",
	  "Ek",
	  "En",
	  "Esk",
	  "Fal",
	  "Gäv",
	  "Göte",
	  "Ha",
	  "Helsing",
	  "Karl",
	  "Krist",
	  "Kram",
	  "Kung",
	  "Kö",
	  "Lyck",
	  "Ny"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "stad",
	  "land",
	  "sås",
	  "ås",
	  "holm",
	  "tuna",
	  "sta",
	  "berg",
	  "löv",
	  "borg",
	  "mora",
	  "hamn",
	  "fors",
	  "köping",
	  "by",
	  "hult",
	  "torp",
	  "fred",
	  "vik"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "s Väg",
	  "s Gata"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ryssland",
	  "Kanada",
	  "Kina",
	  "USA",
	  "Brasilien",
	  "Australien",
	  "Indien",
	  "Argentina",
	  "Kazakstan",
	  "Algeriet",
	  "DR Kongo",
	  "Danmark",
	  "Färöarna",
	  "Grönland",
	  "Saudiarabien",
	  "Mexiko",
	  "Indonesien",
	  "Sudan",
	  "Libyen",
	  "Iran",
	  "Mongoliet",
	  "Peru",
	  "Tchad",
	  "Niger",
	  "Angola",
	  "Mali",
	  "Sydafrika",
	  "Colombia",
	  "Etiopien",
	  "Bolivia",
	  "Mauretanien",
	  "Egypten",
	  "Tanzania",
	  "Nigeria",
	  "Venezuela",
	  "Namibia",
	  "Pakistan",
	  "Moçambique",
	  "Turkiet",
	  "Chile",
	  "Zambia",
	  "Marocko",
	  "Västsahara",
	  "Burma",
	  "Afghanistan",
	  "Somalia",
	  "Centralafrikanska republiken",
	  "Sydsudan",
	  "Ukraina",
	  "Botswana",
	  "Madagaskar",
	  "Kenya",
	  "Frankrike",
	  "Franska Guyana",
	  "Jemen",
	  "Thailand",
	  "Spanien",
	  "Turkmenistan",
	  "Kamerun",
	  "Papua Nya Guinea",
	  "Sverige",
	  "Uzbekistan",
	  "Irak",
	  "Paraguay",
	  "Zimbabwe",
	  "Japan",
	  "Tyskland",
	  "Kongo",
	  "Finland",
	  "Malaysia",
	  "Vietnam",
	  "Norge",
	  "Svalbard",
	  "Jan Mayen",
	  "Elfenbenskusten",
	  "Polen",
	  "Italien",
	  "Filippinerna",
	  "Ecuador",
	  "Burkina Faso",
	  "Nya Zeeland",
	  "Gabon",
	  "Guinea",
	  "Storbritannien",
	  "Ghana",
	  "Rumänien",
	  "Laos",
	  "Uganda",
	  "Guyana",
	  "Oman",
	  "Vitryssland",
	  "Kirgizistan",
	  "Senegal",
	  "Syrien",
	  "Kambodja",
	  "Uruguay",
	  "Tunisien",
	  "Surinam",
	  "Nepal",
	  "Bangladesh",
	  "Tadzjikistan",
	  "Grekland",
	  "Nicaragua",
	  "Eritrea",
	  "Nordkorea",
	  "Malawi",
	  "Benin",
	  "Honduras",
	  "Liberia",
	  "Bulgarien",
	  "Kuba",
	  "Guatemala",
	  "Island",
	  "Sydkorea",
	  "Ungern",
	  "Portugal",
	  "Jordanien",
	  "Serbien",
	  "Azerbajdzjan",
	  "Österrike",
	  "Förenade Arabemiraten",
	  "Tjeckien",
	  "Panama",
	  "Sierra Leone",
	  "Irland",
	  "Georgien",
	  "Sri Lanka",
	  "Litauen",
	  "Lettland",
	  "Togo",
	  "Kroatien",
	  "Bosnien och Hercegovina",
	  "Costa Rica",
	  "Slovakien",
	  "Dominikanska republiken",
	  "Bhutan",
	  "Estland",
	  "Danmark",
	  "Färöarna",
	  "Grönland",
	  "Nederländerna",
	  "Schweiz",
	  "Guinea-Bissau",
	  "Taiwan",
	  "Moldavien",
	  "Belgien",
	  "Lesotho",
	  "Armenien",
	  "Albanien",
	  "Salomonöarna",
	  "Ekvatorialguinea",
	  "Burundi",
	  "Haiti",
	  "Rwanda",
	  "Makedonien",
	  "Djibouti",
	  "Belize",
	  "Israel",
	  "El Salvador",
	  "Slovenien",
	  "Fiji",
	  "Kuwait",
	  "Swaziland",
	  "Timor-Leste",
	  "Montenegro",
	  "Bahamas",
	  "Vanuatu",
	  "Qatar",
	  "Gambia",
	  "Jamaica",
	  "Kosovo",
	  "Libanon",
	  "Cypern",
	  "Brunei",
	  "Trinidad och Tobago",
	  "Kap Verde",
	  "Samoa",
	  "Luxemburg",
	  "Komorerna",
	  "Mauritius",
	  "São Tomé och Príncipe",
	  "Kiribati",
	  "Dominica",
	  "Tonga",
	  "Mikronesiens federerade stater",
	  "Singapore",
	  "Bahrain",
	  "Saint Lucia",
	  "Andorra",
	  "Palau",
	  "Seychellerna",
	  "Antigua och Barbuda",
	  "Barbados",
	  "Saint Vincent och Grenadinerna",
	  "Grenada",
	  "Malta",
	  "Maldiverna",
	  "Saint Kitts och Nevis",
	  "Marshallöarna",
	  "Liechtenstein",
	  "San Marino",
	  "Tuvalu",
	  "Nauru",
	  "Monaco",
	  "Vatikanstaten"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sverige"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1537);
	address.city_suffix = __webpack_require__(1538);
	address.country = __webpack_require__(1540);
	address.common_street_suffix = __webpack_require__(1539);
	address.street_prefix = __webpack_require__(1548);
	address.street_root = __webpack_require__(1549);
	address.street_suffix = __webpack_require__(1550);
	address.state = __webpack_require__(1545);
	address.city = __webpack_require__(1536);
	address.street_name = __webpack_require__(1547);
	address.postcode = __webpack_require__(1543);
	address.building_number = __webpack_require__(1535);
	address.secondary_address = __webpack_require__(1544);
	address.street_address = __webpack_require__(1546);
	address.default_country = __webpack_require__(1541);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Lgh. ###",
	  "Hus ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Blekinge",
	  "Dalarna",
	  "Gotland",
	  "Gävleborg",
	  "Göteborg",
	  "Halland",
	  "Jämtland",
	  "Jönköping",
	  "Kalmar",
	  "Kronoberg",
	  "Norrbotten",
	  "Skaraborg",
	  "Skåne",
	  "Stockholm",
	  "Södermanland",
	  "Uppsala",
	  "Värmland",
	  "Västerbotten",
	  "Västernorrland",
	  "Västmanland",
	  "Älvsborg",
	  "Örebro",
	  "Östergötland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}#{street_suffix}",
	  "#{street_prefix} #{street_root}#{street_suffix}",
	  "#{Name.first_name}#{common_street_suffix}",
	  "#{Name.last_name}#{common_street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Västra",
	  "Östra",
	  "Norra",
	  "Södra",
	  "Övre",
	  "Undre"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Björk",
	  "Järnvägs",
	  "Ring",
	  "Skol",
	  "Skogs",
	  "Ny",
	  "Gran",
	  "Idrotts",
	  "Stor",
	  "Kyrk",
	  "Industri",
	  "Park",
	  "Strand",
	  "Skol",
	  "Trädgård",
	  "Ängs",
	  "Kyrko",
	  "Villa",
	  "Ek",
	  "Kvarn",
	  "Stations",
	  "Back",
	  "Furu",
	  "Gen",
	  "Fabriks",
	  "Åker",
	  "Bäck",
	  "Asp"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "vägen",
	  "gatan",
	  "gränden",
	  "gärdet",
	  "allén"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  56,
	  62,
	  59
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{common_cell_prefix}-###-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.common_cell_prefix = __webpack_require__(1551);
	cell_phone.formats = __webpack_require__(1552);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "vit",
	  "silver",
	  "grå",
	  "svart",
	  "röd",
	  "grön",
	  "blå",
	  "gul",
	  "lila",
	  "indigo",
	  "guld",
	  "brun",
	  "rosa",
	  "purpur",
	  "korall"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Böcker",
	  "Filmer",
	  "Musik",
	  "Spel",
	  "Elektronik",
	  "Datorer",
	  "Hem",
	  "Trädgård",
	  "Verktyg",
	  "Livsmedel",
	  "Hälsa",
	  "Skönhet",
	  "Leksaker",
	  "Klädsel",
	  "Skor",
	  "Smycken",
	  "Sport"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(1554);
	commerce.department = __webpack_require__(1555);
	commerce.product_name = __webpack_require__(1557);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "adjective": [
	    "Liten",
	    "Ergonomisk",
	    "Robust",
	    "Intelligent",
	    "Söt",
	    "Otrolig",
	    "Fatastisk",
	    "Praktisk",
	    "Slimmad",
	    "Grym"
	  ],
	  "material": [
	    "Stål",
	    "Metall",
	    "Trä",
	    "Betong",
	    "Plast",
	    "Bomul",
	    "Grnit",
	    "Gummi",
	    "Latex"
	  ],
	  "product": [
	    "Stol",
	    "Bil",
	    "Dator",
	    "Handskar",
	    "Pants",
	    "Shirt",
	    "Table",
	    "Shoes",
	    "Hat"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1560);
	company.name = __webpack_require__(1559);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Gruppen",
	  "AB",
	  "HB",
	  "Group",
	  "Investment",
	  "Kommanditbolag",
	  "Aktiebolag"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(1562);
	date.weekday = __webpack_require__(1563);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1799
	module["exports"] = {
	  wide: [
	    "januari",
	    "februari",
	    "mars",
	    "april",
	    "maj",
	    "juni",
	    "juli",
	    "augusti",
	    "september",
	    "oktober",
	    "november",
	    "december"
	  ],
	  abbr: [
	    "jan",
	    "feb",
	    "mar",
	    "apr",
	    "maj",
	    "jun",
	    "jul",
	    "aug",
	    "sep",
	    "okt",
	    "nov",
	    "dec"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1847
	module["exports"] = {
	  wide: [
	    "söndag",
	    "måndag",
	    "tisdag",
	    "onsdag",
	    "torsdag",
	    "fredag",
	    "lördag"
	  ],
	  abbr: [
	    "sön",
	    "mån",
	    "tis",
	    "ons",
	    "tor",
	    "fre",
	    "lör"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var sv = {};
	module['exports'] = sv;
	sv.title = "Swedish";
	sv.address = __webpack_require__(1542);
	sv.company = __webpack_require__(1558);
	sv.internet = __webpack_require__(1566);
	sv.name = __webpack_require__(1569);
	sv.phone_number = __webpack_require__(1575);
	sv.cell_phone = __webpack_require__(1553);
	sv.commerce = __webpack_require__(1556);
	sv.team = __webpack_require__(1576);
	sv.date = __webpack_require__(1561);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "se",
	  "nu",
	  "info",
	  "com",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(1565);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Erik",
	  "Lars",
	  "Karl",
	  "Anders",
	  "Per",
	  "Johan",
	  "Nils",
	  "Lennart",
	  "Emil",
	  "Hans"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Maria",
	  "Anna",
	  "Margareta",
	  "Elisabeth",
	  "Eva",
	  "Birgitta",
	  "Kristina",
	  "Karin",
	  "Elisabet",
	  "Marie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name_women = __webpack_require__(1568);
	name.first_name_men = __webpack_require__(1567);
	name.last_name = __webpack_require__(1570);
	name.prefix = __webpack_require__(1572);
	name.title = __webpack_require__(1573);
	name.name = __webpack_require__(1571);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Johansson",
	  "Andersson",
	  "Karlsson",
	  "Nilsson",
	  "Eriksson",
	  "Larsson",
	  "Olsson",
	  "Persson",
	  "Svensson",
	  "Gustafsson"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name_women} #{last_name}",
	  "#{first_name_men} #{last_name}",
	  "#{first_name_women} #{last_name}",
	  "#{first_name_men} #{last_name}",
	  "#{first_name_women} #{last_name}",
	  "#{first_name_men} #{last_name}",
	  "#{prefix} #{first_name_men} #{last_name}",
	  "#{prefix} #{first_name_women} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dr.",
	  "Prof.",
	  "PhD."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####-#####",
	  "####-######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1574);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var team = {};
	module['exports'] = team;
	team.suffix = __webpack_require__(1578);
	team.name = __webpack_require__(1577);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.city} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "IF",
	  "FF",
	  "BK",
	  "HK",
	  "AIF",
	  "SK",
	  "FC",
	  "SK",
	  "BoIS",
	  "FK",
	  "BIS",
	  "FIF",
	  "IK"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#",
	  "##a",
	  "##b",
	  "##c"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adana",
	  "Adıyaman",
	  "Afyon",
	  "Ağrı",
	  "Amasya",
	  "Ankara",
	  "Antalya",
	  "Artvin",
	  "Aydın",
	  "Balıkesir",
	  "Bilecik",
	  "Bingöl",
	  "Bitlis",
	  "Bolu",
	  "Burdur",
	  "Bursa",
	  "Çanakkale",
	  "Çankırı",
	  "Çorum",
	  "Denizli",
	  "Diyarbakır",
	  "Edirne",
	  "Elazığ",
	  "Erzincan",
	  "Erzurum",
	  "Eskişehir",
	  "Gaziantep",
	  "Giresun",
	  "Gümüşhane",
	  "Hakkari",
	  "Hatay",
	  "Isparta",
	  "İçel (Mersin)",
	  "İstanbul",
	  "İzmir",
	  "Kars",
	  "Kastamonu",
	  "Kayseri",
	  "Kırklareli",
	  "Kırşehir",
	  "Kocaeli",
	  "Konya",
	  "Kütahya",
	  "Malatya",
	  "Manisa",
	  "K.maraş",
	  "Mardin",
	  "Muğla",
	  "Muş",
	  "Nevşehir",
	  "Niğde",
	  "Ordu",
	  "Rize",
	  "Sakarya",
	  "Samsun",
	  "Siirt",
	  "Sinop",
	  "Sivas",
	  "Tekirdağ",
	  "Tokat",
	  "Trabzon",
	  "Tunceli",
	  "Şanlıurfa",
	  "Uşak",
	  "Van",
	  "Yozgat",
	  "Zonguldak",
	  "Aksaray",
	  "Bayburt",
	  "Karaman",
	  "Kırıkkale",
	  "Batman",
	  "Şırnak",
	  "Bartın",
	  "Ardahan",
	  "Iğdır",
	  "Yalova",
	  "Karabük",
	  "Kilis",
	  "Osmaniye",
	  "Düzce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistan",
	  "Almanya",
	  "Amerika Birleşik Devletleri",
	  "Amerikan Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla, İngiltere",
	  "Antigua ve Barbuda",
	  "Arjantin",
	  "Arnavutluk",
	  "Aruba, Hollanda",
	  "Avustralya",
	  "Avusturya",
	  "Azerbaycan",
	  "Bahama Adaları",
	  "Bahreyn",
	  "Bangladeş",
	  "Barbados",
	  "Belçika",
	  "Belize",
	  "Benin",
	  "Bermuda, İngiltere",
	  "Beyaz Rusya",
	  "Bhutan",
	  "Birleşik Arap Emirlikleri",
	  "Birmanya (Myanmar)",
	  "Bolivya",
	  "Bosna Hersek",
	  "Botswana",
	  "Brezilya",
	  "Brunei",
	  "Bulgaristan",
	  "Burkina Faso",
	  "Burundi",
	  "Cape Verde",
	  "Cayman Adaları, İngiltere",
	  "Cebelitarık, İngiltere",
	  "Cezayir",
	  "Christmas Adası , Avusturalya",
	  "Cibuti",
	  "Çad",
	  "Çek Cumhuriyeti",
	  "Çin",
	  "Danimarka",
	  "Doğu Timor",
	  "Dominik Cumhuriyeti",
	  "Dominika",
	  "Ekvator",
	  "Ekvator Ginesi",
	  "El Salvador",
	  "Endonezya",
	  "Eritre",
	  "Ermenistan",
	  "Estonya",
	  "Etiyopya",
	  "Fas",
	  "Fiji",
	  "Fildişi Sahili",
	  "Filipinler",
	  "Filistin",
	  "Finlandiya",
	  "Folkland Adaları, İngiltere",
	  "Fransa",
	  "Fransız Guyanası",
	  "Fransız Güney Eyaletleri (Kerguelen Adaları)",
	  "Fransız Polinezyası",
	  "Gabon",
	  "Galler",
	  "Gambiya",
	  "Gana",
	  "Gine",
	  "Gine-Bissau",
	  "Grenada",
	  "Grönland",
	  "Guadalup, Fransa",
	  "Guam, Amerika",
	  "Guatemala",
	  "Guyana",
	  "Güney Afrika",
	  "Güney Georgia ve Güney Sandviç Adaları, İngiltere",
	  "Güney Kıbrıs Rum Yönetimi",
	  "Güney Kore",
	  "Gürcistan H",
	  "Haiti",
	  "Hırvatistan",
	  "Hindistan",
	  "Hollanda",
	  "Hollanda Antilleri",
	  "Honduras",
	  "Irak",
	  "İngiltere",
	  "İran",
	  "İrlanda",
	  "İspanya",
	  "İsrail",
	  "İsveç",
	  "İsviçre",
	  "İtalya",
	  "İzlanda",
	  "Jamaika",
	  "Japonya",
	  "Johnston Atoll, Amerika",
	  "K.K.T.C.",
	  "Kamboçya",
	  "Kamerun",
	  "Kanada",
	  "Kanarya Adaları",
	  "Karadağ",
	  "Katar",
	  "Kazakistan",
	  "Kenya",
	  "Kırgızistan",
	  "Kiribati",
	  "Kolombiya",
	  "Komorlar",
	  "Kongo",
	  "Kongo Demokratik Cumhuriyeti",
	  "Kosova",
	  "Kosta Rika",
	  "Kuveyt",
	  "Kuzey İrlanda",
	  "Kuzey Kore",
	  "Kuzey Maryana Adaları",
	  "Küba",
	  "Laos",
	  "Lesotho",
	  "Letonya",
	  "Liberya",
	  "Libya",
	  "Liechtenstein",
	  "Litvanya",
	  "Lübnan",
	  "Lüksemburg",
	  "Macaristan",
	  "Madagaskar",
	  "Makau (Makao)",
	  "Makedonya",
	  "Malavi",
	  "Maldiv Adaları",
	  "Malezya",
	  "Mali",
	  "Malta",
	  "Marşal Adaları",
	  "Martinik, Fransa",
	  "Mauritius",
	  "Mayotte, Fransa",
	  "Meksika",
	  "Mısır",
	  "Midway Adaları, Amerika",
	  "Mikronezya",
	  "Moğolistan",
	  "Moldavya",
	  "Monako",
	  "Montserrat",
	  "Moritanya",
	  "Mozambik",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Nijer",
	  "Nijerya",
	  "Nikaragua",
	  "Niue, Yeni Zelanda",
	  "Norveç",
	  "Orta Afrika Cumhuriyeti",
	  "Özbekistan",
	  "Pakistan",
	  "Palau Adaları",
	  "Palmyra Atoll, Amerika",
	  "Panama",
	  "Papua Yeni Gine",
	  "Paraguay",
	  "Peru",
	  "Polonya",
	  "Portekiz",
	  "Porto Riko, Amerika",
	  "Reunion, Fransa",
	  "Romanya",
	  "Ruanda",
	  "Rusya Federasyonu",
	  "Saint Helena, İngiltere",
	  "Saint Martin, Fransa",
	  "Saint Pierre ve Miquelon, Fransa",
	  "Samoa",
	  "San Marino",
	  "Santa Kitts ve Nevis",
	  "Santa Lucia",
	  "Santa Vincent ve Grenadinler",
	  "Sao Tome ve Principe",
	  "Senegal",
	  "Seyşeller",
	  "Sırbistan",
	  "Sierra Leone",
	  "Singapur",
	  "Slovakya",
	  "Slovenya",
	  "Solomon Adaları",
	  "Somali",
	  "Sri Lanka",
	  "Sudan",
	  "Surinam",
	  "Suriye",
	  "Suudi Arabistan",
	  "Svalbard, Norveç",
	  "Svaziland",
	  "Şili",
	  "Tacikistan",
	  "Tanzanya",
	  "Tayland",
	  "Tayvan",
	  "Togo",
	  "Tonga",
	  "Trinidad ve Tobago",
	  "Tunus",
	  "Turks ve Caicos Adaları, İngiltere",
	  "Tuvalu",
	  "Türkiye",
	  "Türkmenistan",
	  "Uganda",
	  "Ukrayna",
	  "Umman",
	  "Uruguay",
	  "Ürdün",
	  "Vallis ve Futuna, Fransa",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Virgin Adaları, Amerika",
	  "Virgin Adaları, İngiltere",
	  "Wake Adaları, Amerika",
	  "Yemen",
	  "Yeni Kaledonya, Fransa",
	  "Yeni Zelanda",
	  "Yunanistan",
	  "Zambiya",
	  "Zimbabve"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Türkiye"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city = __webpack_require__(1580);
	address.street_root = __webpack_require__(1587);
	address.country = __webpack_require__(1581);
	address.postcode = __webpack_require__(1584);
	address.default_country = __webpack_require__(1582);
	address.building_number = __webpack_require__(1579);
	address.street_name = __webpack_require__(1586);
	address.street_address = __webpack_require__(1585);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Atatürk Bulvarı",
	  "Alparslan Türkeş Bulvarı",
	  "Ali Çetinkaya Caddesi",
	  "Tevfik Fikret Caddesi",
	  "Kocatepe Caddesi",
	  "İsmet Paşa Caddesi",
	  "30 Ağustos Caddesi",
	  "İsmet Attila Caddesi",
	  "Namık Kemal Caddesi",
	  "Lütfi Karadirek Caddesi",
	  "Sarıkaya Caddesi",
	  "Yunus Emre Sokak",
	  "Dar Sokak",
	  "Fatih Sokak ",
	  "Harman Yolu Sokak ",
	  "Ergenekon Sokak  ",
	  "Ülkü Sokak",
	  "Sağlık Sokak",
	  "Okul Sokak",
	  "Harman Altı Sokak",
	  "Kaldırım Sokak",
	  "Mevlana Sokak",
	  "Gül Sokak",
	  "Sıran Söğüt Sokak",
	  "Güven Yaka Sokak",
	  "Saygılı Sokak",
	  "Menekşe Sokak",
	  "Dağınık Evler Sokak",
	  "Sevgi Sokak",
	  "Afyon Kaya Sokak",
	  "Oğuzhan Sokak",
	  "İbn-i Sina Sokak",
	  "Okul Sokak",
	  "Bahçe Sokak",
	  "Köypınar Sokak",
	  "Kekeçoğlu Sokak",
	  "Barış Sokak",
	  "Bayır Sokak",
	  "Kerimoğlu Sokak",
	  "Nalbant Sokak",
	  "Bandak Sokak"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+90-53#-###-##-##",
	  "+90-54#-###-##-##",
	  "+90-55#-###-##-##",
	  "+90-50#-###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1588);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var tr = {};
	module['exports'] = tr;
	tr.title = "Turkish";
	tr.address = __webpack_require__(1583);
	tr.internet = __webpack_require__(1592);
	tr.lorem = __webpack_require__(1593);
	tr.phone_number = __webpack_require__(1602);
	tr.cell_phone = __webpack_require__(1589);
	tr.name = __webpack_require__(1596);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com.tr",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "gov.tr"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(1591);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1594);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aba",
	  "Abak",
	  "Abaka",
	  "Abakan",
	  "Abakay",
	  "Abar",
	  "Abay",
	  "Abı",
	  "Abılay",
	  "Abluç",
	  "Abşar",
	  "Açığ",
	  "Açık",
	  "Açuk",
	  "Adalan",
	  "Adaldı",
	  "Adalmış",
	  "Adar",
	  "Adaş",
	  "Adberilgen",
	  "Adıgüzel",
	  "Adık",
	  "Adıkutlu",
	  "Adıkutlutaş",
	  "Adlı",
	  "Adlıbeğ",
	  "Adraman",
	  "Adsız",
	  "Afşar",
	  "Afşın",
	  "Ağabay",
	  "Ağakağan",
	  "Ağalak",
	  "Ağlamış",
	  "Ak",
	  "Akaş",
	  "Akata",
	  "Akbaş",
	  "Akbay",
	  "Akboğa",
	  "Akbörü",
	  "Akbudak",
	  "Akbuğra",
	  "Akbulak",
	  "Akça",
	  "Akçakoca",
	  "Akçora",
	  "Akdemir",
	  "Akdoğan",
	  "Akı",
	  "Akıbudak",
	  "Akım",
	  "Akın",
	  "Akınçı",
	  "Akkun",
	  "Akkunlu",
	  "Akkurt",
	  "Akkuş",
	  "Akpıra",
	  "Aksungur",
	  "Aktan",
	  "Al",
	  "Ala",
	  "Alaban",
	  "Alabörü",
	  "Aladağ",
	  "Aladoğan",
	  "Alakurt",
	  "Alayunt",
	  "Alayuntlu",
	  "Aldemir",
	  "Aldıgerey",
	  "Aldoğan",
	  "Algu",
	  "Alımga",
	  "Alka",
	  "Alkabölük",
	  "Alkaevli",
	  "Alkan",
	  "Alkaşı",
	  "Alkış",
	  "Alp",
	  "Alpagut",
	  "Alpamış",
	  "Alparsbeğ",
	  "Alparslan",
	  "Alpata",
	  "Alpay",
	  "Alpaya",
	  "Alpaykağan",
	  "Alpbamsı",
	  "Alpbilge",
	  "Alpdirek",
	  "Alpdoğan",
	  "Alper",
	  "Alperen",
	  "Alpertunga",
	  "Alpgerey",
	  "Alpış",
	  "Alpilig",
	  "Alpkara",
	  "Alpkutlu",
	  "Alpkülük",
	  "Alpşalçı",
	  "Alptegin",
	  "Alptuğrul",
	  "Alptunga",
	  "Alpturan",
	  "Alptutuk",
	  "Alpuluğ",
	  "Alpurungu",
	  "Alpurungututuk",
	  "Alpyörük",
	  "Altan",
	  "Altankağan",
	  "Altankan",
	  "Altay",
	  "Altın",
	  "Altınkağan",
	  "Altınkan",
	  "Altınoba",
	  "Altıntamgan",
	  "Altıntamgantarkan",
	  "Altıntarkan",
	  "Altıntay",
	  "Altmışkara",
	  "Altuga",
	  "Amaç",
	  "Amrak",
	  "Amul",
	  "Ançuk",
	  "Andarıman",
	  "Anıl",
	  "Ant",
	  "Apa",
	  "Apak",
	  "Apatarkan",
	  "Aprançur",
	  "Araboğa",
	  "Arademir",
	  "Aral",
	  "Arbay",
	  "Arbuz",
	  "Arçuk",
	  "Ardıç",
	  "Argıl",
	  "Argu",
	  "Argun",
	  "Arı",
	  "Arıboğa",
	  "Arık",
	  "Arıkağan",
	  "Arıkdoruk",
	  "Arınç",
	  "Arkın",
	  "Arkış",
	  "Armağan",
	  "Arnaç",
	  "Arpat",
	  "Arsal",
	  "Arsıl",
	  "Arslan",
	  "Arslanargun",
	  "Arslanbörü",
	  "Arslansungur",
	  "Arslantegin",
	  "Arslanyabgu",
	  "Arşun",
	  "Artıınal",
	  "Artuk",
	  "Artukaç",
	  "Artut",
	  "Aruk",
	  "Asartegin",
	  "Asığ",
	  "Asrı",
	  "Asuğ",
	  "Aşan",
	  "Aşanboğa",
	  "Aşantuğrul",
	  "Aşantudun",
	  "Aşıkbulmuş",
	  "Aşkın",
	  "Aştaloğul",
	  "Aşuk",
	  "Ataç",
	  "Atakağan",
	  "Atakan",
	  "Atalan",
	  "Ataldı",
	  "Atalmış",
	  "Ataman",
	  "Atasagun",
	  "Atasu",
	  "Atberilgen",
	  "Atıgay",
	  "Atıkutlu",
	  "Atıkutlutaş",
	  "Atıla",
	  "Atılgan",
	  "Atım",
	  "Atımer",
	  "Atış",
	  "Atlı",
	  "Atlıbeğ",
	  "Atlıkağan",
	  "Atmaca",
	  "Atsız",
	  "Atunçu",
	  "Avar",
	  "Avluç",
	  "Avşar",
	  "Ay",
	  "Ayaçı",
	  "Ayas",
	  "Ayaş",
	  "Ayaz",
	  "Aybalta",
	  "Ayban",
	  "Aybars",
	  "Aybeğ",
	  "Aydarkağan",
	  "Aydemir",
	  "Aydın",
	  "Aydınalp",
	  "Aydoğan",
	  "Aydoğdu",
	  "Aydoğmuş",
	  "Aygırak",
	  "Ayıtmış",
	  "Ayız",
	  "Ayızdağ",
	  "Aykağan",
	  "Aykan",
	  "Aykurt",
	  "Ayluç",
	  "Ayluçtarkan",
	  "Ayma",
	  "Ayruk",
	  "Aysılığ",
	  "Aytak",
	  "Ayyıldız",
	  "Azak",
	  "Azban",
	  "Azgan",
	  "Azganaz",
	  "Azıl",
	  "Babır",
	  "Babur",
	  "Baçara",
	  "Baççayman",
	  "Baçman",
	  "Badabul",
	  "Badruk",
	  "Badur",
	  "Bağa",
	  "Bağaalp",
	  "Bağaışbara",
	  "Bağan",
	  "Bağaşatulu",
	  "Bağatarkan",
	  "Bağatengrikağan",
	  "Bağatur",
	  "Bağaturçigşi",
	  "Bağaturgerey",
	  "Bağaturipi",
	  "Bağatursepi",
	  "Bağış",
	  "Bağtaş",
	  "Bakağul",
	  "Bakır",
	  "Bakırsokum",
	  "Baksı",
	  "Bakşı",
	  "Balaban",
	  "Balaka",
	  "Balakatay",
	  "Balamır",
	  "Balçar",
	  "Baldu",
	  "Balkık",
	  "Balta",
	  "Baltacı",
	  "Baltar",
	  "Baltır",
	  "Baltur",
	  "Bamsı",
	  "Bangu",
	  "Barak",
	  "Baraktöre",
	  "Baran",
	  "Barbeğ",
	  "Barboğa",
	  "Barbol",
	  "Barbulsun",
	  "Barça",
	  "Barçadoğdu",
	  "Barçadoğmuş",
	  "Barçadurdu",
	  "Barçadurmuş",
	  "Barçan",
	  "Barçatoyun",
	  "Bardıbay",
	  "Bargan",
	  "Barımtay",
	  "Barın",
	  "Barkan",
	  "Barkdoğdu",
	  "Barkdoğmuş",
	  "Barkdurdu",
	  "Barkdurmuş",
	  "Barkın",
	  "Barlas",
	  "Barlıbay",
	  "Barmaklak",
	  "Barmaklı",
	  "Barman",
	  "Bars",
	  "Barsbeğ",
	  "Barsboğa",
	  "Barsgan",
	  "Barskan",
	  "Barsurungu",
	  "Bartu",
	  "Basademir",
	  "Basan",
	  "Basanyalavaç",
	  "Basar",
	  "Basat",
	  "Baskın",
	  "Basmıl",
	  "Bastı",
	  "Bastuğrul",
	  "Basu",
	  "Basut",
	  "Başak",
	  "Başbuğ",
	  "Başçı",
	  "Başgan",
	  "Başkırt",
	  "Başkurt",
	  "Baştar",
	  "Batrak",
	  "Batu",
	  "Batuk",
	  "Batur",
	  "Baturalp",
	  "Bay",
	  "Bayançar",
	  "Bayankağan",
	  "Bayat",
	  "Bayazıt",
	  "Baybars",
	  "Baybayık",
	  "Baybiçen",
	  "Bayboğa",
	  "Baybora",
	  "Baybüre",
	  "Baydar",
	  "Baydemir",
	  "Baydur",
	  "Bayık",
	  "Bayınçur",
	  "Bayındır",
	  "Baykal",
	  "Baykara",
	  "Baykoca",
	  "Baykuzu",
	  "Baymünke",
	  "Bayna",
	  "Baynal",
	  "Baypüre",
	  "Bayrı",
	  "Bayraç",
	  "Bayrak",
	  "Bayram",
	  "Bayrın",
	  "Bayruk",
	  "Baysungur",
	  "Baytara",
	  "Baytaş",
	  "Bayunçur",
	  "Bayur",
	  "Bayurku",
	  "Bayutmuş",
	  "Bayuttu",
	  "Bazır",
	  "Beçeapa",
	  "Beçkem",
	  "Beğ",
	  "Beğarslan",
	  "Beğbars",
	  "Beğbilgeçikşin",
	  "Beğboğa",
	  "Beğçur",
	  "Beğdemir",
	  "Beğdilli",
	  "Beğdurmuş",
	  "Beğkulu",
	  "Beğtaş",
	  "Beğtegin",
	  "Beğtüzün",
	  "Begi",
	  "Begil",
	  "Begine",
	  "Begitutuk",
	  "Beglen",
	  "Begni",
	  "Bek",
	  "Bekazıl",
	  "Bekbekeç",
	  "Bekeç",
	  "Bekeçarslan",
	  "Bekeçarslantegin",
	  "Bekeçtegin",
	  "Beker",
	  "Beklemiş",
	  "Bektür",
	  "Belçir",
	  "Belek",
	  "Belgi",
	  "Belgüc",
	  "Beltir",
	  "Bengi",
	  "Bengü",
	  "Benlidemir",
	  "Berdibeğ",
	  "Berendey",
	  "Bergü",
	  "Berginsenge",
	  "Berk",
	  "Berke",
	  "Berkiş",
	  "Berkyaruk",
	  "Bermek",
	  "Besentegin",
	  "Betemir",
	  "Beyizçi",
	  "Beyrek",
	  "Beyrem",
	  "Bıçkı",
	  "Bıçkıcı",
	  "Bıdın",
	  "Bıtaybıkı",
	  "Bıtrı",
	  "Biçek",
	  "Bilge",
	  "Bilgebayunçur",
	  "Bilgebeğ",
	  "Bilgeçikşin",
	  "Bilgeışbara",
	  "Bilgeışbaratamgan",
	  "Bilgekağan",
	  "Bilgekan",
	  "Bilgekutluk",
	  "Bilgekülüçur",
	  "Bilgetaçam",
	  "Bilgetamgacı",
	  "Bilgetardu",
	  "Bilgetegin",
	  "Bilgetonyukuk",
	  "Bilgez",
	  "Bilgiç",
	  "Bilgin",
	  "Bilig",
	  "Biligköngülsengün",
	  "Bilik",
	  "Binbeği",
	  "Bindir",
	  "Boğa",
	  "Boğaç",
	  "Boğaçuk",
	  "Boldaz",
	  "Bolmuş",
	  "Bolsun",
	  "Bolun",
	  "Boncuk",
	  "Bongul",
	  "Bongulboğa",
	  "Bora",
	  "Boran",
	  "Borçul",
	  "Borlukçu",
	  "Bornak",
	  "Boyan",
	  "Boyankulu",
	  "Boylabağa",
	  "Boylabağatarkan",
	  "Boylakutlutarkan",
	  "Bozan",
	  "Bozbörü",
	  "Bozdoğan",
	  "Bozkurt",
	  "Bozkuş",
	  "Bozok",
	  "Bögde",
	  "Böge",
	  "Bögü",
	  "Bökde",
	  "Bökde",
	  "Böke",
	  "Bölen",
	  "Bölükbaşı",
	  "Bönek",
	  "Bönge",
	  "Börü",
	  "Börübars",
	  "Börüsengün",
	  "Börteçine",
	  "Buçan",
	  "Buçur",
	  "Budağ",
	  "Budak",
	  "Budunlu",
	  "Buğday",
	  "Buğra",
	  "Buğrakarakağan",
	  "Bukak",
	  "Bukaktutuk",
	  "Bulaçapan",
	  "Bulak",
	  "Bulan",
	  "Buldur",
	  "Bulgak",
	  "Bulmaz",
	  "Bulmuş",
	  "Buluç",
	  "Buluğ",
	  "Buluk",
	  "Buluş",
	  "Bulut",
	  "Bumın",
	  "Bunsuz",
	  "Burçak",
	  "Burguçan",
	  "Burkay",
	  "Burslan",
	  "Burulday",
	  "Burulgu",
	  "Burunduk",
	  "Buşulgan",
	  "Butak",
	  "Butuk",
	  "Buyan",
	  "Buyançuk",
	  "Buyandemir",
	  "Buyankara",
	  "Buyat",
	  "Buyraç",
	  "Buyruç",
	  "Buyruk",
	  "Buzaç",
	  "Buzaçtutuk",
	  "Büdüs",
	  "Büdüstudun",
	  "Bügü",
	  "Bügdüz",
	  "Bügdüzemen",
	  "Büge",
	  "Büğübilge",
	  "Bükdüz",
	  "Büke",
	  "Bükebuyraç",
	  "Bükebuyruç",
	  "Bükey",
	  "Büktegin",
	  "Büküşboğa",
	  "Bümen",
	  "Bünül",
	  "Büre",
	  "Bürgüt",
	  "Bürkek",
	  "Bürküt",
	  "Bürlük",
	  "Cebe",
	  "Ceyhun",
	  "Cılasun",
	  "Çaba",
	  "Çabdar",
	  "Çablı",
	  "Çabuş",
	  "Çağan",
	  "Çağatay",
	  "Çağlar",
	  "Çağlayan",
	  "Çağrı",
	  "Çağrıbeğ",
	  "Çağrıtegin",
	  "Çağru",
	  "Çalapkulu",
	  "Çankız",
	  "Çemen",
	  "Çemgen",
	  "Çeykün",
	  "Çıngır",
	  "Çiçek",
	  "Çiçem",
	  "Çiğdem",
	  "Çilenti",
	  "Çimen",
	  "Çobulmak",
	  "Çocukbörü",
	  "Çokramayul",
	  "Çolman",
	  "Çolpan",
	  "Çölü",
	  "Damla",
	  "Deniz",
	  "Dilek",
	  "Diri",
	  "Dizik",
	  "Duru",
	  "Dururbunsuz",
	  "Duygu",
	  "Ebin",
	  "Ebkızı",
	  "Ebren",
	  "Edil",
	  "Ediz",
	  "Egemen",
	  "Eğrim",
	  "Ekeç",
	  "Ekim",
	  "Ekin",
	  "Elkin",
	  "Elti",
	  "Engin",
	  "Erdem",
	  "Erdeni",
	  "Erdeniözük",
	  "Erdenikatun",
	  "Erentüz",
	  "Ergene",
	  "Ergenekatun",
	  "Erinç",
	  "Erke",
	  "Ermen",
	  "Erten",
	  "Ertenözük",
	  "Esen",
	  "Esenbike",
	  "Eser",
	  "Esin",
	  "Etil",
	  "Evin",
	  "Eyiz",
	  "Gelin",
	  "Gelincik",
	  "Gökbörü",
	  "Gökçe",
	  "Gökçegöl",
	  "Gökçen",
	  "Gökçiçek",
	  "Gökşin",
	  "Gönül",
	  "Görün",
	  "Gözde",
	  "Gülegen",
	  "Gülemen",
	  "Güler",
	  "Gülümser",
	  "Gümüş",
	  "Gün",
	  "Günay",
	  "Günçiçek",
	  "Gündoğdu",
	  "Gündoğmuş",
	  "Güneş",
	  "Günyaruk",
	  "Gürbüz",
	  "Güvercin",
	  "Güzey",
	  "Işığ",
	  "Işık",
	  "Işıl",
	  "Işılay",
	  "Ila",
	  "Ilaçın",
	  "Ilgın",
	  "Inanç",
	  "Irmak",
	  "Isığ",
	  "Isık",
	  "Iyık",
	  "Iyıktağ",
	  "İdil",
	  "İkeme",
	  "İkiçitoyun",
	  "İlbilge",
	  "İldike",
	  "İlgegü",
	  "İmrem",
	  "İnci",
	  "İnç",
	  "İrinç",
	  "İrinçköl",
	  "İrtiş",
	  "İtil",
	  "Kancı",
	  "Kançı",
	  "Kapgar",
	  "Karaca",
	  "Karaça",
	  "Karak",
	  "Kargılaç",
	  "Karlıgaç",
	  "Katun",
	  "Katunkız",
	  "Kayacık",
	  "Kayaçık",
	  "Kayça",
	  "Kaynak",
	  "Kazanç",
	  "Kazkatun",
	  "Kekik",
	  "Keklik",
	  "Kepez",
	  "Kesme",
	  "Keyken",
	  "Kezlik",
	  "Kımız",
	  "Kımızın",
	  "Kımızalma",
	  "Kımızalmıla",
	  "Kırçiçek",
	  "Kırgavul",
	  "Kırlangıç",
	  "Kıvanç",
	  "Kıvılcım",
	  "Kızdurmuş",
	  "Kızılalma"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1595);
	name.last_name = __webpack_require__(1597);
	name.prefix = __webpack_require__(1599);
	name.name = __webpack_require__(1598);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abacı",
	  "Abadan",
	  "Aclan",
	  "Adal",
	  "Adan",
	  "Adıvar",
	  "Akal",
	  "Akan",
	  "Akar ",
	  "Akay",
	  "Akaydın",
	  "Akbulut",
	  "Akgül",
	  "Akışık",
	  "Akman",
	  "Akyürek",
	  "Akyüz",
	  "Akşit",
	  "Alnıaçık",
	  "Alpuğan",
	  "Alyanak",
	  "Arıcan",
	  "Arslanoğlu",
	  "Atakol",
	  "Atan",
	  "Avan",
	  "Ayaydın",
	  "Aybar",
	  "Aydan",
	  "Aykaç",
	  "Ayverdi",
	  "Ağaoğlu",
	  "Aşıkoğlu",
	  "Babacan",
	  "Babaoğlu",
	  "Bademci",
	  "Bakırcıoğlu",
	  "Balaban",
	  "Balcı",
	  "Barbarosoğlu",
	  "Baturalp",
	  "Baykam",
	  "Başoğlu",
	  "Berberoğlu",
	  "Beşerler",
	  "Beşok",
	  "Biçer",
	  "Bolatlı",
	  "Dalkıran",
	  "Dağdaş",
	  "Dağlaroğlu",
	  "Demirbaş",
	  "Demirel",
	  "Denkel",
	  "Dizdar ",
	  "Doğan ",
	  "Durak ",
	  "Durmaz",
	  "Duygulu",
	  "Düşenkalkar",
	  "Egeli",
	  "Ekici",
	  "Ekşioğlu",
	  "Eliçin",
	  "Elmastaşoğlu",
	  "Elçiboğa",
	  "Erbay",
	  "Erberk",
	  "Erbulak",
	  "Erdoğan",
	  "Erez",
	  "Erginsoy",
	  "Erkekli",
	  "Eronat",
	  "Ertepınar",
	  "Ertürk",
	  "Erçetin",
	  "Evliyaoğlu",
	  "Gönültaş",
	  "Gümüşpala",
	  "Günday",
	  "Gürmen",
	  "Hakyemez",
	  "Hamzaoğlu",
	  "Ilıcalı",
	  "Kahveci",
	  "Kaplangı",
	  "Karabulut",
	  "Karaböcek",
	  "Karadaş",
	  "Karaduman",
	  "Karaer",
	  "Kasapoğlu",
	  "Kavaklıoğlu",
	  "Kaya ",
	  "Keseroğlu",
	  "Keçeci",
	  "Kılıççı",
	  "Kıraç ",
	  "Kocabıyık",
	  "Korol",
	  "Koyuncu",
	  "Koç",
	  "Koçoğlu",
	  "Koçyiğit",
	  "Kuday",
	  "Kulaksızoğlu",
	  "Kumcuoğlu",
	  "Kunt",
	  "Kunter",
	  "Kurutluoğlu",
	  "Kutlay",
	  "Kuzucu",
	  "Körmükçü",
	  "Köybaşı",
	  "Köylüoğlu",
	  "Küçükler",
	  "Limoncuoğlu",
	  "Mayhoş",
	  "Menemencioğlu",
	  "Mertoğlu",
	  "Nalbantoğlu",
	  "Nebioğlu",
	  "Numanoğlu",
	  "Okumuş",
	  "Okur",
	  "Oraloğlu",
	  "Orbay",
	  "Ozansoy",
	  "Paksüt",
	  "Pekkan",
	  "Pektemek",
	  "Polat",
	  "Poyrazoğlu",
	  "Poçan",
	  "Sadıklar",
	  "Samancı",
	  "Sandalcı",
	  "Sarıoğlu",
	  "Saygıner",
	  "Sepetçi",
	  "Sezek",
	  "Sinanoğlu",
	  "Solmaz",
	  "Sözeri",
	  "Süleymanoğlu",
	  "Tahincioğlu",
	  "Tanrıkulu",
	  "Tazegül",
	  "Taşlı",
	  "Taşçı",
	  "Tekand",
	  "Tekelioğlu",
	  "Tokatlıoğlu",
	  "Tokgöz",
	  "Topaloğlu",
	  "Topçuoğlu",
	  "Toraman",
	  "Tunaboylu",
	  "Tunçeri",
	  "Tuğlu",
	  "Tuğluk",
	  "Türkdoğan",
	  "Türkyılmaz",
	  "Tütüncü",
	  "Tüzün",
	  "Uca",
	  "Uluhan",
	  "Velioğlu",
	  "Yalçın",
	  "Yazıcı",
	  "Yetkiner",
	  "Yeşilkaya",
	  "Yıldırım ",
	  "Yıldızoğlu",
	  "Yılmazer",
	  "Yorulmaz",
	  "Çamdalı",
	  "Çapanoğlu",
	  "Çatalbaş",
	  "Çağıran",
	  "Çetin",
	  "Çetiner",
	  "Çevik",
	  "Çörekçi",
	  "Önür",
	  "Örge",
	  "Öymen",
	  "Özberk",
	  "Özbey",
	  "Özbir",
	  "Özdenak",
	  "Özdoğan",
	  "Özgörkey",
	  "Özkara",
	  "Özkök ",
	  "Öztonga",
	  "Öztuna"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bay",
	  "Bayan",
	  "Dr.",
	  "Prof. Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "392",
	  "510",
	  "512",
	  "522",
	  "562",
	  "564",
	  "592",
	  "594",
	  "800",
	  "811",
	  "822",
	  "850",
	  "888",
	  "898",
	  "900",
	  "322",
	  "416",
	  "272",
	  "472",
	  "382",
	  "358",
	  "312",
	  "242",
	  "478",
	  "466",
	  "256",
	  "266",
	  "378",
	  "488",
	  "458",
	  "228",
	  "426",
	  "434",
	  "374",
	  "248",
	  "224",
	  "286",
	  "376",
	  "364",
	  "258",
	  "412",
	  "380",
	  "284",
	  "424",
	  "446",
	  "442",
	  "222",
	  "342",
	  "454",
	  "456",
	  "438",
	  "326",
	  "476",
	  "246",
	  "216",
	  "212",
	  "232",
	  "344",
	  "370",
	  "338",
	  "474",
	  "366",
	  "352",
	  "318",
	  "288",
	  "386",
	  "348",
	  "262",
	  "332",
	  "274",
	  "422",
	  "236",
	  "482",
	  "324",
	  "252",
	  "436",
	  "384",
	  "388",
	  "452",
	  "328",
	  "464",
	  "264",
	  "362",
	  "484",
	  "368",
	  "346",
	  "414",
	  "486",
	  "282",
	  "356",
	  "462",
	  "428",
	  "276",
	  "432",
	  "226",
	  "354",
	  "372"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+90-###-###-##-##",
	  "+90-###-###-#-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.area_code = __webpack_require__(1600);
	phone_number.formats = __webpack_require__(1601);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}",
	  "#{city_prefix} #{Name.male_first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Алчевськ",
	  "Артемівськ",
	  "Бердичів",
	  "Бердянськ",
	  "Біла Церква",
	  "Бровари",
	  "Вінниця",
	  "Горлівка",
	  "Дніпродзержинськ",
	  "Дніпропетровськ",
	  "Донецьк",
	  "Євпаторія",
	  "Єнакієве",
	  "Житомир",
	  "Запоріжжя",
	  "Івано-Франківськ",
	  "Ізмаїл",
	  "Кам’янець-Подільський",
	  "Керч",
	  "Київ",
	  "Кіровоград",
	  "Конотоп",
	  "Краматорськ",
	  "Красний Луч",
	  "Кременчук",
	  "Кривий Ріг",
	  "Лисичанськ",
	  "Луганськ",
	  "Луцьк",
	  "Львів",
	  "Макіївка",
	  "Маріуполь",
	  "Мелітополь",
	  "Миколаїв",
	  "Мукачеве",
	  "Нікополь",
	  "Одеса",
	  "Олександрія",
	  "Павлоград",
	  "Полтава",
	  "Рівне",
	  "Севастополь",
	  "Сєвєродонецьк",
	  "Сімферополь",
	  "Слов’янськ",
	  "Суми",
	  "Тернопіль",
	  "Ужгород",
	  "Умань",
	  "Харків",
	  "Херсон",
	  "Хмельницький",
	  "Черкаси",
	  "Чернівці",
	  "Чернігів",
	  "Шостка",
	  "Ялта"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Південний",
	  "Північний",
	  "Східний",
	  "Західний"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "град"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Австралія",
	  "Австрія",
	  "Азербайджан",
	  "Албанія",
	  "Алжир",
	  "Ангола",
	  "Андорра",
	  "Антигуа і Барбуда",
	  "Аргентина",
	  "Афганістан",
	  "Багамські Острови",
	  "Бангладеш",
	  "Барбадос",
	  "Бахрейн",
	  "Беліз",
	  "Бельгія",
	  "Бенін",
	  "Білорусь",
	  "Болгарія",
	  "Болівія",
	  "Боснія і Герцеговина",
	  "Ботсвана",
	  "Бразилія",
	  "Бруней",
	  "Буркіна-Фасо",
	  "Бурунді",
	  "Бутан",
	  "В’єтнам",
	  "Вануату",
	  "Ватикан",
	  "Велика Британія",
	  "Венесуела",
	  "Вірменія",
	  "Габон",
	  "Гаїті",
	  "Гайана",
	  "Гамбія",
	  "Гана",
	  "Гватемала",
	  "Гвінея",
	  "Гвінея-Бісау",
	  "Гондурас",
	  "Гренада",
	  "Греція",
	  "Грузія",
	  "Данія",
	  "Демократична Республіка Конго",
	  "Джибуті",
	  "Домініка",
	  "Домініканська Республіка",
	  "Еквадор",
	  "Екваторіальна Гвінея",
	  "Еритрея",
	  "Естонія",
	  "Ефіопія",
	  "Єгипет",
	  "Ємен",
	  "Замбія",
	  "Зімбабве",
	  "Ізраїль",
	  "Індія",
	  "Індонезія",
	  "Ірак",
	  "Іран",
	  "Ірландія",
	  "Ісландія",
	  "Іспанія",
	  "Італія",
	  "Йорданія",
	  "Кабо-Верде",
	  "Казахстан",
	  "Камбоджа",
	  "Камерун",
	  "Канада",
	  "Катар",
	  "Кенія",
	  "Киргизстан",
	  "Китай",
	  "Кіпр",
	  "Кірибаті",
	  "Колумбія",
	  "Коморські Острови",
	  "Конго",
	  "Коста-Рика",
	  "Кот-д’Івуар",
	  "Куба",
	  "Кувейт",
	  "Лаос",
	  "Латвія",
	  "Лесото",
	  "Литва",
	  "Ліберія",
	  "Ліван",
	  "Лівія",
	  "Ліхтенштейн",
	  "Люксембург",
	  "Маврикій",
	  "Мавританія",
	  "Мадаґаскар",
	  "Македонія",
	  "Малаві",
	  "Малайзія",
	  "Малі",
	  "Мальдіви",
	  "Мальта",
	  "Марокко",
	  "Маршаллові Острови",
	  "Мексика",
	  "Мозамбік",
	  "Молдова",
	  "Монако",
	  "Монголія",
	  "Намібія",
	  "Науру",
	  "Непал",
	  "Нігер",
	  "Нігерія",
	  "Нідерланди",
	  "Нікарагуа",
	  "Німеччина",
	  "Нова Зеландія",
	  "Норвегія",
	  "Об’єднані Арабські Емірати",
	  "Оман",
	  "Пакистан",
	  "Палау",
	  "Панама",
	  "Папуа-Нова Гвінея",
	  "Парагвай",
	  "Перу",
	  "Південна Корея",
	  "Південний Судан",
	  "Південно-Африканська Республіка",
	  "Північна Корея",
	  "Польща",
	  "Португалія",
	  "Російська Федерація",
	  "Руанда",
	  "Румунія",
	  "Сальвадор",
	  "Самоа",
	  "Сан-Марино",
	  "Сан-Томе і Принсіпі",
	  "Саудівська Аравія",
	  "Свазіленд",
	  "Сейшельські Острови",
	  "Сенеґал",
	  "Сент-Вінсент і Гренадини",
	  "Сент-Кітс і Невіс",
	  "Сент-Люсія",
	  "Сербія",
	  "Сирія",
	  "Сінгапур",
	  "Словаччина",
	  "Словенія",
	  "Соломонові Острови",
	  "Сомалі",
	  "Судан",
	  "Суринам",
	  "Східний Тимор",
	  "США",
	  "Сьєрра-Леоне",
	  "Таджикистан",
	  "Таїланд",
	  "Танзанія",
	  "Того",
	  "Тонга",
	  "Тринідад і Тобаго",
	  "Тувалу",
	  "Туніс",
	  "Туреччина",
	  "Туркменістан",
	  "Уганда",
	  "Угорщина",
	  "Узбекистан",
	  "Україна",
	  "Уругвай",
	  "Федеративні Штати Мікронезії",
	  "Фіджі",
	  "Філіппіни",
	  "Фінляндія",
	  "Франція",
	  "Хорватія",
	  "Центральноафриканська Республіка",
	  "Чад",
	  "Чехія",
	  "Чилі",
	  "Чорногорія",
	  "Швейцарія",
	  "Швеція",
	  "Шрі-Ланка",
	  "Ямайка",
	  "Японія"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Україна"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(1608);
	address.building_number = __webpack_require__(1603);
	address.street_prefix = __webpack_require__(1616);
	address.street_suffix = __webpack_require__(1617);
	address.secondary_address = __webpack_require__(1612);
	address.postcode = __webpack_require__(1611);
	address.state = __webpack_require__(1613);
	address.street_title = __webpack_require__(1618);
	address.city_name = __webpack_require__(1605);
	address.city = __webpack_require__(1604);
	address.city_prefix = __webpack_require__(1606);
	address.city_suffix = __webpack_require__(1607);
	address.street_name = __webpack_require__(1615);
	address.street_address = __webpack_require__(1614);
	address.default_country = __webpack_require__(1609);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "кв. ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "АР Крим",
	  "Вінницька область",
	  "Волинська область",
	  "Дніпропетровська область",
	  "Донецька область",
	  "Житомирська область",
	  "Закарпатська область",
	  "Запорізька область",
	  "Івано-Франківська область",
	  "Київська область",
	  "Кіровоградська область",
	  "Луганська область",
	  "Львівська область",
	  "Миколаївська область",
	  "Одеська область",
	  "Полтавська область",
	  "Рівненська область",
	  "Сумська область",
	  "Тернопільська область",
	  "Харківська область",
	  "Херсонська область",
	  "Хмельницька область",
	  "Черкаська область",
	  "Чернівецька область",
	  "Чернігівська область",
	  "Київ",
	  "Севастополь"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}, #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{Address.street_title}",
	  "#{Address.street_title} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "вул.",
	  "вулиця",
	  "пр.",
	  "проспект",
	  "пл.",
	  "площа",
	  "пров.",
	  "провулок"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "майдан"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Зелена",
	  "Молодіжна",
	  "Городоцька",
	  "Стрийська",
	  "Вузька",
	  "Нижанківського",
	  "Староміська",
	  "Ліста",
	  "Вічева",
	  "Брюховичів",
	  "Винників",
	  "Рудного",
	  "Коліївщини"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(1621);
	company.suffix = __webpack_require__(1622);
	company.name = __webpack_require__(1620);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.female_first_name}",
	  "#{prefix} #{Name.male_first_name}",
	  "#{prefix} #{Name.male_last_name}",
	  "#{prefix} #{suffix}#{suffix}",
	  "#{prefix} #{suffix}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}#{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ТОВ",
	  "ПАТ",
	  "ПрАТ",
	  "ТДВ",
	  "КТ",
	  "ПТ",
	  "ДП",
	  "ФОП"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Постач",
	  "Торг",
	  "Пром",
	  "Трейд",
	  "Збут"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var uk = {};
	module['exports'] = uk;
	uk.title = "Ukrainian";
	uk.address = __webpack_require__(1610);
	uk.company = __webpack_require__(1619);
	uk.internet = __webpack_require__(1626);
	uk.name = __webpack_require__(1630);
	uk.phone_number = __webpack_require__(1639);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "cherkassy.ua",
	  "cherkasy.ua",
	  "ck.ua",
	  "cn.ua",
	  "com.ua",
	  "crimea.ua",
	  "cv.ua",
	  "dn.ua",
	  "dnepropetrovsk.ua",
	  "dnipropetrovsk.ua",
	  "donetsk.ua",
	  "dp.ua",
	  "if.ua",
	  "in.ua",
	  "ivano-frankivsk.ua",
	  "kh.ua",
	  "kharkiv.ua",
	  "kharkov.ua",
	  "kherson.ua",
	  "khmelnitskiy.ua",
	  "kiev.ua",
	  "kirovograd.ua",
	  "km.ua",
	  "kr.ua",
	  "ks.ua",
	  "lg.ua",
	  "lt.ua",
	  "lugansk.ua",
	  "lutsk.ua",
	  "lutsk.net",
	  "lviv.ua",
	  "mk.ua",
	  "net.ua",
	  "nikolaev.ua",
	  "od.ua",
	  "odessa.ua",
	  "org.ua",
	  "pl.ua",
	  "pl.ua",
	  "poltava.ua",
	  "rovno.ua",
	  "rv.ua",
	  "sebastopol.ua",
	  "sm.ua",
	  "sumy.ua",
	  "te.ua",
	  "ternopil.ua",
	  "ua",
	  "uz.ua",
	  "uzhgorod.ua",
	  "vinnica.ua",
	  "vn.ua",
	  "volyn.net",
	  "volyn.ua",
	  "yalta.ua",
	  "zaporizhzhe.ua",
	  "zhitomir.ua",
	  "zp.ua",
	  "zt.ua",
	  "укр"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ukr.net",
	  "ex.ua",
	  "e-mail.ua",
	  "i.ua",
	  "meta.ua",
	  "yandex.ua",
	  "gmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1625);
	internet.domain_suffix = __webpack_require__(1624);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Аврелія",
	  "Аврора",
	  "Агапія",
	  "Агата",
	  "Агафія",
	  "Агнеса",
	  "Агнія",
	  "Агрипина",
	  "Ада",
	  "Аделаїда",
	  "Аделіна",
	  "Адріана",
	  "Азалія",
	  "Алевтина",
	  "Аліна",
	  "Алла",
	  "Альбіна",
	  "Альвіна",
	  "Анастасія",
	  "Анастасія",
	  "Анатолія",
	  "Ангеліна",
	  "Анжела",
	  "Анна",
	  "Антонида",
	  "Антоніна",
	  "Антонія",
	  "Анфіса",
	  "Аполлінарія",
	  "Аполлонія",
	  "Аркадія",
	  "Артемія",
	  "Афанасія",
	  "Білослава",
	  "Біляна",
	  "Благовіста",
	  "Богдана",
	  "Богуслава",
	  "Божена",
	  "Болеслава",
	  "Борислава",
	  "Броніслава",
	  "В’ячеслава",
	  "Валентина",
	  "Валерія",
	  "Варвара",
	  "Василина",
	  "Вікторія",
	  "Вілена",
	  "Віленіна",
	  "Віліна",
	  "Віола",
	  "Віолетта",
	  "Віра",
	  "Віргінія",
	  "Віта",
	  "Віталіна",
	  "Влада",
	  "Владислава",
	  "Власта",
	  "Всеслава",
	  "Галина",
	  "Ганна",
	  "Гелена",
	  "Далеслава",
	  "Дана",
	  "Дарина",
	  "Дарислава",
	  "Діана",
	  "Діяна",
	  "Добринка",
	  "Добромила",
	  "Добромира",
	  "Добромисла",
	  "Доброслава",
	  "Долеслава",
	  "Доляна",
	  "Жанна",
	  "Жозефіна",
	  "Забава",
	  "Звенислава",
	  "Зінаїда",
	  "Злата",
	  "Зореслава",
	  "Зорина",
	  "Зоряна",
	  "Зоя",
	  "Іванна",
	  "Ілона",
	  "Інна",
	  "Іннеса",
	  "Ірина",
	  "Ірма",
	  "Калина",
	  "Каріна",
	  "Катерина",
	  "Квітка",
	  "Квітослава",
	  "Клавдія",
	  "Крентта",
	  "Ксенія",
	  "Купава",
	  "Лада",
	  "Лариса",
	  "Леся",
	  "Ликера",
	  "Лідія",
	  "Лілія",
	  "Любава",
	  "Любислава",
	  "Любов",
	  "Любомила",
	  "Любомира",
	  "Люборада",
	  "Любослава",
	  "Людмила",
	  "Людомила",
	  "Майя",
	  "Мальва",
	  "Мар’яна",
	  "Марина",
	  "Марічка",
	  "Марія",
	  "Марта",
	  "Меланія",
	  "Мечислава",
	  "Милодара",
	  "Милослава",
	  "Мирослава",
	  "Мілана",
	  "Мокрина",
	  "Мотря",
	  "Мстислава",
	  "Надія",
	  "Наталія",
	  "Неля",
	  "Немира",
	  "Ніна",
	  "Огняна",
	  "Оксана",
	  "Олександра",
	  "Олена",
	  "Олеся",
	  "Ольга",
	  "Ореста",
	  "Орина",
	  "Орислава",
	  "Орися",
	  "Оріяна",
	  "Павліна",
	  "Палажка",
	  "Пелагея",
	  "Пелагія",
	  "Поліна",
	  "Поляна",
	  "Потішана",
	  "Радміла",
	  "Радослава",
	  "Раїна",
	  "Раїса",
	  "Роксолана",
	  "Ромена",
	  "Ростислава",
	  "Руслана",
	  "Світлана",
	  "Святослава",
	  "Слава",
	  "Сміяна",
	  "Сніжана",
	  "Соломія",
	  "Соня",
	  "Софія",
	  "Станислава",
	  "Сюзана",
	  "Таїсія",
	  "Тамара",
	  "Тетяна",
	  "Устина",
	  "Фаїна",
	  "Февронія",
	  "Федора",
	  "Феодосія",
	  "Харитина",
	  "Христина",
	  "Христя",
	  "Юліанна",
	  "Юлія",
	  "Юстина",
	  "Юхима",
	  "Юхимія",
	  "Яна",
	  "Ярина",
	  "Ярослава"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Андрухович",
	  "Бабух",
	  "Балабан",
	  "Балабуха",
	  "Балакун",
	  "Балицька",
	  "Бамбула",
	  "Бандера",
	  "Барановська",
	  "Бачей",
	  "Башук",
	  "Бердник",
	  "Білич",
	  "Бондаренко",
	  "Борецька",
	  "Боровська",
	  "Борочко",
	  "Боярчук",
	  "Брицька",
	  "Бурмило",
	  "Бутько",
	  "Василишина",
	  "Васильківська",
	  "Вергун",
	  "Вередун",
	  "Верещук",
	  "Витребенько",
	  "Вітряк",
	  "Волощук",
	  "Гайдук",
	  "Гайова",
	  "Гайчук",
	  "Галаєнко",
	  "Галатей",
	  "Галаціон",
	  "Гаман",
	  "Гамула",
	  "Ганич",
	  "Гарай",
	  "Гарун",
	  "Гладківська",
	  "Гладух",
	  "Глинська",
	  "Гнатишина",
	  "Гойко",
	  "Головець",
	  "Горбач",
	  "Гордійчук",
	  "Горова",
	  "Городоцька",
	  "Гречко",
	  "Григоришина",
	  "Гриневецька",
	  "Гриневська",
	  "Гришко",
	  "Громико",
	  "Данилишина",
	  "Данилко",
	  "Демків",
	  "Демчишина",
	  "Дзюб’як",
	  "Дзюба",
	  "Дідух",
	  "Дмитришина",
	  "Дмитрук",
	  "Довгалевська",
	  "Дурдинець",
	  "Євенко",
	  "Євпак",
	  "Ємець",
	  "Єрмак",
	  "Забіла",
	  "Зварич",
	  "Зінкевич",
	  "Зленко",
	  "Іванишина",
	  "Калач",
	  "Кандиба",
	  "Карпух",
	  "Кивач",
	  "Коваленко",
	  "Ковальська",
	  "Коломієць",
	  "Коман",
	  "Компанієць",
	  "Кононець",
	  "Кордун",
	  "Корецька",
	  "Корнїйчук",
	  "Коров’як",
	  "Коцюбинська",
	  "Кулинич",
	  "Кульчицька",
	  "Лагойда",
	  "Лазірко",
	  "Ланова",
	  "Латан",
	  "Латанська",
	  "Лахман",
	  "Левадовська",
	  "Ликович",
	  "Линдик",
	  "Ліхно",
	  "Лобачевська",
	  "Ломова",
	  "Лугова",
	  "Луцька",
	  "Луцьків",
	  "Лученко",
	  "Лучко",
	  "Люта",
	  "Лящук",
	  "Магера",
	  "Мазайло",
	  "Мазило",
	  "Мазун",
	  "Майборода",
	  "Майстренко",
	  "Маковецька",
	  "Малкович",
	  "Мамій",
	  "Маринич",
	  "Марієвська",
	  "Марків",
	  "Махно",
	  "Миклашевська",
	  "Миклухо",
	  "Милославська",
	  "Михайлюк",
	  "Міняйло",
	  "Могилевська",
	  "Москаль",
	  "Москалюк",
	  "Мотрієнко",
	  "Негода",
	  "Ногачевська",
	  "Опенько",
	  "Осадко",
	  "Павленко",
	  "Павлишина",
	  "Павлів",
	  "Пагутяк",
	  "Паламарчук",
	  "Палій",
	  "Паращук",
	  "Пасічник",
	  "Пендик",
	  "Петик",
	  "Петлюра",
	  "Петренко",
	  "Петрина",
	  "Петришина",
	  "Петрів",
	  "Плаксій",
	  "Погиба",
	  "Поліщук",
	  "Пономарів",
	  "Поривай",
	  "Поривайло",
	  "Потебенько",
	  "Потоцька",
	  "Пригода",
	  "Приймак",
	  "Притула",
	  "Прядун",
	  "Розпутня",
	  "Романишина",
	  "Ромей",
	  "Роменець",
	  "Ромочко",
	  "Савицька",
	  "Саєнко",
	  "Свидригайло",
	  "Семеночко",
	  "Семещук",
	  "Сердюк",
	  "Силецька",
	  "Сідлецька",
	  "Сідляк",
	  "Сірко",
	  "Скиба",
	  "Скоропадська",
	  "Слободян",
	  "Сосюра",
	  "Сплюха",
	  "Спотикач",
	  "Степанець",
	  "Стигайло",
	  "Сторожук",
	  "Сторчак",
	  "Стоян",
	  "Сучак",
	  "Сушко",
	  "Тарасюк",
	  "Тиндарей",
	  "Ткаченко",
	  "Третяк",
	  "Троян",
	  "Трублаєвська",
	  "Трясило",
	  "Трясун",
	  "Уманець",
	  "Унич",
	  "Усич",
	  "Федоришина",
	  "Цушко",
	  "Червоній",
	  "Шамрило",
	  "Шевченко",
	  "Шестак",
	  "Шиндарей",
	  "Шиян",
	  "Шкараба",
	  "Шудрик",
	  "Шумило",
	  "Шупик",
	  "Шухевич",
	  "Щербак",
	  "Юрчишина",
	  "Юхно",
	  "Ющик",
	  "Ющук",
	  "Яворівська",
	  "Ялова",
	  "Ялюк",
	  "Янюк",
	  "Ярмак",
	  "Яцишина",
	  "Яцьків",
	  "Ящук"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Адамівна",
	  "Азарівна",
	  "Алевтинівна",
	  "Альбертівна",
	  "Анастасівна",
	  "Анатоліївна",
	  "Андріївна",
	  "Антонівна",
	  "Аркадіївна",
	  "Арсенівна",
	  "Арсеніївна",
	  "Артемівна",
	  "Архипівна",
	  "Аскольдівна",
	  "Афанасіївна",
	  "Білославівна",
	  "Богданівна",
	  "Божемирівна",
	  "Боженівна",
	  "Болеславівна",
	  "Боримирівна",
	  "Борисівна",
	  "Бориславівна",
	  "Братиславівна",
	  "В’ячеславівна",
	  "Вадимівна",
	  "Валентинівна",
	  "Валеріївна",
	  "Василівна",
	  "Вікторівна",
	  "Віталіївна",
	  "Владиславівна",
	  "Володимирівна",
	  "Всеволодівна",
	  "Всеславівна",
	  "Гаврилівна",
	  "Гарасимівна",
	  "Георгіївна",
	  "Гнатівна",
	  "Гордіївна",
	  "Григоріївна",
	  "Данилівна",
	  "Даромирівна",
	  "Денисівна",
	  "Дмитрівна",
	  "Добромирівна",
	  "Доброславівна",
	  "Євгенівна",
	  "Захарівна",
	  "Захаріївна",
	  "Збориславівна",
	  "Звенимирівна",
	  "Звениславівна",
	  "Зеновіївна",
	  "Зиновіївна",
	  "Златомирівна",
	  "Зореславівна",
	  "Іванівна",
	  "Ігорівна",
	  "Ізяславівна",
	  "Корнеліївна",
	  "Корнилівна",
	  "Корніївна",
	  "Костянтинівна",
	  "Лаврентіївна",
	  "Любомирівна",
	  "Макарівна",
	  "Максимівна",
	  "Марківна",
	  "Маркіянівна",
	  "Матвіївна",
	  "Мечиславівна",
	  "Микитівна",
	  "Миколаївна",
	  "Миронівна",
	  "Мирославівна",
	  "Михайлівна",
	  "Мстиславівна",
	  "Назарівна",
	  "Назаріївна",
	  "Натанівна",
	  "Немирівна",
	  "Несторівна",
	  "Олегівна",
	  "Олександрівна",
	  "Олексіївна",
	  "Олельківна",
	  "Омелянівна",
	  "Орестівна",
	  "Орхипівна",
	  "Остапівна",
	  "Охрімівна",
	  "Павлівна",
	  "Панасівна",
	  "Пантелеймонівна",
	  "Петрівна",
	  "Пилипівна",
	  "Радимирівна",
	  "Радимівна",
	  "Родіонівна",
	  "Романівна",
	  "Ростиславівна",
	  "Русланівна",
	  "Святославівна",
	  "Сергіївна",
	  "Славутівна",
	  "Станіславівна",
	  "Степанівна",
	  "Стефаніївна",
	  "Тарасівна",
	  "Тимофіївна",
	  "Тихонівна",
	  "Устимівна",
	  "Юріївна",
	  "Юхимівна",
	  "Ярославівна"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(1631);
	name.male_middle_name = __webpack_require__(1633);
	name.male_last_name = __webpack_require__(1632);
	name.female_first_name = __webpack_require__(1627);
	name.female_middle_name = __webpack_require__(1629);
	name.female_last_name = __webpack_require__(1628);
	name.prefix = __webpack_require__(1635);
	name.suffix = __webpack_require__(1636);
	name.title = __webpack_require__(1637);
	name.name = __webpack_require__(1634);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Августин",
	  "Аврелій",
	  "Адам",
	  "Адріян",
	  "Азарій",
	  "Алевтин",
	  "Альберт",
	  "Анастас",
	  "Анастасій",
	  "Анатолій",
	  "Андрій",
	  "Антін",
	  "Антон",
	  "Антоній",
	  "Аркадій",
	  "Арсен",
	  "Арсеній",
	  "Артем",
	  "Архип",
	  "Аскольд",
	  "Афанасій",
	  "Біломир",
	  "Білослав",
	  "Богдан",
	  "Божемир",
	  "Божен",
	  "Болеслав",
	  "Боримир",
	  "Боримисл",
	  "Борис",
	  "Борислав",
	  "Братимир",
	  "Братислав",
	  "Братомил",
	  "Братослав",
	  "Брячислав",
	  "Будимир",
	  "Буйтур",
	  "Буревіст",
	  "В’ячеслав",
	  "Вадим",
	  "Валентин",
	  "Валерій",
	  "Василь",
	  "Велемир",
	  "Віктор",
	  "Віталій",
	  "Влад",
	  "Владислав",
	  "Володимир",
	  "Володислав",
	  "Всевлад",
	  "Всеволод",
	  "Всеслав",
	  "Гаврило",
	  "Гарнослав",
	  "Геннадій",
	  "Георгій",
	  "Герасим",
	  "Гліб",
	  "Гнат",
	  "Гордій",
	  "Горимир",
	  "Горислав",
	  "Градимир",
	  "Григорій",
	  "Далемир",
	  "Данило",
	  "Дарій",
	  "Даромир",
	  "Денис",
	  "Дмитро",
	  "Добромир",
	  "Добромисл",
	  "Доброслав",
	  "Євген",
	  "Єремій",
	  "Захар",
	  "Захарій",
	  "Зборислав",
	  "Звенигор",
	  "Звенимир",
	  "Звенислав",
	  "Земислав",
	  "Зеновій",
	  "Зиновій",
	  "Злат",
	  "Златомир",
	  "Зоремир",
	  "Зореслав",
	  "Зорян",
	  "Іван",
	  "Ігор",
	  "Ізяслав",
	  "Ілля",
	  "Кий",
	  "Корнелій",
	  "Корнилій",
	  "Корнило",
	  "Корній",
	  "Костянтин",
	  "Кузьма",
	  "Лаврентій",
	  "Лаврін",
	  "Лад",
	  "Ладислав",
	  "Ладо",
	  "Ладомир",
	  "Левко",
	  "Листвич",
	  "Лук’ян",
	  "Любодар",
	  "Любозар",
	  "Любомир",
	  "Макар",
	  "Максим",
	  "Мар’ян",
	  "Маркіян",
	  "Марко",
	  "Матвій",
	  "Мечислав",
	  "Микита",
	  "Микола",
	  "Мирон",
	  "Мирослав",
	  "Михайло",
	  "Мстислав",
	  "Мусій",
	  "Назар",
	  "Назарій",
	  "Натан",
	  "Немир",
	  "Нестор",
	  "Олег",
	  "Олександр",
	  "Олексій",
	  "Олелько",
	  "Олесь",
	  "Омелян",
	  "Орест",
	  "Орхип",
	  "Остап",
	  "Охрім",
	  "Павло",
	  "Панас",
	  "Пантелеймон",
	  "Петро",
	  "Пилип",
	  "Подолян",
	  "Потап",
	  "Радим",
	  "Радимир",
	  "Ратибор",
	  "Ратимир",
	  "Родіон",
	  "Родослав",
	  "Роксолан",
	  "Роман",
	  "Ростислав",
	  "Руслан",
	  "Святополк",
	  "Святослав",
	  "Семибор",
	  "Сергій",
	  "Синьоок",
	  "Славолюб",
	  "Славомир",
	  "Славута",
	  "Сніжан",
	  "Сологуб",
	  "Станіслав",
	  "Степан",
	  "Стефаній",
	  "Стожар",
	  "Тарас",
	  "Тиміш",
	  "Тимофій",
	  "Тихон",
	  "Тур",
	  "Устим",
	  "Хвалимир",
	  "Хорив",
	  "Чорнота",
	  "Щастислав",
	  "Щек",
	  "Юліан",
	  "Юрій",
	  "Юхим",
	  "Ян",
	  "Ярема",
	  "Яровид",
	  "Яромил",
	  "Яромир",
	  "Ярополк",
	  "Ярослав"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Андрухович",
	  "Бабух",
	  "Балабан",
	  "Балабух",
	  "Балакун",
	  "Балицький",
	  "Бамбула",
	  "Бандера",
	  "Барановський",
	  "Бачей",
	  "Башук",
	  "Бердник",
	  "Білич",
	  "Бондаренко",
	  "Борецький",
	  "Боровський",
	  "Борочко",
	  "Боярчук",
	  "Брицький",
	  "Бурмило",
	  "Бутько",
	  "Василин",
	  "Василишин",
	  "Васильківський",
	  "Вергун",
	  "Вередун",
	  "Верещук",
	  "Витребенько",
	  "Вітряк",
	  "Волощук",
	  "Гайдук",
	  "Гайовий",
	  "Гайчук",
	  "Галаєнко",
	  "Галатей",
	  "Галаціон",
	  "Гаман",
	  "Гамула",
	  "Ганич",
	  "Гарай",
	  "Гарун",
	  "Гладківський",
	  "Гладух",
	  "Глинський",
	  "Гнатишин",
	  "Гойко",
	  "Головець",
	  "Горбач",
	  "Гордійчук",
	  "Горовий",
	  "Городоцький",
	  "Гречко",
	  "Григоришин",
	  "Гриневецький",
	  "Гриневський",
	  "Гришко",
	  "Громико",
	  "Данилишин",
	  "Данилко",
	  "Демків",
	  "Демчишин",
	  "Дзюб’як",
	  "Дзюба",
	  "Дідух",
	  "Дмитришин",
	  "Дмитрук",
	  "Довгалевський",
	  "Дурдинець",
	  "Євенко",
	  "Євпак",
	  "Ємець",
	  "Єрмак",
	  "Забіла",
	  "Зварич",
	  "Зінкевич",
	  "Зленко",
	  "Іванишин",
	  "Іванів",
	  "Іванців",
	  "Калач",
	  "Кандиба",
	  "Карпух",
	  "Каськів",
	  "Кивач",
	  "Коваленко",
	  "Ковальський",
	  "Коломієць",
	  "Коман",
	  "Компанієць",
	  "Кононець",
	  "Кордун",
	  "Корецький",
	  "Корнїйчук",
	  "Коров’як",
	  "Коцюбинський",
	  "Кулинич",
	  "Кульчицький",
	  "Лагойда",
	  "Лазірко",
	  "Лановий",
	  "Латаний",
	  "Латанський",
	  "Лахман",
	  "Левадовський",
	  "Ликович",
	  "Линдик",
	  "Ліхно",
	  "Лобачевський",
	  "Ломовий",
	  "Луговий",
	  "Луцький",
	  "Луцьків",
	  "Лученко",
	  "Лучко",
	  "Лютий",
	  "Лящук",
	  "Магера",
	  "Мазайло",
	  "Мазило",
	  "Мазун",
	  "Майборода",
	  "Майстренко",
	  "Маковецький",
	  "Малкович",
	  "Мамій",
	  "Маринич",
	  "Марієвський",
	  "Марків",
	  "Махно",
	  "Миклашевський",
	  "Миклухо",
	  "Милославський",
	  "Михайлюк",
	  "Міняйло",
	  "Могилевський",
	  "Москаль",
	  "Москалюк",
	  "Мотрієнко",
	  "Негода",
	  "Ногачевський",
	  "Опенько",
	  "Осадко",
	  "Павленко",
	  "Павлишин",
	  "Павлів",
	  "Пагутяк",
	  "Паламарчук",
	  "Палій",
	  "Паращук",
	  "Пасічник",
	  "Пендик",
	  "Петик",
	  "Петлюра",
	  "Петренко",
	  "Петрин",
	  "Петришин",
	  "Петрів",
	  "Плаксій",
	  "Погиба",
	  "Поліщук",
	  "Пономарів",
	  "Поривай",
	  "Поривайло",
	  "Потебенько",
	  "Потоцький",
	  "Пригода",
	  "Приймак",
	  "Притула",
	  "Прядун",
	  "Розпутній",
	  "Романишин",
	  "Романів",
	  "Ромей",
	  "Роменець",
	  "Ромочко",
	  "Савицький",
	  "Саєнко",
	  "Свидригайло",
	  "Семеночко",
	  "Семещук",
	  "Сердюк",
	  "Силецький",
	  "Сідлецький",
	  "Сідляк",
	  "Сірко",
	  "Скиба",
	  "Скоропадський",
	  "Слободян",
	  "Сосюра",
	  "Сплюх",
	  "Спотикач",
	  "Стахів",
	  "Степанець",
	  "Стецьків",
	  "Стигайло",
	  "Сторожук",
	  "Сторчак",
	  "Стоян",
	  "Сучак",
	  "Сушко",
	  "Тарасюк",
	  "Тиндарей",
	  "Ткаченко",
	  "Третяк",
	  "Троян",
	  "Трублаєвський",
	  "Трясило",
	  "Трясун",
	  "Уманець",
	  "Унич",
	  "Усич",
	  "Федоришин",
	  "Хитрово",
	  "Цимбалістий",
	  "Цушко",
	  "Червоній",
	  "Шамрило",
	  "Шевченко",
	  "Шестак",
	  "Шиндарей",
	  "Шиян",
	  "Шкараба",
	  "Шудрик",
	  "Шумило",
	  "Шупик",
	  "Шухевич",
	  "Щербак",
	  "Юрчишин",
	  "Юхно",
	  "Ющик",
	  "Ющук",
	  "Яворівський",
	  "Яловий",
	  "Ялюк",
	  "Янюк",
	  "Ярмак",
	  "Яцишин",
	  "Яцьків",
	  "Ящук"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Адамович",
	  "Азарович",
	  "Алевтинович",
	  "Альбертович",
	  "Анастасович",
	  "Анатолійович",
	  "Андрійович",
	  "Антонович",
	  "Аркадійович",
	  "Арсенійович",
	  "Арсенович",
	  "Артемович",
	  "Архипович",
	  "Аскольдович",
	  "Афанасійович",
	  "Білославович",
	  "Богданович",
	  "Божемирович",
	  "Боженович",
	  "Болеславович",
	  "Боримирович",
	  "Борисович",
	  "Бориславович",
	  "Братиславович",
	  "В’ячеславович",
	  "Вадимович",
	  "Валентинович",
	  "Валерійович",
	  "Васильович",
	  "Вікторович",
	  "Віталійович",
	  "Владиславович",
	  "Володимирович",
	  "Всеволодович",
	  "Всеславович",
	  "Гаврилович",
	  "Герасимович",
	  "Георгійович",
	  "Гнатович",
	  "Гордійович",
	  "Григорійович",
	  "Данилович",
	  "Даромирович",
	  "Денисович",
	  "Дмитрович",
	  "Добромирович",
	  "Доброславович",
	  "Євгенович",
	  "Захарович",
	  "Захарійович",
	  "Збориславович",
	  "Звенимирович",
	  "Звениславович",
	  "Зеновійович",
	  "Зиновійович",
	  "Златомирович",
	  "Зореславович",
	  "Іванович",
	  "Ігорович",
	  "Ізяславович",
	  "Корнелійович",
	  "Корнилович",
	  "Корнійович",
	  "Костянтинович",
	  "Лаврентійович",
	  "Любомирович",
	  "Макарович",
	  "Максимович",
	  "Маркович",
	  "Маркіянович",
	  "Матвійович",
	  "Мечиславович",
	  "Микитович",
	  "Миколайович",
	  "Миронович",
	  "Мирославович",
	  "Михайлович",
	  "Мстиславович",
	  "Назарович",
	  "Назарійович",
	  "Натанович",
	  "Немирович",
	  "Несторович",
	  "Олегович",
	  "Олександрович",
	  "Олексійович",
	  "Олелькович",
	  "Омелянович",
	  "Орестович",
	  "Орхипович",
	  "Остапович",
	  "Охрімович",
	  "Павлович",
	  "Панасович",
	  "Пантелеймонович",
	  "Петрович",
	  "Пилипович",
	  "Радимирович",
	  "Радимович",
	  "Родіонович",
	  "Романович",
	  "Ростиславович",
	  "Русланович",
	  "Святославович",
	  "Сергійович",
	  "Славутович",
	  "Станіславович",
	  "Степанович",
	  "Стефанович",
	  "Тарасович",
	  "Тимофійович",
	  "Тихонович",
	  "Устимович",
	  "Юрійович",
	  "Юхимович",
	  "Ярославович"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{male_first_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name}",
	  "#{male_first_name} #{male_middle_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name} #{male_middle_name}",
	  "#{female_first_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name}",
	  "#{female_first_name} #{female_middle_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name} #{female_middle_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Пан",
	  "Пані"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "проф.",
	  "доц.",
	  "докт. пед. наук",
	  "докт. політ. наук",
	  "докт. філол. наук",
	  "докт. філос. наук",
	  "докт. і. наук",
	  "докт. юрид. наук",
	  "докт. техн. наук",
	  "докт. психол. наук",
	  "канд. пед. наук",
	  "канд. політ. наук",
	  "канд. філол. наук",
	  "канд. філос. наук",
	  "канд. і. наук",
	  "канд. юрид. наук",
	  "канд. техн. наук",
	  "канд. психол. наук"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Головний",
	    "Генеральний",
	    "Провідний",
	    "Національний",
	    "Регіональний",
	    "Обласний",
	    "Районний",
	    "Глобальний",
	    "Міжнародний",
	    "Центральний"
	  ],
	  "level": [
	    "маркетинговий",
	    "оптимізаційний",
	    "страховий",
	    "функціональний",
	    "інтеграційний",
	    "логістичний"
	  ],
	  "job": [
	    "інженер",
	    "агент",
	    "адміністратор",
	    "аналітик",
	    "архітектор",
	    "дизайнер",
	    "керівник",
	    "консультант",
	    "координатор",
	    "менеджер",
	    "планувальник",
	    "помічник",
	    "розробник",
	    "спеціаліст",
	    "співробітник",
	    "технік"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(044) ###-##-##",
	  "(050) ###-##-##",
	  "(063) ###-##-##",
	  "(066) ###-##-##",
	  "(073) ###-##-##",
	  "(091) ###-##-##",
	  "(092) ###-##-##",
	  "(093) ###-##-##",
	  "(094) ###-##-##",
	  "(095) ###-##-##",
	  "(096) ###-##-##",
	  "(097) ###-##-##",
	  "(098) ###-##-##",
	  "(099) ###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1638);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bắc Giang",
	  "Bắc Kạn",
	  "Bắc Ninh",
	  "Cao Bằng",
	  "Điện Biên",
	  "Hà Giang",
	  "Hà Nam",
	  "Hà Tây",
	  "Hải Dương",
	  "TP Hải Phòng",
	  "Hòa Bình",
	  "Hưng Yên",
	  "Lai Châu",
	  "Lào Cai",
	  "Lạng Sơn",
	  "Nam Định",
	  "Ninh Bình",
	  "Phú Thọ",
	  "Quảng Ninh",
	  "Sơn La",
	  "Thái Bình",
	  "Thái Nguyên",
	  "Tuyên Quang",
	  "Vĩnh Phúc",
	  "Yên Bái",
	  "TP Đà Nẵng",
	  "Bình Định",
	  "Đắk Lắk",
	  "Đắk Nông",
	  "Gia Lai",
	  "Hà Tĩnh",
	  "Khánh Hòa",
	  "Kon Tum",
	  "Nghệ An",
	  "Phú Yên",
	  "Quảng Bình",
	  "Quảng Nam",
	  "Quảng Ngãi",
	  "Quảng Trị",
	  "Thanh Hóa",
	  "Thừa Thiên Huế",
	  "TP TP. Hồ Chí Minh",
	  "An Giang",
	  "Bà Rịa Vũng Tàu",
	  "Bạc Liêu",
	  "Bến Tre",
	  "Bình Dương",
	  "Bình Phước",
	  "Bình Thuận",
	  "Cà Mau",
	  "TP Cần Thơ",
	  "Đồng Nai",
	  "Đồng Tháp",
	  "Hậu Giang",
	  "Kiên Giang",
	  "Lâm Đồng",
	  "Long An",
	  "Ninh Thuận",
	  "Sóc Trăng",
	  "Tây Ninh",
	  "Tiền Giang",
	  "Trà Vinh",
	  "Vĩnh Long"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avon",
	  "Bedfordshire",
	  "Berkshire",
	  "Borders",
	  "Buckinghamshire",
	  "Cambridgeshire",
	  "Central",
	  "Cheshire",
	  "Cleveland",
	  "Clwyd",
	  "Cornwall",
	  "County Antrim",
	  "County Armagh",
	  "County Down",
	  "County Fermanagh",
	  "County Londonderry",
	  "County Tyrone",
	  "Cumbria",
	  "Derbyshire",
	  "Devon",
	  "Dorset",
	  "Dumfries and Galloway",
	  "Durham",
	  "Dyfed",
	  "East Sussex",
	  "Essex",
	  "Fife",
	  "Gloucestershire",
	  "Grampian",
	  "Greater Manchester",
	  "Gwent",
	  "Gwynedd County",
	  "Hampshire",
	  "Herefordshire",
	  "Hertfordshire",
	  "Highlands and Islands",
	  "Humberside",
	  "Isle of Wight",
	  "Kent",
	  "Lancashire",
	  "Leicestershire",
	  "Lincolnshire",
	  "Lothian",
	  "Merseyside",
	  "Mid Glamorgan",
	  "Norfolk",
	  "North Yorkshire",
	  "Northamptonshire",
	  "Northumberland",
	  "Nottinghamshire",
	  "Oxfordshire",
	  "Powys",
	  "Rutland",
	  "Shropshire",
	  "Somerset",
	  "South Glamorgan",
	  "South Yorkshire",
	  "Staffordshire",
	  "Strathclyde",
	  "Suffolk",
	  "Surrey",
	  "Tayside",
	  "Tyne and Wear",
	  "Việt Nam",
	  "Warwickshire",
	  "West Glamorgan",
	  "West Midlands",
	  "West Sussex",
	  "West Yorkshire",
	  "Wiltshire",
	  "Worcestershire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Việt Nam"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_root = __webpack_require__(1641);
	address.city = __webpack_require__(1640);
	address.county = __webpack_require__(1642);
	address.default_country = __webpack_require__(1643);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "074## ######",
	  "075## ######",
	  "076## ######",
	  "077## ######",
	  "078## ######",
	  "079## ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1645);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(1649);
	company.name = __webpack_require__(1648);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Công ty",
	  "Cty TNHH",
	  "Cty",
	  "Cửa hàng",
	  "Trung tâm",
	  "Chi nhánh"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var vi = {};
	module['exports'] = vi;
	vi.title = "Vietnamese";
	vi.address = __webpack_require__(1644);
	vi.internet = __webpack_require__(1652);
	vi.phone_number = __webpack_require__(1660);
	vi.cell_phone = __webpack_require__(1646);
	vi.name = __webpack_require__(1656);
	vi.company = __webpack_require__(1647);
	vi.lorem = __webpack_require__(1653);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "net",
	  "info",
	  "vn",
	  "com.vn"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(1651);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1654);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "đã",
	  "đang",
	  "ừ",
	  "ờ",
	  "á",
	  "không",
	  "biết",
	  "gì",
	  "hết",
	  "đâu",
	  "nha",
	  "thế",
	  "thì",
	  "là",
	  "đánh",
	  "đá",
	  "đập",
	  "phá",
	  "viết",
	  "vẽ",
	  "tô",
	  "thuê",
	  "mướn",
	  "mượn",
	  "mua",
	  "một",
	  "hai",
	  "ba",
	  "bốn",
	  "năm",
	  "sáu",
	  "bảy",
	  "tám",
	  "chín",
	  "mười",
	  "thôi",
	  "việc",
	  "nghỉ",
	  "làm",
	  "nhà",
	  "cửa",
	  "xe",
	  "đạp",
	  "ác",
	  "độc",
	  "khoảng",
	  "khoan",
	  "thuyền",
	  "tàu",
	  "bè",
	  "lầu",
	  "xanh",
	  "đỏ",
	  "tím",
	  "vàng",
	  "kim",
	  "chỉ",
	  "khâu",
	  "may",
	  "vá",
	  "em",
	  "anh",
	  "yêu",
	  "thương",
	  "thích",
	  "con",
	  "cái",
	  "bàn",
	  "ghế",
	  "tủ",
	  "quần",
	  "áo",
	  "nón",
	  "dép",
	  "giày",
	  "lỗi",
	  "được",
	  "ghét",
	  "giết",
	  "chết",
	  "hết",
	  "tôi",
	  "bạn",
	  "tui",
	  "trời",
	  "trăng",
	  "mây",
	  "gió",
	  "máy",
	  "hàng",
	  "hóa",
	  "leo",
	  "núi",
	  "bơi",
	  "biển",
	  "chìm",
	  "xuồng",
	  "nước",
	  "ngọt",
	  "ruộng",
	  "đồng",
	  "quê",
	  "hương"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Phạm",
	  "Nguyễn",
	  "Trần",
	  "Lê",
	  "Lý",
	  "Hoàng",
	  "Phan",
	  "Vũ",
	  "Tăng",
	  "Đặng",
	  "Bùi",
	  "Đỗ",
	  "Hồ",
	  "Ngô",
	  "Dương",
	  "Đào",
	  "Đoàn",
	  "Vương",
	  "Trịnh",
	  "Đinh",
	  "Lâm",
	  "Phùng",
	  "Mai",
	  "Tô",
	  "Trương",
	  "Hà"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1655);
	name.last_name = __webpack_require__(1657);
	name.name = __webpack_require__(1658);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nam",
	  "Trung",
	  "Thanh",
	  "Thị",
	  "Văn",
	  "Dương",
	  "Tăng",
	  "Quốc",
	  "Như",
	  "Phạm",
	  "Nguyễn",
	  "Trần",
	  "Lê",
	  "Lý",
	  "Hoàng",
	  "Phan",
	  "Vũ",
	  "Tăng",
	  "Đặng",
	  "Bùi",
	  "Đỗ",
	  "Hồ",
	  "Ngô",
	  "Dương",
	  "Đào",
	  "Đoàn",
	  "Vương",
	  "Trịnh",
	  "Đinh",
	  "Lâm",
	  "Phùng",
	  "Mai",
	  "Tô",
	  "Trương",
	  "Hà",
	  "Vinh",
	  "Nhung",
	  "Hòa",
	  "Tiến",
	  "Tâm",
	  "Bửu",
	  "Loan",
	  "Hiền",
	  "Hải",
	  "Vân",
	  "Kha",
	  "Minh",
	  "Nhân",
	  "Triệu",
	  "Tuân",
	  "Hữu",
	  "Đức",
	  "Phú",
	  "Khoa",
	  "Thắgn",
	  "Sơn",
	  "Dung",
	  "Tú",
	  "Trinh",
	  "Thảo",
	  "Sa",
	  "Kim",
	  "Long",
	  "Thi",
	  "Cường",
	  "Ngọc",
	  "Sinh",
	  "Khang",
	  "Phong",
	  "Thắm",
	  "Thu",
	  "Thủy",
	  "Nhàn"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01#### #####",
	  "01### ######",
	  "01#1 ### ####",
	  "011# ### ####",
	  "02# #### ####",
	  "03## ### ####",
	  "055 #### ####",
	  "056 #### ####",
	  "0800 ### ####",
	  "08## ### ####",
	  "09## ### ####",
	  "016977 ####",
	  "01### #####",
	  "0500 ######",
	  "0800 ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1659);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "长",
	  "上",
	  "南",
	  "西",
	  "北",
	  "诸",
	  "宁",
	  "珠",
	  "武",
	  "衡",
	  "成",
	  "福",
	  "厦",
	  "贵",
	  "吉",
	  "海",
	  "太",
	  "济",
	  "安",
	  "吉",
	  "包"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "沙市",
	  "京市",
	  "宁市",
	  "安市",
	  "乡县",
	  "海市",
	  "码市",
	  "汉市",
	  "阳市",
	  "都市",
	  "州市",
	  "门市",
	  "阳市",
	  "口市",
	  "原市",
	  "南市",
	  "徽市",
	  "林市",
	  "头市"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "中国"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1663);
	address.city_suffix = __webpack_require__(1664);
	address.building_number = __webpack_require__(1661);
	address.street_suffix = __webpack_require__(1672);
	address.postcode = __webpack_require__(1667);
	address.state = __webpack_require__(1668);
	address.state_abbr = __webpack_require__(1669);
	address.city = __webpack_require__(1662);
	address.street_name = __webpack_require__(1671);
	address.street_address = __webpack_require__(1670);
	address.default_country = __webpack_require__(1665);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北京市",
	  "上海市",
	  "天津市",
	  "重庆市",
	  "黑龙江省",
	  "吉林省",
	  "辽宁省",
	  "内蒙古",
	  "河北省",
	  "新疆",
	  "甘肃省",
	  "青海省",
	  "陕西省",
	  "宁夏",
	  "河南省",
	  "山东省",
	  "山西省",
	  "安徽省",
	  "湖北省",
	  "湖南省",
	  "江苏省",
	  "四川省",
	  "贵州省",
	  "云南省",
	  "广西省",
	  "西藏",
	  "浙江省",
	  "江西省",
	  "广东省",
	  "福建省",
	  "台湾省",
	  "海南省",
	  "香港",
	  "澳门"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "京",
	  "沪",
	  "津",
	  "渝",
	  "黑",
	  "吉",
	  "辽",
	  "蒙",
	  "冀",
	  "新",
	  "甘",
	  "青",
	  "陕",
	  "宁",
	  "豫",
	  "鲁",
	  "晋",
	  "皖",
	  "鄂",
	  "湘",
	  "苏",
	  "川",
	  "黔",
	  "滇",
	  "桂",
	  "藏",
	  "浙",
	  "赣",
	  "粤",
	  "闽",
	  "台",
	  "琼",
	  "港",
	  "澳"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}号"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "巷",
	  "街",
	  "路",
	  "桥",
	  "侬",
	  "旁",
	  "中心",
	  "栋"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var zh_CN = {};
	module['exports'] = zh_CN;
	zh_CN.title = "Chinese";
	zh_CN.address = __webpack_require__(1666);
	zh_CN.name = __webpack_require__(1675);
	zh_CN.phone_number = __webpack_require__(1679);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "王",
	  "李",
	  "张",
	  "刘",
	  "陈",
	  "杨",
	  "黄",
	  "吴",
	  "赵",
	  "周",
	  "徐",
	  "孙",
	  "马",
	  "朱",
	  "胡",
	  "林",
	  "郭",
	  "何",
	  "高",
	  "罗",
	  "郑",
	  "梁",
	  "谢",
	  "宋",
	  "唐",
	  "许",
	  "邓",
	  "冯",
	  "韩",
	  "曹",
	  "曾",
	  "彭",
	  "萧",
	  "蔡",
	  "潘",
	  "田",
	  "董",
	  "袁",
	  "于",
	  "余",
	  "叶",
	  "蒋",
	  "杜",
	  "苏",
	  "魏",
	  "程",
	  "吕",
	  "丁",
	  "沈",
	  "任",
	  "姚",
	  "卢",
	  "傅",
	  "钟",
	  "姜",
	  "崔",
	  "谭",
	  "廖",
	  "范",
	  "汪",
	  "陆",
	  "金",
	  "石",
	  "戴",
	  "贾",
	  "韦",
	  "夏",
	  "邱",
	  "方",
	  "侯",
	  "邹",
	  "熊",
	  "孟",
	  "秦",
	  "白",
	  "江",
	  "阎",
	  "薛",
	  "尹",
	  "段",
	  "雷",
	  "黎",
	  "史",
	  "龙",
	  "陶",
	  "贺",
	  "顾",
	  "毛",
	  "郝",
	  "龚",
	  "邵",
	  "万",
	  "钱",
	  "严",
	  "赖",
	  "覃",
	  "洪",
	  "武",
	  "莫",
	  "孔"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1674);
	name.last_name = __webpack_require__(1676);
	name.name = __webpack_require__(1677);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "绍齐",
	  "博文",
	  "梓晨",
	  "胤祥",
	  "瑞霖",
	  "明哲",
	  "天翊",
	  "凯瑞",
	  "健雄",
	  "耀杰",
	  "潇然",
	  "子涵",
	  "越彬",
	  "钰轩",
	  "智辉",
	  "致远",
	  "俊驰",
	  "雨泽",
	  "烨磊",
	  "晟睿",
	  "文昊",
	  "修洁",
	  "黎昕",
	  "远航",
	  "旭尧",
	  "鸿涛",
	  "伟祺",
	  "荣轩",
	  "越泽",
	  "浩宇",
	  "瑾瑜",
	  "皓轩",
	  "擎苍",
	  "擎宇",
	  "志泽",
	  "子轩",
	  "睿渊",
	  "弘文",
	  "哲瀚",
	  "雨泽",
	  "楷瑞",
	  "建辉",
	  "晋鹏",
	  "天磊",
	  "绍辉",
	  "泽洋",
	  "鑫磊",
	  "鹏煊",
	  "昊强",
	  "伟宸",
	  "博超",
	  "君浩",
	  "子骞",
	  "鹏涛",
	  "炎彬",
	  "鹤轩",
	  "越彬",
	  "风华",
	  "靖琪",
	  "明辉",
	  "伟诚",
	  "明轩",
	  "健柏",
	  "修杰",
	  "志泽",
	  "弘文",
	  "峻熙",
	  "嘉懿",
	  "煜城",
	  "懿轩",
	  "烨伟",
	  "苑博",
	  "伟泽",
	  "熠彤",
	  "鸿煊",
	  "博涛",
	  "烨霖",
	  "烨华",
	  "煜祺",
	  "智宸",
	  "正豪",
	  "昊然",
	  "明杰",
	  "立诚",
	  "立轩",
	  "立辉",
	  "峻熙",
	  "弘文",
	  "熠彤",
	  "鸿煊",
	  "烨霖",
	  "哲瀚",
	  "鑫鹏",
	  "昊天",
	  "思聪",
	  "展鹏",
	  "笑愚",
	  "志强",
	  "炫明",
	  "雪松",
	  "思源",
	  "智渊",
	  "思淼",
	  "晓啸",
	  "天宇",
	  "浩然",
	  "文轩",
	  "鹭洋",
	  "振家",
	  "乐驹",
	  "晓博",
	  "文博",
	  "昊焱",
	  "立果",
	  "金鑫",
	  "锦程",
	  "嘉熙",
	  "鹏飞",
	  "子默",
	  "思远",
	  "浩轩",
	  "语堂",
	  "聪健",
	  "明",
	  "文",
	  "果",
	  "思",
	  "鹏",
	  "驰",
	  "涛",
	  "琪",
	  "浩",
	  "航",
	  "彬"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name}#{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-########",
	  "####-########",
	  "###########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1678);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "臺北",
	  "新北",
	  "桃園",
	  "臺中",
	  "臺南",
	  "高雄",
	  "基隆",
	  "新竹",
	  "嘉義",
	  "苗栗",
	  "彰化",
	  "南投",
	  "雲林",
	  "屏東",
	  "宜蘭",
	  "花蓮",
	  "臺東",
	  "澎湖",
	  "金門",
	  "連江"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "縣",
	  "市"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Taiwan (R.O.C.)"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1682);
	address.city_suffix = __webpack_require__(1683);
	address.building_number = __webpack_require__(1680);
	address.street_suffix = __webpack_require__(1691);
	address.postcode = __webpack_require__(1686);
	address.state = __webpack_require__(1687);
	address.state_abbr = __webpack_require__(1688);
	address.city = __webpack_require__(1681);
	address.street_name = __webpack_require__(1690);
	address.street_address = __webpack_require__(1689);
	address.default_country = __webpack_require__(1684);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "福建省",
	  "台灣省"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北",
	  "新北",
	  "桃",
	  "中",
	  "南",
	  "高",
	  "基",
	  "竹市",
	  "嘉市",
	  "竹縣",
	  "苗",
	  "彰",
	  "投",
	  "雲",
	  "嘉縣",
	  "宜",
	  "花",
	  "東",
	  "澎",
	  "金",
	  "馬"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}號"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "街",
	  "路",
	  "北路",
	  "南路",
	  "東路",
	  "西路"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var zh_TW = {};
	module['exports'] = zh_TW;
	zh_TW.title = "Chinese (Taiwan)";
	zh_TW.address = __webpack_require__(1685);
	zh_TW.name = __webpack_require__(1694);
	zh_TW.phone_number = __webpack_require__(1698);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "王",
	  "李",
	  "張",
	  "劉",
	  "陳",
	  "楊",
	  "黃",
	  "吳",
	  "趙",
	  "週",
	  "徐",
	  "孫",
	  "馬",
	  "朱",
	  "胡",
	  "林",
	  "郭",
	  "何",
	  "高",
	  "羅",
	  "鄭",
	  "梁",
	  "謝",
	  "宋",
	  "唐",
	  "許",
	  "鄧",
	  "馮",
	  "韓",
	  "曹",
	  "曾",
	  "彭",
	  "蕭",
	  "蔡",
	  "潘",
	  "田",
	  "董",
	  "袁",
	  "於",
	  "餘",
	  "葉",
	  "蔣",
	  "杜",
	  "蘇",
	  "魏",
	  "程",
	  "呂",
	  "丁",
	  "沈",
	  "任",
	  "姚",
	  "盧",
	  "傅",
	  "鐘",
	  "姜",
	  "崔",
	  "譚",
	  "廖",
	  "範",
	  "汪",
	  "陸",
	  "金",
	  "石",
	  "戴",
	  "賈",
	  "韋",
	  "夏",
	  "邱",
	  "方",
	  "侯",
	  "鄒",
	  "熊",
	  "孟",
	  "秦",
	  "白",
	  "江",
	  "閻",
	  "薛",
	  "尹",
	  "段",
	  "雷",
	  "黎",
	  "史",
	  "龍",
	  "陶",
	  "賀",
	  "顧",
	  "毛",
	  "郝",
	  "龔",
	  "邵",
	  "萬",
	  "錢",
	  "嚴",
	  "賴",
	  "覃",
	  "洪",
	  "武",
	  "莫",
	  "孔"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1693);
	name.last_name = __webpack_require__(1695);
	name.name = __webpack_require__(1696);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "紹齊",
	  "博文",
	  "梓晨",
	  "胤祥",
	  "瑞霖",
	  "明哲",
	  "天翊",
	  "凱瑞",
	  "健雄",
	  "耀傑",
	  "瀟然",
	  "子涵",
	  "越彬",
	  "鈺軒",
	  "智輝",
	  "致遠",
	  "俊馳",
	  "雨澤",
	  "燁磊",
	  "晟睿",
	  "文昊",
	  "修潔",
	  "黎昕",
	  "遠航",
	  "旭堯",
	  "鴻濤",
	  "偉祺",
	  "榮軒",
	  "越澤",
	  "浩宇",
	  "瑾瑜",
	  "皓軒",
	  "擎蒼",
	  "擎宇",
	  "志澤",
	  "子軒",
	  "睿淵",
	  "弘文",
	  "哲瀚",
	  "雨澤",
	  "楷瑞",
	  "建輝",
	  "晉鵬",
	  "天磊",
	  "紹輝",
	  "澤洋",
	  "鑫磊",
	  "鵬煊",
	  "昊強",
	  "偉宸",
	  "博超",
	  "君浩",
	  "子騫",
	  "鵬濤",
	  "炎彬",
	  "鶴軒",
	  "越彬",
	  "風華",
	  "靖琪",
	  "明輝",
	  "偉誠",
	  "明軒",
	  "健柏",
	  "修傑",
	  "志澤",
	  "弘文",
	  "峻熙",
	  "嘉懿",
	  "煜城",
	  "懿軒",
	  "燁偉",
	  "苑博",
	  "偉澤",
	  "熠彤",
	  "鴻煊",
	  "博濤",
	  "燁霖",
	  "燁華",
	  "煜祺",
	  "智宸",
	  "正豪",
	  "昊然",
	  "明杰",
	  "立誠",
	  "立軒",
	  "立輝",
	  "峻熙",
	  "弘文",
	  "熠彤",
	  "鴻煊",
	  "燁霖",
	  "哲瀚",
	  "鑫鵬",
	  "昊天",
	  "思聰",
	  "展鵬",
	  "笑愚",
	  "志強",
	  "炫明",
	  "雪松",
	  "思源",
	  "智淵",
	  "思淼",
	  "曉嘯",
	  "天宇",
	  "浩然",
	  "文軒",
	  "鷺洋",
	  "振家",
	  "樂駒",
	  "曉博",
	  "文博",
	  "昊焱",
	  "立果",
	  "金鑫",
	  "錦程",
	  "嘉熙",
	  "鵬飛",
	  "子默",
	  "思遠",
	  "浩軒",
	  "語堂",
	  "聰健"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name}#{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0#-#######",
	  "02-########",
	  "09##-######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1697);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {
	/**
	 *
	 * @namespace faker.lorem
	 */
	var Lorem = function (faker) {
	  var self = this;
	  var Helpers = faker.helpers;
	
	  /**
	   * word
	   *
	   * @method faker.lorem.word
	   * @param {number} num
	   */
	  self.word = function (num) {
	    return faker.random.arrayElement(faker.definitions.lorem.words);
	  };
	
	  /**
	   * generates a space separated list of words
	   *
	   * @method faker.lorem.words
	   * @param {number} num number of words, defaults to 3
	   */
	  self.words = function (num) {
	      if (typeof num == 'undefined') { num = 3; }
	      var words = [];
	      for (var i = 0; i < num; i++) {
	        words.push(faker.lorem.word());
	      }
	      return words.join(' ');
	  };
	
	  /**
	   * sentence
	   *
	   * @method faker.lorem.sentence
	   * @param {number} wordCount defaults to a random number between 3 and 10
	   * @param {number} range
	   */
	  self.sentence = function (wordCount, range) {
	      if (typeof wordCount == 'undefined') { wordCount = faker.random.number({ min: 3, max: 10 }); }
	      // if (typeof range == 'undefined') { range = 7; }
	
	      // strange issue with the node_min_test failing for captialize, please fix and add faker.lorem.back
	      //return  faker.lorem.words(wordCount + Helpers.randomNumber(range)).join(' ').capitalize();
	
	      var sentence = faker.lorem.words(wordCount);
	      return sentence.charAt(0).toUpperCase() + sentence.slice(1) + '.';
	  };
	
	  /**
	   * sentences
	   *
	   * @method faker.lorem.sentences
	   * @param {number} sentenceCount defautls to a random number between 2 and 6
	   * @param {string} separator defaults to `' '`
	   */
	  self.sentences = function (sentenceCount, separator) {
	      if (typeof sentenceCount === 'undefined') { sentenceCount = faker.random.number({ min: 2, max: 6 });}
	      if (typeof separator == 'undefined') { separator = " "; }
	      var sentences = [];
	      for (sentenceCount; sentenceCount > 0; sentenceCount--) {
	        sentences.push(faker.lorem.sentence());
	      }
	      return sentences.join(separator);
	  };
	
	  /**
	   * paragraph
	   *
	   * @method faker.lorem.paragraph
	   * @param {number} sentenceCount defaults to 3
	   */
	  self.paragraph = function (sentenceCount) {
	      if (typeof sentenceCount == 'undefined') { sentenceCount = 3; }
	      return faker.lorem.sentences(sentenceCount + faker.random.number(3));
	  };
	
	  /**
	   * paragraphs
	   *
	   * @method faker.lorem.paragraphs
	   * @param {number} paragraphCount defaults to 3
	   * @param {string} separatora defaults to `'\n \r'`
	   */
	  self.paragraphs = function (paragraphCount, separator) {
	    if (typeof separator === "undefined") {
	      separator = "\n \r";
	    }
	    if (typeof paragraphCount == 'undefined') { paragraphCount = 3; }
	    var paragraphs = [];
	    for (paragraphCount; paragraphCount > 0; paragraphCount--) {
	        paragraphs.push(faker.lorem.paragraph());
	    }
	    return paragraphs.join(separator);
	  }
	
	  /**
	   * returns random text based on a random lorem method
	   *
	   * @method faker.lorem.text
	   * @param {number} times
	   */
	  self.text = function loremText (times) {
	    var loremMethods = ['lorem.word', 'lorem.words', 'lorem.sentence', 'lorem.sentences', 'lorem.paragraph', 'lorem.paragraphs', 'lorem.lines'];
	    var randomLoremMethod = faker.random.arrayElement(loremMethods);
	    return faker.fake('{{' + randomLoremMethod + '}}');
	  };
	
	  /**
	   * returns lines of lorem separated by `'\n'`
	   *
	   * @method faker.lorem.lines
	   * @param {number} lineCount defaults to a random number between 1 and 5
	   */
	  self.lines = function lines (lineCount) {
	    if (typeof lineCount === 'undefined') { lineCount = faker.random.number({ min: 1, max: 5 });}
	    return faker.lorem.sentences(lineCount, '\n')
	  };
	
	  return self;
	};
	
	
	module["exports"] = Lorem;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.name
	 */
	function Name (faker) {
	
	  /**
	   * firstName
	   *
	   * @method firstName
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.firstName = function (gender) {
	    if (typeof faker.definitions.name.male_first_name !== "undefined" && typeof faker.definitions.name.female_first_name !== "undefined") {
	      // some locale datasets ( like ru ) have first_name split by gender. since the name.first_name field does not exist in these datasets,
	      // we must randomly pick a name from either gender array so faker.name.firstName will return the correct locale data ( and not fallback )
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      if (gender === 0) {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.male_first_name)
	      } else {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.female_first_name);
	      }
	    }
	    return faker.random.arrayElement(faker.definitions.name.first_name);
	  };
	
	  /**
	   * lastName
	   *
	   * @method lastName
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.lastName = function (gender) {
	    if (typeof faker.definitions.name.male_last_name !== "undefined" && typeof faker.definitions.name.female_last_name !== "undefined") {
	      // some locale datasets ( like ru ) have last_name split by gender. i have no idea how last names can have genders, but also i do not speak russian
	      // see above comment of firstName method
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      if (gender === 0) {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.male_last_name);
	      } else {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.female_last_name);
	      }
	    }
	    return faker.random.arrayElement(faker.definitions.name.last_name);
	  };
	
	  /**
	   * findName
	   *
	   * @method findName
	   * @param {string} firstName
	   * @param {string} lastName
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.findName = function (firstName, lastName, gender) {
	      var r = faker.random.number(8);
	      var prefix, suffix;
	      // in particular locales first and last names split by gender,
	      // thus we keep consistency by passing 0 as male and 1 as female
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      firstName = firstName || faker.name.firstName(gender);
	      lastName = lastName || faker.name.lastName(gender);
	      switch (r) {
	      case 0:
	          prefix = faker.name.prefix(gender);
	          if (prefix) {
	              return prefix + " " + firstName + " " + lastName;
	          }
	      case 1:
	          suffix = faker.name.suffix(gender);
	          if (suffix) {
	              return firstName + " " + lastName + " " + suffix;
	          }
	      }
	
	      return firstName + " " + lastName;
	  };
	
	  /**
	   * jobTitle
	   *
	   * @method jobTitle
	   * @memberof faker.name
	   */
	  this.jobTitle = function () {
	    return  faker.name.jobDescriptor() + " " +
	      faker.name.jobArea() + " " +
	      faker.name.jobType();
	  };
	  
	  /**
	   * prefix
	   *
	   * @method prefix
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.prefix = function (gender) {
	    if (typeof faker.definitions.name.male_prefix !== "undefined" && typeof faker.definitions.name.female_prefix !== "undefined") {
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      if (gender === 0) {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.male_prefix);
	      } else {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.female_prefix);
	      }
	    }
	    return faker.random.arrayElement(faker.definitions.name.prefix);
	  };
	
	  /**
	   * suffix
	   *
	   * @method suffix
	   * @memberof faker.name
	   */
	  this.suffix = function () {
	      return faker.random.arrayElement(faker.definitions.name.suffix);
	  };
	
	  /**
	   * title
	   *
	   * @method title
	   * @memberof faker.name
	   */
	  this.title = function() {
	      var descriptor  = faker.random.arrayElement(faker.definitions.name.title.descriptor),
	          level       = faker.random.arrayElement(faker.definitions.name.title.level),
	          job         = faker.random.arrayElement(faker.definitions.name.title.job);
	
	      return descriptor + " " + level + " " + job;
	  };
	
	  /**
	   * jobDescriptor
	   *
	   * @method jobDescriptor
	   * @memberof faker.name
	   */
	  this.jobDescriptor = function () {
	    return faker.random.arrayElement(faker.definitions.name.title.descriptor);
	  };
	
	  /**
	   * jobArea
	   *
	   * @method jobArea
	   * @memberof faker.name
	   */
	  this.jobArea = function () {
	    return faker.random.arrayElement(faker.definitions.name.title.level);
	  };
	
	  /**
	   * jobType
	   *
	   * @method jobType
	   * @memberof faker.name
	   */
	  this.jobType = function () {
	    return faker.random.arrayElement(faker.definitions.name.title.job);
	  };
	
	}
	
	module['exports'] = Name;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.phone
	 */
	var Phone = function (faker) {
	  var self = this;
	
	  /**
	   * phoneNumber
	   *
	   * @method faker.phone.phoneNumber
	   * @param {string} format
	   */
	  self.phoneNumber = function (format) {
	      format = format || faker.phone.phoneFormats();
	      return faker.helpers.replaceSymbolWithNumber(format);
	  };
	
	  // FIXME: this is strange passing in an array index.
	  /**
	   * phoneNumberFormat
	   *
	   * @method faker.phone.phoneFormatsArrayIndex
	   * @param phoneFormatsArrayIndex
	   */
	  self.phoneNumberFormat = function (phoneFormatsArrayIndex) {
	      phoneFormatsArrayIndex = phoneFormatsArrayIndex || 0;
	      return faker.helpers.replaceSymbolWithNumber(faker.definitions.phone_number.formats[phoneFormatsArrayIndex]);
	  };
	
	  /**
	   * phoneFormats
	   *
	   * @method faker.phone.phoneFormats
	   */
	  self.phoneFormats = function () {
	    return faker.random.arrayElement(faker.definitions.phone_number.formats);
	  };
	  
	  return self;
	
	};
	
	module['exports'] = Phone;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// generates fake data for many computer systems properties
	
	/**
	 *
	 * @namespace faker.system
	 */
	function System (faker) {
	
	  /**
	   * generates a file name with extension or optional type
	   *
	   * @method faker.system.fileName
	   * @param {string} ext
	   * @param {string} type
	   */
	  this.fileName = function (ext, type) {
	    var str = faker.fake("{{random.words}}.{{system.fileExt}}");
	    str = str.replace(/ /g, '_');
	    str = str.replace(/\,/g, '_');
	    str = str.replace(/\-/g, '_');
	    str = str.replace(/\\/g, '_');
	    str = str.toLowerCase();
	    return str;
	  };
	
	  /**
	   * commonFileName
	   *
	   * @method faker.system.commonFileName
	   * @param {string} ext
	   * @param {string} type
	   */
	  this.commonFileName = function (ext, type) {
	    var str = faker.random.words() + "." + (ext || faker.system.commonFileExt());
	    str = str.replace(/ /g, '_');
	    str = str.replace(/\,/g, '_');
	    str = str.replace(/\-/g, '_');
	    str = str.replace(/\\/g, '_');
	    str = str.toLowerCase();
	    return str;
	  };
	
	  /**
	   * mimeType
	   *
	   * @method faker.system.mimeType
	   */
	  this.mimeType = function () {
	    return faker.random.arrayElement(Object.keys(faker.definitions.system.mimeTypes));
	  };
	
	  /**
	   * returns a commonly used file type
	   *
	   * @method faker.system.commonFileType
	   */
	  this.commonFileType = function () {
	    var types = ['video', 'audio', 'image', 'text', 'application'];
	    return faker.random.arrayElement(types)
	  };
	
	  /**
	   * returns a commonly used file extension based on optional type
	   *
	   * @method faker.system.commonFileExt
	   * @param {string} type
	   */
	  this.commonFileExt = function (type) {
	    var types = [
	      'application/pdf',
	      'audio/mpeg',
	      'audio/wav',
	      'image/png',
	      'image/jpeg',
	      'image/gif',
	      'video/mp4',
	      'video/mpeg',
	      'text/html'
	    ];
	    return faker.system.fileExt(faker.random.arrayElement(types));
	  };
	
	
	  /**
	   * returns any file type available as mime-type
	   *
	   * @method faker.system.fileType
	   */
	  this.fileType = function () {
	    var types = [];
	    var mimes = faker.definitions.system.mimeTypes;
	    Object.keys(mimes).forEach(function(m){
	      var parts = m.split('/');
	      if (types.indexOf(parts[0]) === -1) {
	        types.push(parts[0]);
	      }
	    });
	    return faker.random.arrayElement(types);
	  };
	
	  /**
	   * fileExt
	   *
	   * @method faker.system.fileExt
	   * @param {string} mimeType
	   */
	  this.fileExt = function (mimeType) {
	    var exts = [];
	    var mimes = faker.definitions.system.mimeTypes;
	
	    // get specific ext by mime-type
	    if (typeof mimes[mimeType] === "object") {
	      return faker.random.arrayElement(mimes[mimeType].extensions);
	    }
	
	    // reduce mime-types to those with file-extensions
	    Object.keys(mimes).forEach(function(m){
	      if (mimes[m].extensions instanceof Array) {
	        mimes[m].extensions.forEach(function(ext){
	          exts.push(ext)
	        });
	      }
	    });
	    return faker.random.arrayElement(exts);
	  };
	
	  /**
	   * not yet implemented
	   *
	   * @method faker.system.directoryPath
	   */
	  this.directoryPath = function () {
	    // TODO
	  };
	
	  /**
	   * not yet implemented
	   *
	   * @method faker.system.filePath
	   */
	  this.filePath = function () {
	    // TODO
	  };
	
	  /**
	   * semver
	   *
	   * @method faker.system.semver
	   */
	  this.semver = function () {
	      return [faker.random.number(9),
	              faker.random.number(9),
	              faker.random.number(9)].join('.');
	  }
	
	}
	
	module['exports'] = System;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	// this program is a JavaScript version of Mersenne Twister, with concealment and encapsulation in class,
	// an almost straight conversion from the original program, mt19937ar.c,
	// translated by y. okada on July 17, 2006.
	// and modified a little at july 20, 2006, but there are not any substantial differences.
	// in this program, procedure descriptions and comments of original source code were not removed.
	// lines commented with //c// were originally descriptions of c procedure. and a few following lines are appropriate JavaScript descriptions.
	// lines commented with /* and */ are original comments.
	// lines commented with // are additional comments in this JavaScript version.
	// before using this version, create at least one instance of MersenneTwister19937 class, and initialize the each state, given below in c comments, of all the instances.
	/*
	   A C-program for MT19937, with initialization improved 2002/1/26.
	   Coded by Takuji Nishimura and Makoto Matsumoto.
	
	   Before using, initialize the state by using init_genrand(seed)
	   or init_by_array(init_key, key_length).
	
	   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
	   All rights reserved.
	
	   Redistribution and use in source and binary forms, with or without
	   modification, are permitted provided that the following conditions
	   are met:
	
	     1. Redistributions of source code must retain the above copyright
	        notice, this list of conditions and the following disclaimer.
	
	     2. Redistributions in binary form must reproduce the above copyright
	        notice, this list of conditions and the following disclaimer in the
	        documentation and/or other materials provided with the distribution.
	
	     3. The names of its contributors may not be used to endorse or promote
	        products derived from this software without specific prior written
	        permission.
	
	   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
	   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
	   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	
	
	   Any feedback is very welcome.
	   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
	   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
	*/
	
	function MersenneTwister19937()
	{
		/* constants should be scoped inside the class */
		var N, M, MATRIX_A, UPPER_MASK, LOWER_MASK;
		/* Period parameters */
		//c//#define N 624
		//c//#define M 397
		//c//#define MATRIX_A 0x9908b0dfUL   /* constant vector a */
		//c//#define UPPER_MASK 0x80000000UL /* most significant w-r bits */
		//c//#define LOWER_MASK 0x7fffffffUL /* least significant r bits */
		N = 624;
		M = 397;
		MATRIX_A = 0x9908b0df;   /* constant vector a */
		UPPER_MASK = 0x80000000; /* most significant w-r bits */
		LOWER_MASK = 0x7fffffff; /* least significant r bits */
		//c//static unsigned long mt[N]; /* the array for the state vector  */
		//c//static int mti=N+1; /* mti==N+1 means mt[N] is not initialized */
		var mt = new Array(N);   /* the array for the state vector  */
		var mti = N+1;           /* mti==N+1 means mt[N] is not initialized */
	
		function unsigned32 (n1) // returns a 32-bits unsiged integer from an operand to which applied a bit operator.
		{
			return n1 < 0 ? (n1 ^ UPPER_MASK) + UPPER_MASK : n1;
		}
	
		function subtraction32 (n1, n2) // emulates lowerflow of a c 32-bits unsiged integer variable, instead of the operator -. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			return n1 < n2 ? unsigned32((0x100000000 - (n2 - n1)) & 0xffffffff) : n1 - n2;
		}
	
		function addition32 (n1, n2) // emulates overflow of a c 32-bits unsiged integer variable, instead of the operator +. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			return unsigned32((n1 + n2) & 0xffffffff)
		}
	
		function multiplication32 (n1, n2) // emulates overflow of a c 32-bits unsiged integer variable, instead of the operator *. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			var sum = 0;
			for (var i = 0; i < 32; ++i){
				if ((n1 >>> i) & 0x1){
					sum = addition32(sum, unsigned32(n2 << i));
				}
			}
			return sum;
		}
	
		/* initializes mt[N] with a seed */
		//c//void init_genrand(unsigned long s)
		this.init_genrand = function (s)
		{
			//c//mt[0]= s & 0xffffffff;
			mt[0]= unsigned32(s & 0xffffffff);
			for (mti=1; mti<N; mti++) {
				mt[mti] =
				//c//(1812433253 * (mt[mti-1] ^ (mt[mti-1] >> 30)) + mti);
				addition32(multiplication32(1812433253, unsigned32(mt[mti-1] ^ (mt[mti-1] >>> 30))), mti);
				/* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */
				/* In the previous versions, MSBs of the seed affect   */
				/* only MSBs of the array mt[].                        */
				/* 2002/01/09 modified by Makoto Matsumoto             */
				//c//mt[mti] &= 0xffffffff;
				mt[mti] = unsigned32(mt[mti] & 0xffffffff);
				/* for >32 bit machines */
			}
		}
	
		/* initialize by an array with array-length */
		/* init_key is the array for initializing keys */
		/* key_length is its length */
		/* slight change for C++, 2004/2/26 */
		//c//void init_by_array(unsigned long init_key[], int key_length)
		this.init_by_array = function (init_key, key_length)
		{
			//c//int i, j, k;
			var i, j, k;
			//c//init_genrand(19650218);
			this.init_genrand(19650218);
			i=1; j=0;
			k = (N>key_length ? N : key_length);
			for (; k; k--) {
				//c//mt[i] = (mt[i] ^ ((mt[i-1] ^ (mt[i-1] >> 30)) * 1664525))
				//c//	+ init_key[j] + j; /* non linear */
				mt[i] = addition32(addition32(unsigned32(mt[i] ^ multiplication32(unsigned32(mt[i-1] ^ (mt[i-1] >>> 30)), 1664525)), init_key[j]), j);
				mt[i] =
				//c//mt[i] &= 0xffffffff; /* for WORDSIZE > 32 machines */
				unsigned32(mt[i] & 0xffffffff);
				i++; j++;
				if (i>=N) { mt[0] = mt[N-1]; i=1; }
				if (j>=key_length) j=0;
			}
			for (k=N-1; k; k--) {
				//c//mt[i] = (mt[i] ^ ((mt[i-1] ^ (mt[i-1] >> 30)) * 1566083941))
				//c//- i; /* non linear */
				mt[i] = subtraction32(unsigned32((dbg=mt[i]) ^ multiplication32(unsigned32(mt[i-1] ^ (mt[i-1] >>> 30)), 1566083941)), i);
				//c//mt[i] &= 0xffffffff; /* for WORDSIZE > 32 machines */
				mt[i] = unsigned32(mt[i] & 0xffffffff);
				i++;
				if (i>=N) { mt[0] = mt[N-1]; i=1; }
			}
			mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */
		}
	
	    /* moved outside of genrand_int32() by jwatte 2010-11-17; generate less garbage */
	    var mag01 = [0x0, MATRIX_A];
	
		/* generates a random number on [0,0xffffffff]-interval */
		//c//unsigned long genrand_int32(void)
		this.genrand_int32 = function ()
		{
			//c//unsigned long y;
			//c//static unsigned long mag01[2]={0x0UL, MATRIX_A};
			var y;
			/* mag01[x] = x * MATRIX_A  for x=0,1 */
	
			if (mti >= N) { /* generate N words at one time */
				//c//int kk;
				var kk;
	
				if (mti == N+1)   /* if init_genrand() has not been called, */
					//c//init_genrand(5489); /* a default initial seed is used */
					this.init_genrand(5489); /* a default initial seed is used */
	
				for (kk=0;kk<N-M;kk++) {
					//c//y = (mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK);
					//c//mt[kk] = mt[kk+M] ^ (y >> 1) ^ mag01[y & 0x1];
					y = unsigned32((mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK));
					mt[kk] = unsigned32(mt[kk+M] ^ (y >>> 1) ^ mag01[y & 0x1]);
				}
				for (;kk<N-1;kk++) {
					//c//y = (mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK);
					//c//mt[kk] = mt[kk+(M-N)] ^ (y >> 1) ^ mag01[y & 0x1];
					y = unsigned32((mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK));
					mt[kk] = unsigned32(mt[kk+(M-N)] ^ (y >>> 1) ^ mag01[y & 0x1]);
				}
				//c//y = (mt[N-1]&UPPER_MASK)|(mt[0]&LOWER_MASK);
				//c//mt[N-1] = mt[M-1] ^ (y >> 1) ^ mag01[y & 0x1];
				y = unsigned32((mt[N-1]&UPPER_MASK)|(mt[0]&LOWER_MASK));
				mt[N-1] = unsigned32(mt[M-1] ^ (y >>> 1) ^ mag01[y & 0x1]);
				mti = 0;
			}
	
			y = mt[mti++];
	
			/* Tempering */
			//c//y ^= (y >> 11);
			//c//y ^= (y << 7) & 0x9d2c5680;
			//c//y ^= (y << 15) & 0xefc60000;
			//c//y ^= (y >> 18);
			y = unsigned32(y ^ (y >>> 11));
			y = unsigned32(y ^ ((y << 7) & 0x9d2c5680));
			y = unsigned32(y ^ ((y << 15) & 0xefc60000));
			y = unsigned32(y ^ (y >>> 18));
	
			return y;
		}
	
		/* generates a random number on [0,0x7fffffff]-interval */
		//c//long genrand_int31(void)
		this.genrand_int31 = function ()
		{
			//c//return (genrand_int32()>>1);
			return (this.genrand_int32()>>>1);
		}
	
		/* generates a random number on [0,1]-real-interval */
		//c//double genrand_real1(void)
		this.genrand_real1 = function ()
		{
			//c//return genrand_int32()*(1.0/4294967295.0);
			return this.genrand_int32()*(1.0/4294967295.0);
			/* divided by 2^32-1 */
		}
	
		/* generates a random number on [0,1)-real-interval */
		//c//double genrand_real2(void)
		this.genrand_real2 = function ()
		{
			//c//return genrand_int32()*(1.0/4294967296.0);
			return this.genrand_int32()*(1.0/4294967296.0);
			/* divided by 2^32 */
		}
	
		/* generates a random number on (0,1)-real-interval */
		//c//double genrand_real3(void)
		this.genrand_real3 = function ()
		{
			//c//return ((genrand_int32()) + 0.5)*(1.0/4294967296.0);
			return ((this.genrand_int32()) + 0.5)*(1.0/4294967296.0);
			/* divided by 2^32 */
		}
	
		/* generates a random number on [0,1) with 53-bit resolution*/
		//c//double genrand_res53(void)
		this.genrand_res53 = function ()
		{
			//c//unsigned long a=genrand_int32()>>5, b=genrand_int32()>>6;
			var a=this.genrand_int32()>>>5, b=this.genrand_int32()>>>6;
			return(a*67108864.0+b)*(1.0/9007199254740992.0);
		}
		/* These real versions are due to Isaku Wada, 2002/01/09 added */
	}
	
	//  Exports: Public API
	
	//  Export the twister class
	exports.MersenneTwister19937 = MersenneTwister19937;
	
	//  Export a simplified function to generate random numbers
	var gen = new MersenneTwister19937;
	gen.init_genrand((new Date).getTime() % 1000000000);
	
	// Added max, min range functionality, Marak Squires Sept 11 2014
	exports.rand = function(max, min) {
	    if (max === undefined)
	        {
	        min = 0;
	        max = 32768;
	        }
	    return Math.floor(gen.genrand_real2() * (max - min) + min);
	}
	exports.seed = function(S) {
	    if (typeof(S) != 'number')
	        {
	        throw new Error("seed(S) must take numeric argument; is " + typeof(S));
	        }
	    gen.init_genrand(S);
	}
	exports.seed_array = function(A) {
	    if (typeof(A) != 'object')
	        {
	        throw new Error("seed_array(A) must take array of numbers; is " + typeof(A));
	        }
	    gen.init_by_array(A);
	}


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * password-generator
	 * Copyright(c) 2011-2013 Bermi Ferrer <bermi@bermilabs.com>
	 * MIT Licensed
	 */
	(function (root) {
	
	  var localName, consonant, letter, password, vowel;
	  letter = /[a-zA-Z]$/;
	  vowel = /[aeiouAEIOU]$/;
	  consonant = /[bcdfghjklmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ]$/;
	
	
	  // Defines the name of the local variable the passwordGenerator library will use
	  // this is specially useful if window.passwordGenerator is already being used
	  // by your application and you want a different name. For example:
	  //    // Declare before including the passwordGenerator library
	  //    var localPasswordGeneratorLibraryName = 'pass';
	  localName = root.localPasswordGeneratorLibraryName || "generatePassword",
	
	  password = function (length, memorable, pattern, prefix) {
	    var char, n;
	    if (length == null) {
	      length = 10;
	    }
	    if (memorable == null) {
	      memorable = true;
	    }
	    if (pattern == null) {
	      pattern = /\w/;
	    }
	    if (prefix == null) {
	      prefix = '';
	    }
	    if (prefix.length >= length) {
	      return prefix;
	    }
	    if (memorable) {
	      if (prefix.match(consonant)) {
	        pattern = vowel;
	      } else {
	        pattern = consonant;
	      }
	    }
	    n = Math.floor(Math.random() * 94) + 33;
	    char = String.fromCharCode(n);
	    if (memorable) {
	      char = char.toLowerCase();
	    }
	    if (!char.match(pattern)) {
	      return password(length, memorable, pattern, prefix);
	    }
	    return password(length, memorable, pattern, "" + prefix + char);
	  };
	
	
	  (( true) ? exports : root)[localName] = password;
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      module.exports = password;
	    }
	  }
	
	  // Establish the root object, `window` in the browser, or `global` on the server.
	}(this));

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

	/*
	
	Copyright (c) 2012-2014 Jeffrey Mealo
	
	Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
	documentation files (the "Software"), to deal in the Software without restriction, including without limitation
	the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
	to permit persons to whom the Software is furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all copies or substantial portions of the
	Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
	WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	------------------------------------------------------------------------------------------------------------------------
	
	Based loosely on Luka Pusic's PHP Script: http://360percents.com/posts/php-random-user-agent-generator/
	
	The license for that script is as follows:
	
	"THE BEER-WARE LICENSE" (Revision 42):
	
	<pusic93@gmail.com> wrote this file. As long as you retain this notice you can do whatever you want with this stuff.
	If we meet some day, and you think this stuff is worth it, you can buy me a beer in return. Luka Pusic
	*/
	
	function rnd(a, b) {
	    //calling rnd() with no arguments is identical to rnd(0, 100)
	    a = a || 0;
	    b = b || 100;
	
	    if (typeof b === 'number' && typeof a === 'number') {
	        //rnd(int min, int max) returns integer between min, max
	        return (function (min, max) {
	            if (min > max) {
	                throw new RangeError('expected min <= max; got min = ' + min + ', max = ' + max);
	            }
	            return Math.floor(Math.random() * (max - min + 1)) + min;
	        }(a, b));
	    }
	
	    if (Object.prototype.toString.call(a) === "[object Array]") {
	        //returns a random element from array (a), even weighting
	        return a[Math.floor(Math.random() * a.length)];
	    }
	
	    if (a && typeof a === 'object') {
	        //returns a random key from the passed object; keys are weighted by the decimal probability in their value
	        return (function (obj) {
	            var rand = rnd(0, 100) / 100, min = 0, max = 0, key, return_val;
	
	            for (key in obj) {
	                if (obj.hasOwnProperty(key)) {
	                    max = obj[key] + min;
	                    return_val = key;
	                    if (rand >= min && rand <= max) {
	                        break;
	                    }
	                    min = min + obj[key];
	                }
	            }
	
	            return return_val;
	        }(a));
	    }
	
	    throw new TypeError('Invalid arguments passed to rnd. (' + (b ? a + ', ' + b : a) + ')');
	}
	
	function randomLang() {
	    return rnd(['AB', 'AF', 'AN', 'AR', 'AS', 'AZ', 'BE', 'BG', 'BN', 'BO', 'BR', 'BS', 'CA', 'CE', 'CO', 'CS',
	                'CU', 'CY', 'DA', 'DE', 'EL', 'EN', 'EO', 'ES', 'ET', 'EU', 'FA', 'FI', 'FJ', 'FO', 'FR', 'FY',
	                'GA', 'GD', 'GL', 'GV', 'HE', 'HI', 'HR', 'HT', 'HU', 'HY', 'ID', 'IS', 'IT', 'JA', 'JV', 'KA',
	                'KG', 'KO', 'KU', 'KW', 'KY', 'LA', 'LB', 'LI', 'LN', 'LT', 'LV', 'MG', 'MK', 'MN', 'MO', 'MS',
	                'MT', 'MY', 'NB', 'NE', 'NL', 'NN', 'NO', 'OC', 'PL', 'PT', 'RM', 'RO', 'RU', 'SC', 'SE', 'SK',
	                'SL', 'SO', 'SQ', 'SR', 'SV', 'SW', 'TK', 'TR', 'TY', 'UK', 'UR', 'UZ', 'VI', 'VO', 'YI', 'ZH']);
	}
	
	function randomBrowserAndOS() {
	    var browser = rnd({
	        chrome:    .45132810566,
	        iexplorer: .27477061836,
	        firefox:   .19384170608,
	        safari:    .06186781118,
	        opera:     .01574236955
	    }),
	    os = {
	        chrome:  {win: .89,  mac: .09 , lin: .02},
	        firefox: {win: .83,  mac: .16,  lin: .01},
	        opera:   {win: .91,  mac: .03 , lin: .06},
	        safari:  {win: .04 , mac: .96  },
	        iexplorer: ['win']
	    };
	
	    return [browser, rnd(os[browser])];
	}
	
	function randomProc(arch) {
	    var procs = {
	        lin:['i686', 'x86_64'],
	        mac: {'Intel' : .48, 'PPC': .01, 'U; Intel':.48, 'U; PPC' :.01},
	        win:['', 'WOW64', 'Win64; x64']
	    };
	    return rnd(procs[arch]);
	}
	
	function randomRevision(dots) {
	    var return_val = '';
	    //generate a random revision
	    //dots = 2 returns .x.y where x & y are between 0 and 9
	    for (var x = 0; x < dots; x++) {
	        return_val += '.' + rnd(0, 9);
	    }
	    return return_val;
	}
	
	var version_string = {
	    net: function () {
	        return [rnd(1, 4), rnd(0, 9), rnd(10000, 99999), rnd(0, 9)].join('.');
	    },
	    nt: function () {
	        return rnd(5, 6) + '.' + rnd(0, 3);
	    },
	    ie: function () {
	        return rnd(7, 11);
	    },
	    trident: function () {
	        return rnd(3, 7) + '.' + rnd(0, 1);
	    },
	    osx: function (delim) {
	        return [10, rnd(5, 10), rnd(0, 9)].join(delim || '.');
	    },
	    chrome: function () {
	        return [rnd(13, 39), 0, rnd(800, 899), 0].join('.');
	    },
	    presto: function () {
	        return '2.9.' + rnd(160, 190);
	    },
	    presto2: function () {
	        return rnd(10, 12) + '.00';
	    },
	    safari: function () {
	        return rnd(531, 538) + '.' + rnd(0, 2) + '.' + rnd(0,2);
	    }
	};
	
	var browser = {
	    firefox: function firefox(arch) {
	        //https://developer.mozilla.org/en-US/docs/Gecko_user_agent_string_reference
	        var firefox_ver = rnd(5, 15) + randomRevision(2),
	            gecko_ver = 'Gecko/20100101 Firefox/' + firefox_ver,
	            proc = randomProc(arch),
	            os_ver = (arch === 'win') ? '(Windows NT ' + version_string.nt() + ((proc) ? '; ' + proc : '')
	            : (arch === 'mac') ? '(Macintosh; ' + proc + ' Mac OS X ' + version_string.osx()
	            : '(X11; Linux ' + proc;
	
	        return 'Mozilla/5.0 ' + os_ver + '; rv:' + firefox_ver.slice(0, -2) + ') ' + gecko_ver;
	    },
	
	    iexplorer: function iexplorer() {
	        var ver = version_string.ie();
	
	        if (ver >= 11) {
	            //http://msdn.microsoft.com/en-us/library/ie/hh869301(v=vs.85).aspx
	            return 'Mozilla/5.0 (Windows NT 6.' + rnd(1,3) + '; Trident/7.0; ' + rnd(['Touch; ', '']) + 'rv:11.0) like Gecko';
	        }
	
	        //http://msdn.microsoft.com/en-us/library/ie/ms537503(v=vs.85).aspx
	        return 'Mozilla/5.0 (compatible; MSIE ' + ver + '.0; Windows NT ' + version_string.nt() + '; Trident/' +
	            version_string.trident() + ((rnd(0, 1) === 1) ? '; .NET CLR ' + version_string.net() : '') + ')';
	    },
	
	    opera: function opera(arch) {
	        //http://www.opera.com/docs/history/
	        var presto_ver = ' Presto/' + version_string.presto() + ' Version/' + version_string.presto2() + ')',
	            os_ver = (arch === 'win') ? '(Windows NT ' + version_string.nt() + '; U; ' + randomLang() + presto_ver
	            : (arch === 'lin') ? '(X11; Linux ' + randomProc(arch) + '; U; ' + randomLang() + presto_ver
	            : '(Macintosh; Intel Mac OS X ' + version_string.osx() + ' U; ' + randomLang() + ' Presto/' +
	            version_string.presto() + ' Version/' + version_string.presto2() + ')';
	
	        return 'Opera/' + rnd(9, 14) + '.' + rnd(0, 99) + ' ' + os_ver;
	    },
	
	    safari: function safari(arch) {
	        var safari = version_string.safari(),
	            ver = rnd(4, 7) + '.' + rnd(0,1) + '.' + rnd(0,10),
	            os_ver = (arch === 'mac') ? '(Macintosh; ' + randomProc('mac') + ' Mac OS X '+ version_string.osx('_') + ' rv:' + rnd(2, 6) + '.0; '+ randomLang() + ') '
	            : '(Windows; U; Windows NT ' + version_string.nt() + ')';
	
	        return 'Mozilla/5.0 ' + os_ver + 'AppleWebKit/' + safari + ' (KHTML, like Gecko) Version/' + ver + ' Safari/' + safari;
	    },
	
	    chrome: function chrome(arch) {
	        var safari = version_string.safari(),
	            os_ver = (arch === 'mac') ? '(Macintosh; ' + randomProc('mac') + ' Mac OS X ' + version_string.osx('_') + ') '
	            : (arch === 'win') ? '(Windows; U; Windows NT ' + version_string.nt() + ')'
	            : '(X11; Linux ' + randomProc(arch);
	
	        return 'Mozilla/5.0 ' + os_ver + ' AppleWebKit/' + safari + ' (KHTML, like Gecko) Chrome/' + version_string.chrome() + ' Safari/' + safari;
	    }
	};
	
	exports.generate = function generate() {
	    var random = randomBrowserAndOS();
	    return browser[random[0]](random[1]);
	};


/***/ }),
/* 1706 */,
/* 1707 */,
/* 1708 */
/***/ (function(module, exports) {

	/**
	 * HideSeek jQuery plugin
	 *
	 * @copyright Copyright 2015, Dimitris Krestos
	 * @license   Apache License, Version 2.0 (http://www.opensource.org/licenses/apache2.0.php)
	 * @link      http://vdw.staytuned.gr
	 * @version   v0.7.1
	 *
	 * Dependencies are include in minified versions at the bottom:
	 * 1. Highlight v4 by Johann Burkard
	 *
	 */
	
	  /* Sample html structure
	
	  <input name="search" placeholder="Start typing here" type="text" data-list=".list">
	  <ul class="list">
	    <li>item 1</li>
	    <li>...</li>
	    <li><a href="#">item 2</a></li>
	  </ul>
	
	  or
	
	  <input name="search" placeholder="Start typing here" type="text" data-list=".list">
	  <div class="list">
	    <span>item 1</span>
	    <span>...</span>
	    <span>item 2</span>
	  </div>
	
	  or any similar structure...
	
	  */
	
	;(function($, window, undefined) {
	  "use strict";
	
	  $.fn.hideseek = function(options) {
	
	    var defaults = {
	      list:           '.hideseek-data',
	      nodata:         '',
	      attribute:      'text',
	      highlight:      false,
	      ignore:         '',
	      headers:        '',
	      navigation:     false,
	      ignore_accents: false,
	      hidden_mode:    false,
	      min_chars:      1
	    };
	
	    var options = $.extend(defaults, options);
	
	    return this.each(function() {
	
	      var $this = $(this);
	
	      $this.opts = [];
	
	      $.map( ['list', 'nodata', 'attribute', 'highlight', 'ignore', 'headers', 'navigation', 'ignore_accents', 'hidden_mode', 'min_chars'], function( val, i ) {
	        $this.opts[val] = $this.data(val) || options[val];
	      } );
	
	      if ($this.opts.headers)
	        $this.opts.ignore += $this.opts.ignore ? ', ' + $this.opts.headers : $this.opts.headers;
	
	      var $list = $($this.opts.list);
	
	      if ($this.opts.navigation)  $this.attr('autocomplete', 'off');
	
	      if ($this.opts.hidden_mode) $list.children().hide();
	
	      $this.keyup(function(e) {
	
	        if (e.keyCode != 38 && e.keyCode != 40 && e.keyCode != 13 && ( e.keyCode != 8 ? $this.val().length >= $this.opts.min_chars : true ) ) {
	
	          var q = $this.val().toLowerCase();
	
	          $list.children($this.opts.ignore.trim() ? ":not(" + $this.opts.ignore + ")" : '').removeClass('selected').each(function() {
	
	            var data = (
	                        $this.opts.attribute != 'text'
	                          ? ($(this).attr($this.opts.attribute) || '')
	                          : $(this).text()
	                        ).toLowerCase();
	
	            var treaty = data.removeAccents($this.opts.ignore_accents).indexOf(q) == -1 || q === ($this.opts.hidden_mode ? '' : false)
	
	            if (treaty) {
	
	              $(this).hide();
	
	              $this.trigger('_after_each');
	
	            } else {
	
	              $this.opts.highlight ? $(this).removeHighlight().highlight(q).show() : $(this).show();
	
	              $this.trigger('_after_each');
	
	            }
	
	          });
	
	          // No results message
	          if ($this.opts.nodata) {
	
	            $list.find('.no-results').remove();
	
	            if (!$list.children(':not([style*="display: none"])').length) {
	
	              $list
	                .children()
	                .first()
	                .clone()
	                .removeHighlight()
	                .addClass('no-results')
	                .show()
	                .prependTo($this.opts.list)
	                .text($this.opts.nodata);
	
	              $this.trigger('_after_nodata');
	
	            }
	
	          }
	
	          // hide headers with no results
	          if ($this.opts.headers) {
	            $($this.opts.headers, $list).each(function() {
	              if (!$(this).nextUntil($this.opts.headers).not('[style*="display: none"],' + $this.opts.ignore).length) {
	                $(this).hide();
	              } else {
	                $(this).show();
	              }
	            });
	          }
	
	          $this.trigger('_after');
	
	        };
	
	        // Navigation
	        function current(element) {
	          return element.children('.selected:visible');
	        };
	
	        function prev(element) {
	          return current(element).prevAll(":visible:first");
	        };
	
	        function next(element) {
	          return current(element).nextAll(":visible:first");
	        };
	
	        if ($this.opts.navigation) {
	
	          if (e.keyCode == 38) {
	
	            if (current($list).length) {
	
	              prev($list).addClass('selected');
	
	              current($list).last().removeClass('selected');
	
	            } else {
	
	              $list.children(':visible').last().addClass('selected');
	
	            };
	
	          } else if (e.keyCode == 40) {
	
	            if (current($list).length) {
	
	              next($list).addClass('selected');
	
	              current($list).first().removeClass('selected');
	
	            } else {
	
	              $list.children(':visible').first().addClass('selected');
	
	            };
	
	          } else if (e.keyCode == 13) {
	
	            if (current($list).find('a').length) {
	
	              document.location = current($list).find('a').attr('href');
	
	            } else {
	
	              $this.val(current($list).text());
	
	            };
	
	          };
	
	        };
	
	      });
	
	    });
	
	  };
	
	  $(document).ready(function () { $('[data-toggle="hideseek"]').hideseek(); });
	
	})(jQuery);
	
	/*
	
	highlight v4
	
	Highlights arbitrary terms.
	
	<http://johannburkard.de/blog/programming/javascript/highlight-javascript-text-higlighting-jquery-plugin.html>
	
	MIT license.
	
	Johann Burkard
	<http://johannburkard.de>
	<mailto:jb@eaio.com>
	
	*/
	jQuery.fn.highlight=function(t){function e(t,i){var n=0;if(3==t.nodeType){var a=t.data.removeAccents(true).toUpperCase().indexOf(i);if(a>=0){var s=document.createElement("mark");s.className="highlight";var r=t.splitText(a);r.splitText(i.length);var o=r.cloneNode(!0);s.appendChild(o),r.parentNode.replaceChild(s,r),n=1}}else if(1==t.nodeType&&t.childNodes&&!/(script|style)/i.test(t.tagName))for(var h=0;h<t.childNodes.length;++h)h+=e(t.childNodes[h],i);return n}return this.length&&t&&t.length?this.each(function(){e(this,t.toUpperCase())}):this},jQuery.fn.removeHighlight=function(){return this.find("mark.highlight").each(function(){with(this.parentNode.firstChild.nodeName,this.parentNode)replaceChild(this.firstChild,this),normalize()}).end()};
	
	// Ignore accents
	String.prototype.removeAccents = function(enabled) {
	  if (enabled) return this
	                      .replace(/[áàãâä]/gi,"a")
	                      .replace(/[éè¨ê]/gi,"e")
	                      .replace(/[íìïî]/gi,"i")
	                      .replace(/[óòöôõ]/gi,"o")
	                      .replace(/[úùüû]/gi, "u")
	                      .replace(/[ç]/gi, "c")
	                      .replace(/[ñ]/gi, "n");
	  return this;
	};


/***/ }),
/* 1709 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  decode: __webpack_require__(243),
	  verify: __webpack_require__(1714),
	  sign: __webpack_require__(1713),
	  JsonWebTokenError: __webpack_require__(114),
	  NotBeforeError: __webpack_require__(244),
	  TokenExpiredError: __webpack_require__(245),
	};


/***/ }),
/* 1711 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var w = d * 7;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isFinite(val)) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'weeks':
	    case 'week':
	    case 'w':
	      return n * w;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (msAbs >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (msAbs >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (msAbs >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return plural(ms, msAbs, d, 'day');
	  }
	  if (msAbs >= h) {
	    return plural(ms, msAbs, h, 'hour');
	  }
	  if (msAbs >= m) {
	    return plural(ms, msAbs, m, 'minute');
	  }
	  if (msAbs >= s) {
	    return plural(ms, msAbs, s, 'second');
	  }
	  return ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, msAbs, n, name) {
	  var isPlural = msAbs >= n * 1.5;
	  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
	}


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer
	
	var debug
	/* istanbul ignore next */
	if (typeof process === 'object' &&
	    ({"NODE_ENV":"production"}) &&
	    ({"NODE_ENV":"production"}).NODE_DEBUG &&
	    /\bsemver\b/i.test(({"NODE_ENV":"production"}).NODE_DEBUG)) {
	  debug = function () {
	    var args = Array.prototype.slice.call(arguments, 0)
	    args.unshift('SEMVER')
	    console.log.apply(console, args)
	  }
	} else {
	  debug = function () {}
	}
	
	// Note: this is the semver.org version of the spec that it implements
	// Not necessarily the package version of this code.
	exports.SEMVER_SPEC_VERSION = '2.0.0'
	
	var MAX_LENGTH = 256
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
	  /* istanbul ignore next */ 9007199254740991
	
	// Max safe segment length for coercion.
	var MAX_SAFE_COMPONENT_LENGTH = 16
	
	var MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6
	
	// The actual regexps go on exports.re
	var re = exports.re = []
	var safeRe = exports.safeRe = []
	var src = exports.src = []
	var R = 0
	
	var LETTERDASHNUMBER = '[a-zA-Z0-9-]'
	
	// Replace some greedy regex tokens to prevent regex dos issues. These regex are
	// used internally via the safeRe object since all inputs in this library get
	// normalized first to trim and collapse all extra whitespace. The original
	// regexes are exported for userland consumption and lower level usage. A
	// future breaking change could export the safer regex only with a note that
	// all input should have extra whitespace removed.
	var safeRegexReplacements = [
	  ['\\s', 1],
	  ['\\d', MAX_LENGTH],
	  [LETTERDASHNUMBER, MAX_SAFE_BUILD_LENGTH],
	]
	
	function makeSafeRe (value) {
	  for (var i = 0; i < safeRegexReplacements.length; i++) {
	    var token = safeRegexReplacements[i][0]
	    var max = safeRegexReplacements[i][1]
	    value = value
	      .split(token + '*').join(token + '{0,' + max + '}')
	      .split(token + '+').join(token + '{1,' + max + '}')
	  }
	  return value
	}
	
	// The following Regular Expressions can be used for tokenizing,
	// validating, and parsing SemVer version strings.
	
	// ## Numeric Identifier
	// A single `0`, or a non-zero digit followed by zero or more digits.
	
	var NUMERICIDENTIFIER = R++
	src[NUMERICIDENTIFIER] = '0|[1-9]\\d*'
	var NUMERICIDENTIFIERLOOSE = R++
	src[NUMERICIDENTIFIERLOOSE] = '\\d+'
	
	// ## Non-numeric Identifier
	// Zero or more digits, followed by a letter or hyphen, and then zero or
	// more letters, digits, or hyphens.
	
	var NONNUMERICIDENTIFIER = R++
	src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-]' + LETTERDASHNUMBER + '*'
	
	// ## Main Version
	// Three dot-separated numeric identifiers.
	
	var MAINVERSION = R++
	src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
	                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
	                   '(' + src[NUMERICIDENTIFIER] + ')'
	
	var MAINVERSIONLOOSE = R++
	src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
	                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
	                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')'
	
	// ## Pre-release Version Identifier
	// A numeric identifier, or a non-numeric identifier.
	
	var PRERELEASEIDENTIFIER = R++
	src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
	                            '|' + src[NONNUMERICIDENTIFIER] + ')'
	
	var PRERELEASEIDENTIFIERLOOSE = R++
	src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
	                                 '|' + src[NONNUMERICIDENTIFIER] + ')'
	
	// ## Pre-release Version
	// Hyphen, followed by one or more dot-separated pre-release version
	// identifiers.
	
	var PRERELEASE = R++
	src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
	                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))'
	
	var PRERELEASELOOSE = R++
	src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
	                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))'
	
	// ## Build Metadata Identifier
	// Any combination of digits, letters, or hyphens.
	
	var BUILDIDENTIFIER = R++
	src[BUILDIDENTIFIER] = LETTERDASHNUMBER + '+'
	
	// ## Build Metadata
	// Plus sign, followed by one or more period-separated build metadata
	// identifiers.
	
	var BUILD = R++
	src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
	             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))'
	
	// ## Full Version String
	// A main version, followed optionally by a pre-release version and
	// build metadata.
	
	// Note that the only major, minor, patch, and pre-release sections of
	// the version string are capturing groups.  The build metadata is not a
	// capturing group, because it should not ever be used in version
	// comparison.
	
	var FULL = R++
	var FULLPLAIN = 'v?' + src[MAINVERSION] +
	                src[PRERELEASE] + '?' +
	                src[BUILD] + '?'
	
	src[FULL] = '^' + FULLPLAIN + '$'
	
	// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
	// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
	// common in the npm registry.
	var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
	                 src[PRERELEASELOOSE] + '?' +
	                 src[BUILD] + '?'
	
	var LOOSE = R++
	src[LOOSE] = '^' + LOOSEPLAIN + '$'
	
	var GTLT = R++
	src[GTLT] = '((?:<|>)?=?)'
	
	// Something like "2.*" or "1.2.x".
	// Note that "x.x" is a valid xRange identifer, meaning "any version"
	// Only the first item is strictly required.
	var XRANGEIDENTIFIERLOOSE = R++
	src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*'
	var XRANGEIDENTIFIER = R++
	src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*'
	
	var XRANGEPLAIN = R++
	src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:' + src[PRERELEASE] + ')?' +
	                   src[BUILD] + '?' +
	                   ')?)?'
	
	var XRANGEPLAINLOOSE = R++
	src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:' + src[PRERELEASELOOSE] + ')?' +
	                        src[BUILD] + '?' +
	                        ')?)?'
	
	var XRANGE = R++
	src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$'
	var XRANGELOOSE = R++
	src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$'
	
	// Coercion.
	// Extract anything that could conceivably be a part of a valid semver
	var COERCE = R++
	src[COERCE] = '(?:^|[^\\d])' +
	              '(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '})' +
	              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
	              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
	              '(?:$|[^\\d])'
	
	// Tilde ranges.
	// Meaning is "reasonably at or greater than"
	var LONETILDE = R++
	src[LONETILDE] = '(?:~>?)'
	
	var TILDETRIM = R++
	src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+'
	re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g')
	safeRe[TILDETRIM] = new RegExp(makeSafeRe(src[TILDETRIM]), 'g')
	var tildeTrimReplace = '$1~'
	
	var TILDE = R++
	src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$'
	var TILDELOOSE = R++
	src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$'
	
	// Caret ranges.
	// Meaning is "at least and backwards compatible with"
	var LONECARET = R++
	src[LONECARET] = '(?:\\^)'
	
	var CARETTRIM = R++
	src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+'
	re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g')
	safeRe[CARETTRIM] = new RegExp(makeSafeRe(src[CARETTRIM]), 'g')
	var caretTrimReplace = '$1^'
	
	var CARET = R++
	src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$'
	var CARETLOOSE = R++
	src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$'
	
	// A simple gt/lt/eq thing, or just "" to indicate "any version"
	var COMPARATORLOOSE = R++
	src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$'
	var COMPARATOR = R++
	src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$'
	
	// An expression to strip any whitespace between the gtlt and the thing
	// it modifies, so that `> 1.2.3` ==> `>1.2.3`
	var COMPARATORTRIM = R++
	src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
	                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')'
	
	// this one has to use the /g flag
	re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g')
	safeRe[COMPARATORTRIM] = new RegExp(makeSafeRe(src[COMPARATORTRIM]), 'g')
	var comparatorTrimReplace = '$1$2$3'
	
	// Something like `1.2.3 - 1.2.4`
	// Note that these all use the loose form, because they'll be
	// checked against either the strict or loose comparator form
	// later.
	var HYPHENRANGE = R++
	src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
	                   '\\s+-\\s+' +
	                   '(' + src[XRANGEPLAIN] + ')' +
	                   '\\s*$'
	
	var HYPHENRANGELOOSE = R++
	src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
	                        '\\s+-\\s+' +
	                        '(' + src[XRANGEPLAINLOOSE] + ')' +
	                        '\\s*$'
	
	// Star ranges basically just allow anything at all.
	var STAR = R++
	src[STAR] = '(<|>)?=?\\s*\\*'
	
	// Compile to actual regexp objects.
	// All are flag-free, unless they were created above with a flag.
	for (var i = 0; i < R; i++) {
	  debug(i, src[i])
	  if (!re[i]) {
	    re[i] = new RegExp(src[i])
	
	    // Replace all greedy whitespace to prevent regex dos issues. These regex are
	    // used internally via the safeRe object since all inputs in this library get
	    // normalized first to trim and collapse all extra whitespace. The original
	    // regexes are exported for userland consumption and lower level usage. A
	    // future breaking change could export the safer regex only with a note that
	    // all input should have extra whitespace removed.
	    safeRe[i] = new RegExp(makeSafeRe(src[i]))
	  }
	}
	
	exports.parse = parse
	function parse (version, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (version instanceof SemVer) {
	    return version
	  }
	
	  if (typeof version !== 'string') {
	    return null
	  }
	
	  if (version.length > MAX_LENGTH) {
	    return null
	  }
	
	  var r = options.loose ? safeRe[LOOSE] : safeRe[FULL]
	  if (!r.test(version)) {
	    return null
	  }
	
	  try {
	    return new SemVer(version, options)
	  } catch (er) {
	    return null
	  }
	}
	
	exports.valid = valid
	function valid (version, options) {
	  var v = parse(version, options)
	  return v ? v.version : null
	}
	
	exports.clean = clean
	function clean (version, options) {
	  var s = parse(version.trim().replace(/^[=v]+/, ''), options)
	  return s ? s.version : null
	}
	
	exports.SemVer = SemVer
	
	function SemVer (version, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	  if (version instanceof SemVer) {
	    if (version.loose === options.loose) {
	      return version
	    } else {
	      version = version.version
	    }
	  } else if (typeof version !== 'string') {
	    throw new TypeError('Invalid Version: ' + version)
	  }
	
	  if (version.length > MAX_LENGTH) {
	    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')
	  }
	
	  if (!(this instanceof SemVer)) {
	    return new SemVer(version, options)
	  }
	
	  debug('SemVer', version, options)
	  this.options = options
	  this.loose = !!options.loose
	
	  var m = version.trim().match(options.loose ? safeRe[LOOSE] : safeRe[FULL])
	
	  if (!m) {
	    throw new TypeError('Invalid Version: ' + version)
	  }
	
	  this.raw = version
	
	  // these are actually numbers
	  this.major = +m[1]
	  this.minor = +m[2]
	  this.patch = +m[3]
	
	  if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
	    throw new TypeError('Invalid major version')
	  }
	
	  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
	    throw new TypeError('Invalid minor version')
	  }
	
	  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
	    throw new TypeError('Invalid patch version')
	  }
	
	  // numberify any prerelease numeric ids
	  if (!m[4]) {
	    this.prerelease = []
	  } else {
	    this.prerelease = m[4].split('.').map(function (id) {
	      if (/^[0-9]+$/.test(id)) {
	        var num = +id
	        if (num >= 0 && num < MAX_SAFE_INTEGER) {
	          return num
	        }
	      }
	      return id
	    })
	  }
	
	  this.build = m[5] ? m[5].split('.') : []
	  this.format()
	}
	
	SemVer.prototype.format = function () {
	  this.version = this.major + '.' + this.minor + '.' + this.patch
	  if (this.prerelease.length) {
	    this.version += '-' + this.prerelease.join('.')
	  }
	  return this.version
	}
	
	SemVer.prototype.toString = function () {
	  return this.version
	}
	
	SemVer.prototype.compare = function (other) {
	  debug('SemVer.compare', this.version, this.options, other)
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  return this.compareMain(other) || this.comparePre(other)
	}
	
	SemVer.prototype.compareMain = function (other) {
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  return compareIdentifiers(this.major, other.major) ||
	         compareIdentifiers(this.minor, other.minor) ||
	         compareIdentifiers(this.patch, other.patch)
	}
	
	SemVer.prototype.comparePre = function (other) {
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  // NOT having a prerelease is > having one
	  if (this.prerelease.length && !other.prerelease.length) {
	    return -1
	  } else if (!this.prerelease.length && other.prerelease.length) {
	    return 1
	  } else if (!this.prerelease.length && !other.prerelease.length) {
	    return 0
	  }
	
	  var i = 0
	  do {
	    var a = this.prerelease[i]
	    var b = other.prerelease[i]
	    debug('prerelease compare', i, a, b)
	    if (a === undefined && b === undefined) {
	      return 0
	    } else if (b === undefined) {
	      return 1
	    } else if (a === undefined) {
	      return -1
	    } else if (a === b) {
	      continue
	    } else {
	      return compareIdentifiers(a, b)
	    }
	  } while (++i)
	}
	
	// preminor will bump the version up to the next minor release, and immediately
	// down to pre-release. premajor and prepatch work the same way.
	SemVer.prototype.inc = function (release, identifier) {
	  switch (release) {
	    case 'premajor':
	      this.prerelease.length = 0
	      this.patch = 0
	      this.minor = 0
	      this.major++
	      this.inc('pre', identifier)
	      break
	    case 'preminor':
	      this.prerelease.length = 0
	      this.patch = 0
	      this.minor++
	      this.inc('pre', identifier)
	      break
	    case 'prepatch':
	      // If this is already a prerelease, it will bump to the next version
	      // drop any prereleases that might already exist, since they are not
	      // relevant at this point.
	      this.prerelease.length = 0
	      this.inc('patch', identifier)
	      this.inc('pre', identifier)
	      break
	    // If the input is a non-prerelease version, this acts the same as
	    // prepatch.
	    case 'prerelease':
	      if (this.prerelease.length === 0) {
	        this.inc('patch', identifier)
	      }
	      this.inc('pre', identifier)
	      break
	
	    case 'major':
	      // If this is a pre-major version, bump up to the same major version.
	      // Otherwise increment major.
	      // 1.0.0-5 bumps to 1.0.0
	      // 1.1.0 bumps to 2.0.0
	      if (this.minor !== 0 ||
	          this.patch !== 0 ||
	          this.prerelease.length === 0) {
	        this.major++
	      }
	      this.minor = 0
	      this.patch = 0
	      this.prerelease = []
	      break
	    case 'minor':
	      // If this is a pre-minor version, bump up to the same minor version.
	      // Otherwise increment minor.
	      // 1.2.0-5 bumps to 1.2.0
	      // 1.2.1 bumps to 1.3.0
	      if (this.patch !== 0 || this.prerelease.length === 0) {
	        this.minor++
	      }
	      this.patch = 0
	      this.prerelease = []
	      break
	    case 'patch':
	      // If this is not a pre-release version, it will increment the patch.
	      // If it is a pre-release it will bump up to the same patch version.
	      // 1.2.0-5 patches to 1.2.0
	      // 1.2.0 patches to 1.2.1
	      if (this.prerelease.length === 0) {
	        this.patch++
	      }
	      this.prerelease = []
	      break
	    // This probably shouldn't be used publicly.
	    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
	    case 'pre':
	      if (this.prerelease.length === 0) {
	        this.prerelease = [0]
	      } else {
	        var i = this.prerelease.length
	        while (--i >= 0) {
	          if (typeof this.prerelease[i] === 'number') {
	            this.prerelease[i]++
	            i = -2
	          }
	        }
	        if (i === -1) {
	          // didn't increment anything
	          this.prerelease.push(0)
	        }
	      }
	      if (identifier) {
	        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
	        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
	        if (this.prerelease[0] === identifier) {
	          if (isNaN(this.prerelease[1])) {
	            this.prerelease = [identifier, 0]
	          }
	        } else {
	          this.prerelease = [identifier, 0]
	        }
	      }
	      break
	
	    default:
	      throw new Error('invalid increment argument: ' + release)
	  }
	  this.format()
	  this.raw = this.version
	  return this
	}
	
	exports.inc = inc
	function inc (version, release, loose, identifier) {
	  if (typeof (loose) === 'string') {
	    identifier = loose
	    loose = undefined
	  }
	
	  try {
	    return new SemVer(version, loose).inc(release, identifier).version
	  } catch (er) {
	    return null
	  }
	}
	
	exports.diff = diff
	function diff (version1, version2) {
	  if (eq(version1, version2)) {
	    return null
	  } else {
	    var v1 = parse(version1)
	    var v2 = parse(version2)
	    var prefix = ''
	    if (v1.prerelease.length || v2.prerelease.length) {
	      prefix = 'pre'
	      var defaultResult = 'prerelease'
	    }
	    for (var key in v1) {
	      if (key === 'major' || key === 'minor' || key === 'patch') {
	        if (v1[key] !== v2[key]) {
	          return prefix + key
	        }
	      }
	    }
	    return defaultResult // may be undefined
	  }
	}
	
	exports.compareIdentifiers = compareIdentifiers
	
	var numeric = /^[0-9]+$/
	function compareIdentifiers (a, b) {
	  var anum = numeric.test(a)
	  var bnum = numeric.test(b)
	
	  if (anum && bnum) {
	    a = +a
	    b = +b
	  }
	
	  return a === b ? 0
	    : (anum && !bnum) ? -1
	    : (bnum && !anum) ? 1
	    : a < b ? -1
	    : 1
	}
	
	exports.rcompareIdentifiers = rcompareIdentifiers
	function rcompareIdentifiers (a, b) {
	  return compareIdentifiers(b, a)
	}
	
	exports.major = major
	function major (a, loose) {
	  return new SemVer(a, loose).major
	}
	
	exports.minor = minor
	function minor (a, loose) {
	  return new SemVer(a, loose).minor
	}
	
	exports.patch = patch
	function patch (a, loose) {
	  return new SemVer(a, loose).patch
	}
	
	exports.compare = compare
	function compare (a, b, loose) {
	  return new SemVer(a, loose).compare(new SemVer(b, loose))
	}
	
	exports.compareLoose = compareLoose
	function compareLoose (a, b) {
	  return compare(a, b, true)
	}
	
	exports.rcompare = rcompare
	function rcompare (a, b, loose) {
	  return compare(b, a, loose)
	}
	
	exports.sort = sort
	function sort (list, loose) {
	  return list.sort(function (a, b) {
	    return exports.compare(a, b, loose)
	  })
	}
	
	exports.rsort = rsort
	function rsort (list, loose) {
	  return list.sort(function (a, b) {
	    return exports.rcompare(a, b, loose)
	  })
	}
	
	exports.gt = gt
	function gt (a, b, loose) {
	  return compare(a, b, loose) > 0
	}
	
	exports.lt = lt
	function lt (a, b, loose) {
	  return compare(a, b, loose) < 0
	}
	
	exports.eq = eq
	function eq (a, b, loose) {
	  return compare(a, b, loose) === 0
	}
	
	exports.neq = neq
	function neq (a, b, loose) {
	  return compare(a, b, loose) !== 0
	}
	
	exports.gte = gte
	function gte (a, b, loose) {
	  return compare(a, b, loose) >= 0
	}
	
	exports.lte = lte
	function lte (a, b, loose) {
	  return compare(a, b, loose) <= 0
	}
	
	exports.cmp = cmp
	function cmp (a, op, b, loose) {
	  switch (op) {
	    case '===':
	      if (typeof a === 'object')
	        a = a.version
	      if (typeof b === 'object')
	        b = b.version
	      return a === b
	
	    case '!==':
	      if (typeof a === 'object')
	        a = a.version
	      if (typeof b === 'object')
	        b = b.version
	      return a !== b
	
	    case '':
	    case '=':
	    case '==':
	      return eq(a, b, loose)
	
	    case '!=':
	      return neq(a, b, loose)
	
	    case '>':
	      return gt(a, b, loose)
	
	    case '>=':
	      return gte(a, b, loose)
	
	    case '<':
	      return lt(a, b, loose)
	
	    case '<=':
	      return lte(a, b, loose)
	
	    default:
	      throw new TypeError('Invalid operator: ' + op)
	  }
	}
	
	exports.Comparator = Comparator
	function Comparator (comp, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (comp instanceof Comparator) {
	    if (comp.loose === !!options.loose) {
	      return comp
	    } else {
	      comp = comp.value
	    }
	  }
	
	  if (!(this instanceof Comparator)) {
	    return new Comparator(comp, options)
	  }
	
	  comp = comp.trim().split(/\s+/).join(' ')
	  debug('comparator', comp, options)
	  this.options = options
	  this.loose = !!options.loose
	  this.parse(comp)
	
	  if (this.semver === ANY) {
	    this.value = ''
	  } else {
	    this.value = this.operator + this.semver.version
	  }
	
	  debug('comp', this)
	}
	
	var ANY = {}
	Comparator.prototype.parse = function (comp) {
	  var r = this.options.loose ? safeRe[COMPARATORLOOSE] : safeRe[COMPARATOR]
	  var m = comp.match(r)
	
	  if (!m) {
	    throw new TypeError('Invalid comparator: ' + comp)
	  }
	
	  this.operator = m[1]
	  if (this.operator === '=') {
	    this.operator = ''
	  }
	
	  // if it literally is just '>' or '' then allow anything.
	  if (!m[2]) {
	    this.semver = ANY
	  } else {
	    this.semver = new SemVer(m[2], this.options.loose)
	  }
	}
	
	Comparator.prototype.toString = function () {
	  return this.value
	}
	
	Comparator.prototype.test = function (version) {
	  debug('Comparator.test', version, this.options.loose)
	
	  if (this.semver === ANY) {
	    return true
	  }
	
	  if (typeof version === 'string') {
	    version = new SemVer(version, this.options)
	  }
	
	  return cmp(version, this.operator, this.semver, this.options)
	}
	
	Comparator.prototype.intersects = function (comp, options) {
	  if (!(comp instanceof Comparator)) {
	    throw new TypeError('a Comparator is required')
	  }
	
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  var rangeTmp
	
	  if (this.operator === '') {
	    rangeTmp = new Range(comp.value, options)
	    return satisfies(this.value, rangeTmp, options)
	  } else if (comp.operator === '') {
	    rangeTmp = new Range(this.value, options)
	    return satisfies(comp.semver, rangeTmp, options)
	  }
	
	  var sameDirectionIncreasing =
	    (this.operator === '>=' || this.operator === '>') &&
	    (comp.operator === '>=' || comp.operator === '>')
	  var sameDirectionDecreasing =
	    (this.operator === '<=' || this.operator === '<') &&
	    (comp.operator === '<=' || comp.operator === '<')
	  var sameSemVer = this.semver.version === comp.semver.version
	  var differentDirectionsInclusive =
	    (this.operator === '>=' || this.operator === '<=') &&
	    (comp.operator === '>=' || comp.operator === '<=')
	  var oppositeDirectionsLessThan =
	    cmp(this.semver, '<', comp.semver, options) &&
	    ((this.operator === '>=' || this.operator === '>') &&
	    (comp.operator === '<=' || comp.operator === '<'))
	  var oppositeDirectionsGreaterThan =
	    cmp(this.semver, '>', comp.semver, options) &&
	    ((this.operator === '<=' || this.operator === '<') &&
	    (comp.operator === '>=' || comp.operator === '>'))
	
	  return sameDirectionIncreasing || sameDirectionDecreasing ||
	    (sameSemVer && differentDirectionsInclusive) ||
	    oppositeDirectionsLessThan || oppositeDirectionsGreaterThan
	}
	
	exports.Range = Range
	function Range (range, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (range instanceof Range) {
	    if (range.loose === !!options.loose &&
	        range.includePrerelease === !!options.includePrerelease) {
	      return range
	    } else {
	      return new Range(range.raw, options)
	    }
	  }
	
	  if (range instanceof Comparator) {
	    return new Range(range.value, options)
	  }
	
	  if (!(this instanceof Range)) {
	    return new Range(range, options)
	  }
	
	  this.options = options
	  this.loose = !!options.loose
	  this.includePrerelease = !!options.includePrerelease
	
	  // First reduce all whitespace as much as possible so we do not have to rely
	  // on potentially slow regexes like \s*. This is then stored and used for
	  // future error messages as well.
	  this.raw = range
	    .trim()
	    .split(/\s+/)
	    .join(' ')
	
	  // First, split based on boolean or ||
	  this.set = this.raw.split('||').map(function (range) {
	    return this.parseRange(range.trim())
	  }, this).filter(function (c) {
	    // throw out any that are not relevant for whatever reason
	    return c.length
	  })
	
	  if (!this.set.length) {
	    throw new TypeError('Invalid SemVer Range: ' + this.raw)
	  }
	
	  this.format()
	}
	
	Range.prototype.format = function () {
	  this.range = this.set.map(function (comps) {
	    return comps.join(' ').trim()
	  }).join('||').trim()
	  return this.range
	}
	
	Range.prototype.toString = function () {
	  return this.range
	}
	
	Range.prototype.parseRange = function (range) {
	  var loose = this.options.loose
	  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
	  var hr = loose ? safeRe[HYPHENRANGELOOSE] : safeRe[HYPHENRANGE]
	  range = range.replace(hr, hyphenReplace)
	  debug('hyphen replace', range)
	  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
	  range = range.replace(safeRe[COMPARATORTRIM], comparatorTrimReplace)
	  debug('comparator trim', range, safeRe[COMPARATORTRIM])
	
	  // `~ 1.2.3` => `~1.2.3`
	  range = range.replace(safeRe[TILDETRIM], tildeTrimReplace)
	
	  // `^ 1.2.3` => `^1.2.3`
	  range = range.replace(safeRe[CARETTRIM], caretTrimReplace)
	
	  // At this point, the range is completely trimmed and
	  // ready to be split into comparators.
	  var compRe = loose ? safeRe[COMPARATORLOOSE] : safeRe[COMPARATOR]
	  var set = range.split(' ').map(function (comp) {
	    return parseComparator(comp, this.options)
	  }, this).join(' ').split(/\s+/)
	  if (this.options.loose) {
	    // in loose mode, throw out any that are not valid comparators
	    set = set.filter(function (comp) {
	      return !!comp.match(compRe)
	    })
	  }
	  set = set.map(function (comp) {
	    return new Comparator(comp, this.options)
	  }, this)
	
	  return set
	}
	
	Range.prototype.intersects = function (range, options) {
	  if (!(range instanceof Range)) {
	    throw new TypeError('a Range is required')
	  }
	
	  return this.set.some(function (thisComparators) {
	    return thisComparators.every(function (thisComparator) {
	      return range.set.some(function (rangeComparators) {
	        return rangeComparators.every(function (rangeComparator) {
	          return thisComparator.intersects(rangeComparator, options)
	        })
	      })
	    })
	  })
	}
	
	// Mostly just for testing and legacy API reasons
	exports.toComparators = toComparators
	function toComparators (range, options) {
	  return new Range(range, options).set.map(function (comp) {
	    return comp.map(function (c) {
	      return c.value
	    }).join(' ').trim().split(' ')
	  })
	}
	
	// comprised of xranges, tildes, stars, and gtlt's at this point.
	// already replaced the hyphen ranges
	// turn into a set of JUST comparators.
	function parseComparator (comp, options) {
	  debug('comp', comp, options)
	  comp = replaceCarets(comp, options)
	  debug('caret', comp)
	  comp = replaceTildes(comp, options)
	  debug('tildes', comp)
	  comp = replaceXRanges(comp, options)
	  debug('xrange', comp)
	  comp = replaceStars(comp, options)
	  debug('stars', comp)
	  return comp
	}
	
	function isX (id) {
	  return !id || id.toLowerCase() === 'x' || id === '*'
	}
	
	// ~, ~> --> * (any, kinda silly)
	// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
	// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
	// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
	// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
	// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
	function replaceTildes (comp, options) {
	  return comp.trim().split(/\s+/).map(function (comp) {
	    return replaceTilde(comp, options)
	  }).join(' ')
	}
	
	function replaceTilde (comp, options) {
	  var r = options.loose ? safeRe[TILDELOOSE] : safeRe[TILDE]
	  return comp.replace(r, function (_, M, m, p, pr) {
	    debug('tilde', comp, _, M, m, p, pr)
	    var ret
	
	    if (isX(M)) {
	      ret = ''
	    } else if (isX(m)) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (isX(p)) {
	      // ~1.2 == >=1.2.0 <1.3.0
	      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	    } else if (pr) {
	      debug('replaceTilde pr', pr)
	      ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	            ' <' + M + '.' + (+m + 1) + '.0'
	    } else {
	      // ~1.2.3 == >=1.2.3 <1.3.0
	      ret = '>=' + M + '.' + m + '.' + p +
	            ' <' + M + '.' + (+m + 1) + '.0'
	    }
	
	    debug('tilde return', ret)
	    return ret
	  })
	}
	
	// ^ --> * (any, kinda silly)
	// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
	// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
	// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
	// ^1.2.3 --> >=1.2.3 <2.0.0
	// ^1.2.0 --> >=1.2.0 <2.0.0
	function replaceCarets (comp, options) {
	  return comp.trim().split(/\s+/).map(function (comp) {
	    return replaceCaret(comp, options)
	  }).join(' ')
	}
	
	function replaceCaret (comp, options) {
	  debug('caret', comp, options)
	  var r = options.loose ? safeRe[CARETLOOSE] : safeRe[CARET]
	  return comp.replace(r, function (_, M, m, p, pr) {
	    debug('caret', comp, _, M, m, p, pr)
	    var ret
	
	    if (isX(M)) {
	      ret = ''
	    } else if (isX(m)) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (isX(p)) {
	      if (M === '0') {
	        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	      } else {
	        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0'
	      }
	    } else if (pr) {
	      debug('replaceCaret pr', pr)
	      if (M === '0') {
	        if (m === '0') {
	          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	                ' <' + M + '.' + m + '.' + (+p + 1)
	        } else {
	          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	                ' <' + M + '.' + (+m + 1) + '.0'
	        }
	      } else {
	        ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	              ' <' + (+M + 1) + '.0.0'
	      }
	    } else {
	      debug('no pr')
	      if (M === '0') {
	        if (m === '0') {
	          ret = '>=' + M + '.' + m + '.' + p +
	                ' <' + M + '.' + m + '.' + (+p + 1)
	        } else {
	          ret = '>=' + M + '.' + m + '.' + p +
	                ' <' + M + '.' + (+m + 1) + '.0'
	        }
	      } else {
	        ret = '>=' + M + '.' + m + '.' + p +
	              ' <' + (+M + 1) + '.0.0'
	      }
	    }
	
	    debug('caret return', ret)
	    return ret
	  })
	}
	
	function replaceXRanges (comp, options) {
	  debug('replaceXRanges', comp, options)
	  return comp.split(/\s+/).map(function (comp) {
	    return replaceXRange(comp, options)
	  }).join(' ')
	}
	
	function replaceXRange (comp, options) {
	  comp = comp.trim()
	  var r = options.loose ? safeRe[XRANGELOOSE] : safeRe[XRANGE]
	  return comp.replace(r, function (ret, gtlt, M, m, p, pr) {
	    debug('xRange', comp, ret, gtlt, M, m, p, pr)
	    var xM = isX(M)
	    var xm = xM || isX(m)
	    var xp = xm || isX(p)
	    var anyX = xp
	
	    if (gtlt === '=' && anyX) {
	      gtlt = ''
	    }
	
	    if (xM) {
	      if (gtlt === '>' || gtlt === '<') {
	        // nothing is allowed
	        ret = '<0.0.0'
	      } else {
	        // nothing is forbidden
	        ret = '*'
	      }
	    } else if (gtlt && anyX) {
	      // we know patch is an x, because we have any x at all.
	      // replace X with 0
	      if (xm) {
	        m = 0
	      }
	      p = 0
	
	      if (gtlt === '>') {
	        // >1 => >=2.0.0
	        // >1.2 => >=1.3.0
	        // >1.2.3 => >= 1.2.4
	        gtlt = '>='
	        if (xm) {
	          M = +M + 1
	          m = 0
	          p = 0
	        } else {
	          m = +m + 1
	          p = 0
	        }
	      } else if (gtlt === '<=') {
	        // <=0.7.x is actually <0.8.0, since any 0.7.x should
	        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
	        gtlt = '<'
	        if (xm) {
	          M = +M + 1
	        } else {
	          m = +m + 1
	        }
	      }
	
	      ret = gtlt + M + '.' + m + '.' + p
	    } else if (xm) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (xp) {
	      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	    }
	
	    debug('xRange return', ret)
	
	    return ret
	  })
	}
	
	// Because * is AND-ed with everything else in the comparator,
	// and '' means "any version", just remove the *s entirely.
	function replaceStars (comp, options) {
	  debug('replaceStars', comp, options)
	  // Looseness is ignored here.  star is always as loose as it gets!
	  return comp.trim().replace(safeRe[STAR], '')
	}
	
	// This function is passed to string.replace(safeRe[HYPHENRANGE])
	// M, m, patch, prerelease, build
	// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
	// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
	// 1.2 - 3.4 => >=1.2.0 <3.5.0
	function hyphenReplace ($0,
	  from, fM, fm, fp, fpr, fb,
	  to, tM, tm, tp, tpr, tb) {
	  if (isX(fM)) {
	    from = ''
	  } else if (isX(fm)) {
	    from = '>=' + fM + '.0.0'
	  } else if (isX(fp)) {
	    from = '>=' + fM + '.' + fm + '.0'
	  } else {
	    from = '>=' + from
	  }
	
	  if (isX(tM)) {
	    to = ''
	  } else if (isX(tm)) {
	    to = '<' + (+tM + 1) + '.0.0'
	  } else if (isX(tp)) {
	    to = '<' + tM + '.' + (+tm + 1) + '.0'
	  } else if (tpr) {
	    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr
	  } else {
	    to = '<=' + to
	  }
	
	  return (from + ' ' + to).trim()
	}
	
	// if ANY of the sets match ALL of its comparators, then pass
	Range.prototype.test = function (version) {
	  if (!version) {
	    return false
	  }
	
	  if (typeof version === 'string') {
	    version = new SemVer(version, this.options)
	  }
	
	  for (var i = 0; i < this.set.length; i++) {
	    if (testSet(this.set[i], version, this.options)) {
	      return true
	    }
	  }
	  return false
	}
	
	function testSet (set, version, options) {
	  for (var i = 0; i < set.length; i++) {
	    if (!set[i].test(version)) {
	      return false
	    }
	  }
	
	  if (version.prerelease.length && !options.includePrerelease) {
	    // Find the set of versions that are allowed to have prereleases
	    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
	    // That should allow `1.2.3-pr.2` to pass.
	    // However, `1.2.4-alpha.notready` should NOT be allowed,
	    // even though it's within the range set by the comparators.
	    for (i = 0; i < set.length; i++) {
	      debug(set[i].semver)
	      if (set[i].semver === ANY) {
	        continue
	      }
	
	      if (set[i].semver.prerelease.length > 0) {
	        var allowed = set[i].semver
	        if (allowed.major === version.major &&
	            allowed.minor === version.minor &&
	            allowed.patch === version.patch) {
	          return true
	        }
	      }
	    }
	
	    // Version has a -pre, but it's not one of the ones we like.
	    return false
	  }
	
	  return true
	}
	
	exports.satisfies = satisfies
	function satisfies (version, range, options) {
	  try {
	    range = new Range(range, options)
	  } catch (er) {
	    return false
	  }
	  return range.test(version)
	}
	
	exports.maxSatisfying = maxSatisfying
	function maxSatisfying (versions, range, options) {
	  var max = null
	  var maxSV = null
	  try {
	    var rangeObj = new Range(range, options)
	  } catch (er) {
	    return null
	  }
	  versions.forEach(function (v) {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!max || maxSV.compare(v) === -1) {
	        // compare(max, v, true)
	        max = v
	        maxSV = new SemVer(max, options)
	      }
	    }
	  })
	  return max
	}
	
	exports.minSatisfying = minSatisfying
	function minSatisfying (versions, range, options) {
	  var min = null
	  var minSV = null
	  try {
	    var rangeObj = new Range(range, options)
	  } catch (er) {
	    return null
	  }
	  versions.forEach(function (v) {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!min || minSV.compare(v) === 1) {
	        // compare(min, v, true)
	        min = v
	        minSV = new SemVer(min, options)
	      }
	    }
	  })
	  return min
	}
	
	exports.minVersion = minVersion
	function minVersion (range, loose) {
	  range = new Range(range, loose)
	
	  var minver = new SemVer('0.0.0')
	  if (range.test(minver)) {
	    return minver
	  }
	
	  minver = new SemVer('0.0.0-0')
	  if (range.test(minver)) {
	    return minver
	  }
	
	  minver = null
	  for (var i = 0; i < range.set.length; ++i) {
	    var comparators = range.set[i]
	
	    comparators.forEach(function (comparator) {
	      // Clone to avoid manipulating the comparator's semver object.
	      var compver = new SemVer(comparator.semver.version)
	      switch (comparator.operator) {
	        case '>':
	          if (compver.prerelease.length === 0) {
	            compver.patch++
	          } else {
	            compver.prerelease.push(0)
	          }
	          compver.raw = compver.format()
	          /* fallthrough */
	        case '':
	        case '>=':
	          if (!minver || gt(minver, compver)) {
	            minver = compver
	          }
	          break
	        case '<':
	        case '<=':
	          /* Ignore maximum versions */
	          break
	        /* istanbul ignore next */
	        default:
	          throw new Error('Unexpected operation: ' + comparator.operator)
	      }
	    })
	  }
	
	  if (minver && range.test(minver)) {
	    return minver
	  }
	
	  return null
	}
	
	exports.validRange = validRange
	function validRange (range, options) {
	  try {
	    // Return '*' instead of '' so that truthiness works.
	    // This will throw if it's invalid anyway
	    return new Range(range, options).range || '*'
	  } catch (er) {
	    return null
	  }
	}
	
	// Determine if version is less than all the versions possible in the range
	exports.ltr = ltr
	function ltr (version, range, options) {
	  return outside(version, range, '<', options)
	}
	
	// Determine if version is greater than all the versions possible in the range.
	exports.gtr = gtr
	function gtr (version, range, options) {
	  return outside(version, range, '>', options)
	}
	
	exports.outside = outside
	function outside (version, range, hilo, options) {
	  version = new SemVer(version, options)
	  range = new Range(range, options)
	
	  var gtfn, ltefn, ltfn, comp, ecomp
	  switch (hilo) {
	    case '>':
	      gtfn = gt
	      ltefn = lte
	      ltfn = lt
	      comp = '>'
	      ecomp = '>='
	      break
	    case '<':
	      gtfn = lt
	      ltefn = gte
	      ltfn = gt
	      comp = '<'
	      ecomp = '<='
	      break
	    default:
	      throw new TypeError('Must provide a hilo val of "<" or ">"')
	  }
	
	  // If it satisifes the range it is not outside
	  if (satisfies(version, range, options)) {
	    return false
	  }
	
	  // From now on, variable terms are as if we're in "gtr" mode.
	  // but note that everything is flipped for the "ltr" function.
	
	  for (var i = 0; i < range.set.length; ++i) {
	    var comparators = range.set[i]
	
	    var high = null
	    var low = null
	
	    comparators.forEach(function (comparator) {
	      if (comparator.semver === ANY) {
	        comparator = new Comparator('>=0.0.0')
	      }
	      high = high || comparator
	      low = low || comparator
	      if (gtfn(comparator.semver, high.semver, options)) {
	        high = comparator
	      } else if (ltfn(comparator.semver, low.semver, options)) {
	        low = comparator
	      }
	    })
	
	    // If the edge version comparator has a operator then our version
	    // isn't outside it
	    if (high.operator === comp || high.operator === ecomp) {
	      return false
	    }
	
	    // If the lowest version comparator has an operator and our version
	    // is less than it then it isn't higher than the range
	    if ((!low.operator || low.operator === comp) &&
	        ltefn(version, low.semver)) {
	      return false
	    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
	      return false
	    }
	  }
	  return true
	}
	
	exports.prerelease = prerelease
	function prerelease (version, options) {
	  var parsed = parse(version, options)
	  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null
	}
	
	exports.intersects = intersects
	function intersects (r1, r2, options) {
	  r1 = new Range(r1, options)
	  r2 = new Range(r2, options)
	  return r1.intersects(r2)
	}
	
	exports.coerce = coerce
	function coerce (version) {
	  if (version instanceof SemVer) {
	    return version
	  }
	
	  if (typeof version !== 'string') {
	    return null
	  }
	
	  var match = version.match(safeRe[COERCE])
	
	  if (match == null) {
	    return null
	  }
	
	  return parse(match[1] +
	    '.' + (match[2] || '0') +
	    '.' + (match[3] || '0'))
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var timespan = __webpack_require__(247);
	var PS_SUPPORTED = __webpack_require__(246);
	var jws = __webpack_require__(164);
	var includes = __webpack_require__(1717);
	var isBoolean = __webpack_require__(1718);
	var isInteger = __webpack_require__(1719);
	var isNumber = __webpack_require__(1720);
	var isPlainObject = __webpack_require__(1721);
	var isString = __webpack_require__(1722);
	var once = __webpack_require__(1723);
	
	var SUPPORTED_ALGS = ['RS256', 'RS384', 'RS512', 'ES256', 'ES384', 'ES512', 'HS256', 'HS384', 'HS512', 'none']
	if (PS_SUPPORTED) {
	  SUPPORTED_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
	}
	
	var sign_options_schema = {
	  expiresIn: { isValid: function(value) { return isInteger(value) || (isString(value) && value); }, message: '"expiresIn" should be a number of seconds or string representing a timespan' },
	  notBefore: { isValid: function(value) { return isInteger(value) || (isString(value) && value); }, message: '"notBefore" should be a number of seconds or string representing a timespan' },
	  audience: { isValid: function(value) { return isString(value) || Array.isArray(value); }, message: '"audience" must be a string or array' },
	  algorithm: { isValid: includes.bind(null, SUPPORTED_ALGS), message: '"algorithm" must be a valid string enum value' },
	  header: { isValid: isPlainObject, message: '"header" must be an object' },
	  encoding: { isValid: isString, message: '"encoding" must be a string' },
	  issuer: { isValid: isString, message: '"issuer" must be a string' },
	  subject: { isValid: isString, message: '"subject" must be a string' },
	  jwtid: { isValid: isString, message: '"jwtid" must be a string' },
	  noTimestamp: { isValid: isBoolean, message: '"noTimestamp" must be a boolean' },
	  keyid: { isValid: isString, message: '"keyid" must be a string' },
	  mutatePayload: { isValid: isBoolean, message: '"mutatePayload" must be a boolean' }
	};
	
	var registered_claims_schema = {
	  iat: { isValid: isNumber, message: '"iat" should be a number of seconds' },
	  exp: { isValid: isNumber, message: '"exp" should be a number of seconds' },
	  nbf: { isValid: isNumber, message: '"nbf" should be a number of seconds' }
	};
	
	function validate(schema, allowUnknown, object, parameterName) {
	  if (!isPlainObject(object)) {
	    throw new Error('Expected "' + parameterName + '" to be a plain object.');
	  }
	  Object.keys(object)
	    .forEach(function(key) {
	      var validator = schema[key];
	      if (!validator) {
	        if (!allowUnknown) {
	          throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
	        }
	        return;
	      }
	      if (!validator.isValid(object[key])) {
	        throw new Error(validator.message);
	      }
	    });
	}
	
	function validateOptions(options) {
	  return validate(sign_options_schema, false, options, 'options');
	}
	
	function validatePayload(payload) {
	  return validate(registered_claims_schema, true, payload, 'payload');
	}
	
	var options_to_payload = {
	  'audience': 'aud',
	  'issuer': 'iss',
	  'subject': 'sub',
	  'jwtid': 'jti'
	};
	
	var options_for_objects = [
	  'expiresIn',
	  'notBefore',
	  'noTimestamp',
	  'audience',
	  'issuer',
	  'subject',
	  'jwtid',
	];
	
	module.exports = function (payload, secretOrPrivateKey, options, callback) {
	  if (typeof options === 'function') {
	    callback = options;
	    options = {};
	  } else {
	    options = options || {};
	  }
	
	  var isObjectPayload = typeof payload === 'object' &&
	                        !Buffer.isBuffer(payload);
	
	  var header = Object.assign({
	    alg: options.algorithm || 'HS256',
	    typ: isObjectPayload ? 'JWT' : undefined,
	    kid: options.keyid
	  }, options.header);
	
	  function failure(err) {
	    if (callback) {
	      return callback(err);
	    }
	    throw err;
	  }
	
	  if (!secretOrPrivateKey && options.algorithm !== 'none') {
	    return failure(new Error('secretOrPrivateKey must have a value'));
	  }
	
	  if (typeof payload === 'undefined') {
	    return failure(new Error('payload is required'));
	  } else if (isObjectPayload) {
	    try {
	      validatePayload(payload);
	    }
	    catch (error) {
	      return failure(error);
	    }
	    if (!options.mutatePayload) {
	      payload = Object.assign({},payload);
	    }
	  } else {
	    var invalid_options = options_for_objects.filter(function (opt) {
	      return typeof options[opt] !== 'undefined';
	    });
	
	    if (invalid_options.length > 0) {
	      return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + (typeof payload ) + ' payload'));
	    }
	  }
	
	  if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') {
	    return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
	  }
	
	  if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') {
	    return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
	  }
	
	  try {
	    validateOptions(options);
	  }
	  catch (error) {
	    return failure(error);
	  }
	
	  var timestamp = payload.iat || Math.floor(Date.now() / 1000);
	
	  if (options.noTimestamp) {
	    delete payload.iat;
	  } else if (isObjectPayload) {
	    payload.iat = timestamp;
	  }
	
	  if (typeof options.notBefore !== 'undefined') {
	    try {
	      payload.nbf = timespan(options.notBefore, timestamp);
	    }
	    catch (err) {
	      return failure(err);
	    }
	    if (typeof payload.nbf === 'undefined') {
	      return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
	    }
	  }
	
	  if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
	    try {
	      payload.exp = timespan(options.expiresIn, timestamp);
	    }
	    catch (err) {
	      return failure(err);
	    }
	    if (typeof payload.exp === 'undefined') {
	      return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
	    }
	  }
	
	  Object.keys(options_to_payload).forEach(function (key) {
	    var claim = options_to_payload[key];
	    if (typeof options[key] !== 'undefined') {
	      if (typeof payload[claim] !== 'undefined') {
	        return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
	      }
	      payload[claim] = options[key];
	    }
	  });
	
	  var encoding = options.encoding || 'utf8';
	
	  if (typeof callback === 'function') {
	    callback = callback && once(callback);
	
	    jws.createSign({
	      header: header,
	      privateKey: secretOrPrivateKey,
	      payload: payload,
	      encoding: encoding
	    }).once('error', callback)
	      .once('done', function (signature) {
	        callback(null, signature);
	      });
	  } else {
	    return jws.sign({header: header, payload: payload, secret: secretOrPrivateKey, encoding: encoding});
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	var JsonWebTokenError = __webpack_require__(114);
	var NotBeforeError    = __webpack_require__(244);
	var TokenExpiredError = __webpack_require__(245);
	var decode            = __webpack_require__(243);
	var timespan          = __webpack_require__(247);
	var PS_SUPPORTED      = __webpack_require__(246);
	var jws               = __webpack_require__(164);
	
	var PUB_KEY_ALGS = ['RS256', 'RS384', 'RS512', 'ES256', 'ES384', 'ES512'];
	var RSA_KEY_ALGS = ['RS256', 'RS384', 'RS512'];
	var HS_ALGS = ['HS256', 'HS384', 'HS512'];
	
	if (PS_SUPPORTED) {
	  PUB_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
	  RSA_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
	}
	
	module.exports = function (jwtString, secretOrPublicKey, options, callback) {
	  if ((typeof options === 'function') && !callback) {
	    callback = options;
	    options = {};
	  }
	
	  if (!options) {
	    options = {};
	  }
	
	  //clone this object since we are going to mutate it.
	  options = Object.assign({}, options);
	
	  var done;
	
	  if (callback) {
	    done = callback;
	  } else {
	    done = function(err, data) {
	      if (err) throw err;
	      return data;
	    };
	  }
	
	  if (options.clockTimestamp && typeof options.clockTimestamp !== 'number') {
	    return done(new JsonWebTokenError('clockTimestamp must be a number'));
	  }
	
	  if (options.nonce !== undefined && (typeof options.nonce !== 'string' || options.nonce.trim() === '')) {
	    return done(new JsonWebTokenError('nonce must be a non-empty string'));
	  }
	
	  var clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);
	
	  if (!jwtString){
	    return done(new JsonWebTokenError('jwt must be provided'));
	  }
	
	  if (typeof jwtString !== 'string') {
	    return done(new JsonWebTokenError('jwt must be a string'));
	  }
	
	  var parts = jwtString.split('.');
	
	  if (parts.length !== 3){
	    return done(new JsonWebTokenError('jwt malformed'));
	  }
	
	  var decodedToken;
	
	  try {
	    decodedToken = decode(jwtString, { complete: true });
	  } catch(err) {
	    return done(err);
	  }
	
	  if (!decodedToken) {
	    return done(new JsonWebTokenError('invalid token'));
	  }
	
	  var header = decodedToken.header;
	  var getSecret;
	
	  if(typeof secretOrPublicKey === 'function') {
	    if(!callback) {
	      return done(new JsonWebTokenError('verify must be called asynchronous if secret or public key is provided as a callback'));
	    }
	
	    getSecret = secretOrPublicKey;
	  }
	  else {
	    getSecret = function(header, secretCallback) {
	      return secretCallback(null, secretOrPublicKey);
	    };
	  }
	
	  return getSecret(header, function(err, secretOrPublicKey) {
	    if(err) {
	      return done(new JsonWebTokenError('error in secret or public key callback: ' + err.message));
	    }
	
	    var hasSignature = parts[2].trim() !== '';
	
	    if (!hasSignature && secretOrPublicKey){
	      return done(new JsonWebTokenError('jwt signature is required'));
	    }
	
	    if (hasSignature && !secretOrPublicKey) {
	      return done(new JsonWebTokenError('secret or public key must be provided'));
	    }
	
	    if (!hasSignature && !options.algorithms) {
	      options.algorithms = ['none'];
	    }
	
	    if (!options.algorithms) {
	      options.algorithms = ~secretOrPublicKey.toString().indexOf('BEGIN CERTIFICATE') ||
	        ~secretOrPublicKey.toString().indexOf('BEGIN PUBLIC KEY') ? PUB_KEY_ALGS :
	        ~secretOrPublicKey.toString().indexOf('BEGIN RSA PUBLIC KEY') ? RSA_KEY_ALGS : HS_ALGS;
	
	    }
	
	    if (!~options.algorithms.indexOf(decodedToken.header.alg)) {
	      return done(new JsonWebTokenError('invalid algorithm'));
	    }
	
	    var valid;
	
	    try {
	      valid = jws.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
	    } catch (e) {
	      return done(e);
	    }
	
	    if (!valid) {
	      return done(new JsonWebTokenError('invalid signature'));
	    }
	
	    var payload = decodedToken.payload;
	
	    if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
	      if (typeof payload.nbf !== 'number') {
	        return done(new JsonWebTokenError('invalid nbf value'));
	      }
	      if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) {
	        return done(new NotBeforeError('jwt not active', new Date(payload.nbf * 1000)));
	      }
	    }
	
	    if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
	      if (typeof payload.exp !== 'number') {
	        return done(new JsonWebTokenError('invalid exp value'));
	      }
	      if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) {
	        return done(new TokenExpiredError('jwt expired', new Date(payload.exp * 1000)));
	      }
	    }
	
	    if (options.audience) {
	      var audiences = Array.isArray(options.audience) ? options.audience : [options.audience];
	      var target = Array.isArray(payload.aud) ? payload.aud : [payload.aud];
	
	      var match = target.some(function (targetAudience) {
	        return audiences.some(function (audience) {
	          return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
	        });
	      });
	
	      if (!match) {
	        return done(new JsonWebTokenError('jwt audience invalid. expected: ' + audiences.join(' or ')));
	      }
	    }
	
	    if (options.issuer) {
	      var invalid_issuer =
	              (typeof options.issuer === 'string' && payload.iss !== options.issuer) ||
	              (Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1);
	
	      if (invalid_issuer) {
	        return done(new JsonWebTokenError('jwt issuer invalid. expected: ' + options.issuer));
	      }
	    }
	
	    if (options.subject) {
	      if (payload.sub !== options.subject) {
	        return done(new JsonWebTokenError('jwt subject invalid. expected: ' + options.subject));
	      }
	    }
	
	    if (options.jwtid) {
	      if (payload.jti !== options.jwtid) {
	        return done(new JsonWebTokenError('jwt jwtid invalid. expected: ' + options.jwtid));
	      }
	    }
	
	    if (options.nonce) {
	      if (payload.nonce !== options.nonce) {
	        return done(new JsonWebTokenError('jwt nonce invalid. expected: ' + options.nonce));
	      }
	    }
	
	    if (options.maxAge) {
	      if (typeof payload.iat !== 'number') {
	        return done(new JsonWebTokenError('iat required when maxAge is specified'));
	      }
	
	      var maxAgeTimestamp = timespan(options.maxAge, payload.iat);
	      if (typeof maxAgeTimestamp === 'undefined') {
	        return done(new JsonWebTokenError('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
	      }
	      if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) {
	        return done(new TokenExpiredError('maxAge exceeded', new Date(maxAgeTimestamp * 1000)));
	      }
	    }
	
	    if (options.complete === true) {
	      var signature = decodedToken.signature;
	
	      return done(null, {
	        header: header,
	        payload: payload,
	        signature: signature
	      });
	    }
	
	    return done(null, payload);
	  });
	};


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	/*global module*/
	var Buffer = __webpack_require__(46).Buffer;
	var DataStream = __webpack_require__(249);
	var jwa = __webpack_require__(248);
	var Stream = __webpack_require__(117);
	var toString = __webpack_require__(250);
	var util = __webpack_require__(53);
	
	function base64url(string, encoding) {
	  return Buffer
	    .from(string, encoding)
	    .toString('base64')
	    .replace(/=/g, '')
	    .replace(/\+/g, '-')
	    .replace(/\//g, '_');
	}
	
	function jwsSecuredInput(header, payload, encoding) {
	  encoding = encoding || 'utf8';
	  var encodedHeader = base64url(toString(header), 'binary');
	  var encodedPayload = base64url(toString(payload), encoding);
	  return util.format('%s.%s', encodedHeader, encodedPayload);
	}
	
	function jwsSign(opts) {
	  var header = opts.header;
	  var payload = opts.payload;
	  var secretOrKey = opts.secret || opts.privateKey;
	  var encoding = opts.encoding;
	  var algo = jwa(header.alg);
	  var securedInput = jwsSecuredInput(header, payload, encoding);
	  var signature = algo.sign(securedInput, secretOrKey);
	  return util.format('%s.%s', securedInput, signature);
	}
	
	function SignStream(opts) {
	  var secret = opts.secret||opts.privateKey||opts.key;
	  var secretStream = new DataStream(secret);
	  this.readable = true;
	  this.header = opts.header;
	  this.encoding = opts.encoding;
	  this.secret = this.privateKey = this.key = secretStream;
	  this.payload = new DataStream(opts.payload);
	  this.secret.once('close', function () {
	    if (!this.payload.writable && this.readable)
	      this.sign();
	  }.bind(this));
	
	  this.payload.once('close', function () {
	    if (!this.secret.writable && this.readable)
	      this.sign();
	  }.bind(this));
	}
	util.inherits(SignStream, Stream);
	
	SignStream.prototype.sign = function sign() {
	  try {
	    var signature = jwsSign({
	      header: this.header,
	      payload: this.payload.buffer,
	      secret: this.secret.buffer,
	      encoding: this.encoding
	    });
	    this.emit('done', signature);
	    this.emit('data', signature);
	    this.emit('end');
	    this.readable = false;
	    return signature;
	  } catch (e) {
	    this.readable = false;
	    this.emit('error', e);
	    this.emit('close');
	  }
	};
	
	SignStream.sign = jwsSign;
	
	module.exports = SignStream;


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	/*global module*/
	var Buffer = __webpack_require__(46).Buffer;
	var DataStream = __webpack_require__(249);
	var jwa = __webpack_require__(248);
	var Stream = __webpack_require__(117);
	var toString = __webpack_require__(250);
	var util = __webpack_require__(53);
	var JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
	
	function isObject(thing) {
	  return Object.prototype.toString.call(thing) === '[object Object]';
	}
	
	function safeJsonParse(thing) {
	  if (isObject(thing))
	    return thing;
	  try { return JSON.parse(thing); }
	  catch (e) { return undefined; }
	}
	
	function headerFromJWS(jwsSig) {
	  var encodedHeader = jwsSig.split('.', 1)[0];
	  return safeJsonParse(Buffer.from(encodedHeader, 'base64').toString('binary'));
	}
	
	function securedInputFromJWS(jwsSig) {
	  return jwsSig.split('.', 2).join('.');
	}
	
	function signatureFromJWS(jwsSig) {
	  return jwsSig.split('.')[2];
	}
	
	function payloadFromJWS(jwsSig, encoding) {
	  encoding = encoding || 'utf8';
	  var payload = jwsSig.split('.')[1];
	  return Buffer.from(payload, 'base64').toString(encoding);
	}
	
	function isValidJws(string) {
	  return JWS_REGEX.test(string) && !!headerFromJWS(string);
	}
	
	function jwsVerify(jwsSig, algorithm, secretOrKey) {
	  if (!algorithm) {
	    var err = new Error("Missing algorithm parameter for jws.verify");
	    err.code = "MISSING_ALGORITHM";
	    throw err;
	  }
	  jwsSig = toString(jwsSig);
	  var signature = signatureFromJWS(jwsSig);
	  var securedInput = securedInputFromJWS(jwsSig);
	  var algo = jwa(algorithm);
	  return algo.verify(securedInput, signature, secretOrKey);
	}
	
	function jwsDecode(jwsSig, opts) {
	  opts = opts || {};
	  jwsSig = toString(jwsSig);
	
	  if (!isValidJws(jwsSig))
	    return null;
	
	  var header = headerFromJWS(jwsSig);
	
	  if (!header)
	    return null;
	
	  var payload = payloadFromJWS(jwsSig);
	  if (header.typ === 'JWT' || opts.json)
	    payload = JSON.parse(payload, opts.encoding);
	
	  return {
	    header: header,
	    payload: payload,
	    signature: signatureFromJWS(jwsSig)
	  };
	}
	
	function VerifyStream(opts) {
	  opts = opts || {};
	  var secretOrKey = opts.secret||opts.publicKey||opts.key;
	  var secretStream = new DataStream(secretOrKey);
	  this.readable = true;
	  this.algorithm = opts.algorithm;
	  this.encoding = opts.encoding;
	  this.secret = this.publicKey = this.key = secretStream;
	  this.signature = new DataStream(opts.signature);
	  this.secret.once('close', function () {
	    if (!this.signature.writable && this.readable)
	      this.verify();
	  }.bind(this));
	
	  this.signature.once('close', function () {
	    if (!this.secret.writable && this.readable)
	      this.verify();
	  }.bind(this));
	}
	util.inherits(VerifyStream, Stream);
	VerifyStream.prototype.verify = function verify() {
	  try {
	    var valid = jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
	    var obj = jwsDecode(this.signature.buffer, this.encoding);
	    this.emit('done', valid, obj);
	    this.emit('data', valid);
	    this.emit('end');
	    this.readable = false;
	    return valid;
	  } catch (e) {
	    this.readable = false;
	    this.emit('error', e);
	    this.emit('close');
	  }
	};
	
	VerifyStream.decode = jwsDecode;
	VerifyStream.isValid = isValidJws;
	VerifyStream.verify = jwsVerify;
	
	module.exports = VerifyStream;


/***/ }),
/* 1717 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = includes;


/***/ }),
/* 1718 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && objectToString.call(value) == boolTag);
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isBoolean;


/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is an integer.
	 *
	 * **Note:** This method is based on
	 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	 * @example
	 *
	 * _.isInteger(3);
	 * // => true
	 *
	 * _.isInteger(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isInteger(Infinity);
	 * // => false
	 *
	 * _.isInteger('3');
	 * // => false
	 */
	function isInteger(value) {
	  return typeof value == 'number' && value == toInteger(value);
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = isInteger;


/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	 * as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && objectToString.call(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 1721 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 1722 */
/***/ (function(module, exports) {

	/**
	 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @type Function
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 1723 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = once;


/***/ }),
/* 1724 */
/***/ (function(module, exports) {

	/**
	 * @name MarkerClustererPlus for Google Maps V3
	 * @version 2.1.2 [May 28, 2014]
	 * @author Gary Little
	 * @fileoverview
	 * The library creates and manages per-zoom-level clusters for large amounts of markers.
	 * <p>
	 * This is an enhanced V3 implementation of the
	 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
	 * >V2 MarkerClusterer</a> by Xiaoxi Wu. It is based on the
	 * <a href="http://google-maps-utility-library-v3.googlecode.com/svn/tags/markerclusterer/"
	 * >V3 MarkerClusterer</a> port by Luke Mahe. MarkerClustererPlus was created by Gary Little.
	 * <p>
	 * v2.0 release: MarkerClustererPlus v2.0 is backward compatible with MarkerClusterer v1.0. It
	 *  adds support for the <code>ignoreHidden</code>, <code>title</code>, <code>batchSizeIE</code>,
	 *  and <code>calculator</code> properties as well as support for four more events. It also allows
	 *  greater control over the styling of the text that appears on the cluster marker. The
	 *  documentation has been significantly improved and the overall code has been simplified and
	 *  polished. Very large numbers of markers can now be managed without causing Javascript timeout
	 *  errors on Internet Explorer. Note that the name of the <code>clusterclick</code> event has been
	 *  deprecated. The new name is <code>click</code>, so please change your application code now.
	 */
	
	/**
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	/**
	 * @name ClusterIconStyle
	 * @class This class represents the object for values in the <code>styles</code> array passed
	 *  to the {@link MarkerClusterer} constructor. The element in this array that is used to
	 *  style the cluster icon is determined by calling the <code>calculator</code> function.
	 *
	 * @property {string} url The URL of the cluster icon image file. Required.
	 * @property {number} height The display height (in pixels) of the cluster icon. Required.
	 * @property {number} width The display width (in pixels) of the cluster icon. Required.
	 * @property {Array} [anchorText] The position (in pixels) from the center of the cluster icon to
	 *  where the text label is to be centered and drawn. The format is <code>[yoffset, xoffset]</code>
	 *  where <code>yoffset</code> increases as you go down from center and <code>xoffset</code>
	 *  increases to the right of center. The default is <code>[0, 0]</code>.
	 * @property {Array} [anchorIcon] The anchor position (in pixels) of the cluster icon. This is the
	 *  spot on the cluster icon that is to be aligned with the cluster position. The format is
	 *  <code>[yoffset, xoffset]</code> where <code>yoffset</code> increases as you go down and
	 *  <code>xoffset</code> increases to the right of the top-left corner of the icon. The default
	 *  anchor position is the center of the cluster icon.
	 * @property {string} [textColor="black"] The color of the label text shown on the
	 *  cluster icon.
	 * @property {number} [textSize=11] The size (in pixels) of the label text shown on the
	 *  cluster icon.
	 * @property {string} [textDecoration="none"] The value of the CSS <code>text-decoration</code>
	 *  property for the label text shown on the cluster icon.
	 * @property {string} [fontWeight="bold"] The value of the CSS <code>font-weight</code>
	 *  property for the label text shown on the cluster icon.
	 * @property {string} [fontStyle="normal"] The value of the CSS <code>font-style</code>
	 *  property for the label text shown on the cluster icon.
	 * @property {string} [fontFamily="Arial,sans-serif"] The value of the CSS <code>font-family</code>
	 *  property for the label text shown on the cluster icon.
	 * @property {string} [backgroundPosition="0 0"] The position of the cluster icon image
	 *  within the image defined by <code>url</code>. The format is <code>"xpos ypos"</code>
	 *  (the same format as for the CSS <code>background-position</code> property). You must set
	 *  this property appropriately when the image defined by <code>url</code> represents a sprite
	 *  containing multiple images. Note that the position <i>must</i> be specified in px units.
	 */
	/**
	 * @name ClusterIconInfo
	 * @class This class is an object containing general information about a cluster icon. This is
	 *  the object that a <code>calculator</code> function returns.
	 *
	 * @property {string} text The text of the label to be shown on the cluster icon.
	 * @property {number} index The index plus 1 of the element in the <code>styles</code>
	 *  array to be used to style the cluster icon.
	 * @property {string} title The tooltip to display when the mouse moves over the cluster icon.
	 *  If this value is <code>undefined</code> or <code>""</code>, <code>title</code> is set to the
	 *  value of the <code>title</code> property passed to the MarkerClusterer.
	 */
	/**
	 * A cluster icon.
	 *
	 * @constructor
	 * @extends google.maps.OverlayView
	 * @param {Cluster} cluster The cluster with which the icon is to be associated.
	 * @param {Array} [styles] An array of {@link ClusterIconStyle} defining the cluster icons
	 *  to use for various cluster sizes.
	 * @private
	 */
	function ClusterIcon(cluster, styles) {
	  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);
	
	  this.cluster_ = cluster;
	  this.className_ = cluster.getMarkerClusterer().getClusterClass();
	  this.styles_ = styles;
	  this.center_ = null;
	  this.div_ = null;
	  this.sums_ = null;
	  this.visible_ = false;
	
	  this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
	}
	
	
	/**
	 * Adds the icon to the DOM.
	 */
	ClusterIcon.prototype.onAdd = function () {
	  var cClusterIcon = this;
	  var cMouseDownInCluster;
	  var cDraggingMapByCluster;
	
	  this.div_ = document.createElement("div");
	  this.div_.className = this.className_;
	  if (this.visible_) {
	    this.show();
	  }
	
	  this.getPanes().overlayMouseTarget.appendChild(this.div_);
	
	  // Fix for Issue 157
	  this.boundsChangedListener_ = google.maps.event.addListener(this.getMap(), "bounds_changed", function () {
	    cDraggingMapByCluster = cMouseDownInCluster;
	  });
	
	  google.maps.event.addDomListener(this.div_, "mousedown", function () {
	    cMouseDownInCluster = true;
	    cDraggingMapByCluster = false;
	  });
	
	  google.maps.event.addDomListener(this.div_, "click", function (e) {
	    cMouseDownInCluster = false;
	    if (!cDraggingMapByCluster) {
	      var theBounds;
	      var mz;
	      var mc = cClusterIcon.cluster_.getMarkerClusterer();
	      /**
	       * This event is fired when a cluster marker is clicked.
	       * @name MarkerClusterer#click
	       * @param {Cluster} c The cluster that was clicked.
	       * @event
	       */
	      google.maps.event.trigger(mc, "click", cClusterIcon.cluster_);
	      google.maps.event.trigger(mc, "clusterclick", cClusterIcon.cluster_); // deprecated name
	
	      // The default click handler follows. Disable it by setting
	      // the zoomOnClick property to false.
	      if (mc.getZoomOnClick()) {
	        // Zoom into the cluster.
	        mz = mc.getMaxZoom();
	        theBounds = cClusterIcon.cluster_.getBounds();
	        mc.getMap().fitBounds(theBounds);
	        // There is a fix for Issue 170 here:
	        setTimeout(function () {
	          mc.getMap().fitBounds(theBounds);
	          // Don't zoom beyond the max zoom level
	          if (mz !== null && (mc.getMap().getZoom() > mz)) {
	            mc.getMap().setZoom(mz + 1);
	          }
	        }, 100);
	      }
	
	      // Prevent event propagation to the map:
	      e.cancelBubble = true;
	      if (e.stopPropagation) {
	        e.stopPropagation();
	      }
	    }
	  });
	
	  google.maps.event.addDomListener(this.div_, "mouseover", function () {
	    var mc = cClusterIcon.cluster_.getMarkerClusterer();
	    /**
	     * This event is fired when the mouse moves over a cluster marker.
	     * @name MarkerClusterer#mouseover
	     * @param {Cluster} c The cluster that the mouse moved over.
	     * @event
	     */
	    google.maps.event.trigger(mc, "mouseover", cClusterIcon.cluster_);
	  });
	
	  google.maps.event.addDomListener(this.div_, "mouseout", function () {
	    var mc = cClusterIcon.cluster_.getMarkerClusterer();
	    /**
	     * This event is fired when the mouse moves out of a cluster marker.
	     * @name MarkerClusterer#mouseout
	     * @param {Cluster} c The cluster that the mouse moved out of.
	     * @event
	     */
	    google.maps.event.trigger(mc, "mouseout", cClusterIcon.cluster_);
	  });
	};
	
	
	/**
	 * Removes the icon from the DOM.
	 */
	ClusterIcon.prototype.onRemove = function () {
	  if (this.div_ && this.div_.parentNode) {
	    this.hide();
	    google.maps.event.removeListener(this.boundsChangedListener_);
	    google.maps.event.clearInstanceListeners(this.div_);
	    this.div_.parentNode.removeChild(this.div_);
	    this.div_ = null;
	  }
	};
	
	
	/**
	 * Draws the icon.
	 */
	ClusterIcon.prototype.draw = function () {
	  if (this.visible_) {
	    var pos = this.getPosFromLatLng_(this.center_);
	    this.div_.style.top = pos.y + "px";
	    this.div_.style.left = pos.x + "px";
	  }
	};
	
	
	/**
	 * Hides the icon.
	 */
	ClusterIcon.prototype.hide = function () {
	  if (this.div_) {
	    this.div_.style.display = "none";
	  }
	  this.visible_ = false;
	};
	
	
	/**
	 * Positions and shows the icon.
	 */
	ClusterIcon.prototype.show = function () {
	  if (this.div_) {
	    var img = "";
	    // NOTE: values must be specified in px units
	    var bp = this.backgroundPosition_.split(" ");
	    var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ""), 10);
	    var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ""), 10);
	    var pos = this.getPosFromLatLng_(this.center_);
	    this.div_.style.cssText = this.createCss(pos);
	    img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
	    if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) {
	      img += "clip: rect(" + (-1 * spriteV) + "px, " + ((-1 * spriteH) + this.width_) + "px, " +
	          ((-1 * spriteV) + this.height_) + "px, " + (-1 * spriteH) + "px);";
	    }
	    img += "'>";
	    this.div_.innerHTML = img + "<div style='" +
	        "position: absolute;" +
	        "top: " + this.anchorText_[0] + "px;" +
	        "left: " + this.anchorText_[1] + "px;" +
	        "color: " + this.textColor_ + ";" +
	        "font-size: " + this.textSize_ + "px;" +
	        "font-family: " + this.fontFamily_ + ";" +
	        "font-weight: " + this.fontWeight_ + ";" +
	        "font-style: " + this.fontStyle_ + ";" +
	        "text-decoration: " + this.textDecoration_ + ";" +
	        "text-align: center;" +
	        "width: " + this.width_ + "px;" +
	        "line-height:" + this.height_ + "px;" +
	        "'>" + this.sums_.text + "</div>";
	    if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
	      this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
	    } else {
	      this.div_.title = this.sums_.title;
	    }
	    this.div_.style.display = "";
	  }
	  this.visible_ = true;
	};
	
	
	/**
	 * Sets the icon styles to the appropriate element in the styles array.
	 *
	 * @param {ClusterIconInfo} sums The icon label text and styles index.
	 */
	ClusterIcon.prototype.useStyle = function (sums) {
	  this.sums_ = sums;
	  var index = Math.max(0, sums.index - 1);
	  index = Math.min(this.styles_.length - 1, index);
	  var style = this.styles_[index];
	  this.url_ = style.url;
	  this.height_ = style.height;
	  this.width_ = style.width;
	  this.anchorText_ = style.anchorText || [0, 0];
	  this.anchorIcon_ = style.anchorIcon || [parseInt(this.height_ / 2, 10), parseInt(this.width_ / 2, 10)];
	  this.textColor_ = style.textColor || "black";
	  this.textSize_ = style.textSize || 11;
	  this.textDecoration_ = style.textDecoration || "none";
	  this.fontWeight_ = style.fontWeight || "bold";
	  this.fontStyle_ = style.fontStyle || "normal";
	  this.fontFamily_ = style.fontFamily || "Arial,sans-serif";
	  this.backgroundPosition_ = style.backgroundPosition || "0 0";
	};
	
	
	/**
	 * Sets the position at which to center the icon.
	 *
	 * @param {google.maps.LatLng} center The latlng to set as the center.
	 */
	ClusterIcon.prototype.setCenter = function (center) {
	  this.center_ = center;
	};
	
	
	/**
	 * Creates the cssText style parameter based on the position of the icon.
	 *
	 * @param {google.maps.Point} pos The position of the icon.
	 * @return {string} The CSS style text.
	 */
	ClusterIcon.prototype.createCss = function (pos) {
	  var style = [];
	  style.push("cursor: pointer;");
	  style.push("position: absolute; top: " + pos.y + "px; left: " + pos.x + "px;");
	  style.push("width: " + this.width_ + "px; height: " + this.height_ + "px;");
	  return style.join("");
	};
	
	
	/**
	 * Returns the position at which to place the DIV depending on the latlng.
	 *
	 * @param {google.maps.LatLng} latlng The position in latlng.
	 * @return {google.maps.Point} The position in pixels.
	 */
	ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
	  var pos = this.getProjection().fromLatLngToDivPixel(latlng);
	  pos.x -= this.anchorIcon_[1];
	  pos.y -= this.anchorIcon_[0];
	  pos.x = parseInt(pos.x, 10);
	  pos.y = parseInt(pos.y, 10);
	  return pos;
	};
	
	
	/**
	 * Creates a single cluster that manages a group of proximate markers.
	 *  Used internally, do not call this constructor directly.
	 * @constructor
	 * @param {MarkerClusterer} mc The <code>MarkerClusterer</code> object with which this
	 *  cluster is associated.
	 */
	function Cluster(mc) {
	  this.markerClusterer_ = mc;
	  this.map_ = mc.getMap();
	  this.gridSize_ = mc.getGridSize();
	  this.minClusterSize_ = mc.getMinimumClusterSize();
	  this.averageCenter_ = mc.getAverageCenter();
	  this.markers_ = [];
	  this.center_ = null;
	  this.bounds_ = null;
	  this.clusterIcon_ = new ClusterIcon(this, mc.getStyles());
	}
	
	
	/**
	 * Returns the number of markers managed by the cluster. You can call this from
	 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
	 * for the <code>MarkerClusterer</code> object.
	 *
	 * @return {number} The number of markers in the cluster.
	 */
	Cluster.prototype.getSize = function () {
	  return this.markers_.length;
	};
	
	
	/**
	 * Returns the array of markers managed by the cluster. You can call this from
	 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
	 * for the <code>MarkerClusterer</code> object.
	 *
	 * @return {Array} The array of markers in the cluster.
	 */
	Cluster.prototype.getMarkers = function () {
	  return this.markers_;
	};
	
	
	/**
	 * Returns the center of the cluster. You can call this from
	 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
	 * for the <code>MarkerClusterer</code> object.
	 *
	 * @return {google.maps.LatLng} The center of the cluster.
	 */
	Cluster.prototype.getCenter = function () {
	  return this.center_;
	};
	
	
	/**
	 * Returns the map with which the cluster is associated.
	 *
	 * @return {google.maps.Map} The map.
	 * @ignore
	 */
	Cluster.prototype.getMap = function () {
	  return this.map_;
	};
	
	
	/**
	 * Returns the <code>MarkerClusterer</code> object with which the cluster is associated.
	 *
	 * @return {MarkerClusterer} The associated marker clusterer.
	 * @ignore
	 */
	Cluster.prototype.getMarkerClusterer = function () {
	  return this.markerClusterer_;
	};
	
	
	/**
	 * Returns the bounds of the cluster.
	 *
	 * @return {google.maps.LatLngBounds} the cluster bounds.
	 * @ignore
	 */
	Cluster.prototype.getBounds = function () {
	  var i;
	  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
	  var markers = this.getMarkers();
	  for (i = 0; i < markers.length; i++) {
	    bounds.extend(markers[i].getPosition());
	  }
	  return bounds;
	};
	
	
	/**
	 * Removes the cluster from the map.
	 *
	 * @ignore
	 */
	Cluster.prototype.remove = function () {
	  this.clusterIcon_.setMap(null);
	  this.markers_ = [];
	  delete this.markers_;
	};
	
	
	/**
	 * Adds a marker to the cluster.
	 *
	 * @param {google.maps.Marker} marker The marker to be added.
	 * @return {boolean} True if the marker was added.
	 * @ignore
	 */
	Cluster.prototype.addMarker = function (marker) {
	  var i;
	  var mCount;
	  var mz;
	
	  if (this.isMarkerAlreadyAdded_(marker)) {
	    return false;
	  }
	
	  if (!this.center_) {
	    this.center_ = marker.getPosition();
	    this.calculateBounds_();
	  } else {
	    if (this.averageCenter_) {
	      var l = this.markers_.length + 1;
	      var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
	      var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
	      this.center_ = new google.maps.LatLng(lat, lng);
	      this.calculateBounds_();
	    }
	  }
	
	  marker.isAdded = true;
	  this.markers_.push(marker);
	
	  mCount = this.markers_.length;
	  mz = this.markerClusterer_.getMaxZoom();
	  if (mz !== null && this.map_.getZoom() > mz) {
	    // Zoomed in past max zoom, so show the marker.
	    if (marker.getMap() !== this.map_) {
	      marker.setMap(this.map_);
	    }
	  } else if (mCount < this.minClusterSize_) {
	    // Min cluster size not reached so show the marker.
	    if (marker.getMap() !== this.map_) {
	      marker.setMap(this.map_);
	    }
	  } else if (mCount === this.minClusterSize_) {
	    // Hide the markers that were showing.
	    for (i = 0; i < mCount; i++) {
	      this.markers_[i].setMap(null);
	    }
	  } else {
	    marker.setMap(null);
	  }
	
	  this.updateIcon_();
	  return true;
	};
	
	
	/**
	 * Determines if a marker lies within the cluster's bounds.
	 *
	 * @param {google.maps.Marker} marker The marker to check.
	 * @return {boolean} True if the marker lies in the bounds.
	 * @ignore
	 */
	Cluster.prototype.isMarkerInClusterBounds = function (marker) {
	  return this.bounds_.contains(marker.getPosition());
	};
	
	
	/**
	 * Calculates the extended bounds of the cluster with the grid.
	 */
	Cluster.prototype.calculateBounds_ = function () {
	  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
	  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
	};
	
	
	/**
	 * Updates the cluster icon.
	 */
	Cluster.prototype.updateIcon_ = function () {
	  var mCount = this.markers_.length;
	  var mz = this.markerClusterer_.getMaxZoom();
	
	  if (mz !== null && this.map_.getZoom() > mz) {
	    this.clusterIcon_.hide();
	    return;
	  }
	
	  if (mCount < this.minClusterSize_) {
	    // Min cluster size not yet reached.
	    this.clusterIcon_.hide();
	    return;
	  }
	
	  var numStyles = this.markerClusterer_.getStyles().length;
	  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
	  this.clusterIcon_.setCenter(this.center_);
	  this.clusterIcon_.useStyle(sums);
	  this.clusterIcon_.show();
	};
	
	
	/**
	 * Determines if a marker has already been added to the cluster.
	 *
	 * @param {google.maps.Marker} marker The marker to check.
	 * @return {boolean} True if the marker has already been added.
	 */
	Cluster.prototype.isMarkerAlreadyAdded_ = function (marker) {
	  var i;
	  if (this.markers_.indexOf) {
	    return this.markers_.indexOf(marker) !== -1;
	  } else {
	    for (i = 0; i < this.markers_.length; i++) {
	      if (marker === this.markers_[i]) {
	        return true;
	      }
	    }
	  }
	  return false;
	};
	
	
	/**
	 * @name MarkerClustererOptions
	 * @class This class represents the optional parameter passed to
	 *  the {@link MarkerClusterer} constructor.
	 * @property {number} [gridSize=60] The grid size of a cluster in pixels. The grid is a square.
	 * @property {number} [maxZoom=null] The maximum zoom level at which clustering is enabled or
	 *  <code>null</code> if clustering is to be enabled at all zoom levels.
	 * @property {boolean} [zoomOnClick=true] Whether to zoom the map when a cluster marker is
	 *  clicked. You may want to set this to <code>false</code> if you have installed a handler
	 *  for the <code>click</code> event and it deals with zooming on its own.
	 * @property {boolean} [averageCenter=false] Whether the position of a cluster marker should be
	 *  the average position of all markers in the cluster. If set to <code>false</code>, the
	 *  cluster marker is positioned at the location of the first marker added to the cluster.
	 * @property {number} [minimumClusterSize=2] The minimum number of markers needed in a cluster
	 *  before the markers are hidden and a cluster marker appears.
	 * @property {boolean} [ignoreHidden=false] Whether to ignore hidden markers in clusters. You
	 *  may want to set this to <code>true</code> to ensure that hidden markers are not included
	 *  in the marker count that appears on a cluster marker (this count is the value of the
	 *  <code>text</code> property of the result returned by the default <code>calculator</code>).
	 *  If set to <code>true</code> and you change the visibility of a marker being clustered, be
	 *  sure to also call <code>MarkerClusterer.repaint()</code>.
	 * @property {string} [title=""] The tooltip to display when the mouse moves over a cluster
	 *  marker. (Alternatively, you can use a custom <code>calculator</code> function to specify a
	 *  different tooltip for each cluster marker.)
	 * @property {function} [calculator=MarkerClusterer.CALCULATOR] The function used to determine
	 *  the text to be displayed on a cluster marker and the index indicating which style to use
	 *  for the cluster marker. The input parameters for the function are (1) the array of markers
	 *  represented by a cluster marker and (2) the number of cluster icon styles. It returns a
	 *  {@link ClusterIconInfo} object. The default <code>calculator</code> returns a
	 *  <code>text</code> property which is the number of markers in the cluster and an
	 *  <code>index</code> property which is one higher than the lowest integer such that
	 *  <code>10^i</code> exceeds the number of markers in the cluster, or the size of the styles
	 *  array, whichever is less. The <code>styles</code> array element used has an index of
	 *  <code>index</code> minus 1. For example, the default <code>calculator</code> returns a
	 *  <code>text</code> value of <code>"125"</code> and an <code>index</code> of <code>3</code>
	 *  for a cluster icon representing 125 markers so the element used in the <code>styles</code>
	 *  array is <code>2</code>. A <code>calculator</code> may also return a <code>title</code>
	 *  property that contains the text of the tooltip to be used for the cluster marker. If
	 *   <code>title</code> is not defined, the tooltip is set to the value of the <code>title</code>
	 *   property for the MarkerClusterer.
	 * @property {string} [clusterClass="cluster"] The name of the CSS class defining general styles
	 *  for the cluster markers. Use this class to define CSS styles that are not set up by the code
	 *  that processes the <code>styles</code> array.
	 * @property {Array} [styles] An array of {@link ClusterIconStyle} elements defining the styles
	 *  of the cluster markers to be used. The element to be used to style a given cluster marker
	 *  is determined by the function defined by the <code>calculator</code> property.
	 *  The default is an array of {@link ClusterIconStyle} elements whose properties are derived
	 *  from the values for <code>imagePath</code>, <code>imageExtension</code>, and
	 *  <code>imageSizes</code>.
	 * @property {boolean} [enableRetinaIcons=false] Whether to allow the use of cluster icons that
	 * have sizes that are some multiple (typically double) of their actual display size. Icons such
	 * as these look better when viewed on high-resolution monitors such as Apple's Retina displays.
	 * Note: if this property is <code>true</code>, sprites cannot be used as cluster icons.
	 * @property {number} [batchSize=MarkerClusterer.BATCH_SIZE] Set this property to the
	 *  number of markers to be processed in a single batch when using a browser other than
	 *  Internet Explorer (for Internet Explorer, use the batchSizeIE property instead).
	 * @property {number} [batchSizeIE=MarkerClusterer.BATCH_SIZE_IE] When Internet Explorer is
	 *  being used, markers are processed in several batches with a small delay inserted between
	 *  each batch in an attempt to avoid Javascript timeout errors. Set this property to the
	 *  number of markers to be processed in a single batch; select as high a number as you can
	 *  without causing a timeout error in the browser. This number might need to be as low as 100
	 *  if 15,000 markers are being managed, for example.
	 * @property {string} [imagePath=MarkerClusterer.IMAGE_PATH]
	 *  The full URL of the root name of the group of image files to use for cluster icons.
	 *  The complete file name is of the form <code>imagePath</code>n.<code>imageExtension</code>
	 *  where n is the image file number (1, 2, etc.).
	 * @property {string} [imageExtension=MarkerClusterer.IMAGE_EXTENSION]
	 *  The extension name for the cluster icon image files (e.g., <code>"png"</code> or
	 *  <code>"jpg"</code>).
	 * @property {Array} [imageSizes=MarkerClusterer.IMAGE_SIZES]
	 *  An array of numbers containing the widths of the group of
	 *  <code>imagePath</code>n.<code>imageExtension</code> image files.
	 *  (The images are assumed to be square.)
	 */
	/**
	 * Creates a MarkerClusterer object with the options specified in {@link MarkerClustererOptions}.
	 * @constructor
	 * @extends google.maps.OverlayView
	 * @param {google.maps.Map} map The Google map to attach to.
	 * @param {Array.<google.maps.Marker>} [opt_markers] The markers to be added to the cluster.
	 * @param {MarkerClustererOptions} [opt_options] The optional parameters.
	 */
	function MarkerClusterer(map, opt_markers, opt_options) {
	  // MarkerClusterer implements google.maps.OverlayView interface. We use the
	  // extend function to extend MarkerClusterer with google.maps.OverlayView
	  // because it might not always be available when the code is defined so we
	  // look for it at the last possible moment. If it doesn't exist now then
	  // there is no point going ahead :)
	  this.extend(MarkerClusterer, google.maps.OverlayView);
	
	  opt_markers = opt_markers || [];
	  opt_options = opt_options || {};
	
	  this.markers_ = [];
	  this.clusters_ = [];
	  this.listeners_ = [];
	  this.activeMap_ = null;
	  this.ready_ = false;
	
	  this.gridSize_ = opt_options.gridSize || 60;
	  this.minClusterSize_ = opt_options.minimumClusterSize || 2;
	  this.maxZoom_ = opt_options.maxZoom || null;
	  this.styles_ = opt_options.styles || [];
	  this.title_ = opt_options.title || "";
	  this.zoomOnClick_ = true;
	  if (opt_options.zoomOnClick !== undefined) {
	    this.zoomOnClick_ = opt_options.zoomOnClick;
	  }
	  this.averageCenter_ = false;
	  if (opt_options.averageCenter !== undefined) {
	    this.averageCenter_ = opt_options.averageCenter;
	  }
	  this.ignoreHidden_ = false;
	  if (opt_options.ignoreHidden !== undefined) {
	    this.ignoreHidden_ = opt_options.ignoreHidden;
	  }
	  this.enableRetinaIcons_ = false;
	  if (opt_options.enableRetinaIcons !== undefined) {
	    this.enableRetinaIcons_ = opt_options.enableRetinaIcons;
	  }
	  this.imagePath_ = opt_options.imagePath || MarkerClusterer.IMAGE_PATH;
	  this.imageExtension_ = opt_options.imageExtension || MarkerClusterer.IMAGE_EXTENSION;
	  this.imageSizes_ = opt_options.imageSizes || MarkerClusterer.IMAGE_SIZES;
	  this.calculator_ = opt_options.calculator || MarkerClusterer.CALCULATOR;
	  this.batchSize_ = opt_options.batchSize || MarkerClusterer.BATCH_SIZE;
	  this.batchSizeIE_ = opt_options.batchSizeIE || MarkerClusterer.BATCH_SIZE_IE;
	  this.clusterClass_ = opt_options.clusterClass || "cluster";
	
	  if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) {
	    // Try to avoid IE timeout when processing a huge number of markers:
	    this.batchSize_ = this.batchSizeIE_;
	  }
	
	  this.setupStyles_();
	
	  this.addMarkers(opt_markers, true);
	  this.setMap(map); // Note: this causes onAdd to be called
	}
	
	
	/**
	 * Implementation of the onAdd interface method.
	 * @ignore
	 */
	MarkerClusterer.prototype.onAdd = function () {
	  var cMarkerClusterer = this;
	
	  this.activeMap_ = this.getMap();
	  this.ready_ = true;
	
	  this.repaint();
	
	  // Add the map event listeners
	  this.listeners_ = [
	    google.maps.event.addListener(this.getMap(), "zoom_changed", function () {
	      cMarkerClusterer.resetViewport_(false);
	      // Workaround for this Google bug: when map is at level 0 and "-" of
	      // zoom slider is clicked, a "zoom_changed" event is fired even though
	      // the map doesn't zoom out any further. In this situation, no "idle"
	      // event is triggered so the cluster markers that have been removed
	      // do not get redrawn. Same goes for a zoom in at maxZoom.
	      if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) {
	        google.maps.event.trigger(this, "idle");
	      }
	    }),
	    google.maps.event.addListener(this.getMap(), "idle", function () {
	      cMarkerClusterer.redraw_();
	    })
	  ];
	};
	
	
	/**
	 * Implementation of the onRemove interface method.
	 * Removes map event listeners and all cluster icons from the DOM.
	 * All managed markers are also put back on the map.
	 * @ignore
	 */
	MarkerClusterer.prototype.onRemove = function () {
	  var i;
	
	  // Put all the managed markers back on the map:
	  for (i = 0; i < this.markers_.length; i++) {
	    if (this.markers_[i].getMap() !== this.activeMap_) {
	      this.markers_[i].setMap(this.activeMap_);
	    }
	  }
	
	  // Remove all clusters:
	  for (i = 0; i < this.clusters_.length; i++) {
	    this.clusters_[i].remove();
	  }
	  this.clusters_ = [];
	
	  // Remove map event listeners:
	  for (i = 0; i < this.listeners_.length; i++) {
	    google.maps.event.removeListener(this.listeners_[i]);
	  }
	  this.listeners_ = [];
	
	  this.activeMap_ = null;
	  this.ready_ = false;
	};
	
	
	/**
	 * Implementation of the draw interface method.
	 * @ignore
	 */
	MarkerClusterer.prototype.draw = function () {};
	
	
	/**
	 * Sets up the styles object.
	 */
	MarkerClusterer.prototype.setupStyles_ = function () {
	  var i, size;
	  if (this.styles_.length > 0) {
	    return;
	  }
	
	  for (i = 0; i < this.imageSizes_.length; i++) {
	    size = this.imageSizes_[i];
	    this.styles_.push({
	      url: this.imagePath_ + (i + 1) + "." + this.imageExtension_,
	      height: size,
	      width: size
	    });
	  }
	};
	
	
	/**
	 *  Fits the map to the bounds of the markers managed by the clusterer.
	 */
	MarkerClusterer.prototype.fitMapToMarkers = function () {
	  var i;
	  var markers = this.getMarkers();
	  var bounds = new google.maps.LatLngBounds();
	  for (i = 0; i < markers.length; i++) {
	    bounds.extend(markers[i].getPosition());
	  }
	
	  this.getMap().fitBounds(bounds);
	};
	
	
	/**
	 * Returns the value of the <code>gridSize</code> property.
	 *
	 * @return {number} The grid size.
	 */
	MarkerClusterer.prototype.getGridSize = function () {
	  return this.gridSize_;
	};
	
	
	/**
	 * Sets the value of the <code>gridSize</code> property.
	 *
	 * @param {number} gridSize The grid size.
	 */
	MarkerClusterer.prototype.setGridSize = function (gridSize) {
	  this.gridSize_ = gridSize;
	};
	
	
	/**
	 * Returns the value of the <code>minimumClusterSize</code> property.
	 *
	 * @return {number} The minimum cluster size.
	 */
	MarkerClusterer.prototype.getMinimumClusterSize = function () {
	  return this.minClusterSize_;
	};
	
	/**
	 * Sets the value of the <code>minimumClusterSize</code> property.
	 *
	 * @param {number} minimumClusterSize The minimum cluster size.
	 */
	MarkerClusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
	  this.minClusterSize_ = minimumClusterSize;
	};
	
	
	/**
	 *  Returns the value of the <code>maxZoom</code> property.
	 *
	 *  @return {number} The maximum zoom level.
	 */
	MarkerClusterer.prototype.getMaxZoom = function () {
	  return this.maxZoom_;
	};
	
	
	/**
	 *  Sets the value of the <code>maxZoom</code> property.
	 *
	 *  @param {number} maxZoom The maximum zoom level.
	 */
	MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
	  this.maxZoom_ = maxZoom;
	};
	
	
	/**
	 *  Returns the value of the <code>styles</code> property.
	 *
	 *  @return {Array} The array of styles defining the cluster markers to be used.
	 */
	MarkerClusterer.prototype.getStyles = function () {
	  return this.styles_;
	};
	
	
	/**
	 *  Sets the value of the <code>styles</code> property.
	 *
	 *  @param {Array.<ClusterIconStyle>} styles The array of styles to use.
	 */
	MarkerClusterer.prototype.setStyles = function (styles) {
	  this.styles_ = styles;
	};
	
	
	/**
	 * Returns the value of the <code>title</code> property.
	 *
	 * @return {string} The content of the title text.
	 */
	MarkerClusterer.prototype.getTitle = function () {
	  return this.title_;
	};
	
	
	/**
	 *  Sets the value of the <code>title</code> property.
	 *
	 *  @param {string} title The value of the title property.
	 */
	MarkerClusterer.prototype.setTitle = function (title) {
	  this.title_ = title;
	};
	
	
	/**
	 * Returns the value of the <code>zoomOnClick</code> property.
	 *
	 * @return {boolean} True if zoomOnClick property is set.
	 */
	MarkerClusterer.prototype.getZoomOnClick = function () {
	  return this.zoomOnClick_;
	};
	
	
	/**
	 *  Sets the value of the <code>zoomOnClick</code> property.
	 *
	 *  @param {boolean} zoomOnClick The value of the zoomOnClick property.
	 */
	MarkerClusterer.prototype.setZoomOnClick = function (zoomOnClick) {
	  this.zoomOnClick_ = zoomOnClick;
	};
	
	
	/**
	 * Returns the value of the <code>averageCenter</code> property.
	 *
	 * @return {boolean} True if averageCenter property is set.
	 */
	MarkerClusterer.prototype.getAverageCenter = function () {
	  return this.averageCenter_;
	};
	
	
	/**
	 *  Sets the value of the <code>averageCenter</code> property.
	 *
	 *  @param {boolean} averageCenter The value of the averageCenter property.
	 */
	MarkerClusterer.prototype.setAverageCenter = function (averageCenter) {
	  this.averageCenter_ = averageCenter;
	};
	
	
	/**
	 * Returns the value of the <code>ignoreHidden</code> property.
	 *
	 * @return {boolean} True if ignoreHidden property is set.
	 */
	MarkerClusterer.prototype.getIgnoreHidden = function () {
	  return this.ignoreHidden_;
	};
	
	
	/**
	 *  Sets the value of the <code>ignoreHidden</code> property.
	 *
	 *  @param {boolean} ignoreHidden The value of the ignoreHidden property.
	 */
	MarkerClusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
	  this.ignoreHidden_ = ignoreHidden;
	};
	
	
	/**
	 * Returns the value of the <code>enableRetinaIcons</code> property.
	 *
	 * @return {boolean} True if enableRetinaIcons property is set.
	 */
	MarkerClusterer.prototype.getEnableRetinaIcons = function () {
	  return this.enableRetinaIcons_;
	};
	
	
	/**
	 *  Sets the value of the <code>enableRetinaIcons</code> property.
	 *
	 *  @param {boolean} enableRetinaIcons The value of the enableRetinaIcons property.
	 */
	MarkerClusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
	  this.enableRetinaIcons_ = enableRetinaIcons;
	};
	
	
	/**
	 * Returns the value of the <code>imageExtension</code> property.
	 *
	 * @return {string} The value of the imageExtension property.
	 */
	MarkerClusterer.prototype.getImageExtension = function () {
	  return this.imageExtension_;
	};
	
	
	/**
	 *  Sets the value of the <code>imageExtension</code> property.
	 *
	 *  @param {string} imageExtension The value of the imageExtension property.
	 */
	MarkerClusterer.prototype.setImageExtension = function (imageExtension) {
	  this.imageExtension_ = imageExtension;
	};
	
	
	/**
	 * Returns the value of the <code>imagePath</code> property.
	 *
	 * @return {string} The value of the imagePath property.
	 */
	MarkerClusterer.prototype.getImagePath = function () {
	  return this.imagePath_;
	};
	
	
	/**
	 *  Sets the value of the <code>imagePath</code> property.
	 *
	 *  @param {string} imagePath The value of the imagePath property.
	 */
	MarkerClusterer.prototype.setImagePath = function (imagePath) {
	  this.imagePath_ = imagePath;
	};
	
	
	/**
	 * Returns the value of the <code>imageSizes</code> property.
	 *
	 * @return {Array} The value of the imageSizes property.
	 */
	MarkerClusterer.prototype.getImageSizes = function () {
	  return this.imageSizes_;
	};
	
	
	/**
	 *  Sets the value of the <code>imageSizes</code> property.
	 *
	 *  @param {Array} imageSizes The value of the imageSizes property.
	 */
	MarkerClusterer.prototype.setImageSizes = function (imageSizes) {
	  this.imageSizes_ = imageSizes;
	};
	
	
	/**
	 * Returns the value of the <code>calculator</code> property.
	 *
	 * @return {function} the value of the calculator property.
	 */
	MarkerClusterer.prototype.getCalculator = function () {
	  return this.calculator_;
	};
	
	
	/**
	 * Sets the value of the <code>calculator</code> property.
	 *
	 * @param {function(Array.<google.maps.Marker>, number)} calculator The value
	 *  of the calculator property.
	 */
	MarkerClusterer.prototype.setCalculator = function (calculator) {
	  this.calculator_ = calculator;
	};
	
	
	/**
	 * Returns the value of the <code>batchSizeIE</code> property.
	 *
	 * @return {number} the value of the batchSizeIE property.
	 */
	MarkerClusterer.prototype.getBatchSizeIE = function () {
	  return this.batchSizeIE_;
	};
	
	
	/**
	 * Sets the value of the <code>batchSizeIE</code> property.
	 *
	 *  @param {number} batchSizeIE The value of the batchSizeIE property.
	 */
	MarkerClusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
	  this.batchSizeIE_ = batchSizeIE;
	};
	
	
	/**
	 * Returns the value of the <code>clusterClass</code> property.
	 *
	 * @return {string} the value of the clusterClass property.
	 */
	MarkerClusterer.prototype.getClusterClass = function () {
	  return this.clusterClass_;
	};
	
	
	/**
	 * Sets the value of the <code>clusterClass</code> property.
	 *
	 *  @param {string} clusterClass The value of the clusterClass property.
	 */
	MarkerClusterer.prototype.setClusterClass = function (clusterClass) {
	  this.clusterClass_ = clusterClass;
	};
	
	
	/**
	 *  Returns the array of markers managed by the clusterer.
	 *
	 *  @return {Array} The array of markers managed by the clusterer.
	 */
	MarkerClusterer.prototype.getMarkers = function () {
	  return this.markers_;
	};
	
	
	/**
	 *  Returns the number of markers managed by the clusterer.
	 *
	 *  @return {number} The number of markers.
	 */
	MarkerClusterer.prototype.getTotalMarkers = function () {
	  return this.markers_.length;
	};
	
	
	/**
	 * Returns the current array of clusters formed by the clusterer.
	 *
	 * @return {Array} The array of clusters formed by the clusterer.
	 */
	MarkerClusterer.prototype.getClusters = function () {
	  return this.clusters_;
	};
	
	
	/**
	 * Returns the number of clusters formed by the clusterer.
	 *
	 * @return {number} The number of clusters formed by the clusterer.
	 */
	MarkerClusterer.prototype.getTotalClusters = function () {
	  return this.clusters_.length;
	};
	
	
	/**
	 * Adds a marker to the clusterer. The clusters are redrawn unless
	 *  <code>opt_nodraw</code> is set to <code>true</code>.
	 *
	 * @param {google.maps.Marker} marker The marker to add.
	 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
	 */
	MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
	  this.pushMarkerTo_(marker);
	  if (!opt_nodraw) {
	    this.redraw_();
	  }
	};
	
	
	/**
	 * Adds an array of markers to the clusterer. The clusters are redrawn unless
	 *  <code>opt_nodraw</code> is set to <code>true</code>.
	 *
	 * @param {Array.<google.maps.Marker>} markers The markers to add.
	 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
	 */
	MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
	  var key;
	  for (key in markers) {
	    if (markers.hasOwnProperty(key)) {
	      this.pushMarkerTo_(markers[key]);
	    }
	  }  
	  if (!opt_nodraw) {
	    this.redraw_();
	  }
	};
	
	
	/**
	 * Pushes a marker to the clusterer.
	 *
	 * @param {google.maps.Marker} marker The marker to add.
	 */
	MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
	  // If the marker is draggable add a listener so we can update the clusters on the dragend:
	  if (marker.getDraggable()) {
	    var cMarkerClusterer = this;
	    google.maps.event.addListener(marker, "dragend", function () {
	      if (cMarkerClusterer.ready_) {
	        this.isAdded = false;
	        cMarkerClusterer.repaint();
	      }
	    });
	  }
	  marker.isAdded = false;
	  this.markers_.push(marker);
	};
	
	
	/**
	 * Removes a marker from the cluster.  The clusters are redrawn unless
	 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if the
	 *  marker was removed from the clusterer.
	 *
	 * @param {google.maps.Marker} marker The marker to remove.
	 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
	 * @return {boolean} True if the marker was removed from the clusterer.
	 */
	MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
	  var removed = this.removeMarker_(marker);
	
	  if (!opt_nodraw && removed) {
	    this.repaint();
	  }
	
	  return removed;
	};
	
	
	/**
	 * Removes an array of markers from the cluster. The clusters are redrawn unless
	 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if markers
	 *  were removed from the clusterer.
	 *
	 * @param {Array.<google.maps.Marker>} markers The markers to remove.
	 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
	 * @return {boolean} True if markers were removed from the clusterer.
	 */
	MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
	  var i, r;
	  var removed = false;
	
	  for (i = 0; i < markers.length; i++) {
	    r = this.removeMarker_(markers[i]);
	    removed = removed || r;
	  }
	
	  if (!opt_nodraw && removed) {
	    this.repaint();
	  }
	
	  return removed;
	};
	
	
	/**
	 * Removes a marker and returns true if removed, false if not.
	 *
	 * @param {google.maps.Marker} marker The marker to remove
	 * @return {boolean} Whether the marker was removed or not
	 */
	MarkerClusterer.prototype.removeMarker_ = function (marker) {
	  var i;
	  var index = -1;
	  if (this.markers_.indexOf) {
	    index = this.markers_.indexOf(marker);
	  } else {
	    for (i = 0; i < this.markers_.length; i++) {
	      if (marker === this.markers_[i]) {
	        index = i;
	        break;
	      }
	    }
	  }
	
	  if (index === -1) {
	    // Marker is not in our list of markers, so do nothing:
	    return false;
	  }
	
	  marker.setMap(null);
	  this.markers_.splice(index, 1); // Remove the marker from the list of managed markers
	  return true;
	};
	
	
	/**
	 * Removes all clusters and markers from the map and also removes all markers
	 *  managed by the clusterer.
	 */
	MarkerClusterer.prototype.clearMarkers = function () {
	  this.resetViewport_(true);
	  this.markers_ = [];
	};
	
	
	/**
	 * Recalculates and redraws all the marker clusters from scratch.
	 *  Call this after changing any properties.
	 */
	MarkerClusterer.prototype.repaint = function () {
	  var oldClusters = this.clusters_.slice();
	  this.clusters_ = [];
	  this.resetViewport_(false);
	  this.redraw_();
	
	  // Remove the old clusters.
	  // Do it in a timeout to prevent blinking effect.
	  setTimeout(function () {
	    var i;
	    for (i = 0; i < oldClusters.length; i++) {
	      oldClusters[i].remove();
	    }
	  }, 0);
	};
	
	
	/**
	 * Returns the current bounds extended by the grid size.
	 *
	 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
	 * @return {google.maps.LatLngBounds} The extended bounds.
	 * @ignore
	 */
	MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
	  var projection = this.getProjection();
	
	  // Turn the bounds into latlng.
	  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
	      bounds.getNorthEast().lng());
	  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
	      bounds.getSouthWest().lng());
	
	  // Convert the points to pixels and the extend out by the grid size.
	  var trPix = projection.fromLatLngToDivPixel(tr);
	  trPix.x += this.gridSize_;
	  trPix.y -= this.gridSize_;
	
	  var blPix = projection.fromLatLngToDivPixel(bl);
	  blPix.x -= this.gridSize_;
	  blPix.y += this.gridSize_;
	
	  // Convert the pixel points back to LatLng
	  var ne = projection.fromDivPixelToLatLng(trPix);
	  var sw = projection.fromDivPixelToLatLng(blPix);
	
	  // Extend the bounds to contain the new bounds.
	  bounds.extend(ne);
	  bounds.extend(sw);
	
	  return bounds;
	};
	
	
	/**
	 * Redraws all the clusters.
	 */
	MarkerClusterer.prototype.redraw_ = function () {
	  this.createClusters_(0);
	};
	
	
	/**
	 * Removes all clusters from the map. The markers are also removed from the map
	 *  if <code>opt_hide</code> is set to <code>true</code>.
	 *
	 * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
	 *  from the map.
	 */
	MarkerClusterer.prototype.resetViewport_ = function (opt_hide) {
	  var i, marker;
	  // Remove all the clusters
	  for (i = 0; i < this.clusters_.length; i++) {
	    this.clusters_[i].remove();
	  }
	  this.clusters_ = [];
	
	  // Reset the markers to not be added and to be removed from the map.
	  for (i = 0; i < this.markers_.length; i++) {
	    marker = this.markers_[i];
	    marker.isAdded = false;
	    if (opt_hide) {
	      marker.setMap(null);
	    }
	  }
	};
	
	
	/**
	 * Calculates the distance between two latlng locations in km.
	 *
	 * @param {google.maps.LatLng} p1 The first lat lng point.
	 * @param {google.maps.LatLng} p2 The second lat lng point.
	 * @return {number} The distance between the two points in km.
	 * @see http://www.movable-type.co.uk/scripts/latlong.html
	*/
	MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
	  var R = 6371; // Radius of the Earth in km
	  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
	  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
	  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
	    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
	    Math.sin(dLon / 2) * Math.sin(dLon / 2);
	  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  var d = R * c;
	  return d;
	};
	
	
	/**
	 * Determines if a marker is contained in a bounds.
	 *
	 * @param {google.maps.Marker} marker The marker to check.
	 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
	 * @return {boolean} True if the marker is in the bounds.
	 */
	MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
	  return bounds.contains(marker.getPosition());
	};
	
	
	/**
	 * Adds a marker to a cluster, or creates a new cluster.
	 *
	 * @param {google.maps.Marker} marker The marker to add.
	 */
	MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
	  var i, d, cluster, center;
	  var distance = 40000; // Some large number
	  var clusterToAddTo = null;
	  for (i = 0; i < this.clusters_.length; i++) {
	    cluster = this.clusters_[i];
	    center = cluster.getCenter();
	    if (center) {
	      d = this.distanceBetweenPoints_(center, marker.getPosition());
	      if (d < distance) {
	        distance = d;
	        clusterToAddTo = cluster;
	      }
	    }
	  }
	
	  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
	    clusterToAddTo.addMarker(marker);
	  } else {
	    cluster = new Cluster(this);
	    cluster.addMarker(marker);
	    this.clusters_.push(cluster);
	  }
	};
	
	
	/**
	 * Creates the clusters. This is done in batches to avoid timeout errors
	 *  in some browsers when there is a huge number of markers.
	 *
	 * @param {number} iFirst The index of the first marker in the batch of
	 *  markers to be added to clusters.
	 */
	MarkerClusterer.prototype.createClusters_ = function (iFirst) {
	  var i, marker;
	  var mapBounds;
	  var cMarkerClusterer = this;
	  if (!this.ready_) {
	    return;
	  }
	
	  // Cancel previous batch processing if we're working on the first batch:
	  if (iFirst === 0) {
	    /**
	     * This event is fired when the <code>MarkerClusterer</code> begins
	     *  clustering markers.
	     * @name MarkerClusterer#clusteringbegin
	     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
	     * @event
	     */
	    google.maps.event.trigger(this, "clusteringbegin", this);
	
	    if (typeof this.timerRefStatic !== "undefined") {
	      clearTimeout(this.timerRefStatic);
	      delete this.timerRefStatic;
	    }
	  }
	
	  // Get our current map view bounds.
	  // Create a new bounds object so we don't affect the map.
	  //
	  // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
	  if (this.getMap().getZoom() > 3) {
	    mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),
	      this.getMap().getBounds().getNorthEast());
	  } else {
	    mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
	  }
	  var bounds = this.getExtendedBounds(mapBounds);
	
	  var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);
	
	  for (i = iFirst; i < iLast; i++) {
	    marker = this.markers_[i];
	    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
	      if (!this.ignoreHidden_ || (this.ignoreHidden_ && marker.getVisible())) {
	        this.addToClosestCluster_(marker);
	      }
	    }
	  }
	
	  if (iLast < this.markers_.length) {
	    this.timerRefStatic = setTimeout(function () {
	      cMarkerClusterer.createClusters_(iLast);
	    }, 0);
	  } else {
	    delete this.timerRefStatic;
	
	    /**
	     * This event is fired when the <code>MarkerClusterer</code> stops
	     *  clustering markers.
	     * @name MarkerClusterer#clusteringend
	     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
	     * @event
	     */
	    google.maps.event.trigger(this, "clusteringend", this);
	  }
	};
	
	
	/**
	 * Extends an object's prototype by another's.
	 *
	 * @param {Object} obj1 The object to be extended.
	 * @param {Object} obj2 The object to extend with.
	 * @return {Object} The new extended object.
	 * @ignore
	 */
	MarkerClusterer.prototype.extend = function (obj1, obj2) {
	  return (function (object) {
	    var property;
	    for (property in object.prototype) {
	      this.prototype[property] = object.prototype[property];
	    }
	    return this;
	  }).apply(obj1, [obj2]);
	};
	
	
	/**
	 * The default function for determining the label text and style
	 * for a cluster icon.
	 *
	 * @param {Array.<google.maps.Marker>} markers The array of markers represented by the cluster.
	 * @param {number} numStyles The number of marker styles available.
	 * @return {ClusterIconInfo} The information resource for the cluster.
	 * @constant
	 * @ignore
	 */
	MarkerClusterer.CALCULATOR = function (markers, numStyles) {
	  var index = 0;
	  var title = "";
	  var count = markers.length.toString();
	
	  var dv = count;
	  while (dv !== 0) {
	    dv = parseInt(dv / 10, 10);
	    index++;
	  }
	
	  index = Math.min(index, numStyles);
	  return {
	    text: count,
	    index: index,
	    title: title
	  };
	};
	
	
	/**
	 * The number of markers to process in one batch.
	 *
	 * @type {number}
	 * @constant
	 */
	MarkerClusterer.BATCH_SIZE = 2000;
	
	
	/**
	 * The number of markers to process in one batch (IE only).
	 *
	 * @type {number}
	 * @constant
	 */
	MarkerClusterer.BATCH_SIZE_IE = 500;
	
	
	/**
	 * The default root name for the marker cluster images.
	 *
	 * @type {string}
	 * @constant
	 */
	MarkerClusterer.IMAGE_PATH = "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m";
	
	
	/**
	 * The default extension name for the marker cluster images.
	 *
	 * @type {string}
	 * @constant
	 */
	MarkerClusterer.IMAGE_EXTENSION = "png";
	
	
	/**
	 * The default array of sizes for the marker cluster images.
	 *
	 * @type {Array.<number>}
	 * @constant
	 */
	MarkerClusterer.IMAGE_SIZES = [53, 56, 66, 78, 90];
	
	module.exports = MarkerClusterer


/***/ }),
/* 1725 */,
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = dropEmptyColumns;
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function dropEmptyColumns(data) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$accessor = _ref.accessor,
	      accessor = _ref$accessor === void 0 ? function (_) {
	    return _;
	  } : _ref$accessor,
	      onlyTrimAtTheEnd = _ref.onlyTrimAtTheEnd;
	
	  var i = data[0].length - 1;
	
	  while (i >= 0) {
	    var empty = true;
	
	    for (var _iterator = _createForOfIteratorHelperLoose(data), _step; !(_step = _iterator()).done;) {
	      var row = _step.value;
	
	      if (accessor(row[i]) !== null) {
	        empty = false;
	        break;
	      }
	    }
	
	    if (empty) {
	      var j = 0;
	
	      while (j < data.length) {
	        data[j].splice(i, 1);
	        j++;
	      }
	    } else if (onlyTrimAtTheEnd) {
	      break;
	    }
	
	    i--;
	  }
	
	  return data;
	}
	//# sourceMappingURL=dropEmptyColumns.js.map

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = dropEmptyRows;
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function dropEmptyRows(data) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      rowMap = _ref.rowMap,
	      _ref$accessor = _ref.accessor,
	      accessor = _ref$accessor === void 0 ? function (_) {
	    return _;
	  } : _ref$accessor,
	      onlyTrimAtTheEnd = _ref.onlyTrimAtTheEnd;
	
	  // Drop empty rows.
	  var i = data.length - 1;
	
	  while (i >= 0) {
	    // Check if the row is empty.
	    var empty = true;
	
	    for (var _iterator = _createForOfIteratorHelperLoose(data[i]), _step; !(_step = _iterator()).done;) {
	      var cell = _step.value;
	
	      if (accessor(cell) !== null) {
	        empty = false;
	        break;
	      }
	    } // Remove the empty row.
	
	
	    if (empty) {
	      data.splice(i, 1);
	
	      if (rowMap) {
	        rowMap.splice(i, 1);
	      }
	    } else if (onlyTrimAtTheEnd) {
	      break;
	    }
	
	    i--;
	  }
	
	  return data;
	}
	//# sourceMappingURL=dropEmptyRows.js.map

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getData;
	
	var _dropEmptyRows = _interopRequireDefault(__webpack_require__(1728));
	
	var _dropEmptyColumns = _interopRequireDefault(__webpack_require__(1727));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function getData(sheet, options) {
	  var dimensions = sheet.dimensions,
	      cells = sheet.cells; // If the sheet is empty.
	
	  if (cells.length === 0) {
	    return [];
	  }
	
	  var _dimensions = _slicedToArray(dimensions, 2),
	      leftTop = _dimensions[0],
	      rightBottom = _dimensions[1]; // Don't discard empty rows or columns at the start.
	  // https://github.com/catamphetamine/read-excel-file/issues/102
	  // const colsCount = (rightBottom.column - leftTop.column) + 1
	  // const rowsCount = (rightBottom.row - leftTop.row) + 1
	
	
	  var colsCount = rightBottom.column;
	  var rowsCount = rightBottom.row; // Initialize spreadsheet data structure.
	
	  var data = new Array(rowsCount);
	  var i = 0;
	
	  while (i < rowsCount) {
	    data[i] = new Array(colsCount);
	    var j = 0;
	
	    while (j < colsCount) {
	      data[i][j] = null;
	      j++;
	    }
	
	    i++;
	  } // Fill in spreadsheet `data`.
	  // (this code implies that `cells` aren't necessarily sorted by row and column:
	  //  maybe that's not correct, this piece code was initially copy-pasted
	  //  from some other library that used `XPath`)
	
	
	  for (var _iterator = _createForOfIteratorHelperLoose(cells), _step; !(_step = _iterator()).done;) {
	    var cell = _step.value;
	    // Don't discard empty rows or columns at the start.
	    // https://github.com/catamphetamine/read-excel-file/issues/102
	    // const rowIndex = cell.row - leftTop.row
	    // const columnIndex = cell.column - leftTop.column
	    var rowIndex = cell.row - 1;
	    var columnIndex = cell.column - 1; // Ignore the data in the cell if it's outside of the spreadsheet's "dimensions".
	
	    if (columnIndex < colsCount && rowIndex < rowsCount) {
	      data[rowIndex][columnIndex] = cell.value;
	    }
	  } // Fill in the row map.
	
	
	  var rowMap = options.rowMap;
	
	  if (rowMap) {
	    var _i2 = 0;
	
	    while (_i2 < data.length) {
	      rowMap[_i2] = _i2;
	      _i2++;
	    }
	  } // Drop empty columns or rows.
	
	
	  data = (0, _dropEmptyRows["default"])((0, _dropEmptyColumns["default"])(data, {
	    onlyTrimAtTheEnd: true
	  }), {
	    onlyTrimAtTheEnd: true,
	    rowMap: rowMap
	  }); // Optionally transform data before applying `schema`.
	
	  if (options.transformData) {
	    data = options.transformData(data); // data = options.transformData(data, {
	    //   dropEmptyRowsAndColumns(data) {
	    //     return dropEmptyRows(dropEmptyColumns(data), { rowMap })
	    //   }
	    // })
	  }
	
	  return data;
	}
	//# sourceMappingURL=getData.js.map

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isDateTimestamp;
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	// XLSX does have "d" type for dates, but it's not commonly used.
	// Instead, it prefers using "n" type for storing dates as timestamps.
	//
	// Whether a numeric value is a number or a date timestamp, it sometimes could be
	// detected by looking at the value "format" and seeing if it's a date-specific one.
	// https://github.com/catamphetamine/read-excel-file/issues/3#issuecomment-395770777
	//
	// The list of generic numeric value "formats":
	// https://xlsxwriter.readthedocs.io/format.html#format-set-num-format
	//
	function isDateTimestamp(styleId, styles, options) {
	  if (styleId) {
	    var style = styles[styleId];
	
	    if (!style) {
	      throw new Error("Cell style not found: ".concat(styleId));
	    }
	
	    if (!style.numberFormat) {
	      return false;
	    }
	
	    if ( // Whether it's a "number format" that's conventionally used for storing date timestamps.
	    BUILT_IN_DATE_NUMBER_FORMAT_IDS.indexOf(Number(style.numberFormat.id)) >= 0 || // Whether it's a "number format" that uses a "formatting template"
	    // that the developer is certain is a date formatting template.
	    options.dateFormat && style.numberFormat.template === options.dateFormat || // Whether the "smart formatting template" feature is not disabled
	    // and it has detected that it's a date formatting template by looking at it.
	    options.smartDateParser !== false && style.numberFormat.template && isDateTemplate(style.numberFormat.template)) {
	      return true;
	    }
	  }
	} // https://hexdocs.pm/xlsxir/number_styles.html
	
	
	var BUILT_IN_DATE_NUMBER_FORMAT_IDS = [14, 15, 16, 17, 18, 19, 20, 21, 22, 27, 30, 36, 45, 46, 47, 50, 57]; // On some date formats, there's an "[$-414]" prefix.
	// I don't have any idea what that is.
	//
	// https://stackoverflow.com/questions/4730152/what-indicates-an-office-open-xml-cell-contains-a-date-time-value
	//
	// Examples:
	//
	// * 27 (built-in format) "[$-404]e/m/d"
	// * 164 (custom format) "[$-414]mmmm\ yyyy;@"
	//
	
	var DATE_FORMAT_WEIRD_PREFIX = /^\[\$-414\]/; // On some date formats, there's an ";@" postfix.
	// I don't have any idea what that is.
	// Examples:
	//
	// * 164 (custom format) "m/d/yyyy;@"
	// * 164 (custom format) "[$-414]mmmm\ yyyy;@"
	//
	
	var DATE_FORMAT_WEIRD_POSTFIX = /;@$/;
	
	function isDateTemplate(template) {
	  // Date format tokens could be in upper case or in lower case.
	  // There seems to be no single standard.
	  // So lowercase the template first.
	  template = template.toLowerCase(); // On some date formats, there's an "[$-414]" prefix.
	  // I don't have any idea what that is. Trim it.
	
	  template = template.replace(DATE_FORMAT_WEIRD_PREFIX, ''); // On some date formats, there's an ";@" postfix.
	  // I don't have any idea what that is. Trim it.
	
	  template = template.replace(DATE_FORMAT_WEIRD_POSTFIX, '');
	  var tokens = template.split(/\W+/);
	
	  for (var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;) {
	    var token = _step.value;
	
	    if (DATE_TEMPLATE_TOKENS.indexOf(token) < 0) {
	      return false;
	    }
	  }
	
	  return true;
	} // These tokens could be in upper case or in lower case.
	// There seems to be no single standard, so using lower case.
	
	
	var DATE_TEMPLATE_TOKENS = [// Seconds (min two digits). Example: "05".
	'ss', // Minutes (min two digits). Example: "05". Could also be "Months". Weird.
	'mm', // Hours. Example: "1".
	'h', // Hours (min two digits). Example: "01".
	'hh', // "AM" part of "AM/PM". Lowercased just in case.
	'am', // "PM" part of "AM/PM". Lowercased just in case.
	'pm', // Day. Example: "1"
	'd', // Day (min two digits). Example: "01"
	'dd', // Month (numeric). Example: "1".
	'm', // Month (numeric, min two digits). Example: "01". Could also be "Minutes". Weird.
	'mm', // Month (shortened month name). Example: "Jan".
	'mmm', // Month (full month name). Example: "January".
	'mmmm', // Two-digit year. Example: "20".
	'yy', // Full year. Example: "2020".
	'yyyy', // I don't have any idea what "e" means.
	// It's used in "built-in" XLSX formats:
	// * 27 '[$-404]e/m/d';
	// * 36 '[$-404]e/m/d';
	// * 50 '[$-404]e/m/d';
	// * 57 '[$-404]e/m/d';
	'e'];
	//# sourceMappingURL=isDateTimestamp.js.map

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseCell;
	
	var _parseCellValue = _interopRequireDefault(__webpack_require__(1732));
	
	var _coordinates = __webpack_require__(165);
	
	var _xlsx = __webpack_require__(70);
	
	var _dom = __webpack_require__(371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// Example of a `<c/>`ell element:
	//
	// <c>
	//    <f>string</f> — formula.
	//    <v>string</v> — formula pre-computed value.
	//    <is>
	//       <t>string</t> — an `inlineStr` string (rather than a "common string" from a dictionary).
	//       <r>
	//          <rPr>
	//            ...
	//          </rPr>
	//          <t>string</t>
	//       </r>
	//       <rPh sb="1" eb="1">
	//          <t>string</t>
	//       </rPh>
	//       <phoneticPr fontId="1"/>
	//    </is>
	//    <extLst>
	//       <ext>
	//          <!--any element-->
	//       </ext>
	//    </extLst>
	// </c>
	//
	function parseCell(node, sheet, xml, values, styles, properties, options) {
	  var coords = (0, _coordinates.parseCellCoordinates)(node.getAttribute('r'));
	  var valueElement = (0, _xlsx.getCellValue)(sheet, node); // For `xpath`, `value` can be `undefined` while for native `DOMParser` it's `null`.
	  // So using `value && ...` instead of `if (value !== undefined) { ... }` here
	  // for uniform compatibility with both `xpath` and native `DOMParser`.
	
	  var value = valueElement && valueElement.textContent;
	  var type;
	
	  if (node.hasAttribute('t')) {
	    type = node.getAttribute('t');
	  }
	
	  return {
	    row: coords[0],
	    column: coords[1],
	    value: (0, _parseCellValue["default"])(value, type, {
	      getInlineStringValue: function getInlineStringValue() {
	        return (0, _xlsx.getCellInlineStringValue)(sheet, node);
	      },
	      getInlineStringXml: function getInlineStringXml() {
	        return (0, _dom.getOuterXml)(node);
	      },
	      getStyleId: function getStyleId() {
	        return node.getAttribute('s');
	      },
	      styles: styles,
	      values: values,
	      properties: properties,
	      options: options
	    })
	  };
	}
	//# sourceMappingURL=parseCell.js.map

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseCellValue;
	
	var _parseDate = _interopRequireDefault(__webpack_require__(166));
	
	var _isDateTimestamp = _interopRequireDefault(__webpack_require__(1730));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// Parses a string `value` of a cell.
	function parseCellValue(value, type, _ref) {
	  var getInlineStringValue = _ref.getInlineStringValue,
	      getInlineStringXml = _ref.getInlineStringXml,
	      getStyleId = _ref.getStyleId,
	      styles = _ref.styles,
	      values = _ref.values,
	      properties = _ref.properties,
	      options = _ref.options;
	
	  if (!type) {
	    // Default cell type is "n" (numeric).
	    // http://www.datypic.com/sc/ooxml/t-ssml_CT_Cell.html
	    type = 'n';
	  } // Available Excel cell types:
	  // https://github.com/SheetJS/sheetjs/blob/19620da30be2a7d7b9801938a0b9b1fd3c4c4b00/docbits/52_datatype.md
	  //
	  // Some other document (seems to be old):
	  // http://webapp.docx4java.org/OnlineDemo/ecma376/SpreadsheetML/ST_CellType.html
	  //
	
	
	  switch (type) {
	    // XLSX tends to store all strings as "shared" (indexed) ones
	    // using "s" cell type (for saving on strage space).
	    // "str" cell type is then generally only used for storing
	    // formula-pre-calculated cell values.
	    case 'str':
	      value = parseString(value, options);
	      break;
	    // Sometimes, XLSX stores strings as "inline" strings rather than "shared" (indexed) ones.
	    // Perhaps the specification doesn't force it to use one or another.
	    // Example: `<sheetData><row r="1"><c r="A1" s="1" t="inlineStr"><is><t>Test 123</t></is></c></row></sheetData>`.
	
	    case 'inlineStr':
	      value = getInlineStringValue();
	
	      if (value === undefined) {
	        throw new Error("Unsupported \"inline string\" cell value structure: ".concat(getInlineStringXml()));
	      }
	
	      value = parseString(value, options);
	      break;
	    // XLSX tends to store string values as "shared" (indexed) ones.
	    // "Shared" strings is a way for an Excel editor to reduce
	    // the file size by storing "commonly used" strings in a dictionary
	    // and then referring to such strings by their index in that dictionary.
	    // Example: `<sheetData><row r="1"><c r="A1" s="1" t="s"><v>0</v></c></row></sheetData>`.
	
	    case 's':
	      // If a cell has no value then there's no `<c/>` element for it.
	      // If a `<c/>` element exists then it's not empty.
	      // The `<v/>`alue is a key in the "shared strings" dictionary of the
	      // XLSX file, so look it up in the `values` dictionary by the numeric key.
	      var sharedStringIndex = Number(value);
	
	      if (isNaN(sharedStringIndex)) {
	        throw new Error("Invalid \"shared\" string index: ".concat(value));
	      }
	
	      if (sharedStringIndex >= values.length) {
	        throw new Error("An out-of-bounds \"shared\" string index: ".concat(value));
	      }
	
	      value = values[sharedStringIndex];
	      value = parseString(value, options);
	      break;
	    // Boolean (TRUE/FALSE) values are stored as either "1" or "0"
	    // in cells of type "b".
	
	    case 'b':
	      if (value === '1') {
	        value = true;
	      } else if (value === '0') {
	        value = false;
	      } else {
	        throw new Error("Unsupported \"boolean\" cell value: ".concat(value));
	      }
	
	      break;
	    // XLSX specification seems to support cells of type "z":
	    // blank "stub" cells that should be ignored by data processing utilities.
	
	    case 'z':
	      value = undefined;
	      break;
	    // XLSX specification also defines cells of type "e" containing a numeric "error" code.
	    // It's not clear what that means though.
	    // They also wrote: "and `w` property stores its common name".
	    // It's unclear what they meant by that.
	
	    case 'e':
	      value = decodeError(value);
	      break;
	    // XLSX supports date cells of type "d", though seems like it (almost?) never
	    // uses it for storing dates, preferring "n" numeric timestamp cells instead.
	    // The value of a "d" cell is supposedly a string in "ISO 8601" format.
	    // I haven't seen an XLSX file having such cells.
	    // Example: `<sheetData><row r="1"><c r="A1" s="1" t="d"><v>2021-06-10T00:47:45.700Z</v></c></row></sheetData>`.
	
	    case 'd':
	      if (value === undefined) {
	        break;
	      }
	
	      var parsedDate = new Date(value);
	
	      if (isNaN(parsedDate.valueOf())) {
	        throw new Error("Unsupported \"date\" cell value: ".concat(value));
	      }
	
	      value = parsedDate;
	      break;
	    // Numeric cells have type "n".
	
	    case 'n':
	      if (value === undefined) {
	        break;
	      }
	
	      var isDateTimestampNumber = (0, _isDateTimestamp["default"])(getStyleId(), styles, options); // XLSX does have "d" type for dates, but it's not commonly used.
	      // Instead, it prefers using "n" type for storing dates as timestamps.
	
	      if (isDateTimestampNumber) {
	        // Parse the number from string.
	        value = parseNumberDefault(value); // Parse the number as a date timestamp.
	
	        value = (0, _parseDate["default"])(value, properties);
	      } else {
	        // Parse the number from string.
	        // Supports custom parsing function to work around javascript number encoding precision issues.
	        // https://gitlab.com/catamphetamine/read-excel-file/-/issues/85
	        value = (options.parseNumber || parseNumberDefault)(value);
	      }
	
	      break;
	
	    default:
	      throw new TypeError("Cell type not supported: ".concat(type));
	  } // Convert empty values to `null`.
	
	
	  if (value === undefined) {
	    value = null;
	  }
	
	  return value;
	} // Decodes numeric error code to a string code.
	// https://github.com/SheetJS/sheetjs/blob/19620da30be2a7d7b9801938a0b9b1fd3c4c4b00/docbits/52_datatype.md
	
	
	function decodeError(errorCode) {
	  // While the error values are determined by the application,
	  // the following are some example error values that could be used:
	  switch (errorCode) {
	    case 0x00:
	      return '#NULL!';
	
	    case 0x07:
	      return '#DIV/0!';
	
	    case 0x0F:
	      return '#VALUE!';
	
	    case 0x17:
	      return '#REF!';
	
	    case 0x1D:
	      return '#NAME?';
	
	    case 0x24:
	      return '#NUM!';
	
	    case 0x2A:
	      return '#N/A';
	
	    case 0x2B:
	      return '#GETTING_DATA';
	
	    default:
	      // Such error code doesn't exist. I made it up.
	      return "#ERROR_".concat(errorCode);
	  }
	}
	
	function parseString(value, options) {
	  // In some weird cases, a developer might want to disable
	  // the automatic trimming of all strings.
	  // For example, leading spaces might express a tree-like hierarchy.
	  // https://github.com/catamphetamine/read-excel-file/pull/106#issuecomment-1136062917
	  if (options.trim !== false) {
	    value = value.trim();
	  }
	
	  if (value === '') {
	    value = undefined;
	  }
	
	  return value;
	} // Parses a number from string.
	// Throws an error if the number couldn't be parsed.
	// When parsing floating-point number, is affected by
	// the javascript number encoding precision issues:
	// https://www.youtube.com/watch?v=2gIxbTn7GSc
	// https://www.avioconsulting.com/blog/overcoming-javascript-numeric-precision-issues
	
	
	function parseNumberDefault(stringifiedNumber) {
	  var parsedNumber = Number(stringifiedNumber);
	
	  if (isNaN(parsedNumber)) {
	    throw new Error("Invalid \"numeric\" cell value: ".concat(stringifiedNumber));
	  }
	
	  return parsedNumber;
	}
	//# sourceMappingURL=parseCellValue.js.map

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseCells;
	
	var _parseCell = _interopRequireDefault(__webpack_require__(1731));
	
	var _xlsx = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function parseCells(sheet, xml, values, styles, properties, options) {
	  var cells = (0, _xlsx.getCells)(sheet);
	
	  if (cells.length === 0) {
	    return [];
	  } // const mergedCells = getMergedCells(sheet)
	  // for (const mergedCell of mergedCells) {
	  //   const [from, to] = mergedCell.split(':').map(parseCellCoordinates)
	  //   console.log('Merged Cell.', 'From:', from, 'To:', to)
	  // }
	
	
	  return cells.map(function (node) {
	    return (0, _parseCell["default"])(node, sheet, xml, values, styles, properties, options);
	  });
	}
	//# sourceMappingURL=parseCells.js.map

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseDimensions;
	
	var _coordinates = __webpack_require__(165);
	
	var _xlsx = __webpack_require__(70);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	// `dimensions` defines the spreadsheet area containing all non-empty cells.
	// https://docs.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.sheetdimension?view=openxml-2.8.1
	function parseDimensions(sheet) {
	  var dimensions = (0, _xlsx.getDimensions)(sheet);
	
	  if (dimensions) {
	    dimensions = dimensions.split(':').map(_coordinates.parseCellCoordinates).map(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          row = _ref2[0],
	          column = _ref2[1];
	
	      return {
	        row: row,
	        column: column
	      };
	    }); // Sometimes there can be just a single cell as a spreadsheet's "dimensions".
	    // For example, the default "dimensions" in Apache POI library is "A1",
	    // meaning that only the first cell in the spreadsheet is used.
	    //
	    // A quote from Apache POI library:
	    // "Single cell ranges are formatted like single cell references (e.g. 'A1' instead of 'A1:A1')."
	    //
	
	    if (dimensions.length === 1) {
	      dimensions = [dimensions[0], dimensions[0]];
	    }
	
	    return dimensions;
	  }
	}
	//# sourceMappingURL=parseDimensions.js.map

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseFilePaths;
	
	var _xlsx = __webpack_require__(70);
	
	/**
	 * Returns sheet file paths.
	 * Seems that the correct place to look for the `sheetId` -> `filename` mapping
	 * is `xl/_rels/workbook.xml.rels` file.
	 * https://github.com/tidyverse/readxl/issues/104
	 * @param  {string} content — `xl/_rels/workbook.xml.rels` file contents.
	 * @param  {object} xml
	 * @return {object}
	 */
	function parseFilePaths(content, xml) {
	  // Example:
	  // <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
	  //   ...
	  //   <Relationship
	  //     Id="rId3"
	  //     Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet"
	  //     Target="worksheets/sheet1.xml"/>
	  // </Relationships>
	  var document = xml.createDocument(content);
	  var filePaths = {
	    sheets: {},
	    sharedStrings: undefined,
	    styles: undefined
	  };
	
	  var addFilePathInfo = function addFilePathInfo(relationship) {
	    var filePath = relationship.getAttribute('Target');
	    var fileType = relationship.getAttribute('Type');
	
	    switch (fileType) {
	      case 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles':
	        filePaths.styles = getFilePath(filePath);
	        break;
	
	      case 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings':
	        filePaths.sharedStrings = getFilePath(filePath);
	        break;
	
	      case 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet':
	        filePaths.sheets[relationship.getAttribute('Id')] = getFilePath(filePath);
	        break;
	    }
	  };
	
	  (0, _xlsx.getRelationships)(document).forEach(addFilePathInfo); // Seems like "sharedStrings.xml" is not required to exist.
	  // For example, when the spreadsheet doesn't contain any strings.
	  // https://github.com/catamphetamine/read-excel-file/issues/85
	  // if (!filePaths.sharedStrings) {
	  //   throw new Error('"sharedStrings.xml" file not found in the *.xlsx file')
	  // }
	
	  return filePaths;
	}
	
	function getFilePath(path) {
	  // Normally, `path` is a relative path inside the ZIP archive,
	  // like "worksheets/sheet1.xml", or "sharedStrings.xml", or "styles.xml".
	  // There has been one weird case when file path was an absolute path,
	  // like "/xl/worksheets/sheet1.xml" (specifically for sheets):
	  // https://github.com/catamphetamine/read-excel-file/pull/95
	  // Other libraries (like `xlsx`) and software (like Google Docs)
	  // seem to support such absolute file paths, so this library does too.
	  if (path[0] === '/') {
	    return path.slice('/'.length);
	  } // // Seems like a path could also be a URL.
	  // // http://officeopenxml.com/anatomyofOOXML-xlsx.php
	  // if (/^[a-z]+\:\/\//.test(path)) {
	  //   return path
	  // }
	
	
	  return 'xl/' + path;
	}
	//# sourceMappingURL=parseFilePaths.js.map

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseProperties;
	
	var _xlsx = __webpack_require__(70);
	
	// I guess `xl/workbook.xml` file should always be present inside the *.xlsx archive.
	function parseProperties(content, xml) {
	  var book = xml.createDocument(content);
	  var properties = {}; // Read `<workbookPr/>` element to detect whether dates are 1900-based or 1904-based.
	  // https://support.microsoft.com/en-gb/help/214330/differences-between-the-1900-and-the-1904-date-system-in-excel
	  // http://webapp.docx4java.org/OnlineDemo/ecma376/SpreadsheetML/workbookPr.html
	
	  var workbookProperties = (0, _xlsx.getWorkbookProperties)(book);
	
	  if (workbookProperties && workbookProperties.getAttribute('date1904') === '1') {
	    properties.epoch1904 = true;
	  } // Get sheets info (indexes, names, if they're available).
	  // Example:
	  // <sheets>
	  //   <sheet
	  //     xmlns:ns="http://schemas.openxmlformats.org/officeDocument/2006/relationships"
	  //     name="Sheet1"
	  //     sheetId="1"
	  //     ns:id="rId3"/>
	  // </sheets>
	  // http://www.datypic.com/sc/ooxml/e-ssml_sheet-1.html
	
	
	  properties.sheets = [];
	
	  var addSheetInfo = function addSheetInfo(sheet) {
	    if (sheet.getAttribute('name')) {
	      properties.sheets.push({
	        id: sheet.getAttribute('sheetId'),
	        name: sheet.getAttribute('name'),
	        relationId: sheet.getAttribute('r:id')
	      });
	    }
	  };
	
	  (0, _xlsx.getSheets)(book).forEach(addSheetInfo);
	  return properties;
	}
	//# sourceMappingURL=parseProperties.js.map

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseSharedStrings;
	
	var _xlsx = __webpack_require__(70);
	
	function parseSharedStrings(content, xml) {
	  if (!content) {
	    return [];
	  }
	
	  return (0, _xlsx.getSharedStrings)(xml.createDocument(content));
	}
	//# sourceMappingURL=parseSharedStrings.js.map

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseSheet;
	
	var _parseCells = _interopRequireDefault(__webpack_require__(1733));
	
	var _parseDimensions = _interopRequireDefault(__webpack_require__(1734));
	
	var _coordinates = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function parseSheet(content, xml, values, styles, properties, options) {
	  var sheet = xml.createDocument(content);
	  var cells = (0, _parseCells["default"])(sheet, xml, values, styles, properties, options); // `dimensions` defines the spreadsheet area containing all non-empty cells.
	  // https://docs.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.sheetdimension?view=openxml-2.8.1
	
	  var dimensions = (0, _parseDimensions["default"])(sheet) || (0, _coordinates.calculateDimensions)(cells);
	  return {
	    cells: cells,
	    dimensions: dimensions
	  };
	}
	//# sourceMappingURL=parseSheet.js.map

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseStyles;
	
	var _xlsx = __webpack_require__(70);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// http://officeopenxml.com/SSstyles.php
	// Returns an array of cell styles.
	// A cell style index is its ID.
	function parseStyles(content, xml) {
	  if (!content) {
	    return {};
	  } // https://social.msdn.microsoft.com/Forums/sqlserver/en-US/708978af-b598-45c4-a598-d3518a5a09f0/howwhen-is-cellstylexfs-vs-cellxfs-applied-to-a-cell?forum=os_binaryfile
	  // https://www.office-forums.com/threads/cellxfs-cellstylexfs.2163519/
	
	
	  var doc = xml.createDocument(content);
	  var baseStyles = (0, _xlsx.getBaseStyles)(doc).map(parseCellStyle);
	  var numberFormats = (0, _xlsx.getNumberFormats)(doc).map(parseNumberFormatStyle).reduce(function (formats, format) {
	    // Format ID is a numeric index.
	    // There're some standard "built-in" formats (in Excel) up to about `100`.
	    formats[format.id] = format;
	    return formats;
	  }, []);
	
	  var getCellStyle = function getCellStyle(xf) {
	    if (xf.hasAttribute('xfId')) {
	      return _objectSpread(_objectSpread({}, baseStyles[xf.xfId]), parseCellStyle(xf, numberFormats));
	    }
	
	    return parseCellStyle(xf, numberFormats);
	  };
	
	  return (0, _xlsx.getCellStyles)(doc).map(getCellStyle);
	}
	
	function parseNumberFormatStyle(numFmt) {
	  return {
	    id: numFmt.getAttribute('numFmtId'),
	    template: numFmt.getAttribute('formatCode')
	  };
	} // http://www.datypic.com/sc/ooxml/e-ssml_xf-2.html
	
	
	function parseCellStyle(xf, numFmts) {
	  var style = {};
	
	  if (xf.hasAttribute('numFmtId')) {
	    var numberFormatId = xf.getAttribute('numFmtId'); // Built-in number formats don't have a `<numFmt/>` element in `styles.xml`.
	    // https://hexdocs.pm/xlsxir/number_styles.html
	
	    if (numFmts[numberFormatId]) {
	      style.numberFormat = numFmts[numberFormatId];
	    } else {
	      style.numberFormat = {
	        id: numberFormatId
	      };
	    }
	  }
	
	  return style;
	}
	//# sourceMappingURL=parseStyles.js.map

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = readSheetNames;
	
	var _readXlsxFileBrowser = _interopRequireDefault(__webpack_require__(167));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Reads the list of sheet names in an XLSX file in a web browser.
	 * @param  {file} file - A file being uploaded in the browser.
	 * @return {Promise} Resolves to an array of objects of shape `{ name: string }`.
	 */
	function readSheetNames(file) {
	  return (0, _readXlsxFileBrowser["default"])(file, {
	    getSheets: true
	  }).then(function (sheets) {
	    return sheets.map(function (sheet) {
	      return sheet.name;
	    });
	  });
	}
	//# sourceMappingURL=readSheetNamesBrowser.js.map

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = readXlsx;
	
	var _parseProperties = _interopRequireDefault(__webpack_require__(1736));
	
	var _parseFilePaths = _interopRequireDefault(__webpack_require__(1735));
	
	var _parseStyles = _interopRequireDefault(__webpack_require__(1739));
	
	var _parseSharedStrings = _interopRequireDefault(__webpack_require__(1737));
	
	var _parseSheet = _interopRequireDefault(__webpack_require__(1738));
	
	var _getData = _interopRequireDefault(__webpack_require__(1729));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// For an introduction in reading `*.xlsx` files see "The minimum viable XLSX reader":
	// https://www.brendanlong.com/the-minimum-viable-xlsx-reader.html
	
	/**
	 * Reads an (unzipped) XLSX file structure into a 2D array of cells.
	 * @param  {object} contents - A list of XML files inside XLSX file (which is a zipped directory).
	 * @param  {number?} options.sheet - Workbook sheet id (`1` by default).
	 * @param  {string?} options.dateFormat - Date format, e.g. "mm/dd/yyyy". Values having this format template set will be parsed as dates.
	 * @param  {object} contents - A list of XML files inside XLSX file (which is a zipped directory).
	 * @return {object} An object of shape `{ data, cells, properties }`. `data: string[][]` is an array of rows, each row being an array of cell values. `cells: string[][]` is an array of rows, each row being an array of cells. `properties: object` is the spreadsheet properties (e.g. whether date epoch is 1904 instead of 1900).
	 */
	function readXlsx(contents, xml) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (!options.sheet) {
	    options = _objectSpread({
	      sheet: 1
	    }, options);
	  }
	
	  var getXmlFileContent = function getXmlFileContent(filePath) {
	    if (!contents[filePath]) {
	      throw new Error("\"".concat(filePath, "\" file not found inside the *.xlsx file zip archive"));
	    }
	
	    return contents[filePath];
	  }; // Some Excel editors don't want to use standard naming scheme for sheet files.
	  // https://github.com/tidyverse/readxl/issues/104
	
	
	  var filePaths = (0, _parseFilePaths["default"])(getXmlFileContent('xl/_rels/workbook.xml.rels'), xml); // Default file path for "shared strings": "xl/sharedStrings.xml".
	
	  var values = filePaths.sharedStrings ? (0, _parseSharedStrings["default"])(getXmlFileContent(filePaths.sharedStrings), xml) : []; // Default file path for "styles": "xl/styles.xml".
	
	  var styles = filePaths.styles ? (0, _parseStyles["default"])(getXmlFileContent(filePaths.styles), xml) : {};
	  var properties = (0, _parseProperties["default"])(getXmlFileContent('xl/workbook.xml'), xml); // A feature for getting the list of sheets in an Excel file.
	  // https://github.com/catamphetamine/read-excel-file/issues/14
	
	  if (options.getSheets) {
	    return properties.sheets.map(function (_ref) {
	      var name = _ref.name;
	      return {
	        name: name
	      };
	    });
	  } // Find the sheet by name, or take the first one.
	
	
	  var sheetId = getSheetId(options.sheet, properties.sheets); // If the sheet wasn't found then throw an error.
	  // Example: "xl/worksheets/sheet1.xml".
	
	  if (!sheetId || !filePaths.sheets[sheetId]) {
	    throw createSheetNotFoundError(options.sheet, properties.sheets);
	  } // Parse sheet data.
	
	
	  var sheet = (0, _parseSheet["default"])(getXmlFileContent(filePaths.sheets[sheetId]), xml, values, styles, properties, options); // Get spreadsheet data.
	
	  var data = (0, _getData["default"])(sheet, options); // Can return properties, if required.
	
	  if (options.properties) {
	    return {
	      data: data,
	      properties: properties
	    };
	  } // Return spreadsheet data.
	
	
	  return data;
	}
	
	function getSheetId(sheet, sheets) {
	  if (typeof sheet === 'number') {
	    var _sheet = sheets[sheet - 1];
	    return _sheet && _sheet.relationId;
	  }
	
	  for (var _iterator = _createForOfIteratorHelperLoose(sheets), _step; !(_step = _iterator()).done;) {
	    var _sheet2 = _step.value;
	
	    if (_sheet2.name === sheet) {
	      return _sheet2.relationId;
	    }
	  }
	}
	
	function createSheetNotFoundError(sheet, sheets) {
	  var sheetsList = sheets && sheets.map(function (sheet, i) {
	    return "\"".concat(sheet.name, "\" (#").concat(i + 1, ")");
	  }).join(', ');
	  return new Error("Sheet ".concat(typeof sheet === 'number' ? '#' + sheet : '"' + sheet + '"', " not found in the *.xlsx file.").concat(sheets ? ' Available sheets: ' + sheetsList + '.' : ''));
	}
	//# sourceMappingURL=readXlsx.js.map

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = readXlsxFileContents;
	
	var _readXlsx = _interopRequireDefault(__webpack_require__(1741));
	
	var _convertToJson = _interopRequireDefault(__webpack_require__(1744));
	
	var _convertMapToSchema = _interopRequireDefault(__webpack_require__(1743));
	
	var _excluded = ["schema", "map"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function readXlsxFileContents(entries, xml, _ref) {
	  var schema = _ref.schema,
	      map = _ref.map,
	      options = _objectWithoutProperties(_ref, _excluded);
	
	  if (!schema && map) {
	    schema = (0, _convertMapToSchema["default"])(map);
	  }
	
	  var result = (0, _readXlsx["default"])(entries, xml, _objectSpread(_objectSpread({}, options), {}, {
	    properties: schema || options.properties
	  }));
	
	  if (schema) {
	    return (0, _convertToJson["default"])(result.data, schema, _objectSpread(_objectSpread({}, options), {}, {
	      properties: result.properties
	    }));
	  }
	
	  return result;
	}
	//# sourceMappingURL=readXlsxFileContents.js.map

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = convertMapToSchema;
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function convertMapToSchema(map) {
	  var schema = {};
	
	  for (var _i = 0, _Object$keys = Object.keys(map); _i < _Object$keys.length; _i++) {
	    var key = _Object$keys[_i];
	    var prop = map[key];
	    var type = void 0;
	
	    if (_typeof(prop) === 'object') {
	      prop = Object.keys(map[key])[0];
	      type = convertMapToSchema(map[key][prop]);
	    }
	
	    schema[key] = {
	      prop: prop
	    };
	
	    if (type) {
	      schema[key].type = type;
	    }
	  }
	
	  return schema;
	}
	//# sourceMappingURL=convertMapToSchema.js.map

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	exports.getBlock = getBlock;
	exports.parseArray = parseArray;
	exports.parseValue = parseValue;
	
	var _Number = _interopRequireDefault(__webpack_require__(370));
	
	var _String = _interopRequireDefault(__webpack_require__(1750));
	
	var _Boolean = _interopRequireDefault(__webpack_require__(1746));
	
	var _Date = _interopRequireDefault(__webpack_require__(1747));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DEFAULT_OPTIONS = {
	  isColumnOriented: false
	};
	/**
	 * Convert 2D array to nested objects.
	 * If row oriented data, row 0 is dotted key names.
	 * Column oriented data is transposed.
	 * @param {any[][]} data - An array of rows, each row being an array of cells.
	 * @param {object} schema
	 * @return {object[]}
	 */
	
	function _default(data, schema, options) {
	  if (options) {
	    options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
	  } else {
	    options = DEFAULT_OPTIONS;
	  }
	
	  var _options = options,
	      isColumnOriented = _options.isColumnOriented,
	      rowMap = _options.rowMap,
	      ignoreEmptyRows = _options.ignoreEmptyRows;
	  validateSchema(schema);
	
	  if (isColumnOriented) {
	    data = transpose(data);
	  }
	
	  var columns = data[0];
	  var results = [];
	  var errors = [];
	
	  for (var i = 1; i < data.length; i++) {
	    var result = read(schema, data[i], i, columns, errors, options);
	
	    if (result !== null || ignoreEmptyRows === false) {
	      results.push(result);
	    }
	  } // Correct error rows.
	
	
	  if (rowMap) {
	    for (var _iterator = _createForOfIteratorHelperLoose(errors), _step; !(_step = _iterator()).done;) {
	      var error = _step.value;
	      // Convert the `row` index in `data` to the
	      // actual `row` index in the spreadsheet.
	      // `- 1` converts row number to row index.
	      // `+ 1` converts row index to row number.
	      error.row = rowMap[error.row - 1] + 1;
	    }
	  }
	
	  return {
	    rows: results,
	    errors: errors
	  };
	}
	
	function read(schema, row, rowIndex, columns, errors, options) {
	  var object = {};
	  var isEmptyObject = true;
	
	  var createError = function createError(_ref) {
	    var column = _ref.column,
	        value = _ref.value,
	        errorMessage = _ref.error,
	        reason = _ref.reason;
	    var error = {
	      error: errorMessage,
	      row: rowIndex + 1,
	      column: column,
	      value: value
	    };
	
	    if (reason) {
	      error.reason = reason;
	    }
	
	    if (schema[column].type) {
	      error.type = schema[column].type;
	    }
	
	    return error;
	  };
	
	  var pendingRequiredChecks = [];
	
	  var _loop = function _loop() {
	    var key = _Object$keys[_i];
	    var schemaEntry = schema[key];
	    var isNestedSchema = _typeof(schemaEntry.type) === 'object' && !Array.isArray(schemaEntry.type);
	    var rawValue = row[columns.indexOf(key)];
	
	    if (rawValue === undefined) {
	      rawValue = null;
	    }
	
	    var value = void 0;
	    var error = void 0;
	    var reason = void 0;
	
	    if (isNestedSchema) {
	      value = read(schemaEntry.type, row, rowIndex, columns, errors, options);
	    } else {
	      if (rawValue === null) {
	        value = null;
	      } else if (Array.isArray(schemaEntry.type)) {
	        var notEmpty = false;
	        var array = parseArray(rawValue).map(function (_value) {
	          var result = parseValue(_value, schemaEntry, options);
	
	          if (result.error) {
	            value = _value;
	            error = result.error;
	            reason = result.reason;
	          }
	
	          if (result.value !== null) {
	            notEmpty = true;
	          }
	
	          return result.value;
	        });
	
	        if (!error) {
	          value = notEmpty ? array : null;
	        }
	      } else {
	        var result = parseValue(rawValue, schemaEntry, options);
	        error = result.error;
	        reason = result.reason;
	        value = error ? rawValue : result.value;
	      }
	    }
	
	    if (!error && value === null) {
	      if (typeof schemaEntry.required === 'function') {
	        pendingRequiredChecks.push({
	          column: key
	        });
	      } else if (schemaEntry.required === true) {
	        error = 'required';
	      }
	    }
	
	    if (error) {
	      errors.push(createError({
	        column: key,
	        value: value,
	        error: error,
	        reason: reason
	      }));
	    } else {
	      if (isEmptyObject && value !== null) {
	        isEmptyObject = false;
	      }
	
	      if (value !== null || options.includeNullValues) {
	        object[schemaEntry.prop] = value;
	      }
	    }
	  };
	
	  for (var _i = 0, _Object$keys = Object.keys(schema); _i < _Object$keys.length; _i++) {
	    _loop();
	  }
	
	  if (isEmptyObject) {
	    return null;
	  }
	
	  for (var _i2 = 0, _pendingRequiredCheck = pendingRequiredChecks; _i2 < _pendingRequiredCheck.length; _i2++) {
	    var column = _pendingRequiredCheck[_i2].column;
	    var required = schema[column].required(object);
	
	    if (required) {
	      errors.push(createError({
	        column: column,
	        value: null,
	        error: 'required'
	      }));
	    }
	  }
	
	  return object;
	}
	/**
	 * Converts textual value to a javascript typed value.
	 * @param  {any} value
	 * @param  {object} schemaEntry
	 * @return {{ value: any, error: string }}
	 */
	
	
	function parseValue(value, schemaEntry, options) {
	  if (value === null) {
	    return {
	      value: null
	    };
	  }
	
	  var result;
	
	  if (schemaEntry.parse) {
	    result = parseCustomValue(value, schemaEntry.parse);
	  } else if (schemaEntry.type) {
	    result = parseValueOfType(value, // Supports parsing array types.
	    // See `parseArray()` function for more details.
	    // Example `type`: String[]
	    // Input: 'Barack Obama, "String, with, colons", Donald Trump'
	    // Output: ['Barack Obama', 'String, with, colons', 'Donald Trump']
	    Array.isArray(schemaEntry.type) ? schemaEntry.type[0] : schemaEntry.type, options);
	  } else {
	    result = {
	      value: value
	    }; // throw new Error('Invalid schema entry: no .type and no .parse():\n\n' + JSON.stringify(schemaEntry, null, 2))
	  } // If errored then return the error.
	
	
	  if (result.error) {
	    return result;
	  }
	
	  if (result.value !== null) {
	    if (schemaEntry.oneOf && schemaEntry.oneOf.indexOf(result.value) < 0) {
	      return {
	        error: 'invalid',
	        reason: 'unknown'
	      };
	    }
	
	    if (schemaEntry.validate) {
	      try {
	        schemaEntry.validate(result.value);
	      } catch (error) {
	        return {
	          error: error.message
	        };
	      }
	    }
	  }
	
	  return result;
	}
	/**
	 * Converts textual value to a custom value using supplied `.parse()`.
	 * @param  {any} value
	 * @param  {function} parse
	 * @return {{ value: any, error: string }}
	 */
	
	
	function parseCustomValue(value, parse) {
	  try {
	    value = parse(value);
	
	    if (value === undefined) {
	      return {
	        value: null
	      };
	    }
	
	    return {
	      value: value
	    };
	  } catch (error) {
	    var result = {
	      error: error.message
	    };
	
	    if (error.reason) {
	      result.reason = error.reason;
	    }
	
	    return result;
	  }
	}
	/**
	 * Converts textual value to a javascript typed value.
	 * @param  {any} value
	 * @param  {} type
	 * @return {{ value: (string|number|Date|boolean), error: string, reason?: string }}
	 */
	
	
	function parseValueOfType(value, type, options) {
	  switch (type) {
	    case String:
	      return parseCustomValue(value, _String["default"]);
	
	    case Number:
	      return parseCustomValue(value, _Number["default"]);
	
	    case Date:
	      return parseCustomValue(value, function (value) {
	        return (0, _Date["default"])(value, {
	          properties: options.properties
	        });
	      });
	
	    case Boolean:
	      return parseCustomValue(value, _Boolean["default"]);
	
	    default:
	      if (typeof type === 'function') {
	        return parseCustomValue(value, type);
	      }
	
	      throw new Error("Unsupported schema type: ".concat(type && type.name || type));
	  }
	}
	
	function getBlock(string, endCharacter, startIndex) {
	  var i = 0;
	  var substring = '';
	  var character;
	
	  while (startIndex + i < string.length) {
	    var _character = string[startIndex + i];
	
	    if (_character === endCharacter) {
	      return [substring, i];
	    } else if (_character === '"') {
	      var block = getBlock(string, '"', startIndex + i + 1);
	      substring += block[0];
	      i += '"'.length + block[1] + '"'.length;
	    } else {
	      substring += _character;
	      i++;
	    }
	  }
	
	  return [substring, i];
	}
	/**
	 * Parses a string of comma-separated substrings into an array of substrings.
	 * (the `export` is just for tests)
	 * @param  {string} string — A string of comma-separated substrings.
	 * @return {string[]} An array of substrings.
	 */
	
	
	function parseArray(string) {
	  var blocks = [];
	  var index = 0;
	
	  while (index < string.length) {
	    var _getBlock = getBlock(string, ',', index),
	        _getBlock2 = _slicedToArray(_getBlock, 2),
	        substring = _getBlock2[0],
	        length = _getBlock2[1];
	
	    index += length + ','.length;
	    blocks.push(substring.trim());
	  }
	
	  return blocks;
	} // Transpose a 2D array.
	// https://stackoverflow.com/questions/17428587/transposing-a-2d-array-in-javascript
	
	
	var transpose = function transpose(array) {
	  return array[0].map(function (_, i) {
	    return array.map(function (row) {
	      return row[i];
	    });
	  });
	};
	
	function validateSchema(schema) {
	  for (var _i3 = 0, _Object$keys2 = Object.keys(schema); _i3 < _Object$keys2.length; _i3++) {
	    var key = _Object$keys2[_i3];
	    var entry = schema[key];
	
	    if (!entry.prop) {
	      throw new Error("\"prop\" not defined for schema entry \"".concat(key, "\"."));
	    }
	  }
	}
	//# sourceMappingURL=convertToJson.js.map

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = unpackXlsxFile;
	
	var _fflate = __webpack_require__(1706);
	
	/**
	 * Reads XLSX file in a browser.
	 * @param  {(File|Blob|ArrayBuffer)} input - A `File` or an `ArrayBuffer`.
	 * @return {Promise} Resolves to an object holding XLSX file entries.
	 */
	function unpackXlsxFile(input) {
	  if (input instanceof File) {
	    return input.arrayBuffer().then(unpackXlsxArrayBuffer);
	  }
	
	  if (input instanceof Blob) {
	    return input.arrayBuffer().then(unpackXlsxArrayBuffer);
	  }
	
	  return unpackXlsxArrayBuffer(input);
	}
	/**
	 * Reads XLSX file in a browser from an `ArrayBuffer`.
	 * @param  {ArrayBuffer} input
	 * @return {Promise} Resolves to an object holding XLSX file entries.
	 */
	
	
	function unpackXlsxArrayBuffer(arrayBuffer) {
	  var archive = new Uint8Array(arrayBuffer);
	  var contents = (0, _fflate.unzipSync)(archive);
	  return Promise.resolve(getContents(contents)); // return new Promise((resolve, reject) => {
	  // 	unzip(archive, (error, contents) => {
	  // 		if (error) {
	  // 			return reject(error)
	  // 		}
	  // 		return resolve(getContents(contents))
	  // 	})
	  // })
	}
	
	function getContents(contents) {
	  var unzippedFiles = [];
	
	  for (var _i = 0, _Object$keys = Object.keys(contents); _i < _Object$keys.length; _i++) {
	    var key = _Object$keys[_i];
	    unzippedFiles[key] = (0, _fflate.strFromU8)(contents[key]);
	  }
	
	  return unzippedFiles;
	}
	//# sourceMappingURL=unpackXlsxFileBrowser.js.map

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = BooleanType;
	
	var _InvalidError = _interopRequireDefault(__webpack_require__(69));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function BooleanType(value) {
	  if (typeof value === 'boolean') {
	    return value;
	  }
	
	  throw new _InvalidError["default"]('not_a_boolean');
	}
	//# sourceMappingURL=Boolean.js.map

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = DateType;
	
	var _parseDate = _interopRequireDefault(__webpack_require__(166));
	
	var _InvalidError = _interopRequireDefault(__webpack_require__(69));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function DateType(value, _ref) {
	  var properties = _ref.properties;
	
	  // XLSX has no specific format for dates.
	  // Sometimes a date can be heuristically detected.
	  // https://github.com/catamphetamine/read-excel-file/issues/3#issuecomment-395770777
	  if (value instanceof Date) {
	    if (isNaN(value.valueOf())) {
	      throw new _InvalidError["default"]('out_of_bounds');
	    }
	
	    return value;
	  }
	
	  if (typeof value === 'number') {
	    if (isNaN(value)) {
	      throw new _InvalidError["default"]('invalid_number');
	    }
	
	    if (!isFinite(value)) {
	      throw new _InvalidError["default"]('out_of_bounds');
	    }
	
	    var date = (0, _parseDate["default"])(value, properties);
	
	    if (isNaN(date.valueOf())) {
	      throw new _InvalidError["default"]('out_of_bounds');
	    }
	
	    return date;
	  }
	
	  throw new _InvalidError["default"]('not_a_date');
	}
	//# sourceMappingURL=Date.js.map

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Email;
	exports.isEmail = isEmail;
	
	var _InvalidError = _interopRequireDefault(__webpack_require__(69));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function Email(value) {
	  if (typeof value === 'string') {
	    if (isEmail(value)) {
	      return value;
	    }
	
	    throw new _InvalidError["default"]('not_an_email');
	  }
	
	  throw new _InvalidError["default"]('not_a_string');
	}
	
	var regexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
	
	function isEmail(value) {
	  return regexp.test(value);
	}
	//# sourceMappingURL=Email.js.map

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Integer;
	exports.isInteger = isInteger;
	
	var _InvalidError = _interopRequireDefault(__webpack_require__(69));
	
	var _Number = _interopRequireDefault(__webpack_require__(370));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function Integer(value) {
	  value = (0, _Number["default"])(value);
	
	  if (!isInteger(value)) {
	    throw new _InvalidError["default"]('not_an_integer');
	  }
	
	  return value;
	}
	
	function isInteger(x) {
	  // https://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript
	  return (x | 0) === x;
	}
	//# sourceMappingURL=Integer.js.map

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = StringType;
	
	var _InvalidError = _interopRequireDefault(__webpack_require__(69));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function StringType(value) {
	  if (typeof value === 'string') {
	    return value;
	  } // Excel tends to perform a forced automatic convertion of string-type values
	  // to number-type ones when the user has input them. Otherwise, users wouldn't
	  // be able to perform formula calculations on those cell values because users
	  // won't bother manually choosing a "numeric" cell type for each cell, and
	  // even if they did, choosing a "numeric" cell type every time wouldn't be an
	  // acceptable "user experience".
	  //
	  // So, if a cell value is supposed to be a string and Excel has automatically
	  // converted it to a number, perform a backwards conversion.
	  //
	
	
	  if (typeof value === 'number') {
	    if (isNaN(value)) {
	      throw new _InvalidError["default"]('invalid_number');
	    } // The global `isFinite()` function filters out:
	    // * NaN
	    // * -Infinity
	    // * Infinity
	    //
	    // All other values pass (including non-numbers).
	    //
	
	
	    if (!isFinite(value)) {
	      throw new _InvalidError["default"]('out_of_bounds');
	    }
	
	    return String(value);
	  }
	
	  throw new _InvalidError["default"]('not_a_string');
	}
	//# sourceMappingURL=String.js.map

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = URL;
	exports.isURL = isURL;
	
	var _InvalidError = _interopRequireDefault(__webpack_require__(69));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function URL(value) {
	  if (typeof value === 'string') {
	    if (isURL(value)) {
	      return value;
	    }
	
	    throw new _InvalidError["default"]('not_a_url');
	  }
	
	  throw new _InvalidError["default"]('not_a_string');
	} // URL regexp explanation:
	//
	// /^
	//
	// 	(?:
	// 	  // Matches optional "http(s):" or "ftp:":
	// 		(?:
	// 			(?:https?|ftp):
	// 		)?
	//
	// 	  // Matches "//" (required):
	// 		\/\/
	// 	)
	//
	// 	// Matches a valid non-local IP address:
	// 	(?:
	// 		(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])
	// 		(?:
	// 			\.
	// 			(?:1?\d{1,2}|2[0-4]\d|25[0-5])
	// 		){2}
	// 		(?:
	// 			\.
	// 			(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4])
	// 		)
	//
	// 	  // Or,
	// 		|
	//
	// 	  // Matches an alpha-numeric domain name.
	// 		(?:
	// 			(?:
	// 				[a-z0-9\u00a1-\uffff]
	// 				[a-z0-9\u00a1-\uffff_-]{0,62}
	// 			)?
	// 			[a-z0-9\u00a1-\uffff]
	// 			\.
	// 		)*
	// 		(?:
	// 	    // Domain zone: "com", "net", etc (required):
	// 			[a-z\u00a1-\uffff]{2,}
	// 		)
	// 	)
	//
	// 	// Matches a colon and a port number:
	// 	(?::\d{2,5})?
	//
	// 	// Matches everything after the "origin":
	// 	// * pathname
	// 	// * query
	// 	// * hash
	// 	(?:[/?#]\S*)?
	//
	// $/i
	
	
	var regexp = /^(?:(?:(?:https?|ftp):)?\/\/)(?:(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)*(?:[a-z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:[/?#]\S*)?$/i; // https://stackoverflow.com/questions/8667070/javascript-regular-expression-to-validate-url
	
	function isURL(value) {
	  return regexp.test(value);
	}
	//# sourceMappingURL=URL.js.map

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _default = {
	  createDocument: function createDocument(content) {
	    // if (!content) {
	    // 	throw new Error('No *.xml content')
	    // }
	    // A weird bug: it won't parse XML unless it's trimmed.
	    // https://github.com/catamphetamine/read-excel-file/issues/21
	    return new DOMParser().parseFromString(content.trim(), 'text/xml');
	  }
	};
	exports["default"] = _default;
	//# sourceMappingURL=xmlBrowser.js.map

/***/ }),
/* 1753 */,
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(71);


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(373);
	
	/*<replacement>*/
	var util = __webpack_require__(90);
	util.inherits = __webpack_require__(41);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(46).Buffer;
	/*</replacement>*/
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(169).PassThrough


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(169).Transform


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(168);


/***/ }),
/* 1760 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(32)))

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(9).Buffer
	var Hash   = __webpack_require__(1763)(Buffer)
	
	exports.sha1 = __webpack_require__(1765)(Buffer, Hash)
	exports.sha256 = __webpack_require__(1766)(Buffer, Hash)
	exports.sha512 = __webpack_require__(1767)(Buffer, Hash)


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(53).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(53).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(53).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	/**!
	 * Sortable 1.10.2
	 * @author	RubaXa   <trash@rubaxa.org>
	 * @author	owenm    <owen23355@gmail.com>
	 * @license MIT
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.Sortable = factory());
	}(this, function () { 'use strict';
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _extends() {
	    _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  function _objectSpread(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	      var ownKeys = Object.keys(source);
	
	      if (typeof Object.getOwnPropertySymbols === 'function') {
	        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	        }));
	      }
	
	      ownKeys.forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    }
	
	    return target;
	  }
	
	  function _objectWithoutPropertiesLoose(source, excluded) {
	    if (source == null) return {};
	    var target = {};
	    var sourceKeys = Object.keys(source);
	    var key, i;
	
	    for (i = 0; i < sourceKeys.length; i++) {
	      key = sourceKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      target[key] = source[key];
	    }
	
	    return target;
	  }
	
	  function _objectWithoutProperties(source, excluded) {
	    if (source == null) return {};
	
	    var target = _objectWithoutPropertiesLoose(source, excluded);
	
	    var key, i;
	
	    if (Object.getOwnPropertySymbols) {
	      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	      for (i = 0; i < sourceSymbolKeys.length; i++) {
	        key = sourceSymbolKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	        target[key] = source[key];
	      }
	    }
	
	    return target;
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) {
	      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	      return arr2;
	    }
	  }
	
	  function _iterableToArray(iter) {
	    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance");
	  }
	
	  var version = "1.10.2";
	
	  function userAgent(pattern) {
	    if (typeof window !== 'undefined' && window.navigator) {
	      return !!
	      /*@__PURE__*/
	      navigator.userAgent.match(pattern);
	    }
	  }
	
	  var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
	  var Edge = userAgent(/Edge/i);
	  var FireFox = userAgent(/firefox/i);
	  var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
	  var IOS = userAgent(/iP(ad|od|hone)/i);
	  var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
	
	  var captureMode = {
	    capture: false,
	    passive: false
	  };
	
	  function on(el, event, fn) {
	    el.addEventListener(event, fn, !IE11OrLess && captureMode);
	  }
	
	  function off(el, event, fn) {
	    el.removeEventListener(event, fn, !IE11OrLess && captureMode);
	  }
	
	  function matches(
	  /**HTMLElement*/
	  el,
	  /**String*/
	  selector) {
	    if (!selector) return;
	    selector[0] === '>' && (selector = selector.substring(1));
	
	    if (el) {
	      try {
	        if (el.matches) {
	          return el.matches(selector);
	        } else if (el.msMatchesSelector) {
	          return el.msMatchesSelector(selector);
	        } else if (el.webkitMatchesSelector) {
	          return el.webkitMatchesSelector(selector);
	        }
	      } catch (_) {
	        return false;
	      }
	    }
	
	    return false;
	  }
	
	  function getParentOrHost(el) {
	    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
	  }
	
	  function closest(
	  /**HTMLElement*/
	  el,
	  /**String*/
	  selector,
	  /**HTMLElement*/
	  ctx, includeCTX) {
	    if (el) {
	      ctx = ctx || document;
	
	      do {
	        if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
	          return el;
	        }
	
	        if (el === ctx) break;
	        /* jshint boss:true */
	      } while (el = getParentOrHost(el));
	    }
	
	    return null;
	  }
	
	  var R_SPACE = /\s+/g;
	
	  function toggleClass(el, name, state) {
	    if (el && name) {
	      if (el.classList) {
	        el.classList[state ? 'add' : 'remove'](name);
	      } else {
	        var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
	        el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
	      }
	    }
	  }
	
	  function css(el, prop, val) {
	    var style = el && el.style;
	
	    if (style) {
	      if (val === void 0) {
	        if (document.defaultView && document.defaultView.getComputedStyle) {
	          val = document.defaultView.getComputedStyle(el, '');
	        } else if (el.currentStyle) {
	          val = el.currentStyle;
	        }
	
	        return prop === void 0 ? val : val[prop];
	      } else {
	        if (!(prop in style) && prop.indexOf('webkit') === -1) {
	          prop = '-webkit-' + prop;
	        }
	
	        style[prop] = val + (typeof val === 'string' ? '' : 'px');
	      }
	    }
	  }
	
	  function matrix(el, selfOnly) {
	    var appliedTransforms = '';
	
	    if (typeof el === 'string') {
	      appliedTransforms = el;
	    } else {
	      do {
	        var transform = css(el, 'transform');
	
	        if (transform && transform !== 'none') {
	          appliedTransforms = transform + ' ' + appliedTransforms;
	        }
	        /* jshint boss:true */
	
	      } while (!selfOnly && (el = el.parentNode));
	    }
	
	    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
	    /*jshint -W056 */
	
	    return matrixFn && new matrixFn(appliedTransforms);
	  }
	
	  function find(ctx, tagName, iterator) {
	    if (ctx) {
	      var list = ctx.getElementsByTagName(tagName),
	          i = 0,
	          n = list.length;
	
	      if (iterator) {
	        for (; i < n; i++) {
	          iterator(list[i], i);
	        }
	      }
	
	      return list;
	    }
	
	    return [];
	  }
	
	  function getWindowScrollingElement() {
	    var scrollingElement = document.scrollingElement;
	
	    if (scrollingElement) {
	      return scrollingElement;
	    } else {
	      return document.documentElement;
	    }
	  }
	  /**
	   * Returns the "bounding client rect" of given element
	   * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
	   * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
	   * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
	   * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
	   * @param  {[HTMLElement]} container              The parent the element will be placed in
	   * @return {Object}                               The boundingClientRect of el, with specified adjustments
	   */
	
	
	  function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
	    if (!el.getBoundingClientRect && el !== window) return;
	    var elRect, top, left, bottom, right, height, width;
	
	    if (el !== window && el !== getWindowScrollingElement()) {
	      elRect = el.getBoundingClientRect();
	      top = elRect.top;
	      left = elRect.left;
	      bottom = elRect.bottom;
	      right = elRect.right;
	      height = elRect.height;
	      width = elRect.width;
	    } else {
	      top = 0;
	      left = 0;
	      bottom = window.innerHeight;
	      right = window.innerWidth;
	      height = window.innerHeight;
	      width = window.innerWidth;
	    }
	
	    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
	      // Adjust for translate()
	      container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
	      // Not needed on <= IE11
	
	      if (!IE11OrLess) {
	        do {
	          if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
	            var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container
	
	            top -= containerRect.top + parseInt(css(container, 'border-top-width'));
	            left -= containerRect.left + parseInt(css(container, 'border-left-width'));
	            bottom = top + elRect.height;
	            right = left + elRect.width;
	            break;
	          }
	          /* jshint boss:true */
	
	        } while (container = container.parentNode);
	      }
	    }
	
	    if (undoScale && el !== window) {
	      // Adjust for scale()
	      var elMatrix = matrix(container || el),
	          scaleX = elMatrix && elMatrix.a,
	          scaleY = elMatrix && elMatrix.d;
	
	      if (elMatrix) {
	        top /= scaleY;
	        left /= scaleX;
	        width /= scaleX;
	        height /= scaleY;
	        bottom = top + height;
	        right = left + width;
	      }
	    }
	
	    return {
	      top: top,
	      left: left,
	      bottom: bottom,
	      right: right,
	      width: width,
	      height: height
	    };
	  }
	  /**
	   * Checks if a side of an element is scrolled past a side of its parents
	   * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
	   * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
	   * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
	   * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
	   */
	
	
	  function isScrolledPast(el, elSide, parentSide) {
	    var parent = getParentAutoScrollElement(el, true),
	        elSideVal = getRect(el)[elSide];
	    /* jshint boss:true */
	
	    while (parent) {
	      var parentSideVal = getRect(parent)[parentSide],
	          visible = void 0;
	
	      if (parentSide === 'top' || parentSide === 'left') {
	        visible = elSideVal >= parentSideVal;
	      } else {
	        visible = elSideVal <= parentSideVal;
	      }
	
	      if (!visible) return parent;
	      if (parent === getWindowScrollingElement()) break;
	      parent = getParentAutoScrollElement(parent, false);
	    }
	
	    return false;
	  }
	  /**
	   * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
	   * and non-draggable elements
	   * @param  {HTMLElement} el       The parent element
	   * @param  {Number} childNum      The index of the child
	   * @param  {Object} options       Parent Sortable's options
	   * @return {HTMLElement}          The child at index childNum, or null if not found
	   */
	
	
	  function getChild(el, childNum, options) {
	    var currentChild = 0,
	        i = 0,
	        children = el.children;
	
	    while (i < children.length) {
	      if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
	        if (currentChild === childNum) {
	          return children[i];
	        }
	
	        currentChild++;
	      }
	
	      i++;
	    }
	
	    return null;
	  }
	  /**
	   * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
	   * @param  {HTMLElement} el       Parent element
	   * @param  {selector} selector    Any other elements that should be ignored
	   * @return {HTMLElement}          The last child, ignoring ghostEl
	   */
	
	
	  function lastChild(el, selector) {
	    var last = el.lastElementChild;
	
	    while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
	      last = last.previousElementSibling;
	    }
	
	    return last || null;
	  }
	  /**
	   * Returns the index of an element within its parent for a selected set of
	   * elements
	   * @param  {HTMLElement} el
	   * @param  {selector} selector
	   * @return {number}
	   */
	
	
	  function index(el, selector) {
	    var index = 0;
	
	    if (!el || !el.parentNode) {
	      return -1;
	    }
	    /* jshint boss:true */
	
	
	    while (el = el.previousElementSibling) {
	      if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
	        index++;
	      }
	    }
	
	    return index;
	  }
	  /**
	   * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
	   * The value is returned in real pixels.
	   * @param  {HTMLElement} el
	   * @return {Array}             Offsets in the format of [left, top]
	   */
	
	
	  function getRelativeScrollOffset(el) {
	    var offsetLeft = 0,
	        offsetTop = 0,
	        winScroller = getWindowScrollingElement();
	
	    if (el) {
	      do {
	        var elMatrix = matrix(el),
	            scaleX = elMatrix.a,
	            scaleY = elMatrix.d;
	        offsetLeft += el.scrollLeft * scaleX;
	        offsetTop += el.scrollTop * scaleY;
	      } while (el !== winScroller && (el = el.parentNode));
	    }
	
	    return [offsetLeft, offsetTop];
	  }
	  /**
	   * Returns the index of the object within the given array
	   * @param  {Array} arr   Array that may or may not hold the object
	   * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
	   * @return {Number}      The index of the object in the array, or -1
	   */
	
	
	  function indexOfObject(arr, obj) {
	    for (var i in arr) {
	      if (!arr.hasOwnProperty(i)) continue;
	
	      for (var key in obj) {
	        if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
	      }
	    }
	
	    return -1;
	  }
	
	  function getParentAutoScrollElement(el, includeSelf) {
	    // skip to window
	    if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
	    var elem = el;
	    var gotSelf = false;
	
	    do {
	      // we don't need to get elem css if it isn't even overflowing in the first place (performance)
	      if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
	        var elemCSS = css(elem);
	
	        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
	          if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
	          if (gotSelf || includeSelf) return elem;
	          gotSelf = true;
	        }
	      }
	      /* jshint boss:true */
	
	    } while (elem = elem.parentNode);
	
	    return getWindowScrollingElement();
	  }
	
	  function extend(dst, src) {
	    if (dst && src) {
	      for (var key in src) {
	        if (src.hasOwnProperty(key)) {
	          dst[key] = src[key];
	        }
	      }
	    }
	
	    return dst;
	  }
	
	  function isRectEqual(rect1, rect2) {
	    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
	  }
	
	  var _throttleTimeout;
	
	  function throttle(callback, ms) {
	    return function () {
	      if (!_throttleTimeout) {
	        var args = arguments,
	            _this = this;
	
	        if (args.length === 1) {
	          callback.call(_this, args[0]);
	        } else {
	          callback.apply(_this, args);
	        }
	
	        _throttleTimeout = setTimeout(function () {
	          _throttleTimeout = void 0;
	        }, ms);
	      }
	    };
	  }
	
	  function cancelThrottle() {
	    clearTimeout(_throttleTimeout);
	    _throttleTimeout = void 0;
	  }
	
	  function scrollBy(el, x, y) {
	    el.scrollLeft += x;
	    el.scrollTop += y;
	  }
	
	  function clone(el) {
	    var Polymer = window.Polymer;
	    var $ = window.jQuery || window.Zepto;
	
	    if (Polymer && Polymer.dom) {
	      return Polymer.dom(el).cloneNode(true);
	    } else if ($) {
	      return $(el).clone(true)[0];
	    } else {
	      return el.cloneNode(true);
	    }
	  }
	
	  function setRect(el, rect) {
	    css(el, 'position', 'absolute');
	    css(el, 'top', rect.top);
	    css(el, 'left', rect.left);
	    css(el, 'width', rect.width);
	    css(el, 'height', rect.height);
	  }
	
	  function unsetRect(el) {
	    css(el, 'position', '');
	    css(el, 'top', '');
	    css(el, 'left', '');
	    css(el, 'width', '');
	    css(el, 'height', '');
	  }
	
	  var expando = 'Sortable' + new Date().getTime();
	
	  function AnimationStateManager() {
	    var animationStates = [],
	        animationCallbackId;
	    return {
	      captureAnimationState: function captureAnimationState() {
	        animationStates = [];
	        if (!this.options.animation) return;
	        var children = [].slice.call(this.el.children);
	        children.forEach(function (child) {
	          if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
	          animationStates.push({
	            target: child,
	            rect: getRect(child)
	          });
	
	          var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation
	
	
	          if (child.thisAnimationDuration) {
	            var childMatrix = matrix(child, true);
	
	            if (childMatrix) {
	              fromRect.top -= childMatrix.f;
	              fromRect.left -= childMatrix.e;
	            }
	          }
	
	          child.fromRect = fromRect;
	        });
	      },
	      addAnimationState: function addAnimationState(state) {
	        animationStates.push(state);
	      },
	      removeAnimationState: function removeAnimationState(target) {
	        animationStates.splice(indexOfObject(animationStates, {
	          target: target
	        }), 1);
	      },
	      animateAll: function animateAll(callback) {
	        var _this = this;
	
	        if (!this.options.animation) {
	          clearTimeout(animationCallbackId);
	          if (typeof callback === 'function') callback();
	          return;
	        }
	
	        var animating = false,
	            animationTime = 0;
	        animationStates.forEach(function (state) {
	          var time = 0,
	              target = state.target,
	              fromRect = target.fromRect,
	              toRect = getRect(target),
	              prevFromRect = target.prevFromRect,
	              prevToRect = target.prevToRect,
	              animatingRect = state.rect,
	              targetMatrix = matrix(target, true);
	
	          if (targetMatrix) {
	            // Compensate for current animation
	            toRect.top -= targetMatrix.f;
	            toRect.left -= targetMatrix.e;
	          }
	
	          target.toRect = toRect;
	
	          if (target.thisAnimationDuration) {
	            // Could also check if animatingRect is between fromRect and toRect
	            if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
	            (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
	              // If returning to same place as started from animation and on same axis
	              time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
	            }
	          } // if fromRect != toRect: animate
	
	
	          if (!isRectEqual(toRect, fromRect)) {
	            target.prevFromRect = fromRect;
	            target.prevToRect = toRect;
	
	            if (!time) {
	              time = _this.options.animation;
	            }
	
	            _this.animate(target, animatingRect, toRect, time);
	          }
	
	          if (time) {
	            animating = true;
	            animationTime = Math.max(animationTime, time);
	            clearTimeout(target.animationResetTimer);
	            target.animationResetTimer = setTimeout(function () {
	              target.animationTime = 0;
	              target.prevFromRect = null;
	              target.fromRect = null;
	              target.prevToRect = null;
	              target.thisAnimationDuration = null;
	            }, time);
	            target.thisAnimationDuration = time;
	          }
	        });
	        clearTimeout(animationCallbackId);
	
	        if (!animating) {
	          if (typeof callback === 'function') callback();
	        } else {
	          animationCallbackId = setTimeout(function () {
	            if (typeof callback === 'function') callback();
	          }, animationTime);
	        }
	
	        animationStates = [];
	      },
	      animate: function animate(target, currentRect, toRect, duration) {
	        if (duration) {
	          css(target, 'transition', '');
	          css(target, 'transform', '');
	          var elMatrix = matrix(this.el),
	              scaleX = elMatrix && elMatrix.a,
	              scaleY = elMatrix && elMatrix.d,
	              translateX = (currentRect.left - toRect.left) / (scaleX || 1),
	              translateY = (currentRect.top - toRect.top) / (scaleY || 1);
	          target.animatingX = !!translateX;
	          target.animatingY = !!translateY;
	          css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
	          repaint(target); // repaint
	
	          css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
	          css(target, 'transform', 'translate3d(0,0,0)');
	          typeof target.animated === 'number' && clearTimeout(target.animated);
	          target.animated = setTimeout(function () {
	            css(target, 'transition', '');
	            css(target, 'transform', '');
	            target.animated = false;
	            target.animatingX = false;
	            target.animatingY = false;
	          }, duration);
	        }
	      }
	    };
	  }
	
	  function repaint(target) {
	    return target.offsetWidth;
	  }
	
	  function calculateRealTime(animatingRect, fromRect, toRect, options) {
	    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
	  }
	
	  var plugins = [];
	  var defaults = {
	    initializeByDefault: true
	  };
	  var PluginManager = {
	    mount: function mount(plugin) {
	      // Set default static properties
	      for (var option in defaults) {
	        if (defaults.hasOwnProperty(option) && !(option in plugin)) {
	          plugin[option] = defaults[option];
	        }
	      }
	
	      plugins.push(plugin);
	    },
	    pluginEvent: function pluginEvent(eventName, sortable, evt) {
	      var _this = this;
	
	      this.eventCanceled = false;
	
	      evt.cancel = function () {
	        _this.eventCanceled = true;
	      };
	
	      var eventNameGlobal = eventName + 'Global';
	      plugins.forEach(function (plugin) {
	        if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable
	
	        if (sortable[plugin.pluginName][eventNameGlobal]) {
	          sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
	            sortable: sortable
	          }, evt));
	        } // Only fire plugin event if plugin is enabled in this sortable,
	        // and plugin has event defined
	
	
	        if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
	          sortable[plugin.pluginName][eventName](_objectSpread({
	            sortable: sortable
	          }, evt));
	        }
	      });
	    },
	    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
	      plugins.forEach(function (plugin) {
	        var pluginName = plugin.pluginName;
	        if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
	        var initialized = new plugin(sortable, el, sortable.options);
	        initialized.sortable = sortable;
	        initialized.options = sortable.options;
	        sortable[pluginName] = initialized; // Add default options from plugin
	
	        _extends(defaults, initialized.defaults);
	      });
	
	      for (var option in sortable.options) {
	        if (!sortable.options.hasOwnProperty(option)) continue;
	        var modified = this.modifyOption(sortable, option, sortable.options[option]);
	
	        if (typeof modified !== 'undefined') {
	          sortable.options[option] = modified;
	        }
	      }
	    },
	    getEventProperties: function getEventProperties(name, sortable) {
	      var eventProperties = {};
	      plugins.forEach(function (plugin) {
	        if (typeof plugin.eventProperties !== 'function') return;
	
	        _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
	      });
	      return eventProperties;
	    },
	    modifyOption: function modifyOption(sortable, name, value) {
	      var modifiedValue;
	      plugins.forEach(function (plugin) {
	        // Plugin must exist on the Sortable
	        if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
	
	        if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
	          modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
	        }
	      });
	      return modifiedValue;
	    }
	  };
	
	  function dispatchEvent(_ref) {
	    var sortable = _ref.sortable,
	        rootEl = _ref.rootEl,
	        name = _ref.name,
	        targetEl = _ref.targetEl,
	        cloneEl = _ref.cloneEl,
	        toEl = _ref.toEl,
	        fromEl = _ref.fromEl,
	        oldIndex = _ref.oldIndex,
	        newIndex = _ref.newIndex,
	        oldDraggableIndex = _ref.oldDraggableIndex,
	        newDraggableIndex = _ref.newDraggableIndex,
	        originalEvent = _ref.originalEvent,
	        putSortable = _ref.putSortable,
	        extraEventProperties = _ref.extraEventProperties;
	    sortable = sortable || rootEl && rootEl[expando];
	    if (!sortable) return;
	    var evt,
	        options = sortable.options,
	        onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature
	
	    if (window.CustomEvent && !IE11OrLess && !Edge) {
	      evt = new CustomEvent(name, {
	        bubbles: true,
	        cancelable: true
	      });
	    } else {
	      evt = document.createEvent('Event');
	      evt.initEvent(name, true, true);
	    }
	
	    evt.to = toEl || rootEl;
	    evt.from = fromEl || rootEl;
	    evt.item = targetEl || rootEl;
	    evt.clone = cloneEl;
	    evt.oldIndex = oldIndex;
	    evt.newIndex = newIndex;
	    evt.oldDraggableIndex = oldDraggableIndex;
	    evt.newDraggableIndex = newDraggableIndex;
	    evt.originalEvent = originalEvent;
	    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
	
	    var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));
	
	    for (var option in allEventProperties) {
	      evt[option] = allEventProperties[option];
	    }
	
	    if (rootEl) {
	      rootEl.dispatchEvent(evt);
	    }
	
	    if (options[onName]) {
	      options[onName].call(sortable, evt);
	    }
	  }
	
	  var pluginEvent = function pluginEvent(eventName, sortable) {
	    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	        originalEvent = _ref.evt,
	        data = _objectWithoutProperties(_ref, ["evt"]);
	
	    PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
	      dragEl: dragEl,
	      parentEl: parentEl,
	      ghostEl: ghostEl,
	      rootEl: rootEl,
	      nextEl: nextEl,
	      lastDownEl: lastDownEl,
	      cloneEl: cloneEl,
	      cloneHidden: cloneHidden,
	      dragStarted: moved,
	      putSortable: putSortable,
	      activeSortable: Sortable.active,
	      originalEvent: originalEvent,
	      oldIndex: oldIndex,
	      oldDraggableIndex: oldDraggableIndex,
	      newIndex: newIndex,
	      newDraggableIndex: newDraggableIndex,
	      hideGhostForTarget: _hideGhostForTarget,
	      unhideGhostForTarget: _unhideGhostForTarget,
	      cloneNowHidden: function cloneNowHidden() {
	        cloneHidden = true;
	      },
	      cloneNowShown: function cloneNowShown() {
	        cloneHidden = false;
	      },
	      dispatchSortableEvent: function dispatchSortableEvent(name) {
	        _dispatchEvent({
	          sortable: sortable,
	          name: name,
	          originalEvent: originalEvent
	        });
	      }
	    }, data));
	  };
	
	  function _dispatchEvent(info) {
	    dispatchEvent(_objectSpread({
	      putSortable: putSortable,
	      cloneEl: cloneEl,
	      targetEl: dragEl,
	      rootEl: rootEl,
	      oldIndex: oldIndex,
	      oldDraggableIndex: oldDraggableIndex,
	      newIndex: newIndex,
	      newDraggableIndex: newDraggableIndex
	    }, info));
	  }
	
	  var dragEl,
	      parentEl,
	      ghostEl,
	      rootEl,
	      nextEl,
	      lastDownEl,
	      cloneEl,
	      cloneHidden,
	      oldIndex,
	      newIndex,
	      oldDraggableIndex,
	      newDraggableIndex,
	      activeGroup,
	      putSortable,
	      awaitingDragStarted = false,
	      ignoreNextClick = false,
	      sortables = [],
	      tapEvt,
	      touchEvt,
	      lastDx,
	      lastDy,
	      tapDistanceLeft,
	      tapDistanceTop,
	      moved,
	      lastTarget,
	      lastDirection,
	      pastFirstInvertThresh = false,
	      isCircumstantialInvert = false,
	      targetMoveDistance,
	      // For positioning ghost absolutely
	  ghostRelativeParent,
	      ghostRelativeParentInitialScroll = [],
	      // (left, top)
	  _silent = false,
	      savedInputChecked = [];
	  /** @const */
	
	  var documentExists = typeof document !== 'undefined',
	      PositionGhostAbsolutely = IOS,
	      CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
	      // This will not pass for IE9, because IE9 DnD only works on anchors
	  supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
	      supportCssPointerEvents = function () {
	    if (!documentExists) return; // false when <= IE11
	
	    if (IE11OrLess) {
	      return false;
	    }
	
	    var el = document.createElement('x');
	    el.style.cssText = 'pointer-events:auto';
	    return el.style.pointerEvents === 'auto';
	  }(),
	      _detectDirection = function _detectDirection(el, options) {
	    var elCSS = css(el),
	        elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
	        child1 = getChild(el, 0, options),
	        child2 = getChild(el, 1, options),
	        firstChildCSS = child1 && css(child1),
	        secondChildCSS = child2 && css(child2),
	        firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
	        secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
	
	    if (elCSS.display === 'flex') {
	      return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
	    }
	
	    if (elCSS.display === 'grid') {
	      return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
	    }
	
	    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
	      var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
	      return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
	    }
	
	    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
	  },
	      _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
	    var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
	        dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
	        dragElOppLength = vertical ? dragRect.width : dragRect.height,
	        targetS1Opp = vertical ? targetRect.left : targetRect.top,
	        targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
	        targetOppLength = vertical ? targetRect.width : targetRect.height;
	    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
	  },
	
	  /**
	   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
	   * @param  {Number} x      X position
	   * @param  {Number} y      Y position
	   * @return {HTMLElement}   Element of the first found nearest Sortable
	   */
	  _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
	    var ret;
	    sortables.some(function (sortable) {
	      if (lastChild(sortable)) return;
	      var rect = getRect(sortable),
	          threshold = sortable[expando].options.emptyInsertThreshold,
	          insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
	          insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
	
	      if (threshold && insideHorizontally && insideVertically) {
	        return ret = sortable;
	      }
	    });
	    return ret;
	  },
	      _prepareGroup = function _prepareGroup(options) {
	    function toFn(value, pull) {
	      return function (to, from, dragEl, evt) {
	        var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
	
	        if (value == null && (pull || sameGroup)) {
	          // Default pull value
	          // Default pull and put value if same group
	          return true;
	        } else if (value == null || value === false) {
	          return false;
	        } else if (pull && value === 'clone') {
	          return value;
	        } else if (typeof value === 'function') {
	          return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
	        } else {
	          var otherGroup = (pull ? to : from).options.group.name;
	          return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
	        }
	      };
	    }
	
	    var group = {};
	    var originalGroup = options.group;
	
	    if (!originalGroup || _typeof(originalGroup) != 'object') {
	      originalGroup = {
	        name: originalGroup
	      };
	    }
	
	    group.name = originalGroup.name;
	    group.checkPull = toFn(originalGroup.pull, true);
	    group.checkPut = toFn(originalGroup.put);
	    group.revertClone = originalGroup.revertClone;
	    options.group = group;
	  },
	      _hideGhostForTarget = function _hideGhostForTarget() {
	    if (!supportCssPointerEvents && ghostEl) {
	      css(ghostEl, 'display', 'none');
	    }
	  },
	      _unhideGhostForTarget = function _unhideGhostForTarget() {
	    if (!supportCssPointerEvents && ghostEl) {
	      css(ghostEl, 'display', '');
	    }
	  }; // #1184 fix - Prevent click event on fallback if dragged but item not changed position
	
	
	  if (documentExists) {
	    document.addEventListener('click', function (evt) {
	      if (ignoreNextClick) {
	        evt.preventDefault();
	        evt.stopPropagation && evt.stopPropagation();
	        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
	        ignoreNextClick = false;
	        return false;
	      }
	    }, true);
	  }
	
	  var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
	    if (dragEl) {
	      evt = evt.touches ? evt.touches[0] : evt;
	
	      var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
	
	      if (nearest) {
	        // Create imitation event
	        var event = {};
	
	        for (var i in evt) {
	          if (evt.hasOwnProperty(i)) {
	            event[i] = evt[i];
	          }
	        }
	
	        event.target = event.rootEl = nearest;
	        event.preventDefault = void 0;
	        event.stopPropagation = void 0;
	
	        nearest[expando]._onDragOver(event);
	      }
	    }
	  };
	
	  var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
	    if (dragEl) {
	      dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
	    }
	  };
	  /**
	   * @class  Sortable
	   * @param  {HTMLElement}  el
	   * @param  {Object}       [options]
	   */
	
	
	  function Sortable(el, options) {
	    if (!(el && el.nodeType && el.nodeType === 1)) {
	      throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
	    }
	
	    this.el = el; // root element
	
	    this.options = options = _extends({}, options); // Export instance
	
	    el[expando] = this;
	    var defaults = {
	      group: null,
	      sort: true,
	      disabled: false,
	      store: null,
	      handle: null,
	      draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
	      swapThreshold: 1,
	      // percentage; 0 <= x <= 1
	      invertSwap: false,
	      // invert always
	      invertedSwapThreshold: null,
	      // will be set to same as swapThreshold if default
	      removeCloneOnHide: true,
	      direction: function direction() {
	        return _detectDirection(el, this.options);
	      },
	      ghostClass: 'sortable-ghost',
	      chosenClass: 'sortable-chosen',
	      dragClass: 'sortable-drag',
	      ignore: 'a, img',
	      filter: null,
	      preventOnFilter: true,
	      animation: 0,
	      easing: null,
	      setData: function setData(dataTransfer, dragEl) {
	        dataTransfer.setData('Text', dragEl.textContent);
	      },
	      dropBubble: false,
	      dragoverBubble: false,
	      dataIdAttr: 'data-id',
	      delay: 0,
	      delayOnTouchOnly: false,
	      touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
	      forceFallback: false,
	      fallbackClass: 'sortable-fallback',
	      fallbackOnBody: false,
	      fallbackTolerance: 0,
	      fallbackOffset: {
	        x: 0,
	        y: 0
	      },
	      supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
	      emptyInsertThreshold: 5
	    };
	    PluginManager.initializePlugins(this, el, defaults); // Set default options
	
	    for (var name in defaults) {
	      !(name in options) && (options[name] = defaults[name]);
	    }
	
	    _prepareGroup(options); // Bind all private methods
	
	
	    for (var fn in this) {
	      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
	        this[fn] = this[fn].bind(this);
	      }
	    } // Setup drag mode
	
	
	    this.nativeDraggable = options.forceFallback ? false : supportDraggable;
	
	    if (this.nativeDraggable) {
	      // Touch start threshold cannot be greater than the native dragstart threshold
	      this.options.touchStartThreshold = 1;
	    } // Bind events
	
	
	    if (options.supportPointer) {
	      on(el, 'pointerdown', this._onTapStart);
	    } else {
	      on(el, 'mousedown', this._onTapStart);
	      on(el, 'touchstart', this._onTapStart);
	    }
	
	    if (this.nativeDraggable) {
	      on(el, 'dragover', this);
	      on(el, 'dragenter', this);
	    }
	
	    sortables.push(this.el); // Restore sorting
	
	    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager
	
	    _extends(this, AnimationStateManager());
	  }
	
	  Sortable.prototype =
	  /** @lends Sortable.prototype */
	  {
	    constructor: Sortable,
	    _isOutsideThisEl: function _isOutsideThisEl(target) {
	      if (!this.el.contains(target) && target !== this.el) {
	        lastTarget = null;
	      }
	    },
	    _getDirection: function _getDirection(evt, target) {
	      return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
	    },
	    _onTapStart: function _onTapStart(
	    /** Event|TouchEvent */
	    evt) {
	      if (!evt.cancelable) return;
	
	      var _this = this,
	          el = this.el,
	          options = this.options,
	          preventOnFilter = options.preventOnFilter,
	          type = evt.type,
	          touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
	          target = (touch || evt).target,
	          originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
	          filter = options.filter;
	
	      _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
	
	
	      if (dragEl) {
	        return;
	      }
	
	      if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
	        return; // only left button and enabled
	      } // cancel dnd if original target is content editable
	
	
	      if (originalTarget.isContentEditable) {
	        return;
	      }
	
	      target = closest(target, options.draggable, el, false);
	
	      if (target && target.animated) {
	        return;
	      }
	
	      if (lastDownEl === target) {
	        // Ignoring duplicate `down`
	        return;
	      } // Get the index of the dragged element within its parent
	
	
	      oldIndex = index(target);
	      oldDraggableIndex = index(target, options.draggable); // Check filter
	
	      if (typeof filter === 'function') {
	        if (filter.call(this, evt, target, this)) {
	          _dispatchEvent({
	            sortable: _this,
	            rootEl: originalTarget,
	            name: 'filter',
	            targetEl: target,
	            toEl: el,
	            fromEl: el
	          });
	
	          pluginEvent('filter', _this, {
	            evt: evt
	          });
	          preventOnFilter && evt.cancelable && evt.preventDefault();
	          return; // cancel dnd
	        }
	      } else if (filter) {
	        filter = filter.split(',').some(function (criteria) {
	          criteria = closest(originalTarget, criteria.trim(), el, false);
	
	          if (criteria) {
	            _dispatchEvent({
	              sortable: _this,
	              rootEl: criteria,
	              name: 'filter',
	              targetEl: target,
	              fromEl: el,
	              toEl: el
	            });
	
	            pluginEvent('filter', _this, {
	              evt: evt
	            });
	            return true;
	          }
	        });
	
	        if (filter) {
	          preventOnFilter && evt.cancelable && evt.preventDefault();
	          return; // cancel dnd
	        }
	      }
	
	      if (options.handle && !closest(originalTarget, options.handle, el, false)) {
	        return;
	      } // Prepare `dragstart`
	
	
	      this._prepareDragStart(evt, touch, target);
	    },
	    _prepareDragStart: function _prepareDragStart(
	    /** Event */
	    evt,
	    /** Touch */
	    touch,
	    /** HTMLElement */
	    target) {
	      var _this = this,
	          el = _this.el,
	          options = _this.options,
	          ownerDocument = el.ownerDocument,
	          dragStartFn;
	
	      if (target && !dragEl && target.parentNode === el) {
	        var dragRect = getRect(target);
	        rootEl = el;
	        dragEl = target;
	        parentEl = dragEl.parentNode;
	        nextEl = dragEl.nextSibling;
	        lastDownEl = target;
	        activeGroup = options.group;
	        Sortable.dragged = dragEl;
	        tapEvt = {
	          target: dragEl,
	          clientX: (touch || evt).clientX,
	          clientY: (touch || evt).clientY
	        };
	        tapDistanceLeft = tapEvt.clientX - dragRect.left;
	        tapDistanceTop = tapEvt.clientY - dragRect.top;
	        this._lastX = (touch || evt).clientX;
	        this._lastY = (touch || evt).clientY;
	        dragEl.style['will-change'] = 'all';
	
	        dragStartFn = function dragStartFn() {
	          pluginEvent('delayEnded', _this, {
	            evt: evt
	          });
	
	          if (Sortable.eventCanceled) {
	            _this._onDrop();
	
	            return;
	          } // Delayed drag has been triggered
	          // we can re-enable the events: touchmove/mousemove
	
	
	          _this._disableDelayedDragEvents();
	
	          if (!FireFox && _this.nativeDraggable) {
	            dragEl.draggable = true;
	          } // Bind the events: dragstart/dragend
	
	
	          _this._triggerDragStart(evt, touch); // Drag start event
	
	
	          _dispatchEvent({
	            sortable: _this,
	            name: 'choose',
	            originalEvent: evt
	          }); // Chosen item
	
	
	          toggleClass(dragEl, options.chosenClass, true);
	        }; // Disable "draggable"
	
	
	        options.ignore.split(',').forEach(function (criteria) {
	          find(dragEl, criteria.trim(), _disableDraggable);
	        });
	        on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
	        on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
	        on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
	        on(ownerDocument, 'mouseup', _this._onDrop);
	        on(ownerDocument, 'touchend', _this._onDrop);
	        on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)
	
	        if (FireFox && this.nativeDraggable) {
	          this.options.touchStartThreshold = 4;
	          dragEl.draggable = true;
	        }
	
	        pluginEvent('delayStart', this, {
	          evt: evt
	        }); // Delay is impossible for native DnD in Edge or IE
	
	        if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
	          if (Sortable.eventCanceled) {
	            this._onDrop();
	
	            return;
	          } // If the user moves the pointer or let go the click or touch
	          // before the delay has been reached:
	          // disable the delayed drag
	
	
	          on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
	          on(ownerDocument, 'touchend', _this._disableDelayedDrag);
	          on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
	          on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
	          on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
	          options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
	          _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
	        } else {
	          dragStartFn();
	        }
	      }
	    },
	    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
	    /** TouchEvent|PointerEvent **/
	    e) {
	      var touch = e.touches ? e.touches[0] : e;
	
	      if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
	        this._disableDelayedDrag();
	      }
	    },
	    _disableDelayedDrag: function _disableDelayedDrag() {
	      dragEl && _disableDraggable(dragEl);
	      clearTimeout(this._dragStartTimer);
	
	      this._disableDelayedDragEvents();
	    },
	    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
	      var ownerDocument = this.el.ownerDocument;
	      off(ownerDocument, 'mouseup', this._disableDelayedDrag);
	      off(ownerDocument, 'touchend', this._disableDelayedDrag);
	      off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
	      off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
	      off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
	      off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
	    },
	    _triggerDragStart: function _triggerDragStart(
	    /** Event */
	    evt,
	    /** Touch */
	    touch) {
	      touch = touch || evt.pointerType == 'touch' && evt;
	
	      if (!this.nativeDraggable || touch) {
	        if (this.options.supportPointer) {
	          on(document, 'pointermove', this._onTouchMove);
	        } else if (touch) {
	          on(document, 'touchmove', this._onTouchMove);
	        } else {
	          on(document, 'mousemove', this._onTouchMove);
	        }
	      } else {
	        on(dragEl, 'dragend', this);
	        on(rootEl, 'dragstart', this._onDragStart);
	      }
	
	      try {
	        if (document.selection) {
	          // Timeout neccessary for IE9
	          _nextTick(function () {
	            document.selection.empty();
	          });
	        } else {
	          window.getSelection().removeAllRanges();
	        }
	      } catch (err) {}
	    },
	    _dragStarted: function _dragStarted(fallback, evt) {
	
	      awaitingDragStarted = false;
	
	      if (rootEl && dragEl) {
	        pluginEvent('dragStarted', this, {
	          evt: evt
	        });
	
	        if (this.nativeDraggable) {
	          on(document, 'dragover', _checkOutsideTargetEl);
	        }
	
	        var options = this.options; // Apply effect
	
	        !fallback && toggleClass(dragEl, options.dragClass, false);
	        toggleClass(dragEl, options.ghostClass, true);
	        Sortable.active = this;
	        fallback && this._appendGhost(); // Drag start event
	
	        _dispatchEvent({
	          sortable: this,
	          name: 'start',
	          originalEvent: evt
	        });
	      } else {
	        this._nulling();
	      }
	    },
	    _emulateDragOver: function _emulateDragOver() {
	      if (touchEvt) {
	        this._lastX = touchEvt.clientX;
	        this._lastY = touchEvt.clientY;
	
	        _hideGhostForTarget();
	
	        var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
	        var parent = target;
	
	        while (target && target.shadowRoot) {
	          target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
	          if (target === parent) break;
	          parent = target;
	        }
	
	        dragEl.parentNode[expando]._isOutsideThisEl(target);
	
	        if (parent) {
	          do {
	            if (parent[expando]) {
	              var inserted = void 0;
	              inserted = parent[expando]._onDragOver({
	                clientX: touchEvt.clientX,
	                clientY: touchEvt.clientY,
	                target: target,
	                rootEl: parent
	              });
	
	              if (inserted && !this.options.dragoverBubble) {
	                break;
	              }
	            }
	
	            target = parent; // store last element
	          }
	          /* jshint boss:true */
	          while (parent = parent.parentNode);
	        }
	
	        _unhideGhostForTarget();
	      }
	    },
	    _onTouchMove: function _onTouchMove(
	    /**TouchEvent*/
	    evt) {
	      if (tapEvt) {
	        var options = this.options,
	            fallbackTolerance = options.fallbackTolerance,
	            fallbackOffset = options.fallbackOffset,
	            touch = evt.touches ? evt.touches[0] : evt,
	            ghostMatrix = ghostEl && matrix(ghostEl, true),
	            scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
	            scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
	            relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
	            dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
	            dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging
	
	        if (!Sortable.active && !awaitingDragStarted) {
	          if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
	            return;
	          }
	
	          this._onDragStart(evt, true);
	        }
	
	        if (ghostEl) {
	          if (ghostMatrix) {
	            ghostMatrix.e += dx - (lastDx || 0);
	            ghostMatrix.f += dy - (lastDy || 0);
	          } else {
	            ghostMatrix = {
	              a: 1,
	              b: 0,
	              c: 0,
	              d: 1,
	              e: dx,
	              f: dy
	            };
	          }
	
	          var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
	          css(ghostEl, 'webkitTransform', cssMatrix);
	          css(ghostEl, 'mozTransform', cssMatrix);
	          css(ghostEl, 'msTransform', cssMatrix);
	          css(ghostEl, 'transform', cssMatrix);
	          lastDx = dx;
	          lastDy = dy;
	          touchEvt = touch;
	        }
	
	        evt.cancelable && evt.preventDefault();
	      }
	    },
	    _appendGhost: function _appendGhost() {
	      // Bug if using scale(): https://stackoverflow.com/questions/2637058
	      // Not being adjusted for
	      if (!ghostEl) {
	        var container = this.options.fallbackOnBody ? document.body : rootEl,
	            rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
	            options = this.options; // Position absolutely
	
	        if (PositionGhostAbsolutely) {
	          // Get relatively positioned parent
	          ghostRelativeParent = container;
	
	          while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
	            ghostRelativeParent = ghostRelativeParent.parentNode;
	          }
	
	          if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
	            if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
	            rect.top += ghostRelativeParent.scrollTop;
	            rect.left += ghostRelativeParent.scrollLeft;
	          } else {
	            ghostRelativeParent = getWindowScrollingElement();
	          }
	
	          ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
	        }
	
	        ghostEl = dragEl.cloneNode(true);
	        toggleClass(ghostEl, options.ghostClass, false);
	        toggleClass(ghostEl, options.fallbackClass, true);
	        toggleClass(ghostEl, options.dragClass, true);
	        css(ghostEl, 'transition', '');
	        css(ghostEl, 'transform', '');
	        css(ghostEl, 'box-sizing', 'border-box');
	        css(ghostEl, 'margin', 0);
	        css(ghostEl, 'top', rect.top);
	        css(ghostEl, 'left', rect.left);
	        css(ghostEl, 'width', rect.width);
	        css(ghostEl, 'height', rect.height);
	        css(ghostEl, 'opacity', '0.8');
	        css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
	        css(ghostEl, 'zIndex', '100000');
	        css(ghostEl, 'pointerEvents', 'none');
	        Sortable.ghost = ghostEl;
	        container.appendChild(ghostEl); // Set transform-origin
	
	        css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
	      }
	    },
	    _onDragStart: function _onDragStart(
	    /**Event*/
	    evt,
	    /**boolean*/
	    fallback) {
	      var _this = this;
	
	      var dataTransfer = evt.dataTransfer;
	      var options = _this.options;
	      pluginEvent('dragStart', this, {
	        evt: evt
	      });
	
	      if (Sortable.eventCanceled) {
	        this._onDrop();
	
	        return;
	      }
	
	      pluginEvent('setupClone', this);
	
	      if (!Sortable.eventCanceled) {
	        cloneEl = clone(dragEl);
	        cloneEl.draggable = false;
	        cloneEl.style['will-change'] = '';
	
	        this._hideClone();
	
	        toggleClass(cloneEl, this.options.chosenClass, false);
	        Sortable.clone = cloneEl;
	      } // #1143: IFrame support workaround
	
	
	      _this.cloneId = _nextTick(function () {
	        pluginEvent('clone', _this);
	        if (Sortable.eventCanceled) return;
	
	        if (!_this.options.removeCloneOnHide) {
	          rootEl.insertBefore(cloneEl, dragEl);
	        }
	
	        _this._hideClone();
	
	        _dispatchEvent({
	          sortable: _this,
	          name: 'clone'
	        });
	      });
	      !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events
	
	      if (fallback) {
	        ignoreNextClick = true;
	        _this._loopId = setInterval(_this._emulateDragOver, 50);
	      } else {
	        // Undo what was set in _prepareDragStart before drag started
	        off(document, 'mouseup', _this._onDrop);
	        off(document, 'touchend', _this._onDrop);
	        off(document, 'touchcancel', _this._onDrop);
	
	        if (dataTransfer) {
	          dataTransfer.effectAllowed = 'move';
	          options.setData && options.setData.call(_this, dataTransfer, dragEl);
	        }
	
	        on(document, 'drop', _this); // #1276 fix:
	
	        css(dragEl, 'transform', 'translateZ(0)');
	      }
	
	      awaitingDragStarted = true;
	      _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
	      on(document, 'selectstart', _this);
	      moved = true;
	
	      if (Safari) {
	        css(document.body, 'user-select', 'none');
	      }
	    },
	    // Returns true - if no further action is needed (either inserted or another condition)
	    _onDragOver: function _onDragOver(
	    /**Event*/
	    evt) {
	      var el = this.el,
	          target = evt.target,
	          dragRect,
	          targetRect,
	          revert,
	          options = this.options,
	          group = options.group,
	          activeSortable = Sortable.active,
	          isOwner = activeGroup === group,
	          canSort = options.sort,
	          fromSortable = putSortable || activeSortable,
	          vertical,
	          _this = this,
	          completedFired = false;
	
	      if (_silent) return;
	
	      function dragOverEvent(name, extra) {
	        pluginEvent(name, _this, _objectSpread({
	          evt: evt,
	          isOwner: isOwner,
	          axis: vertical ? 'vertical' : 'horizontal',
	          revert: revert,
	          dragRect: dragRect,
	          targetRect: targetRect,
	          canSort: canSort,
	          fromSortable: fromSortable,
	          target: target,
	          completed: completed,
	          onMove: function onMove(target, after) {
	            return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
	          },
	          changed: changed
	        }, extra));
	      } // Capture animation state
	
	
	      function capture() {
	        dragOverEvent('dragOverAnimationCapture');
	
	        _this.captureAnimationState();
	
	        if (_this !== fromSortable) {
	          fromSortable.captureAnimationState();
	        }
	      } // Return invocation when dragEl is inserted (or completed)
	
	
	      function completed(insertion) {
	        dragOverEvent('dragOverCompleted', {
	          insertion: insertion
	        });
	
	        if (insertion) {
	          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
	          if (isOwner) {
	            activeSortable._hideClone();
	          } else {
	            activeSortable._showClone(_this);
	          }
	
	          if (_this !== fromSortable) {
	            // Set ghost class to new sortable's ghost class
	            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
	            toggleClass(dragEl, options.ghostClass, true);
	          }
	
	          if (putSortable !== _this && _this !== Sortable.active) {
	            putSortable = _this;
	          } else if (_this === Sortable.active && putSortable) {
	            putSortable = null;
	          } // Animation
	
	
	          if (fromSortable === _this) {
	            _this._ignoreWhileAnimating = target;
	          }
	
	          _this.animateAll(function () {
	            dragOverEvent('dragOverAnimationComplete');
	            _this._ignoreWhileAnimating = null;
	          });
	
	          if (_this !== fromSortable) {
	            fromSortable.animateAll();
	            fromSortable._ignoreWhileAnimating = null;
	          }
	        } // Null lastTarget if it is not inside a previously swapped element
	
	
	        if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
	          lastTarget = null;
	        } // no bubbling and not fallback
	
	
	        if (!options.dragoverBubble && !evt.rootEl && target !== document) {
	          dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted
	
	
	          !insertion && nearestEmptyInsertDetectEvent(evt);
	        }
	
	        !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
	        return completedFired = true;
	      } // Call when dragEl has been inserted
	
	
	      function changed() {
	        newIndex = index(dragEl);
	        newDraggableIndex = index(dragEl, options.draggable);
	
	        _dispatchEvent({
	          sortable: _this,
	          name: 'change',
	          toEl: el,
	          newIndex: newIndex,
	          newDraggableIndex: newDraggableIndex,
	          originalEvent: evt
	        });
	      }
	
	      if (evt.preventDefault !== void 0) {
	        evt.cancelable && evt.preventDefault();
	      }
	
	      target = closest(target, options.draggable, el, true);
	      dragOverEvent('dragOver');
	      if (Sortable.eventCanceled) return completedFired;
	
	      if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
	        return completed(false);
	      }
	
	      ignoreNextClick = false;
	
	      if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
	      : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
	        vertical = this._getDirection(evt, target) === 'vertical';
	        dragRect = getRect(dragEl);
	        dragOverEvent('dragOverValid');
	        if (Sortable.eventCanceled) return completedFired;
	
	        if (revert) {
	          parentEl = rootEl; // actualization
	
	          capture();
	
	          this._hideClone();
	
	          dragOverEvent('revert');
	
	          if (!Sortable.eventCanceled) {
	            if (nextEl) {
	              rootEl.insertBefore(dragEl, nextEl);
	            } else {
	              rootEl.appendChild(dragEl);
	            }
	          }
	
	          return completed(true);
	        }
	
	        var elLastChild = lastChild(el, options.draggable);
	
	        if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
	          // If already at end of list: Do not insert
	          if (elLastChild === dragEl) {
	            return completed(false);
	          } // assign target only if condition is true
	
	
	          if (elLastChild && el === evt.target) {
	            target = elLastChild;
	          }
	
	          if (target) {
	            targetRect = getRect(target);
	          }
	
	          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
	            capture();
	            el.appendChild(dragEl);
	            parentEl = el; // actualization
	
	            changed();
	            return completed(true);
	          }
	        } else if (target.parentNode === el) {
	          targetRect = getRect(target);
	          var direction = 0,
	              targetBeforeFirstSwap,
	              differentLevel = dragEl.parentNode !== el,
	              differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
	              side1 = vertical ? 'top' : 'left',
	              scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
	              scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
	
	          if (lastTarget !== target) {
	            targetBeforeFirstSwap = targetRect[side1];
	            pastFirstInvertThresh = false;
	            isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
	          }
	
	          direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
	          var sibling;
	
	          if (direction !== 0) {
	            // Check if target is beside dragEl in respective direction (ignoring hidden elements)
	            var dragIndex = index(dragEl);
	
	            do {
	              dragIndex -= direction;
	              sibling = parentEl.children[dragIndex];
	            } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
	          } // If dragEl is already beside target: Do not insert
	
	
	          if (direction === 0 || sibling === target) {
	            return completed(false);
	          }
	
	          lastTarget = target;
	          lastDirection = direction;
	          var nextSibling = target.nextElementSibling,
	              after = false;
	          after = direction === 1;
	
	          var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
	
	          if (moveVector !== false) {
	            if (moveVector === 1 || moveVector === -1) {
	              after = moveVector === 1;
	            }
	
	            _silent = true;
	            setTimeout(_unsilent, 30);
	            capture();
	
	            if (after && !nextSibling) {
	              el.appendChild(dragEl);
	            } else {
	              target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
	            } // Undo chrome's scroll adjustment (has no effect on other browsers)
	
	
	            if (scrolledPastTop) {
	              scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
	            }
	
	            parentEl = dragEl.parentNode; // actualization
	            // must be done before animation
	
	            if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
	              targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
	            }
	
	            changed();
	            return completed(true);
	          }
	        }
	
	        if (el.contains(dragEl)) {
	          return completed(false);
	        }
	      }
	
	      return false;
	    },
	    _ignoreWhileAnimating: null,
	    _offMoveEvents: function _offMoveEvents() {
	      off(document, 'mousemove', this._onTouchMove);
	      off(document, 'touchmove', this._onTouchMove);
	      off(document, 'pointermove', this._onTouchMove);
	      off(document, 'dragover', nearestEmptyInsertDetectEvent);
	      off(document, 'mousemove', nearestEmptyInsertDetectEvent);
	      off(document, 'touchmove', nearestEmptyInsertDetectEvent);
	    },
	    _offUpEvents: function _offUpEvents() {
	      var ownerDocument = this.el.ownerDocument;
	      off(ownerDocument, 'mouseup', this._onDrop);
	      off(ownerDocument, 'touchend', this._onDrop);
	      off(ownerDocument, 'pointerup', this._onDrop);
	      off(ownerDocument, 'touchcancel', this._onDrop);
	      off(document, 'selectstart', this);
	    },
	    _onDrop: function _onDrop(
	    /**Event*/
	    evt) {
	      var el = this.el,
	          options = this.options; // Get the index of the dragged element within its parent
	
	      newIndex = index(dragEl);
	      newDraggableIndex = index(dragEl, options.draggable);
	      pluginEvent('drop', this, {
	        evt: evt
	      });
	      parentEl = dragEl && dragEl.parentNode; // Get again after plugin event
	
	      newIndex = index(dragEl);
	      newDraggableIndex = index(dragEl, options.draggable);
	
	      if (Sortable.eventCanceled) {
	        this._nulling();
	
	        return;
	      }
	
	      awaitingDragStarted = false;
	      isCircumstantialInvert = false;
	      pastFirstInvertThresh = false;
	      clearInterval(this._loopId);
	      clearTimeout(this._dragStartTimer);
	
	      _cancelNextTick(this.cloneId);
	
	      _cancelNextTick(this._dragStartId); // Unbind events
	
	
	      if (this.nativeDraggable) {
	        off(document, 'drop', this);
	        off(el, 'dragstart', this._onDragStart);
	      }
	
	      this._offMoveEvents();
	
	      this._offUpEvents();
	
	      if (Safari) {
	        css(document.body, 'user-select', '');
	      }
	
	      css(dragEl, 'transform', '');
	
	      if (evt) {
	        if (moved) {
	          evt.cancelable && evt.preventDefault();
	          !options.dropBubble && evt.stopPropagation();
	        }
	
	        ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
	
	        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
	          // Remove clone(s)
	          cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
	        }
	
	        if (dragEl) {
	          if (this.nativeDraggable) {
	            off(dragEl, 'dragend', this);
	          }
	
	          _disableDraggable(dragEl);
	
	          dragEl.style['will-change'] = ''; // Remove classes
	          // ghostClass is added in dragStarted
	
	          if (moved && !awaitingDragStarted) {
	            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
	          }
	
	          toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event
	
	          _dispatchEvent({
	            sortable: this,
	            name: 'unchoose',
	            toEl: parentEl,
	            newIndex: null,
	            newDraggableIndex: null,
	            originalEvent: evt
	          });
	
	          if (rootEl !== parentEl) {
	            if (newIndex >= 0) {
	              // Add event
	              _dispatchEvent({
	                rootEl: parentEl,
	                name: 'add',
	                toEl: parentEl,
	                fromEl: rootEl,
	                originalEvent: evt
	              }); // Remove event
	
	
	              _dispatchEvent({
	                sortable: this,
	                name: 'remove',
	                toEl: parentEl,
	                originalEvent: evt
	              }); // drag from one list and drop into another
	
	
	              _dispatchEvent({
	                rootEl: parentEl,
	                name: 'sort',
	                toEl: parentEl,
	                fromEl: rootEl,
	                originalEvent: evt
	              });
	
	              _dispatchEvent({
	                sortable: this,
	                name: 'sort',
	                toEl: parentEl,
	                originalEvent: evt
	              });
	            }
	
	            putSortable && putSortable.save();
	          } else {
	            if (newIndex !== oldIndex) {
	              if (newIndex >= 0) {
	                // drag & drop within the same list
	                _dispatchEvent({
	                  sortable: this,
	                  name: 'update',
	                  toEl: parentEl,
	                  originalEvent: evt
	                });
	
	                _dispatchEvent({
	                  sortable: this,
	                  name: 'sort',
	                  toEl: parentEl,
	                  originalEvent: evt
	                });
	              }
	            }
	          }
	
	          if (Sortable.active) {
	            /* jshint eqnull:true */
	            if (newIndex == null || newIndex === -1) {
	              newIndex = oldIndex;
	              newDraggableIndex = oldDraggableIndex;
	            }
	
	            _dispatchEvent({
	              sortable: this,
	              name: 'end',
	              toEl: parentEl,
	              originalEvent: evt
	            }); // Save sorting
	
	
	            this.save();
	          }
	        }
	      }
	
	      this._nulling();
	    },
	    _nulling: function _nulling() {
	      pluginEvent('nulling', this);
	      rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
	      savedInputChecked.forEach(function (el) {
	        el.checked = true;
	      });
	      savedInputChecked.length = lastDx = lastDy = 0;
	    },
	    handleEvent: function handleEvent(
	    /**Event*/
	    evt) {
	      switch (evt.type) {
	        case 'drop':
	        case 'dragend':
	          this._onDrop(evt);
	
	          break;
	
	        case 'dragenter':
	        case 'dragover':
	          if (dragEl) {
	            this._onDragOver(evt);
	
	            _globalDragOver(evt);
	          }
	
	          break;
	
	        case 'selectstart':
	          evt.preventDefault();
	          break;
	      }
	    },
	
	    /**
	     * Serializes the item into an array of string.
	     * @returns {String[]}
	     */
	    toArray: function toArray() {
	      var order = [],
	          el,
	          children = this.el.children,
	          i = 0,
	          n = children.length,
	          options = this.options;
	
	      for (; i < n; i++) {
	        el = children[i];
	
	        if (closest(el, options.draggable, this.el, false)) {
	          order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
	        }
	      }
	
	      return order;
	    },
	
	    /**
	     * Sorts the elements according to the array.
	     * @param  {String[]}  order  order of the items
	     */
	    sort: function sort(order) {
	      var items = {},
	          rootEl = this.el;
	      this.toArray().forEach(function (id, i) {
	        var el = rootEl.children[i];
	
	        if (closest(el, this.options.draggable, rootEl, false)) {
	          items[id] = el;
	        }
	      }, this);
	      order.forEach(function (id) {
	        if (items[id]) {
	          rootEl.removeChild(items[id]);
	          rootEl.appendChild(items[id]);
	        }
	      });
	    },
	
	    /**
	     * Save the current sorting
	     */
	    save: function save() {
	      var store = this.options.store;
	      store && store.set && store.set(this);
	    },
	
	    /**
	     * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
	     * @param   {HTMLElement}  el
	     * @param   {String}       [selector]  default: `options.draggable`
	     * @returns {HTMLElement|null}
	     */
	    closest: function closest$1(el, selector) {
	      return closest(el, selector || this.options.draggable, this.el, false);
	    },
	
	    /**
	     * Set/get option
	     * @param   {string} name
	     * @param   {*}      [value]
	     * @returns {*}
	     */
	    option: function option(name, value) {
	      var options = this.options;
	
	      if (value === void 0) {
	        return options[name];
	      } else {
	        var modifiedValue = PluginManager.modifyOption(this, name, value);
	
	        if (typeof modifiedValue !== 'undefined') {
	          options[name] = modifiedValue;
	        } else {
	          options[name] = value;
	        }
	
	        if (name === 'group') {
	          _prepareGroup(options);
	        }
	      }
	    },
	
	    /**
	     * Destroy
	     */
	    destroy: function destroy() {
	      pluginEvent('destroy', this);
	      var el = this.el;
	      el[expando] = null;
	      off(el, 'mousedown', this._onTapStart);
	      off(el, 'touchstart', this._onTapStart);
	      off(el, 'pointerdown', this._onTapStart);
	
	      if (this.nativeDraggable) {
	        off(el, 'dragover', this);
	        off(el, 'dragenter', this);
	      } // Remove draggable attributes
	
	
	      Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
	        el.removeAttribute('draggable');
	      });
	
	      this._onDrop();
	
	      this._disableDelayedDragEvents();
	
	      sortables.splice(sortables.indexOf(this.el), 1);
	      this.el = el = null;
	    },
	    _hideClone: function _hideClone() {
	      if (!cloneHidden) {
	        pluginEvent('hideClone', this);
	        if (Sortable.eventCanceled) return;
	        css(cloneEl, 'display', 'none');
	
	        if (this.options.removeCloneOnHide && cloneEl.parentNode) {
	          cloneEl.parentNode.removeChild(cloneEl);
	        }
	
	        cloneHidden = true;
	      }
	    },
	    _showClone: function _showClone(putSortable) {
	      if (putSortable.lastPutMode !== 'clone') {
	        this._hideClone();
	
	        return;
	      }
	
	      if (cloneHidden) {
	        pluginEvent('showClone', this);
	        if (Sortable.eventCanceled) return; // show clone at dragEl or original position
	
	        if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
	          rootEl.insertBefore(cloneEl, dragEl);
	        } else if (nextEl) {
	          rootEl.insertBefore(cloneEl, nextEl);
	        } else {
	          rootEl.appendChild(cloneEl);
	        }
	
	        if (this.options.group.revertClone) {
	          this.animate(dragEl, cloneEl);
	        }
	
	        css(cloneEl, 'display', '');
	        cloneHidden = false;
	      }
	    }
	  };
	
	  function _globalDragOver(
	  /**Event*/
	  evt) {
	    if (evt.dataTransfer) {
	      evt.dataTransfer.dropEffect = 'move';
	    }
	
	    evt.cancelable && evt.preventDefault();
	  }
	
	  function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
	    var evt,
	        sortable = fromEl[expando],
	        onMoveFn = sortable.options.onMove,
	        retVal; // Support for new CustomEvent feature
	
	    if (window.CustomEvent && !IE11OrLess && !Edge) {
	      evt = new CustomEvent('move', {
	        bubbles: true,
	        cancelable: true
	      });
	    } else {
	      evt = document.createEvent('Event');
	      evt.initEvent('move', true, true);
	    }
	
	    evt.to = toEl;
	    evt.from = fromEl;
	    evt.dragged = dragEl;
	    evt.draggedRect = dragRect;
	    evt.related = targetEl || toEl;
	    evt.relatedRect = targetRect || getRect(toEl);
	    evt.willInsertAfter = willInsertAfter;
	    evt.originalEvent = originalEvent;
	    fromEl.dispatchEvent(evt);
	
	    if (onMoveFn) {
	      retVal = onMoveFn.call(sortable, evt, originalEvent);
	    }
	
	    return retVal;
	  }
	
	  function _disableDraggable(el) {
	    el.draggable = false;
	  }
	
	  function _unsilent() {
	    _silent = false;
	  }
	
	  function _ghostIsLast(evt, vertical, sortable) {
	    var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
	    var spacer = 10;
	    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
	  }
	
	  function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
	    var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
	        targetLength = vertical ? targetRect.height : targetRect.width,
	        targetS1 = vertical ? targetRect.top : targetRect.left,
	        targetS2 = vertical ? targetRect.bottom : targetRect.right,
	        invert = false;
	
	    if (!invertSwap) {
	      // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
	      if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
	        // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
	        // check if past first invert threshold on side opposite of lastDirection
	        if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
	          // past first invert threshold, do not restrict inverted threshold to dragEl shadow
	          pastFirstInvertThresh = true;
	        }
	
	        if (!pastFirstInvertThresh) {
	          // dragEl shadow (target move distance shadow)
	          if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
	          : mouseOnAxis > targetS2 - targetMoveDistance) {
	            return -lastDirection;
	          }
	        } else {
	          invert = true;
	        }
	      } else {
	        // Regular
	        if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
	          return _getInsertDirection(target);
	        }
	      }
	    }
	
	    invert = invert || invertSwap;
	
	    if (invert) {
	      // Invert of regular
	      if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
	        return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
	      }
	    }
	
	    return 0;
	  }
	  /**
	   * Gets the direction dragEl must be swapped relative to target in order to make it
	   * seem that dragEl has been "inserted" into that element's position
	   * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
	   * @return {Number}                   Direction dragEl must be swapped
	   */
	
	
	  function _getInsertDirection(target) {
	    if (index(dragEl) < index(target)) {
	      return 1;
	    } else {
	      return -1;
	    }
	  }
	  /**
	   * Generate id
	   * @param   {HTMLElement} el
	   * @returns {String}
	   * @private
	   */
	
	
	  function _generateId(el) {
	    var str = el.tagName + el.className + el.src + el.href + el.textContent,
	        i = str.length,
	        sum = 0;
	
	    while (i--) {
	      sum += str.charCodeAt(i);
	    }
	
	    return sum.toString(36);
	  }
	
	  function _saveInputCheckedState(root) {
	    savedInputChecked.length = 0;
	    var inputs = root.getElementsByTagName('input');
	    var idx = inputs.length;
	
	    while (idx--) {
	      var el = inputs[idx];
	      el.checked && savedInputChecked.push(el);
	    }
	  }
	
	  function _nextTick(fn) {
	    return setTimeout(fn, 0);
	  }
	
	  function _cancelNextTick(id) {
	    return clearTimeout(id);
	  } // Fixed #973:
	
	
	  if (documentExists) {
	    on(document, 'touchmove', function (evt) {
	      if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
	        evt.preventDefault();
	      }
	    });
	  } // Export utils
	
	
	  Sortable.utils = {
	    on: on,
	    off: off,
	    css: css,
	    find: find,
	    is: function is(el, selector) {
	      return !!closest(el, selector, el, false);
	    },
	    extend: extend,
	    throttle: throttle,
	    closest: closest,
	    toggleClass: toggleClass,
	    clone: clone,
	    index: index,
	    nextTick: _nextTick,
	    cancelNextTick: _cancelNextTick,
	    detectDirection: _detectDirection,
	    getChild: getChild
	  };
	  /**
	   * Get the Sortable instance of an element
	   * @param  {HTMLElement} element The element
	   * @return {Sortable|undefined}         The instance of Sortable
	   */
	
	  Sortable.get = function (element) {
	    return element[expando];
	  };
	  /**
	   * Mount a plugin to Sortable
	   * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
	   */
	
	
	  Sortable.mount = function () {
	    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
	      plugins[_key] = arguments[_key];
	    }
	
	    if (plugins[0].constructor === Array) plugins = plugins[0];
	    plugins.forEach(function (plugin) {
	      if (!plugin.prototype || !plugin.prototype.constructor) {
	        throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
	      }
	
	      if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
	      PluginManager.mount(plugin);
	    });
	  };
	  /**
	   * Create sortable instance
	   * @param {HTMLElement}  el
	   * @param {Object}      [options]
	   */
	
	
	  Sortable.create = function (el, options) {
	    return new Sortable(el, options);
	  }; // Export
	
	
	  Sortable.version = version;
	
	  var autoScrolls = [],
	      scrollEl,
	      scrollRootEl,
	      scrolling = false,
	      lastAutoScrollX,
	      lastAutoScrollY,
	      touchEvt$1,
	      pointerElemChangedInterval;
	
	  function AutoScrollPlugin() {
	    function AutoScroll() {
	      this.defaults = {
	        scroll: true,
	        scrollSensitivity: 30,
	        scrollSpeed: 10,
	        bubbleScroll: true
	      }; // Bind all private methods
	
	      for (var fn in this) {
	        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
	          this[fn] = this[fn].bind(this);
	        }
	      }
	    }
	
	    AutoScroll.prototype = {
	      dragStarted: function dragStarted(_ref) {
	        var originalEvent = _ref.originalEvent;
	
	        if (this.sortable.nativeDraggable) {
	          on(document, 'dragover', this._handleAutoScroll);
	        } else {
	          if (this.options.supportPointer) {
	            on(document, 'pointermove', this._handleFallbackAutoScroll);
	          } else if (originalEvent.touches) {
	            on(document, 'touchmove', this._handleFallbackAutoScroll);
	          } else {
	            on(document, 'mousemove', this._handleFallbackAutoScroll);
	          }
	        }
	      },
	      dragOverCompleted: function dragOverCompleted(_ref2) {
	        var originalEvent = _ref2.originalEvent;
	
	        // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
	        if (!this.options.dragOverBubble && !originalEvent.rootEl) {
	          this._handleAutoScroll(originalEvent);
	        }
	      },
	      drop: function drop() {
	        if (this.sortable.nativeDraggable) {
	          off(document, 'dragover', this._handleAutoScroll);
	        } else {
	          off(document, 'pointermove', this._handleFallbackAutoScroll);
	          off(document, 'touchmove', this._handleFallbackAutoScroll);
	          off(document, 'mousemove', this._handleFallbackAutoScroll);
	        }
	
	        clearPointerElemChangedInterval();
	        clearAutoScrolls();
	        cancelThrottle();
	      },
	      nulling: function nulling() {
	        touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
	        autoScrolls.length = 0;
	      },
	      _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
	        this._handleAutoScroll(evt, true);
	      },
	      _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
	        var _this = this;
	
	        var x = (evt.touches ? evt.touches[0] : evt).clientX,
	            y = (evt.touches ? evt.touches[0] : evt).clientY,
	            elem = document.elementFromPoint(x, y);
	        touchEvt$1 = evt; // IE does not seem to have native autoscroll,
	        // Edge's autoscroll seems too conditional,
	        // MACOS Safari does not have autoscroll,
	        // Firefox and Chrome are good
	
	        if (fallback || Edge || IE11OrLess || Safari) {
	          autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change
	
	          var ogElemScroller = getParentAutoScrollElement(elem, true);
	
	          if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
	            pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour
	
	            pointerElemChangedInterval = setInterval(function () {
	              var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
	
	              if (newElem !== ogElemScroller) {
	                ogElemScroller = newElem;
	                clearAutoScrolls();
	              }
	
	              autoScroll(evt, _this.options, newElem, fallback);
	            }, 10);
	            lastAutoScrollX = x;
	            lastAutoScrollY = y;
	          }
	        } else {
	          // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
	          if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
	            clearAutoScrolls();
	            return;
	          }
	
	          autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
	        }
	      }
	    };
	    return _extends(AutoScroll, {
	      pluginName: 'scroll',
	      initializeByDefault: true
	    });
	  }
	
	  function clearAutoScrolls() {
	    autoScrolls.forEach(function (autoScroll) {
	      clearInterval(autoScroll.pid);
	    });
	    autoScrolls = [];
	  }
	
	  function clearPointerElemChangedInterval() {
	    clearInterval(pointerElemChangedInterval);
	  }
	
	  var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
	    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
	    if (!options.scroll) return;
	    var x = (evt.touches ? evt.touches[0] : evt).clientX,
	        y = (evt.touches ? evt.touches[0] : evt).clientY,
	        sens = options.scrollSensitivity,
	        speed = options.scrollSpeed,
	        winScroller = getWindowScrollingElement();
	    var scrollThisInstance = false,
	        scrollCustomFn; // New scroll root, set scrollEl
	
	    if (scrollRootEl !== rootEl) {
	      scrollRootEl = rootEl;
	      clearAutoScrolls();
	      scrollEl = options.scroll;
	      scrollCustomFn = options.scrollFn;
	
	      if (scrollEl === true) {
	        scrollEl = getParentAutoScrollElement(rootEl, true);
	      }
	    }
	
	    var layersOut = 0;
	    var currentParent = scrollEl;
	
	    do {
	      var el = currentParent,
	          rect = getRect(el),
	          top = rect.top,
	          bottom = rect.bottom,
	          left = rect.left,
	          right = rect.right,
	          width = rect.width,
	          height = rect.height,
	          canScrollX = void 0,
	          canScrollY = void 0,
	          scrollWidth = el.scrollWidth,
	          scrollHeight = el.scrollHeight,
	          elCSS = css(el),
	          scrollPosX = el.scrollLeft,
	          scrollPosY = el.scrollTop;
	
	      if (el === winScroller) {
	        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
	        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
	      } else {
	        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
	        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
	      }
	
	      var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
	      var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
	
	      if (!autoScrolls[layersOut]) {
	        for (var i = 0; i <= layersOut; i++) {
	          if (!autoScrolls[i]) {
	            autoScrolls[i] = {};
	          }
	        }
	      }
	
	      if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
	        autoScrolls[layersOut].el = el;
	        autoScrolls[layersOut].vx = vx;
	        autoScrolls[layersOut].vy = vy;
	        clearInterval(autoScrolls[layersOut].pid);
	
	        if (vx != 0 || vy != 0) {
	          scrollThisInstance = true;
	          /* jshint loopfunc:true */
	
	          autoScrolls[layersOut].pid = setInterval(function () {
	            // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
	            if (isFallback && this.layer === 0) {
	              Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely
	
	            }
	
	            var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
	            var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
	
	            if (typeof scrollCustomFn === 'function') {
	              if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
	                return;
	              }
	            }
	
	            scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
	          }.bind({
	            layer: layersOut
	          }), 24);
	        }
	      }
	
	      layersOut++;
	    } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
	
	    scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
	  }, 30);
	
	  var drop = function drop(_ref) {
	    var originalEvent = _ref.originalEvent,
	        putSortable = _ref.putSortable,
	        dragEl = _ref.dragEl,
	        activeSortable = _ref.activeSortable,
	        dispatchSortableEvent = _ref.dispatchSortableEvent,
	        hideGhostForTarget = _ref.hideGhostForTarget,
	        unhideGhostForTarget = _ref.unhideGhostForTarget;
	    if (!originalEvent) return;
	    var toSortable = putSortable || activeSortable;
	    hideGhostForTarget();
	    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
	    var target = document.elementFromPoint(touch.clientX, touch.clientY);
	    unhideGhostForTarget();
	
	    if (toSortable && !toSortable.el.contains(target)) {
	      dispatchSortableEvent('spill');
	      this.onSpill({
	        dragEl: dragEl,
	        putSortable: putSortable
	      });
	    }
	  };
	
	  function Revert() {}
	
	  Revert.prototype = {
	    startIndex: null,
	    dragStart: function dragStart(_ref2) {
	      var oldDraggableIndex = _ref2.oldDraggableIndex;
	      this.startIndex = oldDraggableIndex;
	    },
	    onSpill: function onSpill(_ref3) {
	      var dragEl = _ref3.dragEl,
	          putSortable = _ref3.putSortable;
	      this.sortable.captureAnimationState();
	
	      if (putSortable) {
	        putSortable.captureAnimationState();
	      }
	
	      var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
	
	      if (nextSibling) {
	        this.sortable.el.insertBefore(dragEl, nextSibling);
	      } else {
	        this.sortable.el.appendChild(dragEl);
	      }
	
	      this.sortable.animateAll();
	
	      if (putSortable) {
	        putSortable.animateAll();
	      }
	    },
	    drop: drop
	  };
	
	  _extends(Revert, {
	    pluginName: 'revertOnSpill'
	  });
	
	  function Remove() {}
	
	  Remove.prototype = {
	    onSpill: function onSpill(_ref4) {
	      var dragEl = _ref4.dragEl,
	          putSortable = _ref4.putSortable;
	      var parentSortable = putSortable || this.sortable;
	      parentSortable.captureAnimationState();
	      dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
	      parentSortable.animateAll();
	    },
	    drop: drop
	  };
	
	  _extends(Remove, {
	    pluginName: 'removeOnSpill'
	  });
	
	  var lastSwapEl;
	
	  function SwapPlugin() {
	    function Swap() {
	      this.defaults = {
	        swapClass: 'sortable-swap-highlight'
	      };
	    }
	
	    Swap.prototype = {
	      dragStart: function dragStart(_ref) {
	        var dragEl = _ref.dragEl;
	        lastSwapEl = dragEl;
	      },
	      dragOverValid: function dragOverValid(_ref2) {
	        var completed = _ref2.completed,
	            target = _ref2.target,
	            onMove = _ref2.onMove,
	            activeSortable = _ref2.activeSortable,
	            changed = _ref2.changed,
	            cancel = _ref2.cancel;
	        if (!activeSortable.options.swap) return;
	        var el = this.sortable.el,
	            options = this.options;
	
	        if (target && target !== el) {
	          var prevSwapEl = lastSwapEl;
	
	          if (onMove(target) !== false) {
	            toggleClass(target, options.swapClass, true);
	            lastSwapEl = target;
	          } else {
	            lastSwapEl = null;
	          }
	
	          if (prevSwapEl && prevSwapEl !== lastSwapEl) {
	            toggleClass(prevSwapEl, options.swapClass, false);
	          }
	        }
	
	        changed();
	        completed(true);
	        cancel();
	      },
	      drop: function drop(_ref3) {
	        var activeSortable = _ref3.activeSortable,
	            putSortable = _ref3.putSortable,
	            dragEl = _ref3.dragEl;
	        var toSortable = putSortable || this.sortable;
	        var options = this.options;
	        lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);
	
	        if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
	          if (dragEl !== lastSwapEl) {
	            toSortable.captureAnimationState();
	            if (toSortable !== activeSortable) activeSortable.captureAnimationState();
	            swapNodes(dragEl, lastSwapEl);
	            toSortable.animateAll();
	            if (toSortable !== activeSortable) activeSortable.animateAll();
	          }
	        }
	      },
	      nulling: function nulling() {
	        lastSwapEl = null;
	      }
	    };
	    return _extends(Swap, {
	      pluginName: 'swap',
	      eventProperties: function eventProperties() {
	        return {
	          swapItem: lastSwapEl
	        };
	      }
	    });
	  }
	
	  function swapNodes(n1, n2) {
	    var p1 = n1.parentNode,
	        p2 = n2.parentNode,
	        i1,
	        i2;
	    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
	    i1 = index(n1);
	    i2 = index(n2);
	
	    if (p1.isEqualNode(p2) && i1 < i2) {
	      i2++;
	    }
	
	    p1.insertBefore(n2, p1.children[i1]);
	    p2.insertBefore(n1, p2.children[i2]);
	  }
	
	  var multiDragElements = [],
	      multiDragClones = [],
	      lastMultiDragSelect,
	      // for selection with modifier key down (SHIFT)
	  multiDragSortable,
	      initialFolding = false,
	      // Initial multi-drag fold when drag started
	  folding = false,
	      // Folding any other time
	  dragStarted = false,
	      dragEl$1,
	      clonesFromRect,
	      clonesHidden;
	
	  function MultiDragPlugin() {
	    function MultiDrag(sortable) {
	      // Bind all private methods
	      for (var fn in this) {
	        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
	          this[fn] = this[fn].bind(this);
	        }
	      }
	
	      if (sortable.options.supportPointer) {
	        on(document, 'pointerup', this._deselectMultiDrag);
	      } else {
	        on(document, 'mouseup', this._deselectMultiDrag);
	        on(document, 'touchend', this._deselectMultiDrag);
	      }
	
	      on(document, 'keydown', this._checkKeyDown);
	      on(document, 'keyup', this._checkKeyUp);
	      this.defaults = {
	        selectedClass: 'sortable-selected',
	        multiDragKey: null,
	        setData: function setData(dataTransfer, dragEl) {
	          var data = '';
	
	          if (multiDragElements.length && multiDragSortable === sortable) {
	            multiDragElements.forEach(function (multiDragElement, i) {
	              data += (!i ? '' : ', ') + multiDragElement.textContent;
	            });
	          } else {
	            data = dragEl.textContent;
	          }
	
	          dataTransfer.setData('Text', data);
	        }
	      };
	    }
	
	    MultiDrag.prototype = {
	      multiDragKeyDown: false,
	      isMultiDrag: false,
	      delayStartGlobal: function delayStartGlobal(_ref) {
	        var dragged = _ref.dragEl;
	        dragEl$1 = dragged;
	      },
	      delayEnded: function delayEnded() {
	        this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
	      },
	      setupClone: function setupClone(_ref2) {
	        var sortable = _ref2.sortable,
	            cancel = _ref2.cancel;
	        if (!this.isMultiDrag) return;
	
	        for (var i = 0; i < multiDragElements.length; i++) {
	          multiDragClones.push(clone(multiDragElements[i]));
	          multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
	          multiDragClones[i].draggable = false;
	          multiDragClones[i].style['will-change'] = '';
	          toggleClass(multiDragClones[i], this.options.selectedClass, false);
	          multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
	        }
	
	        sortable._hideClone();
	
	        cancel();
	      },
	      clone: function clone(_ref3) {
	        var sortable = _ref3.sortable,
	            rootEl = _ref3.rootEl,
	            dispatchSortableEvent = _ref3.dispatchSortableEvent,
	            cancel = _ref3.cancel;
	        if (!this.isMultiDrag) return;
	
	        if (!this.options.removeCloneOnHide) {
	          if (multiDragElements.length && multiDragSortable === sortable) {
	            insertMultiDragClones(true, rootEl);
	            dispatchSortableEvent('clone');
	            cancel();
	          }
	        }
	      },
	      showClone: function showClone(_ref4) {
	        var cloneNowShown = _ref4.cloneNowShown,
	            rootEl = _ref4.rootEl,
	            cancel = _ref4.cancel;
	        if (!this.isMultiDrag) return;
	        insertMultiDragClones(false, rootEl);
	        multiDragClones.forEach(function (clone) {
	          css(clone, 'display', '');
	        });
	        cloneNowShown();
	        clonesHidden = false;
	        cancel();
	      },
	      hideClone: function hideClone(_ref5) {
	        var _this = this;
	
	        var sortable = _ref5.sortable,
	            cloneNowHidden = _ref5.cloneNowHidden,
	            cancel = _ref5.cancel;
	        if (!this.isMultiDrag) return;
	        multiDragClones.forEach(function (clone) {
	          css(clone, 'display', 'none');
	
	          if (_this.options.removeCloneOnHide && clone.parentNode) {
	            clone.parentNode.removeChild(clone);
	          }
	        });
	        cloneNowHidden();
	        clonesHidden = true;
	        cancel();
	      },
	      dragStartGlobal: function dragStartGlobal(_ref6) {
	        var sortable = _ref6.sortable;
	
	        if (!this.isMultiDrag && multiDragSortable) {
	          multiDragSortable.multiDrag._deselectMultiDrag();
	        }
	
	        multiDragElements.forEach(function (multiDragElement) {
	          multiDragElement.sortableIndex = index(multiDragElement);
	        }); // Sort multi-drag elements
	
	        multiDragElements = multiDragElements.sort(function (a, b) {
	          return a.sortableIndex - b.sortableIndex;
	        });
	        dragStarted = true;
	      },
	      dragStarted: function dragStarted(_ref7) {
	        var _this2 = this;
	
	        var sortable = _ref7.sortable;
	        if (!this.isMultiDrag) return;
	
	        if (this.options.sort) {
	          // Capture rects,
	          // hide multi drag elements (by positioning them absolute),
	          // set multi drag elements rects to dragRect,
	          // show multi drag elements,
	          // animate to rects,
	          // unset rects & remove from DOM
	          sortable.captureAnimationState();
	
	          if (this.options.animation) {
	            multiDragElements.forEach(function (multiDragElement) {
	              if (multiDragElement === dragEl$1) return;
	              css(multiDragElement, 'position', 'absolute');
	            });
	            var dragRect = getRect(dragEl$1, false, true, true);
	            multiDragElements.forEach(function (multiDragElement) {
	              if (multiDragElement === dragEl$1) return;
	              setRect(multiDragElement, dragRect);
	            });
	            folding = true;
	            initialFolding = true;
	          }
	        }
	
	        sortable.animateAll(function () {
	          folding = false;
	          initialFolding = false;
	
	          if (_this2.options.animation) {
	            multiDragElements.forEach(function (multiDragElement) {
	              unsetRect(multiDragElement);
	            });
	          } // Remove all auxiliary multidrag items from el, if sorting enabled
	
	
	          if (_this2.options.sort) {
	            removeMultiDragElements();
	          }
	        });
	      },
	      dragOver: function dragOver(_ref8) {
	        var target = _ref8.target,
	            completed = _ref8.completed,
	            cancel = _ref8.cancel;
	
	        if (folding && ~multiDragElements.indexOf(target)) {
	          completed(false);
	          cancel();
	        }
	      },
	      revert: function revert(_ref9) {
	        var fromSortable = _ref9.fromSortable,
	            rootEl = _ref9.rootEl,
	            sortable = _ref9.sortable,
	            dragRect = _ref9.dragRect;
	
	        if (multiDragElements.length > 1) {
	          // Setup unfold animation
	          multiDragElements.forEach(function (multiDragElement) {
	            sortable.addAnimationState({
	              target: multiDragElement,
	              rect: folding ? getRect(multiDragElement) : dragRect
	            });
	            unsetRect(multiDragElement);
	            multiDragElement.fromRect = dragRect;
	            fromSortable.removeAnimationState(multiDragElement);
	          });
	          folding = false;
	          insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
	        }
	      },
	      dragOverCompleted: function dragOverCompleted(_ref10) {
	        var sortable = _ref10.sortable,
	            isOwner = _ref10.isOwner,
	            insertion = _ref10.insertion,
	            activeSortable = _ref10.activeSortable,
	            parentEl = _ref10.parentEl,
	            putSortable = _ref10.putSortable;
	        var options = this.options;
	
	        if (insertion) {
	          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
	          if (isOwner) {
	            activeSortable._hideClone();
	          }
	
	          initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location
	
	          if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
	            // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
	            var dragRectAbsolute = getRect(dragEl$1, false, true, true);
	            multiDragElements.forEach(function (multiDragElement) {
	              if (multiDragElement === dragEl$1) return;
	              setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
	              // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
	
	              parentEl.appendChild(multiDragElement);
	            });
	            folding = true;
	          } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
	
	
	          if (!isOwner) {
	            // Only remove if not folding (folding will remove them anyways)
	            if (!folding) {
	              removeMultiDragElements();
	            }
	
	            if (multiDragElements.length > 1) {
	              var clonesHiddenBefore = clonesHidden;
	
	              activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden
	
	
	              if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
	                multiDragClones.forEach(function (clone) {
	                  activeSortable.addAnimationState({
	                    target: clone,
	                    rect: clonesFromRect
	                  });
	                  clone.fromRect = clonesFromRect;
	                  clone.thisAnimationDuration = null;
	                });
	              }
	            } else {
	              activeSortable._showClone(sortable);
	            }
	          }
	        }
	      },
	      dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
	        var dragRect = _ref11.dragRect,
	            isOwner = _ref11.isOwner,
	            activeSortable = _ref11.activeSortable;
	        multiDragElements.forEach(function (multiDragElement) {
	          multiDragElement.thisAnimationDuration = null;
	        });
	
	        if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
	          clonesFromRect = _extends({}, dragRect);
	          var dragMatrix = matrix(dragEl$1, true);
	          clonesFromRect.top -= dragMatrix.f;
	          clonesFromRect.left -= dragMatrix.e;
	        }
	      },
	      dragOverAnimationComplete: function dragOverAnimationComplete() {
	        if (folding) {
	          folding = false;
	          removeMultiDragElements();
	        }
	      },
	      drop: function drop(_ref12) {
	        var evt = _ref12.originalEvent,
	            rootEl = _ref12.rootEl,
	            parentEl = _ref12.parentEl,
	            sortable = _ref12.sortable,
	            dispatchSortableEvent = _ref12.dispatchSortableEvent,
	            oldIndex = _ref12.oldIndex,
	            putSortable = _ref12.putSortable;
	        var toSortable = putSortable || this.sortable;
	        if (!evt) return;
	        var options = this.options,
	            children = parentEl.children; // Multi-drag selection
	
	        if (!dragStarted) {
	          if (options.multiDragKey && !this.multiDragKeyDown) {
	            this._deselectMultiDrag();
	          }
	
	          toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));
	
	          if (!~multiDragElements.indexOf(dragEl$1)) {
	            multiDragElements.push(dragEl$1);
	            dispatchEvent({
	              sortable: sortable,
	              rootEl: rootEl,
	              name: 'select',
	              targetEl: dragEl$1,
	              originalEvt: evt
	            }); // Modifier activated, select from last to dragEl
	
	            if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
	              var lastIndex = index(lastMultiDragSelect),
	                  currentIndex = index(dragEl$1);
	
	              if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
	                // Must include lastMultiDragSelect (select it), in case modified selection from no selection
	                // (but previous selection existed)
	                var n, i;
	
	                if (currentIndex > lastIndex) {
	                  i = lastIndex;
	                  n = currentIndex;
	                } else {
	                  i = currentIndex;
	                  n = lastIndex + 1;
	                }
	
	                for (; i < n; i++) {
	                  if (~multiDragElements.indexOf(children[i])) continue;
	                  toggleClass(children[i], options.selectedClass, true);
	                  multiDragElements.push(children[i]);
	                  dispatchEvent({
	                    sortable: sortable,
	                    rootEl: rootEl,
	                    name: 'select',
	                    targetEl: children[i],
	                    originalEvt: evt
	                  });
	                }
	              }
	            } else {
	              lastMultiDragSelect = dragEl$1;
	            }
	
	            multiDragSortable = toSortable;
	          } else {
	            multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
	            lastMultiDragSelect = null;
	            dispatchEvent({
	              sortable: sortable,
	              rootEl: rootEl,
	              name: 'deselect',
	              targetEl: dragEl$1,
	              originalEvt: evt
	            });
	          }
	        } // Multi-drag drop
	
	
	        if (dragStarted && this.isMultiDrag) {
	          // Do not "unfold" after around dragEl if reverted
	          if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
	            var dragRect = getRect(dragEl$1),
	                multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
	            if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
	            toSortable.captureAnimationState();
	
	            if (!initialFolding) {
	              if (options.animation) {
	                dragEl$1.fromRect = dragRect;
	                multiDragElements.forEach(function (multiDragElement) {
	                  multiDragElement.thisAnimationDuration = null;
	
	                  if (multiDragElement !== dragEl$1) {
	                    var rect = folding ? getRect(multiDragElement) : dragRect;
	                    multiDragElement.fromRect = rect; // Prepare unfold animation
	
	                    toSortable.addAnimationState({
	                      target: multiDragElement,
	                      rect: rect
	                    });
	                  }
	                });
	              } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
	              // properly they must all be removed
	
	
	              removeMultiDragElements();
	              multiDragElements.forEach(function (multiDragElement) {
	                if (children[multiDragIndex]) {
	                  parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
	                } else {
	                  parentEl.appendChild(multiDragElement);
	                }
	
	                multiDragIndex++;
	              }); // If initial folding is done, the elements may have changed position because they are now
	              // unfolding around dragEl, even though dragEl may not have his index changed, so update event
	              // must be fired here as Sortable will not.
	
	              if (oldIndex === index(dragEl$1)) {
	                var update = false;
	                multiDragElements.forEach(function (multiDragElement) {
	                  if (multiDragElement.sortableIndex !== index(multiDragElement)) {
	                    update = true;
	                    return;
	                  }
	                });
	
	                if (update) {
	                  dispatchSortableEvent('update');
	                }
	              }
	            } // Must be done after capturing individual rects (scroll bar)
	
	
	            multiDragElements.forEach(function (multiDragElement) {
	              unsetRect(multiDragElement);
	            });
	            toSortable.animateAll();
	          }
	
	          multiDragSortable = toSortable;
	        } // Remove clones if necessary
	
	
	        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
	          multiDragClones.forEach(function (clone) {
	            clone.parentNode && clone.parentNode.removeChild(clone);
	          });
	        }
	      },
	      nullingGlobal: function nullingGlobal() {
	        this.isMultiDrag = dragStarted = false;
	        multiDragClones.length = 0;
	      },
	      destroyGlobal: function destroyGlobal() {
	        this._deselectMultiDrag();
	
	        off(document, 'pointerup', this._deselectMultiDrag);
	        off(document, 'mouseup', this._deselectMultiDrag);
	        off(document, 'touchend', this._deselectMultiDrag);
	        off(document, 'keydown', this._checkKeyDown);
	        off(document, 'keyup', this._checkKeyUp);
	      },
	      _deselectMultiDrag: function _deselectMultiDrag(evt) {
	        if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable
	
	        if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable
	
	        if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click
	
	        if (evt && evt.button !== 0) return;
	
	        while (multiDragElements.length) {
	          var el = multiDragElements[0];
	          toggleClass(el, this.options.selectedClass, false);
	          multiDragElements.shift();
	          dispatchEvent({
	            sortable: this.sortable,
	            rootEl: this.sortable.el,
	            name: 'deselect',
	            targetEl: el,
	            originalEvt: evt
	          });
	        }
	      },
	      _checkKeyDown: function _checkKeyDown(evt) {
	        if (evt.key === this.options.multiDragKey) {
	          this.multiDragKeyDown = true;
	        }
	      },
	      _checkKeyUp: function _checkKeyUp(evt) {
	        if (evt.key === this.options.multiDragKey) {
	          this.multiDragKeyDown = false;
	        }
	      }
	    };
	    return _extends(MultiDrag, {
	      // Static methods & properties
	      pluginName: 'multiDrag',
	      utils: {
	        /**
	         * Selects the provided multi-drag item
	         * @param  {HTMLElement} el    The element to be selected
	         */
	        select: function select(el) {
	          var sortable = el.parentNode[expando];
	          if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;
	
	          if (multiDragSortable && multiDragSortable !== sortable) {
	            multiDragSortable.multiDrag._deselectMultiDrag();
	
	            multiDragSortable = sortable;
	          }
	
	          toggleClass(el, sortable.options.selectedClass, true);
	          multiDragElements.push(el);
	        },
	
	        /**
	         * Deselects the provided multi-drag item
	         * @param  {HTMLElement} el    The element to be deselected
	         */
	        deselect: function deselect(el) {
	          var sortable = el.parentNode[expando],
	              index = multiDragElements.indexOf(el);
	          if (!sortable || !sortable.options.multiDrag || !~index) return;
	          toggleClass(el, sortable.options.selectedClass, false);
	          multiDragElements.splice(index, 1);
	        }
	      },
	      eventProperties: function eventProperties() {
	        var _this3 = this;
	
	        var oldIndicies = [],
	            newIndicies = [];
	        multiDragElements.forEach(function (multiDragElement) {
	          oldIndicies.push({
	            multiDragElement: multiDragElement,
	            index: multiDragElement.sortableIndex
	          }); // multiDragElements will already be sorted if folding
	
	          var newIndex;
	
	          if (folding && multiDragElement !== dragEl$1) {
	            newIndex = -1;
	          } else if (folding) {
	            newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
	          } else {
	            newIndex = index(multiDragElement);
	          }
	
	          newIndicies.push({
	            multiDragElement: multiDragElement,
	            index: newIndex
	          });
	        });
	        return {
	          items: _toConsumableArray(multiDragElements),
	          clones: [].concat(multiDragClones),
	          oldIndicies: oldIndicies,
	          newIndicies: newIndicies
	        };
	      },
	      optionListeners: {
	        multiDragKey: function multiDragKey(key) {
	          key = key.toLowerCase();
	
	          if (key === 'ctrl') {
	            key = 'Control';
	          } else if (key.length > 1) {
	            key = key.charAt(0).toUpperCase() + key.substr(1);
	          }
	
	          return key;
	        }
	      }
	    });
	  }
	
	  function insertMultiDragElements(clonesInserted, rootEl) {
	    multiDragElements.forEach(function (multiDragElement, i) {
	      var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
	
	      if (target) {
	        rootEl.insertBefore(multiDragElement, target);
	      } else {
	        rootEl.appendChild(multiDragElement);
	      }
	    });
	  }
	  /**
	   * Insert multi-drag clones
	   * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
	   * @param  {HTMLElement} rootEl
	   */
	
	
	  function insertMultiDragClones(elementsInserted, rootEl) {
	    multiDragClones.forEach(function (clone, i) {
	      var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
	
	      if (target) {
	        rootEl.insertBefore(clone, target);
	      } else {
	        rootEl.appendChild(clone);
	      }
	    });
	  }
	
	  function removeMultiDragElements() {
	    multiDragElements.forEach(function (multiDragElement) {
	      if (multiDragElement === dragEl$1) return;
	      multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
	    });
	  }
	
	  Sortable.mount(new AutoScrollPlugin());
	  Sortable.mount(Remove, Revert);
	
	  Sortable.mount(new SwapPlugin());
	  Sortable.mount(new MultiDragPlugin());
	
	  return Sortable;
	
	}));


/***/ }),
/* 1769 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 1771 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.8.1
	  * (c) 2017 Evan You
	  * @license MIT
	  */
	'use strict';
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (false) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
	  }
	}
	
	function isError (err) {
	  return Object.prototype.toString.call(err).indexOf('Error') > -1
	}
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (_, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true;
	
	    // directly use parent context's createElement() function
	    // so that components rendered by router-view can resolve named slots
	    var h = parent.$createElement;
	    var name = props.name;
	    var route = parent.$route;
	    var cache = parent._routerViewCache || (parent._routerViewCache = {});
	
	    // determine current view depth, also check to see if the tree
	    // has been toggled inactive but kept-alive.
	    var depth = 0;
	    var inactive = false;
	    while (parent && parent._routerRoot !== parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++;
	      }
	      if (parent._inactive) {
	        inactive = true;
	      }
	      parent = parent.$parent;
	    }
	    data.routerViewDepth = depth;
	
	    // render previous view if the tree is inactive and kept-alive
	    if (inactive) {
	      return h(cache[name], data, children)
	    }
	
	    var matched = route.matched[depth];
	    // render empty node if no matched route
	    if (!matched) {
	      cache[name] = null;
	      return h()
	    }
	
	    var component = cache[name] = matched.components[name];
	
	    // attach instance registration hook
	    // this will be called in the instance's injected lifecycle hooks
	    data.registerRouteInstance = function (vm, val) {
	      // val could be undefined for unregistration
	      var current = matched.instances[name];
	      if (
	        (val && current !== vm) ||
	        (!val && current === vm)
	      ) {
	        matched.instances[name] = val;
	      }
	    }
	
	    // also register instance in prepatch hook
	    // in case the same component instance is reused across different routes
	    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
	      matched.instances[name] = vnode.componentInstance;
	    };
	
	    // resolve props
	    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
	    if (propsToPass) {
	      // clone to prevent mutation
	      propsToPass = data.props = extend({}, propsToPass);
	      // pass non-declared props as attrs
	      var attrs = data.attrs = data.attrs || {};
	      for (var key in propsToPass) {
	        if (!component.props || !(key in component.props)) {
	          attrs[key] = propsToPass[key];
	          delete propsToPass[key];
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	};
	
	function resolveProps (route, config) {
	  switch (typeof config) {
	    case 'undefined':
	      return
	    case 'object':
	      return config
	    case 'function':
	      return config(route)
	    case 'boolean':
	      return config ? route.params : undefined
	    default:
	      if (false) {
	        warn(
	          false,
	          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
	          "expecting an object, function or boolean."
	        );
	      }
	  }
	}
	
	function extend (to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to
	}
	
	/*  */
	
	var encodeReserveRE = /[!'()*]/g;
	var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
	var commaRE = /%2C/g;
	
	// fixed encodeURIComponent which is more conformant to RFC3986:
	// - escapes [!'()*]
	// - preserve commas
	var encode = function (str) { return encodeURIComponent(str)
	  .replace(encodeReserveRE, encodeReserveReplacer)
	  .replace(commaRE, ','); };
	
	var decode = decodeURIComponent;
	
	function resolveQuery (
	  query,
	  extraQuery,
	  _parseQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  var parse = _parseQuery || parseQuery;
	  var parsedQuery;
	  try {
	    parsedQuery = parse(query || '');
	  } catch (e) {
	    ("production") !== 'production' && warn(false, e.message);
	    parsedQuery = {};
	  }
	  for (var key in extraQuery) {
	    parsedQuery[key] = extraQuery[key];
	  }
	  return parsedQuery
	}
	
	function parseQuery (query) {
	  var res = {};
	
	  query = query.trim().replace(/^(\?|#|&)/, '');
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=');
	    var key = decode(parts.shift());
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null;
	
	    if (res[key] === undefined) {
	      res[key] = val;
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val);
	    } else {
	      res[key] = [res[key], val];
	    }
	  });
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key];
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = [];
	      val.forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key));
	        } else {
	          result.push(encode(key) + '=' + encode(val2));
	        }
	      });
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null;
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	
	var trailingSlashRE = /\/?$/;
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom,
	  router
	) {
	  var stringifyQuery$$1 = router && router.options.stringifyQuery;
	
	  var query = location.query || {};
	  try {
	    query = clone(query);
	  } catch (e) {}
	
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: query,
	    params: location.params || {},
	    fullPath: getFullPath(location, stringifyQuery$$1),
	    matched: record ? formatMatch(record) : []
	  };
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
	  }
	  return Object.freeze(route)
	}
	
	function clone (value) {
	  if (Array.isArray(value)) {
	    return value.map(clone)
	  } else if (value && typeof value === 'object') {
	    var res = {};
	    for (var key in value) {
	      res[key] = clone(value[key]);
	    }
	    return res
	  } else {
	    return value
	  }
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	});
	
	function formatMatch (record) {
	  var res = [];
	  while (record) {
	    res.unshift(record);
	    record = record.parent;
	  }
	  return res
	}
	
	function getFullPath (
	  ref,
	  _stringifyQuery
	) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  var stringify = _stringifyQuery || stringifyQuery;
	  return (path || '/') + stringify(query) + hash
	}
	
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  // handle null value #1566
	  if (!a || !b) { return a === b }
	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) {
	    var aVal = a[key];
	    var bVal = b[key];
	    // check nested equality
	    if (typeof aVal === 'object' && typeof bVal === 'object') {
	      return isObjectEqual(aVal, bVal)
	    }
	    return String(aVal) === String(bVal)
	  })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.replace(trailingSlashRE, '/').indexOf(
	      target.path.replace(trailingSlashRE, '/')
	    ) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object];
	var eventTypes = [String, Array];
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    exactActiveClass: String,
	    event: {
	      type: eventTypes,
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router;
	    var current = this.$route;
	    var ref = router.resolve(this.to, current, this.append);
	    var location = ref.location;
	    var route = ref.route;
	    var href = ref.href;
	
	    var classes = {};
	    var globalActiveClass = router.options.linkActiveClass;
	    var globalExactActiveClass = router.options.linkExactActiveClass;
	    // Support global empty active class
	    var activeClassFallback = globalActiveClass == null
	            ? 'router-link-active'
	            : globalActiveClass;
	    var exactActiveClassFallback = globalExactActiveClass == null
	            ? 'router-link-exact-active'
	            : globalExactActiveClass;
	    var activeClass = this.activeClass == null
	            ? activeClassFallback
	            : this.activeClass;
	    var exactActiveClass = this.exactActiveClass == null
	            ? exactActiveClassFallback
	            : this.exactActiveClass;
	    var compareTarget = location.path
	      ? createRoute(null, location, null, router)
	      : route;
	
	    classes[exactActiveClass] = isSameRoute(current, compareTarget);
	    classes[activeClass] = this.exact
	      ? classes[exactActiveClass]
	      : isIncludedRoute(current, compareTarget);
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(location);
	        } else {
	          router.push(location);
	        }
	      }
	    };
	
	    var on = { click: guardEvent };
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler; });
	    } else {
	      on[this.event] = handler;
	    }
	
	    var data = {
	      class: classes
	    };
	
	    if (this.tag === 'a') {
	      data.on = on;
	      data.attrs = { href: href };
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default);
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false;
	        var extend = _Vue.util.extend;
	        var aData = a.data = extend({}, a.data);
	        aData.on = on;
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
	        aAttrs.href = href;
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on;
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	};
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  if (e.button !== undefined && e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  if (e.currentTarget && e.currentTarget.getAttribute) {
	    var target = e.currentTarget.getAttribute('target');
	    if (/\b_blank\b/i.test(target)) { return }
	  }
	  // this may be a Weex event which doesn't have this method
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child;
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue;
	
	function install (Vue) {
	  if (install.installed && _Vue === Vue) { return }
	  install.installed = true;
	
	  _Vue = Vue;
	
	  var isDef = function (v) { return v !== undefined; };
	
	  var registerInstance = function (vm, callVal) {
	    var i = vm.$options._parentVnode;
	    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
	      i(vm, callVal);
	    }
	  };
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (isDef(this.$options.router)) {
	        this._routerRoot = this;
	        this._router = this.$options.router;
	        this._router.init(this);
	        Vue.util.defineReactive(this, '_route', this._router.history.current);
	      } else {
	        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
	      }
	      registerInstance(this, this);
	    },
	    destroyed: function destroyed () {
	      registerInstance(this);
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this._routerRoot._router }
	  });
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get () { return this._routerRoot._route }
	  });
	
	  Vue.component('router-view', View);
	  Vue.component('router-link', Link);
	
	  var strats = Vue.config.optionMergeStrategies;
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined';
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  var firstChar = relative.charAt(0);
	  if (firstChar === '/') {
	    return relative
	  }
	
	  if (firstChar === '?' || firstChar === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/');
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop();
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/');
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	    if (segment === '..') {
	      stack.pop();
	    } else if (segment !== '.') {
	      stack.push(segment);
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('');
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = '';
	  var query = '';
	
	  var hashIndex = path.indexOf('#');
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex);
	    path = path.slice(0, hashIndex);
	  }
	
	  var queryIndex = path.indexOf('?');
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1);
	    path = path.slice(0, queryIndex);
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	var isarray = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys;
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	// $flow-disable-line
	var regexpCompileCache = Object.create(null);
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function createRouteMap (
	  routes,
	  oldPathList,
	  oldPathMap,
	  oldNameMap
	) {
	  // the path list is used to control path matching priority
	  var pathList = oldPathList || [];
	  // $flow-disable-line
	  var pathMap = oldPathMap || Object.create(null);
	  // $flow-disable-line
	  var nameMap = oldNameMap || Object.create(null);
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathList, pathMap, nameMap, route);
	  });
	
	  // ensure wildcard routes are always at the end
	  for (var i = 0, l = pathList.length; i < l; i++) {
	    if (pathList[i] === '*') {
	      pathList.push(pathList.splice(i, 1)[0]);
	      l--;
	      i--;
	    }
	  }
	
	  return {
	    pathList: pathList,
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathList,
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.");
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    );
	  }
	
	  var pathToRegexpOptions = route.pathToRegexpOptions || {};
	  var normalizedPath = normalizePath(
	    path,
	    parent,
	    pathToRegexpOptions.strict
	  );
	
	  if (typeof route.caseSensitive === 'boolean') {
	    pathToRegexpOptions.sensitive = route.caseSensitive;
	  }
	
	  var record = {
	    path: normalizedPath,
	    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {},
	    props: route.props == null
	      ? {}
	      : route.components
	        ? route.props
	        : { default: route.props }
	  };
	
	  if (route.children) {
	    // Warn if route is named, does not redirect and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(
	          false,
	          "Named Route '" + (route.name) + "' has a default child route. " +
	          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
	          "the default child route will not be rendered. Remove the name from " +
	          "this route and use the name of the default child route for named " +
	          "links instead."
	        );
	      }
	    }
	    route.children.forEach(function (child) {
	      var childMatchAs = matchAs
	        ? cleanPath((matchAs + "/" + (child.path)))
	        : undefined;
	      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
	    });
	  }
	
	  if (route.alias !== undefined) {
	    var aliases = Array.isArray(route.alias)
	      ? route.alias
	      : [route.alias];
	
	    aliases.forEach(function (alias) {
	      var aliasRoute = {
	        path: alias,
	        children: route.children
	      };
	      addRouteRecord(
	        pathList,
	        pathMap,
	        nameMap,
	        aliasRoute,
	        parent,
	        record.path || '/' // matchAs
	      );
	    });
	  }
	
	  if (!pathMap[record.path]) {
	    pathList.push(record.path);
	    pathMap[record.path] = record;
	  }
	
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record;
	    } else if (false) {
	      warn(
	        false,
	        "Duplicate named routes definition: " +
	        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
	      );
	    }
	  }
	}
	
	function compileRouteRegex (path, pathToRegexpOptions) {
	  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
	  if (false) {
	    var keys = Object.create(null);
	    regex.keys.forEach(function (key) {
	      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
	      keys[key.name] = true;
	    });
	  }
	  return regex
	}
	
	function normalizePath (path, parent, strict) {
	  if (!strict) { path = path.replace(/\/$/, ''); }
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	/*  */
	
	
	function normalizeLocation (
	  raw,
	  current,
	  append,
	  router
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw;
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next);
	    next._normalized = true;
	    var params = assign(assign({}, current.params), next.params);
	    if (current.name) {
	      next.name = current.name;
	      next.params = params;
	    } else if (current.matched.length) {
	      var rawPath = current.matched[current.matched.length - 1].path;
	      next.path = fillParams(rawPath, params, ("path " + (current.path)));
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.");
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '');
	  var basePath = (current && current.path) || '/';
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : basePath;
	
	  var query = resolveQuery(
	    parsedPath.query,
	    next.query,
	    router && router.options.parseQuery
	  );
	
	  var hash = next.hash || parsedPath.hash;
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash;
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key];
	  }
	  return a
	}
	
	/*  */
	
	
	function createMatcher (
	  routes,
	  router
	) {
	  var ref = createRouteMap(routes);
	  var pathList = ref.pathList;
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function addRoutes (routes) {
	    createRouteMap(routes, pathList, pathMap, nameMap);
	  }
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute, false, router);
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name];
	      if (false) {
	        warn(record, ("Route with name '" + name + "' does not exist"));
	      }
	      if (!record) { return _createRoute(null, location) }
	      var paramNames = record.regex.keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; });
	
	      if (typeof location.params !== 'object') {
	        location.params = {};
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key];
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {};
	      for (var i = 0; i < pathList.length; i++) {
	        var path = pathList[i];
	        var record$1 = pathMap[path];
	        if (matchRoute(record$1.regex, location.path, location.params)) {
	          return _createRoute(record$1, location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect;
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location, null, router))
	        : originalRedirect;
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect };
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      if (false) {
	        warn(
	          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	        );
	      }
	      return _createRoute(null, location)
	    }
	
	    var re = redirect;
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query;
	    hash = re.hasOwnProperty('hash') ? re.hash : hash;
	    params = re.hasOwnProperty('params') ? re.params : params;
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name];
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record);
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      if (false) {
	        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
	      }
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    });
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched;
	      var aliasedRecord = matched[matched.length - 1];
	      location.params = aliasedMatch.params;
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom, router)
	  }
	
	  return {
	    match: match,
	    addRoutes: addRoutes
	  }
	}
	
	function matchRoute (
	  regex,
	  path,
	  params
	) {
	  var m = path.match(regex);
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = regex.keys[i - 1];
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
	    if (key) {
	      params[key.name] = val;
	    }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	
	var positionStore = Object.create(null);
	
	function setupScroll () {
	  // Fix for #1585 for Firefox
	  window.history.replaceState({ key: getStateKey() }, '');
	  window.addEventListener('popstate', function (e) {
	    saveScrollPosition();
	    if (e.state && e.state.key) {
	      setStateKey(e.state.key);
	    }
	  });
	}
	
	function handleScroll (
	  router,
	  to,
	  from,
	  isPop
	) {
	  if (!router.app) {
	    return
	  }
	
	  var behavior = router.options.scrollBehavior;
	  if (!behavior) {
	    return
	  }
	
	  if (false) {
	    assert(typeof behavior === 'function', "scrollBehavior must be a function");
	  }
	
	  // wait until re-render finishes before scrolling
	  router.app.$nextTick(function () {
	    var position = getScrollPosition();
	    var shouldScroll = behavior(to, from, isPop ? position : null);
	
	    if (!shouldScroll) {
	      return
	    }
	
	    if (typeof shouldScroll.then === 'function') {
	      shouldScroll.then(function (shouldScroll) {
	        scrollToPosition((shouldScroll), position);
	      }).catch(function (err) {
	        if (false) {
	          assert(false, err.toString());
	        }
	      });
	    } else {
	      scrollToPosition(shouldScroll, position);
	    }
	  });
	}
	
	function saveScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    positionStore[key] = {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	}
	
	function getScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    return positionStore[key]
	  }
	}
	
	function getElementPosition (el, offset) {
	  var docEl = document.documentElement;
	  var docRect = docEl.getBoundingClientRect();
	  var elRect = el.getBoundingClientRect();
	  return {
	    x: elRect.left - docRect.left - offset.x,
	    y: elRect.top - docRect.top - offset.y
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function normalizeOffset (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : 0,
	    y: isNumber(obj.y) ? obj.y : 0
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	function scrollToPosition (shouldScroll, position) {
	  var isObject = typeof shouldScroll === 'object';
	  if (isObject && typeof shouldScroll.selector === 'string') {
	    var el = document.querySelector(shouldScroll.selector);
	    if (el) {
	      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
	      offset = normalizeOffset(offset);
	      position = getElementPosition(el, offset);
	    } else if (isValidPosition(shouldScroll)) {
	      position = normalizePosition(shouldScroll);
	    }
	  } else if (isObject && isValidPosition(shouldScroll)) {
	    position = normalizePosition(shouldScroll);
	  }
	
	  if (position) {
	    window.scrollTo(position.x, position.y);
	  }
	}
	
	/*  */
	
	var supportsPushState = inBrowser && (function () {
	  var ua = window.navigator.userAgent;
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})();
	
	// use User Timing api (if present) for more accurate key precision
	var Time = inBrowser && window.performance && window.performance.now
	  ? window.performance
	  : Date;
	
	var _key = genKey();
	
	function genKey () {
	  return Time.now().toFixed(3)
	}
	
	function getStateKey () {
	  return _key
	}
	
	function setStateKey (key) {
	  _key = key;
	}
	
	function pushState (url, replace) {
	  saveScrollPosition();
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history;
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url);
	    } else {
	      _key = genKey();
	      history.pushState({ key: _key }, '', url);
	    }
	  } catch (e) {
	    window.location[replace ? 'replace' : 'assign'](url);
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true);
	}
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb();
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1);
	        });
	      } else {
	        step(index + 1);
	      }
	    }
	  };
	  step(0);
	}
	
	/*  */
	
	function resolveAsyncComponents (matched) {
	  return function (to, from, next) {
	    var hasAsync = false;
	    var pending = 0;
	    var error = null;
	
	    flatMapComponents(matched, function (def, _, match, key) {
	      // if it's a function and doesn't have cid attached,
	      // assume it's an async component resolve function.
	      // we are not using Vue's default async resolving mechanism because
	      // we want to halt the navigation until the incoming component has been
	      // resolved.
	      if (typeof def === 'function' && def.cid === undefined) {
	        hasAsync = true;
	        pending++;
	
	        var resolve = once(function (resolvedDef) {
	          if (isESModule(resolvedDef)) {
	            resolvedDef = resolvedDef.default;
	          }
	          // save resolved on async factory in case it's used elsewhere
	          def.resolved = typeof resolvedDef === 'function'
	            ? resolvedDef
	            : _Vue.extend(resolvedDef);
	          match.components[key] = resolvedDef;
	          pending--;
	          if (pending <= 0) {
	            next();
	          }
	        });
	
	        var reject = once(function (reason) {
	          var msg = "Failed to resolve async component " + key + ": " + reason;
	          ("production") !== 'production' && warn(false, msg);
	          if (!error) {
	            error = isError(reason)
	              ? reason
	              : new Error(msg);
	            next(error);
	          }
	        });
	
	        var res;
	        try {
	          res = def(resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        if (res) {
	          if (typeof res.then === 'function') {
	            res.then(resolve, reject);
	          } else {
	            // new syntax in Vue 2.3
	            var comp = res.component;
	            if (comp && typeof comp.then === 'function') {
	              comp.then(resolve, reject);
	            }
	          }
	        }
	      }
	    });
	
	    if (!hasAsync) { next(); }
	  }
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	var hasSymbol =
	  typeof Symbol === 'function' &&
	  typeof Symbol.toStringTag === 'symbol';
	
	function isESModule (obj) {
	  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
	}
	
	// in Webpack 2, require.ensure now also returns a Promise
	// so the resolve/reject functions may get called an extra time
	// if the user uses an arrow function shorthand that happens to
	// return that Promise.
	function once (fn) {
	  var called = false;
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    if (called) { return }
	    called = true;
	    return fn.apply(this, args)
	  }
	}
	
	/*  */
	
	var History = function History (router, base) {
	  this.router = router;
	  this.base = normalizeBase(base);
	  // start with a route object that stands for "nowhere"
	  this.current = START;
	  this.pending = null;
	  this.ready = false;
	  this.readyCbs = [];
	  this.readyErrorCbs = [];
	  this.errorCbs = [];
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb;
	};
	
	History.prototype.onReady = function onReady (cb, errorCb) {
	  if (this.ready) {
	    cb();
	  } else {
	    this.readyCbs.push(cb);
	    if (errorCb) {
	      this.readyErrorCbs.push(errorCb);
	    }
	  }
	};
	
	History.prototype.onError = function onError (errorCb) {
	  this.errorCbs.push(errorCb);
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current);
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route);
	    onComplete && onComplete(route);
	    this$1.ensureURL();
	
	    // fire ready cbs once
	    if (!this$1.ready) {
	      this$1.ready = true;
	      this$1.readyCbs.forEach(function (cb) { cb(route); });
	    }
	  }, function (err) {
	    if (onAbort) {
	      onAbort(err);
	    }
	    if (err && !this$1.ready) {
	      this$1.ready = true;
	      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
	    }
	  });
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current;
	  var abort = function (err) {
	    if (isError(err)) {
	      if (this$1.errorCbs.length) {
	        this$1.errorCbs.forEach(function (cb) { cb(err); });
	      } else {
	        warn(false, 'uncaught error during route navigation:');
	        console.error(err);
	      }
	    }
	    onAbort && onAbort(err);
	  };
	  if (
	    isSameRoute(route, current) &&
	    // in the case the route map has been dynamically appended to
	    route.matched.length === current.matched.length
	  ) {
	    this.ensureURL();
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var updated = ref.updated;
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // in-component update hooks
	    extractUpdateHooks(updated),
	    // in-config enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  );
	
	  this.pending = route;
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    try {
	      hook(route, current, function (to) {
	        if (to === false || isError(to)) {
	          // next(false) -> abort navigation, ensure current URL
	          this$1.ensureURL(true);
	          abort(to);
	        } else if (
	          typeof to === 'string' ||
	          (typeof to === 'object' && (
	            typeof to.path === 'string' ||
	            typeof to.name === 'string'
	          ))
	        ) {
	          // next('/') or next({ path: '/' }) -> redirect
	          abort();
	          if (typeof to === 'object' && to.replace) {
	            this$1.replace(to);
	          } else {
	            this$1.push(to);
	          }
	        } else {
	          // confirm transition and pass on the value
	          next(to);
	        }
	      });
	    } catch (e) {
	      abort(e);
	    }
	  };
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = [];
	    var isValid = function () { return this$1.current === route; };
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
	    var queue = enterGuards.concat(this$1.router.resolveHooks);
	    runQueue(queue, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null;
	      onComplete(route);
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { cb(); });
	        });
	      }
	    });
	  });
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current;
	  this.current = route;
	  this.cb && this.cb(route);
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev);
	  });
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base');
	      base = (baseEl && baseEl.getAttribute('href')) || '/';
	      // strip full URL origin
	      base = base.replace(/^https?:\/\/[^\/]+/, '');
	    } else {
	      base = '/';
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base;
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i;
	  var max = Math.max(current.length, next.length);
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    updated: next.slice(0, i),
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuards (
	  records,
	  name,
	  bind,
	  reverse
	) {
	  var guards = flatMapComponents(records, function (def, instance, match, key) {
	    var guard = extractGuard(def, name);
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
	        : bind(guard, instance, match, key)
	    }
	  });
	  return flatten(reverse ? guards.reverse() : guards)
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def);
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (deactivated) {
	  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
	}
	
	function extractUpdateHooks (updated) {
	  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
	}
	
	function bindGuard (guard, instance) {
	  if (instance) {
	    return function boundRouteGuard () {
	      return guard.apply(instance, arguments)
	    }
	  }
	}
	
	function extractEnterGuards (
	  activated,
	  cbs,
	  isValid
	) {
	  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
	    return bindEnterGuard(guard, match, key, cbs, isValid)
	  })
	}
	
	function bindEnterGuard (
	  guard,
	  match,
	  key,
	  cbs,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb);
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid);
	        });
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key]);
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid);
	    }, 16);
	  }
	}
	
	/*  */
	
	
	var HTML5History = (function (History$$1) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History$$1.call(this, router, base);
	
	    var expectScroll = router.options.scrollBehavior;
	
	    if (expectScroll) {
	      setupScroll();
	    }
	
	    var initLocation = getLocation(this.base);
	    window.addEventListener('popstate', function (e) {
	      var current = this$1.current;
	
	      // Avoiding first `popstate` event dispatched in some browsers but first
	      // history route not updated since async guard at the same time.
	      var location = getLocation(this$1.base);
	      if (this$1.current === START && location === initLocation) {
	        return
	      }
	
	      this$1.transitionTo(location, function (route) {
	        if (expectScroll) {
	          handleScroll(router, route, current, true);
	        }
	      });
	    });
	  }
	
	  if ( History$$1 ) HTML5History.__proto__ = History$$1;
	  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath);
	      push ? pushState(current) : replaceState(current);
	    }
	  };
	
	  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getLocation(this.base)
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname;
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length);
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	/*  */
	
	
	var HashHistory = (function (History$$1) {
	  function HashHistory (router, base, fallback) {
	    History$$1.call(this, router, base);
	    // check history fallback deeplinking
	    if (fallback && checkFallback(this.base)) {
	      return
	    }
	    ensureSlash();
	  }
	
	  if ( History$$1 ) HashHistory.__proto__ = History$$1;
	  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  // this is delayed until the app mounts
	  // to avoid the hashchange listener being fired too early
	  HashHistory.prototype.setupListeners = function setupListeners () {
	    var this$1 = this;
	
	    var router = this.router;
	    var expectScroll = router.options.scrollBehavior;
	    var supportsScroll = supportsPushState && expectScroll;
	
	    if (supportsScroll) {
	      setupScroll();
	    }
	
	    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
	      var current = this$1.current;
	      if (!ensureSlash()) {
	        return
	      }
	      this$1.transitionTo(getHash(), function (route) {
	        if (supportsScroll) {
	          handleScroll(this$1.router, route, current, true);
	        }
	        if (!supportsPushState) {
	          replaceHash(route.fullPath);
	        }
	      });
	    });
	  };
	
	  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath;
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current);
	    }
	  };
	
	  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getHash()
	  };
	
	  return HashHistory;
	}(History));
	
	function checkFallback (base) {
	  var location = getLocation(base);
	  if (!/^\/#/.test(location)) {
	    window.location.replace(
	      cleanPath(base + '/#' + location)
	    );
	    return true
	  }
	}
	
	function ensureSlash () {
	  var path = getHash();
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path);
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var index = href.indexOf('#');
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function getUrl (path) {
	  var href = window.location.href;
	  var i = href.indexOf('#');
	  var base = i >= 0 ? href.slice(0, i) : href;
	  return (base + "#" + path)
	}
	
	function pushHash (path) {
	  if (supportsPushState) {
	    pushState(getUrl(path));
	  } else {
	    window.location.hash = path;
	  }
	}
	
	function replaceHash (path) {
	  if (supportsPushState) {
	    replaceState(getUrl(path));
	  } else {
	    window.location.replace(getUrl(path));
	  }
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History$$1) {
	  function AbstractHistory (router, base) {
	    History$$1.call(this, router, base);
	    this.stack = [];
	    this.index = -1;
	  }
	
	  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
	  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
	      this$1.index++;
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n;
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex];
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex;
	      this$1.updateRoute(route);
	    });
	  };
	
	  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    var current = this.stack[this.stack.length - 1];
	    return current ? current.fullPath : '/'
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null;
	  this.apps = [];
	  this.options = options;
	  this.beforeHooks = [];
	  this.resolveHooks = [];
	  this.afterHooks = [];
	  this.matcher = createMatcher(options.routes || [], this);
	
	  var mode = options.mode || 'hash';
	  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
	  if (this.fallback) {
	    mode = 'hash';
	  }
	  if (!inBrowser) {
	    mode = 'abstract';
	  }
	  this.mode = mode;
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base);
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback);
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this, options.base);
	      break
	    default:
	      if (false) {
	        assert(false, ("invalid mode: " + mode));
	      }
	  }
	};
	
	var prototypeAccessors = { currentRoute: { configurable: true } };
	
	VueRouter.prototype.match = function match (
	  raw,
	  current,
	  redirectedFrom
	) {
	  return this.matcher.match(raw, current, redirectedFrom)
	};
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  );
	
	  this.apps.push(app);
	
	  // main app already initialized.
	  if (this.app) {
	    return
	  }
	
	  this.app = app;
	
	  var history = this.history;
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(history.getCurrentLocation());
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      history.setupListeners();
	    };
	    history.transitionTo(
	      history.getCurrentLocation(),
	      setupHashListener,
	      setupHashListener
	    );
	  }
	
	  history.listen(function (route) {
	    this$1.apps.forEach(function (app) {
	      app._route = route;
	    });
	  });
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  return registerHook(this.beforeHooks, fn)
	};
	
	VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
	  return registerHook(this.resolveHooks, fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  return registerHook(this.afterHooks, fn)
	};
	
	VueRouter.prototype.onReady = function onReady (cb, errorCb) {
	  this.history.onReady(cb, errorCb);
	};
	
	VueRouter.prototype.onError = function onError (errorCb) {
	  this.history.onError(errorCb);
	};
	
	VueRouter.prototype.push = function push (location, onComplete, onAbort) {
	  this.history.push(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
	  this.history.replace(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n);
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1);
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1);
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? to.matched
	      ? to
	      : this.resolve(to).route
	    : this.currentRoute;
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var location = normalizeLocation(
	    to,
	    current || this.history.current,
	    append,
	    this
	  );
	  var route = this.match(location, current);
	  var fullPath = route.redirectedFrom || route.fullPath;
	  var base = this.history.base;
	  var href = createHref(base, fullPath, this.mode);
	  return {
	    location: location,
	    route: route,
	    href: href,
	    // for backwards compat
	    normalizedTo: location,
	    resolved: route
	  }
	};
	
	VueRouter.prototype.addRoutes = function addRoutes (routes) {
	  this.matcher.addRoutes(routes);
	  if (this.history.current !== START) {
	    this.history.transitionTo(this.history.getCurrentLocation());
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function registerHook (list, fn) {
	  list.push(fn);
	  return function () {
	    var i = list.indexOf(fn);
	    if (i > -1) { list.splice(i, 1); }
	  }
	}
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath;
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install;
	VueRouter.version = '2.8.1';
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter);
	}
	
	module.exports = VueRouter;


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _eventsBinder = __webpack_require__(47);
	
	var _eventsBinder2 = _interopRequireDefault(_eventsBinder);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _mapElementMixin = __webpack_require__(55);
	
	var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);
	
	var _getPropsValuesMixin = __webpack_require__(42);
	
	var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var props = {
	  center: {
	    type: Object,
	    twoWay: true,
	    required: true
	  },
	  radius: {
	    type: Number,
	    default: 1000,
	    twoWay: true
	  },
	  draggable: {
	    type: Boolean,
	    default: false
	  },
	  editable: {
	    type: Boolean,
	    default: false
	  },
	  options: {
	    type: Object,
	    twoWay: false
	  }
	};
	
	var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];
	
	exports.default = {
	  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
	  props: props,
	  version: 2,
	
	  render: function render() {
	    return '';
	  },
	  deferredReady: function deferredReady() {
	    var options = _lodash2.default.clone(this.getPropsValues());
	    options.map = this.$map;
	    delete options.bounds;
	    this.createCircle(options);
	  },
	
	
	  methods: {
	    createCircle: function createCircle(options) {
	      var _this = this;
	
	      this.$circleObject = new google.maps.Circle(options);
	      // we cant bind bounds because there is no `setBounds` method
	      // on the Circle object
	      var boundProps = _lodash2.default.clone(props);
	      delete boundProps.bounds;
	      (0, _propsBinder2.default)(this, this.$circleObject, boundProps);
	      (0, _eventsBinder2.default)(this, this.$circleObject, events);
	
	      var updateBounds = function updateBounds() {
	        _this.$emit('bounds_changed', _this.$circleObject.getBounds());
	      };
	
	      this.$on('radius_changed', updateBounds);
	      this.$on('center_changed', updateBounds);
	    }
	  },
	
	  destroyed: function destroyed() {
	    if (this.$circleObject) {
	      this.$circleObject.setMap(null);
	    }
	  }
	};

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _eventsBinder = __webpack_require__(47);
	
	var _eventsBinder2 = _interopRequireDefault(_eventsBinder);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _mapElementMixin = __webpack_require__(55);
	
	var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);
	
	var _getPropsValuesMixin = __webpack_require__(42);
	
	var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);
	
	var _markerClustererPlus = __webpack_require__(1724);
	
	var _markerClustererPlus2 = _interopRequireDefault(_markerClustererPlus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* vim: set softtabstop=2 shiftwidth=2 expandtab : */
	
	/**
	  * @class Cluster
	  * @prop $clusterObject -- Exposes the marker clusterer to
	        descendent Marker classes. Override this if you area
	        extending the class
	**/
	
	var props = {
	  maxZoom: {
	    type: Number,
	    twoWay: false
	  },
	  calculator: {
	    type: Function,
	    twoWay: false
	  },
	  gridSize: {
	    type: Number,
	    twoWay: false
	  },
	  styles: {
	    type: Array,
	    twoWay: false
	  }
	};
	
	var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];
	
	exports.default = {
	  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
	  props: props,
	
	  render: function render(h) {
	    // <div><slot></slot></div>
	    return h('div', this.$slots.default);
	  },
	  deferredReady: function deferredReady() {
	    var _this = this;
	
	    var options = _lodash2.default.clone(this.getPropsValues());
	
	    if (typeof _markerClustererPlus2.default === 'undefined') {
	      /* eslint-disable no-console */
	      console.error('MarkerClusterer is not installed! require() it or include it from https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js');
	      throw new Error('MarkerClusterer is not installed! require() it or include it from https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js');
	    }
	
	    this.$clusterObject = new _markerClustererPlus2.default(this.$map, [], options);
	
	    (0, _propsBinder2.default)(this, this.$clusterObject, props, {
	      afterModelChanged: function afterModelChanged(a, v) {
	        // eslint-disable-line no-unused-vars
	        var oldMarkers = _this.$clusterObject.getMarkers();
	        _this.$clusterObject.clearMarkers();
	        _this.$clusterObject.addMarkers(oldMarkers);
	      }
	    });
	    (0, _eventsBinder2.default)(this, this.$clusterObject, events);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this2 = this;
	
	    /* Performance optimization when destroying a large number of markers */
	    this.$children.forEach(function (marker) {
	      if (marker.$clusterObject === _this2.$clusterObject) {
	        marker.$clusterObject = null;
	      }
	    });
	
	    this.$clusterObject.clearMarkers();
	  }
	};

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _eventsBinder = __webpack_require__(47);
	
	var _eventsBinder2 = _interopRequireDefault(_eventsBinder);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _getPropsValuesMixin = __webpack_require__(42);
	
	var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);
	
	var _mapElementMixin = __webpack_require__(55);
	
	var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var props = {
	  animation: {
	    twoWay: true,
	    type: Number
	  },
	  attribution: {
	    type: Object
	  },
	  clickable: {
	    type: Boolean,
	    twoWay: true,
	    default: true
	  },
	  cursor: {
	    type: String,
	    twoWay: true
	  },
	  draggable: {
	    type: Boolean,
	    twoWay: true,
	    default: false
	  },
	  icon: {
	    twoWay: true
	  },
	  label: {},
	  opacity: {
	    type: Number,
	    default: 1
	  },
	  place: {
	    type: Object
	  },
	  position: {
	    type: Object,
	    twoWay: true
	  },
	  shape: {
	    type: Object,
	    twoWay: true
	  },
	  title: {
	    type: String,
	    twoWay: true
	  },
	  zIndex: {
	    type: Number,
	    twoWay: true
	  },
	  visible: {
	    twoWay: true,
	    default: true
	  }
	};
	
	var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];
	
	/**
	 * @class Marker
	 *
	 * Marker class with extra support for
	 *
	 * - Embedded info windows
	 * - Clustered markers
	 *
	 * Support for clustered markers is for backward-compatability
	 * reasons. Otherwise we should use a cluster-marker mixin or
	 * subclass.
	 */
	exports.default = {
	  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
	  props: props,
	
	  render: function render(h) {
	    if (!this.$slots.default || this.$slots.default.length == 0) {
	      return '';
	    } else if (this.$slots.default.length == 1) {
	      // So that infowindows can have a marker parent
	      return this.$slots.default[0];
	    } else {
	      return h('div', this.$slots.default);
	    }
	  },
	  destroyed: function destroyed() {
	    if (!this.$markerObject) return;
	
	    if (this.$clusterObject) {
	      this.$clusterObject.removeMarker(this.$markerObject);
	    } else {
	      this.$markerObject.setMap(null);
	    }
	  },
	  deferredReady: function deferredReady() {
	    var _this = this;
	
	    var options = _lodash2.default.mapValues(props, function (value, prop) {
	      return _this[prop];
	    });
	    options.map = this.$map;
	
	    // search ancestors for cluster object
	    var search = this.$findAncestor(function (ans) {
	      return ans.$clusterObject;
	    });
	
	    this.$clusterObject = search ? search.$clusterObject : null;
	    this.createMarker(options);
	  },
	
	
	  methods: {
	    createMarker: function createMarker(options) {
	      this.$markerObject = new google.maps.Marker(options);
	      (0, _propsBinder2.default)(this, this.$markerObject, props);
	      (0, _eventsBinder2.default)(this, this.$markerObject, events);
	
	      if (this.$clusterObject) {
	        this.$clusterObject.addMarker(this.$markerObject);
	      }
	    }
	  }
	};

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(188);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _eventsBinder = __webpack_require__(47);
	
	var _eventsBinder2 = _interopRequireDefault(_eventsBinder);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _mapElementMixin = __webpack_require__(55);
	
	var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);
	
	var _getPropsValuesMixin = __webpack_require__(42);
	
	var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var props = {
	  draggable: {
	    type: Boolean
	  },
	  editable: {
	    type: Boolean
	  },
	  options: {
	    type: Object
	  },
	  path: {
	    type: Array,
	    twoWay: true
	  },
	  paths: {
	    type: Array,
	    twoWay: true
	  },
	  deepWatch: {
	    type: Boolean,
	    default: false
	  }
	};
	
	var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];
	
	exports.default = {
	  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
	  props: props,
	
	  render: function render() {
	    return '';
	  },
	  destroyed: function destroyed() {
	    if (this.$polygonObject) {
	      this.$polygonObject.setMap(null);
	    }
	  },
	  deferredReady: function deferredReady() {
	    var _this = this;
	
	    var options = _lodash2.default.clone(this.getPropsValues());
	    delete options.options;
	    _lodash2.default.assign(options, this.options);
	    if (!options.path) {
	      delete options.path;
	    }
	    if (!options.paths) {
	      delete options.paths;
	    }
	    this.$polygonObject = new google.maps.Polygon(options);
	
	    (0, _propsBinder2.default)(this, this.$polygonObject, _lodash2.default.omit(props, ['path', 'paths', 'deepWatch']));
	    (0, _eventsBinder2.default)(this, this.$polygonObject, events);
	
	    var clearEvents = function clearEvents() {};
	
	    // Watch paths, on our own, because we do not want to set either when it is
	    // empty
	    this.$watch('paths', function (paths) {
	      if (paths) {
	        clearEvents();
	
	        _this.$polygonObject.setPaths(paths);
	
	        var updatePaths = function updatePaths() {
	          _this.$emit('paths_changed', _this.$polygonObject.getPaths());
	        };
	        var eventListeners = [];
	
	        var mvcArray = _this.$polygonObject.getPaths();
	        for (var i = 0; i < mvcArray.getLength(); i++) {
	          var mvcPath = mvcArray.getAt(i);
	          eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
	          eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
	          eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
	        }
	        eventListeners.push([mvcArray, mvcArray.addListener('insert_at', updatePaths)]);
	        eventListeners.push([mvcArray, mvcArray.addListener('remove_at', updatePaths)]);
	        eventListeners.push([mvcArray, mvcArray.addListener('set_at', updatePaths)]);
	
	        clearEvents = function clearEvents() {
	          eventListeners.map(function (_ref) {
	            var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	                obj = _ref2[0],
	                listenerHandle = _ref2[1];
	
	            return (// eslint-disable-line no-unused-vars
	              google.maps.event.removeListener(listenerHandle)
	            );
	          });
	        };
	      }
	    }, {
	      deep: this.deepWatch,
	      immediate: true
	    });
	
	    this.$watch('path', function (path) {
	      if (path) {
	        clearEvents();
	
	        _this.$polygonObject.setPaths(path);
	
	        var mvcPath = _this.$polygonObject.getPath();
	        var eventListeners = [];
	
	        var updatePaths = function updatePaths() {
	          _this.$emit('path_changed', _this.$polygonObject.getPath());
	        };
	
	        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
	        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
	        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
	
	        clearEvents = function clearEvents() {
	          eventListeners.map(function (_ref3) {
	            var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	                obj = _ref4[0],
	                listenerHandle = _ref4[1];
	
	            return (// eslint-disable-line no-unused-vars
	              google.maps.event.removeListener(listenerHandle)
	            );
	          });
	        };
	      }
	    }, {
	      deep: this.deepWatch,
	      immediate: true
	    });
	
	    // Display the map
	    this.$polygonObject.setMap(this.$map);
	  }
	};

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(188);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _eventsBinder = __webpack_require__(47);
	
	var _eventsBinder2 = _interopRequireDefault(_eventsBinder);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _mapElementMixin = __webpack_require__(55);
	
	var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);
	
	var _getPropsValuesMixin = __webpack_require__(42);
	
	var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var props = {
	  draggable: {
	    type: Boolean
	  },
	  editable: {
	    type: Boolean
	  },
	  options: {
	    twoWay: false,
	    type: Object
	  },
	  path: {
	    type: Array,
	    twoWay: true
	  },
	  deepWatch: {
	    type: Boolean,
	    default: false
	  }
	};
	
	var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];
	
	exports.default = {
	  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
	  props: props,
	
	  render: function render() {
	    return '';
	  },
	  destroyed: function destroyed() {
	    if (this.$polylineObject) {
	      this.$polylineObject.setMap(null);
	    }
	  },
	  deferredReady: function deferredReady() {
	    var _this = this;
	
	    var options = _lodash2.default.clone(this.getPropsValues());
	    delete options.options;
	    _lodash2.default.assign(options, this.options);
	    this.$polylineObject = new google.maps.Polyline(options);
	    this.$polylineObject.setMap(this.$map);
	
	    (0, _propsBinder2.default)(this, this.$polylineObject, _lodash2.default.omit(props, ['deepWatch', 'path']));
	    (0, _eventsBinder2.default)(this, this.$polylineObject, events);
	
	    var clearEvents = function clearEvents() {};
	
	    this.$watch('path', function (path) {
	      if (path) {
	        clearEvents();
	
	        _this.$polylineObject.setPath(path);
	
	        var mvcPath = _this.$polylineObject.getPath();
	        var eventListeners = [];
	
	        var updatePaths = function updatePaths() {
	          _this.$emit('path_changed', _this.$polylineObject.getPath());
	        };
	
	        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
	        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
	        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
	
	        clearEvents = function clearEvents() {
	          eventListeners.map(function (_ref) {
	            var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	                obj = _ref2[0],
	                listenerHandle = _ref2[1];
	
	            return (// eslint-disable-line no-unused-vars
	              google.maps.event.removeListener(listenerHandle)
	            );
	          });
	        };
	      }
	    }, {
	      deep: this.deepWatch
	    });
	
	    // Display the map
	    this.$polylineObject.setMap(this.$map);
	  }
	};

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _eventsBinder = __webpack_require__(47);
	
	var _eventsBinder2 = _interopRequireDefault(_eventsBinder);
	
	var _propsBinder = __webpack_require__(33);
	
	var _propsBinder2 = _interopRequireDefault(_propsBinder);
	
	var _mapElementMixin = __webpack_require__(55);
	
	var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);
	
	var _getPropsValuesMixin = __webpack_require__(42);
	
	var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var props = {
	  bounds: {
	    type: Object,
	    twoWay: true
	  },
	  draggable: {
	    type: Boolean,
	    default: false
	  },
	  editable: {
	    type: Boolean,
	    default: false
	  },
	  options: {
	    type: Object,
	    twoWay: false
	  }
	};
	
	var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];
	
	exports.default = {
	  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
	  props: props,
	
	  render: function render() {
	    return '';
	  },
	  deferredReady: function deferredReady() {
	    var options = _lodash2.default.clone(this.getPropsValues());
	    options.map = this.$map;
	    this.createRectangle(options);
	  },
	
	
	  methods: {
	    createRectangle: function createRectangle(options) {
	      this.$rectangleObject = new google.maps.Rectangle(options);
	      (0, _propsBinder2.default)(this, this.$rectangleObject, props);
	      (0, _eventsBinder2.default)(this, this.$rectangleObject, events);
	    }
	  },
	
	  destroyed: function destroyed() {
	    if (this.$rectangleObject) {
	      this.$rectangleObject.setMap(null);
	    }
	  }
	};

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MountableMixin = exports.Autocomplete = exports.MapElementMixin = exports.PlaceInput = exports.Map = exports.InfoWindow = exports.Rectangle = exports.Circle = exports.Polygon = exports.Polyline = exports.Cluster = exports.Marker = exports.loaded = exports.load = undefined;
	exports.install = install;
	
	var _manager = __webpack_require__(91);
	
	var _marker = __webpack_require__(1841);
	
	var _marker2 = _interopRequireDefault(_marker);
	
	var _cluster = __webpack_require__(1840);
	
	var _cluster2 = _interopRequireDefault(_cluster);
	
	var _polyline = __webpack_require__(1843);
	
	var _polyline2 = _interopRequireDefault(_polyline);
	
	var _polygon = __webpack_require__(1842);
	
	var _polygon2 = _interopRequireDefault(_polygon);
	
	var _circle = __webpack_require__(1839);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	var _rectangle = __webpack_require__(1844);
	
	var _rectangle2 = _interopRequireDefault(_rectangle);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _infoWindow = __webpack_require__(1773);
	
	var _infoWindow2 = _interopRequireDefault(_infoWindow);
	
	var _map = __webpack_require__(1774);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _streetViewPanorama = __webpack_require__(1776);
	
	var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);
	
	var _placeInput = __webpack_require__(1775);
	
	var _placeInput2 = _interopRequireDefault(_placeInput);
	
	var _autocomplete = __webpack_require__(1772);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _mapElementMixin = __webpack_require__(55);
	
	var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);
	
	var _mountableMixin = __webpack_require__(171);
	
	var _mountableMixin2 = _interopRequireDefault(_mountableMixin);
	
	var _deferredReady = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// export everything
	
	
	// Vue component imports
	exports.load = _manager.load;
	exports.loaded = _manager.loaded;
	exports.Marker = _marker2.default;
	exports.Cluster = _cluster2.default;
	exports.Polyline = _polyline2.default;
	exports.Polygon = _polygon2.default;
	exports.Circle = _circle2.default;
	exports.Rectangle = _rectangle2.default;
	exports.InfoWindow = _infoWindow2.default;
	exports.Map = _map2.default;
	exports.PlaceInput = _placeInput2.default;
	exports.MapElementMixin = _mapElementMixin2.default;
	exports.Autocomplete = _autocomplete2.default;
	exports.MountableMixin = _mountableMixin2.default;
	function install(Vue, options) {
	  options = _lodash2.default.defaults(options, {
	    installComponents: true
	  });
	
	  Vue.use(_deferredReady.DeferredReady);
	
	  var defaultResizeBus = new Vue();
	  Vue.$gmapDefaultResizeBus = defaultResizeBus;
	  Vue.mixin({
	    created: function created() {
	      this.$gmapDefaultResizeBus = defaultResizeBus;
	    }
	  });
	
	  if (options.load) {
	    (0, _manager.load)(options.load);
	  }
	
	  if (options.installComponents) {
	    Vue.component('GmapMap', _map2.default);
	    Vue.component('GmapMarker', _marker2.default);
	    Vue.component('GmapCluster', _cluster2.default);
	    Vue.component('GmapInfoWindow', _infoWindow2.default);
	    Vue.component('GmapPolyline', _polyline2.default);
	    Vue.component('GmapPolygon', _polygon2.default);
	    Vue.component('GmapCircle', _circle2.default);
	    Vue.component('GmapRectangle', _rectangle2.default);
	    Vue.component('GmapAutocomplete', _autocomplete2.default);
	    Vue.component('GmapPlaceInput', _placeInput2.default);
	    Vue.component('GmapStreetViewPanorama', _streetViewPanorama2.default);
	  }
	}

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	(function(t,e){ true?module.exports=e(__webpack_require__(1768)):"function"===typeof define&&define.amd?define(["sortablejs"],e):"object"===typeof exports?exports["vuedraggable"]=e(require("sortablejs")):t["vuedraggable"]=e(t["Sortable"])})("undefined"!==typeof self?self:this,(function(t){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"===typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t["default"]}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s="fb15")}({"01f9":function(t,e,n){"use strict";var r=n("2d00"),o=n("5ca1"),i=n("2aba"),c=n("32e9"),u=n("84f2"),a=n("41a0"),s=n("7f20"),f=n("38fd"),l=n("2b4c")("iterator"),d=!([].keys&&"next"in[].keys()),p="@@iterator",h="keys",v="values",g=function(){return this};t.exports=function(t,e,n,b,m,y,x){a(n,e,b);var O,S,w,j=function(t){if(!d&&t in _)return _[t];switch(t){case h:return function(){return new n(this,t)};case v:return function(){return new n(this,t)}}return function(){return new n(this,t)}},M=e+" Iterator",C=m==v,T=!1,_=t.prototype,L=_[l]||_[p]||m&&_[m],I=L||j(m),E=m?C?j("entries"):I:void 0,P="Array"==e&&_.entries||L;if(P&&(w=f(P.call(new t)),w!==Object.prototype&&w.next&&(s(w,M,!0),r||"function"==typeof w[l]||c(w,l,g))),C&&L&&L.name!==v&&(T=!0,I=function(){return L.call(this)}),r&&!x||!d&&!T&&_[l]||c(_,l,I),u[e]=I,u[M]=g,m)if(O={values:C?I:j(v),keys:y?I:j(h),entries:E},x)for(S in O)S in _||i(_,S,O[S]);else o(o.P+o.F*(d||T),e,O);return O}},"02f4":function(t,e,n){var r=n("4588"),o=n("be13");t.exports=function(t){return function(e,n){var i,c,u=String(o(e)),a=r(n),s=u.length;return a<0||a>=s?t?"":void 0:(i=u.charCodeAt(a),i<55296||i>56319||a+1===s||(c=u.charCodeAt(a+1))<56320||c>57343?t?u.charAt(a):i:t?u.slice(a,a+2):c-56320+(i-55296<<10)+65536)}}},"0390":function(t,e,n){"use strict";var r=n("02f4")(!0);t.exports=function(t,e,n){return e+(n?r(t,e).length:1)}},"0bfb":function(t,e,n){"use strict";var r=n("cb7c");t.exports=function(){var t=r(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},"0d58":function(t,e,n){var r=n("ce10"),o=n("e11e");t.exports=Object.keys||function(t){return r(t,o)}},1495:function(t,e,n){var r=n("86cc"),o=n("cb7c"),i=n("0d58");t.exports=n("9e1e")?Object.defineProperties:function(t,e){o(t);var n,c=i(e),u=c.length,a=0;while(u>a)r.f(t,n=c[a++],e[n]);return t}},"214f":function(t,e,n){"use strict";n("b0c5");var r=n("2aba"),o=n("32e9"),i=n("79e5"),c=n("be13"),u=n("2b4c"),a=n("520a"),s=u("species"),f=!i((function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")})),l=function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var n="ab".split(t);return 2===n.length&&"a"===n[0]&&"b"===n[1]}();t.exports=function(t,e,n){var d=u(t),p=!i((function(){var e={};return e[d]=function(){return 7},7!=""[t](e)})),h=p?!i((function(){var e=!1,n=/a/;return n.exec=function(){return e=!0,null},"split"===t&&(n.constructor={},n.constructor[s]=function(){return n}),n[d](""),!e})):void 0;if(!p||!h||"replace"===t&&!f||"split"===t&&!l){var v=/./[d],g=n(c,d,""[t],(function(t,e,n,r,o){return e.exec===a?p&&!o?{done:!0,value:v.call(e,n,r)}:{done:!0,value:t.call(n,e,r)}:{done:!1}})),b=g[0],m=g[1];r(String.prototype,t,b),o(RegExp.prototype,d,2==e?function(t,e){return m.call(t,this,e)}:function(t){return m.call(t,this)})}}},"230e":function(t,e,n){var r=n("d3f4"),o=n("7726").document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},"23c6":function(t,e,n){var r=n("2d95"),o=n("2b4c")("toStringTag"),i="Arguments"==r(function(){return arguments}()),c=function(t,e){try{return t[e]}catch(n){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=c(e=Object(t),o))?n:i?r(e):"Object"==(u=r(e))&&"function"==typeof e.callee?"Arguments":u}},2621:function(t,e){e.f=Object.getOwnPropertySymbols},"2aba":function(t,e,n){var r=n("7726"),o=n("32e9"),i=n("69a8"),c=n("ca5a")("src"),u=n("fa5b"),a="toString",s=(""+u).split(a);n("8378").inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,u){var a="function"==typeof n;a&&(i(n,"name")||o(n,"name",e)),t[e]!==n&&(a&&(i(n,c)||o(n,c,t[e]?""+t[e]:s.join(String(e)))),t===r?t[e]=n:u?t[e]?t[e]=n:o(t,e,n):(delete t[e],o(t,e,n)))})(Function.prototype,a,(function(){return"function"==typeof this&&this[c]||u.call(this)}))},"2aeb":function(t,e,n){var r=n("cb7c"),o=n("1495"),i=n("e11e"),c=n("613b")("IE_PROTO"),u=function(){},a="prototype",s=function(){var t,e=n("230e")("iframe"),r=i.length,o="<",c=">";e.style.display="none",n("fab2").appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write(o+"script"+c+"document.F=Object"+o+"/script"+c),t.close(),s=t.F;while(r--)delete s[a][i[r]];return s()};t.exports=Object.create||function(t,e){var n;return null!==t?(u[a]=r(t),n=new u,u[a]=null,n[c]=t):n=s(),void 0===e?n:o(n,e)}},"2b4c":function(t,e,n){var r=n("5537")("wks"),o=n("ca5a"),i=n("7726").Symbol,c="function"==typeof i,u=t.exports=function(t){return r[t]||(r[t]=c&&i[t]||(c?i:o)("Symbol."+t))};u.store=r},"2d00":function(t,e){t.exports=!1},"2d95":function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},"2fdb":function(t,e,n){"use strict";var r=n("5ca1"),o=n("d2c8"),i="includes";r(r.P+r.F*n("5147")(i),"String",{includes:function(t){return!!~o(this,t,i).indexOf(t,arguments.length>1?arguments[1]:void 0)}})},"32e9":function(t,e,n){var r=n("86cc"),o=n("4630");t.exports=n("9e1e")?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},"38fd":function(t,e,n){var r=n("69a8"),o=n("4bf8"),i=n("613b")("IE_PROTO"),c=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?c:null}},"41a0":function(t,e,n){"use strict";var r=n("2aeb"),o=n("4630"),i=n("7f20"),c={};n("32e9")(c,n("2b4c")("iterator"),(function(){return this})),t.exports=function(t,e,n){t.prototype=r(c,{next:o(1,n)}),i(t,e+" Iterator")}},"456d":function(t,e,n){var r=n("4bf8"),o=n("0d58");n("5eda")("keys",(function(){return function(t){return o(r(t))}}))},4588:function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},4630:function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},"4bf8":function(t,e,n){var r=n("be13");t.exports=function(t){return Object(r(t))}},5147:function(t,e,n){var r=n("2b4c")("match");t.exports=function(t){var e=/./;try{"/./"[t](e)}catch(n){try{return e[r]=!1,!"/./"[t](e)}catch(o){}}return!0}},"520a":function(t,e,n){"use strict";var r=n("0bfb"),o=RegExp.prototype.exec,i=String.prototype.replace,c=o,u="lastIndex",a=function(){var t=/a/,e=/b*/g;return o.call(t,"a"),o.call(e,"a"),0!==t[u]||0!==e[u]}(),s=void 0!==/()??/.exec("")[1],f=a||s;f&&(c=function(t){var e,n,c,f,l=this;return s&&(n=new RegExp("^"+l.source+"$(?!\\s)",r.call(l))),a&&(e=l[u]),c=o.call(l,t),a&&c&&(l[u]=l.global?c.index+c[0].length:e),s&&c&&c.length>1&&i.call(c[0],n,(function(){for(f=1;f<arguments.length-2;f++)void 0===arguments[f]&&(c[f]=void 0)})),c}),t.exports=c},"52a7":function(t,e){e.f={}.propertyIsEnumerable},5537:function(t,e,n){var r=n("8378"),o=n("7726"),i="__core-js_shared__",c=o[i]||(o[i]={});(t.exports=function(t,e){return c[t]||(c[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n("2d00")?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},"5ca1":function(t,e,n){var r=n("7726"),o=n("8378"),i=n("32e9"),c=n("2aba"),u=n("9b43"),a="prototype",s=function(t,e,n){var f,l,d,p,h=t&s.F,v=t&s.G,g=t&s.S,b=t&s.P,m=t&s.B,y=v?r:g?r[e]||(r[e]={}):(r[e]||{})[a],x=v?o:o[e]||(o[e]={}),O=x[a]||(x[a]={});for(f in v&&(n=e),n)l=!h&&y&&void 0!==y[f],d=(l?y:n)[f],p=m&&l?u(d,r):b&&"function"==typeof d?u(Function.call,d):d,y&&c(y,f,d,t&s.U),x[f]!=d&&i(x,f,p),b&&O[f]!=d&&(O[f]=d)};r.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,t.exports=s},"5eda":function(t,e,n){var r=n("5ca1"),o=n("8378"),i=n("79e5");t.exports=function(t,e){var n=(o.Object||{})[t]||Object[t],c={};c[t]=e(n),r(r.S+r.F*i((function(){n(1)})),"Object",c)}},"5f1b":function(t,e,n){"use strict";var r=n("23c6"),o=RegExp.prototype.exec;t.exports=function(t,e){var n=t.exec;if("function"===typeof n){var i=n.call(t,e);if("object"!==typeof i)throw new TypeError("RegExp exec method returned something other than an Object or null");return i}if("RegExp"!==r(t))throw new TypeError("RegExp#exec called on incompatible receiver");return o.call(t,e)}},"613b":function(t,e,n){var r=n("5537")("keys"),o=n("ca5a");t.exports=function(t){return r[t]||(r[t]=o(t))}},"626a":function(t,e,n){var r=n("2d95");t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},6762:function(t,e,n){"use strict";var r=n("5ca1"),o=n("c366")(!0);r(r.P,"Array",{includes:function(t){return o(this,t,arguments.length>1?arguments[1]:void 0)}}),n("9c6c")("includes")},6821:function(t,e,n){var r=n("626a"),o=n("be13");t.exports=function(t){return r(o(t))}},"69a8":function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},"6a99":function(t,e,n){var r=n("d3f4");t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},7333:function(t,e,n){"use strict";var r=n("0d58"),o=n("2621"),i=n("52a7"),c=n("4bf8"),u=n("626a"),a=Object.assign;t.exports=!a||n("79e5")((function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach((function(t){e[t]=t})),7!=a({},t)[n]||Object.keys(a({},e)).join("")!=r}))?function(t,e){var n=c(t),a=arguments.length,s=1,f=o.f,l=i.f;while(a>s){var d,p=u(arguments[s++]),h=f?r(p).concat(f(p)):r(p),v=h.length,g=0;while(v>g)l.call(p,d=h[g++])&&(n[d]=p[d])}return n}:a},7726:function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},"77f1":function(t,e,n){var r=n("4588"),o=Math.max,i=Math.min;t.exports=function(t,e){return t=r(t),t<0?o(t+e,0):i(t,e)}},"79e5":function(t,e){t.exports=function(t){try{return!!t()}catch(e){return!0}}},"7f20":function(t,e,n){var r=n("86cc").f,o=n("69a8"),i=n("2b4c")("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},8378:function(t,e){var n=t.exports={version:"2.6.5"};"number"==typeof __e&&(__e=n)},"84f2":function(t,e){t.exports={}},"86cc":function(t,e,n){var r=n("cb7c"),o=n("c69a"),i=n("6a99"),c=Object.defineProperty;e.f=n("9e1e")?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return c(t,e,n)}catch(u){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},"9b43":function(t,e,n){var r=n("d8e8");t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},"9c6c":function(t,e,n){var r=n("2b4c")("unscopables"),o=Array.prototype;void 0==o[r]&&n("32e9")(o,r,{}),t.exports=function(t){o[r][t]=!0}},"9def":function(t,e,n){var r=n("4588"),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},"9e1e":function(t,e,n){t.exports=!n("79e5")((function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}))},a352:function(e,n){e.exports=t},a481:function(t,e,n){"use strict";var r=n("cb7c"),o=n("4bf8"),i=n("9def"),c=n("4588"),u=n("0390"),a=n("5f1b"),s=Math.max,f=Math.min,l=Math.floor,d=/\$([$&`']|\d\d?|<[^>]*>)/g,p=/\$([$&`']|\d\d?)/g,h=function(t){return void 0===t?t:String(t)};n("214f")("replace",2,(function(t,e,n,v){return[function(r,o){var i=t(this),c=void 0==r?void 0:r[e];return void 0!==c?c.call(r,i,o):n.call(String(i),r,o)},function(t,e){var o=v(n,t,this,e);if(o.done)return o.value;var l=r(t),d=String(this),p="function"===typeof e;p||(e=String(e));var b=l.global;if(b){var m=l.unicode;l.lastIndex=0}var y=[];while(1){var x=a(l,d);if(null===x)break;if(y.push(x),!b)break;var O=String(x[0]);""===O&&(l.lastIndex=u(d,i(l.lastIndex),m))}for(var S="",w=0,j=0;j<y.length;j++){x=y[j];for(var M=String(x[0]),C=s(f(c(x.index),d.length),0),T=[],_=1;_<x.length;_++)T.push(h(x[_]));var L=x.groups;if(p){var I=[M].concat(T,C,d);void 0!==L&&I.push(L);var E=String(e.apply(void 0,I))}else E=g(M,d,C,T,L,e);C>=w&&(S+=d.slice(w,C)+E,w=C+M.length)}return S+d.slice(w)}];function g(t,e,r,i,c,u){var a=r+t.length,s=i.length,f=p;return void 0!==c&&(c=o(c),f=d),n.call(u,f,(function(n,o){var u;switch(o.charAt(0)){case"$":return"$";case"&":return t;case"`":return e.slice(0,r);case"'":return e.slice(a);case"<":u=c[o.slice(1,-1)];break;default:var f=+o;if(0===f)return n;if(f>s){var d=l(f/10);return 0===d?n:d<=s?void 0===i[d-1]?o.charAt(1):i[d-1]+o.charAt(1):n}u=i[f-1]}return void 0===u?"":u}))}}))},aae3:function(t,e,n){var r=n("d3f4"),o=n("2d95"),i=n("2b4c")("match");t.exports=function(t){var e;return r(t)&&(void 0!==(e=t[i])?!!e:"RegExp"==o(t))}},ac6a:function(t,e,n){for(var r=n("cadf"),o=n("0d58"),i=n("2aba"),c=n("7726"),u=n("32e9"),a=n("84f2"),s=n("2b4c"),f=s("iterator"),l=s("toStringTag"),d=a.Array,p={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},h=o(p),v=0;v<h.length;v++){var g,b=h[v],m=p[b],y=c[b],x=y&&y.prototype;if(x&&(x[f]||u(x,f,d),x[l]||u(x,l,b),a[b]=d,m))for(g in r)x[g]||i(x,g,r[g],!0)}},b0c5:function(t,e,n){"use strict";var r=n("520a");n("5ca1")({target:"RegExp",proto:!0,forced:r!==/./.exec},{exec:r})},be13:function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},c366:function(t,e,n){var r=n("6821"),o=n("9def"),i=n("77f1");t.exports=function(t){return function(e,n,c){var u,a=r(e),s=o(a.length),f=i(c,s);if(t&&n!=n){while(s>f)if(u=a[f++],u!=u)return!0}else for(;s>f;f++)if((t||f in a)&&a[f]===n)return t||f||0;return!t&&-1}}},c649:function(t,e,n){"use strict";(function(t){n.d(e,"c",(function(){return s})),n.d(e,"a",(function(){return u})),n.d(e,"b",(function(){return o})),n.d(e,"d",(function(){return a}));n("a481");function r(){return"undefined"!==typeof window?window.console:t.console}var o=r();function i(t){var e=Object.create(null);return function(n){var r=e[n];return r||(e[n]=t(n))}}var c=/-(\w)/g,u=i((function(t){return t.replace(c,(function(t,e){return e?e.toUpperCase():""}))}));function a(t){null!==t.parentElement&&t.parentElement.removeChild(t)}function s(t,e,n){var r=0===n?t.children[0]:t.children[n-1].nextSibling;t.insertBefore(e,r)}}).call(this,n("c8ba"))},c69a:function(t,e,n){t.exports=!n("9e1e")&&!n("79e5")((function(){return 7!=Object.defineProperty(n("230e")("div"),"a",{get:function(){return 7}}).a}))},c8ba:function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(r){"object"===typeof window&&(n=window)}t.exports=n},ca5a:function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},cadf:function(t,e,n){"use strict";var r=n("9c6c"),o=n("d53b"),i=n("84f2"),c=n("6821");t.exports=n("01f9")(Array,"Array",(function(t,e){this._t=c(t),this._i=0,this._k=e}),(function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):o(0,"keys"==e?n:"values"==e?t[n]:[n,t[n]])}),"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},cb7c:function(t,e,n){var r=n("d3f4");t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},ce10:function(t,e,n){var r=n("69a8"),o=n("6821"),i=n("c366")(!1),c=n("613b")("IE_PROTO");t.exports=function(t,e){var n,u=o(t),a=0,s=[];for(n in u)n!=c&&r(u,n)&&s.push(n);while(e.length>a)r(u,n=e[a++])&&(~i(s,n)||s.push(n));return s}},d2c8:function(t,e,n){var r=n("aae3"),o=n("be13");t.exports=function(t,e,n){if(r(e))throw TypeError("String#"+n+" doesn't accept regex!");return String(o(t))}},d3f4:function(t,e){t.exports=function(t){return"object"===typeof t?null!==t:"function"===typeof t}},d53b:function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},d8e8:function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},e11e:function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},f559:function(t,e,n){"use strict";var r=n("5ca1"),o=n("9def"),i=n("d2c8"),c="startsWith",u=""[c];r(r.P+r.F*n("5147")(c),"String",{startsWith:function(t){var e=i(this,t,c),n=o(Math.min(arguments.length>1?arguments[1]:void 0,e.length)),r=String(t);return u?u.call(e,r,n):e.slice(n,n+r.length)===r}})},f6fd:function(t,e){(function(t){var e="currentScript",n=t.getElementsByTagName("script");e in t||Object.defineProperty(t,e,{get:function(){try{throw new Error}catch(r){var t,e=(/.*at [^\(]*\((.*):.+:.+\)$/gi.exec(r.stack)||[!1])[1];for(t in n)if(n[t].src==e||"interactive"==n[t].readyState)return n[t];return null}}})})(document)},f751:function(t,e,n){var r=n("5ca1");r(r.S+r.F,"Object",{assign:n("7333")})},fa5b:function(t,e,n){t.exports=n("5537")("native-function-to-string",Function.toString)},fab2:function(t,e,n){var r=n("7726").document;t.exports=r&&r.documentElement},fb15:function(t,e,n){"use strict";var r;(n.r(e),"undefined"!==typeof window)&&(n("f6fd"),(r=window.document.currentScript)&&(r=r.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))&&(n.p=r[1]));n("f751"),n("f559"),n("ac6a"),n("cadf"),n("456d");function o(t){if(Array.isArray(t))return t}function i(t,e){if("undefined"!==typeof Symbol&&Symbol.iterator in Object(t)){var n=[],r=!0,o=!1,i=void 0;try{for(var c,u=t[Symbol.iterator]();!(r=(c=u.next()).done);r=!0)if(n.push(c.value),e&&n.length===e)break}catch(a){o=!0,i=a}finally{try{r||null==u["return"]||u["return"]()}finally{if(o)throw i}}return n}}function c(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}function u(t,e){if(t){if("string"===typeof t)return c(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?c(t,e):void 0}}function a(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function s(t,e){return o(t)||i(t,e)||u(t,e)||a()}n("6762"),n("2fdb");function f(t){if(Array.isArray(t))return c(t)}function l(t){if("undefined"!==typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}function d(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function p(t){return f(t)||l(t)||u(t)||d()}var h=n("a352"),v=n.n(h),g=n("c649");function b(t,e,n){return void 0===n||(t=t||{},t[e]=n),t}function m(t,e){return t.map((function(t){return t.elm})).indexOf(e)}function y(t,e,n,r){if(!t)return[];var o=t.map((function(t){return t.elm})),i=e.length-r,c=p(e).map((function(t,e){return e>=i?o.length:o.indexOf(t)}));return n?c.filter((function(t){return-1!==t})):c}function x(t,e){var n=this;this.$nextTick((function(){return n.$emit(t.toLowerCase(),e)}))}function O(t){var e=this;return function(n){null!==e.realList&&e["onDrag"+t](n),x.call(e,t,n)}}function S(t){return["transition-group","TransitionGroup"].includes(t)}function w(t){if(!t||1!==t.length)return!1;var e=s(t,1),n=e[0].componentOptions;return!!n&&S(n.tag)}function j(t,e,n){return t[n]||(e[n]?e[n]():void 0)}function M(t,e,n){var r=0,o=0,i=j(e,n,"header");i&&(r=i.length,t=t?[].concat(p(i),p(t)):p(i));var c=j(e,n,"footer");return c&&(o=c.length,t=t?[].concat(p(t),p(c)):p(c)),{children:t,headerOffset:r,footerOffset:o}}function C(t,e){var n=null,r=function(t,e){n=b(n,t,e)},o=Object.keys(t).filter((function(t){return"id"===t||t.startsWith("data-")})).reduce((function(e,n){return e[n]=t[n],e}),{});if(r("attrs",o),!e)return n;var i=e.on,c=e.props,u=e.attrs;return r("on",i),r("props",c),Object.assign(n.attrs,u),n}var T=["Start","Add","Remove","Update","End"],_=["Choose","Unchoose","Sort","Filter","Clone"],L=["Move"].concat(T,_).map((function(t){return"on"+t})),I=null,E={options:Object,list:{type:Array,required:!1,default:null},value:{type:Array,required:!1,default:null},noTransitionOnDrag:{type:Boolean,default:!1},clone:{type:Function,default:function(t){return t}},element:{type:String,default:"div"},tag:{type:String,default:null},move:{type:Function,default:null},componentData:{type:Object,required:!1,default:null}},P={name:"draggable",inheritAttrs:!1,props:E,data:function(){return{transitionMode:!1,noneFunctionalComponentMode:!1}},render:function(t){var e=this.$slots.default;this.transitionMode=w(e);var n=M(e,this.$slots,this.$scopedSlots),r=n.children,o=n.headerOffset,i=n.footerOffset;this.headerOffset=o,this.footerOffset=i;var c=C(this.$attrs,this.componentData);return t(this.getTag(),c,r)},created:function(){null!==this.list&&null!==this.value&&g["b"].error("Value and list props are mutually exclusive! Please set one or another."),"div"!==this.element&&g["b"].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props"),void 0!==this.options&&g["b"].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props")},mounted:function(){var t=this;if(this.noneFunctionalComponentMode=this.getTag().toLowerCase()!==this.$el.nodeName.toLowerCase()&&!this.getIsFunctional(),this.noneFunctionalComponentMode&&this.transitionMode)throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));var e={};T.forEach((function(n){e["on"+n]=O.call(t,n)})),_.forEach((function(n){e["on"+n]=x.bind(t,n)}));var n=Object.keys(this.$attrs).reduce((function(e,n){return e[Object(g["a"])(n)]=t.$attrs[n],e}),{}),r=Object.assign({},this.options,n,e,{onMove:function(e,n){return t.onDragMove(e,n)}});!("draggable"in r)&&(r.draggable=">*"),this._sortable=new v.a(this.rootContainer,r),this.computeIndexes()},beforeDestroy:function(){void 0!==this._sortable&&this._sortable.destroy()},computed:{rootContainer:function(){return this.transitionMode?this.$el.children[0]:this.$el},realList:function(){return this.list?this.list:this.value}},watch:{options:{handler:function(t){this.updateOptions(t)},deep:!0},$attrs:{handler:function(t){this.updateOptions(t)},deep:!0},realList:function(){this.computeIndexes()}},methods:{getIsFunctional:function(){var t=this._vnode.fnOptions;return t&&t.functional},getTag:function(){return this.tag||this.element},updateOptions:function(t){for(var e in t){var n=Object(g["a"])(e);-1===L.indexOf(n)&&this._sortable.option(n,t[e])}},getChildrenNodes:function(){if(this.noneFunctionalComponentMode)return this.$children[0].$slots.default;var t=this.$slots.default;return this.transitionMode?t[0].child.$slots.default:t},computeIndexes:function(){var t=this;this.$nextTick((function(){t.visibleIndexes=y(t.getChildrenNodes(),t.rootContainer.children,t.transitionMode,t.footerOffset)}))},getUnderlyingVm:function(t){var e=m(this.getChildrenNodes()||[],t);if(-1===e)return null;var n=this.realList[e];return{index:e,element:n}},getUnderlyingPotencialDraggableComponent:function(t){var e=t.__vue__;return e&&e.$options&&S(e.$options._componentTag)?e.$parent:!("realList"in e)&&1===e.$children.length&&"realList"in e.$children[0]?e.$children[0]:e},emitChanges:function(t){var e=this;this.$nextTick((function(){e.$emit("change",t)}))},alterList:function(t){if(this.list)t(this.list);else{var e=p(this.value);t(e),this.$emit("input",e)}},spliceList:function(){var t=arguments,e=function(e){return e.splice.apply(e,p(t))};this.alterList(e)},updatePosition:function(t,e){var n=function(n){return n.splice(e,0,n.splice(t,1)[0])};this.alterList(n)},getRelatedContextFromMoveEvent:function(t){var e=t.to,n=t.related,r=this.getUnderlyingPotencialDraggableComponent(e);if(!r)return{component:r};var o=r.realList,i={list:o,component:r};if(e!==n&&o&&r.getUnderlyingVm){var c=r.getUnderlyingVm(n);if(c)return Object.assign(c,i)}return i},getVmIndex:function(t){var e=this.visibleIndexes,n=e.length;return t>n-1?n:e[t]},getComponent:function(){return this.$slots.default[0].componentInstance},resetTransitionData:function(t){if(this.noTransitionOnDrag&&this.transitionMode){var e=this.getChildrenNodes();e[t].data=null;var n=this.getComponent();n.children=[],n.kept=void 0}},onDragStart:function(t){this.context=this.getUnderlyingVm(t.item),t.item._underlying_vm_=this.clone(this.context.element),I=t.item},onDragAdd:function(t){var e=t.item._underlying_vm_;if(void 0!==e){Object(g["d"])(t.item);var n=this.getVmIndex(t.newIndex);this.spliceList(n,0,e),this.computeIndexes();var r={element:e,newIndex:n};this.emitChanges({added:r})}},onDragRemove:function(t){if(Object(g["c"])(this.rootContainer,t.item,t.oldIndex),"clone"!==t.pullMode){var e=this.context.index;this.spliceList(e,1);var n={element:this.context.element,oldIndex:e};this.resetTransitionData(e),this.emitChanges({removed:n})}else Object(g["d"])(t.clone)},onDragUpdate:function(t){Object(g["d"])(t.item),Object(g["c"])(t.from,t.item,t.oldIndex);var e=this.context.index,n=this.getVmIndex(t.newIndex);this.updatePosition(e,n);var r={element:this.context.element,oldIndex:e,newIndex:n};this.emitChanges({moved:r})},updateProperty:function(t,e){t.hasOwnProperty(e)&&(t[e]+=this.headerOffset)},computeFutureIndex:function(t,e){if(!t.element)return 0;var n=p(e.to.children).filter((function(t){return"none"!==t.style["display"]})),r=n.indexOf(e.related),o=t.component.getVmIndex(r),i=-1!==n.indexOf(I);return i||!e.willInsertAfter?o:o+1},onDragMove:function(t,e){var n=this.move;if(!n||!this.realList)return!0;var r=this.getRelatedContextFromMoveEvent(t),o=this.context,i=this.computeFutureIndex(r,t);Object.assign(o,{futureIndex:i});var c=Object.assign({},t,{relatedContext:r,draggedContext:o});return n(c,e)},onDragEnd:function(){this.computeIndexes(),I=null}}};"undefined"!==typeof window&&"Vue"in window&&window.Vue.component("draggable",P);var $=P;e["default"]=$}})["default"]}));
	//# sourceMappingURL=vuedraggable.umd.min.js.map

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	exports.sync = function (store, router, options) {
	  var moduleName = (options || {}).moduleName || 'route'
	
	  store.registerModule(moduleName, {
	    namespaced: true,
	    state: cloneRoute(router.currentRoute),
	    mutations: {
	      'ROUTE_CHANGED': function ROUTE_CHANGED (state, transition) {
	        store.state[moduleName] = cloneRoute(transition.to, transition.from)
	      }
	    }
	  })
	
	  var isTimeTraveling = false
	  var currentPath
	
	  // sync router on store change
	  var storeUnwatch = store.watch(
	    function (state) { return state[moduleName]; },
	    function (route) {
	      var fullPath = route.fullPath;
	      if (fullPath === currentPath) {
	        return
	      }
	      if (currentPath != null) {
	        isTimeTraveling = true
	        router.push(route)
	      }
	      currentPath = fullPath
	    },
	    { sync: true }
	  )
	
	  // sync store on router navigation
	  var afterEachUnHook = router.afterEach(function (to, from) {
	    if (isTimeTraveling) {
	      isTimeTraveling = false
	      return
	    }
	    currentPath = to.fullPath
	    store.commit(moduleName + '/ROUTE_CHANGED', { to: to, from: from })
	  })
	
	  return function unsync () {
	    // On unsync, remove router hook
	    if (afterEachUnHook != null) {
	      afterEachUnHook()
	    }
	
	    // On unsync, remove store watch
	    if (storeUnwatch != null) {
	      storeUnwatch()
	    }
	
	    // On unsync, unregister Module with store
	    store.unregisterModule(moduleName)
	  }
	}
	
	function cloneRoute (to, from) {
	  var clone = {
	    name: to.name,
	    path: to.path,
	    hash: to.hash,
	    query: to.query,
	    params: to.params,
	    fullPath: to.fullPath,
	    meta: to.meta
	  }
	  if (from) {
	    clone.from = cloneRoute(from)
	  }
	  return Object.freeze(clone)
	}
	


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*! cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W100 */
	var cptable = {version:"1.15.0"};
	cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[932] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	return {"enc": e, "dec": d }; })();
	cptable[936] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
	return {"enc": e, "dec": d }; })();
	cptable[949] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	return {"enc": e, "dec": d }; })();
	cptable[950] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	return {"enc": e, "dec": d }; })();
	cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	return {"enc": e, "dec": d }; })();
	cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[28591] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	// eslint-disable-next-line no-undef
	if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
	/*! cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ft=javascript: */
	/*jshint newcap: false */
	(function(root, factory) {
	  /*jshint ignore:start */
	  /*eslint-disable */
	  "use strict";
	  if(typeof cptable === "undefined") {
	    if(true){
	      var cpt = cptable;
	      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
	      else root.cptable = factory(cpt);
	    } else throw new Error("cptable not found");
	  } else cptable = factory(cptable);
	  /*eslint-enable */
	  /*jshint ignore:end */
	}(this, function(cpt){
	  "use strict";
	  /*global module, Buffer */
	  var magic = {
	    "1200":"utf16le",
	    "1201":"utf16be",
	    "12000":"utf32le",
	    "12001":"utf32be",
	    "16969":"utf64le",
	    "20127":"ascii",
	    "65000":"utf7",
	    "65001":"utf8"
	  };
	
	  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
	  var dbcs_cache = [932,936,949,950];
	  var magic_cache = [65001];
	  var magic_decode = {};
	  var magic_encode = {};
	  var cpdcache = {};
	  var cpecache = {};
	
	  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
	  var cca = function cca(x) { return x.charCodeAt(0); };
	
	  var has_buf = (typeof Buffer !== 'undefined');
	  var Buffer_from = function(){};
	  if(has_buf) {
	    var nbfs = !Buffer.from;
	    if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	    Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	    // $FlowIgnore
	    if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
	
	    var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
	    var make_EE = function make_EE(E){
	      var EE = Buffer.allocUnsafe(65536);
	      for(var i = 0; i < 65536;++i) EE[i] = 0;
	      var keys = Object.keys(E), len = keys.length;
	      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
	        if(!(e = keys[ee])) continue;
	        EE[e.charCodeAt(0)] = E[e];
	      }
	      return EE;
	    };
	    var sbcs_encode = function make_sbcs_encode(cp) {
	      var EE = make_EE(cpt[cp].enc);
	      return function sbcs_e(data, ofmt) {
	        var len = data.length;
	        var out, i=0, j=0, D=0, w=0;
	        if(typeof data === 'string') {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
	        } else if(Buffer.isBuffer(data)) {
	          out = Buffer.allocUnsafe(2*len);
	          j = 0;
	          for(i = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) out[j++] = EE[D];
	            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
	            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
	            else {
	              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
	              if(w < 65536) out[j++] = EE[w];
	              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
	            }
	          }
	          out = out.slice(0,j);
	        } else {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var sbcs_decode = function make_sbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c="";
	      for(d=0;d<D.length;++d) {
	        if(!(c=D[d])) continue;
	        var w = c.charCodeAt(0);
	        DD[2*d] = w&255; DD[2*d+1] = w>>8;
	      }
	      return function sbcs_d(data) {
	        var len = data.length, i=0, j=0;
	        if(2 * len > mdl) { mdl = 2 * len; mdb = Buffer.allocUnsafe(mdl); }
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        }
	        return mdb.slice(0, 2 * len).toString('ucs2');
	      };
	    };
	    var dbcs_encode = function make_dbcs_encode(cp) {
	      var E = cpt[cp].enc;
	      var EE = Buffer.allocUnsafe(131072);
	      for(var i = 0; i < 131072; ++i) EE[i] = 0;
	      var keys = Object.keys(E);
	      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
	        if(!(e = keys[ee])) continue;
	        var f = e.charCodeAt(0);
	        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
	      }
	      return function dbcs_e(data, ofmt) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, jj=0, k=0, D=0;
	        if(typeof data === 'string') {
	          for(i = k = 0; i < len; ++i) {
	            j = data.charCodeAt(i)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	          out = out.slice(0,k);
	        } else if(Buffer.isBuffer(data)) {
	          for(i = k = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) j = D;
	            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
	            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
	            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
	            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
	            else { jj = j-65536;
	              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	            }
	          }
	          out = out.slice(0,k);
	        } else {
	          for(i = k = 0; i < len; i++) {
	            j = data[i].charCodeAt(0)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var dbcs_decode = function make_dbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c, w=0, j=0, i=0;
	      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
	      for(d = 0; d < D.length; ++d) {
	        if(!(c=D[d])) continue;
	        w = c.charCodeAt(0);
	        j = 2*d;
	        DD[j] = w&255; DD[j+1] = w>>8;
	      }
	      return function dbcs_d(data) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, k=0;
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        }
	        return out.slice(0,k).toString('ucs2');
	      };
	    };
	    magic_decode[65001] = function utf8_d(data) {
	      if(typeof data === "string") return utf8_d(data.split("").map(cca));
	      var len = data.length, w = 0, ww = 0;
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      var i = 0;
	      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
	        j = 1; D = data[i];
	        if(D < 128) w = D;
	        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
	        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
	        else {
	          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
	        }
	      }
	      return mdb.slice(0,k).toString('ucs2');
	    };
	    magic_encode[65001] = function utf8_e(data, ofmt) {
	      if(has_buf && Buffer.isBuffer(data)) {
	        if(!ofmt || ofmt === 'buf') return data;
	        if(ofmt !== 'arr') return data.toString('binary');
	        return [].slice.call(data);
	      }
	      var len = data.length, w = 0, ww = 0, j = 0;
	      var direct = typeof data === "string";
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      for(var i = 0; i < len; ++i) {
	        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
	        if(w <= 0x007F) mdb[j++] = w;
	        else if(w <= 0x07FF) {
	          mdb[j++] = 192 + (w >> 6);
	          mdb[j++] = 128 + (w&63);
	        } else if(w >= 0xD800 && w <= 0xDFFF) {
	          w -= 0xD800; ++i;
	          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
	          mdb[j++] = 240 + ((ww>>>18) & 0x07);
	          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
	          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
	          mdb[j++] = 128 + (ww & 0x3F);
	        } else {
	          mdb[j++] = 224 + (w >> 12);
	          mdb[j++] = 128 + ((w >> 6)&63);
	          mdb[j++] = 128 + (w&63);
	        }
	      }
	      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
	      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
	      return [].slice.call(mdb, 0, j);
	    };
	  }
	
	  var encache = function encache() {
	    if(has_buf) {
	      if(cpdcache[sbcs_cache[0]]) return;
	      var i=0, s=0;
	      for(i = 0; i < sbcs_cache.length; ++i) {
	        s = sbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = sbcs_decode(s);
	          cpecache[s] = sbcs_encode(s);
	        }
	      }
	      for(i = 0; i < dbcs_cache.length; ++i) {
	        s = dbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = dbcs_decode(s);
	          cpecache[s] = dbcs_encode(s);
	        }
	      }
	      for(i = 0; i < magic_cache.length; ++i) {
	        s = magic_cache[i];
	        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
	        if(magic_encode[s]) cpecache[s] = magic_encode[s];
	      }
	    }
	  };
	  var null_enc = function(data, ofmt) { void ofmt; return ""; };
	  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
	  var decache = function decache() {
	    if(has_buf) {
	      if(!cpdcache[sbcs_cache[0]]) return;
	      sbcs_cache.forEach(cp_decache);
	      dbcs_cache.forEach(cp_decache);
	      magic_cache.forEach(cp_decache);
	    }
	    last_enc = null_enc; last_cp = 0;
	  };
	  var cache = {
	    encache: encache,
	    decache: decache,
	    sbcs: sbcs_cache,
	    dbcs: dbcs_cache
	  };
	
	  encache();
	
	  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
	  var last_enc = null_enc, last_cp = 0;
	  var encode = function encode(cp, data, ofmt) {
	    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
	    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
	    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
	    var len = data.length;
	    var out = has_buf ? Buffer.allocUnsafe(4*len) : [], w=0, i=0, j = 0, ww=0;
	    var C = cpt[cp], E, M = "";
	    var isstr = typeof data === 'string';
	    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
	      w = E[isstr? data.charAt(i) : data[i]];
	      if(w > 255) {
	        out[j] = w>>8;
	        out[++j] = w&255;
	      } else out[j] = w&255;
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(has_buf && isstr) { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else if(w <= 0x07FF) {
	            out[j]   = 192 + (w >> 6);
	            out[++j] = 128 + (w&63);
	          } else if(w >= 0xD800 && w <= 0xDFFF) {
	            w -= 0xD800;
	            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
	            out[j]   = 240 + ((ww>>>18) & 0x07);
	            out[++j] = 144 + ((ww>>>12) & 0x3F);
	            out[++j] = 128 + ((ww>>>6) & 0x3F);
	            out[++j] = 128 + (ww & 0x3F);
	          } else {
	            out[j]   = 224 + (w >> 12);
	            out[++j] = 128 + ((w >> 6)&63);
	            out[++j] = 128 + (w&63);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else throw new Error("bad ascii " + w);
	        }
	        break;
	      case "utf16le":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w&255;
	          out[j++] = w>>8;
	        }
	        break;
	      case "utf16be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w>>8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32le":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j+3] = w&255; w >>= 8;
	          out[j+2] = w&255; w >>= 8;
	          out[j+1] = w&255; w >>= 8;
	          out[j] = w&255;
	          j+=4;
	        }
	        break;
	      case "utf7":
	        for(i = 0; i < len; i++) {
	          var c = isstr ? data.charAt(i) : data[i].charAt(0);
	          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
	          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
	          var tt = encode(1201, c);
	          out[j++] = 0x2b;
	          out[j++] = BM.charCodeAt(tt[0]>>2);
	          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
	          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
	          out[j++] = 0x2d;
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    out = out.slice(0,j);
	    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
	    if(!ofmt || ofmt === 'buf') return out;
	    if(ofmt !== 'arr') return out.toString('binary');
	    return [].slice.call(out);
	  };
	  var decode = function decode(cp, data) {
	    var F; if((F=cpdcache[cp])) return F(data);
	    if(typeof data === "string") return decode(cp, data.split("").map(cca));
	    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
	    var C = cpt[cp], D, M="";
	    if(C && (D=C.dec)) {
	      for(i = 0; i < len; i+=j) {
	        j = 2;
	        s = D[(data[i]<<8)+ data[i+1]];
	        if(!s) {
	          j = 1;
	          s = D[data[i]];
	        }
	        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
	        out[k++] = s;
	      }
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	        for(; i < len; i+=j) {
	          j = 1;
	          if(data[i] < 128) w = data[i];
	          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
	          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	          if(w < 65536) { out[k++] = String.fromCharCode(w); }
	          else {
	            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
	        k = len; break;
	      case "utf16le":
	        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
	        }
	        break;
	      case "utf16be":
	        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
	        }
	        break;
	      case "utf32le":
	        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf32be":
	        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf7":
	        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
	          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
	          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
	        }
	        for(; i < len; i+=j) {
	          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
	          j=1;
	          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
	          // eslint-disable-next-line no-useless-escape
	          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
	          var dash = 0;
	          if(data[i+j] === 0x2d) { ++j; dash=1; }
	          var tt = [];
	          var o64 = "";
	          var c1=0, c2=0, c3=0;
	          var e1=0, e2=0, e3=0, e4=0;
	          for(var l = 1; l < j - dash;) {
	            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            c1 = e1 << 2 | e2 >> 4;
	            tt.push(c1);
	            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e3 === -1) break;
	            c2 = (e2 & 15) << 4 | e3 >> 2;
	            tt.push(c2);
	            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e4 === -1) break;
	            c3 = (e3 & 3) << 6 | e4;
	            if(e4 < 64) tt.push(c3);
	          }
	          o64 = decode(1201, tt);
	          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    return out.slice(0,k).join("");
	  };
	  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
	  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
	  return cpt;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported XLSX */
	/*global exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */
	var XLSX = {};
	function make_xlsx_lib(XLSX){
	XLSX.version = '0.18.5';
	var current_codepage = 1200, current_ansi = 1252;
	/*global cptable:true, window */
	var $cptable;
	if(typeof cptable !== 'undefined') $cptable = cptable;
	else if(true) {
		$cptable = __webpack_require__(1848);
	}
	
	var VALID_ANSI = [ 874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 10000 ];
	/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
	var CS2CP = ({
	0:    1252, /* ANSI */
	1:   65001, /* DEFAULT */
	2:   65001, /* SYMBOL */
	77:  10000, /* MAC */
	128:   932, /* SHIFTJIS */
	129:   949, /* HANGUL */
	130:  1361, /* JOHAB */
	134:   936, /* GB2312 */
	136:   950, /* CHINESEBIG5 */
	161:  1253, /* GREEK */
	162:  1254, /* TURKISH */
	163:  1258, /* VIETNAMESE */
	177:  1255, /* HEBREW */
	178:  1256, /* ARABIC */
	186:  1257, /* BALTIC */
	204:  1251, /* RUSSIAN */
	222:   874, /* THAI */
	238:  1250, /* EASTEUROPE */
	255:  1252, /* OEM */
	69:   6969  /* MISC */
	});
	
	var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
	function reset_ansi() { set_ansi(1252); }
	
	var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
	function reset_cp() { set_cp(1200); reset_ansi(); }
	
	function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }
	
	function utf16leread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
		return o.join("");
	}
	function utf16beread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
		return o.join("");
	}
	
	var debom = function(data) {
		var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
		if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
		if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
		if(c1 == 0xFEFF) return data.slice(1);
		return data;
	};
	
	var _getchar = function _gc1(x) { return String.fromCharCode(x); };
	var _getansi = function _ga1(x) { return String.fromCharCode(x); };
	if(typeof $cptable !== 'undefined') {
		set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
		debom = function(data) {
			if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return $cptable.utils.decode(1200, char_codes(data.slice(2))); }
			return data;
		};
		_getchar = function _gc2(x) {
			if(current_codepage === 1200) return String.fromCharCode(x);
			return $cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
		};
		_getansi = function _ga2(x) {
			return $cptable.utils.decode(current_ansi, [x])[0];
		};
	}
	var DENSE = null;
	var DIF_XL = true;
	var Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	function Base64_encode(input) {
	  var o = "";
	  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
	  for (var i = 0; i < input.length; ) {
	    c1 = input.charCodeAt(i++);
	    e1 = c1 >> 2;
	    c2 = input.charCodeAt(i++);
	    e2 = (c1 & 3) << 4 | c2 >> 4;
	    c3 = input.charCodeAt(i++);
	    e3 = (c2 & 15) << 2 | c3 >> 6;
	    e4 = c3 & 63;
	    if (isNaN(c2)) {
	      e3 = e4 = 64;
	    } else if (isNaN(c3)) {
	      e4 = 64;
	    }
	    o += Base64_map.charAt(e1) + Base64_map.charAt(e2) + Base64_map.charAt(e3) + Base64_map.charAt(e4);
	  }
	  return o;
	}
	function Base64_decode(input) {
	  var o = "";
	  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
	  input = input.replace(/[^\w\+\/\=]/g, "");
	  for (var i = 0; i < input.length; ) {
	    e1 = Base64_map.indexOf(input.charAt(i++));
	    e2 = Base64_map.indexOf(input.charAt(i++));
	    c1 = e1 << 2 | e2 >> 4;
	    o += String.fromCharCode(c1);
	    e3 = Base64_map.indexOf(input.charAt(i++));
	    c2 = (e2 & 15) << 4 | e3 >> 2;
	    if (e3 !== 64) {
	      o += String.fromCharCode(c2);
	    }
	    e4 = Base64_map.indexOf(input.charAt(i++));
	    c3 = (e3 & 3) << 6 | e4;
	    if (e4 !== 64) {
	      o += String.fromCharCode(c3);
	    }
	  }
	  return o;
	}
	var has_buf = (function() { return typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node; })();
	
	var Buffer_from = (function() {
		if(typeof Buffer !== 'undefined') {
			var nbfs = !Buffer.from;
			if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
			return nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
		}
		return function() {};
	})();
	
	
	function new_raw_buf(len) {
		/* jshint -W056 */
		if(has_buf) return Buffer.alloc ? Buffer.alloc(len) : new Buffer(len);
		return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
		/* jshint +W056 */
	}
	
	function new_unsafe_buf(len) {
		/* jshint -W056 */
		if(has_buf) return Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : new Buffer(len);
		return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
		/* jshint +W056 */
	}
	
	var s2a = function s2a(s) {
		if(has_buf) return Buffer_from(s, "binary");
		return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
	};
	
	function s2ab(s) {
		if(typeof ArrayBuffer === 'undefined') return s2a(s);
		var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
		for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
		return buf;
	}
	
	function a2s(data) {
		if(Array.isArray(data)) return data.map(function(c) { return String.fromCharCode(c); }).join("");
		var o = []; for(var i = 0; i < data.length; ++i) o[i] = String.fromCharCode(data[i]); return o.join("");
	}
	
	function a2u(data) {
		if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
		return new Uint8Array(data);
	}
	
	function ab2a(data) {
		if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
		if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
	var o = new Array(data.length);
		for(var i = 0; i < data.length; ++i) o[i] = data[i];
		return o;
	}
	
	var bconcat = has_buf ? function(bufs) { return Buffer.concat(bufs.map(function(buf) { return Buffer.isBuffer(buf) ? buf : Buffer_from(buf); })); } : function(bufs) {
		if(typeof Uint8Array !== "undefined") {
			var i = 0, maxlen = 0;
			for(i = 0; i < bufs.length; ++i) maxlen += bufs[i].length;
			var o = new Uint8Array(maxlen);
			var len = 0;
			for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i) {
				len = bufs[i].length;
				if(bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
				else if(typeof bufs[i] == "string") { throw "wtf"; }
				else o.set(new Uint8Array(bufs[i]), maxlen);
			}
			return o;
		}
		return [].concat.apply([], bufs.map(function(buf) { return Array.isArray(buf) ? buf : [].slice.call(buf); }));
	};
	
	function utf8decode(content) {
		var out = [], widx = 0, L = content.length + 250;
		var o = new_raw_buf(content.length + 255);
		for(var ridx = 0; ridx < content.length; ++ridx) {
			var c = content.charCodeAt(ridx);
			if(c < 0x80) o[widx++] = c;
			else if(c < 0x800) {
				o[widx++] = (192|((c>>6)&31));
				o[widx++] = (128|(c&63));
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64;
				var d = content.charCodeAt(++ridx)&1023;
				o[widx++] = (240|((c>>8)&7));
				o[widx++] = (128|((c>>2)&63));
				o[widx++] = (128|((d>>6)&15)|((c&3)<<4));
				o[widx++] = (128|(d&63));
			} else {
				o[widx++] = (224|((c>>12)&15));
				o[widx++] = (128|((c>>6)&63));
				o[widx++] = (128|(c&63));
			}
			if(widx > L) {
				out.push(o.slice(0, widx));
				widx = 0;
				o = new_raw_buf(65535);
				L = 65530;
			}
		}
		out.push(o.slice(0, widx));
		return bconcat(out);
	}
	
	var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
	/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W041 */
	function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
	function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
	function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
	function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	var p2_32 = Math.pow(2,32);
	function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
	/* yes, in 2022 this is still faster than string compare */
	function SSF_isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
	var days = [
		['Sun', 'Sunday'],
		['Mon', 'Monday'],
		['Tue', 'Tuesday'],
		['Wed', 'Wednesday'],
		['Thu', 'Thursday'],
		['Fri', 'Friday'],
		['Sat', 'Saturday']
	];
	var months = [
		['J', 'Jan', 'January'],
		['F', 'Feb', 'February'],
		['M', 'Mar', 'March'],
		['A', 'Apr', 'April'],
		['M', 'May', 'May'],
		['J', 'Jun', 'June'],
		['J', 'Jul', 'July'],
		['A', 'Aug', 'August'],
		['S', 'Sep', 'September'],
		['O', 'Oct', 'October'],
		['N', 'Nov', 'November'],
		['D', 'Dec', 'December']
	];
	function SSF_init_table(t) {
		if(!t) t = {};
		t[0]=  'General';
		t[1]=  '0';
		t[2]=  '0.00';
		t[3]=  '#,##0';
		t[4]=  '#,##0.00';
		t[9]=  '0%';
		t[10]= '0.00%';
		t[11]= '0.00E+00';
		t[12]= '# ?/?';
		t[13]= '# ??/??';
		t[14]= 'm/d/yy';
		t[15]= 'd-mmm-yy';
		t[16]= 'd-mmm';
		t[17]= 'mmm-yy';
		t[18]= 'h:mm AM/PM';
		t[19]= 'h:mm:ss AM/PM';
		t[20]= 'h:mm';
		t[21]= 'h:mm:ss';
		t[22]= 'm/d/yy h:mm';
		t[37]= '#,##0 ;(#,##0)';
		t[38]= '#,##0 ;[Red](#,##0)';
		t[39]= '#,##0.00;(#,##0.00)';
		t[40]= '#,##0.00;[Red](#,##0.00)';
		t[45]= 'mm:ss';
		t[46]= '[h]:mm:ss';
		t[47]= 'mmss.0';
		t[48]= '##0.0E+0';
		t[49]= '@';
		t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
		return t;
	}
	/* repeated to satiate webpack */
	var table_fmt = {
		0:  'General',
		1:  '0',
		2:  '0.00',
		3:  '#,##0',
		4:  '#,##0.00',
		9:  '0%',
		10: '0.00%',
		11: '0.00E+00',
		12: '# ?/?',
		13: '# ??/??',
		14: 'm/d/yy',
		15: 'd-mmm-yy',
		16: 'd-mmm',
		17: 'mmm-yy',
		18: 'h:mm AM/PM',
		19: 'h:mm:ss AM/PM',
		20: 'h:mm',
		21: 'h:mm:ss',
		22: 'm/d/yy h:mm',
		37: '#,##0 ;(#,##0)',
		38: '#,##0 ;[Red](#,##0)',
		39: '#,##0.00;(#,##0.00)',
		40: '#,##0.00;[Red](#,##0.00)',
		45: 'mm:ss',
		46: '[h]:mm:ss',
		47: 'mmss.0',
		48: '##0.0E+0',
		49: '@',
		56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
	};
	
	/* Defaults determined by systematically testing in Excel 2019 */
	
	/* These formats appear to default to other formats in the table */
	var SSF_default_map = {
		5:  37, 6:  38, 7:  39, 8:  40,         //  5 -> 37 ...  8 -> 40
	
		23:  0, 24:  0, 25:  0, 26:  0,         // 23 ->  0 ... 26 ->  0
	
		27: 14, 28: 14, 29: 14, 30: 14, 31: 14, // 27 -> 14 ... 31 -> 14
	
		50: 14, 51: 14, 52: 14, 53: 14, 54: 14, // 50 -> 14 ... 58 -> 14
		55: 14, 56: 14, 57: 14, 58: 14,
		59:  1, 60:  2, 61:  3, 62:  4,         // 59 ->  1 ... 62 ->  4
	
		67:  9, 68: 10,                         // 67 ->  9 ... 68 -> 10
		69: 12, 70: 13, 71: 14,                 // 69 -> 12 ... 71 -> 14
		72: 14, 73: 15, 74: 16, 75: 17,         // 72 -> 14 ... 75 -> 17
		76: 20, 77: 21, 78: 22,                 // 76 -> 20 ... 78 -> 22
		79: 45, 80: 46, 81: 47,                 // 79 -> 45 ... 81 -> 47
		82: 0                                   // 82 ->  0 ... 65536 -> 0 (omitted)
	};
	
	
	/* These formats technically refer to Accounting formats with no equivalent */
	var SSF_default_str = {
		//  5 -- Currency,   0 decimal, black negative
		5:  '"$"#,##0_);\\("$"#,##0\\)',
		63: '"$"#,##0_);\\("$"#,##0\\)',
	
		//  6 -- Currency,   0 decimal, red   negative
		6:  '"$"#,##0_);[Red]\\("$"#,##0\\)',
		64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
	
		//  7 -- Currency,   2 decimal, black negative
		7:  '"$"#,##0.00_);\\("$"#,##0.00\\)',
		65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
	
		//  8 -- Currency,   2 decimal, red   negative
		8:  '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	
		// 41 -- Accounting, 0 decimal, No Symbol
		41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
	
		// 42 -- Accounting, 0 decimal, $  Symbol
		42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
	
		// 43 -- Accounting, 2 decimal, No Symbol
		43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
	
		// 44 -- Accounting, 2 decimal, $  Symbol
		44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
	};
	
	function SSF_frac(x, D, mixed) {
		var sgn = x < 0 ? -1 : 1;
		var B = x * sgn;
		var P_2 = 0, P_1 = 1, P = 0;
		var Q_2 = 1, Q_1 = 0, Q = 0;
		var A = Math.floor(B);
		while(Q_1 < D) {
			A = Math.floor(B);
			P = A * P_1 + P_2;
			Q = A * Q_1 + Q_2;
			if((B - A) < 0.00000005) break;
			B = 1 / (B - A);
			P_2 = P_1; P_1 = P;
			Q_2 = Q_1; Q_1 = Q;
		}
		if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
		if(!mixed) return [0, sgn * P, Q];
		var q = Math.floor(sgn * P/Q);
		return [q, sgn*P - q*Q, Q];
	}
	function SSF_parse_date_code(v,opts,b2) {
		if(v > 2958465 || v < 0) return null;
		var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
		var dout=[];
		var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
		if(Math.abs(out.u) < 1e-6) out.u = 0;
		if(opts && opts.date1904) date += 1462;
		if(out.u > 0.9999) {
			out.u = 0;
			if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
		}
		if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
		else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
		else {
			if(date > 60) --date;
			/* 1 = Jan 1 1900 in Gregorian */
			var d = new Date(1900, 0, 1);
			d.setDate(d.getDate() + date - 1);
			dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
			dow = d.getDay();
			if(date < 60) dow = (dow + 6) % 7;
			if(b2) dow = SSF_fix_hijri(d, dout);
		}
		out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
		out.S = time % 60; time = Math.floor(time / 60);
		out.M = time % 60; time = Math.floor(time / 60);
		out.H = time;
		out.q = dow;
		return out;
	}
	var SSFbasedate = new Date(1899, 11, 31, 0, 0, 0);
	var SSFdnthresh = SSFbasedate.getTime();
	var SSFbase1904 = new Date(1900, 2, 1, 0, 0, 0);
	function datenum_local(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1461*24*60*60*1000;
		else if(v >= SSFbase1904) epoch += 24*60*60*1000;
		return (epoch - (SSFdnthresh + (v.getTimezoneOffset() - SSFbasedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
	}
	/* ECMA-376 18.8.30 numFmt*/
	/* Note: `toPrecision` uses standard form when prec > E and E >= -6 */
	/* exponent >= -9 and <= 9 */
	function SSF_strip_decimal(o) {
		return (o.indexOf(".") == -1) ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
	}
	
	/* General Exponential always shows 2 digits exp and trims the mantissa */
	function SSF_normalize_exp(o) {
		if(o.indexOf("E") == -1) return o;
		return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2");
	}
	
	/* exponent >= -9 and <= 9 */
	function SSF_small_exp(v) {
		var w = (v<0?12:11);
		var o = SSF_strip_decimal(v.toFixed(12)); if(o.length <= w) return o;
		o = v.toPrecision(10); if(o.length <= w) return o;
		return v.toExponential(5);
	}
	
	/* exponent >= 11 or <= -10 likely exponential */
	function SSF_large_exp(v) {
		var o = SSF_strip_decimal(v.toFixed(11));
		return (o.length > (v<0?12:11) || o === "0" || o === "-0") ? v.toPrecision(6) : o;
	}
	
	function SSF_general_num(v) {
		var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
	
		if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
		else if(Math.abs(V) <= 9) o = SSF_small_exp(v);
		else if(V === 10) o = v.toFixed(10).substr(0,12);
		else o = SSF_large_exp(v);
	
		return SSF_strip_decimal(SSF_normalize_exp(o.toUpperCase()));
	}
	
	
	/*
		"General" rules:
		- text is passed through ("@")
		- booleans are rendered as TRUE/FALSE
		- "up to 11 characters" displayed for numbers
		- Default date format (code 14) used for Dates
	
		The longest 32-bit integer text is "-2147483648", exactly 11 chars
		TODO: technically the display depends on the width of the cell
	*/
	function SSF_general(v, opts) {
		switch(typeof v) {
			case 'string': return v;
			case 'boolean': return v ? "TRUE" : "FALSE";
			case 'number': return (v|0) === v ? v.toString(10) : SSF_general_num(v);
			case 'undefined': return "";
			case 'object':
				if(v == null) return "";
				if(v instanceof Date) return SSF_format(14, datenum_local(v, opts && opts.date1904), opts);
		}
		throw new Error("unsupported value in General format: " + v);
	}
	
	function SSF_fix_hijri(date, o) {
	  /* TODO: properly adjust y/m/d and  */
	  o[0] -= 581;
	  var dow = date.getDay();
	  if(date < 60) dow = (dow + 6) % 7;
	  return dow;
	}
	//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
	function SSF_write_date(type, fmt, val, ss0) {
		var o="", ss=0, tt=0, y = val.y, out, outl = 0;
		switch(type) {
			case 98: /* 'b' buddhist year */
				y = val.y + 543;
				/* falls through */
			case 121: /* 'y' year */
			switch(fmt.length) {
				case 1: case 2: out = y % 100; outl = 2; break;
				default: out = y % 10000; outl = 4; break;
			} break;
			case 109: /* 'm' month */
			switch(fmt.length) {
				case 1: case 2: out = val.m; outl = fmt.length; break;
				case 3: return months[val.m-1][1];
				case 5: return months[val.m-1][0];
				default: return months[val.m-1][2];
			} break;
			case 100: /* 'd' day */
			switch(fmt.length) {
				case 1: case 2: out = val.d; outl = fmt.length; break;
				case 3: return days[val.q][0];
				default: return days[val.q][1];
			} break;
			case 104: /* 'h' 12-hour */
			switch(fmt.length) {
				case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 72: /* 'H' 24-hour */
			switch(fmt.length) {
				case 1: case 2: out = val.H; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 77: /* 'M' minutes */
			switch(fmt.length) {
				case 1: case 2: out = val.M; outl = fmt.length; break;
				default: throw 'bad minute format: ' + fmt;
			} break;
			case 115: /* 's' seconds */
				if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
				if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
	if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
				else tt = ss0 === 1 ? 10 : 1;
				ss = Math.round((tt)*(val.S + val.u));
				if(ss >= 60*tt) ss = 0;
				if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
				o = pad0(ss,2 + ss0);
				if(fmt === 'ss') return o.substr(0,2);
				return "." + o.substr(2,fmt.length-1);
			case 90: /* 'Z' absolute time */
			switch(fmt) {
				case '[h]': case '[hh]': out = val.D*24+val.H; break;
				case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
				case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
				default: throw 'bad abstime format: ' + fmt;
			} outl = fmt.length === 3 ? 1 : 2; break;
			case 101: /* 'e' era */
				out = y; outl = 1; break;
		}
		var outstr = outl > 0 ? pad0(out, outl) : "";
		return outstr;
	}
	
	
	/*jshint -W086 */
	/*jshint +W086 */
	function commaify(s) {
		var w = 3;
		if(s.length <= w) return s;
		var j = (s.length % w), o = s.substr(0,j);
		for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
		return o;
	}
	var pct1 = /%/g;
	function write_num_pct(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	
	function write_num_cm(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	
	function write_num_exp(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(o.indexOf("e") === -1) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				while(o.substr(0,2) === "0.") {
					o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
					o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
				}
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
	function write_num_f1(r, aval, sign) {
		var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
		var myn = (rr - base*den), myd = den;
		return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
	}
	function write_num_f2(r, aval, sign) {
		return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
	}
	var dec1 = /^#*0*\.([0#]+)/;
	var closeparen = /\).*[0#]/;
	var phone = /\(###\) ###\\?-####/;
	function hashq(str) {
		var o = "", cc;
		for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
			case 35: break;
			case 63: o+= " "; break;
			case 48: o+= "0"; break;
			default: o+= String.fromCharCode(cc);
		}
		return o;
	}
	function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
	function dec(val, d) {
		var _frac = val - Math.floor(val), dd = Math.pow(10,d);
		if (d < ('' + Math.round(_frac * dd)).length) return 0;
		return Math.round(_frac * dd);
	}
	function carry(val, d) {
		if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
			return 1;
		}
		return 0;
	}
	function flr(val) {
		if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0));
		return ""+Math.floor(val);
	}
	function write_num_flt(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_flt('n', ffmt, val);
			return '(' + write_num_flt('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = pad0r(val,0); if(o === "0") o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
			o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_flt(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = pad0r(val, 0);
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			ri = dec(val, r[1].length);
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
		}
		switch(fmt) {
			case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
			case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
			case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
			default:
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num_cm2(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_pct2(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_exp2(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp2(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(!o.match(/[Ee]/)) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	function write_num_int(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_int('n', ffmt, val);
			return '(' + write_num_int('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = (""+val); if(val === 0) o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
	o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
			o = o.replace(/\.(\d*)$/,function($$, $1) {
	return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_int(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = "" + val;
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
		}
		switch(fmt) {
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
			default:
				if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num(type, fmt, val) {
		return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
	}
	function SSF_split_fmt(fmt) {
		var out = [];
		var in_str = false/*, cc*/;
		for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
			case 34: /* '"' */
				in_str = !in_str; break;
			case 95: case 42: case 92: /* '_' '*' '\\' */
				++i; break;
			case 59: /* ';' */
				out[out.length] = fmt.substr(j,i-j);
				j = i+1;
		}
		out[out.length] = fmt.substr(j);
		if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
		return out;
	}
	
	var SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
	function fmt_is_date(fmt) {
		var i = 0, /*cc = 0,*/ c = "", o = "";
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': if(SSF_isgeneral(fmt, i)) i+= 6; i++; break;
				case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;){/*empty*/} ++i; break;
				case '\\': i+=2; break;
				case '_': i+=2; break;
				case '@': ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
				case 'A': case 'a': case '上':
					if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
					if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
					if(fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
					++i; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.match(SSF_abstime)) return true;
					break;
				case '.':
					/* falls through */
				case '0': case '#':
					while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
					break;
				case '?': while(fmt.charAt(++i) === c){/* empty */} break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
				case '(': case ')': ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
				case ' ': ++i; break;
				default: ++i; break;
			}
		}
		return false;
	}
	
	function eval_fmt(fmt, v, opts, flen) {
		var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
		var hr='H';
		/* Tokenize */
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': /* General */
					if(!SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
					out[out.length] = {t:'G', v:'General'}; i+=7; break;
				case '"': /* Literal text */
					for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
					out[out.length] = {t:'t', v:o}; ++i; break;
				case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
					out[out.length] = {t:t, v:w}; ++i; break;
				case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
				case '@': /* Text Placeholder */
					out[out.length] = {t:'T', v:v}; ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
						if(dt==null) { dt=SSF_parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
						out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
					}
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					c = c.toLowerCase();
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
					if(v < 0) return "";
					if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
					o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
					if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
					if(c === 'h') c = hr;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case 'A': case 'a': case '上':
					var q={t:c, v:c};
					if(dt==null) dt=SSF_parse_date_code(v, opts);
					if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
					else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
					else if(fmt.substr(i,5).toUpperCase() === "上午/下午") { if(dt!=null) q.v = dt.H >= 12 ? "下午" : "上午"; q.t = 'T'; i+=5; hr='h'; }
					else { q.t = "t"; ++i; }
					if(dt==null && q.t === 'T') return "";
					out[out.length] = q; lst = c; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
					if(o.match(SSF_abstime)) {
						if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
						out[out.length] = {t:'Z', v:o.toLowerCase()};
						lst = o.charAt(1);
					} else if(o.indexOf("$") > -1) {
						o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
						if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
					}
					break;
				/* Numbers */
				case '.':
					if(dt != null) {
						o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
						out[out.length] = {t:'s', v:o}; break;
					}
					/* falls through */
				case '0': case '#':
					o = c; while(++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) o += c;
					out[out.length] = {t:'n', v:o}; break;
				case '?':
					o = c; while(fmt.charAt(++i) === c) o+=c;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
				case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
					out[out.length] = {t:'D', v:o}; break;
				case ' ': out[out.length] = {t:c, v:c}; ++i; break;
				case '$': out[out.length] = {t:'t', v:'$'}; ++i; break;
				default:
					if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
					out[out.length] = {t:'t', v:c}; ++i; break;
			}
		}
	
		/* Scan for date/time parts */
		var bt = 0, ss0 = 0, ssm;
		for(i=out.length-1, lst='t'; i >= 0; --i) {
			switch(out[i].t) {
				case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
				case 's':
					if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
					if(bt < 3) bt = 3;
				/* falls through */
				case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
				case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
				case 'X': /*if(out[i].v === "B2");*/
					break;
				case 'Z':
					if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
					if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
					if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
			}
		}
		/* time rounding depends on presence of minute / second / usec fields */
		switch(bt) {
			case 0: break;
			case 1:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				if(dt.M >=  60) { dt.M = 0; ++dt.H; }
				break;
			case 2:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				break;
		}
	
		/* replace fields */
		var nstr = "", jj;
		for(i=0; i < out.length; ++i) {
			switch(out[i].t) {
				case 't': case 'T': case ' ': case 'D': break;
				case 'X': out[i].v = ""; out[i].t = ";"; break;
				case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
	out[i].v = SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
					out[i].t = 't'; break;
				case 'n': case '?':
					jj = i+1;
					while(out[jj] != null && (
						(c=out[jj].t) === "?" || c === "D" ||
						((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
						(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
						(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
					)) {
						out[i].v += out[jj].v;
						out[jj] = {v:"", t:";"}; ++jj;
					}
					nstr += out[i].v;
					i = jj-1; break;
				case 'G': out[i].t = 't'; out[i].v = SSF_general(v,opts); break;
			}
		}
		var vv = "", myv, ostr;
		if(nstr.length > 0) {
			if(nstr.charCodeAt(0) == 40) /* '(' */ {
				myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
				ostr = write_num('n', nstr, myv);
			} else {
				myv = (v<0 && flen > 1 ? -v : v);
				ostr = write_num('n', nstr, myv);
				if(myv < 0 && out[0] && out[0].t == 't') {
					ostr = ostr.substr(1);
					out[0].v = "-" + out[0].v;
				}
			}
			jj=ostr.length-1;
			var decpt = out.length;
			for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
			var lasti=out.length;
			if(decpt === out.length && ostr.indexOf("E") === -1) {
				for(i=out.length-1; i>= 0;--i) {
					if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
					if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
					else if(jj < 0) out[i].v = "";
					else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			}
			else if(decpt !== out.length && ostr.indexOf("E") === -1) {
				jj = ostr.indexOf(".")-1;
				for(i=decpt; i>= 0; --i) {
					if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
					vv = out[i].v.substr(j+1);
					for(; j>=0; --j) {
						if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
				jj = ostr.indexOf(".")+1;
				for(i=decpt; i<out.length; ++i) {
					if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
					vv = out[i].v.substr(0,j);
					for(; j<out[i].v.length; ++j) {
						if(jj<ostr.length) vv += ostr.charAt(jj++);
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
			}
		}
		for(i=0; i<out.length; ++i) if(out[i] != null && 'n?'.indexOf(out[i].t)>-1) {
			myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
			out[i].v = write_num(out[i].t, out[i].v, myv);
			out[i].t = 't';
		}
		var retval = "";
		for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
		return retval;
	}
	
	var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
	function chkcond(v, rr) {
		if(rr == null) return false;
		var thresh = parseFloat(rr[2]);
		switch(rr[1]) {
			case "=":  if(v == thresh) return true; break;
			case ">":  if(v >  thresh) return true; break;
			case "<":  if(v <  thresh) return true; break;
			case "<>": if(v != thresh) return true; break;
			case ">=": if(v >= thresh) return true; break;
			case "<=": if(v <= thresh) return true; break;
		}
		return false;
	}
	function choose_fmt(f, v) {
		var fmt = SSF_split_fmt(f);
		var l = fmt.length, lat = fmt[l-1].indexOf("@");
		if(l<4 && lat>-1) --l;
		if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
		if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
		switch(fmt.length) {
			case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
			case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
			case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
			case 4: break;
		}
		var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
		if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
		if(fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
			var m1 = fmt[0].match(cfregex2);
			var m2 = fmt[1].match(cfregex2);
			return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
		}
		return [l, ff];
	}
	function SSF_format(fmt,v,o) {
		if(o == null) o = {};
		var sfmt = "";
		switch(typeof fmt) {
			case "string":
				if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
				else sfmt = fmt;
				break;
			case "number":
				if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
				else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
				if(sfmt == null) sfmt = (o.table && o.table[SSF_default_map[fmt]]) || table_fmt[SSF_default_map[fmt]];
				if(sfmt == null) sfmt = SSF_default_str[fmt] || "General";
				break;
		}
		if(SSF_isgeneral(sfmt,0)) return SSF_general(v, o);
		if(v instanceof Date) v = datenum_local(v, o.date1904);
		var f = choose_fmt(sfmt, v);
		if(SSF_isgeneral(f[1])) return SSF_general(v, o);
		if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
		else if(v === "" || v == null) return "";
		return eval_fmt(f[1], v, o, f[0]);
	}
	function SSF_load(fmt, idx) {
		if(typeof idx != 'number') {
			idx = +idx || -1;
	for(var i = 0; i < 0x0188; ++i) {
	if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
				if(table_fmt[i] == fmt) { idx = i; break; }
			}
	if(idx < 0) idx = 0x187;
		}
	table_fmt[idx] = fmt;
		return idx;
	}
	function SSF_load_table(tbl) {
		for(var i=0; i!=0x0188; ++i)
			if(tbl[i] !== undefined) SSF_load(tbl[i], i);
	}
	
	function make_ssf() {
		table_fmt = SSF_init_table();
	}
	
	var SSF = {
		format: SSF_format,
		load: SSF_load,
		_table: table_fmt,
		load_table: SSF_load_table,
		parse_date_code: SSF_parse_date_code,
		is_date: fmt_is_date,
		get_table: function get_table() { return SSF._table = table_fmt; }
	};
	
	var SSFImplicit/*{[number]:string}*/ = ({
		"5": '"$"#,##0_);\\("$"#,##0\\)',
		"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"23": 'General', "24": 'General', "25": 'General', "26": 'General',
		"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
		"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
		"36": 'm/d/yy',
		"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
		"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
		"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
		"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
		"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
		"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
		"59": '0',
		"60": '0.00',
		"61": '#,##0',
		"62": '#,##0.00',
		"63": '"$"#,##0_);\\("$"#,##0\\)',
		"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"67": '0%',
		"68": '0.00%',
		"69": '# ?/?',
		"70": '# ??/??',
		"71": 'm/d/yy',
		"72": 'm/d/yy',
		"73": 'd-mmm-yy',
		"74": 'd-mmm',
		"75": 'mmm-yy',
		"76": 'h:mm',
		"77": 'h:mm:ss',
		"78": 'm/d/yy h:mm',
		"79": 'mm:ss',
		"80": '[h]:mm:ss',
		"81": 'mmss.0'
	});
	
	/* dateNF parse TODO: move to SSF */
	var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
	function dateNF_regex(dateNF) {
		var fmt = typeof dateNF == "number" ? table_fmt[dateNF] : dateNF;
		fmt = fmt.replace(dateNFregex, "(\\d+)");
		return new RegExp("^" + fmt + "$");
	}
	function dateNF_fix(str, dateNF, match) {
		var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
		(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
			var v = parseInt(match[i+1], 10);
			switch(n.toLowerCase().charAt(0)) {
				case 'y': Y = v; break; case 'd': d = v; break;
				case 'h': H = v; break; case 's': S = v; break;
				case 'm': if(H >= 0) M = v; else m = v; break;
			}
		});
		if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
		var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
		if(datestr.length == 7) datestr = "0" + datestr;
		if(datestr.length == 8) datestr = "20" + datestr;
		var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
		if(H == -1 && M == -1 && S == -1) return datestr;
		if(Y == -1 && m == -1 && d == -1) return timestr;
		return datestr + "T" + timestr;
	}
	
	/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*jshint eqnull:true */
	/*exported CFB */
	/*global Uint8Array:false, Uint16Array:false */
	
	/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported CRC32 */
	var CRC32 = (function() {
	var CRC32 = {};
	CRC32.version = '1.2.0';
	/* see perf/crc32table.js */
	/*global Int32Array */
	function signed_crc_table() {
		var c = 0, table = new Array(256);
	
		for(var n =0; n != 256; ++n){
			c = n;
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			table[n] = c;
		}
	
		return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
	}
	
	var T0 = signed_crc_table();
	function slice_by_16_tables(T) {
		var c = 0, v = 0, n = 0, table = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096) ;
	
		for(n = 0; n != 256; ++n) table[n] = T[n];
		for(n = 0; n != 256; ++n) {
			v = T[n];
			for(c = 256 + n; c < 4096; c += 256) v = table[c] = (v >>> 8) ^ T[v & 0xFF];
		}
		var out = [];
		for(n = 1; n != 16; ++n) out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
		return out;
	}
	var TT = slice_by_16_tables(T0);
	var T1 = TT[0],  T2 = TT[1],  T3 = TT[2],  T4 = TT[3],  T5 = TT[4];
	var T6 = TT[5],  T7 = TT[6],  T8 = TT[7],  T9 = TT[8],  Ta = TT[9];
	var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
	function crc32_bstr(bstr, seed) {
		var C = seed ^ -1;
		for(var i = 0, L = bstr.length; i < L;) C = (C>>>8) ^ T0[(C^bstr.charCodeAt(i++))&0xFF];
		return ~C;
	}
	
	function crc32_buf(B, seed) {
		var C = seed ^ -1, L = B.length - 15, i = 0;
		for(; i < L;) C =
			Tf[B[i++] ^ (C & 255)] ^
			Te[B[i++] ^ ((C >> 8) & 255)] ^
			Td[B[i++] ^ ((C >> 16) & 255)] ^
			Tc[B[i++] ^ (C >>> 24)] ^
			Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^
			T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^
			T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
		L += 15;
		while(i < L) C = (C>>>8) ^ T0[(C^B[i++])&0xFF];
		return ~C;
	}
	
	function crc32_str(str, seed) {
		var C = seed ^ -1;
		for(var i = 0, L = str.length, c = 0, d = 0; i < L;) {
			c = str.charCodeAt(i++);
			if(c < 0x80) {
				C = (C>>>8) ^ T0[(C^c)&0xFF];
			} else if(c < 0x800) {
				C = (C>>>8) ^ T0[(C ^ (192|((c>>6)&31)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
				C = (C>>>8) ^ T0[(C ^ (240|((c>>8)&7)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((c>>2)&63)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(d&63)))&0xFF];
			} else {
				C = (C>>>8) ^ T0[(C ^ (224|((c>>12)&15)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((c>>6)&63)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
			}
		}
		return ~C;
	}
	CRC32.table = T0;
	CRC32.bstr = crc32_bstr;
	CRC32.buf = crc32_buf;
	CRC32.str = crc32_str;
	return CRC32;
	})();
	/* [MS-CFB] v20171201 */
	var CFB = (function _CFB(){
	var exports = {};
	exports.version = '1.2.1';
	/* [MS-CFB] 2.6.4 */
	function namecmp(l, r) {
		var L = l.split("/"), R = r.split("/");
		for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
			if((c = L[i].length - R[i].length)) return c;
			if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
		}
		return L.length - R.length;
	}
	function dirname(p) {
		if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(0, c+1);
	}
	
	function filename(p) {
		if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(c+1);
	}
	/* -------------------------------------------------------------------------- */
	/* DOS Date format:
	   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
	   add 1980 to stored year
	   stored second should be doubled
	*/
	
	/* write JS date to buf as a DOS date */
	function write_dos_date(buf, date) {
		if(typeof date === "string") date = new Date(date);
		var hms = date.getHours();
		hms = hms << 6 | date.getMinutes();
		hms = hms << 5 | (date.getSeconds()>>>1);
		buf.write_shift(2, hms);
		var ymd = (date.getFullYear() - 1980);
		ymd = ymd << 4 | (date.getMonth()+1);
		ymd = ymd << 5 | date.getDate();
		buf.write_shift(2, ymd);
	}
	
	/* read four bytes from buf and interpret as a DOS date */
	function parse_dos_date(buf) {
		var hms = buf.read_shift(2) & 0xFFFF;
		var ymd = buf.read_shift(2) & 0xFFFF;
		var val = new Date();
		var d = ymd & 0x1F; ymd >>>= 5;
		var m = ymd & 0x0F; ymd >>>= 4;
		val.setMilliseconds(0);
		val.setFullYear(ymd + 1980);
		val.setMonth(m-1);
		val.setDate(d);
		var S = hms & 0x1F; hms >>>= 5;
		var M = hms & 0x3F; hms >>>= 6;
		val.setHours(hms);
		val.setMinutes(M);
		val.setSeconds(S<<1);
		return val;
	}
	function parse_extra_field(blob) {
		prep_blob(blob, 0);
		var o = {};
		var flags = 0;
		while(blob.l <= blob.length - 4) {
			var type = blob.read_shift(2);
			var sz = blob.read_shift(2), tgt = blob.l + sz;
			var p = {};
			switch(type) {
				/* UNIX-style Timestamps */
				case 0x5455: {
					flags = blob.read_shift(1);
					if(flags & 1) p.mtime = blob.read_shift(4);
					/* for some reason, CD flag corresponds to LFH */
					if(sz > 5) {
						if(flags & 2) p.atime = blob.read_shift(4);
						if(flags & 4) p.ctime = blob.read_shift(4);
					}
					if(p.mtime) p.mt = new Date(p.mtime*1000);
				}
				break;
			}
			blob.l = tgt;
			o[type] = p;
		}
		return o;
	}
	var fs;
	function get_fs() { return fs || (fs = __webpack_require__(386)); }
	function parse(file, options) {
	if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
	if((file[0] | 0x20) == 0x6d && (file[1]|0x20) == 0x69) return parse_mad(file, options);
	if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
	var mver = 3;
	var ssz = 512;
	var nmfs = 0; // number of mini FAT sectors
	var difat_sec_cnt = 0;
	var dir_start = 0;
	var minifat_start = 0;
	var difat_start = 0;
	
	var fat_addrs = []; // locations of FAT sectors
	
	/* [MS-CFB] 2.2 Compound File Header */
	var blob = file.slice(0,512);
	prep_blob(blob, 0);
	
	/* major version */
	var mv = check_get_mver(blob);
	mver = mv[0];
	switch(mver) {
		case 3: ssz = 512; break; case 4: ssz = 4096; break;
		case 0: if(mv[1] == 0) return parse_zip(file, options);
		/* falls through */
		default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
	}
	
	/* reprocess header */
	if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
	/* Save header for final object */
	var header = file.slice(0,ssz);
	
	check_shifts(blob, mver);
	
	// Number of Directory Sectors
	var dir_cnt = blob.read_shift(4, 'i');
	if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
	
	// Number of FAT Sectors
	blob.l += 4;
	
	// First Directory Sector Location
	dir_start = blob.read_shift(4, 'i');
	
	// Transaction Signature
	blob.l += 4;
	
	// Mini Stream Cutoff Size
	blob.chk('00100000', 'Mini Stream Cutoff Size: ');
	
	// First Mini FAT Sector Location
	minifat_start = blob.read_shift(4, 'i');
	
	// Number of Mini FAT Sectors
	nmfs = blob.read_shift(4, 'i');
	
	// First DIFAT sector location
	difat_start = blob.read_shift(4, 'i');
	
	// Number of DIFAT Sectors
	difat_sec_cnt = blob.read_shift(4, 'i');
	
	// Grab FAT Sector Locations
	for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
		q = blob.read_shift(4, 'i');
		if(q<0) break;
		fat_addrs[j] = q;
	}
	
	/** Break the file up into sectors */
	var sectors = sectorify(file, ssz);
	
	sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
	
	/** Chains */
	var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);
	
	sector_list[dir_start].name = "!Directory";
	if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
	sector_list[fat_addrs[0]].name = "!FAT";
	sector_list.fat_addrs = fat_addrs;
	sector_list.ssz = ssz;
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	var files = {}, Paths = [], FileIndex = [], FullPaths = [];
	read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
	
	build_full_paths(FileIndex, FullPaths, Paths);
	Paths.shift();
	
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	
	// $FlowIgnore
	if(options && options.raw) o.raw = {header: header, sectors: sectors};
	return o;
	} // parse
	
	/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
	function check_get_mver(blob) {
		if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
		// header signature 8
		blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
	
		// clsid 16
		//blob.chk(HEADER_CLSID, 'CLSID: ');
		blob.l += 16;
	
		// minor version 2
		var mver = blob.read_shift(2, 'u');
	
		return [blob.read_shift(2,'u'), mver];
	}
	function check_shifts(blob, mver) {
		var shift = 0x09;
	
		// Byte Order
		//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
		blob.l += 2;
	
		// Sector Shift
		switch((shift = blob.read_shift(2))) {
			case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
			case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
			default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
		}
	
		// Mini Sector Shift
		blob.chk('0600', 'Mini Sector Shift: ');
	
		// Reserved
		blob.chk('000000000000', 'Reserved: ');
	}
	
	/** Break the file up into sectors */
	function sectorify(file, ssz) {
		var nsectors = Math.ceil(file.length/ssz)-1;
		var sectors = [];
		for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
		sectors[nsectors-1] = file.slice(nsectors*ssz);
		return sectors;
	}
	
	/* [MS-CFB] 2.6.4 Red-Black Tree */
	function build_full_paths(FI, FP, Paths) {
		var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
		var dad = [], q = [];
	
		for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }
	
		for(; j < q.length; ++j) {
			i = q[j];
			L = FI[i].L; R = FI[i].R; C = FI[i].C;
			if(dad[i] === i) {
				if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
				if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
			}
			if(C !== -1 /*NOSTREAM*/) dad[C] = i;
			if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
			if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
		}
		for(i=1; i < pl; ++i) if(dad[i] === i) {
			if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
			else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
		}
	
		for(i=1; i < pl; ++i) {
			if(FI[i].type === 0 /* unknown */) continue;
			j = i;
			if(j != dad[j]) do {
				j = dad[j];
				FP[i] = FP[j] + "/" + FP[i];
			} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
			dad[i] = -1;
		}
	
		FP[0] += "/";
		for(i=1; i < pl; ++i) {
			if(FI[i].type !== 2 /* stream */) FP[i] += "/";
		}
	}
	
	function get_mfat_entry(entry, payload, mini) {
		var start = entry.start, size = entry.size;
		//return (payload.slice(start*MSSZ, start*MSSZ + size));
		var o = [];
		var idx = start;
		while(mini && size > 0 && idx >= 0) {
			o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
			size -= MSSZ;
			idx = __readInt32LE(mini, idx * 4);
		}
		if(o.length === 0) return (new_buf(0));
		return (bconcat(o).slice(0, entry.size));
	}
	
	/** Chase down the rest of the DIFAT chain to build a comprehensive list
	    DIFAT chains by storing the next sector number as the last 32 bits */
	function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
		var q = ENDOFCHAIN;
		if(idx === ENDOFCHAIN) {
			if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
		} else if(idx !== -1 /*FREESECT*/) {
			var sector = sectors[idx], m = (ssz>>>2)-1;
			if(!sector) return;
			for(var i = 0; i < m; ++i) {
				if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
				fat_addrs.push(q);
			}
			sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
		}
	}
	
	/** Follow the linked list of sectors for a given starting point */
	function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
		var buf = [], buf_chain = [];
		if(!chkd) chkd = [];
		var modulus = ssz - 1, j = 0, jj = 0;
		for(j=start; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		return {nodes: buf, data:__toBuffer([buf_chain])};
	}
	
	/** Chase down the sector linked lists */
	function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
		var sl = sectors.length, sector_list = ([]);
		var chkd = [], buf = [], buf_chain = [];
		var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
		for(i=0; i < sl; ++i) {
			buf = ([]);
			k = (i + dir_start); if(k >= sl) k-=sl;
			if(chkd[k]) continue;
			buf_chain = [];
			var seen = [];
			for(j=k; j>=0;) {
				seen[j] = true;
				chkd[j] = true;
				buf[buf.length] = j;
				buf_chain.push(sectors[j]);
				var addr = fat_addrs[Math.floor(j*4/ssz)];
				jj = ((j*4) & modulus);
				if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
				if(!sectors[addr]) break;
				j = __readInt32LE(sectors[addr], jj);
				if(seen[j]) break;
			}
			sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
		}
		return sector_list;
	}
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
		var minifat_store = 0, pl = (Paths.length?2:0);
		var sector = sector_list[dir_start].data;
		var i = 0, namelen = 0, name;
		for(; i < sector.length; i+= 128) {
			var blob = sector.slice(i, i+128);
			prep_blob(blob, 64);
			namelen = blob.read_shift(2);
			name = __utf16le(blob,0,namelen-pl);
			Paths.push(name);
			var o = ({
				name:  name,
				type:  blob.read_shift(1),
				color: blob.read_shift(1),
				L:     blob.read_shift(4, 'i'),
				R:     blob.read_shift(4, 'i'),
				C:     blob.read_shift(4, 'i'),
				clsid: blob.read_shift(16),
				state: blob.read_shift(4, 'i'),
				start: 0,
				size: 0
			});
			var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
			var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
			o.start = blob.read_shift(4, 'i');
			o.size = blob.read_shift(4, 'i');
			if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
			if(o.type === 5) { /* root */
				minifat_store = o.start;
				if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
				/*minifat_size = o.size;*/
			} else if(o.size >= 4096 /* MSCSZ */) {
				o.storage = 'fat';
				if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
				sector_list[o.start].name = o.name;
				o.content = (sector_list[o.start].data.slice(0,o.size));
			} else {
				o.storage = 'minifat';
				if(o.size < 0) o.size = 0;
				else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
					o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
				}
			}
			if(o.content) prep_blob(o.content, 0);
			files[name] = o;
			FileIndex.push(o);
		}
	}
	
	function read_date(blob, offset) {
		return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
	}
	
	function read_file(filename, options) {
		get_fs();
		return parse(fs.readFileSync(filename), options);
	}
	
	function read(blob, options) {
		var type = options && options.type;
		if(!type) {
			if(has_buf && Buffer.isBuffer(blob)) type = "buffer";
		}
		switch(type || "base64") {
			case "file": return read_file(blob, options);
			case "base64": return parse(s2a(Base64_decode(blob)), options);
			case "binary": return parse(s2a(blob), options);
		}
		return parse(blob, options);
	}
	
	function init_cfb(cfb, opts) {
		var o = opts || {}, root = o.root || "Root Entry";
		if(!cfb.FullPaths) cfb.FullPaths = [];
		if(!cfb.FileIndex) cfb.FileIndex = [];
		if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
		if(cfb.FullPaths.length === 0) {
			cfb.FullPaths[0] = root + "/";
			cfb.FileIndex[0] = ({ name: root, type: 5 });
		}
		if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
		seed_cfb(cfb);
	}
	function seed_cfb(cfb) {
		var nm = "\u0001Sh33tJ5";
		if(CFB.find(cfb, "/" + nm)) return;
		var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
		cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
		cfb.FullPaths.push(cfb.FullPaths[0] + nm);
		rebuild_cfb(cfb);
	}
	function rebuild_cfb(cfb, f) {
		init_cfb(cfb);
		var gc = false, s = false;
		for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
			var _file = cfb.FileIndex[i];
			switch(_file.type) {
				case 0:
					if(s) gc = true;
					else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
					break;
				case 1: case 2: case 5:
					s = true;
					if(isNaN(_file.R * _file.L * _file.C)) gc = true;
					if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
					break;
				default: gc = true; break;
			}
		}
		if(!gc && !f) return;
	
		var now = new Date(1987, 1, 19), j = 0;
		// Track which names exist
		var fullPaths = Object.create ? Object.create(null) : {};
		var data = [];
		for(i = 0; i < cfb.FullPaths.length; ++i) {
			fullPaths[cfb.FullPaths[i]] = true;
			if(cfb.FileIndex[i].type === 0) continue;
			data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
		}
		for(i = 0; i < data.length; ++i) {
			var dad = dirname(data[i][0]);
			s = fullPaths[dad];
			if(!s) {
				data.push([dad, ({
					name: filename(dad).replace("/",""),
					type: 1,
					clsid: HEADER_CLSID,
					ct: now, mt: now,
					content: null
				})]);
				// Add name to set
				fullPaths[dad] = true;
			}
		}
	
		data.sort(function(x,y) { return namecmp(x[0], y[0]); });
		cfb.FullPaths = []; cfb.FileIndex = [];
		for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
		for(i = 0; i < data.length; ++i) {
			var elt = cfb.FileIndex[i];
			var nm = cfb.FullPaths[i];
	
			elt.name =  filename(nm).replace("/","");
			elt.L = elt.R = elt.C = -(elt.color = 1);
			elt.size = elt.content ? elt.content.length : 0;
			elt.start = 0;
			elt.clsid = (elt.clsid || HEADER_CLSID);
			if(i === 0) {
				elt.C = data.length > 1 ? 1 : -1;
				elt.size = 0;
				elt.type = 5;
			} else if(nm.slice(-1) == "/") {
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
				elt.C = j >= data.length ? -1 : j;
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
				elt.R = j >= data.length ? -1 : j;
				elt.type = 1;
			} else {
				if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
				elt.type = 2;
			}
		}
	
	}
	
	function _write(cfb, options) {
		var _opts = options || {};
		/* MAD is order-sensitive, skip rebuild and sort */
		if(_opts.fileType == 'mad') return write_mad(cfb, _opts);
		rebuild_cfb(cfb);
		switch(_opts.fileType) {
			case 'zip': return write_zip(cfb, _opts);
			//case 'mad': return write_mad(cfb, _opts);
		}
		var L = (function(cfb){
			var mini_size = 0, fat_size = 0;
			for(var i = 0; i < cfb.FileIndex.length; ++i) {
				var file = cfb.FileIndex[i];
				if(!file.content) continue;
	var flen = file.content.length;
				if(flen > 0){
					if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
					else fat_size += (flen + 0x01FF) >> 9;
				}
			}
			var dir_cnt = (cfb.FullPaths.length +3) >> 2;
			var mini_cnt = (mini_size + 7) >> 3;
			var mfat_cnt = (mini_size + 0x7F) >> 7;
			var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
			var fat_cnt = (fat_base + 0x7F) >> 7;
			var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
			cfb.FileIndex[0].size = mini_size << 6;
			L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
			return L;
		})(cfb);
		var o = new_buf(L[7] << 9);
		var i = 0, T = 0;
		{
			for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
			for(i = 0; i < 8; ++i) o.write_shift(2, 0);
			o.write_shift(2, 0x003E);
			o.write_shift(2, 0x0003);
			o.write_shift(2, 0xFFFE);
			o.write_shift(2, 0x0009);
			o.write_shift(2, 0x0006);
			for(i = 0; i < 3; ++i) o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, L[2]);
			o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
			o.write_shift(4, 0);
			o.write_shift(4, 1<<12);
			o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
			o.write_shift(4, L[3]);
			o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
			o.write_shift(4, L[1]);
			for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
		}
		if(L[1]) {
			for(T = 0; T < L[1]; ++T) {
				for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
				o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
			}
		}
		var chainit = function(w) {
			for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
			if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
		};
		T = i = 0;
		for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
		for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
		chainit(L[3]);
		chainit(L[4]);
		var j = 0, flen = 0;
		var file = cfb.FileIndex[0];
		for(; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(flen < 0x1000) continue;
			file.start = T;
			chainit((flen + 0x01FF) >> 9);
		}
		chainit((L[6] + 7) >> 3);
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		T = i = 0;
		for(j = 0; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(!flen || flen >= 0x1000) continue;
			file.start = T;
			chainit((flen + 0x3F) >> 6);
		}
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		for(i = 0; i < L[4]<<2; ++i) {
			var nm = cfb.FullPaths[i];
			if(!nm || nm.length === 0) {
				for(j = 0; j < 17; ++j) o.write_shift(4, 0);
				for(j = 0; j < 3; ++j) o.write_shift(4, -1);
				for(j = 0; j < 12; ++j) o.write_shift(4, 0);
				continue;
			}
			file = cfb.FileIndex[i];
			if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
			var _nm = (i === 0 && _opts.root) || file.name;
			flen = 2*(_nm.length+1);
			o.write_shift(64, _nm, "utf16le");
			o.write_shift(2, flen);
			o.write_shift(1, file.type);
			o.write_shift(1, file.color);
			o.write_shift(-4, file.L);
			o.write_shift(-4, file.R);
			o.write_shift(-4, file.C);
			if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
			else o.write_shift(16, file.clsid, "hex");
			o.write_shift(4, file.state || 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, file.start);
			o.write_shift(4, file.size); o.write_shift(4, 0);
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size >= 0x1000) {
				o.l = (file.start+1) << 9;
				if (has_buf && Buffer.isBuffer(file.content)) {
					file.content.copy(o, o.l, 0, file.size);
					// o is a 0-filled Buffer so just set next offset
					o.l += (file.size + 511) & -512;
				} else {
					for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
					for(; j & 0x1FF; ++j) o.write_shift(1, 0);
				}
			}
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size > 0 && file.size < 0x1000) {
				if (has_buf && Buffer.isBuffer(file.content)) {
					file.content.copy(o, o.l, 0, file.size);
					// o is a 0-filled Buffer so just set next offset
					o.l += (file.size + 63) & -64;
				} else {
					for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
					for(; j & 0x3F; ++j) o.write_shift(1, 0);
				}
			}
		}
		if (has_buf) {
			o.l = o.length;
		} else {
			// When using Buffer, already 0-filled
			while(o.l < o.length) o.write_shift(1, 0);
		}
		return o;
	}
	/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
	function find(cfb, path) {
		var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
		var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
		var k = false;
		if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
		else k = path.indexOf("/") !== -1;
		var UCPath = path.toUpperCase();
		var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
		if(w !== -1) return cfb.FileIndex[w];
	
		var m = !UCPath.match(chr1);
		UCPath = UCPath.replace(chr0,'');
		if(m) UCPath = UCPath.replace(chr1,'!');
		for(w = 0; w < UCFullPaths.length; ++w) {
			if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
			if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		}
		return null;
	}
	/** CFB Constants */
	var MSSZ = 64; /* Mini Sector Size = 1<<6 */
	//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
	/* 2.1 Compound File Sector Numbers and Types */
	var ENDOFCHAIN = -2;
	/* 2.2 Compound File Header */
	var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
	var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
	var HEADER_CLSID = '00000000000000000000000000000000';
	var consts = {
		/* 2.1 Compund File Sector Numbers and Types */
		MAXREGSECT: -6,
		DIFSECT: -4,
		FATSECT: -3,
		ENDOFCHAIN: ENDOFCHAIN,
		FREESECT: -1,
		/* 2.2 Compound File Header */
		HEADER_SIGNATURE: HEADER_SIGNATURE,
		HEADER_MINOR_VERSION: '3e00',
		MAXREGSID: -6,
		NOSTREAM: -1,
		HEADER_CLSID: HEADER_CLSID,
		/* 2.6.1 Compound File Directory Entry */
		EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
	};
	
	function write_file(cfb, filename, options) {
		get_fs();
		var o = _write(cfb, options);
	fs.writeFileSync(filename, o);
	}
	
	function a2s(o) {
		var out = new Array(o.length);
		for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
		return out.join("");
	}
	
	function write(cfb, options) {
		var o = _write(cfb, options);
		switch(options && options.type || "buffer") {
			case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
			case "binary": return typeof o == "string" ? o : a2s(o);
			case "base64": return Base64_encode(typeof o == "string" ? o : a2s(o));
			case "buffer": if(has_buf) return Buffer.isBuffer(o) ? o : Buffer_from(o);
				/* falls through */
			case "array": return typeof o == "string" ? s2a(o) : o;
		}
		return o;
	}
	/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
	var _zlib;
	function use_zlib(zlib) { try {
		var InflateRaw = zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
		if(InflRaw.bytesRead) _zlib = zlib;
		else throw new Error("zlib does not expose bytesRead");
	} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }
	
	function _inflateRawSync(payload, usz) {
		if(!_zlib) return _inflate(payload, usz);
		var InflateRaw = _zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
		payload.l += InflRaw.bytesRead;
		return out;
	}
	
	function _deflateRawSync(payload) {
		return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
	}
	var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
	var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];
	
	/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
	var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];
	
	function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }
	
	var use_typed_arrays = typeof Uint8Array !== 'undefined';
	
	var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
	for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);
	
	function bit_swap_n(n, b) {
		var rev = bitswap8[n & 0xFF];
		if(b <= 8) return rev >>> (8-b);
		rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
		if(b <= 16) return rev >>> (16-b);
		rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
		return rev >>> (24-b);
	}
	
	/* helpers for unaligned bit reads */
	function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
	function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
	function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
	function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
	function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }
	
	/* works up to n = 3 * 8 + 1 = 25 */
	function read_bits_n(buf, bl, n) {
		var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
		var v = buf[h] >>> w;
		if(n < 8 - w) return v & f;
		v |= buf[h+1]<<(8-w);
		if(n < 16 - w) return v & f;
		v |= buf[h+2]<<(16-w);
		if(n < 24 - w) return v & f;
		v |= buf[h+3]<<(24-w);
		return v & f;
	}
	
	/* helpers for unaligned bit writes */
	function write_bits_3(buf, bl, v) { var w = bl & 7, h = bl >>> 3;
		if(w <= 5) buf[h] |= (v & 7) << w;
		else {
			buf[h] |= (v << w) & 0xFF;
			buf[h+1] = (v&7) >> (8-w);
		}
		return bl + 3;
	}
	
	function write_bits_1(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v = (v&1) << w;
		buf[h] |= v;
		return bl + 1;
	}
	function write_bits_8(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v <<= w;
		buf[h] |=  v & 0xFF; v >>>= 8;
		buf[h+1] = v;
		return bl + 8;
	}
	function write_bits_16(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v <<= w;
		buf[h] |=  v & 0xFF; v >>>= 8;
		buf[h+1] = v & 0xFF;
		buf[h+2] = v >>> 8;
		return bl + 16;
	}
	
	/* until ArrayBuffer#realloc is a thing, fake a realloc */
	function realloc(b, sz) {
		var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
		if(L >= sz) return b;
		if(has_buf) {
			var o = new_unsafe_buf(M);
			// $FlowIgnore
			if(b.copy) b.copy(o);
			else for(; i < b.length; ++i) o[i] = b[i];
			return o;
		} else if(use_typed_arrays) {
			var a = new Uint8Array(M);
			if(a.set) a.set(b);
			else for(; i < L; ++i) a[i] = b[i];
			return a;
		}
		b.length = M;
		return b;
	}
	
	/* zero-filled arrays for older browsers */
	function zero_fill_array(n) {
		var o = new Array(n);
		for(var i = 0; i < n; ++i) o[i] = 0;
		return o;
	}
	
	/* build tree (used for literals and lengths) */
	function build_tree(clens, cmap, MAX) {
		var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
	
		var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
		for(i = 0; i < 32; ++i) bl_count[i] = 0;
	
		for(i = L; i < MAX; ++i) clens[i] = 0;
		L = clens.length;
	
		var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
	
		/* build code tree */
		for(i = 0; i < L; ++i) {
			bl_count[(w = clens[i])]++;
			if(maxlen < w) maxlen = w;
			ctree[i] = 0;
		}
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
		for(i = 0; i < L; ++i) {
			ccode = clens[i];
			if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
		}
	
		/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
				for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
					cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
			}
		}
		return maxlen;
	}
	
	/* Fixed Huffman */
	var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
	var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
	if(!use_typed_arrays) {
		for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
		for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
	}
	(function() {
		var dlens = [];
		var i = 0;
		for(;i<32; i++) dlens.push(5);
		build_tree(dlens, fix_dmap, 32);
	
		var clens = [];
		i = 0;
		for(; i<=143; i++) clens.push(8);
		for(; i<=255; i++) clens.push(9);
		for(; i<=279; i++) clens.push(7);
		for(; i<=287; i++) clens.push(8);
		build_tree(clens, fix_lmap, 288);
	})();var _deflateRaw = (function _deflateRawIIFE() {
		var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
		var j = 0, k = 0;
		for(; j < DST_LN.length - 1; ++j) {
			for(; k < DST_LN[j+1]; ++k) DST_LN_RE[k] = j;
		}
		for(;k < 32768; ++k) DST_LN_RE[k] = 29;
	
		var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
		for(j = 0, k = 0; j < LEN_LN.length - 1; ++j) {
			for(; k < LEN_LN[j+1]; ++k) LEN_LN_RE[k] = j;
		}
	
		function write_stored(data, out) {
			var boff = 0;
			while(boff < data.length) {
				var L = Math.min(0xFFFF, data.length - boff);
				var h = boff + L == data.length;
				out.write_shift(1, +h);
				out.write_shift(2, L);
				out.write_shift(2, (~L) & 0xFFFF);
				while(L-- > 0) out[out.l++] = data[boff++];
			}
			return out.l;
		}
	
		/* Fixed Huffman */
		function write_huff_fixed(data, out) {
			var bl = 0;
			var boff = 0;
			var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
			while(boff < data.length) {
				var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
	
				/* write a stored block for short data */
				if(L < 10) {
					bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
					if(bl & 7) bl += 8 - (bl & 7);
					out.l = (bl / 8) | 0;
					out.write_shift(2, L);
					out.write_shift(2, (~L) & 0xFFFF);
					while(L-- > 0) out[out.l++] = data[boff++];
					bl = out.l * 8;
					continue;
				}
	
				bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
				var hash = 0;
				while(L-- > 0) {
					var d = data[boff];
					hash = ((hash << 5) ^ d) & 0x7FFF;
	
					var match = -1, mlen = 0;
	
					if((match = addrs[hash])) {
						match |= boff & ~0x7FFF;
						if(match > boff) match -= 0x8000;
						if(match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250) ++mlen;
					}
	
					if(mlen > 2) {
						/* Copy Token  */
						d = LEN_LN_RE[mlen];
						if(d <= 22) bl = write_bits_8(out, bl, bitswap8[d+1]>>1) - 1;
						else {
							write_bits_8(out, bl, 3);
							bl += 5;
							write_bits_8(out, bl, bitswap8[d-23]>>5);
							bl += 3;
						}
						var len_eb = (d < 8) ? 0 : ((d - 4)>>2);
						if(len_eb > 0) {
							write_bits_16(out, bl, mlen - LEN_LN[d]);
							bl += len_eb;
						}
	
						d = DST_LN_RE[boff - match];
						bl = write_bits_8(out, bl, bitswap8[d]>>3);
						bl -= 3;
	
						var dst_eb = d < 4 ? 0 : (d-2)>>1;
						if(dst_eb > 0) {
							write_bits_16(out, bl, boff - match - DST_LN[d]);
							bl += dst_eb;
						}
						for(var q = 0; q < mlen; ++q) {
							addrs[hash] = boff & 0x7FFF;
							hash = ((hash << 5) ^ data[boff]) & 0x7FFF;
							++boff;
						}
						L-= mlen - 1;
					} else {
						/* Literal Token */
						if(d <= 143) d = d + 48;
						else bl = write_bits_1(out, bl, 1);
						bl = write_bits_8(out, bl, bitswap8[d]);
						addrs[hash] = boff & 0x7FFF;
						++boff;
					}
				}
	
				bl = write_bits_8(out, bl, 0) - 1;
			}
			out.l = ((bl + 7)/8)|0;
			return out.l;
		}
		return function _deflateRaw(data, out) {
			if(data.length < 8) return write_stored(data, out);
			return write_huff_fixed(data, out);
		};
	})();
	
	function _deflate(data) {
		var buf = new_buf(50+Math.floor(data.length*1.1));
		var off = _deflateRaw(data, buf);
		return buf.slice(0, off);
	}
	/* modified inflate function also moves original read head */
	
	var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
	var dyn_len_1 = 1, dyn_len_2 = 1;
	
	/* 5.5.3 Expanding Huffman Codes */
	function dyn(data, boff) {
		/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
		var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
		var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
		var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
		var w = 0;
	
		/* grab and store code lengths */
		var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
		var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
		var maxlen = 1;
		var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var L = clens.length; /* 19 */
		for(var i = 0; i < _HCLEN; ++i) {
			clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
			if(maxlen < w) maxlen = w;
			bl_count[w]++;
			boff += 3;
		}
	
		/* build code tree */
		var ccode = 0;
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
		for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
		/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bitswap8[ctree[i]]>>(8-cleni);
				for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
			}
		}
	
		/* read literal and dist codes at once */
		var hcodes = [];
		maxlen = 1;
		for(; hcodes.length < _HLIT + _HDIST;) {
			ccode = dyn_cmap[read_bits_7(data, boff)];
			boff += ccode & 7;
			switch((ccode >>>= 3)) {
				case 16:
					w = 3 + read_bits_2(data, boff); boff += 2;
					ccode = hcodes[hcodes.length - 1];
					while(w-- > 0) hcodes.push(ccode);
					break;
				case 17:
					w = 3 + read_bits_3(data, boff); boff += 3;
					while(w-- > 0) hcodes.push(0);
					break;
				case 18:
					w = 11 + read_bits_7(data, boff); boff += 7;
					while(w -- > 0) hcodes.push(0);
					break;
				default:
					hcodes.push(ccode);
					if(maxlen < ccode) maxlen = ccode;
					break;
			}
		}
	
		/* build literal / length trees */
		var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
		for(i = _HLIT; i < 286; ++i) h1[i] = 0;
		for(i = _HDIST; i < 30; ++i) h2[i] = 0;
		dyn_len_1 = build_tree(h1, dyn_lmap, 286);
		dyn_len_2 = build_tree(h2, dyn_dmap, 30);
		return boff;
	}
	
	/* return [ data, bytesRead ] */
	function inflate(data, usz) {
		/* shortcircuit for empty buffer [0x03, 0x00] */
		if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }
	
		/* bit offset */
		var boff = 0;
	
		/* header includes final bit and type bits */
		var header = 0;
	
		var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
		var woff = 0;
		var OL = outbuf.length>>>0;
		var max_len_1 = 0, max_len_2 = 0;
	
		while((header&1) == 0) {
			header = read_bits_3(data, boff); boff += 3;
			if((header >>> 1) == 0) {
				/* Stored block */
				if(boff & 7) boff += 8 - (boff&7);
				/* 2 bytes sz, 2 bytes bit inverse */
				var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
				boff += 32;
				/* push sz bytes */
				if(sz > 0) {
					if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
					while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
				}
				continue;
			} else if((header >> 1) == 1) {
				/* Fixed Huffman */
				max_len_1 = 9; max_len_2 = 5;
			} else {
				/* Dynamic Huffman */
				boff = dyn(data, boff);
				max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
			}
			for(;;) { // while(true) is apparently out of vogue in modern JS circles
				if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
				/* ingest code and move read head */
				var bits = read_bits_n(data, boff, max_len_1);
				var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
				boff += code & 15; code >>>= 4;
				/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
				if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
				else if(code == 256) break;
				else {
					code -= 257;
					var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
					var tgt = woff + LEN_LN[code];
					/* length extra bits */
					if(len_eb > 0) {
						tgt += read_bits_n(data, boff, len_eb);
						boff += len_eb;
					}
	
					/* dist code */
					bits = read_bits_n(data, boff, max_len_2);
					code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
					boff += code & 15; code >>>= 4;
					var dst_eb = (code < 4 ? 0 : (code-2)>>1);
					var dst = DST_LN[code];
					/* dist extra bits */
					if(dst_eb > 0) {
						dst += read_bits_n(data, boff, dst_eb);
						boff += dst_eb;
					}
	
					/* in the common case, manual byte copy is faster than TA set / Buffer copy */
					if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt + 100); OL = outbuf.length; }
					while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
				}
			}
		}
		if(usz) return [outbuf, (boff+7)>>>3];
		return [outbuf.slice(0, woff), (boff+7)>>>3];
	}
	
	function _inflate(payload, usz) {
		var data = payload.slice(payload.l||0);
		var out = inflate(data, usz);
		payload.l += out[1];
		return out[0];
	}
	
	function warn_or_throw(wrn, msg) {
		if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
		else throw new Error(msg);
	}
	
	function parse_zip(file, options) {
		var blob = file;
		prep_blob(blob, 0);
	
		var FileIndex = [], FullPaths = [];
		var o = {
			FileIndex: FileIndex,
			FullPaths: FullPaths
		};
		init_cfb(o, { root: options.root });
	
		/* find end of central directory, start just after signature */
		var i = blob.length - 4;
		while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
		blob.l = i + 4;
	
		/* parse end of central directory */
		blob.l += 4;
		var fcnt = blob.read_shift(2);
		blob.l += 6;
		var start_cd = blob.read_shift(4);
	
		/* parse central directory */
		blob.l = start_cd;
	
		for(i = 0; i < fcnt; ++i) {
			/* trust local file header instead of CD entry */
			blob.l += 20;
			var csz = blob.read_shift(4);
			var usz = blob.read_shift(4);
			var namelen = blob.read_shift(2);
			var efsz = blob.read_shift(2);
			var fcsz = blob.read_shift(2);
			blob.l += 8;
			var offset = blob.read_shift(4);
			var EF = parse_extra_field(blob.slice(blob.l+namelen, blob.l+namelen+efsz));
			blob.l += namelen + efsz + fcsz;
	
			var L = blob.l;
			blob.l = offset + 4;
			parse_local_file(blob, csz, usz, o, EF);
			blob.l = L;
		}
		return o;
	}
	
	
	/* head starts just after local file header signature */
	function parse_local_file(blob, csz, usz, o, EF) {
		/* [local file header] */
		blob.l += 2;
		var flags = blob.read_shift(2);
		var meth = blob.read_shift(2);
		var date = parse_dos_date(blob);
	
		if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
		var crc32 = blob.read_shift(4);
		var _csz = blob.read_shift(4);
		var _usz = blob.read_shift(4);
	
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
	
		// TODO: flags & (1<<11) // UTF8
		var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
		if(efsz) {
			var ef = parse_extra_field(blob.slice(blob.l, blob.l + efsz));
			if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
			if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
		}
		blob.l += efsz;
	
		/* [encryption header] */
	
		/* [file data] */
		var data = blob.slice(blob.l, blob.l + _csz);
		switch(meth) {
			case 8: data = _inflateRawSync(blob, _usz); break;
			case 0: break; // TODO: scan for magic number
			default: throw new Error("Unsupported ZIP Compression method " + meth);
		}
	
		/* [data descriptor] */
		var wrn = false;
		if(flags & 8) {
			crc32 = blob.read_shift(4);
			if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
			_csz = blob.read_shift(4);
			_usz = blob.read_shift(4);
		}
	
		if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
		if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
		//var _crc32 = CRC32.buf(data, 0);
		//if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
		cfb_add(o, name, data, {unsafe: true, mt: date});
	}
	function write_zip(cfb, options) {
		var _opts = options || {};
		var out = [], cdirs = [];
		var o = new_buf(1);
		var method = (_opts.compression ? 8 : 0), flags = 0;
		var desc = false;
		if(desc) flags |= 8;
		var i = 0, j = 0;
	
		var start_cd = 0, fcnt = 0;
		var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
		var crcs = [];
		var sz_cd = 0;
	
		for(i = 1; i < cfb.FullPaths.length; ++i) {
			fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
			if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
			var start = start_cd;
	
			/* TODO: CP437 filename */
			var namebuf = new_buf(fp.length);
			for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
			namebuf = namebuf.slice(0, namebuf.l);
			crcs[fcnt] = CRC32.buf(fi.content, 0);
	
			var outbuf = fi.content;
			if(method == 8) outbuf = _deflateRawSync(outbuf);
	
			/* local file header */
			o = new_buf(30);
			o.write_shift(4, 0x04034b50);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			/* TODO: last mod file time/date */
			if(fi.mt) write_dos_date(o, fi.mt);
			else o.write_shift(4, 0);
			o.write_shift(-4, (flags & 8) ? 0 : crcs[fcnt]);
			o.write_shift(4,  (flags & 8) ? 0 : outbuf.length);
			o.write_shift(4,  (flags & 8) ? 0 : fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
	
			start_cd += o.length;
			out.push(o);
			start_cd += namebuf.length;
			out.push(namebuf);
	
			/* TODO: extra fields? */
	
			/* TODO: encryption header ? */
	
			start_cd += outbuf.length;
			out.push(outbuf);
	
			/* data descriptor */
			if(flags & 8) {
				o = new_buf(12);
				o.write_shift(-4, crcs[fcnt]);
				o.write_shift(4, outbuf.length);
				o.write_shift(4, fi.content.length);
				start_cd += o.l;
				out.push(o);
			}
	
			/* central directory */
			o = new_buf(46);
			o.write_shift(4, 0x02014b50);
			o.write_shift(2, 0);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			o.write_shift(4, 0); /* TODO: last mod file time/date */
			o.write_shift(-4, crcs[fcnt]);
	
			o.write_shift(4, outbuf.length);
			o.write_shift(4, fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, start);
	
			sz_cd += o.l;
			cdirs.push(o);
			sz_cd += namebuf.length;
			cdirs.push(namebuf);
			++fcnt;
		}
	
		/* end of central directory */
		o = new_buf(22);
		o.write_shift(4, 0x06054b50);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, fcnt);
		o.write_shift(2, fcnt);
		o.write_shift(4, sz_cd);
		o.write_shift(4, start_cd);
		o.write_shift(2, 0);
	
		return bconcat(([bconcat((out)), bconcat(cdirs), o]));
	}
	var ContentTypeMap = ({
		"htm": "text/html",
		"xml": "text/xml",
	
		"gif": "image/gif",
		"jpg": "image/jpeg",
		"png": "image/png",
	
		"mso": "application/x-mso",
		"thmx": "application/vnd.ms-officetheme",
		"sh33tj5": "application/octet-stream"
	});
	
	function get_content_type(fi, fp) {
		if(fi.ctype) return fi.ctype;
	
		var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
		if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
	
		if(fp) {
			m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
			if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
		}
	
		return "application/octet-stream";
	}
	
	/* 76 character chunks TODO: intertwine encoding */
	function write_base64_76(bstr) {
		var data = Base64_encode(bstr);
		var o = [];
		for(var i = 0; i < data.length; i+= 76) o.push(data.slice(i, i+76));
		return o.join("\r\n") + "\r\n";
	}
	
	/*
	Rules for QP:
		- escape =## applies for all non-display characters and literal "="
		- space or tab at end of line must be encoded
		- \r\n newlines can be preserved, but bare \r and \n must be escaped
		- lines must not exceed 76 characters, use soft breaks =\r\n
	
	TODO: Some files from word appear to write line extensions with bare equals:
	
	```
	<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
	="70%"
	```
	*/
	function write_quoted_printable(text) {
		var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
			var w = c.charCodeAt(0).toString(16).toUpperCase();
			return "=" + (w.length == 1 ? "0" + w : w);
		});
	
		encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
	
		if(encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
		encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
	
		var o = [], split = encoded.split("\r\n");
		for(var si = 0; si < split.length; ++si) {
			var str = split[si];
			if(str.length == 0) { o.push(""); continue; }
			for(var i = 0; i < str.length;) {
				var end = 76;
				var tmp = str.slice(i, i + end);
				if(tmp.charAt(end - 1) == "=") end --;
				else if(tmp.charAt(end - 2) == "=") end -= 2;
				else if(tmp.charAt(end - 3) == "=") end -= 3;
				tmp = str.slice(i, i + end);
				i += end;
				if(i < str.length) tmp += "=";
				o.push(tmp);
			}
		}
	
		return o.join("\r\n");
	}
	function parse_quoted_printable(data) {
		var o = [];
	
		/* unify long lines */
		for(var di = 0; di < data.length; ++di) {
			var line = data[di];
			while(di <= data.length && line.charAt(line.length - 1) == "=") line = line.slice(0, line.length - 1) + data[++di];
			o.push(line);
		}
	
		/* decode */
		for(var oi = 0; oi < o.length; ++oi) o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) { return String.fromCharCode(parseInt($$.slice(1), 16)); });
		return s2a(o.join("\r\n"));
	}
	
	
	function parse_mime(cfb, data, root) {
		var fname = "", cte = "", ctype = "", fdata;
		var di = 0;
		for(;di < 10; ++di) {
			var line = data[di];
			if(!line || line.match(/^\s*$/)) break;
			var m = line.match(/^(.*?):\s*([^\s].*)$/);
			if(m) switch(m[1].toLowerCase()) {
				case "content-location": fname = m[2].trim(); break;
				case "content-type": ctype = m[2].trim(); break;
				case "content-transfer-encoding": cte = m[2].trim(); break;
			}
		}
		++di;
		switch(cte.toLowerCase()) {
			case 'base64': fdata = s2a(Base64_decode(data.slice(di).join(""))); break;
			case 'quoted-printable': fdata = parse_quoted_printable(data.slice(di)); break;
			default: throw new Error("Unsupported Content-Transfer-Encoding " + cte);
		}
		var file = cfb_add(cfb, fname.slice(root.length), fdata, {unsafe: true});
		if(ctype) file.ctype = ctype;
	}
	
	function parse_mad(file, options) {
		if(a2s(file.slice(0,13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
		var root = (options && options.root || "");
		// $FlowIgnore
		var data = (has_buf && Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
		var di = 0, row = "";
	
		/* if root is not specified, scan for the common prefix */
		for(di = 0; di < data.length; ++di) {
			row = data[di];
			if(!/^Content-Location:/i.test(row)) continue;
			row = row.slice(row.indexOf("file"));
			if(!root) root = row.slice(0, row.lastIndexOf("/") + 1);
			if(row.slice(0, root.length) == root) continue;
			while(root.length > 0) {
				root = root.slice(0, root.length - 1);
				root = root.slice(0, root.lastIndexOf("/") + 1);
				if(row.slice(0,root.length) == root) break;
			}
		}
	
		var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
		if(!mboundary) throw new Error("MAD cannot find boundary");
		var boundary = "--" + (mboundary[1] || "");
	
		var FileIndex = [], FullPaths = [];
		var o = {
			FileIndex: FileIndex,
			FullPaths: FullPaths
		};
		init_cfb(o);
		var start_di, fcnt = 0;
		for(di = 0; di < data.length; ++di) {
			var line = data[di];
			if(line !== boundary && line !== boundary + "--") continue;
			if(fcnt++) parse_mime(o, data.slice(start_di, di), root);
			start_di = di;
		}
		return o;
	}
	
	function write_mad(cfb, options) {
		var opts = options || {};
		var boundary = opts.boundary || "SheetJS";
		boundary = '------=' + boundary;
	
		var out = [
			'MIME-Version: 1.0',
			'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
			'',
			'',
			''
		];
	
		var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
		for(var i = 1; i < cfb.FullPaths.length; ++i) {
			fp = cfb.FullPaths[i].slice(root.length);
			fi = cfb.FileIndex[i];
			if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
	
			/* Normalize filename */
			fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
				return "_x" + c.charCodeAt(0).toString(16) + "_";
			}).replace(/[\u0080-\uFFFF]/g, function(u) {
				return "_u" + u.charCodeAt(0).toString(16) + "_";
			});
	
			/* Extract content as binary string */
			var ca = fi.content;
			// $FlowIgnore
			var cstr = has_buf && Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
	
			/* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */
			var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
			for(var csl = 0; csl <= L; ++csl) if((cc=cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
			var qp = dispcnt >= L * 4 / 5;
	
			out.push(boundary);
			out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
			out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
			out.push('Content-Type: ' + get_content_type(fi, fp));
			out.push('');
	
			out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
		}
		out.push(boundary + '--\r\n');
		return out.join("\r\n");
	}
	function cfb_new(opts) {
		var o = ({});
		init_cfb(o, opts);
		return o;
	}
	
	function cfb_add(cfb, name, content, opts) {
		var unsafe = opts && opts.unsafe;
		if(!unsafe) init_cfb(cfb);
		var file = !unsafe && CFB.find(cfb, name);
		if(!file) {
			var fpath = cfb.FullPaths[0];
			if(name.slice(0, fpath.length) == fpath) fpath = name;
			else {
				if(fpath.slice(-1) != "/") fpath += "/";
				fpath = (fpath + name).replace("//","/");
			}
			file = ({name: filename(name), type: 2});
			cfb.FileIndex.push(file);
			cfb.FullPaths.push(fpath);
			if(!unsafe) CFB.utils.cfb_gc(cfb);
		}
	file.content = (content);
		file.size = content ? content.length : 0;
		if(opts) {
			if(opts.CLSID) file.clsid = opts.CLSID;
			if(opts.mt) file.mt = opts.mt;
			if(opts.ct) file.ct = opts.ct;
		}
		return file;
	}
	
	function cfb_del(cfb, name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex.splice(j, 1);
			cfb.FullPaths.splice(j, 1);
			return true;
		}
		return false;
	}
	
	function cfb_mov(cfb, old_name, new_name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, old_name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex[j].name = filename(new_name);
			cfb.FullPaths[j] = new_name;
			return true;
		}
		return false;
	}
	
	function cfb_gc(cfb) { rebuild_cfb(cfb, true); }
	
	exports.find = find;
	exports.read = read;
	exports.parse = parse;
	exports.write = write;
	exports.writeFile = write_file;
	exports.utils = {
		cfb_new: cfb_new,
		cfb_add: cfb_add,
		cfb_del: cfb_del,
		cfb_mov: cfb_mov,
		cfb_gc: cfb_gc,
		ReadShift: ReadShift,
		CheckField: CheckField,
		prep_blob: prep_blob,
		bconcat: bconcat,
		use_zlib: use_zlib,
		_deflateRaw: _deflate,
		_inflateRaw: _inflate,
		consts: consts
	};
	
	return exports;
	})();
	
	var _fs;
	if(true) try { _fs = __webpack_require__(386); } catch(e) {}
	
	/* normalize data for blob ctor */
	function blobify(data) {
		if(typeof data === "string") return s2ab(data);
		if(Array.isArray(data)) return a2u(data);
		return data;
	}
	/* write or download file */
	function write_dl(fname, payload, enc) {
		/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */
		if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
		if(typeof Deno !== 'undefined') {
			/* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */
			if(enc && typeof payload == "string") switch(enc) {
				case "utf8": payload = new TextEncoder(enc).encode(payload); break;
				case "binary": payload = s2ab(payload); break;
				/* TODO: binary equivalent */
				default: throw new Error("Unsupported encoding " + enc);
			}
			return Deno.writeFileSync(fname, payload);
		}
		var data = (enc == "utf8") ? utf8write(payload) : payload;
	if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
		if(typeof Blob !== 'undefined') {
			var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
	if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
	if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
			if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
				var url = URL.createObjectURL(blob);
	if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
				}
				var a = document.createElement("a");
				if(a.download != null) {
	a.download = fname; a.href = url; document.body.appendChild(a); a.click();
	document.body.removeChild(a);
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return url;
				}
			}
		}
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var out = File(fname); out.open("w"); out.encoding = "binary";
			if(Array.isArray(payload)) payload = a2s(payload);
			out.write(payload); out.close(); return payload;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("cannot save file " + fname);
	}
	
	/* read binary data from file */
	function read_binary(path) {
		if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
		if(typeof Deno !== 'undefined') return Deno.readFileSync(path);
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var infile = File(path); infile.open("r"); infile.encoding = "binary";
			var data = infile.read(); infile.close();
			return data;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("Cannot access file " + path);
	}
	function keys(o) {
		var ks = Object.keys(o), o2 = [];
		for(var i = 0; i < ks.length; ++i) if(Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
		return o2;
	}
	
	function evert_key(obj, key) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
		return o;
	}
	
	function evert(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
		return o;
	}
	
	function evert_num(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
		return o;
	}
	
	function evert_arr(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) {
			if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
			o[obj[K[i]]].push(K[i]);
		}
		return o;
	}
	
	var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
	function datenum(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1462*24*60*60*1000;
		var dnthresh = basedate.getTime() + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
		return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
	}
	var refdate = new Date();
	var dnthresh = basedate.getTime() + (refdate.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
	var refoffset = refdate.getTimezoneOffset();
	function numdate(v) {
		var out = new Date();
		out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
		if (out.getTimezoneOffset() !== refoffset) {
			out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
		}
		return out;
	}
	
	/* ISO 8601 Duration */
	function parse_isodur(s) {
		var sec = 0, mt = 0, time = false;
		var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
		if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
		for(var i = 1; i != m.length; ++i) {
			if(!m[i]) continue;
			mt = 1;
			if(i > 3) time = true;
			switch(m[i].slice(m[i].length-1)) {
				case 'Y':
					throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
				case 'D': mt *= 24;
					/* falls through */
				case 'H': mt *= 60;
					/* falls through */
				case 'M':
					if(!time) throw new Error("Unsupported ISO Duration Field: M");
					else mt *= 60;
					/* falls through */
				case 'S': break;
			}
			sec += mt * parseInt(m[i], 10);
		}
		return sec;
	}
	
	var good_pd_date_1 = new Date('2017-02-19T19:06:09.000Z');
	var good_pd_date = isNaN(good_pd_date_1.getFullYear()) ? new Date('2/19/17') : good_pd_date_1;
	var good_pd = good_pd_date.getFullYear() == 2017;
	/* parses a date as a local date */
	function parseDate(str, fixdate) {
		var d = new Date(str);
		if(good_pd) {
	if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
			else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
			return d;
		}
		if(str instanceof Date) return str;
		if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
			var s = d.getFullYear();
			if(str.indexOf("" + s) > -1) return d;
			d.setFullYear(d.getFullYear() + 100); return d;
		}
		var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
		var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
		if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
		return out;
	}
	
	function cc2str(arr, debomit) {
		if(has_buf && Buffer.isBuffer(arr)) {
			if(debomit) {
				if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(arr.slice(2).toString("utf16le"));
				if(arr[1] == 0xFE && arr[2] == 0xFF) return utf8write(utf16beread(arr.slice(2).toString("binary")));
			}
			return arr.toString("binary");
		}
	
		if(typeof TextDecoder !== "undefined") try {
			if(debomit) {
				if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
				if(arr[0] == 0xFE && arr[1] == 0xFF) return utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
			}
			var rev = {
				"\u20ac": "\x80", "\u201a": "\x82", "\u0192": "\x83", "\u201e": "\x84",
				"\u2026": "\x85", "\u2020": "\x86", "\u2021": "\x87", "\u02c6": "\x88",
				"\u2030": "\x89", "\u0160": "\x8a", "\u2039": "\x8b", "\u0152": "\x8c",
				"\u017d": "\x8e", "\u2018": "\x91", "\u2019": "\x92", "\u201c": "\x93",
				"\u201d": "\x94", "\u2022": "\x95", "\u2013": "\x96", "\u2014": "\x97",
				"\u02dc": "\x98", "\u2122": "\x99", "\u0161": "\x9a", "\u203a": "\x9b",
				"\u0153": "\x9c", "\u017e": "\x9e", "\u0178": "\x9f"
			};
			if(Array.isArray(arr)) arr = new Uint8Array(arr);
			return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) { return rev[c] || c; });
		} catch(e) {}
	
		var o = [];
		for(var i = 0; i != arr.length; ++i) o.push(String.fromCharCode(arr[i]));
		return o.join("");
	}
	
	function dup(o) {
		if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
		if(typeof o != 'object' || o == null) return o;
		if(o instanceof Date) return new Date(o.getTime());
		var out = {};
		for(var k in o) if(Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
		return out;
	}
	
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	
	/* TODO: stress test */
	function fuzzynum(s) {
		var v = Number(s);
		if(!isNaN(v)) return isFinite(v) ? v : NaN;
		if(!/\d/.test(s)) return v;
		var wt = 1;
		var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
		if(!isNaN(v = Number(ss))) return v / wt;
		ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
		if(!isNaN(v = Number(ss))) return v / wt;
		return v;
	}
	var lower_months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
	function fuzzydate(s) {
		var o = new Date(s), n = new Date(NaN);
		var y = o.getYear(), m = o.getMonth(), d = o.getDate();
		if(isNaN(d)) return n;
		var lower = s.toLowerCase();
		if(lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
			lower = lower.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"");
			if(lower.length > 3 && lower_months.indexOf(lower) == -1) return n;
		} else if(lower.match(/[a-z]/)) return n;
		if(y < 0 || y > 8099) return n;
		if((m > 0 || d > 1) && y != 101) return o;
		if(s.match(/[^-0-9:,\/\\]/)) return n;
		return o;
	}
	
	var split_regex = (function() {
		var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
		return function split_regex(str, re, def) {
			if(safe_split_regex || typeof re == "string") return str.split(re);
			var p = str.split(re), o = [p[0]];
			for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
			return o;
		};
	})();
	function getdatastr(data) {
		if(!data) return null;
		if(data.content && data.type) return cc2str(data.content, true);
		if(data.data) return debom(data.data);
		if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
		if(data.asBinary) return debom(data.asBinary());
		if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
		return null;
	}
	
	function getdatabin(data) {
		if(!data) return null;
		if(data.data) return char_codes(data.data);
		if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
		if(data._data && data._data.getContent) {
			var o = data._data.getContent();
			if(typeof o == "string") return char_codes(o);
			return Array.prototype.slice.call(o);
		}
		if(data.content && data.type) return data.content;
		return null;
	}
	
	function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }
	
	/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
	/* OASIS does not comment on filename case sensitivity */
	function safegetzipfile(zip, file) {
		var k = zip.FullPaths || keys(zip.files);
		var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g,'\/');
		for(var i=0; i<k.length; ++i) {
			var n = k[i].replace(/^Root Entry[\/]/,"").toLowerCase();
			if(f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
		}
		return null;
	}
	
	function getzipfile(zip, file) {
		var o = safegetzipfile(zip, file);
		if(o == null) throw new Error("Cannot find file " + file + " in zip");
		return o;
	}
	
	function getzipdata(zip, file, safe) {
		if(!safe) return getdata(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipdata(zip, file); } catch(e) { return null; }
	}
	
	function getzipstr(zip, file, safe) {
		if(!safe) return getdatastr(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipstr(zip, file); } catch(e) { return null; }
	}
	
	function getzipbin(zip, file, safe) {
		if(!safe) return getdatabin(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipbin(zip, file); } catch(e) { return null; }
	}
	
	function zipentries(zip) {
		var k = zip.FullPaths || keys(zip.files), o = [];
		for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
		return o.sort();
	}
	
	function zip_add_file(zip, path, content) {
		if(zip.FullPaths) {
			if(typeof content == "string") {
				var res;
				if(has_buf) res = Buffer_from(content);
				/* TODO: investigate performance in Edge 13 */
				//else if(typeof TextEncoder !== "undefined") res = new TextEncoder().encode(content);
				else res = utf8decode(content);
				return CFB.utils.cfb_add(zip, path, res);
			}
			CFB.utils.cfb_add(zip, path, content);
		}
		else zip.file(path, content);
	}
	
	function zip_new() { return CFB.utils.cfb_new(); }
	
	function zip_read(d, o) {
		switch(o.type) {
			case "base64": return CFB.read(d, { type: "base64" });
			case "binary": return CFB.read(d, { type: "binary" });
			case "buffer": case "array": return CFB.read(d, { type: "buffer" });
		}
		throw new Error("Unrecognized type " + o.type);
	}
	
	function resolve_path(path, base) {
		if(path.charAt(0) == "/") return path.slice(1);
		var result = base.split('/');
		if(base.slice(-1) != "/") result.pop(); // folder path
		var target = path.split('/');
		while (target.length !== 0) {
			var step = target.shift();
			if (step === '..') result.pop();
			else if (step !== '.') result.push(step);
		}
		return result.join('/');
	}
	var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
	var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
	var tagregex1=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, tagregex2 = /<[^>]*>/g;
	var tagregex = XML_HEADER.match(tagregex1) ? tagregex1 : tagregex2;
	var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
	function parsexmltag(tag, skip_root, skip_LC) {
		var z = ({});
		var eq = 0, c = 0;
		for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
		if(!skip_root) z[0] = tag.slice(0, eq);
		if(eq === tag.length) return z;
		var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
		if(m) for(i = 0; i != m.length; ++i) {
			cc = m[i];
			for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
			q = cc.slice(0,c).trim();
			while(cc.charCodeAt(c+1) == 32) ++c;
			quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
			v = cc.slice(c+1+quot, cc.length-quot);
			for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
			if(j===q.length) {
				if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
				z[q] = v;
				if(!skip_LC) z[q.toLowerCase()] = v;
			}
			else {
				var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
				if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
				z[k] = v;
				if(!skip_LC) z[k.toLowerCase()] = v;
			}
		}
		return z;
	}
	function strip_ns(x) { return x.replace(nsregex2, "<$1"); }
	
	var encodings = {
		'&quot;': '"',
		'&apos;': "'",
		'&gt;': '>',
		'&lt;': '<',
		'&amp;': '&'
	};
	var rencoding = evert(encodings);
	//var rencstr = "&<>'\"".split("");
	
	// TODO: CP remap (need to read file version to determine OS)
	var unescapexml = (function() {
		/* 22.4.2.4 bstr (Basic String) */
		var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
		return function unescapexml(text) {
			var s = text + '', i = s.indexOf("<![CDATA[");
			if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
			var j = s.indexOf("]]>");
			return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
		};
	})();
	
	var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
	function escapexml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
	}
	function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }
	
	var htmlcharegex = /[\u0000-\u001f]/g;
	function escapehtml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
	}
	
	function escapexlml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
	}
	
	/* TODO: handle codepages */
	var xlml_fixstr = (function() {
		var entregex = /&#(\d+);/g;
		function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
		return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
	})();
	function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); }
	
	function parsexmlbool(value) {
		switch(value) {
			case 1: case true: case '1': case 'true': case 'TRUE': return true;
			/* case '0': case 'false': case 'FALSE':*/
			default: return false;
		}
	}
	
	function utf8reada(orig) {
		var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
		while (i < orig.length) {
			c = orig.charCodeAt(i++);
			if (c < 128) { out += String.fromCharCode(c); continue; }
			d = orig.charCodeAt(i++);
			if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
			e = orig.charCodeAt(i++);
			if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
			f = orig.charCodeAt(i++);
			w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
			out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
			out += String.fromCharCode(0xDC00 + (w&1023));
		}
		return out;
	}
	
	function utf8readb(data) {
		var out = new_raw_buf(2*data.length), w, i, j = 1, k = 0, ww=0, c;
		for(i = 0; i < data.length; i+=j) {
			j = 1;
			if((c=data.charCodeAt(i)) < 128) w = c;
			else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
			else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
			else { j = 4;
				w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
				w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
			}
			if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
			out[k++] = w%256; out[k++] = w>>>8;
		}
		return out.slice(0,k).toString('ucs2');
	}
	
	function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); }
	
	var utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
	var utf8read = has_buf && (utf8readc(utf8corpus) == utf8reada(utf8corpus) && utf8readc || utf8readb(utf8corpus) == utf8reada(utf8corpus) && utf8readb) || utf8reada;
	
	var utf8write = has_buf ? function(data) { return Buffer_from(data, 'utf8').toString("binary"); } : function(orig) {
		var out = [], i = 0, c = 0, d = 0;
		while(i < orig.length) {
			c = orig.charCodeAt(i++);
			switch(true) {
				case c < 128: out.push(String.fromCharCode(c)); break;
				case c < 2048:
					out.push(String.fromCharCode(192 + (c >> 6)));
					out.push(String.fromCharCode(128 + (c & 63)));
					break;
				case c >= 55296 && c < 57344:
					c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
					out.push(String.fromCharCode(240 + ((d >>18) & 7)));
					out.push(String.fromCharCode(144 + ((d >>12) & 63)));
					out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
					out.push(String.fromCharCode(128 + (d & 63)));
					break;
				default:
					out.push(String.fromCharCode(224 + (c >> 12)));
					out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
					out.push(String.fromCharCode(128 + (c & 63)));
			}
		}
		return out.join("");
	};
	
	// matches <foo>...</foo> extracts content
	var matchtag = (function() {
		var mtcache = ({});
		return function matchtag(f,g) {
			var t = f+"|"+(g||"");
			if(mtcache[t]) return mtcache[t];
			return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
		};
	})();
	
	var htmldecode = (function() {
		var entities = [
			['nbsp', ' '], ['middot', '·'],
			['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
		].map(function(x) { return [new RegExp('&' + x[0] + ';', "ig"), x[1]]; });
		return function htmldecode(str) {
			var o = str
					// Remove new lines and spaces from start of content
					.replace(/^[\t\n\r ]+/, "")
					// Remove new lines and spaces from end of content
					.replace(/[\t\n\r ]+$/,"")
					// Added line which removes any white space characters after and before html tags
					.replace(/>\s+/g,">").replace(/\s+</g,"<")
					// Replace remaining new lines and spaces with space
					.replace(/[\t\n\r ]+/g, " ")
					// Replace <br> tags with new lines
					.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")
					// Strip HTML elements
					.replace(/<[^>]*>/g,"");
			for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
			return o;
		};
	})();
	
	var vtregex = (function(){ var vt_cache = {};
		return function vt_regex(bt) {
			if(vt_cache[bt] !== undefined) return vt_cache[bt];
			return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
	};})();
	var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
	function parseVector(data, opts) {
		var h = parsexmltag(data);
	
		var matches = data.match(vtregex(h.baseType))||[];
		var res = [];
		if(matches.length != h.size) {
			if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
			return res;
		}
		matches.forEach(function(x) {
			var v = x.replace(vtvregex,"").match(vtmregex);
			if(v) res.push({v:utf8read(v[2]), t:v[1]});
		});
		return res;
	}
	
	var wtregex = /(^\s|\s$|\n)/;
	function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }
	
	function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
	function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}
	
	function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }
	
	function write_vt(s, xlsx) {
		switch(typeof s) {
			case 'string':
				var o = writextag('vt:lpwstr', escapexml(s));
				if(xlsx) o = o.replace(/&quot;/g, "_x0022_");
				return o;
			case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', escapexml(String(s)));
			case 'boolean': return writextag('vt:bool',s?'true':'false');
		}
		if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
		throw new Error("Unable to serialize " + s);
	}
	
	function xlml_normalize(d) {
		if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
		if(typeof d === 'string') return d;
		/* duktape */
		if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
		throw new Error("Bad input format: expected Buffer or string");
	}
	/* UOS uses CJK in tags */
	var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
	//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
	
	var XMLNS = ({
		CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
		CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
		EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
		CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
		RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
		TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
		'dc': 'http://purl.org/dc/elements/1.1/',
		'dcterms': 'http://purl.org/dc/terms/',
		'dcmitype': 'http://purl.org/dc/dcmitype/',
		'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
		'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
		'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
		'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
		'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
		'xsd': 'http://www.w3.org/2001/XMLSchema'
	});
	
	var XMLNS_main = [
		'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
		'http://purl.oclc.org/ooxml/spreadsheetml/main',
		'http://schemas.microsoft.com/office/excel/2006/main',
		'http://schemas.microsoft.com/office/excel/2006/2'
	];
	
	var XLMLNS = ({
		'o':    'urn:schemas-microsoft-com:office:office',
		'x':    'urn:schemas-microsoft-com:office:excel',
		'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
		'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
		'mv':   'http://macVmlSchemaUri',
		'v':    'urn:schemas-microsoft-com:vml',
		'html': 'http://www.w3.org/TR/REC-html40'
	});
	function read_double_le(b, idx) {
		var s = 1 - 2 * (b[idx + 7] >>> 7);
		var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
		var m = (b[idx+6]&0x0f);
		for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
		if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
		if(e == 0) e = -1022;
		else { e -= 1023; m += Math.pow(2,52); }
		return s * Math.pow(2, e - 52) * m;
	}
	
	function write_double_le(b, v, idx) {
		var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
		var av = bs ? (-v) : v;
		if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
		else if(av == 0) e = m = 0;
		else {
			e = Math.floor(Math.log(av) / Math.LN2);
			m = av * Math.pow(2, 52 - e);
			if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
			else { m -= Math.pow(2,52); e+=1023; }
		}
		for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
		b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
		b[idx + 7] = (e >> 4) | bs;
	}
	
	var ___toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
	var __toBuffer = has_buf ? function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0].map(function(x) { return Buffer.isBuffer(x) ? x : Buffer_from(x); })) : ___toBuffer(bufs);} : ___toBuffer;
	
	var ___utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
	var __utf16le = has_buf ? function(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; } : ___utf16le;
	
	var ___hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
	var __hexlify = has_buf ? function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); } : ___hexlify;
	
	var ___utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
	var __utf8 = has_buf ? function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : ___utf8(b,s,e); } : ___utf8;
	
	var ___lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __lpstr = ___lpstr;
	
	var ___cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __cpstr = ___cpstr;
	
	var ___lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __lpwstr = ___lpwstr;
	
	var ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
	var __lpp4 = ___lpp4;
	
	var ___8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
	var __8lpp4 = ___8lpp4;
	
	var ___double = function(b, idx) { return read_double_le(b, idx);};
	var __double = ___double;
	
	var is_buf = function is_buf_a(a) { return Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
	
	if(has_buf) {
		__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
		__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
		__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
		__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
		is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
	}
	
	/* from js-xls */
	function cpdoit() {
		__utf16le = function(b,s,e) { return $cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
		__utf8 = function(b,s,e) { return $cptable.utils.decode(65001, b.slice(s,e)); };
		__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
		__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
		__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
		__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
		__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
	}
	if(typeof $cptable !== 'undefined') cpdoit();
	
	var __readUInt8 = function(b, idx) { return b[idx]; };
	var __readUInt16LE = function(b, idx) { return (b[idx+1]*(1<<8))+b[idx]; };
	var __readInt16LE = function(b, idx) { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
	var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
	var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
	var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };
	
	function ReadShift(size, t) {
		var o="", oI, oR, oo=[], w, vv, i, loc;
		switch(t) {
			case 'dbcs':
				loc = this.l;
				if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
				else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
				size *= 2;
				break;
	
			case 'utf8': o = __utf8(this, this.l, this.l + size); break;
			case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;
	
			case 'wstr':
				if(typeof $cptable !== 'undefined') o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
				else return ReadShift.call(this, size, 'dbcs');
				size = 2 * size; break;
	
			/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
			case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
			case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
			/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
			case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
			/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
			case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;
	
			case 'cstr': size = 0; o = "";
				while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
				o = oo.join(""); break;
			case '_wstr': size = 0; o = "";
				while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
				size+=2; o = oo.join(""); break;
	
			/* sbcs and dbcs support continue records in the SST way TODO codepages */
			case 'dbcs-cont': o = ""; loc = this.l;
				for(i = 0; i < size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt16LE(this, loc)));
					loc+=2;
				} o = oo.join(""); size *= 2; break;
	
			case 'cpstr':
				if(typeof $cptable !== 'undefined') {
					o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
					break;
				}
			/* falls through */
			case 'sbcs-cont': o = ""; loc = this.l;
				for(i = 0; i != size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt8(this, loc)));
					loc+=1;
				} o = oo.join(""); break;
	
			default:
		switch(size) {
			case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
			case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
			case 4: case -4:
				if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
				else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
			case 8: case -8:
				if(t === 'f') {
					if(size == 8) oR = __double(this, this.l);
					else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
					this.l += 8; return oR;
				} else size = 8;
			/* falls through */
			case 16: o = __hexlify(this, this.l, size); break;
		}}
		this.l+=size; return o;
	}
	
	var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
	var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
	var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };
	
	function WriteShift(t, val, f) {
		var size = 0, i = 0;
		if(f === 'dbcs') {
	for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
			size = 2 * val.length;
		} else if(f === 'sbcs') {
			if(typeof $cptable !== 'undefined' && current_ansi == 874) {
				/* TODO: use tables directly, don't encode */
	for(i = 0; i != val.length; ++i) {
					var cppayload = $cptable.utils.encode(current_ansi, val.charAt(i));
					this[this.l + i] = cppayload[0];
				}
			} else {
	val = val.replace(/[^\x00-\x7F]/g, "_");
	for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
			}
			size = val.length;
		} else if(f === 'hex') {
			for(; i < t; ++i) {
	this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
			} return this;
		} else if(f === 'utf16le') {
	var end = Math.min(this.l + t, this.length);
				for(i = 0; i < Math.min(val.length, t); ++i) {
					var cc = val.charCodeAt(i);
					this[this.l++] = (cc & 0xff);
					this[this.l++] = (cc >> 8);
				}
				while(this.l < end) this[this.l++] = 0;
				return this;
		} else  switch(t) {
			case  1: size = 1; this[this.l] = val&0xFF; break;
			case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
			case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
			case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
			case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
			/* falls through */
			case 16: break;
			case -4: size = 4; __writeInt32LE(this, val, this.l); break;
		}
		this.l += size; return this;
	}
	
	function CheckField(hexstr, fld) {
		var m = __hexlify(this,this.l,hexstr.length>>1);
		if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
		this.l += hexstr.length>>1;
	}
	
	function prep_blob(blob, pos) {
		blob.l = pos;
		blob.read_shift = ReadShift;
		blob.chk = CheckField;
		blob.write_shift = WriteShift;
	}
	
	function parsenoop(blob, length) { blob.l += length; }
	
	function new_buf(sz) {
		var o = new_raw_buf(sz);
		prep_blob(o, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.1.4 Record */
	function recordhopper(data, cb, opts) {
		if(!data) return;
		var tmpbyte, cntbyte, length;
		prep_blob(data, data.l || 0);
		var L = data.length, RT = 0, tgt = 0;
		while(data.l < L) {
			RT = data.read_shift(1);
			if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
			var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
			tmpbyte = data.read_shift(1);
			length = tmpbyte & 0x7F;
			for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
			tgt = data.l + length;
			var d = R.f && R.f(data, length, opts);
			data.l = tgt;
			if(cb(d, R, RT)) return;
		}
	}
	
	/* control buffer usage for fixed-length buffers */
	function buf_array() {
		var bufs = [], blksz = has_buf ? 256 : 2048;
		var newblk = function ba_newblk(sz) {
			var o = (new_buf(sz));
			prep_blob(o, 0);
			return o;
		};
	
		var curbuf = newblk(blksz);
	
		var endbuf = function ba_endbuf() {
			if(!curbuf) return;
			if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
			if(curbuf.length > 0) bufs.push(curbuf);
			curbuf = null;
		};
	
		var next = function ba_next(sz) {
			if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
			endbuf();
			return (curbuf = newblk(Math.max(sz+1, blksz)));
		};
	
		var end = function ba_end() {
			endbuf();
			return bconcat(bufs);
		};
	
		var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };
	
		return ({ next:next, push:push, end:end, _bufs:bufs });
	}
	
	function write_record(ba, type, payload, length) {
		var t = +type, l;
		if(isNaN(t)) return; // TODO: throw something here?
		if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
		l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
		if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
		var o = ba.next(l);
		if(t <= 0x7F) o.write_shift(1, t);
		else {
			o.write_shift(1, (t & 0x7F) + 0x80);
			o.write_shift(1, (t >> 7));
		}
		for(var i = 0; i != 4; ++i) {
			if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
			else { o.write_shift(1, length); break; }
		}
		if(length > 0 && is_buf(payload)) ba.push(payload);
	}
	/* XLS ranges enforced */
	function shift_cell_xls(cell, tgt, opts) {
		var out = dup(cell);
		if(tgt.s) {
			if(out.cRel) out.c += tgt.s.c;
			if(out.rRel) out.r += tgt.s.r;
		} else {
			if(out.cRel) out.c += tgt.c;
			if(out.rRel) out.r += tgt.r;
		}
		if(!opts || opts.biff < 12) {
			while(out.c >= 0x100) out.c -= 0x100;
			while(out.r >= 0x10000) out.r -= 0x10000;
		}
		return out;
	}
	
	function shift_range_xls(cell, range, opts) {
		var out = dup(cell);
		out.s = shift_cell_xls(out.s, range.s, opts);
		out.e = shift_cell_xls(out.e, range.s, opts);
		return out;
	}
	
	function encode_cell_xls(c, biff) {
		if(c.cRel && c.c < 0) { c = dup(c); while(c.c < 0) c.c += (biff > 8) ? 0x4000 : 0x100; }
		if(c.rRel && c.r < 0) { c = dup(c); while(c.r < 0) c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
		var s = encode_cell(c);
		if(!c.cRel && c.cRel != null) s = fix_col(s);
		if(!c.rRel && c.rRel != null) s = fix_row(s);
		return s;
	}
	
	function encode_range_xls(r, opts) {
		if(r.s.r == 0 && !r.s.rRel) {
			if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
				return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
			}
		}
		if(r.s.c == 0 && !r.s.cRel) {
			if(r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) {
				return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
			}
		}
		return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
	}
	function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
	function encode_row(row) { return "" + (row + 1); }
	function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
	function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }
	
	function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
	function encode_col(col) { if(col < 0) throw new Error("invalid column " + col); var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
	function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
	function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }
	
	function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
	//function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
	function decode_cell(cstr) {
		var R = 0, C = 0;
		for(var i = 0; i < cstr.length; ++i) {
			var cc = cstr.charCodeAt(i);
			if(cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
			else if(cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
		}
		return { c: C - 1, r:R - 1 };
	}
	//function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
	function encode_cell(cell) {
		var col = cell.c + 1;
		var s="";
		for(; col; col=((col-1)/26)|0) s = String.fromCharCode(((col-1)%26) + 65) + s;
		return s + (cell.r + 1);
	}
	function decode_range(range) {
		var idx = range.indexOf(":");
		if(idx == -1) return { s: decode_cell(range), e: decode_cell(range) };
		return { s: decode_cell(range.slice(0, idx)), e: decode_cell(range.slice(idx + 1)) };
	}
	function encode_range(cs,ce) {
		if(typeof ce === 'undefined' || typeof ce === 'number') {
	return encode_range(cs.s, cs.e);
		}
	if(typeof cs !== 'string') cs = encode_cell((cs));
		if(typeof ce !== 'string') ce = encode_cell((ce));
	return cs == ce ? cs : cs + ":" + ce;
	}
	
	function safe_decode_range(range) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		var idx = 0, i = 0, cc = 0;
		var len = range.length;
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.s.c = --idx;
	
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.s.r = --idx;
	
		if(i === len || cc != 10) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
		++i;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.e.c = --idx;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.e.r = --idx;
		return o;
	}
	
	function safe_format_cell(cell, v) {
		var q = (cell.t == 'd' && v instanceof Date);
		if(cell.z != null) try { return (cell.w = SSF_format(cell.z, q ? datenum(v) : v)); } catch(e) { }
		try { return (cell.w = SSF_format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
	}
	
	function format_cell(cell, v, o) {
		if(cell == null || cell.t == null || cell.t == 'z') return "";
		if(cell.w !== undefined) return cell.w;
		if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
		if(cell.t == "e") return BErr[cell.v] || cell.v;
		if(v == undefined) return safe_format_cell(cell, cell.v);
		return safe_format_cell(cell, v);
	}
	
	function sheet_to_workbook(sheet, opts) {
		var n = opts && opts.sheet ? opts.sheet : "Sheet1";
		var sheets = {}; sheets[n] = sheet;
		return { SheetNames: [n], Sheets: sheets };
	}
	
	function sheet_add_aoa(_ws, data, opts) {
		var o = opts || {};
		var dense = _ws ? Array.isArray(_ws) : o.dense;
		if(DENSE != null && dense == null) dense = DENSE;
		var ws = _ws || (dense ? ([]) : ({}));
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
			if(!ws["!ref"]) ws["!ref"] = "A1:A1";
		}
		var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.s.c = _range.s.c;
			range.s.r = _range.s.r;
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) range.e.r = _R = _range.e.r + 1;
		}
		for(var R = 0; R != data.length; ++R) {
			if(!data[R]) continue;
			if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
			for(var C = 0; C != data[R].length; ++C) {
				if(typeof data[R][C] === 'undefined') continue;
				var cell = ({v: data[R][C] });
				var __R = _R + R, __C = _C + C;
				if(range.s.r > __R) range.s.r = __R;
				if(range.s.c > __C) range.s.c = __C;
				if(range.e.r < __R) range.e.r = __R;
				if(range.e.c < __C) range.e.c = __C;
				if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
				else {
					if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
					if(cell.v === null) {
						if(cell.f) cell.t = 'n';
						else if(o.nullError) { cell.t = 'e'; cell.v = 0; }
						else if(!o.sheetStubs) continue;
						else cell.t = 'z';
					}
					else if(typeof cell.v === 'number') cell.t = 'n';
					else if(typeof cell.v === 'boolean') cell.t = 'b';
					else if(cell.v instanceof Date) {
						cell.z = o.dateNF || table_fmt[14];
						if(o.cellDates) { cell.t = 'd'; cell.w = SSF_format(cell.z, datenum(cell.v)); }
						else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF_format(cell.z, cell.v); }
					}
					else cell.t = 's';
				}
				if(dense) {
					if(!ws[__R]) ws[__R] = [];
					if(ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
					ws[__R][__C] = cell;
				} else {
					var cell_ref = encode_cell(({c:__C,r:__R}));
					if(ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
					ws[cell_ref] = cell;
				}
			}
		}
		if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
		return ws;
	}
	function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }
	
	function parse_Int32LE(data) {
		return data.read_shift(4, 'i');
	}
	function write_UInt32LE(x, o) {
		if (!o) o = new_buf(4);
		o.write_shift(4, x);
		return o;
	}
	
	/* [MS-XLSB] 2.5.168 */
	function parse_XLWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLWideString(data, o) {
		var _null = false; if (o == null) { _null = true; o = new_buf(4 + 2 * data.length); }
		o.write_shift(4, data.length);
		if (data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.91 */
	//function parse_LPWideString(data) {
	//	var cchCharacters = data.read_shift(2);
	//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
	//}
	
	/* [MS-XLSB] 2.5.143 */
	function parse_StrRun(data) {
		return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
	}
	function write_StrRun(run, o) {
		if (!o) o = new_buf(4);
		o.write_shift(2, run.ich || 0);
		o.write_shift(2, run.ifnt || 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.121 */
	function parse_RichStr(data, length) {
		var start = data.l;
		var flags = data.read_shift(1);
		var str = parse_XLWideString(data);
		var rgsStrRun = [];
		var z = ({ t: str, h: str });
		if ((flags & 1) !== 0) { /* fRichStr */
			/* TODO: formatted string */
			var dwSizeStrRun = data.read_shift(4);
			for (var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
			z.r = rgsStrRun;
		}
		else z.r = [{ ich: 0, ifnt: 0 }];
		//if((flags & 2) !== 0) { /* fExtStr */
		//	/* TODO: phonetic string */
		//}
		data.l = start + length;
		return z;
	}
	function write_RichStr(str, o) {
		/* TODO: formatted string */
		var _null = false; if (o == null) { _null = true; o = new_buf(15 + 4 * str.t.length); }
		o.write_shift(1, 0);
		write_XLWideString(str.t, o);
		return _null ? o.slice(0, o.l) : o;
	}
	/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
	var parse_BrtCommentText = parse_RichStr;
	function write_BrtCommentText(str, o) {
		/* TODO: formatted string */
		var _null = false; if (o == null) { _null = true; o = new_buf(23 + 4 * str.t.length); }
		o.write_shift(1, 1);
		write_XLWideString(str.t, o);
		o.write_shift(4, 1);
		write_StrRun({ ich: 0, ifnt: 0 }, o);
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.9 */
	function parse_XLSBCell(data) {
		var col = data.read_shift(4);
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) << 16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c: col, iStyleRef: iStyleRef };
	}
	function write_XLSBCell(cell, o) {
		if (o == null) o = new_buf(8);
		o.write_shift(-4, cell.c);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	/* Short XLSB Cell does not include column */
	function parse_XLSBShortCell(data) {
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) <<16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c:-1, iStyleRef: iStyleRef };
	}
	function write_XLSBShortCell(cell, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	/* [MS-XLSB] 2.5.21 */
	var parse_XLSBCodeName = parse_XLWideString;
	var write_XLSBCodeName = write_XLWideString;
	
	/* [MS-XLSB] 2.5.166 */
	function parse_XLNullableWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLNullableWideString(data, o) {
		var _null = false; if (o == null) { _null = true; o = new_buf(127); }
		o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
		if (data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.165 */
	var parse_XLNameWideString = parse_XLWideString;
	//var write_XLNameWideString = write_XLWideString;
	
	/* [MS-XLSB] 2.5.114 */
	var parse_RelID = parse_XLNullableWideString;
	var write_RelID = write_XLNullableWideString;
	
	
	/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
	function parse_RkNumber(data) {
		var b = data.slice(data.l, data.l + 4);
		var fX100 = (b[0] & 1), fInt = (b[0] & 2);
		data.l += 4;
		var RK = fInt === 0 ? __double([0, 0, 0, 0, (b[0] & 0xFC), b[1], b[2], b[3]], 0) : __readInt32LE(b, 0) >> 2;
		return fX100 ? (RK / 100) : RK;
	}
	function write_RkNumber(data, o) {
		if (o == null) o = new_buf(4);
		var fX100 = 0, fInt = 0, d100 = data * 100;
		if ((data == (data | 0)) && (data >= -(1 << 29)) && (data < (1 << 29))) { fInt = 1; }
		else if ((d100 == (d100 | 0)) && (d100 >= -(1 << 29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
		if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
		else throw new Error("unsupported RkNumber " + data); // TODO
	}
	
	
	/* [MS-XLSB] 2.5.117 RfX */
	function parse_RfX(data ) {
		var cell = ({ s: {}, e: {} });
		cell.s.r = data.read_shift(4);
		cell.e.r = data.read_shift(4);
		cell.s.c = data.read_shift(4);
		cell.e.c = data.read_shift(4);
		return cell;
	}
	function write_RfX(r, o) {
		if (!o) o = new_buf(16);
		o.write_shift(4, r.s.r);
		o.write_shift(4, r.e.r);
		o.write_shift(4, r.s.c);
		o.write_shift(4, r.e.c);
		return o;
	}
	
	/* [MS-XLSB] 2.5.153 UncheckedRfX */
	var parse_UncheckedRfX = parse_RfX;
	var write_UncheckedRfX = write_RfX;
	
	/* [MS-XLSB] 2.5.155 UncheckedSqRfX */
	//function parse_UncheckedSqRfX(data) {
	//	var cnt = data.read_shift(4);
	//	var out = [];
	//	for(var i = 0; i < cnt; ++i) {
	//		var rng = parse_UncheckedRfX(data);
	//		out.push(encode_range(rng));
	//	}
	//	return out.join(",");
	//}
	//function write_UncheckedSqRfX(sqrfx) {
	//	var parts = sqrfx.split(/\s*,\s*/);
	//	var o = new_buf(4); o.write_shift(4, parts.length);
	//	var out = [o];
	//	parts.forEach(function(rng) {
	//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
	//	});
	//	return bconcat(out);
	//}
	
	/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
	/* TODO: error checking, NaN and Infinity values are not valid Xnum */
	function parse_Xnum(data) {
		if(data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
		return data.read_shift(8, 'f');
	}
	function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }
	
	/* [MS-XLSB] 2.4.324 BrtColor */
	function parse_BrtColor(data) {
		var out = {};
		var d = data.read_shift(1);
	
		//var fValidRGB = d & 1;
		var xColorType = d >>> 1;
	
		var index = data.read_shift(1);
		var nTS = data.read_shift(2, 'i');
		var bR = data.read_shift(1);
		var bG = data.read_shift(1);
		var bB = data.read_shift(1);
		data.l++; //var bAlpha = data.read_shift(1);
	
		switch (xColorType) {
			case 0: out.auto = 1; break;
			case 1:
				out.index = index;
				var icv = XLSIcv[index];
				/* automatic pseudo index 81 */
				if (icv) out.rgb = rgb2Hex(icv);
				break;
			case 2:
				/* if(!fValidRGB) throw new Error("invalid"); */
				out.rgb = rgb2Hex([bR, bG, bB]);
				break;
			case 3: out.theme = index; break;
		}
		if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
	
		return out;
	}
	function write_BrtColor(color, o) {
		if (!o) o = new_buf(8);
		if (!color || color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
		if (color.index != null) {
			o.write_shift(1, 0x02);
			o.write_shift(1, color.index);
		} else if (color.theme != null) {
			o.write_shift(1, 0x06);
			o.write_shift(1, color.theme);
		} else {
			o.write_shift(1, 0x05);
			o.write_shift(1, 0);
		}
		var nTS = color.tint || 0;
		if (nTS > 0) nTS *= 32767;
		else if (nTS < 0) nTS *= 32768;
		o.write_shift(2, nTS);
		if (!color.rgb || color.theme != null) {
			o.write_shift(2, 0);
			o.write_shift(1, 0);
			o.write_shift(1, 0);
		} else {
			var rgb = (color.rgb || 'FFFFFF');
			if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
			o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
			o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
			o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
			o.write_shift(1, 0xFF);
		}
		return o;
	}
	
	/* [MS-XLSB] 2.5.52 */
	function parse_FontFlags(data) {
		var d = data.read_shift(1);
		data.l++;
		var out = {
			fBold: d & 0x01,
			fItalic: d & 0x02,
			fUnderline: d & 0x04,
			fStrikeout: d & 0x08,
			fOutline: d & 0x10,
			fShadow: d & 0x20,
			fCondense: d & 0x40,
			fExtend: d & 0x80
		};
		return out;
	}
	function write_FontFlags(font, o) {
		if (!o) o = new_buf(2);
		var grbit =
			(font.italic ? 0x02 : 0) |
			(font.strike ? 0x08 : 0) |
			(font.outline ? 0x10 : 0) |
			(font.shadow ? 0x20 : 0) |
			(font.condense ? 0x40 : 0) |
			(font.extend ? 0x80 : 0);
		o.write_shift(1, grbit);
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-OLEDS] 2.3.1 and 2.3.2 */
	function parse_ClipboardFormatOrString(o, w) {
		// $FlowIgnore
		var ClipFmt = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" };
		var m = o.read_shift(4);
		switch (m) {
			case 0x00000000: return "";
			case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)] || "";
		}
		if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
		o.l -= 4;
		return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
	}
	function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
	function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }
	
	/* [MS-OLEPS] 2.2 PropertyType */
	// Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
	//var VT_EMPTY    = 0x0000;
	//var VT_NULL     = 0x0001;
	var VT_I2       = 0x0002;
	var VT_I4       = 0x0003;
	//var VT_R4       = 0x0004;
	//var VT_R8       = 0x0005;
	//var VT_CY       = 0x0006;
	//var VT_DATE     = 0x0007;
	//var VT_BSTR     = 0x0008;
	//var VT_ERROR    = 0x000A;
	var VT_BOOL     = 0x000B;
	var VT_VARIANT  = 0x000C;
	//var VT_DECIMAL  = 0x000E;
	//var VT_I1       = 0x0010;
	//var VT_UI1      = 0x0011;
	//var VT_UI2      = 0x0012;
	var VT_UI4      = 0x0013;
	//var VT_I8       = 0x0014;
	//var VT_UI8      = 0x0015;
	//var VT_INT      = 0x0016;
	//var VT_UINT     = 0x0017;
	var VT_LPSTR    = 0x001E;
	//var VT_LPWSTR   = 0x001F;
	var VT_FILETIME = 0x0040;
	var VT_BLOB     = 0x0041;
	//var VT_STREAM   = 0x0042;
	//var VT_STORAGE  = 0x0043;
	//var VT_STREAMED_Object  = 0x0044;
	//var VT_STORED_Object    = 0x0045;
	//var VT_BLOB_Object      = 0x0046;
	var VT_CF       = 0x0047;
	//var VT_CLSID    = 0x0048;
	//var VT_VERSIONED_STREAM = 0x0049;
	var VT_VECTOR   = 0x1000;
	var VT_VECTOR_VARIANT = 0x100C;
	var VT_VECTOR_LPSTR   = 0x101E;
	//var VT_ARRAY    = 0x2000;
	
	var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
	var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
	var VT_CUSTOM   = [VT_STRING, VT_USTR];
	
	/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
	var DocSummaryPIDDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Category', t: VT_STRING },
	0x03: { n: 'PresentationFormat', t: VT_STRING },
	0x04: { n: 'ByteCount', t: VT_I4 },
	0x05: { n: 'LineCount', t: VT_I4 },
	0x06: { n: 'ParagraphCount', t: VT_I4 },
	0x07: { n: 'SlideCount', t: VT_I4 },
	0x08: { n: 'NoteCount', t: VT_I4 },
	0x09: { n: 'HiddenCount', t: VT_I4 },
	0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
	0x0b: { n: 'ScaleCrop', t: VT_BOOL },
	0x0c: { n: 'HeadingPairs', t: VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ },
	0x0d: { n: 'TitlesOfParts', t: VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ },
	0x0e: { n: 'Manager', t: VT_STRING },
	0x0f: { n: 'Company', t: VT_STRING },
	0x10: { n: 'LinksUpToDate', t: VT_BOOL },
	0x11: { n: 'CharacterCount', t: VT_I4 },
	0x13: { n: 'SharedDoc', t: VT_BOOL },
	0x16: { n: 'HyperlinksChanged', t: VT_BOOL },
	0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
	0x18: { n: 'DigSig', t: VT_BLOB },
	0x1A: { n: 'ContentType', t: VT_STRING },
	0x1B: { n: 'ContentStatus', t: VT_STRING },
	0x1C: { n: 'Language', t: VT_STRING },
	0x1D: { n: 'Version', t: VT_STRING },
	0xFF: {},
		/* [MS-OLEPS] 2.18 */
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
	var SummaryPIDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Title', t: VT_STRING },
	0x03: { n: 'Subject', t: VT_STRING },
	0x04: { n: 'Author', t: VT_STRING },
	0x05: { n: 'Keywords', t: VT_STRING },
	0x06: { n: 'Comments', t: VT_STRING },
	0x07: { n: 'Template', t: VT_STRING },
	0x08: { n: 'LastAuthor', t: VT_STRING },
	0x09: { n: 'RevNumber', t: VT_STRING },
	0x0A: { n: 'EditTime', t: VT_FILETIME },
	0x0B: { n: 'LastPrinted', t: VT_FILETIME },
	0x0C: { n: 'CreatedDate', t: VT_FILETIME },
	0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
	0x0E: { n: 'PageCount', t: VT_I4 },
	0x0F: { n: 'WordCount', t: VT_I4 },
	0x10: { n: 'CharCount', t: VT_I4 },
	0x11: { n: 'Thumbnail', t: VT_CF },
	0x12: { n: 'Application', t: VT_STRING },
	0x13: { n: 'DocSecurity', t: VT_I4 },
	0xFF: {},
		/* [MS-OLEPS] 2.18 */
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	/* [MS-XLS] 2.4.63 Country/Region codes */
	var CountryEnum = {
	0x0001: "US", // United States
	0x0002: "CA", // Canada
	0x0003: "", // Latin America (except Brazil)
	0x0007: "RU", // Russia
	0x0014: "EG", // Egypt
	0x001E: "GR", // Greece
	0x001F: "NL", // Netherlands
	0x0020: "BE", // Belgium
	0x0021: "FR", // France
	0x0022: "ES", // Spain
	0x0024: "HU", // Hungary
	0x0027: "IT", // Italy
	0x0029: "CH", // Switzerland
	0x002B: "AT", // Austria
	0x002C: "GB", // United Kingdom
	0x002D: "DK", // Denmark
	0x002E: "SE", // Sweden
	0x002F: "NO", // Norway
	0x0030: "PL", // Poland
	0x0031: "DE", // Germany
	0x0034: "MX", // Mexico
	0x0037: "BR", // Brazil
	0x003d: "AU", // Australia
	0x0040: "NZ", // New Zealand
	0x0042: "TH", // Thailand
	0x0051: "JP", // Japan
	0x0052: "KR", // Korea
	0x0054: "VN", // Viet Nam
	0x0056: "CN", // China
	0x005A: "TR", // Turkey
	0x0069: "JS", // Ramastan
	0x00D5: "DZ", // Algeria
	0x00D8: "MA", // Morocco
	0x00DA: "LY", // Libya
	0x015F: "PT", // Portugal
	0x0162: "IS", // Iceland
	0x0166: "FI", // Finland
	0x01A4: "CZ", // Czech Republic
	0x0376: "TW", // Taiwan
	0x03C1: "LB", // Lebanon
	0x03C2: "JO", // Jordan
	0x03C3: "SY", // Syria
	0x03C4: "IQ", // Iraq
	0x03C5: "KW", // Kuwait
	0x03C6: "SA", // Saudi Arabia
	0x03CB: "AE", // United Arab Emirates
	0x03CC: "IL", // Israel
	0x03CE: "QA", // Qatar
	0x03D5: "IR", // Iran
	0xFFFF: "US"  // United States
	};
	
	/* [MS-XLS] 2.5.127 */
	var XLSFillPattern = [
		null,
		'solid',
		'mediumGray',
		'darkGray',
		'lightGray',
		'darkHorizontal',
		'darkVertical',
		'darkDown',
		'darkUp',
		'darkGrid',
		'darkTrellis',
		'lightHorizontal',
		'lightVertical',
		'lightDown',
		'lightUp',
		'lightGrid',
		'lightTrellis',
		'gray125',
		'gray0625'
	];
	
	function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }
	
	/* [MS-XLS] 2.5.161 */
	/* [MS-XLSB] 2.5.75 Icv */
	var _XLSIcv =  rgbify([
		/* Color Constants */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		/* Overridable Defaults */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		0x800000,
		0x008000,
		0x000080,
		0x808000,
		0x800080,
		0x008080,
		0xC0C0C0,
		0x808080,
		0x9999FF,
		0x993366,
		0xFFFFCC,
		0xCCFFFF,
		0x660066,
		0xFF8080,
		0x0066CC,
		0xCCCCFF,
	
		0x000080,
		0xFF00FF,
		0xFFFF00,
		0x00FFFF,
		0x800080,
		0x800000,
		0x008080,
		0x0000FF,
		0x00CCFF,
		0xCCFFFF,
		0xCCFFCC,
		0xFFFF99,
		0x99CCFF,
		0xFF99CC,
		0xCC99FF,
		0xFFCC99,
	
		0x3366FF,
		0x33CCCC,
		0x99CC00,
		0xFFCC00,
		0xFF9900,
		0xFF6600,
		0x666699,
		0x969696,
		0x003366,
		0x339966,
		0x003300,
		0x333300,
		0x993300,
		0x993366,
		0x333399,
		0x333333,
	
		/* Other entries to appease BIFF8/12 */
		0xFFFFFF, /* 0x40 icvForeground ?? */
		0x000000, /* 0x41 icvBackground ?? */
		0x000000, /* 0x42 icvFrame ?? */
		0x000000, /* 0x43 icv3D ?? */
		0x000000, /* 0x44 icv3DText ?? */
		0x000000, /* 0x45 icv3DHilite ?? */
		0x000000, /* 0x46 icv3DShadow ?? */
		0x000000, /* 0x47 icvHilite ?? */
		0x000000, /* 0x48 icvCtlText ?? */
		0x000000, /* 0x49 icvCtlScrl ?? */
		0x000000, /* 0x4A icvCtlInv ?? */
		0x000000, /* 0x4B icvCtlBody ?? */
		0x000000, /* 0x4C icvCtlFrame ?? */
		0x000000, /* 0x4D icvCtlFore ?? */
		0x000000, /* 0x4E icvCtlBack ?? */
		0x000000, /* 0x4F icvCtlNeutral */
		0x000000, /* 0x50 icvInfoBk ?? */
		0x000000 /* 0x51 icvInfoText ?? */
	]);
	var XLSIcv = dup(_XLSIcv);
	
	/* [MS-XLSB] 2.5.97.2 */
	var BErr = {
	0x00: "#NULL!",
	0x07: "#DIV/0!",
	0x0F: "#VALUE!",
	0x17: "#REF!",
	0x1D: "#NAME?",
	0x24: "#NUM!",
	0x2A: "#N/A",
	0x2B: "#GETTING_DATA",
	0xFF: "#WTF?"
	};
	//var RBErr = evert_num(BErr);
	var RBErr = {
		"#NULL!":        0x00,
		"#DIV/0!":       0x07,
		"#VALUE!":       0x0F,
		"#REF!":         0x17,
		"#NAME?":        0x1D,
		"#NUM!":         0x24,
		"#N/A":          0x2A,
		"#GETTING_DATA": 0x2B,
		"#WTF?":         0xFF
	};
	
	/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
	/* 12.3 Part Summary <SpreadsheetML> */
	/* 14.2 Part Summary <DrawingML> */
	/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
	var ct2type/*{[string]:string}*/ = ({
		/* Workbook */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
		"application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
		"application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
		"application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
	
		/* Worksheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
		"application/vnd.ms-excel.worksheet": "sheets",
		"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */
	
		/* Chartsheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
		"application/vnd.ms-excel.chartsheet": "charts",
	
		/* Macrosheet */
		"application/vnd.ms-excel.macrosheet+xml": "macros",
		"application/vnd.ms-excel.macrosheet": "macros",
		"application/vnd.ms-excel.intlmacrosheet": "TODO",
		"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */
	
		/* Dialogsheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
		"application/vnd.ms-excel.dialogsheet": "dialogs",
	
		/* Shared Strings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
		"application/vnd.ms-excel.sharedStrings": "strs",
	
		/* Styles */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
		"application/vnd.ms-excel.styles": "styles",
	
		/* File Properties */
		"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
		"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
		"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
	
		/* Custom Data Properties */
		"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
	
		/* Comments */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
		"application/vnd.ms-excel.comments": "comments",
		"application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
		"application/vnd.ms-excel.person+xml": "people",
	
		/* Metadata (Stock/Geography and Dynamic Array) */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
		"application/vnd.ms-excel.sheetMetadata": "metadata",
	
		/* PivotTable */
		"application/vnd.ms-excel.pivotTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
	
		/* Chart Objects */
		"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
	
		/* Chart Colors */
		"application/vnd.ms-office.chartcolorstyle+xml": "TODO",
	
		/* Chart Style */
		"application/vnd.ms-office.chartstyle+xml": "TODO",
	
		/* Chart Advanced */
		"application/vnd.ms-office.chartex+xml": "TODO",
	
		/* Calculation Chain */
		"application/vnd.ms-excel.calcChain": "calcchains",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
	
		/* Printer Settings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
	
		/* ActiveX */
		"application/vnd.ms-office.activeX": "TODO",
		"application/vnd.ms-office.activeX+xml": "TODO",
	
		/* Custom Toolbars */
		"application/vnd.ms-excel.attachedToolbars": "TODO",
	
		/* External Data Connections */
		"application/vnd.ms-excel.connections": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
	
		/* External Links */
		"application/vnd.ms-excel.externalLink": "links",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
	
		/* PivotCache */
		"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
		"application/vnd.ms-excel.pivotCacheRecords": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
	
		/* Query Table */
		"application/vnd.ms-excel.queryTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
	
		/* Shared Workbook */
		"application/vnd.ms-excel.userNames": "TODO",
		"application/vnd.ms-excel.revisionHeaders": "TODO",
		"application/vnd.ms-excel.revisionLog": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
	
		/* Single Cell Table */
		"application/vnd.ms-excel.tableSingleCells": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
	
		/* Slicer */
		"application/vnd.ms-excel.slicer": "TODO",
		"application/vnd.ms-excel.slicerCache": "TODO",
		"application/vnd.ms-excel.slicer+xml": "TODO",
		"application/vnd.ms-excel.slicerCache+xml": "TODO",
	
		/* Sort Map */
		"application/vnd.ms-excel.wsSortMap": "TODO",
	
		/* Table */
		"application/vnd.ms-excel.table": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
	
		/* Themes */
		"application/vnd.openxmlformats-officedocument.theme+xml": "themes",
	
		/* Theme Override */
		"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
	
		/* Timeline */
		"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
		"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */
	
		/* VBA */
		"application/vnd.ms-office.vbaProject": "vba",
		"application/vnd.ms-office.vbaProjectSignature": "TODO",
	
		/* Volatile Dependencies */
		"application/vnd.ms-office.volatileDependencies": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
	
		/* Control Properties */
		"application/vnd.ms-excel.controlproperties+xml": "TODO",
	
		/* Data Model */
		"application/vnd.openxmlformats-officedocument.model+data": "TODO",
	
		/* Survey */
		"application/vnd.ms-excel.Survey+xml": "TODO",
	
		/* Drawing */
		"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
		"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
	
		/* VML */
		"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
	
		"application/vnd.openxmlformats-package.relationships+xml": "rels",
		"application/vnd.openxmlformats-officedocument.oleObject": "TODO",
	
		/* Image */
		"image/png": "TODO",
	
		"sheet": "js"
	});
	
	var CT_LIST = {
			workbooks: {
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
				xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
				xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
				xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
				xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
			},
			strs: { /* Shared Strings */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
				xlsb: "application/vnd.ms-excel.sharedStrings"
			},
			comments: { /* Comments */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
				xlsb: "application/vnd.ms-excel.comments"
			},
			sheets: { /* Worksheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
				xlsb: "application/vnd.ms-excel.worksheet"
			},
			charts: { /* Chartsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
				xlsb: "application/vnd.ms-excel.chartsheet"
			},
			dialogs: { /* Dialogsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
				xlsb: "application/vnd.ms-excel.dialogsheet"
			},
			macros: { /* Macrosheet (Excel 4.0 Macros) */
				xlsx: "application/vnd.ms-excel.macrosheet+xml",
				xlsb: "application/vnd.ms-excel.macrosheet"
			},
			metadata: { /* Metadata (Stock/Geography and Dynamic Array) */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
				xlsb: "application/vnd.ms-excel.sheetMetadata"
			},
			styles: { /* Styles */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
				xlsb: "application/vnd.ms-excel.styles"
			}
	};
	
	function new_ct() {
		return ({
			workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
			rels:[], strs:[], comments:[], threadedcomments:[], links:[],
			coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
			calcchains:[], vba: [], drawings: [], metadata: [], people:[],
			TODO:[], xmlns: "" });
	}
	
	function parse_ct(data) {
		var ct = new_ct();
		if(!data || !data.match) return ct;
		var ctext = {};
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0].replace(nsregex,"<")) {
				case '<?xml': break;
				case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
				case '<Default': ctext[y.Extension] = y.ContentType; break;
				case '<Override':
					if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
					break;
			}
		});
		if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
		ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
		ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
		ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
		ct.defaults = ctext;
		delete ct.calcchains;
		return ct;
	}
	
	function write_ct(ct, opts) {
		var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);
	
		var o = [], v;
		o[o.length] = (XML_HEADER);
		o[o.length] = writextag('Types', null, {
			'xmlns': XMLNS.CT,
			'xmlns:xsd': XMLNS.xsd,
			'xmlns:xsi': XMLNS.xsi
		});
	
		o = o.concat([
			['xml', 'application/xml'],
			['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
			['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
			['data', 'application/vnd.openxmlformats-officedocument.model+data'],
			/* from test files */
			['bmp', 'image/bmp'],
			['png', 'image/png'],
			['gif', 'image/gif'],
			['emf', 'image/x-emf'],
			['wmf', 'image/x-wmf'],
			['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
			['tif', 'image/tiff'], ['tiff', 'image/tiff'],
			['pdf', 'application/pdf'],
			['rels', 'application/vnd.openxmlformats-package.relationships+xml']
		].map(function(x) {
			return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
		}));
	
		/* only write first instance */
		var f1 = function(w) {
			if(ct[w] && ct[w].length > 0) {
				v = ct[w][0];
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
				}));
			}
		};
	
		/* book type-specific */
		var f2 = function(w) {
			(ct[w]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
				}));
			});
		};
	
		/* standard type */
		var f3 = function(t) {
			(ct[t]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': type2ct[t][0]
				}));
			});
		};
	
		f1('workbooks');
		f2('sheets');
		f2('charts');
		f3('themes');
		['strs', 'styles'].forEach(f1);
		['coreprops', 'extprops', 'custprops'].forEach(f3);
		f3('vba');
		f3('comments');
		f3('threadedcomments');
		f3('drawings');
		f2('metadata');
		f3('people');
		if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 9.3 Relationships */
	var RELS = ({
		WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
		VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
		XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
		XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
		XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
		CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
		CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
		CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
		CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
		EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
		CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
		SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
		STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
		THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
		CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
		CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
		CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
		WS: [
			"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
			"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
		],
		DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
		MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
		IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
		DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
		XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
		TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
		PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
		VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
	});
	
	
	/* 9.3.3 Representing Relationships */
	function get_rels_path(file) {
		var n = file.lastIndexOf("/");
		return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
	}
	
	function parse_rels(data, currentFilePath) {
		var rels = {"!id":{}};
		if (!data) return rels;
		if (currentFilePath.charAt(0) !== '/') {
			currentFilePath = '/'+currentFilePath;
		}
		var hash = {};
	
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			/* 9.3.2.2 OPC_Relationships */
			if (y[0] === '<Relationship') {
				var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; if(y.TargetMode) rel.TargetMode = y.TargetMode;
				var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
				rels[canonictarget] = rel;
				hash[y.Id] = rel;
			}
		});
		rels["!id"] = hash;
		return rels;
	}
	
	
	/* TODO */
	function write_rels(rels) {
		var o = [XML_HEADER, writextag('Relationships', null, {
			//'xmlns:ns0': XMLNS.RELS,
			'xmlns': XMLNS.RELS
		})];
		keys(rels['!id']).forEach(function(rid) {
			o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
		});
		if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	function add_rels(rels, rId, f, type, relobj, targetmode) {
		if(!relobj) relobj = {};
		if(!rels['!id']) rels['!id'] = {};
		if(!rels['!idx']) rels['!idx'] = 1;
		if(rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId){/* empty */}
		rels['!idx'] = rId + 1;
		relobj.Id = 'rId' + rId;
		relobj.Type = type;
		relobj.Target = f;
		if(targetmode) relobj.TargetMode = targetmode;
		else if([RELS.HLINK, RELS.XPATH, RELS.XMISS].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
		if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
		rels['!id'][relobj.Id] = relobj;
		rels[('/' + relobj.Target).replace("//","/")] = relobj;
		return rId;
	}
	/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
	/* Part 3 Section 4 Manifest File */
	var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
	function parse_manifest(d, opts) {
		var str = xlml_normalize(d);
		var Rn;
		var FEtag;
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'manifest': break; // 4.2 <manifest:manifest>
			case 'file-entry': // 4.3 <manifest:file-entry>
				FEtag = parsexmltag(Rn[0], false);
				if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
				break;
			case 'encryption-data': // 4.4 <manifest:encryption-data>
			case 'algorithm': // 4.5 <manifest:algorithm>
			case 'start-key-generation': // 4.6 <manifest:start-key-generation>
			case 'key-derivation': // 4.7 <manifest:key-derivation>
				throw new Error("Unsupported ODS Encryption");
			default: if(opts && opts.WTF) throw Rn;
		}
	}
	
	function write_manifest(manifest) {
		var o = [XML_HEADER];
		o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
		o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
		for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
		o.push('</manifest:manifest>');
		return o.join("");
	}
	
	/* Part 3 Section 6 Metadata Manifest File */
	function write_rdf_type(file, res, tag) {
		return [
			'  <rdf:Description rdf:about="' + file + '">\n',
			'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf_has(base, file) {
		return [
			'  <rdf:Description rdf:about="' + base + '">\n',
			'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf(rdf) {
		var o = [XML_HEADER];
		o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
		for(var i = 0; i != rdf.length; ++i) {
			o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
			o.push(write_rdf_has("",rdf[i][0]));
		}
		o.push(write_rdf_type("","Document", "pkg"));
		o.push('</rdf:RDF>');
		return o.join("");
	}
	/* TODO: pull properties */
	function write_meta_ods() {
		return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
	}
	
	/* ECMA-376 Part II 11.1 Core Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var CORE_PROPS = [
		["cp:category", "Category"],
		["cp:contentStatus", "ContentStatus"],
		["cp:keywords", "Keywords"],
		["cp:lastModifiedBy", "LastAuthor"],
		["cp:lastPrinted", "LastPrinted"],
		["cp:revision", "RevNumber"],
		["cp:version", "Version"],
		["dc:creator", "Author"],
		["dc:description", "Comments"],
		["dc:identifier", "Identifier"],
		["dc:language", "Language"],
		["dc:subject", "Subject"],
		["dc:title", "Title"],
		["dcterms:created", "CreatedDate", 'date'],
		["dcterms:modified", "ModifiedDate", 'date']
	];
	
	var CORE_PROPS_REGEX = (function() {
		var r = new Array(CORE_PROPS.length);
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
			r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
		}
		return r;
	})();
	
	function parse_core_props(data) {
		var p = {};
		data = utf8read(data);
	
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
			if(cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
			if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
		}
	
		return p;
	}
	
	function cp_doit(f, g, h, o, p) {
		if(p[f] != null || g == null || g === "") return;
		p[f] = g;
		g = escapexml(g);
		o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
	}
	
	function write_core_props(cp, _opts) {
		var opts = _opts || {};
		var o = [XML_HEADER, writextag('cp:coreProperties', null, {
			//'xmlns': XMLNS.CORE_PROPS,
			'xmlns:cp': XMLNS.CORE_PROPS,
			'xmlns:dc': XMLNS.dc,
			'xmlns:dcterms': XMLNS.dcterms,
			'xmlns:dcmitype': XMLNS.dcmitype,
			'xmlns:xsi': XMLNS.xsi
		})], p = {};
		if(!cp && !opts.Props) return o.join("");
	
		if(cp) {
			if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
			if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		}
	
		for(var i = 0; i != CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
			if(v === true) v = "1";
			else if(v === false) v = "0";
			else if(typeof v == "number") v = String(v);
			if(v != null) cp_doit(f[0], v, null, o, p);
		}
		if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.3 Extended File Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var EXT_PROPS = [
		["Application", "Application", "string"],
		["AppVersion", "AppVersion", "string"],
		["Company", "Company", "string"],
		["DocSecurity", "DocSecurity", "string"],
		["Manager", "Manager", "string"],
		["HyperlinksChanged", "HyperlinksChanged", "bool"],
		["SharedDoc", "SharedDoc", "bool"],
		["LinksUpToDate", "LinksUpToDate", "bool"],
		["ScaleCrop", "ScaleCrop", "bool"],
		["HeadingPairs", "HeadingPairs", "raw"],
		["TitlesOfParts", "TitlesOfParts", "raw"]
	];
	
	var PseudoPropsPairs = [
		"Worksheets",  "SheetNames",
		"NamedRanges", "DefinedNames",
		"Chartsheets", "ChartNames"
	];
	function load_props_pairs(HP, TOP, props, opts) {
		var v = [];
		if(typeof HP == "string") v = parseVector(HP, opts);
		else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
		var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
		var idx = 0, len = 0;
		if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
			len = +(v[i+1].v);
			switch(v[i].v) {
				case "Worksheets":
				case "工作表":
				case "Листы":
				case "أوراق العمل":
				case "ワークシート":
				case "גליונות עבודה":
				case "Arbeitsblätter":
				case "Çalışma Sayfaları":
				case "Feuilles de calcul":
				case "Fogli di lavoro":
				case "Folhas de cálculo":
				case "Planilhas":
				case "Regneark":
				case "Hojas de cálculo":
				case "Werkbladen":
					props.Worksheets = len;
					props.SheetNames = parts.slice(idx, idx + len);
					break;
	
				case "Named Ranges":
				case "Rangos con nombre":
				case "名前付き一覧":
				case "Benannte Bereiche":
				case "Navngivne områder":
					props.NamedRanges = len;
					props.DefinedNames = parts.slice(idx, idx + len);
					break;
	
				case "Charts":
				case "Diagramme":
					props.Chartsheets = len;
					props.ChartNames = parts.slice(idx, idx + len);
					break;
			}
			idx += len;
		}
	}
	
	function parse_ext_props(data, p, opts) {
		var q = {}; if(!p) p = {};
		data = utf8read(data);
	
		EXT_PROPS.forEach(function(f) {
			var xml = (data.match(matchtag(f[0]))||[])[1];
			switch(f[2]) {
				case "string": if(xml) p[f[1]] = unescapexml(xml); break;
				case "bool": p[f[1]] = xml === "true"; break;
				case "raw":
					var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
					if(cur && cur.length > 0) q[f[1]] = cur[1];
					break;
			}
		});
	
		if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
	
		return p;
	}
	
	function write_ext_props(cp) {
		var o = [], W = writextag;
		if(!cp) cp = {};
		cp.Application = "SheetJS";
		o[o.length] = (XML_HEADER);
		o[o.length] = (writextag('Properties', null, {
			'xmlns': XMLNS.EXT_PROPS,
			'xmlns:vt': XMLNS.vt
		}));
	
		EXT_PROPS.forEach(function(f) {
			if(cp[f[1]] === undefined) return;
			var v;
			switch(f[2]) {
				case 'string': v = escapexml(String(cp[f[1]])); break;
				case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
			}
			if(v !== undefined) o[o.length] = (W(f[0], v));
		});
	
		/* TODO: HeadingPairs, TitlesOfParts */
		o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
		o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
		if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.2 Custom File Properties Part */
	var custregex = /<[^>]+>[^<]*/g;
	function parse_cust_props(data, opts) {
		var p = {}, name = "";
		var m = data.match(custregex);
		if(m) for(var i = 0; i != m.length; ++i) {
			var x = m[i], y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				case '<Properties': break;
				case '<property': name = unescapexml(y.name); break;
				case '</property>': name = null; break;
				default: if (x.indexOf('<vt:') === 0) {
					var toks = x.split('>');
					var type = toks[0].slice(4), text = toks[1];
					/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
					switch(type) {
						case 'lpstr': case 'bstr': case 'lpwstr':
							p[name] = unescapexml(text);
							break;
						case 'bool':
							p[name] = parsexmlbool(text);
							break;
						case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
							p[name] = parseInt(text, 10);
							break;
						case 'r4': case 'r8': case 'decimal':
							p[name] = parseFloat(text);
							break;
						case 'filetime': case 'date':
							p[name] = parseDate(text);
							break;
						case 'cy': case 'error':
							p[name] = unescapexml(text);
							break;
						default:
							if(type.slice(-1) == '/') break;
							if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
					}
				} else if(x.slice(0,2) === "</") {/* empty */
				} else if(opts.WTF) throw new Error(x);
			}
		}
		return p;
	}
	
	function write_cust_props(cp) {
		var o = [XML_HEADER, writextag('Properties', null, {
			'xmlns': XMLNS.CUST_PROPS,
			'xmlns:vt': XMLNS.vt
		})];
		if(!cp) return o.join("");
		var pid = 1;
		keys(cp).forEach(function custprop(k) { ++pid;
			o[o.length] = (writextag('property', write_vt(cp[k], true), {
				'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
				'pid': pid,
				'name': escapexml(k)
			}));
		});
		if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* Common Name -> XLML Name */
	var XLMLDocPropsMap = {
		Title: 'Title',
		Subject: 'Subject',
		Author: 'Author',
		Keywords: 'Keywords',
		Comments: 'Description',
		LastAuthor: 'LastAuthor',
		RevNumber: 'Revision',
		Application: 'AppName',
		/* TotalTime: 'TotalTime', */
		LastPrinted: 'LastPrinted',
		CreatedDate: 'Created',
		ModifiedDate: 'LastSaved',
		/* Pages */
		/* Words */
		/* Characters */
		Category: 'Category',
		/* PresentationFormat */
		Manager: 'Manager',
		Company: 'Company',
		/* Guid */
		/* HyperlinkBase */
		/* Bytes */
		/* Lines */
		/* Paragraphs */
		/* CharactersWithSpaces */
		AppVersion: 'Version',
	
		ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
		Identifier: 'Identifier', /* NOTE: missing from schema */
		Language: 'Language' /* NOTE: missing from schema */
	};
	var evert_XLMLDPM;
	
	function xlml_set_prop(Props, tag, val) {
		if(!evert_XLMLDPM) evert_XLMLDPM = evert(XLMLDocPropsMap);
		tag = evert_XLMLDPM[tag] || tag;
		Props[tag] = val;
	}
	
	function xlml_write_docprops(Props, opts) {
		var o = [];
		keys(XLMLDocPropsMap).map(function(m) {
			for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
			for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
			throw m;
		}).forEach(function(p) {
			if(Props[p[1]] == null) return;
			var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
			switch(p[2]) {
				case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
			}
			if(typeof m == 'number') m = String(m);
			else if(m === true || m === false) { m = m ? "1" : "0"; }
			else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
			o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
		});
		return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
	}
	function xlml_write_custprops(Props, Custprops) {
		var BLACKLIST = ["Worksheets","SheetNames"];
		var T = 'CustomDocumentProperties';
		var o = [];
		if(Props) keys(Props).forEach(function(k) {
	if(!Object.prototype.hasOwnProperty.call(Props, k)) return;
			for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
			for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
			for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;
	
			var m = Props[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		if(Custprops) keys(Custprops).forEach(function(k) {
	if(!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
			if(Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
			var m = Custprops[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
	}
	/* [MS-DTYP] 2.3.3 FILETIME */
	/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
	/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
	function parse_FILETIME(blob) {
		var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
		return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
	}
	function write_FILETIME(time) {
		var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
		var t = date.getTime() / 1000 + 11644473600;
		var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
		l *= 1e7; h *= 1e7;
		var w = (l / Math.pow(2,32)) | 0;
		if(w > 0) { l = l % Math.pow(2,32); h += w; }
		var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
	}
	
	/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
	function parse_lpstr(blob, type, pad) {
		var start = blob.l;
		var str = blob.read_shift(0, 'lpstr-cp');
		if(pad) while((blob.l - start) & 3) ++blob.l;
		return str;
	}
	
	/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
	function parse_lpwstr(blob, type, pad) {
		var str = blob.read_shift(0, 'lpwstr');
		if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
		return str;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.11 VtString */
	/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
	function parse_VtStringBase(blob, stringType, pad) {
		if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
		return parse_lpstr(blob, stringType, pad);
	}
	
	function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
	function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }
	
	/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */
	function parse_VtVecLpwstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) {
			var start = blob.l;
			ret[i] = blob.read_shift(0, 'lpwstr').replace(chr0,'');
			if((blob.l - start) & 0x02) blob.l += 2;
		}
		return ret;
	}
	
	/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
	function parse_VtVecUnalignedLpstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
		return ret;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
	function parse_VtHeadingPair(blob) {
		var start = blob.l;
		var headingString = parse_TypedPropertyValue(blob, VT_USTR);
		if(blob[blob.l] == 0x00 && blob[blob.l+1] == 0x00 && ((blob.l - start) & 0x02)) blob.l += 2;
		var headerParts = parse_TypedPropertyValue(blob, VT_I4);
		return [headingString, headerParts];
	}
	
	/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
	function parse_VtVecHeadingPairValue(blob) {
		var cElements = blob.read_shift(4);
		var out = [];
		for(var i = 0; i < cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
		return out;
	}
	
	/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
	function parse_dictionary(blob,CodePage) {
		var cnt = blob.read_shift(4);
		var dict = ({});
		for(var j = 0; j != cnt; ++j) {
			var pid = blob.read_shift(4);
			var len = blob.read_shift(4);
			dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
			if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
		}
		if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
		return dict;
	}
	
	/* [MS-OLEPS] 2.9 BLOB */
	function parse_BLOB(blob) {
		var size = blob.read_shift(4);
		var bytes = blob.slice(blob.l,blob.l+size);
		blob.l += size;
		if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
		return bytes;
	}
	
	/* [MS-OLEPS] 2.11 ClipboardData */
	function parse_ClipboardData(blob) {
		// TODO
		var o = {};
		o.Size = blob.read_shift(4);
		//o.Format = blob.read_shift(4);
		blob.l += o.Size + 3 - (o.Size - 1) % 4;
		return o;
	}
	
	/* [MS-OLEPS] 2.15 TypedPropertyValue */
	function parse_TypedPropertyValue(blob, type, _opts) {
		var t = blob.read_shift(2), ret, opts = _opts||{};
		blob.l += 2;
		if(type !== VT_VARIANT)
		if(t !== type && VT_CUSTOM.indexOf(type)===-1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
		switch(type === VT_VARIANT ? t : type) {
			case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
			case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
			case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
			case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
			case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
			case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
			case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
			case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
			case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
			case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
			case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
			case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPairValue(blob);
			case 0x101E /*VT_VECTOR|VT_LPSTR*/:
			case 0x101F /*VT_VECTOR|VT_LPWSTR*/:
				return t == 0x101F ? parse_VtVecLpwstrValue(blob) : parse_VtVecUnalignedLpstrValue(blob);
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
		}
	}
	function write_TypedPropertyValue(type, value) {
		var o = new_buf(4), p = new_buf(4);
		o.write_shift(4, type == 0x50 ? 0x1F : type);
		switch(type) {
			case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
			case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
			case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
			case 0x40 /*VT_FILETIME*/:  p = write_FILETIME(value); break;
			case 0x1F /*VT_LPWSTR*/:
			case 0x50 /*VT_STRING*/:
	p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				p.write_shift(4, value.length + 1);
				p.write_shift(0, value, "dbcs");
				while(p.l != p.length) p.write_shift(1, 0);
				break;
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
		}
		return bconcat([o, p]);
	}
	
	/* [MS-OLEPS] 2.20 PropertySet */
	function parse_PropertySet(blob, PIDSI) {
		var start_addr = blob.l;
		var size = blob.read_shift(4);
		var NumProps = blob.read_shift(4);
		var Props = [], i = 0;
		var CodePage = 0;
		var Dictionary = -1, DictObj = ({});
		for(i = 0; i != NumProps; ++i) {
			var PropID = blob.read_shift(4);
			var Offset = blob.read_shift(4);
			Props[i] = [PropID, Offset + start_addr];
		}
		Props.sort(function(x,y) { return x[1] - y[1]; });
		var PropH = {};
		for(i = 0; i != NumProps; ++i) {
			if(blob.l !== Props[i][1]) {
				var fail = true;
				if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
					case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
					case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
					case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				}
				if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
				if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
			}
			if(PIDSI) {
				var piddsi = PIDSI[Props[i][0]];
				PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
				if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
				if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
					case 0: PropH[piddsi.n] = 1252;
						/* falls through */
					case 874:
					case 932:
					case 936:
					case 949:
					case 950:
					case 1250:
					case 1251:
					case 1253:
					case 1254:
					case 1255:
					case 1256:
					case 1257:
					case 1258:
					case 10000:
					case 1200:
					case 1201:
					case 1252:
					case 65000: case -536:
					case 65001: case -535:
						set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
					default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
				}
			} else {
				if(Props[i][0] === 0x1) {
					CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
					set_cp(CodePage);
					if(Dictionary !== -1) {
						var oldpos = blob.l;
						blob.l = Props[Dictionary][1];
						DictObj = parse_dictionary(blob,CodePage);
						blob.l = oldpos;
					}
				} else if(Props[i][0] === 0) {
					if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
					DictObj = parse_dictionary(blob,CodePage);
				} else {
					var name = DictObj[Props[i][0]];
					var val;
					/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
					switch(blob[blob.l]) {
						case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
						case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
						case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
						case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
						case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
						case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
						default: throw new Error("unparsed value: " + blob[blob.l]);
					}
					PropH[name] = val;
				}
			}
		}
		blob.l = start_addr + size; /* step ahead to skip padding */
		return PropH;
	}
	var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ]; //.concat(PseudoPropsPairs);
	function guess_property_type(val) {
		switch(typeof val) {
			case "boolean": return 0x0B;
			case "number": return ((val|0)==val) ? 0x03 : 0x05;
			case "string": return 0x1F;
			case "object": if(val instanceof Date) return 0x40; break;
		}
		return -1;
	}
	function write_PropertySet(entries, RE, PIDSI) {
		var hdr = new_buf(8), piao = [], prop = [];
		var sz = 8, i = 0;
	
		var pr = new_buf(8), pio = new_buf(8);
		pr.write_shift(4, 0x0002);
		pr.write_shift(4, 0x04B0);
		pio.write_shift(4, 0x0001);
		prop.push(pr); piao.push(pio);
		sz += 8 + pr.length;
	
		if(!RE) {
			pio = new_buf(8);
			pio.write_shift(4, 0);
			piao.unshift(pio);
	
			var bufs = [new_buf(4)];
			bufs[0].write_shift(4, entries.length);
			for(i = 0; i < entries.length; ++i) {
				var value = entries[i][0];
				pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				pr.write_shift(4, i+2);
				pr.write_shift(4, value.length + 1);
				pr.write_shift(0, value, "dbcs");
				while(pr.l != pr.length) pr.write_shift(1, 0);
				bufs.push(pr);
			}
			pr = bconcat(bufs);
			prop.unshift(pr);
			sz += 8 + pr.length;
		}
	
		for(i = 0; i < entries.length; ++i) {
			if(RE && !RE[entries[i][0]]) continue;
			if(XLSPSSkip.indexOf(entries[i][0]) > -1 || PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
			if(entries[i][1] == null) continue;
	
			var val = entries[i][1], idx = 0;
			if(RE) {
				idx = +RE[entries[i][0]];
				var pinfo = (PIDSI)[idx];
				if(pinfo.p == "version" && typeof val == "string") {
	var arr = val.split(".");
					val = ((+arr[0])<<16) + ((+arr[1])||0);
				}
				pr = write_TypedPropertyValue(pinfo.t, val);
			} else {
				var T = guess_property_type(val);
				if(T == -1) { T = 0x1F; val = String(val); }
				pr = write_TypedPropertyValue(T, val);
			}
			prop.push(pr);
	
			pio = new_buf(8);
			pio.write_shift(4, !RE ? 2+i : idx);
			piao.push(pio);
	
			sz += 8 + pr.length;
		}
	
		var w = 8 * (prop.length + 1);
		for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
		hdr.write_shift(4, sz);
		hdr.write_shift(4, prop.length);
		return bconcat([hdr].concat(piao).concat(prop));
	}
	
	/* [MS-OLEPS] 2.21 PropertySetStream */
	function parse_PropertySetStream(file, PIDSI, clsid) {
		var blob = file.content;
		if(!blob) return ({});
		prep_blob(blob, 0);
	
		var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
		blob.chk('feff', 'Byte Order: ');
	
		/*var vers = */blob.read_shift(2); // TODO: check version
		var SystemIdentifier = blob.read_shift(4);
		var CLSID = blob.read_shift(16);
		if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
		NumSets = blob.read_shift(4);
		if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
		FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);
	
		if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
		else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
		var PSet0 = parse_PropertySet(blob, PIDSI);
	
		var rval = ({ SystemIdentifier: SystemIdentifier });
		for(var y in PSet0) rval[y] = PSet0[y];
		//rval.blob = blob;
		rval.FMTID = FMTID0;
		//rval.PSet0 = PSet0;
		if(NumSets === 1) return rval;
		if(Offset1 - blob.l == 2) blob.l += 2;
		if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
		var PSet1;
		try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
		for(y in PSet1) rval[y] = PSet1[y];
		rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
		return rval;
	}
	function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
		var hdr = new_buf(entries2 ? 68 : 48);
		var bufs = [hdr];
		hdr.write_shift(2, 0xFFFE);
		hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
		hdr.write_shift(4, 0x32363237);
		hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
		hdr.write_shift(4, (entries2 ? 2 : 1));
		hdr.write_shift(16, clsid, "hex");
		hdr.write_shift(4, (entries2 ? 68 : 48));
		var ps0 = write_PropertySet(entries, RE, PIDSI);
		bufs.push(ps0);
	
		if(entries2) {
			var ps1 = write_PropertySet(entries2, null, null);
			hdr.write_shift(16, clsid2, "hex");
			hdr.write_shift(4, 68 + ps0.length);
			bufs.push(ps1);
		}
		return bconcat(bufs);
	}
	
	function parsenoop2(blob, length) { blob.read_shift(length); return null; }
	function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }
	
	function parslurp(blob, length, cb) {
		var arr = [], target = blob.l + length;
		while(blob.l < target) arr.push(cb(blob, target - blob.l));
		if(target !== blob.l) throw new Error("Slurp error");
		return arr;
	}
	
	function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
	function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }
	
	function parseuint16(blob) { return blob.read_shift(2, 'u'); }
	function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
	function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}
	
	/* --- 2.5 Structures --- */
	
	/* [MS-XLS] 2.5.10 Bes (boolean or error) */
	function parse_Bes(blob) {
		var v = blob.read_shift(1), t = blob.read_shift(1);
		return t === 0x01 ? v : v === 0x01;
	}
	function write_Bes(v, t, o) {
		if(!o) o = new_buf(2);
		o.write_shift(1, ((t == 'e') ? +v : +!!v));
		o.write_shift(1, ((t == 'e') ? 1 : 0));
		return o;
	}
	
	/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
	function parse_ShortXLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
		var encoding = 'sbcs-cont';
		var cp = current_codepage;
		if(opts && opts.biff >= 8) current_codepage = 1200;
		if(!opts || opts.biff == 8 ) {
			var fHighByte = blob.read_shift(1);
			if(fHighByte) { encoding = 'dbcs-cont'; }
		} else if(opts.biff == 12) {
			encoding = 'wstr';
		}
		if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
		var o = cch ? blob.read_shift(cch, encoding) : "";
		current_codepage = cp;
		return o;
	}
	
	/* 2.5.293 XLUnicodeRichExtendedString */
	function parse_XLUnicodeRichExtendedString(blob) {
		var cp = current_codepage;
		current_codepage = 1200;
		var cch = blob.read_shift(2), flags = blob.read_shift(1);
		var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
		var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
		var cRun = 0, cbExtRst;
		var z = {};
		if(fRichSt) cRun = blob.read_shift(2);
		if(fExtSt) cbExtRst = blob.read_shift(4);
		var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
		var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
		if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
		if(fExtSt) blob.l += cbExtRst; //TODO: parse this
		z.t = msg;
		if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
		current_codepage = cp;
		return z;
	}
	function write_XLUnicodeRichExtendedString(xlstr) {
		var str = (xlstr.t||""), nfmts = 1;
	
		var hdr = new_buf(3 + (nfmts > 1 ? 2 : 0));
		hdr.write_shift(2, str.length);
		hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
		if(nfmts > 1) hdr.write_shift(2, nfmts);
	
		var otext = new_buf(2 * str.length);
		otext.write_shift(2 * str.length, str, 'utf16le');
	
		var out = [hdr, otext];
	
		return bconcat(out);
	}
	
	/* 2.5.296 XLUnicodeStringNoCch */
	function parse_XLUnicodeStringNoCch(blob, cch, opts) {
		var retval;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
			if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
		}
		var fHighByte = blob.read_shift(1);
		if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
		else { retval = blob.read_shift(cch, 'dbcs-cont'); }
		return retval;
	}
	
	/* 2.5.294 XLUnicodeString */
	function parse_XLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		if(cch === 0) { blob.l++; return ""; }
		return parse_XLUnicodeStringNoCch(blob, cch, opts);
	}
	/* BIFF5 override */
	function parse_XLUnicodeString2(blob, length, opts) {
		if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
	}
	/* TODO: BIFF5 and lower, codepage awareness */
	function write_XLUnicodeString(str, opts, o) {
		if(!o) o = new_buf(3 + 2 * str.length);
		o.write_shift(2, str.length);
		o.write_shift(1, 1);
		o.write_shift(31, str, 'utf16le');
		return o;
	}
	
	/* [MS-XLS] 2.5.61 ControlInfo */
	function parse_ControlInfo(blob) {
		var flags = blob.read_shift(1);
		blob.l++;
		var accel = blob.read_shift(2);
		blob.l += 2;
		return [flags, accel];
	}
	
	/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
	function parse_URLMoniker(blob) {
		var len = blob.read_shift(4), start = blob.l;
		var extra = false;
		if(len > 24) {
			/* look ahead */
			blob.l += len - 24;
			if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
			blob.l = start;
		}
		var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
		if(extra) blob.l += 24;
		return url;
	}
	
	/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
	function parse_FileMoniker(blob) {
		var cAnti = blob.read_shift(2);
		var preamble = ""; while(cAnti-- > 0) preamble += "../";
		var ansiPath = blob.read_shift(0, 'lpstr-ansi');
		blob.l += 2; //var endServer = blob.read_shift(2);
		if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
		var sz = blob.read_shift(4);
		if(sz === 0) return preamble + ansiPath.replace(/\\/g,"/");
		var bytes = blob.read_shift(4);
		if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
		var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
		return preamble + unicodePath;
	}
	
	/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
	function parse_HyperlinkMoniker(blob, length) {
		var clsid = blob.read_shift(16); length -= 16;
		switch(clsid) {
			case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
			case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
			default: throw new Error("Unsupported Moniker " + clsid);
		}
	}
	
	/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
	function parse_HyperlinkString(blob) {
		var len = blob.read_shift(4);
		var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
		return o;
	}
	function write_HyperlinkString(str, o) {
		if(!o) o = new_buf(6 + str.length * 2);
		o.write_shift(4, 1 + str.length);
		for(var i = 0; i < str.length; ++i) o.write_shift(2, str.charCodeAt(i));
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
	function parse_Hyperlink(blob, length) {
		var end = blob.l + length;
		var sVer = blob.read_shift(4);
		if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
		var flags = blob.read_shift(2);
		blob.l += 2;
		var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
		if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
		if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0020) guid = blob.read_shift(16);
		if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
		blob.l = end;
		var target = targetFrameName||moniker||oleMoniker||"";
		if(target && Loc) target+="#"+Loc;
		if(!target) target = "#" + Loc;
		if((flags & 0x0002) && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
		var out = ({Target:target});
		if(guid) out.guid = guid;
		if(fileTime) out.time = fileTime;
		if(displayName) out.Tooltip = displayName;
		return out;
	}
	function write_Hyperlink(hl) {
		var out = new_buf(512), i = 0;
		var Target = hl.Target;
		if(Target.slice(0,7) == "file://") Target = Target.slice(7);
		var hashidx = Target.indexOf("#");
		var F = hashidx > -1 ? 0x1f : 0x17;
		switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
		out.write_shift(4,2); out.write_shift(4, F);
		var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
		if(F == 0x1C) {
			Target = Target.slice(1);
			write_HyperlinkString(Target, out);
		} else if(F & 0x02) {
			data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
			out.write_shift(4, 2*(Pretarget.length + 1));
			for(i = 0; i < Pretarget.length; ++i) out.write_shift(2, Pretarget.charCodeAt(i));
			out.write_shift(2, 0);
			if(F & 0x08) write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx+1): "", out);
		} else {
			data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var P = 0;
			while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
			out.write_shift(2, P);
			out.write_shift(4, Target.length - 3 * P + 1);
			for(i = 0; i < Target.length - 3 * P; ++i) out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
			out.write_shift(1, 0);
			out.write_shift(2, 0xFFFF);
			out.write_shift(2, 0xDEAD);
			for(i = 0; i < 6; ++i) out.write_shift(4, 0);
		}
		return out.slice(0, out.l);
	}
	
	/* 2.5.178 LongRGBA */
	function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }
	
	/* 2.5.177 LongRGB */
	function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }
	
	
	/* [MS-XLS] 2.5.19 */
	function parse_XLSCell(blob) {
		var rw = blob.read_shift(2); // 0-indexed
		var col = blob.read_shift(2);
		var ixfe = blob.read_shift(2);
		return ({r:rw, c:col, ixfe:ixfe});
	}
	function write_XLSCell(R, C, ixfe, o) {
		if(!o) o = new_buf(6);
		o.write_shift(2, R);
		o.write_shift(2, C);
		o.write_shift(2, ixfe||0);
		return o;
	}
	
	/* [MS-XLS] 2.5.134 */
	function parse_frtHeader(blob) {
		var rt = blob.read_shift(2);
		var flags = blob.read_shift(2); // TODO: parse these flags
		blob.l += 8;
		return {type: rt, flags: flags};
	}
	
	
	
	function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }
	
	/* [MS-XLS] 2.5.344 */
	function parse_XTI(blob, length, opts) {
		var w = opts.biff > 8 ? 4 : 2;
		var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
		return [iSupBook, itabFirst, itabLast];
	}
	
	/* [MS-XLS] 2.5.218 */
	function parse_RkRec(blob) {
		var ixfe = blob.read_shift(2);
		var RK = parse_RkNumber(blob);
		return [ixfe, RK];
	}
	
	/* [MS-XLS] 2.5.1 */
	function parse_AddinUdf(blob, length, opts) {
		blob.l += 4; length -= 4;
		var l = blob.l + length;
		var udfName = parse_ShortXLUnicodeString(blob, length, opts);
		var cb = blob.read_shift(2);
		l -= blob.l;
		if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
		blob.l += cb;
		return udfName;
	}
	
	/* [MS-XLS] 2.5.209 TODO: Check sizes */
	function parse_Ref8U(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(2);
		var colLast = blob.read_shift(2);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	function write_Ref8U(r, o) {
		if(!o) o = new_buf(8);
		o.write_shift(2, r.s.r);
		o.write_shift(2, r.e.r);
		o.write_shift(2, r.s.c);
		o.write_shift(2, r.e.c);
		return o;
	}
	
	/* [MS-XLS] 2.5.211 */
	function parse_RefU(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(1);
		var colLast = blob.read_shift(1);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	
	/* [MS-XLS] 2.5.207 */
	var parse_Ref = parse_RefU;
	
	/* [MS-XLS] 2.5.143 */
	function parse_FtCmo(blob) {
		blob.l += 4;
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var flags = blob.read_shift(2);
		blob.l+=12;
		return [id, ot, flags];
	}
	
	/* [MS-XLS] 2.5.149 */
	function parse_FtNts(blob) {
		var out = {};
		blob.l += 4;
		blob.l += 16; // GUID TODO
		out.fSharedNote = blob.read_shift(2);
		blob.l += 4;
		return out;
	}
	
	/* [MS-XLS] 2.5.142 */
	function parse_FtCf(blob) {
		var out = {};
		blob.l += 4;
		blob.cf = blob.read_shift(2);
		return out;
	}
	
	/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
	function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
	var FtTab = {
	0x00: parse_FtSkip,      /* FtEnd */
	0x04: parse_FtSkip,      /* FtMacro */
	0x05: parse_FtSkip,      /* FtButton */
	0x06: parse_FtSkip,      /* FtGmo */
	0x07: parse_FtCf,        /* FtCf */
	0x08: parse_FtSkip,      /* FtPioGrbit */
	0x09: parse_FtSkip,      /* FtPictFmla */
	0x0A: parse_FtSkip,      /* FtCbls */
	0x0B: parse_FtSkip,      /* FtRbo */
	0x0C: parse_FtSkip,      /* FtSbs */
	0x0D: parse_FtNts,       /* FtNts */
	0x0E: parse_FtSkip,      /* FtSbsFmla */
	0x0F: parse_FtSkip,      /* FtGboData */
	0x10: parse_FtSkip,      /* FtEdoData */
	0x11: parse_FtSkip,      /* FtRboData */
	0x12: parse_FtSkip,      /* FtCblsData */
	0x13: parse_FtSkip,      /* FtLbsData */
	0x14: parse_FtSkip,      /* FtCblsFmla */
	0x15: parse_FtCmo
	};
	function parse_FtArray(blob, length) {
		var tgt = blob.l + length;
		var fts = [];
		while(blob.l < tgt) {
			var ft = blob.read_shift(2);
			blob.l-=2;
			try {
				fts.push(FtTab[ft](blob, tgt - blob.l));
			} catch(e) { blob.l = tgt; return fts; }
		}
		if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
		return fts;
	}
	
	/* --- 2.4 Records --- */
	
	/* [MS-XLS] 2.4.21 */
	function parse_BOF(blob, length) {
		var o = {BIFFVer:0, dt:0};
		o.BIFFVer = blob.read_shift(2); length -= 2;
		if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
		switch(o.BIFFVer) {
			case 0x0600: /* BIFF8 */
			case 0x0500: /* BIFF5 */
			case 0x0400: /* BIFF4 */
			case 0x0300: /* BIFF3 */
			case 0x0200: /* BIFF2 */
			case 0x0002: case 0x0007: /* BIFF2 */
				break;
			default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
		}
	
		blob.read_shift(length);
		return o;
	}
	function write_BOF(wb, t, o) {
		var h = 0x0600, w = 16;
		switch(o.bookType) {
			case 'biff8': break;
			case 'biff5': h = 0x0500; w = 8; break;
			case 'biff4': h = 0x0004; w = 6; break;
			case 'biff3': h = 0x0003; w = 6; break;
			case 'biff2': h = 0x0002; w = 4; break;
			case 'xla': break;
			default: throw new Error("unsupported BIFF version");
		}
		var out = new_buf(w);
		out.write_shift(2, h);
		out.write_shift(2, t);
		if(w > 4) out.write_shift(2, 0x7262);
		if(w > 6) out.write_shift(2, 0x07CD);
		if(w > 8) {
			out.write_shift(2, 0xC009);
			out.write_shift(2, 0x0001);
			out.write_shift(2, 0x0706);
			out.write_shift(2, 0x0000);
		}
		return out;
	}
	
	
	/* [MS-XLS] 2.4.146 */
	function parse_InterfaceHdr(blob, length) {
		if(length === 0) return 0x04b0;
		if((blob.read_shift(2))!==0x04b0){/* empty */}
		return 0x04b0;
	}
	
	
	/* [MS-XLS] 2.4.349 */
	function parse_WriteAccess(blob, length, opts) {
		if(opts.enc) { blob.l += length; return ""; }
		var l = blob.l;
		// TODO: make sure XLUnicodeString doesnt overrun
		var UserName = parse_XLUnicodeString2(blob, 0, opts);
		blob.read_shift(length + l - blob.l);
		return UserName;
	}
	function write_WriteAccess(s, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(b8 ? 112 : 54);
		o.write_shift(opts.biff == 8 ? 2 : 1, 7);
		if(b8) o.write_shift(1, 0);
		o.write_shift(4, 0x33336853);
		o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
		while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
		return o;
	}
	
	/* [MS-XLS] 2.4.351 */
	function parse_WsBool(blob, length, opts) {
		var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
		return { fDialog: flags & 0x10, fBelow: flags & 0x40, fRight: flags & 0x80 };
	}
	
	/* [MS-XLS] 2.4.28 */
	function parse_BoundSheet8(blob, length, opts) {
		var pos = blob.read_shift(4);
		var hidden = blob.read_shift(1) & 0x03;
		var dt = blob.read_shift(1);
		switch(dt) {
			case 0: dt = 'Worksheet'; break;
			case 1: dt = 'Macrosheet'; break;
			case 2: dt = 'Chartsheet'; break;
			case 6: dt = 'VBAModule'; break;
		}
		var name = parse_ShortXLUnicodeString(blob, 0, opts);
		if(name.length === 0) name = "Sheet1";
		return { pos:pos, hs:hidden, dt:dt, name:name };
	}
	function write_BoundSheet8(data, opts) {
		var w = (!opts || opts.biff >= 8 ? 2 : 1);
		var o = new_buf(8 + w * data.name.length);
		o.write_shift(4, data.pos);
		o.write_shift(1, data.hs || 0);
		o.write_shift(1, data.dt);
		o.write_shift(1, data.name.length);
		if(opts.biff >= 8) o.write_shift(1, 1);
		o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
		var out = o.slice(0, o.l);
		out.l = o.l; return out;
	}
	
	/* [MS-XLS] 2.4.265 TODO */
	function parse_SST(blob, length) {
		var end = blob.l + length;
		var cnt = blob.read_shift(4);
		var ucnt = blob.read_shift(4);
		var strs = ([]);
		for(var i = 0; i != ucnt && blob.l < end; ++i) {
			strs.push(parse_XLUnicodeRichExtendedString(blob));
		}
		strs.Count = cnt; strs.Unique = ucnt;
		return strs;
	}
	function write_SST(sst, opts) {
		var header = new_buf(8);
		header.write_shift(4, sst.Count);
		header.write_shift(4, sst.Unique);
		var strs = [];
		for(var j = 0; j < sst.length; ++j) strs[j] = write_XLUnicodeRichExtendedString(sst[j], opts);
		var o = bconcat([header].concat(strs));
	o.parts = [header.length].concat(strs.map(function(str) { return str.length; }));
		return o;
	}
	
	/* [MS-XLS] 2.4.107 */
	function parse_ExtSST(blob, length) {
		var extsst = {};
		extsst.dsst = blob.read_shift(2);
		blob.l += length-2;
		return extsst;
	}
	
	
	/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
	function parse_Row(blob) {
		var z = ({});
		z.r = blob.read_shift(2);
		z.c = blob.read_shift(2);
		z.cnt = blob.read_shift(2) - z.c;
		var miyRw = blob.read_shift(2);
		blob.l += 4; // reserved(2), unused(2)
		var flags = blob.read_shift(1); // various flags
		blob.l += 3; // reserved(8), ixfe(12), flags(4)
		if(flags & 0x07) z.level = flags & 0x07;
		// collapsed: flags & 0x10
		if(flags & 0x20) z.hidden = true;
		if(flags & 0x40) z.hpt = miyRw / 20;
		return z;
	}
	
	
	/* [MS-XLS] 2.4.125 */
	function parse_ForceFullCalculation(blob) {
		var header = parse_frtHeader(blob);
		if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
		var fullcalc = blob.read_shift(4);
		return fullcalc !== 0x0;
	}
	
	
	
	
	
	/* [MS-XLS] 2.4.215 rt */
	function parse_RecalcId(blob) {
		blob.read_shift(2);
		return blob.read_shift(4);
	}
	
	/* [MS-XLS] 2.4.87 */
	function parse_DefaultRowHeight(blob, length, opts) {
		var f = 0;
		if(!(opts && opts.biff == 2)) {
			f = blob.read_shift(2);
		}
		var miyRw = blob.read_shift(2);
		if((opts && opts.biff == 2)) {
			f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
		}
		var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
		return [fl, miyRw];
	}
	
	/* [MS-XLS] 2.4.345 TODO */
	function parse_Window1(blob) {
		var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
		var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
		var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
		return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
			FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
	}
	function write_Window1() {
		var o = new_buf(18);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0x7260);
		o.write_shift(2, 0x44c0);
		o.write_shift(2, 0x38);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 1);
		o.write_shift(2, 0x01f4);
		return o;
	}
	/* [MS-XLS] 2.4.346 TODO */
	function parse_Window2(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff < 5) return {};
		var f = blob.read_shift(2);
		return { RTL: f & 0x40 };
	}
	function write_Window2(view) {
		var o = new_buf(18), f = 0x6b6;
		if(view && view.RTL) f |= 0x40;
		o.write_shift(2, f);
		o.write_shift(4, 0);
		o.write_shift(4, 64);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.189 TODO */
	function parse_Pane(/*blob, length, opts*/) {
	}
	
	/* [MS-XLS] 2.4.122 TODO */
	function parse_Font(blob, length, opts) {
		var o = {
			dyHeight: blob.read_shift(2),
			fl: blob.read_shift(2)
		};
		switch((opts && opts.biff) || 8) {
			case 2: break;
			case 3: case 4: blob.l += 2; break;
			default: blob.l += 10; break;
		}
		o.name = parse_ShortXLUnicodeString(blob, 0, opts);
		return o;
	}
	function write_Font(data, opts) {
		var name = data.name || "Arial";
		var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
		var o = new_buf(w);
		o.write_shift(2, (data.sz || 12) * 20);
		o.write_shift(4, 0);
		o.write_shift(2, 400);
		o.write_shift(4, 0);
		o.write_shift(2, 0);
		o.write_shift(1, name.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
		return o;
	}
	
	/* [MS-XLS] 2.4.149 */
	function parse_LabelSst(blob) {
		var cell = parse_XLSCell(blob);
		cell.isst = blob.read_shift(4);
		return cell;
	}
	function write_LabelSst(R, C, v, os ) {
		var o = new_buf(10);
		write_XLSCell(R, C, os, o);
		o.write_shift(4, v);
		return o;
	}
	
	/* [MS-XLS] 2.4.148 */
	function parse_Label(blob, length, opts) {
		if(opts.biffguess && opts.biff == 2) opts.biff = 5;
		var target = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) blob.l++;
		var str = parse_XLUnicodeString(blob, target - blob.l, opts);
		cell.val = str;
		return cell;
	}
	function write_Label(R, C, v, os, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
		write_XLSCell(R, C, os, o);
		o.write_shift(2, v.length);
		if(b8) o.write_shift(1, 1);
		o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
		return o;
	}
	
	
	/* [MS-XLS] 2.4.126 Number Formats */
	function parse_Format(blob, length, opts) {
		var numFmtId = blob.read_shift(2);
		var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
		return [numFmtId, fmtstr];
	}
	function write_Format(i, f, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
		o.write_shift(2, i);
		o.write_shift((b5 ? 1 : 2), f.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(out.l == null) out.l = out.length;
		return out;
	}
	var parse_BIFF2Format = parse_XLUnicodeString2;
	
	/* [MS-XLS] 2.4.90 */
	function parse_Dimensions(blob, length, opts) {
		var end = blob.l + length;
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var r = blob.read_shift(w), R = blob.read_shift(w);
		var c = blob.read_shift(2), C = blob.read_shift(2);
		blob.l = end;
		return {s: {r:r, c:c}, e: {r:R, c:C}};
	}
	function write_Dimensions(range, opts) {
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var o = new_buf(2*w + 6);
		o.write_shift(w, range.s.r);
		o.write_shift(w, range.e.r + 1);
		o.write_shift(2, range.s.c);
		o.write_shift(2, range.e.c + 1);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.220 */
	function parse_RK(blob) {
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrec = parse_RkRec(blob);
		return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
	}
	
	/* [MS-XLS] 2.4.175 */
	function parse_MulRk(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrecs = [];
		while(blob.l < target) rkrecs.push(parse_RkRec(blob));
		if(blob.l !== target) throw new Error("MulRK read error");
		var lastcol = blob.read_shift(2);
		if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
		return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
	}
	/* [MS-XLS] 2.4.174 */
	function parse_MulBlank(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var ixfes = [];
		while(blob.l < target) ixfes.push(blob.read_shift(2));
		if(blob.l !== target) throw new Error("MulBlank read error");
		var lastcol = blob.read_shift(2);
		if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
		return {r:rw, c:col, C:lastcol, ixfe:ixfes};
	}
	
	/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
	function parse_CellStyleXF(blob, length, style, opts) {
		var o = {};
		var a = blob.read_shift(4), b = blob.read_shift(4);
		var c = blob.read_shift(4), d = blob.read_shift(2);
		o.patternType = XLSFillPattern[c >> 26];
	
		if(!opts.cellStyles) return o;
		o.alc = a & 0x07;
		o.fWrap = (a >> 3) & 0x01;
		o.alcV = (a >> 4) & 0x07;
		o.fJustLast = (a >> 7) & 0x01;
		o.trot = (a >> 8) & 0xFF;
		o.cIndent = (a >> 16) & 0x0F;
		o.fShrinkToFit = (a >> 20) & 0x01;
		o.iReadOrder = (a >> 22) & 0x02;
		o.fAtrNum = (a >> 26) & 0x01;
		o.fAtrFnt = (a >> 27) & 0x01;
		o.fAtrAlc = (a >> 28) & 0x01;
		o.fAtrBdr = (a >> 29) & 0x01;
		o.fAtrPat = (a >> 30) & 0x01;
		o.fAtrProt = (a >> 31) & 0x01;
	
		o.dgLeft = b & 0x0F;
		o.dgRight = (b >> 4) & 0x0F;
		o.dgTop = (b >> 8) & 0x0F;
		o.dgBottom = (b >> 12) & 0x0F;
		o.icvLeft = (b >> 16) & 0x7F;
		o.icvRight = (b >> 23) & 0x7F;
		o.grbitDiag = (b >> 30) & 0x03;
	
		o.icvTop = c & 0x7F;
		o.icvBottom = (c >> 7) & 0x7F;
		o.icvDiag = (c >> 14) & 0x7F;
		o.dgDiag = (c >> 21) & 0x0F;
	
		o.icvFore = d & 0x7F;
		o.icvBack = (d >> 7) & 0x7F;
		o.fsxButton = (d >> 14) & 0x01;
		return o;
	}
	//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
	//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
	
	/* [MS-XLS] 2.4.353 TODO: actually do this right */
	function parse_XF(blob, length, opts) {
		var o = {};
		o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
		o.fStyle = (o.flags >> 2) & 0x01;
		length -= 6;
		o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
		return o;
	}
	function write_XF(data, ixfeP, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? 16 : 20);
		o.write_shift(2, 0);
		if(data.style) {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, 0xFFF4);
		} else {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, (ixfeP<<4));
		}
		var f = 0;
		if(data.numFmtId > 0 && b5) f |= 0x0400;
		o.write_shift(4, f);
		o.write_shift(4, 0);
		if(!b5) o.write_shift(4, 0);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.134 */
	function parse_Guts(blob) {
		blob.l += 4;
		var out = [blob.read_shift(2), blob.read_shift(2)];
		if(out[0] !== 0) out[0]--;
		if(out[1] !== 0) out[1]--;
		if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
		return out;
	}
	function write_Guts(guts) {
		var o = new_buf(8);
		o.write_shift(4, 0);
		o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
		o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.24 */
	function parse_BoolErr(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2 || length == 9) ++blob.l;
		var val = parse_Bes(blob, 2);
		cell.val = val;
		cell.t = (val === true || val === false) ? 'b' : 'e';
		return cell;
	}
	function write_BoolErr(R, C, v, os, opts, t) {
		var o = new_buf(8);
		write_XLSCell(R, C, os, o);
		write_Bes(v, t, o);
		return o;
	}
	
	/* [MS-XLS] 2.4.180 Number */
	function parse_Number(blob, length, opts) {
		if(opts.biffguess && opts.biff == 2) opts.biff = 5;
		var cell = parse_XLSCell(blob, 6);
		var xnum = parse_Xnum(blob, 8);
		cell.val = xnum;
		return cell;
	}
	function write_Number(R, C, v, os) {
		var o = new_buf(14);
		write_XLSCell(R, C, os, o);
		write_Xnum(v, o);
		return o;
	}
	
	var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136
	
	/* [MS-XLS] 2.4.271 */
	function parse_SupBook(blob, length, opts) {
		var end = blob.l + length;
		var ctab = blob.read_shift(2);
		var cch = blob.read_shift(2);
		opts.sbcch = cch;
		if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
		if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
		var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
		/* TODO: 2.5.277 Virtual Path */
		var rgst = [];
		while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
		return [cch, ctab, virtPath, rgst];
	}
	
	/* [MS-XLS] 2.4.105 TODO */
	function parse_ExternName(blob, length, opts) {
		var flags = blob.read_shift(2);
		var body;
		var o = ({
			fBuiltIn: flags & 0x01,
			fWantAdvise: (flags >>> 1) & 0x01,
			fWantPict: (flags >>> 2) & 0x01,
			fOle: (flags >>> 3) & 0x01,
			fOleLink: (flags >>> 4) & 0x01,
			cf: (flags >>> 5) & 0x3FF,
			fIcon: flags >>> 15 & 0x01
		});
		if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
		//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
		o.body = body || blob.read_shift(length-2);
		if(typeof body === "string") o.Name = body;
		return o;
	}
	
	/* [MS-XLS] 2.4.150 TODO */
	var XLSLblBuiltIn = [
		"_xlnm.Consolidate_Area",
		"_xlnm.Auto_Open",
		"_xlnm.Auto_Close",
		"_xlnm.Extract",
		"_xlnm.Database",
		"_xlnm.Criteria",
		"_xlnm.Print_Area",
		"_xlnm.Print_Titles",
		"_xlnm.Recorder",
		"_xlnm.Data_Form",
		"_xlnm.Auto_Activate",
		"_xlnm.Auto_Deactivate",
		"_xlnm.Sheet_Title",
		"_xlnm._FilterDatabase"
	];
	function parse_Lbl(blob, length, opts) {
		var target = blob.l + length;
		var flags = blob.read_shift(2);
		var chKey = blob.read_shift(1);
		var cch = blob.read_shift(1);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var itab = 0;
		if(!opts || opts.biff >= 5) {
			if(opts.biff != 5) blob.l += 2;
			itab = blob.read_shift(2);
			if(opts.biff == 5) blob.l += 2;
			blob.l += 4;
		}
		var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
		if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
		var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
		/*jshint -W018 */
		var rgce = (target == blob.l || cce === 0 || !(npflen > 0)) ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
		/*jshint +W018 */
		return {
			chKey: chKey,
			Name: name,
			itab: itab,
			rgce: rgce
		};
	}
	
	/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
	function parse_ExternSheet(blob, length, opts) {
		if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
		var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
		while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
			// [iSupBook, itabFirst, itabLast];
		if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
		return o;
	}
	function parse_BIFF5ExternSheet(blob, length, opts) {
		if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
		var o = parse_ShortXLUnicodeString(blob, length, opts);
		return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
	}
	
	/* [MS-XLS] 2.4.176 TODO: check older biff */
	function parse_NameCmt(blob, length, opts) {
		if(opts.biff < 8) { blob.l += length; return; }
		var cchName = blob.read_shift(2);
		var cchComment = blob.read_shift(2);
		var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
		var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
		return [name, comment];
	}
	
	/* [MS-XLS] 2.4.260 */
	function parse_ShrFmla(blob, length, opts) {
		var ref = parse_RefU(blob, 6);
		blob.l++;
		var cUse = blob.read_shift(1);
		length -= 8;
		return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
	}
	
	/* [MS-XLS] 2.4.4 TODO */
	function parse_Array(blob, length, opts) {
		var ref = parse_Ref(blob, 6);
		/* TODO: fAlwaysCalc */
		switch(opts.biff) {
			case 2: blob.l ++; length -= 7; break;
			case 3: case 4: blob.l += 2; length -= 8; break;
			default: blob.l += 6; length -= 12;
		}
		return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
	}
	
	/* [MS-XLS] 2.4.173 */
	function parse_MTRSettings(blob) {
		var fMTREnabled = blob.read_shift(4) !== 0x00;
		var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
		var cUserThreadCount = blob.read_shift(4);
		return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
	}
	
	/* [MS-XLS] 2.5.186 TODO: BIFF5 */
	function parse_NoteSh(blob, length, opts) {
		if(opts.biff < 8) return;
		var row = blob.read_shift(2), col = blob.read_shift(2);
		var flags = blob.read_shift(2), idObj = blob.read_shift(2);
		var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
		if(opts.biff < 8) blob.read_shift(1);
		return [{r:row,c:col}, stAuthor, idObj, flags];
	}
	
	/* [MS-XLS] 2.4.179 */
	function parse_Note(blob, length, opts) {
		/* TODO: Support revisions */
		return parse_NoteSh(blob, length, opts);
	}
	
	/* [MS-XLS] 2.4.168 */
	function parse_MergeCells(blob, length) {
		var merges = [];
		var cmcs = blob.read_shift(2);
		while (cmcs--) merges.push(parse_Ref8U(blob,length));
		return merges;
	}
	function write_MergeCells(merges) {
		var o = new_buf(2 + merges.length * 8);
		o.write_shift(2, merges.length);
		for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
		return o;
	}
	
	/* [MS-XLS] 2.4.181 TODO: parse all the things! */
	function parse_Obj(blob, length, opts) {
		if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
		var cmo = parse_FtCmo(blob, 22); // id, ot, flags
		var fts = parse_FtArray(blob, length-22, cmo[1]);
		return { cmo: cmo, ft:fts };
	}
	/* from older spec */
	var parse_BIFF5OT = {
	0x08: function(blob, length) {
		var tgt = blob.l + length;
		blob.l += 10; // todo
		var cf = blob.read_shift(2);
		blob.l += 4;
		blob.l += 2; //var cbPictFmla = blob.read_shift(2);
		blob.l += 2;
		blob.l += 2; //var grbit = blob.read_shift(2);
		blob.l += 4;
		var cchName = blob.read_shift(1);
		blob.l += cchName; // TODO: stName
		blob.l = tgt; // TODO: fmla
		return { fmt:cf };
	}
	};
	
	function parse_BIFF5Obj(blob, length, opts) {
		blob.l += 4; //var cnt = blob.read_shift(4);
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var grbit = blob.read_shift(2);
		blob.l += 2; //var colL = blob.read_shift(2);
		blob.l += 2; //var dxL = blob.read_shift(2);
		blob.l += 2; //var rwT = blob.read_shift(2);
		blob.l += 2; //var dyT = blob.read_shift(2);
		blob.l += 2; //var colR = blob.read_shift(2);
		blob.l += 2; //var dxR = blob.read_shift(2);
		blob.l += 2; //var rwB = blob.read_shift(2);
		blob.l += 2; //var dyB = blob.read_shift(2);
		blob.l += 2; //var cbMacro = blob.read_shift(2);
		blob.l += 6;
		length -= 36;
		var fts = [];
		fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
		return { cmo: [id, ot, grbit], ft:fts };
	}
	
	/* [MS-XLS] 2.4.329 TODO: parse properly */
	function parse_TxO(blob, length, opts) {
		var s = blob.l;
		var texts = "";
	try {
		blob.l += 4;
		var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
		var controlInfo; // eslint-disable-line no-unused-vars
		if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
		else controlInfo = parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
		var cchText = blob.read_shift(2);
		/*var cbRuns = */blob.read_shift(2);
		/*var ifntEmpty = */parseuint16(blob, 2);
		var len = blob.read_shift(2);
		blob.l += len;
		//var fmla = parse_ObjFmla(blob, s + length - blob.l);
	
		for(var i = 1; i < blob.lens.length-1; ++i) {
			if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
			var hdr = blob[blob.l];
			var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
			texts += t;
			if(texts.length >= (hdr ? cchText : 2*cchText)) break;
		}
		if(texts.length !== cchText && texts.length !== cchText*2) {
			throw new Error("cchText: " + cchText + " != " + texts.length);
		}
	
		blob.l = s + length;
		/* [MS-XLS] 2.5.272 TxORuns */
	//	var rgTxoRuns = [];
	//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
	//	var cchText2 = blob.read_shift(2);
	//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
	//	blob.l += 6;
	//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
		return { t: texts };
	} catch(e) { blob.l = s + length; return { t: texts }; }
	}
	
	/* [MS-XLS] 2.4.140 */
	function parse_HLink(blob, length) {
		var ref = parse_Ref8U(blob, 8);
		blob.l += 16; /* CLSID */
		var hlink = parse_Hyperlink(blob, length-24);
		return [ref, hlink];
	}
	function write_HLink(hl) {
		var O = new_buf(24);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
		return bconcat([O, write_Hyperlink(hl[1])]);
	}
	
	
	/* [MS-XLS] 2.4.141 */
	function parse_HLinkTooltip(blob, length) {
		blob.read_shift(2);
		var ref = parse_Ref8U(blob, 8);
		var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
		wzTooltip = wzTooltip.replace(chr0,"");
		return [ref, wzTooltip];
	}
	function write_HLinkTooltip(hl) {
		var TT = hl[1].Tooltip;
		var O = new_buf(10 + 2 * (TT.length + 1));
		O.write_shift(2, 0x0800);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
		O.write_shift(2, 0);
		return O;
	}
	
	/* [MS-XLS] 2.4.63 */
	function parse_Country(blob) {
		var o = [0,0], d;
		d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
		d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
		return o;
	}
	function write_Country(o) {
		if(!o) o = new_buf(4);
		o.write_shift(2, 0x01);
		o.write_shift(2, 0x01);
		return o;
	}
	
	/* [MS-XLS] 2.4.50 ClrtClient */
	function parse_ClrtClient(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.188 */
	function parse_Palette(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.354 */
	function parse_XFCRC(blob) {
		blob.l += 2;
		var o = {cxfs:0, crc:0};
		o.cxfs = blob.read_shift(2);
		o.crc = blob.read_shift(4);
		return o;
	}
	
	/* [MS-XLS] 2.4.53 TODO: parse flags */
	/* [MS-XLSB] 2.4.323 TODO: parse flags */
	function parse_ColInfo(blob, length, opts) {
		if(!opts.cellStyles) return parsenoop(blob, length);
		var w = opts && opts.biff >= 12 ? 4 : 2;
		var colFirst = blob.read_shift(w);
		var colLast = blob.read_shift(w);
		var coldx = blob.read_shift(w);
		var ixfe = blob.read_shift(w);
		var flags = blob.read_shift(2);
		if(w == 2) blob.l += 2;
		var o = ({s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags});
		if(opts.biff >= 5 || !opts.biff) o.level = (flags >> 8) & 0x7;
		return o;
	}
	function write_ColInfo(col, idx) {
		var o = new_buf(12);
		o.write_shift(2, idx);
		o.write_shift(2, idx);
		o.write_shift(2, col.width * 256);
		o.write_shift(2, 0);
		var f = 0;
		if(col.hidden) f |= 1;
		o.write_shift(1, f);
		f = col.level || 0;
		o.write_shift(1, f);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.257 */
	function parse_Setup(blob, length) {
		var o = {};
		if(length < 32) return o;
		blob.l += 16;
		o.header = parse_Xnum(blob, 8);
		o.footer = parse_Xnum(blob, 8);
		blob.l += 2;
		return o;
	}
	
	/* [MS-XLS] 2.4.261 */
	function parse_ShtProps(blob, length, opts) {
		var def = {area:false};
		if(opts.biff != 5) { blob.l += length; return def; }
		var d = blob.read_shift(1); blob.l += 3;
		if((d & 0x10)) def.area = true;
		return def;
	}
	
	/* [MS-XLS] 2.4.241 */
	function write_RRTabId(n) {
		var out = new_buf(2 * n);
		for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
		return out;
	}
	
	var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
	var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
	var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */
	
	/* --- Specific to versions before BIFF8 --- */
	function parse_ImData(blob) {
		var cf = blob.read_shift(2);
		var env = blob.read_shift(2);
		var lcb = blob.read_shift(4);
		var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
		blob.l += lcb;
		return o;
	}
	
	/* BIFF2_??? where ??? is the name from [XLS] */
	function parse_BIFF2STR(blob, length, opts) {
		if(opts.biffguess && opts.biff == 5) opts.biff = 2;
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var str = parse_XLUnicodeString2(blob, length-7, opts);
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	
	function parse_BIFF2NUM(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = parse_Xnum(blob, 8);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2NUM(r, c, val) {
		var out = new_buf(15);
		write_BIFF2Cell(out, r, c);
		out.write_shift(8, val, 'f');
		return out;
	}
	
	function parse_BIFF2INT(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = blob.read_shift(2);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2INT(r, c, val) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		out.write_shift(2, val);
		return out;
	}
	
	function parse_BIFF2STRING(blob) {
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, 'sbcs-cont');
	}
	
	/* TODO: convert to BIFF8 font struct */
	function parse_BIFF2FONTXTRA(blob, length) {
		blob.l += 6; // unknown
		blob.l += 2; // font weight "bls"
		blob.l += 1; // charset
		blob.l += 3; // unknown
		blob.l += 1; // font family
		blob.l += length - 13;
	}
	
	/* TODO: parse rich text runs */
	function parse_RString(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		var cch = blob.read_shift(2);
		var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
		blob.l = end;
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	/* from js-harb (C) 2014-present  SheetJS */
	var DBF_SUPPORTED_VERSIONS = [0x02, 0x03, 0x30, 0x31, 0x83, 0x8B, 0x8C, 0xF5];
	var DBF = (function() {
	var dbf_codepage_map = {
		/* Code Pages Supported by Visual FoxPro */
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	
		/* shapefile DBF extension */
	0x00: 20127,           0x08:   865,
	0x09:   437,           0x0A:   850,
	0x0B:   437,           0x0D:   437,
	0x0E:   850,           0x0F:   437,
	0x10:   850,           0x11:   437,
	0x12:   850,           0x13:   932,
	0x14:   850,           0x15:   437,
	0x16:   850,           0x17:   865,
	0x18:   437,           0x19:   437,
	0x1A:   850,           0x1B:   437,
	0x1C:   863,           0x1D:   850,
	0x1F:   852,           0x22:   852,
	0x23:   852,           0x24:   860,
	0x25:   850,           0x26:   866,
	0x37:   850,           0x40:   852,
	0x4D:   936,           0x4E:   949,
	0x4F:   950,           0x50:   874,
	0x57:  1252,           0x58:  1252,
	0x59:  1252,           0x6C:   863,
	0x86:   737,           0x87:   852,
	0x88:   857,           0xCC:  1257,
	
	0xFF: 16969
	};
	var dbf_reverse_map = evert({
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	0x00: 20127
	});
	/* TODO: find an actual specification */
	function dbf_to_aoa(buf, opts) {
		var out = [];
		var d = (new_raw_buf(1));
		switch(opts.type) {
			case 'base64': d = s2a(Base64_decode(buf)); break;
			case 'binary': d = s2a(buf); break;
			case 'buffer':
			case 'array': d = buf; break;
		}
		prep_blob(d, 0);
	
		/* header */
		var ft = d.read_shift(1);
		var memo = !!(ft & 0x88);
		var vfp = false, l7 = false;
		switch(ft) {
			case 0x02: break; // dBASE II
			case 0x03: break; // dBASE III
			case 0x30: vfp = true; memo = true; break; // VFP
			case 0x31: vfp = true; memo = true; break; // VFP with autoincrement
			// 0x43 dBASE IV SQL table files
			// 0x63 dBASE IV SQL system files
			case 0x83: break; // dBASE III with memo
			case 0x8B: break; // dBASE IV with memo
			case 0x8C: l7 = true; break; // dBASE Level 7 with memo
			// case 0xCB dBASE IV SQL table files with memo
			case 0xF5: break; // FoxPro 2.x with memo
			// case 0xFB FoxBASE
			default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
		}
	
		var nrow = 0, fpos = 0x0209;
		if(ft == 0x02) nrow = d.read_shift(2);
		d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
		if(ft != 0x02) nrow = d.read_shift(4);
		if(nrow > 1048576) nrow = 1e6;
	
		if(ft != 0x02) fpos = d.read_shift(2); // header length
		var rlen = d.read_shift(2); // record length
	
		var /*flags = 0,*/ current_cp = opts.codepage || 1252;
		if(ft != 0x02) { // 20 reserved bytes
			d.l+=16;
			/*flags = */d.read_shift(1);
			//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
	
			/* codepage present in FoxPro and dBASE Level 7 */
			if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
			d.l+=1;
	
			d.l+=2;
		}
		if(l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
	
	var fields = [], field = ({});
		var hend = Math.min(d.length, (ft == 0x02 ? 0x209 : (fpos - 10 - (vfp ? 264 : 0))));
		var ww = l7 ? 32 : 11;
		while(d.l < hend && d[d.l] != 0x0d) {
			field = ({});
			field.name = $cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
			d.l += ww;
			field.type = String.fromCharCode(d.read_shift(1));
			if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
			field.len = d.read_shift(1);
			if(ft == 0x02) field.offset = d.read_shift(2);
			field.dec = d.read_shift(1);
			if(field.name.length) fields.push(field);
			if(ft != 0x02) d.l += l7 ? 13 : 14;
			switch(field.type) {
				case 'B': // Double (VFP) / Binary (dBASE L7)
					if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case 'G': // General (FoxPro and dBASE L7)
				case 'P': // Picture (FoxPro and dBASE L7)
					if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case '+': // Autoincrement (dBASE L7 only)
				case '0': // _NullFlags (VFP only)
				case '@': // Timestamp (dBASE L7 only)
				case 'C': // Character (dBASE II)
				case 'D': // Date (dBASE III)
				case 'F': // Float (dBASE IV)
				case 'I': // Long (VFP and dBASE L7)
				case 'L': // Logical (dBASE II)
				case 'M': // Memo (dBASE III)
				case 'N': // Number (dBASE II)
				case 'O': // Double (dBASE L7 only)
				case 'T': // Datetime (VFP only)
				case 'Y': // Currency (VFP only)
					break;
				default: throw new Error('Unknown Field Type: ' + field.type);
			}
		}
	
		if(d[d.l] !== 0x0D) d.l = fpos-1;
		if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
		d.l = fpos;
	
		/* data */
		var R = 0, C = 0;
		out[0] = [];
		for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
		while(nrow-- > 0) {
			if(d[d.l] === 0x2A) {
				// TODO: record marked as deleted -- create a hidden row?
				d.l+=rlen;
				continue;
			}
			++d.l;
			out[++R] = []; C = 0;
			for(C = 0; C != fields.length; ++C) {
				var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
				prep_blob(dd, 0);
				var s = $cptable.utils.decode(current_cp, dd);
				switch(fields[C].type) {
					case 'C':
						// NOTE: it is conventional to write '  /  /  ' for empty dates
						if(s.trim().length) out[R][C] = s.replace(/\s+$/,"");
						break;
					case 'D':
						if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
						else out[R][C] = s;
						break;
					case 'F': out[R][C] = parseFloat(s.trim()); break;
					case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
					case 'L': switch(s.trim().toUpperCase()) {
						case 'Y': case 'T': out[R][C] = true; break;
						case 'N': case 'F': out[R][C] = false; break;
						case '': case '?': break;
						default: throw new Error("DBF Unrecognized L:|" + s + "|");
						} break;
					case 'M': /* TODO: handle memo files */
						if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
						out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
						break;
					case 'N':
						s = s.replace(/\u0000/g,"").trim();
						// NOTE: dBASE II interprets "  .  " as 0
						if(s && s != ".") out[R][C] = +s || 0; break;
					case '@':
						// NOTE: dBASE specs appear to be incorrect
						out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
						break;
					case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
					case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4 + (dd.read_shift(4, 'i')/1e4)*Math.pow(2,32); break;
					case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
					case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
						/* falls through */
					case 'G': case 'P': dd.l += fields[C].len; break;
					case '0':
						if(fields[C].name === '_NullFlags') break;
						/* falls through */
					default: throw new Error("DBF Unsupported data type " + fields[C].type);
				}
			}
		}
		if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
		if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
		opts.DBF = fields;
		return out;
	}
	
	function dbf_to_sheet(buf, opts) {
		var o = opts || {};
		if(!o.dateNF) o.dateNF = "yyyymmdd";
		var ws = aoa_to_sheet(dbf_to_aoa(buf, o), o);
		ws["!cols"] = o.DBF.map(function(field) { return {
			wch: field.len,
			DBF: field
		};});
		delete o.DBF;
		return ws;
	}
	
	function dbf_to_workbook(buf, opts) {
		try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
		catch(e) { if(opts && opts.WTF) throw e; }
		return ({SheetNames:[],Sheets:{}});
	}
	
	var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
	function sheet_to_dbf(ws, opts) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write DBF to JS string");
		var ba = buf_array();
		var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
		var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
		var i = 0, j = 0, hcnt = 0, rlen = 1;
		for(i = 0; i < headers.length; ++i) {
			if(((cols[i]||{}).DBF||{}).name) { headers[i] = cols[i].DBF.name; ++hcnt; continue; }
			if(headers[i] == null) continue;
			++hcnt;
			if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
			if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
			if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
				if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
		}
		var range = safe_decode_range(ws['!ref']);
		var coltypes = [];
		var colwidths = [];
		var coldecimals = [];
		for(i = 0; i <= range.e.c - range.s.c; ++i) {
			var guess = '', _guess = '', maxlen = 0;
			var col = [];
			for(j=0; j < data.length; ++j) {
				if(data[j][i] != null) col.push(data[j][i]);
			}
			if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
			for(j = 0; j < col.length; ++j) {
				switch(typeof col[j]) {
					/* TODO: check if L2 compat is desired */
					case 'number': _guess = 'B'; break;
					case 'string': _guess = 'C'; break;
					case 'boolean': _guess = 'L'; break;
					case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
					default: _guess = 'C';
				}
				maxlen = Math.max(maxlen, String(col[j]).length);
				guess = guess && guess != _guess ? 'C' : _guess;
				//if(guess == 'C') break;
			}
			if(maxlen > 250) maxlen = 250;
			_guess = ((cols[i]||{}).DBF||{}).type;
			/* TODO: more fine grained control over DBF type resolution */
			if(_guess == 'C') {
				if(cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
			}
			if(guess == 'B' && _guess == 'N') {
				guess = 'N';
				coldecimals[i] = cols[i].DBF.dec;
				maxlen = cols[i].DBF.len;
			}
			colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : (_RLEN[guess] || 0);
			rlen += colwidths[i];
			coltypes[i] = guess;
		}
	
		var h = ba.next(32);
		h.write_shift(4, 0x13021130);
		h.write_shift(4, data.length);
		h.write_shift(2, 296 + 32 * hcnt);
		h.write_shift(2, rlen);
		for(i=0; i < 4; ++i) h.write_shift(4, 0);
		h.write_shift(4, 0x00000000 | ((+dbf_reverse_map[current_ansi] || 0x03)<<8));
	
		for(i = 0, j = 0; i < headers.length; ++i) {
			if(headers[i] == null) continue;
			var hf = ba.next(32);
			var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
			hf.write_shift(1, _f, "sbcs");
			hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
			hf.write_shift(4, j);
			hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
			hf.write_shift(1, coldecimals[i] || 0);
			hf.write_shift(1, 0x02);
			hf.write_shift(4, 0);
			hf.write_shift(1, 0);
			hf.write_shift(4, 0);
			hf.write_shift(4, 0);
			j += (colwidths[i] || _RLEN[coltypes[i]] || 0);
		}
	
		var hb = ba.next(264);
		hb.write_shift(4, 0x0000000D);
		for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
		for(i=0; i < data.length; ++i) {
			var rout = ba.next(rlen);
			rout.write_shift(1, 0);
			for(j=0; j<headers.length; ++j) {
				if(headers[j] == null) continue;
				switch(coltypes[j]) {
					case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
					case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
					case 'N':
						var _n = "0";
						if(typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j]||0);
						for(hcnt=0; hcnt < colwidths[j]-_n.length; ++hcnt) rout.write_shift(1, 0x20);
						rout.write_shift(1, _n, "sbcs");
						break;
					case 'D':
						if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
						else {
							rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
							rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
							rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
						} break;
					case 'C':
						var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
						rout.write_shift(1, _s, "sbcs");
						for(hcnt=0; hcnt < colwidths[j]-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
				}
			}
			// data
		}
		ba.next(1).write_shift(1, 0x1A);
		return ba.end();
	}
		return {
			to_workbook: dbf_to_workbook,
			to_sheet: dbf_to_sheet,
			from_sheet: sheet_to_dbf
		};
	})();
	
	var SYLK = (function() {
		/* TODO: stress test sequences */
		var sylk_escapes = ({
			AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
			AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
			AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
			AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
			AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
			Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
			Ae:'è', Be:'é', Ce:'ê',         He:'ë',
			Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
			Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
			Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
			KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
			DN:209, Dn:241, Hy:255,
			S:169,  c:170,  R:174,  "B ":180,
	0:176,    1:177,  2:178,
	3:179,    5:181,  6:182,
	7:183,    Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
			"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
			"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
		});
		var sylk_char_regex = new RegExp("\u001BN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
		var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
		var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
		sylk_escapes["|"] = 254;
		/* TODO: find an actual specification */
		function sylk_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return sylk_to_aoa_str(Base64_decode(d), opts);
				case 'binary': return sylk_to_aoa_str(d, opts);
				case 'buffer': return sylk_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array': return sylk_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function sylk_to_aoa_str(str, opts) {
			var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
			var formats = [];
			var next_cell_format = null;
			var sht = {}, rowinfo = [], colinfo = [], cw = [];
			var Mval = 0, j;
			if(+opts.codepage >= 0) set_cp(+opts.codepage);
			for (; ri !== records.length; ++ri) {
				Mval = 0;
				var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
				var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
				var RT=record[0], val;
				if(rstr.length > 0) switch(RT) {
				case 'ID': break; /* header */
				case 'E': break; /* EOF */
				case 'B': break; /* dimensions */
				case 'O': break; /* options? */
				case 'W': break; /* window? */
				case 'P':
					if(record[1].charAt(0) == 'P')
						formats.push(rstr.slice(3).replace(/;;/g, ";"));
					break;
				case 'C':
				var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'A': break; // TODO: comment
					case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'K':
						val = record[rj].slice(1);
						if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
						else if(val === 'TRUE') val = true;
						else if(val === 'FALSE') val = false;
						else if(!isNaN(fuzzynum(val))) {
							val = fuzzynum(val);
							if(next_cell_format !== null && fmt_is_date(next_cell_format)) val = numdate(val);
						} else if(!isNaN(fuzzydate(val).getDate())) {
							val = parseDate(val);
						}
						if(typeof $cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = $cptable.utils.decode(opts.codepage, val);
						C_seen_K = true;
						break;
					case 'E':
						C_seen_E = true;
						var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
						arr[R][C] = [arr[R][C], formula];
						break;
					case 'S':
						C_seen_S = true;
						arr[R][C] = [arr[R][C], "S5S"];
						break;
					case 'G': break; // unknown
					case 'R': _R = parseInt(record[rj].slice(1))-1; break;
					case 'C': _C = parseInt(record[rj].slice(1))-1; break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(C_seen_K) {
					if(arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
					else arr[R][C] = val;
					next_cell_format = null;
				}
				if(C_seen_S) {
					if(C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
					var shrbase = _R > -1 && arr[_R][_C];
					if(!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
					arr[R][C][1] = shift_formula_str(shrbase[1], {r: R - _R, c: C - _C});
				}
				break;
				case 'F':
				var F_seen = 0;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
					case 'F': break; /* ??? */
					case 'G': break; /* hide grid */
					case 'P':
						next_cell_format = formats[parseInt(record[rj].slice(1))];
						break;
					case 'S': break; /* cell style */
					case 'D': break; /* column */
					case 'N': break; /* font */
					case 'W':
						cw = record[rj].slice(1).split(" ");
						for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
							Mval = parseInt(cw[2], 10);
							colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
						} break;
					case 'C': /* default column format */
						C = parseInt(record[rj].slice(1))-1;
						if(!colinfo[C]) colinfo[C] = {};
						break;
					case 'R': /* row properties */
						R = parseInt(record[rj].slice(1))-1;
						if(!rowinfo[R]) rowinfo[R] = {};
						if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
						else if(Mval === 0) rowinfo[R].hidden = true;
						break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(F_seen < 1) next_cell_format = null; break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
			}
			if(rowinfo.length > 0) sht['!rows'] = rowinfo;
			if(colinfo.length > 0) sht['!cols'] = colinfo;
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return [arr, sht];
		}
	
		function sylk_to_sheet(d, opts) {
			var aoasht = sylk_to_aoa(d, opts);
			var aoa = aoasht[0], ws = aoasht[1];
			var o = aoa_to_sheet(aoa, opts);
			keys(ws).forEach(function(k) { o[k] = ws[k]; });
			return o;
		}
	
		function sylk_to_workbook(d, opts) { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }
	
		function write_ws_cell_sylk(cell, ws, R, C) {
			var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
			switch(cell.t) {
				case 'n':
					o += (cell.v||0);
					if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
				case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
				case 'e': o += cell.w || cell.v; break;
				case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
				case 's': o += '"' + cell.v.replace(/"/g,"").replace(/;/g, ";;") + '"'; break;
			}
			return o;
		}
	
		function write_ws_cols_sylk(out, cols) {
			cols.forEach(function(col, i) {
				var rec = "F;W" + (i+1) + " " + (i+1) + " ";
				if(col.hidden) rec += "0";
				else {
					if(typeof col.width == 'number' && !col.wpx) col.wpx = width2px(col.width);
					if(typeof col.wpx == 'number' && !col.wch) col.wch = px2char(col.wpx);
					if(typeof col.wch == 'number') rec += Math.round(col.wch);
				}
				if(rec.charAt(rec.length - 1) != " ") out.push(rec);
			});
		}
	
		function write_ws_rows_sylk(out, rows) {
			rows.forEach(function(row, i) {
				var rec = "F;";
				if(row.hidden) rec += "M0;";
				else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
				else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
				if(rec.length > 2) out.push(rec + "R" + (i+1));
			});
		}
	
		function sheet_to_sylk(ws, opts) {
			var preamble = ["ID;PWXL;N;E"], o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			var RS = "\r\n";
	
			preamble.push("P;PGeneral");
			preamble.push("F;P0;DG0G8;M255");
			if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
			if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
	
			preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
					o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
				}
			}
			return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
		}
	
		return {
			to_workbook: sylk_to_workbook,
			to_sheet: sylk_to_sheet,
			from_sheet: sheet_to_sylk
		};
	})();
	
	var DIF = (function() {
		function dif_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return dif_to_aoa_str(Base64_decode(d), opts);
				case 'binary': return dif_to_aoa_str(d, opts);
				case 'buffer': return dif_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array': return dif_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function dif_to_aoa_str(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
				if (R < 0) continue;
				var metadata = records[ri].trim().split(",");
				var type = metadata[0], value = metadata[1];
				++ri;
				var data = records[ri] || "";
				while(((data.match(/["]/g)||[]).length & 1) && ri < records.length - 1) data += "\n" + records[++ri];
				data = data.trim();
				switch (+type) {
					case -1:
						if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
						else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
						break;
					case 0:
						if(data === 'TRUE') arr[R][C] = true;
						else if(data === 'FALSE') arr[R][C] = false;
						else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
						else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
						else arr[R][C] = value;
						++C; break;
					case 1:
						data = data.slice(1,data.length-1);
						data = data.replace(/""/g, '"');
						if(DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
						arr[R][C++] = data !== '' ? data : null;
						break;
				}
				if (data === 'EOD') break;
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
		function dif_to_workbook(str, opts) { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }
	
		var sheet_to_dif = (function() {
			var push_field = function pf(o, topic, v, n, s) {
				o.push(topic);
				o.push(v + "," + n);
				o.push('"' + s.replace(/"/g,'""') + '"');
			};
			var push_value = function po(o, type, v, s) {
				o.push(type + "," + v);
				o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
			};
			return function sheet_to_dif(ws) {
				var o = [];
				var r = safe_decode_range(ws['!ref']), cell;
				var dense = Array.isArray(ws);
				push_field(o, "TABLE", 0, 1, "sheetjs");
				push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
				push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
				push_field(o, "DATA", 0, 0,"");
				for(var R = r.s.r; R <= r.e.r; ++R) {
					push_value(o, -1, 0, "BOT");
					for(var C = r.s.c; C <= r.e.c; ++C) {
						var coord = encode_cell({r:R,c:C});
						cell = dense ? (ws[R]||[])[C] : ws[coord];
						if(!cell) { push_value(o, 1, 0, ""); continue;}
						switch(cell.t) {
							case 'n':
								var val = DIF_XL ? cell.w : cell.v;
								if(!val && cell.v != null) val = cell.v;
								if(val == null) {
									if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
									else push_value(o, 1, 0, "");
								}
								else push_value(o, 0, val, "V");
								break;
							case 'b':
								push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
								break;
							case 's':
								push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
								break;
							case 'd':
								if(!cell.w) cell.w = SSF_format(cell.z || table_fmt[14], datenum(parseDate(cell.v)));
								if(DIF_XL) push_value(o, 0, cell.w, "V");
								else push_value(o, 1, 0, cell.w);
								break;
							default: push_value(o, 1, 0, "");
						}
					}
				}
				push_value(o, -1, 0, "EOD");
				var RS = "\r\n";
				var oo = o.join(RS);
				//while((oo.length & 0x7F) != 0) oo += "\0";
				return oo;
			};
		})();
		return {
			to_workbook: dif_to_workbook,
			to_sheet: dif_to_sheet,
			from_sheet: sheet_to_dif
		};
	})();
	
	var ETH = (function() {
		function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
		function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }
	
		function eth_to_aoa(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				var record = records[ri].trim().split(":");
				if(record[0] !== 'cell') continue;
				var addr = decode_cell(record[1]);
				if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
				R = addr.r; C = addr.c;
				switch(record[2]) {
					case 't': arr[R][C] = decode(record[3]); break;
					case 'v': arr[R][C] = +record[3]; break;
					case 'vtf': var _f = record[record.length - 1];
						/* falls through */
					case 'vtc':
						switch(record[3]) {
							case 'nl': arr[R][C] = +record[4] ? true : false; break;
							default: arr[R][C] = +record[4]; break;
						}
						if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
				}
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
		function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }
	
		var header = [
			"socialcalc:version:1.5",
			"MIME-Version: 1.0",
			"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
		].join("\n");
	
		var sep = [
			"--SocialCalcSpreadsheetControlSave",
			"Content-type: text/plain; charset=UTF-8"
		].join("\n") + "\n";
	
		/* TODO: the other parts */
		var meta = [
			"# SocialCalc Spreadsheet Control Save",
			"part:sheet"
		].join("\n");
	
		var end = "--SocialCalcSpreadsheetControlSave--";
	
		function sheet_to_eth_data(ws) {
			if(!ws || !ws['!ref']) return "";
			var o = [], oo = [], cell, coord = "";
			var r = decode_range(ws['!ref']);
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null || cell.t === 'z') continue;
					oo = ["cell", coord, 't'];
					switch(cell.t) {
						case 's': case 'str': oo.push(encode(cell.v)); break;
						case 'n':
							if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
							else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
							break;
						case 'b':
							oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
							oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
							break;
						case 'd':
							var t = datenum(parseDate(cell.v));
							oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
							oo[5] = cell.w || SSF_format(cell.z || table_fmt[14], t);
							break;
						case 'e': continue;
					}
					o.push(oo.join(":"));
				}
			}
			o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
			o.push("valueformat:1:text-wiki");
			//o.push("copiedfrom:" + ws['!ref']); // clipboard only
			return o.join("\n");
		}
	
		function sheet_to_eth(ws) {
			return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
			// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
		}
	
		return {
			to_workbook: eth_to_workbook,
			to_sheet: eth_to_sheet,
			from_sheet: sheet_to_eth
		};
	})();
	
	var PRN = (function() {
		function set_text_arr(data, arr, R, C, o) {
			if(o.raw) arr[R][C] = data;
			else if(data === ""){/* empty */}
			else if(data === 'TRUE') arr[R][C] = true;
			else if(data === 'FALSE') arr[R][C] = false;
			else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
			else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
			else arr[R][C] = data;
		}
	
		function prn_to_aoa_str(f, opts) {
			var o = opts || {};
			var arr = ([]);
			if(!f || f.length === 0) return arr;
			var lines = f.split(/[\r\n]/);
			var L = lines.length - 1;
			while(L >= 0 && lines[L].length === 0) --L;
			var start = 10, idx = 0;
			var R = 0;
			for(; R <= L; ++R) {
				idx = lines[R].indexOf(" ");
				if(idx == -1) idx = lines[R].length; else idx++;
				start = Math.max(start, idx);
			}
			for(R = 0; R <= L; ++R) {
				arr[R] = [];
				/* TODO: confirm that widths are always 10 */
				var C = 0;
				set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
				for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
					set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
			}
			if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
			return arr;
		}
	
		// List of accepted CSV separators
		var guess_seps = {
	0x2C: ',',
	0x09: "\t",
	0x3B: ';',
	0x7C: '|'
		};
	
		// CSV separator weights to be used in case of equal numbers
		var guess_sep_weights = {
	0x2C: 3,
	0x09: 2,
	0x3B: 1,
	0x7C: 0
		};
	
		function guess_sep(str) {
			var cnt = {}, instr = false, end = 0, cc = 0;
			for(;end < str.length;++end) {
				if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
				else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
			}
	
			cc = [];
			for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
				cc.push([ cnt[end], end ]);
			}
	
			if ( !cc.length ) {
				cnt = guess_sep_weights;
				for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
					cc.push([ cnt[end], end ]);
				}
			}
	
			cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });
	
			return guess_seps[cc.pop()[1]] || 0x2C;
		}
	
		function dsv_to_sheet_str(str, opts) {
			var o = opts || {};
			var sep = "";
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var ws = o.dense ? ([]) : ({});
			var range = ({s: {c:0, r:0}, e: {c:0, r:0}});
	
			if(str.slice(0,4) == "sep=") {
				// If the line ends in \r\n
				if(str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10 ) {
					sep = str.charAt(4); str = str.slice(7);
				}
				// If line ends in \r OR \n
				else if(str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10 ) {
					sep = str.charAt(4); str = str.slice(6);
				}
				else sep = guess_sep(str.slice(0,1024));
			}
			else if(o && o.FS) sep = o.FS;
			else sep = guess_sep(str.slice(0,1024));
			var R = 0, C = 0, v = 0;
			var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0, startcc=str.charCodeAt(0);
			str = str.replace(/\r\n/mg, "\n");
			var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
			function finish_cell() {
				var s = str.slice(start, end);
				var cell = ({});
				if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
				if(s.length === 0) cell.t = 'z';
				else if(o.raw) { cell.t = 's'; cell.v = s; }
				else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
				else if(s.charCodeAt(0) == 0x3D) {
					if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
					else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
					else { cell.t = 's'; cell.v = s; } }
				else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
				else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
				else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
				else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
					cell.z = o.dateNF || table_fmt[14];
					var k = 0;
					if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
					if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
					else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
					if(o.cellText !== false) cell.w = SSF_format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
					if(!o.cellNF) delete cell.z;
				} else {
					cell.t = 's';
					cell.v = s;
				}
				if(cell.t == 'z'){}
				else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
				else ws[encode_cell({c:C,r:R})] = cell;
				start = end+1; startcc = str.charCodeAt(start);
				if(range.e.c < C) range.e.c = C;
				if(range.e.r < R) range.e.r = R;
				if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
			}
			outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
				case 0x22: if(startcc === 0x22) instr = !instr; break;
				case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
				default: break;
			}
			if(end - start > 0) finish_cell();
	
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function prn_to_sheet_str(str, opts) {
			if(!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
			if(opts.FS) return dsv_to_sheet_str(str, opts);
			if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
			if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
			return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
		}
	
		function prn_to_sheet(d, opts) {
			var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
			switch(opts.type) {
				case 'base64': str = Base64_decode(d); break;
				case 'binary': str = d; break;
				case 'buffer':
					if(opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
					else if(opts.codepage && typeof $cptable !== 'undefined') str = $cptable.utils.decode(opts.codepage, d);
					else str = has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d);
					break;
				case 'array': str = cc2str(d); break;
				case 'string': str = d; break;
				default: throw new Error("Unrecognized type " + opts.type);
			}
			if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
			else if(opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = utf8read(str);
			else if((opts.type == 'binary') && typeof $cptable !== 'undefined' && opts.codepage)  str = $cptable.utils.decode(opts.codepage, $cptable.utils.encode(28591,str));
			if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
			return prn_to_sheet_str(str, opts);
		}
	
		function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }
	
		function sheet_to_prn(ws) {
			var o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				var oo = [];
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null) { oo.push("          "); continue; }
					var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
					while(w.length < 10) w += " ";
					oo.push(w + (C === 0 ? " " : ""));
				}
				o.push(oo.join(""));
			}
			return o.join("\n");
		}
	
		return {
			to_workbook: prn_to_workbook,
			to_sheet: prn_to_sheet,
			from_sheet: sheet_to_prn
		};
	})();
	
	/* Excel defaults to SYLK but warns if data is not valid */
	function read_wb_ID(d, opts) {
		var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
		try {
			var out = SYLK.to_workbook(d, o);
			o.WTF = OLD_WTF;
			return out;
		} catch(e) {
			o.WTF = OLD_WTF;
			if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
			return PRN.to_workbook(d, opts);
		}
	}
	
	var WK_ = (function() {
		function lotushopper(data, cb, opts) {
			if(!data) return;
			prep_blob(data, data.l || 0);
			var Enum = opts.Enum || WK1Enum;
			while(data.l < data.length) {
				var RT = data.read_shift(2);
				var R = Enum[RT] || Enum[0xFFFF];
				var length = data.read_shift(2);
				var tgt = data.l + length;
				var d = R.f && R.f(data, length, opts);
				data.l = tgt;
				if(cb(d, R, RT)) return;
			}
		}
	
		function lotus_to_workbook(d, opts) {
			switch(opts.type) {
				case 'base64': return lotus_to_workbook_buf(s2a(Base64_decode(d)), opts);
				case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
				case 'buffer':
				case 'array': return lotus_to_workbook_buf(d, opts);
			}
			throw "Unsupported type " + opts.type;
		}
	
		function lotus_to_workbook_buf(d, opts) {
			if(!d) return d;
			var o = opts || {};
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var s = ((o.dense ? [] : {})), n = "Sheet1", next_n = "", sidx = 0;
			var sheets = {}, snames = [], realnames = [];
	
			var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
			var sheetRows = o.sheetRows || 0;
	
			if(d[2] == 0x00) {
				if(d[3] == 0x08 || d[3] == 0x09) {
					if(d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
				}
			}
	
			if(d[2] == 0x02) {
				o.Enum = WK1Enum;
				lotushopper(d, function(val, R, RT) { switch(RT) {
					case 0x00: /* BOF */
						o.vers = val;
						if(val >= 0x1000) o.qpro = true;
						break;
					case 0x06: refguess = val; break; /* RANGE */
					case 0xCC: if(val) next_n = val; break; /* SHEETNAMECS */
					case 0xDE: next_n = val; break; /* SHEETNAMELP */
					case 0x0F: /* LABEL */
					case 0x33: /* STRING */
						if(!o.qpro) val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x0D: /* INTEGER */
					case 0x0E: /* NUMBER */
					case 0x10: /* FORMULA */
						/* TODO: actual translation of the format code */
						if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
							val[1].z = o.dateNF || table_fmt[14];
							if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
						}
	
						if(o.qpro) {
							if(val[3] > sidx) {
								s["!ref"] = encode_range(refguess);
								sheets[n] = s;
								snames.push(n);
								s = (o.dense ? [] : {});
								refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
								sidx = val[3]; n = next_n || "Sheet" + (sidx + 1); next_n = "";
							}
						}
	
						var tmpcell = o.dense ? (s[val[0].r]||[])[val[0].c] : s[encode_cell(val[0])];
						if(tmpcell) {
							tmpcell.t = val[1].t; tmpcell.v = val[1].v;
							if(val[1].z != null) tmpcell.z = val[1].z;
							if(val[1].f != null) tmpcell.f = val[1].f;
							break;
						}
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						break;
					default:
				}}, o);
			} else if(d[2] == 0x1A || d[2] == 0x0E) {
				o.Enum = WK3Enum;
				if(d[2] == 0x0E) { o.qpro = true; d.l = 0; }
				lotushopper(d, function(val, R, RT) { switch(RT) {
					case 0xCC: n = val; break; /* SHEETNAMECS */
					case 0x16: /* LABEL16 */
						val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x17: /* NUMBER17 */
					case 0x18: /* NUMBER18 */
					case 0x19: /* FORMULA19 */
					case 0x25: /* NUMBER25 */
					case 0x27: /* NUMBER27 */
					case 0x28: /* FORMULA28 */
						if(val[3] > sidx) {
							s["!ref"] = encode_range(refguess);
							sheets[n] = s;
							snames.push(n);
							s = (o.dense ? [] : {});
							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
							sidx = val[3]; n = "Sheet" + (sidx + 1);
						}
						if(sheetRows > 0 && val[0].r >= sheetRows) break;
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
						if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
						break;
					case 0x1B: /* XFORMAT */
						if(val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
						break;
					case 0x0601: /* SHEETINFOQP */
						realnames[val[0]] = val[1]; if(val[0] == sidx) n = val[1]; break;
					default: break;
				}}, o);
			} else throw new Error("Unrecognized LOTUS BOF " + d[2]);
			s["!ref"] = encode_range(refguess);
			sheets[next_n || n] = s;
			snames.push(next_n || n);
			if(!realnames.length) return { SheetNames: snames, Sheets: sheets };
			var osheets = {}, rnames = [];
			/* TODO: verify no collisions */
			for(var i = 0; i < realnames.length; ++i) if(sheets[snames[i]]) {
				rnames.push(realnames[i] || snames[i]);
				osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
			} else {
				rnames.push(realnames[i]);
				osheets[realnames[i]] = ({ "!ref": "A1" });
			}
			return { SheetNames: rnames, Sheets: osheets };
		}
	
		function sheet_to_wk1(ws, opts) {
			var o = opts || {};
			if(+o.codepage >= 0) set_cp(+o.codepage);
			if(o.type == "string") throw new Error("Cannot write WK1 to JS string");
			var ba = buf_array();
			var range = safe_decode_range(ws["!ref"]);
			var dense = Array.isArray(ws);
			var cols = [];
	
			write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
			write_biff_rec(ba, 0x06, write_RANGE(range));
			var max_R = Math.min(range.e.r, 8191);
			for(var R = range.s.r; R <= max_R; ++R) {
				var rr = encode_row(R);
				for(var C = range.s.c; C <= range.e.c; ++C) {
					if(R === range.s.r) cols[C] = encode_col(C);
					var ref = cols[C] + rr;
					var cell = dense ? (ws[R]||[])[C] : ws[ref];
					if(!cell || cell.t == "z") continue;
					/* TODO: formula records */
					if(cell.t == "n") {
						if((cell.v|0)==cell.v && cell.v >= -32768 && cell.v <= 32767) write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
						else write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
					} else {
						var str = format_cell(cell);
						write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
					}
				}
			}
	
			write_biff_rec(ba, 0x01);
			return ba.end();
		}
	
		function book_to_wk3(wb, opts) {
			var o = opts || {};
			if(+o.codepage >= 0) set_cp(+o.codepage);
			if(o.type == "string") throw new Error("Cannot write WK3 to JS string");
			var ba = buf_array();
	
			write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
	
			for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i) if((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
	
			var wsidx = 0;
			for(i = 0; i < wb.SheetNames.length; ++i) {
				var ws = wb.Sheets[wb.SheetNames[i]];
				if(!ws || !ws["!ref"]) continue;
				var range = safe_decode_range(ws["!ref"]);
				var dense = Array.isArray(ws);
				var cols = [];
				var max_R = Math.min(range.e.r, 8191);
				for(var R = range.s.r; R <= max_R; ++R) {
					var rr = encode_row(R);
					for(var C = range.s.c; C <= range.e.c; ++C) {
						if(R === range.s.r) cols[C] = encode_col(C);
						var ref = cols[C] + rr;
						var cell = dense ? (ws[R]||[])[C] : ws[ref];
						if(!cell || cell.t == "z") continue;
						/* TODO: FORMULA19 NUMBER18 records */
						if(cell.t == "n") {
							write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
						} else {
							var str = format_cell(cell);
							/* TODO: max len? */
							write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
						}
					}
				}
				++wsidx;
			}
	
			write_biff_rec(ba, 0x01);
			return ba.end();
		}
	
	
		function write_BOF_WK1(v) {
			var out = new_buf(2);
			out.write_shift(2, v);
			return out;
		}
	
		function write_BOF_WK3(wb) {
			var out = new_buf(26);
			out.write_shift(2, 0x1000);
			out.write_shift(2, 0x0004);
			out.write_shift(4, 0x0000);
			var rows = 0, cols = 0, wscnt = 0;
			for(var i = 0; i < wb.SheetNames.length; ++i) {
				var name = wb.SheetNames[i];
				var ws = wb.Sheets[name];
				if(!ws || !ws["!ref"]) continue;
				++wscnt;
				var range = decode_range(ws["!ref"]);
				if(rows < range.e.r) rows = range.e.r;
				if(cols < range.e.c) cols = range.e.c;
			}
			if(rows > 8191) rows = 8191;
			out.write_shift(2, rows);
			out.write_shift(1, wscnt);
			out.write_shift(1, cols);
			out.write_shift(2, 0x00);
			out.write_shift(2, 0x00);
			out.write_shift(1, 0x01);
			out.write_shift(1, 0x02);
			out.write_shift(4, 0);
			out.write_shift(4, 0);
			return out;
		}
	
		function parse_RANGE(blob, length, opts) {
			var o = {s:{c:0,r:0},e:{c:0,r:0}};
			if(length == 8 && opts.qpro) {
				o.s.c = blob.read_shift(1);
				blob.l++;
				o.s.r = blob.read_shift(2);
				o.e.c = blob.read_shift(1);
				blob.l++;
				o.e.r = blob.read_shift(2);
				return o;
			}
			o.s.c = blob.read_shift(2);
			o.s.r = blob.read_shift(2);
			if(length == 12 && opts.qpro) blob.l += 2;
			o.e.c = blob.read_shift(2);
			o.e.r = blob.read_shift(2);
			if(length == 12 && opts.qpro) blob.l += 2;
			if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
			return o;
		}
		function write_RANGE(range) {
			var out = new_buf(8);
			out.write_shift(2, range.s.c);
			out.write_shift(2, range.s.r);
			out.write_shift(2, range.e.c);
			out.write_shift(2, range.e.r);
			return out;
		}
	
		function parse_cell(blob, length, opts) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0, 0];
			if(opts.qpro && opts.vers != 0x5120) {
				o[0].c = blob.read_shift(1);
				o[3] = blob.read_shift(1);
				o[0].r = blob.read_shift(2);
				blob.l+=2;
			} else {
				o[2] = blob.read_shift(1);
				o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
			}
			return o;
		}
	
		function parse_LABEL(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			o[1].t = 's';
			if(opts.vers == 0x5120) {
				blob.l++;
				var len = blob.read_shift(1);
				o[1].v = blob.read_shift(len, 'utf8');
				return o;
			}
			if(opts.qpro) blob.l++;
			o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
			return o;
		}
		function write_LABEL(R, C, s) {
			/* TODO: encoding */
			var o = new_buf(7 + s.length);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(1, 0x27); // ??
			for(var i = 0; i < o.length; ++i) {
				var cc = s.charCodeAt(i);
				o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
			}
			o.write_shift(1, 0);
			return o;
		}
	
		function parse_INTEGER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(2, 'i');
			return o;
		}
		function write_INTEGER(R, C, v) {
			var o = new_buf(7);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(2, v, 'i');
			return o;
		}
	
		function parse_NUMBER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(8, 'f');
			return o;
		}
		function write_NUMBER(R, C, v) {
			var o = new_buf(13);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(8, v, 'f');
			return o;
		}
	
		function parse_FORMULA(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			/* TODO: formula */
			o[1].v = blob.read_shift(8, 'f');
			if(opts.qpro) blob.l = tgt;
			else {
				var flen = blob.read_shift(2);
				wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
				blob.l += flen;
			}
			return o;
		}
	
		function wk1_parse_rc(B, V, col) {
			var rel = V & 0x8000;
			V &= ~0x8000;
			V = (rel ? B : 0) + ((V >= 0x2000) ? V - 0x4000 : V);
			return (rel ? "" : "$") + (col ? encode_col(V) : encode_row(V));
		}
		/* var oprec = [
			8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
			3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
		]; */
		/* TODO: flesh out */
		var FuncTab = {
			0x33: ["FALSE", 0],
			0x34: ["TRUE", 0],
			0x46: ["LEN", 1],
			0x50: ["SUM", 69],
			0x51: ["AVERAGEA", 69],
			0x52: ["COUNTA", 69],
			0x53: ["MINA", 69],
			0x54: ["MAXA", 69],
			0x6F: ["T", 1]
		};
		var BinOpTab = [
			  "",   "",   "",   "",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
			  "",  "+",  "-",  "*",  "/",  "^",  "=", "<>", // eslint-disable-line no-mixed-spaces-and-tabs
			"<=", ">=",  "<",  ">",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
			 "&",   "",   "",   "",   "",   "",   "",   ""  // eslint-disable-line no-mixed-spaces-and-tabs
		];
	
		function wk1_fmla_to_csf(blob, o) {
			prep_blob(blob, 0);
			var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
			while(blob.l < blob.length) {
				var cc = blob[blob.l++];
				switch(cc) {
					case 0x00: out.push(blob.read_shift(8, 'f')); break;
					case 0x01: {
						C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						out.push(C + R);
					} break;
					case 0x02: {
						var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						out.push(c + r + ":" + C + R);
					} break;
					case 0x03:
						if(blob.l < blob.length) { console.error("WK1 premature formula end"); return; }
						break;
					case 0x04: out.push("(" + out.pop() + ")"); break;
					case 0x05: out.push(blob.read_shift(2)); break;
					case 0x06: {
						/* TODO: text encoding */
						var Z = ""; while((cc = blob[blob.l++])) Z += String.fromCharCode(cc);
						out.push('"' + Z.replace(/"/g, '""') + '"');
					} break;
	
					case 0x08: out.push("-" + out.pop()); break;
					case 0x17: out.push("+" + out.pop()); break;
					case 0x16: out.push("NOT(" + out.pop() + ")"); break;
	
					case 0x14: case 0x15: {
						argR = out.pop(); argL = out.pop();
						out.push(["AND", "OR"][cc - 0x14] + "(" + argL + "," + argR + ")");
					} break;
	
					default:
						if(cc < 0x20 && BinOpTab[cc]) {
							argR = out.pop(); argL = out.pop();
							out.push(argL + BinOpTab[cc] + argR);
						} else if(FuncTab[cc]) {
							argc = FuncTab[cc][1];
							if(argc == 69) argc = blob[blob.l++];
							if(argc > out.length) { console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|"); return; }
							var args = out.slice(-argc);
							out.length -= argc;
							out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
						}
						else if(cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
						else if(cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
						else if(cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
						else if(cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
						// possible future functions ??
						else return console.error("WK1 unrecognized opcode " + cc.toString(16));
				}
			}
			if(out.length == 1) o[1].f = "" + out[0];
			else console.error("WK1 bad formula parse |" + out.join("|") + "|");
		}
	
	
		function parse_cell_3(blob) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0];
			o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
			return o;
		}
	
		function parse_LABEL_16(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].t = 's';
			o[1].v = blob.read_shift(length - 4, 'cstr');
			return o;
		}
		function write_LABEL_16(R, C, wsidx, s) {
			/* TODO: encoding */
			var o = new_buf(6 + s.length);
			o.write_shift(2, R);
			o.write_shift(1, wsidx);
			o.write_shift(1, C);
			o.write_shift(1, 0x27);
			for(var i = 0; i < s.length; ++i) {
				var cc = s.charCodeAt(i);
				o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
			}
			o.write_shift(1, 0);
			return o;
		}
	
		function parse_NUMBER_18(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].v = blob.read_shift(2);
			var v = o[1].v >> 1;
			if(o[1].v & 0x1) {
				switch(v & 0x07) {
					case 0: v = (v >> 3) * 5000; break;
					case 1: v = (v >> 3) * 500; break;
					case 2: v = (v >> 3) / 20; break;
					case 3: v = (v >> 3) / 200; break;
					case 4: v = (v >> 3) / 2000; break;
					case 5: v = (v >> 3) / 20000; break;
					case 6: v = (v >> 3) / 16; break;
					case 7: v = (v >> 3) / 64; break;
				}
			}
			o[1].v = v;
			return o;
		}
	
		function parse_NUMBER_17(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			var v2 = blob.read_shift(4);
			var e = blob.read_shift(2);
			if(e == 0xFFFF) {
				if(v1 === 0 && v2 === 0xC0000000) { o[1].t = "e"; o[1].v = 0x0F; } // ERR -> #VALUE!
				else if(v1 === 0 && v2 === 0xD0000000) { o[1].t = "e"; o[1].v = 0x2A; } // NA -> #N/A
				else o[1].v = 0;
				return o;
			}
			var s = e & 0x8000; e = (e&0x7FFF) - 16446;
			o[1].v = (1 - s*2) * (v2 * Math.pow(2, e+32) + v1 * Math.pow(2, e));
			return o;
		}
		function write_NUMBER_17(R, C, wsidx, v) {
			var o = new_buf(14);
			o.write_shift(2, R);
			o.write_shift(1, wsidx);
			o.write_shift(1, C);
			if(v == 0) {
				o.write_shift(4, 0);
				o.write_shift(4, 0);
				o.write_shift(2, 0xFFFF);
				return o;
			}
			var s = 0, e = 0, v1 = 0, v2 = 0;
			if(v < 0) { s = 1; v = -v; }
			e = Math.log2(v) | 0;
			v /= Math.pow(2, e-31);
			v2 = (v)>>>0;
			if((v2&0x80000000) == 0) { v/=2; ++e; v2 = v >>> 0; }
			v -= v2;
			v2 |= 0x80000000;
			v2 >>>= 0;
			v *= Math.pow(2, 32);
			v1 = v>>>0;
			o.write_shift(4, v1);
			o.write_shift(4, v2);
			e += 0x3FFF + (s ? 0x8000 : 0);
			o.write_shift(2, e);
			return o;
		}
	
		function parse_FORMULA_19(blob, length) {
			var o = parse_NUMBER_17(blob, 14);
			blob.l += length - 14; /* TODO: WK3 formula */
			return o;
		}
	
		function parse_NUMBER_25(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			o[1].v = v1 >> 6;
			return o;
		}
	
		function parse_NUMBER_27(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(8,'f');
			o[1].v = v1;
			return o;
		}
	
		function parse_FORMULA_28(blob, length) {
			var o = parse_NUMBER_27(blob, 14);
			blob.l += length - 10; /* TODO: formula */
			return o;
		}
	
		function parse_SHEETNAMECS(blob, length) {
			return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
		}
	
		function parse_SHEETNAMELP(blob, length) {
			var len = blob[blob.l++];
			if(len > length - 1) len = length - 1;
			var o = ""; while(o.length < len) o += String.fromCharCode(blob[blob.l++]);
			return o;
		}
	
		function parse_SHEETINFOQP(blob, length, opts) {
			if(!opts.qpro || length < 21) return;
			var id = blob.read_shift(1);
			blob.l += 17;
			blob.l += 1; //var len = blob.read_shift(1);
			blob.l += 2;
			var nm = blob.read_shift(length - 21, 'cstr');
			return [id, nm];
		}
	
		function parse_XFORMAT(blob, length) {
			var o = {}, tgt = blob.l + length;
			while(blob.l < tgt) {
				var dt = blob.read_shift(2);
				if(dt == 0x36b0) {
					o[dt] = [0, ""];
					o[dt][0] = blob.read_shift(2);
					while(blob[blob.l]) { o[dt][1] += String.fromCharCode(blob[blob.l]); blob.l++; } blob.l++;
				}
				// TODO: 0x3a99 ??
			}
			return o;
		}
		function write_XFORMAT_SHEETNAME(name, wsidx) {
			var out = new_buf(5 + name.length);
			out.write_shift(2, 0x36b0);
			out.write_shift(2, wsidx);
			for(var i = 0; i < name.length; ++i) {
				var cc = name.charCodeAt(i);
				out[out.l++] = cc > 0x7F ? 0x5F : cc;
			}
			out[out.l++] = 0;
			return out;
		}
	
		var WK1Enum = {
	0x0000: { n:"BOF", f:parseuint16 },
	0x0001: { n:"EOF" },
	0x0002: { n:"CALCMODE" },
	0x0003: { n:"CALCORDER" },
	0x0004: { n:"SPLIT" },
	0x0005: { n:"SYNC" },
	0x0006: { n:"RANGE", f:parse_RANGE },
	0x0007: { n:"WINDOW1" },
	0x0008: { n:"COLW1" },
	0x0009: { n:"WINTWO" },
	0x000A: { n:"COLW2" },
	0x000B: { n:"NAME" },
	0x000C: { n:"BLANK" },
	0x000D: { n:"INTEGER", f:parse_INTEGER },
	0x000E: { n:"NUMBER", f:parse_NUMBER },
	0x000F: { n:"LABEL", f:parse_LABEL },
	0x0010: { n:"FORMULA", f:parse_FORMULA },
	0x0018: { n:"TABLE" },
	0x0019: { n:"ORANGE" },
	0x001A: { n:"PRANGE" },
	0x001B: { n:"SRANGE" },
	0x001C: { n:"FRANGE" },
	0x001D: { n:"KRANGE1" },
	0x0020: { n:"HRANGE" },
	0x0023: { n:"KRANGE2" },
	0x0024: { n:"PROTEC" },
	0x0025: { n:"FOOTER" },
	0x0026: { n:"HEADER" },
	0x0027: { n:"SETUP" },
	0x0028: { n:"MARGINS" },
	0x0029: { n:"LABELFMT" },
	0x002A: { n:"TITLES" },
	0x002B: { n:"SHEETJS" },
	0x002D: { n:"GRAPH" },
	0x002E: { n:"NGRAPH" },
	0x002F: { n:"CALCCOUNT" },
	0x0030: { n:"UNFORMATTED" },
	0x0031: { n:"CURSORW12" },
	0x0032: { n:"WINDOW" },
	0x0033: { n:"STRING", f:parse_LABEL },
	0x0037: { n:"PASSWORD" },
	0x0038: { n:"LOCKED" },
	0x003C: { n:"QUERY" },
	0x003D: { n:"QUERYNAME" },
	0x003E: { n:"PRINT" },
	0x003F: { n:"PRINTNAME" },
	0x0040: { n:"GRAPH2" },
	0x0041: { n:"GRAPHNAME" },
	0x0042: { n:"ZOOM" },
	0x0043: { n:"SYMSPLIT" },
	0x0044: { n:"NSROWS" },
	0x0045: { n:"NSCOLS" },
	0x0046: { n:"RULER" },
	0x0047: { n:"NNAME" },
	0x0048: { n:"ACOMM" },
	0x0049: { n:"AMACRO" },
	0x004A: { n:"PARSE" },
	0x0066: { n:"PRANGES??" },
	0x0067: { n:"RRANGES??" },
	0x0068: { n:"FNAME??" },
	0x0069: { n:"MRANGES??" },
	0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
	0x00DE: { n:"SHEETNAMELP", f:parse_SHEETNAMELP },
	0xFFFF: { n:"" }
		};
	
		var WK3Enum = {
	0x0000: { n:"BOF" },
	0x0001: { n:"EOF" },
	0x0002: { n:"PASSWORD" },
	0x0003: { n:"CALCSET" },
	0x0004: { n:"WINDOWSET" },
	0x0005: { n:"SHEETCELLPTR" },
	0x0006: { n:"SHEETLAYOUT" },
	0x0007: { n:"COLUMNWIDTH" },
	0x0008: { n:"HIDDENCOLUMN" },
	0x0009: { n:"USERRANGE" },
	0x000A: { n:"SYSTEMRANGE" },
	0x000B: { n:"ZEROFORCE" },
	0x000C: { n:"SORTKEYDIR" },
	0x000D: { n:"FILESEAL" },
	0x000E: { n:"DATAFILLNUMS" },
	0x000F: { n:"PRINTMAIN" },
	0x0010: { n:"PRINTSTRING" },
	0x0011: { n:"GRAPHMAIN" },
	0x0012: { n:"GRAPHSTRING" },
	0x0013: { n:"??" },
	0x0014: { n:"ERRCELL" },
	0x0015: { n:"NACELL" },
	0x0016: { n:"LABEL16", f:parse_LABEL_16},
	0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
	0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
	0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
	0x001A: { n:"FORMULA1A" },
	0x001B: { n:"XFORMAT", f:parse_XFORMAT },
	0x001C: { n:"DTLABELMISC" },
	0x001D: { n:"DTLABELCELL" },
	0x001E: { n:"GRAPHWINDOW" },
	0x001F: { n:"CPA" },
	0x0020: { n:"LPLAUTO" },
	0x0021: { n:"QUERY" },
	0x0022: { n:"HIDDENSHEET" },
	0x0023: { n:"??" },
	0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
	0x0026: { n:"??" },
	0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
	0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
	0x008E: { n:"??" },
	0x0093: { n:"??" },
	0x0096: { n:"??" },
	0x0097: { n:"??" },
	0x0098: { n:"??" },
	0x0099: { n:"??" },
	0x009A: { n:"??" },
	0x009B: { n:"??" },
	0x009C: { n:"??" },
	0x00A3: { n:"??" },
	0x00AE: { n:"??" },
	0x00AF: { n:"??" },
	0x00B0: { n:"??" },
	0x00B1: { n:"??" },
	0x00B8: { n:"??" },
	0x00B9: { n:"??" },
	0x00BA: { n:"??" },
	0x00BB: { n:"??" },
	0x00BC: { n:"??" },
	0x00C3: { n:"??" },
	0x00C9: { n:"??" },
	0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
	0x00CD: { n:"??" },
	0x00CE: { n:"??" },
	0x00CF: { n:"??" },
	0x00D0: { n:"??" },
	0x0100: { n:"??" },
	0x0103: { n:"??" },
	0x0104: { n:"??" },
	0x0105: { n:"??" },
	0x0106: { n:"??" },
	0x0107: { n:"??" },
	0x0109: { n:"??" },
	0x010A: { n:"??" },
	0x010B: { n:"??" },
	0x010C: { n:"??" },
	0x010E: { n:"??" },
	0x010F: { n:"??" },
	0x0180: { n:"??" },
	0x0185: { n:"??" },
	0x0186: { n:"??" },
	0x0189: { n:"??" },
	0x018C: { n:"??" },
	0x0200: { n:"??" },
	0x0202: { n:"??" },
	0x0201: { n:"??" },
	0x0204: { n:"??" },
	0x0205: { n:"??" },
	0x0280: { n:"??" },
	0x0281: { n:"??" },
	0x0282: { n:"??" },
	0x0283: { n:"??" },
	0x0284: { n:"??" },
	0x0285: { n:"??" },
	0x0286: { n:"??" },
	0x0287: { n:"??" },
	0x0288: { n:"??" },
	0x0292: { n:"??" },
	0x0293: { n:"??" },
	0x0294: { n:"??" },
	0x0295: { n:"??" },
	0x0296: { n:"??" },
	0x0299: { n:"??" },
	0x029A: { n:"??" },
	0x0300: { n:"??" },
	0x0304: { n:"??" },
	0x0601: { n:"SHEETINFOQP", f:parse_SHEETINFOQP },
	0x0640: { n:"??" },
	0x0642: { n:"??" },
	0x0701: { n:"??" },
	0x0702: { n:"??" },
	0x0703: { n:"??" },
	0x0704: { n:"??" },
	0x0780: { n:"??" },
	0x0800: { n:"??" },
	0x0801: { n:"??" },
	0x0804: { n:"??" },
	0x0A80: { n:"??" },
	0x2AF6: { n:"??" },
	0x3231: { n:"??" },
	0x6E49: { n:"??" },
	0x6F44: { n:"??" },
	0xFFFF: { n:"" }
		};
		return {
			sheet_to_wk1: sheet_to_wk1,
			book_to_wk3: book_to_wk3,
			to_workbook: lotus_to_workbook
		};
	})();
	/* 18.4.7 rPr CT_RPrElt */
	function parse_rpr(rpr) {
		var font = {}, m = rpr.match(tagregex), i = 0;
		var pass = false;
		if(m) for(;i!=m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(y[0].replace(/\w*:/g,"")) {
				/* 18.8.12 condense CT_BooleanProperty */
				/* ** not required . */
				case '<condense': break;
				/* 18.8.17 extend CT_BooleanProperty */
				/* ** not required . */
				case '<extend': break;
				/* 18.8.36 shadow CT_BooleanProperty */
				/* ** not required . */
				case '<shadow':
					if(!y.val) break;
					/* falls through */
				case '<shadow>':
				case '<shadow/>': font.shadow = 1; break;
				case '</shadow>': break;
	
				/* 18.4.1 charset CT_IntProperty TODO */
				case '<charset':
					if(y.val == '1') break;
					font.cp = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.4.2 outline CT_BooleanProperty TODO */
				case '<outline':
					if(!y.val) break;
					/* falls through */
				case '<outline>':
				case '<outline/>': font.outline = 1; break;
				case '</outline>': break;
	
				/* 18.4.5 rFont CT_FontName */
				case '<rFont': font.name = y.val; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': font.sz = y.val; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike':
					if(!y.val) break;
					/* falls through */
				case '<strike>':
				case '<strike/>': font.strike = 1; break;
				case '</strike>': break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					if(!y.val) break;
					switch(y.val) {
						case 'double': font.uval = "double"; break;
						case 'singleAccounting': font.uval = "single-accounting"; break;
						case 'doubleAccounting': font.uval = "double-accounting"; break;
					}
					/* falls through */
				case '<u>':
				case '<u/>': font.u = 1; break;
				case '</u>': break;
	
				/* 18.8.2 b */
				case '<b':
					if(y.val == '0') break;
					/* falls through */
				case '<b>':
				case '<b/>': font.b = 1; break;
				case '</b>': break;
	
				/* 18.8.26 i */
				case '<i':
					if(y.val == '0') break;
					/* falls through */
				case '<i>':
				case '<i/>': font.i = 1; break;
				case '</i>': break;
	
				/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
				case '<color':
					if(y.rgb) font.color = y.rgb.slice(2,8);
					break;
				case '<color>': case '<color/>': case '</color>': break;
	
				/* 18.8.18 family ST_FontFamily */
				case '<family': font.family = y.val; break;
				case '<family>': case '<family/>': case '</family>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
				case '<vertAlign': font.valign = y.val; break;
				case '<vertAlign>': case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.35 scheme CT_FontScheme TODO */
				case '<scheme': break;
				case '<scheme>': case '<scheme/>': case '</scheme>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default:
					if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
			}
		}
		return font;
	}
	
	var parse_rs = (function() {
		var tregex = matchtag("t"), rpregex = matchtag("rPr");
		/* 18.4.4 r CT_RElt */
		function parse_r(r) {
			/* 18.4.12 t ST_Xstring */
			var t = r.match(tregex)/*, cp = 65001*/;
			if(!t) return {t:"s", v:""};
	
			var o = ({t:'s', v:unescapexml(t[1])});
			var rpr = r.match(rpregex);
			if(rpr) o.s = parse_rpr(rpr[1]);
			return o;
		}
		var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
		return function parse_rs(rs) {
			return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r) { return r.v; });
		};
	})();
	
	
	/* Parse a list of <r> tags */
	var rs_to_html = (function parse_rs_factory() {
		var nlregex = /(\r\n|\n)/g;
		function parse_rpr2(font, intro, outro) {
			var style = [];
	
			if(font.u) style.push("text-decoration: underline;");
			if(font.uval) style.push("text-underline-style:" + font.uval + ";");
			if(font.sz) style.push("font-size:" + font.sz + "pt;");
			if(font.outline) style.push("text-effect: outline;");
			if(font.shadow) style.push("text-shadow: auto;");
			intro.push('<span style="' + style.join("") + '">');
	
			if(font.b) { intro.push("<b>"); outro.push("</b>"); }
			if(font.i) { intro.push("<i>"); outro.push("</i>"); }
			if(font.strike) { intro.push("<s>"); outro.push("</s>"); }
	
			var align = font.valign || "";
			if(align == "superscript" || align == "super") align = "sup";
			else if(align == "subscript") align = "sub";
			if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }
	
			outro.push("</span>");
			return font;
		}
	
		/* 18.4.4 r CT_RElt */
		function r_to_html(r) {
			var terms = [[],r.v,[]];
			if(!r.v) return "";
	
			if(r.s) parse_rpr2(r.s, terms[0], terms[2]);
	
			return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
		}
	
		return function parse_rs(rs) {
			return rs.map(r_to_html).join("");
		};
	})();
	
	/* 18.4.8 si CT_Rst */
	var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
	var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
	function parse_si(x, opts) {
		var html = opts ? opts.cellHTML : true;
		var z = {};
		if(!x) return { t: "" };
		//var y;
		/* 18.4.12 t ST_Xstring (Plaintext String) */
		// TODO: is whitespace actually valid here?
		if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
			z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
			z.r = utf8read(x);
			if(html) z.h = escapehtml(z.t);
		}
		/* 18.4.4 r CT_RElt (Rich Text Run) */
		else if((/*y = */x.match(sirregex))) {
			z.r = utf8read(x);
			z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
			if(html) z.h = rs_to_html(parse_rs(z.r));
		}
		/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
		/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
		return z;
	}
	
	/* 18.4 Shared String Table */
	var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
	var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
	var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
	function parse_sst_xml(data, opts) {
		var s = ([]), ss = "";
		if(!data) return s;
		/* 18.4.9 sst CT_Sst */
		var sst = data.match(sstr0);
		if(sst) {
			ss = sst[2].replace(sstr1,"").split(sstr2);
			for(var i = 0; i != ss.length; ++i) {
				var o = parse_si(ss[i].trim(), opts);
				if(o != null) s[s.length] = o;
			}
			sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
		}
		return s;
	}
	
	var straywsregex = /^\s|\s$|[\t\n\r]/;
	function write_sst_xml(sst, opts) {
		if(!opts.bookSST) return "";
		var o = [XML_HEADER];
		o[o.length] = (writextag('sst', null, {
			xmlns: XMLNS_main[0],
			count: sst.Count,
			uniqueCount: sst.Unique
		}));
		for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
			var s = sst[i];
			var sitag = "<si>";
			if(s.r) sitag += s.r;
			else {
				sitag += "<t";
				if(!s.t) s.t = "";
				if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
				sitag += ">" + escapexml(s.t) + "</t>";
			}
			sitag += "</si>";
			o[o.length] = (sitag);
		}
		if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.221 BrtBeginSst */
	function parse_BrtBeginSst(data) {
		return [data.read_shift(4), data.read_shift(4)];
	}
	
	/* [MS-XLSB] 2.1.7.45 Shared Strings */
	function parse_sst_bin(data, opts) {
		var s = ([]);
		var pass = false;
		recordhopper(data, function hopper_sst(val, R, RT) {
			switch(RT) {
				case 0x009F: /* BrtBeginSst */
					s.Count = val[0]; s.Unique = val[1]; break;
				case 0x0013: /* BrtSSTItem */
					s.push(val); break;
				case 0x00A0: /* BrtEndSst */
					return true;
	
				case 0x0023: /* BrtFRTBegin */
					pass = true; break;
				case 0x0024: /* BrtFRTEnd */
					pass = false; break;
	
				default:
					if(R.T){}
					if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return s;
	}
	
	function write_BrtBeginSst(sst, o) {
		if(!o) o = new_buf(8);
		o.write_shift(4, sst.Count);
		o.write_shift(4, sst.Unique);
		return o;
	}
	
	var write_BrtSSTItem = write_RichStr;
	
	function write_sst_bin(sst) {
		var ba = buf_array();
		write_record(ba, 0x009F /* BrtBeginSst */, write_BrtBeginSst(sst));
		for(var i = 0; i < sst.length; ++i) write_record(ba, 0x0013 /* BrtSSTItem */, write_BrtSSTItem(sst[i]));
		/* FRTSST */
		write_record(ba, 0x00A0 /* BrtEndSst */);
		return ba.end();
	}
	function _JS2ANSI(str) {
		if(typeof $cptable !== 'undefined') return $cptable.utils.encode(current_ansi, str);
		var o = [], oo = str.split("");
		for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.4 Version */
	function parse_CRYPTOVersion(blob, length) {
		var o = {};
		o.Major = blob.read_shift(2);
		o.Minor = blob.read_shift(2);
	if(length >= 4) blob.l += length - 4;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
	function parse_DataSpaceVersionInfo(blob) {
		var o = {};
		o.id = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
	function parse_DataSpaceMapEntry(blob) {
		var len = blob.read_shift(4);
		var end = blob.l + len - 4;
		var o = {};
		var cnt = blob.read_shift(4);
		var comps = [];
		/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
		while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
		o.name = blob.read_shift(0, 'lpp4');
		o.comps = comps;
		if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
	function parse_DataSpaceMap(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
	function parse_DataSpaceDefinition(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
	function parse_TransformInfoHeader(blob) {
		var o = {};
		/*var len = */blob.read_shift(4);
		blob.l += 4; // must be 0x1
		o.id = blob.read_shift(0, 'lpp4');
		o.name = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	function parse_Primary(blob) {
		/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
		var hdr = parse_TransformInfoHeader(blob);
		/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
		hdr.ename = blob.read_shift(0, '8lpp4');
		hdr.blksz = blob.read_shift(4);
		hdr.cmode = blob.read_shift(4);
		if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
		return hdr;
	}
	
	/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
	function parse_EncryptionHeader(blob, length) {
		var tgt = blob.l + length;
		var o = {};
		o.Flags = (blob.read_shift(4) & 0x3F);
		blob.l += 4;
		o.AlgID = blob.read_shift(4);
		var valid = false;
		switch(o.AlgID) {
			case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
			case 0x6801: valid = (o.Flags == 0x04); break;
			case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
			default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
		}
		if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
		o.AlgIDHash = blob.read_shift(4);
		o.KeySize = blob.read_shift(4);
		o.ProviderType = blob.read_shift(4);
		blob.l += 8;
		o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
		blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
	function parse_EncryptionVerifier(blob, length) {
		var o = {}, tgt = blob.l + length;
		blob.l += 4; // SaltSize must be 0x10
		o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
		o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
		/*var sz = */blob.read_shift(4);
		o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
	function parse_EncryptionInfo(blob) {
		var vers = parse_CRYPTOVersion(blob);
		switch(vers.Minor) {
			case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
			case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
			case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
		}
		throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
	function parse_EncInfoStd(blob) {
		var flags = blob.read_shift(4);
		if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
		var sz = blob.read_shift(4);
		//var tgt = blob.l + sz;
		var hdr = parse_EncryptionHeader(blob, sz);
		var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
		return { t:"Std", h:hdr, v:verifier };
	}
	/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
	function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
	/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
	function parse_EncInfoAgl(blob) {
		var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
		blob.l+=4;
		var xml = blob.read_shift(blob.length - blob.l, 'utf8');
		var o = {};
		xml.replace(tagregex, function xml_agile(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
				case '<encryption': case '</encryption>': break;
				case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
				case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
				case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
				case '</keyEncryptors>': break;
	
				case '<keyEncryptor': o.uri = y.uri; break;
				case '</keyEncryptor>': break;
				case '<encryptedKey': o.encs.push(y); break;
				default: throw y[0];
			}
		});
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
	function parse_RC4CryptoHeader(blob, length) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
		if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
		if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
		o.Flags = blob.read_shift(4); length -= 4;
		var sz = blob.read_shift(4); length -= 4;
		o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
		o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
		return o;
	}
	/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
	function parse_RC4Header(blob) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
		if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
		o.Salt = blob.read_shift(16);
		o.EncryptedVerifier = blob.read_shift(16);
		o.EncryptedVerifierHash = blob.read_shift(16);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
	function crypto_CreatePasswordVerifier_Method1(Password) {
		var Verifier = 0x0000, PasswordArray;
		var PasswordDecoded = _JS2ANSI(Password);
		var len = PasswordDecoded.length + 1, i, PasswordByte;
		var Intermediate1, Intermediate2, Intermediate3;
		PasswordArray = new_raw_buf(len);
		PasswordArray[0] = PasswordDecoded.length;
		for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
		for(i = len-1; i >= 0; --i) {
			PasswordByte = PasswordArray[i];
			Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
			Intermediate2 = (Verifier << 1) & 0x7FFF;
			Intermediate3 = Intermediate1 | Intermediate2;
			Verifier = Intermediate3 ^ PasswordByte;
		}
		return Verifier ^ 0xCE4B;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
	var crypto_CreateXorArray_Method1 = (function() {
		var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
		var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
		var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
		var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
		var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
		var CreateXorKey_Method1 = function(Password) {
			var XorKey = InitialCode[Password.length - 1];
			var CurrentElement = 0x68;
			for(var i = Password.length-1; i >= 0; --i) {
				var Char = Password[i];
				for(var j = 0; j != 7; ++j) {
					if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
					Char *= 2; --CurrentElement;
				}
			}
			return XorKey;
		};
		return function(password) {
			var Password = _JS2ANSI(password);
			var XorKey = CreateXorKey_Method1(Password);
			var Index = Password.length;
			var ObfuscationArray = new_raw_buf(16);
			for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
			var Temp, PasswordLastChar, PadIndex;
			if((Index & 1) === 1) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				PasswordLastChar = Password[Password.length - 1];
				ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
			}
			while(Index > 0) {
				--Index;
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			}
			Index = 15;
			PadIndex = 15 - Password.length;
			while(PadIndex > 0) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
				--Index;
				--PadIndex;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				--PadIndex;
			}
			return ObfuscationArray;
		};
	})();
	
	/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
	var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
		/* If XorArray is set, use it; if O is not set, make changes in-place */
		if(!O) O = Data;
		if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
		var Index, Value;
		for(Index = 0; Index != Data.length; ++Index) {
			Value = Data[Index];
			Value ^= XorArray[XorArrayIndex];
			Value = ((Value>>5) | (Value<<3)) & 0xFF;
			O[Index] = Value;
			++XorArrayIndex;
		}
		return [O, XorArrayIndex, XorArray];
	};
	
	var crypto_MakeXorDecryptor = function(password) {
		var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
		return function(Data) {
			var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
			XorArrayIndex = O[1];
			return O[0];
		};
	};
	
	/* 2.5.343 */
	function parse_XORObfuscation(blob, length, opts, out) {
		var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
		if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
		out.valid = o.verificationBytes === o.verifier;
		if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
		return o;
	}
	
	/* 2.4.117 */
	function parse_FilePassHeader(blob, length, oo) {
		var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
		if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
		else o.Data = parse_RC4CryptoHeader(blob, length);
		return o;
	}
	function parse_FilePass(blob, length, opts) {
		var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
		if(o.Type) parse_FilePassHeader(blob, length-2, o);
		else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
		return o;
	}
	
	
	var RTF = (function() {
		function rtf_to_sheet(d, opts) {
			switch(opts.type) {
				case 'base64': return rtf_to_sheet_str(Base64_decode(d), opts);
				case 'binary': return rtf_to_sheet_str(d, opts);
				case 'buffer': return rtf_to_sheet_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
	
		/* TODO: this is a stub */
		function rtf_to_sheet_str(str, opts) {
			var o = opts || {};
			var ws = o.dense ? ([]) : ({});
	
			var rows = str.match(/\\trowd.*?\\row\b/g);
			if(!rows.length) throw new Error("RTF missing table");
			var range = ({s: {c:0, r:0}, e: {c:0, r:rows.length - 1}});
			rows.forEach(function(rowtf, R) {
				if(Array.isArray(ws)) ws[R] = [];
				var rtfre = /\\\w+\b/g;
				var last_index = 0;
				var res;
				var C = -1;
				while((res = rtfre.exec(rowtf))) {
					switch(res[0]) {
						case "\\cell":
							var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
							if(data[0] == " ") data = data.slice(1);
							++C;
							if(data.length) {
								// TODO: value parsing, including codepage adjustments
								var cell = {v: data, t:"s"};
								if(Array.isArray(ws)) ws[R][C] = cell;
								else ws[encode_cell({r:R, c:C})] = cell;
							}
							break;
					}
					last_index = rtfre.lastIndex;
				}
				if(C > range.e.c) range.e.c = C;
			});
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function rtf_to_workbook(d, opts) { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }
	
		/* TODO: this is a stub */
		function sheet_to_rtf(ws) {
			var o = ["{\\rtf1\\ansi"];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				o.push("\\trowd\\trautofit1");
				for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
				o.push("\\pard\\intbl");
				for(C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
					o.push(" " + (cell.w || (format_cell(cell), cell.w)));
					o.push("\\cell");
				}
				o.push("\\pard\\intbl\\row");
			}
			return o.join("") + "}";
		}
	
		return {
			to_workbook: rtf_to_workbook,
			to_sheet: rtf_to_sheet,
			from_sheet: sheet_to_rtf
		};
	})();
	function hex2RGB(h) {
		var o = h.slice(h[0]==="#"?1:0).slice(0,6);
		return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
	}
	function rgb2Hex(rgb) {
		for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
		return o.toString(16).toUpperCase().slice(1);
	}
	
	function rgb2HSL(rgb) {
		var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
		var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
		if(C === 0) return [0, 0, R];
	
		var H6 = 0, S = 0, L2 = (M + m);
		S = C / (L2 > 1 ? 2 - L2 : L2);
		switch(M){
			case R: H6 = ((G - B) / C + 6)%6; break;
			case G: H6 = ((B - R) / C + 2); break;
			case B: H6 = ((R - G) / C + 4); break;
		}
		return [H6 / 6, S, L2 / 2];
	}
	
	function hsl2RGB(hsl){
		var H = hsl[0], S = hsl[1], L = hsl[2];
		var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
		var rgb = [m,m,m], h6 = 6*H;
	
		var X;
		if(S !== 0) switch(h6|0) {
			case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
			case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
			case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
			case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
			case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
			case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
		}
		for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
		return rgb;
	}
	
	/* 18.8.3 bgColor tint algorithm */
	function rgb_tint(hex, tint) {
		if(tint === 0) return hex;
		var hsl = rgb2HSL(hex2RGB(hex));
		if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
		else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
		return rgb2Hex(hsl2RGB(hsl));
	}
	
	/* 18.3.1.13 width calculations */
	/* [MS-OI29500] 2.1.595 Column Width & Formatting */
	var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
	function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
	function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
	function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
	//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
	//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
	function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
	/* XLSX/XLSB/XLS specify width in units of MDW */
	function find_mdw_colw(collw) {
		var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
		if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
		MDW = _MDW;
	}
	/* XLML specifies width in terms of pixels */
	/*function find_mdw_wpx(wpx) {
		var delta = Infinity, guess = 0, _MDW = MIN_MDW;
		for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
			guess = char2width_(px2char_(wpx))*256;
			guess = (guess) % 1;
			if(guess > 0.5) guess--;
			if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
		}
		MDW = _MDW;
	}*/
	
	function process_col(coll) {
		if(coll.width) {
			coll.wpx = width2px(coll.width);
			coll.wch = px2char(coll.wpx);
			coll.MDW = MDW;
		} else if(coll.wpx) {
			coll.wch = px2char(coll.wpx);
			coll.width = char2width(coll.wch);
			coll.MDW = MDW;
		} else if(typeof coll.wch == 'number') {
			coll.width = char2width(coll.wch);
			coll.wpx = width2px(coll.width);
			coll.MDW = MDW;
		}
		if(coll.customWidth) delete coll.customWidth;
	}
	
	var DEF_PPI = 96, PPI = DEF_PPI;
	function px2pt(px) { return px * 96 / PPI; }
	function pt2px(pt) { return pt * PPI / 96; }
	
	/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
	var XLMLPatternTypeMap = {
		"None": "none",
		"Solid": "solid",
		"Gray50": "mediumGray",
		"Gray75": "darkGray",
		"Gray25": "lightGray",
		"HorzStripe": "darkHorizontal",
		"VertStripe": "darkVertical",
		"ReverseDiagStripe": "darkDown",
		"DiagStripe": "darkUp",
		"DiagCross": "darkGrid",
		"ThickDiagCross": "darkTrellis",
		"ThinHorzStripe": "lightHorizontal",
		"ThinVertStripe": "lightVertical",
		"ThinReverseDiagStripe": "lightDown",
		"ThinHorzCross": "lightGrid"
	};
	
	/* 18.8.5 borders CT_Borders */
	function parse_borders(t, styles, themes, opts) {
		styles.Borders = [];
		var border = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<borders': case '<borders>': case '</borders>': break;
	
				/* 18.8.4 border CT_Border */
				case '<border': case '<border>': case '<border/>':
					border = {};
					if(y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
					if(y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
					styles.Borders.push(border);
					break;
				case '</border>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<left/>': break;
				case '<left': case '<left>': break;
				case '</left>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<right/>': break;
				case '<right': case '<right>': break;
				case '</right>': break;
	
				/* 18.8.43 top CT_BorderPr */
				case '<top/>': break;
				case '<top': case '<top>': break;
				case '</top>': break;
	
				/* 18.8.6 bottom CT_BorderPr */
				case '<bottom/>': break;
				case '<bottom': case '<bottom>': break;
				case '</bottom>': break;
	
				/* 18.8.13 diagonal CT_BorderPr */
				case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
				case '</diagonal>': break;
	
				/* 18.8.25 horizontal CT_BorderPr */
				case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
				case '</horizontal>': break;
	
				/* 18.8.44 vertical CT_BorderPr */
				case '<vertical': case '<vertical>': case '<vertical/>': break;
				case '</vertical>': break;
	
				/* 18.8.37 start CT_BorderPr */
				case '<start': case '<start>': case '<start/>': break;
				case '</start>': break;
	
				/* 18.8.16 end CT_BorderPr */
				case '<end': case '<end>': case '<end/>': break;
				case '</end>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color>':
					break;
				case '<color/>': case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
				}
			}
		});
	}
	
	/* 18.8.21 fills CT_Fills */
	function parse_fills(t, styles, themes, opts) {
		styles.Fills = [];
		var fill = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fills': case '<fills>': case '</fills>': break;
	
				/* 18.8.20 fill CT_Fill */
				case '<fill>': case '<fill': case '<fill/>':
					fill = {}; styles.Fills.push(fill); break;
				case '</fill>': break;
	
				/* 18.8.24 gradientFill CT_GradientFill */
				case '<gradientFill>': break;
				case '<gradientFill':
				case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;
	
				/* 18.8.32 patternFill CT_PatternFill */
				case '<patternFill': case '<patternFill>':
					if(y.patternType) fill.patternType = y.patternType;
					break;
				case '<patternFill/>': case '</patternFill>': break;
	
				/* 18.8.3 bgColor CT_Color */
				case '<bgColor':
					if(!fill.bgColor) fill.bgColor = {};
					if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
					if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
					break;
				case '<bgColor/>': case '</bgColor>': break;
	
				/* 18.8.19 fgColor CT_Color */
				case '<fgColor':
					if(!fill.fgColor) fill.fgColor = {};
					if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
					break;
				case '<fgColor/>': case '</fgColor>': break;
	
				/* 18.8.38 stop CT_GradientStop */
				case '<stop': case '<stop/>': break;
				case '</stop>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color/>': break;
				case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
				}
			}
		});
	}
	
	/* 18.8.23 fonts CT_Fonts */
	function parse_fonts(t, styles, themes, opts) {
		styles.Fonts = [];
		var font = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fonts': case '<fonts>': case '</fonts>': break;
	
				/* 18.8.22 font CT_Font */
				case '<font': case '<font>': break;
				case '</font>': case '<font/>':
					styles.Fonts.push(font);
					font = {};
					break;
	
				/* 18.8.29 name CT_FontName */
				case '<name': if(y.val) font.name = utf8read(y.val); break;
				case '<name/>': case '</name>': break;
	
				/* 18.8.2  b CT_BooleanProperty */
				case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
				case '<b/>': font.bold = 1; break;
	
				/* 18.8.26 i CT_BooleanProperty */
				case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
				case '<i/>': font.italic = 1; break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					switch(y.val) {
						case "none": font.underline = 0x00; break;
						case "single": font.underline = 0x01; break;
						case "double": font.underline = 0x02; break;
						case "singleAccounting": font.underline = 0x21; break;
						case "doubleAccounting": font.underline = 0x22; break;
					} break;
				case '<u/>': font.underline = 1; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
				case '<strike/>': font.strike = 1; break;
	
				/* 18.4.2  outline CT_BooleanProperty */
				case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
				case '<outline/>': font.outline = 1; break;
	
				/* 18.8.36 shadow CT_BooleanProperty */
				case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
				case '<shadow/>': font.shadow = 1; break;
	
				/* 18.8.12 condense CT_BooleanProperty */
				case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
				case '<condense/>': font.condense = 1; break;
	
				/* 18.8.17 extend CT_BooleanProperty */
				case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
				case '<extend/>': font.extend = 1; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': if(y.val) font.sz = +y.val; break;
				case '<sz/>': case '</sz>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
				case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
				case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.18 family CT_FontFamily */
				case '<family': if(y.val) font.family = parseInt(y.val,10); break;
				case '<family/>': case '</family>': break;
	
				/* 18.8.35 scheme CT_FontScheme */
				case '<scheme': if(y.val) font.scheme = y.val; break;
				case '<scheme/>': case '</scheme>': break;
	
				/* 18.4.1 charset CT_IntProperty */
				case '<charset':
					if(y.val == '1') break;
					y.codepage = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.?.? color CT_Color */
				case '<color':
					if(!font.color) font.color = {};
					if(y.auto) font.color.auto = parsexmlbool(y.auto);
	
					if(y.rgb) font.color.rgb = y.rgb.slice(-6);
					else if(y.indexed) {
						font.color.index = parseInt(y.indexed, 10);
						var icv = XLSIcv[font.color.index];
						if(font.color.index == 81) icv = XLSIcv[1];
						if(!icv) icv = XLSIcv[1]; //throw new Error(x); // note: 206 is valid
						font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
					} else if(y.theme) {
						font.color.theme = parseInt(y.theme, 10);
						if(y.tint) font.color.tint = parseFloat(y.tint);
						if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
							font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
						}
					}
	
					break;
				case '<color/>': case '</color>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
				}
			}
		});
	}
	
	/* 18.8.31 numFmts CT_NumFmts */
	function parse_numFmts(t, styles, opts) {
		styles.NumberFmt = [];
		var k/*Array<number>*/ = (keys(table_fmt));
		for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = table_fmt[k[i]];
		var m = t[0].match(tagregex);
		if(!m) return;
		for(i=0; i < m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(strip_ns(y[0])) {
				case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
				case '<numFmt': {
					var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
					styles.NumberFmt[j] = f;
					if(j>0) {
						if(j > 0x188) {
							for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
							styles.NumberFmt[j] = f;
						}
						SSF_load(f,j);
					}
				} break;
				case '</numFmt>': break;
				default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
			}
		}
	}
	
	function write_numFmts(NF) {
		var o = ["<numFmts>"];
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
			for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
		});
		if(o.length === 1) return "";
		o[o.length] = ("</numFmts>");
		o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
		return o.join("");
	}
	
	/* 18.8.10 cellXfs CT_CellXfs */
	var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
	var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
	function parse_cellXfs(t, styles, opts) {
		styles.CellXf = [];
		var xf;
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x), i = 0;
			switch(strip_ns(y[0])) {
				case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;
	
				/* 18.8.45 xf CT_Xf */
				case '<xf': case '<xf/>':
					xf = y;
					delete xf[0];
					for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
						xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
					for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
						xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
					if(styles.NumberFmt && xf.numFmtId > 0x188) {
						for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
					}
					styles.CellXf.push(xf); break;
				case '</xf>': break;
	
				/* 18.8.1 alignment CT_CellAlignment */
				case '<alignment': case '<alignment/>':
					var alignment = {};
					if(y.vertical) alignment.vertical = y.vertical;
					if(y.horizontal) alignment.horizontal = y.horizontal;
					if(y.textRotation != null) alignment.textRotation = y.textRotation;
					if(y.indent) alignment.indent = y.indent;
					if(y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
					xf.alignment = alignment;
					break;
				case '</alignment>': break;
	
				/* 18.8.33 protection CT_CellProtection */
				case '<protection':
					break;
				case '</protection>': case '<protection/>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
				}
			}
		});
	}
	
	function write_cellXfs(cellXfs) {
		var o = [];
		o[o.length] = (writextag('cellXfs',null));
		cellXfs.forEach(function(c) {
			o[o.length] = (writextag('xf', null, c));
		});
		o[o.length] = ("</cellXfs>");
		if(o.length === 2) return "";
		o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
		return o.join("");
	}
	
	/* 18.8 Styles CT_Stylesheet*/
	var parse_sty_xml= (function make_pstyx() {
	var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
	var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
	var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
	var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
	var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
	
	return function parse_sty_xml(data, themes, opts) {
		var styles = {};
		if(!data) return styles;
		data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		/* 18.8.39 styleSheet CT_Stylesheet */
		var t;
	
		/* 18.8.31 numFmts CT_NumFmts ? */
		if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);
	
		/* 18.8.23 fonts CT_Fonts ? */
		if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);
	
		/* 18.8.21 fills CT_Fills ? */
		if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);
	
		/* 18.8.5  borders CT_Borders ? */
		if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);
	
		/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
		/* 18.8.8  cellStyles CT_CellStyles ? */
	
		/* 18.8.10 cellXfs CT_CellXfs ? */
		if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);
	
		/* 18.8.15 dxfs CT_Dxfs ? */
		/* 18.8.42 tableStyles CT_TableStyles ? */
		/* 18.8.11 colors CT_Colors ? */
		/* 18.2.10 extLst CT_ExtensionList ? */
	
		return styles;
	};
	})();
	
	function write_sty_xml(wb, opts) {
		var o = [XML_HEADER, writextag('styleSheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:vt': XMLNS.vt
		})], w;
		if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
		o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
		o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
		o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
		o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
		if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
		o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
		o[o.length] = ('<dxfs count="0"/>');
		o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');
	
		if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.657 BrtFmt */
	function parse_BrtFmt(data, length) {
		var numFmtId = data.read_shift(2);
		var stFmtCode = parse_XLWideString(data,length-2);
		return [numFmtId, stFmtCode];
	}
	function write_BrtFmt(i, f, o) {
		if(!o) o = new_buf(6 + 4 * f.length);
		o.write_shift(2, i);
		write_XLWideString(f, o);
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(o.l == null) o.l = o.length;
		return out;
	}
	
	/* [MS-XLSB] 2.4.659 BrtFont TODO */
	function parse_BrtFont(data, length, opts) {
		var out = ({});
	
		out.sz = data.read_shift(2) / 20;
	
		var grbit = parse_FontFlags(data, 2, opts);
		if(grbit.fItalic) out.italic = 1;
		if(grbit.fCondense) out.condense = 1;
		if(grbit.fExtend) out.extend = 1;
		if(grbit.fShadow) out.shadow = 1;
		if(grbit.fOutline) out.outline = 1;
		if(grbit.fStrikeout) out.strike = 1;
	
		var bls = data.read_shift(2);
		if(bls === 0x02BC) out.bold = 1;
	
		switch(data.read_shift(2)) {
			/* case 0: out.vertAlign = "baseline"; break; */
			case 1: out.vertAlign = "superscript"; break;
			case 2: out.vertAlign = "subscript"; break;
		}
	
		var underline = data.read_shift(1);
		if(underline != 0) out.underline = underline;
	
		var family = data.read_shift(1);
		if(family > 0) out.family = family;
	
		var bCharSet = data.read_shift(1);
		if(bCharSet > 0) out.charset = bCharSet;
	
		data.l++;
		out.color = parse_BrtColor(data, 8);
	
		switch(data.read_shift(1)) {
			/* case 0: out.scheme = "none": break; */
			case 1: out.scheme = "major"; break;
			case 2: out.scheme = "minor"; break;
		}
	
		out.name = parse_XLWideString(data, length - 21);
	
		return out;
	}
	function write_BrtFont(font, o) {
		if(!o) o = new_buf(25+4*32);
		o.write_shift(2, font.sz * 20);
		write_FontFlags(font, o);
		o.write_shift(2, font.bold ? 0x02BC : 0x0190);
		var sss = 0;
		if(font.vertAlign == "superscript") sss = 1;
		else if(font.vertAlign == "subscript") sss = 2;
		o.write_shift(2, sss);
		o.write_shift(1, font.underline || 0);
		o.write_shift(1, font.family || 0);
		o.write_shift(1, font.charset || 0);
		o.write_shift(1, 0);
		write_BrtColor(font.color, o);
		var scheme = 0;
		if(font.scheme == "major") scheme = 1;
		if(font.scheme == "minor") scheme = 2;
		o.write_shift(1, scheme);
		write_XLWideString(font.name, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.650 BrtFill */
	var XLSBFillPTNames = [
		"none",
		"solid",
		"mediumGray",
		"darkGray",
		"lightGray",
		"darkHorizontal",
		"darkVertical",
		"darkDown",
		"darkUp",
		"darkGrid",
		"darkTrellis",
		"lightHorizontal",
		"lightVertical",
		"lightDown",
		"lightUp",
		"lightGrid",
		"lightTrellis",
		"gray125",
		"gray0625"
	];
	var rev_XLSBFillPTNames;
	/* TODO: gradient fill representation */
	var parse_BrtFill = parsenoop;
	function write_BrtFill(fill, o) {
		if(!o) o = new_buf(4*3 + 8*7 + 16*1);
		if(!rev_XLSBFillPTNames) rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
		var fls = rev_XLSBFillPTNames[fill.patternType];
		if(fls == null) fls = 0x28;
		o.write_shift(4, fls);
		var j = 0;
		if(fls != 0x28) {
			/* TODO: custom FG Color */
			write_BrtColor({auto:1}, o);
			/* TODO: custom BG Color */
			write_BrtColor({auto:1}, o);
	
			for(; j < 12; ++j) o.write_shift(4, 0);
		} else {
			for(; j < 4; ++j) o.write_shift(4, 0);
	
			for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
			/* iGradientType */
			/* xnumDegree */
			/* xnumFillToLeft */
			/* xnumFillToRight */
			/* xnumFillToTop */
			/* xnumFillToBottom */
			/* cNumStop */
			/* xfillGradientStop */
		}
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.824 BrtXF */
	function parse_BrtXF(data, length) {
		var tgt = data.l + length;
		var ixfeParent = data.read_shift(2);
		var ifmt = data.read_shift(2);
		data.l = tgt;
		return {ixfe:ixfeParent, numFmtId:ifmt };
	}
	function write_BrtXF(data, ixfeP, o) {
		if(!o) o = new_buf(16);
		o.write_shift(2, ixfeP||0);
		o.write_shift(2, data.numFmtId||0);
		o.write_shift(2, 0); /* iFont */
		o.write_shift(2, 0); /* iFill */
		o.write_shift(2, 0); /* ixBorder */
		o.write_shift(1, 0); /* trot */
		o.write_shift(1, 0); /* indent */
		var flow = 0;
		o.write_shift(1, flow); /* flags */
		o.write_shift(1, 0); /* flags */
		o.write_shift(1, 0); /* xfGrbitAtr */
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.4 Blxf TODO */
	function write_Blxf(data, o) {
		if(!o) o = new_buf(10);
		o.write_shift(1, 0); /* dg */
		o.write_shift(1, 0);
		o.write_shift(4, 0); /* color */
		o.write_shift(4, 0); /* color */
		return o;
	}
	/* [MS-XLSB] 2.4.302 BrtBorder TODO */
	var parse_BrtBorder = parsenoop;
	function write_BrtBorder(border, o) {
		if(!o) o = new_buf(51);
		o.write_shift(1, 0); /* diagonal */
		write_Blxf(null, o); /* top */
		write_Blxf(null, o); /* bottom */
		write_Blxf(null, o); /* left */
		write_Blxf(null, o); /* right */
		write_Blxf(null, o); /* diag */
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.763 BrtStyle TODO */
	function write_BrtStyle(style, o) {
		if(!o) o = new_buf(12+4*10);
		o.write_shift(4, style.xfId);
		o.write_shift(2, 1);
		o.write_shift(1, +style.builtinId);
		o.write_shift(1, 0); /* iLevel */
		write_XLNullableWideString(style.name || "", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
	function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
		var o = new_buf(4+256*2*4);
		o.write_shift(4, cnt);
		write_XLNullableWideString(defTableStyle, o);
		write_XLNullableWideString(defPivotStyle, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function parse_sty_bin(data, themes, opts) {
		var styles = {};
		styles.NumberFmt = ([]);
		for(var y in table_fmt) styles.NumberFmt[y] = table_fmt[y];
	
		styles.CellXf = [];
		styles.Fonts = [];
		var state = [];
		var pass = false;
		recordhopper(data, function hopper_sty(val, R, RT) {
			switch(RT) {
				case 0x002C: /* BrtFmt */
					styles.NumberFmt[val[0]] = val[1]; SSF_load(val[1], val[0]);
					break;
				case 0x002B: /* BrtFont */
					styles.Fonts.push(val);
					if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
						val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
					}
					break;
				case 0x0401: /* BrtKnownFonts */ break;
				case 0x002D: /* BrtFill */
					break;
				case 0x002E: /* BrtBorder */
					break;
				case 0x002F: /* BrtXF */
					if(state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */) {
						styles.CellXf.push(val);
					}
					break;
				case 0x0030: /* BrtStyle */
				case 0x01FB: /* BrtDXF */
				case 0x023C: /* BrtMRUColor */
				case 0x01DB: /* BrtIndexedColor */
					break;
	
				case 0x0493: /* BrtDXF14 */
				case 0x0836: /* BrtDXF15 */
				case 0x046A: /* BrtSlicerStyleElement */
				case 0x0200: /* BrtTableStyleElement */
				case 0x082F: /* BrtTimelineStyleElement */
				case 0x0C00: /* BrtUid */
					break;
	
				case 0x0023: /* BrtFRTBegin */
					pass = true; break;
				case 0x0024: /* BrtFRTEnd */
					pass = false; break;
				case 0x0025: /* BrtACBegin */
					state.push(RT); pass = true; break;
				case 0x0026: /* BrtACEnd */
					state.pop(); pass = false; break;
	
				default:
					if(R.T > 0) state.push(RT);
					else if(R.T < 0) state.pop();
					else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return styles;
	}
	
	function write_FMTS_bin(ba, NF) {
		if(!NF) return;
		var cnt = 0;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
		});
	
		if(cnt == 0) return;
		write_record(ba, 0x0267 /* BrtBeginFmts */, write_UInt32LE(cnt));
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, 0x002C /* BrtFmt */, write_BrtFmt(i, NF[i]));
		});
		write_record(ba, 0x0268 /* BrtEndFmts */);
	}
	
	function write_FONTS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, 0x0263 /* BrtBeginFonts */, write_UInt32LE(cnt));
		write_record(ba, 0x002B /* BrtFont */, write_BrtFont({
			sz:12,
			color: {theme:1},
			name: "Calibri",
			family: 2,
			scheme: "minor"
		}));
		/* 1*65491BrtFont [ACFONTS] */
		write_record(ba, 0x0264 /* BrtEndFonts */);
	}
	
	function write_FILLS_bin(ba) {
		var cnt = 2;
	
		if(cnt == 0) return;
		write_record(ba, 0x025B /* BrtBeginFills */, write_UInt32LE(cnt));
		write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"none"}));
		write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"gray125"}));
		/* 1*65431BrtFill */
		write_record(ba, 0x025C /* BrtEndFills */);
	}
	
	function write_BORDERS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, 0x0265 /* BrtBeginBorders */, write_UInt32LE(cnt));
		write_record(ba, 0x002E /* BrtBorder */, write_BrtBorder({}));
		/* 1*65430BrtBorder */
		write_record(ba, 0x0266 /* BrtEndBorders */);
	}
	
	function write_CELLSTYLEXFS_bin(ba) {
		var cnt = 1;
		write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */, write_UInt32LE(cnt));
		write_record(ba, 0x002F /* BrtXF */, write_BrtXF({
			numFmtId: 0,
			fontId:   0,
			fillId:   0,
			borderId: 0
		}, 0xFFFF));
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, 0x0273 /* BrtEndCellStyleXFs */);
	}
	
	function write_CELLXFS_bin(ba, data) {
		write_record(ba, 0x0269 /* BrtBeginCellXFs */, write_UInt32LE(data.length));
		data.forEach(function(c) { write_record(ba, 0x002F /* BrtXF */, write_BrtXF(c,0)); });
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, 0x026A /* BrtEndCellXFs */);
	}
	
	function write_STYLES_bin(ba) {
		var cnt = 1;
	
		write_record(ba, 0x026B /* BrtBeginStyles */, write_UInt32LE(cnt));
		write_record(ba, 0x0030 /* BrtStyle */, write_BrtStyle({
			xfId:0,
			builtinId:0,
			name:"Normal"
		}));
		/* 1*65430(BrtStyle *FRT) */
		write_record(ba, 0x026C /* BrtEndStyles */);
	}
	
	function write_DXFS_bin(ba) {
		var cnt = 0;
	
		write_record(ba, 0x01F9 /* BrtBeginDXFs */, write_UInt32LE(cnt));
		/* *2147483647(BrtDXF *FRT) */
		write_record(ba, 0x01FA /* BrtEndDXFs */);
	}
	
	function write_TABLESTYLES_bin(ba) {
		var cnt = 0;
	
		write_record(ba, 0x01FC /* BrtBeginTableStyles */, write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
		/* *TABLESTYLE */
		write_record(ba, 0x01FD /* BrtEndTableStyles */);
	}
	
	function write_COLORPALETTE_bin() {
		return;
		/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function write_sty_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, 0x0116 /* BrtBeginStyleSheet */);
		write_FMTS_bin(ba, wb.SSF);
		write_FONTS_bin(ba, wb);
		write_FILLS_bin(ba, wb);
		write_BORDERS_bin(ba, wb);
		write_CELLSTYLEXFS_bin(ba, wb);
		write_CELLXFS_bin(ba, opts.cellXfs);
		write_STYLES_bin(ba, wb);
		write_DXFS_bin(ba, wb);
		write_TABLESTYLES_bin(ba, wb);
		write_COLORPALETTE_bin(ba, wb);
		/* FRTSTYLESHEET*/
		write_record(ba, 0x0117 /* BrtEndStyleSheet */);
		return ba.end();
	}
	/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */
	var XLSXThemeClrScheme = [
		'</a:lt1>', '</a:dk1>', '</a:lt2>', '</a:dk2>',
		'</a:accent1>', '</a:accent2>', '</a:accent3>',
		'</a:accent4>', '</a:accent5>', '</a:accent6>',
		'</a:hlink>', '</a:folHlink>'
	];
	/* 20.1.6.2 clrScheme CT_ColorScheme */
	function parse_clrScheme(t, themes, opts) {
		themes.themeElements.clrScheme = [];
		var color = {};
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
				case '<a:clrScheme': case '</a:clrScheme>': break;
	
				/* 20.1.2.3.32 srgbClr CT_SRgbColor */
				case '<a:srgbClr':
					color.rgb = y.val; break;
	
				/* 20.1.2.3.33 sysClr CT_SystemColor */
				case '<a:sysClr':
					color.rgb = y.lastClr; break;
	
				/* 20.1.4.1.1 accent1 (Accent 1) */
				/* 20.1.4.1.2 accent2 (Accent 2) */
				/* 20.1.4.1.3 accent3 (Accent 3) */
				/* 20.1.4.1.4 accent4 (Accent 4) */
				/* 20.1.4.1.5 accent5 (Accent 5) */
				/* 20.1.4.1.6 accent6 (Accent 6) */
				/* 20.1.4.1.9 dk1 (Dark 1) */
				/* 20.1.4.1.10 dk2 (Dark 2) */
				/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
				/* 20.1.4.1.19 hlink (Hyperlink) */
				/* 20.1.4.1.22 lt1 (Light 1) */
				/* 20.1.4.1.23 lt2 (Light 2) */
				case '<a:dk1>': case '</a:dk1>':
				case '<a:lt1>': case '</a:lt1>':
				case '<a:dk2>': case '</a:dk2>':
				case '<a:lt2>': case '</a:lt2>':
				case '<a:accent1>': case '</a:accent1>':
				case '<a:accent2>': case '</a:accent2>':
				case '<a:accent3>': case '</a:accent3>':
				case '<a:accent4>': case '</a:accent4>':
				case '<a:accent5>': case '</a:accent5>':
				case '<a:accent6>': case '</a:accent6>':
				case '<a:hlink>': case '</a:hlink>':
				case '<a:folHlink>': case '</a:folHlink>':
					if (y[0].charAt(1) === '/') {
						themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
						color = {};
					} else {
						color.name = y[0].slice(3, y[0].length - 1);
					}
					break;
	
				default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
			}
		});
	}
	
	/* 20.1.4.1.18 fontScheme CT_FontScheme */
	function parse_fontScheme() { }
	
	/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
	function parse_fmtScheme() { }
	
	var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
	var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
	var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
	
	/* 20.1.6.10 themeElements CT_BaseStyles */
	function parse_themeElements(data, themes, opts) {
		themes.themeElements = {};
	
		var t;
	
		[
			/* clrScheme CT_ColorScheme */
			['clrScheme', clrsregex, parse_clrScheme],
			/* fontScheme CT_FontScheme */
			['fontScheme', fntsregex, parse_fontScheme],
			/* fmtScheme CT_StyleMatrix */
			['fmtScheme', fmtsregex, parse_fmtScheme]
		].forEach(function(m) {
			if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
			m[2](t, themes, opts);
		});
	}
	
	var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
	
	/* 14.2.7 Theme Part */
	function parse_theme_xml(data, opts) {
		/* 20.1.6.9 theme CT_OfficeStyleSheet */
		if(!data || data.length === 0) data = write_theme();
	
		var t;
		var themes = {};
	
		/* themeElements CT_BaseStyles */
		if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
		parse_themeElements(t[0], themes, opts);
		themes.raw = data;
		return themes;
	}
	
	function write_theme(Themes, opts) {
		if(opts && opts.themeXLSX) return opts.themeXLSX;
		if(Themes && typeof Themes.raw == "string") return Themes.raw;
		var o = [XML_HEADER];
		o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
		o[o.length] =  '<a:themeElements>';
	
		o[o.length] =   '<a:clrScheme name="Office">';
		o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
		o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
		o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
		o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
		o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
		o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
		o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
		o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
		o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
		o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
		o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
		o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
		o[o.length] =   '</a:clrScheme>';
	
		o[o.length] =   '<a:fontScheme name="Office">';
		o[o.length] =    '<a:majorFont>';
		o[o.length] =     '<a:latin typeface="Cambria"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:majorFont>';
		o[o.length] =    '<a:minorFont>';
		o[o.length] =     '<a:latin typeface="Calibri"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:minorFont>';
		o[o.length] =   '</a:fontScheme>';
	
		o[o.length] =   '<a:fmtScheme name="Office">';
		o[o.length] =    '<a:fillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:fillStyleLst>';
		o[o.length] =    '<a:lnStyleLst>';
		o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =    '</a:lnStyleLst>';
		o[o.length] =    '<a:effectStyleLst>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
		o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =    '</a:effectStyleLst>';
		o[o.length] =    '<a:bgFillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:bgFillStyleLst>';
		o[o.length] =   '</a:fmtScheme>';
		o[o.length] =  '</a:themeElements>';
	
		o[o.length] =  '<a:objectDefaults>';
		o[o.length] =   '<a:spDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:spDef>';
		o[o.length] =   '<a:lnDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:lnDef>';
		o[o.length] =  '</a:objectDefaults>';
		o[o.length] =  '<a:extraClrSchemeLst/>';
		o[o.length] = '</a:theme>';
		return o.join("");
	}
	/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
	function parse_Theme(blob, length, opts) {
		var end = blob.l + length;
		var dwThemeVersion = blob.read_shift(4);
		if(dwThemeVersion === 124226) return;
		if(!opts.cellStyles) { blob.l = end; return; }
		var data = blob.slice(blob.l);
		blob.l = end;
		var zip; try { zip = zip_read(data, {type: "array"}); } catch(e) { return; }
		var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
		if(!themeXML) return;
		return parse_theme_xml(themeXML, opts);
	}
	
	/* 2.5.49 */
	function parse_ColorTheme(blob) { return blob.read_shift(4); }
	
	/* 2.5.155 */
	function parse_FullColorExt(blob) {
		var o = {};
		o.xclrType = blob.read_shift(2);
		o.nTintShade = blob.read_shift(2);
		switch(o.xclrType) {
			case 0: blob.l += 4; break;
			case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
			case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
			case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
			case 4: blob.l += 4; break;
		}
		blob.l += 8;
		return o;
	}
	
	/* 2.5.164 TODO: read 7 bits*/
	function parse_IcvXF(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* 2.5.280 */
	function parse_XFExtGradient(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* [MS-XLS] 2.5.108 */
	function parse_ExtProp(blob) {
		var extType = blob.read_shift(2);
		var cb = blob.read_shift(2) - 4;
		var o = [extType];
		switch(extType) {
			case 0x04: case 0x05: case 0x07: case 0x08:
			case 0x09: case 0x0A: case 0x0B: case 0x0D:
				o[1] = parse_FullColorExt(blob, cb); break;
			case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
			case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
			default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
		}
		return o;
	}
	
	/* 2.4.355 */
	function parse_XFExt(blob, length) {
		var end = blob.l + length;
		blob.l += 2;
		var ixfe = blob.read_shift(2);
		blob.l += 2;
		var cexts = blob.read_shift(2);
		var ext = [];
		while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
		return {ixfe:ixfe, ext:ext};
	}
	
	/* xf is an XF, see parse_XFExt for xfext */
	function update_xfext(xf, xfext) {
		xfext.forEach(function(xfe) {
			switch(xfe[0]) { /* 2.5.108 extPropData */
				case 0x04: break; /* foreground color */
				case 0x05: break; /* background color */
				case 0x06: break; /* gradient fill */
				case 0x07: break; /* top cell border color */
				case 0x08: break; /* bottom cell border color */
				case 0x09: break; /* left cell border color */
				case 0x0a: break; /* right cell border color */
				case 0x0b: break; /* diagonal cell border color */
				case 0x0d: /* text color */
					break;
				case 0x0e: break; /* font scheme */
				case 0x0f: break; /* indentation level */
			}
		});
	}
	
	function parse_BrtMdtinfo(data, length) {
	  return {
	    flags: data.read_shift(4),
	    version: data.read_shift(4),
	    name: parse_XLWideString(data, length - 8)
	  };
	}
	function write_BrtMdtinfo(data) {
	  var o = new_buf(12 + 2 * data.name.length);
	  o.write_shift(4, data.flags);
	  o.write_shift(4, data.version);
	  write_XLWideString(data.name, o);
	  return o.slice(0, o.l);
	}
	function parse_BrtMdb(data) {
	  var out = [];
	  var cnt = data.read_shift(4);
	  while (cnt-- > 0)
	    out.push([data.read_shift(4), data.read_shift(4)]);
	  return out;
	}
	function write_BrtMdb(mdb) {
	  var o = new_buf(4 + 8 * mdb.length);
	  o.write_shift(4, mdb.length);
	  for (var i = 0; i < mdb.length; ++i) {
	    o.write_shift(4, mdb[i][0]);
	    o.write_shift(4, mdb[i][1]);
	  }
	  return o;
	}
	function write_BrtBeginEsfmd(cnt, name) {
	  var o = new_buf(8 + 2 * name.length);
	  o.write_shift(4, cnt);
	  write_XLWideString(name, o);
	  return o.slice(0, o.l);
	}
	function parse_BrtBeginEsmdb(data) {
	  data.l += 4;
	  return data.read_shift(4) != 0;
	}
	function write_BrtBeginEsmdb(cnt, cm) {
	  var o = new_buf(8);
	  o.write_shift(4, cnt);
	  o.write_shift(4, cm ? 1 : 0);
	  return o;
	}
	function parse_xlmeta_bin(data, name, _opts) {
	  var out = { Types: [], Cell: [], Value: [] };
	  var opts = _opts || {};
	  var state = [];
	  var pass = false;
	  var metatype = 2;
	  recordhopper(data, function(val, R, RT) {
	    switch (RT) {
	      case 335:
	        out.Types.push({ name: val.name });
	        break;
	      case 51:
	        val.forEach(function(r) {
	          if (metatype == 1)
	            out.Cell.push({ type: out.Types[r[0] - 1].name, index: r[1] });
	          else if (metatype == 0)
	            out.Value.push({ type: out.Types[r[0] - 1].name, index: r[1] });
	        });
	        break;
	      case 337:
	        metatype = val ? 1 : 0;
	        break;
	      case 338:
	        metatype = 2;
	        break;
	      case 35:
	        state.push(RT);
	        pass = true;
	        break;
	      case 36:
	        state.pop();
	        pass = false;
	        break;
	      default:
	        if (R.T) {
	        } else if (!pass || opts.WTF && state[state.length - 1] != 35)
	          throw new Error("Unexpected record 0x" + RT.toString(16));
	    }
	  });
	  return out;
	}
	function write_xlmeta_bin() {
	  var ba = buf_array();
	  write_record(ba, 332);
	  write_record(ba, 334, write_UInt32LE(1));
	  write_record(ba, 335, write_BrtMdtinfo({
	    name: "XLDAPR",
	    version: 12e4,
	    flags: 3496657072
	  }));
	  write_record(ba, 336);
	  write_record(ba, 339, write_BrtBeginEsfmd(1, "XLDAPR"));
	  write_record(ba, 52);
	  write_record(ba, 35, write_UInt32LE(514));
	  write_record(ba, 4096, write_UInt32LE(0));
	  write_record(ba, 4097, writeuint16(1));
	  write_record(ba, 36);
	  write_record(ba, 53);
	  write_record(ba, 340);
	  write_record(ba, 337, write_BrtBeginEsmdb(1, true));
	  write_record(ba, 51, write_BrtMdb([[1, 0]]));
	  write_record(ba, 338);
	  write_record(ba, 333);
	  return ba.end();
	}
	function parse_xlmeta_xml(data, name, opts) {
	  var out = { Types: [], Cell: [], Value: [] };
	  if (!data)
	    return out;
	  var pass = false;
	  var metatype = 2;
	  var lastmeta;
	  data.replace(tagregex, function(x) {
	    var y = parsexmltag(x);
	    switch (strip_ns(y[0])) {
	      case "<?xml":
	        break;
	      case "<metadata":
	      case "</metadata>":
	        break;
	      case "<metadataTypes":
	      case "</metadataTypes>":
	        break;
	      case "<metadataType":
	        out.Types.push({ name: y.name });
	        break;
	      case "</metadataType>":
	        break;
	      case "<futureMetadata":
	        for (var j = 0; j < out.Types.length; ++j)
	          if (out.Types[j].name == y.name)
	            lastmeta = out.Types[j];
	        break;
	      case "</futureMetadata>":
	        break;
	      case "<bk>":
	        break;
	      case "</bk>":
	        break;
	      case "<rc":
	        if (metatype == 1)
	          out.Cell.push({ type: out.Types[y.t - 1].name, index: +y.v });
	        else if (metatype == 0)
	          out.Value.push({ type: out.Types[y.t - 1].name, index: +y.v });
	        break;
	      case "</rc>":
	        break;
	      case "<cellMetadata":
	        metatype = 1;
	        break;
	      case "</cellMetadata>":
	        metatype = 2;
	        break;
	      case "<valueMetadata":
	        metatype = 0;
	        break;
	      case "</valueMetadata>":
	        metatype = 2;
	        break;
	      case "<extLst":
	      case "<extLst>":
	      case "</extLst>":
	      case "<extLst/>":
	        break;
	      case "<ext":
	        pass = true;
	        break;
	      case "</ext>":
	        pass = false;
	        break;
	      case "<rvb":
	        if (!lastmeta)
	          break;
	        if (!lastmeta.offsets)
	          lastmeta.offsets = [];
	        lastmeta.offsets.push(+y.i);
	        break;
	      default:
	        if (!pass && opts.WTF)
	          throw new Error("unrecognized " + y[0] + " in metadata");
	    }
	    return x;
	  });
	  return out;
	}
	function write_xlmeta_xml() {
	  var o = [XML_HEADER];
	  o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
	  return o.join("");
	}
	/* 18.6 Calculation Chain */
	function parse_cc_xml(data) {
		var d = [];
		if(!data) return d;
		var i = 1;
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				/* 18.6.2  calcChain CT_CalcChain 1 */
				case '<calcChain': case '<calcChain>': case '</calcChain>': break;
				/* 18.6.1  c CT_CalcCell 1 */
				case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
			}
		});
		return d;
	}
	
	//function write_cc_xml(data, opts) { }
	
	/* [MS-XLSB] 2.6.4.1 */
	function parse_BrtCalcChainItem$(data) {
		var out = {};
		out.i = data.read_shift(4);
		var cell = {};
		cell.r = data.read_shift(4);
		cell.c = data.read_shift(4);
		out.r = encode_cell(cell);
		var flags = data.read_shift(1);
		if(flags & 0x2) out.l = '1';
		if(flags & 0x8) out.a = '1';
		return out;
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_bin(data, name, opts) {
		var out = [];
		var pass = false;
		recordhopper(data, function hopper_cc(val, R, RT) {
			switch(RT) {
				case 0x003F: /* 'BrtCalcChainItem$' */
					out.push(val); break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return out;
	}
	
	//function write_cc_bin(data, opts) { }
	/* 18.14 Supplementary Workbook Data */
	function parse_xlink_xml() {
		//var opts = _opts || {};
		//if(opts.WTF) throw "XLSX External Link";
	}
	
	/* [MS-XLSB] 2.1.7.25 External Link */
	function parse_xlink_bin(data, rel, name, _opts) {
		if(!data) return data;
		var opts = _opts || {};
	
		var pass = false, end = false;
	
		recordhopper(data, function xlink_parse(val, R, RT) {
			if(end) return;
			switch(RT) {
				case 0x0167: /* 'BrtSupTabs' */
				case 0x016B: /* 'BrtExternTableStart' */
				case 0x016C: /* 'BrtExternTableEnd' */
				case 0x016E: /* 'BrtExternRowHdr' */
				case 0x016F: /* 'BrtExternCellBlank' */
				case 0x0170: /* 'BrtExternCellReal' */
				case 0x0171: /* 'BrtExternCellBool' */
				case 0x0172: /* 'BrtExternCellError' */
				case 0x0173: /* 'BrtExternCellString' */
				case 0x01D8: /* 'BrtExternValueMeta' */
				case 0x0241: /* 'BrtSupNameStart' */
				case 0x0242: /* 'BrtSupNameValueStart' */
				case 0x0243: /* 'BrtSupNameValueEnd' */
				case 0x0244: /* 'BrtSupNameNum' */
				case 0x0245: /* 'BrtSupNameErr' */
				case 0x0246: /* 'BrtSupNameSt' */
				case 0x0247: /* 'BrtSupNameNil' */
				case 0x0248: /* 'BrtSupNameBool' */
				case 0x0249: /* 'BrtSupNameFmla' */
				case 0x024A: /* 'BrtSupNameBits' */
				case 0x024B: /* 'BrtSupNameEnd' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	}
	/* 20.5 DrawingML - SpreadsheetML Drawing */
	/* 20.5.2.35 wsDr CT_Drawing */
	function parse_drawing(data, rels) {
		if(!data) return "??";
		/*
		  Chartsheet Drawing:
		   - 20.5.2.35 wsDr CT_Drawing
		    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
		     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
		      - 20.1.2.2.16 graphic CT_GraphicalObject
		       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
	          - chart reference
		   the actual type is based on the URI of the graphicData
			TODO: handle embedded charts and other types of graphics
		*/
		var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];
	
		return rels['!id'][id].Target;
	}
	
	/* L.5.5.2 SpreadsheetML Comments + VML Schema */
	var _shapeid = 1024;
	function write_comments_vml(rId, comments) {
		var csize = [21600, 21600];
		/* L.5.2.1.2 Path Attribute */
		var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
		var o = [
			writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
			writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
			writextag("v:shapetype", [
				writextag("v:stroke", null, {joinstyle:"miter"}),
				writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
			].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
		];
		while(_shapeid < rId * 1000) _shapeid += 1000;
	
		comments.forEach(function(x) {
		var c = decode_cell(x[0]);
		var fillopts = {'color2':"#BEFF82", 'type':"gradient"};
		if(fillopts.type == "gradient") fillopts.angle = "-180";
		var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}) : null;
		var fillxml = writextag('v:fill', fillparm, fillopts);
	
		var shadata = ({on:"t", 'obscured':"t"});
		++_shapeid;
	
		o = o.concat([
		'<v:shape' + wxt_helper({
			id:'_x0000_s' + _shapeid,
			type:"#_x0000_t202",
			style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
			fillcolor:"#ECFAD4",
			strokecolor:"#edeaa1"
		}) + '>',
			fillxml,
			writextag("v:shadow", null, shadata),
			writextag("v:path", null, {'o:connecttype':"none"}),
			'<v:textbox><div style="text-align:left"></div></v:textbox>',
			'<x:ClientData ObjectType="Note">',
				'<x:MoveWithCells/>',
				'<x:SizeWithCells/>',
				/* Part 4 19.4.2.3 Anchor (Anchor) */
				writetag('x:Anchor', [c.c+1, 0, c.r+1, 0, c.c+3, 20, c.r+5, 20].join(",")),
				writetag('x:AutoFill', "False"),
				writetag('x:Row', String(c.r)),
				writetag('x:Column', String(c.c)),
				x[1].hidden ? '' : '<x:Visible/>',
			'</x:ClientData>',
		'</v:shape>'
		]); });
		o.push('</xml>');
		return o.join("");
	}
	function sheet_insert_comments(sheet, comments, threaded, people) {
		var dense = Array.isArray(sheet);
		var cell;
		comments.forEach(function(comment) {
			var r = decode_cell(comment.ref);
			if(dense) {
				if(!sheet[r.r]) sheet[r.r] = [];
				cell = sheet[r.r][r.c];
			} else cell = sheet[comment.ref];
			if (!cell) {
				cell = ({t:"z"});
				if(dense) sheet[r.r][r.c] = cell;
				else sheet[comment.ref] = cell;
				var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
				if(range.s.r > r.r) range.s.r = r.r;
				if(range.e.r < r.r) range.e.r = r.r;
				if(range.s.c > r.c) range.s.c = r.c;
				if(range.e.c < r.c) range.e.c = r.c;
				var encoded = encode_range(range);
				if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
			}
	
			if (!cell.c) cell.c = [];
			var o = ({a: comment.author, t: comment.t, r: comment.r, T: threaded});
			if(comment.h) o.h = comment.h;
	
			/* threaded comments always override */
			for(var i = cell.c.length - 1; i >= 0; --i) {
				if(!threaded && cell.c[i].T) return;
				if(threaded && !cell.c[i].T) cell.c.splice(i, 1);
			}
			if(threaded && people) for(i = 0; i < people.length; ++i) {
				if(o.a == people[i].id) { o.a = people[i].name || o.a; break; }
			}
			cell.c.push(o);
		});
	}
	
	/* 18.7 Comments */
	function parse_comments_xml(data, opts) {
		/* 18.7.6 CT_Comments */
		if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
		var authors = [];
		var commentList = [];
		var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
		if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
			if(a) authors.push(a[1]);
		});
		var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
		if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
			if(!cm) return;
			var y = parsexmltag(cm[0]);
			var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
			var cell = decode_cell(y.ref);
			if(opts.sheetRows && opts.sheetRows <= cell.r) return;
			var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
			var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
			comment.r = rt.r;
			if(rt.r == "<t></t>") rt.t = rt.h = "";
			comment.t = (rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");
			if(opts.cellHTML) comment.h = rt.h;
			commentList.push(comment);
		});
		return commentList;
	}
	
	function write_comments_xml(data) {
		var o = [XML_HEADER, writextag('comments', null, { 'xmlns': XMLNS_main[0] })];
	
		var iauthor = [];
		o.push("<authors>");
		data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
			if(iauthor.indexOf(a) == -1) {
				iauthor.push(a);
				o.push("<author>" + a + "</author>");
			}
			if(w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
				iauthor.push("tc=" + w.ID);
				o.push("<author>" + "tc=" + w.ID + "</author>");
			}
		}); });
		if(iauthor.length == 0) { iauthor.push("SheetJ5"); o.push("<author>SheetJ5</author>"); }
		o.push("</authors>");
		o.push("<commentList>");
		data.forEach(function(d) {
			/* 18.7.3 CT_Comment */
			var lastauthor = 0, ts = [];
			if(d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
			else d[1].forEach(function(c) {
				if(c.a) lastauthor = iauthor.indexOf(escapexml(c.a));
				ts.push(c.t||"");
			});
			o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
			if(ts.length <= 1) o.push(writetag("t", escapexml(ts[0]||"")));
			else {
				/* based on Threaded Comments -> Comments projection */
				var t = "Comment:\n    " + (ts[0]) + "\n";
				for(var i = 1; i < ts.length; ++i) t += "Reply:\n    " + ts[i] + "\n";
				o.push(writetag("t", escapexml(t)));
			}
			o.push('</text></comment>');
		});
		o.push("</commentList>");
		if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSX] 2.1.17 */
	function parse_tcmnt_xml(data, opts) {
		var out = [];
		var pass = false, comment = {}, tidx = 0;
		data.replace(tagregex, function xml_tcmnt(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 2.6.207 ThreadedComments CT_ThreadedComments */
				case '<ThreadedComments': break;
				case '</ThreadedComments>': break;
	
				/* 2.6.205 threadedComment CT_ThreadedComment */
				case '<threadedComment': comment = {author: y.personId, guid: y.id, ref: y.ref, T: 1}; break;
				case '</threadedComment>': if(comment.t != null) out.push(comment); break;
	
				case '<text>': case '<text': tidx = idx + x.length; break;
				case '</text>': comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n"); break;
	
				/* 2.6.206 mentions CT_ThreadedCommentMentions TODO */
				case '<mentions': case '<mentions>': pass = true; break;
				case '</mentions>': pass = false; break;
	
				/* 2.6.202 mention CT_Mention TODO */
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break;
				case '</ext>': pass=false; break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
			}
			return x;
		});
		return out;
	}
	
	function write_tcmnt_xml(comments, people, opts) {
		var o = [XML_HEADER, writextag('ThreadedComments', null, { 'xmlns': XMLNS.TCMNT }).replace(/[\/]>/, ">")];
		comments.forEach(function(carr) {
			var rootid = "";
			(carr[1] || []).forEach(function(c, idx) {
				if(!c.T) { delete c.ID; return; }
				if(c.a && people.indexOf(c.a) == -1) people.push(c.a);
				var tcopts = {
					ref: carr[0],
					id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
				};
				if(idx == 0) rootid = tcopts.id;
				else tcopts.parentId = rootid;
				c.ID = tcopts.id;
				if(c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
				o.push(writextag('threadedComment', writetag('text', c.t||""), tcopts));
			});
		});
		o.push('</ThreadedComments>');
		return o.join("");
	}
	
	/* [MS-XLSX] 2.1.18 */
	function parse_people_xml(data, opts) {
		var out = [];
		var pass = false;
		data.replace(tagregex, function xml_tcmnt(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 2.4.85 personList CT_PersonList */
				case '<personList': break;
				case '</personList>': break;
	
				/* 2.6.203 person CT_Person TODO: providers */
				case '<person': out.push({name: y.displayname, id: y.id }); break;
				case '</person>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break;
				case '</ext>': pass=false; break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
			}
			return x;
		});
		return out;
	}
	function write_people_xml(people/*, opts*/) {
		var o = [XML_HEADER, writextag('personList', null, {
			'xmlns': XMLNS.TCMNT,
			'xmlns:x': XMLNS_main[0]
		}).replace(/[\/]>/, ">")];
		people.forEach(function(person, idx) {
			o.push(writextag('person', null, {
				displayName: person,
				id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
				userId: person,
				providerId: "None"
			}));
		});
		o.push("</personList>");
		return o.join("");
	}
	/* [MS-XLSB] 2.4.28 BrtBeginComment */
	function parse_BrtBeginComment(data) {
		var out = {};
		out.iauthor = data.read_shift(4);
		var rfx = parse_UncheckedRfX(data, 16);
		out.rfx = rfx.s;
		out.ref = encode_cell(rfx.s);
		data.l += 16; /*var guid = parse_GUID(data); */
		return out;
	}
	function write_BrtBeginComment(data, o) {
		if(o == null) o = new_buf(36);
		o.write_shift(4, data[1].iauthor);
		write_UncheckedRfX((data[0]), o);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
	var parse_BrtCommentAuthor = parse_XLWideString;
	function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }
	
	/* [MS-XLSB] 2.1.7.8 Comments */
	function parse_comments_bin(data, opts) {
		var out = [];
		var authors = [];
		var c = {};
		var pass = false;
		recordhopper(data, function hopper_cmnt(val, R, RT) {
			switch(RT) {
				case 0x0278: /* 'BrtCommentAuthor' */
					authors.push(val); break;
				case 0x027B: /* 'BrtBeginComment' */
					c = val; break;
				case 0x027D: /* 'BrtCommentText' */
					c.t = val.t; c.h = val.h; c.r = val.r; break;
				case 0x027C: /* 'BrtEndComment' */
					c.author = authors[c.iauthor];
					delete (c).iauthor;
					if(opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
					if(!c.t) c.t = "";
					delete c.rfx; out.push(c); break;
	
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */ break;
				case 0x0026: /* 'BrtACEnd' */ break;
	
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return out;
	}
	
	function write_comments_bin(data) {
		var ba = buf_array();
		var iauthor = [];
		write_record(ba, 0x0274 /* BrtBeginComments */);
	
		write_record(ba, 0x0276 /* BrtBeginCommentAuthors */);
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				if(iauthor.indexOf(c.a) > -1) return;
				iauthor.push(c.a.slice(0,54));
				write_record(ba, 0x0278 /* BrtCommentAuthor */, write_BrtCommentAuthor(c.a));
			});
		});
		write_record(ba, 0x0277 /* BrtEndCommentAuthors */);
	
		write_record(ba, 0x0279 /* BrtBeginCommentList */);
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				c.iauthor = iauthor.indexOf(c.a);
				var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
				write_record(ba, 0x027B /* BrtBeginComment */, write_BrtBeginComment([range, c]));
				if(c.t && c.t.length > 0) write_record(ba, 0x027D /* BrtCommentText */, write_BrtCommentText(c));
				write_record(ba, 0x027C /* BrtEndComment */);
				delete c.iauthor;
			});
		});
		write_record(ba, 0x027A /* BrtEndCommentList */);
	
		write_record(ba, 0x0275 /* BrtEndComments */);
		return ba.end();
	}
	var CT_VBA = "application/vnd.ms-office.vbaProject";
	function make_vba_xls(cfb) {
	  var newcfb = CFB.utils.cfb_new({ root: "R" });
	  cfb.FullPaths.forEach(function(p, i) {
	    if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/))
	      return;
	    var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
	    CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
	  });
	  return CFB.write(newcfb);
	}
	function fill_vba_xls(cfb, vba) {
	  vba.FullPaths.forEach(function(p, i) {
	    if (i == 0)
	      return;
	    var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
	    if (newpath.slice(-1) !== "/")
	      CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
	  });
	}
	var VBAFMTS = ["xlsb", "xlsm", "xlam", "biff8", "xla"];
	/* macro and dialog sheet stubs */
	function parse_ds_bin() { return {'!type':'dialog'}; }
	function parse_ds_xml() { return {'!type':'dialog'}; }
	function parse_ms_bin() { return {'!type':'macro'}; }
	function parse_ms_xml() { return {'!type':'macro'}; }
	/* TODO: it will be useful to parse the function str */
	var rc_to_a1 = (function(){
		var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
		var rcbase = ({r:0,c:0});
		function rcfunc($$,$1,$2,$3) {
			var cRel = false, rRel = false;
	
			if($2.length == 0) rRel = true;
			else if($2.charAt(0) == "[") { rRel = true; $2 = $2.slice(1, -1); }
	
			if($3.length == 0) cRel = true;
			else if($3.charAt(0) == "[") { cRel = true; $3 = $3.slice(1, -1); }
	
			var R = $2.length>0?parseInt($2,10)|0:0, C = $3.length>0?parseInt($3,10)|0:0;
	
			if(cRel) C += rcbase.c; else --C;
			if(rRel) R += rcbase.r; else --R;
			return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
		}
		return function rc_to_a1(fstr, base) {
			rcbase = base;
			return fstr.replace(rcregex, rcfunc);
		};
	})();
	
	var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
	var a1_to_rc = (function(){
		return function a1_to_rc(fstr, base) {
			return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
				var c = decode_col($3) - ($2 ? 0 : base.c);
				var r = decode_row($5) - ($4 ? 0 : base.r);
				var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
				var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
				return $1 + "R" + R + "C" + C;
			});
		};
	})();
	
	/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
	function shift_formula_str(f, delta) {
		return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
		});
	}
	
	function shift_formula_xlsx(f, range, cell) {
		var r = decode_range(range), s = r.s, c = decode_cell(cell);
		var delta = {r:c.r - s.r, c:c.c - s.c};
		return shift_formula_str(f, delta);
	}
	
	/* TODO: parse formula */
	function fuzzyfmla(f) {
		if(f.length == 1) return false;
		return true;
	}
	
	function _xlfn(f) {
		return f.replace(/_xlfn\./g,"");
	}
	function parseread1(blob) { blob.l+=1; return; }
	
	/* [MS-XLS] 2.5.51 */
	function parse_ColRelU(blob, length) {
		var c = blob.read_shift(length == 1 ? 1 : 2);
		return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
	function parse_RgceArea(blob, length, opts) {
		var w = 2;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
			else if(opts.biff == 12) w = 4;
		}
		var r=blob.read_shift(w), R=blob.read_shift(w);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	/* BIFF 2-5 encodes flags in the row field */
	function parse_RgceArea_BIFF2(blob) {
		var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
		var c=blob.read_shift(1);
		var C=blob.read_shift(1);
		return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
	function parse_RgceAreaRel(blob, length, opts) {
		if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
		var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	
	/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
	function parse_RgceLoc(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
		var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
		var c = parse_ColRelU(blob, 2);
		return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
	}
	function parse_RgceLoc_BIFF2(blob) {
		var r = parse_ColRelU(blob, 2);
		var c = blob.read_shift(1);
		return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
	}
	
	/* [MS-XLS] 2.5.198.107, 2.5.47 */
	function parse_RgceElfLoc(blob) {
		var r = blob.read_shift(2);
		var c = blob.read_shift(2);
		return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
	}
	
	/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
	function parse_RgceLocRel(blob, length, opts) {
		var biff = opts && opts.biff ? opts.biff : 8;
		if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
		var r = blob.read_shift(biff >= 12 ? 4 : 2);
		var cl = blob.read_shift(2);
		var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
		cl &= 0x3FFF;
		if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
		if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
		return {r:r,c:cl,cRel:cRel,rRel:rRel};
	}
	function parse_RgceLocRel_BIFF2(blob) {
		var rl = blob.read_shift(2);
		var c = blob.read_shift(1);
		var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
		rl &= 0x3FFF;
		if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
		if(cRel == 1 && c >= 0x80) c = c - 0x100;
		return {r:rl,c:c,cRel:cRel,rRel:rRel};
	}
	
	/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
	function parse_PtgArea(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
	function parse_PtgArea3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2, 'i');
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		var area = parse_RgceArea(blob, w, opts);
		return [type, ixti, area];
	}
	
	/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
	function parse_PtgAreaErr(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
		return [type];
	}
	/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
	function parse_PtgAreaErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
	function parse_PtgAreaN(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceAreaRel(blob, length - 1, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
	function parse_PtgArray(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
	function parse_PtgAttrBaxcel(blob) {
		var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
		var bitBaxcel = 1;
		blob.l += 4;
		return [bitSemi, bitBaxcel];
	}
	
	/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
	function parse_PtgAttrChoose(blob, length, opts) {
		blob.l +=2;
		var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var o = [];
		/* offset is 1 less than the number of elements */
		for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
	function parse_PtgAttrGoto(blob, length, opts) {
		var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
	function parse_PtgAttrIf(blob, length, opts) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLSB] 2.5.97.28 */
	function parse_PtgAttrIfError(blob) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(2)];
	}
	
	/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
	function parse_PtgAttrSemi(blob, length, opts) {
		var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += opts && opts.biff == 2 ? 3 : 4;
		return [bitSemi];
	}
	
	/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
	function parse_PtgAttrSpaceType(blob) {
		var type = blob.read_shift(1), cch = blob.read_shift(1);
		return [type, cch];
	}
	
	/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
	function parse_PtgAttrSpace(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
	function parse_PtgAttrSpaceSemi(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
	function parse_PtgRef(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLoc(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
	function parse_PtgRefN(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLocRel(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
	function parse_PtgRef3d(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var ixti = blob.read_shift(2); // XtiIndex
		if(opts && opts.biff == 5) blob.l += 12;
		var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
		return [type, ixti, loc];
	}
	
	
	/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
	function parse_PtgFunc(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
		return [FtabArgc[iftab], Ftab[iftab], type];
	}
	/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
	function parse_PtgFuncVar(blob, length, opts) {
		var type = blob[blob.l++];
		var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
		return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
	}
	
	function parsetab(blob) {
		return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
	}
	
	/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
	function parse_PtgAttrSum(blob, length, opts) {
		blob.l += opts && opts.biff == 2 ? 3 : 4; return;
	}
	
	/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
	function parse_PtgExp(blob, length, opts) {
		blob.l++;
		if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
		var row = blob.read_shift(2);
		var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [row, col];
	}
	
	/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
	function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }
	
	/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
	function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }
	
	/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
	function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}
	
	/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
	function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }
	
	/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
	function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }
	
	/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
	/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
	function parse_SerAr(blob, biff) {
		var val = [blob.read_shift(1)];
		if(biff == 12) switch(val[0]) {
			case 0x02: val[0] = 0x04; break; /* SerBool */
			case 0x04: val[0] = 0x10; break; /* SerErr */
			case 0x00: val[0] = 0x01; break; /* SerNum */
			case 0x01: val[0] = 0x02; break; /* SerStr */
		}
		switch(val[0]) {
			case 0x04: /* SerBool -- boolean */
				val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
				if(biff != 12) blob.l += 7; break;
			case 0x25: /* appears to be an alias */
			case 0x10: /* SerErr -- error */
				val[1] = BErr[blob[blob.l]];
				blob.l += ((biff == 12) ? 4 : 8); break;
			case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
				blob.l += 8; break;
			case 0x01: /* SerNum -- Xnum */
				val[1] = parse_Xnum(blob, 8); break;
			case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
				val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
			default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
		}
		return val;
	}
	
	/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
	function parse_PtgExtraMem(blob, cce, opts) {
		var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
		var out = [];
		for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
		return out;
	}
	
	/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
	function parse_PtgExtraArray(blob, length, opts) {
		var rows = 0, cols = 0;
		if(opts.biff == 12) {
			rows = blob.read_shift(4); // DRw
			cols = blob.read_shift(4); // DCol
		} else {
			cols = 1 + blob.read_shift(1); //DColByteU
			rows = 1 + blob.read_shift(2); //DRw
		}
		if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
		// $FlowIgnore
		for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
			for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
		return o;
	}
	
	/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
	function parse_PtgName(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
		var nameindex = blob.read_shift(w);
		switch(opts.biff) {
			case 2: blob.l += 5; break;
			case 3: case 4: blob.l += 8; break;
			case 5: blob.l += 12; break;
		}
		return [type, 0, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
	function parse_PtgNameX(blob, length, opts) {
		if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2); // XtiIndex
		var nameindex = blob.read_shift(4);
		return [type, ixti, nameindex];
	}
	function parse_PtgNameX_BIFF5(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2, 'i'); // XtiIndex
		blob.l += 8;
		var nameindex = blob.read_shift(2);
		blob.l += 12;
		return [type, ixti, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
	function parse_PtgMemArea(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += (opts && opts.biff == 2 ? 3 : 4);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
	function parse_PtgMemFunc(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	
	/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
	function parse_PtgRefErr(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += 4;
		if(opts.biff < 8) blob.l--;
		if(opts.biff == 12) blob.l += 2;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
	function parse_PtgRefErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 4;
		if(opts) switch(opts.biff) {
			case 5: w = 15; break;
			case 12: w = 6; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
	var parse_PtgMemErr = parsenoop;
	/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
	var parse_PtgMemNoMem = parsenoop;
	/* [MS-XLS] 2.5.198.92 */
	var parse_PtgTbl = parsenoop;
	
	function parse_PtgElfLoc(blob, length, opts) {
		blob.l += 2;
		return [parse_RgceElfLoc(blob, 4, opts)];
	}
	function parse_PtgElfNoop(blob) {
		blob.l += 6;
		return [];
	}
	/* [MS-XLS] 2.5.198.46 */
	var parse_PtgElfCol = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.47 */
	var parse_PtgElfColS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.48 */
	var parse_PtgElfColSV = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.49 */
	var parse_PtgElfColV = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.50 */
	function parse_PtgElfLel(blob) {
		blob.l += 2;
		return [parseuint16(blob), blob.read_shift(2) & 0x01];
	}
	/* [MS-XLS] 2.5.198.51 */
	var parse_PtgElfRadical = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.52 */
	var parse_PtgElfRadicalLel = parse_PtgElfLel;
	/* [MS-XLS] 2.5.198.53 */
	var parse_PtgElfRadicalS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.54 */
	var parse_PtgElfRw = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.55 */
	var parse_PtgElfRwV = parse_PtgElfLoc;
	
	/* [MS-XLSB] 2.5.97.52 TODO */
	var PtgListRT = [
		"Data",
		"All",
		"Headers",
		"??",
		"?Data2",
		"??",
		"?DataHeaders",
		"??",
		"Totals",
		"??",
		"??",
		"??",
		"?DataTotals",
		"??",
		"??",
		"??",
		"?Current"
	];
	function parse_PtgList(blob) {
		blob.l += 2;
		var ixti = blob.read_shift(2);
		var flags = blob.read_shift(2);
		var idx = blob.read_shift(4);
		var c = blob.read_shift(2);
		var C = blob.read_shift(2);
		var rt = PtgListRT[(flags >> 2) & 0x1F];
		return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
	}
	/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
	function parse_PtgSxName(blob) {
		blob.l += 2;
		return [blob.read_shift(4)];
	}
	
	/* [XLS] old spec */
	function parse_PtgSheet(blob, length, opts) {
		blob.l += 5;
		blob.l += 2;
		blob.l += (opts.biff == 2 ? 1 : 4);
		return ["PTGSHEET"];
	}
	function parse_PtgEndSheet(blob, length, opts) {
		blob.l += (opts.biff == 2 ? 4 : 5);
		return ["PTGENDSHEET"];
	}
	function parse_PtgMemAreaN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgMemNoMemN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgAttrNoop(blob) {
		blob.l += 4;
		return [0, 0];
	}
	
	/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
	var PtgTypes = {
	0x01: { n:'PtgExp', f:parse_PtgExp },
	0x02: { n:'PtgTbl', f:parse_PtgTbl },
	0x03: { n:'PtgAdd', f:parseread1 },
	0x04: { n:'PtgSub', f:parseread1 },
	0x05: { n:'PtgMul', f:parseread1 },
	0x06: { n:'PtgDiv', f:parseread1 },
	0x07: { n:'PtgPower', f:parseread1 },
	0x08: { n:'PtgConcat', f:parseread1 },
	0x09: { n:'PtgLt', f:parseread1 },
	0x0A: { n:'PtgLe', f:parseread1 },
	0x0B: { n:'PtgEq', f:parseread1 },
	0x0C: { n:'PtgGe', f:parseread1 },
	0x0D: { n:'PtgGt', f:parseread1 },
	0x0E: { n:'PtgNe', f:parseread1 },
	0x0F: { n:'PtgIsect', f:parseread1 },
	0x10: { n:'PtgUnion', f:parseread1 },
	0x11: { n:'PtgRange', f:parseread1 },
	0x12: { n:'PtgUplus', f:parseread1 },
	0x13: { n:'PtgUminus', f:parseread1 },
	0x14: { n:'PtgPercent', f:parseread1 },
	0x15: { n:'PtgParen', f:parseread1 },
	0x16: { n:'PtgMissArg', f:parseread1 },
	0x17: { n:'PtgStr', f:parse_PtgStr },
	0x1A: { n:'PtgSheet', f:parse_PtgSheet },
	0x1B: { n:'PtgEndSheet', f:parse_PtgEndSheet },
	0x1C: { n:'PtgErr', f:parse_PtgErr },
	0x1D: { n:'PtgBool', f:parse_PtgBool },
	0x1E: { n:'PtgInt', f:parse_PtgInt },
	0x1F: { n:'PtgNum', f:parse_PtgNum },
	0x20: { n:'PtgArray', f:parse_PtgArray },
	0x21: { n:'PtgFunc', f:parse_PtgFunc },
	0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
	0x23: { n:'PtgName', f:parse_PtgName },
	0x24: { n:'PtgRef', f:parse_PtgRef },
	0x25: { n:'PtgArea', f:parse_PtgArea },
	0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
	0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
	0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
	0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
	0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
	0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
	0x2C: { n:'PtgRefN', f:parse_PtgRefN },
	0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
	0x2E: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
	0x2F: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
	0x39: { n:'PtgNameX', f:parse_PtgNameX },
	0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
	0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
	0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
	0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
	0xFF: {}
	};
	/* These are duplicated in the PtgTypes table */
	var PtgDupes = {
	0x40: 0x20, 0x60: 0x20,
	0x41: 0x21, 0x61: 0x21,
	0x42: 0x22, 0x62: 0x22,
	0x43: 0x23, 0x63: 0x23,
	0x44: 0x24, 0x64: 0x24,
	0x45: 0x25, 0x65: 0x25,
	0x46: 0x26, 0x66: 0x26,
	0x47: 0x27, 0x67: 0x27,
	0x48: 0x28, 0x68: 0x28,
	0x49: 0x29, 0x69: 0x29,
	0x4A: 0x2A, 0x6A: 0x2A,
	0x4B: 0x2B, 0x6B: 0x2B,
	0x4C: 0x2C, 0x6C: 0x2C,
	0x4D: 0x2D, 0x6D: 0x2D,
	0x4E: 0x2E, 0x6E: 0x2E,
	0x4F: 0x2F, 0x6F: 0x2F,
	0x58: 0x22, 0x78: 0x22,
	0x59: 0x39, 0x79: 0x39,
	0x5A: 0x3A, 0x7A: 0x3A,
	0x5B: 0x3B, 0x7B: 0x3B,
	0x5C: 0x3C, 0x7C: 0x3C,
	0x5D: 0x3D, 0x7D: 0x3D
	};
	
	var Ptg18 = {
	0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
	0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
	0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
	0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
	0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
	0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
	0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
	0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
	0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
	0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
	0x19: { n:'PtgList', f:parse_PtgList },
	0x1D: { n:'PtgSxName', f:parse_PtgSxName },
	0xFF: {}
	};
	var Ptg19 = {
	0x00: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
	0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
	0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
	0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
	0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
	0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
	0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x21: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
	0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
	0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
	0xFF: {}
	};
	
	/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
	function parse_RgbExtra(blob, length, rgce, opts) {
		if(opts.biff < 8) return parsenoop(blob, length);
		var target = blob.l + length;
		var o = [];
		for(var i = 0; i !== rgce.length; ++i) {
			switch(rgce[i][0]) {
				case 'PtgArray': /* PtgArray -> PtgExtraArray */
					rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
					o.push(rgce[i][1]);
					break;
				case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
					rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
					o.push(rgce[i][2]);
					break;
				case 'PtgExp': /* PtgExp -> PtgExtraCol */
					if(opts && opts.biff == 12) {
						rgce[i][1][1] = blob.read_shift(4);
						o.push(rgce[i][1]);
					} break;
				case 'PtgList': /* TODO: PtgList -> PtgExtraList */
				case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
				case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
				case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
					throw "Unsupported " + rgce[i][0];
				default: break;
			}
		}
		length = target - blob.l;
		/* note: this is technically an error but Excel disregards */
		//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
		if(length !== 0) o.push(parsenoop(blob, length));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
	function parse_Rgce(blob, length, opts) {
		var target = blob.l + length;
		var R, id, ptgs = [];
		while(target != blob.l) {
			length = target - blob.l;
			id = blob[blob.l];
			R = PtgTypes[id] || PtgTypes[PtgDupes[id]];
			if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
			if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
			else { ptgs.push([R.n, R.f(blob, length, opts)]); }
		}
		return ptgs;
	}
	
	function stringify_array(f) {
		var o = [];
		for(var i = 0; i < f.length; ++i) {
			var x = f[i], r = [];
			for(var j = 0; j < x.length; ++j) {
				var y = x[j];
				if(y) switch(y[0]) {
					// TODO: handle embedded quotes
					case 0x02:
	r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
					default: r.push(y[1]);
				} else r.push("");
			}
			o.push(r.join(","));
		}
		return o.join(";");
	}
	
	/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
	var PtgBinOp = {
		PtgAdd: "+",
		PtgConcat: "&",
		PtgDiv: "/",
		PtgEq: "=",
		PtgGe: ">=",
		PtgGt: ">",
		PtgLe: "<=",
		PtgLt: "<",
		PtgMul: "*",
		PtgNe: "<>",
		PtgPower: "^",
		PtgSub: "-"
	};
	
	// List of invalid characters needs to be tested further
	function formula_quote_sheet_name(sname, opts) {
		if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
		if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname + "'";
		return sname;
	}
	function get_ixti_raw(supbooks, ixti, opts) {
		if(!supbooks) return "SH33TJSERR0";
		if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
		if(!supbooks.XTI) return "SH33TJSERR6";
		var XTI = supbooks.XTI[ixti];
		if(opts.biff < 8) {
			if(ixti > 10000) ixti-= 65536;
			if(ixti < 0) ixti = -ixti;
			return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
		}
		if(!XTI) return "SH33TJSERR1";
		var o = "";
		if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
			case 0x0165: /* 'BrtSupSelf' */
				o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x0166: /* 'BrtSupSame' */
				if(opts.SID != null) return supbooks.SheetNames[opts.SID];
				return "SH33TJSSAME" + supbooks[XTI[0]][0];
			case 0x0163: /* 'BrtSupBookSrc' */
				/* falls through */
			default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
		}
		switch(supbooks[XTI[0]][0][0]) {
			case 0x0401:
				o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
			default:
				if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
				o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
		}
	}
	function get_ixti(supbooks, ixti, opts) {
		var ixtiraw = get_ixti_raw(supbooks, ixti, opts);
		return ixtiraw == "#REF" ? ixtiraw : formula_quote_sheet_name(ixtiraw, opts);
	}
	function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
		var biff = (opts && opts.biff) || 8;
		var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
		var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
		if(!formula[0] || !formula[0][0]) return "";
		var last_sp = -1, sp = "";
		for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
			var f = formula[0][ff];
			switch(f[0]) {
				case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
					stack.push("-" + stack.pop()); break;
				case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
					stack.push("+" + stack.pop()); break;
				case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
					stack.push(stack.pop() + "%"); break;
	
				case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
				case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
				case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
				case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
				case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
				case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
				case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
				case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
				case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
				case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
				case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
				case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
					e1 = stack.pop(); e2 = stack.pop();
					if(last_sp >= 0) {
						switch(formula[0][last_sp][1][0]) {
							case 0:
								// $FlowIgnore
								sp = fill(" ", formula[0][last_sp][1][1]); break;
							case 1:
								// $FlowIgnore
								sp = fill("\r", formula[0][last_sp][1][1]); break;
							default:
								sp = "";
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						e2 = e2 + sp;
						last_sp = -1;
					}
					stack.push(e2+PtgBinOp[f[0]]+e1);
					break;
	
				case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+" "+e1);
					break;
				case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+","+e1);
					break;
				case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+":"+e1);
					break;
	
				case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
					break;
				case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
					break;
				case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
					break;
				case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
					break;
	
	
				case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
	c = shift_cell_xls((f[1][1]), _range, opts);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
	c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
	ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
					sname = get_ixti(supbooks, ixti, opts);
					var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
					stack.push(sname + "!" + encode_cell_xls(c, biff));
					break;
	
				case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
				case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
					/* f[1] = [argc, func, type] */
					var argc = (f[1][0]), func = (f[1][1]);
					if(!argc) argc = 0;
					argc &= 0x7F;
					var args = argc == 0 ? [] : stack.slice(-argc);
					stack.length -= argc;
					if(func === 'User') func = args.shift();
					stack.push(func + "(" + args.join(",") + ")");
					break;
	
				case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
					stack.push(f[1] ? "TRUE" : "FALSE"); break;
				case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
					stack.push(f[1]); break;
				case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
					stack.push(String(f[1])); break;
				case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
					// $FlowIgnore
					stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
				case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
					stack.push(f[1]); break;
				case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
	r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
	r = shift_range_xls(f[1][1], _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
	ixti = f[1][1]; r = f[1][2];
					sname = get_ixti(supbooks, ixti, opts);
					stack.push(sname + "!" + encode_range_xls((r), opts));
					break;
				case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
					stack.push("SUM(" + stack.pop() + ")");
					break;
	
				case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
				case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
					break;
	
				case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
					/* f[1] = type, 0, nameindex */
					nameidx = (f[1][2]);
					var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
					var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
					/* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */
					if(name && name.slice(0,6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
					stack.push(name);
					break;
	
				case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
					/* f[1] = type, ixti, nameindex */
					var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
					/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
					if(opts.biff <= 5) {
						if(bookidx < 0) bookidx = -bookidx;
						if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
					} else {
						var o = "";
						if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
						else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
							if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
								o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
							}
						}
						else o = supbooks.SheetNames[nameidx-1]+ "!";
						if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
						else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
						else {
							var ixtidata = (get_ixti_raw(supbooks, bookidx, opts)||"").split(";;");
							if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
							else o += "SH33TJSERRX";
						}
						stack.push(o);
						break;
					}
					if(!externbook) externbook = {Name: "SH33TJSERRY"};
					stack.push(externbook.Name);
					break;
	
				case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
					var lp = '(', rp = ')';
					if(last_sp >= 0) {
						sp = "";
						switch(formula[0][last_sp][1][0]) {
							// $FlowIgnore
							case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
							// $FlowIgnore
							case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
							default:
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						last_sp = -1;
					}
					stack.push(lp + stack.pop() + rp); break;
	
				case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
					stack.push('#REF!'); break;
	
				case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
					stack.push('#REF!'); break;
	
				case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
					c = {c:(f[1][1]),r:(f[1][0])};
					var q = ({c: cell.c, r:cell.r});
					if(supbooks.sharedf[encode_cell(c)]) {
						var parsedf = (supbooks.sharedf[encode_cell(c)]);
						stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
					} else {
						var fnd = false;
						for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
							/* TODO: should be something like range_has */
							e2 = supbooks.arrayf[e1];
							if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
							if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
							stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
							fnd = true;
							break;
						}
						if(!fnd) stack.push(f[1]);
					}
					break;
	
				case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
					stack.push("{" + stringify_array(f[1]) + "}");
					break;
	
				case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
					//stack.push("(" + f[2].map(encode_range).join(",") + ")");
					break;
	
				case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
				case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
					last_sp = ff;
					break;
	
				case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
					break;
	
				case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
					break;
	
				case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
					stack.push("");
					break;
	
				case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
					stack.push("#REF!"); break;
	
				case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
					stack.push("#REF!"); break;
	
				case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
					// $FlowIgnore
					stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
					break;
	
				case 'PtgMemAreaN':
				case 'PtgMemNoMemN':
				case 'PtgAttrNoop':
				case 'PtgSheet':
				case 'PtgEndSheet':
					break;
	
				case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
					break;
				case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
					break;
	
				case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
				case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
				case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
				case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
				case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
				case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
				case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
				case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
				case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
				case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
					throw new Error("Unsupported ELFs");
	
				case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
					throw new Error('Unrecognized Formula Token: ' + String(f));
				default: throw new Error('Unrecognized Formula Token: ' + String(f));
			}
			var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
			if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
				f = formula[0][last_sp];
				var _left = true;
				switch(f[1][0]) {
					/* note: some bad XLSB files omit the PtgParen */
					case 4: _left = false;
					/* falls through */
					case 0:
						// $FlowIgnore
						sp = fill(" ", f[1][1]); break;
					case 5: _left = false;
					/* falls through */
					case 1:
						// $FlowIgnore
						sp = fill("\r", f[1][1]); break;
					default:
						sp = "";
						// $FlowIgnore
						if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
				}
				stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
				last_sp = -1;
			}
		}
		if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
		return stack[0];
	}
	
	/* [MS-XLS] 2.5.198.1 TODO */
	function parse_ArrayParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.3 TODO */
	function parse_XLSCellParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.21 */
	function parse_NameParsedFormula(blob, length, opts, cce) {
		var target = blob.l + length;
		var rgce = parse_Rgce(blob, cce, opts);
		var rgcb;
		if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.118 TODO */
	function parse_SharedParsedFormula(blob, length, opts) {
		var target = blob.l + length;
		var rgcb, cce = blob.read_shift(2); // length of rgce
		var rgce = parse_Rgce(blob, cce, opts);
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
	function parse_FormulaValue(blob) {
		var b;
		if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
		switch(blob[blob.l]) {
			case 0x00: blob.l += 8; return ["String", 's'];
			case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
			case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
			case 0x03: blob.l += 8; return ["",'s'];
		}
		return [];
	}
	function write_FormulaValue(value) {
		if(value == null) {
			// Blank String Value
			var o = new_buf(8);
			o.write_shift(1, 0x03);
			o.write_shift(1, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0xFFFF);
			return o;
		} else if(typeof value == "number") return write_Xnum(value);
		return write_Xnum(0);
	}
	
	/* [MS-XLS] 2.4.127 TODO */
	function parse_Formula(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) ++blob.l;
		var val = parse_FormulaValue(blob,8);
		var flags = blob.read_shift(1);
		if(opts.biff != 2) {
			blob.read_shift(1);
			if(opts.biff >= 5) {
				/*var chn = */blob.read_shift(4);
			}
		}
		var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
		return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
	}
	function write_Formula(cell, R, C, opts, os) {
		// Cell
		var o1 = write_XLSCell(R, C, os);
	
		// FormulaValue
		var o2 = write_FormulaValue(cell.v);
	
		// flags + cache
		var o3 = new_buf(6);
		var flags = 0x01 | 0x20;
		o3.write_shift(2, flags);
		o3.write_shift(4, 0);
	
		// CellParsedFormula
		var bf = new_buf(cell.bf.length);
		for(var i = 0; i < cell.bf.length; ++i) bf[i] = cell.bf[i];
	
		var out = bconcat([o1, o2, o3, bf]);
		return out;
	}
	
	
	/* XLSB Parsed Formula records have the same shape */
	function parse_XLSBParsedFormula(data, length, opts) {
		var cce = data.read_shift(4);
		var rgce = parse_Rgce(data, cce, opts);
		var cb = data.read_shift(4);
		var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
		return [rgce, rgcb];
	}
	
	/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
	var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
	var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.8 DVParsedFormula */
	//var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */
	//var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
	/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
	var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
	var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
	var Cetab = {
	  0: "BEEP",
	  1: "OPEN",
	  2: "OPEN.LINKS",
	  3: "CLOSE.ALL",
	  4: "SAVE",
	  5: "SAVE.AS",
	  6: "FILE.DELETE",
	  7: "PAGE.SETUP",
	  8: "PRINT",
	  9: "PRINTER.SETUP",
	  10: "QUIT",
	  11: "NEW.WINDOW",
	  12: "ARRANGE.ALL",
	  13: "WINDOW.SIZE",
	  14: "WINDOW.MOVE",
	  15: "FULL",
	  16: "CLOSE",
	  17: "RUN",
	  22: "SET.PRINT.AREA",
	  23: "SET.PRINT.TITLES",
	  24: "SET.PAGE.BREAK",
	  25: "REMOVE.PAGE.BREAK",
	  26: "FONT",
	  27: "DISPLAY",
	  28: "PROTECT.DOCUMENT",
	  29: "PRECISION",
	  30: "A1.R1C1",
	  31: "CALCULATE.NOW",
	  32: "CALCULATION",
	  34: "DATA.FIND",
	  35: "EXTRACT",
	  36: "DATA.DELETE",
	  37: "SET.DATABASE",
	  38: "SET.CRITERIA",
	  39: "SORT",
	  40: "DATA.SERIES",
	  41: "TABLE",
	  42: "FORMAT.NUMBER",
	  43: "ALIGNMENT",
	  44: "STYLE",
	  45: "BORDER",
	  46: "CELL.PROTECTION",
	  47: "COLUMN.WIDTH",
	  48: "UNDO",
	  49: "CUT",
	  50: "COPY",
	  51: "PASTE",
	  52: "CLEAR",
	  53: "PASTE.SPECIAL",
	  54: "EDIT.DELETE",
	  55: "INSERT",
	  56: "FILL.RIGHT",
	  57: "FILL.DOWN",
	  61: "DEFINE.NAME",
	  62: "CREATE.NAMES",
	  63: "FORMULA.GOTO",
	  64: "FORMULA.FIND",
	  65: "SELECT.LAST.CELL",
	  66: "SHOW.ACTIVE.CELL",
	  67: "GALLERY.AREA",
	  68: "GALLERY.BAR",
	  69: "GALLERY.COLUMN",
	  70: "GALLERY.LINE",
	  71: "GALLERY.PIE",
	  72: "GALLERY.SCATTER",
	  73: "COMBINATION",
	  74: "PREFERRED",
	  75: "ADD.OVERLAY",
	  76: "GRIDLINES",
	  77: "SET.PREFERRED",
	  78: "AXES",
	  79: "LEGEND",
	  80: "ATTACH.TEXT",
	  81: "ADD.ARROW",
	  82: "SELECT.CHART",
	  83: "SELECT.PLOT.AREA",
	  84: "PATTERNS",
	  85: "MAIN.CHART",
	  86: "OVERLAY",
	  87: "SCALE",
	  88: "FORMAT.LEGEND",
	  89: "FORMAT.TEXT",
	  90: "EDIT.REPEAT",
	  91: "PARSE",
	  92: "JUSTIFY",
	  93: "HIDE",
	  94: "UNHIDE",
	  95: "WORKSPACE",
	  96: "FORMULA",
	  97: "FORMULA.FILL",
	  98: "FORMULA.ARRAY",
	  99: "DATA.FIND.NEXT",
	  100: "DATA.FIND.PREV",
	  101: "FORMULA.FIND.NEXT",
	  102: "FORMULA.FIND.PREV",
	  103: "ACTIVATE",
	  104: "ACTIVATE.NEXT",
	  105: "ACTIVATE.PREV",
	  106: "UNLOCKED.NEXT",
	  107: "UNLOCKED.PREV",
	  108: "COPY.PICTURE",
	  109: "SELECT",
	  110: "DELETE.NAME",
	  111: "DELETE.FORMAT",
	  112: "VLINE",
	  113: "HLINE",
	  114: "VPAGE",
	  115: "HPAGE",
	  116: "VSCROLL",
	  117: "HSCROLL",
	  118: "ALERT",
	  119: "NEW",
	  120: "CANCEL.COPY",
	  121: "SHOW.CLIPBOARD",
	  122: "MESSAGE",
	  124: "PASTE.LINK",
	  125: "APP.ACTIVATE",
	  126: "DELETE.ARROW",
	  127: "ROW.HEIGHT",
	  128: "FORMAT.MOVE",
	  129: "FORMAT.SIZE",
	  130: "FORMULA.REPLACE",
	  131: "SEND.KEYS",
	  132: "SELECT.SPECIAL",
	  133: "APPLY.NAMES",
	  134: "REPLACE.FONT",
	  135: "FREEZE.PANES",
	  136: "SHOW.INFO",
	  137: "SPLIT",
	  138: "ON.WINDOW",
	  139: "ON.DATA",
	  140: "DISABLE.INPUT",
	  142: "OUTLINE",
	  143: "LIST.NAMES",
	  144: "FILE.CLOSE",
	  145: "SAVE.WORKBOOK",
	  146: "DATA.FORM",
	  147: "COPY.CHART",
	  148: "ON.TIME",
	  149: "WAIT",
	  150: "FORMAT.FONT",
	  151: "FILL.UP",
	  152: "FILL.LEFT",
	  153: "DELETE.OVERLAY",
	  155: "SHORT.MENUS",
	  159: "SET.UPDATE.STATUS",
	  161: "COLOR.PALETTE",
	  162: "DELETE.STYLE",
	  163: "WINDOW.RESTORE",
	  164: "WINDOW.MAXIMIZE",
	  166: "CHANGE.LINK",
	  167: "CALCULATE.DOCUMENT",
	  168: "ON.KEY",
	  169: "APP.RESTORE",
	  170: "APP.MOVE",
	  171: "APP.SIZE",
	  172: "APP.MINIMIZE",
	  173: "APP.MAXIMIZE",
	  174: "BRING.TO.FRONT",
	  175: "SEND.TO.BACK",
	  185: "MAIN.CHART.TYPE",
	  186: "OVERLAY.CHART.TYPE",
	  187: "SELECT.END",
	  188: "OPEN.MAIL",
	  189: "SEND.MAIL",
	  190: "STANDARD.FONT",
	  191: "CONSOLIDATE",
	  192: "SORT.SPECIAL",
	  193: "GALLERY.3D.AREA",
	  194: "GALLERY.3D.COLUMN",
	  195: "GALLERY.3D.LINE",
	  196: "GALLERY.3D.PIE",
	  197: "VIEW.3D",
	  198: "GOAL.SEEK",
	  199: "WORKGROUP",
	  200: "FILL.GROUP",
	  201: "UPDATE.LINK",
	  202: "PROMOTE",
	  203: "DEMOTE",
	  204: "SHOW.DETAIL",
	  206: "UNGROUP",
	  207: "OBJECT.PROPERTIES",
	  208: "SAVE.NEW.OBJECT",
	  209: "SHARE",
	  210: "SHARE.NAME",
	  211: "DUPLICATE",
	  212: "APPLY.STYLE",
	  213: "ASSIGN.TO.OBJECT",
	  214: "OBJECT.PROTECTION",
	  215: "HIDE.OBJECT",
	  216: "SET.EXTRACT",
	  217: "CREATE.PUBLISHER",
	  218: "SUBSCRIBE.TO",
	  219: "ATTRIBUTES",
	  220: "SHOW.TOOLBAR",
	  222: "PRINT.PREVIEW",
	  223: "EDIT.COLOR",
	  224: "SHOW.LEVELS",
	  225: "FORMAT.MAIN",
	  226: "FORMAT.OVERLAY",
	  227: "ON.RECALC",
	  228: "EDIT.SERIES",
	  229: "DEFINE.STYLE",
	  240: "LINE.PRINT",
	  243: "ENTER.DATA",
	  249: "GALLERY.RADAR",
	  250: "MERGE.STYLES",
	  251: "EDITION.OPTIONS",
	  252: "PASTE.PICTURE",
	  253: "PASTE.PICTURE.LINK",
	  254: "SPELLING",
	  256: "ZOOM",
	  259: "INSERT.OBJECT",
	  260: "WINDOW.MINIMIZE",
	  265: "SOUND.NOTE",
	  266: "SOUND.PLAY",
	  267: "FORMAT.SHAPE",
	  268: "EXTEND.POLYGON",
	  269: "FORMAT.AUTO",
	  272: "GALLERY.3D.BAR",
	  273: "GALLERY.3D.SURFACE",
	  274: "FILL.AUTO",
	  276: "CUSTOMIZE.TOOLBAR",
	  277: "ADD.TOOL",
	  278: "EDIT.OBJECT",
	  279: "ON.DOUBLECLICK",
	  280: "ON.ENTRY",
	  281: "WORKBOOK.ADD",
	  282: "WORKBOOK.MOVE",
	  283: "WORKBOOK.COPY",
	  284: "WORKBOOK.OPTIONS",
	  285: "SAVE.WORKSPACE",
	  288: "CHART.WIZARD",
	  289: "DELETE.TOOL",
	  290: "MOVE.TOOL",
	  291: "WORKBOOK.SELECT",
	  292: "WORKBOOK.ACTIVATE",
	  293: "ASSIGN.TO.TOOL",
	  295: "COPY.TOOL",
	  296: "RESET.TOOL",
	  297: "CONSTRAIN.NUMERIC",
	  298: "PASTE.TOOL",
	  302: "WORKBOOK.NEW",
	  305: "SCENARIO.CELLS",
	  306: "SCENARIO.DELETE",
	  307: "SCENARIO.ADD",
	  308: "SCENARIO.EDIT",
	  309: "SCENARIO.SHOW",
	  310: "SCENARIO.SHOW.NEXT",
	  311: "SCENARIO.SUMMARY",
	  312: "PIVOT.TABLE.WIZARD",
	  313: "PIVOT.FIELD.PROPERTIES",
	  314: "PIVOT.FIELD",
	  315: "PIVOT.ITEM",
	  316: "PIVOT.ADD.FIELDS",
	  318: "OPTIONS.CALCULATION",
	  319: "OPTIONS.EDIT",
	  320: "OPTIONS.VIEW",
	  321: "ADDIN.MANAGER",
	  322: "MENU.EDITOR",
	  323: "ATTACH.TOOLBARS",
	  324: "VBAActivate",
	  325: "OPTIONS.CHART",
	  328: "VBA.INSERT.FILE",
	  330: "VBA.PROCEDURE.DEFINITION",
	  336: "ROUTING.SLIP",
	  338: "ROUTE.DOCUMENT",
	  339: "MAIL.LOGON",
	  342: "INSERT.PICTURE",
	  343: "EDIT.TOOL",
	  344: "GALLERY.DOUGHNUT",
	  350: "CHART.TREND",
	  352: "PIVOT.ITEM.PROPERTIES",
	  354: "WORKBOOK.INSERT",
	  355: "OPTIONS.TRANSITION",
	  356: "OPTIONS.GENERAL",
	  370: "FILTER.ADVANCED",
	  373: "MAIL.ADD.MAILER",
	  374: "MAIL.DELETE.MAILER",
	  375: "MAIL.REPLY",
	  376: "MAIL.REPLY.ALL",
	  377: "MAIL.FORWARD",
	  378: "MAIL.NEXT.LETTER",
	  379: "DATA.LABEL",
	  380: "INSERT.TITLE",
	  381: "FONT.PROPERTIES",
	  382: "MACRO.OPTIONS",
	  383: "WORKBOOK.HIDE",
	  384: "WORKBOOK.UNHIDE",
	  385: "WORKBOOK.DELETE",
	  386: "WORKBOOK.NAME",
	  388: "GALLERY.CUSTOM",
	  390: "ADD.CHART.AUTOFORMAT",
	  391: "DELETE.CHART.AUTOFORMAT",
	  392: "CHART.ADD.DATA",
	  393: "AUTO.OUTLINE",
	  394: "TAB.ORDER",
	  395: "SHOW.DIALOG",
	  396: "SELECT.ALL",
	  397: "UNGROUP.SHEETS",
	  398: "SUBTOTAL.CREATE",
	  399: "SUBTOTAL.REMOVE",
	  400: "RENAME.OBJECT",
	  412: "WORKBOOK.SCROLL",
	  413: "WORKBOOK.NEXT",
	  414: "WORKBOOK.PREV",
	  415: "WORKBOOK.TAB.SPLIT",
	  416: "FULL.SCREEN",
	  417: "WORKBOOK.PROTECT",
	  420: "SCROLLBAR.PROPERTIES",
	  421: "PIVOT.SHOW.PAGES",
	  422: "TEXT.TO.COLUMNS",
	  423: "FORMAT.CHARTTYPE",
	  424: "LINK.FORMAT",
	  425: "TRACER.DISPLAY",
	  430: "TRACER.NAVIGATE",
	  431: "TRACER.CLEAR",
	  432: "TRACER.ERROR",
	  433: "PIVOT.FIELD.GROUP",
	  434: "PIVOT.FIELD.UNGROUP",
	  435: "CHECKBOX.PROPERTIES",
	  436: "LABEL.PROPERTIES",
	  437: "LISTBOX.PROPERTIES",
	  438: "EDITBOX.PROPERTIES",
	  439: "PIVOT.REFRESH",
	  440: "LINK.COMBO",
	  441: "OPEN.TEXT",
	  442: "HIDE.DIALOG",
	  443: "SET.DIALOG.FOCUS",
	  444: "ENABLE.OBJECT",
	  445: "PUSHBUTTON.PROPERTIES",
	  446: "SET.DIALOG.DEFAULT",
	  447: "FILTER",
	  448: "FILTER.SHOW.ALL",
	  449: "CLEAR.OUTLINE",
	  450: "FUNCTION.WIZARD",
	  451: "ADD.LIST.ITEM",
	  452: "SET.LIST.ITEM",
	  453: "REMOVE.LIST.ITEM",
	  454: "SELECT.LIST.ITEM",
	  455: "SET.CONTROL.VALUE",
	  456: "SAVE.COPY.AS",
	  458: "OPTIONS.LISTS.ADD",
	  459: "OPTIONS.LISTS.DELETE",
	  460: "SERIES.AXES",
	  461: "SERIES.X",
	  462: "SERIES.Y",
	  463: "ERRORBAR.X",
	  464: "ERRORBAR.Y",
	  465: "FORMAT.CHART",
	  466: "SERIES.ORDER",
	  467: "MAIL.LOGOFF",
	  468: "CLEAR.ROUTING.SLIP",
	  469: "APP.ACTIVATE.MICROSOFT",
	  470: "MAIL.EDIT.MAILER",
	  471: "ON.SHEET",
	  472: "STANDARD.WIDTH",
	  473: "SCENARIO.MERGE",
	  474: "SUMMARY.INFO",
	  475: "FIND.FILE",
	  476: "ACTIVE.CELL.FONT",
	  477: "ENABLE.TIPWIZARD",
	  478: "VBA.MAKE.ADDIN",
	  480: "INSERTDATATABLE",
	  481: "WORKGROUP.OPTIONS",
	  482: "MAIL.SEND.MAILER",
	  485: "AUTOCORRECT",
	  489: "POST.DOCUMENT",
	  491: "PICKLIST",
	  493: "VIEW.SHOW",
	  494: "VIEW.DEFINE",
	  495: "VIEW.DELETE",
	  509: "SHEET.BACKGROUND",
	  510: "INSERT.MAP.OBJECT",
	  511: "OPTIONS.MENONO",
	  517: "MSOCHECKS",
	  518: "NORMAL",
	  519: "LAYOUT",
	  520: "RM.PRINT.AREA",
	  521: "CLEAR.PRINT.AREA",
	  522: "ADD.PRINT.AREA",
	  523: "MOVE.BRK",
	  545: "HIDECURR.NOTE",
	  546: "HIDEALL.NOTES",
	  547: "DELETE.NOTE",
	  548: "TRAVERSE.NOTES",
	  549: "ACTIVATE.NOTES",
	  620: "PROTECT.REVISIONS",
	  621: "UNPROTECT.REVISIONS",
	  647: "OPTIONS.ME",
	  653: "WEB.PUBLISH",
	  667: "NEWWEBQUERY",
	  673: "PIVOT.TABLE.CHART",
	  753: "OPTIONS.SAVE",
	  755: "OPTIONS.SPELL",
	  808: "HIDEALL.INKANNOTS"
	};
	var Ftab = {
	  0: "COUNT",
	  1: "IF",
	  2: "ISNA",
	  3: "ISERROR",
	  4: "SUM",
	  5: "AVERAGE",
	  6: "MIN",
	  7: "MAX",
	  8: "ROW",
	  9: "COLUMN",
	  10: "NA",
	  11: "NPV",
	  12: "STDEV",
	  13: "DOLLAR",
	  14: "FIXED",
	  15: "SIN",
	  16: "COS",
	  17: "TAN",
	  18: "ATAN",
	  19: "PI",
	  20: "SQRT",
	  21: "EXP",
	  22: "LN",
	  23: "LOG10",
	  24: "ABS",
	  25: "INT",
	  26: "SIGN",
	  27: "ROUND",
	  28: "LOOKUP",
	  29: "INDEX",
	  30: "REPT",
	  31: "MID",
	  32: "LEN",
	  33: "VALUE",
	  34: "TRUE",
	  35: "FALSE",
	  36: "AND",
	  37: "OR",
	  38: "NOT",
	  39: "MOD",
	  40: "DCOUNT",
	  41: "DSUM",
	  42: "DAVERAGE",
	  43: "DMIN",
	  44: "DMAX",
	  45: "DSTDEV",
	  46: "VAR",
	  47: "DVAR",
	  48: "TEXT",
	  49: "LINEST",
	  50: "TREND",
	  51: "LOGEST",
	  52: "GROWTH",
	  53: "GOTO",
	  54: "HALT",
	  55: "RETURN",
	  56: "PV",
	  57: "FV",
	  58: "NPER",
	  59: "PMT",
	  60: "RATE",
	  61: "MIRR",
	  62: "IRR",
	  63: "RAND",
	  64: "MATCH",
	  65: "DATE",
	  66: "TIME",
	  67: "DAY",
	  68: "MONTH",
	  69: "YEAR",
	  70: "WEEKDAY",
	  71: "HOUR",
	  72: "MINUTE",
	  73: "SECOND",
	  74: "NOW",
	  75: "AREAS",
	  76: "ROWS",
	  77: "COLUMNS",
	  78: "OFFSET",
	  79: "ABSREF",
	  80: "RELREF",
	  81: "ARGUMENT",
	  82: "SEARCH",
	  83: "TRANSPOSE",
	  84: "ERROR",
	  85: "STEP",
	  86: "TYPE",
	  87: "ECHO",
	  88: "SET.NAME",
	  89: "CALLER",
	  90: "DEREF",
	  91: "WINDOWS",
	  92: "SERIES",
	  93: "DOCUMENTS",
	  94: "ACTIVE.CELL",
	  95: "SELECTION",
	  96: "RESULT",
	  97: "ATAN2",
	  98: "ASIN",
	  99: "ACOS",
	  100: "CHOOSE",
	  101: "HLOOKUP",
	  102: "VLOOKUP",
	  103: "LINKS",
	  104: "INPUT",
	  105: "ISREF",
	  106: "GET.FORMULA",
	  107: "GET.NAME",
	  108: "SET.VALUE",
	  109: "LOG",
	  110: "EXEC",
	  111: "CHAR",
	  112: "LOWER",
	  113: "UPPER",
	  114: "PROPER",
	  115: "LEFT",
	  116: "RIGHT",
	  117: "EXACT",
	  118: "TRIM",
	  119: "REPLACE",
	  120: "SUBSTITUTE",
	  121: "CODE",
	  122: "NAMES",
	  123: "DIRECTORY",
	  124: "FIND",
	  125: "CELL",
	  126: "ISERR",
	  127: "ISTEXT",
	  128: "ISNUMBER",
	  129: "ISBLANK",
	  130: "T",
	  131: "N",
	  132: "FOPEN",
	  133: "FCLOSE",
	  134: "FSIZE",
	  135: "FREADLN",
	  136: "FREAD",
	  137: "FWRITELN",
	  138: "FWRITE",
	  139: "FPOS",
	  140: "DATEVALUE",
	  141: "TIMEVALUE",
	  142: "SLN",
	  143: "SYD",
	  144: "DDB",
	  145: "GET.DEF",
	  146: "REFTEXT",
	  147: "TEXTREF",
	  148: "INDIRECT",
	  149: "REGISTER",
	  150: "CALL",
	  151: "ADD.BAR",
	  152: "ADD.MENU",
	  153: "ADD.COMMAND",
	  154: "ENABLE.COMMAND",
	  155: "CHECK.COMMAND",
	  156: "RENAME.COMMAND",
	  157: "SHOW.BAR",
	  158: "DELETE.MENU",
	  159: "DELETE.COMMAND",
	  160: "GET.CHART.ITEM",
	  161: "DIALOG.BOX",
	  162: "CLEAN",
	  163: "MDETERM",
	  164: "MINVERSE",
	  165: "MMULT",
	  166: "FILES",
	  167: "IPMT",
	  168: "PPMT",
	  169: "COUNTA",
	  170: "CANCEL.KEY",
	  171: "FOR",
	  172: "WHILE",
	  173: "BREAK",
	  174: "NEXT",
	  175: "INITIATE",
	  176: "REQUEST",
	  177: "POKE",
	  178: "EXECUTE",
	  179: "TERMINATE",
	  180: "RESTART",
	  181: "HELP",
	  182: "GET.BAR",
	  183: "PRODUCT",
	  184: "FACT",
	  185: "GET.CELL",
	  186: "GET.WORKSPACE",
	  187: "GET.WINDOW",
	  188: "GET.DOCUMENT",
	  189: "DPRODUCT",
	  190: "ISNONTEXT",
	  191: "GET.NOTE",
	  192: "NOTE",
	  193: "STDEVP",
	  194: "VARP",
	  195: "DSTDEVP",
	  196: "DVARP",
	  197: "TRUNC",
	  198: "ISLOGICAL",
	  199: "DCOUNTA",
	  200: "DELETE.BAR",
	  201: "UNREGISTER",
	  204: "USDOLLAR",
	  205: "FINDB",
	  206: "SEARCHB",
	  207: "REPLACEB",
	  208: "LEFTB",
	  209: "RIGHTB",
	  210: "MIDB",
	  211: "LENB",
	  212: "ROUNDUP",
	  213: "ROUNDDOWN",
	  214: "ASC",
	  215: "DBCS",
	  216: "RANK",
	  219: "ADDRESS",
	  220: "DAYS360",
	  221: "TODAY",
	  222: "VDB",
	  223: "ELSE",
	  224: "ELSE.IF",
	  225: "END.IF",
	  226: "FOR.CELL",
	  227: "MEDIAN",
	  228: "SUMPRODUCT",
	  229: "SINH",
	  230: "COSH",
	  231: "TANH",
	  232: "ASINH",
	  233: "ACOSH",
	  234: "ATANH",
	  235: "DGET",
	  236: "CREATE.OBJECT",
	  237: "VOLATILE",
	  238: "LAST.ERROR",
	  239: "CUSTOM.UNDO",
	  240: "CUSTOM.REPEAT",
	  241: "FORMULA.CONVERT",
	  242: "GET.LINK.INFO",
	  243: "TEXT.BOX",
	  244: "INFO",
	  245: "GROUP",
	  246: "GET.OBJECT",
	  247: "DB",
	  248: "PAUSE",
	  251: "RESUME",
	  252: "FREQUENCY",
	  253: "ADD.TOOLBAR",
	  254: "DELETE.TOOLBAR",
	  255: "User",
	  256: "RESET.TOOLBAR",
	  257: "EVALUATE",
	  258: "GET.TOOLBAR",
	  259: "GET.TOOL",
	  260: "SPELLING.CHECK",
	  261: "ERROR.TYPE",
	  262: "APP.TITLE",
	  263: "WINDOW.TITLE",
	  264: "SAVE.TOOLBAR",
	  265: "ENABLE.TOOL",
	  266: "PRESS.TOOL",
	  267: "REGISTER.ID",
	  268: "GET.WORKBOOK",
	  269: "AVEDEV",
	  270: "BETADIST",
	  271: "GAMMALN",
	  272: "BETAINV",
	  273: "BINOMDIST",
	  274: "CHIDIST",
	  275: "CHIINV",
	  276: "COMBIN",
	  277: "CONFIDENCE",
	  278: "CRITBINOM",
	  279: "EVEN",
	  280: "EXPONDIST",
	  281: "FDIST",
	  282: "FINV",
	  283: "FISHER",
	  284: "FISHERINV",
	  285: "FLOOR",
	  286: "GAMMADIST",
	  287: "GAMMAINV",
	  288: "CEILING",
	  289: "HYPGEOMDIST",
	  290: "LOGNORMDIST",
	  291: "LOGINV",
	  292: "NEGBINOMDIST",
	  293: "NORMDIST",
	  294: "NORMSDIST",
	  295: "NORMINV",
	  296: "NORMSINV",
	  297: "STANDARDIZE",
	  298: "ODD",
	  299: "PERMUT",
	  300: "POISSON",
	  301: "TDIST",
	  302: "WEIBULL",
	  303: "SUMXMY2",
	  304: "SUMX2MY2",
	  305: "SUMX2PY2",
	  306: "CHITEST",
	  307: "CORREL",
	  308: "COVAR",
	  309: "FORECAST",
	  310: "FTEST",
	  311: "INTERCEPT",
	  312: "PEARSON",
	  313: "RSQ",
	  314: "STEYX",
	  315: "SLOPE",
	  316: "TTEST",
	  317: "PROB",
	  318: "DEVSQ",
	  319: "GEOMEAN",
	  320: "HARMEAN",
	  321: "SUMSQ",
	  322: "KURT",
	  323: "SKEW",
	  324: "ZTEST",
	  325: "LARGE",
	  326: "SMALL",
	  327: "QUARTILE",
	  328: "PERCENTILE",
	  329: "PERCENTRANK",
	  330: "MODE",
	  331: "TRIMMEAN",
	  332: "TINV",
	  334: "MOVIE.COMMAND",
	  335: "GET.MOVIE",
	  336: "CONCATENATE",
	  337: "POWER",
	  338: "PIVOT.ADD.DATA",
	  339: "GET.PIVOT.TABLE",
	  340: "GET.PIVOT.FIELD",
	  341: "GET.PIVOT.ITEM",
	  342: "RADIANS",
	  343: "DEGREES",
	  344: "SUBTOTAL",
	  345: "SUMIF",
	  346: "COUNTIF",
	  347: "COUNTBLANK",
	  348: "SCENARIO.GET",
	  349: "OPTIONS.LISTS.GET",
	  350: "ISPMT",
	  351: "DATEDIF",
	  352: "DATESTRING",
	  353: "NUMBERSTRING",
	  354: "ROMAN",
	  355: "OPEN.DIALOG",
	  356: "SAVE.DIALOG",
	  357: "VIEW.GET",
	  358: "GETPIVOTDATA",
	  359: "HYPERLINK",
	  360: "PHONETIC",
	  361: "AVERAGEA",
	  362: "MAXA",
	  363: "MINA",
	  364: "STDEVPA",
	  365: "VARPA",
	  366: "STDEVA",
	  367: "VARA",
	  368: "BAHTTEXT",
	  369: "THAIDAYOFWEEK",
	  370: "THAIDIGIT",
	  371: "THAIMONTHOFYEAR",
	  372: "THAINUMSOUND",
	  373: "THAINUMSTRING",
	  374: "THAISTRINGLENGTH",
	  375: "ISTHAIDIGIT",
	  376: "ROUNDBAHTDOWN",
	  377: "ROUNDBAHTUP",
	  378: "THAIYEAR",
	  379: "RTD",
	  380: "CUBEVALUE",
	  381: "CUBEMEMBER",
	  382: "CUBEMEMBERPROPERTY",
	  383: "CUBERANKEDMEMBER",
	  384: "HEX2BIN",
	  385: "HEX2DEC",
	  386: "HEX2OCT",
	  387: "DEC2BIN",
	  388: "DEC2HEX",
	  389: "DEC2OCT",
	  390: "OCT2BIN",
	  391: "OCT2HEX",
	  392: "OCT2DEC",
	  393: "BIN2DEC",
	  394: "BIN2OCT",
	  395: "BIN2HEX",
	  396: "IMSUB",
	  397: "IMDIV",
	  398: "IMPOWER",
	  399: "IMABS",
	  400: "IMSQRT",
	  401: "IMLN",
	  402: "IMLOG2",
	  403: "IMLOG10",
	  404: "IMSIN",
	  405: "IMCOS",
	  406: "IMEXP",
	  407: "IMARGUMENT",
	  408: "IMCONJUGATE",
	  409: "IMAGINARY",
	  410: "IMREAL",
	  411: "COMPLEX",
	  412: "IMSUM",
	  413: "IMPRODUCT",
	  414: "SERIESSUM",
	  415: "FACTDOUBLE",
	  416: "SQRTPI",
	  417: "QUOTIENT",
	  418: "DELTA",
	  419: "GESTEP",
	  420: "ISEVEN",
	  421: "ISODD",
	  422: "MROUND",
	  423: "ERF",
	  424: "ERFC",
	  425: "BESSELJ",
	  426: "BESSELK",
	  427: "BESSELY",
	  428: "BESSELI",
	  429: "XIRR",
	  430: "XNPV",
	  431: "PRICEMAT",
	  432: "YIELDMAT",
	  433: "INTRATE",
	  434: "RECEIVED",
	  435: "DISC",
	  436: "PRICEDISC",
	  437: "YIELDDISC",
	  438: "TBILLEQ",
	  439: "TBILLPRICE",
	  440: "TBILLYIELD",
	  441: "PRICE",
	  442: "YIELD",
	  443: "DOLLARDE",
	  444: "DOLLARFR",
	  445: "NOMINAL",
	  446: "EFFECT",
	  447: "CUMPRINC",
	  448: "CUMIPMT",
	  449: "EDATE",
	  450: "EOMONTH",
	  451: "YEARFRAC",
	  452: "COUPDAYBS",
	  453: "COUPDAYS",
	  454: "COUPDAYSNC",
	  455: "COUPNCD",
	  456: "COUPNUM",
	  457: "COUPPCD",
	  458: "DURATION",
	  459: "MDURATION",
	  460: "ODDLPRICE",
	  461: "ODDLYIELD",
	  462: "ODDFPRICE",
	  463: "ODDFYIELD",
	  464: "RANDBETWEEN",
	  465: "WEEKNUM",
	  466: "AMORDEGRC",
	  467: "AMORLINC",
	  468: "CONVERT",
	  724: "SHEETJS",
	  469: "ACCRINT",
	  470: "ACCRINTM",
	  471: "WORKDAY",
	  472: "NETWORKDAYS",
	  473: "GCD",
	  474: "MULTINOMIAL",
	  475: "LCM",
	  476: "FVSCHEDULE",
	  477: "CUBEKPIMEMBER",
	  478: "CUBESET",
	  479: "CUBESETCOUNT",
	  480: "IFERROR",
	  481: "COUNTIFS",
	  482: "SUMIFS",
	  483: "AVERAGEIF",
	  484: "AVERAGEIFS"
	};
	var FtabArgc = {
	  2: 1,
	  3: 1,
	  10: 0,
	  15: 1,
	  16: 1,
	  17: 1,
	  18: 1,
	  19: 0,
	  20: 1,
	  21: 1,
	  22: 1,
	  23: 1,
	  24: 1,
	  25: 1,
	  26: 1,
	  27: 2,
	  30: 2,
	  31: 3,
	  32: 1,
	  33: 1,
	  34: 0,
	  35: 0,
	  38: 1,
	  39: 2,
	  40: 3,
	  41: 3,
	  42: 3,
	  43: 3,
	  44: 3,
	  45: 3,
	  47: 3,
	  48: 2,
	  53: 1,
	  61: 3,
	  63: 0,
	  65: 3,
	  66: 3,
	  67: 1,
	  68: 1,
	  69: 1,
	  70: 1,
	  71: 1,
	  72: 1,
	  73: 1,
	  74: 0,
	  75: 1,
	  76: 1,
	  77: 1,
	  79: 2,
	  80: 2,
	  83: 1,
	  85: 0,
	  86: 1,
	  89: 0,
	  90: 1,
	  94: 0,
	  95: 0,
	  97: 2,
	  98: 1,
	  99: 1,
	  101: 3,
	  102: 3,
	  105: 1,
	  106: 1,
	  108: 2,
	  111: 1,
	  112: 1,
	  113: 1,
	  114: 1,
	  117: 2,
	  118: 1,
	  119: 4,
	  121: 1,
	  126: 1,
	  127: 1,
	  128: 1,
	  129: 1,
	  130: 1,
	  131: 1,
	  133: 1,
	  134: 1,
	  135: 1,
	  136: 2,
	  137: 2,
	  138: 2,
	  140: 1,
	  141: 1,
	  142: 3,
	  143: 4,
	  144: 4,
	  161: 1,
	  162: 1,
	  163: 1,
	  164: 1,
	  165: 2,
	  172: 1,
	  175: 2,
	  176: 2,
	  177: 3,
	  178: 2,
	  179: 1,
	  184: 1,
	  186: 1,
	  189: 3,
	  190: 1,
	  195: 3,
	  196: 3,
	  197: 1,
	  198: 1,
	  199: 3,
	  201: 1,
	  207: 4,
	  210: 3,
	  211: 1,
	  212: 2,
	  213: 2,
	  214: 1,
	  215: 1,
	  225: 0,
	  229: 1,
	  230: 1,
	  231: 1,
	  232: 1,
	  233: 1,
	  234: 1,
	  235: 3,
	  244: 1,
	  247: 4,
	  252: 2,
	  257: 1,
	  261: 1,
	  271: 1,
	  273: 4,
	  274: 2,
	  275: 2,
	  276: 2,
	  277: 3,
	  278: 3,
	  279: 1,
	  280: 3,
	  281: 3,
	  282: 3,
	  283: 1,
	  284: 1,
	  285: 2,
	  286: 4,
	  287: 3,
	  288: 2,
	  289: 4,
	  290: 3,
	  291: 3,
	  292: 3,
	  293: 4,
	  294: 1,
	  295: 3,
	  296: 1,
	  297: 3,
	  298: 1,
	  299: 2,
	  300: 3,
	  301: 3,
	  302: 4,
	  303: 2,
	  304: 2,
	  305: 2,
	  306: 2,
	  307: 2,
	  308: 2,
	  309: 3,
	  310: 2,
	  311: 2,
	  312: 2,
	  313: 2,
	  314: 2,
	  315: 2,
	  316: 4,
	  325: 2,
	  326: 2,
	  327: 2,
	  328: 2,
	  331: 2,
	  332: 2,
	  337: 2,
	  342: 1,
	  343: 1,
	  346: 2,
	  347: 1,
	  350: 4,
	  351: 3,
	  352: 1,
	  353: 2,
	  360: 1,
	  368: 1,
	  369: 1,
	  370: 1,
	  371: 1,
	  372: 1,
	  373: 1,
	  374: 1,
	  375: 1,
	  376: 1,
	  377: 1,
	  378: 1,
	  382: 3,
	  385: 1,
	  392: 1,
	  393: 1,
	  396: 2,
	  397: 2,
	  398: 2,
	  399: 1,
	  400: 1,
	  401: 1,
	  402: 1,
	  403: 1,
	  404: 1,
	  405: 1,
	  406: 1,
	  407: 1,
	  408: 1,
	  409: 1,
	  410: 1,
	  414: 4,
	  415: 1,
	  416: 1,
	  417: 2,
	  420: 1,
	  421: 1,
	  422: 2,
	  424: 1,
	  425: 2,
	  426: 2,
	  427: 2,
	  428: 2,
	  430: 3,
	  438: 3,
	  439: 3,
	  440: 3,
	  443: 2,
	  444: 2,
	  445: 2,
	  446: 2,
	  447: 6,
	  448: 6,
	  449: 2,
	  450: 2,
	  464: 2,
	  468: 3,
	  476: 2,
	  479: 1,
	  480: 2,
	  65535: 0
	};
	/* Part 3 TODO: actually parse formulae */
	function ods_to_csf_formula(f) {
		if(f.slice(0,3) == "of:") f = f.slice(3);
		/* 5.2 Basic Expressions */
		if(f.charCodeAt(0) == 61) {
			f = f.slice(1);
			if(f.charCodeAt(0) == 61) f = f.slice(1);
		}
		f = f.replace(/COM\.MICROSOFT\./g, "");
		/* Part 3 Section 5.8 References */
		f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
		/* TODO: something other than this */
		f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
		return f.replace(/[;~]/g,",").replace(/\|/g,";");
	}
	
	function csf_to_ods_formula(f) {
		var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
		/* TODO: something other than this */
		return o.replace(/;/g, "|").replace(/,/g,";");
	}
	
	function ods_to_csf_3D(r) {
		var a = r.split(":");
		var s = a[0].split(".")[0];
		return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
	}
	
	function csf_to_ods_3D(r) {
		return r.replace(/\./,"!");
	}
	
	var strs = {}; // shared strings
	var _ssfopts = {}; // spreadsheet formatting options
	
	
	/*global Map */
	var browser_has_Map = typeof Map !== 'undefined';
	
	function get_sst_id(sst, str, rev) {
		var i = 0, len = sst.length;
		if(rev) {
			if(browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
				var revarr = browser_has_Map ? rev.get(str) : rev[str];
				for(; i < revarr.length; ++i) {
					if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
				}
			}
		} else for(; i < len; ++i) {
			if(sst[i].t === str) { sst.Count ++; return i; }
		}
		sst[len] = ({t:str}); sst.Count ++; sst.Unique ++;
		if(rev) {
			if(browser_has_Map) {
				if(!rev.has(str)) rev.set(str, []);
				rev.get(str).push(len);
			} else {
				if(!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
				rev[str].push(len);
			}
		}
		return len;
	}
	
	function col_obj_w(C, col) {
		var p = ({min:C+1,max:C+1});
		/* wch (chars), wpx (pixels) */
		var wch = -1;
		if(col.MDW) MDW = col.MDW;
		if(col.width != null) p.customWidth = 1;
		else if(col.wpx != null) wch = px2char(col.wpx);
		else if(col.wch != null) wch = col.wch;
		if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
		else if(col.width != null) p.width = col.width;
		if(col.hidden) p.hidden = true;
		if(col.level != null) { p.outlineLevel = p.level = col.level; }
		return p;
	}
	
	function default_margins(margins, mode) {
		if(!margins) return;
		var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
		if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
		if(margins.left   == null) margins.left   = defs[0];
		if(margins.right  == null) margins.right  = defs[1];
		if(margins.top    == null) margins.top    = defs[2];
		if(margins.bottom == null) margins.bottom = defs[3];
		if(margins.header == null) margins.header = defs[4];
		if(margins.footer == null) margins.footer = defs[5];
	}
	
	function get_cell_style(styles, cell, opts) {
		var z = opts.revssf[cell.z != null ? cell.z : "General"];
		var i = 0x3c, len = styles.length;
		if(z == null && opts.ssf) {
			for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
				SSF_load(cell.z, i);
				// $FlowIgnore
				opts.ssf[i] = cell.z;
				opts.revssf[cell.z] = z = i;
				break;
			}
		}
		for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
		styles[len] = {
			numFmtId:z,
			fontId:0,
			fillId:0,
			borderId:0,
			xfId:0,
			applyNumberFormat:1
		};
		return len;
	}
	
	function safe_format(p, fmtid, fillid, opts, themes, styles) {
		try {
			if(opts.cellNF) p.z = table_fmt[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(p.t === 'z' && !opts.cellStyles) return;
		if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
		if((!opts || opts.cellText !== false) && p.t !== 'z') try {
			if(table_fmt[fmtid] == null) SSF_load(SSFImplicit[fmtid] || "General", fmtid);
			if(p.t === 'e') p.w = p.w || BErr[p.v];
			else if(fmtid === 0) {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = p.v.toString(10);
					else p.w = SSF_general_num(p.v);
				}
				else if(p.t === 'd') {
					var dd = datenum(p.v);
					if((dd|0) === dd) p.w = dd.toString(10);
					else p.w = SSF_general_num(dd);
				}
				else if(p.v === undefined) return "";
				else p.w = SSF_general(p.v,_ssfopts);
			}
			else if(p.t === 'd') p.w = SSF_format(fmtid,datenum(p.v),_ssfopts);
			else p.w = SSF_format(fmtid,p.v,_ssfopts);
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts.cellStyles) return;
		if(fillid != null) try {
			p.s = styles.Fills[fillid];
			if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
				p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
				if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
			}
			if (p.s.bgColor && p.s.bgColor.theme) {
				p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
				if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
			}
		} catch(e) { if(opts.WTF && styles.Fills) throw e; }
	}
	
	function check_ws(ws, sname, i) {
		if(ws && ws['!ref']) {
			var range = safe_decode_range(ws['!ref']);
			if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
		}
	}
	function parse_ws_xml_dim(ws, s) {
		var d = safe_decode_range(s);
		if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
	}
	var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
	var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
	var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
	var dimregex = /"(\w*:\w*)"/;
	var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
	var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
	var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
	var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
	var sheetprregex2= /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
	var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
	
	/* 18.3 Worksheets */
	function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	
		/* 18.3.1.99 worksheet CT_Worksheet */
		var s = opts.dense ? ([]) : ({});
		var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });
	
		var data1 = "", data2 = "";
		var mtch = data.match(sheetdataregex);
		if(mtch) {
			data1 = data.slice(0, mtch.index);
			data2 = data.slice(mtch.index + mtch[0].length);
		} else data1 = data2 = data;
	
		/* 18.3.1.82 sheetPr CT_SheetPr */
		var sheetPr = data1.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
		else if((sheetPr = data1.match(sheetprregex2))) parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1]||"", s, wb, idx, styles, themes);
	
		/* 18.3.1.35 dimension CT_SheetDimension */
		var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
		if(ridx > 0) {
			var ref = data1.slice(ridx,ridx+50).match(dimregex);
			if(ref) parse_ws_xml_dim(s, ref[1]);
		}
	
		/* 18.3.1.88 sheetViews CT_SheetViews */
		var svs = data1.match(svsregex);
		if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);
	
		/* 18.3.1.17 cols CT_Cols */
		var columns = [];
		if(opts.cellStyles) {
			/* 18.3.1.13 col CT_Col */
			var cols = data1.match(colregex);
			if(cols) parse_ws_xml_cols(columns, cols);
		}
	
		/* 18.3.1.80 sheetData CT_SheetData ? */
		if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
	
		/* 18.3.1.2  autoFilter CT_AutoFilter */
		var afilter = data2.match(afregex);
		if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);
	
		/* 18.3.1.55 mergeCells CT_MergeCells */
		var merges = [];
		var _merge = data2.match(mergecregex);
		if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
			merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));
	
		/* 18.3.1.48 hyperlinks CT_Hyperlinks */
		var hlink = data2.match(hlinkregex);
		if(hlink) parse_ws_xml_hlinks(s, hlink, rels);
	
		/* 18.3.1.62 pageMargins CT_PageMargins */
		var margins = data2.match(marginregex);
		if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));
	
		if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
		if(opts.sheetRows > 0 && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(columns.length > 0) s["!cols"] = columns;
		if(merges.length > 0) s["!merges"] = merges;
		return s;
	}
	
	function write_ws_xml_merges(merges) {
		if(merges.length === 0) return "";
		var o = '<mergeCells count="' + merges.length + '">';
		for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
		return o + '</mergeCells>';
	}
	
	/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
	function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
		var data = parsexmltag(sheetPr);
		if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
		if(data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
	}
	function parse_ws_xml_sheetpr2(sheetPr, body, s, wb, idx) {
		parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
	}
	function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
		var needed = false;
		var props = {}, payload = null;
		if(opts.bookType !== 'xlsx' && wb.vbaraw) {
			var cname = wb.SheetNames[idx];
			try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
			needed = true;
			props.codeName = utf8write(escapexml(cname));
		}
	
		if(ws && ws["!outline"]) {
			var outlineprops = {summaryBelow:1, summaryRight:1};
			if(ws["!outline"].above) outlineprops.summaryBelow = 0;
			if(ws["!outline"].left) outlineprops.summaryRight = 0;
			payload = (payload||"") + writextag('outlinePr', null, outlineprops);
		}
	
		if(!needed && !payload) return;
		o[o.length] = (writextag('sheetPr', payload, props));
	}
	
	/* 18.3.1.85 sheetProtection CT_SheetProtection */
	var sheetprot_deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
	var sheetprot_deftrue = [
		"formatColumns", "formatRows", "formatCells",
		"insertColumns", "insertRows", "insertHyperlinks",
		"deleteColumns", "deleteRows",
		"sort", "autoFilter", "pivotTables"
	];
	function write_ws_xml_protection(sp) {
		// algorithmName, hashValue, saltValue, spinCount
		var o = ({sheet:1});
		sheetprot_deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
		sheetprot_deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
		/* TODO: algorithm */
		if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
		return writextag('sheetProtection', null, o);
	}
	
	function parse_ws_xml_hlinks(s, data, rels) {
		var dense = Array.isArray(s);
		for(var i = 0; i != data.length; ++i) {
			var val = parsexmltag(utf8read(data[i]), true);
			if(!val.ref) return;
			var rel = ((rels || {})['!id']||[])[val.id];
			if(rel) {
				val.Target = rel.Target;
				if(val.location) val.Target += "#"+unescapexml(val.location);
			} else {
				val.Target = "#" + unescapexml(val.location);
				rel = {Target: val.Target, TargetMode: 'Internal'};
			}
			val.Rel = rel;
			if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
			var rng = safe_decode_range(val.ref);
			for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
				var addr = encode_cell({c:C,r:R});
				if(dense) {
					if(!s[R]) s[R] = [];
					if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
					s[R][C].l = val;
				} else {
					if(!s[addr]) s[addr] = {t:"z",v:undefined};
					s[addr].l = val;
				}
			}
		}
	}
	
	function parse_ws_xml_margins(margin) {
		var o = {};
		["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
			if(margin[k]) o[k] = parseFloat(margin[k]);
		});
		return o;
	}
	function write_ws_xml_margins(margin) {
		default_margins(margin);
		return writextag('pageMargins', null, margin);
	}
	
	function parse_ws_xml_cols(columns, cols) {
		var seencol = false;
		for(var coli = 0; coli != cols.length; ++coli) {
			var coll = parsexmltag(cols[coli], true);
			if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
			var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
			if(coll.outlineLevel) coll.level = (+coll.outlineLevel || 0);
			delete coll.min; delete coll.max; coll.width = +coll.width;
			if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
			process_col(coll);
			while(colm <= colM) columns[colm++] = dup(coll);
		}
	}
	function write_ws_xml_cols(ws, cols) {
		var o = ["<cols>"], col;
		for(var i = 0; i != cols.length; ++i) {
			if(!(col = cols[i])) continue;
			o[o.length] = (writextag('col', null, col_obj_w(i, col)));
		}
		o[o.length] = "</cols>";
		return o.join("");
	}
	
	function parse_ws_xml_autofilter(data) {
		var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
		return o;
	}
	function write_ws_xml_autofilter(data, ws, wb, idx) {
		var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
		return writextag("autoFilter", null, {ref:ref});
	}
	
	/* 18.3.1.88 sheetViews CT_SheetViews */
	/* 18.3.1.87 sheetView CT_SheetView */
	var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
	function parse_ws_xml_sheetviews(data, wb) {
		if(!wb.Views) wb.Views = [{}];
		(data.match(sviewregex)||[]).forEach(function(r, i) {
			var tag = parsexmltag(r);
			// $FlowIgnore
			if(!wb.Views[i]) wb.Views[i] = {};
			// $FlowIgnore
			if(+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
			// $FlowIgnore
			if(parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
		});
	}
	function write_ws_xml_sheetviews(ws, opts, idx, wb) {
		var sview = ({workbookViewId:"0"});
		// $FlowIgnore
		if((((wb||{}).Workbook||{}).Views||[])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
		return writextag("sheetViews", writextag("sheetView", null, sview), {});
	}
	
	function write_ws_xml_cell(cell, ref, ws, opts) {
		if(cell.c) ws['!comments'].push([ref, cell.c]);
		if(cell.v === undefined && typeof cell.f !== "string" || cell.t === 'z' && !cell.f) return "";
		var vv = "";
		var oldt = cell.t, oldv = cell.v;
		if(cell.t !== "z") switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'n': vv = ''+cell.v; break;
			case 'e': vv = BErr[cell.v]; break;
			case 'd':
				if(opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
				else {
					cell = dup(cell);
					cell.t = 'n';
					vv = ''+(cell.v = datenum(parseDate(cell.v)));
				}
				if(typeof cell.z === 'undefined') cell.z = table_fmt[14];
				break;
			default: vv = cell.v; break;
		}
		var v = writetag('v', escapexml(vv)), o = ({r:ref});
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		if(os !== 0) o.s = os;
		switch(cell.t) {
			case 'n': break;
			case 'd': o.t = "d"; break;
			case 'b': o.t = "b"; break;
			case 'e': o.t = "e"; break;
			case 'z': break;
			default: if(cell.v == null) { delete cell.t; break; }
				if(cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
				if(opts && opts.bookSST) {
					v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
					o.t = "s"; break;
				}
				o.t = "str"; break;
		}
		if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
		if(typeof cell.f == "string" && cell.f) {
			var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
			v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
		}
		if(cell.l) ws['!links'].push([ref, cell.l]);
		if(cell.D) o.cm = 1;
		return writextag('c', v, o);
	}
	
	var parse_ws_xml_data = (function() {
		var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
		var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
		var refregex = /ref=["']([^"']*)["']/;
		var match_v = matchtag("v"), match_f = matchtag("f");
	
	return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
		var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
		var tag, tagr = 0, tagc = 0;
		var sstr, ftag;
		var fmtid = 0, fillid = 0;
		var do_format = Array.isArray(styles.CellXf), cf;
		var arrayf = [];
		var sharedf = [];
		var dense = Array.isArray(s);
		var rows = [], rowobj = {}, rowrite = false;
		var sheetStubs = !!opts.sheetStubs;
		for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
			x = marr[mt].trim();
			var xlen = x.length;
			if(xlen === 0) continue;
	
			/* 18.3.1.73 row CT_Row */
			var rstarti = 0;
			outa: for(ri = 0; ri < xlen; ++ri) switch(/*x.charCodeAt(ri)*/x[ri]) {
				case ">" /*62*/:
					if(/*x.charCodeAt(ri-1) != 47*/x[ri-1] != "/") { ++ri; break outa; }
					if(opts && opts.cellStyles) {
						// TODO: avoid duplication
						tag = parsexmltag(x.slice(rstarti,ri), true);
						tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
						if(opts.sheetRows && opts.sheetRows < tagr) continue;
						rowobj = {}; rowrite = false;
						if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
						if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
						if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
						if(rowrite) rows[tagr-1] = rowobj;
					}
					break;
				case "<" /*60*/: rstarti = ri; break;
			}
			if(rstarti >= ri) break;
			tag = parsexmltag(x.slice(rstarti,ri), true);
			tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
			if(opts.sheetRows && opts.sheetRows < tagr) continue;
			if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
			if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;
	
			if(opts && opts.cellStyles) {
				rowobj = {}; rowrite = false;
				if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
				if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
				if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
				if(rowrite) rows[tagr-1] = rowobj;
			}
	
			/* 18.3.1.4 c CT_Cell */
			cells = x.slice(ri).split(cellregex);
			for(var rslice = 0; rslice != cells.length; ++rslice) if(cells[rslice].trim().charAt(0) != "<") break;
			cells = cells.slice(rslice);
			for(ri = 0; ri != cells.length; ++ri) {
				x = cells[ri].trim();
				if(x.length === 0) continue;
				cref = x.match(rregex); idx = ri; i=0; cc=0;
				x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
				if(cref != null && cref.length === 2) {
					idx = 0; d=cref[1];
					for(i=0; i != d.length; ++i) {
						if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
						idx = 26*idx + cc;
					}
					--idx;
					tagc = idx;
				} else ++tagc;
				for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
				tag = parsexmltag(x.slice(0,i), true);
				if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
				d = x.slice(i);
				p = ({t:""});
	
				if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
				if(opts.cellFormula) {
					if((cref=d.match(match_f))!= null && cref[1] !== '') {
						/* TODO: match against XLSXFutureFunctions */
						p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g, "\n");
						if(!opts.xlfn) p.f = _xlfn(p.f);
						if(cref[0].indexOf('t="array"') > -1) {
							p.F = (d.match(refregex)||[])[1];
							if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
						} else if(cref[0].indexOf('t="shared"') > -1) {
							// TODO: parse formula
							ftag = parsexmltag(cref[0]);
							var ___f = unescapexml(utf8read(cref[1]));
							if(!opts.xlfn) ___f = _xlfn(___f);
							sharedf[parseInt(ftag.si, 10)] = [ftag, ___f, tag.r];
						}
					} else if((cref=d.match(/<f[^>]*\/>/))) {
						ftag = parsexmltag(cref[0]);
						if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
					}
					/* TODO: factor out contains logic */
					var _tag = decode_cell(tag.r);
					for(i = 0; i < arrayf.length; ++i)
						if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
							if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
								p.F = arrayf[i][1];
				}
	
				if(tag.t == null && p.v === undefined) {
					if(p.f || p.F) {
						p.v = 0; p.t = "n";
					} else if(!sheetStubs) continue;
					else p.t = "z";
				}
				else p.t = tag.t || "n";
				if(guess.s.c > tagc) guess.s.c = tagc;
				if(guess.e.c < tagc) guess.e.c = tagc;
				/* 18.18.11 t ST_CellType */
				switch(p.t) {
					case 'n':
						if(p.v == "" || p.v == null) {
							if(!sheetStubs) continue;
							p.t = 'z';
						} else p.v = parseFloat(p.v);
						break;
					case 's':
						if(typeof p.v == 'undefined') {
							if(!sheetStubs) continue;
							p.t = 'z';
						} else {
							sstr = strs[parseInt(p.v, 10)];
							p.v = sstr.t;
							p.r = sstr.r;
							if(opts.cellHTML) p.h = sstr.h;
						}
						break;
					case 'str':
						p.t = "s";
						p.v = (p.v!=null) ? utf8read(p.v) : '';
						if(opts.cellHTML) p.h = escapehtml(p.v);
						break;
					case 'inlineStr':
						cref = d.match(isregex);
						p.t = 's';
						if(cref != null && (sstr = parse_si(cref[1]))) {
							p.v = sstr.t;
							if(opts.cellHTML) p.h = sstr.h;
						} else p.v = "";
						break;
					case 'b': p.v = parsexmlbool(p.v); break;
					case 'd':
						if(opts.cellDates) p.v = parseDate(p.v, 1);
						else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
						break;
					/* error string in .w, number in .v */
					case 'e':
						if(!opts || opts.cellText !== false) p.w = p.v;
						p.v = RBErr[p.v]; break;
				}
				/* formatting */
				fmtid = fillid = 0;
				cf = null;
				if(do_format && tag.s !== undefined) {
					cf = styles.CellXf[tag.s];
					if(cf != null) {
						if(cf.numFmtId != null) fmtid = cf.numFmtId;
						if(opts.cellStyles) {
							if(cf.fillId != null) fillid = cf.fillId;
						}
					}
				}
				safe_format(p, fmtid, fillid, opts, themes, styles);
				if(opts.cellDates && do_format && p.t == 'n' && fmt_is_date(table_fmt[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
				if(tag.cm && opts.xlmeta) {
					var cm = (opts.xlmeta.Cell||[])[+tag.cm-1];
					if(cm && cm.type == 'XLDAPR') p.D = true;
				}
				if(dense) {
					var _r = decode_cell(tag.r);
					if(!s[_r.r]) s[_r.r] = [];
					s[_r.r][_r.c] = p;
				} else s[tag.r] = p;
			}
		}
		if(rows.length > 0) s['!rows'] = rows;
	}; })();
	
	function write_ws_xml_data(ws, opts, idx, wb) {
		var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
		var dense = Array.isArray(ws);
		var params = ({r:rr}), row, height = -1;
		for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
		for(R = range.s.r; R <= range.e.r; ++R) {
			r = [];
			rr = encode_row(R);
			for(C = range.s.c; C <= range.e.c; ++C) {
				ref = cols[C] + rr;
				var _cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(_cell === undefined) continue;
				if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
			}
			if(r.length > 0 || (rows && rows[R])) {
				params = ({r:rr});
				if(rows && rows[R]) {
					row = rows[R];
					if(row.hidden) params.hidden = 1;
					height = -1;
					if(row.hpx) height = px2pt(row.hpx);
					else if(row.hpt) height = row.hpt;
					if(height > -1) { params.ht = height; params.customHeight = 1; }
					if(row.level) { params.outlineLevel = row.level; }
				}
				o[o.length] = (writextag('row', r.join(""), params));
			}
		}
		if(rows) for(; R < rows.length; ++R) {
			if(rows && rows[R]) {
				params = ({r:R+1});
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if (row.hpx) height = px2pt(row.hpx);
				else if (row.hpt) height = row.hpt;
				if (height > -1) { params.ht = height; params.customHeight = 1; }
				if (row.level) { params.outlineLevel = row.level; }
				o[o.length] = (writextag('row', "", params));
			}
		}
		return o.join("");
	}
	
	function write_ws_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, writextag('worksheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		})];
		var s = wb.SheetNames[idx], sidx = 0, rdata = "";
		var ws = wb.Sheets[s];
		if(ws == null) ws = {};
		var ref = ws['!ref'] || 'A1';
		var range = safe_decode_range(ref);
		if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
			range.e.c = Math.min(range.e.c, 0x3FFF);
			range.e.r = Math.min(range.e.c, 0xFFFFF);
			ref = encode_range(range);
		}
		if(!rels) rels = {};
		ws['!comments'] = [];
		var _drawing = [];
	
		write_ws_xml_sheetpr(ws, wb, idx, opts, o);
	
		o[o.length] = (writextag('dimension', null, {'ref': ref}));
	
		o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);
	
		/* TODO: store in WB, process styles */
		if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
			defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
			baseColWidth:opts.sheetFormat.baseColWidth||'10',
			outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
		}));
	
		if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));
	
		o[sidx = o.length] = '<sheetData/>';
		ws['!links'] = [];
		if(ws['!ref'] != null) {
			rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
			if(rdata.length > 0) o[o.length] = (rdata);
		}
		if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }
	
		/* sheetCalcPr */
	
		if(ws['!protect']) o[o.length] = write_ws_xml_protection(ws['!protect']);
	
		/* protectedRanges */
		/* scenarios */
	
		if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
	
		/* sortState */
		/* dataConsolidate */
		/* customSheetViews */
	
		if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));
	
		/* phoneticPr */
		/* conditionalFormatting */
		/* dataValidations */
	
		var relc = -1, rel, rId = -1;
		if(ws['!links'].length > 0) {
			o[o.length] = "<hyperlinks>";
	ws['!links'].forEach(function(l) {
				if(!l[1].Target) return;
				rel = ({"ref":l[0]});
				if(l[1].Target.charAt(0) != "#") {
					rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
					rel["r:id"] = "rId"+rId;
				}
				if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
				if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
				o[o.length] = writextag("hyperlink",null,rel);
			});
			o[o.length] = "</hyperlinks>";
		}
		delete ws['!links'];
	
		/* printOptions */
	
		if(ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);
	
		/* pageSetup */
		/* headerFooter */
		/* rowBreaks */
		/* colBreaks */
		/* customProperties */
		/* cellWatches */
	
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));
	
		/* smartTags */
	
		if(_drawing.length > 0) {
			rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
			o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
			ws['!drawing'] = _drawing;
		}
	
		if(ws['!comments'].length > 0) {
			rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
			ws['!legacy'] = rId;
		}
	
		/* legacyDrawingHF */
		/* picture */
		/* oleObjects */
		/* controls */
		/* webPublishItems */
		/* tableParts */
		/* extLst */
	
		if(o.length>1) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.726 BrtRowHdr */
	function parse_BrtRowHdr(data, length) {
		var z = ({});
		var tgt = data.l + length;
		z.r = data.read_shift(4);
		data.l += 4; // TODO: ixfe
		var miyRw = data.read_shift(2);
		data.l += 1; // TODO: top/bot padding
		var flags = data.read_shift(1);
		data.l = tgt;
		if(flags & 0x07) z.level = flags & 0x07;
		if(flags & 0x10) z.hidden = true;
		if(flags & 0x20) z.hpt = miyRw / 20;
		return z;
	}
	function write_BrtRowHdr(R, range, ws) {
		var o = new_buf(17+8*16);
		var row = (ws['!rows']||[])[R]||{};
		o.write_shift(4, R);
	
		o.write_shift(4, 0); /* TODO: ixfe */
	
		var miyRw = 0x0140;
		if(row.hpx) miyRw = px2pt(row.hpx) * 20;
		else if(row.hpt) miyRw = row.hpt * 20;
		o.write_shift(2, miyRw);
	
		o.write_shift(1, 0); /* top/bot padding */
	
		var flags = 0x0;
		if(row.level) flags |= row.level;
		if(row.hidden) flags |= 0x10;
		if(row.hpx || row.hpt) flags |= 0x20;
		o.write_shift(1, flags);
	
		o.write_shift(1, 0); /* phonetic guide */
	
		/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
		var ncolspan = 0, lcs = o.l;
		o.l += 4;
	
		var caddr = {r:R, c:0};
		for(var i = 0; i < 16; ++i) {
			if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
			var first = -1, last = -1;
			for(var j = (i<<10); j < ((i+1)<<10); ++j) {
				caddr.c = j;
				var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
				if(cell) { if(first < 0) first = j; last = j; }
			}
			if(first < 0) continue;
			++ncolspan;
			o.write_shift(4, first);
			o.write_shift(4, last);
		}
	
		var l = o.l;
		o.l = lcs;
		o.write_shift(4, ncolspan);
		o.l = l;
	
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function write_row_header(ba, ws, range, R) {
		var o = write_BrtRowHdr(R, range, ws);
		if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 0x0000 /* BrtRowHdr */, o);
	}
	
	/* [MS-XLSB] 2.4.820 BrtWsDim */
	var parse_BrtWsDim = parse_UncheckedRfX;
	var write_BrtWsDim = write_UncheckedRfX;
	
	/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
	function parse_BrtWsFmtInfo() {
	}
	//function write_BrtWsFmtInfo(ws, o) { }
	
	/* [MS-XLSB] 2.4.823 BrtWsProp */
	function parse_BrtWsProp(data, length) {
		var z = {};
		var f = data[data.l]; ++data.l;
		z.above = !(f & 0x40);
		z.left  = !(f & 0x80);
		/* TODO: pull flags */
		data.l += 18;
		z.name = parse_XLSBCodeName(data, length - 19);
		return z;
	}
	function write_BrtWsProp(str, outl, o) {
		if(o == null) o = new_buf(84+4*str.length);
		var f = 0xC0;
		if(outl) {
			if(outl.above) f &= ~0x40;
			if(outl.left)  f &= ~0x80;
		}
		o.write_shift(1, f);
		for(var i = 1; i < 3; ++i) o.write_shift(1,0);
		write_BrtColor({auto:1}, o);
		o.write_shift(-4,-1);
		o.write_shift(-4,-1);
		write_XLSBCodeName(str, o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.306 BrtCellBlank */
	function parse_BrtCellBlank(data) {
		var cell = parse_XLSBCell(data);
		return [cell];
	}
	function write_BrtCellBlank(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		return write_XLSBCell(ncell, o);
	}
	function parse_BrtShortBlank(data) {
		var cell = parse_XLSBShortCell(data);
		return [cell];
	}
	function write_BrtShortBlank(cell, ncell, o) {
		if(o == null) o = new_buf(4);
		return write_XLSBShortCell(ncell, o);
	}
	
	/* [MS-XLSB] 2.4.307 BrtCellBool */
	function parse_BrtCellBool(data) {
		var cell = parse_XLSBCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtCellBool(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	function parse_BrtShortBool(data) {
		var cell = parse_XLSBShortCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtShortBool(cell, ncell, o) {
		if(o == null) o = new_buf(5);
		write_XLSBShortCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.308 BrtCellError */
	function parse_BrtCellError(data) {
		var cell = parse_XLSBCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	function write_BrtCellError(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v);
		return o;
	}
	function parse_BrtShortError(data) {
		var cell = parse_XLSBShortCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	function write_BrtShortError(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		o.write_shift(1, cell.v);
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		return o;
	}
	
	
	/* [MS-XLSB] 2.4.311 BrtCellIsst */
	function parse_BrtCellIsst(data) {
		var cell = parse_XLSBCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtCellIsst(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	function parse_BrtShortIsst(data) {
		var cell = parse_XLSBShortCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtShortIsst(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	
	/* [MS-XLSB] 2.4.313 BrtCellReal */
	function parse_BrtCellReal(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellReal(cell, ncell, o) {
		if(o == null) o = new_buf(16);
		write_XLSBCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	function parse_BrtShortReal(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtShortReal(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBShortCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.314 BrtCellRk */
	function parse_BrtCellRk(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellRk(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	function parse_BrtShortRk(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtShortRk(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtCellRString */
	function parse_BrtCellRString(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RichStr(data);
		return [cell, value, 'is'];
	}
	
	/* [MS-XLSB] 2.4.317 BrtCellSt */
	function parse_BrtCellSt(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtCellSt(cell, ncell, o) {
		if(o == null) o = new_buf(12 + 4 * cell.v.length);
		write_XLSBCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function parse_BrtShortSt(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtShortSt(cell, ncell, o) {
		if(o == null) o = new_buf(8 + 4 * cell.v.length);
		write_XLSBShortCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.653 BrtFmlaBool */
	function parse_BrtFmlaBool(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'b'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.654 BrtFmlaError */
	function parse_BrtFmlaError(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'e'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.655 BrtFmlaNum */
	function parse_BrtFmlaNum(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_Xnum(data);
		var o = [cell, value, 'n'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.656 BrtFmlaString */
	function parse_BrtFmlaString(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_XLWideString(data);
		var o = [cell, value, 'str'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.682 BrtMergeCell */
	var parse_BrtMergeCell = parse_UncheckedRfX;
	var write_BrtMergeCell = write_UncheckedRfX;
	/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
	function write_BrtBeginMergeCells(cnt, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(4, cnt);
		return o;
	}
	
	/* [MS-XLSB] 2.4.662 BrtHLink */
	function parse_BrtHLink(data, length) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var relId = parse_XLNullableWideString(data);
		var loc = parse_XLWideString(data);
		var tooltip = parse_XLWideString(data);
		var display = parse_XLWideString(data);
		data.l = end;
		var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
		if(tooltip) o.Tooltip = tooltip;
		return o;
	}
	function write_BrtHLink(l, rId) {
		var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
		write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
		write_RelID("rId" + rId, o);
		var locidx = l[1].Target.indexOf("#");
		var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
		write_XLWideString(loc || "", o);
		write_XLWideString(l[1].Tooltip || "", o);
		write_XLWideString("", o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.692 BrtPane */
	function parse_BrtPane(/*data, length, opts*/) {
	}
	
	/* [MS-XLSB] 2.4.6 BrtArrFmla */
	function parse_BrtArrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_RfX(data, 16);
		var fAlwaysCalc = data.read_shift(1);
		var o = [rfx]; o[2] = fAlwaysCalc;
		if(opts.cellFormula) {
			var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
			o[1] = formula;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.750 BrtShrFmla */
	function parse_BrtShrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var o = [rfx];
		if(opts.cellFormula) {
			var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
			o[1] = formula;
			data.l = end;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtColInfo */
	/* TODO: once XLS ColInfo is set, combine the functions */
	function write_BrtColInfo(C, col, o) {
		if(o == null) o = new_buf(18);
		var p = col_obj_w(C, col);
		o.write_shift(-4, C);
		o.write_shift(-4, C);
		o.write_shift(4, (p.width || 10) * 256);
		o.write_shift(4, 0/*ixfe*/); // style
		var flags = 0;
		if(col.hidden) flags |= 0x01;
		if(typeof p.width == 'number') flags |= 0x02;
		if(col.level) flags |= (col.level << 8);
		o.write_shift(2, flags); // bit flag
		return o;
	}
	
	/* [MS-XLSB] 2.4.678 BrtMargins */
	var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
	function parse_BrtMargins(data) {
		var margins = ({});
		BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
		return margins;
	}
	function write_BrtMargins(margins, o) {
		if(o == null) o = new_buf(6*8);
		default_margins(margins);
		BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
		return o;
	}
	
	/* [MS-XLSB] 2.4.299 BrtBeginWsView */
	function parse_BrtBeginWsView(data) {
		var f = data.read_shift(2);
		data.l += 28;
		return { RTL: f & 0x20 };
	}
	function write_BrtBeginWsView(ws, Workbook, o) {
		if(o == null) o = new_buf(30);
		var f = 0x39c;
		if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
		o.write_shift(2, f); // bit flag
		o.write_shift(4, 0);
		o.write_shift(4, 0); // view first row
		o.write_shift(4, 0); // view first col
		o.write_shift(1, 0); // gridline color ICV
		o.write_shift(1, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 100); // zoom scale
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0); // workbook view id
		return o;
	}
	
	/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
	function write_BrtCellIgnoreEC(ref) {
		var o = new_buf(24);
		o.write_shift(4, 4);
		o.write_shift(4, 1);
		write_UncheckedRfX(ref, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.748 BrtSheetProtection */
	function write_BrtSheetProtection(sp, o) {
		if(o == null) o = new_buf(16*4+2);
		o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
		o.write_shift(4, 1); // this record should not be written if no protection
		[
			["objects",             false], // fObjects
			["scenarios",           false], // fScenarios
			["formatCells",          true], // fFormatCells
			["formatColumns",        true], // fFormatColumns
			["formatRows",           true], // fFormatRows
			["insertColumns",        true], // fInsertColumns
			["insertRows",           true], // fInsertRows
			["insertHyperlinks",     true], // fInsertHyperlinks
			["deleteColumns",        true], // fDeleteColumns
			["deleteRows",           true], // fDeleteRows
			["selectLockedCells",   false], // fSelLockedCells
			["sort",                 true], // fSort
			["autoFilter",           true], // fAutoFilter
			["pivotTables",          true], // fPivotTables
			["selectUnlockedCells", false]  // fSelUnlockedCells
		].forEach(function(n) {
	if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
			else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
		});
		return o;
	}
	
	function parse_BrtDVal(/*data, length, opts*/) {
	}
	function parse_BrtDVal14(/*data, length, opts*/) {
	}
	/* [MS-XLSB] 2.1.7.61 Worksheet */
	function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		var opts = _opts || {};
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var s = (opts.dense ? [] : {});
	
		var ref;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		var state = [];
		var pass = false, end = false;
		var row, p, cf, R, C, addr, sstr, rr, cell;
		var merges = [];
		opts.biff = 12;
		opts['!row'] = 0;
	
		var ai = 0, af = false;
	
		var arrayf = [];
		var sharedf = {};
		var supbooks = opts.supbooks || wb.supbooks || ([[]]);
		supbooks.sharedf = sharedf;
		supbooks.arrayf = arrayf;
		supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
		if(!opts.supbooks) {
			opts.supbooks = supbooks;
			if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
		}
	
		var colinfo = [], rowinfo = [];
		var seencol = false;
	
		XLSBRecordEnum[0x0010] = { n:"BrtShortReal", f:parse_BrtShortReal };
	
		var cm, vm;
	
		recordhopper(data, function ws_parse(val, RR, RT) {
			if(end) return;
			switch(RT) {
				case 0x0094: /* 'BrtWsDim' */
					ref = val; break;
				case 0x0000: /* 'BrtRowHdr' */
					row = val;
					if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
					rr = encode_row(R = row.r);
					opts['!row'] = row.r;
					if(val.hidden || val.hpt || val.level != null) {
						if(val.hpt) val.hpx = pt2px(val.hpt);
						rowinfo[val.r] = val;
					}
					break;
	
				case 0x0002: /* 'BrtCellRk' */
				case 0x0003: /* 'BrtCellError' */
				case 0x0004: /* 'BrtCellBool' */
				case 0x0005: /* 'BrtCellReal' */
				case 0x0006: /* 'BrtCellSt' */
				case 0x0007: /* 'BrtCellIsst' */
				case 0x0008: /* 'BrtFmlaString' */
				case 0x0009: /* 'BrtFmlaNum' */
				case 0x000A: /* 'BrtFmlaBool' */
				case 0x000B: /* 'BrtFmlaError' */
				case 0x000D: /* 'BrtShortRk' */
				case 0x000E: /* 'BrtShortError' */
				case 0x000F: /* 'BrtShortBool' */
				case 0x0010: /* 'BrtShortReal' */
				case 0x0011: /* 'BrtShortSt' */
				case 0x0012: /* 'BrtShortIsst' */
				case 0x003E: /* 'BrtCellRString' */
					p = ({t:val[2]});
					switch(val[2]) {
						case 'n': p.v = val[1]; break;
						case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
						case 'b': p.v = val[1] ? true : false; break;
						case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
						case 'str': p.t = 's'; p.v = val[1]; break;
						case 'is': p.t = 's'; p.v = val[1].t; break;
					}
					if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
					C = val[0].c == -1 ? C + 1 : val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(opts.cellFormula) {
						af = false;
						for(ai = 0; ai < arrayf.length; ++ai) {
							var aii = arrayf[ai];
							if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
								if(C >= aii[0].s.c && C <= aii[0].e.c) {
									p.F = encode_range(aii[0]); af = true;
								}
						}
						if(!af && val.length > 3) p.f = val[3];
					}
	
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(opts.cellDates && cf && p.t == 'n' && fmt_is_date(table_fmt[cf.numFmtId])) {
						var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
					}
					if(cm) {
						if(cm.type == 'XLDAPR') p.D = true;
						cm = void 0;
					}
					if(vm) vm = void 0;
					break;
	
				case 0x0001: /* 'BrtCellBlank' */
				case 0x000C: /* 'BrtShortBlank' */
					if(!opts.sheetStubs || pass) break;
					p = ({t:'z',v:void 0});
					C = val[0].c == -1 ? C + 1 : val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(cm) {
						if(cm.type == 'XLDAPR') p.D = true;
						cm = void 0;
					}
					if(vm) vm = void 0;
					break;
	
				case 0x00B0: /* 'BrtMergeCell' */
					merges.push(val); break;
	
				case 0x0031: { /* 'BrtCellMeta' */
					cm = ((opts.xlmeta||{}).Cell||[])[val-1];
				} break;
	
				case 0x01EE: /* 'BrtHLink' */
					var rel = rels['!id'][val.relId];
					if(rel) {
						val.Target = rel.Target;
						if(val.loc) val.Target += "#"+val.loc;
						val.Rel = rel;
					} else if(val.relId == '') {
						val.Target = "#" + val.loc;
					}
					for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
						if(opts.dense) {
							if(!s[R]) s[R] = [];
							if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
							s[R][C].l = val;
						} else {
							addr = encode_cell({c:C,r:R});
							if(!s[addr]) s[addr] = {t:'z',v:undefined};
							s[addr].l = val;
						}
					}
					break;
	
				case 0x01AA: /* 'BrtArrFmla' */
					if(!opts.cellFormula) break;
					arrayf.push(val);
					cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					cell.F = encode_range(val[0]);
					break;
				case 0x01AB: /* 'BrtShrFmla' */
					if(!opts.cellFormula) break;
					sharedf[encode_cell(val[0].s)] = val[1];
					cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					break;
	
				/* identical to 'ColInfo' in XLS */
				case 0x003C: /* 'BrtColInfo' */
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01), level: val.level };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
					break;
	
				case 0x00A1: /* 'BrtBeginAFilter' */
					s['!autofilter'] = { ref:encode_range(val) };
					break;
	
				case 0x01DC: /* 'BrtMargins' */
					s['!margins'] = val;
					break;
	
				case 0x0093: /* 'BrtWsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					if(val.above || val.left) s['!outline'] = { above: val.above, left: val.left };
					break;
	
				case 0x0089: /* 'BrtBeginWsView' */
					if(!wb.Views) wb.Views = [{}];
					if(!wb.Views[0]) wb.Views[0] = {};
					if(val.RTL) wb.Views[0].RTL = true;
					break;
	
				case 0x01E5: /* 'BrtWsFmtInfo' */
					break;
	
				case 0x0040: /* 'BrtDVal' */
				case 0x041D: /* 'BrtDVal14' */
					break;
	
				case 0x0097: /* 'BrtPane' */
					break;
				case 0x0098: /* 'BrtSel' */
				case 0x00AF: /* 'BrtAFilterDateGroupItem' */
				case 0x0284: /* 'BrtActiveX' */
				case 0x0271: /* 'BrtBigName' */
				case 0x0232: /* 'BrtBkHim' */
				case 0x018C: /* 'BrtBrk' */
				case 0x0458: /* 'BrtCFIcon' */
				case 0x047A: /* 'BrtCFRuleExt' */
				case 0x01D7: /* 'BrtCFVO' */
				case 0x041A: /* 'BrtCFVO14' */
				case 0x0289: /* 'BrtCellIgnoreEC' */
				case 0x0451: /* 'BrtCellIgnoreEC14' */
				case 0x024D: /* 'BrtCellSmartTagProperty' */
				case 0x025F: /* 'BrtCellWatch' */
				case 0x0234: /* 'BrtColor' */
				case 0x041F: /* 'BrtColor14' */
				case 0x00A8: /* 'BrtColorFilter' */
				case 0x00AE: /* 'BrtCustomFilter' */
				case 0x049C: /* 'BrtCustomFilter14' */
				case 0x01F3: /* 'BrtDRef' */
				case 0x01FB: /* 'BrtDXF' */
				case 0x0226: /* 'BrtDrawing' */
				case 0x00AB: /* 'BrtDynamicFilter' */
				case 0x00A7: /* 'BrtFilter' */
				case 0x0499: /* 'BrtFilter14' */
				case 0x00A9: /* 'BrtIconFilter' */
				case 0x049D: /* 'BrtIconFilter14' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x0295: /* 'BrtListPart' */
				case 0x027F: /* 'BrtOleObject' */
				case 0x01DE: /* 'BrtPageSetup' */
				case 0x0219: /* 'BrtPhoneticInfo' */
				case 0x01DD: /* 'BrtPrintOptions' */
				case 0x0218: /* 'BrtRangeProtection' */
				case 0x044F: /* 'BrtRangeProtection14' */
				case 0x02A8: /* 'BrtRangeProtectionIso' */
				case 0x0450: /* 'BrtRangeProtectionIso14' */
				case 0x0400: /* 'BrtRwDescent' */
				case 0x0297: /* 'BrtSheetCalcProp' */
				case 0x0217: /* 'BrtSheetProtection' */
				case 0x02A6: /* 'BrtSheetProtectionIso' */
				case 0x01F8: /* 'BrtSlc' */
				case 0x0413: /* 'BrtSparkline' */
				case 0x01AC: /* 'BrtTable' */
				case 0x00AA: /* 'BrtTop10Filter' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0032: /* 'BrtValueMeta' */
				case 0x0816: /* 'BrtWebExtension' */
				case 0x0415: /* 'BrtWsFmtInfoEx14' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				default:
					if(RR.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		delete opts.supbooks;
		delete opts['!row'];
	
		if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
		if(opts.sheetRows && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(merges.length > 0) s["!merges"] = merges;
		if(colinfo.length > 0) s["!cols"] = colinfo;
		if(rowinfo.length > 0) s["!rows"] = rowinfo;
		return s;
	}
	
	/* TODO: something useful -- this is a stub */
	function write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen) {
		if(cell.v === undefined) return false;
		var vv = "";
		switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'd': // no BrtCellDate :(
				cell = dup(cell);
				cell.z = cell.z || table_fmt[14];
				cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
				break;
			/* falls through */
			case 'n': case 'e': vv = ''+cell.v; break;
			default: vv = cell.v; break;
		}
		var o = ({r:R, c:C});
		/* TODO: cell style */
		o.s = get_cell_style(opts.cellXfs, cell, opts);
		if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
		if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
		switch(cell.t) {
			case 's': case 'str':
				if(opts.bookSST) {
					vv = get_sst_id(opts.Strings, (cell.v), opts.revStrings);
					o.t = "s"; o.v = vv;
					if(last_seen) write_record(ba, 0x0012 /* BrtShortIsst */, write_BrtShortIsst(cell, o));
					else write_record(ba, 0x0007 /* BrtCellIsst */, write_BrtCellIsst(cell, o));
				} else {
					o.t = "str";
					if(last_seen) write_record(ba, 0x0011 /* BrtShortSt */, write_BrtShortSt(cell, o));
					else write_record(ba, 0x0006 /* BrtCellSt */, write_BrtCellSt(cell, o));
				}
				return true;
			case 'n':
				/* TODO: determine threshold for Real vs RK */
				if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
					if(last_seen) write_record(ba, 0x000D /* BrtShortRk */, write_BrtShortRk(cell, o));
					else write_record(ba, 0x0002 /* BrtCellRk */, write_BrtCellRk(cell, o));
				} else {
					if(last_seen) write_record(ba, 0x0010 /* BrtShortReal */, write_BrtShortReal(cell, o));
					else write_record(ba, 0x0005 /* BrtCellReal */, write_BrtCellReal(cell, o));
				} return true;
			case 'b':
				o.t = "b";
				if(last_seen) write_record(ba, 0x000F /* BrtShortBool */, write_BrtShortBool(cell, o));
				else write_record(ba, 0x0004 /* BrtCellBool */, write_BrtCellBool(cell, o));
				return true;
			case 'e':
				o.t = "e";
				if(last_seen) write_record(ba, 0x000E /* BrtShortError */, write_BrtShortError(cell, o));
				else write_record(ba, 0x0003 /* BrtCellError */, write_BrtCellError(cell, o));
				return true;
		}
		if(last_seen) write_record(ba, 0x000C /* BrtShortBlank */, write_BrtShortBlank(cell, o));
		else write_record(ba, 0x0001 /* BrtCellBlank */, write_BrtCellBlank(cell, o));
		return true;
	}
	
	function write_CELLTABLE(ba, ws, idx, opts) {
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		write_record(ba, 0x0091 /* BrtBeginSheetData */);
		var dense = Array.isArray(ws);
		var cap = range.e.r;
		if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
		for(var R = range.s.r; R <= cap; ++R) {
			rr = encode_row(R);
			/* [ACCELLTABLE] */
			/* BrtRowHdr */
			write_row_header(ba, ws, range, R);
			var last_seen = false;
			if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
				/* *16384CELL */
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) { last_seen = false; continue; }
				/* write cell */
				last_seen = write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
			}
		}
		write_record(ba, 0x0092 /* BrtEndSheetData */);
	}
	
	function write_MERGECELLS(ba, ws) {
		if(!ws || !ws['!merges']) return;
		write_record(ba, 0x00B1 /* BrtBeginMergeCells */, write_BrtBeginMergeCells(ws['!merges'].length));
		ws['!merges'].forEach(function(m) { write_record(ba, 0x00B0 /* BrtMergeCell */, write_BrtMergeCell(m)); });
		write_record(ba, 0x00B2 /* BrtEndMergeCells */);
	}
	
	function write_COLINFOS(ba, ws) {
		if(!ws || !ws['!cols']) return;
		write_record(ba, 0x0186 /* BrtBeginColInfos */);
		ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 0x003C /* 'BrtColInfo' */, write_BrtColInfo(i, m)); });
		write_record(ba, 0x0187 /* BrtEndColInfos */);
	}
	
	function write_IGNOREECS(ba, ws) {
		if(!ws || !ws['!ref']) return;
		write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */);
		write_record(ba, 0x0289 /* BrtCellIgnoreEC */, write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
		write_record(ba, 0x028A /* BrtEndCellIgnoreECs */);
	}
	
	function write_HLINKS(ba, ws, rels) {
		/* *BrtHLink */
		ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
			write_record(ba, 0x01EE /* BrtHLink */, write_BrtHLink(l, rId));
		});
		delete ws['!links'];
	}
	function write_LEGACYDRAWING(ba, ws, idx, rels) {
		/* [BrtLegacyDrawing] */
		if(ws['!comments'].length > 0) {
			var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			write_record(ba, 0x0227 /* BrtLegacyDrawing */, write_RelID("rId" + rId));
			ws['!legacy'] = rId;
		}
	}
	
	function write_AUTOFILTER(ba, ws, wb, idx) {
		if(!ws['!autofilter']) return;
		var data = ws['!autofilter'];
		var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);
	
		/* Update FilterDatabase defined name for the worksheet */
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
	
		write_record(ba, 0x00A1 /* BrtBeginAFilter */, write_UncheckedRfX(safe_decode_range(ref)));
		/* *FILTERCOLUMN */
		/* [SORTSTATE] */
		/* BrtEndAFilter */
		write_record(ba, 0x00A2 /* BrtEndAFilter */);
	}
	
	function write_WSVIEWS2(ba, ws, Workbook) {
		write_record(ba, 0x0085 /* BrtBeginWsViews */);
		{ /* 1*WSVIEW2 */
			/* [ACUID] */
			write_record(ba, 0x0089 /* BrtBeginWsView */, write_BrtBeginWsView(ws, Workbook));
			/* [BrtPane] */
			/* *4BrtSel */
			/* *4SXSELECT */
			/* *FRT */
			write_record(ba, 0x008A /* BrtEndWsView */);
		}
		/* *FRT */
		write_record(ba, 0x0086 /* BrtEndWsViews */);
	}
	
	function write_WSFMTINFO() {
		/* [ACWSFMTINFO] */
		// write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
	}
	
	function write_SHEETPROTECT(ba, ws) {
		if(!ws['!protect']) return;
		/* [BrtSheetProtectionIso] */
		write_record(ba, 0x0217 /* BrtSheetProtection */, write_BrtSheetProtection(ws['!protect']));
	}
	
	function write_ws_bin(idx, opts, wb, rels) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
		var r = safe_decode_range(ws['!ref'] || "A1");
		if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
			r.e.c = Math.min(r.e.c, 0x3FFF);
			r.e.r = Math.min(r.e.c, 0xFFFFF);
		}
		ws['!links'] = [];
		/* passed back to write_zip and removed there */
		ws['!comments'] = [];
		write_record(ba, 0x0081 /* BrtBeginSheet */);
		if(wb.vbaraw || ws['!outline']) write_record(ba, 0x0093 /* BrtWsProp */, write_BrtWsProp(c, ws['!outline']));
		write_record(ba, 0x0094 /* BrtWsDim */, write_BrtWsDim(r));
		write_WSVIEWS2(ba, ws, wb.Workbook);
		write_WSFMTINFO(ba, ws);
		write_COLINFOS(ba, ws, idx, opts, wb);
		write_CELLTABLE(ba, ws, idx, opts, wb);
		/* [BrtSheetCalcProp] */
		write_SHEETPROTECT(ba, ws);
		/* *([BrtRangeProtectionIso] BrtRangeProtection) */
		/* [SCENMAN] */
		write_AUTOFILTER(ba, ws, wb, idx);
		/* [SORTSTATE] */
		/* [DCON] */
		/* [USERSHVIEWS] */
		write_MERGECELLS(ba, ws);
		/* [BrtPhoneticInfo] */
		/* *CONDITIONALFORMATTING */
		/* [DVALS] */
		write_HLINKS(ba, ws, rels);
		/* [BrtPrintOptions] */
		if(ws['!margins']) write_record(ba, 0x01DC /* BrtMargins */, write_BrtMargins(ws['!margins']));
		/* [BrtPageSetup] */
		/* [HEADERFOOTER] */
		/* [RWBRK] */
		/* [COLBRK] */
		/* *BrtBigName */
		/* [CELLWATCHES] */
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
		/* [SMARTTAGS] */
		/* [BrtDrawing] */
		write_LEGACYDRAWING(ba, ws, idx, rels);
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [OLEOBJECTS] */
		/* [ACTIVEXCONTROLS] */
		/* [WEBPUBITEMS] */
		/* [LISTPARTS] */
		/* FRTWORKSHEET */
		write_record(ba, 0x0082 /* BrtEndSheet */);
		return ba.end();
	}
	function parse_Cache(data) {
		var col = [];
		var num = data.match(/^<c:numCache>/);
		var f;
	
		/* 21.2.2.150 pt CT_NumVal */
		(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
			var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
			if(!q) return;
			col[+q[1]] = num ? +q[2] : q[2];
		});
	
		/* 21.2.2.71 formatCode CT_Xstring */
		var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);
	
		(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F) { f = F.replace(/<.*?>/g,""); });
	
		return [col, nf, f];
	}
	
	/* 21.2 DrawingML - Charts */
	function parse_chart(data, name, opts, rels, wb, csheet) {
		var cs = ((csheet || {"!type":"chart"}));
		if(!data) return csheet;
		/* 21.2.2.27 chart CT_Chart */
	
		var C = 0, R = 0, col = "A";
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		/* 21.2.2.120 numCache CT_NumData */
		(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
			var cache = parse_Cache(nc);
			refguess.s.r = refguess.s.c = 0;
			refguess.e.c = C;
			col = encode_col(C);
			cache[0].forEach(function(n,i) {
				cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
				R = i;
			});
			if(refguess.e.r < R) refguess.e.r = R;
			++C;
		});
		if(C > 0) cs["!ref"] = encode_range(refguess);
		return cs;
	}
	/* 18.3 Worksheets also covers Chartsheets */
	function parse_cs_xml(data, opts, idx, rels, wb) {
		if(!data) return data;
		/* 18.3.1.12 chartsheet CT_ChartSheet */
		if(!rels) rels = {'!id':{}};
		var s = ({'!type':"chart", '!drawel':null, '!rel':""});
		var m;
	
		/* 18.3.1.83 sheetPr CT_ChartsheetPr */
		var sheetPr = data.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	
		/* 18.3.1.36 drawing CT_Drawing */
		if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, writextag('chartsheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		})];
		o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
		add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.331 BrtCsProp */
	function parse_BrtCsProp(data, length) {
		data.l += 10;
		var name = parse_XLWideString(data, length - 10);
		return { name: name };
	}
	
	/* [MS-XLSB] 2.1.7.7 Chart Sheet */
	function parse_cs_bin(data, opts, idx, rels, wb) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		var s = {'!type':"chart", '!drawel':null, '!rel':""};
		var state = [];
		var pass = false;
		recordhopper(data, function cs_parse(val, R, RT) {
			switch(RT) {
	
				case 0x0226: /* 'BrtDrawing' */
					s['!rel'] = val; break;
	
				case 0x028B: /* 'BrtCsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					break;
	
				case 0x0232: /* 'BrtBkHim' */
				case 0x028C: /* 'BrtCsPageSetup' */
				case 0x029D: /* 'BrtCsProtection' */
				case 0x02A7: /* 'BrtCsProtectionIso' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x01DC: /* 'BrtMargins' */
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); break;
	
				default:
					if(R.T > 0) state.push(RT);
					else if(R.T < 0) state.pop();
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_bin() {
		var ba = buf_array();
		write_record(ba, 0x0081 /* BrtBeginSheet */);
		/* [BrtCsProp] */
		/* CSVIEWS */
		/* [[BrtCsProtectionIso] BrtCsProtection] */
		/* [USERCSVIEWS] */
		/* [BrtMargins] */
		/* [BrtCsPageSetup] */
		/* [HEADERFOOTER] */
		/* BrtDrawing */
		/* [BrtLegacyDrawing] */
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [WEBPUBITEMS] */
		/* FRTCHARTSHEET */
		write_record(ba, 0x0082 /* BrtEndSheet */);
		return ba.end();
	}
	/* 18.2.28 (CT_WorkbookProtection) Defaults */
	var WBPropsDef = [
		['allowRefreshQuery',           false, "bool"],
		['autoCompressPictures',        true,  "bool"],
		['backupFile',                  false, "bool"],
		['checkCompatibility',          false, "bool"],
		['CodeName',                    ''],
		['date1904',                    false, "bool"],
		['defaultThemeVersion',         0,      "int"],
		['filterPrivacy',               false, "bool"],
		['hidePivotFieldList',          false, "bool"],
		['promptedSolutions',           false, "bool"],
		['publishItems',                false, "bool"],
		['refreshAllConnections',       false, "bool"],
		['saveExternalLinkValues',      true,  "bool"],
		['showBorderUnselectedTables',  true,  "bool"],
		['showInkAnnotation',           true,  "bool"],
		['showObjects',                 'all'],
		['showPivotChartFilter',        false, "bool"],
		['updateLinks', 'userSet']
	];
	
	/* 18.2.30 (CT_BookView) Defaults */
	var WBViewDef = [
		['activeTab',                   0,      "int"],
		['autoFilterDateGrouping',      true,  "bool"],
		['firstSheet',                  0,      "int"],
		['minimized',                   false, "bool"],
		['showHorizontalScroll',        true,  "bool"],
		['showSheetTabs',               true,  "bool"],
		['showVerticalScroll',          true,  "bool"],
		['tabRatio',                    600,    "int"],
		['visibility',                  'visible']
		//window{Height,Width}, {x,y}Window
	];
	
	/* 18.2.19 (CT_Sheet) Defaults */
	var SheetDef = [
		//['state', 'visible']
	];
	
	/* 18.2.2  (CT_CalcPr) Defaults */
	var CalcPrDef = [
		['calcCompleted', 'true'],
		['calcMode', 'auto'],
		['calcOnSave', 'true'],
		['concurrentCalc', 'true'],
		['fullCalcOnLoad', 'false'],
		['fullPrecision', 'true'],
		['iterate', 'false'],
		['iterateCount', '100'],
		['iterateDelta', '0.001'],
		['refMode', 'A1']
	];
	
	/* 18.2.3 (CT_CustomWorkbookView) Defaults */
	/*var CustomWBViewDef = [
		['autoUpdate', 'false'],
		['changesSavedWin', 'false'],
		['includeHiddenRowCol', 'true'],
		['includePrintSettings', 'true'],
		['maximized', 'false'],
		['minimized', 'false'],
		['onlySync', 'false'],
		['personalView', 'false'],
		['showComments', 'commIndicator'],
		['showFormulaBar', 'true'],
		['showHorizontalScroll', 'true'],
		['showObjects', 'all'],
		['showSheetTabs', 'true'],
		['showStatusbar', 'true'],
		['showVerticalScroll', 'true'],
		['tabRatio', '600'],
		['xWindow', '0'],
		['yWindow', '0']
	];*/
	
	function push_defaults_array(target, defaults) {
		for(var j = 0; j != target.length; ++j) { var w = target[j];
			for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
				if(w[z[0]] == null) w[z[0]] = z[1];
				else switch(z[2]) {
				case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
				case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
				}
			}
		}
	}
	function push_defaults(target, defaults) {
		for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
			if(target[z[0]] == null) target[z[0]] = z[1];
			else switch(z[2]) {
				case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
				case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
			}
		}
	}
	
	function parse_wb_defaults(wb) {
		push_defaults(wb.WBProps, WBPropsDef);
		push_defaults(wb.CalcPr, CalcPrDef);
	
		push_defaults_array(wb.WBView, WBViewDef);
		push_defaults_array(wb.Sheets, SheetDef);
	
		_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
	}
	
	function safe1904(wb) {
		/* TODO: store date1904 somewhere else */
		if(!wb.Workbook) return "false";
		if(!wb.Workbook.WBProps) return "false";
		return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
	}
	
	var badchars = "][*?\/\\".split("");
	function check_ws_name(n, safe) {
		if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
		var _good = true;
		badchars.forEach(function(c) {
			if(n.indexOf(c) == -1) return;
			if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
			_good = false;
		});
		return _good;
	}
	function check_wb_names(N, S, codes) {
		N.forEach(function(n,i) {
			check_ws_name(n);
			for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
			if(codes) {
				var cn = (S && S[i] && S[i].CodeName) || n;
				if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
			}
		});
	}
	function check_wb(wb) {
		if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
		if(!wb.SheetNames.length) throw new Error("Workbook is empty");
		var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
		check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
		for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
		/* TODO: validate workbook */
	}
	/* 18.2 Workbook */
	var wbnsregex = /<\w+:workbook/;
	function parse_wb_xml(data, opts) {
		if(!data) throw new Error("Could not find file");
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
		var pass = false, xmlns = "xmlns";
		var dname = {}, dnstart = 0;
		data.replace(tagregex, function xml_wb(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 18.2.27 workbook CT_Workbook 1 */
				case '<workbook':
					if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
					wb.xmlns = y[xmlns];
					break;
				case '</workbook>': break;
	
				/* 18.2.13 fileVersion CT_FileVersion ? */
				case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
				case '<fileVersion/>': case '</fileVersion>': break;
	
				/* 18.2.12 fileSharing CT_FileSharing ? */
				case '<fileSharing':
					break;
				case '<fileSharing/>': break;
	
				/* 18.2.28 workbookPr CT_WorkbookPr ? */
				case '<workbookPr':
				case '<workbookPr/>':
					WBPropsDef.forEach(function(w) {
						if(y[w[0]] == null) return;
						switch(w[2]) {
							case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
							case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
							default: wb.WBProps[w[0]] = y[w[0]];
						}
					});
					if(y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
					break;
				case '</workbookPr>': break;
	
				/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
				case '<workbookProtection':
					break;
				case '<workbookProtection/>': break;
	
				/* 18.2.1  bookViews CT_BookViews ? */
				case '<bookViews': case '<bookViews>': case '</bookViews>': break;
				/* 18.2.30   workbookView CT_BookView + */
				case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
				case '</workbookView>': break;
	
				/* 18.2.20 sheets CT_Sheets 1 */
				case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
				/* 18.2.19   sheet CT_Sheet + */
				case '<sheet':
					switch(y.state) {
						case "hidden": y.Hidden = 1; break;
						case "veryHidden": y.Hidden = 2; break;
						default: y.Hidden = 0;
					}
					delete y.state;
					y.name = unescapexml(utf8read(y.name));
					delete y[0]; wb.Sheets.push(y); break;
				case '</sheet>': break;
	
				/* 18.2.15 functionGroups CT_FunctionGroups ? */
				case '<functionGroups': case '<functionGroups/>': break;
				/* 18.2.14   functionGroup CT_FunctionGroup + */
				case '<functionGroup': break;
	
				/* 18.2.9  externalReferences CT_ExternalReferences ? */
				case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
				/* 18.2.8    externalReference CT_ExternalReference + */
				case '<externalReference': break;
	
				/* 18.2.6  definedNames CT_DefinedNames ? */
				case '<definedNames/>': break;
				case '<definedNames>': case '<definedNames': pass=true; break;
				case '</definedNames>': pass=false; break;
				/* 18.2.5    definedName CT_DefinedName + */
				case '<definedName': {
					dname = {};
					dname.Name = utf8read(y.name);
					if(y.comment) dname.Comment = y.comment;
					if(y.localSheetId) dname.Sheet = +y.localSheetId;
					if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
					dnstart = idx + x.length;
				}	break;
				case '</definedName>': {
					dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
					wb.Names.push(dname);
				} break;
				case '<definedName/>': break;
	
				/* 18.2.2  calcPr CT_CalcPr ? */
				case '<calcPr': delete y[0]; wb.CalcPr = y; break;
				case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
				case '</calcPr>': break;
	
				/* 18.2.16 oleSize CT_OleSize ? (ref required) */
				case '<oleSize': break;
	
				/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
				case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
				/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
				case '<customWorkbookView': case '</customWorkbookView>': break;
	
				/* 18.2.18 pivotCaches CT_PivotCaches ? */
				case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
				/* 18.2.17 pivotCache CT_PivotCache ? */
				case '<pivotCache': break;
	
				/* 18.2.21 smartTagPr CT_SmartTagPr ? */
				case '<smartTagPr': case '<smartTagPr/>': break;
	
				/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
				case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
				/* 18.2.22 smartTagType CT_SmartTagType ? */
				case '<smartTagType': break;
	
				/* 18.2.24 webPublishing CT_WebPublishing ? */
				case '<webPublishing': case '<webPublishing/>': break;
	
				/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
				case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;
	
				/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
				case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
				/* 18.2.25 webPublishObject CT_WebPublishObject ? */
				case '<webPublishObject': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break; //TODO: check with versions of excel
				case '</ext>': pass=false; break;
	
				/* Others */
				case '<ArchID': break;
				case '<AlternateContent':
				case '<AlternateContent>': pass=true; break;
				case '</AlternateContent>': pass=false; break;
	
				/* TODO */
				case '<revisionPtr': break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
			}
			return x;
		});
		if(XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
	
		parse_wb_defaults(wb);
	
		return wb;
	}
	
	function write_wb_xml(wb) {
		var o = [XML_HEADER];
		o[o.length] = writextag('workbook', null, {
			'xmlns': XMLNS_main[0],
			//'xmlns:mx': XMLNS.mx,
			//'xmlns:s': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		});
	
		var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);
	
		/* fileVersion */
		/* fileSharing */
	
		var workbookPr = ({codeName:"ThisWorkbook"});
		if(wb.Workbook && wb.Workbook.WBProps) {
			WBPropsDef.forEach(function(x) {
	if((wb.Workbook.WBProps[x[0]]) == null) return;
				if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
				workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
			});
	if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
		}
		o[o.length] = (writextag('workbookPr', null, workbookPr));
	
		/* workbookProtection */
	
		var sheets = wb.Workbook && wb.Workbook.Sheets || [];
		var i = 0;
	
		/* bookViews only written if first worksheet is hidden */
		if(sheets && sheets[0] && !!sheets[0].Hidden) {
			o[o.length] = "<bookViews>";
			for(i = 0; i != wb.SheetNames.length; ++i) {
				if(!sheets[i]) break;
				if(!sheets[i].Hidden) break;
			}
			if(i == wb.SheetNames.length) i = 0;
			o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
			o[o.length] = "</bookViews>";
		}
	
		o[o.length] = "<sheets>";
		for(i = 0; i != wb.SheetNames.length; ++i) {
			var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
			sht.sheetId = ""+(i+1);
			sht["r:id"] = "rId"+(i+1);
			if(sheets[i]) switch(sheets[i].Hidden) {
				case 1: sht.state = "hidden"; break;
				case 2: sht.state = "veryHidden"; break;
			}
			o[o.length] = (writextag('sheet',null,sht));
		}
		o[o.length] = "</sheets>";
	
		/* functionGroups */
		/* externalReferences */
	
		if(write_names) {
			o[o.length] = "<definedNames>";
			if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
				var d = {name:n.Name};
				if(n.Comment) d.comment = n.Comment;
				if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
				if(n.Hidden) d.hidden = "1";
				if(!n.Ref) return;
				o[o.length] = writextag('definedName', escapexml(n.Ref), d);
			});
			o[o.length] = "</definedNames>";
		}
	
		/* calcPr */
		/* oleSize */
		/* customWorkbookViews */
		/* pivotCaches */
		/* smartTagPr */
		/* smartTagTypes */
		/* webPublishing */
		/* fileRecoveryPr */
		/* webPublishObjects */
		/* extLst */
	
		if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.304 BrtBundleSh */
	function parse_BrtBundleSh(data, length) {
		var z = {};
		z.Hidden = data.read_shift(4); //hsState ST_SheetState
		z.iTabID = data.read_shift(4);
		z.strRelID = parse_RelID(data,length-8);
		z.name = parse_XLWideString(data);
		return z;
	}
	function write_BrtBundleSh(data, o) {
		if(!o) o = new_buf(127);
		o.write_shift(4, data.Hidden);
		o.write_shift(4, data.iTabID);
		write_RelID(data.strRelID, o);
		write_XLWideString(data.name.slice(0,31), o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.815 BrtWbProp */
	function parse_BrtWbProp(data, length) {
		var o = ({});
		var flags = data.read_shift(4);
		o.defaultThemeVersion = data.read_shift(4);
		var strName = (length > 8) ? parse_XLWideString(data) : "";
		if(strName.length > 0) o.CodeName = strName;
		o.autoCompressPictures = !!(flags & 0x10000);
		o.backupFile = !!(flags & 0x40);
		o.checkCompatibility = !!(flags & 0x1000);
		o.date1904 = !!(flags & 0x01);
		o.filterPrivacy = !!(flags & 0x08);
		o.hidePivotFieldList = !!(flags & 0x400);
		o.promptedSolutions = !!(flags & 0x10);
		o.publishItems = !!(flags & 0x800);
		o.refreshAllConnections = !!(flags & 0x40000);
		o.saveExternalLinkValues = !!(flags & 0x80);
		o.showBorderUnselectedTables = !!(flags & 0x04);
		o.showInkAnnotation = !!(flags & 0x20);
		o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
		o.showPivotChartFilter = !!(flags & 0x8000);
		o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
		return o;
	}
	function write_BrtWbProp(data, o) {
		if(!o) o = new_buf(72);
		var flags = 0;
		if(data) {
			/* TODO: mirror parse_BrtWbProp fields */
			if(data.filterPrivacy) flags |= 0x08;
		}
		o.write_shift(4, flags);
		o.write_shift(4, 0);
		write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
		return o.slice(0, o.l);
	}
	
	function parse_BrtFRTArchID$(data, length) {
		var o = {};
		data.read_shift(4);
		o.ArchID = data.read_shift(4);
		data.l += length - 8;
		return o;
	}
	
	/* [MS-XLSB] 2.4.687 BrtName */
	function parse_BrtName(data, length, opts) {
		var end = data.l + length;
		data.l += 4; //var flags = data.read_shift(4);
		data.l += 1; //var chKey = data.read_shift(1);
		var itab = data.read_shift(4);
		var name = parse_XLNameWideString(data);
		var formula = parse_XLSBNameParsedFormula(data, 0, opts);
		var comment = parse_XLNullableWideString(data);
		//if(0 /* fProc */) {
			// unusedstring1: XLNullableWideString
			// description: XLNullableWideString
			// helpTopic: XLNullableWideString
			// unusedstring2: XLNullableWideString
		//}
		data.l = end;
		var out = ({Name:name, Ptg:formula});
		if(itab < 0xFFFFFFF) out.Sheet = itab;
		if(comment) out.Comment = comment;
		return out;
	}
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function parse_wb_bin(data, opts) {
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
		var state = [];
		var pass = false;
	
		if(!opts) opts = {};
		opts.biff = 12;
	
		var Names = [];
		var supbooks = ([[]]);
		supbooks.SheetNames = [];
		supbooks.XTI = [];
	
		XLSBRecordEnum[0x0010] = { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ };
	
		recordhopper(data, function hopper_wb(val, R, RT) {
			switch(RT) {
				case 0x009C: /* 'BrtBundleSh' */
					supbooks.SheetNames.push(val.name);
					wb.Sheets.push(val); break;
	
				case 0x0099: /* 'BrtWbProp' */
					wb.WBProps = val; break;
	
				case 0x0027: /* 'BrtName' */
					if(val.Sheet != null) opts.SID = val.Sheet;
					val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
					delete opts.SID;
					delete val.Ptg;
					Names.push(val);
					break;
				case 0x040C: /* 'BrtNameExt' */ break;
	
				case 0x0165: /* 'BrtSupSelf' */
				case 0x0166: /* 'BrtSupSame' */
				case 0x0163: /* 'BrtSupBookSrc' */
				case 0x029B: /* 'BrtSupAddin' */
					if(!supbooks[0].length) supbooks[0] = [RT, val];
					else supbooks.push([RT, val]);
					supbooks[supbooks.length - 1].XTI = [];
					break;
				case 0x016A: /* 'BrtExternSheet' */
					if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
					supbooks.XTI = supbooks.XTI.concat(val);
					break;
				case 0x0169: /* 'BrtPlaceholderName' */
					break;
	
				case 0x0817: /* 'BrtAbsPath15' */
				case 0x009E: /* 'BrtBookView' */
				case 0x008F: /* 'BrtBeginBundleShs' */
				case 0x0298: /* 'BrtBeginFnGroup' */
				case 0x0161: /* 'BrtBeginExternals' */
					break;
	
				/* case 'BrtModelTimeGroupingCalcCol' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0C01: /* 'BrtRevisionPtr' */
				case 0x0216: /* 'BrtBookProtection' */
				case 0x02A5: /* 'BrtBookProtectionIso' */
				case 0x009D: /* 'BrtCalcProp' */
				case 0x0262: /* 'BrtCrashRecErr' */
				case 0x0802: /* 'BrtDecoupledPivotCacheID' */
				case 0x009B: /* 'BrtFileRecover' */
				case 0x0224: /* 'BrtFileSharing' */
				case 0x02A4: /* 'BrtFileSharingIso' */
				case 0x0080: /* 'BrtFileVersion' */
				case 0x0299: /* 'BrtFnGroup' */
				case 0x0850: /* 'BrtModelRelationship' */
				case 0x084D: /* 'BrtModelTable' */
				case 0x0225: /* 'BrtOleSize' */
				case 0x0805: /* 'BrtPivotTableRef' */
				case 0x0254: /* 'BrtSmartTagType' */
				case 0x081C: /* 'BrtTableSlicerCacheID' */
				case 0x081B: /* 'BrtTableSlicerCacheIDs' */
				case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
				case 0x018D: /* 'BrtUserBookView' */
				case 0x009A: /* 'BrtWbFactoid' */
				case 0x045D: /* 'BrtWbProp14' */
				case 0x0229: /* 'BrtWebOpt' */
				case 0x082B: /* 'BrtWorkBookPr15' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					state.push(RT); pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					state.pop(); pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				case 0x0010: /* 'BrtFRTArchID$' */ break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */ && state[state.length-1] != 0x0023 /* BrtFRTBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		parse_wb_defaults(wb);
	
		// $FlowIgnore
		wb.Names = Names;
	
		(wb).supbooks = supbooks;
		return wb;
	}
	
	function write_BUNDLESHS(ba, wb) {
		write_record(ba, 0x008F /* BrtBeginBundleShs */);
		for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
			var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
			var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
			write_record(ba, 0x009C /* BrtBundleSh */, write_BrtBundleSh(d));
		}
		write_record(ba, 0x0090 /* BrtEndBundleShs */);
	}
	
	/* [MS-XLSB] 2.4.649 BrtFileVersion */
	function write_BrtFileVersion(data, o) {
		if(!o) o = new_buf(127);
		for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
		write_XLWideString("SheetJS", o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString("7262", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.301 BrtBookView */
	function write_BrtBookView(idx, o) {
		if(!o) o = new_buf(29);
		o.write_shift(-4, 0);
		o.write_shift(-4, 460);
		o.write_shift(4,  28800);
		o.write_shift(4,  17600);
		o.write_shift(4,  500);
		o.write_shift(4,  idx);
		o.write_shift(4,  idx);
		var flags = 0x78;
		o.write_shift(1,  flags);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	function write_BOOKVIEWS(ba, wb) {
		/* required if hidden tab appears before visible tab */
		if(!wb.Workbook || !wb.Workbook.Sheets) return;
		var sheets = wb.Workbook.Sheets;
		var i = 0, vistab = -1, hidden = -1;
		for(; i < sheets.length; ++i) {
			if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
			else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
		}
		if(hidden > vistab) return;
		write_record(ba, 0x0087 /* BrtBeginBookViews */);
		write_record(ba, 0x009E /* BrtBookView */, write_BrtBookView(vistab));
		/* 1*(BrtBookView *FRT) */
		write_record(ba, 0x0088 /* BrtEndBookViews */);
	}
	
	/* [MS-XLSB] 2.4.305 BrtCalcProp */
	/*function write_BrtCalcProp(data, o) {
		if(!o) o = new_buf(26);
		o.write_shift(4,0); // force recalc
		o.write_shift(4,1);
		o.write_shift(4,0);
		write_Xnum(0, o);
		o.write_shift(-4, 1023);
		o.write_shift(1, 0x33);
		o.write_shift(1, 0x00);
		return o;
	}*/
	
	/* [MS-XLSB] 2.4.646 BrtFileRecover */
	/*function write_BrtFileRecover(data, o) {
		if(!o) o = new_buf(1);
		o.write_shift(1,0);
		return o;
	}*/
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function write_wb_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, 0x0083 /* BrtBeginBook */);
		write_record(ba, 0x0080 /* BrtFileVersion */, write_BrtFileVersion());
		/* [[BrtFileSharingIso] BrtFileSharing] */
		write_record(ba, 0x0099 /* BrtWbProp */, write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
		/* [ACABSPATH] */
		/* [[BrtBookProtectionIso] BrtBookProtection] */
		write_BOOKVIEWS(ba, wb, opts);
		write_BUNDLESHS(ba, wb, opts);
		/* [FNGROUP] */
		/* [EXTERNALS] */
		/* *BrtName */
		/* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */
		/* [BrtOleSize] */
		/* *(BrtUserBookView *FRT) */
		/* [PIVOTCACHEIDS] */
		/* [BrtWbFactoid] */
		/* [SMARTTAGTYPES] */
		/* [BrtWebOpt] */
		/* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */
		/* [WEBPUBITEMS] */
		/* [CRERRS] */
		/* FRTWORKBOOK */
		write_record(ba, 0x0084 /* BrtEndBook */);
	
		return ba.end();
	}
	function parse_wb(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
		return parse_wb_xml((data), opts);
	}
	
	function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_sty(data, name, themes, opts) {
		if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
		return parse_sty_xml((data), themes, opts);
	}
	
	function parse_theme(data, name, opts) {
		return parse_theme_xml(data, opts);
	}
	
	function parse_sst(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
		return parse_sst_xml((data), opts);
	}
	
	function parse_cmnt(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
		return parse_comments_xml((data), opts);
	}
	
	function parse_cc(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
		return parse_cc_xml((data), name, opts);
	}
	
	function parse_xlink(data, rel, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlink_bin((data), rel, name, opts);
		return parse_xlink_xml((data), rel, name, opts);
	}
	
	function parse_xlmeta(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlmeta_bin((data), name, opts);
		return parse_xlmeta_xml((data), name, opts);
	}
	
	function write_wb(wb, name, opts) {
		return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
	}
	
	function write_ws(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
	}
	
	// eslint-disable-next-line no-unused-vars
	function write_cs(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
	}
	
	function write_sty(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
	}
	
	function write_sst(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
	}
	
	function write_cmnt(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
	}
	/*
	function write_cc(data, name:string, opts) {
		return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
	}
	*/
	
	function write_xlmeta(name) {
		return (name.slice(-4)===".bin" ? write_xlmeta_bin : write_xlmeta_xml)();
	}
	var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
	var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
	function xlml_parsexmltag(tag, skip_root) {
		var words = tag.split(/\s+/);
		var z = ([]); if(!skip_root) z[0] = words[0];
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	function xlml_parsexmltagobj(tag) {
		var words = tag.split(/\s+/);
		var z = {};
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	
	// ----
	
	/* map from xlml named formats to SSF TODO: localize */
	var XLMLFormatMap;
	
	function xlml_format(format, value) {
		var fmt = XLMLFormatMap[format] || unescapexml(format);
		if(fmt === "General") return SSF_general(value);
		return SSF_format(fmt, value);
	}
	
	function xlml_set_custprop(Custprops, key, cp, val) {
		var oval = val;
		switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
			case "boolean": oval = parsexmlbool(val); break;
			case "i2": case "int": oval = parseInt(val, 10); break;
			case "r4": case "float": oval = parseFloat(val); break;
			case "date": case "dateTime.tz": oval = parseDate(val); break;
			case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
			default: throw new Error("bad custprop:" + cp[0]);
		}
		Custprops[unescapexml(key)] = oval;
	}
	
	function safe_format_xlml(cell, nf, o) {
		if(cell.t === 'z') return;
		if(!o || o.cellText !== false) try {
			if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
			else if(nf === "General") {
				if(cell.t === 'n') {
					if((cell.v|0) === cell.v) cell.w = cell.v.toString(10);
					else cell.w = SSF_general_num(cell.v);
				}
				else cell.w = SSF_general(cell.v);
			}
			else cell.w = xlml_format(nf||"General", cell.v);
		} catch(e) { if(o.WTF) throw e; }
		try {
			var z = XLMLFormatMap[nf]||nf||"General";
			if(o.cellNF) cell.z = z;
			if(o.cellDates && cell.t == 'n' && fmt_is_date(z)) {
				var _d = SSF_parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
			}
		} catch(e) { if(o.WTF) throw e; }
	}
	
	function process_style_xlml(styles, stag, opts) {
		if(opts.cellStyles) {
			if(stag.Interior) {
				var I = stag.Interior;
				if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
			}
		}
		styles[stag.ID] = stag;
	}
	
	/* TODO: there must exist some form of OSP-blessed spec */
	function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
		var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
		var interiors = [];
		var i = 0;
		if(sid === undefined && row) sid = row.StyleID;
		if(sid === undefined && csty) sid = csty.StyleID;
		while(styles[sid] !== undefined) {
			if(styles[sid].nf) nf = styles[sid].nf;
			if(styles[sid].Interior) interiors.push(styles[sid].Interior);
			if(!styles[sid].Parent) break;
			sid = styles[sid].Parent;
		}
		switch(data.Type) {
			case 'Boolean':
				cell.t = 'b';
				cell.v = parsexmlbool(xml);
				break;
			case 'String':
				cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
				cell.v = (xml.indexOf("<") > -1 ? unescapexml(ss||xml).replace(/<.*?>/g, "") : cell.r); // todo: BR etc
				break;
			case 'DateTime':
				if(xml.slice(-1) != "Z") xml += "Z";
				cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
				if(cell.v !== cell.v) cell.v = unescapexml(xml);
				else if(cell.v<60) cell.v = cell.v -1;
				if(!nf || nf == "General") nf = "yyyy-mm-dd";
				/* falls through */
			case 'Number':
				if(cell.v === undefined) cell.v=+xml;
				if(!cell.t) cell.t = 'n';
				break;
			case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
			default:
				if(xml == "" && ss == "") { cell.t = 'z'; }
				else { cell.t = 's'; cell.v = xlml_fixstr(ss||xml); }
				break;
		}
		safe_format_xlml(cell, nf, o);
		if(o.cellFormula !== false) {
			if(cell.Formula) {
				var fstr = unescapexml(cell.Formula);
				/* strictly speaking, the leading = is required but some writers omit */
				if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
				cell.f = rc_to_a1(fstr, base);
				delete cell.Formula;
				if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
				else if(cell.ArrayRange) {
					cell.F = rc_to_a1(cell.ArrayRange, base);
					arrayf.push([safe_decode_range(cell.F), cell.F]);
				}
			} else {
				for(i = 0; i < arrayf.length; ++i)
					if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
						if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
							cell.F = arrayf[i][1];
			}
		}
		if(o.cellStyles) {
			interiors.forEach(function(x) {
				if(!S.patternType && x.patternType) S.patternType = x.patternType;
			});
			cell.s = S;
		}
		if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
	}
	
	function xlml_clean_comment(comment) {
		comment.t = comment.v || "";
		comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		comment.v = comment.w = comment.ixfe = undefined;
	}
	
	/* TODO: Everything */
	function parse_xlml_xml(d, _opts) {
		var opts = _opts || {};
		make_ssf();
		var str = debom(xlml_normalize(d));
		if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
			if(typeof $cptable !== 'undefined') str = $cptable.utils.decode(65001, char_codes(str));
			else str = utf8read(str);
		}
		var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
		opening = opening.replace(/".*?"/g, "");
		if((opening.indexOf(">") & 1023) > Math.min((opening.indexOf(",") & 1023), (opening.indexOf(";")&1023))) { var _o = dup(opts); _o.type = "string"; return PRN.to_workbook(str, _o); }
		if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
		if(ishtml) return html_to_workbook(str, opts);
	
		XLMLFormatMap = ({
			"General Number": "General",
			"General Date": table_fmt[22],
			"Long Date": "dddd, mmmm dd, yyyy",
			"Medium Date": table_fmt[15],
			"Short Date": table_fmt[14],
			"Long Time": table_fmt[19],
			"Medium Time": table_fmt[18],
			"Short Time": table_fmt[20],
			"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
			"Fixed": table_fmt[2],
			"Standard": table_fmt[4],
			"Percent": table_fmt[10],
			"Scientific": table_fmt[11],
			"Yes/No": '"Yes";"Yes";"No";@',
			"True/False": '"True";"True";"False";@',
			"On/Off": '"Yes";"Yes";"No";@'
		});
	
	
		var Rn;
		var state = [], tmp;
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
		var cell = ({}), row = {};// eslint-disable-line no-unused-vars
		var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
		var c = 0, r = 0;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
		var styles = {}, stag = {};
		var ss = "", fidx = 0;
		var merges = [];
		var Props = {}, Custprops = {}, pidx = 0, cp = [];
		var comments = [], comment = ({});
		var cstys = [], csty, seencol = false;
		var arrayf = [];
		var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
		var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"");
		var raw_Rn3 = "";
		while((Rn = xlmlregex.exec(str))) switch((Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase())) {
			case 'data' /*case 'Data'*/:
				if(raw_Rn3 == "data") {
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
				}
				if(state[state.length-1][1]) break;
				if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
				else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
				break;
			case 'cell' /*case 'Cell'*/:
				if(Rn[1]==='/'){
					if(comments.length > 0) cell.c = comments;
					if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
						if(opts.dense) {
							if(!cursheet[r]) cursheet[r] = [];
							cursheet[r][c] = cell;
						} else cursheet[encode_col(c) + encode_row(r)] = cell;
					}
					if(cell.HRef) {
						cell.l = ({Target:unescapexml(cell.HRef)});
						if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
						delete cell.HRef; delete cell.HRefScreenTip;
					}
					if(cell.MergeAcross || cell.MergeDown) {
						cc = c + (parseInt(cell.MergeAcross,10)|0);
						rr = r + (parseInt(cell.MergeDown,10)|0);
						merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
					}
					if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
					else if(cell.MergeAcross || cell.MergeDown) {
	for(var cma = c; cma <= cc; ++cma) {
							for(var cmd = r; cmd <= rr; ++cmd) {
								if(cma > c || cmd > r) {
									if(opts.dense) {
										if(!cursheet[cmd]) cursheet[cmd] = [];
										cursheet[cmd][cma] = {t:'z'};
									} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
								}
							}
						}
						c = cc + 1;
					}
					else ++c;
				} else {
					cell = xlml_parsexmltagobj(Rn[0]);
					if(cell.Index) c = +cell.Index - 1;
					if(c < refguess.s.c) refguess.s.c = c;
					if(c > refguess.e.c) refguess.e.c = c;
					if(Rn[0].slice(-2) === "/>") ++c;
					comments = [];
				}
				break;
			case 'row' /*case 'Row'*/:
				if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
					if(r < refguess.s.r) refguess.s.r = r;
					if(r > refguess.e.r) refguess.e.r = r;
					if(Rn[0].slice(-2) === "/>") {
						row = xlml_parsexmltag(Rn[0]);
						if(row.Index) r = +row.Index - 1;
					}
					c = 0; ++r;
				} else {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
					rowobj = {};
					if(row.AutoFitHeight == "0" || row.Height) {
						rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
						rowinfo[r] = rowobj;
					}
					if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
				}
				break;
			case 'worksheet' /*case 'Worksheet'*/: /* TODO: read range from FullRows/FullColumns */
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					sheetnames.push(sheetname);
					if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
						cursheet["!ref"] = encode_range(refguess);
						if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
							cursheet["!fullref"] = cursheet["!ref"];
							refguess.e.r = opts.sheetRows - 1;
							cursheet["!ref"] = encode_range(refguess);
						}
					}
					if(merges.length) cursheet["!merges"] = merges;
					if(cstys.length > 0) cursheet["!cols"] = cstys;
					if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
					sheets[sheetname] = cursheet;
				} else {
					refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
					r = c = 0;
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					sheetname = unescapexml(tmp.Name);
					cursheet = (opts.dense ? [] : {});
					merges = [];
					arrayf = [];
					rowinfo = [];
					wsprops = {name:sheetname, Hidden:0};
					Workbook.Sheets.push(wsprops);
				}
				break;
			case 'table' /*case 'Table'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].slice(-2) == "/>") break;
				else {
					state.push([Rn[3], false]);
					cstys = []; seencol = false;
				}
				break;
	
			case 'style' /*case 'Style'*/:
				if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
				else stag = xlml_parsexmltag(Rn[0]);
				break;
	
			case 'numberformat' /*case 'NumberFormat'*/:
				stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
				if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
				for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == stag.nf) break;
				if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == null) { SSF_load(stag.nf, ssfidx); break; }
				break;
	
			case 'column' /*case 'Column'*/:
				if(state[state.length-1][0] !== /*'Table'*/'table') break;
				csty = xlml_parsexmltag(Rn[0]);
				if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
				if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
				if(!seencol && csty.wpx > 10) {
					seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
					for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
				}
				if(seencol) process_col(csty);
				cstys[(csty.Index-1||cstys.length)] = csty;
				for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
				break;
	
			case 'namedrange' /*case 'NamedRange'*/:
				if(Rn[1]==='/') break;
				if(!Workbook.Names) Workbook.Names = [];
				var _NamedRange = parsexmltag(Rn[0]);
				var _DefinedName = ({
					Name: _NamedRange.Name,
					Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
				});
				if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
	Workbook.Names.push(_DefinedName);
				break;
	
			case 'namedcell' /*case 'NamedCell'*/: break;
			case 'b' /*case 'B'*/: break;
			case 'i' /*case 'I'*/: break;
			case 'u' /*case 'U'*/: break;
			case 's' /*case 'S'*/: break;
			case 'em' /*case 'EM'*/: break;
			case 'h2' /*case 'H2'*/: break;
			case 'h3' /*case 'H3'*/: break;
			case 'sub' /*case 'Sub'*/: break;
			case 'sup' /*case 'Sup'*/: break;
			case 'span' /*case 'Span'*/: break;
			case 'alignment' /*case 'Alignment'*/:
				break;
			case 'borders' /*case 'Borders'*/: break;
			case 'border' /*case 'Border'*/: break;
			case 'font' /*case 'Font'*/:
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
				else fidx = Rn.index + Rn[0].length;
				break;
			case 'interior' /*case 'Interior'*/:
				if(!opts.cellStyles) break;
				stag.Interior = xlml_parsexmltag(Rn[0]);
				break;
			case 'protection' /*case 'Protection'*/: break;
	
			case 'author' /*case 'Author'*/:
			case 'title' /*case 'Title'*/:
			case 'description' /*case 'Description'*/:
			case 'created' /*case 'Created'*/:
			case 'keywords' /*case 'Keywords'*/:
			case 'subject' /*case 'Subject'*/:
			case 'category' /*case 'Category'*/:
			case 'company' /*case 'Company'*/:
			case 'lastauthor' /*case 'LastAuthor'*/:
			case 'lastsaved' /*case 'LastSaved'*/:
			case 'lastprinted' /*case 'LastPrinted'*/:
			case 'version' /*case 'Version'*/:
			case 'revision' /*case 'Revision'*/:
			case 'totaltime' /*case 'TotalTime'*/:
			case 'hyperlinkbase' /*case 'HyperlinkBase'*/:
			case 'manager' /*case 'Manager'*/:
			case 'contentstatus' /*case 'ContentStatus'*/:
			case 'identifier' /*case 'Identifier'*/:
			case 'language' /*case 'Language'*/:
			case 'appname' /*case 'AppName'*/:
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
				else pidx = Rn.index + Rn[0].length;
				break;
			case 'paragraphs' /*case 'Paragraphs'*/: break;
	
			case 'styles' /*case 'Styles'*/:
			case 'workbook' /*case 'Workbook'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else state.push([Rn[3], false]);
				break;
	
			case 'comment' /*case 'Comment'*/:
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					xlml_clean_comment(comment);
					comments.push(comment);
				} else {
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					comment = ({a:tmp.Author});
				}
				break;
	
			case 'autofilter' /*case 'AutoFilter'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					var AutoFilter = xlml_parsexmltag(Rn[0]);
					cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
					state.push([Rn[3], true]);
				}
				break;
	
			case 'name' /*case 'Name'*/: break;
	
			case 'datavalidation' /*case 'DataValidation'*/:
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				} else {
					if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				}
				break;
	
			case 'pixelsperinch' /*case 'PixelsPerInch'*/:
				break;
			case 'componentoptions' /*case 'ComponentOptions'*/:
			case 'documentproperties' /*case 'DocumentProperties'*/:
			case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/:
			case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/:
			case 'pivottable' /*case 'PivotTable'*/:
			case 'pivotcache' /*case 'PivotCache'*/:
			case 'names' /*case 'Names'*/:
			case 'mapinfo' /*case 'MapInfo'*/:
			case 'pagebreaks' /*case 'PageBreaks'*/:
			case 'querytable' /*case 'QueryTable'*/:
			case 'sorting' /*case 'Sorting'*/:
			case 'schema' /*case 'Schema'*/: //case 'data' /*case 'data'*/:
			case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
			case 'smarttagtype' /*case 'SmartTagType'*/:
			case 'smarttags' /*case 'SmartTags'*/:
			case 'excelworkbook' /*case 'ExcelWorkbook'*/:
			case 'workbookoptions' /*case 'WorkbookOptions'*/:
			case 'worksheetoptions' /*case 'WorksheetOptions'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
	
			case 'null' /*case 'Null'*/: break;
	
			default:
				/* FODS file root is <office:document> */
				if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
				/* UOS file root is <uof:UOF> */
				if(state.length == 0 && Rn[3] == "uof"/*"UOF"*/) return parse_fods(str, opts);
	
				var seen = true;
				switch(state[state.length-1][0]) {
					/* OfficeDocumentSettings */
					case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/: switch(Rn[3]) {
						case 'allowpng' /*case 'AllowPNG'*/: break;
						case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/: break;
						case 'downloadcomponents' /*case 'DownloadComponents'*/: break;
						case 'locationofcomponents' /*case 'LocationOfComponents'*/: break;
						case 'colors' /*case 'Colors'*/: break;
						case 'color' /*case 'Color'*/: break;
						case 'index' /*case 'Index'*/: break;
						case 'rgb' /*case 'RGB'*/: break;
						case 'targetscreensize' /*case 'TargetScreenSize'*/: break;
						case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/: break;
						default: seen = false;
					} break;
	
					/* ComponentOptions */
					case 'componentoptions' /*case 'ComponentOptions'*/: switch(Rn[3]) {
						case 'toolbar' /*case 'Toolbar'*/: break;
						case 'hideofficelogo' /*case 'HideOfficeLogo'*/: break;
						case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/: break;
						case 'label' /*case 'Label'*/: break;
						case 'caption' /*case 'Caption'*/: break;
						case 'maxheight' /*case 'MaxHeight'*/: break;
						case 'maxwidth' /*case 'MaxWidth'*/: break;
						case 'nextsheetnumber' /*case 'NextSheetNumber'*/: break;
						default: seen = false;
					} break;
	
					/* ExcelWorkbook */
					case 'excelworkbook' /*case 'ExcelWorkbook'*/: switch(Rn[3]) {
						case 'date1904' /*case 'Date1904'*/:
	Workbook.WBProps.date1904 = true;
							break;
						case 'windowheight' /*case 'WindowHeight'*/: break;
						case 'windowwidth' /*case 'WindowWidth'*/: break;
						case 'windowtopx' /*case 'WindowTopX'*/: break;
						case 'windowtopy' /*case 'WindowTopY'*/: break;
						case 'tabratio' /*case 'TabRatio'*/: break;
						case 'protectstructure' /*case 'ProtectStructure'*/: break;
						case 'protectwindow' /*case 'ProtectWindow'*/: break;
						case 'protectwindows' /*case 'ProtectWindows'*/: break;
						case 'activesheet' /*case 'ActiveSheet'*/: break;
						case 'displayinknotes' /*case 'DisplayInkNotes'*/: break;
						case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/: break;
						case 'supbook' /*case 'SupBook'*/: break;
						case 'sheetname' /*case 'SheetName'*/: break;
						case 'sheetindex' /*case 'SheetIndex'*/: break;
						case 'sheetindexfirst' /*case 'SheetIndexFirst'*/: break;
						case 'sheetindexlast' /*case 'SheetIndexLast'*/: break;
						case 'dll' /*case 'Dll'*/: break;
						case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/: break;
						case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/: break;
						case 'iteration' /*case 'Iteration'*/: break;
						case 'maxiterations' /*case 'MaxIterations'*/: break;
						case 'maxchange' /*case 'MaxChange'*/: break;
						case 'path' /*case 'Path'*/: break;
						case 'xct' /*case 'Xct'*/: break;
						case 'count' /*case 'Count'*/: break;
						case 'selectedsheets' /*case 'SelectedSheets'*/: break;
						case 'calculation' /*case 'Calculation'*/: break;
						case 'uncalced' /*case 'Uncalced'*/: break;
						case 'startupprompt' /*case 'StartupPrompt'*/: break;
						case 'crn' /*case 'Crn'*/: break;
						case 'externname' /*case 'ExternName'*/: break;
						case 'formula' /*case 'Formula'*/: break;
						case 'colfirst' /*case 'ColFirst'*/: break;
						case 'collast' /*case 'ColLast'*/: break;
						case 'wantadvise' /*case 'WantAdvise'*/: break;
						case 'boolean' /*case 'Boolean'*/: break;
						case 'error' /*case 'Error'*/: break;
						case 'text' /*case 'Text'*/: break;
						case 'ole' /*case 'OLE'*/: break;
						case 'noautorecover' /*case 'NoAutoRecover'*/: break;
						case 'publishobjects' /*case 'PublishObjects'*/: break;
						case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'refmoder1c1' /*case 'RefModeR1C1'*/: break;
						case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/: break;
						default: seen = false;
					} break;
	
					/* WorkbookOptions */
					case 'workbookoptions' /*case 'WorkbookOptions'*/: switch(Rn[3]) {
						case 'owcversion' /*case 'OWCVersion'*/: break;
						case 'height' /*case 'Height'*/: break;
						case 'width' /*case 'Width'*/: break;
						default: seen = false;
					} break;
	
					/* WorksheetOptions */
					case 'worksheetoptions' /*case 'WorksheetOptions'*/: switch(Rn[3]) {
						case 'visible' /*case 'Visible'*/:
							if(Rn[0].slice(-2) === "/>"){/* empty */}
							else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
								case "SheetHidden": wsprops.Hidden = 1; break;
								case "SheetVeryHidden": wsprops.Hidden = 2; break;
							}
							else pidx = Rn.index + Rn[0].length;
							break;
						case 'header' /*case 'Header'*/:
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +parsexmltag(Rn[0]).Margin;
							break;
						case 'footer' /*case 'Footer'*/:
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +parsexmltag(Rn[0]).Margin;
							break;
						case 'pagemargins' /*case 'PageMargins'*/:
							var pagemargins = parsexmltag(Rn[0]);
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
							if(!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
							if(!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
							if(!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
							if(!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
							break;
						case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/:
							if(!Workbook.Views) Workbook.Views = [];
							if(!Workbook.Views[0]) Workbook.Views[0] = {};
							Workbook.Views[0].RTL = true;
							break;
	
						case 'freezepanes' /*case 'FreezePanes'*/: break;
						case 'frozennosplit' /*case 'FrozenNoSplit'*/: break;
	
						case 'splithorizontal' /*case 'SplitHorizontal'*/:
						case 'splitvertical' /*case 'SplitVertical'*/:
							break;
	
						case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/:
							break;
	
						case 'activerow' /*case 'ActiveRow'*/: break;
						case 'activecol' /*case 'ActiveCol'*/: break;
						case 'toprowbottompane' /*case 'TopRowBottomPane'*/: break;
						case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/: break;
	
						case 'unsynced' /*case 'Unsynced'*/: break;
						case 'print' /*case 'Print'*/: break;
						case 'printerrors' /*case 'PrintErrors'*/: break;
						case 'panes' /*case 'Panes'*/: break;
						case 'scale' /*case 'Scale'*/: break;
						case 'pane' /*case 'Pane'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'layout' /*case 'Layout'*/: break;
						case 'pagesetup' /*case 'PageSetup'*/: break;
						case 'selected' /*case 'Selected'*/: break;
						case 'protectobjects' /*case 'ProtectObjects'*/: break;
						case 'enableselection' /*case 'EnableSelection'*/: break;
						case 'protectscenarios' /*case 'ProtectScenarios'*/: break;
						case 'validprinterinfo' /*case 'ValidPrinterInfo'*/: break;
						case 'horizontalresolution' /*case 'HorizontalResolution'*/: break;
						case 'verticalresolution' /*case 'VerticalResolution'*/: break;
						case 'numberofcopies' /*case 'NumberofCopies'*/: break;
						case 'activepane' /*case 'ActivePane'*/: break;
						case 'toprowvisible' /*case 'TopRowVisible'*/: break;
						case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/: break;
						case 'fittopage' /*case 'FitToPage'*/: break;
						case 'rangeselection' /*case 'RangeSelection'*/: break;
						case 'papersizeindex' /*case 'PaperSizeIndex'*/: break;
						case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/: break;
						case 'pagebreakzoom' /*case 'PageBreakZoom'*/: break;
						case 'filteron' /*case 'FilterOn'*/: break;
						case 'fitwidth' /*case 'FitWidth'*/: break;
						case 'fitheight' /*case 'FitHeight'*/: break;
						case 'commentslayout' /*case 'CommentsLayout'*/: break;
						case 'zoom' /*case 'Zoom'*/: break;
						case 'lefttoright' /*case 'LeftToRight'*/: break;
						case 'gridlines' /*case 'Gridlines'*/: break;
						case 'allowsort' /*case 'AllowSort'*/: break;
						case 'allowfilter' /*case 'AllowFilter'*/: break;
						case 'allowinsertrows' /*case 'AllowInsertRows'*/: break;
						case 'allowdeleterows' /*case 'AllowDeleteRows'*/: break;
						case 'allowinsertcols' /*case 'AllowInsertCols'*/: break;
						case 'allowdeletecols' /*case 'AllowDeleteCols'*/: break;
						case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/: break;
						case 'allowformatcells' /*case 'AllowFormatCells'*/: break;
						case 'allowsizecols' /*case 'AllowSizeCols'*/: break;
						case 'allowsizerows' /*case 'AllowSizeRows'*/: break;
						case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/:
							if(!cursheet["!outline"]) cursheet["!outline"] = {};
							cursheet["!outline"].above = true;
							break;
						case 'tabcolorindex' /*case 'TabColorIndex'*/: break;
						case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/: break;
						case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/: break;
						case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/:
							if(!cursheet["!outline"]) cursheet["!outline"] = {};
							cursheet["!outline"].left = true;
							break;
						case 'blackandwhite' /*case 'BlackAndWhite'*/: break;
						case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/: break;
						case 'displaypagebreak' /*case 'DisplayPageBreak'*/: break;
						case 'rowcolheadings' /*case 'RowColHeadings'*/: break;
						case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/: break;
						case 'noorientation' /*case 'NoOrientation'*/: break;
						case 'allowusepivottables' /*case 'AllowUsePivotTables'*/: break;
						case 'zeroheight' /*case 'ZeroHeight'*/: break;
						case 'viewablerange' /*case 'ViewableRange'*/: break;
						case 'selection' /*case 'Selection'*/: break;
						case 'protectcontents' /*case 'ProtectContents'*/: break;
						default: seen = false;
					} break;
	
					/* PivotTable */
					case 'pivottable' /*case 'PivotTable'*/: case 'pivotcache' /*case 'PivotCache'*/: switch(Rn[3]) {
						case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/: break;
						case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/: break;
						case 'compactrowindent' /*case 'CompactRowIndent'*/: break;
						case 'location' /*case 'Location'*/: break;
						case 'pivotfield' /*case 'PivotField'*/: break;
						case 'orientation' /*case 'Orientation'*/: break;
						case 'layoutform' /*case 'LayoutForm'*/: break;
						case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/: break;
						case 'layoutcompactrow' /*case 'LayoutCompactRow'*/: break;
						case 'position' /*case 'Position'*/: break;
						case 'pivotitem' /*case 'PivotItem'*/: break;
						case 'datatype' /*case 'DataType'*/: break;
						case 'datafield' /*case 'DataField'*/: break;
						case 'sourcename' /*case 'SourceName'*/: break;
						case 'parentfield' /*case 'ParentField'*/: break;
						case 'ptlineitems' /*case 'PTLineItems'*/: break;
						case 'ptlineitem' /*case 'PTLineItem'*/: break;
						case 'countofsameitems' /*case 'CountOfSameItems'*/: break;
						case 'item' /*case 'Item'*/: break;
						case 'itemtype' /*case 'ItemType'*/: break;
						case 'ptsource' /*case 'PTSource'*/: break;
						case 'cacheindex' /*case 'CacheIndex'*/: break;
						case 'consolidationreference' /*case 'ConsolidationReference'*/: break;
						case 'filename' /*case 'FileName'*/: break;
						case 'reference' /*case 'Reference'*/: break;
						case 'nocolumngrand' /*case 'NoColumnGrand'*/: break;
						case 'norowgrand' /*case 'NoRowGrand'*/: break;
						case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/: break;
						case 'hidden' /*case 'Hidden'*/: break;
						case 'subtotal' /*case 'Subtotal'*/: break;
						case 'basefield' /*case 'BaseField'*/: break;
						case 'mapchilditems' /*case 'MapChildItems'*/: break;
						case 'function' /*case 'Function'*/: break;
						case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/: break;
						case 'printsettitles' /*case 'PrintSetTitles'*/: break;
						case 'mergelabels' /*case 'MergeLabels'*/: break;
						case 'defaultversion' /*case 'DefaultVersion'*/: break;
						case 'refreshname' /*case 'RefreshName'*/: break;
						case 'refreshdate' /*case 'RefreshDate'*/: break;
						case 'refreshdatecopy' /*case 'RefreshDateCopy'*/: break;
						case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
						case 'versionlastupdate' /*case 'VersionLastUpdate'*/: break;
						case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/: break;
						case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/: break;
						case 'calculation' /*case 'Calculation'*/: break;
						default: seen = false;
					} break;
	
					/* PageBreaks */
					case 'pagebreaks' /*case 'PageBreaks'*/: switch(Rn[3]) {
						case 'colbreaks' /*case 'ColBreaks'*/: break;
						case 'colbreak' /*case 'ColBreak'*/: break;
						case 'rowbreaks' /*case 'RowBreaks'*/: break;
						case 'rowbreak' /*case 'RowBreak'*/: break;
						case 'colstart' /*case 'ColStart'*/: break;
						case 'colend' /*case 'ColEnd'*/: break;
						case 'rowend' /*case 'RowEnd'*/: break;
						default: seen = false;
					} break;
	
					/* AutoFilter */
					case 'autofilter' /*case 'AutoFilter'*/: switch(Rn[3]) {
						case 'autofiltercolumn' /*case 'AutoFilterColumn'*/: break;
						case 'autofiltercondition' /*case 'AutoFilterCondition'*/: break;
						case 'autofilterand' /*case 'AutoFilterAnd'*/: break;
						case 'autofilteror' /*case 'AutoFilterOr'*/: break;
						default: seen = false;
					} break;
	
					/* QueryTable */
					case 'querytable' /*case 'QueryTable'*/: switch(Rn[3]) {
						case 'id' /*case 'Id'*/: break;
						case 'autoformatfont' /*case 'AutoFormatFont'*/: break;
						case 'autoformatpattern' /*case 'AutoFormatPattern'*/: break;
						case 'querysource' /*case 'QuerySource'*/: break;
						case 'querytype' /*case 'QueryType'*/: break;
						case 'enableredirections' /*case 'EnableRedirections'*/: break;
						case 'refreshedinxl9' /*case 'RefreshedInXl9'*/: break;
						case 'urlstring' /*case 'URLString'*/: break;
						case 'htmltables' /*case 'HTMLTables'*/: break;
						case 'connection' /*case 'Connection'*/: break;
						case 'commandtext' /*case 'CommandText'*/: break;
						case 'refreshinfo' /*case 'RefreshInfo'*/: break;
						case 'notitles' /*case 'NoTitles'*/: break;
						case 'nextid' /*case 'NextId'*/: break;
						case 'columninfo' /*case 'ColumnInfo'*/: break;
						case 'overwritecells' /*case 'OverwriteCells'*/: break;
						case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/: break;
						case 'textwizardsettings' /*case 'TextWizardSettings'*/: break;
						case 'source' /*case 'Source'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'decimal' /*case 'Decimal'*/: break;
						case 'thousandseparator' /*case 'ThousandSeparator'*/: break;
						case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/: break;
						case 'formatsettings' /*case 'FormatSettings'*/: break;
						case 'fieldtype' /*case 'FieldType'*/: break;
						case 'delimiters' /*case 'Delimiters'*/: break;
						case 'tab' /*case 'Tab'*/: break;
						case 'comma' /*case 'Comma'*/: break;
						case 'autoformatname' /*case 'AutoFormatName'*/: break;
						case 'versionlastedit' /*case 'VersionLastEdit'*/: break;
						case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
						default: seen = false;
					} break;
	
					case 'datavalidation' /*case 'DataValidation'*/:
					switch(Rn[3]) {
						case 'range' /*case 'Range'*/: break;
	
						case 'type' /*case 'Type'*/: break;
						case 'min' /*case 'Min'*/: break;
						case 'max' /*case 'Max'*/: break;
						case 'sort' /*case 'Sort'*/: break;
						case 'descending' /*case 'Descending'*/: break;
						case 'order' /*case 'Order'*/: break;
						case 'casesensitive' /*case 'CaseSensitive'*/: break;
						case 'value' /*case 'Value'*/: break;
						case 'errorstyle' /*case 'ErrorStyle'*/: break;
						case 'errormessage' /*case 'ErrorMessage'*/: break;
						case 'errortitle' /*case 'ErrorTitle'*/: break;
						case 'inputmessage' /*case 'InputMessage'*/: break;
						case 'inputtitle' /*case 'InputTitle'*/: break;
						case 'combohide' /*case 'ComboHide'*/: break;
						case 'inputhide' /*case 'InputHide'*/: break;
						case 'condition' /*case 'Condition'*/: break;
						case 'qualifier' /*case 'Qualifier'*/: break;
						case 'useblank' /*case 'UseBlank'*/: break;
						case 'value1' /*case 'Value1'*/: break;
						case 'value2' /*case 'Value2'*/: break;
						case 'format' /*case 'Format'*/: break;
	
						case 'cellrangelist' /*case 'CellRangeList'*/: break;
						default: seen = false;
					} break;
	
					case 'sorting' /*case 'Sorting'*/:
					case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
					switch(Rn[3]) {
						case 'range' /*case 'Range'*/: break;
						case 'type' /*case 'Type'*/: break;
						case 'min' /*case 'Min'*/: break;
						case 'max' /*case 'Max'*/: break;
						case 'sort' /*case 'Sort'*/: break;
						case 'descending' /*case 'Descending'*/: break;
						case 'order' /*case 'Order'*/: break;
						case 'casesensitive' /*case 'CaseSensitive'*/: break;
						case 'value' /*case 'Value'*/: break;
						case 'errorstyle' /*case 'ErrorStyle'*/: break;
						case 'errormessage' /*case 'ErrorMessage'*/: break;
						case 'errortitle' /*case 'ErrorTitle'*/: break;
						case 'cellrangelist' /*case 'CellRangeList'*/: break;
						case 'inputmessage' /*case 'InputMessage'*/: break;
						case 'inputtitle' /*case 'InputTitle'*/: break;
						case 'combohide' /*case 'ComboHide'*/: break;
						case 'inputhide' /*case 'InputHide'*/: break;
						case 'condition' /*case 'Condition'*/: break;
						case 'qualifier' /*case 'Qualifier'*/: break;
						case 'useblank' /*case 'UseBlank'*/: break;
						case 'value1' /*case 'Value1'*/: break;
						case 'value2' /*case 'Value2'*/: break;
						case 'format' /*case 'Format'*/: break;
						default: seen = false;
					} break;
	
					/* MapInfo (schema) */
					case 'mapinfo' /*case 'MapInfo'*/: case 'schema' /*case 'Schema'*/: case 'data' /*case 'data'*/: switch(Rn[3]) {
						case 'map' /*case 'Map'*/: break;
						case 'entry' /*case 'Entry'*/: break;
						case 'range' /*case 'Range'*/: break;
						case 'xpath' /*case 'XPath'*/: break;
						case 'field' /*case 'Field'*/: break;
						case 'xsdtype' /*case 'XSDType'*/: break;
						case 'filteron' /*case 'FilterOn'*/: break;
						case 'aggregate' /*case 'Aggregate'*/: break;
						case 'elementtype' /*case 'ElementType'*/: break;
						case 'attributetype' /*case 'AttributeType'*/: break;
					/* These are from xsd (XML Schema Definition) */
						case 'schema' /*case 'schema'*/:
						case 'element' /*case 'element'*/:
						case 'complextype' /*case 'complexType'*/:
						case 'datatype' /*case 'datatype'*/:
						case 'all' /*case 'all'*/:
						case 'attribute' /*case 'attribute'*/:
						case 'extends' /*case 'extends'*/: break;
	
						case 'row' /*case 'row'*/: break;
						default: seen = false;
					} break;
	
					/* SmartTags (can be anything) */
					case 'smarttags' /*case 'SmartTags'*/: break;
	
					default: seen = false; break;
				}
				if(seen) break;
				/* CustomDocumentProperties */
				if(Rn[3].match(/!\[CDATA/)) break;
				if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
				if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties') {
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
					else { cp = Rn; pidx = Rn.index + Rn[0].length; }
					break;
				}
				if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
		}
		var out = ({});
		if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
		out.SheetNames = sheetnames;
		out.Workbook = Workbook;
		out.SSF = dup(table_fmt);
		out.Props = Props;
		out.Custprops = Custprops;
		return out;
	}
	
	function parse_xlml(data, opts) {
		fix_read_opts(opts=opts||{});
		switch(opts.type||"base64") {
			case "base64": return parse_xlml_xml(Base64_decode(data), opts);
			case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
			case "array": return parse_xlml_xml(a2s(data), opts);
		}
	}
	
	/* TODO */
	function write_props_xlml(wb, opts) {
		var o = [];
		/* DocumentProperties */
		if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
		/* CustomDocumentProperties */
		if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
		return o.join("");
	}
	/* TODO */
	function write_wb_xlml() {
		/* OfficeDocumentSettings */
		/* ExcelWorkbook */
		return "";
	}
	/* TODO */
	function write_sty_xlml(wb, opts) {
		/* Styles */
		var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
		opts.cellXfs.forEach(function(xf, id) {
			var payload = [];
			payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(table_fmt[xf.numFmtId])}));
	
			var o = {"ss:ID": "s" + (21+id)};
			styles.push(writextag('Style', payload.join(""), o));
		});
		return writextag("Styles", styles.join(""));
	}
	function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
	function write_names_xlml(wb) {
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != null) continue;
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return writextag("Names", out.join(""));
	}
	function write_ws_xlml_names(ws, opts, idx, wb) {
		if(!ws) return "";
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != idx) continue;
			/*switch(n.Name) {
				case "_": continue;
			}*/
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return out.join("");
	}
	/* WorksheetOptions */
	function write_ws_xlml_wsopts(ws, opts, idx, wb) {
		if(!ws) return "";
		var o = [];
		/* NOTE: spec technically allows any order, but stick with implied order */
	
		/* FitToPage */
		/* DoNotDisplayColHeaders */
		/* DoNotDisplayRowHeaders */
		/* ViewableRange */
		/* Selection */
		/* GridlineColor */
		/* Name */
		/* ExcelWorksheetType */
		/* IntlMacro */
		/* Unsynced */
		/* Selected */
		/* CodeName */
	
		if(ws['!margins']) {
			o.push("<PageSetup>");
			if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
			if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
			o.push(writextag("PageMargins", null, {
				'x:Bottom': ws['!margins'].bottom || "0.75",
				'x:Left': ws['!margins'].left || "0.7",
				'x:Right': ws['!margins'].right || "0.7",
				'x:Top': ws['!margins'].top || "0.75"
			}));
			o.push("</PageSetup>");
		}
	
		/* PageSetup */
		/* DisplayPageBreak */
		/* TransitionExpressionEvaluation */
		/* TransitionFormulaEntry */
		/* Print */
		/* Zoom */
		/* PageLayoutZoom */
		/* PageBreakZoom */
		/* ShowPageBreakZoom */
		/* DefaultRowHeight */
		/* DefaultColumnWidth */
		/* StandardWidth */
	
		if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
			/* Visible */
			if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
			else {
				/* Selected */
				for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
				if(i == idx) o.push("<Selected/>");
			}
		}
	
		/* LeftColumnVisible */
	
		if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");
	
		/* GridlineColorIndex */
		/* DisplayFormulas */
		/* DoNotDisplayGridlines */
		/* DoNotDisplayHeadings */
		/* DoNotDisplayOutline */
		/* ApplyAutomaticOutlineStyles */
		/* NoSummaryRowsBelowDetail */
		/* NoSummaryColumnsRightDetail */
		/* DoNotDisplayZeros */
		/* ActiveRow */
		/* ActiveColumn */
		/* FilterOn */
		/* RangeSelection */
		/* TopRowVisible */
		/* TopRowBottomPane */
		/* LeftColumnRightPane */
		/* ActivePane */
		/* SplitHorizontal */
		/* SplitVertical */
		/* FreezePanes */
		/* FrozenNoSplit */
		/* TabColorIndex */
		/* Panes */
	
		/* NOTE: Password not supported in XLML Format */
		if(ws['!protect']) {
			o.push(writetag("ProtectContents", "True"));
			if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
			if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
			if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
			else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
		[
			[ "formatCells", "AllowFormatCells" ],
			[ "formatColumns", "AllowSizeCols" ],
			[ "formatRows", "AllowSizeRows" ],
			[ "insertColumns", "AllowInsertCols" ],
			[ "insertRows", "AllowInsertRows" ],
			[ "insertHyperlinks", "AllowInsertHyperlinks" ],
			[ "deleteColumns", "AllowDeleteCols" ],
			[ "deleteRows", "AllowDeleteRows" ],
			[ "sort", "AllowSort" ],
			[ "autoFilter", "AllowFilter" ],
			[ "pivotTables", "AllowUsePivotTables" ]
		].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
		}
	
		if(o.length == 0) return "";
		return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
	}
	function write_ws_xlml_comment(comments) {
		return comments.map(function(c) {
			// TODO: formatted text
			var t = xlml_unfixstr(c.t||"");
			var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
			return writextag("Comment", d, {"ss:Author":c.a});
		}).join("");
	}
	function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
		if(!cell || (cell.v == undefined && cell.f == undefined)) return "";
	
		var attr = {};
		if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
		if(cell.F && cell.F.slice(0, ref.length) == ref) {
			var end = decode_cell(cell.F.slice(ref.length + 1));
			attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
		}
	
		if(cell.l && cell.l.Target) {
			attr["ss:HRef"] = escapexml(cell.l.Target);
			if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
		}
	
		if(ws['!merges']) {
			var marr = ws['!merges'];
			for(var mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
				if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
				if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
			}
		}
	
		var t = "", p = "";
		switch(cell.t) {
			case 'z': if(!opts.sheetStubs) return ""; break;
			case 'n': t = 'Number'; p = String(cell.v); break;
			case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
			case 'e': t = 'Error'; p = BErr[cell.v]; break;
			case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || table_fmt[14]; break;
			case 's': t = 'String'; p = escapexlml(cell.v||""); break;
		}
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		attr["ss:StyleID"] = "s" + (21+os);
		attr["ss:Index"] = addr.c + 1;
		var _v = (cell.v != null ? p : "");
		var m = cell.t == 'z' ? "" : ('<Data ss:Type="' + t + '">' + _v + '</Data>');
	
		if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);
	
		return writextag("Cell", m, attr);
	}
	function write_ws_xlml_row(R, row) {
		var o = '<Row ss:Index="' + (R+1) + '"';
		if(row) {
			if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
			if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
			if(row.hidden) o += ' ss:Hidden="1"';
		}
		return o + '>';
	}
	/* TODO */
	function write_ws_xlml_table(ws, opts, idx, wb) {
		if(!ws['!ref']) return "";
		var range = safe_decode_range(ws['!ref']);
		var marr = ws['!merges'] || [], mi = 0;
		var o = [];
		if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
			process_col(n);
			var w = !!n.width;
			var p = col_obj_w(i, n);
			var k = {"ss:Index":i+1};
			if(w) k['ss:Width'] = width2px(p.width);
			if(n.hidden) k['ss:Hidden']="1";
			o.push(writextag("Column",null,k));
		});
		var dense = Array.isArray(ws);
		for(var R = range.s.r; R <= range.e.r; ++R) {
			var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
			for(var C = range.s.c; C <= range.e.c; ++C) {
				var skip = false;
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					break;
				}
				if(skip) continue;
				var addr = {r:R,c:C};
				var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
				row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
			}
			row.push("</Row>");
			if(row.length > 2) o.push(row.join(""));
		}
		return o.join("");
	}
	function write_ws_xlml(idx, opts, wb) {
		var o = [];
		var s = wb.SheetNames[idx];
		var ws = wb.Sheets[s];
	
		var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Names>" + t + "</Names>");
	
		/* Table */
		t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Table>" + t + "</Table>");
	
		/* WorksheetOptions */
		o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));
	
		return o.join("");
	}
	function write_xlml(wb, opts) {
		if(!opts) opts = {};
		if(!wb.SSF) wb.SSF = dup(table_fmt);
		if(wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
			opts.cellXfs = [];
			get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
		}
		var d = [];
		d.push(write_props_xlml(wb, opts));
		d.push(write_wb_xlml(wb, opts));
		d.push("");
		d.push("");
		for(var i = 0; i < wb.SheetNames.length; ++i)
			d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
		d[2] = write_sty_xlml(wb, opts);
		d[3] = write_names_xlml(wb, opts);
		return XML_HEADER + writextag("Workbook", d.join(""), {
			'xmlns':      XLMLNS.ss,
			'xmlns:o':    XLMLNS.o,
			'xmlns:x':    XLMLNS.x,
			'xmlns:ss':   XLMLNS.ss,
			'xmlns:dt':   XLMLNS.dt,
			'xmlns:html': XLMLNS.html
		});
	}
	/* [MS-OLEDS] 2.3.8 CompObjStream */
	function parse_compobj(obj) {
		var v = {};
		var o = obj.content;
	/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
		o.l = 28;
	
		v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
		v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);
	
		if(o.length - o.l <= 4) return v;
	
		var m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");
	
		if(o.length - o.l <= 4) return v;
		m = o.read_shift(4);
		if(m !== 0x71b239f4) return v;
		v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);
	
		m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
	}
	
	/*
		Continue logic for:
		- 2.4.58 Continue          0x003c
		- 2.4.59 ContinueBigName   0x043c
		- 2.4.60 ContinueFrt       0x0812
		- 2.4.61 ContinueFrt11     0x0875
		- 2.4.62 ContinueFrt12     0x087f
	*/
	var CONTINUE_RT = [ 0x003c, 0x043c, 0x0812, 0x0875, 0x087f ];
	function slurp(RecordType, R, blob, length, opts) {
		var l = length;
		var bufs = [];
		var d = blob.slice(blob.l,blob.l+l);
		if(opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType) {
		case 0x0009: case 0x0209: case 0x0409: case 0x0809/* BOF */: case 0x002f /* FilePass */: case 0x0195 /* FileLock */: case 0x00e1 /* InterfaceHdr */: case 0x0196 /* RRDInfo */: case 0x0138 /* RRDHead */: case 0x0194 /* UsrExcl */: case 0x000a /* EOF */:
			break;
		case 0x0085 /* BoundSheet8 */:
			break;
		default:
			opts.enc.insitu(d);
		}
		bufs.push(d);
		blob.l += l;
		var nextrt = __readUInt16LE(blob,blob.l), next = XLSRecordEnum[nextrt];
		var start = 0;
		while(next != null && CONTINUE_RT.indexOf(nextrt) > -1) {
			l = __readUInt16LE(blob,blob.l+2);
			start = blob.l + 4;
			if(nextrt == 0x0812 /* ContinueFrt */) start += 4;
			else if(nextrt == 0x0875 || nextrt == 0x087f) {
				start += 12;
			}
			d = blob.slice(start,blob.l+4+l);
			bufs.push(d);
			blob.l += 4+l;
			next = (XLSRecordEnum[nextrt = __readUInt16LE(blob, blob.l)]);
		}
		var b = (bconcat(bufs));
		prep_blob(b, 0);
		var ll = 0; b.lens = [];
		for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
		if(b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
		return R.f(b, b.length, opts);
	}
	
	function safe_format_xf(p, opts, date1904) {
		if(p.t === 'z') return;
		if(!p.XF) return;
		var fmtid = 0;
		try {
			fmtid = p.z || p.XF.numFmtId || 0;
			if(opts.cellNF) p.z = table_fmt[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts || opts.cellText !== false) try {
			if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
			else if(fmtid === 0 || fmtid == "General") {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = p.v.toString(10);
					else p.w = SSF_general_num(p.v);
				}
				else p.w = SSF_general(p.v);
			}
			else p.w = SSF_format(fmtid,p.v, {date1904:!!date1904, dateNF: opts && opts.dateNF});
		} catch(e) { if(opts.WTF) throw e; }
		if(opts.cellDates && fmtid && p.t == 'n' && fmt_is_date(table_fmt[fmtid] || String(fmtid))) {
			var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	}
	
	function make_cell(val, ixfe, t) {
		return ({v:val, ixfe:ixfe, t:t});
	}
	
	// 2.3.2
	function parse_workbook(blob, options) {
		var wb = ({opts:{}});
		var Sheets = {};
		if(DENSE != null && options.dense == null) options.dense = DENSE;
		var out = ((options.dense ? [] : {}));
		var Directory = {};
		var range = ({});
		var last_formula = null;
		var sst = ([]);
		var cur_sheet = "";
		var Preamble = {};
		var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
		var sharedf = {};
		var arrayf = [];
		var temp_val;
		var country;
		var XFs = []; /* XF records */
		var palette = [];
		var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
		var get_rgb = function getrgb(icv) {
			if(icv < 8) return XLSIcv[icv];
			if(icv < 64) return palette[icv-8] || XLSIcv[icv];
			return XLSIcv[icv];
		};
		var process_cell_style = function pcs(cell, line, options) {
			var xfd = line.XF.data;
			if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
			line.s = ({});
			line.s.patternType = xfd.patternType;
			var t;
			if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
			if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
		};
		var addcell = function addcell(cell, line, options) {
			if(file_depth > 1) return;
			if(options.sheetRows && cell.r >= options.sheetRows) return;
			if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
			delete line.ixfe; delete line.XF;
			lastcell = cell;
			last_cell = encode_cell(cell);
			if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
			if(cell.r < range.s.r) range.s.r = cell.r;
			if(cell.c < range.s.c) range.s.c = cell.c;
			if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
			if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
			if(options.cellFormula && line.f) {
				for(var afi = 0; afi < arrayf.length; ++afi) {
					if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
					if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
					line.F = encode_range(arrayf[afi][0]);
					if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
					if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
					break;
				}
			}
			{
				if(options.dense) {
					if(!out[cell.r]) out[cell.r] = [];
					out[cell.r][cell.c] = line;
				} else out[last_cell] = line;
			}
		};
		var opts = ({
			enc: false, // encrypted
			sbcch: 0, // cch in the preceding SupBook
			snames: [], // sheetnames
			sharedf: sharedf, // shared formulae by address
			arrayf: arrayf, // array formulae array
			rrtabid: [], // RRTabId
			lastuser: "", // Last User from WriteAccess
			biff: 8, // BIFF version
			codepage: 0, // CP from CodePage record
			winlocked: 0, // fLockWn from WinProtect
			cellStyles: !!options && !!options.cellStyles,
			WTF: !!options && !!options.wtf
		});
		if(options.password) opts.password = options.password;
		var themes;
		var merges = [];
		var objects = [];
		var colinfo = [], rowinfo = [];
		var seencol = false;
		var supbooks = ([]); // 1-indexed, will hold extern names
		supbooks.SheetNames = opts.snames;
		supbooks.sharedf = opts.sharedf;
		supbooks.arrayf = opts.arrayf;
		supbooks.names = [];
		supbooks.XTI = [];
		var last_RT = 0;
		var file_depth = 0; /* TODO: make a real stack */
		var BIFF2Fmt = 0, BIFF2FmtTable = [];
		var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
		var last_lbl;
	
		/* explicit override for some broken writers */
		opts.codepage = 1200;
		set_cp(1200);
		var seen_codepage = false;
		while(blob.l < blob.length - 1) {
			var s = blob.l;
			var RecordType = blob.read_shift(2);
			if(RecordType === 0 && last_RT === 0x000a /* EOF */) break;
			var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
			var R = XLSRecordEnum[RecordType];
			//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
			//if(!R) console.log(blob.slice(blob.l, blob.l + length));
			if(R && R.f) {
				if(options.bookSheets) {
					if(last_RT === 0x0085 /* BoundSheet8 */ && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */) break;
				}
				last_RT = RecordType;
				if(R.r === 2 || R.r == 12) {
					var rt = blob.read_shift(2); length -= 2;
					if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
					if(R.r == 12){
						blob.l += 10; length -= 10;
					} // skip FRT
				}
				//console.error(R,blob.l,length,blob.length);
				var val = ({});
				if(RecordType === 0x000a /* EOF */) val = R.f(blob, length, opts);
				else val = slurp(RecordType, R, blob, length, opts);
	if(file_depth == 0 && [0x0009, 0x0209, 0x0409, 0x0809].indexOf(last_RT) === -1 /* 'BOF' */) continue;
				switch(RecordType) {
					case 0x0022 /* Date1904 */:
	wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
					case 0x0086 /* WriteProtect */: wb.opts.WriteProtect = true; break;
					case 0x002f /* FilePass */:
						if(!opts.enc) blob.l = 0;
						opts.enc = val;
						if(!options.password) throw new Error("File is password-protected");
						if(val.valid == null) throw new Error("Encryption scheme unsupported");
						if(!val.valid) throw new Error("Password is incorrect");
						break;
					case 0x005c /* WriteAccess */: opts.lastuser = val; break;
					case 0x0042 /* CodePage */:
						var cpval = Number(val);
						/* overrides based on test cases */
						switch(cpval) {
							case 0x5212: cpval =  1200; break;
							case 0x8000: cpval = 10000; break;
							case 0x8001: cpval =  1252; break;
						}
						set_cp(opts.codepage = cpval);
						seen_codepage = true;
						break;
					case 0x013d /* RRTabId */: opts.rrtabid = val; break;
					case 0x0019 /* WinProtect */: opts.winlocked = val; break;
					case 0x01b7 /* RefreshAll */: wb.opts["RefreshAll"] = val; break;
					case 0x000c /* CalcCount */: wb.opts["CalcCount"] = val; break;
					case 0x0010 /* CalcDelta */: wb.opts["CalcDelta"] = val; break;
					case 0x0011 /* CalcIter */: wb.opts["CalcIter"] = val; break;
					case 0x000d /* CalcMode */: wb.opts["CalcMode"] = val; break;
					case 0x000e /* CalcPrecision */: wb.opts["CalcPrecision"] = val; break;
					case 0x005f /* CalcSaveRecalc */: wb.opts["CalcSaveRecalc"] = val; break;
					case 0x000f /* CalcRefMode */: opts.CalcRefMode = val; break; // TODO: implement R1C1
					case 0x08a3 /* ForceFullCalculation */: wb.opts.FullCalc = val; break;
					case 0x0081 /* WsBool */:
						if(val.fDialog) out["!type"] = "dialog";
						if(!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
						if(!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
						break; // TODO
					case 0x00e0 /* XF */:
						XFs.push(val); break;
					case 0x01ae /* SupBook */:
						supbooks.push([val]);
						supbooks[supbooks.length-1].XTI = [];
						break;
					case 0x0023: case 0x0223 /* ExternName */:
						supbooks[supbooks.length-1].push(val);
						break;
					case 0x0018: case 0x0218 /* Lbl */:
						last_lbl = ({
							Name: val.Name,
							Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
						});
						if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
						supbooks.names.push(last_lbl);
						if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length-1].push(val);
						if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
							if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
								FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
						break;
					case 0x0016 /* ExternCount */: opts.ExternCount = val; break;
					case 0x0017 /* ExternSheet */:
						if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
					case 0x0894 /* NameCmt */:
						/* TODO: search for correct name */
						if(opts.biff < 8) break;
						if(last_lbl != null) last_lbl.Comment = val[1];
						break;
					case 0x0012 /* Protect */: out["!protect"] = val; break; /* for sheet or book */
					case 0x0013 /* Password */: if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
					case 0x0085 /* BoundSheet8 */: {
						Directory[val.pos] = val;
						opts.snames.push(val.name);
					} break;
					case 0x000a /* EOF */: {
						if(--file_depth) break;
						if(range.e) {
							if(range.e.r > 0 && range.e.c > 0) {
								range.e.r--; range.e.c--;
								out["!ref"] = encode_range(range);
								if(options.sheetRows && options.sheetRows <= range.e.r) {
									var tmpri = range.e.r;
									range.e.r = options.sheetRows - 1;
									out["!fullref"] = out["!ref"];
									out["!ref"] = encode_range(range);
									range.e.r = tmpri;
								}
								range.e.r++; range.e.c++;
							}
							if(merges.length > 0) out["!merges"] = merges;
							if(objects.length > 0) out["!objects"] = objects;
							if(colinfo.length > 0) out["!cols"] = colinfo;
							if(rowinfo.length > 0) out["!rows"] = rowinfo;
							Workbook.Sheets.push(wsprops);
						}
						if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
						out = ((options.dense ? [] : {}));
					} break;
					case 0x0009: case 0x0209: case 0x0409: case 0x0809 /* BOF */: {
						if(opts.biff === 8) opts.biff = {
	0x0009:2,
	0x0209:3,
	0x0409:4
						}[RecordType] || {
	0x0200:2,
	0x0300:3,
	0x0400:4,
	0x0500:5,
	0x0600:8,
	0x0002:2,
	0x0007:2
						}[val.BIFFVer] || 8;
						opts.biffguess = val.BIFFVer == 0;
						if(val.BIFFVer == 0 && val.dt == 0x1000) { opts.biff = 5; seen_codepage = true; set_cp(opts.codepage = 28591); }
						if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
						if(file_depth++) break;
						out = ((options.dense ? [] : {}));
	
						if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }
	
						if(opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
							if(cur_sheet === "") cur_sheet = "Sheet1";
							range = {s:{r:0,c:0},e:{r:0,c:0}};
							/* fake BoundSheet8 */
							var fakebs8 = {pos: blob.l - length, name:cur_sheet};
							Directory[fakebs8.pos] = fakebs8;
							opts.snames.push(cur_sheet);
						}
						else cur_sheet = (Directory[s] || {name:""}).name;
						if(val.dt == 0x20) out["!type"] = "chart";
						if(val.dt == 0x40) out["!type"] = "macro";
						merges = [];
						objects = [];
						opts.arrayf = arrayf = [];
						colinfo = []; rowinfo = [];
						seencol = false;
						wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
					} break;
					case 0x0203 /* Number */: case 0x0003 /* BIFF2NUM */: case 0x0002 /* BIFF2INT */: {
						if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x0005: case 0x0205 /* BoolErr */: {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x027e /* RK */: {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x00bd /* MulRk */: {
						for(var j = val.c; j <= val.C; ++j) {
							var ixfe = val.rkrec[j-val.c][0];
							temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:j, r:val.r}, temp_val, options);
						}
					} break;
					case 0x0006: case 0x0206: case 0x0406 /* Formula */: {
						if(val.val == 'String') { last_formula = val; break; }
						temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							var _f = val.formula;
							if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
								var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
								var _fe = encode_cell({r:_fr, c:_fc});
								if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
								else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
							} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(val.cell, temp_val, options);
						last_formula = val;
					} break;
					case 0x0007: case 0x0207 /* String */: {
						if(last_formula) { /* technically always true */
							last_formula.val = val;
							temp_val = make_cell(val, last_formula.cell.ixfe, 's');
							temp_val.XF = XFs[temp_val.ixfe];
							if(options.cellFormula) {
								temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
							}
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell(last_formula.cell, temp_val, options);
							last_formula = null;
						} else throw new Error("String record expects Formula");
					} break;
					case 0x0021: case 0x0221 /* Array */: {
						arrayf.push(val);
						var _arraystart = encode_cell(val[0].s);
						cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
						if(options.cellFormula && cc) {
							if(!last_formula) break; /* technically unreachable */
							if(!_arraystart || !cc) break;
							cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
							cc.F = encode_range(val[0]);
						}
					} break;
					case 0x04bc /* ShrFmla */: {
						if(!options.cellFormula) break;
						if(last_cell) {
							/* TODO: capture range */
							if(!last_formula) break; /* technically unreachable */
							sharedf[encode_cell(last_formula.cell)]= val[0];
							cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
							(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
						}
					} break;
					case 0x00fd /* LabelSst */:
						temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
						if(sst[val.isst].h) temp_val.h = sst[val.isst].h;
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
					case 0x0201 /* Blank */: if(options.sheetStubs) {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x00be /* MulBlank */: if(options.sheetStubs) {
						for(var _j = val.c; _j <= val.C; ++_j) {
							var _ixfe = val.ixfe[_j-val.c];
							temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:_j, r:val.r}, temp_val, options);
						}
					} break;
					case 0x00d6 /* RString */:
					case 0x0204 /* Label */: case 0x0004 /* BIFF2STR */:
						temp_val=make_cell(val.val, val.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
	
					case 0x0000: case 0x0200 /* Dimensions */: {
						if(file_depth === 1) range = val; /* TODO: stack */
					} break;
					case 0x00fc /* SST */: {
						sst = val;
					} break;
					case 0x041e /* Format */: { /* val = [id, fmt] */
						if(opts.biff == 4) {
							BIFF2FmtTable[BIFF2Fmt++] = val[1];
							for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(table_fmt[b4idx] == val[1]) break;
							if(b4idx >= 163) SSF_load(val[1], BIFF2Fmt + 163);
						}
						else SSF_load(val[1], val[0]);
					} break;
					case 0x001e /* BIFF2FORMAT */: {
						BIFF2FmtTable[BIFF2Fmt++] = val;
						for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(table_fmt[b2idx] == val) break;
						if(b2idx >= 163) SSF_load(val, BIFF2Fmt + 163);
					} break;
	
					case 0x00e5 /* MergeCells */: merges = merges.concat(val); break;
	
					case 0x005d /* Obj */: objects[val.cmo[0]] = opts.lastobj = val; break;
					case 0x01b6 /* TxO */: opts.lastobj.TxO = val; break;
					case 0x007f /* ImData */: opts.lastobj.ImData = val; break;
	
					case 0x01b8 /* HLink */: {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc) cc.l = val[1];
							}
					} break;
					case 0x0800 /* HLinkTooltip */: {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc && cc.l) cc.l.Tooltip = val[1];
								}
					} break;
					case 0x001c /* Note */: {
						if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
						cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
						var noteobj = objects[val[2]];
						if(!cc) {
							if(options.dense) {
								if(!out[val[0].r]) out[val[0].r] = [];
								cc = out[val[0].r][val[0].c] = ({t:"z"});
							} else {
								cc = out[encode_cell(val[0])] = ({t:"z"});
							}
							range.e.r = Math.max(range.e.r, val[0].r);
							range.s.r = Math.min(range.s.r, val[0].r);
							range.e.c = Math.max(range.e.c, val[0].c);
							range.s.c = Math.min(range.s.c, val[0].c);
						}
						if(!cc.c) cc.c = [];
						cmnt = {a:val[1],t:noteobj.TxO.t};
						cc.c.push(cmnt);
					} break;
					case 0x087d /* XFExt */: update_xfext(XFs[val.ixfe], val.ext); break;
					case 0x007d /* ColInfo */: {
						if(!opts.cellStyles) break;
						while(val.e >= val.s) {
							colinfo[val.e--] = { width: val.w/256, level: (val.level || 0), hidden: !!(val.flags & 1) };
							if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
							process_col(colinfo[val.e+1]);
						}
					} break;
					case 0x0208 /* Row */: {
						var rowobj = {};
						if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
						if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
						if(val.hpt) {
							rowinfo[val.r] = rowobj;
							rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
						}
					} break;
					case 0x0026 /* LeftMargin */:
					case 0x0027 /* RightMargin */:
					case 0x0028 /* TopMargin */:
					case 0x0029 /* BottomMargin */:
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'][({0x26: "left", 0x27:"right", 0x28:"top", 0x29:"bottom"})[RecordType]] = val;
						break;
					case 0x00a1 /* Setup */: // TODO
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'].header = val.header;
						out['!margins'].footer = val.footer;
						break;
					case 0x023e /* Window2 */: // TODO
						// $FlowIgnore
						if(val.RTL) Workbook.Views[0].RTL = true;
						break;
					case 0x0092 /* Palette */: palette = val; break;
					case 0x0896 /* Theme */: themes = val; break;
					case 0x008c /* Country */: country = val; break;
					case 0x01ba /* CodeName */: {
	if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
						else wsprops.CodeName = val || wsprops.name;
					} break;
				}
			} else {
				if(!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
				blob.l += length;
			}
		}
		wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
		if(!options.bookSheets) wb.Sheets=Sheets;
		if(!wb.SheetNames.length && Preamble["!ref"]) {
			wb.SheetNames.push("Sheet1");
			/*jshint -W069 */
			if(wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
			/*jshint +W069 */
		} else wb.Preamble=Preamble;
		if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
		wb.Strings = sst;
		wb.SSF = dup(table_fmt);
		if(opts.enc) wb.Encryption = opts.enc;
		if(themes) wb.Themes = themes;
		wb.Metadata = {};
		if(country !== undefined) wb.Metadata.Country = country;
		if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
		wb.Workbook = Workbook;
		return wb;
	}
	
	/* TODO: split props*/
	var PSCLSID = {
		SI: "e0859ff2f94f6810ab9108002b27b3d9",
		DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
		UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
	};
	function parse_xls_props(cfb, props, o) {
		/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
		var DSI = CFB.find(cfb, '/!DocumentSummaryInformation');
		if(DSI && DSI.size > 0) try {
			var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
			for(var d in DocSummary) props[d] = DocSummary[d];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
		var SI = CFB.find(cfb, '/!SummaryInformation');
		if(SI && SI.size > 0) try {
			var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
			for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		if(props.HeadingPairs && props.TitlesOfParts) {
			load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
			delete props.HeadingPairs; delete props.TitlesOfParts;
		}
	}
	function write_xls_props(wb, cfb) {
		var DSEntries = [], SEntries = [], CEntries = [];
		var i = 0, Keys;
		var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
		var SummaryRE = evert_key(SummaryPIDSI, "n");
		if(wb.Props) {
			Keys = keys(wb.Props);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
		}
		if(wb.Custprops) {
			Keys = keys(wb.Custprops);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) if(!Object.prototype.hasOwnProperty.call((wb.Props||{}), Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
		}
		var CEntries2 = [];
		for(i = 0; i < CEntries.length; ++i) {
			if(XLSPSSkip.indexOf(CEntries[i][0]) > -1 || PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
			if(CEntries[i][1] == null) continue;
			CEntries2.push(CEntries[i]);
		}
		if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
		if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
	}
	
	function parse_xlscfb(cfb, options) {
	if(!options) options = {};
	fix_read_opts(options);
	reset_cp();
	if(options.codepage) set_ansi(options.codepage);
	var CompObj, WB;
	if(cfb.FullPaths) {
		if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
		CompObj = CFB.find(cfb, '!CompObj');
		WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
	} else {
		switch(options.type) {
			case 'base64': cfb = s2a(Base64_decode(cfb)); break;
			case 'binary': cfb = s2a(cfb); break;
			case 'buffer': break;
			case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
		}
		prep_blob(cfb, 0);
		WB = ({content: cfb});
	}
	var WorkbookP;
	
	var _data;
	if(CompObj) parse_compobj(CompObj);
	if(options.bookProps && !options.bookSheets) WorkbookP = ({});
	else {
		var T = has_buf ? 'buffer' : 'array';
		if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
		/* Quattro Pro 7-8 */
		else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Quattro Pro 9 */
		else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Works 4 for Mac */
		else if((_data=CFB.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
		else throw new Error("Cannot find Workbook stream");
		if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
	}
	
	var props = {};
	if(cfb.FullPaths) parse_xls_props(cfb, props, options);
	
	WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
	if(options.bookFiles) WorkbookP.cfb = cfb;
	/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
	return WorkbookP;
	}
	
	
	function write_xlscfb(wb, opts) {
		var o = opts || {};
		var cfb = CFB.utils.cfb_new({root:"R"});
		var wbpath = "/Workbook";
		switch(o.bookType || "xls") {
			case "xls": o.bookType = "biff8";
			/* falls through */
			case "xla": if(!o.bookType) o.bookType = "xla";
			/* falls through */
			case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
			case "biff5": wbpath = "/Book"; o.biff = 5; break;
			default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
		}
		CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
		if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
		// TODO: SI, DSI, CO
		if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
		return cfb;
	}
	/* [MS-XLSB] 2.3 Record Enumeration */
	var XLSBRecordEnum = {
	0x0000: { /* n:"BrtRowHdr", */ f:parse_BrtRowHdr },
	0x0001: { /* n:"BrtCellBlank", */ f:parse_BrtCellBlank },
	0x0002: { /* n:"BrtCellRk", */ f:parse_BrtCellRk },
	0x0003: { /* n:"BrtCellError", */ f:parse_BrtCellError },
	0x0004: { /* n:"BrtCellBool", */ f:parse_BrtCellBool },
	0x0005: { /* n:"BrtCellReal", */ f:parse_BrtCellReal },
	0x0006: { /* n:"BrtCellSt", */ f:parse_BrtCellSt },
	0x0007: { /* n:"BrtCellIsst", */ f:parse_BrtCellIsst },
	0x0008: { /* n:"BrtFmlaString", */ f:parse_BrtFmlaString },
	0x0009: { /* n:"BrtFmlaNum", */ f:parse_BrtFmlaNum },
	0x000A: { /* n:"BrtFmlaBool", */ f:parse_BrtFmlaBool },
	0x000B: { /* n:"BrtFmlaError", */ f:parse_BrtFmlaError },
	0x000C: { /* n:"BrtShortBlank", */ f:parse_BrtShortBlank },
	0x000D: { /* n:"BrtShortRk", */ f:parse_BrtShortRk },
	0x000E: { /* n:"BrtShortError", */ f:parse_BrtShortError },
	0x000F: { /* n:"BrtShortBool", */ f:parse_BrtShortBool },
	0x0010: { /* n:"BrtShortReal", */ f:parse_BrtShortReal },
	0x0011: { /* n:"BrtShortSt", */ f:parse_BrtShortSt },
	0x0012: { /* n:"BrtShortIsst", */ f:parse_BrtShortIsst },
	0x0013: { /* n:"BrtSSTItem", */ f:parse_RichStr },
	0x0014: { /* n:"BrtPCDIMissing" */ },
	0x0015: { /* n:"BrtPCDINumber" */ },
	0x0016: { /* n:"BrtPCDIBoolean" */ },
	0x0017: { /* n:"BrtPCDIError" */ },
	0x0018: { /* n:"BrtPCDIString" */ },
	0x0019: { /* n:"BrtPCDIDatetime" */ },
	0x001A: { /* n:"BrtPCDIIndex" */ },
	0x001B: { /* n:"BrtPCDIAMissing" */ },
	0x001C: { /* n:"BrtPCDIANumber" */ },
	0x001D: { /* n:"BrtPCDIABoolean" */ },
	0x001E: { /* n:"BrtPCDIAError" */ },
	0x001F: { /* n:"BrtPCDIAString" */ },
	0x0020: { /* n:"BrtPCDIADatetime" */ },
	0x0021: { /* n:"BrtPCRRecord" */ },
	0x0022: { /* n:"BrtPCRRecordDt" */ },
	0x0023: { /* n:"BrtFRTBegin", */ T:1 },
	0x0024: { /* n:"BrtFRTEnd", */ T:-1 },
	0x0025: { /* n:"BrtACBegin", */ T:1 },
	0x0026: { /* n:"BrtACEnd", */ T:-1 },
	0x0027: { /* n:"BrtName", */ f:parse_BrtName },
	0x0028: { /* n:"BrtIndexRowBlock" */ },
	0x002A: { /* n:"BrtIndexBlock" */ },
	0x002B: { /* n:"BrtFont", */ f:parse_BrtFont },
	0x002C: { /* n:"BrtFmt", */ f:parse_BrtFmt },
	0x002D: { /* n:"BrtFill", */ f:parse_BrtFill },
	0x002E: { /* n:"BrtBorder", */ f:parse_BrtBorder },
	0x002F: { /* n:"BrtXF", */ f:parse_BrtXF },
	0x0030: { /* n:"BrtStyle" */ },
	0x0031: { /* n:"BrtCellMeta", */ f:parse_Int32LE },
	0x0032: { /* n:"BrtValueMeta" */ },
	0x0033: { /* n:"BrtMdb" */ f:parse_BrtMdb },
	0x0034: { /* n:"BrtBeginFmd", */ T:1 },
	0x0035: { /* n:"BrtEndFmd", */ T:-1 },
	0x0036: { /* n:"BrtBeginMdx", */ T:1 },
	0x0037: { /* n:"BrtEndMdx", */ T:-1 },
	0x0038: { /* n:"BrtBeginMdxTuple", */ T:1 },
	0x0039: { /* n:"BrtEndMdxTuple", */ T:-1 },
	0x003A: { /* n:"BrtMdxMbrIstr" */ },
	0x003B: { /* n:"BrtStr" */ },
	0x003C: { /* n:"BrtColInfo", */ f:parse_ColInfo },
	0x003E: { /* n:"BrtCellRString", */ f:parse_BrtCellRString },
	0x003F: { /* n:"BrtCalcChainItem$", */ f:parse_BrtCalcChainItem$ },
	0x0040: { /* n:"BrtDVal", */ f:parse_BrtDVal },
	0x0041: { /* n:"BrtSxvcellNum" */ },
	0x0042: { /* n:"BrtSxvcellStr" */ },
	0x0043: { /* n:"BrtSxvcellBool" */ },
	0x0044: { /* n:"BrtSxvcellErr" */ },
	0x0045: { /* n:"BrtSxvcellDate" */ },
	0x0046: { /* n:"BrtSxvcellNil" */ },
	0x0080: { /* n:"BrtFileVersion" */ },
	0x0081: { /* n:"BrtBeginSheet", */ T:1 },
	0x0082: { /* n:"BrtEndSheet", */ T:-1 },
	0x0083: { /* n:"BrtBeginBook", */ T:1, f:parsenoop, p:0 },
	0x0084: { /* n:"BrtEndBook", */ T:-1 },
	0x0085: { /* n:"BrtBeginWsViews", */ T:1 },
	0x0086: { /* n:"BrtEndWsViews", */ T:-1 },
	0x0087: { /* n:"BrtBeginBookViews", */ T:1 },
	0x0088: { /* n:"BrtEndBookViews", */ T:-1 },
	0x0089: { /* n:"BrtBeginWsView", */ T:1, f:parse_BrtBeginWsView },
	0x008A: { /* n:"BrtEndWsView", */ T:-1 },
	0x008B: { /* n:"BrtBeginCsViews", */ T:1 },
	0x008C: { /* n:"BrtEndCsViews", */ T:-1 },
	0x008D: { /* n:"BrtBeginCsView", */ T:1 },
	0x008E: { /* n:"BrtEndCsView", */ T:-1 },
	0x008F: { /* n:"BrtBeginBundleShs", */ T:1 },
	0x0090: { /* n:"BrtEndBundleShs", */ T:-1 },
	0x0091: { /* n:"BrtBeginSheetData", */ T:1 },
	0x0092: { /* n:"BrtEndSheetData", */ T:-1 },
	0x0093: { /* n:"BrtWsProp", */ f:parse_BrtWsProp },
	0x0094: { /* n:"BrtWsDim", */ f:parse_BrtWsDim, p:16 },
	0x0097: { /* n:"BrtPane", */ f:parse_BrtPane },
	0x0098: { /* n:"BrtSel" */ },
	0x0099: { /* n:"BrtWbProp", */ f:parse_BrtWbProp },
	0x009A: { /* n:"BrtWbFactoid" */ },
	0x009B: { /* n:"BrtFileRecover" */ },
	0x009C: { /* n:"BrtBundleSh", */ f:parse_BrtBundleSh },
	0x009D: { /* n:"BrtCalcProp" */ },
	0x009E: { /* n:"BrtBookView" */ },
	0x009F: { /* n:"BrtBeginSst", */ T:1, f:parse_BrtBeginSst },
	0x00A0: { /* n:"BrtEndSst", */ T:-1 },
	0x00A1: { /* n:"BrtBeginAFilter", */ T:1, f:parse_UncheckedRfX },
	0x00A2: { /* n:"BrtEndAFilter", */ T:-1 },
	0x00A3: { /* n:"BrtBeginFilterColumn", */ T:1 },
	0x00A4: { /* n:"BrtEndFilterColumn", */ T:-1 },
	0x00A5: { /* n:"BrtBeginFilters", */ T:1 },
	0x00A6: { /* n:"BrtEndFilters", */ T:-1 },
	0x00A7: { /* n:"BrtFilter" */ },
	0x00A8: { /* n:"BrtColorFilter" */ },
	0x00A9: { /* n:"BrtIconFilter" */ },
	0x00AA: { /* n:"BrtTop10Filter" */ },
	0x00AB: { /* n:"BrtDynamicFilter" */ },
	0x00AC: { /* n:"BrtBeginCustomFilters", */ T:1 },
	0x00AD: { /* n:"BrtEndCustomFilters", */ T:-1 },
	0x00AE: { /* n:"BrtCustomFilter" */ },
	0x00AF: { /* n:"BrtAFilterDateGroupItem" */ },
	0x00B0: { /* n:"BrtMergeCell", */ f:parse_BrtMergeCell },
	0x00B1: { /* n:"BrtBeginMergeCells", */ T:1 },
	0x00B2: { /* n:"BrtEndMergeCells", */ T:-1 },
	0x00B3: { /* n:"BrtBeginPivotCacheDef", */ T:1 },
	0x00B4: { /* n:"BrtEndPivotCacheDef", */ T:-1 },
	0x00B5: { /* n:"BrtBeginPCDFields", */ T:1 },
	0x00B6: { /* n:"BrtEndPCDFields", */ T:-1 },
	0x00B7: { /* n:"BrtBeginPCDField", */ T:1 },
	0x00B8: { /* n:"BrtEndPCDField", */ T:-1 },
	0x00B9: { /* n:"BrtBeginPCDSource", */ T:1 },
	0x00BA: { /* n:"BrtEndPCDSource", */ T:-1 },
	0x00BB: { /* n:"BrtBeginPCDSRange", */ T:1 },
	0x00BC: { /* n:"BrtEndPCDSRange", */ T:-1 },
	0x00BD: { /* n:"BrtBeginPCDFAtbl", */ T:1 },
	0x00BE: { /* n:"BrtEndPCDFAtbl", */ T:-1 },
	0x00BF: { /* n:"BrtBeginPCDIRun", */ T:1 },
	0x00C0: { /* n:"BrtEndPCDIRun", */ T:-1 },
	0x00C1: { /* n:"BrtBeginPivotCacheRecords", */ T:1 },
	0x00C2: { /* n:"BrtEndPivotCacheRecords", */ T:-1 },
	0x00C3: { /* n:"BrtBeginPCDHierarchies", */ T:1 },
	0x00C4: { /* n:"BrtEndPCDHierarchies", */ T:-1 },
	0x00C5: { /* n:"BrtBeginPCDHierarchy", */ T:1 },
	0x00C6: { /* n:"BrtEndPCDHierarchy", */ T:-1 },
	0x00C7: { /* n:"BrtBeginPCDHFieldsUsage", */ T:1 },
	0x00C8: { /* n:"BrtEndPCDHFieldsUsage", */ T:-1 },
	0x00C9: { /* n:"BrtBeginExtConnection", */ T:1 },
	0x00CA: { /* n:"BrtEndExtConnection", */ T:-1 },
	0x00CB: { /* n:"BrtBeginECDbProps", */ T:1 },
	0x00CC: { /* n:"BrtEndECDbProps", */ T:-1 },
	0x00CD: { /* n:"BrtBeginECOlapProps", */ T:1 },
	0x00CE: { /* n:"BrtEndECOlapProps", */ T:-1 },
	0x00CF: { /* n:"BrtBeginPCDSConsol", */ T:1 },
	0x00D0: { /* n:"BrtEndPCDSConsol", */ T:-1 },
	0x00D1: { /* n:"BrtBeginPCDSCPages", */ T:1 },
	0x00D2: { /* n:"BrtEndPCDSCPages", */ T:-1 },
	0x00D3: { /* n:"BrtBeginPCDSCPage", */ T:1 },
	0x00D4: { /* n:"BrtEndPCDSCPage", */ T:-1 },
	0x00D5: { /* n:"BrtBeginPCDSCPItem", */ T:1 },
	0x00D6: { /* n:"BrtEndPCDSCPItem", */ T:-1 },
	0x00D7: { /* n:"BrtBeginPCDSCSets", */ T:1 },
	0x00D8: { /* n:"BrtEndPCDSCSets", */ T:-1 },
	0x00D9: { /* n:"BrtBeginPCDSCSet", */ T:1 },
	0x00DA: { /* n:"BrtEndPCDSCSet", */ T:-1 },
	0x00DB: { /* n:"BrtBeginPCDFGroup", */ T:1 },
	0x00DC: { /* n:"BrtEndPCDFGroup", */ T:-1 },
	0x00DD: { /* n:"BrtBeginPCDFGItems", */ T:1 },
	0x00DE: { /* n:"BrtEndPCDFGItems", */ T:-1 },
	0x00DF: { /* n:"BrtBeginPCDFGRange", */ T:1 },
	0x00E0: { /* n:"BrtEndPCDFGRange", */ T:-1 },
	0x00E1: { /* n:"BrtBeginPCDFGDiscrete", */ T:1 },
	0x00E2: { /* n:"BrtEndPCDFGDiscrete", */ T:-1 },
	0x00E3: { /* n:"BrtBeginPCDSDTupleCache", */ T:1 },
	0x00E4: { /* n:"BrtEndPCDSDTupleCache", */ T:-1 },
	0x00E5: { /* n:"BrtBeginPCDSDTCEntries", */ T:1 },
	0x00E6: { /* n:"BrtEndPCDSDTCEntries", */ T:-1 },
	0x00E7: { /* n:"BrtBeginPCDSDTCEMembers", */ T:1 },
	0x00E8: { /* n:"BrtEndPCDSDTCEMembers", */ T:-1 },
	0x00E9: { /* n:"BrtBeginPCDSDTCEMember", */ T:1 },
	0x00EA: { /* n:"BrtEndPCDSDTCEMember", */ T:-1 },
	0x00EB: { /* n:"BrtBeginPCDSDTCQueries", */ T:1 },
	0x00EC: { /* n:"BrtEndPCDSDTCQueries", */ T:-1 },
	0x00ED: { /* n:"BrtBeginPCDSDTCQuery", */ T:1 },
	0x00EE: { /* n:"BrtEndPCDSDTCQuery", */ T:-1 },
	0x00EF: { /* n:"BrtBeginPCDSDTCSets", */ T:1 },
	0x00F0: { /* n:"BrtEndPCDSDTCSets", */ T:-1 },
	0x00F1: { /* n:"BrtBeginPCDSDTCSet", */ T:1 },
	0x00F2: { /* n:"BrtEndPCDSDTCSet", */ T:-1 },
	0x00F3: { /* n:"BrtBeginPCDCalcItems", */ T:1 },
	0x00F4: { /* n:"BrtEndPCDCalcItems", */ T:-1 },
	0x00F5: { /* n:"BrtBeginPCDCalcItem", */ T:1 },
	0x00F6: { /* n:"BrtEndPCDCalcItem", */ T:-1 },
	0x00F7: { /* n:"BrtBeginPRule", */ T:1 },
	0x00F8: { /* n:"BrtEndPRule", */ T:-1 },
	0x00F9: { /* n:"BrtBeginPRFilters", */ T:1 },
	0x00FA: { /* n:"BrtEndPRFilters", */ T:-1 },
	0x00FB: { /* n:"BrtBeginPRFilter", */ T:1 },
	0x00FC: { /* n:"BrtEndPRFilter", */ T:-1 },
	0x00FD: { /* n:"BrtBeginPNames", */ T:1 },
	0x00FE: { /* n:"BrtEndPNames", */ T:-1 },
	0x00FF: { /* n:"BrtBeginPName", */ T:1 },
	0x0100: { /* n:"BrtEndPName", */ T:-1 },
	0x0101: { /* n:"BrtBeginPNPairs", */ T:1 },
	0x0102: { /* n:"BrtEndPNPairs", */ T:-1 },
	0x0103: { /* n:"BrtBeginPNPair", */ T:1 },
	0x0104: { /* n:"BrtEndPNPair", */ T:-1 },
	0x0105: { /* n:"BrtBeginECWebProps", */ T:1 },
	0x0106: { /* n:"BrtEndECWebProps", */ T:-1 },
	0x0107: { /* n:"BrtBeginEcWpTables", */ T:1 },
	0x0108: { /* n:"BrtEndECWPTables", */ T:-1 },
	0x0109: { /* n:"BrtBeginECParams", */ T:1 },
	0x010A: { /* n:"BrtEndECParams", */ T:-1 },
	0x010B: { /* n:"BrtBeginECParam", */ T:1 },
	0x010C: { /* n:"BrtEndECParam", */ T:-1 },
	0x010D: { /* n:"BrtBeginPCDKPIs", */ T:1 },
	0x010E: { /* n:"BrtEndPCDKPIs", */ T:-1 },
	0x010F: { /* n:"BrtBeginPCDKPI", */ T:1 },
	0x0110: { /* n:"BrtEndPCDKPI", */ T:-1 },
	0x0111: { /* n:"BrtBeginDims", */ T:1 },
	0x0112: { /* n:"BrtEndDims", */ T:-1 },
	0x0113: { /* n:"BrtBeginDim", */ T:1 },
	0x0114: { /* n:"BrtEndDim", */ T:-1 },
	0x0115: { /* n:"BrtIndexPartEnd" */ },
	0x0116: { /* n:"BrtBeginStyleSheet", */ T:1 },
	0x0117: { /* n:"BrtEndStyleSheet", */ T:-1 },
	0x0118: { /* n:"BrtBeginSXView", */ T:1 },
	0x0119: { /* n:"BrtEndSXVI", */ T:-1 },
	0x011A: { /* n:"BrtBeginSXVI", */ T:1 },
	0x011B: { /* n:"BrtBeginSXVIs", */ T:1 },
	0x011C: { /* n:"BrtEndSXVIs", */ T:-1 },
	0x011D: { /* n:"BrtBeginSXVD", */ T:1 },
	0x011E: { /* n:"BrtEndSXVD", */ T:-1 },
	0x011F: { /* n:"BrtBeginSXVDs", */ T:1 },
	0x0120: { /* n:"BrtEndSXVDs", */ T:-1 },
	0x0121: { /* n:"BrtBeginSXPI", */ T:1 },
	0x0122: { /* n:"BrtEndSXPI", */ T:-1 },
	0x0123: { /* n:"BrtBeginSXPIs", */ T:1 },
	0x0124: { /* n:"BrtEndSXPIs", */ T:-1 },
	0x0125: { /* n:"BrtBeginSXDI", */ T:1 },
	0x0126: { /* n:"BrtEndSXDI", */ T:-1 },
	0x0127: { /* n:"BrtBeginSXDIs", */ T:1 },
	0x0128: { /* n:"BrtEndSXDIs", */ T:-1 },
	0x0129: { /* n:"BrtBeginSXLI", */ T:1 },
	0x012A: { /* n:"BrtEndSXLI", */ T:-1 },
	0x012B: { /* n:"BrtBeginSXLIRws", */ T:1 },
	0x012C: { /* n:"BrtEndSXLIRws", */ T:-1 },
	0x012D: { /* n:"BrtBeginSXLICols", */ T:1 },
	0x012E: { /* n:"BrtEndSXLICols", */ T:-1 },
	0x012F: { /* n:"BrtBeginSXFormat", */ T:1 },
	0x0130: { /* n:"BrtEndSXFormat", */ T:-1 },
	0x0131: { /* n:"BrtBeginSXFormats", */ T:1 },
	0x0132: { /* n:"BrtEndSxFormats", */ T:-1 },
	0x0133: { /* n:"BrtBeginSxSelect", */ T:1 },
	0x0134: { /* n:"BrtEndSxSelect", */ T:-1 },
	0x0135: { /* n:"BrtBeginISXVDRws", */ T:1 },
	0x0136: { /* n:"BrtEndISXVDRws", */ T:-1 },
	0x0137: { /* n:"BrtBeginISXVDCols", */ T:1 },
	0x0138: { /* n:"BrtEndISXVDCols", */ T:-1 },
	0x0139: { /* n:"BrtEndSXLocation", */ T:-1 },
	0x013A: { /* n:"BrtBeginSXLocation", */ T:1 },
	0x013B: { /* n:"BrtEndSXView", */ T:-1 },
	0x013C: { /* n:"BrtBeginSXTHs", */ T:1 },
	0x013D: { /* n:"BrtEndSXTHs", */ T:-1 },
	0x013E: { /* n:"BrtBeginSXTH", */ T:1 },
	0x013F: { /* n:"BrtEndSXTH", */ T:-1 },
	0x0140: { /* n:"BrtBeginISXTHRws", */ T:1 },
	0x0141: { /* n:"BrtEndISXTHRws", */ T:-1 },
	0x0142: { /* n:"BrtBeginISXTHCols", */ T:1 },
	0x0143: { /* n:"BrtEndISXTHCols", */ T:-1 },
	0x0144: { /* n:"BrtBeginSXTDMPS", */ T:1 },
	0x0145: { /* n:"BrtEndSXTDMPs", */ T:-1 },
	0x0146: { /* n:"BrtBeginSXTDMP", */ T:1 },
	0x0147: { /* n:"BrtEndSXTDMP", */ T:-1 },
	0x0148: { /* n:"BrtBeginSXTHItems", */ T:1 },
	0x0149: { /* n:"BrtEndSXTHItems", */ T:-1 },
	0x014A: { /* n:"BrtBeginSXTHItem", */ T:1 },
	0x014B: { /* n:"BrtEndSXTHItem", */ T:-1 },
	0x014C: { /* n:"BrtBeginMetadata", */ T:1 },
	0x014D: { /* n:"BrtEndMetadata", */ T:-1 },
	0x014E: { /* n:"BrtBeginEsmdtinfo", */ T:1 },
	0x014F: { /* n:"BrtMdtinfo", */ f:parse_BrtMdtinfo },
	0x0150: { /* n:"BrtEndEsmdtinfo", */ T:-1 },
	0x0151: { /* n:"BrtBeginEsmdb", */ f:parse_BrtBeginEsmdb, T:1 },
	0x0152: { /* n:"BrtEndEsmdb", */ T:-1 },
	0x0153: { /* n:"BrtBeginEsfmd", */ T:1 },
	0x0154: { /* n:"BrtEndEsfmd", */ T:-1 },
	0x0155: { /* n:"BrtBeginSingleCells", */ T:1 },
	0x0156: { /* n:"BrtEndSingleCells", */ T:-1 },
	0x0157: { /* n:"BrtBeginList", */ T:1 },
	0x0158: { /* n:"BrtEndList", */ T:-1 },
	0x0159: { /* n:"BrtBeginListCols", */ T:1 },
	0x015A: { /* n:"BrtEndListCols", */ T:-1 },
	0x015B: { /* n:"BrtBeginListCol", */ T:1 },
	0x015C: { /* n:"BrtEndListCol", */ T:-1 },
	0x015D: { /* n:"BrtBeginListXmlCPr", */ T:1 },
	0x015E: { /* n:"BrtEndListXmlCPr", */ T:-1 },
	0x015F: { /* n:"BrtListCCFmla" */ },
	0x0160: { /* n:"BrtListTrFmla" */ },
	0x0161: { /* n:"BrtBeginExternals", */ T:1 },
	0x0162: { /* n:"BrtEndExternals", */ T:-1 },
	0x0163: { /* n:"BrtSupBookSrc", */ f:parse_RelID},
	0x0165: { /* n:"BrtSupSelf" */ },
	0x0166: { /* n:"BrtSupSame" */ },
	0x0167: { /* n:"BrtSupTabs" */ },
	0x0168: { /* n:"BrtBeginSupBook", */ T:1 },
	0x0169: { /* n:"BrtPlaceholderName" */ },
	0x016A: { /* n:"BrtExternSheet", */ f:parse_ExternSheet },
	0x016B: { /* n:"BrtExternTableStart" */ },
	0x016C: { /* n:"BrtExternTableEnd" */ },
	0x016E: { /* n:"BrtExternRowHdr" */ },
	0x016F: { /* n:"BrtExternCellBlank" */ },
	0x0170: { /* n:"BrtExternCellReal" */ },
	0x0171: { /* n:"BrtExternCellBool" */ },
	0x0172: { /* n:"BrtExternCellError" */ },
	0x0173: { /* n:"BrtExternCellString" */ },
	0x0174: { /* n:"BrtBeginEsmdx", */ T:1 },
	0x0175: { /* n:"BrtEndEsmdx", */ T:-1 },
	0x0176: { /* n:"BrtBeginMdxSet", */ T:1 },
	0x0177: { /* n:"BrtEndMdxSet", */ T:-1 },
	0x0178: { /* n:"BrtBeginMdxMbrProp", */ T:1 },
	0x0179: { /* n:"BrtEndMdxMbrProp", */ T:-1 },
	0x017A: { /* n:"BrtBeginMdxKPI", */ T:1 },
	0x017B: { /* n:"BrtEndMdxKPI", */ T:-1 },
	0x017C: { /* n:"BrtBeginEsstr", */ T:1 },
	0x017D: { /* n:"BrtEndEsstr", */ T:-1 },
	0x017E: { /* n:"BrtBeginPRFItem", */ T:1 },
	0x017F: { /* n:"BrtEndPRFItem", */ T:-1 },
	0x0180: { /* n:"BrtBeginPivotCacheIDs", */ T:1 },
	0x0181: { /* n:"BrtEndPivotCacheIDs", */ T:-1 },
	0x0182: { /* n:"BrtBeginPivotCacheID", */ T:1 },
	0x0183: { /* n:"BrtEndPivotCacheID", */ T:-1 },
	0x0184: { /* n:"BrtBeginISXVIs", */ T:1 },
	0x0185: { /* n:"BrtEndISXVIs", */ T:-1 },
	0x0186: { /* n:"BrtBeginColInfos", */ T:1 },
	0x0187: { /* n:"BrtEndColInfos", */ T:-1 },
	0x0188: { /* n:"BrtBeginRwBrk", */ T:1 },
	0x0189: { /* n:"BrtEndRwBrk", */ T:-1 },
	0x018A: { /* n:"BrtBeginColBrk", */ T:1 },
	0x018B: { /* n:"BrtEndColBrk", */ T:-1 },
	0x018C: { /* n:"BrtBrk" */ },
	0x018D: { /* n:"BrtUserBookView" */ },
	0x018E: { /* n:"BrtInfo" */ },
	0x018F: { /* n:"BrtCUsr" */ },
	0x0190: { /* n:"BrtUsr" */ },
	0x0191: { /* n:"BrtBeginUsers", */ T:1 },
	0x0193: { /* n:"BrtEOF" */ },
	0x0194: { /* n:"BrtUCR" */ },
	0x0195: { /* n:"BrtRRInsDel" */ },
	0x0196: { /* n:"BrtRREndInsDel" */ },
	0x0197: { /* n:"BrtRRMove" */ },
	0x0198: { /* n:"BrtRREndMove" */ },
	0x0199: { /* n:"BrtRRChgCell" */ },
	0x019A: { /* n:"BrtRREndChgCell" */ },
	0x019B: { /* n:"BrtRRHeader" */ },
	0x019C: { /* n:"BrtRRUserView" */ },
	0x019D: { /* n:"BrtRRRenSheet" */ },
	0x019E: { /* n:"BrtRRInsertSh" */ },
	0x019F: { /* n:"BrtRRDefName" */ },
	0x01A0: { /* n:"BrtRRNote" */ },
	0x01A1: { /* n:"BrtRRConflict" */ },
	0x01A2: { /* n:"BrtRRTQSIF" */ },
	0x01A3: { /* n:"BrtRRFormat" */ },
	0x01A4: { /* n:"BrtRREndFormat" */ },
	0x01A5: { /* n:"BrtRRAutoFmt" */ },
	0x01A6: { /* n:"BrtBeginUserShViews", */ T:1 },
	0x01A7: { /* n:"BrtBeginUserShView", */ T:1 },
	0x01A8: { /* n:"BrtEndUserShView", */ T:-1 },
	0x01A9: { /* n:"BrtEndUserShViews", */ T:-1 },
	0x01AA: { /* n:"BrtArrFmla", */ f:parse_BrtArrFmla },
	0x01AB: { /* n:"BrtShrFmla", */ f:parse_BrtShrFmla },
	0x01AC: { /* n:"BrtTable" */ },
	0x01AD: { /* n:"BrtBeginExtConnections", */ T:1 },
	0x01AE: { /* n:"BrtEndExtConnections", */ T:-1 },
	0x01AF: { /* n:"BrtBeginPCDCalcMems", */ T:1 },
	0x01B0: { /* n:"BrtEndPCDCalcMems", */ T:-1 },
	0x01B1: { /* n:"BrtBeginPCDCalcMem", */ T:1 },
	0x01B2: { /* n:"BrtEndPCDCalcMem", */ T:-1 },
	0x01B3: { /* n:"BrtBeginPCDHGLevels", */ T:1 },
	0x01B4: { /* n:"BrtEndPCDHGLevels", */ T:-1 },
	0x01B5: { /* n:"BrtBeginPCDHGLevel", */ T:1 },
	0x01B6: { /* n:"BrtEndPCDHGLevel", */ T:-1 },
	0x01B7: { /* n:"BrtBeginPCDHGLGroups", */ T:1 },
	0x01B8: { /* n:"BrtEndPCDHGLGroups", */ T:-1 },
	0x01B9: { /* n:"BrtBeginPCDHGLGroup", */ T:1 },
	0x01BA: { /* n:"BrtEndPCDHGLGroup", */ T:-1 },
	0x01BB: { /* n:"BrtBeginPCDHGLGMembers", */ T:1 },
	0x01BC: { /* n:"BrtEndPCDHGLGMembers", */ T:-1 },
	0x01BD: { /* n:"BrtBeginPCDHGLGMember", */ T:1 },
	0x01BE: { /* n:"BrtEndPCDHGLGMember", */ T:-1 },
	0x01BF: { /* n:"BrtBeginQSI", */ T:1 },
	0x01C0: { /* n:"BrtEndQSI", */ T:-1 },
	0x01C1: { /* n:"BrtBeginQSIR", */ T:1 },
	0x01C2: { /* n:"BrtEndQSIR", */ T:-1 },
	0x01C3: { /* n:"BrtBeginDeletedNames", */ T:1 },
	0x01C4: { /* n:"BrtEndDeletedNames", */ T:-1 },
	0x01C5: { /* n:"BrtBeginDeletedName", */ T:1 },
	0x01C6: { /* n:"BrtEndDeletedName", */ T:-1 },
	0x01C7: { /* n:"BrtBeginQSIFs", */ T:1 },
	0x01C8: { /* n:"BrtEndQSIFs", */ T:-1 },
	0x01C9: { /* n:"BrtBeginQSIF", */ T:1 },
	0x01CA: { /* n:"BrtEndQSIF", */ T:-1 },
	0x01CB: { /* n:"BrtBeginAutoSortScope", */ T:1 },
	0x01CC: { /* n:"BrtEndAutoSortScope", */ T:-1 },
	0x01CD: { /* n:"BrtBeginConditionalFormatting", */ T:1 },
	0x01CE: { /* n:"BrtEndConditionalFormatting", */ T:-1 },
	0x01CF: { /* n:"BrtBeginCFRule", */ T:1 },
	0x01D0: { /* n:"BrtEndCFRule", */ T:-1 },
	0x01D1: { /* n:"BrtBeginIconSet", */ T:1 },
	0x01D2: { /* n:"BrtEndIconSet", */ T:-1 },
	0x01D3: { /* n:"BrtBeginDatabar", */ T:1 },
	0x01D4: { /* n:"BrtEndDatabar", */ T:-1 },
	0x01D5: { /* n:"BrtBeginColorScale", */ T:1 },
	0x01D6: { /* n:"BrtEndColorScale", */ T:-1 },
	0x01D7: { /* n:"BrtCFVO" */ },
	0x01D8: { /* n:"BrtExternValueMeta" */ },
	0x01D9: { /* n:"BrtBeginColorPalette", */ T:1 },
	0x01DA: { /* n:"BrtEndColorPalette", */ T:-1 },
	0x01DB: { /* n:"BrtIndexedColor" */ },
	0x01DC: { /* n:"BrtMargins", */ f:parse_BrtMargins },
	0x01DD: { /* n:"BrtPrintOptions" */ },
	0x01DE: { /* n:"BrtPageSetup" */ },
	0x01DF: { /* n:"BrtBeginHeaderFooter", */ T:1 },
	0x01E0: { /* n:"BrtEndHeaderFooter", */ T:-1 },
	0x01E1: { /* n:"BrtBeginSXCrtFormat", */ T:1 },
	0x01E2: { /* n:"BrtEndSXCrtFormat", */ T:-1 },
	0x01E3: { /* n:"BrtBeginSXCrtFormats", */ T:1 },
	0x01E4: { /* n:"BrtEndSXCrtFormats", */ T:-1 },
	0x01E5: { /* n:"BrtWsFmtInfo", */ f:parse_BrtWsFmtInfo },
	0x01E6: { /* n:"BrtBeginMgs", */ T:1 },
	0x01E7: { /* n:"BrtEndMGs", */ T:-1 },
	0x01E8: { /* n:"BrtBeginMGMaps", */ T:1 },
	0x01E9: { /* n:"BrtEndMGMaps", */ T:-1 },
	0x01EA: { /* n:"BrtBeginMG", */ T:1 },
	0x01EB: { /* n:"BrtEndMG", */ T:-1 },
	0x01EC: { /* n:"BrtBeginMap", */ T:1 },
	0x01ED: { /* n:"BrtEndMap", */ T:-1 },
	0x01EE: { /* n:"BrtHLink", */ f:parse_BrtHLink },
	0x01EF: { /* n:"BrtBeginDCon", */ T:1 },
	0x01F0: { /* n:"BrtEndDCon", */ T:-1 },
	0x01F1: { /* n:"BrtBeginDRefs", */ T:1 },
	0x01F2: { /* n:"BrtEndDRefs", */ T:-1 },
	0x01F3: { /* n:"BrtDRef" */ },
	0x01F4: { /* n:"BrtBeginScenMan", */ T:1 },
	0x01F5: { /* n:"BrtEndScenMan", */ T:-1 },
	0x01F6: { /* n:"BrtBeginSct", */ T:1 },
	0x01F7: { /* n:"BrtEndSct", */ T:-1 },
	0x01F8: { /* n:"BrtSlc" */ },
	0x01F9: { /* n:"BrtBeginDXFs", */ T:1 },
	0x01FA: { /* n:"BrtEndDXFs", */ T:-1 },
	0x01FB: { /* n:"BrtDXF" */ },
	0x01FC: { /* n:"BrtBeginTableStyles", */ T:1 },
	0x01FD: { /* n:"BrtEndTableStyles", */ T:-1 },
	0x01FE: { /* n:"BrtBeginTableStyle", */ T:1 },
	0x01FF: { /* n:"BrtEndTableStyle", */ T:-1 },
	0x0200: { /* n:"BrtTableStyleElement" */ },
	0x0201: { /* n:"BrtTableStyleClient" */ },
	0x0202: { /* n:"BrtBeginVolDeps", */ T:1 },
	0x0203: { /* n:"BrtEndVolDeps", */ T:-1 },
	0x0204: { /* n:"BrtBeginVolType", */ T:1 },
	0x0205: { /* n:"BrtEndVolType", */ T:-1 },
	0x0206: { /* n:"BrtBeginVolMain", */ T:1 },
	0x0207: { /* n:"BrtEndVolMain", */ T:-1 },
	0x0208: { /* n:"BrtBeginVolTopic", */ T:1 },
	0x0209: { /* n:"BrtEndVolTopic", */ T:-1 },
	0x020A: { /* n:"BrtVolSubtopic" */ },
	0x020B: { /* n:"BrtVolRef" */ },
	0x020C: { /* n:"BrtVolNum" */ },
	0x020D: { /* n:"BrtVolErr" */ },
	0x020E: { /* n:"BrtVolStr" */ },
	0x020F: { /* n:"BrtVolBool" */ },
	0x0210: { /* n:"BrtBeginCalcChain$", */ T:1 },
	0x0211: { /* n:"BrtEndCalcChain$", */ T:-1 },
	0x0212: { /* n:"BrtBeginSortState", */ T:1 },
	0x0213: { /* n:"BrtEndSortState", */ T:-1 },
	0x0214: { /* n:"BrtBeginSortCond", */ T:1 },
	0x0215: { /* n:"BrtEndSortCond", */ T:-1 },
	0x0216: { /* n:"BrtBookProtection" */ },
	0x0217: { /* n:"BrtSheetProtection" */ },
	0x0218: { /* n:"BrtRangeProtection" */ },
	0x0219: { /* n:"BrtPhoneticInfo" */ },
	0x021A: { /* n:"BrtBeginECTxtWiz", */ T:1 },
	0x021B: { /* n:"BrtEndECTxtWiz", */ T:-1 },
	0x021C: { /* n:"BrtBeginECTWFldInfoLst", */ T:1 },
	0x021D: { /* n:"BrtEndECTWFldInfoLst", */ T:-1 },
	0x021E: { /* n:"BrtBeginECTwFldInfo", */ T:1 },
	0x0224: { /* n:"BrtFileSharing" */ },
	0x0225: { /* n:"BrtOleSize" */ },
	0x0226: { /* n:"BrtDrawing", */ f:parse_RelID },
	0x0227: { /* n:"BrtLegacyDrawing" */ },
	0x0228: { /* n:"BrtLegacyDrawingHF" */ },
	0x0229: { /* n:"BrtWebOpt" */ },
	0x022A: { /* n:"BrtBeginWebPubItems", */ T:1 },
	0x022B: { /* n:"BrtEndWebPubItems", */ T:-1 },
	0x022C: { /* n:"BrtBeginWebPubItem", */ T:1 },
	0x022D: { /* n:"BrtEndWebPubItem", */ T:-1 },
	0x022E: { /* n:"BrtBeginSXCondFmt", */ T:1 },
	0x022F: { /* n:"BrtEndSXCondFmt", */ T:-1 },
	0x0230: { /* n:"BrtBeginSXCondFmts", */ T:1 },
	0x0231: { /* n:"BrtEndSXCondFmts", */ T:-1 },
	0x0232: { /* n:"BrtBkHim" */ },
	0x0234: { /* n:"BrtColor" */ },
	0x0235: { /* n:"BrtBeginIndexedColors", */ T:1 },
	0x0236: { /* n:"BrtEndIndexedColors", */ T:-1 },
	0x0239: { /* n:"BrtBeginMRUColors", */ T:1 },
	0x023A: { /* n:"BrtEndMRUColors", */ T:-1 },
	0x023C: { /* n:"BrtMRUColor" */ },
	0x023D: { /* n:"BrtBeginDVals", */ T:1 },
	0x023E: { /* n:"BrtEndDVals", */ T:-1 },
	0x0241: { /* n:"BrtSupNameStart" */ },
	0x0242: { /* n:"BrtSupNameValueStart" */ },
	0x0243: { /* n:"BrtSupNameValueEnd" */ },
	0x0244: { /* n:"BrtSupNameNum" */ },
	0x0245: { /* n:"BrtSupNameErr" */ },
	0x0246: { /* n:"BrtSupNameSt" */ },
	0x0247: { /* n:"BrtSupNameNil" */ },
	0x0248: { /* n:"BrtSupNameBool" */ },
	0x0249: { /* n:"BrtSupNameFmla" */ },
	0x024A: { /* n:"BrtSupNameBits" */ },
	0x024B: { /* n:"BrtSupNameEnd" */ },
	0x024C: { /* n:"BrtEndSupBook", */ T:-1 },
	0x024D: { /* n:"BrtCellSmartTagProperty" */ },
	0x024E: { /* n:"BrtBeginCellSmartTag", */ T:1 },
	0x024F: { /* n:"BrtEndCellSmartTag", */ T:-1 },
	0x0250: { /* n:"BrtBeginCellSmartTags", */ T:1 },
	0x0251: { /* n:"BrtEndCellSmartTags", */ T:-1 },
	0x0252: { /* n:"BrtBeginSmartTags", */ T:1 },
	0x0253: { /* n:"BrtEndSmartTags", */ T:-1 },
	0x0254: { /* n:"BrtSmartTagType" */ },
	0x0255: { /* n:"BrtBeginSmartTagTypes", */ T:1 },
	0x0256: { /* n:"BrtEndSmartTagTypes", */ T:-1 },
	0x0257: { /* n:"BrtBeginSXFilters", */ T:1 },
	0x0258: { /* n:"BrtEndSXFilters", */ T:-1 },
	0x0259: { /* n:"BrtBeginSXFILTER", */ T:1 },
	0x025A: { /* n:"BrtEndSXFilter", */ T:-1 },
	0x025B: { /* n:"BrtBeginFills", */ T:1 },
	0x025C: { /* n:"BrtEndFills", */ T:-1 },
	0x025D: { /* n:"BrtBeginCellWatches", */ T:1 },
	0x025E: { /* n:"BrtEndCellWatches", */ T:-1 },
	0x025F: { /* n:"BrtCellWatch" */ },
	0x0260: { /* n:"BrtBeginCRErrs", */ T:1 },
	0x0261: { /* n:"BrtEndCRErrs", */ T:-1 },
	0x0262: { /* n:"BrtCrashRecErr" */ },
	0x0263: { /* n:"BrtBeginFonts", */ T:1 },
	0x0264: { /* n:"BrtEndFonts", */ T:-1 },
	0x0265: { /* n:"BrtBeginBorders", */ T:1 },
	0x0266: { /* n:"BrtEndBorders", */ T:-1 },
	0x0267: { /* n:"BrtBeginFmts", */ T:1 },
	0x0268: { /* n:"BrtEndFmts", */ T:-1 },
	0x0269: { /* n:"BrtBeginCellXFs", */ T:1 },
	0x026A: { /* n:"BrtEndCellXFs", */ T:-1 },
	0x026B: { /* n:"BrtBeginStyles", */ T:1 },
	0x026C: { /* n:"BrtEndStyles", */ T:-1 },
	0x0271: { /* n:"BrtBigName" */ },
	0x0272: { /* n:"BrtBeginCellStyleXFs", */ T:1 },
	0x0273: { /* n:"BrtEndCellStyleXFs", */ T:-1 },
	0x0274: { /* n:"BrtBeginComments", */ T:1 },
	0x0275: { /* n:"BrtEndComments", */ T:-1 },
	0x0276: { /* n:"BrtBeginCommentAuthors", */ T:1 },
	0x0277: { /* n:"BrtEndCommentAuthors", */ T:-1 },
	0x0278: { /* n:"BrtCommentAuthor", */ f:parse_BrtCommentAuthor },
	0x0279: { /* n:"BrtBeginCommentList", */ T:1 },
	0x027A: { /* n:"BrtEndCommentList", */ T:-1 },
	0x027B: { /* n:"BrtBeginComment", */ T:1, f:parse_BrtBeginComment},
	0x027C: { /* n:"BrtEndComment", */ T:-1 },
	0x027D: { /* n:"BrtCommentText", */ f:parse_BrtCommentText },
	0x027E: { /* n:"BrtBeginOleObjects", */ T:1 },
	0x027F: { /* n:"BrtOleObject" */ },
	0x0280: { /* n:"BrtEndOleObjects", */ T:-1 },
	0x0281: { /* n:"BrtBeginSxrules", */ T:1 },
	0x0282: { /* n:"BrtEndSxRules", */ T:-1 },
	0x0283: { /* n:"BrtBeginActiveXControls", */ T:1 },
	0x0284: { /* n:"BrtActiveX" */ },
	0x0285: { /* n:"BrtEndActiveXControls", */ T:-1 },
	0x0286: { /* n:"BrtBeginPCDSDTCEMembersSortBy", */ T:1 },
	0x0288: { /* n:"BrtBeginCellIgnoreECs", */ T:1 },
	0x0289: { /* n:"BrtCellIgnoreEC" */ },
	0x028A: { /* n:"BrtEndCellIgnoreECs", */ T:-1 },
	0x028B: { /* n:"BrtCsProp", */ f:parse_BrtCsProp },
	0x028C: { /* n:"BrtCsPageSetup" */ },
	0x028D: { /* n:"BrtBeginUserCsViews", */ T:1 },
	0x028E: { /* n:"BrtEndUserCsViews", */ T:-1 },
	0x028F: { /* n:"BrtBeginUserCsView", */ T:1 },
	0x0290: { /* n:"BrtEndUserCsView", */ T:-1 },
	0x0291: { /* n:"BrtBeginPcdSFCIEntries", */ T:1 },
	0x0292: { /* n:"BrtEndPCDSFCIEntries", */ T:-1 },
	0x0293: { /* n:"BrtPCDSFCIEntry" */ },
	0x0294: { /* n:"BrtBeginListParts", */ T:1 },
	0x0295: { /* n:"BrtListPart" */ },
	0x0296: { /* n:"BrtEndListParts", */ T:-1 },
	0x0297: { /* n:"BrtSheetCalcProp" */ },
	0x0298: { /* n:"BrtBeginFnGroup", */ T:1 },
	0x0299: { /* n:"BrtFnGroup" */ },
	0x029A: { /* n:"BrtEndFnGroup", */ T:-1 },
	0x029B: { /* n:"BrtSupAddin" */ },
	0x029C: { /* n:"BrtSXTDMPOrder" */ },
	0x029D: { /* n:"BrtCsProtection" */ },
	0x029F: { /* n:"BrtBeginWsSortMap", */ T:1 },
	0x02A0: { /* n:"BrtEndWsSortMap", */ T:-1 },
	0x02A1: { /* n:"BrtBeginRRSort", */ T:1 },
	0x02A2: { /* n:"BrtEndRRSort", */ T:-1 },
	0x02A3: { /* n:"BrtRRSortItem" */ },
	0x02A4: { /* n:"BrtFileSharingIso" */ },
	0x02A5: { /* n:"BrtBookProtectionIso" */ },
	0x02A6: { /* n:"BrtSheetProtectionIso" */ },
	0x02A7: { /* n:"BrtCsProtectionIso" */ },
	0x02A8: { /* n:"BrtRangeProtectionIso" */ },
	0x02A9: { /* n:"BrtDValList" */ },
	0x0400: { /* n:"BrtRwDescent" */ },
	0x0401: { /* n:"BrtKnownFonts" */ },
	0x0402: { /* n:"BrtBeginSXTupleSet", */ T:1 },
	0x0403: { /* n:"BrtEndSXTupleSet", */ T:-1 },
	0x0404: { /* n:"BrtBeginSXTupleSetHeader", */ T:1 },
	0x0405: { /* n:"BrtEndSXTupleSetHeader", */ T:-1 },
	0x0406: { /* n:"BrtSXTupleSetHeaderItem" */ },
	0x0407: { /* n:"BrtBeginSXTupleSetData", */ T:1 },
	0x0408: { /* n:"BrtEndSXTupleSetData", */ T:-1 },
	0x0409: { /* n:"BrtBeginSXTupleSetRow", */ T:1 },
	0x040A: { /* n:"BrtEndSXTupleSetRow", */ T:-1 },
	0x040B: { /* n:"BrtSXTupleSetRowItem" */ },
	0x040C: { /* n:"BrtNameExt" */ },
	0x040D: { /* n:"BrtPCDH14" */ },
	0x040E: { /* n:"BrtBeginPCDCalcMem14", */ T:1 },
	0x040F: { /* n:"BrtEndPCDCalcMem14", */ T:-1 },
	0x0410: { /* n:"BrtSXTH14" */ },
	0x0411: { /* n:"BrtBeginSparklineGroup", */ T:1 },
	0x0412: { /* n:"BrtEndSparklineGroup", */ T:-1 },
	0x0413: { /* n:"BrtSparkline" */ },
	0x0414: { /* n:"BrtSXDI14" */ },
	0x0415: { /* n:"BrtWsFmtInfoEx14" */ },
	0x0416: { /* n:"BrtBeginConditionalFormatting14", */ T:1 },
	0x0417: { /* n:"BrtEndConditionalFormatting14", */ T:-1 },
	0x0418: { /* n:"BrtBeginCFRule14", */ T:1 },
	0x0419: { /* n:"BrtEndCFRule14", */ T:-1 },
	0x041A: { /* n:"BrtCFVO14" */ },
	0x041B: { /* n:"BrtBeginDatabar14", */ T:1 },
	0x041C: { /* n:"BrtBeginIconSet14", */ T:1 },
	0x041D: { /* n:"BrtDVal14", */ f: parse_BrtDVal14 },
	0x041E: { /* n:"BrtBeginDVals14", */ T:1 },
	0x041F: { /* n:"BrtColor14" */ },
	0x0420: { /* n:"BrtBeginSparklines", */ T:1 },
	0x0421: { /* n:"BrtEndSparklines", */ T:-1 },
	0x0422: { /* n:"BrtBeginSparklineGroups", */ T:1 },
	0x0423: { /* n:"BrtEndSparklineGroups", */ T:-1 },
	0x0425: { /* n:"BrtSXVD14" */ },
	0x0426: { /* n:"BrtBeginSXView14", */ T:1 },
	0x0427: { /* n:"BrtEndSXView14", */ T:-1 },
	0x0428: { /* n:"BrtBeginSXView16", */ T:1 },
	0x0429: { /* n:"BrtEndSXView16", */ T:-1 },
	0x042A: { /* n:"BrtBeginPCD14", */ T:1 },
	0x042B: { /* n:"BrtEndPCD14", */ T:-1 },
	0x042C: { /* n:"BrtBeginExtConn14", */ T:1 },
	0x042D: { /* n:"BrtEndExtConn14", */ T:-1 },
	0x042E: { /* n:"BrtBeginSlicerCacheIDs", */ T:1 },
	0x042F: { /* n:"BrtEndSlicerCacheIDs", */ T:-1 },
	0x0430: { /* n:"BrtBeginSlicerCacheID", */ T:1 },
	0x0431: { /* n:"BrtEndSlicerCacheID", */ T:-1 },
	0x0433: { /* n:"BrtBeginSlicerCache", */ T:1 },
	0x0434: { /* n:"BrtEndSlicerCache", */ T:-1 },
	0x0435: { /* n:"BrtBeginSlicerCacheDef", */ T:1 },
	0x0436: { /* n:"BrtEndSlicerCacheDef", */ T:-1 },
	0x0437: { /* n:"BrtBeginSlicersEx", */ T:1 },
	0x0438: { /* n:"BrtEndSlicersEx", */ T:-1 },
	0x0439: { /* n:"BrtBeginSlicerEx", */ T:1 },
	0x043A: { /* n:"BrtEndSlicerEx", */ T:-1 },
	0x043B: { /* n:"BrtBeginSlicer", */ T:1 },
	0x043C: { /* n:"BrtEndSlicer", */ T:-1 },
	0x043D: { /* n:"BrtSlicerCachePivotTables" */ },
	0x043E: { /* n:"BrtBeginSlicerCacheOlapImpl", */ T:1 },
	0x043F: { /* n:"BrtEndSlicerCacheOlapImpl", */ T:-1 },
	0x0440: { /* n:"BrtBeginSlicerCacheLevelsData", */ T:1 },
	0x0441: { /* n:"BrtEndSlicerCacheLevelsData", */ T:-1 },
	0x0442: { /* n:"BrtBeginSlicerCacheLevelData", */ T:1 },
	0x0443: { /* n:"BrtEndSlicerCacheLevelData", */ T:-1 },
	0x0444: { /* n:"BrtBeginSlicerCacheSiRanges", */ T:1 },
	0x0445: { /* n:"BrtEndSlicerCacheSiRanges", */ T:-1 },
	0x0446: { /* n:"BrtBeginSlicerCacheSiRange", */ T:1 },
	0x0447: { /* n:"BrtEndSlicerCacheSiRange", */ T:-1 },
	0x0448: { /* n:"BrtSlicerCacheOlapItem" */ },
	0x0449: { /* n:"BrtBeginSlicerCacheSelections", */ T:1 },
	0x044A: { /* n:"BrtSlicerCacheSelection" */ },
	0x044B: { /* n:"BrtEndSlicerCacheSelections", */ T:-1 },
	0x044C: { /* n:"BrtBeginSlicerCacheNative", */ T:1 },
	0x044D: { /* n:"BrtEndSlicerCacheNative", */ T:-1 },
	0x044E: { /* n:"BrtSlicerCacheNativeItem" */ },
	0x044F: { /* n:"BrtRangeProtection14" */ },
	0x0450: { /* n:"BrtRangeProtectionIso14" */ },
	0x0451: { /* n:"BrtCellIgnoreEC14" */ },
	0x0457: { /* n:"BrtList14" */ },
	0x0458: { /* n:"BrtCFIcon" */ },
	0x0459: { /* n:"BrtBeginSlicerCachesPivotCacheIDs", */ T:1 },
	0x045A: { /* n:"BrtEndSlicerCachesPivotCacheIDs", */ T:-1 },
	0x045B: { /* n:"BrtBeginSlicers", */ T:1 },
	0x045C: { /* n:"BrtEndSlicers", */ T:-1 },
	0x045D: { /* n:"BrtWbProp14" */ },
	0x045E: { /* n:"BrtBeginSXEdit", */ T:1 },
	0x045F: { /* n:"BrtEndSXEdit", */ T:-1 },
	0x0460: { /* n:"BrtBeginSXEdits", */ T:1 },
	0x0461: { /* n:"BrtEndSXEdits", */ T:-1 },
	0x0462: { /* n:"BrtBeginSXChange", */ T:1 },
	0x0463: { /* n:"BrtEndSXChange", */ T:-1 },
	0x0464: { /* n:"BrtBeginSXChanges", */ T:1 },
	0x0465: { /* n:"BrtEndSXChanges", */ T:-1 },
	0x0466: { /* n:"BrtSXTupleItems" */ },
	0x0468: { /* n:"BrtBeginSlicerStyle", */ T:1 },
	0x0469: { /* n:"BrtEndSlicerStyle", */ T:-1 },
	0x046A: { /* n:"BrtSlicerStyleElement" */ },
	0x046B: { /* n:"BrtBeginStyleSheetExt14", */ T:1 },
	0x046C: { /* n:"BrtEndStyleSheetExt14", */ T:-1 },
	0x046D: { /* n:"BrtBeginSlicerCachesPivotCacheID", */ T:1 },
	0x046E: { /* n:"BrtEndSlicerCachesPivotCacheID", */ T:-1 },
	0x046F: { /* n:"BrtBeginConditionalFormattings", */ T:1 },
	0x0470: { /* n:"BrtEndConditionalFormattings", */ T:-1 },
	0x0471: { /* n:"BrtBeginPCDCalcMemExt", */ T:1 },
	0x0472: { /* n:"BrtEndPCDCalcMemExt", */ T:-1 },
	0x0473: { /* n:"BrtBeginPCDCalcMemsExt", */ T:1 },
	0x0474: { /* n:"BrtEndPCDCalcMemsExt", */ T:-1 },
	0x0475: { /* n:"BrtPCDField14" */ },
	0x0476: { /* n:"BrtBeginSlicerStyles", */ T:1 },
	0x0477: { /* n:"BrtEndSlicerStyles", */ T:-1 },
	0x0478: { /* n:"BrtBeginSlicerStyleElements", */ T:1 },
	0x0479: { /* n:"BrtEndSlicerStyleElements", */ T:-1 },
	0x047A: { /* n:"BrtCFRuleExt" */ },
	0x047B: { /* n:"BrtBeginSXCondFmt14", */ T:1 },
	0x047C: { /* n:"BrtEndSXCondFmt14", */ T:-1 },
	0x047D: { /* n:"BrtBeginSXCondFmts14", */ T:1 },
	0x047E: { /* n:"BrtEndSXCondFmts14", */ T:-1 },
	0x0480: { /* n:"BrtBeginSortCond14", */ T:1 },
	0x0481: { /* n:"BrtEndSortCond14", */ T:-1 },
	0x0482: { /* n:"BrtEndDVals14", */ T:-1 },
	0x0483: { /* n:"BrtEndIconSet14", */ T:-1 },
	0x0484: { /* n:"BrtEndDatabar14", */ T:-1 },
	0x0485: { /* n:"BrtBeginColorScale14", */ T:1 },
	0x0486: { /* n:"BrtEndColorScale14", */ T:-1 },
	0x0487: { /* n:"BrtBeginSxrules14", */ T:1 },
	0x0488: { /* n:"BrtEndSxrules14", */ T:-1 },
	0x0489: { /* n:"BrtBeginPRule14", */ T:1 },
	0x048A: { /* n:"BrtEndPRule14", */ T:-1 },
	0x048B: { /* n:"BrtBeginPRFilters14", */ T:1 },
	0x048C: { /* n:"BrtEndPRFilters14", */ T:-1 },
	0x048D: { /* n:"BrtBeginPRFilter14", */ T:1 },
	0x048E: { /* n:"BrtEndPRFilter14", */ T:-1 },
	0x048F: { /* n:"BrtBeginPRFItem14", */ T:1 },
	0x0490: { /* n:"BrtEndPRFItem14", */ T:-1 },
	0x0491: { /* n:"BrtBeginCellIgnoreECs14", */ T:1 },
	0x0492: { /* n:"BrtEndCellIgnoreECs14", */ T:-1 },
	0x0493: { /* n:"BrtDxf14" */ },
	0x0494: { /* n:"BrtBeginDxF14s", */ T:1 },
	0x0495: { /* n:"BrtEndDxf14s", */ T:-1 },
	0x0499: { /* n:"BrtFilter14" */ },
	0x049A: { /* n:"BrtBeginCustomFilters14", */ T:1 },
	0x049C: { /* n:"BrtCustomFilter14" */ },
	0x049D: { /* n:"BrtIconFilter14" */ },
	0x049E: { /* n:"BrtPivotCacheConnectionName" */ },
	0x0800: { /* n:"BrtBeginDecoupledPivotCacheIDs", */ T:1 },
	0x0801: { /* n:"BrtEndDecoupledPivotCacheIDs", */ T:-1 },
	0x0802: { /* n:"BrtDecoupledPivotCacheID" */ },
	0x0803: { /* n:"BrtBeginPivotTableRefs", */ T:1 },
	0x0804: { /* n:"BrtEndPivotTableRefs", */ T:-1 },
	0x0805: { /* n:"BrtPivotTableRef" */ },
	0x0806: { /* n:"BrtSlicerCacheBookPivotTables" */ },
	0x0807: { /* n:"BrtBeginSxvcells", */ T:1 },
	0x0808: { /* n:"BrtEndSxvcells", */ T:-1 },
	0x0809: { /* n:"BrtBeginSxRow", */ T:1 },
	0x080A: { /* n:"BrtEndSxRow", */ T:-1 },
	0x080C: { /* n:"BrtPcdCalcMem15" */ },
	0x0813: { /* n:"BrtQsi15" */ },
	0x0814: { /* n:"BrtBeginWebExtensions", */ T:1 },
	0x0815: { /* n:"BrtEndWebExtensions", */ T:-1 },
	0x0816: { /* n:"BrtWebExtension" */ },
	0x0817: { /* n:"BrtAbsPath15" */ },
	0x0818: { /* n:"BrtBeginPivotTableUISettings", */ T:1 },
	0x0819: { /* n:"BrtEndPivotTableUISettings", */ T:-1 },
	0x081B: { /* n:"BrtTableSlicerCacheIDs" */ },
	0x081C: { /* n:"BrtTableSlicerCacheID" */ },
	0x081D: { /* n:"BrtBeginTableSlicerCache", */ T:1 },
	0x081E: { /* n:"BrtEndTableSlicerCache", */ T:-1 },
	0x081F: { /* n:"BrtSxFilter15" */ },
	0x0820: { /* n:"BrtBeginTimelineCachePivotCacheIDs", */ T:1 },
	0x0821: { /* n:"BrtEndTimelineCachePivotCacheIDs", */ T:-1 },
	0x0822: { /* n:"BrtTimelineCachePivotCacheID" */ },
	0x0823: { /* n:"BrtBeginTimelineCacheIDs", */ T:1 },
	0x0824: { /* n:"BrtEndTimelineCacheIDs", */ T:-1 },
	0x0825: { /* n:"BrtBeginTimelineCacheID", */ T:1 },
	0x0826: { /* n:"BrtEndTimelineCacheID", */ T:-1 },
	0x0827: { /* n:"BrtBeginTimelinesEx", */ T:1 },
	0x0828: { /* n:"BrtEndTimelinesEx", */ T:-1 },
	0x0829: { /* n:"BrtBeginTimelineEx", */ T:1 },
	0x082A: { /* n:"BrtEndTimelineEx", */ T:-1 },
	0x082B: { /* n:"BrtWorkBookPr15" */ },
	0x082C: { /* n:"BrtPCDH15" */ },
	0x082D: { /* n:"BrtBeginTimelineStyle", */ T:1 },
	0x082E: { /* n:"BrtEndTimelineStyle", */ T:-1 },
	0x082F: { /* n:"BrtTimelineStyleElement" */ },
	0x0830: { /* n:"BrtBeginTimelineStylesheetExt15", */ T:1 },
	0x0831: { /* n:"BrtEndTimelineStylesheetExt15", */ T:-1 },
	0x0832: { /* n:"BrtBeginTimelineStyles", */ T:1 },
	0x0833: { /* n:"BrtEndTimelineStyles", */ T:-1 },
	0x0834: { /* n:"BrtBeginTimelineStyleElements", */ T:1 },
	0x0835: { /* n:"BrtEndTimelineStyleElements", */ T:-1 },
	0x0836: { /* n:"BrtDxf15" */ },
	0x0837: { /* n:"BrtBeginDxfs15", */ T:1 },
	0x0838: { /* n:"BrtEndDxfs15", */ T:-1 },
	0x0839: { /* n:"BrtSlicerCacheHideItemsWithNoData" */ },
	0x083A: { /* n:"BrtBeginItemUniqueNames", */ T:1 },
	0x083B: { /* n:"BrtEndItemUniqueNames", */ T:-1 },
	0x083C: { /* n:"BrtItemUniqueName" */ },
	0x083D: { /* n:"BrtBeginExtConn15", */ T:1 },
	0x083E: { /* n:"BrtEndExtConn15", */ T:-1 },
	0x083F: { /* n:"BrtBeginOledbPr15", */ T:1 },
	0x0840: { /* n:"BrtEndOledbPr15", */ T:-1 },
	0x0841: { /* n:"BrtBeginDataFeedPr15", */ T:1 },
	0x0842: { /* n:"BrtEndDataFeedPr15", */ T:-1 },
	0x0843: { /* n:"BrtTextPr15" */ },
	0x0844: { /* n:"BrtRangePr15" */ },
	0x0845: { /* n:"BrtDbCommand15" */ },
	0x0846: { /* n:"BrtBeginDbTables15", */ T:1 },
	0x0847: { /* n:"BrtEndDbTables15", */ T:-1 },
	0x0848: { /* n:"BrtDbTable15" */ },
	0x0849: { /* n:"BrtBeginDataModel", */ T:1 },
	0x084A: { /* n:"BrtEndDataModel", */ T:-1 },
	0x084B: { /* n:"BrtBeginModelTables", */ T:1 },
	0x084C: { /* n:"BrtEndModelTables", */ T:-1 },
	0x084D: { /* n:"BrtModelTable" */ },
	0x084E: { /* n:"BrtBeginModelRelationships", */ T:1 },
	0x084F: { /* n:"BrtEndModelRelationships", */ T:-1 },
	0x0850: { /* n:"BrtModelRelationship" */ },
	0x0851: { /* n:"BrtBeginECTxtWiz15", */ T:1 },
	0x0852: { /* n:"BrtEndECTxtWiz15", */ T:-1 },
	0x0853: { /* n:"BrtBeginECTWFldInfoLst15", */ T:1 },
	0x0854: { /* n:"BrtEndECTWFldInfoLst15", */ T:-1 },
	0x0855: { /* n:"BrtBeginECTWFldInfo15", */ T:1 },
	0x0856: { /* n:"BrtFieldListActiveItem" */ },
	0x0857: { /* n:"BrtPivotCacheIdVersion" */ },
	0x0858: { /* n:"BrtSXDI15" */ },
	0x0859: { /* n:"BrtBeginModelTimeGroupings", */ T:1 },
	0x085A: { /* n:"BrtEndModelTimeGroupings", */ T:-1 },
	0x085B: { /* n:"BrtBeginModelTimeGrouping", */ T:1 },
	0x085C: { /* n:"BrtEndModelTimeGrouping", */ T:-1 },
	0x085D: { /* n:"BrtModelTimeGroupingCalcCol" */ },
	0x0C00: { /* n:"BrtUid" */ },
	0x0C01: { /* n:"BrtRevisionPtr" */ },
	0x1000: { /* n:"BrtBeginDynamicArrayPr", */ T:1 },
	0x1001: { /* n:"BrtEndDynamicArrayPr", */ T:-1 },
	0x138A: { /* n:"BrtBeginRichValueBlock", */ T:1 },
	0x138B: { /* n:"BrtEndRichValueBlock", */ T:-1 },
	0x13D9: { /* n:"BrtBeginRichFilters", */ T:1 },
	0x13DA: { /* n:"BrtEndRichFilters", */ T:-1 },
	0x13DB: { /* n:"BrtRichFilter" */ },
	0x13DC: { /* n:"BrtBeginRichFilterColumn", */ T:1 },
	0x13DD: { /* n:"BrtEndRichFilterColumn", */ T:-1 },
	0x13DE: { /* n:"BrtBeginCustomRichFilters", */ T:1 },
	0x13DF: { /* n:"BrtEndCustomRichFilters", */ T:-1 },
	0x13E0: { /* n:"BrtCustomRichFilter" */ },
	0x13E1: { /* n:"BrtTop10RichFilter" */ },
	0x13E2: { /* n:"BrtDynamicRichFilter" */ },
	0x13E4: { /* n:"BrtBeginRichSortCondition", */ T:1 },
	0x13E5: { /* n:"BrtEndRichSortCondition", */ T:-1 },
	0x13E6: { /* n:"BrtRichFilterDateGroupItem" */ },
	0x13E7: { /* n:"BrtBeginCalcFeatures", */ T:1 },
	0x13E8: { /* n:"BrtEndCalcFeatures", */ T:-1 },
	0x13E9: { /* n:"BrtCalcFeature" */ },
	0x13EB: { /* n:"BrtExternalLinksPr" */ },
	0xFFFF: { n:"" }
	};
	
	/* [MS-XLS] 2.3 Record Enumeration (and other sources) */
	var XLSRecordEnum = {
		/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
	0x0006: { /* n:"Formula", */ f:parse_Formula },
	0x000a: { /* n:"EOF", */ f:parsenoop2 },
	0x000c: { /* n:"CalcCount", */ f:parseuint16 }, //
	0x000d: { /* n:"CalcMode", */ f:parseuint16 }, //
	0x000e: { /* n:"CalcPrecision", */ f:parsebool }, //
	0x000f: { /* n:"CalcRefMode", */ f:parsebool }, //
	0x0010: { /* n:"CalcDelta", */ f:parse_Xnum }, //
	0x0011: { /* n:"CalcIter", */ f:parsebool }, //
	0x0012: { /* n:"Protect", */ f:parsebool },
	0x0013: { /* n:"Password", */ f:parseuint16 },
	0x0014: { /* n:"Header", */ f:parse_XLHeaderFooter },
	0x0015: { /* n:"Footer", */ f:parse_XLHeaderFooter },
	0x0017: { /* n:"ExternSheet", */ f:parse_ExternSheet },
	0x0018: { /* n:"Lbl", */ f:parse_Lbl },
	0x0019: { /* n:"WinProtect", */ f:parsebool },
	0x001a: { /* n:"VerticalPageBreaks", */ },
	0x001b: { /* n:"HorizontalPageBreaks", */ },
	0x001c: { /* n:"Note", */ f:parse_Note },
	0x001d: { /* n:"Selection", */ },
	0x0022: { /* n:"Date1904", */ f:parsebool },
	0x0023: { /* n:"ExternName", */ f:parse_ExternName },
	0x0026: { /* n:"LeftMargin", */ f:parse_Xnum }, // *
	0x0027: { /* n:"RightMargin", */ f:parse_Xnum }, // *
	0x0028: { /* n:"TopMargin", */ f:parse_Xnum }, // *
	0x0029: { /* n:"BottomMargin", */ f:parse_Xnum }, // *
	0x002a: { /* n:"PrintRowCol", */ f:parsebool },
	0x002b: { /* n:"PrintGrid", */ f:parsebool },
	0x002f: { /* n:"FilePass", */ f:parse_FilePass },
	0x0031: { /* n:"Font", */ f:parse_Font },
	0x0033: { /* n:"PrintSize", */ f:parseuint16 },
	0x003c: { /* n:"Continue", */ },
	0x003d: { /* n:"Window1", */ f:parse_Window1 },
	0x0040: { /* n:"Backup", */ f:parsebool },
	0x0041: { /* n:"Pane", */ f:parse_Pane },
	0x0042: { /* n:"CodePage", */ f:parseuint16 },
	0x004d: { /* n:"Pls", */ },
	0x0050: { /* n:"DCon", */ },
	0x0051: { /* n:"DConRef", */ },
	0x0052: { /* n:"DConName", */ },
	0x0055: { /* n:"DefColWidth", */ f:parseuint16 },
	0x0059: { /* n:"XCT", */ },
	0x005a: { /* n:"CRN", */ },
	0x005b: { /* n:"FileSharing", */ },
	0x005c: { /* n:"WriteAccess", */ f:parse_WriteAccess },
	0x005d: { /* n:"Obj", */ f:parse_Obj },
	0x005e: { /* n:"Uncalced", */ },
	0x005f: { /* n:"CalcSaveRecalc", */ f:parsebool }, //
	0x0060: { /* n:"Template", */ },
	0x0061: { /* n:"Intl", */ },
	0x0063: { /* n:"ObjProtect", */ f:parsebool },
	0x007d: { /* n:"ColInfo", */ f:parse_ColInfo },
	0x0080: { /* n:"Guts", */ f:parse_Guts },
	0x0081: { /* n:"WsBool", */ f:parse_WsBool },
	0x0082: { /* n:"GridSet", */ f:parseuint16 },
	0x0083: { /* n:"HCenter", */ f:parsebool },
	0x0084: { /* n:"VCenter", */ f:parsebool },
	0x0085: { /* n:"BoundSheet8", */ f:parse_BoundSheet8 },
	0x0086: { /* n:"WriteProtect", */ },
	0x008c: { /* n:"Country", */ f:parse_Country },
	0x008d: { /* n:"HideObj", */ f:parseuint16 },
	0x0090: { /* n:"Sort", */ },
	0x0092: { /* n:"Palette", */ f:parse_Palette },
	0x0097: { /* n:"Sync", */ },
	0x0098: { /* n:"LPr", */ },
	0x0099: { /* n:"DxGCol", */ },
	0x009a: { /* n:"FnGroupName", */ },
	0x009b: { /* n:"FilterMode", */ },
	0x009c: { /* n:"BuiltInFnGroupCount", */ f:parseuint16 },
	0x009d: { /* n:"AutoFilterInfo", */ },
	0x009e: { /* n:"AutoFilter", */ },
	0x00a0: { /* n:"Scl", */ f:parse_Scl },
	0x00a1: { /* n:"Setup", */ f:parse_Setup },
	0x00ae: { /* n:"ScenMan", */ },
	0x00af: { /* n:"SCENARIO", */ },
	0x00b0: { /* n:"SxView", */ },
	0x00b1: { /* n:"Sxvd", */ },
	0x00b2: { /* n:"SXVI", */ },
	0x00b4: { /* n:"SxIvd", */ },
	0x00b5: { /* n:"SXLI", */ },
	0x00b6: { /* n:"SXPI", */ },
	0x00b8: { /* n:"DocRoute", */ },
	0x00b9: { /* n:"RecipName", */ },
	0x00bd: { /* n:"MulRk", */ f:parse_MulRk },
	0x00be: { /* n:"MulBlank", */ f:parse_MulBlank },
	0x00c1: { /* n:"Mms", */ f:parsenoop2 },
	0x00c5: { /* n:"SXDI", */ },
	0x00c6: { /* n:"SXDB", */ },
	0x00c7: { /* n:"SXFDB", */ },
	0x00c8: { /* n:"SXDBB", */ },
	0x00c9: { /* n:"SXNum", */ },
	0x00ca: { /* n:"SxBool", */ f:parsebool },
	0x00cb: { /* n:"SxErr", */ },
	0x00cc: { /* n:"SXInt", */ },
	0x00cd: { /* n:"SXString", */ },
	0x00ce: { /* n:"SXDtr", */ },
	0x00cf: { /* n:"SxNil", */ },
	0x00d0: { /* n:"SXTbl", */ },
	0x00d1: { /* n:"SXTBRGIITM", */ },
	0x00d2: { /* n:"SxTbpg", */ },
	0x00d3: { /* n:"ObProj", */ },
	0x00d5: { /* n:"SXStreamID", */ },
	0x00d7: { /* n:"DBCell", */ },
	0x00d8: { /* n:"SXRng", */ },
	0x00d9: { /* n:"SxIsxoper", */ },
	0x00da: { /* n:"BookBool", */ f:parseuint16 },
	0x00dc: { /* n:"DbOrParamQry", */ },
	0x00dd: { /* n:"ScenarioProtect", */ f:parsebool },
	0x00de: { /* n:"OleObjectSize", */ },
	0x00e0: { /* n:"XF", */ f:parse_XF },
	0x00e1: { /* n:"InterfaceHdr", */ f:parse_InterfaceHdr },
	0x00e2: { /* n:"InterfaceEnd", */ f:parsenoop2 },
	0x00e3: { /* n:"SXVS", */ },
	0x00e5: { /* n:"MergeCells", */ f:parse_MergeCells },
	0x00e9: { /* n:"BkHim", */ },
	0x00eb: { /* n:"MsoDrawingGroup", */ },
	0x00ec: { /* n:"MsoDrawing", */ },
	0x00ed: { /* n:"MsoDrawingSelection", */ },
	0x00ef: { /* n:"PhoneticInfo", */ },
	0x00f0: { /* n:"SxRule", */ },
	0x00f1: { /* n:"SXEx", */ },
	0x00f2: { /* n:"SxFilt", */ },
	0x00f4: { /* n:"SxDXF", */ },
	0x00f5: { /* n:"SxItm", */ },
	0x00f6: { /* n:"SxName", */ },
	0x00f7: { /* n:"SxSelect", */ },
	0x00f8: { /* n:"SXPair", */ },
	0x00f9: { /* n:"SxFmla", */ },
	0x00fb: { /* n:"SxFormat", */ },
	0x00fc: { /* n:"SST", */ f:parse_SST },
	0x00fd: { /* n:"LabelSst", */ f:parse_LabelSst },
	0x00ff: { /* n:"ExtSST", */ f:parse_ExtSST },
	0x0100: { /* n:"SXVDEx", */ },
	0x0103: { /* n:"SXFormula", */ },
	0x0122: { /* n:"SXDBEx", */ },
	0x0137: { /* n:"RRDInsDel", */ },
	0x0138: { /* n:"RRDHead", */ },
	0x013b: { /* n:"RRDChgCell", */ },
	0x013d: { /* n:"RRTabId", */ f:parseuint16a },
	0x013e: { /* n:"RRDRenSheet", */ },
	0x013f: { /* n:"RRSort", */ },
	0x0140: { /* n:"RRDMove", */ },
	0x014a: { /* n:"RRFormat", */ },
	0x014b: { /* n:"RRAutoFmt", */ },
	0x014d: { /* n:"RRInsertSh", */ },
	0x014e: { /* n:"RRDMoveBegin", */ },
	0x014f: { /* n:"RRDMoveEnd", */ },
	0x0150: { /* n:"RRDInsDelBegin", */ },
	0x0151: { /* n:"RRDInsDelEnd", */ },
	0x0152: { /* n:"RRDConflict", */ },
	0x0153: { /* n:"RRDDefName", */ },
	0x0154: { /* n:"RRDRstEtxp", */ },
	0x015f: { /* n:"LRng", */ },
	0x0160: { /* n:"UsesELFs", */ f:parsebool },
	0x0161: { /* n:"DSF", */ f:parsenoop2 },
	0x0191: { /* n:"CUsr", */ },
	0x0192: { /* n:"CbUsr", */ },
	0x0193: { /* n:"UsrInfo", */ },
	0x0194: { /* n:"UsrExcl", */ },
	0x0195: { /* n:"FileLock", */ },
	0x0196: { /* n:"RRDInfo", */ },
	0x0197: { /* n:"BCUsrs", */ },
	0x0198: { /* n:"UsrChk", */ },
	0x01a9: { /* n:"UserBView", */ },
	0x01aa: { /* n:"UserSViewBegin", */ },
	0x01ab: { /* n:"UserSViewEnd", */ },
	0x01ac: { /* n:"RRDUserView", */ },
	0x01ad: { /* n:"Qsi", */ },
	0x01ae: { /* n:"SupBook", */ f:parse_SupBook },
	0x01af: { /* n:"Prot4Rev", */ f:parsebool },
	0x01b0: { /* n:"CondFmt", */ },
	0x01b1: { /* n:"CF", */ },
	0x01b2: { /* n:"DVal", */ },
	0x01b5: { /* n:"DConBin", */ },
	0x01b6: { /* n:"TxO", */ f:parse_TxO },
	0x01b7: { /* n:"RefreshAll", */ f:parsebool }, //
	0x01b8: { /* n:"HLink", */ f:parse_HLink },
	0x01b9: { /* n:"Lel", */ },
	0x01ba: { /* n:"CodeName", */ f:parse_XLUnicodeString },
	0x01bb: { /* n:"SXFDBType", */ },
	0x01bc: { /* n:"Prot4RevPass", */ f:parseuint16 },
	0x01bd: { /* n:"ObNoMacros", */ },
	0x01be: { /* n:"Dv", */ },
	0x01c0: { /* n:"Excel9File", */ f:parsenoop2 },
	0x01c1: { /* n:"RecalcId", */ f:parse_RecalcId, r:2},
	0x01c2: { /* n:"EntExU2", */ f:parsenoop2 },
	0x0200: { /* n:"Dimensions", */ f:parse_Dimensions },
	0x0201: { /* n:"Blank", */ f:parse_Blank },
	0x0203: { /* n:"Number", */ f:parse_Number },
	0x0204: { /* n:"Label", */ f:parse_Label },
	0x0205: { /* n:"BoolErr", */ f:parse_BoolErr },
	0x0207: { /* n:"String", */ f:parse_String },
	0x0208: { /* n:"Row", */ f:parse_Row },
	0x020b: { /* n:"Index", */ },
	0x0221: { /* n:"Array", */ f:parse_Array },
	0x0225: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
	0x0236: { /* n:"Table", */ },
	0x023e: { /* n:"Window2", */ f:parse_Window2 },
	0x027e: { /* n:"RK", */ f:parse_RK },
	0x0293: { /* n:"Style", */ },
	0x0418: { /* n:"BigName", */ },
	0x041e: { /* n:"Format", */ f:parse_Format },
	0x043c: { /* n:"ContinueBigName", */ },
	0x04bc: { /* n:"ShrFmla", */ f:parse_ShrFmla },
	0x0800: { /* n:"HLinkTooltip", */ f:parse_HLinkTooltip },
	0x0801: { /* n:"WebPub", */ },
	0x0802: { /* n:"QsiSXTag", */ },
	0x0803: { /* n:"DBQueryExt", */ },
	0x0804: { /* n:"ExtString", */ },
	0x0805: { /* n:"TxtQry", */ },
	0x0806: { /* n:"Qsir", */ },
	0x0807: { /* n:"Qsif", */ },
	0x0808: { /* n:"RRDTQSIF", */ },
	0x0809: { /* n:"BOF", */ f:parse_BOF },
	0x080a: { /* n:"OleDbConn", */ },
	0x080b: { /* n:"WOpt", */ },
	0x080c: { /* n:"SXViewEx", */ },
	0x080d: { /* n:"SXTH", */ },
	0x080e: { /* n:"SXPIEx", */ },
	0x080f: { /* n:"SXVDTEx", */ },
	0x0810: { /* n:"SXViewEx9", */ },
	0x0812: { /* n:"ContinueFrt", */ },
	0x0813: { /* n:"RealTimeData", */ },
	0x0850: { /* n:"ChartFrtInfo", */ },
	0x0851: { /* n:"FrtWrapper", */ },
	0x0852: { /* n:"StartBlock", */ },
	0x0853: { /* n:"EndBlock", */ },
	0x0854: { /* n:"StartObject", */ },
	0x0855: { /* n:"EndObject", */ },
	0x0856: { /* n:"CatLab", */ },
	0x0857: { /* n:"YMult", */ },
	0x0858: { /* n:"SXViewLink", */ },
	0x0859: { /* n:"PivotChartBits", */ },
	0x085a: { /* n:"FrtFontList", */ },
	0x0862: { /* n:"SheetExt", */ },
	0x0863: { /* n:"BookExt", */ r:12},
	0x0864: { /* n:"SXAddl", */ },
	0x0865: { /* n:"CrErr", */ },
	0x0866: { /* n:"HFPicture", */ },
	0x0867: { /* n:"FeatHdr", */ f:parsenoop2 },
	0x0868: { /* n:"Feat", */ },
	0x086a: { /* n:"DataLabExt", */ },
	0x086b: { /* n:"DataLabExtContents", */ },
	0x086c: { /* n:"CellWatch", */ },
	0x0871: { /* n:"FeatHdr11", */ },
	0x0872: { /* n:"Feature11", */ },
	0x0874: { /* n:"DropDownObjIds", */ },
	0x0875: { /* n:"ContinueFrt11", */ },
	0x0876: { /* n:"DConn", */ },
	0x0877: { /* n:"List12", */ },
	0x0878: { /* n:"Feature12", */ },
	0x0879: { /* n:"CondFmt12", */ },
	0x087a: { /* n:"CF12", */ },
	0x087b: { /* n:"CFEx", */ },
	0x087c: { /* n:"XFCRC", */ f:parse_XFCRC, r:12 },
	0x087d: { /* n:"XFExt", */ f:parse_XFExt, r:12 },
	0x087e: { /* n:"AutoFilter12", */ },
	0x087f: { /* n:"ContinueFrt12", */ },
	0x0884: { /* n:"MDTInfo", */ },
	0x0885: { /* n:"MDXStr", */ },
	0x0886: { /* n:"MDXTuple", */ },
	0x0887: { /* n:"MDXSet", */ },
	0x0888: { /* n:"MDXProp", */ },
	0x0889: { /* n:"MDXKPI", */ },
	0x088a: { /* n:"MDB", */ },
	0x088b: { /* n:"PLV", */ },
	0x088c: { /* n:"Compat12", */ f:parsebool, r:12 },
	0x088d: { /* n:"DXF", */ },
	0x088e: { /* n:"TableStyles", */ r:12 },
	0x088f: { /* n:"TableStyle", */ },
	0x0890: { /* n:"TableStyleElement", */ },
	0x0892: { /* n:"StyleExt", */ },
	0x0893: { /* n:"NamePublish", */ },
	0x0894: { /* n:"NameCmt", */ f:parse_NameCmt, r:12 },
	0x0895: { /* n:"SortData", */ },
	0x0896: { /* n:"Theme", */ f:parse_Theme, r:12 },
	0x0897: { /* n:"GUIDTypeLib", */ },
	0x0898: { /* n:"FnGrp12", */ },
	0x0899: { /* n:"NameFnGrp12", */ },
	0x089a: { /* n:"MTRSettings", */ f:parse_MTRSettings, r:12 },
	0x089b: { /* n:"CompressPictures", */ f:parsenoop2 },
	0x089c: { /* n:"HeaderFooter", */ },
	0x089d: { /* n:"CrtLayout12", */ },
	0x089e: { /* n:"CrtMlFrt", */ },
	0x089f: { /* n:"CrtMlFrtContinue", */ },
	0x08a3: { /* n:"ForceFullCalculation", */ f:parse_ForceFullCalculation },
	0x08a4: { /* n:"ShapePropsStream", */ },
	0x08a5: { /* n:"TextPropsStream", */ },
	0x08a6: { /* n:"RichTextStream", */ },
	0x08a7: { /* n:"CrtLayout12A", */ },
	0x1001: { /* n:"Units", */ },
	0x1002: { /* n:"Chart", */ },
	0x1003: { /* n:"Series", */ },
	0x1006: { /* n:"DataFormat", */ },
	0x1007: { /* n:"LineFormat", */ },
	0x1009: { /* n:"MarkerFormat", */ },
	0x100a: { /* n:"AreaFormat", */ },
	0x100b: { /* n:"PieFormat", */ },
	0x100c: { /* n:"AttachedLabel", */ },
	0x100d: { /* n:"SeriesText", */ },
	0x1014: { /* n:"ChartFormat", */ },
	0x1015: { /* n:"Legend", */ },
	0x1016: { /* n:"SeriesList", */ },
	0x1017: { /* n:"Bar", */ },
	0x1018: { /* n:"Line", */ },
	0x1019: { /* n:"Pie", */ },
	0x101a: { /* n:"Area", */ },
	0x101b: { /* n:"Scatter", */ },
	0x101c: { /* n:"CrtLine", */ },
	0x101d: { /* n:"Axis", */ },
	0x101e: { /* n:"Tick", */ },
	0x101f: { /* n:"ValueRange", */ },
	0x1020: { /* n:"CatSerRange", */ },
	0x1021: { /* n:"AxisLine", */ },
	0x1022: { /* n:"CrtLink", */ },
	0x1024: { /* n:"DefaultText", */ },
	0x1025: { /* n:"Text", */ },
	0x1026: { /* n:"FontX", */ f:parseuint16 },
	0x1027: { /* n:"ObjectLink", */ },
	0x1032: { /* n:"Frame", */ },
	0x1033: { /* n:"Begin", */ },
	0x1034: { /* n:"End", */ },
	0x1035: { /* n:"PlotArea", */ },
	0x103a: { /* n:"Chart3d", */ },
	0x103c: { /* n:"PicF", */ },
	0x103d: { /* n:"DropBar", */ },
	0x103e: { /* n:"Radar", */ },
	0x103f: { /* n:"Surf", */ },
	0x1040: { /* n:"RadarArea", */ },
	0x1041: { /* n:"AxisParent", */ },
	0x1043: { /* n:"LegendException", */ },
	0x1044: { /* n:"ShtProps", */ f:parse_ShtProps },
	0x1045: { /* n:"SerToCrt", */ },
	0x1046: { /* n:"AxesUsed", */ },
	0x1048: { /* n:"SBaseRef", */ },
	0x104a: { /* n:"SerParent", */ },
	0x104b: { /* n:"SerAuxTrend", */ },
	0x104e: { /* n:"IFmtRecord", */ },
	0x104f: { /* n:"Pos", */ },
	0x1050: { /* n:"AlRuns", */ },
	0x1051: { /* n:"BRAI", */ },
	0x105b: { /* n:"SerAuxErrBar", */ },
	0x105c: { /* n:"ClrtClient", */ f:parse_ClrtClient },
	0x105d: { /* n:"SerFmt", */ },
	0x105f: { /* n:"Chart3DBarShape", */ },
	0x1060: { /* n:"Fbi", */ },
	0x1061: { /* n:"BopPop", */ },
	0x1062: { /* n:"AxcExt", */ },
	0x1063: { /* n:"Dat", */ },
	0x1064: { /* n:"PlotGrowth", */ },
	0x1065: { /* n:"SIIndex", */ },
	0x1066: { /* n:"GelFrame", */ },
	0x1067: { /* n:"BopPopCustom", */ },
	0x1068: { /* n:"Fbi2", */ },
	
	0x0000: { /* n:"Dimensions", */ f:parse_Dimensions },
	0x0001: { /* n:"BIFF2BLANK", */ },
	0x0002: { /* n:"BIFF2INT", */ f:parse_BIFF2INT },
	0x0003: { /* n:"BIFF2NUM", */ f:parse_BIFF2NUM },
	0x0004: { /* n:"BIFF2STR", */ f:parse_BIFF2STR },
	0x0005: { /* n:"BoolErr", */ f:parse_BoolErr },
	0x0007: { /* n:"String", */ f:parse_BIFF2STRING },
	0x0008: { /* n:"BIFF2ROW", */ },
	0x0009: { /* n:"BOF", */ f:parse_BOF },
	0x000b: { /* n:"Index", */ },
	0x0016: { /* n:"ExternCount", */ f:parseuint16 },
	0x001e: { /* n:"BIFF2FORMAT", */ f:parse_BIFF2Format },
	0x001f: { /* n:"BIFF2FMTCNT", */ }, /* 16-bit cnt of BIFF2FORMAT records */
	0x0020: { /* n:"BIFF2COLINFO", */ },
	0x0021: { /* n:"Array", */ f:parse_Array },
	0x0024: { /* n:"COLWIDTH", */ },
	0x0025: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
		// 0x2c ??
		// 0x2d ??
		// 0x2e ??
		// 0x30 FONTCOUNT: number of fonts
	0x0032: { /* n:"BIFF2FONTXTRA", */ f:parse_BIFF2FONTXTRA },
		// 0x35: INFOOPTS
		// 0x36: TABLE (BIFF2 only)
		// 0x37: TABLE2 (BIFF2 only)
		// 0x38: WNDESK
		// 0x39 ??
		// 0x3a: BEGINPREF
		// 0x3b: ENDPREF
	0x003e: { /* n:"BIFF2WINDOW2", */ },
		// 0x3f ??
		// 0x46: SHOWSCROLL
		// 0x47: SHOWFORMULA
		// 0x48: STATUSBAR
		// 0x49: SHORTMENUS
		// 0x4A:
		// 0x4B:
		// 0x4C:
		// 0x4E:
		// 0x4F:
		// 0x58: TOOLBAR (BIFF3)
	
		/* - - - */
	0x0034: { /* n:"DDEObjName", */ },
	0x0043: { /* n:"BIFF2XF", */ },
	0x0044: { /* n:"BIFF2XFINDEX", */ f:parseuint16 },
	0x0045: { /* n:"BIFF2FONTCLR", */ },
	0x0056: { /* n:"BIFF4FMTCNT", */ }, /* 16-bit cnt, similar to BIFF2 */
	0x007e: { /* n:"RK", */ }, /* Not necessarily same as 0x027e */
	0x007f: { /* n:"ImData", */ f:parse_ImData },
	0x0087: { /* n:"Addin", */ },
	0x0088: { /* n:"Edg", */ },
	0x0089: { /* n:"Pub", */ },
		// 0x8A
		// 0x8B LH: alternate menu key flag (BIFF3/4)
		// 0x8E
		// 0x8F
	0x0091: { /* n:"Sub", */ },
		// 0x93 STYLE
	0x0094: { /* n:"LHRecord", */ },
	0x0095: { /* n:"LHNGraph", */ },
	0x0096: { /* n:"Sound", */ },
		// 0xA2 FNPROTO: function prototypes (BIFF4)
		// 0xA3
		// 0xA8
	0x00a9: { /* n:"CoordList", */ },
	0x00ab: { /* n:"GCW", */ },
	0x00bc: { /* n:"ShrFmla", */ }, /* Not necessarily same as 0x04bc */
	0x00bf: { /* n:"ToolbarHdr", */ },
	0x00c0: { /* n:"ToolbarEnd", */ },
	0x00c2: { /* n:"AddMenu", */ },
	0x00c3: { /* n:"DelMenu", */ },
	0x00d6: { /* n:"RString", */ f:parse_RString },
	0x00df: { /* n:"UDDesc", */ },
	0x00ea: { /* n:"TabIdConf", */ },
	0x0162: { /* n:"XL5Modify", */ },
	0x01a5: { /* n:"FileSharing2", */ },
	0x0206: { /* n:"Formula", */ f:parse_Formula },
	0x0209: { /* n:"BOF", */ f:parse_BOF },
	0x0218: { /* n:"Lbl", */ f:parse_Lbl },
	0x0223: { /* n:"ExternName", */ f:parse_ExternName },
	0x0231: { /* n:"Font", */ },
	0x0243: { /* n:"BIFF3XF", */ },
	0x0406: { /* n:"Formula", */ f:parse_Formula },
	0x0409: { /* n:"BOF", */ f:parse_BOF },
	0x0443: { /* n:"BIFF4XF", */ },
	0x086d: { /* n:"FeatInfo", */ },
	0x0873: { /* n:"FeatInfo11", */ },
	0x0881: { /* n:"SXAddl12", */ },
	0x08c0: { /* n:"AutoWebPub", */ },
	0x08c1: { /* n:"ListObj", */ },
	0x08c2: { /* n:"ListField", */ },
	0x08c3: { /* n:"ListDV", */ },
	0x08c4: { /* n:"ListCondFmt", */ },
	0x08c5: { /* n:"ListCF", */ },
	0x08c6: { /* n:"FMQry", */ },
	0x08c7: { /* n:"FMSQry", */ },
	0x08c8: { /* n:"PLV", */ },
	0x08c9: { /* n:"LnExt", */ },
	0x08ca: { /* n:"MkrExt", */ },
	0x08cb: { /* n:"CrtCoopt", */ },
	0x08d6: { /* n:"FRTArchId$", */ r:12 },
	
	0x7262: {}
	};
	
	function write_biff_rec(ba, type, payload, length) {
		var t = type;
		if(isNaN(t)) return;
		var len = length || (payload||[]).length || 0;
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, len);
		if(len > 0 && is_buf(payload)) ba.push(payload);
	}
	
	function write_biff_continue(ba, type, payload, length) {
		var len = length || (payload||[]).length || 0;
		if(len <= 8224) return write_biff_rec(ba, type, payload, len);
		var t = type;
		if(isNaN(t)) return;
		var parts = payload.parts || [], sidx = 0;
		var i = 0, w = 0;
		while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, w);
		ba.push(payload.slice(i, i + w));
		i += w;
		while(i < len) {
			o = ba.next(4);
			o.write_shift(2, 0x3c); // TODO: figure out correct continue type
			w = 0;
			while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
			o.write_shift(2, w);
			ba.push(payload.slice(i, i+w)); i+= w;
		}
	}
	
	function write_BIFF2Cell(out, r, c) {
		if(!out) out = new_buf(7);
		out.write_shift(2, r);
		out.write_shift(2, c);
		out.write_shift(2, 0);
		out.write_shift(1, 0);
		return out;
	}
	
	function write_BIFF2BERR(r, c, val, t) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		write_Bes(val, t || 'b', out);
		return out;
	}
	
	/* TODO: codepage, large strings */
	function write_BIFF2LABEL(r, c, val) {
		var out = new_buf(8 + 2*val.length);
		write_BIFF2Cell(out, r, c);
		out.write_shift(1, val.length);
		out.write_shift(val.length, val, 'sbcs');
		return out.l < out.length ? out.slice(0, out.l) : out;
	}
	
	function write_ws_biff2_cell(ba, cell, R, C) {
		if(cell.v != null) switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				if((v == (v|0)) && (v >= 0) && (v < 65536))
					write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
				else
					write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
				return;
			case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
			/* TODO: codepage, sst */
			case 's': case 'str':
				write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, (cell.v||"").slice(0,255)));
				return;
		}
		write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
	}
	
	function write_ws_biff2(ba, ws, idx, opts) {
		var dense = Array.isArray(ws);
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, 0x3FFF);
			ref = encode_range(range);
		}
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff2_cell(ba, cell, R, C, opts);
			}
		}
	}
	
	/* Based on test files */
	function write_biff2_buf(wb, opts) {
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ba = buf_array();
		var idx = 0;
		for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
		if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
		write_biff_rec(ba, (o.biff == 4 ? 0x0409 : (o.biff == 3 ? 0x0209 : 0x0009)), write_BOF(wb, 0x10, o));
		/* ... */
		write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
		/* ... */
		write_biff_rec(ba, 0x000A);
		return ba.end();
	}
	
	function write_FONTS_biff8(ba, data, opts) {
		write_biff_rec(ba, 0x0031 /* Font */, write_Font({
			sz:12,
			color: {theme:1},
			name: "Arial",
			family: 2,
			scheme: "minor"
		}, opts));
	}
	
	
	function write_FMTS_biff8(ba, NF, opts) {
		if(!NF) return;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, 0x041E /* Format */, write_Format(i, NF[i], opts));
		});
	}
	
	function write_FEAT(ba, ws) {
		/* [MS-XLS] 2.4.112 */
		var o = new_buf(19);
		o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
		write_biff_rec(ba, 0x0867 /* FeatHdr */, o);
		/* [MS-XLS] 2.4.111 */
		o = new_buf(39);
		o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
		o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
		write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
		o.write_shift(4, 4);
		write_biff_rec(ba, 0x0868 /* Feat */, o);
	}
	
	function write_CELLXFS_biff8(ba, opts) {
		for(var i = 0; i < 16; ++i) write_biff_rec(ba, 0x00e0 /* XF */, write_XF({numFmtId:0, style:true}, 0, opts));
		opts.cellXfs.forEach(function(c) {
			write_biff_rec(ba, 0x00e0 /* XF */, write_XF(c, 0, opts));
		});
	}
	
	function write_ws_biff8_hlinks(ba, ws) {
		for(var R=0; R<ws['!links'].length; ++R) {
			var HL = ws['!links'][R];
			write_biff_rec(ba, 0x01b8 /* HLink */, write_HLink(HL));
			if(HL[1].Tooltip) write_biff_rec(ba, 0x0800 /* HLinkTooltip */, write_HLinkTooltip(HL));
		}
		delete ws['!links'];
	}
	
	function write_ws_cols_biff8(ba, cols) {
		if(!cols) return;
		var cnt = 0;
		cols.forEach(function(col, idx) {
			if(++cnt <= 256 && col) {
				write_biff_rec(ba, 0x007d /* ColInfo */, write_ColInfo(col_obj_w(idx, col), idx));
			}
		});
	}
	
	function write_ws_biff8_cell(ba, cell, R, C, opts) {
		var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
		if(cell.v == null && !cell.bf) {
			write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
			return;
		}
		if(cell.bf) write_biff_rec(ba, 0x0006 /* Formula */, write_Formula(cell, R, C, opts, os));
		else switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				/* TODO: emit RK as appropriate */
				write_biff_rec(ba, 0x0203 /* Number */, write_Number(R, C, v, os, opts));
				break;
			case 'b': case 'e':
				write_biff_rec(ba, 0x0205 /* BoolErr */, write_BoolErr(R, C, cell.v, os, opts, cell.t));
				break;
			/* TODO: codepage, sst */
			case 's': case 'str':
				if(opts.bookSST) {
					var isst = get_sst_id(opts.Strings, cell.v, opts.revStrings);
					write_biff_rec(ba, 0x00fd /* LabelSst */, write_LabelSst(R, C, isst, os, opts));
				} else write_biff_rec(ba, 0x0204 /* Label */, write_Label(R, C, (cell.v||"").slice(0,255), os, opts));
				break;
			default:
				write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
		}
	}
	
	/* [MS-XLS] 2.1.7.20.5 */
	function write_ws_biff8(idx, opts, wb) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var _WB = ((wb||{}).Workbook||{});
		var _sheet = ((_WB.Sheets||[])[idx]||{});
		var dense = Array.isArray(ws);
		var b8 = opts.biff == 8;
		var ref, rr = "", cols = [];
		var range = safe_decode_range(ws['!ref'] || "A1");
		var MAX_ROWS = b8 ? 65536 : 16384;
		if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, MAX_ROWS-1);
		}
	
		write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
		/* [Uncalced] Index */
		write_biff_rec(ba, 0x000d /* CalcMode */, writeuint16(1));
		write_biff_rec(ba, 0x000c /* CalcCount */, writeuint16(100));
		write_biff_rec(ba, 0x000f /* CalcRefMode */, writebool(true));
		write_biff_rec(ba, 0x0011 /* CalcIter */, writebool(false));
		write_biff_rec(ba, 0x0010 /* CalcDelta */, write_Xnum(0.001));
		write_biff_rec(ba, 0x005f /* CalcSaveRecalc */, writebool(true));
		write_biff_rec(ba, 0x002a /* PrintRowCol */, writebool(false));
		write_biff_rec(ba, 0x002b /* PrintGrid */, writebool(false));
		write_biff_rec(ba, 0x0082 /* GridSet */, writeuint16(1));
		write_biff_rec(ba, 0x0080 /* Guts */, write_Guts([0,0]));
		/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */
		/* Header (string) */
		/* Footer (string) */
		write_biff_rec(ba, 0x0083 /* HCenter */, writebool(false));
		write_biff_rec(ba, 0x0084 /* VCenter */, writebool(false));
		/* ... */
		if(b8) write_ws_cols_biff8(ba, ws["!cols"]);
		/* ... */
		write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
		/* ... */
	
		if(b8) ws['!links'] = [];
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff8_cell(ba, cell, R, C, opts);
				if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
			}
		}
		var cname = _sheet.CodeName || _sheet.name || s;
		/* ... */
		if(b8) write_biff_rec(ba, 0x023e /* Window2 */, write_Window2((_WB.Views||[])[0]));
		/* ... */
		if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, 0x00e5 /* MergeCells */, write_MergeCells(ws['!merges']));
		/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */
		if(b8) write_ws_biff8_hlinks(ba, ws);
		/* [DVAL] */
		write_biff_rec(ba, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
		/* *WebPub *CellWatch [SheetExt] */
		if(b8) write_FEAT(ba, ws);
		/* *FEAT11 *RECORD12 */
		write_biff_rec(ba, 0x000a /* EOF */);
		return ba.end();
	}
	
	/* [MS-XLS] 2.1.7.20.3 */
	function write_biff8_global(wb, bufs, opts) {
		var A = buf_array();
		var _WB = ((wb||{}).Workbook||{});
		var _sheets = (_WB.Sheets||[]);
		var _wb = _WB.WBProps||{};
		var b8 = opts.biff == 8, b5 = opts.biff == 5;
		write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
		if(opts.bookType == "xla") write_biff_rec(A, 0x0087 /* Addin */);
		write_biff_rec(A, 0x00e1 /* InterfaceHdr */, b8 ? writeuint16(0x04b0) : null);
		write_biff_rec(A, 0x00c1 /* Mms */, writezeroes(2));
		if(b5) write_biff_rec(A, 0x00bf /* ToolbarHdr */);
		if(b5) write_biff_rec(A, 0x00c0 /* ToolbarEnd */);
		write_biff_rec(A, 0x00e2 /* InterfaceEnd */);
		write_biff_rec(A, 0x005c /* WriteAccess */, write_WriteAccess("SheetJS", opts));
		/* [FileSharing] */
		write_biff_rec(A, 0x0042 /* CodePage */, writeuint16(b8 ? 0x04b0 : 0x04E4));
		/* *2047 Lel */
		if(b8) write_biff_rec(A, 0x0161 /* DSF */, writeuint16(0));
		if(b8) write_biff_rec(A, 0x01c0 /* Excel9File */);
		write_biff_rec(A, 0x013d /* RRTabId */, write_RRTabId(wb.SheetNames.length));
		if(b8 && wb.vbaraw) write_biff_rec(A, 0x00d3 /* ObProj */);
		/* [ObNoMacros] */
		if(b8 && wb.vbaraw) {
			var cname = _wb.CodeName || "ThisWorkbook";
			write_biff_rec(A, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
		}
		write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */, writeuint16(0x11));
		/* *FnGroupName *FnGrp12 */
		/* *Lbl */
		/* [OleObjectSize] */
		write_biff_rec(A, 0x0019 /* WinProtect */, writebool(false));
		write_biff_rec(A, 0x0012 /* Protect */, writebool(false));
		write_biff_rec(A, 0x0013 /* Password */, writeuint16(0));
		if(b8) write_biff_rec(A, 0x01af /* Prot4Rev */, writebool(false));
		if(b8) write_biff_rec(A, 0x01bc /* Prot4RevPass */, writeuint16(0));
		write_biff_rec(A, 0x003d /* Window1 */, write_Window1(opts));
		write_biff_rec(A, 0x0040 /* Backup */, writebool(false));
		write_biff_rec(A, 0x008d /* HideObj */, writeuint16(0));
		write_biff_rec(A, 0x0022 /* Date1904 */, writebool(safe1904(wb)=="true"));
		write_biff_rec(A, 0x000e /* CalcPrecision */, writebool(true));
		if(b8) write_biff_rec(A, 0x01b7 /* RefreshAll */, writebool(false));
		write_biff_rec(A, 0x00DA /* BookBool */, writeuint16(0));
		/* ... */
		write_FONTS_biff8(A, wb, opts);
		write_FMTS_biff8(A, wb.SSF, opts);
		write_CELLXFS_biff8(A, opts);
		/* ... */
		if(b8) write_biff_rec(A, 0x0160 /* UsesELFs */, writebool(false));
		var a = A.end();
	
		var C = buf_array();
		/* METADATA [MTRSettings] [ForceFullCalculation] */
		if(b8) write_biff_rec(C, 0x008C, write_Country());
		/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */
	
		/* BIFF8: [SST *Continue] ExtSST */
		if(b8 && opts.Strings) write_biff_continue(C, 0x00FC, write_SST(opts.Strings, opts));
	
		/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */
		write_biff_rec(C, 0x000A /* EOF */);
		var c = C.end();
	
		var B = buf_array();
		var blen = 0, j = 0;
		for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
		var start = a.length + blen + c.length;
		for(j = 0; j < wb.SheetNames.length; ++j) {
			var _sheet = _sheets[j] || ({});
			write_biff_rec(B, 0x0085 /* BoundSheet8 */, write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
			start += bufs[j].length;
		}
		/* 1*BoundSheet8 */
		var b = B.end();
		if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
	
		var out = [];
		if(a.length) out.push(a);
		if(b.length) out.push(b);
		if(c.length) out.push(c);
		return bconcat(out);
	}
	
	/* [MS-XLS] 2.1.7.20 Workbook Stream */
	function write_biff8_buf(wb, opts) {
		var o = opts || {};
		var bufs = [];
	
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
			o.ssf = wb.SSF;
		}
	
		o.Strings = []; o.Strings.Count = 0; o.Strings.Unique = 0;
		fix_write_opts(o);
	
		o.cellXfs = [];
		get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
		bufs.unshift(write_biff8_global(wb, bufs, o));
		return bconcat(bufs);
	}
	
	function write_biff_buf(wb, opts) {
		for(var i = 0; i <= wb.SheetNames.length; ++i) {
			var ws = wb.Sheets[wb.SheetNames[i]];
			if(!ws || !ws["!ref"]) continue;
			var range = decode_range(ws["!ref"]);
			if(range.e.c > 255) { // note: 255 is IV
			if(typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
			}
		}
	
		var o = opts || {};
		switch(o.biff || 2) {
			case 8: case 5: return write_biff8_buf(wb, opts);
			case 4: case 3: case 2: return write_biff2_buf(wb, opts);
		}
		throw new Error("invalid type " + o.bookType + " for BIFF");
	}
	/* note: browser DOM element cannot see mso- style attrs, must parse */
	function html_to_sheet(str, _opts) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var ws = opts.dense ? ([]) : ({});
		str = str.replace(/<!--.*?-->/g, "");
		var mtch = str.match(/<table/i);
		if(!mtch) throw new Error("Invalid HTML: could not find <table>");
		var mtch2 = str.match(/<\/table/i);
		var i = mtch.index, j = mtch2 && mtch2.index || str.length;
		var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
		var R = -1, C = 0, RS = 0, CS = 0;
		var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
		var merges = [];
		for(i = 0; i < rows.length; ++i) {
			var row = rows[i].trim();
			var hd = row.slice(0,3).toLowerCase();
			if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
			if(hd != "<td" && hd != "<th") continue;
			var cells = row.split(/<\/t[dh]>/i);
			for(j = 0; j < cells.length; ++j) {
				var cell = cells[j].trim();
				if(!cell.match(/<t[dh]/i)) continue;
				var m = cell, cc = 0;
				/* TODO: parse styles etc */
				while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
				for(var midx = 0; midx < merges.length; ++midx) {
					var _merge = merges[midx];
					if(_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) { C = _merge.e.c + 1; midx = -1; }
				}
				var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
				CS = tag.colspan ? +tag.colspan : 1;
				if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
				var _t = tag.t || tag["data-t"] || "";
				/* TODO: generate stub cells */
				if(!m.length) { C += CS; continue; }
				m = htmldecode(m);
				if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
				if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
				if(!m.length) { C += CS; continue; }
				var o = {t:'s', v:m};
				if(opts.raw || !m.trim().length || _t == 's'){}
				else if(m === 'TRUE') o = {t:'b', v:true};
				else if(m === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
				else if(!isNaN(fuzzydate(m).getDate())) {
					o = ({t:'d', v:parseDate(m)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || table_fmt[14];
				}
				if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
				else ws[encode_cell({r:R, c:C})] = o;
				C += CS;
			}
		}
		ws['!ref'] = encode_range(range);
		if(merges.length) ws["!merges"] = merges;
		return ws;
	}
	function make_html_row(ws, r, R, o) {
		var M = (ws['!merges'] ||[]);
		var oo = [];
		for(var C = r.s.c; C <= r.e.c; ++C) {
			var RS = 0, CS = 0;
			for(var j = 0; j < M.length; ++j) {
				if(M[j].s.r > R || M[j].s.c > C) continue;
				if(M[j].e.r < R || M[j].e.c < C) continue;
				if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
				RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
			}
			if(RS < 0) continue;
			var coord = encode_cell({r:R,c:C});
			var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
			/* TODO: html entities */
			var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
			var sp = ({});
			if(RS > 1) sp.rowspan = RS;
			if(CS > 1) sp.colspan = CS;
			if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
			else if(cell) {
				sp["data-t"] = cell && cell.t || 'z';
				if(cell.v != null) sp["data-v"] = cell.v;
				if(cell.z != null) sp["data-z"] = cell.z;
				if(cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target +'">' + w + '</a>';
			}
			sp.id = (o.id || "sjs") + "-" + coord;
			oo.push(writextag('td', w, sp));
		}
		var preamble = "<tr>";
		return preamble + oo.join("") + "</tr>";
	}
	
	var HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
	var HTML_END = '</body></html>';
	
	function html_to_workbook(str, opts) {
		var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
		if(!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
		if(mtch.length == 1) return sheet_to_workbook(html_to_sheet(mtch[0], opts), opts);
		var wb = book_new();
		mtch.forEach(function(s, idx) { book_append_sheet(wb, html_to_sheet(s, opts), "Sheet" + (idx+1)); });
		return wb;
	}
	
	function make_html_preamble(ws, R, o) {
		var out = [];
		return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
	}
	
	function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
		var o = opts || {};
		var header = o.header != null ? o.header : HTML_BEGIN;
		var footer = o.footer != null ? o.footer : HTML_END;
		var out = [header];
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		out.push(make_html_preamble(ws, r, o));
		for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
		out.push("</table>" + footer);
		return out.join("");
	}
	
	function sheet_add_dom(ws, table, _opts) {
		var opts = _opts || {};
		if(DENSE != null) opts.dense = DENSE;
		var or_R = 0, or_C = 0;
		if(opts.origin != null) {
			if(typeof opts.origin == 'number') or_R = opts.origin;
			else {
				var _origin = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
				or_R = _origin.r; or_C = _origin.c;
			}
		}
	
		var rows = table.getElementsByTagName('tr');
		var sheetRows = Math.min(opts.sheetRows||10000000, rows.length);
		var range = {s:{r:0,c:0},e:{r:or_R,c:or_C}};
		if(ws["!ref"]) {
			var _range = decode_range(ws["!ref"]);
			range.s.r = Math.min(range.s.r, _range.s.r);
			range.s.c = Math.min(range.s.c, _range.s.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			range.e.c = Math.max(range.e.c, _range.e.c);
			if(or_R == -1) range.e.r = or_R = _range.e.r + 1;
		}
		var merges = [], midx = 0;
		var rowinfo = ws["!rows"] || (ws["!rows"] = []);
		var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
		if(!ws["!cols"]) ws['!cols'] = [];
		for(; _R < rows.length && R < sheetRows; ++_R) {
			var row = rows[_R];
			if (is_dom_element_hidden(row)) {
				if (opts.display) continue;
				rowinfo[R] = {hidden: true};
			}
			var elts = (row.children);
			for(_C = C = 0; _C < elts.length; ++_C) {
				var elt = elts[_C];
				if (opts.display && is_dom_element_hidden(elt)) continue;
				var v = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : htmldecode(elt.innerHTML);
				var z = elt.getAttribute('data-z') || elt.getAttribute('z');
				for(midx = 0; midx < merges.length; ++midx) {
					var m = merges[midx];
					if(m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) { C = m.e.c+1 - or_C; midx = -1; }
				}
				/* TODO: figure out how to extract nonstandard mso- style */
				CS = +elt.getAttribute("colspan") || 1;
				if( ((RS = (+elt.getAttribute("rowspan") || 1)))>1 || CS>1) merges.push({s:{r:R + or_R,c:C + or_C},e:{r:R + or_R + (RS||1) - 1, c:C + or_C + (CS||1) - 1}});
				var o = {t:'s', v:v};
				var _t = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
				if(v != null) {
					if(v.length == 0) o.t = _t || 'z';
					else if(opts.raw || v.trim().length == 0 || _t == "s"){}
					else if(v === 'TRUE') o = {t:'b', v:true};
					else if(v === 'FALSE') o = {t:'b', v:false};
					else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
					else if(!isNaN(fuzzydate(v).getDate())) {
						o = ({t:'d', v:parseDate(v)});
						if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
						o.z = opts.dateNF || table_fmt[14];
					}
				}
				if(o.z === undefined && z != null) o.z = z;
				/* The first link is used.  Links are assumed to be fully specified.
				 * TODO: The right way to process relative links is to make a new <a> */
				var l = "", Aelts = elt.getElementsByTagName("A");
				if(Aelts && Aelts.length) for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)	if(Aelts[Aelti].hasAttribute("href")) {
					l = Aelts[Aelti].getAttribute("href"); if(l.charAt(0) != "#") break;
				}
				if(l && l.charAt(0) != "#") o.l = ({ Target: l });
				if(opts.dense) { if(!ws[R + or_R]) ws[R + or_R] = []; ws[R + or_R][C + or_C] = o; }
				else ws[encode_cell({c:C + or_C, r:R + or_R})] = o;
				if(range.e.c < C + or_C) range.e.c = C + or_C;
				C += CS;
			}
			++R;
		}
		if(merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
		range.e.r = Math.max(range.e.r, R - 1 + or_R);
		ws['!ref'] = encode_range(range);
		if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1 + or_R,range)); // We can count the real number of rows to parse but we don't to improve the performance
		return ws;
	}
	
	function parse_dom_table(table, _opts) {
		var opts = _opts || {};
		var ws = opts.dense ? ([]) : ({});
		return sheet_add_dom(ws, table, _opts);
	}
	
	function table_to_book(table, opts) {
		return sheet_to_workbook(parse_dom_table(table, opts), opts);
	}
	
	function is_dom_element_hidden(element) {
		var display = '';
		var get_computed_style = get_get_computed_style_function(element);
		if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
		if(!display) display = element.style && element.style.display;
		return display === 'none';
	}
	
	/* global getComputedStyle */
	function get_get_computed_style_function(element) {
		// The proper getComputedStyle implementation is the one defined in the element window
		if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
		// If it is not available, try to get one from the global namespace
		if(typeof getComputedStyle === 'function') return getComputedStyle;
		return null;
	}
	/* OpenDocument */
	function parse_text_p(text) {
		/* 6.1.2 White Space Characters */
		var fixed = text
			.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
			.replace(/<text:s\/>/g," ")
			.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
			.replace(/<text:tab[^>]*\/>/g,"\t")
			.replace(/<text:line-break\/>/g,"\n");
		var v = unescapexml(fixed.replace(/<[^>]*>/g,""));
	
		return [v];
	}
	
	var number_formats_ods = {
		/* ods name: [short ssf fmt, long ssf fmt] */
		day:           ["d",   "dd"],
		month:         ["m",   "mm"],
		year:          ["y",   "yy"],
		hours:         ["h",   "hh"],
		minutes:       ["m",   "mm"],
		seconds:       ["s",   "ss"],
		"am-pm":       ["A/P", "AM/PM"],
		"day-of-week": ["ddd", "dddd"],
		era:           ["e",   "ee"],
		/* there is no native representation of LO "Q" format */
		quarter:       ["\\Qm", "m\\\"th quarter\""]
	};
	
	
	function parse_content_xml(d, _opts) {
			var opts = _opts || {};
			if(DENSE != null && opts.dense == null) opts.dense = DENSE;
			var str = xlml_normalize(d);
			var state = [], tmp;
			var tag;
			var NFtag = {name:""}, NF = "", pidx = 0;
			var sheetag;
			var rowtag;
			var Sheets = {}, SheetNames = [];
			var ws = opts.dense ? ([]) : ({});
			var Rn, q;
			var ctag = ({value:""});
			var textp = "", textpidx = 0, textptag;
			var textR = [];
			var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
			var row_ol = 0;
			var number_format_map = {};
			var merges = [], mrange = {}, mR = 0, mC = 0;
			var rowinfo = [], rowpeat = 1, colpeat = 1;
			var arrayf = [];
			var WB = {Names:[]};
			var atag = ({});
			var _Ref = ["", ""];
			var comments = [], comment = ({});
			var creator = "", creatoridx = 0;
			var isstub = false, intable = false;
			var i = 0;
			xlmlregex.lastIndex = 0;
			str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
			while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {
	
				case 'table': case '工作表': // 9.1.2 <table:table>
					if(Rn[1]==='/') {
						if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
						else ws['!ref'] = "A1:A1";
						if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
							ws['!fullref'] = ws['!ref'];
							range.e.r = opts.sheetRows - 1;
							ws['!ref'] = encode_range(range);
						}
						if(merges.length) ws['!merges'] = merges;
						if(rowinfo.length) ws["!rows"] = rowinfo;
						sheetag.name = sheetag['名称'] || sheetag.name;
						if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
						SheetNames.push(sheetag.name);
						Sheets[sheetag.name] = ws;
						intable = false;
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						sheetag = parsexmltag(Rn[0], false);
						R = C = -1;
						range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
						ws = opts.dense ? ([]) : ({}); merges = [];
						rowinfo = [];
						intable = true;
					}
					break;
	
				case 'table-row-group': // 9.1.9 <table:table-row-group>
					if(Rn[1] === "/") --row_ol; else ++row_ol;
					break;
				case 'table-row': case '行': // 9.1.3 <table:table-row>
					if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
					rowtag = parsexmltag(Rn[0], false);
					if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
					rowpeat = +rowtag['number-rows-repeated'] || 1;
					/* TODO: remove magic */
					if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
					C = -1; break;
				case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
					if(Rn[1] !== '/') ++C;
					if(opts.sheetStubs) {
						if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
						else ws[encode_cell({r:R,c:C})] = {t:'z'};
					}
					textp = ""; textR = [];
					break; /* stub */
				case 'table-cell': case '数据':
					if(Rn[0].charAt(Rn[0].length-2) === '/') {
						++C;
						ctag = parsexmltag(Rn[0], false);
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						q = ({t:'z', v:null});
						if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
						if((ctag['数据类型'] || ctag['value-type']) == "string") {
							q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
							if(opts.dense) {
								if(!ws[R]) ws[R] = [];
								ws[R][C] = q;
							} else {
								ws[encode_cell({r:R,c:C})] = q;
							}
						}
						C+= colpeat-1;
					} else if(Rn[1]!=='/') {
						++C;
						textp = ""; textpidx = 0; textR = [];
						colpeat = 1;
						var rptR = rowpeat ? R + rowpeat - 1 : R;
						if(C > range.e.c) range.e.c = C;
						if(C < range.s.c) range.s.c = C;
						if(R < range.s.r) range.s.r = R;
						if(rptR > range.e.r) range.e.r = rptR;
						ctag = parsexmltag(Rn[0], false);
						comments = []; comment = ({});
						q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
						if(opts.cellFormula) {
							if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
							if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
								mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
								mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
								mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
								q.F = encode_range(mrange);
								arrayf.push([mrange, q.F]);
							}
							if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
							else for(i = 0; i < arrayf.length; ++i)
								if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
									if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
										q.F = arrayf[i][1];
						}
						if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
							mR = parseInt(ctag['number-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							merges.push(mrange);
						}
	
						/* 19.675.2 table:number-columns-repeated */
						if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
	
						/* 19.385 office:value-type */
						switch(q.t) {
							case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
							case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
								if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
								q.z = 'm/d/yy'; break;
							case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400;
								if(opts.cellDates) { q.t = 'd'; q.v = numdate(q.v); }
								q.z = 'HH:MM:SS'; break;
							case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
							default:
								if(q.t === 'string' || q.t === 'text' || !q.t) {
									q.t = 's';
									if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
								} else throw new Error('Unsupported value type ' + q.t);
						}
					} else {
						isstub = false;
						if(q.t === 's') {
							q.v = textp || '';
							if(textR.length) q.R = textR;
							isstub = textpidx == 0;
						}
						if(atag.Target) q.l = atag;
						if(comments.length > 0) { q.c = comments; comments = []; }
						if(textp && opts.cellText !== false) q.w = textp;
						if(isstub) { q.t = "z"; delete q.v; }
						if(!isstub || opts.sheetStubs) {
							if(!(opts.sheetRows && opts.sheetRows <= R)) {
								for(var rpt = 0; rpt < rowpeat; ++rpt) {
									colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
									if(opts.dense) {
										if(!ws[R + rpt]) ws[R + rpt] = [];
										ws[R + rpt][C] = rpt == 0 ? q : dup(q);
										while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
									} else {
										ws[encode_cell({r:R + rpt,c:C})] = q;
										while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
									}
									if(range.e.c <= C) range.e.c = C;
								}
							}
						}
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						C += colpeat-1; colpeat = 0;
						q = {};
						textp = ""; textR = [];
					}
					atag = ({});
					break; // 9.1.4 <table:table-cell>
	
				/* pure state */
				case 'document': // TODO: <office:document> is the root for FODS
				case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
				case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
				case 'scripts': // 3.12 <office:scripts>
				case 'styles': // TODO <office:styles>
				case 'font-face-decls': // 3.14 <office:font-face-decls>
				case 'master-styles': // 3.15.4 <office:master-styles> -- relevant for FODS
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
	
				case 'annotation': // 14.1 <office:annotation>
					if(Rn[1]==='/'){
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
						comment.t = textp;
						if(textR.length) comment.R = textR;
						comment.a = creator;
						comments.push(comment);
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
					creator = ""; creatoridx = 0;
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'creator': // 4.3.2.7 <dc:creator>
					if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
					else creatoridx = Rn.index + Rn[0].length;
					break;
	
				/* ignore state */
				case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
				case 'settings': // TODO: <office:settings>
				case 'config-item-set': // TODO: <office:config-item-set>
				case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
				case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
				case 'config-item-map-named': // TODO: <office:config-item-map-entry>
				case 'shapes': // 9.2.8 <table:shapes>
				case 'frame': // 10.4.2 <draw:frame>
				case 'text-box': // 10.4.3 <draw:text-box>
				case 'image': // 10.4.4 <draw:image>
				case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
				case 'list-style': // 16.30 <text:list-style>
				case 'form': // 13.13 <form:form>
				case 'dde-links': // 9.8 <table:dde-links>
				case 'event-listeners': // TODO
				case 'chart': // TODO
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'scientific-number': // TODO: <number:scientific-number>
					break;
				case 'currency-symbol': // TODO: <number:currency-symbol>
					break;
				case 'currency-style': // TODO: <number:currency-style>
					break;
				case 'number-style': // 16.27.2 <number:number-style>
				case 'percentage-style': // 16.27.9 <number:percentage-style>
				case 'date-style': // 16.27.10 <number:date-style>
				case 'time-style': // 16.27.18 <number:time-style>
					if(Rn[1]==='/'){
						number_format_map[NFtag.name] = NF;
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						NF = "";
						NFtag = parsexmltag(Rn[0], false);
						state.push([Rn[3], true]);
					} break;
	
				case 'script': break; // 3.13 <office:script>
				case 'libraries': break; // TODO: <ooo:libraries>
				case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
	
				case 'default-style': // TODO: <style:default-style>
				case 'page-layout': break; // TODO: <style:page-layout>
				case 'style': // 16.2 <style:style>
					break;
				case 'map': break; // 16.3 <style:map>
				case 'font-face': break; // 16.21 <style:font-face>
	
				case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
				case 'table-properties': break; // 17.15 <style:table-properties>
				case 'table-column-properties': break; // 17.16 <style:table-column-properties>
				case 'table-row-properties': break; // 17.17 <style:table-row-properties>
				case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>
	
				case 'number': // 16.27.3 <number:number>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'fraction': break; // TODO 16.27.6 <number:fraction>
	
				case 'day': // 16.27.11 <number:day>
				case 'month': // 16.27.12 <number:month>
				case 'year': // 16.27.13 <number:year>
				case 'era': // 16.27.14 <number:era>
				case 'day-of-week': // 16.27.15 <number:day-of-week>
				case 'week-of-year': // 16.27.16 <number:week-of-year>
				case 'quarter': // 16.27.17 <number:quarter>
				case 'hours': // 16.27.19 <number:hours>
				case 'minutes': // 16.27.20 <number:minutes>
				case 'seconds': // 16.27.21 <number:seconds>
				case 'am-pm': // 16.27.22 <number:am-pm>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'boolean-style': break; // 16.27.23 <number:boolean-style>
				case 'boolean': break; // 16.27.24 <number:boolean>
				case 'text-style': break; // 16.27.25 <number:text-style>
				case 'text': // 16.27.26 <number:text>
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") switch(state[state.length-1][0]) {
						case 'number-style':
						case 'date-style':
						case 'time-style':
							NF += str.slice(pidx, Rn.index);
							break;
					}
					else pidx = Rn.index + Rn[0].length;
					break;
	
				case 'named-range': // 9.4.12 <table:named-range>
					tag = parsexmltag(Rn[0], false);
					_Ref = ods_to_csf_3D(tag['cell-range-address']);
					var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
					if(intable) nrange.Sheet = SheetNames.length;
					WB.Names.push(nrange);
					break;
	
				case 'text-content': break; // 16.27.27 <number:text-content>
				case 'text-properties': break; // 16.27.27 <style:text-properties>
				case 'embedded-text': break; // 16.27.4 <number:embedded-text>
	
				case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3
	
				case 'forms': break; // 12.25.2 13.2
				case 'table-column': break; // 9.1.6 <table:table-column>
				case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
				case 'table-rows': break; // 9.1.12 <table:table-rows>
				/* TODO: outline levels */
				case 'table-column-group': break; // 9.1.10 <table:table-column-group>
				case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
				case 'table-columns': break; // 9.1.12 <table:table-columns>
	
				case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904
	
				case 'graphic-properties': break; // 17.21 <style:graphic-properties>
				case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
				case 'named-expressions': break; // 9.4.11 <table:named-expressions>
				case 'label-range': break; // 9.4.9 <table:label-range>
				case 'label-ranges': break; // 9.4.10 <table:label-ranges>
				case 'named-expression': break; // 9.4.13 <table:named-expression>
				case 'sort': break; // 9.4.19 <table:sort>
				case 'sort-by': break; // 9.4.20 <table:sort-by>
				case 'sort-groups': break; // 9.4.22 <table:sort-groups>
	
				case 'tab': break; // 6.1.4 <text:tab>
				case 'line-break': break; // 6.1.5 <text:line-break>
				case 'span': break; // 6.1.7 <text:span>
				case 'p': case '文本串': // 5.1.3 <text:p>
					if(['master-styles'].indexOf(state[state.length-1][0]) > -1) break;
					if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
						var ptp = parse_text_p(str.slice(textpidx,Rn.index), textptag);
						textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
					} else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
					break; // <text:p>
				case 's': break; // <text:s>
	
				case 'database-range': // 9.4.15 <table:database-range>
					if(Rn[1]==='/') break;
					try {
						_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
						Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
					} catch(e) {/* empty */}
					break;
	
				case 'date': break; // <*:date>
	
				case 'object': break; // 10.4.6.2 <draw:object>
				case 'title': case '标题': break; // <*:title> OR <uof:标题>
				case 'desc': break; // <*:desc>
				case 'binary-data': break; // 10.4.5 TODO: b64 blob
	
				/* 9.2 Advanced Tables */
				case 'table-source': break; // 9.2.6
				case 'scenario': break; // 9.2.6
	
				case 'iteration': break; // 9.4.3 <table:iteration>
				case 'content-validations': break; // 9.4.4 <table:
				case 'content-validation': break; // 9.4.5 <table:
				case 'help-message': break; // 9.4.6 <table:
				case 'error-message': break; // 9.4.7 <table:
				case 'database-ranges': break; // 9.4.14 <table:database-ranges>
				case 'filter': break; // 9.5.2 <table:filter>
				case 'filter-and': break; // 9.5.3 <table:filter-and>
				case 'filter-or': break; // 9.5.4 <table:filter-or>
				case 'filter-condition': break; // 9.5.5 <table:filter-condition>
	
				case 'list-level-style-bullet': break; // 16.31 <text:
				case 'list-level-style-number': break; // 16.32 <text:
				case 'list-level-properties': break; // 17.19 <style:
	
				/* 7.3 Document Fields */
				case 'sender-firstname': // 7.3.6.2
				case 'sender-lastname': // 7.3.6.3
				case 'sender-initials': // 7.3.6.4
				case 'sender-title': // 7.3.6.5
				case 'sender-position': // 7.3.6.6
				case 'sender-email': // 7.3.6.7
				case 'sender-phone-private': // 7.3.6.8
				case 'sender-fax': // 7.3.6.9
				case 'sender-company': // 7.3.6.10
				case 'sender-phone-work': // 7.3.6.11
				case 'sender-street': // 7.3.6.12
				case 'sender-city': // 7.3.6.13
				case 'sender-postal-code': // 7.3.6.14
				case 'sender-country': // 7.3.6.15
				case 'sender-state-or-province': // 7.3.6.16
				case 'author-name': // 7.3.7.1
				case 'author-initials': // 7.3.7.2
				case 'chapter': // 7.3.8
				case 'file-name': // 7.3.9
				case 'template-name': // 7.3.9
				case 'sheet-name': // 7.3.9
					break;
	
				case 'event-listener':
					break;
				/* TODO: FODS Properties */
				case 'initial-creator':
				case 'creation-date':
				case 'print-date':
				case 'generator':
				case 'document-statistic':
				case 'user-defined':
				case 'editing-duration':
				case 'editing-cycles':
					break;
	
				/* TODO: FODS Config */
				case 'config-item':
					break;
	
				/* TODO: style tokens */
				case 'page-number': break; // TODO <text:page-number>
				case 'page-count': break; // TODO <text:page-count>
				case 'time': break; // TODO <text:time>
	
				/* 9.3 Advanced Table Cells */
				case 'cell-range-source': break; // 9.3.1 <table:
				case 'detective': break; // 9.3.2 <table:
				case 'operation': break; // 9.3.3 <table:
				case 'highlighted-range': break; // 9.3.4 <table:
	
				/* 9.6 Data Pilot Tables <table: */
				case 'data-pilot-table': // 9.6.3
				case 'source-cell-range': // 9.6.5
				case 'source-service': // 9.6.6
				case 'data-pilot-field': // 9.6.7
				case 'data-pilot-level': // 9.6.8
				case 'data-pilot-subtotals': // 9.6.9
				case 'data-pilot-subtotal': // 9.6.10
				case 'data-pilot-members': // 9.6.11
				case 'data-pilot-member': // 9.6.12
				case 'data-pilot-display-info': // 9.6.13
				case 'data-pilot-sort-info': // 9.6.14
				case 'data-pilot-layout-info': // 9.6.15
				case 'data-pilot-field-reference': // 9.6.16
				case 'data-pilot-groups': // 9.6.17
				case 'data-pilot-group': // 9.6.18
				case 'data-pilot-group-member': // 9.6.19
					break;
	
				/* 10.3 Drawing Shapes */
				case 'rect': // 10.3.2
					break;
	
				/* 14.6 DDE Connections */
				case 'dde-connection-decls': // 14.6.2 <text:
				case 'dde-connection-decl': // 14.6.3 <text:
				case 'dde-link': // 14.6.4 <table:
				case 'dde-source': // 14.6.5 <office:
					break;
	
				case 'properties': break; // 13.7 <form:properties>
				case 'property': break; // 13.8 <form:property>
	
				case 'a': // 6.1.8 hyperlink
					if(Rn[1]!== '/') {
						atag = parsexmltag(Rn[0], false);
						if(!atag.href) break;
						atag.Target = unescapexml(atag.href); delete atag.href;
						if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
							_Ref = ods_to_csf_3D(atag.Target.slice(1));
							atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
						} else if(atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
					}
					break;
	
				/* non-standard */
				case 'table-protection': break;
				case 'data-pilot-grand-total': break; // <table:
				case 'office-document-common-attrs': break; // bare
				default: switch(Rn[2]) {
					case 'dc:':       // TODO: properties
					case 'calcext:':  // ignore undocumented extensions
					case 'loext:':    // ignore undocumented extensions
					case 'ooo:':      // ignore undocumented extensions
					case 'chartooo:': // ignore undocumented extensions
					case 'draw:':     // TODO: drawing
					case 'style:':    // TODO: styles
					case 'chart:':    // TODO: charts
					case 'form:':     // TODO: forms
					case 'uof:':      // TODO: uof
					case '表:':       // TODO: uof
					case '字:':       // TODO: uof
						break;
					default: if(opts.WTF) throw new Error(Rn);
				}
			}
			var out = ({
				Sheets: Sheets,
				SheetNames: SheetNames,
				Workbook: WB
			});
			if(opts.bookSheets) delete out.Sheets;
			return out;
	}
	
	function parse_ods(zip, opts) {
		opts = opts || ({});
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
		var content = getzipstr(zip, 'content.xml');
		if(!content) throw new Error("Missing content.xml in ODS / UOF file");
		var wb = parse_content_xml(utf8read(content), opts);
		if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
		return wb;
	}
	function parse_fods(data, opts) {
		return parse_content_xml(data, opts);
	}
	
	/* OpenDocument */
	var write_styles_ods = /* @__PURE__ */(function() {
		var master_styles = [
			'<office:master-styles>',
				'<style:master-page style:name="mp1" style:page-layout-name="mp1">',
					'<style:header/>',
					'<style:header-left style:display="false"/>',
					'<style:footer/>',
					'<style:footer-left style:display="false"/>',
				'</style:master-page>',
			'</office:master-styles>'
		].join("");
	
		var payload = '<office:document-styles ' + wxt_helper({
			'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':    "http://www.w3.org/1999/xlink",
			'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
			'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'office:version': "1.2"
		}) + '>' + master_styles + '</office:document-styles>';
	
		return function wso() {
			return XML_HEADER + payload;
		};
	})();
	var write_content_ods = /* @__PURE__ */(function() {
		/* 6.1.2 White Space Characters */
		var write_text_p = function(text) {
			return escapexml(text)
				.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
				.replace(/\t/g, "<text:tab/>")
				.replace(/\n/g, "</text:p><text:p>")
				.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
		};
	
		var null_cell_xml = '          <table:table-cell />\n';
		var covered_cell_xml = '          <table:covered-table-cell/>\n';
		var write_ws = function(ws, wb, i) {
			/* Section 9 Tables */
			var o = [];
			o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
			var R=0,C=0, range = decode_range(ws['!ref']||"A1");
			var marr = ws['!merges'] || [], mi = 0;
			var dense = Array.isArray(ws);
			if(ws["!cols"]) {
				for(C = 0; C <= range.e.c; ++C) o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
			}
			var H = "", ROWS = ws["!rows"]||[];
			for(R = 0; R < range.s.r; ++R) {
				H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
				o.push('        <table:table-row' + H + '></table:table-row>\n');
			}
			for(; R <= range.e.r; ++R) {
				H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
				o.push('        <table:table-row' + H + '>\n');
				for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
				for(; C <= range.e.c; ++C) {
					var skip = false, ct = {}, textp = "";
					for(mi = 0; mi != marr.length; ++mi) {
						if(marr[mi].s.c > C) continue;
						if(marr[mi].s.r > R) continue;
						if(marr[mi].e.c < C) continue;
						if(marr[mi].e.r < R) continue;
						if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
						ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
						ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
						break;
					}
					if(skip) { o.push(covered_cell_xml); continue; }
					var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
					if(cell && cell.f) {
						ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
						if(cell.F) {
							if(cell.F.slice(0, ref.length) == ref) {
								var _Fref = decode_range(cell.F);
								ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
								ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
							}
						}
					}
					if(!cell) { o.push(null_cell_xml); continue; }
					switch(cell.t) {
						case 'b':
							textp = (cell.v ? 'TRUE' : 'FALSE');
							ct['office:value-type'] = "boolean";
							ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
							break;
						case 'n':
							textp = (cell.w||String(cell.v||0));
							ct['office:value-type'] = "float";
							ct['office:value'] = (cell.v||0);
							break;
						case 's': case 'str':
							textp = cell.v == null ? "" : cell.v;
							ct['office:value-type'] = "string";
							break;
						case 'd':
							textp = (cell.w||(parseDate(cell.v).toISOString()));
							ct['office:value-type'] = "date";
							ct['office:date-value'] = (parseDate(cell.v).toISOString());
							ct['table:style-name'] = "ce1";
							break;
						//case 'e':
						default: o.push(null_cell_xml); continue;
					}
					var text_p = write_text_p(textp);
					if(cell.l && cell.l.Target) {
						var _tgt = cell.l.Target;
						_tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
						// TODO: choose correct parent path format based on link delimiters
						if(_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
						text_p = writextag('text:a', text_p, {'xlink:href': _tgt.replace(/&/g, "&amp;")});
					}
					o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
				}
				o.push('        </table:table-row>\n');
			}
			o.push('      </table:table>\n');
			return o.join("");
		};
	
		var write_automatic_styles_ods = function(o, wb) {
			o.push(' <office:automatic-styles>\n');
	
			o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
			o.push('   <number:month number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:day number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:year/>\n');
			o.push('  </number:date-style>\n');
	
			/* column styles */
			var cidx = 0;
			wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
				if(!ws) return;
				if(ws["!cols"]) {
					for(var C = 0; C < ws["!cols"].length; ++C) if(ws["!cols"][C]) {
						var colobj = ws["!cols"][C];
						if(colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
						process_col(colobj);
						colobj.ods = cidx;
						var w = ws["!cols"][C].wpx + "px";
						o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
						o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
						o.push('  </style:style>\n');
						++cidx;
					}
				}
			});
	
			/* row styles */
			var ridx = 0;
			wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
				if(!ws) return;
				if(ws["!rows"]) {
					for(var R = 0; R < ws["!rows"].length; ++R) if(ws["!rows"][R]) {
						ws["!rows"][R].ods = ridx;
						var h = ws["!rows"][R].hpx + "px";
						o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
						o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
						o.push('  </style:style>\n');
						++ridx;
					}
				}
			});
	
			/* table */
			o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
			o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
			o.push('  </style:style>\n');
	
			/* table cells, text */
			o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
	
			/* page-layout */
	
			o.push(' </office:automatic-styles>\n');
		};
	
		return function wcx(wb, opts) {
			var o = [XML_HEADER];
			/* 3.1.3.2 */
			var attr = wxt_helper({
				'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
				'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
				'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
				'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
				'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
				'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
				'xmlns:xlink':        "http://www.w3.org/1999/xlink",
				'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
				'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
				'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
				'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
				'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
				'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
				'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
				'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
				'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
				'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
				'xmlns:ooo':          "http://openoffice.org/2004/office",
				'xmlns:ooow':         "http://openoffice.org/2004/writer",
				'xmlns:oooc':         "http://openoffice.org/2004/calc",
				'xmlns:dom':          "http://www.w3.org/2001/xml-events",
				'xmlns:xforms':       "http://www.w3.org/2002/xforms",
				'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
				'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
				'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
				'xmlns:rpt':          "http://openoffice.org/2005/report",
				'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
				'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
				'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
				'xmlns:tableooo':     "http://openoffice.org/2009/table",
				'xmlns:drawooo':      "http://openoffice.org/2010/draw",
				'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
				'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
				'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
				'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
				'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
				'office:version':     "1.2"
			});
	
			var fods = wxt_helper({
				'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
				'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
			});
	
			if(opts.bookType == "fods") {
				o.push('<office:document' + attr + fods + '>\n');
				o.push(write_meta_ods().replace(/office:document-meta/g, "office:meta"));
				// TODO: settings (equiv of settings.xml for ODS)
			} else o.push('<office:document-content' + attr  + '>\n');
			// o.push('  <office:scripts/>\n');
			write_automatic_styles_ods(o, wb);
			o.push('  <office:body>\n');
			o.push('    <office:spreadsheet>\n');
			for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
			o.push('    </office:spreadsheet>\n');
			o.push('  </office:body>\n');
			if(opts.bookType == "fods") o.push('</office:document>');
			else o.push('</office:document-content>');
			return o.join("");
		};
	})();
	
	function write_ods(wb, opts) {
		if(opts.bookType == "fods") return write_content_ods(wb, opts);
	
		var zip = zip_new();
		var f = "";
	
		var manifest = [];
		var rdf = [];
	
		/* Part 3 Section 3.3 MIME Media Type */
		f = "mimetype";
		zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
	
		/* Part 1 Section 2.2 Documents */
		f = "content.xml";
		zip_add_file(zip, f, write_content_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "ContentFile"]);
	
		/* TODO: these are hard-coded styles to satiate excel */
		f = "styles.xml";
		zip_add_file(zip, f, write_styles_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "StylesFile"]);
	
		/* TODO: this is hard-coded to satiate excel */
		f = "meta.xml";
		zip_add_file(zip, f, XML_HEADER + write_meta_ods());
		manifest.push([f, "text/xml"]);
		rdf.push([f, "MetadataFile"]);
	
		/* Part 3 Section 6 Metadata Manifest File */
		f = "manifest.rdf";
		zip_add_file(zip, f, write_rdf(rdf/*, opts*/));
		manifest.push([f, "application/rdf+xml"]);
	
		/* Part 3 Section 4 Manifest File */
		f = "META-INF/manifest.xml";
		zip_add_file(zip, f, write_manifest(manifest/*, opts*/));
	
		return zip;
	}
	
	/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
	function u8_to_dataview(array) {
	  return new DataView(array.buffer, array.byteOffset, array.byteLength);
	}
	function u8str(u8) {
	  return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : utf8read(a2s(u8));
	}
	function stru8(str) {
	  return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : s2a(utf8write(str));
	}
	function u8contains(body, search) {
	  outer:
	    for (var L = 0; L <= body.length - search.length; ++L) {
	      for (var j = 0; j < search.length; ++j)
	        if (body[L + j] != search[j])
	          continue outer;
	      return true;
	    }
	  return false;
	}
	function u8concat(u8a) {
	  var len = u8a.reduce(function(acc, x) {
	    return acc + x.length;
	  }, 0);
	  var out = new Uint8Array(len);
	  var off = 0;
	  u8a.forEach(function(u8) {
	    out.set(u8, off);
	    off += u8.length;
	  });
	  return out;
	}
	function popcnt(x) {
	  x -= x >> 1 & 1431655765;
	  x = (x & 858993459) + (x >> 2 & 858993459);
	  return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
	}
	function readDecimal128LE(buf, offset) {
	  var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
	  var mantissa = buf[offset + 14] & 1;
	  for (var j = offset + 13; j >= offset; --j)
	    mantissa = mantissa * 256 + buf[j];
	  return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
	}
	function writeDecimal128LE(buf, offset, value) {
	  var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 20;
	  var mantissa = value / Math.pow(10, exp - 6176);
	  buf[offset + 15] |= exp >> 7;
	  buf[offset + 14] |= (exp & 127) << 1;
	  for (var i = 0; mantissa >= 1; ++i, mantissa /= 256)
	    buf[offset + i] = mantissa & 255;
	  buf[offset + 15] |= value >= 0 ? 0 : 128;
	}
	function parse_varint49(buf, ptr) {
	  var l = ptr ? ptr[0] : 0;
	  var usz = buf[l] & 127;
	  varint:
	    if (buf[l++] >= 128) {
	      usz |= (buf[l] & 127) << 7;
	      if (buf[l++] < 128)
	        break varint;
	      usz |= (buf[l] & 127) << 14;
	      if (buf[l++] < 128)
	        break varint;
	      usz |= (buf[l] & 127) << 21;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 28);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 35);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 42);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	    }
	  if (ptr)
	    ptr[0] = l;
	  return usz;
	}
	function write_varint49(v) {
	  var usz = new Uint8Array(7);
	  usz[0] = v & 127;
	  var L = 1;
	  sz:
	    if (v > 127) {
	      usz[L - 1] |= 128;
	      usz[L] = v >> 7 & 127;
	      ++L;
	      if (v <= 16383)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v >> 14 & 127;
	      ++L;
	      if (v <= 2097151)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v >> 21 & 127;
	      ++L;
	      if (v <= 268435455)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 256 >>> 21 & 127;
	      ++L;
	      if (v <= 34359738367)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 65536 >>> 21 & 127;
	      ++L;
	      if (v <= 4398046511103)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 16777216 >>> 21 & 127;
	      ++L;
	    }
	  return usz.slice(0, L);
	}
	function varint_to_i32(buf) {
	  var l = 0, i32 = buf[l] & 127;
	  varint:
	    if (buf[l++] >= 128) {
	      i32 |= (buf[l] & 127) << 7;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 14;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 21;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 28;
	    }
	  return i32;
	}
	function parse_shallow(buf) {
	  var out = [], ptr = [0];
	  while (ptr[0] < buf.length) {
	    var off = ptr[0];
	    var num = parse_varint49(buf, ptr);
	    var type = num & 7;
	    num = Math.floor(num / 8);
	    var len = 0;
	    var res;
	    if (num == 0)
	      break;
	    switch (type) {
	      case 0:
	        {
	          var l = ptr[0];
	          while (buf[ptr[0]++] >= 128)
	            ;
	          res = buf.slice(l, ptr[0]);
	        }
	        break;
	      case 5:
	        len = 4;
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 1:
	        len = 8;
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 2:
	        len = parse_varint49(buf, ptr);
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 3:
	      case 4:
	      default:
	        throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
	    }
	    var v = { data: res, type: type };
	    if (out[num] == null)
	      out[num] = [v];
	    else
	      out[num].push(v);
	  }
	  return out;
	}
	function write_shallow(proto) {
	  var out = [];
	  proto.forEach(function(field, idx) {
	    field.forEach(function(item) {
	      if (!item.data)
	        return;
	      out.push(write_varint49(idx * 8 + item.type));
	      if (item.type == 2)
	        out.push(write_varint49(item.data.length));
	      out.push(item.data);
	    });
	  });
	  return u8concat(out);
	}
	function mappa(data, cb) {
	  return (data == null ? void 0 : data.map(function(d) {
	    return cb(d.data);
	  })) || [];
	}
	function parse_iwa_file(buf) {
	  var _a;
	  var out = [], ptr = [0];
	  while (ptr[0] < buf.length) {
	    var len = parse_varint49(buf, ptr);
	    var ai = parse_shallow(buf.slice(ptr[0], ptr[0] + len));
	    ptr[0] += len;
	    var res = {
	      id: varint_to_i32(ai[1][0].data),
	      messages: []
	    };
	    ai[2].forEach(function(b) {
	      var mi = parse_shallow(b.data);
	      var fl = varint_to_i32(mi[3][0].data);
	      res.messages.push({
	        meta: mi,
	        data: buf.slice(ptr[0], ptr[0] + fl)
	      });
	      ptr[0] += fl;
	    });
	    if ((_a = ai[3]) == null ? void 0 : _a[0])
	      res.merge = varint_to_i32(ai[3][0].data) >>> 0 > 0;
	    out.push(res);
	  }
	  return out;
	}
	function write_iwa_file(ias) {
	  var bufs = [];
	  ias.forEach(function(ia) {
	    var ai = [];
	    ai[1] = [{ data: write_varint49(ia.id), type: 0 }];
	    ai[2] = [];
	    if (ia.merge != null)
	      ai[3] = [{ data: write_varint49(+!!ia.merge), type: 0 }];
	    var midata = [];
	    ia.messages.forEach(function(mi) {
	      midata.push(mi.data);
	      mi.meta[3] = [{ type: 0, data: write_varint49(mi.data.length) }];
	      ai[2].push({ data: write_shallow(mi.meta), type: 2 });
	    });
	    var aipayload = write_shallow(ai);
	    bufs.push(write_varint49(aipayload.length));
	    bufs.push(aipayload);
	    midata.forEach(function(mid) {
	      return bufs.push(mid);
	    });
	  });
	  return u8concat(bufs);
	}
	function parse_snappy_chunk(type, buf) {
	  if (type != 0)
	    throw new Error("Unexpected Snappy chunk type ".concat(type));
	  var ptr = [0];
	  var usz = parse_varint49(buf, ptr);
	  var chunks = [];
	  while (ptr[0] < buf.length) {
	    var tag = buf[ptr[0]] & 3;
	    if (tag == 0) {
	      var len = buf[ptr[0]++] >> 2;
	      if (len < 60)
	        ++len;
	      else {
	        var c = len - 59;
	        len = buf[ptr[0]];
	        if (c > 1)
	          len |= buf[ptr[0] + 1] << 8;
	        if (c > 2)
	          len |= buf[ptr[0] + 2] << 16;
	        if (c > 3)
	          len |= buf[ptr[0] + 3] << 24;
	        len >>>= 0;
	        len++;
	        ptr[0] += c;
	      }
	      chunks.push(buf.slice(ptr[0], ptr[0] + len));
	      ptr[0] += len;
	      continue;
	    } else {
	      var offset = 0, length = 0;
	      if (tag == 1) {
	        length = (buf[ptr[0]] >> 2 & 7) + 4;
	        offset = (buf[ptr[0]++] & 224) << 3;
	        offset |= buf[ptr[0]++];
	      } else {
	        length = (buf[ptr[0]++] >> 2) + 1;
	        if (tag == 2) {
	          offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
	          ptr[0] += 2;
	        } else {
	          offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
	          ptr[0] += 4;
	        }
	      }
	      chunks = [u8concat(chunks)];
	      if (offset == 0)
	        throw new Error("Invalid offset 0");
	      if (offset > chunks[0].length)
	        throw new Error("Invalid offset beyond length");
	      if (length >= offset) {
	        chunks.push(chunks[0].slice(-offset));
	        length -= offset;
	        while (length >= chunks[chunks.length - 1].length) {
	          chunks.push(chunks[chunks.length - 1]);
	          length -= chunks[chunks.length - 1].length;
	        }
	      }
	      chunks.push(chunks[0].slice(-offset, -offset + length));
	    }
	  }
	  var o = u8concat(chunks);
	  if (o.length != usz)
	    throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
	  return o;
	}
	function decompress_iwa_file(buf) {
	  var out = [];
	  var l = 0;
	  while (l < buf.length) {
	    var t = buf[l++];
	    var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
	    l += 3;
	    out.push(parse_snappy_chunk(t, buf.slice(l, l + len)));
	    l += len;
	  }
	  if (l !== buf.length)
	    throw new Error("data is not a valid framed stream!");
	  return u8concat(out);
	}
	function compress_iwa_file(buf) {
	  var out = [];
	  var l = 0;
	  while (l < buf.length) {
	    var c = Math.min(buf.length - l, 268435455);
	    var frame = new Uint8Array(4);
	    out.push(frame);
	    var usz = write_varint49(c);
	    var L = usz.length;
	    out.push(usz);
	    if (c <= 60) {
	      L++;
	      out.push(new Uint8Array([c - 1 << 2]));
	    } else if (c <= 256) {
	      L += 2;
	      out.push(new Uint8Array([240, c - 1 & 255]));
	    } else if (c <= 65536) {
	      L += 3;
	      out.push(new Uint8Array([244, c - 1 & 255, c - 1 >> 8 & 255]));
	    } else if (c <= 16777216) {
	      L += 4;
	      out.push(new Uint8Array([248, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255]));
	    } else if (c <= 4294967296) {
	      L += 5;
	      out.push(new Uint8Array([252, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255, c - 1 >>> 24 & 255]));
	    }
	    out.push(buf.slice(l, l + c));
	    L += c;
	    frame[0] = 0;
	    frame[1] = L & 255;
	    frame[2] = L >> 8 & 255;
	    frame[3] = L >> 16 & 255;
	    l += c;
	  }
	  return u8concat(out);
	}
	function parse_old_storage(buf, sst, rsst, v) {
	  var dv = u8_to_dataview(buf);
	  var flags = dv.getUint32(4, true);
	  var data_offset = (v > 1 ? 12 : 8) + popcnt(flags & (v > 1 ? 3470 : 398)) * 4;
	  var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
	  if (flags & 512) {
	    ridx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  data_offset += popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
	  if (flags & 16) {
	    sidx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  if (flags & 32) {
	    ieee = dv.getFloat64(data_offset, true);
	    data_offset += 8;
	  }
	  if (flags & 64) {
	    dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
	    data_offset += 8;
	  }
	  var ret;
	  switch (buf[2]) {
	    case 0:
	      break;
	    case 2:
	      ret = { t: "n", v: ieee };
	      break;
	    case 3:
	      ret = { t: "s", v: sst[sidx] };
	      break;
	    case 5:
	      ret = { t: "d", v: dt };
	      break;
	    case 6:
	      ret = { t: "b", v: ieee > 0 };
	      break;
	    case 7:
	      ret = { t: "n", v: ieee / 86400 };
	      break;
	    case 8:
	      ret = { t: "e", v: 0 };
	      break;
	    case 9:
	      {
	        if (ridx > -1)
	          ret = { t: "s", v: rsst[ridx] };
	        else if (sidx > -1)
	          ret = { t: "s", v: sst[sidx] };
	        else if (!isNaN(ieee))
	          ret = { t: "n", v: ieee };
	        else
	          throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
	      }
	      break;
	    default:
	      throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
	  }
	  return ret;
	}
	function parse_new_storage(buf, sst, rsst) {
	  var dv = u8_to_dataview(buf);
	  var flags = dv.getUint32(8, true);
	  var data_offset = 12;
	  var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
	  if (flags & 1) {
	    d128 = readDecimal128LE(buf, data_offset);
	    data_offset += 16;
	  }
	  if (flags & 2) {
	    ieee = dv.getFloat64(data_offset, true);
	    data_offset += 8;
	  }
	  if (flags & 4) {
	    dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
	    data_offset += 8;
	  }
	  if (flags & 8) {
	    sidx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  if (flags & 16) {
	    ridx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  var ret;
	  switch (buf[1]) {
	    case 0:
	      break;
	    case 2:
	      ret = { t: "n", v: d128 };
	      break;
	    case 3:
	      ret = { t: "s", v: sst[sidx] };
	      break;
	    case 5:
	      ret = { t: "d", v: dt };
	      break;
	    case 6:
	      ret = { t: "b", v: ieee > 0 };
	      break;
	    case 7:
	      ret = { t: "n", v: ieee / 86400 };
	      break;
	    case 8:
	      ret = { t: "e", v: 0 };
	      break;
	    case 9:
	      {
	        if (ridx > -1)
	          ret = { t: "s", v: rsst[ridx] };
	        else
	          throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
	      }
	      break;
	    case 10:
	      ret = { t: "n", v: d128 };
	      break;
	    default:
	      throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
	  }
	  return ret;
	}
	function write_new_storage(cell, sst) {
	  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
	  out[0] = 5;
	  switch (cell.t) {
	    case "n":
	      out[1] = 2;
	      writeDecimal128LE(out, l, cell.v);
	      flags |= 1;
	      l += 16;
	      break;
	    case "b":
	      out[1] = 6;
	      dv.setFloat64(l, cell.v ? 1 : 0, true);
	      flags |= 2;
	      l += 8;
	      break;
	    case "s":
	      if (sst.indexOf(cell.v) == -1)
	        throw new Error("Value ".concat(cell.v, " missing from SST!"));
	      out[1] = 3;
	      dv.setUint32(l, sst.indexOf(cell.v), true);
	      flags |= 8;
	      l += 4;
	      break;
	    default:
	      throw "unsupported cell type " + cell.t;
	  }
	  dv.setUint32(8, flags, true);
	  return out.slice(0, l);
	}
	function write_old_storage(cell, sst) {
	  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
	  out[0] = 3;
	  switch (cell.t) {
	    case "n":
	      out[2] = 2;
	      dv.setFloat64(l, cell.v, true);
	      flags |= 32;
	      l += 8;
	      break;
	    case "b":
	      out[2] = 6;
	      dv.setFloat64(l, cell.v ? 1 : 0, true);
	      flags |= 32;
	      l += 8;
	      break;
	    case "s":
	      if (sst.indexOf(cell.v) == -1)
	        throw new Error("Value ".concat(cell.v, " missing from SST!"));
	      out[2] = 3;
	      dv.setUint32(l, sst.indexOf(cell.v), true);
	      flags |= 16;
	      l += 4;
	      break;
	    default:
	      throw "unsupported cell type " + cell.t;
	  }
	  dv.setUint32(4, flags, true);
	  return out.slice(0, l);
	}
	function parse_cell_storage(buf, sst, rsst) {
	  switch (buf[0]) {
	    case 0:
	    case 1:
	    case 2:
	    case 3:
	      return parse_old_storage(buf, sst, rsst, buf[0]);
	    case 5:
	      return parse_new_storage(buf, sst, rsst);
	    default:
	      throw new Error("Unsupported payload version ".concat(buf[0]));
	  }
	}
	function parse_TSP_Reference(buf) {
	  var pb = parse_shallow(buf);
	  return parse_varint49(pb[1][0].data);
	}
	function write_TSP_Reference(idx) {
	  var out = [];
	  out[1] = [{ type: 0, data: write_varint49(idx) }];
	  return write_shallow(out);
	}
	function parse_TST_TableDataList(M, root) {
	  var pb = parse_shallow(root.data);
	  var type = varint_to_i32(pb[1][0].data);
	  var entries = pb[3];
	  var data = [];
	  (entries || []).forEach(function(entry) {
	    var le = parse_shallow(entry.data);
	    var key = varint_to_i32(le[1][0].data) >>> 0;
	    switch (type) {
	      case 1:
	        data[key] = u8str(le[3][0].data);
	        break;
	      case 8:
	        {
	          var rt = M[parse_TSP_Reference(le[9][0].data)][0];
	          var rtp = parse_shallow(rt.data);
	          var rtpref = M[parse_TSP_Reference(rtp[1][0].data)][0];
	          var mtype = varint_to_i32(rtpref.meta[1][0].data);
	          if (mtype != 2001)
	            throw new Error("2000 unexpected reference to ".concat(mtype));
	          var tswpsa = parse_shallow(rtpref.data);
	          data[key] = tswpsa[3].map(function(x) {
	            return u8str(x.data);
	          }).join("");
	        }
	        break;
	    }
	  });
	  return data;
	}
	function parse_TST_TileRowInfo(u8, type) {
	  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
	  var pb = parse_shallow(u8);
	  var R = varint_to_i32(pb[1][0].data) >>> 0;
	  var cnt = varint_to_i32(pb[2][0].data) >>> 0;
	  var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && varint_to_i32(pb[8][0].data) > 0 || false;
	  var used_storage_u8, used_storage;
	  if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
	    used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
	    used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
	  } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
	    used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
	    used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
	  } else
	    throw "NUMBERS Tile missing ".concat(type, " cell storage");
	  var width = wide_offsets ? 4 : 1;
	  var used_storage_offsets = u8_to_dataview(used_storage_u8);
	  var offsets = [];
	  for (var C = 0; C < used_storage_u8.length / 2; ++C) {
	    var off = used_storage_offsets.getUint16(C * 2, true);
	    if (off < 65535)
	      offsets.push([C, off]);
	  }
	  if (offsets.length != cnt)
	    throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
	  var cells = [];
	  for (C = 0; C < offsets.length - 1; ++C)
	    cells[offsets[C][0]] = used_storage.subarray(offsets[C][1] * width, offsets[C + 1][1] * width);
	  if (offsets.length >= 1)
	    cells[offsets[offsets.length - 1][0]] = used_storage.subarray(offsets[offsets.length - 1][1] * width);
	  return { R: R, cells: cells };
	}
	function parse_TST_Tile(M, root) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var storage = ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) ? varint_to_i32(pb[7][0].data) >>> 0 > 0 ? 1 : 0 : -1;
	  var ri = mappa(pb[5], function(u8) {
	    return parse_TST_TileRowInfo(u8, storage);
	  });
	  return {
	    nrows: varint_to_i32(pb[4][0].data) >>> 0,
	    data: ri.reduce(function(acc, x) {
	      if (!acc[x.R])
	        acc[x.R] = [];
	      x.cells.forEach(function(cell, C) {
	        if (acc[x.R][C])
	          throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
	        acc[x.R][C] = cell;
	      });
	      return acc;
	    }, [])
	  };
	}
	function parse_TST_TableModelArchive(M, root, ws) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var range = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
	  range.e.r = (varint_to_i32(pb[6][0].data) >>> 0) - 1;
	  if (range.e.r < 0)
	    throw new Error("Invalid row varint ".concat(pb[6][0].data));
	  range.e.c = (varint_to_i32(pb[7][0].data) >>> 0) - 1;
	  if (range.e.c < 0)
	    throw new Error("Invalid col varint ".concat(pb[7][0].data));
	  ws["!ref"] = encode_range(range);
	  var store = parse_shallow(pb[4][0].data);
	  var sst = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[4][0].data)][0]);
	  var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? parse_TST_TableDataList(M, M[parse_TSP_Reference(store[17][0].data)][0]) : [];
	  var tile = parse_shallow(store[3][0].data);
	  var _R = 0;
	  tile[1].forEach(function(t) {
	    var tl = parse_shallow(t.data);
	    var ref = M[parse_TSP_Reference(tl[2][0].data)][0];
	    var mtype = varint_to_i32(ref.meta[1][0].data);
	    if (mtype != 6002)
	      throw new Error("6001 unexpected reference to ".concat(mtype));
	    var _tile = parse_TST_Tile(M, ref);
	    _tile.data.forEach(function(row, R) {
	      row.forEach(function(buf, C) {
	        var addr = encode_cell({ r: _R + R, c: C });
	        var res = parse_cell_storage(buf, sst, rsst);
	        if (res)
	          ws[addr] = res;
	      });
	    });
	    _R += _tile.nrows;
	  });
	}
	function parse_TST_TableInfoArchive(M, root) {
	  var pb = parse_shallow(root.data);
	  var out = { "!ref": "A1" };
	  var tableref = M[parse_TSP_Reference(pb[2][0].data)];
	  var mtype = varint_to_i32(tableref[0].meta[1][0].data);
	  if (mtype != 6001)
	    throw new Error("6000 unexpected reference to ".concat(mtype));
	  parse_TST_TableModelArchive(M, tableref[0], out);
	  return out;
	}
	function parse_TN_SheetArchive(M, root) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var out = {
	    name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? u8str(pb[1][0].data) : "",
	    sheets: []
	  };
	  var shapeoffs = mappa(pb[2], parse_TSP_Reference);
	  shapeoffs.forEach(function(off) {
	    M[off].forEach(function(m) {
	      var mtype = varint_to_i32(m.meta[1][0].data);
	      if (mtype == 6e3)
	        out.sheets.push(parse_TST_TableInfoArchive(M, m));
	    });
	  });
	  return out;
	}
	function parse_TN_DocumentArchive(M, root) {
	  var out = book_new();
	  var pb = parse_shallow(root.data);
	  var sheetoffs = mappa(pb[1], parse_TSP_Reference);
	  sheetoffs.forEach(function(off) {
	    M[off].forEach(function(m) {
	      var mtype = varint_to_i32(m.meta[1][0].data);
	      if (mtype == 2) {
	        var root2 = parse_TN_SheetArchive(M, m);
	        root2.sheets.forEach(function(sheet, idx) {
	          book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
	        });
	      }
	    });
	  });
	  if (out.SheetNames.length == 0)
	    throw new Error("Empty NUMBERS file");
	  return out;
	}
	function parse_numbers_iwa(cfb) {
	  var _a, _b, _c, _d;
	  var M = {}, indices = [];
	  cfb.FullPaths.forEach(function(p) {
	    if (p.match(/\.iwpv2/))
	      throw new Error("Unsupported password protection");
	  });
	  cfb.FileIndex.forEach(function(s) {
	    if (!s.name.match(/\.iwa$/))
	      return;
	    var o;
	    try {
	      o = decompress_iwa_file(s.content);
	    } catch (e) {
	      return console.log("?? " + s.content.length + " " + (e.message || e));
	    }
	    var packets;
	    try {
	      packets = parse_iwa_file(o);
	    } catch (e) {
	      return console.log("## " + (e.message || e));
	    }
	    packets.forEach(function(packet) {
	      M[packet.id] = packet.messages;
	      indices.push(packet.id);
	    });
	  });
	  if (!indices.length)
	    throw new Error("File has no messages");
	  var docroot = ((_d = (_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta) == null ? void 0 : _c[1]) == null ? void 0 : _d[0].data) && varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
	  if (!docroot)
	    indices.forEach(function(idx) {
	      M[idx].forEach(function(iwam) {
	        var mtype = varint_to_i32(iwam.meta[1][0].data) >>> 0;
	        if (mtype == 1) {
	          if (!docroot)
	            docroot = iwam;
	          else
	            throw new Error("Document has multiple roots");
	        }
	      });
	    });
	  if (!docroot)
	    throw new Error("Cannot find Document root");
	  return parse_TN_DocumentArchive(M, docroot);
	}
	function write_tile_row(tri, data, SST) {
	  var _a, _b, _c, _d;
	  if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0]))
	    throw "Mutation only works on post-BNC storages!";
	  var wide_offsets = ((_d = (_c = tri[8]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && varint_to_i32(tri[8][0].data) > 0 || false;
	  if (wide_offsets)
	    throw "Math only works with normal offsets";
	  var cnt = 0;
	  var dv = u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
	  var _dv = u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
	  for (var C = 0; C < data.length; ++C) {
	    if (data[C] == null) {
	      dv.setUint16(C * 2, 65535, true);
	      _dv.setUint16(C * 2, 65535);
	      continue;
	    }
	    dv.setUint16(C * 2, last_offset, true);
	    _dv.setUint16(C * 2, _last_offset, true);
	    var celload, _celload;
	    switch (typeof data[C]) {
	      case "string":
	        celload = write_new_storage({ t: "s", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "s", v: data[C] }, SST);
	        break;
	      case "number":
	        celload = write_new_storage({ t: "n", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "n", v: data[C] }, SST);
	        break;
	      case "boolean":
	        celload = write_new_storage({ t: "b", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "b", v: data[C] }, SST);
	        break;
	      default:
	        throw new Error("Unsupported value " + data[C]);
	    }
	    cell_storage.push(celload);
	    last_offset += celload.length;
	    _cell_storage.push(_celload);
	    _last_offset += _celload.length;
	    ++cnt;
	  }
	  tri[2][0].data = write_varint49(cnt);
	  for (; C < tri[7][0].data.length / 2; ++C) {
	    dv.setUint16(C * 2, 65535, true);
	    _dv.setUint16(C * 2, 65535, true);
	  }
	  tri[6][0].data = u8concat(cell_storage);
	  tri[3][0].data = u8concat(_cell_storage);
	  return cnt;
	}
	function write_numbers_iwa(wb, opts) {
	  if (!opts || !opts.numbers)
	    throw new Error("Must pass a `numbers` option -- check the README");
	  var ws = wb.Sheets[wb.SheetNames[0]];
	  if (wb.SheetNames.length > 1)
	    console.error("The Numbers writer currently writes only the first table");
	  var range = decode_range(ws["!ref"]);
	  range.s.r = range.s.c = 0;
	  var trunc = false;
	  if (range.e.c > 9) {
	    trunc = true;
	    range.e.c = 9;
	  }
	  if (range.e.r > 49) {
	    trunc = true;
	    range.e.r = 49;
	  }
	  if (trunc)
	    console.error("The Numbers writer is currently limited to ".concat(encode_range(range)));
	  var data = sheet_to_json(ws, { range: range, header: 1 });
	  var SST = ["~Sh33tJ5~"];
	  data.forEach(function(row) {
	    return row.forEach(function(cell) {
	      if (typeof cell == "string")
	        SST.push(cell);
	    });
	  });
	  var dependents = {};
	  var indices = [];
	  var cfb = CFB.read(opts.numbers, { type: "base64" });
	  cfb.FileIndex.map(function(fi, idx) {
	    return [fi, cfb.FullPaths[idx]];
	  }).forEach(function(row) {
	    var fi = row[0], fp = row[1];
	    if (fi.type != 2)
	      return;
	    if (!fi.name.match(/\.iwa/))
	      return;
	    var old_content = fi.content;
	    var raw1 = decompress_iwa_file(old_content);
	    var x2 = parse_iwa_file(raw1);
	    x2.forEach(function(packet2) {
	      indices.push(packet2.id);
	      dependents[packet2.id] = { deps: [], location: fp, type: varint_to_i32(packet2.messages[0].meta[1][0].data) };
	    });
	  });
	  indices.sort(function(x2, y2) {
	    return x2 - y2;
	  });
	  var indices_varint = indices.filter(function(x2) {
	    return x2 > 1;
	  }).map(function(x2) {
	    return [x2, write_varint49(x2)];
	  });
	  cfb.FileIndex.map(function(fi, idx) {
	    return [fi, cfb.FullPaths[idx]];
	  }).forEach(function(row) {
	    var fi = row[0], fp = row[1];
	    if (!fi.name.match(/\.iwa/))
	      return;
	    var x2 = parse_iwa_file(decompress_iwa_file(fi.content));
	    x2.forEach(function(ia) {
	      ia.messages.forEach(function(m) {
	        indices_varint.forEach(function(ivi) {
	          if (ia.messages.some(function(mess) {
	            return varint_to_i32(mess.meta[1][0].data) != 11006 && u8contains(mess.data, ivi[1]);
	          })) {
	            dependents[ivi[0]].deps.push(ia.id);
	          }
	        });
	      });
	    });
	  });
	  function get_unique_msgid() {
	    for (var i = 927262; i < 2e6; ++i)
	      if (!dependents[i])
	        return i;
	    throw new Error("Too many messages");
	  }
	  var entry = CFB.find(cfb, dependents[1].location);
	  var x = parse_iwa_file(decompress_iwa_file(entry.content));
	  var docroot;
	  for (var xi = 0; xi < x.length; ++xi) {
	    var packet = x[xi];
	    if (packet.id == 1)
	      docroot = packet;
	  }
	  var sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[1][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  var pb = parse_shallow(docroot.messages[0].data);
	  {
	    pb[6][0].data = write_varint49(range.e.r + 1);
	    pb[7][0].data = write_varint49(range.e.c + 1);
	    var cruidsref = parse_TSP_Reference(pb[46][0].data);
	    var oldbucket = CFB.find(cfb, dependents[cruidsref].location);
	    var _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	    {
	      for (var j = 0; j < _x.length; ++j) {
	        if (_x[j].id == cruidsref)
	          break;
	      }
	      if (_x[j].id != cruidsref)
	        throw "Bad ColumnRowUIDMapArchive";
	      var cruids = parse_shallow(_x[j].messages[0].data);
	      cruids[1] = [];
	      cruids[2] = [], cruids[3] = [];
	      for (var C = 0; C <= range.e.c; ++C) {
	        var uuid = [];
	        uuid[1] = uuid[2] = [{ type: 0, data: write_varint49(C + 420690) }];
	        cruids[1].push({ type: 2, data: write_shallow(uuid) });
	        cruids[2].push({ type: 0, data: write_varint49(C) });
	        cruids[3].push({ type: 0, data: write_varint49(C) });
	      }
	      cruids[4] = [];
	      cruids[5] = [], cruids[6] = [];
	      for (var R = 0; R <= range.e.r; ++R) {
	        uuid = [];
	        uuid[1] = uuid[2] = [{ type: 0, data: write_varint49(R + 726270) }];
	        cruids[4].push({ type: 2, data: write_shallow(uuid) });
	        cruids[5].push({ type: 0, data: write_varint49(R) });
	        cruids[6].push({ type: 0, data: write_varint49(R) });
	      }
	      _x[j].messages[0].data = write_shallow(cruids);
	    }
	    oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	    oldbucket.size = oldbucket.content.length;
	    delete pb[46];
	    var store = parse_shallow(pb[4][0].data);
	    {
	      store[7][0].data = write_varint49(range.e.r + 1);
	      var row_headers = parse_shallow(store[1][0].data);
	      var row_header_ref = parse_TSP_Reference(row_headers[2][0].data);
	      oldbucket = CFB.find(cfb, dependents[row_header_ref].location);
	      _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	      {
	        if (_x[0].id != row_header_ref)
	          throw "Bad HeaderStorageBucket";
	        var base_bucket = parse_shallow(_x[0].messages[0].data);
	        for (R = 0; R < data.length; ++R) {
	          var _bucket = parse_shallow(base_bucket[2][0].data);
	          _bucket[1][0].data = write_varint49(R);
	          _bucket[4][0].data = write_varint49(data[R].length);
	          base_bucket[2][R] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
	        }
	        _x[0].messages[0].data = write_shallow(base_bucket);
	      }
	      oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	      oldbucket.size = oldbucket.content.length;
	      var col_header_ref = parse_TSP_Reference(store[2][0].data);
	      oldbucket = CFB.find(cfb, dependents[col_header_ref].location);
	      _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	      {
	        if (_x[0].id != col_header_ref)
	          throw "Bad HeaderStorageBucket";
	        base_bucket = parse_shallow(_x[0].messages[0].data);
	        for (C = 0; C <= range.e.c; ++C) {
	          _bucket = parse_shallow(base_bucket[2][0].data);
	          _bucket[1][0].data = write_varint49(C);
	          _bucket[4][0].data = write_varint49(range.e.r + 1);
	          base_bucket[2][C] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
	        }
	        _x[0].messages[0].data = write_shallow(base_bucket);
	      }
	      oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	      oldbucket.size = oldbucket.content.length;
	      var sstref = parse_TSP_Reference(store[4][0].data);
	      (function() {
	        var sentry = CFB.find(cfb, dependents[sstref].location);
	        var sx = parse_iwa_file(decompress_iwa_file(sentry.content));
	        var sstroot;
	        for (var sxi = 0; sxi < sx.length; ++sxi) {
	          var packet2 = sx[sxi];
	          if (packet2.id == sstref)
	            sstroot = packet2;
	        }
	        var sstdata = parse_shallow(sstroot.messages[0].data);
	        {
	          sstdata[3] = [];
	          var newsst = [];
	          SST.forEach(function(str, i) {
	            newsst[1] = [{ type: 0, data: write_varint49(i) }];
	            newsst[2] = [{ type: 0, data: write_varint49(1) }];
	            newsst[3] = [{ type: 2, data: stru8(str) }];
	            sstdata[3].push({ type: 2, data: write_shallow(newsst) });
	          });
	        }
	        sstroot.messages[0].data = write_shallow(sstdata);
	        var sy = write_iwa_file(sx);
	        var raw32 = compress_iwa_file(sy);
	        sentry.content = raw32;
	        sentry.size = sentry.content.length;
	      })();
	      var tile = parse_shallow(store[3][0].data);
	      {
	        var t = tile[1][0];
	        delete tile[2];
	        var tl = parse_shallow(t.data);
	        {
	          var tileref = parse_TSP_Reference(tl[2][0].data);
	          (function() {
	            var tentry = CFB.find(cfb, dependents[tileref].location);
	            var tx = parse_iwa_file(decompress_iwa_file(tentry.content));
	            var tileroot;
	            for (var sxi = 0; sxi < tx.length; ++sxi) {
	              var packet2 = tx[sxi];
	              if (packet2.id == tileref)
	                tileroot = packet2;
	            }
	            var tiledata = parse_shallow(tileroot.messages[0].data);
	            {
	              delete tiledata[6];
	              delete tile[7];
	              var rowload = new Uint8Array(tiledata[5][0].data);
	              tiledata[5] = [];
	              var cnt = 0;
	              for (var R2 = 0; R2 <= range.e.r; ++R2) {
	                var tilerow = parse_shallow(rowload);
	                cnt += write_tile_row(tilerow, data[R2], SST);
	                tilerow[1][0].data = write_varint49(R2);
	                tiledata[5].push({ data: write_shallow(tilerow), type: 2 });
	              }
	              tiledata[1] = [{ type: 0, data: write_varint49(range.e.c + 1) }];
	              tiledata[2] = [{ type: 0, data: write_varint49(range.e.r + 1) }];
	              tiledata[3] = [{ type: 0, data: write_varint49(cnt) }];
	              tiledata[4] = [{ type: 0, data: write_varint49(range.e.r + 1) }];
	            }
	            tileroot.messages[0].data = write_shallow(tiledata);
	            var ty = write_iwa_file(tx);
	            var raw32 = compress_iwa_file(ty);
	            tentry.content = raw32;
	            tentry.size = tentry.content.length;
	          })();
	        }
	        t.data = write_shallow(tl);
	      }
	      store[3][0].data = write_shallow(tile);
	    }
	    pb[4][0].data = write_shallow(store);
	  }
	  docroot.messages[0].data = write_shallow(pb);
	  var y = write_iwa_file(x);
	  var raw3 = compress_iwa_file(y);
	  entry.content = raw3;
	  entry.size = entry.content.length;
	  return cfb;
	}
	function fix_opts_func(defaults) {
		return function fix_opts(opts) {
			for(var i = 0; i != defaults.length; ++i) {
				var d = defaults[i];
				if(opts[d[0]] === undefined) opts[d[0]] = d[1];
				if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
			}
		};
	}
	
	function fix_read_opts(opts) {
	fix_opts_func([
		['cellNF', false], /* emit cell number format string as .z */
		['cellHTML', true], /* emit html string as .h */
		['cellFormula', true], /* emit formulae as .f */
		['cellStyles', false], /* emits style/theme as .s */
		['cellText', true], /* emit formatted text as .w */
		['cellDates', false], /* emit date cells with type `d` */
	
		['sheetStubs', false], /* emit empty cells */
		['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */
	
		['bookDeps', false], /* parse calculation chains */
		['bookSheets', false], /* only try to get sheet names (no Sheets) */
		['bookProps', false], /* only try to get properties (no Sheets) */
		['bookFiles', false], /* include raw file structure (keys, files, cfb) */
		['bookVBA', false], /* include vba raw data (vbaraw) */
	
		['password',''], /* password */
		['WTF', false] /* WTF mode (throws errors) */
	])(opts);
	}
	
	function fix_write_opts(opts) {
	fix_opts_func([
		['cellDates', false], /* write date cells with type `d` */
	
		['bookSST', false], /* Generate Shared String Table */
	
		['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */
	
		['compression', false], /* Use file compression */
	
		['WTF', false] /* WTF mode (throws errors) */
	])(opts);
	}
	function get_sheet_type(n) {
		if(RELS.WS.indexOf(n) > -1) return "sheet";
		if(RELS.CS && n == RELS.CS) return "chart";
		if(RELS.DS && n == RELS.DS) return "dialog";
		if(RELS.MS && n == RELS.MS) return "macro";
		return (n && n.length) ? n : "sheet";
	}
	function safe_parse_wbrels(wbrels, sheets) {
		if(!wbrels) return 0;
		try {
			wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
		} catch(e) { return null; }
		return !wbrels || wbrels.length === 0 ? null : wbrels;
	}
	
	function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
		try {
			sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
			var data = getzipdata(zip, path);
			var _ws;
			switch(stype) {
				case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
					if(!_ws || !_ws['!drawel']) break;
					var dfile = resolve_path(_ws['!drawel'].Target, path);
					var drelsp = get_rels_path(dfile);
					var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
					var chartp = resolve_path(draw, dfile);
					var crelsp = get_rels_path(chartp);
					_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
					break;
				case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				default: throw new Error("Unrecognized sheet type " + stype);
			}
			sheets[sheet] = _ws;
	
			/* scan rels for comments and threaded comments */
			var tcomments = [];
			if(sheetRels && sheetRels[sheet]) keys(sheetRels[sheet]).forEach(function(n) {
				var dfile = "";
				if(sheetRels[sheet][n].Type == RELS.CMNT) {
					dfile = resolve_path(sheetRels[sheet][n].Target, path);
					var comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
					if(!comments || !comments.length) return;
					sheet_insert_comments(_ws, comments, false);
				}
				if(sheetRels[sheet][n].Type == RELS.TCMNT) {
					dfile = resolve_path(sheetRels[sheet][n].Target, path);
					tcomments = tcomments.concat(parse_tcmnt_xml(getzipdata(zip, dfile, true), opts));
				}
			});
			if(tcomments && tcomments.length) sheet_insert_comments(_ws, tcomments, true, opts.people || []);
		} catch(e) { if(opts.WTF) throw e; }
	}
	
	function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }
	
	function parse_zip(zip, opts) {
		make_ssf();
		opts = opts || {};
		fix_read_opts(opts);
	
		/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
		/* UOC */
		if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
		/* Numbers */
		if(safegetzipfile(zip, 'Index/Document.iwa')) {
			if(typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
			if(typeof parse_numbers_iwa != "undefined") {
				if(zip.FileIndex) return parse_numbers_iwa(zip);
				var _zip = CFB.utils.cfb_new();
				zipentries(zip).forEach(function(e) { zip_add_file(_zip, e, getzipbin(zip, e)); });
				return parse_numbers_iwa(_zip);
			}
			throw new Error('Unsupported NUMBERS file');
		}
		if(!safegetzipfile(zip, '[Content_Types].xml')) {
			if(safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
			if(safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
			throw new Error('Unsupported ZIP file');
		}
	
		var entries = zipentries(zip);
		var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
		var xlsb = false;
		var sheets, binname;
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.xml";
			if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
		}
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.bin";
			if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
			dir.workbooks.push(binname);
			xlsb = true;
		}
		if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;
	
		var themes = ({});
		var styles = ({});
		if(!opts.bookSheets && !opts.bookProps) {
			strs = [];
			if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }
	
			if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);
	
			if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
		}
	
		/*var externbooks = */dir.links.map(function(link) {
			try {
				var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
				return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
			} catch(e) {}
		});
	
		var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
	
		var props = {}, propdata = "";
	
		if(dir.coreprops.length) {
			propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
			if(propdata) props = parse_core_props(propdata);
			if(dir.extprops.length !== 0) {
				propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
				if(propdata) parse_ext_props(propdata, props, opts);
			}
		}
	
		var custprops = {};
		if(!opts.bookSheets || opts.bookProps) {
			if (dir.custprops.length !== 0) {
				propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
				if(propdata) custprops = parse_cust_props(propdata, opts);
			}
		}
	
		var out = ({});
		if(opts.bookSheets || opts.bookProps) {
			if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
			else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
			if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
			if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
			if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
		}
		sheets = {};
	
		var deps = {};
		if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);
	
		var i=0;
		var sheetRels = ({});
		var path, relsPath;
	
		{
			var wbsheets = wb.Sheets;
			props.Worksheets = wbsheets.length;
			props.SheetNames = [];
			for(var j = 0; j != wbsheets.length; ++j) {
				props.SheetNames[j] = wbsheets[j].name;
			}
		}
	
		var wbext = xlsb ? "bin" : "xml";
		var wbrelsi = dir.workbooks[0].lastIndexOf("/");
		var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
		if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
		var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
	
		if((dir.metadata || []).length >= 1) {
			/* TODO: MDX and other types of metadata */
			opts.xlmeta = parse_xlmeta(getzipdata(zip, strip_front_slash(dir.metadata[0])),dir.metadata[0],opts);
		}
	
		if((dir.people || []).length >= 1) {
			opts.people = parse_people_xml(getzipdata(zip, strip_front_slash(dir.people[0])),opts);
		}
	
		if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);
	
		/* Numbers iOS hack */
		var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
		wsloop: for(i = 0; i != props.Worksheets; ++i) {
			var stype = "sheet";
			if(wbrels && wbrels[i]) {
				path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
				if(!safegetzipfile(zip, path)) path = wbrels[i][1];
				if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
				stype = wbrels[i][2];
			} else {
				path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
				path = path.replace(/sheet0\./,"sheet.");
			}
			relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
			if(opts && opts.sheets != null) switch(typeof opts.sheets) {
				case "number": if(i != opts.sheets) continue wsloop; break;
				case "string": if(props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop; break;
				default: if(Array.isArray && Array.isArray(opts.sheets)) {
					var snjseen = false;
					for(var snj = 0; snj != opts.sheets.length; ++snj) {
						if(typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen=1;
						if(typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
					}
					if(!snjseen) continue wsloop;
				}
			}
			safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
		}
	
		out = ({
			Directory: dir,
			Workbook: wb,
			Props: props,
			Custprops: custprops,
			Deps: deps,
			Sheets: sheets,
			SheetNames: props.SheetNames,
			Strings: strs,
			Styles: styles,
			Themes: themes,
			SSF: dup(table_fmt)
		});
		if(opts && opts.bookFiles) {
			if(zip.files) {
				out.keys = entries;
				out.files = zip.files;
			} else {
				out.keys = [];
				out.files = {};
				zip.FullPaths.forEach(function(p, idx) {
					p = p.replace(/^Root Entry[\/]/, "");
					out.keys.push(p);
					out.files[p] = zip.FileIndex[idx];
				});
			}
		}
		if(opts && opts.bookVBA) {
			if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
			else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
		}
		return out;
	}
	
	/* [MS-OFFCRYPTO] 2.1.1 */
	function parse_xlsxcfb(cfb, _opts) {
		var opts = _opts || {};
		var f = 'Workbook', data = CFB.find(cfb, f);
		try {
		f = '/!DataSpaces/Version';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var version = */parse_DataSpaceVersionInfo(data.content);
	
		/* 2.3.4.1 */
		f = '/!DataSpaces/DataSpaceMap';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var dsm = parse_DataSpaceMap(data.content);
		if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.2 */
		f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var seds = parse_DataSpaceDefinition(data.content);
		if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.3 */
		f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var hdr = */parse_Primary(data.content);
		} catch(e) {}
	
		f = '/EncryptionInfo';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var einfo = parse_EncryptionInfo(data.content);
	
		/* 2.3.4.4 */
		f = '/EncryptedPackage';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	
	/*global decrypt_agile */
	if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
	/*global decrypt_std76 */
	if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
		throw new Error("File is password-protected");
	}
	
	function write_zip(wb, opts) {
		if(opts.bookType == "ods") return write_ods(wb, opts);
		if(opts.bookType == "numbers") return write_numbers_iwa(wb, opts);
		if(opts.bookType == "xlsb") return write_zip_xlsxb(wb, opts);
		return write_zip_xlsx(wb, opts);
	}
	
	/* XLSX and XLSB writing are very similar.  Originally they were unified in one
	   export function.  This is horrible for tree shaking in the common case (most
	   applications need to export files in one format) so this function supports
	   both formats while write_zip_xlsx only handles XLSX */
	function write_zip_xlsxb(wb, opts) {
		_shapeid = 1024;
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		if(browser_has_Map) opts.revStrings = new Map();
		else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
		var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
		var zip = zip_new();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip_add_file(zip, f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		else {
			var _sn = [];
			for(var _i = 0; _i < wb.SheetNames.length; ++_i)
				if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
			wb.Props.SheetNames = _sn;
		}
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip_add_file(zip, f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart":
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip_add_file(zip, f, write_ws(rId-1, f, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				var need_vml = false;
				var cf = "";
				if(comments && comments.length > 0) {
					cf = "xl/comments" + rId + "." + wbext;
					zip_add_file(zip, cf, write_cmnt(comments, cf, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
					need_vml = true;
				}
				if(ws['!legacy']) {
					if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip_add_file(zip, f, write_sst(opts.Strings, f, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		f = "xl/workbook." + wbext;
		zip_add_file(zip, f, write_wb(wb, f, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip_add_file(zip, f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip_add_file(zip, f, write_sty(wb, f, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip_add_file(zip, f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		f = "xl/metadata." + wbext;
		zip_add_file(zip, f, write_xlmeta(f));
		ct.metadata.push(f);
		add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);
	
		zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
		zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
		zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	
	function write_zip_xlsx(wb, opts) {
		_shapeid = 1024;
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		if(browser_has_Map) opts.revStrings = new Map();
		else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
		var wbext = "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
		var zip = zip_new();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip_add_file(zip, f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		else {
			var _sn = [];
			for(var _i = 0; _i < wb.SheetNames.length; ++_i)
				if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
			wb.Props.SheetNames = _sn;
		}
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip_add_file(zip, f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		var people = ["SheetJ5"];
		opts.tcid = 0;
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart":
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip_add_file(zip, f, write_ws_xml(rId-1, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				var need_vml = false;
				var cf = "";
				if(comments && comments.length > 0) {
					var needtc = false;
					comments.forEach(function(carr) {
						carr[1].forEach(function(c) { if(c.T == true) needtc = true; });
					});
					if(needtc) {
						cf = "xl/threadedComments/threadedComment" + rId + "." + wbext;
						zip_add_file(zip, cf, write_tcmnt_xml(comments, people, opts));
						ct.threadedcomments.push(cf);
						add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + "." + wbext, RELS.TCMNT);
					}
	
					cf = "xl/comments" + rId + "." + wbext;
					zip_add_file(zip, cf, write_comments_xml(comments, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
					need_vml = true;
				}
				if(ws['!legacy']) {
					if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip_add_file(zip, f, write_sst_xml(opts.Strings, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		f = "xl/workbook." + wbext;
		zip_add_file(zip, f, write_wb_xml(wb, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip_add_file(zip, f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip_add_file(zip, f, write_sty_xml(wb, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip_add_file(zip, f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		f = "xl/metadata." + wbext;
		zip_add_file(zip, f, write_xlmeta_xml());
		ct.metadata.push(f);
		add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);
	
		if(people.length > 1) {
			f = "xl/persons/person.xml";
			zip_add_file(zip, f, write_people_xml(people, opts));
			ct.people.push(f);
			add_rels(opts.wbrels, -1, "persons/person.xml", RELS.PEOPLE);
		}
	
		zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
		zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
		zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	
	function firstbyte(f,o) {
		var x = "";
		switch((o||{}).type || "base64") {
			case 'buffer': return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
			case 'base64': x = Base64_decode(f.slice(0,12)); break;
			case 'binary': x = f; break;
			case 'array':  return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
			default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
		}
		return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3), x.charCodeAt(4), x.charCodeAt(5), x.charCodeAt(6), x.charCodeAt(7)];
	}
	
	function read_cfb(cfb, opts) {
		if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
		return parse_xlscfb(cfb, opts);
	}
	
	function read_zip(data, opts) {
		var zip, d = data;
		var o = opts||{};
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		zip = zip_read(d, o);
		return parse_zip(zip, o);
	}
	
	function read_plaintext(data, o) {
		var i = 0;
		main: while(i < data.length) switch(data.charCodeAt(i)) {
			case 0x0A: case 0x0D: case 0x20: ++i; break;
			case 0x3C: return parse_xlml(data.slice(i),o);
			default: break main;
		}
		return PRN.to_workbook(data, o);
	}
	
	function read_plaintext_raw(data, o) {
		var str = "", bytes = firstbyte(data, o);
		switch(o.type) {
			case 'base64': str = Base64_decode(data); break;
			case 'binary': str = data; break;
			case 'buffer': str = data.toString('binary'); break;
			case 'array': str = cc2str(data); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
		o.type = "binary";
		return read_plaintext(str, o);
	}
	
	function read_utf16(data, o) {
		var d = data;
		if(o.type == 'base64') d = Base64_decode(d);
		d = $cptable.utils.decode(1200, d.slice(2), 'str');
		o.type = "binary";
		return read_plaintext(d, o);
	}
	
	function bstrify(data) {
		return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
	}
	
	function read_prn(data, d, o, str) {
		if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
		return PRN.to_workbook(d, o);
	}
	
	function readSync(data, opts) {
		reset_cp();
		var o = opts||{};
		if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), (o = dup(o), o.type = "array", o));
		if(typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
		var d = data, n = [0,0,0,0], str = false;
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		_ssfopts = {};
		if(o.dateNF) _ssfopts.dateNF = o.dateNF;
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); if(typeof Uint8Array !== 'undefined' && !has_buf) o.type = "array"; }
		if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
		if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
			// $FlowIgnore
			var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
			// $FlowIgnore
			if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
		}
		switch((n = firstbyte(d, o))[0]) {
			case 0xD0: if(n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o); break;
			case 0x09: if(n[1] <= 0x08) return parse_xlscfb(d, o); break;
			case 0x3C: return parse_xlml(d, o);
			case 0x49:
				if(n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
				if(n[1] === 0x44) return read_wb_ID(d, o);
				break;
			case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
			case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
			case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
			case 0xFF:
				if(n[1] === 0xFE) { return read_utf16(d, o); }
				else if(n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
				break;
			case 0x00:
				if(n[1] === 0x00) {
					if(n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
					if(n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return WK_.to_workbook(d, o);
				}
				break;
			case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
			case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
			case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
			case 0x89: if(n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet"); break;
		}
		if(DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
		return read_prn(data, d, o, str);
	}
	
	function readFileSync(filename, opts) {
		var o = opts||{}; o.type = 'file';
		return readSync(filename, o);
	}
	function write_cfb_ctr(cfb, o) {
		switch(o.type) {
			case "base64": case "binary": break;
			case "buffer": case "array": o.type = ""; break;
			case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			default: throw new Error("Unrecognized type " + o.type);
		}
		return CFB.write(cfb, o);
	}
	
	function write_zip_type(wb, opts) {
		var o = dup(opts||{});
		var z = write_zip(wb, o);
		return write_zip_denouement(z, o);
	}
	function write_zip_typeXLSX(wb, opts) {
		var o = dup(opts||{});
		var z = write_zip_xlsx(wb, o);
		return write_zip_denouement(z, o);
	}
	function write_zip_denouement(z, o) {
		var oopts = {};
		var ftype = has_buf ? "nodebuffer" : (typeof Uint8Array !== "undefined" ? "array" : "string");
		if(o.compression) oopts.compression = 'DEFLATE';
		if(o.password) oopts.type = ftype;
		else switch(o.type) {
			case "base64": oopts.type = "base64"; break;
			case "binary": oopts.type = "string"; break;
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			case "buffer":
			case "file": oopts.type = ftype; break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		var out = z.FullPaths ? CFB.write(z, {fileType:"zip", type: {"nodebuffer": "buffer", "string": "binary"}[oopts.type] || oopts.type, compression: !!o.compression}) : z.generate(oopts);
		if(typeof Deno !== "undefined") {
			if(typeof out == "string") {
				if(o.type == "binary" || o.type == "base64") return out;
				out = new Uint8Array(s2ab(out));
			}
		}
	/*jshint -W083 */
		if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
	/*jshint +W083 */
		if(o.type === "file") return write_dl(o.file, out);
		return o.type == "string" ? utf8read(out) : out;
	}
	
	function write_cfb_type(wb, opts) {
		var o = opts||{};
		var cfb = write_xlscfb(wb, o);
		return write_cfb_ctr(cfb, o);
	}
	
	function write_string_type(out, opts, bom) {
		if(!bom) bom = "";
		var o = bom + out;
		switch(opts.type) {
			case "base64": return Base64_encode(utf8write(o));
			case "binary": return utf8write(o);
			case "string": return out;
			case "file": return write_dl(opts.file, o, 'utf8');
			case "buffer": {
				if(has_buf) return Buffer_from(o, 'utf8');
				else if(typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
				else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	function write_stxt_type(out, opts) {
		switch(opts.type) {
			case "base64": return Base64_encode(out);
			case "binary": return out;
			case "string": return out; /* override in sheet_to_txt */
			case "file": return write_dl(opts.file, out, 'binary');
			case "buffer": {
				if(has_buf) return Buffer_from(out, 'binary');
				else return out.split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	/* TODO: test consistency */
	function write_binary_type(out, opts) {
		switch(opts.type) {
			case "string":
			case "base64":
			case "binary":
				var bstr = "";
				// $FlowIgnore
				for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
				return opts.type == 'base64' ? Base64_encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
			case "file": return write_dl(opts.file, out);
			case "buffer": return out;
			default: throw new Error("Unrecognized type " + opts.type);
		}
	}
	
	function writeSyncXLSX(wb, opts) {
		reset_cp();
		check_wb(wb);
		var o = dup(opts||{});
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		if(o.type == "array") { o.type = "binary"; var out = (writeSyncXLSX(wb, o)); o.type = "array"; return s2ab(out); }
		return write_zip_typeXLSX(wb, o);
	}
	
	function writeSync(wb, opts) {
		reset_cp();
		check_wb(wb);
		var o = dup(opts||{});
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
		var idx = 0;
		if(o.sheet) {
			if(typeof o.sheet == "number") idx = o.sheet;
			else idx = wb.SheetNames.indexOf(o.sheet);
			if(!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + (typeof o.sheet));
		}
		switch(o.bookType || 'xlsb') {
			case 'xml':
			case 'xlml': return write_string_type(write_xlml(wb, o), o);
			case 'slk':
			case 'sylk': return write_string_type(SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'htm':
			case 'html': return write_string_type(sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'txt': return write_stxt_type(sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'csv': return write_string_type(sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
			case 'dif': return write_string_type(DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'dbf': return write_binary_type(DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'prn': return write_string_type(PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'rtf': return write_string_type(RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'eth': return write_string_type(ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'fods': return write_string_type(write_ods(wb, o), o);
			case 'wk1': return write_binary_type(WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'wk3': return write_binary_type(WK_.book_to_wk3(wb, o), o);
			case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
			case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
			case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
			case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
			case 'biff8':
			case 'xla':
			case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
			case 'xlsx':
			case 'xlsm':
			case 'xlam':
			case 'xlsb':
			case 'numbers':
			case 'ods': return write_zip_type(wb, o);
			default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
		}
	}
	
	function resolve_book_type(o) {
		if(o.bookType) return;
		var _BT = {
			"xls": "biff8",
			"htm": "html",
			"slk": "sylk",
			"socialcalc": "eth",
			"Sh33tJS": "WTF"
		};
		var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
		if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
		o.bookType = _BT[o.bookType] || o.bookType;
	}
	
	function writeFileSync(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSync(wb, o);
	}
	
	function writeFileSyncXLSX(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSyncXLSX(wb, o);
	}
	
	
	function writeFileAsync(filename, wb, opts, cb) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		o.type = 'buffer';
		var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
		return _fs.writeFile(filename, writeSync(wb, o), _cb);
	}
	function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
		var rr = encode_row(R);
		var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
		var isempty = true;
		var row = (header === 1) ? [] : {};
		if(header !== 1) {
			if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
			else row.__rowNum__ = R;
		}
		if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
			var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			if(val === undefined || val.t === undefined) {
				if(defval === undefined) continue;
				if(hdr[C] != null) { row[hdr[C]] = defval; }
				continue;
			}
			var v = val.v;
			switch(val.t){
				case 'z': if(v == null) break; continue;
				case 'e': v = (v == 0 ? null : void 0); break;
				case 's': case 'd': case 'b': case 'n': break;
				default: throw new Error('unrecognized type ' + val.t);
			}
			if(hdr[C] != null) {
				if(v == null) {
					if(val.t == "e" && v === null) row[hdr[C]] = null;
					else if(defval !== undefined) row[hdr[C]] = defval;
					else if(raw && v === null) row[hdr[C]] = null;
					else continue;
				} else {
					row[hdr[C]] = raw && (val.t !== "n" || (val.t === "n" && o.rawNumbers !== false)) ? v : format_cell(val,v,o);
				}
				if(v != null) isempty = false;
			}
		}
		return { row: row, isempty: isempty };
	}
	
	
	function sheet_to_json(sheet, opts) {
		if(sheet == null || sheet["!ref"] == null) return [];
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		else if(o.header == null) header = 0;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var out = [];
		var outi = 0, counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0;
		var header_cnt = {};
		if(dense && !sheet[R]) sheet[R] = [];
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			if(((colinfo[C]||{}).hidden)) continue;
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = header_cnt[v] || 0;
					if(!counter) header_cnt[v] = 1;
					else {
						do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
						header_cnt[vv] = 1;
					}
					hdr[C] = vv;
			}
		}
		for (R = r.s.r + offset; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
			if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
		}
		out.length = outi;
		return out;
	}
	
	var qreg = /"/g;
	function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
		var isempty = true;
		var row = [], txt = "", rr = encode_row(R);
		for(var C = r.s.c; C <= r.e.c; ++C) {
			if (!cols[C]) continue;
			var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
			if(val == null) txt = "";
			else if(val.v != null) {
				isempty = false;
				txt = ''+(o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
				for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
				if(txt == "ID") txt = '"ID"';
			} else if(val.f != null && !val.F) {
				isempty = false;
				txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
			} else txt = "";
			/* NOTE: Excel CSV does not support array formulae */
			row.push(txt);
		}
		if(o.blankrows === false && isempty) return null;
		return row.join(FS);
	}
	
	function sheet_to_csv(sheet, opts) {
		var out = [];
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) return "";
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var w = 0;
		for(var R = r.s.r; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
			if(row == null) { continue; }
			if(o.strip) row = row.replace(endregex,"");
			if(row || (o.blankrows !== false)) out.push((w++ ? RS : "") + row);
		}
		delete o.dense;
		return out.join("");
	}
	
	function sheet_to_txt(sheet, opts) {
		if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
		var s = sheet_to_csv(sheet, opts);
		if(typeof $cptable == 'undefined' || opts.type == 'string') return s;
		var o = $cptable.utils.encode(1200, s, 'str');
		return String.fromCharCode(255) + String.fromCharCode(254) + o;
	}
	
	function sheet_to_formulae(sheet) {
		var y = "", x, val="";
		if(sheet == null || sheet["!ref"] == null) return [];
		var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
		var cmds = [];
		var dense = Array.isArray(sheet);
		for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			rr = encode_row(R);
			for(C = r.s.c; C <= r.e.c; ++C) {
				y = cols[C] + rr;
				x = dense ? (sheet[R]||[])[C] : sheet[y];
				val = "";
				if(x === undefined) continue;
				else if(x.F != null) {
					y = x.F;
					if(!x.f) continue;
					val = x.f;
					if(y.indexOf(":") == -1) y = y + ":" + y;
				}
				if(x.f != null) val = x.f;
				else if(x.t == 'z') continue;
				else if(x.t == 'n' && x.v != null) val = "" + x.v;
				else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
				else if(x.w !== undefined) val = "'" + x.w;
				else if(x.v === undefined) continue;
				else if(x.t == 's') val = "'" + x.v;
				else val = ""+x.v;
				cmds[cmds.length] = y + "=" + val;
			}
		}
		return cmds;
	}
	
	function sheet_add_json(_ws, js, opts) {
		var o = opts || {};
		var offset = +!o.skipHeader;
		var ws = _ws || ({});
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
		}
		var cell;
		var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) { _R = _range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
		} else {
			if(_R == -1) { _R = 0; range.e.r = js.length - 1 + offset; }
		}
		var hdr = o.header || [], C = 0;
	
		js.forEach(function (JS, R) {
			keys(JS).forEach(function(k) {
				if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
				var v = JS[k];
				var t = 'z';
				var z = "";
				var ref = encode_cell({c:_C + C,r:_R + R + offset});
				cell = ws_get_cell_stub(ws, ref);
				if(v && typeof v === 'object' && !(v instanceof Date)){
					ws[ref] = v;
				} else {
					if(typeof v == 'number') t = 'n';
					else if(typeof v == 'boolean') t = 'b';
					else if(typeof v == 'string') t = 's';
					else if(v instanceof Date) {
						t = 'd';
						if(!o.cellDates) { t = 'n'; v = datenum(v); }
						z = (o.dateNF || table_fmt[14]);
					}
					else if(v === null && o.nullError) { t = 'e'; v = 0; }
					if(!cell) ws[ref] = cell = ({t:t, v:v});
					else {
						cell.t = t; cell.v = v;
						delete cell.w; delete cell.R;
						if(z) cell.z = z;
					}
					if(z) cell.z = z;
				}
			});
		});
		range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
		var __R = encode_row(_R);
		if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
		ws['!ref'] = encode_range(range);
		return ws;
	}
	function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }
	
	/* get cell, creating a stub if necessary */
	function ws_get_cell_stub(ws, R, C) {
		/* A1 cell address */
		if(typeof R == "string") {
			/* dense */
			if(Array.isArray(ws)) {
				var RC = decode_cell(R);
				if(!ws[RC.r]) ws[RC.r] = [];
				return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {t:'z'});
			}
			return ws[R] || (ws[R] = {t:'z'});
		}
		/* cell address object */
		if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
		/* R and C are 0-based indices */
		return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
	}
	
	/* find sheet index for given name / validate index */
	function wb_sheet_idx(wb, sh) {
		if(typeof sh == "number") {
			if(sh >= 0 && wb.SheetNames.length > sh) return sh;
			throw new Error("Cannot find sheet # " + sh);
		} else if(typeof sh == "string") {
			var idx = wb.SheetNames.indexOf(sh);
			if(idx > -1) return idx;
			throw new Error("Cannot find sheet name |" + sh + "|");
		} else throw new Error("Cannot find sheet |" + sh + "|");
	}
	
	/* simple blank workbook object */
	function book_new() {
		return { SheetNames: [], Sheets: {} };
	}
	
	/* add a worksheet to the end of a given workbook */
	function book_append_sheet(wb, ws, name, roll) {
		var i = 1;
		if(!name) for(; i <= 0xFFFF; ++i, name = undefined) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
		if(!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
		if(roll && wb.SheetNames.indexOf(name) >= 0) {
			var m = name.match(/(^.*?)(\d+)$/);
			i = m && +m[2] || 0;
			var root = m && m[1] || name;
			for(++i; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = root + i) == -1) break;
		}
		check_ws_name(name);
		if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
	
		wb.SheetNames.push(name);
		wb.Sheets[name] = ws;
		return name;
	}
	
	/* set sheet visibility (visible/hidden/very hidden) */
	function book_set_sheet_visibility(wb, sh, vis) {
		if(!wb.Workbook) wb.Workbook = {};
		if(!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
	
		var idx = wb_sheet_idx(wb, sh);
		// $FlowIgnore
		if(!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
	
		switch(vis) {
			case 0: case 1: case 2: break;
			default: throw new Error("Bad sheet visibility setting " + vis);
		}
		// $FlowIgnore
		wb.Workbook.Sheets[idx].Hidden = vis;
	}
	
	/* set number format */
	function cell_set_number_format(cell, fmt) {
		cell.z = fmt;
		return cell;
	}
	
	/* set cell hyperlink */
	function cell_set_hyperlink(cell, target, tooltip) {
		if(!target) {
			delete cell.l;
		} else {
			cell.l = ({ Target: target });
			if(tooltip) cell.l.Tooltip = tooltip;
		}
		return cell;
	}
	function cell_set_internal_link(cell, range, tooltip) { return cell_set_hyperlink(cell, "#" + range, tooltip); }
	
	/* add to cell comments */
	function cell_add_comment(cell, text, author) {
		if(!cell.c) cell.c = [];
		cell.c.push({t:text, a:author||"SheetJS"});
	}
	
	/* set array formula and flush related cells */
	function sheet_set_array_formula(ws, range, formula, dynamic) {
		var rng = typeof range != "string" ? range : safe_decode_range(range);
		var rngstr = typeof range == "string" ? range : encode_range(range);
		for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
			var cell = ws_get_cell_stub(ws, R, C);
			cell.t = 'n';
			cell.F = rngstr;
			delete cell.v;
			if(R == rng.s.r && C == rng.s.c) {
				cell.f = formula;
				if(dynamic) cell.D = true;
			}
		}
		return ws;
	}
	
	var utils = {
		encode_col: encode_col,
		encode_row: encode_row,
		encode_cell: encode_cell,
		encode_range: encode_range,
		decode_col: decode_col,
		decode_row: decode_row,
		split_cell: split_cell,
		decode_cell: decode_cell,
		decode_range: decode_range,
		format_cell: format_cell,
		sheet_add_aoa: sheet_add_aoa,
		sheet_add_json: sheet_add_json,
		sheet_add_dom: sheet_add_dom,
		aoa_to_sheet: aoa_to_sheet,
		json_to_sheet: json_to_sheet,
		table_to_sheet: parse_dom_table,
		table_to_book: table_to_book,
		sheet_to_csv: sheet_to_csv,
		sheet_to_txt: sheet_to_txt,
		sheet_to_json: sheet_to_json,
		sheet_to_html: sheet_to_html,
		sheet_to_formulae: sheet_to_formulae,
		sheet_to_row_object_array: sheet_to_json,
		sheet_get_cell: ws_get_cell_stub,
		book_new: book_new,
		book_append_sheet: book_append_sheet,
		book_set_sheet_visibility: book_set_sheet_visibility,
		cell_set_number_format: cell_set_number_format,
		cell_set_hyperlink: cell_set_hyperlink,
		cell_set_internal_link: cell_set_internal_link,
		cell_add_comment: cell_add_comment,
		sheet_set_array_formula: sheet_set_array_formula,
		consts: {
			SHEET_VISIBLE: 0,
			SHEET_HIDDEN: 1,
			SHEET_VERY_HIDDEN: 2
		}
	};
	
	var _Readable;
	function set_readable(R) { _Readable = R; }
	
	function write_csv_stream(sheet, opts) {
		var stream = _Readable();
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var R = r.s.r;
		var BOM = false, w = 0;
		stream._read = function() {
			if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
			while(R <= r.e.r) {
				++R;
				if ((rowinfo[R-1]||{}).hidden) continue;
				row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
				if(row != null) {
					if(o.strip) row = row.replace(endregex,"");
					if(row || (o.blankrows !== false)) return stream.push((w++ ? RS : "") + row);
				}
			}
			return stream.push(null);
		};
		return stream;
	}
	
	function write_html_stream(ws, opts) {
		var stream = _Readable();
	
		var o = opts || {};
		var header = o.header != null ? o.header : HTML_BEGIN;
		var footer = o.footer != null ? o.footer : HTML_END;
		stream.push(header);
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		stream.push(make_html_preamble(ws, r, o));
		var R = r.s.r;
		var end = false;
		stream._read = function() {
			if(R > r.e.r) {
				if(!end) { end = true; stream.push("</table>" + footer); }
				return stream.push(null);
			}
			while(R <= r.e.r) {
				stream.push(make_html_row(ws, r, R, o));
				++R;
				break;
			}
		};
		return stream;
	}
	
	function write_json_stream(sheet, opts) {
		var stream = _Readable({objectMode:true});
	
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0;
		var header_cnt = {};
		if(dense && !sheet[R]) sheet[R] = [];
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			if(((colinfo[C]||{}).hidden)) continue;
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = header_cnt[v] || 0;
					if(!counter) header_cnt[v] = 1;
					else {
						do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
						header_cnt[vv] = 1;
					}
					hdr[C] = vv;
			}
		}
		R = r.s.r + offset;
		stream._read = function() {
			while(R <= r.e.r) {
				if ((rowinfo[R-1]||{}).hidden) continue;
				var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
				++R;
				if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
					stream.push(row.row);
					return;
				}
			}
			return stream.push(null);
		};
		return stream;
	}
	
	var __stream = {
		to_json: write_json_stream,
		to_html: write_html_stream,
		to_csv: write_csv_stream,
	  set_readable: set_readable
	};
	if(typeof parse_xlscfb !== "undefined") XLSX.parse_xlscfb = parse_xlscfb;
	XLSX.parse_zip = parse_zip;
	XLSX.read = readSync; //xlsread
	XLSX.readFile = readFileSync; //readFile
	XLSX.readFileSync = readFileSync;
	XLSX.write = writeSync;
	XLSX.writeFile = writeFileSync;
	XLSX.writeFileSync = writeFileSync;
	XLSX.writeFileAsync = writeFileAsync;
	XLSX.utils = utils;
	XLSX.writeXLSX = writeSyncXLSX;
	XLSX.writeFileXLSX = writeFileSyncXLSX;
	XLSX.SSF = SSF;
	if(typeof __stream !== "undefined") XLSX.stream = __stream;
	if(typeof CFB !== "undefined") XLSX.CFB = CFB;
	if(true) {
	  var strmod = __webpack_require__(1852);
	  if((strmod||{}).Readable) set_readable(strmod.Readable);
	}
	}
	/*global define */
	if(true) make_xlsx_lib(exports);
	else if(typeof module !== 'undefined' && module.exports) make_xlsx_lib(module.exports);
	else if(typeof define === 'function' && define.amd) define('xlsx', function() { if(!XLSX.version) make_xlsx_lib(XLSX); return XLSX; });
	else make_xlsx_lib(XLSX);
	/* NOTE: the following extra line is needed for "Lightning Locker Service" */
	if(typeof window !== 'undefined' && !window.XLSX) try { window.XLSX = XLSX; } catch(e) {}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer, __webpack_require__(32)))

/***/ }),
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ })
]);


// WEBPACK FOOTER //
// static/js/vendor.6a3ab7542e5ce34d02f9.js